
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire144e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire144e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3WzGF", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2df2789bdf0d1887$export$ffb0004e005737fa; }, function (v) { return $2df2789bdf0d1887$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2df2789bdf0d1887$export$34b9dba7ce09269b; }, function (v) { return $2df2789bdf0d1887$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2df2789bdf0d1887$export$25062201e9e25d76; }, function (v) { return $2df2789bdf0d1887$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2df2789bdf0d1887$export$ffb0004e005737fa;
var $2df2789bdf0d1887$export$34b9dba7ce09269b;
var $2df2789bdf0d1887$export$25062201e9e25d76;
'use strict';
parcelRequire("gj7pJ");

var $jSIPP = parcelRequire("jSIPP");
var $2df2789bdf0d1887$var$g = 60103;
$2df2789bdf0d1887$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $2df2789bdf0d1887$var$h = Symbol.for;
    $2df2789bdf0d1887$var$g = $2df2789bdf0d1887$var$h("react.element");
    $2df2789bdf0d1887$export$ffb0004e005737fa = $2df2789bdf0d1887$var$h("react.fragment");
}
var $2df2789bdf0d1887$var$m = $jSIPP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2df2789bdf0d1887$var$n = Object.prototype.hasOwnProperty, $2df2789bdf0d1887$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2df2789bdf0d1887$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$2df2789bdf0d1887$var$n.call(a, b) && !$2df2789bdf0d1887$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2df2789bdf0d1887$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $2df2789bdf0d1887$var$m.current
    };
}
$2df2789bdf0d1887$export$34b9dba7ce09269b = $2df2789bdf0d1887$var$q;
$2df2789bdf0d1887$export$25062201e9e25d76 = $2df2789bdf0d1887$var$q;

});
parcelRegister("gj7pJ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $bdf42bf94e34cdc0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $bdf42bf94e34cdc0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bdf42bf94e34cdc0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $bdf42bf94e34cdc0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $bdf42bf94e34cdc0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $bdf42bf94e34cdc0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $bdf42bf94e34cdc0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($bdf42bf94e34cdc0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($bdf42bf94e34cdc0$var$getOwnPropertySymbols) {
            symbols = $bdf42bf94e34cdc0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($bdf42bf94e34cdc0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("jSIPP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bTxSL"));

});
parcelRegister("bTxSL", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8a8f1d0ee34c5898$export$ffb0004e005737fa; }, function (v) { return $8a8f1d0ee34c5898$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8a8f1d0ee34c5898$export$5f8d39834fd61797; }, function (v) { return $8a8f1d0ee34c5898$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $8a8f1d0ee34c5898$export$e2c29f18771995cb; }, function (v) { return $8a8f1d0ee34c5898$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $8a8f1d0ee34c5898$export$74bf444e3cd11ea5; }, function (v) { return $8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $8a8f1d0ee34c5898$export$dca3b0875bd9a954; }, function (v) { return $8a8f1d0ee34c5898$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8a8f1d0ee34c5898$export$16fa2f45be04daa8; }, function (v) { return $8a8f1d0ee34c5898$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8a8f1d0ee34c5898$export$221d75b3f55bb0bd; }, function (v) { return $8a8f1d0ee34c5898$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8a8f1d0ee34c5898$export$ae55be85d98224ed; }, function (v) { return $8a8f1d0ee34c5898$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8a8f1d0ee34c5898$export$e530037191fcd5d7; }, function (v) { return $8a8f1d0ee34c5898$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8a8f1d0ee34c5898$export$fd42f52fd3ae1109; }, function (v) { return $8a8f1d0ee34c5898$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8a8f1d0ee34c5898$export$c8a8987d4410bf2d; }, function (v) { return $8a8f1d0ee34c5898$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8a8f1d0ee34c5898$export$d38cd72104c1f0e9; }, function (v) { return $8a8f1d0ee34c5898$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43; }, function (v) { return $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8a8f1d0ee34c5898$export$257a8862b851cb5b; }, function (v) { return $8a8f1d0ee34c5898$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8a8f1d0ee34c5898$export$a8257692ac88316c; }, function (v) { return $8a8f1d0ee34c5898$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8a8f1d0ee34c5898$export$488013bae63b21da; }, function (v) { return $8a8f1d0ee34c5898$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8a8f1d0ee34c5898$export$7c73462e0d25e514; }, function (v) { return $8a8f1d0ee34c5898$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8a8f1d0ee34c5898$export$35808ee640e87ca7; }, function (v) { return $8a8f1d0ee34c5898$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8a8f1d0ee34c5898$export$fae74005e78b1a27; }, function (v) { return $8a8f1d0ee34c5898$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e; }, function (v) { return $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $8a8f1d0ee34c5898$export$6d9c69b0de29b591; }, function (v) { return $8a8f1d0ee34c5898$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8a8f1d0ee34c5898$export$d5a552a76deda3c2; }, function (v) { return $8a8f1d0ee34c5898$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8a8f1d0ee34c5898$export$e5c5a5f917a5871c; }, function (v) { return $8a8f1d0ee34c5898$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8a8f1d0ee34c5898$export$1538c33de8887b59; }, function (v) { return $8a8f1d0ee34c5898$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8a8f1d0ee34c5898$export$13e3392192263954; }, function (v) { return $8a8f1d0ee34c5898$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8a8f1d0ee34c5898$export$b8f5890fc79d6aca; }, function (v) { return $8a8f1d0ee34c5898$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8a8f1d0ee34c5898$export$60241385465d0a34; }, function (v) { return $8a8f1d0ee34c5898$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $8a8f1d0ee34c5898$export$83d89fbfd8236492; }, function (v) { return $8a8f1d0ee34c5898$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8a8f1d0ee34c5898$export$ffb0004e005737fa;
var $8a8f1d0ee34c5898$export$5f8d39834fd61797;
var $8a8f1d0ee34c5898$export$e2c29f18771995cb;
var $8a8f1d0ee34c5898$export$74bf444e3cd11ea5;
var $8a8f1d0ee34c5898$export$dca3b0875bd9a954;
var $8a8f1d0ee34c5898$export$16fa2f45be04daa8;
var $8a8f1d0ee34c5898$export$221d75b3f55bb0bd;
var $8a8f1d0ee34c5898$export$ae55be85d98224ed;
var $8a8f1d0ee34c5898$export$e530037191fcd5d7;
var $8a8f1d0ee34c5898$export$fd42f52fd3ae1109;
var $8a8f1d0ee34c5898$export$c8a8987d4410bf2d;
var $8a8f1d0ee34c5898$export$d38cd72104c1f0e9;
var $8a8f1d0ee34c5898$export$7d1e3a5e95ceca43;
var $8a8f1d0ee34c5898$export$257a8862b851cb5b;
var $8a8f1d0ee34c5898$export$a8257692ac88316c;
var $8a8f1d0ee34c5898$export$488013bae63b21da;
var $8a8f1d0ee34c5898$export$7c73462e0d25e514;
var $8a8f1d0ee34c5898$export$35808ee640e87ca7;
var $8a8f1d0ee34c5898$export$fae74005e78b1a27;
var $8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e;
var $8a8f1d0ee34c5898$export$6d9c69b0de29b591;
var $8a8f1d0ee34c5898$export$d5a552a76deda3c2;
var $8a8f1d0ee34c5898$export$e5c5a5f917a5871c;
var $8a8f1d0ee34c5898$export$1538c33de8887b59;
var $8a8f1d0ee34c5898$export$13e3392192263954;
var $8a8f1d0ee34c5898$export$b8f5890fc79d6aca;
var $8a8f1d0ee34c5898$export$60241385465d0a34;
var $8a8f1d0ee34c5898$export$83d89fbfd8236492;
'use strict';

var $gj7pJ = parcelRequire("gj7pJ");
var $8a8f1d0ee34c5898$var$n = 60103, $8a8f1d0ee34c5898$var$p = 60106;
$8a8f1d0ee34c5898$export$ffb0004e005737fa = 60107;
$8a8f1d0ee34c5898$export$5f8d39834fd61797 = 60108;
$8a8f1d0ee34c5898$export$e2c29f18771995cb = 60114;
var $8a8f1d0ee34c5898$var$q = 60109, $8a8f1d0ee34c5898$var$r = 60110, $8a8f1d0ee34c5898$var$t = 60112;
$8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = 60113;
var $8a8f1d0ee34c5898$var$u = 60115, $8a8f1d0ee34c5898$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $8a8f1d0ee34c5898$var$w = Symbol.for;
    $8a8f1d0ee34c5898$var$n = $8a8f1d0ee34c5898$var$w("react.element");
    $8a8f1d0ee34c5898$var$p = $8a8f1d0ee34c5898$var$w("react.portal");
    $8a8f1d0ee34c5898$export$ffb0004e005737fa = $8a8f1d0ee34c5898$var$w("react.fragment");
    $8a8f1d0ee34c5898$export$5f8d39834fd61797 = $8a8f1d0ee34c5898$var$w("react.strict_mode");
    $8a8f1d0ee34c5898$export$e2c29f18771995cb = $8a8f1d0ee34c5898$var$w("react.profiler");
    $8a8f1d0ee34c5898$var$q = $8a8f1d0ee34c5898$var$w("react.provider");
    $8a8f1d0ee34c5898$var$r = $8a8f1d0ee34c5898$var$w("react.context");
    $8a8f1d0ee34c5898$var$t = $8a8f1d0ee34c5898$var$w("react.forward_ref");
    $8a8f1d0ee34c5898$export$74bf444e3cd11ea5 = $8a8f1d0ee34c5898$var$w("react.suspense");
    $8a8f1d0ee34c5898$var$u = $8a8f1d0ee34c5898$var$w("react.memo");
    $8a8f1d0ee34c5898$var$v = $8a8f1d0ee34c5898$var$w("react.lazy");
}
var $8a8f1d0ee34c5898$var$x = "function" === typeof Symbol && Symbol.iterator;
function $8a8f1d0ee34c5898$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8a8f1d0ee34c5898$var$x && a[$8a8f1d0ee34c5898$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $8a8f1d0ee34c5898$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8a8f1d0ee34c5898$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8a8f1d0ee34c5898$var$B = {};
function $8a8f1d0ee34c5898$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8a8f1d0ee34c5898$var$B;
    this.updater = c || $8a8f1d0ee34c5898$var$A;
}
$8a8f1d0ee34c5898$var$C.prototype.isReactComponent = {};
$8a8f1d0ee34c5898$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($8a8f1d0ee34c5898$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8a8f1d0ee34c5898$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8a8f1d0ee34c5898$var$D() {}
$8a8f1d0ee34c5898$var$D.prototype = $8a8f1d0ee34c5898$var$C.prototype;
function $8a8f1d0ee34c5898$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8a8f1d0ee34c5898$var$B;
    this.updater = c || $8a8f1d0ee34c5898$var$A;
}
var $8a8f1d0ee34c5898$var$F = $8a8f1d0ee34c5898$var$E.prototype = new $8a8f1d0ee34c5898$var$D;
$8a8f1d0ee34c5898$var$F.constructor = $8a8f1d0ee34c5898$var$E;
$gj7pJ($8a8f1d0ee34c5898$var$F, $8a8f1d0ee34c5898$var$C.prototype);
$8a8f1d0ee34c5898$var$F.isPureReactComponent = !0;
var $8a8f1d0ee34c5898$var$G = {
    current: null
}, $8a8f1d0ee34c5898$var$H = Object.prototype.hasOwnProperty, $8a8f1d0ee34c5898$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8a8f1d0ee34c5898$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8a8f1d0ee34c5898$var$H.call(b, e) && !$8a8f1d0ee34c5898$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $8a8f1d0ee34c5898$var$G.current
    };
}
function $8a8f1d0ee34c5898$var$K(a, b) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8a8f1d0ee34c5898$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8a8f1d0ee34c5898$var$n;
}
function $8a8f1d0ee34c5898$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8a8f1d0ee34c5898$var$M = /\/+/g;
function $8a8f1d0ee34c5898$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8a8f1d0ee34c5898$var$escape("" + a.key) : b.toString(36);
}
function $8a8f1d0ee34c5898$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8a8f1d0ee34c5898$var$n:
                case $8a8f1d0ee34c5898$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $8a8f1d0ee34c5898$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($8a8f1d0ee34c5898$var$M, "$&/") + "/"), $8a8f1d0ee34c5898$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($8a8f1d0ee34c5898$var$L(d) && (d = $8a8f1d0ee34c5898$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($8a8f1d0ee34c5898$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $8a8f1d0ee34c5898$var$N(k, g);
        h += $8a8f1d0ee34c5898$var$O(k, b, c, f, d);
    }
    else if (f = $8a8f1d0ee34c5898$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $8a8f1d0ee34c5898$var$N(k, g++), h += $8a8f1d0ee34c5898$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($8a8f1d0ee34c5898$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $8a8f1d0ee34c5898$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $8a8f1d0ee34c5898$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $8a8f1d0ee34c5898$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $8a8f1d0ee34c5898$var$R = {
    current: null
};
function $8a8f1d0ee34c5898$var$S() {
    var a = $8a8f1d0ee34c5898$var$R.current;
    if (null === a) throw Error($8a8f1d0ee34c5898$var$z(321));
    return a;
}
var $8a8f1d0ee34c5898$var$T = {
    ReactCurrentDispatcher: $8a8f1d0ee34c5898$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $8a8f1d0ee34c5898$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $gj7pJ
};
$8a8f1d0ee34c5898$export$dca3b0875bd9a954 = {
    map: $8a8f1d0ee34c5898$var$P,
    forEach: function(a, b, c) {
        $8a8f1d0ee34c5898$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $8a8f1d0ee34c5898$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8a8f1d0ee34c5898$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8a8f1d0ee34c5898$var$L(a)) throw Error($8a8f1d0ee34c5898$var$z(143));
        return a;
    }
};
$8a8f1d0ee34c5898$export$16fa2f45be04daa8 = $8a8f1d0ee34c5898$var$C;
$8a8f1d0ee34c5898$export$221d75b3f55bb0bd = $8a8f1d0ee34c5898$var$E;
$8a8f1d0ee34c5898$export$ae55be85d98224ed = $8a8f1d0ee34c5898$var$T;
$8a8f1d0ee34c5898$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($8a8f1d0ee34c5898$var$z(267, a));
    var e = $gj7pJ({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8a8f1d0ee34c5898$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8a8f1d0ee34c5898$var$H.call(b, f) && !$8a8f1d0ee34c5898$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $8a8f1d0ee34c5898$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$8a8f1d0ee34c5898$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $8a8f1d0ee34c5898$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $8a8f1d0ee34c5898$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$8a8f1d0ee34c5898$export$c8a8987d4410bf2d = $8a8f1d0ee34c5898$var$J;
$8a8f1d0ee34c5898$export$d38cd72104c1f0e9 = function(a) {
    var b = $8a8f1d0ee34c5898$var$J.bind(null, a);
    b.type = a;
    return b;
};
$8a8f1d0ee34c5898$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8a8f1d0ee34c5898$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$t,
        render: a
    };
};
$8a8f1d0ee34c5898$export$a8257692ac88316c = $8a8f1d0ee34c5898$var$L;
$8a8f1d0ee34c5898$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8a8f1d0ee34c5898$var$Q
    };
};
$8a8f1d0ee34c5898$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8a8f1d0ee34c5898$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8a8f1d0ee34c5898$export$35808ee640e87ca7 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useCallback(a, b);
};
$8a8f1d0ee34c5898$export$fae74005e78b1a27 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useContext(a, b);
};
$8a8f1d0ee34c5898$export$dc8fbce3eb94dc1e = function() {};
$8a8f1d0ee34c5898$export$6d9c69b0de29b591 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useEffect(a, b);
};
$8a8f1d0ee34c5898$export$d5a552a76deda3c2 = function(a, b, c) {
    return $8a8f1d0ee34c5898$var$S().useImperativeHandle(a, b, c);
};
$8a8f1d0ee34c5898$export$e5c5a5f917a5871c = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useLayoutEffect(a, b);
};
$8a8f1d0ee34c5898$export$1538c33de8887b59 = function(a, b) {
    return $8a8f1d0ee34c5898$var$S().useMemo(a, b);
};
$8a8f1d0ee34c5898$export$13e3392192263954 = function(a, b, c) {
    return $8a8f1d0ee34c5898$var$S().useReducer(a, b, c);
};
$8a8f1d0ee34c5898$export$b8f5890fc79d6aca = function(a) {
    return $8a8f1d0ee34c5898$var$S().useRef(a);
};
$8a8f1d0ee34c5898$export$60241385465d0a34 = function(a) {
    return $8a8f1d0ee34c5898$var$S().useState(a);
};
$8a8f1d0ee34c5898$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("akLJP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2R3UW = parcelRequire("2R3UW");

var $enUKR = parcelRequire("enUKR");

var $fGxyn = parcelRequire("fGxyn");

var $2rbHa = parcelRequire("2rbHa");
var $7860cd767072d70e$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $fGxyn.RawSha256();
        if (secret) {
            this.outer = new $fGxyn.RawSha256();
            var inner = $7860cd767072d70e$var$bufferFromSecret(secret);
            var outer = new Uint8Array($enUKR.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $enUKR.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ($7860cd767072d70e$var$isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update($7860cd767072d70e$var$convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $2R3UW.__awaiter(this, void 0, void 0, function() {
            return $2R3UW.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $7860cd767072d70e$var$Sha256;
function $7860cd767072d70e$var$bufferFromSecret(secret) {
    var input = $7860cd767072d70e$var$convertToBuffer(secret);
    if (input.byteLength > $enUKR.BLOCK_SIZE) {
        var bufferHash = new $fGxyn.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($enUKR.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function $7860cd767072d70e$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $7860cd767072d70e$var$convertToBuffer(data) {
    if (typeof data === "string") return $2rbHa.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("2R3UW", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $214391efb4948e2b$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $214391efb4948e2b$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $214391efb4948e2b$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $214391efb4948e2b$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $214391efb4948e2b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $214391efb4948e2b$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $214391efb4948e2b$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $214391efb4948e2b$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spread", function () { return $214391efb4948e2b$export$afc72e2116322959; });
$parcel$export(module.exports, "__await", function () { return $214391efb4948e2b$export$10c90e4f7922046c; });
$parcel$export(module.exports, "__asyncGenerator", function () { return $214391efb4948e2b$export$e427f37a30a4de9b; });
$parcel$export(module.exports, "__asyncValues", function () { return $214391efb4948e2b$export$e3b29a3d6162315f; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $214391efb4948e2b$var$extendStatics = function(d, b) {
    $214391efb4948e2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $214391efb4948e2b$var$extendStatics(d, b);
};
function $214391efb4948e2b$export$a8ba968b8961cb8a(d, b) {
    $214391efb4948e2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $214391efb4948e2b$export$18ce0697a983be9b = function() {
    $214391efb4948e2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $214391efb4948e2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $214391efb4948e2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $214391efb4948e2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $214391efb4948e2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $214391efb4948e2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $214391efb4948e2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $214391efb4948e2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $214391efb4948e2b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $214391efb4948e2b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $214391efb4948e2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $214391efb4948e2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $214391efb4948e2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($214391efb4948e2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $214391efb4948e2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $214391efb4948e2b$export$10c90e4f7922046c(v) {
    return this instanceof $214391efb4948e2b$export$10c90e4f7922046c ? (this.v = v, this) : new $214391efb4948e2b$export$10c90e4f7922046c(v);
}
function $214391efb4948e2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $214391efb4948e2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $214391efb4948e2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $214391efb4948e2b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $214391efb4948e2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $214391efb4948e2b$export$19a8beecd37a4c45 === "function" ? $214391efb4948e2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $214391efb4948e2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $214391efb4948e2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $214391efb4948e2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $214391efb4948e2b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $214391efb4948e2b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("enUKR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("fGxyn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $enUKR = parcelRequire("enUKR");
/**
 * @internal
 */ var $b6b4ce473e91d5ce$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($enUKR.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $enUKR.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $enUKR.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $enUKR.BLOCK_SIZE >= $enUKR.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $enUKR.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $enUKR.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($enUKR.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($enUKR.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($enUKR.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $enUKR.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($enUKR.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $b6b4ce473e91d5ce$var$RawSha256;

});

parcelRegister("2rbHa", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $1c672cd2c7553417$export$c7c5cef950a4d2fc; });

var $5Edau = parcelRequire("5Edau");

var $kv0nc = parcelRequire("kv0nc");
var $1c672cd2c7553417$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $kv0nc.fromUtf8)(input) : (0, $5Edau.fromUtf8)(input);
};
var $1c672cd2c7553417$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $kv0nc.toUtf8)(input) : (0, $5Edau.toUtf8)(input);
};

});
parcelRegister("5Edau", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $41cae71d3ea1e7a7$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $41cae71d3ea1e7a7$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $41cae71d3ea1e7a7$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $41cae71d3ea1e7a7$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("kv0nc", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $eec6fe027c97943c$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $eec6fe027c97943c$export$b4b216764bb846eb; });
function $eec6fe027c97943c$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $eec6fe027c97943c$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("6Wce5", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $d4Mmx = parcelRequire("d4Mmx");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $cjved = parcelRequire("cjved");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $cjved.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $d4Mmx.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $cjved.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $cjved.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("d4Mmx", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("cjved", function(module, exports) {
'use strict';

var $1cn56 = parcelRequire("1cn56");

var $gnTvJ = parcelRequire("gnTvJ");

var $2InO4 = parcelRequire("2InO4");
module.exports = {
    formats: $2InO4,
    parse: $gnTvJ,
    stringify: $1cn56
};

});
parcelRegister("1cn56", function(module, exports) {
'use strict';

var $guOHz = parcelRequire("guOHz");

var $6Um72 = parcelRequire("6Um72");

var $2InO4 = parcelRequire("2InO4");
var $0df8d0e734d008ab$var$has = Object.prototype.hasOwnProperty;
var $0df8d0e734d008ab$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $0df8d0e734d008ab$var$isArray = Array.isArray;
var $0df8d0e734d008ab$var$push = Array.prototype.push;
var $0df8d0e734d008ab$var$pushToArray = function(arr, valueOrArray) {
    $0df8d0e734d008ab$var$push.apply(arr, $0df8d0e734d008ab$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $0df8d0e734d008ab$var$toISO = Date.prototype.toISOString;
var $0df8d0e734d008ab$var$defaultFormat = $2InO4.default;
var $0df8d0e734d008ab$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: $6Um72.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $0df8d0e734d008ab$var$defaultFormat,
    formatter: $2InO4.formatters[$0df8d0e734d008ab$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $0df8d0e734d008ab$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $0df8d0e734d008ab$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $0df8d0e734d008ab$var$sentinel = {};
var $0df8d0e734d008ab$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
    var obj = object;
    if (currentDepth > depth) throw new RangeError('Input depth exceeded depth option of ' + depth);
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($0df8d0e734d008ab$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($0df8d0e734d008ab$var$sentinel) === 'undefined') step = 0;
    }
    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
    if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $0df8d0e734d008ab$var$isArray(obj)) obj = $6Um72.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $0df8d0e734d008ab$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($0df8d0e734d008ab$var$isNonNullishPrimitive(obj) || $6Um72.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $0df8d0e734d008ab$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $0df8d0e734d008ab$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $0df8d0e734d008ab$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $6Um72.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v, $0df8d0e734d008ab$var$defaults.encoder, charset, 'value', format);
        });
        objKeys = [
            {
                value: obj.length > 0 ? $6Um72.toCoercible(obj).join(',') || null : void 0
            }
        ];
    } else if ($0df8d0e734d008ab$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = String(prefix);
    var adjustedPrefix = commaRoundTrip && $0df8d0e734d008ab$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $0df8d0e734d008ab$var$isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return formatter(encoder && !encodeValuesOnly ? encoder(adjustedPrefix, $0df8d0e734d008ab$var$defaults.encoder, charset, 'key', format) : adjustedPrefix) + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $0df8d0e734d008ab$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $guOHz();
        valueSideChannel.set($0df8d0e734d008ab$var$sentinel, sideChannel);
        $0df8d0e734d008ab$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $0df8d0e734d008ab$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
    }
    return values;
};
var $0df8d0e734d008ab$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $0df8d0e734d008ab$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $0df8d0e734d008ab$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $2InO4.default;
    if (typeof opts.format !== 'undefined') {
        if (!$0df8d0e734d008ab$var$has.call($2InO4.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $2InO4.formatters[format];
    var filter = $0df8d0e734d008ab$var$defaults.filter;
    if (typeof opts.filter === 'function' || $0df8d0e734d008ab$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if ($0df8d0e734d008ab$var$has.call($0df8d0e734d008ab$var$arrayPrefixGenerators, opts.arrayFormat)) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $0df8d0e734d008ab$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $0df8d0e734d008ab$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $0df8d0e734d008ab$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $0df8d0e734d008ab$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $0df8d0e734d008ab$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $0df8d0e734d008ab$var$defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : $0df8d0e734d008ab$var$defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $0df8d0e734d008ab$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $0df8d0e734d008ab$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $0df8d0e734d008ab$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $0df8d0e734d008ab$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $0df8d0e734d008ab$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $0df8d0e734d008ab$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $0df8d0e734d008ab$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $0df8d0e734d008ab$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($0df8d0e734d008ab$var$isArray(options.filter)) {
        // a copy: `sort` below must not reorder the caller's array, and nested
        // levels take their key order from the sorted copy
        filter = options.filter.slice();
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $0df8d0e734d008ab$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $guOHz();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        $0df8d0e734d008ab$var$pushToArray(keys, $0df8d0e734d008ab$var$stringify(value, encodedKey, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("guOHz", function(module, exports) {
'use strict';

var $kS7wF = parcelRequire("kS7wF");

var $1WZRg = parcelRequire("1WZRg");

var $hakM6 = parcelRequire("hakM6");

var $13Wf7 = parcelRequire("13Wf7");

var $gzNdD = parcelRequire("gzNdD");
var $c026c6fe03bd6c23$var$makeChannel = $gzNdD || $13Wf7 || $hakM6;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $1WZRg(key);
                throw new $kS7wF('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $c026c6fe03bd6c23$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("kS7wF", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("1WZRg", function(module, exports) {
var $16bb30f43bc4efef$var$hasMap = typeof Map === 'function' && Map.prototype;
var $16bb30f43bc4efef$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $16bb30f43bc4efef$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $16bb30f43bc4efef$var$mapSize = $16bb30f43bc4efef$var$hasMap && $16bb30f43bc4efef$var$mapSizeDescriptor && typeof $16bb30f43bc4efef$var$mapSizeDescriptor.get === 'function' ? $16bb30f43bc4efef$var$mapSizeDescriptor.get : null;
var $16bb30f43bc4efef$var$mapForEach = $16bb30f43bc4efef$var$hasMap && Map.prototype.forEach;
var $16bb30f43bc4efef$var$hasSet = typeof Set === 'function' && Set.prototype;
var $16bb30f43bc4efef$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $16bb30f43bc4efef$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $16bb30f43bc4efef$var$setSize = $16bb30f43bc4efef$var$hasSet && $16bb30f43bc4efef$var$setSizeDescriptor && typeof $16bb30f43bc4efef$var$setSizeDescriptor.get === 'function' ? $16bb30f43bc4efef$var$setSizeDescriptor.get : null;
var $16bb30f43bc4efef$var$setForEach = $16bb30f43bc4efef$var$hasSet && Set.prototype.forEach;
var $16bb30f43bc4efef$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $16bb30f43bc4efef$var$weakMapHas = $16bb30f43bc4efef$var$hasWeakMap ? WeakMap.prototype.has : null;
var $16bb30f43bc4efef$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $16bb30f43bc4efef$var$weakSetHas = $16bb30f43bc4efef$var$hasWeakSet ? WeakSet.prototype.has : null;
var $16bb30f43bc4efef$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $16bb30f43bc4efef$var$weakRefDeref = $16bb30f43bc4efef$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $16bb30f43bc4efef$var$booleanValueOf = Boolean.prototype.valueOf;
var $16bb30f43bc4efef$var$objectToString = Object.prototype.toString;
var $16bb30f43bc4efef$var$functionToString = Function.prototype.toString;
var $16bb30f43bc4efef$var$$match = String.prototype.match;
var $16bb30f43bc4efef$var$$slice = String.prototype.slice;
var $16bb30f43bc4efef$var$$replace = String.prototype.replace;
var $16bb30f43bc4efef$var$$toUpperCase = String.prototype.toUpperCase;
var $16bb30f43bc4efef$var$$toLowerCase = String.prototype.toLowerCase;
var $16bb30f43bc4efef$var$$test = RegExp.prototype.test;
var $16bb30f43bc4efef$var$$concat = Array.prototype.concat;
var $16bb30f43bc4efef$var$$join = Array.prototype.join;
var $16bb30f43bc4efef$var$$arrSlice = Array.prototype.slice;
var $16bb30f43bc4efef$var$$floor = Math.floor;
var $16bb30f43bc4efef$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $16bb30f43bc4efef$var$gOPS = Object.getOwnPropertySymbols;
var $16bb30f43bc4efef$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $16bb30f43bc4efef$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $16bb30f43bc4efef$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $16bb30f43bc4efef$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $16bb30f43bc4efef$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $16bb30f43bc4efef$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $16bb30f43bc4efef$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $16bb30f43bc4efef$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$16bb30f43bc4efef$var$$floor(-num) : $16bb30f43bc4efef$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $16bb30f43bc4efef$var$$slice.call(str, intStr.length + 1);
            return $16bb30f43bc4efef$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $16bb30f43bc4efef$var$$replace.call($16bb30f43bc4efef$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $16bb30f43bc4efef$var$$replace.call(str, sepRegex, '$&_');
}

var $7K7Bf = parcelRequire("7K7Bf");
var $16bb30f43bc4efef$var$inspectCustom = $7K7Bf.custom;
var $16bb30f43bc4efef$var$inspectSymbol = $16bb30f43bc4efef$var$isSymbol($16bb30f43bc4efef$var$inspectCustom) ? $16bb30f43bc4efef$var$inspectCustom : null;
var $16bb30f43bc4efef$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $16bb30f43bc4efef$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($16bb30f43bc4efef$var$has(opts, 'quoteStyle') && !$16bb30f43bc4efef$var$has($16bb30f43bc4efef$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($16bb30f43bc4efef$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $16bb30f43bc4efef$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($16bb30f43bc4efef$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($16bb30f43bc4efef$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $16bb30f43bc4efef$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $16bb30f43bc4efef$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $16bb30f43bc4efef$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $16bb30f43bc4efef$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $16bb30f43bc4efef$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($16bb30f43bc4efef$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $16bb30f43bc4efef$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($16bb30f43bc4efef$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$16bb30f43bc4efef$var$isRegExp(obj)) {
        var name = $16bb30f43bc4efef$var$nameOf(obj);
        var keys = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $16bb30f43bc4efef$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($16bb30f43bc4efef$var$isSymbol(obj)) {
        var symString = $16bb30f43bc4efef$var$hasShammedSymbols ? $16bb30f43bc4efef$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $16bb30f43bc4efef$var$symToString.call(obj);
        return typeof obj === 'object' && !$16bb30f43bc4efef$var$hasShammedSymbols ? $16bb30f43bc4efef$var$markBoxed(symString) : symString;
    }
    if ($16bb30f43bc4efef$var$isElement(obj)) {
        var s = '<' + $16bb30f43bc4efef$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $16bb30f43bc4efef$var$wrapQuotes($16bb30f43bc4efef$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $16bb30f43bc4efef$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($16bb30f43bc4efef$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        if (indent && !$16bb30f43bc4efef$var$singleLineValues(xs)) return '[' + $16bb30f43bc4efef$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $16bb30f43bc4efef$var$$join.call(xs, ', ') + ' ]';
    }
    if ($16bb30f43bc4efef$var$isError(obj)) {
        var parts = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$16bb30f43bc4efef$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $16bb30f43bc4efef$var$$join.call($16bb30f43bc4efef$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $16bb30f43bc4efef$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($16bb30f43bc4efef$var$inspectSymbol && typeof obj[$16bb30f43bc4efef$var$inspectSymbol] === 'function' && $7K7Bf) return $7K7Bf(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($16bb30f43bc4efef$var$isMap(obj)) {
        var mapParts = [];
        if ($16bb30f43bc4efef$var$mapForEach) $16bb30f43bc4efef$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $16bb30f43bc4efef$var$collectionOf('Map', $16bb30f43bc4efef$var$mapSize.call(obj), mapParts, indent);
    }
    if ($16bb30f43bc4efef$var$isSet(obj)) {
        var setParts = [];
        if ($16bb30f43bc4efef$var$setForEach) $16bb30f43bc4efef$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $16bb30f43bc4efef$var$collectionOf('Set', $16bb30f43bc4efef$var$setSize.call(obj), setParts, indent);
    }
    if ($16bb30f43bc4efef$var$isWeakMap(obj)) return $16bb30f43bc4efef$var$weakCollectionOf('WeakMap');
    if ($16bb30f43bc4efef$var$isWeakSet(obj)) return $16bb30f43bc4efef$var$weakCollectionOf('WeakSet');
    if ($16bb30f43bc4efef$var$isWeakRef(obj)) return $16bb30f43bc4efef$var$weakCollectionOf('WeakRef');
    if ($16bb30f43bc4efef$var$isNumber(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect(Number(obj)));
    if ($16bb30f43bc4efef$var$isBigInt(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect($16bb30f43bc4efef$var$bigIntValueOf.call(obj)));
    if ($16bb30f43bc4efef$var$isBoolean(obj)) return $16bb30f43bc4efef$var$markBoxed($16bb30f43bc4efef$var$booleanValueOf.call(obj));
    if ($16bb30f43bc4efef$var$isString(obj)) return $16bb30f43bc4efef$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$16bb30f43bc4efef$var$isDate(obj) && !$16bb30f43bc4efef$var$isRegExp(obj)) {
        var ys = $16bb30f43bc4efef$var$arrObjKeys(obj, inspect);
        var isPlainObject = $16bb30f43bc4efef$var$gPO ? $16bb30f43bc4efef$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $16bb30f43bc4efef$var$toStringTag && Object(obj) === obj && $16bb30f43bc4efef$var$toStringTag in obj ? $16bb30f43bc4efef$var$$slice.call($16bb30f43bc4efef$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $16bb30f43bc4efef$var$$join.call($16bb30f43bc4efef$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $16bb30f43bc4efef$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $16bb30f43bc4efef$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $16bb30f43bc4efef$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $16bb30f43bc4efef$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $16bb30f43bc4efef$var$quote(s) {
    return $16bb30f43bc4efef$var$$replace.call(String(s), /"/g, '&quot;');
}
function $16bb30f43bc4efef$var$canTrustToString(obj) {
    return !$16bb30f43bc4efef$var$toStringTag || !(typeof obj === 'object' && ($16bb30f43bc4efef$var$toStringTag in obj || typeof obj[$16bb30f43bc4efef$var$toStringTag] !== 'undefined'));
}
function $16bb30f43bc4efef$var$isArray(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object Array]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isDate(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object Date]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isRegExp(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object RegExp]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isError(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object Error]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isString(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object String]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isNumber(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object Number]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
function $16bb30f43bc4efef$var$isBoolean(obj) {
    return $16bb30f43bc4efef$var$toStr(obj) === '[object Boolean]' && $16bb30f43bc4efef$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $16bb30f43bc4efef$var$isSymbol(obj) {
    if ($16bb30f43bc4efef$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$16bb30f43bc4efef$var$symToString) return false;
    try {
        $16bb30f43bc4efef$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$16bb30f43bc4efef$var$bigIntValueOf) return false;
    try {
        $16bb30f43bc4efef$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $16bb30f43bc4efef$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $16bb30f43bc4efef$var$has(obj, key) {
    return $16bb30f43bc4efef$var$hasOwn.call(obj, key);
}
function $16bb30f43bc4efef$var$toStr(obj) {
    return $16bb30f43bc4efef$var$objectToString.call(obj);
}
function $16bb30f43bc4efef$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $16bb30f43bc4efef$var$$match.call($16bb30f43bc4efef$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $16bb30f43bc4efef$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $16bb30f43bc4efef$var$isMap(x) {
    if (!$16bb30f43bc4efef$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $16bb30f43bc4efef$var$mapSize.call(x);
        try {
            $16bb30f43bc4efef$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isWeakMap(x) {
    if (!$16bb30f43bc4efef$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $16bb30f43bc4efef$var$weakMapHas.call(x, $16bb30f43bc4efef$var$weakMapHas);
        try {
            $16bb30f43bc4efef$var$weakSetHas.call(x, $16bb30f43bc4efef$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isWeakRef(x) {
    if (!$16bb30f43bc4efef$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $16bb30f43bc4efef$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isSet(x) {
    if (!$16bb30f43bc4efef$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $16bb30f43bc4efef$var$setSize.call(x);
        try {
            $16bb30f43bc4efef$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isWeakSet(x) {
    if (!$16bb30f43bc4efef$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $16bb30f43bc4efef$var$weakSetHas.call(x, $16bb30f43bc4efef$var$weakSetHas);
        try {
            $16bb30f43bc4efef$var$weakMapHas.call(x, $16bb30f43bc4efef$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $16bb30f43bc4efef$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $16bb30f43bc4efef$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $16bb30f43bc4efef$var$inspectString($16bb30f43bc4efef$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $16bb30f43bc4efef$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $16bb30f43bc4efef$var$$replace.call($16bb30f43bc4efef$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $16bb30f43bc4efef$var$lowbyte);
    return $16bb30f43bc4efef$var$wrapQuotes(s, 'single', opts);
}
function $16bb30f43bc4efef$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $16bb30f43bc4efef$var$$toUpperCase.call(n.toString(16));
}
function $16bb30f43bc4efef$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $16bb30f43bc4efef$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $16bb30f43bc4efef$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $16bb30f43bc4efef$var$indentedJoin(entries, indent) : $16bb30f43bc4efef$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $16bb30f43bc4efef$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($16bb30f43bc4efef$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $16bb30f43bc4efef$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $16bb30f43bc4efef$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $16bb30f43bc4efef$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $16bb30f43bc4efef$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $16bb30f43bc4efef$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $16bb30f43bc4efef$var$arrObjKeys(obj, inspect) {
    var isArr = $16bb30f43bc4efef$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $16bb30f43bc4efef$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $16bb30f43bc4efef$var$gOPS === 'function' ? $16bb30f43bc4efef$var$gOPS(obj) : [];
    var symMap;
    if ($16bb30f43bc4efef$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$16bb30f43bc4efef$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($16bb30f43bc4efef$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($16bb30f43bc4efef$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $16bb30f43bc4efef$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($16bb30f43bc4efef$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("7K7Bf", function(module, exports) {
"use strict";

});


parcelRegister("hakM6", function(module, exports) {
'use strict';

var $1WZRg = parcelRequire("1WZRg");

var $kS7wF = parcelRequire("kS7wF");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $c7f37c4d935f22bf$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $c7f37c4d935f22bf$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $c7f37c4d935f22bf$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $c7f37c4d935f22bf$var$listSet = function(objects, key, value) {
    var node = $c7f37c4d935f22bf$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $c7f37c4d935f22bf$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$c7f37c4d935f22bf$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $c7f37c4d935f22bf$var$listDelete = function(objects, key) {
    if (objects) return $c7f37c4d935f22bf$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kS7wF('Side channel does not contain ' + $1WZRg(key));
        },
        'delete': function(key) {
            var deletedNode = $c7f37c4d935f22bf$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $c7f37c4d935f22bf$var$listGet($o, key);
        },
        has: function(key) {
            return $c7f37c4d935f22bf$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $c7f37c4d935f22bf$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("13Wf7", function(module, exports) {
'use strict';

var $e0BBw = parcelRequire("e0BBw");

var $aUGbd = parcelRequire("aUGbd");

var $1WZRg = parcelRequire("1WZRg");

var $kS7wF = parcelRequire("kS7wF");
var $0c634011a2313b34$var$$Map = $e0BBw('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $0c634011a2313b34$var$$mapGet = $aUGbd('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $0c634011a2313b34$var$$mapSet = $aUGbd('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0c634011a2313b34$var$$mapHas = $aUGbd('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0c634011a2313b34$var$$mapDelete = $aUGbd('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $0c634011a2313b34$var$$mapSize = $aUGbd('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$0c634011a2313b34$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kS7wF('Side channel does not contain ' + $1WZRg(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $0c634011a2313b34$var$$mapDelete($m, key);
                if ($0c634011a2313b34$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $0c634011a2313b34$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $0c634011a2313b34$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $0c634011a2313b34$var$$Map();
            $0c634011a2313b34$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("e0BBw", function(module, exports) {
'use strict';
var $a32e3c2da1678e38$var$undefined1;

var $bDFo4 = parcelRequire("bDFo4");

var $7CVei = parcelRequire("7CVei");

var $529hc = parcelRequire("529hc");

var $aEL3h = parcelRequire("aEL3h");

var $4FH2j = parcelRequire("4FH2j");

var $8yKOu = parcelRequire("8yKOu");

var $kS7wF = parcelRequire("kS7wF");

var $eawNf = parcelRequire("eawNf");

var $jH5UI = parcelRequire("jH5UI");

var $1CNmV = parcelRequire("1CNmV");

var $4FXKt = parcelRequire("4FXKt");

var $5K9Qy = parcelRequire("5K9Qy");

var $j0eWb = parcelRequire("j0eWb");

var $aju4Y = parcelRequire("aju4Y");

var $Yk1Gz = parcelRequire("Yk1Gz");
var $a32e3c2da1678e38$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $a32e3c2da1678e38$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $a32e3c2da1678e38$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $15uek = parcelRequire("15uek");

var $b11rU = parcelRequire("b11rU");
var $a32e3c2da1678e38$var$throwTypeError = function() {
    throw new $kS7wF();
};
var $a32e3c2da1678e38$var$ThrowTypeError = $15uek ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $a32e3c2da1678e38$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $15uek(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $a32e3c2da1678e38$var$throwTypeError;
        }
    }
}() : $a32e3c2da1678e38$var$throwTypeError;

var $a32e3c2da1678e38$var$hasSymbols = (parcelRequire("3MbC0"))();

var $8Pps9 = parcelRequire("8Pps9");

var $gFqkA = parcelRequire("gFqkA");

var $bPFgL = parcelRequire("bPFgL");

var $giOwQ = parcelRequire("giOwQ");

var $9Lm1y = parcelRequire("9Lm1y");
var $a32e3c2da1678e38$var$needsEval = {};
var $a32e3c2da1678e38$var$TypedArray = typeof Uint8Array === 'undefined' || !$8Pps9 ? undefined : $8Pps9(Uint8Array);
var $a32e3c2da1678e38$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $a32e3c2da1678e38$var$hasSymbols && $8Pps9 ? $8Pps9([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $a32e3c2da1678e38$var$needsEval,
    '%AsyncGenerator%': $a32e3c2da1678e38$var$needsEval,
    '%AsyncGeneratorFunction%': $a32e3c2da1678e38$var$needsEval,
    '%AsyncIteratorPrototype%': $a32e3c2da1678e38$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $7CVei,
    '%eval%': eval,
    '%EvalError%': $529hc,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $a32e3c2da1678e38$var$$Function,
    '%GeneratorFunction%': $a32e3c2da1678e38$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $a32e3c2da1678e38$var$hasSymbols && $8Pps9 ? $8Pps9($8Pps9([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$a32e3c2da1678e38$var$hasSymbols || !$8Pps9 ? undefined : $8Pps9(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $bDFo4,
    '%Object.getOwnPropertyDescriptor%': $15uek,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aEL3h,
    '%ReferenceError%': $4FH2j,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$a32e3c2da1678e38$var$hasSymbols || !$8Pps9 ? undefined : $8Pps9(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $a32e3c2da1678e38$var$hasSymbols && $8Pps9 ? $8Pps9(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $a32e3c2da1678e38$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $8yKOu,
    '%ThrowTypeError%': $a32e3c2da1678e38$var$ThrowTypeError,
    '%TypedArray%': $a32e3c2da1678e38$var$TypedArray,
    '%TypeError%': $kS7wF,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $eawNf,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9Lm1y,
    '%Function.prototype.apply%': $giOwQ,
    '%Object.defineProperty%': $b11rU,
    '%Object.getPrototypeOf%': $gFqkA,
    '%Math.abs%': $jH5UI,
    '%Math.floor%': $1CNmV,
    '%Math.max%': $4FXKt,
    '%Math.min%': $5K9Qy,
    '%Math.pow%': $j0eWb,
    '%Math.round%': $aju4Y,
    '%Math.sign%': $Yk1Gz,
    '%Reflect.getPrototypeOf%': $bPFgL
};
if ($8Pps9) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $a32e3c2da1678e38$var$errorProto = $8Pps9($8Pps9(e));
    $a32e3c2da1678e38$var$INTRINSICS['%Error.prototype%'] = $a32e3c2da1678e38$var$errorProto;
}
var $a32e3c2da1678e38$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $a32e3c2da1678e38$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $a32e3c2da1678e38$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $a32e3c2da1678e38$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $8Pps9) value = $8Pps9(gen.prototype);
    }
    $a32e3c2da1678e38$var$INTRINSICS[name] = value;
    return value;
};
var $a32e3c2da1678e38$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $dcAqh = parcelRequire("dcAqh");

var $i2DJ6 = parcelRequire("i2DJ6");
var $a32e3c2da1678e38$var$$concat = $dcAqh.call($9Lm1y, Array.prototype.concat);
var $a32e3c2da1678e38$var$$spliceApply = $dcAqh.call($giOwQ, Array.prototype.splice);
var $a32e3c2da1678e38$var$$replace = $dcAqh.call($9Lm1y, String.prototype.replace);
var $a32e3c2da1678e38$var$$strSlice = $dcAqh.call($9Lm1y, String.prototype.slice);
var $a32e3c2da1678e38$var$$exec = $dcAqh.call($9Lm1y, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $a32e3c2da1678e38$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $a32e3c2da1678e38$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $a32e3c2da1678e38$var$stringToPath = function stringToPath(string) {
    var first = $a32e3c2da1678e38$var$$strSlice(string, 0, 1);
    var last = $a32e3c2da1678e38$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $8yKOu('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $8yKOu('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $a32e3c2da1678e38$var$$replace(string, $a32e3c2da1678e38$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $a32e3c2da1678e38$var$$replace(subString, $a32e3c2da1678e38$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $a32e3c2da1678e38$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($i2DJ6($a32e3c2da1678e38$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $a32e3c2da1678e38$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($i2DJ6($a32e3c2da1678e38$var$INTRINSICS, intrinsicName)) {
        var value = $a32e3c2da1678e38$var$INTRINSICS[intrinsicName];
        if (value === $a32e3c2da1678e38$var$needsEval) value = $a32e3c2da1678e38$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $kS7wF('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $8yKOu('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $kS7wF('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $kS7wF('"allowMissing" argument must be a boolean');
    if ($a32e3c2da1678e38$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $8yKOu('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $a32e3c2da1678e38$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $a32e3c2da1678e38$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $a32e3c2da1678e38$var$$spliceApply(parts, $a32e3c2da1678e38$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $a32e3c2da1678e38$var$$strSlice(part, 0, 1);
        var last = $a32e3c2da1678e38$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $8yKOu('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($i2DJ6($a32e3c2da1678e38$var$INTRINSICS, intrinsicRealName)) value = $a32e3c2da1678e38$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $kS7wF('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($15uek && i + 1 >= parts.length) {
                var desc = $15uek(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $i2DJ6(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $a32e3c2da1678e38$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("bDFo4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("7CVei", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("529hc", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aEL3h", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("4FH2j", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("8yKOu", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eawNf", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("jH5UI", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("1CNmV", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("4FXKt", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("5K9Qy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("j0eWb", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("aju4Y", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("Yk1Gz", function(module, exports) {
'use strict';

var $1OFVv = parcelRequire("1OFVv");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($1OFVv(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("1OFVv", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("15uek", function(module, exports) {
'use strict';

var $fJYz1 = parcelRequire("fJYz1");
var $0cadb52aa4f20443$require$$gOPD = $fJYz1;
if ($0cadb52aa4f20443$require$$gOPD) try {
    $0cadb52aa4f20443$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $0cadb52aa4f20443$require$$gOPD = null;
}
module.exports = $0cadb52aa4f20443$require$$gOPD;

});
parcelRegister("fJYz1", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("b11rU", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $8050e9779d4756f8$var$$defineProperty = Object.defineProperty || false;
if ($8050e9779d4756f8$var$$defineProperty) try {
    $8050e9779d4756f8$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $8050e9779d4756f8$var$$defineProperty = false;
}
module.exports = $8050e9779d4756f8$var$$defineProperty;

});

parcelRegister("3MbC0", function(module, exports) {
'use strict';
var $2bfedcada10f3218$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9WrZJ = parcelRequire("9WrZJ");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $2bfedcada10f3218$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $2bfedcada10f3218$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9WrZJ();
};

});
parcelRegister("9WrZJ", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8Pps9", function(module, exports) {
'use strict';

var $bPFgL = parcelRequire("bPFgL");

var $gFqkA = parcelRequire("gFqkA");

var $hfoD2 = parcelRequire("hfoD2");
/** @type {import('.')} */ module.exports = $bPFgL ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $bPFgL(O);
} : $gFqkA ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gFqkA(O);
} : $hfoD2 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hfoD2(O);
} : null;

});
parcelRegister("bPFgL", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("gFqkA", function(module, exports) {
'use strict';

var $bDFo4 = parcelRequire("bDFo4");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $bDFo4.getPrototypeOf || null;

});

parcelRegister("hfoD2", function(module, exports) {
'use strict';

var $cOyN9 = parcelRequire("cOyN9");

var $15uek = parcelRequire("15uek");
var $c8e6f120a269a66e$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $c8e6f120a269a66e$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $c8e6f120a269a66e$var$desc = !!$c8e6f120a269a66e$var$hasProtoAccessor && $15uek && $15uek(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $c8e6f120a269a66e$var$$Object = Object;
var $c8e6f120a269a66e$var$$getPrototypeOf = $c8e6f120a269a66e$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $c8e6f120a269a66e$var$desc && typeof $c8e6f120a269a66e$var$desc.get === 'function' ? $cOyN9([
    $c8e6f120a269a66e$var$desc.get
]) : typeof $c8e6f120a269a66e$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $c8e6f120a269a66e$var$$getPrototypeOf(value == null ? value : $c8e6f120a269a66e$var$$Object(value));
} : false;

});
parcelRegister("cOyN9", function(module, exports) {
'use strict';

var $dcAqh = parcelRequire("dcAqh");

var $kS7wF = parcelRequire("kS7wF");

var $9Lm1y = parcelRequire("9Lm1y");

var $hWQYy = parcelRequire("hWQYy");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $kS7wF('a function is required');
    return $hWQYy($dcAqh, $9Lm1y, args);
};

});
parcelRegister("dcAqh", function(module, exports) {
'use strict';

var $dy6Jb = parcelRequire("dy6Jb");
module.exports = Function.prototype.bind || $dy6Jb;

});
parcelRegister("dy6Jb", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $9dd3ab54d1343fbe$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $9dd3ab54d1343fbe$var$toStr = Object.prototype.toString;
var $9dd3ab54d1343fbe$var$max = Math.max;
var $9dd3ab54d1343fbe$var$funcType = '[object Function]';
var $9dd3ab54d1343fbe$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $9dd3ab54d1343fbe$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $9dd3ab54d1343fbe$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $9dd3ab54d1343fbe$var$toStr.apply(target) !== $9dd3ab54d1343fbe$var$funcType) throw new TypeError($9dd3ab54d1343fbe$var$ERROR_MESSAGE + target);
    var args = $9dd3ab54d1343fbe$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $9dd3ab54d1343fbe$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $9dd3ab54d1343fbe$var$concatty(args, arguments));
    };
    var boundLength = $9dd3ab54d1343fbe$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $9dd3ab54d1343fbe$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9Lm1y", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("hWQYy", function(module, exports) {
'use strict';

var $dcAqh = parcelRequire("dcAqh");

var $giOwQ = parcelRequire("giOwQ");

var $9Lm1y = parcelRequire("9Lm1y");

var $48E2r = parcelRequire("48E2r");
/** @type {import('./actualApply')} */ module.exports = $48E2r || $dcAqh.call($9Lm1y, $giOwQ);

});
parcelRegister("giOwQ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("48E2r", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("i2DJ6", function(module, exports) {
'use strict';
var $d2273ab8f73d1ea0$var$call = Function.prototype.call;
var $d2273ab8f73d1ea0$var$$hasOwn = Object.prototype.hasOwnProperty;

var $dcAqh = parcelRequire("dcAqh");
/** @type {import('.')} */ module.exports = $dcAqh.call($d2273ab8f73d1ea0$var$call, $d2273ab8f73d1ea0$var$$hasOwn);

});


parcelRegister("aUGbd", function(module, exports) {
'use strict';

var $e0BBw = parcelRequire("e0BBw");

var $cOyN9 = parcelRequire("cOyN9");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $7f1fda646d4d1895$var$$indexOf = $cOyN9([
    $e0BBw('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $e0BBw(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $7f1fda646d4d1895$var$$indexOf(name, '.prototype.') > -1) return $cOyN9(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("gzNdD", function(module, exports) {
'use strict';

var $e0BBw = parcelRequire("e0BBw");

var $aUGbd = parcelRequire("aUGbd");

var $1WZRg = parcelRequire("1WZRg");

var $13Wf7 = parcelRequire("13Wf7");

var $kS7wF = parcelRequire("kS7wF");
var $c116180db7c2bced$var$$WeakMap = $e0BBw('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $c116180db7c2bced$var$$weakMapGet = $aUGbd('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $c116180db7c2bced$var$$weakMapSet = $aUGbd('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $c116180db7c2bced$var$$weakMapHas = $aUGbd('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $c116180db7c2bced$var$$weakMapDelete = $aUGbd('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $c116180db7c2bced$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kS7wF('Side channel does not contain ' + $1WZRg(key));
        },
        'delete': function(key) {
            if ($c116180db7c2bced$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $c116180db7c2bced$var$$weakMapDelete($wm, key);
            } else if ($13Wf7) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($c116180db7c2bced$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $c116180db7c2bced$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($c116180db7c2bced$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $c116180db7c2bced$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($c116180db7c2bced$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $c116180db7c2bced$var$$WeakMap();
                $c116180db7c2bced$var$$weakMapSet($wm, key, value);
            } else if ($13Wf7) {
                if (!$m) $m = $13Wf7();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $13Wf7;

});


parcelRegister("6Um72", function(module, exports) {
'use strict';

var $2InO4 = parcelRequire("2InO4");

var $guOHz = parcelRequire("guOHz");

var $b11rU = parcelRequire("b11rU");
var $5079201a00a785d9$var$has = Object.prototype.hasOwnProperty;
var $5079201a00a785d9$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $5079201a00a785d9$var$overflowChannel = $guOHz();
var $5079201a00a785d9$var$markOverflow = function markOverflow(obj, maxIndex) {
    $5079201a00a785d9$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $5079201a00a785d9$var$isOverflow = function isOverflow(obj) {
    return $5079201a00a785d9$var$overflowChannel.has(obj);
};
var $5079201a00a785d9$var$getMaxIndex = function getMaxIndex(obj) {
    return $5079201a00a785d9$var$overflowChannel.get(obj);
};
var $5079201a00a785d9$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $5079201a00a785d9$var$overflowChannel.set(obj, maxIndex);
};
// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
// so repeated conflicts on one path append instead of nesting a new wrapper each time
var $5079201a00a785d9$var$conflictChannel = $guOHz();
var $5079201a00a785d9$var$markConflict = function markConflict(obj, maxIndex) {
    $5079201a00a785d9$var$conflictChannel.set(obj, maxIndex);
    return obj;
};
var $5079201a00a785d9$var$isConflict = function isConflict(obj) {
    return $5079201a00a785d9$var$conflictChannel.has(obj);
};
var $5079201a00a785d9$var$getConflictIndex = function getConflictIndex(obj) {
    return $5079201a00a785d9$var$conflictChannel.get(obj);
};
var $5079201a00a785d9$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $5079201a00a785d9$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($5079201a00a785d9$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $5079201a00a785d9$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $5079201a00a785d9$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $b11rU) $b11rU(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $5079201a00a785d9$var$maxNumericIndex = function maxNumericIndex(obj, min) {
    var max = min;
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; ++i){
        var num = parseInt(keys[i], 10);
        if (String(num) === keys[i] && num > max) max = num;
    }
    return max;
};
// parsed arrays stay sparse until `compact`, so `length` would count the holes left by indices like `a[19]`
var $5079201a00a785d9$var$countElements = function countElements(arr) {
    var count = 0;
    for(var i = 0; i < arr.length; ++i)if ($5079201a00a785d9$var$has.call(arr, i)) count += 1;
    return count;
};
var $5079201a00a785d9$var$limitedPair = function limitedPair(first, second, options) {
    var pair = [
        first,
        second
    ];
    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
        if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $5079201a00a785d9$var$markOverflow($5079201a00a785d9$var$arrayToObject(pair, options), 1);
    }
    return pair;
};
var $5079201a00a785d9$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($5079201a00a785d9$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && $5079201a00a785d9$var$countElements(target) >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $5079201a00a785d9$var$markOverflow($5079201a00a785d9$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($5079201a00a785d9$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $5079201a00a785d9$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $5079201a00a785d9$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge && $5079201a00a785d9$var$isConflict(target)) {
                var nextConflict = $5079201a00a785d9$var$getConflictIndex(target) + 1;
                if (options.throwOnLimitExceeded && typeof options.arrayLimit === 'number' && nextConflict >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                target[nextConflict] = source;
                $5079201a00a785d9$var$markConflict(target, nextConflict);
            } else if (options && options.strictMerge) {
                var conflict = $5079201a00a785d9$var$limitedPair(target, source, options);
                return $5079201a00a785d9$var$isArray(conflict) ? $5079201a00a785d9$var$markConflict(conflict, 1) : conflict;
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$5079201a00a785d9$var$has.call(Object.prototype, source)) target[source] = true;
        } else return $5079201a00a785d9$var$limitedPair(target, source, options);
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($5079201a00a785d9$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $5079201a00a785d9$var$markOverflow(result, $5079201a00a785d9$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $5079201a00a785d9$var$markOverflow($5079201a00a785d9$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($5079201a00a785d9$var$isArray(target) && !$5079201a00a785d9$var$isArray(source)) {
        mergeTarget = $5079201a00a785d9$var$arrayToObject(target, options);
        if ($5079201a00a785d9$var$isConflict(target)) // the array may have grown past its last conflict, so continue after its last index
        $5079201a00a785d9$var$markConflict(mergeTarget, target.length - 1);
    }
    if ($5079201a00a785d9$var$isArray(target) && $5079201a00a785d9$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($5079201a00a785d9$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && $5079201a00a785d9$var$countElements(target) > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $5079201a00a785d9$var$markOverflow($5079201a00a785d9$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($5079201a00a785d9$var$has.call(acc, key)) $5079201a00a785d9$var$setProperty(acc, key, merge(acc[key], value, options));
        else $5079201a00a785d9$var$setProperty(acc, key, value);
        if ($5079201a00a785d9$var$isOverflow(source) && !$5079201a00a785d9$var$isOverflow(acc)) $5079201a00a785d9$var$markOverflow(acc, $5079201a00a785d9$var$maxNumericIndex(acc, $5079201a00a785d9$var$getMaxIndex(source)));
        if ($5079201a00a785d9$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $5079201a00a785d9$var$getMaxIndex(acc)) $5079201a00a785d9$var$setMaxIndex(acc, keyNum);
        }
        if ($5079201a00a785d9$var$isConflict(acc)) {
            var conflictKey = parseInt(key, 10);
            if (String(conflictKey) === key && conflictKey > $5079201a00a785d9$var$getConflictIndex(acc)) $5079201a00a785d9$var$markConflict(acc, conflictKey);
        }
        return acc;
    }, mergeTarget);
};
var $5079201a00a785d9$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $5079201a00a785d9$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $5079201a00a785d9$var$decode = function(str, defaultDecoder, charset) {
    // With no `%` there is no escape to expand, in either charset: `unescape` has
    // nothing to match, and `decodeURIComponent` is the identity on such a string
    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
    if (typeof str === 'string' && str.indexOf('%') === -1) return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $5079201a00a785d9$var$hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
var $5079201a00a785d9$var$arrayJoin = Array.prototype.join;
var $5079201a00a785d9$var$arrayToString = Array.prototype.toString;
var $5079201a00a785d9$var$objectToString = Object.prototype.toString;
// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
var $5079201a00a785d9$var$toCoercible = function toCoercible(value, joining) {
    if (!value || typeof value !== 'object' && typeof value !== 'function') return value;
    if ($5079201a00a785d9$var$hasToPrimitive && value[Symbol.toPrimitive] != null) return value;
    if ($5079201a00a785d9$var$isArray(value) && value.toString === $5079201a00a785d9$var$arrayToString && value.join === $5079201a00a785d9$var$arrayJoin) {
        var ancestors = joining || $guOHz();
        if (ancestors.has(value)) return '';
        ancestors.set(value, true);
        var copy;
        for(var i = 0; i < value.length; i += 1){
            var item = value[i];
            var coerced = toCoercible(item, ancestors);
            if (!copy && coerced !== item) {
                copy = [];
                for(var j = 0; j < i; j += 1)copy[j] = value[j];
            }
            if (copy) copy[i] = coerced;
        }
        ancestors['delete'](value);
        return copy || value;
    }
    if (typeof value.toString === 'function') return value;
    var valueOf = value.valueOf;
    if (typeof valueOf === 'function') {
        var primitive = valueOf.call(value);
        if (!primitive || typeof primitive !== 'object' && typeof primitive !== 'function') return String(primitive);
    }
    return $5079201a00a785d9$var$objectToString.call(value);
};
var $5079201a00a785d9$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $5079201a00a785d9$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String($5079201a00a785d9$var$toCoercible(str));
    if (charset === 'iso-8859-1') // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
    // so it must be percent-encoded to round-trip (the utf-8 path already does this).
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    }).replace(/\+/g, '%2B');
    var out = '';
    for(var j = 0; j < string.length; j += $5079201a00a785d9$var$limit){
        var segment = string.length >= $5079201a00a785d9$var$limit ? string.slice(j, j + $5079201a00a785d9$var$limit) : string;
        if (j + $5079201a00a785d9$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E && format !== $2InO4.WHATWG // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $2InO4.RFC1738 && (c === 0x28 || c === 0x29) // ( )
             || format === $2InO4.WHATWG && c === 0x2A // *
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $5079201a00a785d9$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $5079201a00a785d9$var$hexTable[0xC0 | c >> 6] + $5079201a00a785d9$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $5079201a00a785d9$var$hexTable[0xE0 | c >> 12] + $5079201a00a785d9$var$hexTable[0x80 | c >> 6 & 0x3F] + $5079201a00a785d9$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            var next = segment.charCodeAt(i + 1);
            if (c <= 0xDBFF && next >= 0xDC00 && next <= 0xDFFF) {
                i += 1;
                c = 0x10000 + ((c & 0x3FF) << 10 | next & 0x3FF);
                arr[arr.length] = $5079201a00a785d9$var$hexTable[0xF0 | c >> 18] + $5079201a00a785d9$var$hexTable[0x80 | c >> 12 & 0x3F] + $5079201a00a785d9$var$hexTable[0x80 | c >> 6 & 0x3F] + $5079201a00a785d9$var$hexTable[0x80 | c & 0x3F];
            } else // a lone surrogate has no UTF-8 encoding; like `URLSearchParams` and `TextEncoder`, emit U+FFFD
            arr[arr.length] = '%EF%BF%BD';
        }
        out += arr.join('');
    }
    return out;
};
var $5079201a00a785d9$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $guOHz();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $5079201a00a785d9$var$compactQueue(queue);
    return value;
};
var $5079201a00a785d9$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $5079201a00a785d9$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};
var $5079201a00a785d9$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($5079201a00a785d9$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = $5079201a00a785d9$var$isArray(b) ? b : [
            b
        ];
        var newIndex = $5079201a00a785d9$var$getMaxIndex(a);
        for(var i = 0; i < bValues.length; ++i){
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        $5079201a00a785d9$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $5079201a00a785d9$var$markOverflow($5079201a00a785d9$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $5079201a00a785d9$var$maybeMap = function maybeMap(val, fn) {
    if ($5079201a00a785d9$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $5079201a00a785d9$var$arrayToObject,
    assign: $5079201a00a785d9$var$assign,
    combine: $5079201a00a785d9$var$combine,
    compact: $5079201a00a785d9$var$compact,
    decode: $5079201a00a785d9$var$decode,
    encode: $5079201a00a785d9$var$encode,
    isBuffer: $5079201a00a785d9$var$isBuffer,
    isOverflow: $5079201a00a785d9$var$isOverflow,
    isRegExp: $5079201a00a785d9$var$isRegExp,
    markOverflow: $5079201a00a785d9$var$markOverflow,
    maybeMap: $5079201a00a785d9$var$maybeMap,
    merge: $5079201a00a785d9$var$merge,
    setProperty: $5079201a00a785d9$var$setProperty,
    toCoercible: $5079201a00a785d9$var$toCoercible
};

});
parcelRegister("2InO4", function(module, exports) {
'use strict';
var $1fa2285992c7af58$var$replace = String.prototype.replace;
var $1fa2285992c7af58$var$percentTwenties = /%20/g;
var $1fa2285992c7af58$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986',
    WHATWG: 'WHATWG'
};
module.exports = {
    'default': $1fa2285992c7af58$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $1fa2285992c7af58$var$replace.call(value, $1fa2285992c7af58$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        },
        WHATWG: function(value) {
            return $1fa2285992c7af58$var$replace.call(value, $1fa2285992c7af58$var$percentTwenties, '+');
        }
    },
    RFC1738: $1fa2285992c7af58$var$Format.RFC1738,
    RFC3986: $1fa2285992c7af58$var$Format.RFC3986,
    WHATWG: $1fa2285992c7af58$var$Format.WHATWG
};

});



parcelRegister("gnTvJ", function(module, exports) {
'use strict';

var $guOHz = parcelRequire("guOHz");

var $6Um72 = parcelRequire("6Um72");
var $bed9da98ecacd0b2$var$has = Object.prototype.hasOwnProperty;
var $bed9da98ecacd0b2$var$isArray = Array.isArray;
var $bed9da98ecacd0b2$var$getPrototypeOf = Object.getPrototypeOf;
var $bed9da98ecacd0b2$var$fromCharCode = String.fromCharCode;
var $bed9da98ecacd0b2$var$isPlainContainer = function isPlainContainer(value) {
    if (!value || typeof value !== 'object') return false;
    if ($bed9da98ecacd0b2$var$isArray(value)) return true;
    var proto = $bed9da98ecacd0b2$var$getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
var $bed9da98ecacd0b2$var$emptyCopyOf = function emptyCopyOf(value) {
    if ($bed9da98ecacd0b2$var$isArray(value)) {
        var arr = [];
        arr.length = value.length;
        return arr;
    }
    return $bed9da98ecacd0b2$var$getPrototypeOf(value) === null ? {
        __proto__: null
    } : {};
};
// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
var $bed9da98ecacd0b2$var$copyInput = function copyInput(input) {
    var copies = $guOHz();
    var result = {};
    var queue = [
        {
            source: input,
            target: result
        }
    ];
    for(var i = 0; i < queue.length; ++i){
        var source = queue[i].source;
        var target = queue[i].target;
        var keys = Object.keys(source);
        for(var j = 0; j < keys.length; ++j){
            var value = source[keys[j]];
            // `target[key] =` would invoke the `__proto__` setter. `setProperty` stores that key as data.
            if ($bed9da98ecacd0b2$var$isPlainContainer(value)) {
                if (!copies.has(value)) {
                    var copy = $bed9da98ecacd0b2$var$emptyCopyOf(value);
                    copies.set(value, copy);
                    queue[queue.length] = {
                        source: value,
                        target: copy
                    };
                }
                $6Um72.setProperty(target, keys[j], copies.get(value));
            } else $6Um72.setProperty(target, keys[j], value);
        }
    }
    return result;
};
var $bed9da98ecacd0b2$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $6Um72.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $bed9da98ecacd0b2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        var c = parseInt(numberStr, 10);
        if (c > 0xFFFF && c <= 0x10FFFF) {
            // `String.fromCodePoint` is not available in every supported engine, so build the surrogate pair by hand
            c -= 0x10000;
            return $bed9da98ecacd0b2$var$fromCharCode(0xD800 | c >> 10, 0xDC00 | c & 0x3FF);
        }
        return $bed9da98ecacd0b2$var$fromCharCode(c);
    });
};
var $bed9da98ecacd0b2$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit && currentArrayLength > 0) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $bed9da98ecacd0b2$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $bed9da98ecacd0b2$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $bed9da98ecacd0b2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $bed9da98ecacd0b2$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $bed9da98ecacd0b2$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $bed9da98ecacd0b2$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $bed9da98ecacd0b2$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $6Um72.maybeMap($bed9da98ecacd0b2$var$parseArrayValue(part.slice(pos + 1), options, $bed9da98ecacd0b2$var$isArray(obj[key]) && (options.duplicates === 'combine' || isEmptyBracketKey) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $bed9da98ecacd0b2$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $6Um72.maybeMap(val, function(value) {
            return value ? $bed9da98ecacd0b2$var$interpretNumericEntities(String(value)) : value;
        });
        if (isEmptyBracketKey) val = $bed9da98ecacd0b2$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $bed9da98ecacd0b2$var$isArray(val) && val.length > options.arrayLimit) val = $6Um72.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $bed9da98ecacd0b2$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) obj[key] = $6Um72.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $bed9da98ecacd0b2$var$stripWrappingBrackets = function stripWrappingBrackets(key) {
    return key.charAt(0) === '[' && key.charAt(key.length - 1) === ']' ? key.slice(1, -1) : key;
};
var $bed9da98ecacd0b2$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $bed9da98ecacd0b2$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($6Um72.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $6Um72.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = $bed9da98ecacd0b2$var$stripWrappingBrackets(root);
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/gi, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj[0] = leaf;
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $6Um72.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
var $bed9da98ecacd0b2$var$topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
    var result = '';
    var depth = 0;
    for(var i = 0; i < key.length; i += 1){
        var cu = key.charCodeAt(i);
        if (cu === 0x5B) {
            depth += 1;
            result += '[';
        } else if (cu === 0x5D) {
            if (depth > 0) depth -= 1;
            result += ']';
        } else if (cu === 0x2E // '.'
         && depth === 0 && i + 1 < key.length && key.charCodeAt(i + 1) !== 0x2E // not another '.'
         && key.charCodeAt(i + 1) !== 0x5B // not '['
        ) {
            var start = i + 1;
            var j = start;
            while(j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B)j += 1;
            result += '[' + key.slice(start, j) + ']';
            i = j - 1;
        } else result += key.charAt(i);
    }
    return result;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $bed9da98ecacd0b2$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? $bed9da98ecacd0b2$var$topLevelDotsToBrackets(originalKey) : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        // `parseObject` strips one wrapping bracket pair, so guard the key it will store ("[toString]" -> "toString")
        if (!options.plainObjects && $bed9da98ecacd0b2$var$has.call(Object.prototype, $bed9da98ecacd0b2$var$stripWrappingBrackets(key))) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $bed9da98ecacd0b2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $bed9da98ecacd0b2$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $bed9da98ecacd0b2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $bed9da98ecacd0b2$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $bed9da98ecacd0b2$var$parseObject(keys, val, options, valuesParsed);
};
var $bed9da98ecacd0b2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $bed9da98ecacd0b2$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $bed9da98ecacd0b2$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $bed9da98ecacd0b2$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $bed9da98ecacd0b2$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $bed9da98ecacd0b2$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $bed9da98ecacd0b2$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $bed9da98ecacd0b2$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $bed9da98ecacd0b2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $bed9da98ecacd0b2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $bed9da98ecacd0b2$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $bed9da98ecacd0b2$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $bed9da98ecacd0b2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $6Um72.isRegExp(opts.delimiter) ? opts.delimiter : $bed9da98ecacd0b2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $bed9da98ecacd0b2$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $bed9da98ecacd0b2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $bed9da98ecacd0b2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $bed9da98ecacd0b2$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $bed9da98ecacd0b2$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $bed9da98ecacd0b2$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $bed9da98ecacd0b2$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $bed9da98ecacd0b2$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $bed9da98ecacd0b2$var$parseValues(str, options) : $bed9da98ecacd0b2$var$copyInput(str);
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $bed9da98ecacd0b2$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $6Um72.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $6Um72.compact(obj);
};

});



parcelRegister("i9mdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $lPRYN = parcelRequire("lPRYN");

var $bbsdH = parcelRequire("bbsdH");

var $l5UcW = parcelRequire("l5UcW");

var $8Cal1 = parcelRequire("8Cal1");

var $l68vo = parcelRequire("l68vo");

var $2jaeq = parcelRequire("2jaeq");
var $d36a4c0601de62b6$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $8Cal1.supportsWebCrypto)((0, $2jaeq.locateWindow)())) this.hash = new $bbsdH.Sha256(secret);
        else if ((0, $l68vo.isMsWindow)((0, $2jaeq.locateWindow)())) this.hash = new $lPRYN.Sha256(secret);
        else this.hash = new $l5UcW.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $d36a4c0601de62b6$var$Sha256;

});
parcelRegister("lPRYN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $4p7wa = parcelRequire("4p7wa");

var $kz09t = parcelRequire("kz09t");

var $2rbHa = parcelRequire("2rbHa");

var $2jaeq = parcelRequire("2jaeq");
var $fe583b9e3faca739$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $fe583b9e3faca739$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $2jaeq.locateWindow)().msCrypto.subtle.sign($kz09t.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $2jaeq.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $4p7wa.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($fe583b9e3faca739$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $fe583b9e3faca739$var$Sha256;
function $fe583b9e3faca739$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $2jaeq.locateWindow)().msCrypto.subtle.importKey("raw", $fe583b9e3faca739$var$toArrayBufferView(secret), $kz09t.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $fe583b9e3faca739$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $2rbHa.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("4p7wa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $334f54204894e19c$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $334f54204894e19c$var$isEmptyData;

});

parcelRegister("kz09t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("2jaeq", function(module, exports) {

$parcel$export(module.exports, "locateWindow", function () { return $1ae54ae7561f4625$export$2a77db4d0e0dd1ff; });
const $1ae54ae7561f4625$var$fallbackWindow = {};
function $1ae54ae7561f4625$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $1ae54ae7561f4625$var$fallbackWindow;
}

});


parcelRegister("bbsdH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $4OHCC = parcelRequire("4OHCC");

var $kz09t = parcelRequire("kz09t");

var $2jaeq = parcelRequire("2jaeq");
var $82469cace7272225$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $2jaeq.locateWindow)().crypto.subtle.importKey("raw", (0, $4OHCC.convertToBuffer)(secret), $kz09t.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $4OHCC.isEmptyData)(data)) return;
        var update = (0, $4OHCC.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $2jaeq.locateWindow)().crypto.subtle.sign($kz09t.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $4OHCC.isEmptyData)(this.toHash)) return Promise.resolve($kz09t.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $2jaeq.locateWindow)().crypto.subtle.digest($kz09t.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $82469cace7272225$var$Sha256;

});
parcelRegister("4OHCC", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $bEttp = parcelRequire("bEttp");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $bEttp.convertToBuffer;
    }
});

var $lS3Yd = parcelRequire("lS3Yd");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $lS3Yd.isEmptyData;
    }
});

var $j9qX4 = parcelRequire("j9qX4");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $j9qX4.numToUint8;
    }
});

var $3IJwq = parcelRequire("3IJwq");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $3IJwq.uint32ArrayFrom;
    }
});

});
parcelRegister("bEttp", function(module, exports) {

var $5rAHc = parcelRequire("5rAHc");
var $87ba4aec162a763d$require$Buffer = $5rAHc.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $5iJKR = parcelRequire("5iJKR");
// Quick polyfill
var $87ba4aec162a763d$var$fromUtf8 = typeof $87ba4aec162a763d$require$Buffer !== "undefined" && $87ba4aec162a763d$require$Buffer.from ? function(input) {
    return $87ba4aec162a763d$require$Buffer.from(input, "utf8");
} : $5iJKR.fromUtf8;
function $87ba4aec162a763d$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $87ba4aec162a763d$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $87ba4aec162a763d$var$convertToBuffer;

});
parcelRegister("5rAHc", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3f6bf06693ea9a56$export$a143d493d941bafc; }, function (v) { return $3f6bf06693ea9a56$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3f6bf06693ea9a56$export$f99ded8fe4b79145; }, function (v) { return $3f6bf06693ea9a56$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3f6bf06693ea9a56$export$a143d493d941bafc;
var $3f6bf06693ea9a56$export$e4cf37d7f6fb9e0a;
var $3f6bf06693ea9a56$export$f99ded8fe4b79145;
var $3f6bf06693ea9a56$export$599f31c3813fae4d;
'use strict';

var $iImIH = parcelRequire("iImIH");

var $fO9md = parcelRequire("fO9md");
const $3f6bf06693ea9a56$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3f6bf06693ea9a56$export$a143d493d941bafc = $3f6bf06693ea9a56$var$Buffer;
$3f6bf06693ea9a56$export$e4cf37d7f6fb9e0a = $3f6bf06693ea9a56$var$SlowBuffer;
$3f6bf06693ea9a56$export$f99ded8fe4b79145 = 50;
const $3f6bf06693ea9a56$var$K_MAX_LENGTH = 0x7fffffff;
$3f6bf06693ea9a56$export$599f31c3813fae4d = $3f6bf06693ea9a56$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3f6bf06693ea9a56$var$Buffer.TYPED_ARRAY_SUPPORT = $3f6bf06693ea9a56$var$typedArraySupport();
if (!$3f6bf06693ea9a56$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3f6bf06693ea9a56$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3f6bf06693ea9a56$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3f6bf06693ea9a56$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3f6bf06693ea9a56$var$createBuffer(length) {
    if (length > $3f6bf06693ea9a56$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3f6bf06693ea9a56$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3f6bf06693ea9a56$var$allocUnsafe(arg);
    }
    return $3f6bf06693ea9a56$var$from(arg, encodingOrOffset, length);
}
$3f6bf06693ea9a56$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3f6bf06693ea9a56$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3f6bf06693ea9a56$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3f6bf06693ea9a56$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3f6bf06693ea9a56$var$isInstance(value, ArrayBuffer) || value && $3f6bf06693ea9a56$var$isInstance(value.buffer, ArrayBuffer)) return $3f6bf06693ea9a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3f6bf06693ea9a56$var$isInstance(value, SharedArrayBuffer) || value && $3f6bf06693ea9a56$var$isInstance(value.buffer, SharedArrayBuffer))) return $3f6bf06693ea9a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3f6bf06693ea9a56$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3f6bf06693ea9a56$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3f6bf06693ea9a56$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3f6bf06693ea9a56$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3f6bf06693ea9a56$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3f6bf06693ea9a56$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3f6bf06693ea9a56$var$Buffer, Uint8Array);
function $3f6bf06693ea9a56$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3f6bf06693ea9a56$var$alloc(size, fill, encoding) {
    $3f6bf06693ea9a56$var$assertSize(size);
    if (size <= 0) return $3f6bf06693ea9a56$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3f6bf06693ea9a56$var$createBuffer(size).fill(fill, encoding) : $3f6bf06693ea9a56$var$createBuffer(size).fill(fill);
    return $3f6bf06693ea9a56$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3f6bf06693ea9a56$var$Buffer.alloc = function(size, fill, encoding) {
    return $3f6bf06693ea9a56$var$alloc(size, fill, encoding);
};
function $3f6bf06693ea9a56$var$allocUnsafe(size) {
    $3f6bf06693ea9a56$var$assertSize(size);
    return $3f6bf06693ea9a56$var$createBuffer(size < 0 ? 0 : $3f6bf06693ea9a56$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3f6bf06693ea9a56$var$Buffer.allocUnsafe = function(size) {
    return $3f6bf06693ea9a56$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3f6bf06693ea9a56$var$Buffer.allocUnsafeSlow = function(size) {
    return $3f6bf06693ea9a56$var$allocUnsafe(size);
};
function $3f6bf06693ea9a56$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3f6bf06693ea9a56$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3f6bf06693ea9a56$var$byteLength(string, encoding) | 0;
    let buf = $3f6bf06693ea9a56$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3f6bf06693ea9a56$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3f6bf06693ea9a56$var$checked(array.length) | 0;
    const buf = $3f6bf06693ea9a56$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3f6bf06693ea9a56$var$fromArrayView(arrayView) {
    if ($3f6bf06693ea9a56$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3f6bf06693ea9a56$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3f6bf06693ea9a56$var$fromArrayLike(arrayView);
}
function $3f6bf06693ea9a56$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return buf;
}
function $3f6bf06693ea9a56$var$fromObject(obj) {
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(obj)) {
        const len = $3f6bf06693ea9a56$var$checked(obj.length) | 0;
        const buf = $3f6bf06693ea9a56$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3f6bf06693ea9a56$var$numberIsNaN(obj.length)) return $3f6bf06693ea9a56$var$createBuffer(0);
        return $3f6bf06693ea9a56$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3f6bf06693ea9a56$var$fromArrayLike(obj.data);
}
function $3f6bf06693ea9a56$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3f6bf06693ea9a56$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3f6bf06693ea9a56$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3f6bf06693ea9a56$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3f6bf06693ea9a56$var$Buffer.alloc(+length);
}
$3f6bf06693ea9a56$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3f6bf06693ea9a56$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3f6bf06693ea9a56$var$Buffer.compare = function compare(a, b) {
    if ($3f6bf06693ea9a56$var$isInstance(a, Uint8Array)) a = $3f6bf06693ea9a56$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3f6bf06693ea9a56$var$isInstance(b, Uint8Array)) b = $3f6bf06693ea9a56$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(a) || !$3f6bf06693ea9a56$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3f6bf06693ea9a56$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3f6bf06693ea9a56$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3f6bf06693ea9a56$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3f6bf06693ea9a56$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3f6bf06693ea9a56$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) buf = $3f6bf06693ea9a56$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3f6bf06693ea9a56$var$byteLength(string, encoding) {
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3f6bf06693ea9a56$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3f6bf06693ea9a56$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3f6bf06693ea9a56$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3f6bf06693ea9a56$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3f6bf06693ea9a56$var$Buffer.byteLength = $3f6bf06693ea9a56$var$byteLength;
function $3f6bf06693ea9a56$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3f6bf06693ea9a56$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3f6bf06693ea9a56$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3f6bf06693ea9a56$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3f6bf06693ea9a56$var$latin1Slice(this, start, end);
        case 'base64':
            return $3f6bf06693ea9a56$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3f6bf06693ea9a56$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3f6bf06693ea9a56$var$Buffer.prototype._isBuffer = true;
function $3f6bf06693ea9a56$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3f6bf06693ea9a56$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3f6bf06693ea9a56$var$swap(this, i, i + 1);
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3f6bf06693ea9a56$var$swap(this, i, i + 3);
        $3f6bf06693ea9a56$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3f6bf06693ea9a56$var$swap(this, i, i + 7);
        $3f6bf06693ea9a56$var$swap(this, i + 1, i + 6);
        $3f6bf06693ea9a56$var$swap(this, i + 2, i + 5);
        $3f6bf06693ea9a56$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3f6bf06693ea9a56$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3f6bf06693ea9a56$var$utf8Slice(this, 0, length);
    return $3f6bf06693ea9a56$var$slowToString.apply(this, arguments);
};
$3f6bf06693ea9a56$var$Buffer.prototype.toLocaleString = $3f6bf06693ea9a56$var$Buffer.prototype.toString;
$3f6bf06693ea9a56$var$Buffer.prototype.equals = function equals(b) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3f6bf06693ea9a56$var$Buffer.compare(this, b) === 0;
};
$3f6bf06693ea9a56$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3f6bf06693ea9a56$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3f6bf06693ea9a56$var$customInspectSymbol) $3f6bf06693ea9a56$var$Buffer.prototype[$3f6bf06693ea9a56$var$customInspectSymbol] = $3f6bf06693ea9a56$var$Buffer.prototype.inspect;
$3f6bf06693ea9a56$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3f6bf06693ea9a56$var$isInstance(target, Uint8Array)) target = $3f6bf06693ea9a56$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3f6bf06693ea9a56$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3f6bf06693ea9a56$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3f6bf06693ea9a56$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3f6bf06693ea9a56$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3f6bf06693ea9a56$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3f6bf06693ea9a56$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3f6bf06693ea9a56$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3f6bf06693ea9a56$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3f6bf06693ea9a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3f6bf06693ea9a56$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3f6bf06693ea9a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3f6bf06693ea9a56$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3f6bf06693ea9a56$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3f6bf06693ea9a56$var$utf8Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3f6bf06693ea9a56$var$asciiWrite(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$asciiToBytes(string), buf, offset, length);
}
function $3f6bf06693ea9a56$var$base64Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$base64ToBytes(string), buf, offset, length);
}
function $3f6bf06693ea9a56$var$ucs2Write(buf, string, offset, length) {
    return $3f6bf06693ea9a56$var$blitBuffer($3f6bf06693ea9a56$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3f6bf06693ea9a56$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3f6bf06693ea9a56$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3f6bf06693ea9a56$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3f6bf06693ea9a56$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3f6bf06693ea9a56$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3f6bf06693ea9a56$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3f6bf06693ea9a56$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3f6bf06693ea9a56$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iImIH.fromByteArray(buf);
    else return $iImIH.fromByteArray(buf.slice(start, end));
}
function $3f6bf06693ea9a56$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3f6bf06693ea9a56$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3f6bf06693ea9a56$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3f6bf06693ea9a56$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3f6bf06693ea9a56$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3f6bf06693ea9a56$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3f6bf06693ea9a56$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3f6bf06693ea9a56$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3f6bf06693ea9a56$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3f6bf06693ea9a56$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3f6bf06693ea9a56$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3f6bf06693ea9a56$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3f6bf06693ea9a56$var$Buffer.prototype.readUintLE = $3f6bf06693ea9a56$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUintBE = $3f6bf06693ea9a56$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint8 = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint16LE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint16BE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint32LE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readUint32BE = $3f6bf06693ea9a56$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readBigUInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3f6bf06693ea9a56$var$Buffer.prototype.readBigUInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3f6bf06693ea9a56$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3f6bf06693ea9a56$var$Buffer.prototype.readBigInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readBigInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3f6bf06693ea9a56$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f6bf06693ea9a56$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3f6bf06693ea9a56$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return $fO9md.read(this, offset, true, 23, 4);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 4, this.length);
    return $fO9md.read(this, offset, false, 23, 4);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 8, this.length);
    return $fO9md.read(this, offset, true, 52, 8);
};
$3f6bf06693ea9a56$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkOffset(offset, 8, this.length);
    return $fO9md.read(this, offset, false, 52, 8);
};
function $3f6bf06693ea9a56$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeUintLE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUintBE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint8 = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint16LE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint16BE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint32LE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeUint32BE = $3f6bf06693ea9a56$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3f6bf06693ea9a56$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3f6bf06693ea9a56$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigUInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigUInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f6bf06693ea9a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigInt64LE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3f6bf06693ea9a56$var$Buffer.prototype.writeBigInt64BE = $3f6bf06693ea9a56$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3f6bf06693ea9a56$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3f6bf06693ea9a56$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $fO9md.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeFloat(this, value, offset, true, noAssert);
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeFloat(this, value, offset, false, noAssert);
};
function $3f6bf06693ea9a56$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f6bf06693ea9a56$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $fO9md.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3f6bf06693ea9a56$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeDouble(this, value, offset, true, noAssert);
};
$3f6bf06693ea9a56$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3f6bf06693ea9a56$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3f6bf06693ea9a56$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3f6bf06693ea9a56$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3f6bf06693ea9a56$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3f6bf06693ea9a56$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3f6bf06693ea9a56$var$Buffer.isBuffer(val) ? val : $3f6bf06693ea9a56$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3f6bf06693ea9a56$var$errors = {};
function $3f6bf06693ea9a56$var$E(sym, getMessage, Base) {
    $3f6bf06693ea9a56$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$3f6bf06693ea9a56$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3f6bf06693ea9a56$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3f6bf06693ea9a56$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3f6bf06693ea9a56$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3f6bf06693ea9a56$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3f6bf06693ea9a56$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3f6bf06693ea9a56$var$checkBounds(buf, offset, byteLength) {
    $3f6bf06693ea9a56$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3f6bf06693ea9a56$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3f6bf06693ea9a56$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3f6bf06693ea9a56$var$checkBounds(buf, offset, byteLength);
}
function $3f6bf06693ea9a56$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3f6bf06693ea9a56$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3f6bf06693ea9a56$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3f6bf06693ea9a56$var$validateNumber(value, type);
        throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3f6bf06693ea9a56$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3f6bf06693ea9a56$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3f6bf06693ea9a56$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3f6bf06693ea9a56$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3f6bf06693ea9a56$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3f6bf06693ea9a56$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3f6bf06693ea9a56$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3f6bf06693ea9a56$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3f6bf06693ea9a56$var$base64ToBytes(str) {
    return $iImIH.toByteArray($3f6bf06693ea9a56$var$base64clean(str));
}
function $3f6bf06693ea9a56$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3f6bf06693ea9a56$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3f6bf06693ea9a56$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3f6bf06693ea9a56$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3f6bf06693ea9a56$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3f6bf06693ea9a56$var$BufferBigIntNotDefined : fn;
}
function $3f6bf06693ea9a56$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("iImIH", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $d9fdf5bdbb84785c$export$d622b2ad8d90c771; }, function (v) { return $d9fdf5bdbb84785c$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $d9fdf5bdbb84785c$export$6100ba28696e12de; }, function (v) { return $d9fdf5bdbb84785c$export$6100ba28696e12de = v; });
var $d9fdf5bdbb84785c$export$a48f0734ac7c2329;
var $d9fdf5bdbb84785c$export$d622b2ad8d90c771;
var $d9fdf5bdbb84785c$export$6100ba28696e12de;
'use strict';
$d9fdf5bdbb84785c$export$a48f0734ac7c2329 = $d9fdf5bdbb84785c$var$byteLength;
$d9fdf5bdbb84785c$export$d622b2ad8d90c771 = $d9fdf5bdbb84785c$var$toByteArray;
$d9fdf5bdbb84785c$export$6100ba28696e12de = $d9fdf5bdbb84785c$var$fromByteArray;
var $d9fdf5bdbb84785c$var$lookup = [];
var $d9fdf5bdbb84785c$var$revLookup = [];
var $d9fdf5bdbb84785c$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $d9fdf5bdbb84785c$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $d9fdf5bdbb84785c$var$i = 0, $d9fdf5bdbb84785c$var$len = $d9fdf5bdbb84785c$var$code.length; $d9fdf5bdbb84785c$var$i < $d9fdf5bdbb84785c$var$len; ++$d9fdf5bdbb84785c$var$i){
    $d9fdf5bdbb84785c$var$lookup[$d9fdf5bdbb84785c$var$i] = $d9fdf5bdbb84785c$var$code[$d9fdf5bdbb84785c$var$i];
    $d9fdf5bdbb84785c$var$revLookup[$d9fdf5bdbb84785c$var$code.charCodeAt($d9fdf5bdbb84785c$var$i)] = $d9fdf5bdbb84785c$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d9fdf5bdbb84785c$var$revLookup['-'.charCodeAt(0)] = 62;
$d9fdf5bdbb84785c$var$revLookup['_'.charCodeAt(0)] = 63;
function $d9fdf5bdbb84785c$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d9fdf5bdbb84785c$var$byteLength(b64) {
    var lens = $d9fdf5bdbb84785c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d9fdf5bdbb84785c$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d9fdf5bdbb84785c$var$toByteArray(b64) {
    var tmp;
    var lens = $d9fdf5bdbb84785c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d9fdf5bdbb84785c$var$Arr($d9fdf5bdbb84785c$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 18 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 2 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i)] << 10 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d9fdf5bdbb84785c$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d9fdf5bdbb84785c$var$tripletToBase64(num) {
    return $d9fdf5bdbb84785c$var$lookup[num >> 18 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num >> 12 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num >> 6 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[num & 0x3F];
}
function $d9fdf5bdbb84785c$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d9fdf5bdbb84785c$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $d9fdf5bdbb84785c$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d9fdf5bdbb84785c$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d9fdf5bdbb84785c$var$lookup[tmp >> 2] + $d9fdf5bdbb84785c$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d9fdf5bdbb84785c$var$lookup[tmp >> 10] + $d9fdf5bdbb84785c$var$lookup[tmp >> 4 & 0x3F] + $d9fdf5bdbb84785c$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("fO9md", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $b822c8ad7030d15d$export$aafa59e2e03f2942; }, function (v) { return $b822c8ad7030d15d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $b822c8ad7030d15d$export$68d8715fc104d294; }, function (v) { return $b822c8ad7030d15d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $b822c8ad7030d15d$export$aafa59e2e03f2942;
var $b822c8ad7030d15d$export$68d8715fc104d294;
$b822c8ad7030d15d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b822c8ad7030d15d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5iJKR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $3dc2202732dd84f6$export$c7c5cef950a4d2fc; });

var $1mKdH = parcelRequire("1mKdH");

var $bwcUB = parcelRequire("bwcUB");
const $3dc2202732dd84f6$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $bwcUB.fromUtf8)(input) : (0, $1mKdH.fromUtf8)(input);
const $3dc2202732dd84f6$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $bwcUB.toUtf8)(input) : (0, $1mKdH.toUtf8)(input);

});
parcelRegister("1mKdH", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $0febb2d842266f29$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $0febb2d842266f29$export$b4b216764bb846eb; });
const $0febb2d842266f29$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $0febb2d842266f29$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("bwcUB", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $862cb2e6b8627b40$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $862cb2e6b8627b40$export$b4b216764bb846eb; });
function $862cb2e6b8627b40$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $862cb2e6b8627b40$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("lS3Yd", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $fec1b886c4169fea$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $fec1b886c4169fea$var$isEmptyData;

});

parcelRegister("j9qX4", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $df13c39db76f0c92$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $df13c39db76f0c92$var$numToUint8;

});

parcelRegister("3IJwq", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $2b58cade472186f7$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $2b58cade472186f7$var$uint32ArrayFrom;

});



parcelRegister("l5UcW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2R3UW = parcelRequire("2R3UW");

(0, $2R3UW.__exportStar)((parcelRequire("9ZNbp")), module.exports);

});
parcelRegister("9ZNbp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $2R3UW = parcelRequire("2R3UW");

var $f63m0 = parcelRequire("f63m0");

var $cLEed = parcelRequire("cLEed");

var $4OHCC = parcelRequire("4OHCC");
var $746ff646253a0ac4$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $cLEed.RawSha256();
        if (secret) {
            this.outer = new $cLEed.RawSha256();
            var inner = $746ff646253a0ac4$var$bufferFromSecret(secret);
            var outer = new Uint8Array($f63m0.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $f63m0.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $4OHCC.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $4OHCC.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            return (0, $2R3UW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $746ff646253a0ac4$var$Sha256;
function $746ff646253a0ac4$var$bufferFromSecret(secret) {
    var input = (0, $4OHCC.convertToBuffer)(secret);
    if (input.byteLength > $f63m0.BLOCK_SIZE) {
        var bufferHash = new $cLEed.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($f63m0.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("f63m0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("cLEed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $f63m0 = parcelRequire("f63m0");
/**
 * @internal
 */ var $94b91451b2147264$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($f63m0.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $f63m0.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $f63m0.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $f63m0.BLOCK_SIZE >= $f63m0.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $f63m0.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $f63m0.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($f63m0.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($f63m0.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($f63m0.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $f63m0.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($f63m0.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $94b91451b2147264$var$RawSha256;

});



parcelRegister("8Cal1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2R3UW = parcelRequire("2R3UW");

$2R3UW.__exportStar((parcelRequire("i87KB")), module.exports);

});
parcelRegister("i87KB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $2R3UW = parcelRequire("2R3UW");
var $d32efc795dd0bf88$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $d32efc795dd0bf88$var$supportsWebCrypto(window) {
    if ($d32efc795dd0bf88$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $d32efc795dd0bf88$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $d32efc795dd0bf88$var$supportsWebCrypto;
function $d32efc795dd0bf88$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $d32efc795dd0bf88$var$supportsSecureRandom;
function $d32efc795dd0bf88$var$supportsSubtleCrypto(subtle) {
    return subtle && $d32efc795dd0bf88$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $d32efc795dd0bf88$var$supportsSubtleCrypto;
function $d32efc795dd0bf88$var$supportsZeroByteGCM(subtle) {
    return $2R3UW.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $2R3UW.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$d32efc795dd0bf88$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $d32efc795dd0bf88$var$supportsZeroByteGCM;

});


parcelRegister("l68vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2R3UW = parcelRequire("2R3UW");

$2R3UW.__exportStar((parcelRequire("grTF5")), module.exports);

$2R3UW.__exportStar((parcelRequire("lvmLD")), module.exports);

$2R3UW.__exportStar((parcelRequire("92V8E")), module.exports);

$2R3UW.__exportStar((parcelRequire("8U9x2")), module.exports);

$2R3UW.__exportStar((parcelRequire("jh6ro")), module.exports);

});
parcelRegister("grTF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lvmLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("92V8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8U9x2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jh6ro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $e08499dd1c249a8d$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $e08499dd1c249a8d$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $e08499dd1c249a8d$var$isMsWindow(window) {
    if ($e08499dd1c249a8d$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $e08499dd1c249a8d$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $e08499dd1c249a8d$var$isMsWindow;

});



parcelRegister("hafja", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $c7ef3eb420f34d34$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7ef3eb420f34d34$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c7ef3eb420f34d34$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c7ef3eb420f34d34$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c7ef3eb420f34d34$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $c7ef3eb420f34d34$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $c7ef3eb420f34d34$var$hasSymbol = function(name) {
    return $c7ef3eb420f34d34$var$hasSymbols() && Boolean(Symbol[name]);
};
var $c7ef3eb420f34d34$var$getSymbol = function(name) {
    return $c7ef3eb420f34d34$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($c7ef3eb420f34d34$var$hasSymbols() && !$c7ef3eb420f34d34$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $c7ef3eb420f34d34$var$SymbolIterator = $c7ef3eb420f34d34$var$getSymbol('iterator');
var $c7ef3eb420f34d34$var$SymbolObservable = $c7ef3eb420f34d34$var$getSymbol('observable');
var $c7ef3eb420f34d34$var$SymbolSpecies = $c7ef3eb420f34d34$var$getSymbol('species'); // === Abstract Operations ===
function $c7ef3eb420f34d34$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $c7ef3eb420f34d34$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$c7ef3eb420f34d34$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $c7ef3eb420f34d34$var$Observable;
}
function $c7ef3eb420f34d34$var$isObservable(x) {
    return x instanceof $c7ef3eb420f34d34$var$Observable; // SPEC: Brand check
}
function $c7ef3eb420f34d34$var$hostReportError(e) {
    if ($c7ef3eb420f34d34$var$hostReportError.log) $c7ef3eb420f34d34$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $c7ef3eb420f34d34$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $c7ef3eb420f34d34$var$hostReportError(e);
        }
    });
}
function $c7ef3eb420f34d34$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $c7ef3eb420f34d34$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $c7ef3eb420f34d34$var$hostReportError(e);
    }
}
function $c7ef3eb420f34d34$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $c7ef3eb420f34d34$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $c7ef3eb420f34d34$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $c7ef3eb420f34d34$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $c7ef3eb420f34d34$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $c7ef3eb420f34d34$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $c7ef3eb420f34d34$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $c7ef3eb420f34d34$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $c7ef3eb420f34d34$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $c7ef3eb420f34d34$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $c7ef3eb420f34d34$var$enqueue(function() {
            return $c7ef3eb420f34d34$var$flushSubscription(subscription);
        });
        return;
    }
    $c7ef3eb420f34d34$var$notifySubscription(subscription, type, value);
}
var $c7ef3eb420f34d34$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $c7ef3eb420f34d34$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $c7ef3eb420f34d34$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $c7ef3eb420f34d34$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $c7ef3eb420f34d34$var$closeSubscription(this);
                    $c7ef3eb420f34d34$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $c7ef3eb420f34d34$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $c7ef3eb420f34d34$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $c7ef3eb420f34d34$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $c7ef3eb420f34d34$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $c7ef3eb420f34d34$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $c7ef3eb420f34d34$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $c7ef3eb420f34d34$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $c7ef3eb420f34d34$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $c7ef3eb420f34d34$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $c7ef3eb420f34d34$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $c7ef3eb420f34d34$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $c7ef3eb420f34d34$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $c7ef3eb420f34d34$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $c7ef3eb420f34d34$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $c7ef3eb420f34d34$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $c7ef3eb420f34d34$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $c7ef3eb420f34d34$var$getMethod(x, $c7ef3eb420f34d34$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($c7ef3eb420f34d34$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($c7ef3eb420f34d34$var$hasSymbol('iterator')) {
                    method = $c7ef3eb420f34d34$var$getMethod(x, $c7ef3eb420f34d34$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $c7ef3eb420f34d34$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $c7ef3eb420f34d34$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $c7ef3eb420f34d34$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $c7ef3eb420f34d34$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $c7ef3eb420f34d34$var$Observable;
if ($c7ef3eb420f34d34$var$hasSymbols()) Object.defineProperty($c7ef3eb420f34d34$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $c7ef3eb420f34d34$var$SymbolObservable,
        hostReportError: $c7ef3eb420f34d34$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("2DpkE", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("7K7Bf"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("ivs1Y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("2DpkE")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("evCD1", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("2DpkE")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("CJImr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("2DpkE")), (parcelRequire("evCD1")), (parcelRequire("1eSUz")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("1eSUz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("2DpkE")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("qxxev", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("2DpkE")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("3XTjv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2e31c9e615961c77$export$2e2bcd8739ae039; });
function $2e31c9e615961c77$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("9jbE1", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", function () { return $6c6eebc42ece6e69$export$fa981bbccf843781; }, function (v) { return $6c6eebc42ece6e69$export$fa981bbccf843781 = v; });
var $6c6eebc42ece6e69$export$fa981bbccf843781;
'use strict';
const $6c6eebc42ece6e69$var$char = function(a) {
    return String.fromCharCode(a);
};
const $6c6eebc42ece6e69$var$chars = {
    nilChar: $6c6eebc42ece6e69$var$char(176),
    missingChar: $6c6eebc42ece6e69$var$char(201),
    nilPremitive: $6c6eebc42ece6e69$var$char(175),
    missingPremitive: $6c6eebc42ece6e69$var$char(200),
    emptyChar: $6c6eebc42ece6e69$var$char(178),
    emptyValue: $6c6eebc42ece6e69$var$char(177),
    boundryChar: $6c6eebc42ece6e69$var$char(179),
    objStart: $6c6eebc42ece6e69$var$char(198),
    arrStart: $6c6eebc42ece6e69$var$char(204),
    arrayEnd: $6c6eebc42ece6e69$var$char(185)
};
const $6c6eebc42ece6e69$var$charsArr = [
    $6c6eebc42ece6e69$var$chars.nilChar,
    $6c6eebc42ece6e69$var$chars.nilPremitive,
    $6c6eebc42ece6e69$var$chars.missingChar,
    $6c6eebc42ece6e69$var$chars.missingPremitive,
    $6c6eebc42ece6e69$var$chars.boundryChar,
    $6c6eebc42ece6e69$var$chars.emptyChar,
    $6c6eebc42ece6e69$var$chars.emptyValue,
    $6c6eebc42ece6e69$var$chars.arrayEnd,
    $6c6eebc42ece6e69$var$chars.objStart,
    $6c6eebc42ece6e69$var$chars.arrStart
];
const $6c6eebc42ece6e69$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === 'string') {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $6c6eebc42ece6e69$var$getValue(node[0].val, e_schema);
        else return $6c6eebc42ece6e69$var$getValue(node, e_schema);
    } else {
        const hasValidData = $6c6eebc42ece6e69$var$hasData(node);
        if (hasValidData === true) {
            let str = '';
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $6c6eebc42ece6e69$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //const itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === 'string') for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $6c6eebc42ece6e69$var$getValue(node[arr_i].val, itemSchema);
                    str = $6c6eebc42ece6e69$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $6c6eebc42ece6e69$var$_e(node[arr_i], itemSchema, options);
                    str = $6c6eebc42ece6e69$var$processValue(str, r);
                }
                str += $6c6eebc42ece6e69$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $6c6eebc42ece6e69$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $6c6eebc42ece6e69$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $6c6eebc42ece6e69$var$_e(node.val, e_schema[key], options);
                    else r = $6c6eebc42ece6e69$var$_e(node.child[key], e_schema[key], options);
                    str = $6c6eebc42ece6e69$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $6c6eebc42ece6e69$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $6c6eebc42ece6e69$var$chars.missingPremitive;
        case null:
            return $6c6eebc42ece6e69$var$chars.nilPremitive;
        case '':
            return $6c6eebc42ece6e69$var$chars.emptyValue;
        default:
            return a;
    }
};
const $6c6eebc42ece6e69$var$processValue = function(str, r) {
    if (!$6c6eebc42ece6e69$var$isAppChar(r[0]) && !$6c6eebc42ece6e69$var$isAppChar(str[str.length - 1])) str += $6c6eebc42ece6e69$var$chars.boundryChar;
    return str + r;
};
const $6c6eebc42ece6e69$var$isAppChar = function(ch) {
    return $6c6eebc42ece6e69$var$charsArr.indexOf(ch) !== -1;
};
function $6c6eebc42ece6e69$var$hasData(jObj) {
    if (jObj === undefined) return $6c6eebc42ece6e69$var$chars.missingChar;
    else if (jObj === null) return $6c6eebc42ece6e69$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $6c6eebc42ece6e69$var$chars.emptyChar;
    else return true;
}

var $a9fXZ = parcelRequire("a9fXZ");

var $jfqRo = parcelRequire("jfqRo");
var $6c6eebc42ece6e69$require$buildOptions = $jfqRo.buildOptions;
const $6c6eebc42ece6e69$var$convert2nimn = function(node, e_schema, options) {
    options = $6c6eebc42ece6e69$require$buildOptions(options, $a9fXZ.defaultOptions, $a9fXZ.props);
    return $6c6eebc42ece6e69$var$_e(node, e_schema, options);
};
$6c6eebc42ece6e69$export$fa981bbccf843781 = $6c6eebc42ece6e69$var$convert2nimn;

});
parcelRegister("a9fXZ", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", function () { return $76372146937930fa$export$ba43bf67f3d48107; }, function (v) { return $76372146937930fa$export$ba43bf67f3d48107 = v; });
$parcel$export(module.exports, "props", function () { return $76372146937930fa$export$8128bb6492cf3de7; }, function (v) { return $76372146937930fa$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "getTraversalObj", function () { return $76372146937930fa$export$2ca3eb0a2f8a693a; }, function (v) { return $76372146937930fa$export$2ca3eb0a2f8a693a = v; });
var $76372146937930fa$export$ba43bf67f3d48107;
var $76372146937930fa$export$8128bb6492cf3de7;
var $76372146937930fa$export$2ca3eb0a2f8a693a;
'use strict';

var $jfqRo = parcelRequire("jfqRo");

var $jfqRo = parcelRequire("jfqRo");
var $76372146937930fa$require$buildOptions = $jfqRo.buildOptions;

var $iNUq6 = parcelRequire("iNUq6");

var $3iNqH = parcelRequire("3iNqH");
const $76372146937930fa$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $jfqRo.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $76372146937930fa$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    numParseOptions: {
        hex: true,
        leadingZeros: true
    },
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: [],
    alwaysCreateTextNode: false
};
$76372146937930fa$export$ba43bf67f3d48107 = $76372146937930fa$var$defaultOptions;
const $76372146937930fa$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'ignoreNameSpace',
    'allowBooleanAttributes',
    'parseNodeValue',
    'parseAttributeValue',
    'arrayMode',
    'trimValues',
    'cdataTagName',
    'cdataPositionChar',
    'tagValueProcessor',
    'attrValueProcessor',
    'parseTrueNumberOnly',
    'numParseOptions',
    'stopNodes',
    'alwaysCreateTextNode'
];
$76372146937930fa$export$8128bb6492cf3de7 = $76372146937930fa$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $76372146937930fa$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $76372146937930fa$var$parseValue(val, options.parseNodeValue, options.numParseOptions);
    }
    return val;
}
function $76372146937930fa$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $76372146937930fa$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $3iNqH(val, options);
    } else {
        if ($jfqRo.isExist(val)) return val;
        else return '';
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $76372146937930fa$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function $76372146937930fa$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === 'string') {
        attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $jfqRo.getAllMatches(attrStr, $76372146937930fa$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $76372146937930fa$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $76372146937930fa$var$parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $76372146937930fa$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $76372146937930fa$require$buildOptions(options, $76372146937930fa$var$defaultOptions, $76372146937930fa$var$props);
    const xmlObj = new $iNUq6('!xml');
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            if (xmlData[i + 1] === '/') {
                const closeIndex = $76372146937930fa$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $jfqRo.getValue(currentNode.val) + '' + $76372146937930fa$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $76372146937930fa$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') i = $76372146937930fa$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === '!--') i = $76372146937930fa$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === '!D') {
                const closeIndex = $76372146937930fa$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $76372146937930fa$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $jfqRo.getValue(currentNode.val) + '' + $76372146937930fa$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $iNUq6(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $jfqRo.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || '') + (tagExp || '');
                i = closeIndex + 2;
            } else {
                const result = $76372146937930fa$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') currentNode.val = $jfqRo.getValue(currentNode.val) + '' + $76372146937930fa$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $iNUq6(tagName, currentNode, '');
                    if (tagName !== tagExp) childNode.attrsMap = $76372146937930fa$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $iNUq6(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $76372146937930fa$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $76372146937930fa$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === '>') return {
            data: tagExp,
            index: index
        };
        else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $76372146937930fa$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$76372146937930fa$export$2ca3eb0a2f8a693a = $76372146937930fa$var$getTraversalObj;

});
parcelRegister("jfqRo", function(module, exports) {

$parcel$export(module.exports, "isExist", function () { return $e03440ed740e09e7$export$a5edf3f35b6dd392; }, function (v) { return $e03440ed740e09e7$export$a5edf3f35b6dd392 = v; });
$parcel$export(module.exports, "isEmptyObject", function () { return $e03440ed740e09e7$export$83b788b1a3698c03; }, function (v) { return $e03440ed740e09e7$export$83b788b1a3698c03 = v; });
$parcel$export(module.exports, "merge", function () { return $e03440ed740e09e7$export$4950aa0f605343fb; }, function (v) { return $e03440ed740e09e7$export$4950aa0f605343fb = v; });
$parcel$export(module.exports, "getValue", function () { return $e03440ed740e09e7$export$bf7199a9ebcb84a9; }, function (v) { return $e03440ed740e09e7$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "buildOptions", function () { return $e03440ed740e09e7$export$ecbd7d678ac4909b; }, function (v) { return $e03440ed740e09e7$export$ecbd7d678ac4909b = v; });
$parcel$export(module.exports, "isTagNameInArrayMode", function () { return $e03440ed740e09e7$export$fd3b6180ca5b0284; }, function (v) { return $e03440ed740e09e7$export$fd3b6180ca5b0284 = v; });
$parcel$export(module.exports, "isName", function () { return $e03440ed740e09e7$export$998d7ff9801e90bb; }, function (v) { return $e03440ed740e09e7$export$998d7ff9801e90bb = v; });
$parcel$export(module.exports, "getAllMatches", function () { return $e03440ed740e09e7$export$aaa9734c55cb7a19; }, function (v) { return $e03440ed740e09e7$export$aaa9734c55cb7a19 = v; });
$parcel$export(module.exports, "nameRegexp", function () { return $e03440ed740e09e7$export$e8f2644f7085b4b1; }, function (v) { return $e03440ed740e09e7$export$e8f2644f7085b4b1 = v; });
var $e03440ed740e09e7$export$a5edf3f35b6dd392;
var $e03440ed740e09e7$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $e03440ed740e09e7$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $e03440ed740e09e7$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $e03440ed740e09e7$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $e03440ed740e09e7$export$fd3b6180ca5b0284;
var $e03440ed740e09e7$export$998d7ff9801e90bb;
var $e03440ed740e09e7$export$aaa9734c55cb7a19;
var $e03440ed740e09e7$export$e8f2644f7085b4b1;
'use strict';
const $e03440ed740e09e7$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $e03440ed740e09e7$var$nameChar = $e03440ed740e09e7$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $e03440ed740e09e7$var$nameRegexp = '[' + $e03440ed740e09e7$var$nameStartChar + '][' + $e03440ed740e09e7$var$nameChar + ']*';
const $e03440ed740e09e7$var$regexName = new RegExp('^' + $e03440ed740e09e7$var$nameRegexp + '$');
const $e03440ed740e09e7$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $e03440ed740e09e7$var$isName = function(string) {
    const match = $e03440ed740e09e7$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$e03440ed740e09e7$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$e03440ed740e09e7$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$e03440ed740e09e7$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$e03440ed740e09e7$export$bf7199a9ebcb84a9 = function(v) {
    if ($e03440ed740e09e7$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$e03440ed740e09e7$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    let newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$e03440ed740e09e7$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === 'function') return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$e03440ed740e09e7$export$998d7ff9801e90bb = $e03440ed740e09e7$var$isName;
$e03440ed740e09e7$export$aaa9734c55cb7a19 = $e03440ed740e09e7$var$getAllMatches;
$e03440ed740e09e7$export$e8f2644f7085b4b1 = $e03440ed740e09e7$var$nameRegexp;

});

parcelRegister("iNUq6", function(module, exports) {
'use strict';
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});

parcelRegister("3iNqH", function(module, exports) {
const $26796536ebee2ca1$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $26796536ebee2ca1$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
// const octRegex = /^0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
const $26796536ebee2ca1$var$consider = {
    hex: true,
    // oct: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $26796536ebee2ca1$var$toNumber(str, options = {}) {
    options = Object.assign({}, $26796536ebee2ca1$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (str === "0") return 0;
    else if (options.hex && $26796536ebee2ca1$var$hexRegex.test(trimmedStr)) return $26796536ebee2ca1$var$parse_int(trimmedStr, 16);
    else if (trimmedStr.search(/[eE]/) !== -1) {
        const notation = trimmedStr.match(/^([-\+])?(0*)([0-9]*(\.[0-9]*)?[eE][-\+]?[0-9]+)$/);
        // +00.123 => [ , '+', '00', '.123', ..
        if (notation) {
            // console.log(notation)
            if (options.leadingZeros) trimmedStr = (notation[1] || "") + notation[3];
            else {
                if (notation[2] === "0" && notation[3][0] === ".") ;
                else return str;
            }
            return options.eNotation ? Number(trimmedStr) : str;
        } else return str;
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    } else {
        //separate negative sign, leading zeros, and rest number
        const match = $26796536ebee2ca1$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $26796536ebee2ca1$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else if (options.leadingZeros && leadingZeros === str) return 0; //00
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) return numTrimmedByZeros === numStr || sign + numTrimmedByZeros === numStr ? num : str;
                else return trimmedStr === numStr || trimmedStr === sign + numStr ? num : str;
            }
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $26796536ebee2ca1$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $26796536ebee2ca1$var$parse_int(numStr, base) {
    //polyfill
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
module.exports = $26796536ebee2ca1$var$toNumber;

});



parcelRegister("b8ump", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", function () { return $81b7fdff2b129ac5$export$54ffaacfc0931fb0; }, function (v) { return $81b7fdff2b129ac5$export$54ffaacfc0931fb0 = v; });
var $81b7fdff2b129ac5$export$54ffaacfc0931fb0;
'use strict';

var $jfqRo = parcelRequire("jfqRo");

var $jfqRo = parcelRequire("jfqRo");
var $81b7fdff2b129ac5$require$buildOptions = $jfqRo.buildOptions;

var $a9fXZ = parcelRequire("a9fXZ");
//TODO: do it later
const $81b7fdff2b129ac5$var$convertToJsonString = function(node, options) {
    options = $81b7fdff2b129ac5$require$buildOptions(options, $a9fXZ.defaultOptions, $a9fXZ.props);
    options.indentBy = options.indentBy || '';
    return $81b7fdff2b129ac5$var$_cToJsonStr(node, options, 0);
};
const $81b7fdff2b129ac5$var$_cToJsonStr = function(node, options, level) {
    let jObj = '{';
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(let tag in node.child[tagname])jObj += $81b7fdff2b129ac5$var$_cToJsonStr(node.child[tagname][tag], options) + ' , ';
            jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $81b7fdff2b129ac5$var$_cToJsonStr(node.child[tagname][0], options) + ' ,';
    }
    $jfqRo.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($jfqRo.isEmptyObject(jObj)) return $jfqRo.isExist(node.val) ? node.val : '';
    else {
        if ($jfqRo.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $81b7fdff2b129ac5$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ',') jObj = jObj.substr(0, jObj.length - 2);
    return jObj + '}';
};
function $81b7fdff2b129ac5$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $81b7fdff2b129ac5$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$81b7fdff2b129ac5$export$54ffaacfc0931fb0 = $81b7fdff2b129ac5$var$convertToJsonString;

});

parcelRegister("hPBK7", function(module, exports) {
'use strict';

var $jfqRo = parcelRequire("jfqRo");
var $cfb47a08605a0925$require$buildOptions = $jfqRo.buildOptions;
const $cfb47a08605a0925$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    format: false,
    indentBy: '  ',
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $cfb47a08605a0925$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'cdataTagName',
    'cdataPositionChar',
    'format',
    'indentBy',
    'supressEmptyNode',
    'tagValueProcessor',
    'attrValueProcessor',
    'rootNodeName'
];
function $cfb47a08605a0925$var$Parser(options) {
    this.options = $cfb47a08605a0925$require$buildOptions(options, $cfb47a08605a0925$var$defaultOptions, $cfb47a08605a0925$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $cfb47a08605a0925$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $cfb47a08605a0925$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $cfb47a08605a0925$var$replaceCDATAstr;
    this.replaceCDATAarr = $cfb47a08605a0925$var$replaceCDATAarr;
    this.processTextOrObjNode = $cfb47a08605a0925$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $cfb47a08605a0925$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $cfb47a08605a0925$var$buildEmptyTextNode;
        this.buildObjNode = $cfb47a08605a0925$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $cfb47a08605a0925$var$buildTextValNode;
        this.buildObjNode = $cfb47a08605a0925$var$buildObjectNode;
    }
    this.buildTextValNode = $cfb47a08605a0925$var$buildTextValNode;
    this.buildObjectNode = $cfb47a08605a0925$var$buildObjectNode;
}
$cfb47a08605a0925$var$Parser.prototype.parse = function(jObj) {
    if (Array.isArray(jObj) && this.options.rootNodeName && this.options.rootNodeName.length > 1) jObj = {
        [this.options.rootNodeName]: jObj
    };
    return this.j2x(jObj, 0).val;
};
$cfb47a08605a0925$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr('', jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor('' + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr('', jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === 'undefined') ;
                    else if (item === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                    else if (typeof item === 'object') val += this.processTextOrObjNode(item, key, level);
                    else val += this.buildTextNode(item, key, '', level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += ' ' + Ks[j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[j]]) + '"';
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $cfb47a08605a0925$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextNode(result.val, key, result.attrStr, level);
    else return this.buildObjNode(result.val, key, result.attrStr, level);
}
function $cfb47a08605a0925$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
}
function $cfb47a08605a0925$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
        return str + this.newLine;
    }
}
function $cfb47a08605a0925$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
    // + this.indentate(level)
    '</' + key + this.tagEndChar;
    else return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + '</' + key + this.tagEndChar;
}
function $cfb47a08605a0925$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $cfb47a08605a0925$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
}
function $cfb47a08605a0925$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== '') return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $cfb47a08605a0925$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $cfb47a08605a0925$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $cfb47a08605a0925$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $cfb47a08605a0925$var$Parser;

});

parcelRegister("lb8R8", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $eRxY3 = parcelRequire("eRxY3");

var $hZcx1 = parcelRequire("hZcx1");

var $bEJkE = parcelRequire("bEJkE");

var $cMMSQ = parcelRequire("cMMSQ");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $f6b17eb1e5d6d2f9$var$createInstance(defaultConfig) {
    var context = new $hZcx1(defaultConfig);
    var instance = $eRxY3($hZcx1.prototype.request, context);
    // Copy axios.prototype to instance
    $amdKG.extend(instance, $hZcx1.prototype, context);
    // Copy context to instance
    $amdKG.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $f6b17eb1e5d6d2f9$var$createInstance($bEJkE(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $f6b17eb1e5d6d2f9$var$axios = $f6b17eb1e5d6d2f9$var$createInstance($cMMSQ);
// Expose Axios class to allow class inheritance
$f6b17eb1e5d6d2f9$var$axios.Axios = $hZcx1;

// Expose Cancel & CancelToken
$f6b17eb1e5d6d2f9$var$axios.Cancel = (parcelRequire("7kuEQ"));

$f6b17eb1e5d6d2f9$var$axios.CancelToken = (parcelRequire("fB7HN"));

$f6b17eb1e5d6d2f9$var$axios.isCancel = (parcelRequire("heqz6"));

$f6b17eb1e5d6d2f9$var$axios.VERSION = (parcelRequire("1BCQ6")).version;
// Expose all/spread
$f6b17eb1e5d6d2f9$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$f6b17eb1e5d6d2f9$var$axios.spread = (parcelRequire("jVBhM"));

// Expose isAxiosError
$f6b17eb1e5d6d2f9$var$axios.isAxiosError = (parcelRequire("doyvi"));
module.exports = $f6b17eb1e5d6d2f9$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $f6b17eb1e5d6d2f9$var$axios;

});
parcelRegister("amdKG", function(module, exports) {
'use strict';

var $eRxY3 = parcelRequire("eRxY3");
// utils is a library of generic helper functions non-specific to axios
var $78a6a04eb1d7e79d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $78a6a04eb1d7e79d$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $78a6a04eb1d7e79d$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $78a6a04eb1d7e79d$var$isBuffer(val) {
    return val !== null && !$78a6a04eb1d7e79d$var$isUndefined(val) && val.constructor !== null && !$78a6a04eb1d7e79d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $78a6a04eb1d7e79d$var$isArrayBuffer(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $78a6a04eb1d7e79d$var$isFormData(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object FormData]';
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $78a6a04eb1d7e79d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $78a6a04eb1d7e79d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $78a6a04eb1d7e79d$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $78a6a04eb1d7e79d$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $78a6a04eb1d7e79d$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $78a6a04eb1d7e79d$var$isPlainObject(val) {
    if ($78a6a04eb1d7e79d$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $78a6a04eb1d7e79d$var$isDate(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $78a6a04eb1d7e79d$var$isFile(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $78a6a04eb1d7e79d$var$isBlob(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $78a6a04eb1d7e79d$var$isFunction(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $78a6a04eb1d7e79d$var$isStream(val) {
    return $78a6a04eb1d7e79d$var$isObject(val) && $78a6a04eb1d7e79d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $78a6a04eb1d7e79d$var$isURLSearchParams(val) {
    return $78a6a04eb1d7e79d$var$toString.call(val) === '[object URLSearchParams]';
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $78a6a04eb1d7e79d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $78a6a04eb1d7e79d$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $78a6a04eb1d7e79d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($78a6a04eb1d7e79d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $78a6a04eb1d7e79d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($78a6a04eb1d7e79d$var$isPlainObject(result[key]) && $78a6a04eb1d7e79d$var$isPlainObject(val)) result[key] = $78a6a04eb1d7e79d$var$merge(result[key], val);
        else if ($78a6a04eb1d7e79d$var$isPlainObject(val)) result[key] = $78a6a04eb1d7e79d$var$merge({}, val);
        else if ($78a6a04eb1d7e79d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$78a6a04eb1d7e79d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $78a6a04eb1d7e79d$var$extend(a, b, thisArg) {
    $78a6a04eb1d7e79d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $eRxY3(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $78a6a04eb1d7e79d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $78a6a04eb1d7e79d$var$isArray,
    isArrayBuffer: $78a6a04eb1d7e79d$var$isArrayBuffer,
    isBuffer: $78a6a04eb1d7e79d$var$isBuffer,
    isFormData: $78a6a04eb1d7e79d$var$isFormData,
    isArrayBufferView: $78a6a04eb1d7e79d$var$isArrayBufferView,
    isString: $78a6a04eb1d7e79d$var$isString,
    isNumber: $78a6a04eb1d7e79d$var$isNumber,
    isObject: $78a6a04eb1d7e79d$var$isObject,
    isPlainObject: $78a6a04eb1d7e79d$var$isPlainObject,
    isUndefined: $78a6a04eb1d7e79d$var$isUndefined,
    isDate: $78a6a04eb1d7e79d$var$isDate,
    isFile: $78a6a04eb1d7e79d$var$isFile,
    isBlob: $78a6a04eb1d7e79d$var$isBlob,
    isFunction: $78a6a04eb1d7e79d$var$isFunction,
    isStream: $78a6a04eb1d7e79d$var$isStream,
    isURLSearchParams: $78a6a04eb1d7e79d$var$isURLSearchParams,
    isStandardBrowserEnv: $78a6a04eb1d7e79d$var$isStandardBrowserEnv,
    forEach: $78a6a04eb1d7e79d$var$forEach,
    merge: $78a6a04eb1d7e79d$var$merge,
    extend: $78a6a04eb1d7e79d$var$extend,
    trim: $78a6a04eb1d7e79d$var$trim,
    stripBOM: $78a6a04eb1d7e79d$var$stripBOM
};

});
parcelRegister("eRxY3", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("hZcx1", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $9Cy8X = parcelRequire("9Cy8X");

var $mv9MK = parcelRequire("mv9MK");

var $f8yLK = parcelRequire("f8yLK");

var $bEJkE = parcelRequire("bEJkE");

var $cwwia = parcelRequire("cwwia");
var $d181dab4354f9495$var$validators = $cwwia.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $d181dab4354f9495$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $mv9MK(),
        response: new $mv9MK()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $d181dab4354f9495$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $bEJkE(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $cwwia.assertOptions(transitional, {
        silentJSONParsing: $d181dab4354f9495$var$validators.transitional($d181dab4354f9495$var$validators.boolean),
        forcedJSONParsing: $d181dab4354f9495$var$validators.transitional($d181dab4354f9495$var$validators.boolean),
        clarifyTimeoutError: $d181dab4354f9495$var$validators.transitional($d181dab4354f9495$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $f8yLK,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $f8yLK(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$d181dab4354f9495$var$Axios.prototype.getUri = function getUri(config) {
    config = $bEJkE(this.defaults, config);
    return $9Cy8X(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$amdKG.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d181dab4354f9495$var$Axios.prototype[method] = function(url, config) {
        return this.request($bEJkE(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$amdKG.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $d181dab4354f9495$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($bEJkE(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $d181dab4354f9495$var$Axios;

});
parcelRegister("9Cy8X", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
function $701225ddfd139b1f$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($amdKG.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $amdKG.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($amdKG.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $amdKG.forEach(val, function parseValue(v) {
                if ($amdKG.isDate(v)) v = v.toISOString();
                else if ($amdKG.isObject(v)) v = JSON.stringify(v);
                parts.push($701225ddfd139b1f$var$encode(key) + '=' + $701225ddfd139b1f$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("mv9MK", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
function $043a3949027d7617$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $043a3949027d7617$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $043a3949027d7617$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $043a3949027d7617$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $amdKG.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $043a3949027d7617$var$InterceptorManager;

});

parcelRegister("f8yLK", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $cmeAl = parcelRequire("cmeAl");

var $heqz6 = parcelRequire("heqz6");

var $cMMSQ = parcelRequire("cMMSQ");

var $7kuEQ = parcelRequire("7kuEQ");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $b05292c9195b780f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $7kuEQ('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $b05292c9195b780f$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $cmeAl.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $amdKG.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $amdKG.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $cMMSQ.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $b05292c9195b780f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $cmeAl.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$heqz6(reason)) {
            $b05292c9195b780f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $cmeAl.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("cmeAl", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $cMMSQ = parcelRequire("cMMSQ");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $cMMSQ;
    /*eslint no-param-reassign:0*/ $amdKG.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("cMMSQ", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $aq1pR = parcelRequire("aq1pR");

var $3oYnG = parcelRequire("3oYnG");
var $94efe2fd9a5f5be1$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $94efe2fd9a5f5be1$var$setContentTypeIfUnset(headers, value) {
    if (!$amdKG.isUndefined(headers) && $amdKG.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $94efe2fd9a5f5be1$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("fuFPQ"));
    return adapter;
}
function $94efe2fd9a5f5be1$var$stringifySafely(rawValue, parser, encoder) {
    if ($amdKG.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $amdKG.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $94efe2fd9a5f5be1$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $94efe2fd9a5f5be1$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $aq1pR(headers, 'Accept');
            $aq1pR(headers, 'Content-Type');
            if ($amdKG.isFormData(data) || $amdKG.isArrayBuffer(data) || $amdKG.isBuffer(data) || $amdKG.isStream(data) || $amdKG.isFile(data) || $amdKG.isBlob(data)) return data;
            if ($amdKG.isArrayBufferView(data)) return data.buffer;
            if ($amdKG.isURLSearchParams(data)) {
                $94efe2fd9a5f5be1$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($amdKG.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $94efe2fd9a5f5be1$var$setContentTypeIfUnset(headers, 'application/json');
                return $94efe2fd9a5f5be1$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $94efe2fd9a5f5be1$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $amdKG.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $3oYnG(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$amdKG.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $94efe2fd9a5f5be1$var$defaults.headers[method] = {};
});
$amdKG.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $94efe2fd9a5f5be1$var$defaults.headers[method] = $amdKG.merge($94efe2fd9a5f5be1$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $94efe2fd9a5f5be1$var$defaults;

});
parcelRegister("aq1pR", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $amdKG.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3oYnG", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("fuFPQ", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");

var $dgkLz = parcelRequire("dgkLz");

var $aXZZj = parcelRequire("aXZZj");

var $9Cy8X = parcelRequire("9Cy8X");

var $4QScp = parcelRequire("4QScp");

var $b7MIK = parcelRequire("b7MIK");

var $7mrng = parcelRequire("7mrng");

var $7BFPW = parcelRequire("7BFPW");

var $cMMSQ = parcelRequire("cMMSQ");

var $7kuEQ = parcelRequire("7kuEQ");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($amdKG.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $4QScp(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $9Cy8X(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $b7MIK(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $dgkLz(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($7BFPW('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($7BFPW('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $cMMSQ.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($7BFPW(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($amdKG.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $7mrng(fullPath)) && config.xsrfCookieName ? $aXZZj.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $amdKG.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$amdKG.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $7kuEQ('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("dgkLz", function(module, exports) {
'use strict';

var $7BFPW = parcelRequire("7BFPW");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($7BFPW('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("7BFPW", function(module, exports) {
'use strict';

var $3oYnG = parcelRequire("3oYnG");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3oYnG(error, config, code, request, response);
};

});


parcelRegister("aXZZj", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
module.exports = $amdKG.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($amdKG.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($amdKG.isString(path)) cookie.push('path=' + path);
            if ($amdKG.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("4QScp", function(module, exports) {
'use strict';

var $v2OTW = parcelRequire("v2OTW");

var $d7Eqo = parcelRequire("d7Eqo");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$v2OTW(requestedURL)) return $d7Eqo(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("v2OTW", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("d7Eqo", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("b7MIK", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $819624161672f3aa$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $amdKG.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $amdKG.trim(line.substr(0, i)).toLowerCase();
        val = $amdKG.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $819624161672f3aa$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("7mrng", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
module.exports = $amdKG.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $amdKG.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("7kuEQ", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $55622eaea323f592$var$Cancel(message) {
    this.message = message;
}
$55622eaea323f592$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$55622eaea323f592$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $55622eaea323f592$var$Cancel;

});




parcelRegister("heqz6", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("bEJkE", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($amdKG.isPlainObject(target) && $amdKG.isPlainObject(source)) return $amdKG.merge(target, source);
        else if ($amdKG.isPlainObject(source)) return $amdKG.merge({}, source);
        else if ($amdKG.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$amdKG.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$amdKG.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$amdKG.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$amdKG.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$amdKG.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $amdKG.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $amdKG.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("cwwia", function(module, exports) {
'use strict';

var $1BCQ6 = parcelRequire("1BCQ6");
var $91e185b9975be562$require$VERSION = $1BCQ6.version;
var $91e185b9975be562$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $91e185b9975be562$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $91e185b9975be562$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $91e185b9975be562$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $91e185b9975be562$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$91e185b9975be562$var$deprecatedWarnings[opt]) {
            $91e185b9975be562$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $91e185b9975be562$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $91e185b9975be562$var$assertOptions,
    validators: $91e185b9975be562$var$validators
};

});
parcelRegister("1BCQ6", function(module, exports) {
module.exports = {
    "version": "0.26.0"
};

});



parcelRegister("fB7HN", function(module, exports) {
'use strict';

var $7kuEQ = parcelRequire("7kuEQ");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $b5b049dbe468d418$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $7kuEQ(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $b5b049dbe468d418$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $b5b049dbe468d418$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $b5b049dbe468d418$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $b5b049dbe468d418$var$CancelToken.source = function source() {
    var cancel;
    var token = new $b5b049dbe468d418$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $b5b049dbe468d418$var$CancelToken;

});

parcelRegister("jVBhM", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("doyvi", function(module, exports) {
'use strict';

var $amdKG = parcelRequire("amdKG");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $amdKG.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("i8TFP", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $bqaVq = parcelRequire("bqaVq");

var $7VUAY = parcelRequire("7VUAY");

var $k3Ec3 = parcelRequire("k3Ec3");

var $gsvCQ = parcelRequire("gsvCQ");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $d35428ffc79b1f22$var$createInstance(defaultConfig) {
    var context = new $7VUAY(defaultConfig);
    var instance = $bqaVq($7VUAY.prototype.request, context);
    // Copy axios.prototype to instance
    $c5W50.extend(instance, $7VUAY.prototype, context);
    // Copy context to instance
    $c5W50.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $d35428ffc79b1f22$var$axios = $d35428ffc79b1f22$var$createInstance($gsvCQ);
// Expose Axios class to allow class inheritance
$d35428ffc79b1f22$var$axios.Axios = $7VUAY;
// Factory for creating new instances
$d35428ffc79b1f22$var$axios.create = function create(instanceConfig) {
    return $d35428ffc79b1f22$var$createInstance($k3Ec3($d35428ffc79b1f22$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$d35428ffc79b1f22$var$axios.Cancel = (parcelRequire("azPI5"));

$d35428ffc79b1f22$var$axios.CancelToken = (parcelRequire("98lk8"));

$d35428ffc79b1f22$var$axios.isCancel = (parcelRequire("cJOpH"));
// Expose all/spread
$d35428ffc79b1f22$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$d35428ffc79b1f22$var$axios.spread = (parcelRequire("5XfTS"));

// Expose isAxiosError
$d35428ffc79b1f22$var$axios.isAxiosError = (parcelRequire("gpST1"));
module.exports = $d35428ffc79b1f22$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $d35428ffc79b1f22$var$axios;

});
parcelRegister("c5W50", function(module, exports) {
'use strict';

var $bqaVq = parcelRequire("bqaVq");
// utils is a library of generic helper functions non-specific to axios
var $8ce301193535602b$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $8ce301193535602b$var$isArray(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $8ce301193535602b$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ce301193535602b$var$isBuffer(val) {
    return val !== null && !$8ce301193535602b$var$isUndefined(val) && val.constructor !== null && !$8ce301193535602b$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $8ce301193535602b$var$isArrayBuffer(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $8ce301193535602b$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ce301193535602b$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $8ce301193535602b$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $8ce301193535602b$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $8ce301193535602b$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $8ce301193535602b$var$isPlainObject(val) {
    if ($8ce301193535602b$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $8ce301193535602b$var$isDate(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $8ce301193535602b$var$isFile(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $8ce301193535602b$var$isBlob(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $8ce301193535602b$var$isFunction(val) {
    return $8ce301193535602b$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $8ce301193535602b$var$isStream(val) {
    return $8ce301193535602b$var$isObject(val) && $8ce301193535602b$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $8ce301193535602b$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $8ce301193535602b$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $8ce301193535602b$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $8ce301193535602b$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ce301193535602b$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $8ce301193535602b$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($8ce301193535602b$var$isPlainObject(result[key]) && $8ce301193535602b$var$isPlainObject(val)) result[key] = $8ce301193535602b$var$merge(result[key], val);
        else if ($8ce301193535602b$var$isPlainObject(val)) result[key] = $8ce301193535602b$var$merge({}, val);
        else if ($8ce301193535602b$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$8ce301193535602b$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $8ce301193535602b$var$extend(a, b, thisArg) {
    $8ce301193535602b$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $bqaVq(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $8ce301193535602b$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $8ce301193535602b$var$isArray,
    isArrayBuffer: $8ce301193535602b$var$isArrayBuffer,
    isBuffer: $8ce301193535602b$var$isBuffer,
    isFormData: $8ce301193535602b$var$isFormData,
    isArrayBufferView: $8ce301193535602b$var$isArrayBufferView,
    isString: $8ce301193535602b$var$isString,
    isNumber: $8ce301193535602b$var$isNumber,
    isObject: $8ce301193535602b$var$isObject,
    isPlainObject: $8ce301193535602b$var$isPlainObject,
    isUndefined: $8ce301193535602b$var$isUndefined,
    isDate: $8ce301193535602b$var$isDate,
    isFile: $8ce301193535602b$var$isFile,
    isBlob: $8ce301193535602b$var$isBlob,
    isFunction: $8ce301193535602b$var$isFunction,
    isStream: $8ce301193535602b$var$isStream,
    isURLSearchParams: $8ce301193535602b$var$isURLSearchParams,
    isStandardBrowserEnv: $8ce301193535602b$var$isStandardBrowserEnv,
    forEach: $8ce301193535602b$var$forEach,
    merge: $8ce301193535602b$var$merge,
    extend: $8ce301193535602b$var$extend,
    trim: $8ce301193535602b$var$trim,
    stripBOM: $8ce301193535602b$var$stripBOM
};

});
parcelRegister("bqaVq", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("7VUAY", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $gQAVJ = parcelRequire("gQAVJ");

var $eDhHp = parcelRequire("eDhHp");

var $5FDSQ = parcelRequire("5FDSQ");

var $k3Ec3 = parcelRequire("k3Ec3");

var $3yvAT = parcelRequire("3yvAT");
var $5c69c1ea003e0b59$var$validators = $3yvAT.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $5c69c1ea003e0b59$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $eDhHp(),
        response: new $eDhHp()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $5c69c1ea003e0b59$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $k3Ec3(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $3yvAT.assertOptions(transitional, {
        silentJSONParsing: $5c69c1ea003e0b59$var$validators.transitional($5c69c1ea003e0b59$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $5c69c1ea003e0b59$var$validators.transitional($5c69c1ea003e0b59$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $5c69c1ea003e0b59$var$validators.transitional($5c69c1ea003e0b59$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $5FDSQ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $5FDSQ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$5c69c1ea003e0b59$var$Axios.prototype.getUri = function getUri(config) {
    config = $k3Ec3(this.defaults, config);
    return $gQAVJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$c5W50.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5c69c1ea003e0b59$var$Axios.prototype[method] = function(url, config) {
        return this.request($k3Ec3(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$c5W50.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $5c69c1ea003e0b59$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($k3Ec3(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $5c69c1ea003e0b59$var$Axios;

});
parcelRegister("gQAVJ", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
function $c43e263d8e43b741$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($c5W50.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $c5W50.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($c5W50.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $c5W50.forEach(val, function parseValue(v) {
                if ($c5W50.isDate(v)) v = v.toISOString();
                else if ($c5W50.isObject(v)) v = JSON.stringify(v);
                parts.push($c43e263d8e43b741$var$encode(key) + '=' + $c43e263d8e43b741$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("eDhHp", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
function $aa726fe2f753788b$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $aa726fe2f753788b$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $aa726fe2f753788b$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $aa726fe2f753788b$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $c5W50.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $aa726fe2f753788b$var$InterceptorManager;

});

parcelRegister("5FDSQ", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $1Y6H7 = parcelRequire("1Y6H7");

var $cJOpH = parcelRequire("cJOpH");

var $gsvCQ = parcelRequire("gsvCQ");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $420fb82391f17167$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $420fb82391f17167$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $1Y6H7.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $c5W50.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $c5W50.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $gsvCQ.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $420fb82391f17167$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $1Y6H7.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$cJOpH(reason)) {
            $420fb82391f17167$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $1Y6H7.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("1Y6H7", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $gsvCQ = parcelRequire("gsvCQ");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $gsvCQ;
    /*eslint no-param-reassign:0*/ $c5W50.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("gsvCQ", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $2Dvve = parcelRequire("2Dvve");

var $94q1C = parcelRequire("94q1C");
var $03179c0c7f53f530$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $03179c0c7f53f530$var$setContentTypeIfUnset(headers, value) {
    if (!$c5W50.isUndefined(headers) && $c5W50.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $03179c0c7f53f530$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("dvBvn"));
    return adapter;
}
function $03179c0c7f53f530$var$stringifySafely(rawValue, parser, encoder) {
    if ($c5W50.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $c5W50.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $03179c0c7f53f530$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $03179c0c7f53f530$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $2Dvve(headers, 'Accept');
            $2Dvve(headers, 'Content-Type');
            if ($c5W50.isFormData(data) || $c5W50.isArrayBuffer(data) || $c5W50.isBuffer(data) || $c5W50.isStream(data) || $c5W50.isFile(data) || $c5W50.isBlob(data)) return data;
            if ($c5W50.isArrayBufferView(data)) return data.buffer;
            if ($c5W50.isURLSearchParams(data)) {
                $03179c0c7f53f530$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($c5W50.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $03179c0c7f53f530$var$setContentTypeIfUnset(headers, 'application/json');
                return $03179c0c7f53f530$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $c5W50.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $94q1C(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$03179c0c7f53f530$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$c5W50.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $03179c0c7f53f530$var$defaults.headers[method] = {};
});
$c5W50.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $03179c0c7f53f530$var$defaults.headers[method] = $c5W50.merge($03179c0c7f53f530$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $03179c0c7f53f530$var$defaults;

});
parcelRegister("2Dvve", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $c5W50.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("94q1C", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("dvBvn", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");

var $loniO = parcelRequire("loniO");

var $bOQ9d = parcelRequire("bOQ9d");

var $gQAVJ = parcelRequire("gQAVJ");

var $7oHti = parcelRequire("7oHti");

var $3yEuU = parcelRequire("3yEuU");

var $guPim = parcelRequire("guPim");

var $lk1b0 = parcelRequire("lk1b0");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($c5W50.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7oHti(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $gQAVJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $3yEuU(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $loniO(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($lk1b0('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($lk1b0('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($lk1b0(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($c5W50.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $guPim(fullPath)) && config.xsrfCookieName ? $bOQ9d.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $c5W50.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$c5W50.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("loniO", function(module, exports) {
'use strict';

var $lk1b0 = parcelRequire("lk1b0");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($lk1b0('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("lk1b0", function(module, exports) {
'use strict';

var $94q1C = parcelRequire("94q1C");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $94q1C(error, config, code, request, response);
};

});


parcelRegister("bOQ9d", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
module.exports = $c5W50.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($c5W50.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($c5W50.isString(path)) cookie.push('path=' + path);
            if ($c5W50.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7oHti", function(module, exports) {
'use strict';

var $5IjAp = parcelRequire("5IjAp");

var $fHHtO = parcelRequire("fHHtO");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$5IjAp(requestedURL)) return $fHHtO(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("5IjAp", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fHHtO", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("3yEuU", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $2973f60d9797af7b$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $c5W50.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $c5W50.trim(line.substr(0, i)).toLowerCase();
        val = $c5W50.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $2973f60d9797af7b$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("guPim", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
module.exports = $c5W50.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $c5W50.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("cJOpH", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("k3Ec3", function(module, exports) {
'use strict';

var $c5W50 = parcelRequire("c5W50");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($c5W50.isPlainObject(target) && $c5W50.isPlainObject(source)) return $c5W50.merge(target, source);
        else if ($c5W50.isPlainObject(source)) return $c5W50.merge({}, source);
        else if ($c5W50.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$c5W50.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$c5W50.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $c5W50.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$c5W50.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $c5W50.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $c5W50.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$c5W50.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$c5W50.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $c5W50.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $c5W50.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("3yvAT", function(module, exports) {
'use strict';

var $GHyUf = parcelRequire("GHyUf");
var $296d0e00fe548072$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $296d0e00fe548072$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $296d0e00fe548072$var$deprecatedWarnings = {};
var $296d0e00fe548072$var$currentVerArr = $GHyUf.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $296d0e00fe548072$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $296d0e00fe548072$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $296d0e00fe548072$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $296d0e00fe548072$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $GHyUf.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$296d0e00fe548072$var$deprecatedWarnings[opt]) {
            $296d0e00fe548072$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $296d0e00fe548072$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $296d0e00fe548072$var$isOlderVersion,
    assertOptions: $296d0e00fe548072$var$assertOptions,
    validators: $296d0e00fe548072$var$validators
};

});
parcelRegister("GHyUf", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("azPI5", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $7b3548cb0e22fb3e$var$Cancel(message) {
    this.message = message;
}
$7b3548cb0e22fb3e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$7b3548cb0e22fb3e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $7b3548cb0e22fb3e$var$Cancel;

});

parcelRegister("98lk8", function(module, exports) {
'use strict';

var $azPI5 = parcelRequire("azPI5");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $6a6566d8188a5ba1$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $azPI5(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $6a6566d8188a5ba1$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $6a6566d8188a5ba1$var$CancelToken.source = function source() {
    var cancel;
    var token = new $6a6566d8188a5ba1$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $6a6566d8188a5ba1$var$CancelToken;

});

parcelRegister("5XfTS", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("gpST1", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("6iqOz", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $jSIPP = parcelRequire("jSIPP");

var $gj7pJ = parcelRequire("gj7pJ");

var $dX4Zi = parcelRequire("dX4Zi");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$jSIPP) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $jSIPP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $gj7pJ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $jSIPP.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $gj7pJ({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $gj7pJ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $gj7pJ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $dX4Zi.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $dX4Zi.unstable_scheduleCallback($dX4Zi.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $dX4Zi.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $dX4Zi.unstable_UserBlockingPriority, ed = $dX4Zi.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $gj7pJ(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $gj7pJ({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $gj7pJ({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $gj7pJ({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $gj7pJ({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $gj7pJ({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $gj7pJ({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $gj7pJ({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $gj7pJ({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $gj7pJ({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $gj7pJ({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $gj7pJ({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $gj7pJ({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $gj7pJ({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $dX4Zi.unstable_runWithPriority, Of = $dX4Zi.unstable_scheduleCallback, Pf = $dX4Zi.unstable_cancelCallback, Qf = $dX4Zi.unstable_shouldYield, Rf = $dX4Zi.unstable_requestPaint, Sf = $dX4Zi.unstable_now, Tf = $dX4Zi.unstable_getCurrentPriorityLevel, Uf = $dX4Zi.unstable_ImmediatePriority, Vf = $dX4Zi.unstable_UserBlockingPriority, Wf = $dX4Zi.unstable_NormalPriority, Xf = $dX4Zi.unstable_LowPriority, Yf = $dX4Zi.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $gj7pJ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $gj7pJ({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $jSIPP.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $gj7pJ({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $gj7pJ({}, e, {
                    value: void 0
                });
                d = $gj7pJ({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $gj7pJ({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("dX4Zi", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dIuBR"));

});
parcelRegister("dIuBR", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9fc720dcb1fe1e65$export$c4744153514ff05d; }, function (v) { return $9fc720dcb1fe1e65$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9fc720dcb1fe1e65$export$b5836b71941fa3ed; }, function (v) { return $9fc720dcb1fe1e65$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9fc720dcb1fe1e65$export$d66a1c1c77bd778b; }, function (v) { return $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7; }, function (v) { return $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9fc720dcb1fe1e65$export$e26fe2ed2fa76875; }, function (v) { return $9fc720dcb1fe1e65$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9fc720dcb1fe1e65$export$502329bbf4b505b1; }, function (v) { return $9fc720dcb1fe1e65$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9fc720dcb1fe1e65$export$6e3807111c4874c4; }, function (v) { return $9fc720dcb1fe1e65$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9fc720dcb1fe1e65$export$c27134553091fb3a; }, function (v) { return $9fc720dcb1fe1e65$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2; }, function (v) { return $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9fc720dcb1fe1e65$export$b00a404bbd5edef2; }, function (v) { return $9fc720dcb1fe1e65$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9fc720dcb1fe1e65$export$8352ce38b91d0c62; }, function (v) { return $9fc720dcb1fe1e65$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9fc720dcb1fe1e65$export$d3dfb8e4810cb555; }, function (v) { return $9fc720dcb1fe1e65$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9fc720dcb1fe1e65$export$839f9183b0465a69; }, function (v) { return $9fc720dcb1fe1e65$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9fc720dcb1fe1e65$export$72fdf0e06517287b; }, function (v) { return $9fc720dcb1fe1e65$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9fc720dcb1fe1e65$export$4b844e58a3e414b4; }, function (v) { return $9fc720dcb1fe1e65$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9fc720dcb1fe1e65$export$816d2913ae6b83b1; }, function (v) { return $9fc720dcb1fe1e65$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9fc720dcb1fe1e65$export$61bcfe829111a1d0; }, function (v) { return $9fc720dcb1fe1e65$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f; }, function (v) { return $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9fc720dcb1fe1e65$export$cf845f2c119da08a; }, function (v) { return $9fc720dcb1fe1e65$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9fc720dcb1fe1e65$export$c4744153514ff05d;
var $9fc720dcb1fe1e65$export$b5836b71941fa3ed;
var $9fc720dcb1fe1e65$export$d66a1c1c77bd778b;
var $9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7;
var $9fc720dcb1fe1e65$export$e26fe2ed2fa76875;
var $9fc720dcb1fe1e65$export$502329bbf4b505b1;
var $9fc720dcb1fe1e65$export$6e3807111c4874c4;
var $9fc720dcb1fe1e65$export$c27134553091fb3a;
var $9fc720dcb1fe1e65$export$33ee1acdc04fd2a2;
var $9fc720dcb1fe1e65$export$b00a404bbd5edef2;
var $9fc720dcb1fe1e65$export$8352ce38b91d0c62;
var $9fc720dcb1fe1e65$export$d3dfb8e4810cb555;
var $9fc720dcb1fe1e65$export$839f9183b0465a69;
var $9fc720dcb1fe1e65$export$72fdf0e06517287b;
var $9fc720dcb1fe1e65$export$4b844e58a3e414b4;
var $9fc720dcb1fe1e65$export$816d2913ae6b83b1;
var $9fc720dcb1fe1e65$export$61bcfe829111a1d0;
var $9fc720dcb1fe1e65$export$7ee8c9beb337bc3f;
var $9fc720dcb1fe1e65$export$cf845f2c119da08a;
'use strict';
var $9fc720dcb1fe1e65$var$f, $9fc720dcb1fe1e65$var$g, $9fc720dcb1fe1e65$var$h, $9fc720dcb1fe1e65$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9fc720dcb1fe1e65$var$l = performance;
    $9fc720dcb1fe1e65$export$c4744153514ff05d = function() {
        return $9fc720dcb1fe1e65$var$l.now();
    };
} else {
    var $9fc720dcb1fe1e65$var$p = Date, $9fc720dcb1fe1e65$var$q = $9fc720dcb1fe1e65$var$p.now();
    $9fc720dcb1fe1e65$export$c4744153514ff05d = function() {
        return $9fc720dcb1fe1e65$var$p.now() - $9fc720dcb1fe1e65$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $9fc720dcb1fe1e65$var$t = null, $9fc720dcb1fe1e65$var$u = null, $9fc720dcb1fe1e65$var$w = function() {
        if (null !== $9fc720dcb1fe1e65$var$t) try {
            var a = $9fc720dcb1fe1e65$export$c4744153514ff05d();
            $9fc720dcb1fe1e65$var$t(!0, a);
            $9fc720dcb1fe1e65$var$t = null;
        } catch (b) {
            throw setTimeout($9fc720dcb1fe1e65$var$w, 0), b;
        }
    };
    $9fc720dcb1fe1e65$var$f = function(a) {
        null !== $9fc720dcb1fe1e65$var$t ? setTimeout($9fc720dcb1fe1e65$var$f, 0, a) : ($9fc720dcb1fe1e65$var$t = a, setTimeout($9fc720dcb1fe1e65$var$w, 0));
    };
    $9fc720dcb1fe1e65$var$g = function(a, b) {
        $9fc720dcb1fe1e65$var$u = setTimeout(a, b);
    };
    $9fc720dcb1fe1e65$var$h = function() {
        clearTimeout($9fc720dcb1fe1e65$var$u);
    };
    $9fc720dcb1fe1e65$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $9fc720dcb1fe1e65$var$k = $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = function() {};
} else {
    var $9fc720dcb1fe1e65$var$x = window.setTimeout, $9fc720dcb1fe1e65$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $9fc720dcb1fe1e65$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $9fc720dcb1fe1e65$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $9fc720dcb1fe1e65$var$A = !1, $9fc720dcb1fe1e65$var$B = null, $9fc720dcb1fe1e65$var$C = -1, $9fc720dcb1fe1e65$var$D = 5, $9fc720dcb1fe1e65$var$E = 0;
    $9fc720dcb1fe1e65$export$b5836b71941fa3ed = function() {
        return $9fc720dcb1fe1e65$export$c4744153514ff05d() >= $9fc720dcb1fe1e65$var$E;
    };
    $9fc720dcb1fe1e65$var$k = function() {};
    $9fc720dcb1fe1e65$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9fc720dcb1fe1e65$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $9fc720dcb1fe1e65$var$F = new MessageChannel, $9fc720dcb1fe1e65$var$G = $9fc720dcb1fe1e65$var$F.port2;
    $9fc720dcb1fe1e65$var$F.port1.onmessage = function() {
        if (null !== $9fc720dcb1fe1e65$var$B) {
            var a = $9fc720dcb1fe1e65$export$c4744153514ff05d();
            $9fc720dcb1fe1e65$var$E = a + $9fc720dcb1fe1e65$var$D;
            try {
                $9fc720dcb1fe1e65$var$B(!0, a) ? $9fc720dcb1fe1e65$var$G.postMessage(null) : ($9fc720dcb1fe1e65$var$A = !1, $9fc720dcb1fe1e65$var$B = null);
            } catch (b) {
                throw $9fc720dcb1fe1e65$var$G.postMessage(null), b;
            }
        } else $9fc720dcb1fe1e65$var$A = !1;
    };
    $9fc720dcb1fe1e65$var$f = function(a) {
        $9fc720dcb1fe1e65$var$B = a;
        $9fc720dcb1fe1e65$var$A || ($9fc720dcb1fe1e65$var$A = !0, $9fc720dcb1fe1e65$var$G.postMessage(null));
    };
    $9fc720dcb1fe1e65$var$g = function(a, b) {
        $9fc720dcb1fe1e65$var$C = $9fc720dcb1fe1e65$var$x(function() {
            a($9fc720dcb1fe1e65$export$c4744153514ff05d());
        }, b);
    };
    $9fc720dcb1fe1e65$var$h = function() {
        $9fc720dcb1fe1e65$var$y($9fc720dcb1fe1e65$var$C);
        $9fc720dcb1fe1e65$var$C = -1;
    };
}
function $9fc720dcb1fe1e65$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $9fc720dcb1fe1e65$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9fc720dcb1fe1e65$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $9fc720dcb1fe1e65$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $9fc720dcb1fe1e65$var$I(n, c)) void 0 !== r && 0 > $9fc720dcb1fe1e65$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $9fc720dcb1fe1e65$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $9fc720dcb1fe1e65$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $9fc720dcb1fe1e65$var$L = [], $9fc720dcb1fe1e65$var$M = [], $9fc720dcb1fe1e65$var$N = 1, $9fc720dcb1fe1e65$var$O = null, $9fc720dcb1fe1e65$var$P = 3, $9fc720dcb1fe1e65$var$Q = !1, $9fc720dcb1fe1e65$var$R = !1, $9fc720dcb1fe1e65$var$S = !1;
function $9fc720dcb1fe1e65$var$T(a) {
    for(var b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M); null !== b;){
        if (null === b.callback) $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$M);
        else if (b.startTime <= a) $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$M), b.sortIndex = b.expirationTime, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$L, b);
        else break;
        b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
    }
}
function $9fc720dcb1fe1e65$var$U(a) {
    $9fc720dcb1fe1e65$var$S = !1;
    $9fc720dcb1fe1e65$var$T(a);
    if (!$9fc720dcb1fe1e65$var$R) {
        if (null !== $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L)) $9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V);
        else {
            var b = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
            null !== b && $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, b.startTime - a);
        }
    }
}
function $9fc720dcb1fe1e65$var$V(a, b) {
    $9fc720dcb1fe1e65$var$R = !1;
    $9fc720dcb1fe1e65$var$S && ($9fc720dcb1fe1e65$var$S = !1, $9fc720dcb1fe1e65$var$h());
    $9fc720dcb1fe1e65$var$Q = !0;
    var c = $9fc720dcb1fe1e65$var$P;
    try {
        $9fc720dcb1fe1e65$var$T(b);
        for($9fc720dcb1fe1e65$var$O = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L); null !== $9fc720dcb1fe1e65$var$O && (!($9fc720dcb1fe1e65$var$O.expirationTime > b) || a && !$9fc720dcb1fe1e65$export$b5836b71941fa3ed());){
            var d = $9fc720dcb1fe1e65$var$O.callback;
            if ("function" === typeof d) {
                $9fc720dcb1fe1e65$var$O.callback = null;
                $9fc720dcb1fe1e65$var$P = $9fc720dcb1fe1e65$var$O.priorityLevel;
                var e = d($9fc720dcb1fe1e65$var$O.expirationTime <= b);
                b = $9fc720dcb1fe1e65$export$c4744153514ff05d();
                "function" === typeof e ? $9fc720dcb1fe1e65$var$O.callback = e : $9fc720dcb1fe1e65$var$O === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L) && $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$L);
                $9fc720dcb1fe1e65$var$T(b);
            } else $9fc720dcb1fe1e65$var$K($9fc720dcb1fe1e65$var$L);
            $9fc720dcb1fe1e65$var$O = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L);
        }
        if (null !== $9fc720dcb1fe1e65$var$O) var m = !0;
        else {
            var n = $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M);
            null !== n && $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $9fc720dcb1fe1e65$var$O = null, $9fc720dcb1fe1e65$var$P = c, $9fc720dcb1fe1e65$var$Q = !1;
    }
}
var $9fc720dcb1fe1e65$var$W = $9fc720dcb1fe1e65$var$k;
$9fc720dcb1fe1e65$export$3e506c1ccc9cc1a7 = 5;
$9fc720dcb1fe1e65$export$e26fe2ed2fa76875 = 1;
$9fc720dcb1fe1e65$export$502329bbf4b505b1 = 4;
$9fc720dcb1fe1e65$export$6e3807111c4874c4 = 3;
$9fc720dcb1fe1e65$export$c27134553091fb3a = null;
$9fc720dcb1fe1e65$export$33ee1acdc04fd2a2 = 2;
$9fc720dcb1fe1e65$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9fc720dcb1fe1e65$export$8352ce38b91d0c62 = function() {
    $9fc720dcb1fe1e65$var$R || $9fc720dcb1fe1e65$var$Q || ($9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V));
};
$9fc720dcb1fe1e65$export$d3dfb8e4810cb555 = function() {
    return $9fc720dcb1fe1e65$var$P;
};
$9fc720dcb1fe1e65$export$839f9183b0465a69 = function() {
    return $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L);
};
$9fc720dcb1fe1e65$export$72fdf0e06517287b = function(a) {
    switch($9fc720dcb1fe1e65$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9fc720dcb1fe1e65$var$P;
    }
    var c = $9fc720dcb1fe1e65$var$P;
    $9fc720dcb1fe1e65$var$P = b;
    try {
        return a();
    } finally{
        $9fc720dcb1fe1e65$var$P = c;
    }
};
$9fc720dcb1fe1e65$export$4b844e58a3e414b4 = function() {};
$9fc720dcb1fe1e65$export$816d2913ae6b83b1 = $9fc720dcb1fe1e65$var$W;
$9fc720dcb1fe1e65$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9fc720dcb1fe1e65$var$P;
    $9fc720dcb1fe1e65$var$P = a;
    try {
        return b();
    } finally{
        $9fc720dcb1fe1e65$var$P = c;
    }
};
$9fc720dcb1fe1e65$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9fc720dcb1fe1e65$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9fc720dcb1fe1e65$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$M, a), null === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$L) && a === $9fc720dcb1fe1e65$var$J($9fc720dcb1fe1e65$var$M) && ($9fc720dcb1fe1e65$var$S ? $9fc720dcb1fe1e65$var$h() : $9fc720dcb1fe1e65$var$S = !0, $9fc720dcb1fe1e65$var$g($9fc720dcb1fe1e65$var$U, c - d))) : (a.sortIndex = e, $9fc720dcb1fe1e65$var$H($9fc720dcb1fe1e65$var$L, a), $9fc720dcb1fe1e65$var$R || $9fc720dcb1fe1e65$var$Q || ($9fc720dcb1fe1e65$var$R = !0, $9fc720dcb1fe1e65$var$f($9fc720dcb1fe1e65$var$V)));
    return a;
};
$9fc720dcb1fe1e65$export$cf845f2c119da08a = function(a) {
    var b = $9fc720dcb1fe1e65$var$P;
    return function() {
        var c = $9fc720dcb1fe1e65$var$P;
        $9fc720dcb1fe1e65$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9fc720dcb1fe1e65$var$P = c;
        }
    };
};

});



parcelRegister("kHujd", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $1gTt1 = parcelRequire("1gTt1");
function $f11f558512582ed5$var$emptyFunction() {}
function $f11f558512582ed5$var$emptyFunctionWithReset() {}
$f11f558512582ed5$var$emptyFunctionWithReset.resetWarningCache = $f11f558512582ed5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $1gTt1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f11f558512582ed5$var$emptyFunctionWithReset,
        resetWarningCache: $f11f558512582ed5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("1gTt1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $0ed24fabe6ffc3d4$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $0ed24fabe6ffc3d4$var$ReactPropTypesSecret;

});


parcelRegister("vzIz9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $05ee9a2d7583b0cc$export$2b8d127b894957b9; }, function (v) { return $05ee9a2d7583b0cc$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $05ee9a2d7583b0cc$export$cea3a54a6425200c; }, function (v) { return $05ee9a2d7583b0cc$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $05ee9a2d7583b0cc$export$a7c73072b1a182ae; }, function (v) { return $05ee9a2d7583b0cc$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $05ee9a2d7583b0cc$export$9f27bc3417b4524d; }, function (v) { return $05ee9a2d7583b0cc$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $05ee9a2d7583b0cc$export$db77ccec0bb4ccac; }, function (v) { return $05ee9a2d7583b0cc$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $05ee9a2d7583b0cc$export$8392c0c9d3dcbd35; }, function (v) { return $05ee9a2d7583b0cc$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $05ee9a2d7583b0cc$export$ffb0004e005737fa; }, function (v) { return $05ee9a2d7583b0cc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $05ee9a2d7583b0cc$export$b624eff549462981; }, function (v) { return $05ee9a2d7583b0cc$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $05ee9a2d7583b0cc$export$7897aa7841a5380c; }, function (v) { return $05ee9a2d7583b0cc$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $05ee9a2d7583b0cc$export$602eac185826482c; }, function (v) { return $05ee9a2d7583b0cc$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $05ee9a2d7583b0cc$export$e2c29f18771995cb; }, function (v) { return $05ee9a2d7583b0cc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $05ee9a2d7583b0cc$export$5f8d39834fd61797; }, function (v) { return $05ee9a2d7583b0cc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $05ee9a2d7583b0cc$export$74bf444e3cd11ea5; }, function (v) { return $05ee9a2d7583b0cc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $05ee9a2d7583b0cc$export$92387174baf9b227; }, function (v) { return $05ee9a2d7583b0cc$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $05ee9a2d7583b0cc$export$ec112efeb987d9c6; }, function (v) { return $05ee9a2d7583b0cc$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $05ee9a2d7583b0cc$export$b706b080d889d2c9; }, function (v) { return $05ee9a2d7583b0cc$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $05ee9a2d7583b0cc$export$5be5a87408f70ddc; }, function (v) { return $05ee9a2d7583b0cc$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $05ee9a2d7583b0cc$export$45a5e7f76e0caa8d; }, function (v) { return $05ee9a2d7583b0cc$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $05ee9a2d7583b0cc$export$455c2e768291efa6; }, function (v) { return $05ee9a2d7583b0cc$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $05ee9a2d7583b0cc$export$9522e17588c12572; }, function (v) { return $05ee9a2d7583b0cc$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $05ee9a2d7583b0cc$export$2110ac352bb060b9; }, function (v) { return $05ee9a2d7583b0cc$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $05ee9a2d7583b0cc$export$56885ab8b9c456ab; }, function (v) { return $05ee9a2d7583b0cc$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $05ee9a2d7583b0cc$export$d927fcb6adf8f9de; }, function (v) { return $05ee9a2d7583b0cc$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $05ee9a2d7583b0cc$export$b82d16f27459e05a; }, function (v) { return $05ee9a2d7583b0cc$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $05ee9a2d7583b0cc$export$522c17b4f5e123e8; }, function (v) { return $05ee9a2d7583b0cc$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $05ee9a2d7583b0cc$export$1aabd8a0274ecfd6; }, function (v) { return $05ee9a2d7583b0cc$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $05ee9a2d7583b0cc$export$9b621391a187a31a; }, function (v) { return $05ee9a2d7583b0cc$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $05ee9a2d7583b0cc$export$f5bbd400c2f4426f; }, function (v) { return $05ee9a2d7583b0cc$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $05ee9a2d7583b0cc$export$2b8d127b894957b9;
var $05ee9a2d7583b0cc$export$cea3a54a6425200c;
var $05ee9a2d7583b0cc$export$a7c73072b1a182ae;
var $05ee9a2d7583b0cc$export$9f27bc3417b4524d;
var $05ee9a2d7583b0cc$export$db77ccec0bb4ccac;
var $05ee9a2d7583b0cc$export$8392c0c9d3dcbd35;
var $05ee9a2d7583b0cc$export$ffb0004e005737fa;
var $05ee9a2d7583b0cc$export$b624eff549462981;
var $05ee9a2d7583b0cc$export$7897aa7841a5380c;
var $05ee9a2d7583b0cc$export$602eac185826482c;
var $05ee9a2d7583b0cc$export$e2c29f18771995cb;
var $05ee9a2d7583b0cc$export$5f8d39834fd61797;
var $05ee9a2d7583b0cc$export$74bf444e3cd11ea5;
var $05ee9a2d7583b0cc$export$92387174baf9b227;
var $05ee9a2d7583b0cc$export$ec112efeb987d9c6;
var $05ee9a2d7583b0cc$export$b706b080d889d2c9;
var $05ee9a2d7583b0cc$export$5be5a87408f70ddc;
var $05ee9a2d7583b0cc$export$45a5e7f76e0caa8d;
var $05ee9a2d7583b0cc$export$455c2e768291efa6;
var $05ee9a2d7583b0cc$export$9522e17588c12572;
var $05ee9a2d7583b0cc$export$2110ac352bb060b9;
var $05ee9a2d7583b0cc$export$56885ab8b9c456ab;
var $05ee9a2d7583b0cc$export$d927fcb6adf8f9de;
var $05ee9a2d7583b0cc$export$b82d16f27459e05a;
var $05ee9a2d7583b0cc$export$522c17b4f5e123e8;
var $05ee9a2d7583b0cc$export$1aabd8a0274ecfd6;
var $05ee9a2d7583b0cc$export$9b621391a187a31a;
var $05ee9a2d7583b0cc$export$f5bbd400c2f4426f;
'use strict';
var $05ee9a2d7583b0cc$var$b = "function" === typeof Symbol && Symbol.for, $05ee9a2d7583b0cc$var$c = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.element") : 60103, $05ee9a2d7583b0cc$var$d = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.portal") : 60106, $05ee9a2d7583b0cc$var$e = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.fragment") : 60107, $05ee9a2d7583b0cc$var$f = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.strict_mode") : 60108, $05ee9a2d7583b0cc$var$g = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.profiler") : 60114, $05ee9a2d7583b0cc$var$h = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.provider") : 60109, $05ee9a2d7583b0cc$var$k = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.context") : 60110, $05ee9a2d7583b0cc$var$l = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.async_mode") : 60111, $05ee9a2d7583b0cc$var$m = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.concurrent_mode") : 60111, $05ee9a2d7583b0cc$var$n = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.forward_ref") : 60112, $05ee9a2d7583b0cc$var$p = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.suspense") : 60113, $05ee9a2d7583b0cc$var$q = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.suspense_list") : 60120, $05ee9a2d7583b0cc$var$r = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.memo") : 60115, $05ee9a2d7583b0cc$var$t = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.lazy") : 60116, $05ee9a2d7583b0cc$var$v = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.block") : 60121, $05ee9a2d7583b0cc$var$w = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.fundamental") : 60117, $05ee9a2d7583b0cc$var$x = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.responder") : 60118, $05ee9a2d7583b0cc$var$y = $05ee9a2d7583b0cc$var$b ? Symbol.for("react.scope") : 60119;
function $05ee9a2d7583b0cc$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $05ee9a2d7583b0cc$var$c:
                switch(a = a.type, a){
                    case $05ee9a2d7583b0cc$var$l:
                    case $05ee9a2d7583b0cc$var$m:
                    case $05ee9a2d7583b0cc$var$e:
                    case $05ee9a2d7583b0cc$var$g:
                    case $05ee9a2d7583b0cc$var$f:
                    case $05ee9a2d7583b0cc$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $05ee9a2d7583b0cc$var$k:
                            case $05ee9a2d7583b0cc$var$n:
                            case $05ee9a2d7583b0cc$var$t:
                            case $05ee9a2d7583b0cc$var$r:
                            case $05ee9a2d7583b0cc$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $05ee9a2d7583b0cc$var$d:
                return u;
        }
    }
}
function $05ee9a2d7583b0cc$var$A(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$m;
}
$05ee9a2d7583b0cc$export$2b8d127b894957b9 = $05ee9a2d7583b0cc$var$l;
$05ee9a2d7583b0cc$export$cea3a54a6425200c = $05ee9a2d7583b0cc$var$m;
$05ee9a2d7583b0cc$export$a7c73072b1a182ae = $05ee9a2d7583b0cc$var$k;
$05ee9a2d7583b0cc$export$9f27bc3417b4524d = $05ee9a2d7583b0cc$var$h;
$05ee9a2d7583b0cc$export$db77ccec0bb4ccac = $05ee9a2d7583b0cc$var$c;
$05ee9a2d7583b0cc$export$8392c0c9d3dcbd35 = $05ee9a2d7583b0cc$var$n;
$05ee9a2d7583b0cc$export$ffb0004e005737fa = $05ee9a2d7583b0cc$var$e;
$05ee9a2d7583b0cc$export$b624eff549462981 = $05ee9a2d7583b0cc$var$t;
$05ee9a2d7583b0cc$export$7897aa7841a5380c = $05ee9a2d7583b0cc$var$r;
$05ee9a2d7583b0cc$export$602eac185826482c = $05ee9a2d7583b0cc$var$d;
$05ee9a2d7583b0cc$export$e2c29f18771995cb = $05ee9a2d7583b0cc$var$g;
$05ee9a2d7583b0cc$export$5f8d39834fd61797 = $05ee9a2d7583b0cc$var$f;
$05ee9a2d7583b0cc$export$74bf444e3cd11ea5 = $05ee9a2d7583b0cc$var$p;
$05ee9a2d7583b0cc$export$92387174baf9b227 = function(a) {
    return $05ee9a2d7583b0cc$var$A(a) || $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$l;
};
$05ee9a2d7583b0cc$export$ec112efeb987d9c6 = $05ee9a2d7583b0cc$var$A;
$05ee9a2d7583b0cc$export$b706b080d889d2c9 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$k;
};
$05ee9a2d7583b0cc$export$5be5a87408f70ddc = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$h;
};
$05ee9a2d7583b0cc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $05ee9a2d7583b0cc$var$c;
};
$05ee9a2d7583b0cc$export$455c2e768291efa6 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$n;
};
$05ee9a2d7583b0cc$export$9522e17588c12572 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$e;
};
$05ee9a2d7583b0cc$export$2110ac352bb060b9 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$t;
};
$05ee9a2d7583b0cc$export$56885ab8b9c456ab = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$r;
};
$05ee9a2d7583b0cc$export$d927fcb6adf8f9de = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$d;
};
$05ee9a2d7583b0cc$export$b82d16f27459e05a = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$g;
};
$05ee9a2d7583b0cc$export$522c17b4f5e123e8 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$f;
};
$05ee9a2d7583b0cc$export$1aabd8a0274ecfd6 = function(a) {
    return $05ee9a2d7583b0cc$var$z(a) === $05ee9a2d7583b0cc$var$p;
};
$05ee9a2d7583b0cc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $05ee9a2d7583b0cc$var$e || a === $05ee9a2d7583b0cc$var$m || a === $05ee9a2d7583b0cc$var$g || a === $05ee9a2d7583b0cc$var$f || a === $05ee9a2d7583b0cc$var$p || a === $05ee9a2d7583b0cc$var$q || "object" === typeof a && null !== a && (a.$$typeof === $05ee9a2d7583b0cc$var$t || a.$$typeof === $05ee9a2d7583b0cc$var$r || a.$$typeof === $05ee9a2d7583b0cc$var$h || a.$$typeof === $05ee9a2d7583b0cc$var$k || a.$$typeof === $05ee9a2d7583b0cc$var$n || a.$$typeof === $05ee9a2d7583b0cc$var$w || a.$$typeof === $05ee9a2d7583b0cc$var$x || a.$$typeof === $05ee9a2d7583b0cc$var$y || a.$$typeof === $05ee9a2d7583b0cc$var$v);
};
$05ee9a2d7583b0cc$export$f5bbd400c2f4426f = $05ee9a2d7583b0cc$var$z;

});

parcelRegister("3qqzO", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $27e86a649335d696$export$a7c73072b1a182ae; }, function (v) { return $27e86a649335d696$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27e86a649335d696$export$9f27bc3417b4524d; }, function (v) { return $27e86a649335d696$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27e86a649335d696$export$db77ccec0bb4ccac; }, function (v) { return $27e86a649335d696$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27e86a649335d696$export$8392c0c9d3dcbd35; }, function (v) { return $27e86a649335d696$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27e86a649335d696$export$ffb0004e005737fa; }, function (v) { return $27e86a649335d696$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27e86a649335d696$export$b624eff549462981; }, function (v) { return $27e86a649335d696$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27e86a649335d696$export$7897aa7841a5380c; }, function (v) { return $27e86a649335d696$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27e86a649335d696$export$602eac185826482c; }, function (v) { return $27e86a649335d696$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27e86a649335d696$export$e2c29f18771995cb; }, function (v) { return $27e86a649335d696$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27e86a649335d696$export$5f8d39834fd61797; }, function (v) { return $27e86a649335d696$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27e86a649335d696$export$74bf444e3cd11ea5; }, function (v) { return $27e86a649335d696$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27e86a649335d696$export$92387174baf9b227; }, function (v) { return $27e86a649335d696$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27e86a649335d696$export$ec112efeb987d9c6; }, function (v) { return $27e86a649335d696$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27e86a649335d696$export$b706b080d889d2c9; }, function (v) { return $27e86a649335d696$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27e86a649335d696$export$5be5a87408f70ddc; }, function (v) { return $27e86a649335d696$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27e86a649335d696$export$45a5e7f76e0caa8d; }, function (v) { return $27e86a649335d696$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27e86a649335d696$export$455c2e768291efa6; }, function (v) { return $27e86a649335d696$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27e86a649335d696$export$9522e17588c12572; }, function (v) { return $27e86a649335d696$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27e86a649335d696$export$2110ac352bb060b9; }, function (v) { return $27e86a649335d696$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27e86a649335d696$export$56885ab8b9c456ab; }, function (v) { return $27e86a649335d696$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27e86a649335d696$export$d927fcb6adf8f9de; }, function (v) { return $27e86a649335d696$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27e86a649335d696$export$b82d16f27459e05a; }, function (v) { return $27e86a649335d696$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27e86a649335d696$export$522c17b4f5e123e8; }, function (v) { return $27e86a649335d696$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27e86a649335d696$export$1aabd8a0274ecfd6; }, function (v) { return $27e86a649335d696$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27e86a649335d696$export$9b621391a187a31a; }, function (v) { return $27e86a649335d696$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27e86a649335d696$export$f5bbd400c2f4426f; }, function (v) { return $27e86a649335d696$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27e86a649335d696$export$a7c73072b1a182ae;
var $27e86a649335d696$export$9f27bc3417b4524d;
var $27e86a649335d696$export$db77ccec0bb4ccac;
var $27e86a649335d696$export$8392c0c9d3dcbd35;
var $27e86a649335d696$export$ffb0004e005737fa;
var $27e86a649335d696$export$b624eff549462981;
var $27e86a649335d696$export$7897aa7841a5380c;
var $27e86a649335d696$export$602eac185826482c;
var $27e86a649335d696$export$e2c29f18771995cb;
var $27e86a649335d696$export$5f8d39834fd61797;
var $27e86a649335d696$export$74bf444e3cd11ea5;
var $27e86a649335d696$export$92387174baf9b227;
var $27e86a649335d696$export$ec112efeb987d9c6;
var $27e86a649335d696$export$b706b080d889d2c9;
var $27e86a649335d696$export$5be5a87408f70ddc;
var $27e86a649335d696$export$45a5e7f76e0caa8d;
var $27e86a649335d696$export$455c2e768291efa6;
var $27e86a649335d696$export$9522e17588c12572;
var $27e86a649335d696$export$2110ac352bb060b9;
var $27e86a649335d696$export$56885ab8b9c456ab;
var $27e86a649335d696$export$d927fcb6adf8f9de;
var $27e86a649335d696$export$b82d16f27459e05a;
var $27e86a649335d696$export$522c17b4f5e123e8;
var $27e86a649335d696$export$1aabd8a0274ecfd6;
var $27e86a649335d696$export$9b621391a187a31a;
var $27e86a649335d696$export$f5bbd400c2f4426f;
'use strict';
var $27e86a649335d696$var$b = 60103, $27e86a649335d696$var$c = 60106, $27e86a649335d696$var$d = 60107, $27e86a649335d696$var$e = 60108, $27e86a649335d696$var$f = 60114, $27e86a649335d696$var$g = 60109, $27e86a649335d696$var$h = 60110, $27e86a649335d696$var$k = 60112, $27e86a649335d696$var$l = 60113, $27e86a649335d696$var$m = 60120, $27e86a649335d696$var$n = 60115, $27e86a649335d696$var$p = 60116, $27e86a649335d696$var$q = 60121, $27e86a649335d696$var$r = 60122, $27e86a649335d696$var$u = 60117, $27e86a649335d696$var$v = 60129, $27e86a649335d696$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $27e86a649335d696$var$x = Symbol.for;
    $27e86a649335d696$var$b = $27e86a649335d696$var$x("react.element");
    $27e86a649335d696$var$c = $27e86a649335d696$var$x("react.portal");
    $27e86a649335d696$var$d = $27e86a649335d696$var$x("react.fragment");
    $27e86a649335d696$var$e = $27e86a649335d696$var$x("react.strict_mode");
    $27e86a649335d696$var$f = $27e86a649335d696$var$x("react.profiler");
    $27e86a649335d696$var$g = $27e86a649335d696$var$x("react.provider");
    $27e86a649335d696$var$h = $27e86a649335d696$var$x("react.context");
    $27e86a649335d696$var$k = $27e86a649335d696$var$x("react.forward_ref");
    $27e86a649335d696$var$l = $27e86a649335d696$var$x("react.suspense");
    $27e86a649335d696$var$m = $27e86a649335d696$var$x("react.suspense_list");
    $27e86a649335d696$var$n = $27e86a649335d696$var$x("react.memo");
    $27e86a649335d696$var$p = $27e86a649335d696$var$x("react.lazy");
    $27e86a649335d696$var$q = $27e86a649335d696$var$x("react.block");
    $27e86a649335d696$var$r = $27e86a649335d696$var$x("react.server.block");
    $27e86a649335d696$var$u = $27e86a649335d696$var$x("react.fundamental");
    $27e86a649335d696$var$v = $27e86a649335d696$var$x("react.debug_trace_mode");
    $27e86a649335d696$var$w = $27e86a649335d696$var$x("react.legacy_hidden");
}
function $27e86a649335d696$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $27e86a649335d696$var$b:
                switch(a = a.type, a){
                    case $27e86a649335d696$var$d:
                    case $27e86a649335d696$var$f:
                    case $27e86a649335d696$var$e:
                    case $27e86a649335d696$var$l:
                    case $27e86a649335d696$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27e86a649335d696$var$h:
                            case $27e86a649335d696$var$k:
                            case $27e86a649335d696$var$p:
                            case $27e86a649335d696$var$n:
                            case $27e86a649335d696$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $27e86a649335d696$var$c:
                return t;
        }
    }
}
var $27e86a649335d696$var$z = $27e86a649335d696$var$g, $27e86a649335d696$var$A = $27e86a649335d696$var$b, $27e86a649335d696$var$B = $27e86a649335d696$var$k, $27e86a649335d696$var$C = $27e86a649335d696$var$d, $27e86a649335d696$var$D = $27e86a649335d696$var$p, $27e86a649335d696$var$E = $27e86a649335d696$var$n, $27e86a649335d696$var$F = $27e86a649335d696$var$c, $27e86a649335d696$var$G = $27e86a649335d696$var$f, $27e86a649335d696$var$H = $27e86a649335d696$var$e, $27e86a649335d696$var$I = $27e86a649335d696$var$l;
$27e86a649335d696$export$a7c73072b1a182ae = $27e86a649335d696$var$h;
$27e86a649335d696$export$9f27bc3417b4524d = $27e86a649335d696$var$z;
$27e86a649335d696$export$db77ccec0bb4ccac = $27e86a649335d696$var$A;
$27e86a649335d696$export$8392c0c9d3dcbd35 = $27e86a649335d696$var$B;
$27e86a649335d696$export$ffb0004e005737fa = $27e86a649335d696$var$C;
$27e86a649335d696$export$b624eff549462981 = $27e86a649335d696$var$D;
$27e86a649335d696$export$7897aa7841a5380c = $27e86a649335d696$var$E;
$27e86a649335d696$export$602eac185826482c = $27e86a649335d696$var$F;
$27e86a649335d696$export$e2c29f18771995cb = $27e86a649335d696$var$G;
$27e86a649335d696$export$5f8d39834fd61797 = $27e86a649335d696$var$H;
$27e86a649335d696$export$74bf444e3cd11ea5 = $27e86a649335d696$var$I;
$27e86a649335d696$export$92387174baf9b227 = function() {
    return !1;
};
$27e86a649335d696$export$ec112efeb987d9c6 = function() {
    return !1;
};
$27e86a649335d696$export$b706b080d889d2c9 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$h;
};
$27e86a649335d696$export$5be5a87408f70ddc = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$g;
};
$27e86a649335d696$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27e86a649335d696$var$b;
};
$27e86a649335d696$export$455c2e768291efa6 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$k;
};
$27e86a649335d696$export$9522e17588c12572 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$d;
};
$27e86a649335d696$export$2110ac352bb060b9 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$p;
};
$27e86a649335d696$export$56885ab8b9c456ab = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$n;
};
$27e86a649335d696$export$d927fcb6adf8f9de = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$c;
};
$27e86a649335d696$export$b82d16f27459e05a = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$f;
};
$27e86a649335d696$export$522c17b4f5e123e8 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$e;
};
$27e86a649335d696$export$1aabd8a0274ecfd6 = function(a) {
    return $27e86a649335d696$var$y(a) === $27e86a649335d696$var$l;
};
$27e86a649335d696$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27e86a649335d696$var$d || a === $27e86a649335d696$var$f || a === $27e86a649335d696$var$v || a === $27e86a649335d696$var$e || a === $27e86a649335d696$var$l || a === $27e86a649335d696$var$m || a === $27e86a649335d696$var$w || "object" === typeof a && null !== a && (a.$$typeof === $27e86a649335d696$var$p || a.$$typeof === $27e86a649335d696$var$n || a.$$typeof === $27e86a649335d696$var$g || a.$$typeof === $27e86a649335d696$var$h || a.$$typeof === $27e86a649335d696$var$k || a.$$typeof === $27e86a649335d696$var$u || a.$$typeof === $27e86a649335d696$var$q || a[0] === $27e86a649335d696$var$r) ? !0 : !1;
};
$27e86a649335d696$export$f5bbd400c2f4426f = $27e86a649335d696$var$y;

});

parcelRegister("1Gnf1", function(module, exports) {
function $139bbdf0c1c6e7bc$var$_extends() {
    return module.exports = $139bbdf0c1c6e7bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $139bbdf0c1c6e7bc$var$_extends.apply(null, arguments);
}
module.exports = $139bbdf0c1c6e7bc$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j3GPk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ddff84a5fc936d31$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $ddff84a5fc936d31$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $ddff84a5fc936d31$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eNcJv")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("lebkq")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("lebkq")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("7Cxrh")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("emEIf")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1LXaJ = parcelRequire("1LXaJ");

var $hr4Ln = parcelRequire("hr4Ln");

var $lebkq = parcelRequire("lebkq");
var $eNcJv = parcelRequire("eNcJv");

var $7Cxrh = parcelRequire("7Cxrh");

var $emEIf = parcelRequire("emEIf");
'use client';
function $ddff84a5fc936d31$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $1LXaJ.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $ddff84a5fc936d31$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $ddff84a5fc936d31$var$wrapper = [];
function $ddff84a5fc936d31$export$13a2d3ef13012b32(styles) {
    $ddff84a5fc936d31$var$wrapper[0] = styles;
    return (0, $hr4Ln.serializeStyles)($ddff84a5fc936d31$var$wrapper);
}

});
parcelRegister("1LXaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14a81494e839253a$export$2e2bcd8739ae039; });

var $7NbjO = parcelRequire("7NbjO");
parcelRequire("1Gnf1");

parcelRequire("hr4Ln");
parcelRequire("420Cf");
parcelRequire("9IQNN");
parcelRequire("jSIPP");
parcelRequire("hjPj3");
var $14a81494e839253a$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $14a81494e839253a$export$2e2bcd8739ae039 = (0, $7NbjO.default).bind(null);
$14a81494e839253a$var$tags.forEach(function(tagName) {
    $14a81494e839253a$export$2e2bcd8739ae039[tagName] = $14a81494e839253a$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("7NbjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ac5e3a344ab2cac$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");
parcelRequire("lebkq");
var $eNcJv = parcelRequire("eNcJv");

var $hr4Ln = parcelRequire("hr4Ln");

var $420Cf = parcelRequire("420Cf");

var $9IQNN = parcelRequire("9IQNN");

var $jSIPP = parcelRequire("jSIPP");

var $hjPj3 = parcelRequire("hjPj3");
var $5ac5e3a344ab2cac$var$isBrowser = typeof document !== 'undefined';
var $5ac5e3a344ab2cac$var$isDevelopment = false;
var $5ac5e3a344ab2cac$var$testOmitPropsOnStringTag = (0, $hjPj3.default);
var $5ac5e3a344ab2cac$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $5ac5e3a344ab2cac$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $5ac5e3a344ab2cac$var$testOmitPropsOnStringTag : $5ac5e3a344ab2cac$var$testOmitPropsOnComponent;
};
var $5ac5e3a344ab2cac$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $5ac5e3a344ab2cac$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9IQNN.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $420Cf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9IQNN.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$5ac5e3a344ab2cac$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $jSIPP.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $5ac5e3a344ab2cac$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $5ac5e3a344ab2cac$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $5ac5e3a344ab2cac$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eNcJv.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $jSIPP.useContext((0, $eNcJv.T));
            }
            if (typeof props.className === 'string') className = (0, $9IQNN.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $hr4Ln.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $5ac5e3a344ab2cac$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $jSIPP.createElement($jSIPP.Fragment, null, /*#__PURE__*/ $jSIPP.createElement($5ac5e3a344ab2cac$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $jSIPP.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $5ac5e3a344ab2cac$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $erOpW.default)({}, options, nextOptions, {
                shouldForwardProp: $5ac5e3a344ab2cac$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("erOpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a84ab2276b50d419$export$2e2bcd8739ae039; });
function $a84ab2276b50d419$export$2e2bcd8739ae039() {
    return $a84ab2276b50d419$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a84ab2276b50d419$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("lebkq", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $f743b15fc260160e$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $f743b15fc260160e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $f743b15fc260160e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $f743b15fc260160e$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eNcJv")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("eNcJv")).w; });

var $eNcJv = parcelRequire("eNcJv");

var $jSIPP = parcelRequire("jSIPP");

var $9IQNN = parcelRequire("9IQNN");

var $420Cf = parcelRequire("420Cf");

var $hr4Ln = parcelRequire("hr4Ln");
parcelRequire("93Aqs");
parcelRequire("1Gnf1");
parcelRequire("iRS4s");

parcelRequire("lvZzf");
var $f743b15fc260160e$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eNcJv.h).call(props, 'css')) return $jSIPP.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eNcJv.E);
    createElementArgArray[1] = (0, $eNcJv.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $jSIPP.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($f743b15fc260160e$export$c8a8987d4410bf2d || ($f743b15fc260160e$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f743b15fc260160e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eNcJv.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $hr4Ln.serializeStyles)([
        styles
    ], undefined, $jSIPP.useContext((0, $eNcJv.T)));
    if (!(0, $eNcJv.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $jSIPP.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $jSIPP.useRef();
    (0, $420Cf.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $420Cf.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $9IQNN.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $f743b15fc260160e$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $hr4Ln.serializeStyles)(args);
}
function $f743b15fc260160e$export$d25ddfdf17c3ad3e() {
    var insertable = $f743b15fc260160e$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $f743b15fc260160e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $f743b15fc260160e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $9IQNN.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f743b15fc260160e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $420Cf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $9IQNN.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eNcJv.i) && res !== undefined) rules += res;
        }
        if (!(0, $eNcJv.i)) return rules;
    });
    if (!(0, $eNcJv.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $jSIPP.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f743b15fc260160e$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eNcJv.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eNcJv.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $hr4Ln.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $9IQNN.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eNcJv.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f743b15fc260160e$var$merge(cache.registered, css, $f743b15fc260160e$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $jSIPP.useContext((0, $eNcJv.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $jSIPP.createElement($jSIPP.Fragment, null, /*#__PURE__*/ $jSIPP.createElement($f743b15fc260160e$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eNcJv", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $ac4f84d1c112d499$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $ac4f84d1c112d499$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $ac4f84d1c112d499$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $ac4f84d1c112d499$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $ac4f84d1c112d499$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $ac4f84d1c112d499$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $ac4f84d1c112d499$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $ac4f84d1c112d499$export$a9c23c6ac3fc3eca; });

var $jSIPP = parcelRequire("jSIPP");

var $93Aqs = parcelRequire("93Aqs");

var $erOpW = parcelRequire("erOpW");

var $iRS4s = parcelRequire("iRS4s");

var $agcBp = parcelRequire("agcBp");

var $9IQNN = parcelRequire("9IQNN");

var $hr4Ln = parcelRequire("hr4Ln");

var $420Cf = parcelRequire("420Cf");
var $ac4f84d1c112d499$export$407448d2b89b1813 = false;
var $ac4f84d1c112d499$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $ac4f84d1c112d499$var$EmotionCacheContext = /* #__PURE__ */ $jSIPP.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $93Aqs.default)({
    key: 'css'
}) : null);
var $ac4f84d1c112d499$export$e7094788287c5e9b = $ac4f84d1c112d499$var$EmotionCacheContext.Provider;
var $ac4f84d1c112d499$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $jSIPP.useContext)($ac4f84d1c112d499$var$EmotionCacheContext);
};
var $ac4f84d1c112d499$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $jSIPP.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $jSIPP.useContext)($ac4f84d1c112d499$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$ac4f84d1c112d499$export$23f2a1d2818174ef) $ac4f84d1c112d499$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $jSIPP.useContext)($ac4f84d1c112d499$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $93Aqs.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $jSIPP.createElement($ac4f84d1c112d499$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $ac4f84d1c112d499$export$971d5caa766a69d7 = /* #__PURE__ */ $jSIPP.createContext({});
var $ac4f84d1c112d499$export$3b14a55fb2447963 = function useTheme() {
    return $jSIPP.useContext($ac4f84d1c112d499$export$971d5caa766a69d7);
};
var $ac4f84d1c112d499$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $erOpW.default)({}, outerTheme, theme);
};
var $ac4f84d1c112d499$var$createCacheWithTheme = /* #__PURE__ */ (0, $iRS4s.default)(function(outerTheme) {
    return (0, $iRS4s.default)(function(theme) {
        return $ac4f84d1c112d499$var$getTheme(outerTheme, theme);
    });
});
var $ac4f84d1c112d499$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $jSIPP.useContext($ac4f84d1c112d499$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ac4f84d1c112d499$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $jSIPP.createElement($ac4f84d1c112d499$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ac4f84d1c112d499$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $jSIPP.forwardRef(function render(props, ref) {
        var theme = $jSIPP.useContext($ac4f84d1c112d499$export$971d5caa766a69d7);
        return /*#__PURE__*/ $jSIPP.createElement(Component, (0, $erOpW.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $agcBp.default)(WithTheme, Component);
}
var $ac4f84d1c112d499$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ac4f84d1c112d499$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $ac4f84d1c112d499$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($ac4f84d1c112d499$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$ac4f84d1c112d499$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $ac4f84d1c112d499$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9IQNN.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $420Cf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9IQNN.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$ac4f84d1c112d499$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $jSIPP.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $ac4f84d1c112d499$var$Emotion = /* #__PURE__ */ $ac4f84d1c112d499$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ac4f84d1c112d499$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $9IQNN.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $hr4Ln.serializeStyles)(registeredStyles, undefined, $jSIPP.useContext($ac4f84d1c112d499$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($ac4f84d1c112d499$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $ac4f84d1c112d499$var$typePropName && !$ac4f84d1c112d499$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $jSIPP.createElement($jSIPP.Fragment, null, /*#__PURE__*/ $jSIPP.createElement($ac4f84d1c112d499$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $jSIPP.createElement(WrappedComponent, newProps));
});
var $ac4f84d1c112d499$export$a9c23c6ac3fc3eca = $ac4f84d1c112d499$var$Emotion;

});
parcelRegister("93Aqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6980a63c6d675c74$export$2e2bcd8739ae039; });

var $0zppd = parcelRequire("0zppd");

var $hewgl = parcelRequire("hewgl");

var $iRS4s = parcelRequire("iRS4s");

var $77plb = parcelRequire("77plb");
var $6980a63c6d675c74$var$isBrowser = typeof document !== 'undefined';
var $6980a63c6d675c74$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $hewgl.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $hewgl.token)(character)) break;
        (0, $hewgl.next)();
    }
    return (0, $hewgl.slice)(begin, (0, $hewgl.position));
};
var $6980a63c6d675c74$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $hewgl.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $hewgl.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6980a63c6d675c74$var$identifierWithPointTracking((0, $hewgl.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $hewgl.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $hewgl.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $hewgl.from)(character);
    }
    while (character = (0, $hewgl.next)());
    return parsed;
};
var $6980a63c6d675c74$var$getRules = function getRules(value, points) {
    return (0, $hewgl.dealloc)($6980a63c6d675c74$var$toRules((0, $hewgl.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6980a63c6d675c74$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6980a63c6d675c74$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6980a63c6d675c74$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6980a63c6d675c74$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6980a63c6d675c74$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6980a63c6d675c74$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $6980a63c6d675c74$var$prefix(value, length) {
    switch((0, $hewgl.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $hewgl.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $hewgl.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MOZ) + value + (0, $hewgl.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + value + value;
        // order
        case 6165:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.replace)(value, /(\w+).+(:[^]+)/, (0, $hewgl.WEBKIT) + 'box-$1$2' + (0, $hewgl.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + 'flex-item-' + (0, $hewgl.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + 'flex-line-pack' + (0, $hewgl.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $hewgl.WEBKIT) + 'box-' + (0, $hewgl.replace)(value, '-grow', '') + (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $hewgl.WEBKIT) + (0, $hewgl.replace)(value, /([^-])(transform)/g, '$1' + (0, $hewgl.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $hewgl.replace)((0, $hewgl.replace)((0, $hewgl.replace)(value, /(zoom-|grab)/, (0, $hewgl.WEBKIT) + '$1'), /(image-set)/, (0, $hewgl.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $hewgl.replace)(value, /(image-set\([^]*)/, (0, $hewgl.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $hewgl.replace)((0, $hewgl.replace)(value, /(.+:)(flex-)?(.*)/, (0, $hewgl.WEBKIT) + 'box-pack:$3' + (0, $hewgl.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $hewgl.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $hewgl.replace)(value, /(.+)-inline(.+)/, (0, $hewgl.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $hewgl.strlen)(value) - 1 - length > 6) switch((0, $hewgl.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $hewgl.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $hewgl.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $hewgl.WEBKIT) + '$2-$3' + '$1' + (0, $hewgl.MOZ) + ((0, $hewgl.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $hewgl.indexof)(value, 'stretch') ? $6980a63c6d675c74$var$prefix((0, $hewgl.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $hewgl.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $hewgl.charat)(value, (0, $hewgl.strlen)(value) - 3 - (~(0, $hewgl.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $hewgl.replace)(value, ':', ':' + (0, $hewgl.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $hewgl.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $hewgl.WEBKIT) + ((0, $hewgl.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $hewgl.WEBKIT) + '$2$3' + '$1' + (0, $hewgl.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $hewgl.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + (0, $hewgl.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $hewgl.WEBKIT) + value + (0, $hewgl.MS) + value + value;
    }
    return value;
}
var $6980a63c6d675c74$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $hewgl.DECLARATION:
                element["return"] = $6980a63c6d675c74$var$prefix(element.value, element.length);
                break;
            case 0, $hewgl.KEYFRAMES:
                return (0, $hewgl.serialize)([
                    (0, $hewgl.copy)(element, {
                        value: (0, $hewgl.replace)(element.value, '@', '@' + (0, $hewgl.WEBKIT))
                    })
                ], callback);
            case 0, $hewgl.RULESET:
                if (element.length) return (0, $hewgl.combine)(element.props, function(value) {
                    switch((0, $hewgl.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $hewgl.serialize)([
                                (0, $hewgl.copy)(element, {
                                    props: [
                                        (0, $hewgl.replace)(value, /:(read-\w+)/, ':' + (0, $hewgl.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $hewgl.serialize)([
                                (0, $hewgl.copy)(element, {
                                    props: [
                                        (0, $hewgl.replace)(value, /:(plac\w+)/, ':' + (0, $hewgl.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $hewgl.copy)(element, {
                                    props: [
                                        (0, $hewgl.replace)(value, /:(plac\w+)/, ':' + (0, $hewgl.MOZ) + '$1')
                                    ]
                                }),
                                (0, $hewgl.copy)(element, {
                                    props: [
                                        (0, $hewgl.replace)(value, /:(plac\w+)/, (0, $hewgl.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $6980a63c6d675c74$var$getServerStylisCache = $6980a63c6d675c74$var$isBrowser ? undefined : (0, $iRS4s.default)(function() {
    return (0, $77plb.default)(function() {
        return {};
    });
});
var $6980a63c6d675c74$var$defaultStylisPlugins = [
    $6980a63c6d675c74$var$prefixer
];
var $6980a63c6d675c74$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($6980a63c6d675c74$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $6980a63c6d675c74$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($6980a63c6d675c74$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $6980a63c6d675c74$var$compat,
        $6980a63c6d675c74$var$removeLabel
    ];
    if (!$6980a63c6d675c74$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $hewgl.stringify),
            (0, $hewgl.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $hewgl.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $hewgl.serialize)((0, $hewgl.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $hewgl.stringify)
        ];
        var _serializer = (0, $hewgl.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $hewgl.serialize)((0, $hewgl.compile)(styles), _serializer);
        };
        var serverStylisCache = $6980a63c6d675c74$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $0zppd.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("0zppd", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $001b77a557d7f9bb$export$9d753cd7ae895cce; });
var $001b77a557d7f9bb$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $001b77a557d7f9bb$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $001b77a557d7f9bb$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $001b77a557d7f9bb$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$001b77a557d7f9bb$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($001b77a557d7f9bb$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $001b77a557d7f9bb$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("hewgl", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $50721cc01a756bf7$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $50721cc01a756bf7$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $50721cc01a756bf7$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $50721cc01a756bf7$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $50721cc01a756bf7$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $50721cc01a756bf7$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $50721cc01a756bf7$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $50721cc01a756bf7$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $50721cc01a756bf7$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $50721cc01a756bf7$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $50721cc01a756bf7$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $50721cc01a756bf7$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $50721cc01a756bf7$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $50721cc01a756bf7$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $50721cc01a756bf7$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $50721cc01a756bf7$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $50721cc01a756bf7$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $50721cc01a756bf7$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $50721cc01a756bf7$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $50721cc01a756bf7$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $50721cc01a756bf7$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $50721cc01a756bf7$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $50721cc01a756bf7$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $50721cc01a756bf7$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $50721cc01a756bf7$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $50721cc01a756bf7$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $50721cc01a756bf7$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $50721cc01a756bf7$export$38bcb760f1d4871c; });
var $50721cc01a756bf7$export$71ad59f2e432cfe8 = "-ms-";
var $50721cc01a756bf7$export$2c0f367103c8d01c = "-moz-";
var $50721cc01a756bf7$export$39dfd62a25e0fe93 = "-webkit-";
var $50721cc01a756bf7$export$a29989082612d0d9 = "comm";
var $50721cc01a756bf7$export$aa3a2e812ca8570d = "rule";
var $50721cc01a756bf7$export$527d108ccf083c2b = "decl";
var $50721cc01a756bf7$export$d3d35020fa5b54f0 = "@page";
var $50721cc01a756bf7$export$500415a86c544f73 = "@media";
var $50721cc01a756bf7$export$a763edbf796b780a = "@import";
var $50721cc01a756bf7$export$2790aeb8b4e5c826 = "@charset";
var $50721cc01a756bf7$export$1cc683e23b84b133 = "@viewport";
var $50721cc01a756bf7$export$9447a5efea57e862 = "@supports";
var $50721cc01a756bf7$export$ef011b4e114b1fba = "@document";
var $50721cc01a756bf7$export$6aad947bda0f3f46 = "@namespace";
var $50721cc01a756bf7$export$b44a8529a35fcb60 = "@keyframes";
var $50721cc01a756bf7$export$2c16de31893252e6 = "@font-face";
var $50721cc01a756bf7$export$3d846dd52e150c6f = "@counter-style";
var $50721cc01a756bf7$export$22314bfbb57653fe = "@font-feature-values";
var $50721cc01a756bf7$export$d773506282b3cfe6 = "@layer";
var $50721cc01a756bf7$export$2335f513bbd82c6d = Math.abs;
var $50721cc01a756bf7$export$6788812c4e6611e6 = String.fromCharCode;
var $50721cc01a756bf7$export$e6e34fd1f2686227 = Object.assign;
function $50721cc01a756bf7$export$d6af199866bfb566(e, r) {
    return $50721cc01a756bf7$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $50721cc01a756bf7$export$a9db5e087081082d(e, 0)) << 2 ^ $50721cc01a756bf7$export$a9db5e087081082d(e, 1)) << 2 ^ $50721cc01a756bf7$export$a9db5e087081082d(e, 2)) << 2 ^ $50721cc01a756bf7$export$a9db5e087081082d(e, 3) : 0;
}
function $50721cc01a756bf7$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $50721cc01a756bf7$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $50721cc01a756bf7$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $50721cc01a756bf7$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $50721cc01a756bf7$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $50721cc01a756bf7$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $50721cc01a756bf7$export$36776f635604f274(e) {
    return e.length;
}
function $50721cc01a756bf7$export$f9084667e487ed46(e) {
    return e.length;
}
function $50721cc01a756bf7$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $50721cc01a756bf7$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $50721cc01a756bf7$export$53f1d5ea8de3d7c = 1;
var $50721cc01a756bf7$export$4e0c71f277ca26b3 = 1;
var $50721cc01a756bf7$export$f24224f1c91d8156 = 0;
var $50721cc01a756bf7$export$5880b8b5730aff45 = 0;
var $50721cc01a756bf7$export$c0306caf338ac095 = 0;
var $50721cc01a756bf7$export$30a86d91af8ff6e6 = "";
function $50721cc01a756bf7$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $50721cc01a756bf7$export$53f1d5ea8de3d7c,
        column: $50721cc01a756bf7$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $50721cc01a756bf7$export$784d13d8ee351f07(e, r) {
    return $50721cc01a756bf7$export$e6e34fd1f2686227($50721cc01a756bf7$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $50721cc01a756bf7$export$eba6f6f03b0a92e7() {
    return $50721cc01a756bf7$export$c0306caf338ac095;
}
function $50721cc01a756bf7$export$232faf9add678146() {
    $50721cc01a756bf7$export$c0306caf338ac095 = $50721cc01a756bf7$export$5880b8b5730aff45 > 0 ? $50721cc01a756bf7$export$a9db5e087081082d($50721cc01a756bf7$export$30a86d91af8ff6e6, --$50721cc01a756bf7$export$5880b8b5730aff45) : 0;
    if ($50721cc01a756bf7$export$4e0c71f277ca26b3--, $50721cc01a756bf7$export$c0306caf338ac095 === 10) $50721cc01a756bf7$export$4e0c71f277ca26b3 = 1, $50721cc01a756bf7$export$53f1d5ea8de3d7c--;
    return $50721cc01a756bf7$export$c0306caf338ac095;
}
function $50721cc01a756bf7$export$48cfd1e771a65c4f() {
    $50721cc01a756bf7$export$c0306caf338ac095 = $50721cc01a756bf7$export$5880b8b5730aff45 < $50721cc01a756bf7$export$f24224f1c91d8156 ? $50721cc01a756bf7$export$a9db5e087081082d($50721cc01a756bf7$export$30a86d91af8ff6e6, $50721cc01a756bf7$export$5880b8b5730aff45++) : 0;
    if ($50721cc01a756bf7$export$4e0c71f277ca26b3++, $50721cc01a756bf7$export$c0306caf338ac095 === 10) $50721cc01a756bf7$export$4e0c71f277ca26b3 = 1, $50721cc01a756bf7$export$53f1d5ea8de3d7c++;
    return $50721cc01a756bf7$export$c0306caf338ac095;
}
function $50721cc01a756bf7$export$4d3fb11e950abb9e() {
    return $50721cc01a756bf7$export$a9db5e087081082d($50721cc01a756bf7$export$30a86d91af8ff6e6, $50721cc01a756bf7$export$5880b8b5730aff45);
}
function $50721cc01a756bf7$export$e88cb2efb12ae807() {
    return $50721cc01a756bf7$export$5880b8b5730aff45;
}
function $50721cc01a756bf7$export$58adb3bec8346d0f(e, r) {
    return $50721cc01a756bf7$export$2f35ab04d2335697($50721cc01a756bf7$export$30a86d91af8ff6e6, e, r);
}
function $50721cc01a756bf7$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $50721cc01a756bf7$export$2de70f21292aac9e(e) {
    return $50721cc01a756bf7$export$53f1d5ea8de3d7c = $50721cc01a756bf7$export$4e0c71f277ca26b3 = 1, $50721cc01a756bf7$export$f24224f1c91d8156 = $50721cc01a756bf7$export$36776f635604f274($50721cc01a756bf7$export$30a86d91af8ff6e6 = e), $50721cc01a756bf7$export$5880b8b5730aff45 = 0, [];
}
function $50721cc01a756bf7$export$45918ac1574455b1(e) {
    return $50721cc01a756bf7$export$30a86d91af8ff6e6 = "", e;
}
function $50721cc01a756bf7$export$410ac95b9ec204b8(e) {
    return $50721cc01a756bf7$export$87c2784dc9fc4ab($50721cc01a756bf7$export$58adb3bec8346d0f($50721cc01a756bf7$export$5880b8b5730aff45 - 1, $50721cc01a756bf7$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $50721cc01a756bf7$export$660b2ee2d4fb4eff(e) {
    return $50721cc01a756bf7$export$45918ac1574455b1($50721cc01a756bf7$export$5f8c09e3ae6f64e1($50721cc01a756bf7$export$2de70f21292aac9e(e)));
}
function $50721cc01a756bf7$export$7af1228ff777d175(e) {
    while($50721cc01a756bf7$export$c0306caf338ac095 = $50721cc01a756bf7$export$4d3fb11e950abb9e())if ($50721cc01a756bf7$export$c0306caf338ac095 < 33) $50721cc01a756bf7$export$48cfd1e771a65c4f();
    else break;
    return $50721cc01a756bf7$export$9e1725a4cfeada27(e) > 2 || $50721cc01a756bf7$export$9e1725a4cfeada27($50721cc01a756bf7$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $50721cc01a756bf7$export$5f8c09e3ae6f64e1(e) {
    while($50721cc01a756bf7$export$48cfd1e771a65c4f())switch($50721cc01a756bf7$export$9e1725a4cfeada27($50721cc01a756bf7$export$c0306caf338ac095)){
        case 0:
            $50721cc01a756bf7$export$10d8903dec122b9d($50721cc01a756bf7$export$c2ab62c7bf24634($50721cc01a756bf7$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $50721cc01a756bf7$export$10d8903dec122b9d($50721cc01a756bf7$export$410ac95b9ec204b8($50721cc01a756bf7$export$c0306caf338ac095), e);
            break;
        default:
            $50721cc01a756bf7$export$10d8903dec122b9d($50721cc01a756bf7$export$6788812c4e6611e6($50721cc01a756bf7$export$c0306caf338ac095), e);
    }
    return e;
}
function $50721cc01a756bf7$export$955ba06d119e085e(e, r) {
    while(--r && $50721cc01a756bf7$export$48cfd1e771a65c4f())if ($50721cc01a756bf7$export$c0306caf338ac095 < 48 || $50721cc01a756bf7$export$c0306caf338ac095 > 102 || $50721cc01a756bf7$export$c0306caf338ac095 > 57 && $50721cc01a756bf7$export$c0306caf338ac095 < 65 || $50721cc01a756bf7$export$c0306caf338ac095 > 70 && $50721cc01a756bf7$export$c0306caf338ac095 < 97) break;
    return $50721cc01a756bf7$export$58adb3bec8346d0f(e, $50721cc01a756bf7$export$e88cb2efb12ae807() + (r < 6 && $50721cc01a756bf7$export$4d3fb11e950abb9e() == 32 && $50721cc01a756bf7$export$48cfd1e771a65c4f() == 32));
}
function $50721cc01a756bf7$export$c889f2fcc19dbf12(e) {
    while($50721cc01a756bf7$export$48cfd1e771a65c4f())switch($50721cc01a756bf7$export$c0306caf338ac095){
        case e:
            return $50721cc01a756bf7$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $50721cc01a756bf7$export$c889f2fcc19dbf12($50721cc01a756bf7$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $50721cc01a756bf7$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $50721cc01a756bf7$export$48cfd1e771a65c4f();
            break;
    }
    return $50721cc01a756bf7$export$5880b8b5730aff45;
}
function $50721cc01a756bf7$export$4254d4e2b3745c4c(e, r) {
    while($50721cc01a756bf7$export$48cfd1e771a65c4f())if (e + $50721cc01a756bf7$export$c0306caf338ac095 === 57) break;
    else if (e + $50721cc01a756bf7$export$c0306caf338ac095 === 84 && $50721cc01a756bf7$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $50721cc01a756bf7$export$58adb3bec8346d0f(r, $50721cc01a756bf7$export$5880b8b5730aff45 - 1) + "*" + $50721cc01a756bf7$export$6788812c4e6611e6(e === 47 ? e : $50721cc01a756bf7$export$48cfd1e771a65c4f());
}
function $50721cc01a756bf7$export$c2ab62c7bf24634(e) {
    while(!$50721cc01a756bf7$export$9e1725a4cfeada27($50721cc01a756bf7$export$4d3fb11e950abb9e()))$50721cc01a756bf7$export$48cfd1e771a65c4f();
    return $50721cc01a756bf7$export$58adb3bec8346d0f(e, $50721cc01a756bf7$export$5880b8b5730aff45);
}
function $50721cc01a756bf7$export$ef7acd7185315e22(e) {
    return $50721cc01a756bf7$export$45918ac1574455b1($50721cc01a756bf7$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $50721cc01a756bf7$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $50721cc01a756bf7$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $50721cc01a756bf7$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $50721cc01a756bf7$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($50721cc01a756bf7$export$f8e21b1e77979a08(j += $50721cc01a756bf7$export$77ad94ebf1c2b9ed($50721cc01a756bf7$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $50721cc01a756bf7$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $50721cc01a756bf7$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $50721cc01a756bf7$export$955ba06d119e085e($50721cc01a756bf7$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($50721cc01a756bf7$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $50721cc01a756bf7$export$10d8903dec122b9d($50721cc01a756bf7$export$4a34f930e789283c($50721cc01a756bf7$export$4254d4e2b3745c4c($50721cc01a756bf7$export$48cfd1e771a65c4f(), $50721cc01a756bf7$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $50721cc01a756bf7$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $50721cc01a756bf7$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $50721cc01a756bf7$export$36776f635604f274(j) - l) $50721cc01a756bf7$export$10d8903dec122b9d(p > 32 ? $50721cc01a756bf7$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $50721cc01a756bf7$export$f8483753829ec8f3($50721cc01a756bf7$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $50721cc01a756bf7$export$10d8903dec122b9d(y = $50721cc01a756bf7$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $50721cc01a756bf7$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $50721cc01a756bf7$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $50721cc01a756bf7$export$98e6a39c04603d36(e, y, y, n && $50721cc01a756bf7$export$10d8903dec122b9d($50721cc01a756bf7$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $50721cc01a756bf7$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $50721cc01a756bf7$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $50721cc01a756bf7$export$232faf9add678146() == 125) continue;
            }
            switch(j += $50721cc01a756bf7$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($50721cc01a756bf7$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($50721cc01a756bf7$export$4d3fb11e950abb9e() === 45) j += $50721cc01a756bf7$export$410ac95b9ec204b8($50721cc01a756bf7$export$48cfd1e771a65c4f());
                    v = $50721cc01a756bf7$export$4d3fb11e950abb9e(), o = l = $50721cc01a756bf7$export$36776f635604f274(g = j += $50721cc01a756bf7$export$c2ab62c7bf24634($50721cc01a756bf7$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $50721cc01a756bf7$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $50721cc01a756bf7$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $50721cc01a756bf7$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $50721cc01a756bf7$export$2f35ab04d2335697(e, v + 1, v = $50721cc01a756bf7$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $50721cc01a756bf7$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $50721cc01a756bf7$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $50721cc01a756bf7$export$35059013cd4a06db(e, r, a, s === 0 ? $50721cc01a756bf7$export$aa3a2e812ca8570d : i, f, o, l);
}
function $50721cc01a756bf7$export$4a34f930e789283c(e, r, a) {
    return $50721cc01a756bf7$export$35059013cd4a06db(e, r, a, $50721cc01a756bf7$export$a29989082612d0d9, $50721cc01a756bf7$export$6788812c4e6611e6($50721cc01a756bf7$export$eba6f6f03b0a92e7()), $50721cc01a756bf7$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $50721cc01a756bf7$export$f8483753829ec8f3(e, r, a, n) {
    return $50721cc01a756bf7$export$35059013cd4a06db(e, r, a, $50721cc01a756bf7$export$527d108ccf083c2b, $50721cc01a756bf7$export$2f35ab04d2335697(e, 0, n), $50721cc01a756bf7$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $50721cc01a756bf7$export$82e9f45cca5ba907(n, c, s) {
    switch($50721cc01a756bf7$export$d6af199866bfb566(n, c)){
        case 5103:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $50721cc01a756bf7$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$2c0f367103c8d01c + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($50721cc01a756bf7$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "box-$1$2" + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "flex-item-" + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$50721cc01a756bf7$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $50721cc01a756bf7$export$71ad59f2e432cfe8 + "grid-row-" + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "flex-line-pack" + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + "box-" + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "-grow", "") + $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $50721cc01a756bf7$export$39dfd62a25e0fe93 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed($50721cc01a756bf7$export$77ad94ebf1c2b9ed($50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed($50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "box-pack:$3" + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $50721cc01a756bf7$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$50721cc01a756bf7$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $50721cc01a756bf7$export$71ad59f2e432cfe8 + "grid-column-align" + $50721cc01a756bf7$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $50721cc01a756bf7$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$50721cc01a756bf7$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$50721cc01a756bf7$export$f8e21b1e77979a08(s, "span") ? $50721cc01a756bf7$export$4659b591c19bdf3d(s, /\d+/) : +$50721cc01a756bf7$export$4659b591c19bdf3d(s, /\d+/) - +$50721cc01a756bf7$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $50721cc01a756bf7$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $50721cc01a756bf7$export$71ad59f2e432cfe8 + $50721cc01a756bf7$export$77ad94ebf1c2b9ed($50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($50721cc01a756bf7$export$36776f635604f274(n) - 1 - c > 6) switch($50721cc01a756bf7$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($50721cc01a756bf7$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $50721cc01a756bf7$export$2c0f367103c8d01c + ($50721cc01a756bf7$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$50721cc01a756bf7$export$f8e21b1e77979a08(n, "stretch") ? $50721cc01a756bf7$export$82e9f45cca5ba907($50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $50721cc01a756bf7$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $50721cc01a756bf7$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($50721cc01a756bf7$export$a9db5e087081082d(n, c + 6) === 121) return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, ":", ":" + $50721cc01a756bf7$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($50721cc01a756bf7$export$a9db5e087081082d(n, $50721cc01a756bf7$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $50721cc01a756bf7$export$39dfd62a25e0fe93 + ($50721cc01a756bf7$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $50721cc01a756bf7$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $50721cc01a756bf7$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, ":", ":" + $50721cc01a756bf7$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $50721cc01a756bf7$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $50721cc01a756bf7$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $50721cc01a756bf7$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $50721cc01a756bf7$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $50721cc01a756bf7$export$a763edbf796b780a:
        case $50721cc01a756bf7$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $50721cc01a756bf7$export$a29989082612d0d9:
            return "";
        case $50721cc01a756bf7$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $50721cc01a756bf7$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $50721cc01a756bf7$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $50721cc01a756bf7$export$36776f635604f274(a = $50721cc01a756bf7$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $50721cc01a756bf7$export$5a7767152ae0305f(e) {
    var r = $50721cc01a756bf7$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $50721cc01a756bf7$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $50721cc01a756bf7$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $50721cc01a756bf7$export$527d108ccf083c2b:
                n.return = $50721cc01a756bf7$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $50721cc01a756bf7$export$b44a8529a35fcb60:
                return $50721cc01a756bf7$export$dfdc1655ccc5b9cb([
                    $50721cc01a756bf7$export$784d13d8ee351f07(n, {
                        value: $50721cc01a756bf7$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $50721cc01a756bf7$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $50721cc01a756bf7$export$aa3a2e812ca8570d:
                if (n.length) return $50721cc01a756bf7$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($50721cc01a756bf7$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $50721cc01a756bf7$export$dfdc1655ccc5b9cb([
                                $50721cc01a756bf7$export$784d13d8ee351f07(n, {
                                    props: [
                                        $50721cc01a756bf7$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $50721cc01a756bf7$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $50721cc01a756bf7$export$dfdc1655ccc5b9cb([
                                $50721cc01a756bf7$export$784d13d8ee351f07(n, {
                                    props: [
                                        $50721cc01a756bf7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $50721cc01a756bf7$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $50721cc01a756bf7$export$784d13d8ee351f07(n, {
                                    props: [
                                        $50721cc01a756bf7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $50721cc01a756bf7$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $50721cc01a756bf7$export$784d13d8ee351f07(n, {
                                    props: [
                                        $50721cc01a756bf7$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $50721cc01a756bf7$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $50721cc01a756bf7$export$76a88f7de6507443(e) {
    switch(e.type){
        case $50721cc01a756bf7$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $50721cc01a756bf7$export$1be1fc439b849fdf($50721cc01a756bf7$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($50721cc01a756bf7$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $50721cc01a756bf7$export$2f35ab04d2335697(r, 1, $50721cc01a756bf7$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $50721cc01a756bf7$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $50721cc01a756bf7$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $50721cc01a756bf7$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iRS4s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbc71e978fdb61f0$export$2e2bcd8739ae039; });
var $dbc71e978fdb61f0$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("77plb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52ecd7f9078684a0$export$2e2bcd8739ae039; });
function $52ecd7f9078684a0$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("agcBp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01ed80b7f5a3ed4b$export$2e2bcd8739ae039; });

var $lvZzf = parcelRequire("lvZzf");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $01ed80b7f5a3ed4b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(targetComponent, sourceComponent);
};

});
parcelRegister("lvZzf", function(module, exports) {
'use strict';

var $jvIA0 = parcelRequire("jvIA0");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $fa9c4045700bf3db$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $fa9c4045700bf3db$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $fa9c4045700bf3db$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $fa9c4045700bf3db$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $fa9c4045700bf3db$var$TYPE_STATICS = {};
$fa9c4045700bf3db$var$TYPE_STATICS[$jvIA0.ForwardRef] = $fa9c4045700bf3db$var$FORWARD_REF_STATICS;
$fa9c4045700bf3db$var$TYPE_STATICS[$jvIA0.Memo] = $fa9c4045700bf3db$var$MEMO_STATICS;
function $fa9c4045700bf3db$var$getStatics(component) {
    // React v16.11 and below
    if ($jvIA0.isMemo(component)) return $fa9c4045700bf3db$var$MEMO_STATICS;
     // React v16.12 and above
    return $fa9c4045700bf3db$var$TYPE_STATICS[component['$$typeof']] || $fa9c4045700bf3db$var$REACT_STATICS;
}
var $fa9c4045700bf3db$var$defineProperty = Object.defineProperty;
var $fa9c4045700bf3db$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $fa9c4045700bf3db$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $fa9c4045700bf3db$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $fa9c4045700bf3db$var$getPrototypeOf = Object.getPrototypeOf;
var $fa9c4045700bf3db$var$objectPrototype = Object.prototype;
function $fa9c4045700bf3db$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($fa9c4045700bf3db$var$objectPrototype) {
            var inheritedComponent = $fa9c4045700bf3db$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $fa9c4045700bf3db$var$objectPrototype) $fa9c4045700bf3db$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $fa9c4045700bf3db$var$getOwnPropertyNames(sourceComponent);
        if ($fa9c4045700bf3db$var$getOwnPropertySymbols) keys = keys.concat($fa9c4045700bf3db$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $fa9c4045700bf3db$var$getStatics(targetComponent);
        var sourceStatics = $fa9c4045700bf3db$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$fa9c4045700bf3db$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $fa9c4045700bf3db$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $fa9c4045700bf3db$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $fa9c4045700bf3db$var$hoistNonReactStatics;

});
parcelRegister("jvIA0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("vzIz9"));

});



parcelRegister("9IQNN", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $71412e88598516e0$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $71412e88598516e0$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $71412e88598516e0$export$6f077d94b33a01aa; });
var $71412e88598516e0$var$isBrowser = typeof document !== 'undefined';
function $71412e88598516e0$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $71412e88598516e0$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $71412e88598516e0$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $71412e88598516e0$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $71412e88598516e0$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$71412e88598516e0$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$71412e88598516e0$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("hr4Ln", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $cb18a72537188880$export$6321afa313b251b5; });

var $dqcpG = parcelRequire("dqcpG");

var $fjyfN = parcelRequire("fjyfN");

var $77plb = parcelRequire("77plb");
var $cb18a72537188880$var$isDevelopment = false;
var $cb18a72537188880$var$hyphenateRegex = /[A-Z]|^ms/g;
var $cb18a72537188880$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $cb18a72537188880$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $cb18a72537188880$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $cb18a72537188880$var$processStyleName = /* #__PURE__ */ (0, $77plb.default)(function(styleName) {
    return $cb18a72537188880$var$isCustomProperty(styleName) ? styleName : styleName.replace($cb18a72537188880$var$hyphenateRegex, '-$&').toLowerCase();
});
var $cb18a72537188880$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($cb18a72537188880$var$animationRegex, function(match, p1, p2) {
                $cb18a72537188880$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $cb18a72537188880$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fjyfN.default)[key] !== 1 && !$cb18a72537188880$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $cb18a72537188880$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $cb18a72537188880$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $cb18a72537188880$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $cb18a72537188880$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $cb18a72537188880$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $cb18a72537188880$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $cb18a72537188880$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $cb18a72537188880$var$cursor;
                var result = interpolation(mergedProps);
                $cb18a72537188880$var$cursor = previousCursor;
                return $cb18a72537188880$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $cb18a72537188880$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $cb18a72537188880$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($cb18a72537188880$var$isProcessableValue(asString)) string += $cb18a72537188880$var$processStyleName(key) + ":" + $cb18a72537188880$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $cb18a72537188880$var$isDevelopment) throw new Error($cb18a72537188880$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($cb18a72537188880$var$isProcessableValue(value[_i])) string += $cb18a72537188880$var$processStyleName(key) + ":" + $cb18a72537188880$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $cb18a72537188880$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $cb18a72537188880$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $cb18a72537188880$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $cb18a72537188880$var$cursor;
function $cb18a72537188880$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $cb18a72537188880$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $cb18a72537188880$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $cb18a72537188880$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $cb18a72537188880$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $cb18a72537188880$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $dqcpG.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $cb18a72537188880$var$cursor
    };
}

});
parcelRegister("dqcpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c5755133d19a7ee$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $9c5755133d19a7ee$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("fjyfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2633379d6d61016$export$2e2bcd8739ae039; });
var $b2633379d6d61016$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("420Cf", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $2ef7d3a2496a138d$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $2ef7d3a2496a138d$export$811a713a7276cb9d; });

var $jSIPP = parcelRequire("jSIPP");
var $2ef7d3a2496a138d$var$isBrowser = typeof document !== 'undefined';
var $2ef7d3a2496a138d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $2ef7d3a2496a138d$var$useInsertionEffect = $jSIPP.useInsertionEffect ? $jSIPP.useInsertionEffect : false;
var $2ef7d3a2496a138d$export$db21c7ffa21794e7 = !$2ef7d3a2496a138d$var$isBrowser ? $2ef7d3a2496a138d$var$syncFallback : $2ef7d3a2496a138d$var$useInsertionEffect || $2ef7d3a2496a138d$var$syncFallback;
var $2ef7d3a2496a138d$export$811a713a7276cb9d = $2ef7d3a2496a138d$var$useInsertionEffect || $jSIPP.useLayoutEffect;

});



parcelRegister("hjPj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bc02624e13832e$export$2e2bcd8739ae039; });

var $77plb = parcelRequire("77plb");
// eslint-disable-next-line no-undef
var $c9bc02624e13832e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c9bc02624e13832e$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $77plb.default)(function(prop) {
    return $c9bc02624e13832e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("7Cxrh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58c6054bc48b3207$export$2e2bcd8739ae039; });

var $jSIPP = parcelRequire("jSIPP");


var $eNcJv = parcelRequire("eNcJv");

var $93Aqs = parcelRequire("93Aqs");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $58c6054bc48b3207$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $93Aqs.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $58c6054bc48b3207$var$cacheMap = new Map();
function $58c6054bc48b3207$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $jSIPP.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $58c6054bc48b3207$var$cacheMap.has(cacheKey)) return $58c6054bc48b3207$var$cacheMap.get(cacheKey);
        const fresh = $58c6054bc48b3207$var$getCache(injectFirst, enableCssLayer);
        $58c6054bc48b3207$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $eNcJv.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("4uaIU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3WzGF"));

});


parcelRegister("emEIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b2e1dcbe3b9074$export$2e2bcd8739ae039; });
parcelRequire("jSIPP");


var $lebkq = parcelRequire("lebkq");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $02b2e1dcbe3b9074$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $02b2e1dcbe3b9074$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($02b2e1dcbe3b9074$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $lebkq.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("7JymB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7ONYC")).default; });

var $7ONYC = parcelRequire("7ONYC");

});
parcelRegister("7ONYC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b13f840e0b08da6$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $5b13f840e0b08da6$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("lJggu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5dz9b")).default; });

var $5dz9b = parcelRequire("5dz9b");

});
parcelRegister("5dz9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cc96e22429bbd83$export$2e2bcd8739ae039; });
function $3cc96e22429bbd83$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3cc96e22429bbd83$export$2e2bcd8739ae039 = $3cc96e22429bbd83$var$clamp;

});


parcelRegister("eC0uE", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $aa34ff4511b78fef$export$2b8d127b894957b9; }, function (v) { return $aa34ff4511b78fef$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $aa34ff4511b78fef$export$cea3a54a6425200c; }, function (v) { return $aa34ff4511b78fef$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $aa34ff4511b78fef$export$a7c73072b1a182ae; }, function (v) { return $aa34ff4511b78fef$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $aa34ff4511b78fef$export$9f27bc3417b4524d; }, function (v) { return $aa34ff4511b78fef$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $aa34ff4511b78fef$export$db77ccec0bb4ccac; }, function (v) { return $aa34ff4511b78fef$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $aa34ff4511b78fef$export$8392c0c9d3dcbd35; }, function (v) { return $aa34ff4511b78fef$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $aa34ff4511b78fef$export$ffb0004e005737fa; }, function (v) { return $aa34ff4511b78fef$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $aa34ff4511b78fef$export$b624eff549462981; }, function (v) { return $aa34ff4511b78fef$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $aa34ff4511b78fef$export$7897aa7841a5380c; }, function (v) { return $aa34ff4511b78fef$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $aa34ff4511b78fef$export$602eac185826482c; }, function (v) { return $aa34ff4511b78fef$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $aa34ff4511b78fef$export$e2c29f18771995cb; }, function (v) { return $aa34ff4511b78fef$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $aa34ff4511b78fef$export$5f8d39834fd61797; }, function (v) { return $aa34ff4511b78fef$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $aa34ff4511b78fef$export$74bf444e3cd11ea5; }, function (v) { return $aa34ff4511b78fef$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $aa34ff4511b78fef$export$92387174baf9b227; }, function (v) { return $aa34ff4511b78fef$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $aa34ff4511b78fef$export$ec112efeb987d9c6; }, function (v) { return $aa34ff4511b78fef$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $aa34ff4511b78fef$export$b706b080d889d2c9; }, function (v) { return $aa34ff4511b78fef$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $aa34ff4511b78fef$export$5be5a87408f70ddc; }, function (v) { return $aa34ff4511b78fef$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $aa34ff4511b78fef$export$45a5e7f76e0caa8d; }, function (v) { return $aa34ff4511b78fef$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $aa34ff4511b78fef$export$455c2e768291efa6; }, function (v) { return $aa34ff4511b78fef$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $aa34ff4511b78fef$export$9522e17588c12572; }, function (v) { return $aa34ff4511b78fef$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $aa34ff4511b78fef$export$2110ac352bb060b9; }, function (v) { return $aa34ff4511b78fef$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $aa34ff4511b78fef$export$56885ab8b9c456ab; }, function (v) { return $aa34ff4511b78fef$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $aa34ff4511b78fef$export$d927fcb6adf8f9de; }, function (v) { return $aa34ff4511b78fef$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $aa34ff4511b78fef$export$b82d16f27459e05a; }, function (v) { return $aa34ff4511b78fef$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $aa34ff4511b78fef$export$522c17b4f5e123e8; }, function (v) { return $aa34ff4511b78fef$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $aa34ff4511b78fef$export$1aabd8a0274ecfd6; }, function (v) { return $aa34ff4511b78fef$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $aa34ff4511b78fef$export$9b621391a187a31a; }, function (v) { return $aa34ff4511b78fef$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $aa34ff4511b78fef$export$f5bbd400c2f4426f; }, function (v) { return $aa34ff4511b78fef$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa34ff4511b78fef$export$2b8d127b894957b9;
var $aa34ff4511b78fef$export$cea3a54a6425200c;
var $aa34ff4511b78fef$export$a7c73072b1a182ae;
var $aa34ff4511b78fef$export$9f27bc3417b4524d;
var $aa34ff4511b78fef$export$db77ccec0bb4ccac;
var $aa34ff4511b78fef$export$8392c0c9d3dcbd35;
var $aa34ff4511b78fef$export$ffb0004e005737fa;
var $aa34ff4511b78fef$export$b624eff549462981;
var $aa34ff4511b78fef$export$7897aa7841a5380c;
var $aa34ff4511b78fef$export$602eac185826482c;
var $aa34ff4511b78fef$export$e2c29f18771995cb;
var $aa34ff4511b78fef$export$5f8d39834fd61797;
var $aa34ff4511b78fef$export$74bf444e3cd11ea5;
var $aa34ff4511b78fef$export$92387174baf9b227;
var $aa34ff4511b78fef$export$ec112efeb987d9c6;
var $aa34ff4511b78fef$export$b706b080d889d2c9;
var $aa34ff4511b78fef$export$5be5a87408f70ddc;
var $aa34ff4511b78fef$export$45a5e7f76e0caa8d;
var $aa34ff4511b78fef$export$455c2e768291efa6;
var $aa34ff4511b78fef$export$9522e17588c12572;
var $aa34ff4511b78fef$export$2110ac352bb060b9;
var $aa34ff4511b78fef$export$56885ab8b9c456ab;
var $aa34ff4511b78fef$export$d927fcb6adf8f9de;
var $aa34ff4511b78fef$export$b82d16f27459e05a;
var $aa34ff4511b78fef$export$522c17b4f5e123e8;
var $aa34ff4511b78fef$export$1aabd8a0274ecfd6;
var $aa34ff4511b78fef$export$9b621391a187a31a;
var $aa34ff4511b78fef$export$f5bbd400c2f4426f;
'use strict';
var $aa34ff4511b78fef$var$b = "function" === typeof Symbol && Symbol.for, $aa34ff4511b78fef$var$c = $aa34ff4511b78fef$var$b ? Symbol.for("react.element") : 60103, $aa34ff4511b78fef$var$d = $aa34ff4511b78fef$var$b ? Symbol.for("react.portal") : 60106, $aa34ff4511b78fef$var$e = $aa34ff4511b78fef$var$b ? Symbol.for("react.fragment") : 60107, $aa34ff4511b78fef$var$f = $aa34ff4511b78fef$var$b ? Symbol.for("react.strict_mode") : 60108, $aa34ff4511b78fef$var$g = $aa34ff4511b78fef$var$b ? Symbol.for("react.profiler") : 60114, $aa34ff4511b78fef$var$h = $aa34ff4511b78fef$var$b ? Symbol.for("react.provider") : 60109, $aa34ff4511b78fef$var$k = $aa34ff4511b78fef$var$b ? Symbol.for("react.context") : 60110, $aa34ff4511b78fef$var$l = $aa34ff4511b78fef$var$b ? Symbol.for("react.async_mode") : 60111, $aa34ff4511b78fef$var$m = $aa34ff4511b78fef$var$b ? Symbol.for("react.concurrent_mode") : 60111, $aa34ff4511b78fef$var$n = $aa34ff4511b78fef$var$b ? Symbol.for("react.forward_ref") : 60112, $aa34ff4511b78fef$var$p = $aa34ff4511b78fef$var$b ? Symbol.for("react.suspense") : 60113, $aa34ff4511b78fef$var$q = $aa34ff4511b78fef$var$b ? Symbol.for("react.suspense_list") : 60120, $aa34ff4511b78fef$var$r = $aa34ff4511b78fef$var$b ? Symbol.for("react.memo") : 60115, $aa34ff4511b78fef$var$t = $aa34ff4511b78fef$var$b ? Symbol.for("react.lazy") : 60116, $aa34ff4511b78fef$var$v = $aa34ff4511b78fef$var$b ? Symbol.for("react.block") : 60121, $aa34ff4511b78fef$var$w = $aa34ff4511b78fef$var$b ? Symbol.for("react.fundamental") : 60117, $aa34ff4511b78fef$var$x = $aa34ff4511b78fef$var$b ? Symbol.for("react.responder") : 60118, $aa34ff4511b78fef$var$y = $aa34ff4511b78fef$var$b ? Symbol.for("react.scope") : 60119;
function $aa34ff4511b78fef$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $aa34ff4511b78fef$var$c:
                switch(a = a.type, a){
                    case $aa34ff4511b78fef$var$l:
                    case $aa34ff4511b78fef$var$m:
                    case $aa34ff4511b78fef$var$e:
                    case $aa34ff4511b78fef$var$g:
                    case $aa34ff4511b78fef$var$f:
                    case $aa34ff4511b78fef$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aa34ff4511b78fef$var$k:
                            case $aa34ff4511b78fef$var$n:
                            case $aa34ff4511b78fef$var$t:
                            case $aa34ff4511b78fef$var$r:
                            case $aa34ff4511b78fef$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $aa34ff4511b78fef$var$d:
                return u;
        }
    }
}
function $aa34ff4511b78fef$var$A(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$m;
}
$aa34ff4511b78fef$export$2b8d127b894957b9 = $aa34ff4511b78fef$var$l;
$aa34ff4511b78fef$export$cea3a54a6425200c = $aa34ff4511b78fef$var$m;
$aa34ff4511b78fef$export$a7c73072b1a182ae = $aa34ff4511b78fef$var$k;
$aa34ff4511b78fef$export$9f27bc3417b4524d = $aa34ff4511b78fef$var$h;
$aa34ff4511b78fef$export$db77ccec0bb4ccac = $aa34ff4511b78fef$var$c;
$aa34ff4511b78fef$export$8392c0c9d3dcbd35 = $aa34ff4511b78fef$var$n;
$aa34ff4511b78fef$export$ffb0004e005737fa = $aa34ff4511b78fef$var$e;
$aa34ff4511b78fef$export$b624eff549462981 = $aa34ff4511b78fef$var$t;
$aa34ff4511b78fef$export$7897aa7841a5380c = $aa34ff4511b78fef$var$r;
$aa34ff4511b78fef$export$602eac185826482c = $aa34ff4511b78fef$var$d;
$aa34ff4511b78fef$export$e2c29f18771995cb = $aa34ff4511b78fef$var$g;
$aa34ff4511b78fef$export$5f8d39834fd61797 = $aa34ff4511b78fef$var$f;
$aa34ff4511b78fef$export$74bf444e3cd11ea5 = $aa34ff4511b78fef$var$p;
$aa34ff4511b78fef$export$92387174baf9b227 = function(a) {
    return $aa34ff4511b78fef$var$A(a) || $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$l;
};
$aa34ff4511b78fef$export$ec112efeb987d9c6 = $aa34ff4511b78fef$var$A;
$aa34ff4511b78fef$export$b706b080d889d2c9 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$k;
};
$aa34ff4511b78fef$export$5be5a87408f70ddc = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$h;
};
$aa34ff4511b78fef$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aa34ff4511b78fef$var$c;
};
$aa34ff4511b78fef$export$455c2e768291efa6 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$n;
};
$aa34ff4511b78fef$export$9522e17588c12572 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$e;
};
$aa34ff4511b78fef$export$2110ac352bb060b9 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$t;
};
$aa34ff4511b78fef$export$56885ab8b9c456ab = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$r;
};
$aa34ff4511b78fef$export$d927fcb6adf8f9de = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$d;
};
$aa34ff4511b78fef$export$b82d16f27459e05a = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$g;
};
$aa34ff4511b78fef$export$522c17b4f5e123e8 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$f;
};
$aa34ff4511b78fef$export$1aabd8a0274ecfd6 = function(a) {
    return $aa34ff4511b78fef$var$z(a) === $aa34ff4511b78fef$var$p;
};
$aa34ff4511b78fef$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aa34ff4511b78fef$var$e || a === $aa34ff4511b78fef$var$m || a === $aa34ff4511b78fef$var$g || a === $aa34ff4511b78fef$var$f || a === $aa34ff4511b78fef$var$p || a === $aa34ff4511b78fef$var$q || "object" === typeof a && null !== a && (a.$$typeof === $aa34ff4511b78fef$var$t || a.$$typeof === $aa34ff4511b78fef$var$r || a.$$typeof === $aa34ff4511b78fef$var$h || a.$$typeof === $aa34ff4511b78fef$var$k || a.$$typeof === $aa34ff4511b78fef$var$n || a.$$typeof === $aa34ff4511b78fef$var$w || a.$$typeof === $aa34ff4511b78fef$var$x || a.$$typeof === $aa34ff4511b78fef$var$y || a.$$typeof === $aa34ff4511b78fef$var$v);
};
$aa34ff4511b78fef$export$f5bbd400c2f4426f = $aa34ff4511b78fef$var$z;

});

parcelRegister("6kSKS", function(module, exports) {
function $49cf15925e823422$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $49cf15925e823422$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("beDEc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("61i5U")).default; });

var $61i5U = parcelRequire("61i5U");

});
parcelRegister("61i5U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4620df3ea6ca5b73$export$2e2bcd8739ae039; });

var $7ONYC = parcelRequire("7ONYC");
function $4620df3ea6ca5b73$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $7ONYC.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("e2iNU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("69ZdV")).default; });

var $69ZdV = parcelRequire("69ZdV");
$parcel$exportWildcard(module.exports, $69ZdV);

});
parcelRegister("69ZdV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $47c3130db100db15$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $47c3130db100db15$export$2e2bcd8739ae039; });

var $gs9XW = parcelRequire("gs9XW");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $47c3130db100db15$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $47c3130db100db15$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($47c3130db100db15$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $47c3130db100db15$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $47c3130db100db15$export$aad197c7121a6651(Component) || fallback;
}
function $47c3130db100db15$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $47c3130db100db15$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $47c3130db100db15$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $47c3130db100db15$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $gs9XW.ForwardRef:
            return $47c3130db100db15$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $gs9XW.Memo:
            return $47c3130db100db15$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("gs9XW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jJMyZ"));

});
parcelRegister("jJMyZ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e5e7e3f35d72f9c0$export$a7c73072b1a182ae; }, function (v) { return $e5e7e3f35d72f9c0$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e5e7e3f35d72f9c0$export$9f27bc3417b4524d; }, function (v) { return $e5e7e3f35d72f9c0$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e5e7e3f35d72f9c0$export$db77ccec0bb4ccac; }, function (v) { return $e5e7e3f35d72f9c0$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e5e7e3f35d72f9c0$export$8392c0c9d3dcbd35; }, function (v) { return $e5e7e3f35d72f9c0$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e5e7e3f35d72f9c0$export$ffb0004e005737fa; }, function (v) { return $e5e7e3f35d72f9c0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e5e7e3f35d72f9c0$export$b624eff549462981; }, function (v) { return $e5e7e3f35d72f9c0$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e5e7e3f35d72f9c0$export$7897aa7841a5380c; }, function (v) { return $e5e7e3f35d72f9c0$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e5e7e3f35d72f9c0$export$602eac185826482c; }, function (v) { return $e5e7e3f35d72f9c0$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e5e7e3f35d72f9c0$export$e2c29f18771995cb; }, function (v) { return $e5e7e3f35d72f9c0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e5e7e3f35d72f9c0$export$5f8d39834fd61797; }, function (v) { return $e5e7e3f35d72f9c0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e5e7e3f35d72f9c0$export$74bf444e3cd11ea5; }, function (v) { return $e5e7e3f35d72f9c0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e5e7e3f35d72f9c0$export$998bcd577473dd93; }, function (v) { return $e5e7e3f35d72f9c0$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e5e7e3f35d72f9c0$export$b706b080d889d2c9; }, function (v) { return $e5e7e3f35d72f9c0$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e5e7e3f35d72f9c0$export$5be5a87408f70ddc; }, function (v) { return $e5e7e3f35d72f9c0$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e5e7e3f35d72f9c0$export$45a5e7f76e0caa8d; }, function (v) { return $e5e7e3f35d72f9c0$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e5e7e3f35d72f9c0$export$455c2e768291efa6; }, function (v) { return $e5e7e3f35d72f9c0$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e5e7e3f35d72f9c0$export$9522e17588c12572; }, function (v) { return $e5e7e3f35d72f9c0$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e5e7e3f35d72f9c0$export$2110ac352bb060b9; }, function (v) { return $e5e7e3f35d72f9c0$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e5e7e3f35d72f9c0$export$56885ab8b9c456ab; }, function (v) { return $e5e7e3f35d72f9c0$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e5e7e3f35d72f9c0$export$d927fcb6adf8f9de; }, function (v) { return $e5e7e3f35d72f9c0$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e5e7e3f35d72f9c0$export$b82d16f27459e05a; }, function (v) { return $e5e7e3f35d72f9c0$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e5e7e3f35d72f9c0$export$522c17b4f5e123e8; }, function (v) { return $e5e7e3f35d72f9c0$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e5e7e3f35d72f9c0$export$1aabd8a0274ecfd6; }, function (v) { return $e5e7e3f35d72f9c0$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e5e7e3f35d72f9c0$export$3d6c20d97e46b957; }, function (v) { return $e5e7e3f35d72f9c0$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e5e7e3f35d72f9c0$export$9b621391a187a31a; }, function (v) { return $e5e7e3f35d72f9c0$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e5e7e3f35d72f9c0$export$f5bbd400c2f4426f; }, function (v) { return $e5e7e3f35d72f9c0$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5e7e3f35d72f9c0$export$a7c73072b1a182ae;
var $e5e7e3f35d72f9c0$export$9f27bc3417b4524d;
var $e5e7e3f35d72f9c0$export$db77ccec0bb4ccac;
var $e5e7e3f35d72f9c0$export$8392c0c9d3dcbd35;
var $e5e7e3f35d72f9c0$export$ffb0004e005737fa;
var $e5e7e3f35d72f9c0$export$b624eff549462981;
var $e5e7e3f35d72f9c0$export$7897aa7841a5380c;
var $e5e7e3f35d72f9c0$export$602eac185826482c;
var $e5e7e3f35d72f9c0$export$e2c29f18771995cb;
var $e5e7e3f35d72f9c0$export$5f8d39834fd61797;
var $e5e7e3f35d72f9c0$export$74bf444e3cd11ea5;
var $e5e7e3f35d72f9c0$export$998bcd577473dd93;
var $e5e7e3f35d72f9c0$export$b706b080d889d2c9;
var $e5e7e3f35d72f9c0$export$5be5a87408f70ddc;
var $e5e7e3f35d72f9c0$export$45a5e7f76e0caa8d;
var $e5e7e3f35d72f9c0$export$455c2e768291efa6;
var $e5e7e3f35d72f9c0$export$9522e17588c12572;
var $e5e7e3f35d72f9c0$export$2110ac352bb060b9;
var $e5e7e3f35d72f9c0$export$56885ab8b9c456ab;
var $e5e7e3f35d72f9c0$export$d927fcb6adf8f9de;
var $e5e7e3f35d72f9c0$export$b82d16f27459e05a;
var $e5e7e3f35d72f9c0$export$522c17b4f5e123e8;
var $e5e7e3f35d72f9c0$export$1aabd8a0274ecfd6;
var $e5e7e3f35d72f9c0$export$3d6c20d97e46b957;
var $e5e7e3f35d72f9c0$export$9b621391a187a31a;
var $e5e7e3f35d72f9c0$export$f5bbd400c2f4426f;
"use strict";
var $e5e7e3f35d72f9c0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e5e7e3f35d72f9c0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e5e7e3f35d72f9c0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e5e7e3f35d72f9c0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e5e7e3f35d72f9c0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e5e7e3f35d72f9c0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e5e7e3f35d72f9c0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e5e7e3f35d72f9c0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e5e7e3f35d72f9c0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e5e7e3f35d72f9c0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e5e7e3f35d72f9c0$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $e5e7e3f35d72f9c0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e5e7e3f35d72f9c0$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $e5e7e3f35d72f9c0$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $e5e7e3f35d72f9c0$var$REACT_FRAGMENT_TYPE:
                    case $e5e7e3f35d72f9c0$var$REACT_PROFILER_TYPE:
                    case $e5e7e3f35d72f9c0$var$REACT_STRICT_MODE_TYPE:
                    case $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_TYPE:
                    case $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_LIST_TYPE:
                    case $e5e7e3f35d72f9c0$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $e5e7e3f35d72f9c0$var$REACT_CONTEXT_TYPE:
                            case $e5e7e3f35d72f9c0$var$REACT_FORWARD_REF_TYPE:
                            case $e5e7e3f35d72f9c0$var$REACT_LAZY_TYPE:
                            case $e5e7e3f35d72f9c0$var$REACT_MEMO_TYPE:
                                return object;
                            case $e5e7e3f35d72f9c0$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $e5e7e3f35d72f9c0$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$e5e7e3f35d72f9c0$export$a7c73072b1a182ae = $e5e7e3f35d72f9c0$var$REACT_CONSUMER_TYPE;
$e5e7e3f35d72f9c0$export$9f27bc3417b4524d = $e5e7e3f35d72f9c0$var$REACT_CONTEXT_TYPE;
$e5e7e3f35d72f9c0$export$db77ccec0bb4ccac = $e5e7e3f35d72f9c0$var$REACT_ELEMENT_TYPE;
$e5e7e3f35d72f9c0$export$8392c0c9d3dcbd35 = $e5e7e3f35d72f9c0$var$REACT_FORWARD_REF_TYPE;
$e5e7e3f35d72f9c0$export$ffb0004e005737fa = $e5e7e3f35d72f9c0$var$REACT_FRAGMENT_TYPE;
$e5e7e3f35d72f9c0$export$b624eff549462981 = $e5e7e3f35d72f9c0$var$REACT_LAZY_TYPE;
$e5e7e3f35d72f9c0$export$7897aa7841a5380c = $e5e7e3f35d72f9c0$var$REACT_MEMO_TYPE;
$e5e7e3f35d72f9c0$export$602eac185826482c = $e5e7e3f35d72f9c0$var$REACT_PORTAL_TYPE;
$e5e7e3f35d72f9c0$export$e2c29f18771995cb = $e5e7e3f35d72f9c0$var$REACT_PROFILER_TYPE;
$e5e7e3f35d72f9c0$export$5f8d39834fd61797 = $e5e7e3f35d72f9c0$var$REACT_STRICT_MODE_TYPE;
$e5e7e3f35d72f9c0$export$74bf444e3cd11ea5 = $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_TYPE;
$e5e7e3f35d72f9c0$export$998bcd577473dd93 = $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_LIST_TYPE;
$e5e7e3f35d72f9c0$export$b706b080d889d2c9 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_CONSUMER_TYPE;
};
$e5e7e3f35d72f9c0$export$5be5a87408f70ddc = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_CONTEXT_TYPE;
};
$e5e7e3f35d72f9c0$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e5e7e3f35d72f9c0$var$REACT_ELEMENT_TYPE;
};
$e5e7e3f35d72f9c0$export$455c2e768291efa6 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_FORWARD_REF_TYPE;
};
$e5e7e3f35d72f9c0$export$9522e17588c12572 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_FRAGMENT_TYPE;
};
$e5e7e3f35d72f9c0$export$2110ac352bb060b9 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_LAZY_TYPE;
};
$e5e7e3f35d72f9c0$export$56885ab8b9c456ab = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_MEMO_TYPE;
};
$e5e7e3f35d72f9c0$export$d927fcb6adf8f9de = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_PORTAL_TYPE;
};
$e5e7e3f35d72f9c0$export$b82d16f27459e05a = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_PROFILER_TYPE;
};
$e5e7e3f35d72f9c0$export$522c17b4f5e123e8 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_STRICT_MODE_TYPE;
};
$e5e7e3f35d72f9c0$export$1aabd8a0274ecfd6 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_TYPE;
};
$e5e7e3f35d72f9c0$export$3d6c20d97e46b957 = function(object) {
    return $e5e7e3f35d72f9c0$var$typeOf(object) === $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_LIST_TYPE;
};
$e5e7e3f35d72f9c0$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $e5e7e3f35d72f9c0$var$REACT_FRAGMENT_TYPE || type === $e5e7e3f35d72f9c0$var$REACT_PROFILER_TYPE || type === $e5e7e3f35d72f9c0$var$REACT_STRICT_MODE_TYPE || type === $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_TYPE || type === $e5e7e3f35d72f9c0$var$REACT_SUSPENSE_LIST_TYPE || type === $e5e7e3f35d72f9c0$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_LAZY_TYPE || type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_MEMO_TYPE || type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_CONTEXT_TYPE || type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_CONSUMER_TYPE || type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $e5e7e3f35d72f9c0$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$e5e7e3f35d72f9c0$export$f5bbd400c2f4426f = $e5e7e3f35d72f9c0$var$typeOf;

});




parcelRegister("qsHMF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gDcI8")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("1rMcC")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("8XPEN")).default; });

var $gDcI8 = parcelRequire("gDcI8");

var $1rMcC = parcelRequire("1rMcC");

var $8XPEN = parcelRequire("8XPEN");

});
parcelRegister("gDcI8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ba25fc2a0f3d31$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $2TupR = parcelRequire("2TupR");

var $1rMcC = parcelRequire("1rMcC");

var $ljOy9 = parcelRequire("ljOy9");

var $ckppX = parcelRequire("ckppX");

var $4bG06 = parcelRequire("4bG06");

var $eNwMf = parcelRequire("eNwMf");

var $8XPEN = parcelRequire("8XPEN");
const $c1ba25fc2a0f3d31$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $c1ba25fc2a0f3d31$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cMu4A.default)(options, $c1ba25fc2a0f3d31$var$_excluded);
    const breakpoints = (0, $1rMcC.default)(breakpointsInput);
    const spacing = (0, $ckppX.default)(spacingInput);
    let muiTheme = (0, $2TupR.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $erOpW.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $erOpW.default)({}, (0, $ljOy9.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $8XPEN.default);
    muiTheme = args.reduce((acc, argument)=>(0, $2TupR.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $erOpW.default)({}, (0, $eNwMf.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $4bG06.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $c1ba25fc2a0f3d31$export$2e2bcd8739ae039 = $c1ba25fc2a0f3d31$var$createTheme;

});
parcelRegister("cMu4A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e14b9af4ccf7d1$export$2e2bcd8739ae039; });
function $94e14b9af4ccf7d1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("2TupR", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $21b84fda3d55a443$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $21b84fda3d55a443$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");
function $21b84fda3d55a443$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $21b84fda3d55a443$var$deepClone(source) {
    if (/*#__PURE__*/ $jSIPP.isValidElement(source) || !$21b84fda3d55a443$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $21b84fda3d55a443$var$deepClone(source[key]);
    });
    return output;
}
function $21b84fda3d55a443$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $erOpW.default)({}, target) : target;
    if ($21b84fda3d55a443$export$53b83ca8eaab0383(target) && $21b84fda3d55a443$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $jSIPP.isValidElement(source[key])) output[key] = source[key];
        else if ($21b84fda3d55a443$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $21b84fda3d55a443$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $21b84fda3d55a443$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $21b84fda3d55a443$export$53b83ca8eaab0383(source[key]) ? $21b84fda3d55a443$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("1rMcC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ddb41611593d6f$export$2e2bcd8739ae039; });

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");
const $10ddb41611593d6f$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $10ddb41611593d6f$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $10ddb41611593d6f$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $erOpW.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $10ddb41611593d6f$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $cMu4A.default)(breakpoints, $10ddb41611593d6f$var$_excluded);
    const sortedValues = $10ddb41611593d6f$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $erOpW.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("ljOy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8529576924376d7$export$2e2bcd8739ae039; });
const $f8529576924376d7$var$shape = {
    borderRadius: 4
};
var $f8529576924376d7$export$2e2bcd8739ae039 = $f8529576924376d7$var$shape;

});

parcelRegister("ckppX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f9b11b815fe4c59$export$2e2bcd8739ae039; });

var $dO3gU = parcelRequire("dO3gU");
function $8f9b11b815fe4c59$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $dO3gU.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("dO3gU", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $a0d27b8ebabdc779$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $a0d27b8ebabdc779$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $a0d27b8ebabdc779$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $a0d27b8ebabdc779$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $a0d27b8ebabdc779$export$6f98e8eaf0be1996; });


var $668ih = parcelRequire("668ih");

var $5hf9L = parcelRequire("5hf9L");

var $cFrO7 = parcelRequire("cFrO7");

var $eW0Bk = parcelRequire("eW0Bk");
const $a0d27b8ebabdc779$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $a0d27b8ebabdc779$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $a0d27b8ebabdc779$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $a0d27b8ebabdc779$var$getCssProperties = (0, $eW0Bk.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($a0d27b8ebabdc779$var$aliases[prop]) prop = $a0d27b8ebabdc779$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $a0d27b8ebabdc779$var$properties[a];
    const direction = $a0d27b8ebabdc779$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $a0d27b8ebabdc779$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $a0d27b8ebabdc779$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $a0d27b8ebabdc779$var$spacingKeys = [
    ...$a0d27b8ebabdc779$export$aab52a0dde05ad8a,
    ...$a0d27b8ebabdc779$export$f8397d44f03ab6ad
];
function $a0d27b8ebabdc779$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $5hf9L.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $a0d27b8ebabdc779$export$1def6f833384e3d1(theme) {
    return $a0d27b8ebabdc779$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $a0d27b8ebabdc779$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $a0d27b8ebabdc779$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $a0d27b8ebabdc779$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $a0d27b8ebabdc779$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $a0d27b8ebabdc779$var$getCssProperties(prop);
    const styleFromPropValue = $a0d27b8ebabdc779$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $668ih.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $a0d27b8ebabdc779$var$style(props, keys) {
    const transformer = $a0d27b8ebabdc779$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$a0d27b8ebabdc779$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $cFrO7.default), {});
}
function $a0d27b8ebabdc779$export$7ede87f9b603dd3c(props) {
    return $a0d27b8ebabdc779$var$style(props, $a0d27b8ebabdc779$export$aab52a0dde05ad8a);
}
$a0d27b8ebabdc779$export$7ede87f9b603dd3c.propTypes = {};
$a0d27b8ebabdc779$export$7ede87f9b603dd3c.filterProps = $a0d27b8ebabdc779$export$aab52a0dde05ad8a;
function $a0d27b8ebabdc779$export$6f98e8eaf0be1996(props) {
    return $a0d27b8ebabdc779$var$style(props, $a0d27b8ebabdc779$export$f8397d44f03ab6ad);
}
$a0d27b8ebabdc779$export$6f98e8eaf0be1996.propTypes = {};
$a0d27b8ebabdc779$export$6f98e8eaf0be1996.filterProps = $a0d27b8ebabdc779$export$f8397d44f03ab6ad;
function $a0d27b8ebabdc779$var$spacing(props) {
    return $a0d27b8ebabdc779$var$style(props, $a0d27b8ebabdc779$var$spacingKeys);
}
$a0d27b8ebabdc779$var$spacing.propTypes = {};
$a0d27b8ebabdc779$var$spacing.filterProps = $a0d27b8ebabdc779$var$spacingKeys;
var $a0d27b8ebabdc779$export$2e2bcd8739ae039 = $a0d27b8ebabdc779$var$spacing;

});
parcelRegister("668ih", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $4709bc9953cb5705$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $4709bc9953cb5705$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $4709bc9953cb5705$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $4709bc9953cb5705$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $4709bc9953cb5705$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $4709bc9953cb5705$export$980e6a259d807490; });

var $erOpW = parcelRequire("erOpW");


var $2TupR = parcelRequire("2TupR");

var $cFrO7 = parcelRequire("cFrO7");
const $4709bc9953cb5705$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $4709bc9953cb5705$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$4709bc9953cb5705$export$68c286be0e7e55b7[key]}px)`
};
function $4709bc9953cb5705$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $4709bc9953cb5705$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $4709bc9953cb5705$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $4709bc9953cb5705$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $4709bc9953cb5705$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $4709bc9953cb5705$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $erOpW.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $cFrO7.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $4709bc9953cb5705$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $4709bc9953cb5705$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $4709bc9953cb5705$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $4709bc9953cb5705$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $2TupR.default)(prev, next), {});
    return $4709bc9953cb5705$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $4709bc9953cb5705$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $4709bc9953cb5705$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $4709bc9953cb5705$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $4709bc9953cb5705$export$2e2bcd8739ae039 = $4709bc9953cb5705$var$breakpoints;

});
parcelRegister("cFrO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $938ee254cc0b8cf3$export$2e2bcd8739ae039; });

var $2TupR = parcelRequire("2TupR");
function $938ee254cc0b8cf3$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $2TupR.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $938ee254cc0b8cf3$export$2e2bcd8739ae039 = $938ee254cc0b8cf3$var$merge;

});


parcelRegister("5hf9L", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $3d7a4c0881560501$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $3d7a4c0881560501$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $3d7a4c0881560501$export$2e2bcd8739ae039; });

var $61i5U = parcelRequire("61i5U");


var $668ih = parcelRequire("668ih");
function $3d7a4c0881560501$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $3d7a4c0881560501$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $3d7a4c0881560501$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $3d7a4c0881560501$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $3d7a4c0881560501$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $3d7a4c0881560501$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $3d7a4c0881560501$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $61i5U.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $668ih.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $3d7a4c0881560501$export$2e2bcd8739ae039 = $3d7a4c0881560501$var$style;

});

parcelRegister("eW0Bk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adf6f2d066e68f0f$export$2e2bcd8739ae039; });
function $adf6f2d066e68f0f$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("4bG06", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $30c8c4f663db5bd4$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $30c8c4f663db5bd4$export$2e2bcd8739ae039; });

var $61i5U = parcelRequire("61i5U");

var $cFrO7 = parcelRequire("cFrO7");

var $5hf9L = parcelRequire("5hf9L");

var $668ih = parcelRequire("668ih");

var $eNwMf = parcelRequire("eNwMf");
function $30c8c4f663db5bd4$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $30c8c4f663db5bd4$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $30c8c4f663db5bd4$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $5hf9L.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $5hf9L.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $5hf9L.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $61i5U.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $668ih.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $eNwMf.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $668ih.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $30c8c4f663db5bd4$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $cFrO7.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $668ih.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($30c8c4f663db5bd4$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $cFrO7.default)(css, breakpointsValues);
                        }
                    } else css = (0, $cFrO7.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $668ih.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $668ih.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $30c8c4f663db5bd4$var$styleFunctionSx = $30c8c4f663db5bd4$export$7d53d8bf2911e013();
$30c8c4f663db5bd4$var$styleFunctionSx.filterProps = [
    'sx'
];
var $30c8c4f663db5bd4$export$2e2bcd8739ae039 = $30c8c4f663db5bd4$var$styleFunctionSx;

});
parcelRegister("eNwMf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac5f112b269afc03$export$2e2bcd8739ae039; });

var $dO3gU = parcelRequire("dO3gU");

var $lEV49 = parcelRequire("lEV49");

var $6nbvW = parcelRequire("6nbvW");

var $9pTDM = parcelRequire("9pTDM");

var $eBML6 = parcelRequire("eBML6");
const $ac5f112b269afc03$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $lEV49.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $lEV49.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $9pTDM.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $9pTDM.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $9pTDM.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $dO3gU.padding)
    },
    pt: {
        style: (0, $dO3gU.padding)
    },
    pr: {
        style: (0, $dO3gU.padding)
    },
    pb: {
        style: (0, $dO3gU.padding)
    },
    pl: {
        style: (0, $dO3gU.padding)
    },
    px: {
        style: (0, $dO3gU.padding)
    },
    py: {
        style: (0, $dO3gU.padding)
    },
    padding: {
        style: (0, $dO3gU.padding)
    },
    paddingTop: {
        style: (0, $dO3gU.padding)
    },
    paddingRight: {
        style: (0, $dO3gU.padding)
    },
    paddingBottom: {
        style: (0, $dO3gU.padding)
    },
    paddingLeft: {
        style: (0, $dO3gU.padding)
    },
    paddingX: {
        style: (0, $dO3gU.padding)
    },
    paddingY: {
        style: (0, $dO3gU.padding)
    },
    paddingInline: {
        style: (0, $dO3gU.padding)
    },
    paddingInlineStart: {
        style: (0, $dO3gU.padding)
    },
    paddingInlineEnd: {
        style: (0, $dO3gU.padding)
    },
    paddingBlock: {
        style: (0, $dO3gU.padding)
    },
    paddingBlockStart: {
        style: (0, $dO3gU.padding)
    },
    paddingBlockEnd: {
        style: (0, $dO3gU.padding)
    },
    m: {
        style: (0, $dO3gU.margin)
    },
    mt: {
        style: (0, $dO3gU.margin)
    },
    mr: {
        style: (0, $dO3gU.margin)
    },
    mb: {
        style: (0, $dO3gU.margin)
    },
    ml: {
        style: (0, $dO3gU.margin)
    },
    mx: {
        style: (0, $dO3gU.margin)
    },
    my: {
        style: (0, $dO3gU.margin)
    },
    margin: {
        style: (0, $dO3gU.margin)
    },
    marginTop: {
        style: (0, $dO3gU.margin)
    },
    marginRight: {
        style: (0, $dO3gU.margin)
    },
    marginBottom: {
        style: (0, $dO3gU.margin)
    },
    marginLeft: {
        style: (0, $dO3gU.margin)
    },
    marginX: {
        style: (0, $dO3gU.margin)
    },
    marginY: {
        style: (0, $dO3gU.margin)
    },
    marginInline: {
        style: (0, $dO3gU.margin)
    },
    marginInlineStart: {
        style: (0, $dO3gU.margin)
    },
    marginInlineEnd: {
        style: (0, $dO3gU.margin)
    },
    marginBlock: {
        style: (0, $dO3gU.margin)
    },
    marginBlockStart: {
        style: (0, $dO3gU.margin)
    },
    marginBlockEnd: {
        style: (0, $dO3gU.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $6nbvW.gap)
    },
    rowGap: {
        style: (0, $6nbvW.rowGap)
    },
    columnGap: {
        style: (0, $6nbvW.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $eBML6.sizingTransform)
    },
    maxWidth: {
        style: (0, $eBML6.maxWidth)
    },
    minWidth: {
        transform: (0, $eBML6.sizingTransform)
    },
    height: {
        transform: (0, $eBML6.sizingTransform)
    },
    maxHeight: {
        transform: (0, $eBML6.sizingTransform)
    },
    minHeight: {
        transform: (0, $eBML6.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $ac5f112b269afc03$export$2e2bcd8739ae039 = $ac5f112b269afc03$var$defaultSxConfig;

});
parcelRegister("lEV49", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $fc499980f758e1a7$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $fc499980f758e1a7$export$7a57f79000377ca2; });


var $5hf9L = parcelRequire("5hf9L");

var $6f8yd = parcelRequire("6f8yd");

var $dO3gU = parcelRequire("dO3gU");

var $668ih = parcelRequire("668ih");
function $fc499980f758e1a7$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $fc499980f758e1a7$var$createBorderStyle(prop, transform) {
    return (0, $5hf9L.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $fc499980f758e1a7$export$1edee58a52776cd9 = $fc499980f758e1a7$var$createBorderStyle('border', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$f9a7b6bd24892946 = $fc499980f758e1a7$var$createBorderStyle('borderTop', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$5abca33e6be905d2 = $fc499980f758e1a7$var$createBorderStyle('borderRight', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$e2ce9f12a980a822 = $fc499980f758e1a7$var$createBorderStyle('borderBottom', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$47658cca1a909427 = $fc499980f758e1a7$var$createBorderStyle('borderLeft', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$e7fb0694ba2404fc = $fc499980f758e1a7$var$createBorderStyle('borderColor');
const $fc499980f758e1a7$export$126a92c968acdb85 = $fc499980f758e1a7$var$createBorderStyle('borderTopColor');
const $fc499980f758e1a7$export$85cc51cb8fbb8c0e = $fc499980f758e1a7$var$createBorderStyle('borderRightColor');
const $fc499980f758e1a7$export$340b0327727f6d1a = $fc499980f758e1a7$var$createBorderStyle('borderBottomColor');
const $fc499980f758e1a7$export$60beef91a985b4bf = $fc499980f758e1a7$var$createBorderStyle('borderLeftColor');
const $fc499980f758e1a7$export$f9258c55612cbed7 = $fc499980f758e1a7$var$createBorderStyle('outline', $fc499980f758e1a7$export$34e2febe53ae29cc);
const $fc499980f758e1a7$export$621fe586efeb64b9 = $fc499980f758e1a7$var$createBorderStyle('outlineColor');
const $fc499980f758e1a7$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $dO3gU.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $dO3gU.getValue)(transformer, propValue)
            });
        return (0, $668ih.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$fc499980f758e1a7$export$7a57f79000377ca2.propTypes = {};
$fc499980f758e1a7$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $fc499980f758e1a7$var$borders = (0, $6f8yd.default)($fc499980f758e1a7$export$1edee58a52776cd9, $fc499980f758e1a7$export$f9a7b6bd24892946, $fc499980f758e1a7$export$5abca33e6be905d2, $fc499980f758e1a7$export$e2ce9f12a980a822, $fc499980f758e1a7$export$47658cca1a909427, $fc499980f758e1a7$export$e7fb0694ba2404fc, $fc499980f758e1a7$export$126a92c968acdb85, $fc499980f758e1a7$export$85cc51cb8fbb8c0e, $fc499980f758e1a7$export$340b0327727f6d1a, $fc499980f758e1a7$export$60beef91a985b4bf, $fc499980f758e1a7$export$7a57f79000377ca2, $fc499980f758e1a7$export$f9258c55612cbed7, $fc499980f758e1a7$export$621fe586efeb64b9);
var $fc499980f758e1a7$export$2e2bcd8739ae039 = $fc499980f758e1a7$var$borders;

});
parcelRegister("6f8yd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48bac6cb8cf8664c$export$2e2bcd8739ae039; });

var $cFrO7 = parcelRequire("cFrO7");
function $48bac6cb8cf8664c$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $cFrO7.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $48bac6cb8cf8664c$export$2e2bcd8739ae039 = $48bac6cb8cf8664c$var$compose;

});


parcelRegister("6nbvW", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $4a3dd28adb76f634$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $4a3dd28adb76f634$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $4a3dd28adb76f634$export$8a833ffa5f5dbeda; });

var $5hf9L = parcelRequire("5hf9L");

var $6f8yd = parcelRequire("6f8yd");

var $dO3gU = parcelRequire("dO3gU");

var $668ih = parcelRequire("668ih");

const $4a3dd28adb76f634$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $dO3gU.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $dO3gU.getValue)(transformer, propValue)
            });
        return (0, $668ih.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$4a3dd28adb76f634$export$5df9adcb0db95e1e.propTypes = {};
$4a3dd28adb76f634$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $4a3dd28adb76f634$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $dO3gU.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $dO3gU.getValue)(transformer, propValue)
            });
        return (0, $668ih.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$4a3dd28adb76f634$export$ec60d70ff941a580.propTypes = {};
$4a3dd28adb76f634$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $4a3dd28adb76f634$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $dO3gU.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $dO3gU.getValue)(transformer, propValue)
            });
        return (0, $668ih.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$4a3dd28adb76f634$export$8a833ffa5f5dbeda.propTypes = {};
$4a3dd28adb76f634$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $4a3dd28adb76f634$export$baf44164ca3a34e8 = (0, $5hf9L.default)({
    prop: 'gridColumn'
});
const $4a3dd28adb76f634$export$8f7213a1cd01e832 = (0, $5hf9L.default)({
    prop: 'gridRow'
});
const $4a3dd28adb76f634$export$b0e0abbc49ba668 = (0, $5hf9L.default)({
    prop: 'gridAutoFlow'
});
const $4a3dd28adb76f634$export$bcd8b929d4b4142 = (0, $5hf9L.default)({
    prop: 'gridAutoColumns'
});
const $4a3dd28adb76f634$export$e5039a674e14c828 = (0, $5hf9L.default)({
    prop: 'gridAutoRows'
});
const $4a3dd28adb76f634$export$42bd9088661ffb03 = (0, $5hf9L.default)({
    prop: 'gridTemplateColumns'
});
const $4a3dd28adb76f634$export$920682ae05b999bc = (0, $5hf9L.default)({
    prop: 'gridTemplateRows'
});
const $4a3dd28adb76f634$export$1b88fbdd482fd33a = (0, $5hf9L.default)({
    prop: 'gridTemplateAreas'
});
const $4a3dd28adb76f634$export$bdb486e40d52d26f = (0, $5hf9L.default)({
    prop: 'gridArea'
});
const $4a3dd28adb76f634$var$grid = (0, $6f8yd.default)($4a3dd28adb76f634$export$5df9adcb0db95e1e, $4a3dd28adb76f634$export$ec60d70ff941a580, $4a3dd28adb76f634$export$8a833ffa5f5dbeda, $4a3dd28adb76f634$export$baf44164ca3a34e8, $4a3dd28adb76f634$export$8f7213a1cd01e832, $4a3dd28adb76f634$export$b0e0abbc49ba668, $4a3dd28adb76f634$export$bcd8b929d4b4142, $4a3dd28adb76f634$export$e5039a674e14c828, $4a3dd28adb76f634$export$42bd9088661ffb03, $4a3dd28adb76f634$export$920682ae05b999bc, $4a3dd28adb76f634$export$1b88fbdd482fd33a, $4a3dd28adb76f634$export$bdb486e40d52d26f);
var $4a3dd28adb76f634$export$2e2bcd8739ae039 = $4a3dd28adb76f634$var$grid;

});

parcelRegister("9pTDM", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $6db19be5ceb2b58c$export$dbaffd4420ea0ac6; });

var $5hf9L = parcelRequire("5hf9L");

var $6f8yd = parcelRequire("6f8yd");
function $6db19be5ceb2b58c$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $6db19be5ceb2b58c$export$35e9368ef982300f = (0, $5hf9L.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $6db19be5ceb2b58c$export$dbaffd4420ea0ac6
});
const $6db19be5ceb2b58c$export$2506f56c10355b33 = (0, $5hf9L.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $6db19be5ceb2b58c$export$dbaffd4420ea0ac6
});
const $6db19be5ceb2b58c$export$8c5a050822fd698c = (0, $5hf9L.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $6db19be5ceb2b58c$export$dbaffd4420ea0ac6
});
const $6db19be5ceb2b58c$var$palette = (0, $6f8yd.default)($6db19be5ceb2b58c$export$35e9368ef982300f, $6db19be5ceb2b58c$export$2506f56c10355b33, $6db19be5ceb2b58c$export$8c5a050822fd698c);
var $6db19be5ceb2b58c$export$2e2bcd8739ae039 = $6db19be5ceb2b58c$var$palette;

});

parcelRegister("eBML6", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $aa2a57ddba39cf5d$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $aa2a57ddba39cf5d$export$488fda99655ff65a; });

var $5hf9L = parcelRequire("5hf9L");

var $6f8yd = parcelRequire("6f8yd");

var $668ih = parcelRequire("668ih");
function $aa2a57ddba39cf5d$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $aa2a57ddba39cf5d$export$7e3df82ee760448c = (0, $5hf9L.default)({
    prop: 'width',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $668ih.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $aa2a57ddba39cf5d$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $668ih.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$aa2a57ddba39cf5d$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $aa2a57ddba39cf5d$export$ee148fbbe8357dd2 = (0, $5hf9L.default)({
    prop: 'minWidth',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$ac607276a8fe9f0a = (0, $5hf9L.default)({
    prop: 'height',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$dc0d8bd0b94f8570 = (0, $5hf9L.default)({
    prop: 'maxHeight',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$a43cf604e12f3b17 = (0, $5hf9L.default)({
    prop: 'minHeight',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$ffed9f14fb65e276 = (0, $5hf9L.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$905076ed6620e671 = (0, $5hf9L.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $aa2a57ddba39cf5d$export$8afece71750ec241
});
const $aa2a57ddba39cf5d$export$6ccc93f785106a58 = (0, $5hf9L.default)({
    prop: 'boxSizing'
});
const $aa2a57ddba39cf5d$var$sizing = (0, $6f8yd.default)($aa2a57ddba39cf5d$export$7e3df82ee760448c, $aa2a57ddba39cf5d$export$488fda99655ff65a, $aa2a57ddba39cf5d$export$ee148fbbe8357dd2, $aa2a57ddba39cf5d$export$ac607276a8fe9f0a, $aa2a57ddba39cf5d$export$dc0d8bd0b94f8570, $aa2a57ddba39cf5d$export$a43cf604e12f3b17, $aa2a57ddba39cf5d$export$6ccc93f785106a58);
var $aa2a57ddba39cf5d$export$2e2bcd8739ae039 = $aa2a57ddba39cf5d$var$sizing;

});



parcelRegister("8XPEN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $686be76dbf1bc1d4$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $686be76dbf1bc1d4$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("13B2F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4bG06")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("4bG06")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("4IZqw")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("eNwMf")).default; });

var $4bG06 = parcelRequire("4bG06");

var $4IZqw = parcelRequire("4IZqw");

var $eNwMf = parcelRequire("eNwMf");

});
parcelRegister("4IZqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $370aeb8cc53f2670$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $2TupR = parcelRequire("2TupR");

var $eNwMf = parcelRequire("eNwMf");
const $370aeb8cc53f2670$var$_excluded = [
    "sx"
];
const $370aeb8cc53f2670$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $eNwMf.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $370aeb8cc53f2670$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cMu4A.default)(props, $370aeb8cc53f2670$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $370aeb8cc53f2670$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $2TupR.isPlainObject)(result)) return systemProps;
        return (0, $erOpW.default)({}, systemProps, result);
    };
    else finalSx = (0, $erOpW.default)({}, systemProps, inSx);
    return (0, $erOpW.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("eB22U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.heightWidthRadiusDefaults = module.exports.heightWidthDefaults = module.exports.sizeMarginDefaults = module.exports.sizeDefaults = void 0;
/*
 * DefaultProps object for different loaders
 */ var $aa061bace7aabbeb$var$commonValues = {
    loading: true,
    color: "#000000",
    css: "",
    speedMultiplier: 1
};
function $aa061bace7aabbeb$var$sizeDefaults(sizeValue) {
    return Object.assign({}, $aa061bace7aabbeb$var$commonValues, {
        size: sizeValue
    });
}
module.exports.sizeDefaults = $aa061bace7aabbeb$var$sizeDefaults;
function $aa061bace7aabbeb$var$sizeMarginDefaults(sizeValue) {
    return Object.assign({}, $aa061bace7aabbeb$var$sizeDefaults(sizeValue), {
        margin: 2
    });
}
module.exports.sizeMarginDefaults = $aa061bace7aabbeb$var$sizeMarginDefaults;
function $aa061bace7aabbeb$var$heightWidthDefaults(height, width) {
    return Object.assign({}, $aa061bace7aabbeb$var$commonValues, {
        height: height,
        width: width
    });
}
module.exports.heightWidthDefaults = $aa061bace7aabbeb$var$heightWidthDefaults;
function $aa061bace7aabbeb$var$heightWidthRadiusDefaults(height, width, radius) {
    if (radius === void 0) radius = 2;
    return Object.assign({}, $aa061bace7aabbeb$var$heightWidthDefaults(height, width), {
        radius: radius,
        margin: 2
    });
}
module.exports.heightWidthRadiusDefaults = $aa061bace7aabbeb$var$heightWidthRadiusDefaults;

});

parcelRegister("5Ulum", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateRgba = void 0;
var $44d2d9e711f14a02$var$BasicColors;
(function(BasicColors) {
    BasicColors["maroon"] = "#800000";
    BasicColors["red"] = "#FF0000";
    BasicColors["orange"] = "#FFA500";
    BasicColors["yellow"] = "#FFFF00";
    BasicColors["olive"] = "#808000";
    BasicColors["green"] = "#008000";
    BasicColors["purple"] = "#800080";
    BasicColors["fuchsia"] = "#FF00FF";
    BasicColors["lime"] = "#00FF00";
    BasicColors["teal"] = "#008080";
    BasicColors["aqua"] = "#00FFFF";
    BasicColors["blue"] = "#0000FF";
    BasicColors["navy"] = "#000080";
    BasicColors["black"] = "#000000";
    BasicColors["gray"] = "#808080";
    BasicColors["silver"] = "#C0C0C0";
    BasicColors["white"] = "#FFFFFF";
})($44d2d9e711f14a02$var$BasicColors || ($44d2d9e711f14a02$var$BasicColors = {}));
var $44d2d9e711f14a02$var$calculateRgba = function(color, opacity) {
    if (Object.keys($44d2d9e711f14a02$var$BasicColors).includes(color)) color = $44d2d9e711f14a02$var$BasicColors[color];
    if (color[0] === "#") color = color.slice(1);
    if (color.length === 3) {
        var res_1 = "";
        color.split("").forEach(function(c) {
            res_1 += c;
            res_1 += c;
        });
        color = res_1;
    }
    var rgbValues = (color.match(/.{2}/g) || []).map(function(hex) {
        return parseInt(hex, 16);
    }).join(", ");
    return "rgba(" + rgbValues + ", " + opacity + ")";
};
module.exports.calculateRgba = $44d2d9e711f14a02$var$calculateRgba;

});

parcelRegister("eQnTi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cssValue = module.exports.parseLengthAndUnit = void 0;
var $ace8744470ece337$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */ function $ace8744470ece337$var$parseLengthAndUnit(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($ace8744470ece337$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: " + size + " is not a valid css value. Defaulting to " + value + "px.");
    return {
        value: value,
        unit: "px"
    };
}
module.exports.parseLengthAndUnit = $ace8744470ece337$var$parseLengthAndUnit;
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */ function $ace8744470ece337$var$cssValue(value) {
    var lengthWithunit = $ace8744470ece337$var$parseLengthAndUnit(value);
    return "" + lengthWithunit.value + lengthWithunit.unit;
}
module.exports.cssValue = $ace8744470ece337$var$cssValue;

});

parcelRegister("ghfJh", function(module, exports) {

$parcel$export(module.exports, "Formik", function () { return Formik; });

var $cHP6Z = parcelRequire("cHP6Z");

var $1Gi2c = parcelRequire("1Gi2c");

var $2L2lK = parcelRequire("2L2lK");

var $jSIPP = parcelRequire("jSIPP");

var $k5fqp = parcelRequire("k5fqp");

var $i2vOQ = parcelRequire("i2vOQ");

var $aS22v = parcelRequire("aS22v");

var $l8KrO = parcelRequire("l8KrO");

var $lvZzf = parcelRequire("lvZzf");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $jSIPP.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $jSIPP.useContext)(FormikContext);
    !!!formik && (0, $i2vOQ.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $jSIPP.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $l8KrO.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $aS22v.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $l8KrO.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $aS22v.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $jSIPP.useRef)(props.initialValues);
    var initialErrors = (0, $jSIPP.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $jSIPP.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $jSIPP.useRef)(props.initialStatus);
    var isMounted = (0, $jSIPP.useRef)(false);
    var fieldRegistry = (0, $jSIPP.useRef)({});
    (0, $jSIPP.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $jSIPP.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $jSIPP.useRef)({
        values: (0, $2L2lK.default)(props.initialValues),
        errors: (0, $2L2lK.default)(props.initialErrors) || emptyErrors,
        touched: (0, $2L2lK.default)(props.initialTouched) || emptyTouched,
        status: (0, $2L2lK.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $jSIPP.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $jSIPP.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $jSIPP.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $jSIPP.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $jSIPP.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $jSIPP.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cHP6Z.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $jSIPP.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $jSIPP.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $jSIPP.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $jSIPP.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $jSIPP.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $jSIPP.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $jSIPP.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $jSIPP.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $jSIPP.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $jSIPP.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $jSIPP.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $jSIPP.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $jSIPP.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $jSIPP.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $jSIPP.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $jSIPP.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $jSIPP.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $jSIPP.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $jSIPP.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $jSIPP.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $jSIPP.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $jSIPP.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $jSIPP.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $jSIPP.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $1Gi2c.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $1Gi2c.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cHP6Z.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cHP6Z.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $jSIPP.useLayoutEffect) : (0, $jSIPP.useEffect);
function useEventCallback(fn) {
    var ref = (0, $jSIPP.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $jSIPP.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $jSIPP.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $i2vOQ.default)(false);
    var fieldHelpers = (0, $jSIPP.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $jSIPP.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $jSIPP.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $jSIPP.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $jSIPP.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $jSIPP.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $jSIPP.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $jSIPP.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $jSIPP.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $jSIPP.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $jSIPP.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $jSIPP.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $i2vOQ.default)(false);
            return (0, $jSIPP.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $2L2lK.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($k5fqp)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $jSIPP.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $jSIPP.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $jSIPP.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $jSIPP.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $jSIPP.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $i2vOQ.default)(false);
        !!(component && render) && (0, $i2vOQ.default)(false);
        !!(is && children && isFunction(children)) && (0, $i2vOQ.default)(false);
        !!(component && children && isFunction(children)) && (0, $i2vOQ.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $i2vOQ.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $jSIPP.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $jSIPP.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $jSIPP.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $jSIPP.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $jSIPP.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cHP6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $940125e7197bfed1$export$2e2bcd8739ae039; });
var $940125e7197bfed1$var$isMergeableObject = function isMergeableObject(value) {
    return $940125e7197bfed1$var$isNonNullObject(value) && !$940125e7197bfed1$var$isSpecial(value);
};
function $940125e7197bfed1$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $940125e7197bfed1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $940125e7197bfed1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $940125e7197bfed1$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $940125e7197bfed1$var$REACT_ELEMENT_TYPE = $940125e7197bfed1$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $940125e7197bfed1$var$isReactElement(value) {
    return value.$$typeof === $940125e7197bfed1$var$REACT_ELEMENT_TYPE;
}
function $940125e7197bfed1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $940125e7197bfed1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $940125e7197bfed1$var$deepmerge($940125e7197bfed1$var$emptyTarget(value), value, options) : value;
}
function $940125e7197bfed1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $940125e7197bfed1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $940125e7197bfed1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $940125e7197bfed1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $940125e7197bfed1$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $940125e7197bfed1$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $940125e7197bfed1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $940125e7197bfed1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $940125e7197bfed1$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $940125e7197bfed1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $940125e7197bfed1$var$mergeObject(target, source, options);
}
$940125e7197bfed1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $940125e7197bfed1$var$deepmerge(prev, next, options);
    }, {});
};
var $940125e7197bfed1$var$deepmerge_1 = $940125e7197bfed1$var$deepmerge;
var $940125e7197bfed1$export$2e2bcd8739ae039 = $940125e7197bfed1$var$deepmerge_1;

});

parcelRegister("1Gi2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1397b3f035177f54$export$2e2bcd8739ae039; });

var $gwS9V = parcelRequire("gwS9V");

var $bp1AU = parcelRequire("bp1AU");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $1397b3f035177f54$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1397b3f035177f54$var$funcProto = Function.prototype, $1397b3f035177f54$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1397b3f035177f54$var$funcToString = $1397b3f035177f54$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1397b3f035177f54$var$hasOwnProperty = $1397b3f035177f54$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $1397b3f035177f54$var$objectCtorString = $1397b3f035177f54$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $1397b3f035177f54$var$isPlainObject(value) {
    if (!(0, $96UVv.default)(value) || (0, $gwS9V.default)(value) != $1397b3f035177f54$var$objectTag) return false;
    var proto = (0, $bp1AU.default)(value);
    if (proto === null) return true;
    var Ctor = $1397b3f035177f54$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $1397b3f035177f54$var$funcToString.call(Ctor) == $1397b3f035177f54$var$objectCtorString;
}
var $1397b3f035177f54$export$2e2bcd8739ae039 = $1397b3f035177f54$var$isPlainObject;

});
parcelRegister("gwS9V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c089a55add9b5fa8$export$2e2bcd8739ae039; });

var $lxt5K = parcelRequire("lxt5K");

var $fJzc3 = parcelRequire("fJzc3");

var $4oHAg = parcelRequire("4oHAg");
/** `Object#toString` result references. */ var $c089a55add9b5fa8$var$nullTag = '[object Null]', $c089a55add9b5fa8$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $c089a55add9b5fa8$var$symToStringTag = (0, $lxt5K.default) ? (0, $lxt5K.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c089a55add9b5fa8$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c089a55add9b5fa8$var$undefinedTag : $c089a55add9b5fa8$var$nullTag;
    return $c089a55add9b5fa8$var$symToStringTag && $c089a55add9b5fa8$var$symToStringTag in Object(value) ? (0, $fJzc3.default)(value) : (0, $4oHAg.default)(value);
}
var $c089a55add9b5fa8$export$2e2bcd8739ae039 = $c089a55add9b5fa8$var$baseGetTag;

});
parcelRegister("lxt5K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fae33f0852e985db$export$2e2bcd8739ae039; });

var $jpEbX = parcelRequire("jpEbX");
/** Built-in value references. */ var $fae33f0852e985db$var$Symbol = (0, $jpEbX.default).Symbol;
var $fae33f0852e985db$export$2e2bcd8739ae039 = $fae33f0852e985db$var$Symbol;

});
parcelRegister("jpEbX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e21f875d7abe8059$export$2e2bcd8739ae039; });

var $aJvHR = parcelRequire("aJvHR");
/** Detect free variable `self`. */ var $e21f875d7abe8059$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e21f875d7abe8059$var$root = (0, $aJvHR.default) || $e21f875d7abe8059$var$freeSelf || Function('return this')();
var $e21f875d7abe8059$export$2e2bcd8739ae039 = $e21f875d7abe8059$var$root;

});
parcelRegister("aJvHR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d06b39ae81f041d$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $7d06b39ae81f041d$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $7d06b39ae81f041d$export$2e2bcd8739ae039 = $7d06b39ae81f041d$var$freeGlobal;

});



parcelRegister("fJzc3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7465ba737296558$export$2e2bcd8739ae039; });

var $lxt5K = parcelRequire("lxt5K");
/** Used for built-in method references. */ var $b7465ba737296558$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b7465ba737296558$var$hasOwnProperty = $b7465ba737296558$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b7465ba737296558$var$nativeObjectToString = $b7465ba737296558$var$objectProto.toString;
/** Built-in value references. */ var $b7465ba737296558$var$symToStringTag = (0, $lxt5K.default) ? (0, $lxt5K.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b7465ba737296558$var$getRawTag(value) {
    var isOwn = $b7465ba737296558$var$hasOwnProperty.call(value, $b7465ba737296558$var$symToStringTag), tag = value[$b7465ba737296558$var$symToStringTag];
    try {
        value[$b7465ba737296558$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b7465ba737296558$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b7465ba737296558$var$symToStringTag] = tag;
        else delete value[$b7465ba737296558$var$symToStringTag];
    }
    return result;
}
var $b7465ba737296558$export$2e2bcd8739ae039 = $b7465ba737296558$var$getRawTag;

});

parcelRegister("4oHAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $333b362d9997dfe8$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $333b362d9997dfe8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $333b362d9997dfe8$var$nativeObjectToString = $333b362d9997dfe8$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $333b362d9997dfe8$var$objectToString(value) {
    return $333b362d9997dfe8$var$nativeObjectToString.call(value);
}
var $333b362d9997dfe8$export$2e2bcd8739ae039 = $333b362d9997dfe8$var$objectToString;

});


parcelRegister("bp1AU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d34416f54f3c30$export$2e2bcd8739ae039; });

var $gF1oV = parcelRequire("gF1oV");
/** Built-in value references. */ var $84d34416f54f3c30$var$getPrototype = (0, $gF1oV.default)(Object.getPrototypeOf, Object);
var $84d34416f54f3c30$export$2e2bcd8739ae039 = $84d34416f54f3c30$var$getPrototype;

});
parcelRegister("gF1oV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2118fe6aeaa90fb$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c2118fe6aeaa90fb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $c2118fe6aeaa90fb$export$2e2bcd8739ae039 = $c2118fe6aeaa90fb$var$overArg;

});


parcelRegister("96UVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a20d507088afc2e$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6a20d507088afc2e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $6a20d507088afc2e$export$2e2bcd8739ae039 = $6a20d507088afc2e$var$isObjectLike;

});


parcelRegister("2L2lK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2021cb2f700f6df7$export$2e2bcd8739ae039; });

var $jt0Ic = parcelRequire("jt0Ic");
/** Used to compose bitmasks for cloning. */ var $2021cb2f700f6df7$var$CLONE_DEEP_FLAG = 1, $2021cb2f700f6df7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $2021cb2f700f6df7$var$cloneDeep(value) {
    return (0, $jt0Ic.default)(value, $2021cb2f700f6df7$var$CLONE_DEEP_FLAG | $2021cb2f700f6df7$var$CLONE_SYMBOLS_FLAG);
}
var $2021cb2f700f6df7$export$2e2bcd8739ae039 = $2021cb2f700f6df7$var$cloneDeep;

});
parcelRegister("jt0Ic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2c14719bad680c3$export$2e2bcd8739ae039; });

var $dUZA8 = parcelRequire("dUZA8");

var $3Ajad = parcelRequire("3Ajad");

var $caONb = parcelRequire("caONb");

var $7RFBj = parcelRequire("7RFBj");

var $8BPK0 = parcelRequire("8BPK0");

var $frSVJ = parcelRequire("frSVJ");

var $2z32G = parcelRequire("2z32G");

var $fLu40 = parcelRequire("fLu40");

var $5YSOR = parcelRequire("5YSOR");

var $4aKzG = parcelRequire("4aKzG");

var $3iRGB = parcelRequire("3iRGB");

var $lrwIc = parcelRequire("lrwIc");

var $8fJiG = parcelRequire("8fJiG");

var $gQt7v = parcelRequire("gQt7v");

var $1g7ai = parcelRequire("1g7ai");

var $9U1t4 = parcelRequire("9U1t4");

var $gDsIk = parcelRequire("gDsIk");

var $4p2BU = parcelRequire("4p2BU");

var $fxpzz = parcelRequire("fxpzz");

var $gbrpx = parcelRequire("gbrpx");

var $fAIqa = parcelRequire("fAIqa");

var $dzZeW = parcelRequire("dzZeW");
/** Used to compose bitmasks for cloning. */ var $e2c14719bad680c3$var$CLONE_DEEP_FLAG = 1, $e2c14719bad680c3$var$CLONE_FLAT_FLAG = 2, $e2c14719bad680c3$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e2c14719bad680c3$var$argsTag = '[object Arguments]', $e2c14719bad680c3$var$arrayTag = '[object Array]', $e2c14719bad680c3$var$boolTag = '[object Boolean]', $e2c14719bad680c3$var$dateTag = '[object Date]', $e2c14719bad680c3$var$errorTag = '[object Error]', $e2c14719bad680c3$var$funcTag = '[object Function]', $e2c14719bad680c3$var$genTag = '[object GeneratorFunction]', $e2c14719bad680c3$var$mapTag = '[object Map]', $e2c14719bad680c3$var$numberTag = '[object Number]', $e2c14719bad680c3$var$objectTag = '[object Object]', $e2c14719bad680c3$var$regexpTag = '[object RegExp]', $e2c14719bad680c3$var$setTag = '[object Set]', $e2c14719bad680c3$var$stringTag = '[object String]', $e2c14719bad680c3$var$symbolTag = '[object Symbol]', $e2c14719bad680c3$var$weakMapTag = '[object WeakMap]';
var $e2c14719bad680c3$var$arrayBufferTag = '[object ArrayBuffer]', $e2c14719bad680c3$var$dataViewTag = '[object DataView]', $e2c14719bad680c3$var$float32Tag = '[object Float32Array]', $e2c14719bad680c3$var$float64Tag = '[object Float64Array]', $e2c14719bad680c3$var$int8Tag = '[object Int8Array]', $e2c14719bad680c3$var$int16Tag = '[object Int16Array]', $e2c14719bad680c3$var$int32Tag = '[object Int32Array]', $e2c14719bad680c3$var$uint8Tag = '[object Uint8Array]', $e2c14719bad680c3$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e2c14719bad680c3$var$uint16Tag = '[object Uint16Array]', $e2c14719bad680c3$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e2c14719bad680c3$var$cloneableTags = {};
$e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$argsTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$arrayTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$arrayBufferTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$dataViewTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$boolTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$dateTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$float32Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$float64Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$int8Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$int16Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$int32Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$mapTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$numberTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$objectTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$regexpTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$setTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$stringTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$symbolTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$uint8Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$uint8ClampedTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$uint16Tag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$uint32Tag] = true;
$e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$errorTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$funcTag] = $e2c14719bad680c3$var$cloneableTags[$e2c14719bad680c3$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e2c14719bad680c3$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e2c14719bad680c3$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e2c14719bad680c3$var$CLONE_FLAT_FLAG, isFull = bitmask & $e2c14719bad680c3$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $fxpzz.default)(value)) return value;
    var isArr = (0, $9U1t4.default)(value);
    if (isArr) {
        result = (0, $8fJiG.default)(value);
        if (!isDeep) return (0, $2z32G.default)(value, result);
    } else {
        var tag = (0, $lrwIc.default)(value), isFunc = tag == $e2c14719bad680c3$var$funcTag || tag == $e2c14719bad680c3$var$genTag;
        if ((0, $gDsIk.default)(value)) return (0, $frSVJ.default)(value, isDeep);
        if (tag == $e2c14719bad680c3$var$objectTag || tag == $e2c14719bad680c3$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $1g7ai.default)(value);
            if (!isDeep) return isFlat ? (0, $5YSOR.default)(value, (0, $8BPK0.default)(result, value)) : (0, $fLu40.default)(value, (0, $7RFBj.default)(result, value));
        } else {
            if (!$e2c14719bad680c3$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $gQt7v.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $dUZA8.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $gbrpx.default)(value)) value.forEach(function(subValue) {
        result.add($e2c14719bad680c3$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $4p2BU.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e2c14719bad680c3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $3iRGB.default) : (0, $4aKzG.default) : isFlat ? (0, $dzZeW.default) : (0, $fAIqa.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $3Ajad.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $caONb.default)(result, key, $e2c14719bad680c3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e2c14719bad680c3$export$2e2bcd8739ae039 = $e2c14719bad680c3$var$baseClone;

});
parcelRegister("dUZA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a220463658d58b6c$export$2e2bcd8739ae039; });

var $l74YT = parcelRequire("l74YT");

var $2TiLd = parcelRequire("2TiLd");

var $fV7EQ = parcelRequire("fV7EQ");

var $20wYK = parcelRequire("20wYK");

var $FYjAL = parcelRequire("FYjAL");

var $1Tex0 = parcelRequire("1Tex0");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a220463658d58b6c$var$Stack(entries) {
    var data = this.__data__ = new (0, $l74YT.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$a220463658d58b6c$var$Stack.prototype.clear = (0, $2TiLd.default);
$a220463658d58b6c$var$Stack.prototype['delete'] = (0, $fV7EQ.default);
$a220463658d58b6c$var$Stack.prototype.get = (0, $20wYK.default);
$a220463658d58b6c$var$Stack.prototype.has = (0, $FYjAL.default);
$a220463658d58b6c$var$Stack.prototype.set = (0, $1Tex0.default);
var $a220463658d58b6c$export$2e2bcd8739ae039 = $a220463658d58b6c$var$Stack;

});
parcelRegister("l74YT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5ee1d976759943c$export$2e2bcd8739ae039; });

var $i18Fn = parcelRequire("i18Fn");

var $eIA5m = parcelRequire("eIA5m");

var $8Xn00 = parcelRequire("8Xn00");

var $e2uB6 = parcelRequire("e2uB6");

var $icbT9 = parcelRequire("icbT9");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f5ee1d976759943c$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f5ee1d976759943c$var$ListCache.prototype.clear = (0, $i18Fn.default);
$f5ee1d976759943c$var$ListCache.prototype['delete'] = (0, $eIA5m.default);
$f5ee1d976759943c$var$ListCache.prototype.get = (0, $8Xn00.default);
$f5ee1d976759943c$var$ListCache.prototype.has = (0, $e2uB6.default);
$f5ee1d976759943c$var$ListCache.prototype.set = (0, $icbT9.default);
var $f5ee1d976759943c$export$2e2bcd8739ae039 = $f5ee1d976759943c$var$ListCache;

});
parcelRegister("i18Fn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1df0af7d5766507$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d1df0af7d5766507$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $d1df0af7d5766507$export$2e2bcd8739ae039 = $d1df0af7d5766507$var$listCacheClear;

});

parcelRegister("eIA5m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab712a91f361dcc8$export$2e2bcd8739ae039; });

var $io1hw = parcelRequire("io1hw");
/** Used for built-in method references. */ var $ab712a91f361dcc8$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ab712a91f361dcc8$var$splice = $ab712a91f361dcc8$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ab712a91f361dcc8$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $io1hw.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ab712a91f361dcc8$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ab712a91f361dcc8$export$2e2bcd8739ae039 = $ab712a91f361dcc8$var$listCacheDelete;

});
parcelRegister("io1hw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62b7664a0924b45$export$2e2bcd8739ae039; });

var $1VncP = parcelRequire("1VncP");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d62b7664a0924b45$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $1VncP.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $d62b7664a0924b45$export$2e2bcd8739ae039 = $d62b7664a0924b45$var$assocIndexOf;

});
parcelRegister("1VncP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166d1d82324da8c5$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $166d1d82324da8c5$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $166d1d82324da8c5$export$2e2bcd8739ae039 = $166d1d82324da8c5$var$eq;

});



parcelRegister("8Xn00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6855ac950f730401$export$2e2bcd8739ae039; });

var $io1hw = parcelRequire("io1hw");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6855ac950f730401$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $io1hw.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $6855ac950f730401$export$2e2bcd8739ae039 = $6855ac950f730401$var$listCacheGet;

});

parcelRegister("e2uB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a388fc9da6a6b8d8$export$2e2bcd8739ae039; });

var $io1hw = parcelRequire("io1hw");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a388fc9da6a6b8d8$var$listCacheHas(key) {
    return (0, $io1hw.default)(this.__data__, key) > -1;
}
var $a388fc9da6a6b8d8$export$2e2bcd8739ae039 = $a388fc9da6a6b8d8$var$listCacheHas;

});

parcelRegister("icbT9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3f291c7b72e1fe1$export$2e2bcd8739ae039; });

var $io1hw = parcelRequire("io1hw");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d3f291c7b72e1fe1$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $io1hw.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $d3f291c7b72e1fe1$export$2e2bcd8739ae039 = $d3f291c7b72e1fe1$var$listCacheSet;

});


parcelRegister("2TiLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21af454c8d5c4f25$export$2e2bcd8739ae039; });

var $l74YT = parcelRequire("l74YT");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $21af454c8d5c4f25$var$stackClear() {
    this.__data__ = new (0, $l74YT.default);
    this.size = 0;
}
var $21af454c8d5c4f25$export$2e2bcd8739ae039 = $21af454c8d5c4f25$var$stackClear;

});

parcelRegister("fV7EQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9721e9367867716$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b9721e9367867716$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $b9721e9367867716$export$2e2bcd8739ae039 = $b9721e9367867716$var$stackDelete;

});

parcelRegister("20wYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $176529bd01137ae8$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $176529bd01137ae8$var$stackGet(key) {
    return this.__data__.get(key);
}
var $176529bd01137ae8$export$2e2bcd8739ae039 = $176529bd01137ae8$var$stackGet;

});

parcelRegister("FYjAL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e29dc0bab10d65$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $07e29dc0bab10d65$var$stackHas(key) {
    return this.__data__.has(key);
}
var $07e29dc0bab10d65$export$2e2bcd8739ae039 = $07e29dc0bab10d65$var$stackHas;

});

parcelRegister("1Tex0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16063318e6813478$export$2e2bcd8739ae039; });

var $l74YT = parcelRequire("l74YT");

var $kLZzq = parcelRequire("kLZzq");

var $a5acJ = parcelRequire("a5acJ");
/** Used as the size to enable large array optimizations. */ var $16063318e6813478$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $16063318e6813478$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $l74YT.default)) {
        var pairs = data.__data__;
        if (!(0, $kLZzq.default) || pairs.length < $16063318e6813478$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $a5acJ.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $16063318e6813478$export$2e2bcd8739ae039 = $16063318e6813478$var$stackSet;

});
parcelRegister("kLZzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f7f5034f8f71db$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");

var $jpEbX = parcelRequire("jpEbX");
/* Built-in method references that are verified to be native. */ var $f1f7f5034f8f71db$var$Map = (0, $6rWms.default)((0, $jpEbX.default), 'Map');
var $f1f7f5034f8f71db$export$2e2bcd8739ae039 = $f1f7f5034f8f71db$var$Map;

});
parcelRegister("6rWms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b228904445f0851$export$2e2bcd8739ae039; });

var $lVZVQ = parcelRequire("lVZVQ");

var $jGeaK = parcelRequire("jGeaK");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4b228904445f0851$var$getNative(object, key) {
    var value = (0, $jGeaK.default)(object, key);
    return (0, $lVZVQ.default)(value) ? value : undefined;
}
var $4b228904445f0851$export$2e2bcd8739ae039 = $4b228904445f0851$var$getNative;

});
parcelRegister("lVZVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff7ef63c505270a6$export$2e2bcd8739ae039; });

var $6yxoh = parcelRequire("6yxoh");

var $ipGEQ = parcelRequire("ipGEQ");

var $fxpzz = parcelRequire("fxpzz");

var $eRZzg = parcelRequire("eRZzg");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ff7ef63c505270a6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ff7ef63c505270a6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ff7ef63c505270a6$var$funcProto = Function.prototype, $ff7ef63c505270a6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ff7ef63c505270a6$var$funcToString = $ff7ef63c505270a6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ff7ef63c505270a6$var$hasOwnProperty = $ff7ef63c505270a6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ff7ef63c505270a6$var$reIsNative = RegExp('^' + $ff7ef63c505270a6$var$funcToString.call($ff7ef63c505270a6$var$hasOwnProperty).replace($ff7ef63c505270a6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ff7ef63c505270a6$var$baseIsNative(value) {
    if (!(0, $fxpzz.default)(value) || (0, $ipGEQ.default)(value)) return false;
    var pattern = (0, $6yxoh.default)(value) ? $ff7ef63c505270a6$var$reIsNative : $ff7ef63c505270a6$var$reIsHostCtor;
    return pattern.test((0, $eRZzg.default)(value));
}
var $ff7ef63c505270a6$export$2e2bcd8739ae039 = $ff7ef63c505270a6$var$baseIsNative;

});
parcelRegister("6yxoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c5fd1b8c027d49e$export$2e2bcd8739ae039; });

var $gwS9V = parcelRequire("gwS9V");

var $fxpzz = parcelRequire("fxpzz");
/** `Object#toString` result references. */ var $4c5fd1b8c027d49e$var$asyncTag = '[object AsyncFunction]', $4c5fd1b8c027d49e$var$funcTag = '[object Function]', $4c5fd1b8c027d49e$var$genTag = '[object GeneratorFunction]', $4c5fd1b8c027d49e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4c5fd1b8c027d49e$var$isFunction(value) {
    if (!(0, $fxpzz.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $gwS9V.default)(value);
    return tag == $4c5fd1b8c027d49e$var$funcTag || tag == $4c5fd1b8c027d49e$var$genTag || tag == $4c5fd1b8c027d49e$var$asyncTag || tag == $4c5fd1b8c027d49e$var$proxyTag;
}
var $4c5fd1b8c027d49e$export$2e2bcd8739ae039 = $4c5fd1b8c027d49e$var$isFunction;

});
parcelRegister("fxpzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4fdc6451ff755c2$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b4fdc6451ff755c2$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $b4fdc6451ff755c2$export$2e2bcd8739ae039 = $b4fdc6451ff755c2$var$isObject;

});


parcelRegister("ipGEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67ba6bc7882f1bd$export$2e2bcd8739ae039; });

var $62o8W = parcelRequire("62o8W");
/** Used to detect methods masquerading as native. */ var $d67ba6bc7882f1bd$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $62o8W.default) && (0, $62o8W.default).keys && (0, $62o8W.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $d67ba6bc7882f1bd$var$isMasked(func) {
    return !!$d67ba6bc7882f1bd$var$maskSrcKey && $d67ba6bc7882f1bd$var$maskSrcKey in func;
}
var $d67ba6bc7882f1bd$export$2e2bcd8739ae039 = $d67ba6bc7882f1bd$var$isMasked;

});
parcelRegister("62o8W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4655a8513f3b8bc3$export$2e2bcd8739ae039; });

var $jpEbX = parcelRequire("jpEbX");
/** Used to detect overreaching core-js shims. */ var $4655a8513f3b8bc3$var$coreJsData = (0, $jpEbX.default)['__core-js_shared__'];
var $4655a8513f3b8bc3$export$2e2bcd8739ae039 = $4655a8513f3b8bc3$var$coreJsData;

});


parcelRegister("eRZzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad35c604b82fedc1$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $ad35c604b82fedc1$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ad35c604b82fedc1$var$funcToString = $ad35c604b82fedc1$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ad35c604b82fedc1$var$toSource(func) {
    if (func != null) {
        try {
            return $ad35c604b82fedc1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $ad35c604b82fedc1$export$2e2bcd8739ae039 = $ad35c604b82fedc1$var$toSource;

});


parcelRegister("jGeaK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e53ceeebc680342c$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e53ceeebc680342c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e53ceeebc680342c$export$2e2bcd8739ae039 = $e53ceeebc680342c$var$getValue;

});



parcelRegister("a5acJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7572495e837b809b$export$2e2bcd8739ae039; });

var $3HwTo = parcelRequire("3HwTo");

var $6rEpf = parcelRequire("6rEpf");

var $3WE38 = parcelRequire("3WE38");

var $bs40Y = parcelRequire("bs40Y");

var $eI1ce = parcelRequire("eI1ce");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7572495e837b809b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7572495e837b809b$var$MapCache.prototype.clear = (0, $3HwTo.default);
$7572495e837b809b$var$MapCache.prototype['delete'] = (0, $6rEpf.default);
$7572495e837b809b$var$MapCache.prototype.get = (0, $3WE38.default);
$7572495e837b809b$var$MapCache.prototype.has = (0, $bs40Y.default);
$7572495e837b809b$var$MapCache.prototype.set = (0, $eI1ce.default);
var $7572495e837b809b$export$2e2bcd8739ae039 = $7572495e837b809b$var$MapCache;

});
parcelRegister("3HwTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b1ee704fe98b6eb$export$2e2bcd8739ae039; });

var $2Ccwm = parcelRequire("2Ccwm");

var $l74YT = parcelRequire("l74YT");

var $kLZzq = parcelRequire("kLZzq");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $2b1ee704fe98b6eb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $2Ccwm.default),
        'map': new ((0, $kLZzq.default) || (0, $l74YT.default)),
        'string': new (0, $2Ccwm.default)
    };
}
var $2b1ee704fe98b6eb$export$2e2bcd8739ae039 = $2b1ee704fe98b6eb$var$mapCacheClear;

});
parcelRegister("2Ccwm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e78d7c6796e52d7$export$2e2bcd8739ae039; });

var $gtihi = parcelRequire("gtihi");

var $2H1U2 = parcelRequire("2H1U2");

var $i8SIX = parcelRequire("i8SIX");

var $k6t0Y = parcelRequire("k6t0Y");

var $d3NkL = parcelRequire("d3NkL");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1e78d7c6796e52d7$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1e78d7c6796e52d7$var$Hash.prototype.clear = (0, $gtihi.default);
$1e78d7c6796e52d7$var$Hash.prototype['delete'] = (0, $2H1U2.default);
$1e78d7c6796e52d7$var$Hash.prototype.get = (0, $i8SIX.default);
$1e78d7c6796e52d7$var$Hash.prototype.has = (0, $k6t0Y.default);
$1e78d7c6796e52d7$var$Hash.prototype.set = (0, $d3NkL.default);
var $1e78d7c6796e52d7$export$2e2bcd8739ae039 = $1e78d7c6796e52d7$var$Hash;

});
parcelRegister("gtihi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfdd886c5ae0edb2$export$2e2bcd8739ae039; });

var $5S5C1 = parcelRequire("5S5C1");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $bfdd886c5ae0edb2$var$hashClear() {
    this.__data__ = (0, $5S5C1.default) ? (0, $5S5C1.default)(null) : {};
    this.size = 0;
}
var $bfdd886c5ae0edb2$export$2e2bcd8739ae039 = $bfdd886c5ae0edb2$var$hashClear;

});
parcelRegister("5S5C1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4466596437011a9f$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");
/* Built-in method references that are verified to be native. */ var $4466596437011a9f$var$nativeCreate = (0, $6rWms.default)(Object, 'create');
var $4466596437011a9f$export$2e2bcd8739ae039 = $4466596437011a9f$var$nativeCreate;

});


parcelRegister("2H1U2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f6112d02ec38d70$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1f6112d02ec38d70$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1f6112d02ec38d70$export$2e2bcd8739ae039 = $1f6112d02ec38d70$var$hashDelete;

});

parcelRegister("i8SIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3536c6b16c33072$export$2e2bcd8739ae039; });

var $5S5C1 = parcelRequire("5S5C1");
/** Used to stand-in for `undefined` hash values. */ var $d3536c6b16c33072$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d3536c6b16c33072$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d3536c6b16c33072$var$hasOwnProperty = $d3536c6b16c33072$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d3536c6b16c33072$var$hashGet(key) {
    var data = this.__data__;
    if (0, $5S5C1.default) {
        var result = data[key];
        return result === $d3536c6b16c33072$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d3536c6b16c33072$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d3536c6b16c33072$export$2e2bcd8739ae039 = $d3536c6b16c33072$var$hashGet;

});

parcelRegister("k6t0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea2adfe5b4c46eba$export$2e2bcd8739ae039; });

var $5S5C1 = parcelRequire("5S5C1");
/** Used for built-in method references. */ var $ea2adfe5b4c46eba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea2adfe5b4c46eba$var$hasOwnProperty = $ea2adfe5b4c46eba$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ea2adfe5b4c46eba$var$hashHas(key) {
    var data = this.__data__;
    return (0, $5S5C1.default) ? data[key] !== undefined : $ea2adfe5b4c46eba$var$hasOwnProperty.call(data, key);
}
var $ea2adfe5b4c46eba$export$2e2bcd8739ae039 = $ea2adfe5b4c46eba$var$hashHas;

});

parcelRegister("d3NkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9821d2ddbc2cb571$export$2e2bcd8739ae039; });

var $5S5C1 = parcelRequire("5S5C1");
/** Used to stand-in for `undefined` hash values. */ var $9821d2ddbc2cb571$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $9821d2ddbc2cb571$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $5S5C1.default) && value === undefined ? $9821d2ddbc2cb571$var$HASH_UNDEFINED : value;
    return this;
}
var $9821d2ddbc2cb571$export$2e2bcd8739ae039 = $9821d2ddbc2cb571$var$hashSet;

});



parcelRegister("6rEpf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b149b8a471e49d4$export$2e2bcd8739ae039; });

var $aDorc = parcelRequire("aDorc");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4b149b8a471e49d4$var$mapCacheDelete(key) {
    var result = (0, $aDorc.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $4b149b8a471e49d4$export$2e2bcd8739ae039 = $4b149b8a471e49d4$var$mapCacheDelete;

});
parcelRegister("aDorc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7be080bc4e866945$export$2e2bcd8739ae039; });

var $3n7fx = parcelRequire("3n7fx");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $7be080bc4e866945$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $3n7fx.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $7be080bc4e866945$export$2e2bcd8739ae039 = $7be080bc4e866945$var$getMapData;

});
parcelRegister("3n7fx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274924b2f3cfa1f8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $274924b2f3cfa1f8$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $274924b2f3cfa1f8$export$2e2bcd8739ae039 = $274924b2f3cfa1f8$var$isKeyable;

});



parcelRegister("3WE38", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df5dae8caf0ac20$export$2e2bcd8739ae039; });

var $aDorc = parcelRequire("aDorc");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2df5dae8caf0ac20$var$mapCacheGet(key) {
    return (0, $aDorc.default)(this, key).get(key);
}
var $2df5dae8caf0ac20$export$2e2bcd8739ae039 = $2df5dae8caf0ac20$var$mapCacheGet;

});

parcelRegister("bs40Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85656c794683970c$export$2e2bcd8739ae039; });

var $aDorc = parcelRequire("aDorc");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $85656c794683970c$var$mapCacheHas(key) {
    return (0, $aDorc.default)(this, key).has(key);
}
var $85656c794683970c$export$2e2bcd8739ae039 = $85656c794683970c$var$mapCacheHas;

});

parcelRegister("eI1ce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab561a4c1f563ce1$export$2e2bcd8739ae039; });

var $aDorc = parcelRequire("aDorc");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ab561a4c1f563ce1$var$mapCacheSet(key, value) {
    var data = (0, $aDorc.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ab561a4c1f563ce1$export$2e2bcd8739ae039 = $ab561a4c1f563ce1$var$mapCacheSet;

});




parcelRegister("3Ajad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c39965d2ac85b4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $29c39965d2ac85b4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $29c39965d2ac85b4$export$2e2bcd8739ae039 = $29c39965d2ac85b4$var$arrayEach;

});

parcelRegister("caONb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dcdd17d9aa20276$export$2e2bcd8739ae039; });

var $2t0FW = parcelRequire("2t0FW");

var $1VncP = parcelRequire("1VncP");
/** Used for built-in method references. */ var $8dcdd17d9aa20276$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8dcdd17d9aa20276$var$hasOwnProperty = $8dcdd17d9aa20276$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8dcdd17d9aa20276$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($8dcdd17d9aa20276$var$hasOwnProperty.call(object, key) && (0, $1VncP.default)(objValue, value)) || value === undefined && !(key in object)) (0, $2t0FW.default)(object, key, value);
}
var $8dcdd17d9aa20276$export$2e2bcd8739ae039 = $8dcdd17d9aa20276$var$assignValue;

});
parcelRegister("2t0FW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cbed05c2824e6f5$export$2e2bcd8739ae039; });

var $jv8oJ = parcelRequire("jv8oJ");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1cbed05c2824e6f5$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $jv8oJ.default)) (0, $jv8oJ.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $1cbed05c2824e6f5$export$2e2bcd8739ae039 = $1cbed05c2824e6f5$var$baseAssignValue;

});
parcelRegister("jv8oJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3276d3a8c825088$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");
var $e3276d3a8c825088$var$defineProperty = function() {
    try {
        var func = (0, $6rWms.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $e3276d3a8c825088$export$2e2bcd8739ae039 = $e3276d3a8c825088$var$defineProperty;

});



parcelRegister("7RFBj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9dc0b268170646$export$2e2bcd8739ae039; });

var $3sn1f = parcelRequire("3sn1f");

var $fAIqa = parcelRequire("fAIqa");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $5b9dc0b268170646$var$baseAssign(object, source) {
    return object && (0, $3sn1f.default)(source, (0, $fAIqa.default)(source), object);
}
var $5b9dc0b268170646$export$2e2bcd8739ae039 = $5b9dc0b268170646$var$baseAssign;

});
parcelRegister("3sn1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2845d7c08573eb93$export$2e2bcd8739ae039; });

var $caONb = parcelRequire("caONb");

var $2t0FW = parcelRequire("2t0FW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2845d7c08573eb93$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $2t0FW.default)(object, key, newValue);
        else (0, $caONb.default)(object, key, newValue);
    }
    return object;
}
var $2845d7c08573eb93$export$2e2bcd8739ae039 = $2845d7c08573eb93$var$copyObject;

});

parcelRegister("fAIqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b59cace6a2956691$export$2e2bcd8739ae039; });

var $iGdcI = parcelRequire("iGdcI");

var $4cLTb = parcelRequire("4cLTb");

var $fhfib = parcelRequire("fhfib");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b59cace6a2956691$var$keys(object) {
    return (0, $fhfib.default)(object) ? (0, $iGdcI.default)(object) : (0, $4cLTb.default)(object);
}
var $b59cace6a2956691$export$2e2bcd8739ae039 = $b59cace6a2956691$var$keys;

});
parcelRegister("iGdcI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d996645115f12e53$export$2e2bcd8739ae039; });

var $e4XqF = parcelRequire("e4XqF");

var $hxwPu = parcelRequire("hxwPu");

var $9U1t4 = parcelRequire("9U1t4");

var $gDsIk = parcelRequire("gDsIk");

var $4CIFw = parcelRequire("4CIFw");

var $fN1kZ = parcelRequire("fN1kZ");
/** Used for built-in method references. */ var $d996645115f12e53$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d996645115f12e53$var$hasOwnProperty = $d996645115f12e53$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d996645115f12e53$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $9U1t4.default)(value), isArg = !isArr && (0, $hxwPu.default)(value), isBuff = !isArr && !isArg && (0, $gDsIk.default)(value), isType = !isArr && !isArg && !isBuff && (0, $fN1kZ.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $e4XqF.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $d996645115f12e53$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $4CIFw.default)(key, length)))) result.push(key);
    return result;
}
var $d996645115f12e53$export$2e2bcd8739ae039 = $d996645115f12e53$var$arrayLikeKeys;

});
parcelRegister("e4XqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3ff89c819a512f5$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $a3ff89c819a512f5$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $a3ff89c819a512f5$export$2e2bcd8739ae039 = $a3ff89c819a512f5$var$baseTimes;

});

parcelRegister("hxwPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc4efc00dc8f3746$export$2e2bcd8739ae039; });

var $flhga = parcelRequire("flhga");

var $96UVv = parcelRequire("96UVv");
/** Used for built-in method references. */ var $cc4efc00dc8f3746$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc4efc00dc8f3746$var$hasOwnProperty = $cc4efc00dc8f3746$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $cc4efc00dc8f3746$var$propertyIsEnumerable = $cc4efc00dc8f3746$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $cc4efc00dc8f3746$var$isArguments = (0, $flhga.default)(function() {
    return arguments;
}()) ? (0, $flhga.default) : function(value) {
    return (0, $96UVv.default)(value) && $cc4efc00dc8f3746$var$hasOwnProperty.call(value, 'callee') && !$cc4efc00dc8f3746$var$propertyIsEnumerable.call(value, 'callee');
};
var $cc4efc00dc8f3746$export$2e2bcd8739ae039 = $cc4efc00dc8f3746$var$isArguments;

});
parcelRegister("flhga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b634a23e9e07f9$export$2e2bcd8739ae039; });

var $gwS9V = parcelRequire("gwS9V");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $b2b634a23e9e07f9$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $b2b634a23e9e07f9$var$baseIsArguments(value) {
    return (0, $96UVv.default)(value) && (0, $gwS9V.default)(value) == $b2b634a23e9e07f9$var$argsTag;
}
var $b2b634a23e9e07f9$export$2e2bcd8739ae039 = $b2b634a23e9e07f9$var$baseIsArguments;

});


parcelRegister("9U1t4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735a7b7e0e91f54a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $735a7b7e0e91f54a$var$isArray = Array.isArray;
var $735a7b7e0e91f54a$export$2e2bcd8739ae039 = $735a7b7e0e91f54a$var$isArray;

});

parcelRegister("gDsIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c68fd6305afcd3$export$2e2bcd8739ae039; });

var $jpEbX = parcelRequire("jpEbX");

var $jxrU6 = parcelRequire("jxrU6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $jpEbX.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $jxrU6.default);
var $c1c68fd6305afcd3$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("jxrU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e396be8a3aa63a68$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e396be8a3aa63a68$var$stubFalse() {
    return false;
}
var $e396be8a3aa63a68$export$2e2bcd8739ae039 = $e396be8a3aa63a68$var$stubFalse;

});


parcelRegister("4CIFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35dd5c4fc9e8059c$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $35dd5c4fc9e8059c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $35dd5c4fc9e8059c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $35dd5c4fc9e8059c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $35dd5c4fc9e8059c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $35dd5c4fc9e8059c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $35dd5c4fc9e8059c$export$2e2bcd8739ae039 = $35dd5c4fc9e8059c$var$isIndex;

});

parcelRegister("fN1kZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7ec783c66dd7a9e$export$2e2bcd8739ae039; });

var $h1qnp = parcelRequire("h1qnp");

var $e6Upd = parcelRequire("e6Upd");

var $eay4C = parcelRequire("eay4C");
/* Node.js helper references. */ var $b7ec783c66dd7a9e$var$nodeIsTypedArray = (0, $eay4C.default) && (0, $eay4C.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b7ec783c66dd7a9e$var$isTypedArray = $b7ec783c66dd7a9e$var$nodeIsTypedArray ? (0, $e6Upd.default)($b7ec783c66dd7a9e$var$nodeIsTypedArray) : (0, $h1qnp.default);
var $b7ec783c66dd7a9e$export$2e2bcd8739ae039 = $b7ec783c66dd7a9e$var$isTypedArray;

});
parcelRegister("h1qnp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c646fd8308309d37$export$2e2bcd8739ae039; });

var $gwS9V = parcelRequire("gwS9V");

var $b369F = parcelRequire("b369F");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $c646fd8308309d37$var$argsTag = '[object Arguments]', $c646fd8308309d37$var$arrayTag = '[object Array]', $c646fd8308309d37$var$boolTag = '[object Boolean]', $c646fd8308309d37$var$dateTag = '[object Date]', $c646fd8308309d37$var$errorTag = '[object Error]', $c646fd8308309d37$var$funcTag = '[object Function]', $c646fd8308309d37$var$mapTag = '[object Map]', $c646fd8308309d37$var$numberTag = '[object Number]', $c646fd8308309d37$var$objectTag = '[object Object]', $c646fd8308309d37$var$regexpTag = '[object RegExp]', $c646fd8308309d37$var$setTag = '[object Set]', $c646fd8308309d37$var$stringTag = '[object String]', $c646fd8308309d37$var$weakMapTag = '[object WeakMap]';
var $c646fd8308309d37$var$arrayBufferTag = '[object ArrayBuffer]', $c646fd8308309d37$var$dataViewTag = '[object DataView]', $c646fd8308309d37$var$float32Tag = '[object Float32Array]', $c646fd8308309d37$var$float64Tag = '[object Float64Array]', $c646fd8308309d37$var$int8Tag = '[object Int8Array]', $c646fd8308309d37$var$int16Tag = '[object Int16Array]', $c646fd8308309d37$var$int32Tag = '[object Int32Array]', $c646fd8308309d37$var$uint8Tag = '[object Uint8Array]', $c646fd8308309d37$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c646fd8308309d37$var$uint16Tag = '[object Uint16Array]', $c646fd8308309d37$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $c646fd8308309d37$var$typedArrayTags = {};
$c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$float32Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$float64Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$int8Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$int16Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$int32Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$uint8Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$uint8ClampedTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$uint16Tag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$uint32Tag] = true;
$c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$argsTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$arrayTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$arrayBufferTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$boolTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$dataViewTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$dateTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$errorTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$funcTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$mapTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$numberTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$objectTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$regexpTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$setTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$stringTag] = $c646fd8308309d37$var$typedArrayTags[$c646fd8308309d37$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c646fd8308309d37$var$baseIsTypedArray(value) {
    return (0, $96UVv.default)(value) && (0, $b369F.default)(value.length) && !!$c646fd8308309d37$var$typedArrayTags[(0, $gwS9V.default)(value)];
}
var $c646fd8308309d37$export$2e2bcd8739ae039 = $c646fd8308309d37$var$baseIsTypedArray;

});
parcelRegister("b369F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80b4bfc072e63fdf$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $80b4bfc072e63fdf$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $80b4bfc072e63fdf$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $80b4bfc072e63fdf$var$MAX_SAFE_INTEGER;
}
var $80b4bfc072e63fdf$export$2e2bcd8739ae039 = $80b4bfc072e63fdf$var$isLength;

});


parcelRegister("e6Upd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a45d613fc3252ea4$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a45d613fc3252ea4$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $a45d613fc3252ea4$export$2e2bcd8739ae039 = $a45d613fc3252ea4$var$baseUnary;

});

parcelRegister("eay4C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50c6e26f6e1a3ed$export$2e2bcd8739ae039; });

var $aJvHR = parcelRequire("aJvHR");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $aJvHR.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $a50c6e26f6e1a3ed$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("4cLTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30fd6e2d3ae13cda$export$2e2bcd8739ae039; });

var $gfIvj = parcelRequire("gfIvj");

var $1uNJz = parcelRequire("1uNJz");
/** Used for built-in method references. */ var $30fd6e2d3ae13cda$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $30fd6e2d3ae13cda$var$hasOwnProperty = $30fd6e2d3ae13cda$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $30fd6e2d3ae13cda$var$baseKeys(object) {
    if (!(0, $gfIvj.default)(object)) return (0, $1uNJz.default)(object);
    var result = [];
    for(var key in Object(object))if ($30fd6e2d3ae13cda$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $30fd6e2d3ae13cda$export$2e2bcd8739ae039 = $30fd6e2d3ae13cda$var$baseKeys;

});
parcelRegister("gfIvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd50919b7d092807$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $bd50919b7d092807$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $bd50919b7d092807$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $bd50919b7d092807$var$objectProto;
    return value === proto;
}
var $bd50919b7d092807$export$2e2bcd8739ae039 = $bd50919b7d092807$var$isPrototype;

});

parcelRegister("1uNJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $116f2be7d384d33b$export$2e2bcd8739ae039; });

var $gF1oV = parcelRequire("gF1oV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $116f2be7d384d33b$var$nativeKeys = (0, $gF1oV.default)(Object.keys, Object);
var $116f2be7d384d33b$export$2e2bcd8739ae039 = $116f2be7d384d33b$var$nativeKeys;

});


parcelRegister("fhfib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f44e46b1f6a846$export$2e2bcd8739ae039; });

var $6yxoh = parcelRequire("6yxoh");

var $b369F = parcelRequire("b369F");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b1f44e46b1f6a846$var$isArrayLike(value) {
    return value != null && (0, $b369F.default)(value.length) && !(0, $6yxoh.default)(value);
}
var $b1f44e46b1f6a846$export$2e2bcd8739ae039 = $b1f44e46b1f6a846$var$isArrayLike;

});



parcelRegister("8BPK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6449ea1fb8df76f7$export$2e2bcd8739ae039; });

var $3sn1f = parcelRequire("3sn1f");

var $dzZeW = parcelRequire("dzZeW");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6449ea1fb8df76f7$var$baseAssignIn(object, source) {
    return object && (0, $3sn1f.default)(source, (0, $dzZeW.default)(source), object);
}
var $6449ea1fb8df76f7$export$2e2bcd8739ae039 = $6449ea1fb8df76f7$var$baseAssignIn;

});
parcelRegister("dzZeW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e2e0c3aae60840a$export$2e2bcd8739ae039; });

var $iGdcI = parcelRequire("iGdcI");

var $aWnex = parcelRequire("aWnex");

var $fhfib = parcelRequire("fhfib");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9e2e0c3aae60840a$var$keysIn(object) {
    return (0, $fhfib.default)(object) ? (0, $iGdcI.default)(object, true) : (0, $aWnex.default)(object);
}
var $9e2e0c3aae60840a$export$2e2bcd8739ae039 = $9e2e0c3aae60840a$var$keysIn;

});
parcelRegister("aWnex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f7157dcdcb40213$export$2e2bcd8739ae039; });

var $fxpzz = parcelRequire("fxpzz");

var $gfIvj = parcelRequire("gfIvj");

var $8Rhfe = parcelRequire("8Rhfe");
/** Used for built-in method references. */ var $7f7157dcdcb40213$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f7157dcdcb40213$var$hasOwnProperty = $7f7157dcdcb40213$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7f7157dcdcb40213$var$baseKeysIn(object) {
    if (!(0, $fxpzz.default)(object)) return (0, $8Rhfe.default)(object);
    var isProto = (0, $gfIvj.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$7f7157dcdcb40213$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $7f7157dcdcb40213$export$2e2bcd8739ae039 = $7f7157dcdcb40213$var$baseKeysIn;

});
parcelRegister("8Rhfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6730a6602d3306bd$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6730a6602d3306bd$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6730a6602d3306bd$export$2e2bcd8739ae039 = $6730a6602d3306bd$var$nativeKeysIn;

});




parcelRegister("frSVJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f3fc9bee9c5431$export$2e2bcd8739ae039; });

var $jpEbX = parcelRequire("jpEbX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $jpEbX.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $b3f3fc9bee9c5431$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("2z32G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1de135c3c9a4765c$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1de135c3c9a4765c$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $1de135c3c9a4765c$export$2e2bcd8739ae039 = $1de135c3c9a4765c$var$copyArray;

});

parcelRegister("fLu40", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7a290ce087b9ed9$export$2e2bcd8739ae039; });

var $3sn1f = parcelRequire("3sn1f");

var $ifNqT = parcelRequire("ifNqT");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b7a290ce087b9ed9$var$copySymbols(source, object) {
    return (0, $3sn1f.default)(source, (0, $ifNqT.default)(source), object);
}
var $b7a290ce087b9ed9$export$2e2bcd8739ae039 = $b7a290ce087b9ed9$var$copySymbols;

});
parcelRegister("ifNqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d49ff909eb0d4a29$export$2e2bcd8739ae039; });

var $2riQl = parcelRequire("2riQl");

var $gha39 = parcelRequire("gha39");
/** Used for built-in method references. */ var $d49ff909eb0d4a29$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d49ff909eb0d4a29$var$propertyIsEnumerable = $d49ff909eb0d4a29$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d49ff909eb0d4a29$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d49ff909eb0d4a29$var$getSymbols = !$d49ff909eb0d4a29$var$nativeGetSymbols ? (0, $gha39.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $2riQl.default)($d49ff909eb0d4a29$var$nativeGetSymbols(object), function(symbol) {
        return $d49ff909eb0d4a29$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $d49ff909eb0d4a29$export$2e2bcd8739ae039 = $d49ff909eb0d4a29$var$getSymbols;

});
parcelRegister("2riQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c6cb84ac1a265ee$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1c6cb84ac1a265ee$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $1c6cb84ac1a265ee$export$2e2bcd8739ae039 = $1c6cb84ac1a265ee$var$arrayFilter;

});

parcelRegister("gha39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd96078aa9661d36$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $bd96078aa9661d36$var$stubArray() {
    return [];
}
var $bd96078aa9661d36$export$2e2bcd8739ae039 = $bd96078aa9661d36$var$stubArray;

});



parcelRegister("5YSOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45ad1452b0ba2452$export$2e2bcd8739ae039; });

var $3sn1f = parcelRequire("3sn1f");

var $lPXHV = parcelRequire("lPXHV");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $45ad1452b0ba2452$var$copySymbolsIn(source, object) {
    return (0, $3sn1f.default)(source, (0, $lPXHV.default)(source), object);
}
var $45ad1452b0ba2452$export$2e2bcd8739ae039 = $45ad1452b0ba2452$var$copySymbolsIn;

});
parcelRegister("lPXHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe5cad09cb2ac6d0$export$2e2bcd8739ae039; });

var $cdmk9 = parcelRequire("cdmk9");

var $bp1AU = parcelRequire("bp1AU");

var $ifNqT = parcelRequire("ifNqT");

var $gha39 = parcelRequire("gha39");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fe5cad09cb2ac6d0$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $fe5cad09cb2ac6d0$var$getSymbolsIn = !$fe5cad09cb2ac6d0$var$nativeGetSymbols ? (0, $gha39.default) : function(object) {
    var result = [];
    while(object){
        (0, $cdmk9.default)(result, (0, $ifNqT.default)(object));
        object = (0, $bp1AU.default)(object);
    }
    return result;
};
var $fe5cad09cb2ac6d0$export$2e2bcd8739ae039 = $fe5cad09cb2ac6d0$var$getSymbolsIn;

});
parcelRegister("cdmk9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e48040abdf2538e$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8e48040abdf2538e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8e48040abdf2538e$export$2e2bcd8739ae039 = $8e48040abdf2538e$var$arrayPush;

});



parcelRegister("4aKzG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309c394ea5b8cf42$export$2e2bcd8739ae039; });

var $aAaHM = parcelRequire("aAaHM");

var $ifNqT = parcelRequire("ifNqT");

var $fAIqa = parcelRequire("fAIqa");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $309c394ea5b8cf42$var$getAllKeys(object) {
    return (0, $aAaHM.default)(object, (0, $fAIqa.default), (0, $ifNqT.default));
}
var $309c394ea5b8cf42$export$2e2bcd8739ae039 = $309c394ea5b8cf42$var$getAllKeys;

});
parcelRegister("aAaHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b459203c3d19169$export$2e2bcd8739ae039; });

var $cdmk9 = parcelRequire("cdmk9");

var $9U1t4 = parcelRequire("9U1t4");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7b459203c3d19169$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $9U1t4.default)(object) ? result : (0, $cdmk9.default)(result, symbolsFunc(object));
}
var $7b459203c3d19169$export$2e2bcd8739ae039 = $7b459203c3d19169$var$baseGetAllKeys;

});


parcelRegister("3iRGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $267cb27e1731b607$export$2e2bcd8739ae039; });

var $aAaHM = parcelRequire("aAaHM");

var $lPXHV = parcelRequire("lPXHV");

var $dzZeW = parcelRequire("dzZeW");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $267cb27e1731b607$var$getAllKeysIn(object) {
    return (0, $aAaHM.default)(object, (0, $dzZeW.default), (0, $lPXHV.default));
}
var $267cb27e1731b607$export$2e2bcd8739ae039 = $267cb27e1731b607$var$getAllKeysIn;

});

parcelRegister("lrwIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9c57e7cbd8f8b78$export$2e2bcd8739ae039; });

var $dVS5W = parcelRequire("dVS5W");

var $kLZzq = parcelRequire("kLZzq");

var $2lNta = parcelRequire("2lNta");

var $8O59j = parcelRequire("8O59j");

var $ep2dZ = parcelRequire("ep2dZ");

var $gwS9V = parcelRequire("gwS9V");

var $eRZzg = parcelRequire("eRZzg");
/** `Object#toString` result references. */ var $f9c57e7cbd8f8b78$var$mapTag = '[object Map]', $f9c57e7cbd8f8b78$var$objectTag = '[object Object]', $f9c57e7cbd8f8b78$var$promiseTag = '[object Promise]', $f9c57e7cbd8f8b78$var$setTag = '[object Set]', $f9c57e7cbd8f8b78$var$weakMapTag = '[object WeakMap]';
var $f9c57e7cbd8f8b78$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $f9c57e7cbd8f8b78$var$dataViewCtorString = (0, $eRZzg.default)((0, $dVS5W.default)), $f9c57e7cbd8f8b78$var$mapCtorString = (0, $eRZzg.default)((0, $kLZzq.default)), $f9c57e7cbd8f8b78$var$promiseCtorString = (0, $eRZzg.default)((0, $2lNta.default)), $f9c57e7cbd8f8b78$var$setCtorString = (0, $eRZzg.default)((0, $8O59j.default)), $f9c57e7cbd8f8b78$var$weakMapCtorString = (0, $eRZzg.default)((0, $ep2dZ.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f9c57e7cbd8f8b78$var$getTag = (0, $gwS9V.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dVS5W.default) && $f9c57e7cbd8f8b78$var$getTag(new (0, $dVS5W.default)(new ArrayBuffer(1))) != $f9c57e7cbd8f8b78$var$dataViewTag || (0, $kLZzq.default) && $f9c57e7cbd8f8b78$var$getTag(new (0, $kLZzq.default)) != $f9c57e7cbd8f8b78$var$mapTag || (0, $2lNta.default) && $f9c57e7cbd8f8b78$var$getTag((0, $2lNta.default).resolve()) != $f9c57e7cbd8f8b78$var$promiseTag || (0, $8O59j.default) && $f9c57e7cbd8f8b78$var$getTag(new (0, $8O59j.default)) != $f9c57e7cbd8f8b78$var$setTag || (0, $ep2dZ.default) && $f9c57e7cbd8f8b78$var$getTag(new (0, $ep2dZ.default)) != $f9c57e7cbd8f8b78$var$weakMapTag) $f9c57e7cbd8f8b78$var$getTag = function(value) {
    var result = (0, $gwS9V.default)(value), Ctor = result == $f9c57e7cbd8f8b78$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $eRZzg.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $f9c57e7cbd8f8b78$var$dataViewCtorString:
            return $f9c57e7cbd8f8b78$var$dataViewTag;
        case $f9c57e7cbd8f8b78$var$mapCtorString:
            return $f9c57e7cbd8f8b78$var$mapTag;
        case $f9c57e7cbd8f8b78$var$promiseCtorString:
            return $f9c57e7cbd8f8b78$var$promiseTag;
        case $f9c57e7cbd8f8b78$var$setCtorString:
            return $f9c57e7cbd8f8b78$var$setTag;
        case $f9c57e7cbd8f8b78$var$weakMapCtorString:
            return $f9c57e7cbd8f8b78$var$weakMapTag;
    }
    return result;
};
var $f9c57e7cbd8f8b78$export$2e2bcd8739ae039 = $f9c57e7cbd8f8b78$var$getTag;

});
parcelRegister("dVS5W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a24a8f591c7b4002$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");

var $jpEbX = parcelRequire("jpEbX");
/* Built-in method references that are verified to be native. */ var $a24a8f591c7b4002$var$DataView = (0, $6rWms.default)((0, $jpEbX.default), 'DataView');
var $a24a8f591c7b4002$export$2e2bcd8739ae039 = $a24a8f591c7b4002$var$DataView;

});

parcelRegister("2lNta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b63ea8c77ad0a35$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");

var $jpEbX = parcelRequire("jpEbX");
/* Built-in method references that are verified to be native. */ var $1b63ea8c77ad0a35$var$Promise = (0, $6rWms.default)((0, $jpEbX.default), 'Promise');
var $1b63ea8c77ad0a35$export$2e2bcd8739ae039 = $1b63ea8c77ad0a35$var$Promise;

});

parcelRegister("8O59j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6696fcc039cc2897$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");

var $jpEbX = parcelRequire("jpEbX");
/* Built-in method references that are verified to be native. */ var $6696fcc039cc2897$var$Set = (0, $6rWms.default)((0, $jpEbX.default), 'Set');
var $6696fcc039cc2897$export$2e2bcd8739ae039 = $6696fcc039cc2897$var$Set;

});

parcelRegister("ep2dZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7c52047497babd6$export$2e2bcd8739ae039; });

var $6rWms = parcelRequire("6rWms");

var $jpEbX = parcelRequire("jpEbX");
/* Built-in method references that are verified to be native. */ var $a7c52047497babd6$var$WeakMap = (0, $6rWms.default)((0, $jpEbX.default), 'WeakMap');
var $a7c52047497babd6$export$2e2bcd8739ae039 = $a7c52047497babd6$var$WeakMap;

});


parcelRegister("8fJiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6022dd208021f4ee$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $6022dd208021f4ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6022dd208021f4ee$var$hasOwnProperty = $6022dd208021f4ee$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $6022dd208021f4ee$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $6022dd208021f4ee$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $6022dd208021f4ee$export$2e2bcd8739ae039 = $6022dd208021f4ee$var$initCloneArray;

});

parcelRegister("gQt7v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c438174b0111bbf8$export$2e2bcd8739ae039; });

var $6eYq6 = parcelRequire("6eYq6");

var $dw4YO = parcelRequire("dw4YO");

var $8tb0U = parcelRequire("8tb0U");

var $gUIP1 = parcelRequire("gUIP1");

var $bOpJc = parcelRequire("bOpJc");
/** `Object#toString` result references. */ var $c438174b0111bbf8$var$boolTag = '[object Boolean]', $c438174b0111bbf8$var$dateTag = '[object Date]', $c438174b0111bbf8$var$mapTag = '[object Map]', $c438174b0111bbf8$var$numberTag = '[object Number]', $c438174b0111bbf8$var$regexpTag = '[object RegExp]', $c438174b0111bbf8$var$setTag = '[object Set]', $c438174b0111bbf8$var$stringTag = '[object String]', $c438174b0111bbf8$var$symbolTag = '[object Symbol]';
var $c438174b0111bbf8$var$arrayBufferTag = '[object ArrayBuffer]', $c438174b0111bbf8$var$dataViewTag = '[object DataView]', $c438174b0111bbf8$var$float32Tag = '[object Float32Array]', $c438174b0111bbf8$var$float64Tag = '[object Float64Array]', $c438174b0111bbf8$var$int8Tag = '[object Int8Array]', $c438174b0111bbf8$var$int16Tag = '[object Int16Array]', $c438174b0111bbf8$var$int32Tag = '[object Int32Array]', $c438174b0111bbf8$var$uint8Tag = '[object Uint8Array]', $c438174b0111bbf8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c438174b0111bbf8$var$uint16Tag = '[object Uint16Array]', $c438174b0111bbf8$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $c438174b0111bbf8$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $c438174b0111bbf8$var$arrayBufferTag:
            return (0, $6eYq6.default)(object);
        case $c438174b0111bbf8$var$boolTag:
        case $c438174b0111bbf8$var$dateTag:
            return new Ctor(+object);
        case $c438174b0111bbf8$var$dataViewTag:
            return (0, $dw4YO.default)(object, isDeep);
        case $c438174b0111bbf8$var$float32Tag:
        case $c438174b0111bbf8$var$float64Tag:
        case $c438174b0111bbf8$var$int8Tag:
        case $c438174b0111bbf8$var$int16Tag:
        case $c438174b0111bbf8$var$int32Tag:
        case $c438174b0111bbf8$var$uint8Tag:
        case $c438174b0111bbf8$var$uint8ClampedTag:
        case $c438174b0111bbf8$var$uint16Tag:
        case $c438174b0111bbf8$var$uint32Tag:
            return (0, $bOpJc.default)(object, isDeep);
        case $c438174b0111bbf8$var$mapTag:
            return new Ctor;
        case $c438174b0111bbf8$var$numberTag:
        case $c438174b0111bbf8$var$stringTag:
            return new Ctor(object);
        case $c438174b0111bbf8$var$regexpTag:
            return (0, $8tb0U.default)(object);
        case $c438174b0111bbf8$var$setTag:
            return new Ctor;
        case $c438174b0111bbf8$var$symbolTag:
            return (0, $gUIP1.default)(object);
    }
}
var $c438174b0111bbf8$export$2e2bcd8739ae039 = $c438174b0111bbf8$var$initCloneByTag;

});
parcelRegister("6eYq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b2eb0cb0f9fb19$export$2e2bcd8739ae039; });

var $6E4ie = parcelRequire("6E4ie");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $48b2eb0cb0f9fb19$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $6E4ie.default)(result).set(new (0, $6E4ie.default)(arrayBuffer));
    return result;
}
var $48b2eb0cb0f9fb19$export$2e2bcd8739ae039 = $48b2eb0cb0f9fb19$var$cloneArrayBuffer;

});
parcelRegister("6E4ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d69cf02dbdf81c0$export$2e2bcd8739ae039; });

var $jpEbX = parcelRequire("jpEbX");
/** Built-in value references. */ var $4d69cf02dbdf81c0$var$Uint8Array = (0, $jpEbX.default).Uint8Array;
var $4d69cf02dbdf81c0$export$2e2bcd8739ae039 = $4d69cf02dbdf81c0$var$Uint8Array;

});


parcelRegister("dw4YO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d72206cc46729d4$export$2e2bcd8739ae039; });

var $6eYq6 = parcelRequire("6eYq6");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $9d72206cc46729d4$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $6eYq6.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $9d72206cc46729d4$export$2e2bcd8739ae039 = $9d72206cc46729d4$var$cloneDataView;

});

parcelRegister("8tb0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a9933c4536743e$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $62a9933c4536743e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $62a9933c4536743e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $62a9933c4536743e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $62a9933c4536743e$export$2e2bcd8739ae039 = $62a9933c4536743e$var$cloneRegExp;

});

parcelRegister("gUIP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c504a5068c3b84d2$export$2e2bcd8739ae039; });

var $lxt5K = parcelRequire("lxt5K");
/** Used to convert symbols to primitives and strings. */ var $c504a5068c3b84d2$var$symbolProto = (0, $lxt5K.default) ? (0, $lxt5K.default).prototype : undefined, $c504a5068c3b84d2$var$symbolValueOf = $c504a5068c3b84d2$var$symbolProto ? $c504a5068c3b84d2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $c504a5068c3b84d2$var$cloneSymbol(symbol) {
    return $c504a5068c3b84d2$var$symbolValueOf ? Object($c504a5068c3b84d2$var$symbolValueOf.call(symbol)) : {};
}
var $c504a5068c3b84d2$export$2e2bcd8739ae039 = $c504a5068c3b84d2$var$cloneSymbol;

});

parcelRegister("bOpJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8998524ac40dda70$export$2e2bcd8739ae039; });

var $6eYq6 = parcelRequire("6eYq6");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $8998524ac40dda70$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $6eYq6.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $8998524ac40dda70$export$2e2bcd8739ae039 = $8998524ac40dda70$var$cloneTypedArray;

});


parcelRegister("1g7ai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eacd7e79d7d82b4$export$2e2bcd8739ae039; });

var $bFggw = parcelRequire("bFggw");

var $bp1AU = parcelRequire("bp1AU");

var $gfIvj = parcelRequire("gfIvj");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0eacd7e79d7d82b4$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $gfIvj.default)(object) ? (0, $bFggw.default)((0, $bp1AU.default)(object)) : {};
}
var $0eacd7e79d7d82b4$export$2e2bcd8739ae039 = $0eacd7e79d7d82b4$var$initCloneObject;

});
parcelRegister("bFggw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87e02409bd7b1594$export$2e2bcd8739ae039; });

var $fxpzz = parcelRequire("fxpzz");
/** Built-in value references. */ var $87e02409bd7b1594$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $87e02409bd7b1594$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $fxpzz.default)(proto)) return {};
        if ($87e02409bd7b1594$var$objectCreate) return $87e02409bd7b1594$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $87e02409bd7b1594$export$2e2bcd8739ae039 = $87e02409bd7b1594$var$baseCreate;

});


parcelRegister("4p2BU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334b85a0aef4e3d7$export$2e2bcd8739ae039; });

var $b2eQ7 = parcelRequire("b2eQ7");

var $e6Upd = parcelRequire("e6Upd");

var $eay4C = parcelRequire("eay4C");
/* Node.js helper references. */ var $334b85a0aef4e3d7$var$nodeIsMap = (0, $eay4C.default) && (0, $eay4C.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $334b85a0aef4e3d7$var$isMap = $334b85a0aef4e3d7$var$nodeIsMap ? (0, $e6Upd.default)($334b85a0aef4e3d7$var$nodeIsMap) : (0, $b2eQ7.default);
var $334b85a0aef4e3d7$export$2e2bcd8739ae039 = $334b85a0aef4e3d7$var$isMap;

});
parcelRegister("b2eQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808b6477e60b20b1$export$2e2bcd8739ae039; });

var $lrwIc = parcelRequire("lrwIc");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $808b6477e60b20b1$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $808b6477e60b20b1$var$baseIsMap(value) {
    return (0, $96UVv.default)(value) && (0, $lrwIc.default)(value) == $808b6477e60b20b1$var$mapTag;
}
var $808b6477e60b20b1$export$2e2bcd8739ae039 = $808b6477e60b20b1$var$baseIsMap;

});


parcelRegister("gbrpx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc82efa24a1d143f$export$2e2bcd8739ae039; });

var $6xHEs = parcelRequire("6xHEs");

var $e6Upd = parcelRequire("e6Upd");

var $eay4C = parcelRequire("eay4C");
/* Node.js helper references. */ var $bc82efa24a1d143f$var$nodeIsSet = (0, $eay4C.default) && (0, $eay4C.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $bc82efa24a1d143f$var$isSet = $bc82efa24a1d143f$var$nodeIsSet ? (0, $e6Upd.default)($bc82efa24a1d143f$var$nodeIsSet) : (0, $6xHEs.default);
var $bc82efa24a1d143f$export$2e2bcd8739ae039 = $bc82efa24a1d143f$var$isSet;

});
parcelRegister("6xHEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c37af7273351431$export$2e2bcd8739ae039; });

var $lrwIc = parcelRequire("lrwIc");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $4c37af7273351431$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $4c37af7273351431$var$baseIsSet(value) {
    return (0, $96UVv.default)(value) && (0, $lrwIc.default)(value) == $4c37af7273351431$var$setTag;
}
var $4c37af7273351431$export$2e2bcd8739ae039 = $4c37af7273351431$var$baseIsSet;

});




parcelRegister("k5fqp", function(module, exports) {
'use strict';
var $e9f03d57e4622927$var$isArray = Array.isArray;
var $e9f03d57e4622927$var$keyList = Object.keys;
var $e9f03d57e4622927$var$hasProp = Object.prototype.hasOwnProperty;
var $e9f03d57e4622927$var$hasElementType = typeof Element !== 'undefined';
function $e9f03d57e4622927$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $e9f03d57e4622927$var$isArray(a), arrB = $e9f03d57e4622927$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$e9f03d57e4622927$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $e9f03d57e4622927$var$keyList(a);
        length = keys.length;
        if (length !== $e9f03d57e4622927$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$e9f03d57e4622927$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($e9f03d57e4622927$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$e9f03d57e4622927$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $e9f03d57e4622927$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("i2vOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2211882f486b230$export$2e2bcd8739ae039; });
var $d2211882f486b230$var$isProduction = true;
function $d2211882f486b230$var$warning(condition, message) {
    if (!$d2211882f486b230$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $d2211882f486b230$export$2e2bcd8739ae039 = $d2211882f486b230$var$warning;

});

parcelRegister("aS22v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea08782fc30a493$export$2e2bcd8739ae039; });

var $jt0Ic = parcelRequire("jt0Ic");
/** Used to compose bitmasks for cloning. */ var $7ea08782fc30a493$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $7ea08782fc30a493$var$clone(value) {
    return (0, $jt0Ic.default)(value, $7ea08782fc30a493$var$CLONE_SYMBOLS_FLAG);
}
var $7ea08782fc30a493$export$2e2bcd8739ae039 = $7ea08782fc30a493$var$clone;

});

parcelRegister("l8KrO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63e5fd4d59fb97c$export$2e2bcd8739ae039; });

var $kvMHV = parcelRequire("kvMHV");

var $2z32G = parcelRequire("2z32G");

var $9U1t4 = parcelRequire("9U1t4");

var $kEc0D = parcelRequire("kEc0D");

var $2AOzi = parcelRequire("2AOzi");

var $lljBh = parcelRequire("lljBh");

var $7emIM = parcelRequire("7emIM");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $f63e5fd4d59fb97c$var$toPath(value) {
    if ((0, $9U1t4.default)(value)) return (0, $kvMHV.default)(value, (0, $lljBh.default));
    return (0, $kEc0D.default)(value) ? [
        value
    ] : (0, $2z32G.default)((0, $2AOzi.default)((0, $7emIM.default)(value)));
}
var $f63e5fd4d59fb97c$export$2e2bcd8739ae039 = $f63e5fd4d59fb97c$var$toPath;

});
parcelRegister("kvMHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeec7c2a6a29f984$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $eeec7c2a6a29f984$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $eeec7c2a6a29f984$export$2e2bcd8739ae039 = $eeec7c2a6a29f984$var$arrayMap;

});

parcelRegister("kEc0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f080dbd8b758be9a$export$2e2bcd8739ae039; });

var $gwS9V = parcelRequire("gwS9V");

var $96UVv = parcelRequire("96UVv");
/** `Object#toString` result references. */ var $f080dbd8b758be9a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f080dbd8b758be9a$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $96UVv.default)(value) && (0, $gwS9V.default)(value) == $f080dbd8b758be9a$var$symbolTag;
}
var $f080dbd8b758be9a$export$2e2bcd8739ae039 = $f080dbd8b758be9a$var$isSymbol;

});

parcelRegister("2AOzi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e362b6080c72540$export$2e2bcd8739ae039; });

var $cPYsa = parcelRequire("cPYsa");
/** Used to match property names within property paths. */ var $1e362b6080c72540$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $1e362b6080c72540$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $1e362b6080c72540$var$stringToPath = (0, $cPYsa.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($1e362b6080c72540$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($1e362b6080c72540$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $1e362b6080c72540$export$2e2bcd8739ae039 = $1e362b6080c72540$var$stringToPath;

});
parcelRegister("cPYsa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9589243be8835631$export$2e2bcd8739ae039; });

var $8j9eJ = parcelRequire("8j9eJ");
/** Used as the maximum memoize cache size. */ var $9589243be8835631$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $9589243be8835631$var$memoizeCapped(func) {
    var result = (0, $8j9eJ.default)(func, function(key) {
        if (cache.size === $9589243be8835631$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $9589243be8835631$export$2e2bcd8739ae039 = $9589243be8835631$var$memoizeCapped;

});
parcelRegister("8j9eJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60c74346add333d2$export$2e2bcd8739ae039; });

var $a5acJ = parcelRequire("a5acJ");
/** Error message constants. */ var $60c74346add333d2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $60c74346add333d2$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($60c74346add333d2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($60c74346add333d2$var$memoize.Cache || (0, $a5acJ.default));
    return memoized;
}
// Expose `MapCache`.
$60c74346add333d2$var$memoize.Cache = (0, $a5acJ.default);
var $60c74346add333d2$export$2e2bcd8739ae039 = $60c74346add333d2$var$memoize;

});



parcelRegister("lljBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89ac359bdef5862$export$2e2bcd8739ae039; });

var $kEc0D = parcelRequire("kEc0D");
/** Used as references for various `Number` constants. */ var $f89ac359bdef5862$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f89ac359bdef5862$var$toKey(value) {
    if (typeof value == 'string' || (0, $kEc0D.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$f89ac359bdef5862$var$INFINITY ? '-0' : result;
}
var $f89ac359bdef5862$export$2e2bcd8739ae039 = $f89ac359bdef5862$var$toKey;

});

parcelRegister("7emIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $543b7728bb9c7346$export$2e2bcd8739ae039; });

var $40F4h = parcelRequire("40F4h");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $543b7728bb9c7346$var$toString(value) {
    return value == null ? '' : (0, $40F4h.default)(value);
}
var $543b7728bb9c7346$export$2e2bcd8739ae039 = $543b7728bb9c7346$var$toString;

});
parcelRegister("40F4h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eb704c802c9e645$export$2e2bcd8739ae039; });

var $lxt5K = parcelRequire("lxt5K");

var $kvMHV = parcelRequire("kvMHV");

var $9U1t4 = parcelRequire("9U1t4");

var $kEc0D = parcelRequire("kEc0D");
/** Used as references for various `Number` constants. */ var $2eb704c802c9e645$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2eb704c802c9e645$var$symbolProto = (0, $lxt5K.default) ? (0, $lxt5K.default).prototype : undefined, $2eb704c802c9e645$var$symbolToString = $2eb704c802c9e645$var$symbolProto ? $2eb704c802c9e645$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2eb704c802c9e645$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $9U1t4.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $kvMHV.default)(value, $2eb704c802c9e645$var$baseToString) + '';
    if ((0, $kEc0D.default)(value)) return $2eb704c802c9e645$var$symbolToString ? $2eb704c802c9e645$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$2eb704c802c9e645$var$INFINITY ? '-0' : result;
}
var $2eb704c802c9e645$export$2e2bcd8739ae039 = $2eb704c802c9e645$var$baseToString;

});




parcelRegister("ePjyc", function(module, exports) {

var $ad9xy = parcelRequire("ad9xy");

var $85Fej = parcelRequire("85Fej");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $ad9xy.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $85Fej;
module.exports = isBuffer;

});
parcelRegister("ad9xy", function(module, exports) {

var $kh18z = parcelRequire("kh18z");
/** Detect free variable `self`. */ var $76f284c995254255$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $76f284c995254255$var$root = $kh18z || $76f284c995254255$var$freeSelf || Function('return this')();
module.exports = $76f284c995254255$var$root;

});
parcelRegister("kh18z", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ec2646ff010cd4f3$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ec2646ff010cd4f3$var$freeGlobal;

});


parcelRegister("85Fej", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $5e3ec5c17925907f$var$stubFalse() {
    return false;
}
module.exports = $5e3ec5c17925907f$var$stubFalse;

});


parcelRegister("21HyH", function(module, exports) {

var $kh18z = parcelRequire("kh18z");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $kh18z.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("58bog", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $3bc688ff49b88c4e$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $3bc688ff49b88c4e$export$2e2bcd8739ae039 = fn;

});

parcelRegister("32m8d", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $gVlpF.default;
    }
});

var $gVlpF = parcelRequire("gVlpF");

});
parcelRegister("gVlpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c522945ed2253423$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $uKtfw = parcelRequire("uKtfw");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $c522945ed2253423$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $uKtfw.default), (0, $erOpW.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $uKtfw.default).muiName;
    return /*#__PURE__*/ $jSIPP.memo(/*#__PURE__*/ $jSIPP.forwardRef(Component));
}

});
parcelRegister("uKtfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05c6d99519711623$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $iLAKr = parcelRequire("iLAKr");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $2joa6 = parcelRequire("2joa6");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $05c6d99519711623$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $05c6d99519711623$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $iLAKr.default)(color)}`,
            `fontSize${(0, $iLAKr.default)(fontSize)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $2joa6.getSvgIconUtilityClass), classes);
};
const $05c6d99519711623$var$SvgIconRoot = (0, $28RyA.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
            styles[`fontSize${(0, $iLAKr.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $05c6d99519711623$var$SvgIcon = /*#__PURE__*/ $jSIPP.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $cMu4A.default)(props, $05c6d99519711623$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $jSIPP.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $05c6d99519711623$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($05c6d99519711623$var$SvgIconRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $4uaIU.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$05c6d99519711623$var$SvgIcon.muiName = 'SvgIcon';
var $05c6d99519711623$export$2e2bcd8739ae039 = $05c6d99519711623$var$SvgIcon;

});
parcelRegister("86B3v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a601911f6d57ecc$export$2e2bcd8739ae039; });
function $8a601911f6d57ecc$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $8a601911f6d57ecc$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $8a601911f6d57ecc$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $8a601911f6d57ecc$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8a601911f6d57ecc$export$2e2bcd8739ae039 = $8a601911f6d57ecc$export$4f5d2d50c9deca37;

});

parcelRegister("i3Yji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2674a243304e75f$export$2e2bcd8739ae039; });
function $d2674a243304e75f$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("iLAKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da991f343865c6aa$export$2e2bcd8739ae039; });

var $61i5U = parcelRequire("61i5U");
var $da991f343865c6aa$export$2e2bcd8739ae039 = (0, $61i5U.default);

});

parcelRegister("eyQWd", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $a99d4e0f799d9538$export$2440da353cedad43; });

var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $RDVEV = parcelRequire("RDVEV");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $a99d4e0f799d9538$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $RDVEV.default), (0, $erOpW.default)({}, props));
}
var $a99d4e0f799d9538$export$2e2bcd8739ae039 = $a99d4e0f799d9538$var$DefaultPropsProvider;
function $a99d4e0f799d9538$export$2440da353cedad43(params) {
    return (0, $RDVEV.useDefaultProps)(params);
}

});
parcelRegister("RDVEV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $0a13ec6aab26ac6f$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $0a13ec6aab26ac6f$export$2e2bcd8739ae039; });

var $jSIPP = parcelRequire("jSIPP");


var $3Tcpe = parcelRequire("3Tcpe");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $0a13ec6aab26ac6f$var$PropsContext = /*#__PURE__*/ $jSIPP.createContext(undefined);
function $0a13ec6aab26ac6f$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)($0a13ec6aab26ac6f$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $0a13ec6aab26ac6f$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $3Tcpe.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $3Tcpe.default)(config, props);
    return props;
}
function $0a13ec6aab26ac6f$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $jSIPP.useContext($0a13ec6aab26ac6f$var$PropsContext);
    return $0a13ec6aab26ac6f$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $0a13ec6aab26ac6f$export$2e2bcd8739ae039 = $0a13ec6aab26ac6f$var$DefaultPropsProvider;

});
parcelRegister("3Tcpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d5021bc36a86965$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");
function $2d5021bc36a86965$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $erOpW.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $erOpW.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $erOpW.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $2d5021bc36a86965$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("28RyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18f5df67bb9d1f45$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("hDFpT")).default; });

var $4fZMU = parcelRequire("4fZMU");

var $kq7Gb = parcelRequire("kq7Gb");

var $iX5qO = parcelRequire("iX5qO");

var $hDFpT = parcelRequire("hDFpT");

var $aSAhh = parcelRequire("aSAhh");
'use client';
const $18f5df67bb9d1f45$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($4fZMU)))({
    themeId: (0, $iX5qO.default),
    defaultTheme: $kq7Gb.default,
    rootShouldForwardProp: $hDFpT.default
});
var $18f5df67bb9d1f45$export$2e2bcd8739ae039 = $18f5df67bb9d1f45$var$styled;

});
parcelRegister("4fZMU", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31987ded1b20c15f$var$createStyled;
module.exports.shouldForwardProp = $31987ded1b20c15f$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $31987ded1b20c15f$var$_extends2 = $1rPoN((parcelRequire("1Gnf1")));

var $31987ded1b20c15f$var$_objectWithoutPropertiesLoose2 = $1rPoN((parcelRequire("6kSKS")));

var $31987ded1b20c15f$var$_styledEngine = $31987ded1b20c15f$var$_interopRequireWildcard((parcelRequire("j3GPk")));

var $2TupR = parcelRequire("2TupR");

var $31987ded1b20c15f$var$_capitalize = $1rPoN((parcelRequire("beDEc")));

var $31987ded1b20c15f$var$_getDisplayName = $1rPoN((parcelRequire("e2iNU")));

var $31987ded1b20c15f$var$_createTheme = $1rPoN((parcelRequire("qsHMF")));

var $31987ded1b20c15f$var$_styleFunctionSx = $1rPoN((parcelRequire("13B2F")));
const $31987ded1b20c15f$var$_excluded = [
    "ownerState"
], $31987ded1b20c15f$var$_excluded2 = [
    "variants"
], $31987ded1b20c15f$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $31987ded1b20c15f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($31987ded1b20c15f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $31987ded1b20c15f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $31987ded1b20c15f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $31987ded1b20c15f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $31987ded1b20c15f$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $31987ded1b20c15f$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $31987ded1b20c15f$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $31987ded1b20c15f$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $31987ded1b20c15f$var$_createTheme.default)();
const $31987ded1b20c15f$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $31987ded1b20c15f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $31987ded1b20c15f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $31987ded1b20c15f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $31987ded1b20c15f$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $31987ded1b20c15f$var$_objectWithoutPropertiesLoose2.default)(_ref, $31987ded1b20c15f$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $31987ded1b20c15f$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$31987ded1b20c15f$var$processStyleArg(resolvedStyle, (0, $31987ded1b20c15f$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $31987ded1b20c15f$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $31987ded1b20c15f$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $31987ded1b20c15f$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $31987ded1b20c15f$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $31987ded1b20c15f$var$shallowLayer((0, $31987ded1b20c15f$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $31987ded1b20c15f$var$shallowLayer((0, $31987ded1b20c15f$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $31987ded1b20c15f$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $31987ded1b20c15f$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $31987ded1b20c15f$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $31987ded1b20c15f$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $31987ded1b20c15f$var$_styleFunctionSx.default)((0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
            theme: $31987ded1b20c15f$var$resolveTheme((0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $31987ded1b20c15f$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $31987ded1b20c15f$var$defaultOverridesResolver($31987ded1b20c15f$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $31987ded1b20c15f$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $31987ded1b20c15f$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $31987ded1b20c15f$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($31987ded1b20c15f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $31987ded1b20c15f$var$_styledEngine.default)(tag, (0, $31987ded1b20c15f$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $2TupR.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $31987ded1b20c15f$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $31987ded1b20c15f$var$processStyleArg(stylesArg, (0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $31987ded1b20c15f$var$resolveTheme((0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $31987ded1b20c15f$var$processStyleArg(slotStyle, (0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $31987ded1b20c15f$var$resolveTheme((0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $31987ded1b20c15f$var$processStyleArg({
                    variants: themeVariants
                }, (0, $31987ded1b20c15f$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1rPoN", function(module, exports) {
function $10e02ecf9090bc17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $10e02ecf9090bc17$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kq7Gb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eddc315807c2b427$export$2e2bcd8739ae039; });

var $ct73g = parcelRequire("ct73g");
'use client';
const $eddc315807c2b427$var$defaultTheme = (0, $ct73g.default)();
var $eddc315807c2b427$export$2e2bcd8739ae039 = $eddc315807c2b427$var$defaultTheme;

});
parcelRegister("ct73g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $913da9c64b9972d0$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $7ONYC = parcelRequire("7ONYC");

var $2TupR = parcelRequire("2TupR");

var $4bG06 = parcelRequire("4bG06");
var $eNwMf = parcelRequire("eNwMf");

var $gDcI8 = parcelRequire("gDcI8");


var $bQmLi = parcelRequire("bQmLi");

var $cJKKJ = parcelRequire("cJKKJ");

var $4BoZY = parcelRequire("4BoZY");

var $9pb26 = parcelRequire("9pb26");

var $cl3zs = parcelRequire("cl3zs");

var $eNBey = parcelRequire("eNBey");
const $913da9c64b9972d0$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $913da9c64b9972d0$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cMu4A.default)(options, $913da9c64b9972d0$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $7ONYC.default)(18));
    const palette = (0, $cJKKJ.default)(paletteInput);
    const systemTheme = (0, $gDcI8.default)(options);
    let muiTheme = (0, $2TupR.default)(systemTheme, {
        mixins: (0, $bQmLi.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $9pb26.default).slice(),
        typography: (0, $4BoZY.default)(palette, typographyInput),
        transitions: (0, $cl3zs.default)(transitionsInput),
        zIndex: (0, $erOpW.default)({}, (0, $eNBey.default))
    });
    muiTheme = (0, $2TupR.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $2TupR.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $erOpW.default)({}, (0, $eNwMf.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $4bG06.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $913da9c64b9972d0$var$warnedOnce = false;
function $913da9c64b9972d0$export$c469355549431d9b(...args) {
    return $913da9c64b9972d0$var$createTheme(...args);
}
var $913da9c64b9972d0$export$2e2bcd8739ae039 = $913da9c64b9972d0$var$createTheme;

});
parcelRegister("bQmLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89f635174fe7b3ab$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");
function $89f635174fe7b3ab$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $erOpW.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("cJKKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945df41c32d333ad$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $7ONYC = parcelRequire("7ONYC");

var $2TupR = parcelRequire("2TupR");

var $hnF8Y = parcelRequire("hnF8Y");

var $flwUJ = parcelRequire("flwUJ");

var $6Pn0m = parcelRequire("6Pn0m");

var $h207q = parcelRequire("h207q");

var $hiHHm = parcelRequire("hiHHm");

var $jT1UJ = parcelRequire("jT1UJ");

var $bBaCB = parcelRequire("bBaCB");

var $dTXr4 = parcelRequire("dTXr4");

var $cIygu = parcelRequire("cIygu");
const $945df41c32d333ad$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $945df41c32d333ad$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $flwUJ.default).white,
        default: (0, $flwUJ.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $945df41c32d333ad$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $flwUJ.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $flwUJ.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $945df41c32d333ad$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $hnF8Y.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $hnF8Y.darken)(intent.main, tonalOffsetDark);
    }
}
function $945df41c32d333ad$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bBaCB.default)[200],
        light: (0, $bBaCB.default)[50],
        dark: (0, $bBaCB.default)[400]
    };
    return {
        main: (0, $bBaCB.default)[700],
        light: (0, $bBaCB.default)[400],
        dark: (0, $bBaCB.default)[800]
    };
}
function $945df41c32d333ad$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $h207q.default)[200],
        light: (0, $h207q.default)[50],
        dark: (0, $h207q.default)[400]
    };
    return {
        main: (0, $h207q.default)[500],
        light: (0, $h207q.default)[300],
        dark: (0, $h207q.default)[700]
    };
}
function $945df41c32d333ad$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hiHHm.default)[500],
        light: (0, $hiHHm.default)[300],
        dark: (0, $hiHHm.default)[700]
    };
    return {
        main: (0, $hiHHm.default)[700],
        light: (0, $hiHHm.default)[400],
        dark: (0, $hiHHm.default)[800]
    };
}
function $945df41c32d333ad$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dTXr4.default)[400],
        light: (0, $dTXr4.default)[300],
        dark: (0, $dTXr4.default)[700]
    };
    return {
        main: (0, $dTXr4.default)[700],
        light: (0, $dTXr4.default)[500],
        dark: (0, $dTXr4.default)[900]
    };
}
function $945df41c32d333ad$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $cIygu.default)[400],
        light: (0, $cIygu.default)[300],
        dark: (0, $cIygu.default)[700]
    };
    return {
        main: (0, $cIygu.default)[800],
        light: (0, $cIygu.default)[500],
        dark: (0, $cIygu.default)[900]
    };
}
function $945df41c32d333ad$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $jT1UJ.default)[400],
        light: (0, $jT1UJ.default)[300],
        dark: (0, $jT1UJ.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $jT1UJ.default)[500],
        dark: (0, $jT1UJ.default)[900]
    };
}
function $945df41c32d333ad$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cMu4A.default)(palette, $945df41c32d333ad$var$_excluded);
    const primary = palette.primary || $945df41c32d333ad$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $945df41c32d333ad$var$getDefaultSecondary(mode);
    const error = palette.error || $945df41c32d333ad$var$getDefaultError(mode);
    const info = palette.info || $945df41c32d333ad$var$getDefaultInfo(mode);
    const success = palette.success || $945df41c32d333ad$var$getDefaultSuccess(mode);
    const warning = palette.warning || $945df41c32d333ad$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $hnF8Y.getContrastRatio)(background, $945df41c32d333ad$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $945df41c32d333ad$export$55ce6f3a06c59543.text.primary : $945df41c32d333ad$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $erOpW.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $7ONYC.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $7ONYC.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $945df41c32d333ad$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $945df41c32d333ad$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $945df41c32d333ad$export$55ce6f3a06c59543,
        light: $945df41c32d333ad$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $2TupR.default)((0, $erOpW.default)({
        // A collection of common colors.
        common: (0, $erOpW.default)({}, (0, $flwUJ.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $6Pn0m.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("hnF8Y", function(module, exports) {
"use strict";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $ca747ff45fec440c$var$alpha;
module.exports.blend = $ca747ff45fec440c$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $ca747ff45fec440c$var$darken;
module.exports.decomposeColor = $ca747ff45fec440c$var$decomposeColor;
module.exports.emphasize = $ca747ff45fec440c$var$emphasize;
module.exports.getContrastRatio = $ca747ff45fec440c$var$getContrastRatio;
module.exports.getLuminance = $ca747ff45fec440c$var$getLuminance;
module.exports.hexToRgb = $ca747ff45fec440c$var$hexToRgb;
module.exports.hslToRgb = $ca747ff45fec440c$var$hslToRgb;
module.exports.lighten = $ca747ff45fec440c$var$lighten;
module.exports.private_safeAlpha = $ca747ff45fec440c$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $ca747ff45fec440c$var$private_safeDarken;
module.exports.private_safeEmphasize = $ca747ff45fec440c$var$private_safeEmphasize;
module.exports.private_safeLighten = $ca747ff45fec440c$var$private_safeLighten;
module.exports.recomposeColor = $ca747ff45fec440c$var$recomposeColor;
module.exports.rgbToHex = $ca747ff45fec440c$var$rgbToHex;

var $ca747ff45fec440c$var$_formatMuiErrorMessage2 = $1rPoN((parcelRequire("7JymB")));

var $ca747ff45fec440c$var$_clamp = $1rPoN((parcelRequire("lJggu")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ca747ff45fec440c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $ca747ff45fec440c$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $ca747ff45fec440c$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $ca747ff45fec440c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $ca747ff45fec440c$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $ca747ff45fec440c$var$decomposeColor($ca747ff45fec440c$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $ca747ff45fec440c$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $ca747ff45fec440c$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $ca747ff45fec440c$var$colorChannel = (color)=>{
    const decomposedColor = $ca747ff45fec440c$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $ca747ff45fec440c$var$colorChannel;
const $ca747ff45fec440c$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $ca747ff45fec440c$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $ca747ff45fec440c$var$private_safeColorChannel;
function $ca747ff45fec440c$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $ca747ff45fec440c$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $ca747ff45fec440c$var$decomposeColor(color);
    return `#${values.map((n, i)=>$ca747ff45fec440c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $ca747ff45fec440c$var$hslToRgb(color) {
    color = $ca747ff45fec440c$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $ca747ff45fec440c$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $ca747ff45fec440c$var$getLuminance(color) {
    color = $ca747ff45fec440c$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $ca747ff45fec440c$var$decomposeColor($ca747ff45fec440c$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $ca747ff45fec440c$var$getContrastRatio(foreground, background) {
    const lumA = $ca747ff45fec440c$var$getLuminance(foreground);
    const lumB = $ca747ff45fec440c$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $ca747ff45fec440c$var$alpha(color, value) {
    color = $ca747ff45fec440c$var$decomposeColor(color);
    value = $ca747ff45fec440c$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ca747ff45fec440c$var$recomposeColor(color);
}
function $ca747ff45fec440c$var$private_safeAlpha(color, value, warning) {
    try {
        return $ca747ff45fec440c$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $ca747ff45fec440c$var$darken(color, coefficient) {
    color = $ca747ff45fec440c$var$decomposeColor(color);
    coefficient = $ca747ff45fec440c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ca747ff45fec440c$var$recomposeColor(color);
}
function $ca747ff45fec440c$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $ca747ff45fec440c$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $ca747ff45fec440c$var$lighten(color, coefficient) {
    color = $ca747ff45fec440c$var$decomposeColor(color);
    coefficient = $ca747ff45fec440c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ca747ff45fec440c$var$recomposeColor(color);
}
function $ca747ff45fec440c$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $ca747ff45fec440c$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $ca747ff45fec440c$var$emphasize(color, coefficient = 0.15) {
    return $ca747ff45fec440c$var$getLuminance(color) > 0.5 ? $ca747ff45fec440c$var$darken(color, coefficient) : $ca747ff45fec440c$var$lighten(color, coefficient);
}
function $ca747ff45fec440c$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $ca747ff45fec440c$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $ca747ff45fec440c$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $ca747ff45fec440c$var$decomposeColor(background);
    const overlayColor = $ca747ff45fec440c$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $ca747ff45fec440c$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("flwUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2c259320bdf65a3$export$2e2bcd8739ae039; });
const $b2c259320bdf65a3$var$common = {
    black: '#000',
    white: '#fff'
};
var $b2c259320bdf65a3$export$2e2bcd8739ae039 = $b2c259320bdf65a3$var$common;

});

parcelRegister("6Pn0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f8959c6ed5cdc42$export$2e2bcd8739ae039; });
const $4f8959c6ed5cdc42$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $4f8959c6ed5cdc42$export$2e2bcd8739ae039 = $4f8959c6ed5cdc42$var$grey;

});

parcelRegister("h207q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $033323fc799a81e3$export$2e2bcd8739ae039; });
const $033323fc799a81e3$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $033323fc799a81e3$export$2e2bcd8739ae039 = $033323fc799a81e3$var$purple;

});

parcelRegister("hiHHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c98603ace82d6d5e$export$2e2bcd8739ae039; });
const $c98603ace82d6d5e$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $c98603ace82d6d5e$export$2e2bcd8739ae039 = $c98603ace82d6d5e$var$red;

});

parcelRegister("jT1UJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7a4a37896e04a56$export$2e2bcd8739ae039; });
const $e7a4a37896e04a56$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $e7a4a37896e04a56$export$2e2bcd8739ae039 = $e7a4a37896e04a56$var$orange;

});

parcelRegister("bBaCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $871b639e6bca7dd8$export$2e2bcd8739ae039; });
const $871b639e6bca7dd8$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $871b639e6bca7dd8$export$2e2bcd8739ae039 = $871b639e6bca7dd8$var$blue;

});

parcelRegister("dTXr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1ee8412f975e479$export$2e2bcd8739ae039; });
const $a1ee8412f975e479$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $a1ee8412f975e479$export$2e2bcd8739ae039 = $a1ee8412f975e479$var$lightBlue;

});

parcelRegister("cIygu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94242c68f788391b$export$2e2bcd8739ae039; });
const $94242c68f788391b$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $94242c68f788391b$export$2e2bcd8739ae039 = $94242c68f788391b$var$green;

});


parcelRegister("4BoZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359e02576113e4bf$export$2e2bcd8739ae039; });

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $2TupR = parcelRequire("2TupR");
const $359e02576113e4bf$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $359e02576113e4bf$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $359e02576113e4bf$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $359e02576113e4bf$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $359e02576113e4bf$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $359e02576113e4bf$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cMu4A.default)(_ref, $359e02576113e4bf$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $erOpW.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $359e02576113e4bf$var$defaultFontFamily ? {
            letterSpacing: `${$359e02576113e4bf$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $359e02576113e4bf$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $359e02576113e4bf$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $2TupR.default)((0, $erOpW.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("9pb26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8f01c976a14a8d$export$2e2bcd8739ae039; });
const $6d8f01c976a14a8d$var$shadowKeyUmbraOpacity = 0.2;
const $6d8f01c976a14a8d$var$shadowKeyPenumbraOpacity = 0.14;
const $6d8f01c976a14a8d$var$shadowAmbientShadowOpacity = 0.12;
function $6d8f01c976a14a8d$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$6d8f01c976a14a8d$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$6d8f01c976a14a8d$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$6d8f01c976a14a8d$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $6d8f01c976a14a8d$var$shadows = [
    'none',
    $6d8f01c976a14a8d$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $6d8f01c976a14a8d$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $6d8f01c976a14a8d$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $6d8f01c976a14a8d$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $6d8f01c976a14a8d$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $6d8f01c976a14a8d$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $6d8f01c976a14a8d$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $6d8f01c976a14a8d$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $6d8f01c976a14a8d$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $6d8f01c976a14a8d$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $6d8f01c976a14a8d$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $6d8f01c976a14a8d$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $6d8f01c976a14a8d$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $6d8f01c976a14a8d$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $6d8f01c976a14a8d$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $6d8f01c976a14a8d$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $6d8f01c976a14a8d$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $6d8f01c976a14a8d$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $6d8f01c976a14a8d$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $6d8f01c976a14a8d$export$2e2bcd8739ae039 = $6d8f01c976a14a8d$var$shadows;

});

parcelRegister("cl3zs", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $8fba374fb9cc5b50$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $8fba374fb9cc5b50$export$2e2bcd8739ae039; });

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");
const $8fba374fb9cc5b50$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $8fba374fb9cc5b50$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $8fba374fb9cc5b50$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $8fba374fb9cc5b50$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $8fba374fb9cc5b50$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $8fba374fb9cc5b50$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $erOpW.default)({}, $8fba374fb9cc5b50$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $erOpW.default)({}, $8fba374fb9cc5b50$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cMu4A.default)(options, $8fba374fb9cc5b50$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $8fba374fb9cc5b50$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $8fba374fb9cc5b50$var$formatMs(delay)}`).join(',');
    };
    return (0, $erOpW.default)({
        getAutoHeightDuration: $8fba374fb9cc5b50$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("eNBey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac62862350dc73c9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ac62862350dc73c9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ac62862350dc73c9$export$2e2bcd8739ae039 = $ac62862350dc73c9$var$zIndex;

});



parcelRegister("iX5qO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcc1f341d9c1df3a$export$2e2bcd8739ae039; });
var $dcc1f341d9c1df3a$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("hDFpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd7634a733deb2f2$export$2e2bcd8739ae039; });

var $aSAhh = parcelRequire("aSAhh");
const $cd7634a733deb2f2$var$rootShouldForwardProp = (prop)=>(0, $aSAhh.default)(prop) && prop !== 'classes';
var $cd7634a733deb2f2$export$2e2bcd8739ae039 = $cd7634a733deb2f2$var$rootShouldForwardProp;

});
parcelRegister("aSAhh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ebb168a87232792$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $7ebb168a87232792$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $7ebb168a87232792$export$2e2bcd8739ae039 = $7ebb168a87232792$var$slotShouldForwardProp;

});



parcelRegister("2joa6", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $1af0192de5cbb060$export$c7c50641356bdfa5; });

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $1af0192de5cbb060$export$c7c50641356bdfa5(slot) {
    return (0, $geF11.default)('MuiSvgIcon', slot);
}
const $1af0192de5cbb060$var$svgIconClasses = (0, $rARwS.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $1af0192de5cbb060$export$2e2bcd8739ae039 = $1af0192de5cbb060$var$svgIconClasses;

});
parcelRegister("rARwS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $052f1dd4b3989d03$export$2e2bcd8739ae039; });

var $geF11 = parcelRequire("geF11");
function $052f1dd4b3989d03$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $geF11.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("geF11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1dc4f39df9fce1$export$2e2bcd8739ae039; });

var $9vnzz = parcelRequire("9vnzz");
const $bd1dc4f39df9fce1$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $bd1dc4f39df9fce1$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $bd1dc4f39df9fce1$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $9vnzz.default).generate(componentName)}-${slot}`;
}
function $bd1dc4f39df9fce1$export$34c0130b1f3e8ae3(slot) {
    return $bd1dc4f39df9fce1$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("9vnzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb94b59c3b38b1c$export$2e2bcd8739ae039; });
const $6eb94b59c3b38b1c$var$defaultGenerator = (componentName)=>componentName;
const $6eb94b59c3b38b1c$var$createClassNameGenerator = ()=>{
    let generate = $6eb94b59c3b38b1c$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $6eb94b59c3b38b1c$var$defaultGenerator;
        }
    };
};
const $6eb94b59c3b38b1c$var$ClassNameGenerator = $6eb94b59c3b38b1c$var$createClassNameGenerator();
var $6eb94b59c3b38b1c$export$2e2bcd8739ae039 = $6eb94b59c3b38b1c$var$ClassNameGenerator;

});







parcelRegister("fIt1N", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $erOpW = parcelRequire("erOpW");

var $llCtR = parcelRequire("llCtR");

var $i2vOQ = parcelRequire("i2vOQ");

var $4vDmR = parcelRequire("4vDmR");

var $22rg6 = parcelRequire("22rg6");

var $ccFUg = parcelRequire("ccFUg");

var $cMu4A = parcelRequire("cMu4A");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $22rg6.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $ccFUg.default)((0, $ccFUg.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $erOpW.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $4vDmR.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $erOpW.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $erOpW.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $erOpW.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $22rg6.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $erOpW.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $erOpW.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $erOpW.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $erOpW.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $cMu4A.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $4vDmR.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $llCtR.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $erOpW.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $erOpW.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $erOpW.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $i2vOQ.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $i2vOQ.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $4vDmR.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $b7117b6e65070a7a$export$2e2bcd8739ae039 = index;

});
parcelRegister("llCtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8a96896ef9f9e6a$export$2e2bcd8739ae039; });
var $f8a96896ef9f9e6a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $f8a96896ef9f9e6a$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $f8a96896ef9f9e6a$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $f8a96896ef9f9e6a$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $f8a96896ef9f9e6a$export$2e2bcd8739ae039 = $f8a96896ef9f9e6a$export$4e09c449d6c407f7;

});

parcelRegister("4vDmR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $348898449673412a$export$2e2bcd8739ae039; });

var $dBoEs = parcelRequire("dBoEs");
function $348898449673412a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $dBoEs.default)(o.key), o);
    }
}
function $348898449673412a$export$2e2bcd8739ae039(e, r, t) {
    return r && $348898449673412a$var$_defineProperties(e.prototype, r), t && $348898449673412a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("dBoEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e71da5648238fcc$export$2e2bcd8739ae039; });

var $2AMwG = parcelRequire("2AMwG");

var $5SyJK = parcelRequire("5SyJK");
function $9e71da5648238fcc$export$2e2bcd8739ae039(t) {
    var i = (0, $5SyJK.default)(t, "string");
    return "symbol" == (0, $2AMwG.default)(i) ? i : i + "";
}

});
parcelRegister("2AMwG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3495db473c04e2$export$2e2bcd8739ae039; });
function $1e3495db473c04e2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1e3495db473c04e2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e3495db473c04e2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5SyJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $447cf0f01ba20ed9$export$2e2bcd8739ae039; });

var $2AMwG = parcelRequire("2AMwG");
function $447cf0f01ba20ed9$export$2e2bcd8739ae039(t, e) {
    if ("object" != (0, $2AMwG.default)(t) || !t) return t;
    var r;
    if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) {
        var i = r.call(t, e || "default");
        if ("object" != (0, $2AMwG.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}

});



parcelRegister("22rg6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c0e9ace78cc8e8$export$2e2bcd8739ae039; });

var $6Bbae = parcelRequire("6Bbae");
function $17c0e9ace78cc8e8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $6Bbae.default)(t, o);
}

});
parcelRegister("6Bbae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cdedbb35842c754$export$2e2bcd8739ae039; });
function $4cdedbb35842c754$export$2e2bcd8739ae039(t, e) {
    return $4cdedbb35842c754$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4cdedbb35842c754$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("ccFUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e271cc9abd2c9d3$export$2e2bcd8739ae039; });
function $8e271cc9abd2c9d3$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("26IBV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $188ebf0fb21a217d$var$ReactIs, $188ebf0fb21a217d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("kHujd"))();

});

var $d4ca426cabe2d4d4$exports = {};
$parcel$extendImportMap({
    "3FzEg": "ntell-logo.b319aea6.png"
});


var $4uaIU = parcelRequire("4uaIU");
/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // Logging constants
var $76aa9856a7a73372$export$480ff6141d16ea0 = 26;
var $76aa9856a7a73372$export$b28184bf79b04783 = 1048576;
var $76aa9856a7a73372$export$a21f820c9933d674 = 256000;
var $76aa9856a7a73372$export$13470c6f1642bbce = 'Logging';
var $76aa9856a7a73372$export$d781556e70493844 = 'AWSCloudWatch';
var $76aa9856a7a73372$export$9a85ff898770a423 = 'No credentials';
var $76aa9856a7a73372$export$569d67cd7966b708 = [
    'ResourceNotFoundException',
    'InvalidSequenceTokenException'
];


var $169cd1937805fb62$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $169cd1937805fb62$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $169cd1937805fb62$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($169cd1937805fb62$var$__read(arguments[i]));
    return ar;
};
var $169cd1937805fb62$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var $169cd1937805fb62$export$ee432113040024a6;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})($169cd1937805fb62$export$ee432113040024a6 || ($169cd1937805fb62$export$ee432113040024a6 = {}));
/**
 * Write logs
 * @class Logger
 */ var $169cd1937805fb62$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = $169cd1937805fb62$export$ee432113040024a6.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $169cd1937805fb62$var$LOG_LEVELS[logger_level_name];
        var type_level = $169cd1937805fb62$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === $169cd1937805fb62$export$ee432113040024a6.ERROR && console.error) log = console.error.bind(console);
        if (type === $169cd1937805fb62$export$ee432113040024a6.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        var message = '';
        if (msg.length === 1 && typeof msg[0] === 'string') {
            message = prefix + " - " + msg[0];
            log(message);
        } else if (msg.length === 1) {
            message = prefix + " " + msg[0];
            log(prefix, msg[0]);
        } else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = prefix + " - " + msg[0] + " " + obj;
            log(prefix + " - " + msg[0], obj);
        } else {
            message = prefix + " " + msg;
            log(prefix, msg);
        }
        try {
            for(var _b = $169cd1937805fb62$var$__values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.INFO
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.INFO
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.WARN
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.ERROR
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.DEBUG
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $169cd1937805fb62$var$__spread([
            $169cd1937805fb62$export$ee432113040024a6.VERBOSE
        ], msg));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $76aa9856a7a73372$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $5af950529fc36b5c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5af950529fc36b5c$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Amplify');
var $5af950529fc36b5c$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Logger = (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $5af950529fc36b5c$var$logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $5af950529fc36b5c$var$logger.debug('no getModuleName method for component', comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $5af950529fc36b5c$var$logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $5af950529fc36b5c$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable['getCategory'] && typeof pluggable['getCategory'] === 'function') this._components.map(function(comp) {
            if (comp['addPluggable'] && typeof comp['addPluggable'] === 'function') comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $5af950529fc36b5c$export$a3858a9a153cffc7 = new $5af950529fc36b5c$export$b412d755cfa0136();
var /**
 * @deprecated use named import
 */ $5af950529fc36b5c$export$2e2bcd8739ae039 = $5af950529fc36b5c$export$a3858a9a153cffc7;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // generated by genversion
var $4b84ade21bc2451e$export$83d89fbfd8236492 = '4.7.14';


var $8eca817bf49e3d6a$var$BASE_USER_AGENT = "aws-amplify/" + (0, $4b84ade21bc2451e$export$83d89fbfd8236492);
var $8eca817bf49e3d6a$export$2dffd0b5373a4389 = {
    userAgent: $8eca817bf49e3d6a$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $8eca817bf49e3d6a$export$2dffd0b5373a4389.product = navigator.product || '';
    $8eca817bf49e3d6a$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $8eca817bf49e3d6a$export$2dffd0b5373a4389.userAgent = $8eca817bf49e3d6a$var$BASE_USER_AGENT + " react-native";
            $8eca817bf49e3d6a$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $8eca817bf49e3d6a$export$2dffd0b5373a4389.userAgent = $8eca817bf49e3d6a$var$BASE_USER_AGENT + " js";
            $8eca817bf49e3d6a$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $8eca817bf49e3d6a$export$ede38edb26c0bfdf = function(content) {
    return "" + $8eca817bf49e3d6a$export$2dffd0b5373a4389.userAgent + (content ? content : '');
};
var /**
 * @deprecated use named import
 */ $8eca817bf49e3d6a$export$2e2bcd8739ae039 = $8eca817bf49e3d6a$export$2dffd0b5373a4389;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $b4f6bc4ae2e6082d$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('ClientDevice_Browser');
function $b4f6bc4ae2e6082d$export$a2e6d3a753e91268() {
    if (typeof window === 'undefined') return {};
    return $b4f6bc4ae2e6082d$var$browserClientInfo();
}
function $b4f6bc4ae2e6082d$var$browserClientInfo() {
    if (typeof window === 'undefined') {
        $b4f6bc4ae2e6082d$var$logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        $b4f6bc4ae2e6082d$var$logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = $b4f6bc4ae2e6082d$export$80c0d0b601fd0789(userAgent);
    var timezone = $b4f6bc4ae2e6082d$var$browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language: language,
        timezone: timezone
    };
}
function $b4f6bc4ae2e6082d$export$edcd89beb969619a() {
    if (typeof window === 'undefined') {
        $b4f6bc4ae2e6082d$var$logger.warn('No window object available to get browser client info');
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function $b4f6bc4ae2e6082d$var$browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function $b4f6bc4ae2e6082d$export$80c0d0b601fd0789(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}


var $4175994c96625b7e$export$11b7ab1da2ac1804 = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, $b4f6bc4ae2e6082d$export$a2e6d3a753e91268)();
    };
    ClientDevice.dimension = function() {
        return (0, $b4f6bc4ae2e6082d$export$edcd89beb969619a)();
    };
    return ClientDevice;
}();
var /**
 * @deprecated use named import
 */ $4175994c96625b7e$export$2e2bcd8739ae039 = $4175994c96625b7e$export$11b7ab1da2ac1804;




/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $6c553752040387ec$var$__assign = undefined && undefined.__assign || function() {
    $6c553752040387ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c553752040387ec$var$__assign.apply(this, arguments);
};
var $6c553752040387ec$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6c553752040387ec$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6c553752040387ec$var$__read(arguments[i]));
    return ar;
};
var $6c553752040387ec$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Hub');
var $6c553752040387ec$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
function $6c553752040387ec$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $6c553752040387ec$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'ui',
            'xr'
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $6c553752040387ec$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $6c553752040387ec$var$__spread(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $6c553752040387ec$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $6c553752040387ec$var$__spread(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = '';
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $6c553752040387ec$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $6c553752040387ec$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $6c553752040387ec$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $6c553752040387ec$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = 'noname';
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($6c553752040387ec$var$isLegacyCallback(callback)) {
            $6c553752040387ec$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== 'function') throw new Error('No callback supplied to Hub');
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $6c553752040387ec$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $6c553752040387ec$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $6c553752040387ec$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $6c553752040387ec$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $6c553752040387ec$var$__assign($6c553752040387ec$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $6c553752040387ec$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $6c553752040387ec$export$8c41bb232f1008b1 = new $6c553752040387ec$export$6b38ef2be9abbbb9('__default__');
var /**
 * @deprecated use named import
 */ $6c553752040387ec$export$2e2bcd8739ae039 = $6c553752040387ec$export$8c41bb232f1008b1;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $d06f132cea397ea5$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('I18n');
/**
 * Language transition class
 */ var $d06f132cea397ea5$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        $d06f132cea397ea5$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $0088a97202c98b36$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('I18n');
var $0088a97202c98b36$var$_config = null;
var $0088a97202c98b36$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $0088a97202c98b36$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $0088a97202c98b36$var$logger.debug('configure I18n');
        if (!config) return $0088a97202c98b36$var$_config;
        $0088a97202c98b36$var$_config = Object.assign({}, $0088a97202c98b36$var$_config, config.I18n || config);
        I18n.createInstance();
        return $0088a97202c98b36$var$_config;
    };
    I18n.getModuleName = function() {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $0088a97202c98b36$var$logger.debug('create I18n instance');
        if ($0088a97202c98b36$var$_i18n) return;
        $0088a97202c98b36$var$_i18n = new (0, $d06f132cea397ea5$export$dbe3113d60765c1a)($0088a97202c98b36$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $0088a97202c98b36$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        return $0088a97202c98b36$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $0088a97202c98b36$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $0088a97202c98b36$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$0088a97202c98b36$var$_i18n) $0088a97202c98b36$var$_i18n = new (0, $d06f132cea397ea5$export$dbe3113d60765c1a)($0088a97202c98b36$var$_config);
        return true;
    };
    return I18n;
}();
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).register($0088a97202c98b36$export$dbe3113d60765c1a);
var /**
 * @deprecated use named import
 */ $0088a97202c98b36$export$2e2bcd8739ae039 = $0088a97202c98b36$export$dbe3113d60765c1a;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $1436837d4e301e07$var$MIME_MAP = [
    {
        type: 'text/plain',
        ext: 'txt'
    },
    {
        type: 'text/html',
        ext: 'html'
    },
    {
        type: 'text/javascript',
        ext: 'js'
    },
    {
        type: 'text/css',
        ext: 'css'
    },
    {
        type: 'text/csv',
        ext: 'csv'
    },
    {
        type: 'text/yaml',
        ext: 'yml'
    },
    {
        type: 'text/yaml',
        ext: 'yaml'
    },
    {
        type: 'text/calendar',
        ext: 'ics'
    },
    {
        type: 'text/calendar',
        ext: 'ical'
    },
    {
        type: 'image/apng',
        ext: 'apng'
    },
    {
        type: 'image/bmp',
        ext: 'bmp'
    },
    {
        type: 'image/gif',
        ext: 'gif'
    },
    {
        type: 'image/x-icon',
        ext: 'ico'
    },
    {
        type: 'image/x-icon',
        ext: 'cur'
    },
    {
        type: 'image/jpeg',
        ext: 'jpg'
    },
    {
        type: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        type: 'image/jpeg',
        ext: 'jfif'
    },
    {
        type: 'image/jpeg',
        ext: 'pjp'
    },
    {
        type: 'image/jpeg',
        ext: 'pjpeg'
    },
    {
        type: 'image/png',
        ext: 'png'
    },
    {
        type: 'image/svg+xml',
        ext: 'svg'
    },
    {
        type: 'image/tiff',
        ext: 'tif'
    },
    {
        type: 'image/tiff',
        ext: 'tiff'
    },
    {
        type: 'image/webp',
        ext: 'webp'
    },
    {
        type: 'application/json',
        ext: 'json'
    },
    {
        type: 'application/xml',
        ext: 'xml'
    },
    {
        type: 'application/x-sh',
        ext: 'sh'
    },
    {
        type: 'application/zip',
        ext: 'zip'
    },
    {
        type: 'application/x-rar-compressed',
        ext: 'rar'
    },
    {
        type: 'application/x-tar',
        ext: 'tar'
    },
    {
        type: 'application/x-bzip',
        ext: 'bz'
    },
    {
        type: 'application/x-bzip2',
        ext: 'bz2'
    },
    {
        type: 'application/pdf',
        ext: 'pdf'
    },
    {
        type: 'application/java-archive',
        ext: 'jar'
    },
    {
        type: 'application/msword',
        ext: 'doc'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xlsx'
    },
    {
        type: 'message/rfc822',
        ext: 'eml'
    }
];
var $1436837d4e301e07$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $1436837d4e301e07$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        if (typeof a_val === 'undefined') return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $1436837d4e301e07$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $1436837d4e301e07$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = 'application/octet-stream';
    var name = filename.toLowerCase();
    var filtered = $1436837d4e301e07$var$MIME_MAP.filter(function(mime) {
        return name.endsWith('.' + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $1436837d4e301e07$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) return true;
    return 'application/json' === type || 'application/xml' === type || 'application/sh' === type;
};
var $1436837d4e301e07$export$9e15fb06e64c4810 = function() {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $1436837d4e301e07$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $1436837d4e301e07$export$97b87b8868ff7a3c = function() {
    if (typeof self === 'undefined') return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};
var $1436837d4e301e07$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = false;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $1436837d4e301e07$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$1436837d4e301e07$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $1436837d4e301e07$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $1436837d4e301e07$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$1436837d4e301e07$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $1436837d4e301e07$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $1436837d4e301e07$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};
/**
 * @deprecated use per-function imports
 */ var $1436837d4e301e07$export$174a40858393256b = /** @class */ function() {
    function JS() {}
    JS.isEmpty = $1436837d4e301e07$export$dd1bc94b04021eeb;
    JS.sortByField = $1436837d4e301e07$export$756e1e7707954007;
    JS.objectLessAttributes = $1436837d4e301e07$export$5e10ed067f63a9ea;
    JS.filenameToContentType = $1436837d4e301e07$export$49cecb876bed446d;
    JS.isTextFile = $1436837d4e301e07$export$689bea3eece53c0e;
    JS.generateRandomString = $1436837d4e301e07$export$9e15fb06e64c4810;
    JS.makeQuerablePromise = $1436837d4e301e07$export$8f33cb495ca11832;
    JS.isWebWorker = $1436837d4e301e07$export$97b87b8868ff7a3c;
    JS.browserOrNode = $1436837d4e301e07$export$a2708fdb45cd35f;
    JS.transferKeyToLowerCase = $1436837d4e301e07$export$6281ea8cfc59a49c;
    JS.transferKeyToUpperCase = $1436837d4e301e07$export$f8790a3d3d35829c;
    JS.isStrictObject = $1436837d4e301e07$export$250974ab4f95003c;
    return JS;
}();
var /**
 * @deprecated use per-function imports
 */ $1436837d4e301e07$export$2e2bcd8739ae039 = $1436837d4e301e07$export$174a40858393256b;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $b55bfb59b21d9d6a$exports = {};
"use strict";
Object.defineProperty($b55bfb59b21d9d6a$exports, "__esModule", {
    value: true
});

var $2R3UW = parcelRequire("2R3UW");

$2R3UW.__exportStar((parcelRequire("akLJP")), $b55bfb59b21d9d6a$exports);


var $ab304b52b02b1119$var$SHORT_TO_HEX = {};
var $ab304b52b02b1119$var$HEX_TO_SHORT = {};
for(var $ab304b52b02b1119$var$i = 0; $ab304b52b02b1119$var$i < 256; $ab304b52b02b1119$var$i++){
    var $ab304b52b02b1119$var$encodedByte = $ab304b52b02b1119$var$i.toString(16).toLowerCase();
    if ($ab304b52b02b1119$var$encodedByte.length === 1) $ab304b52b02b1119$var$encodedByte = "0" + $ab304b52b02b1119$var$encodedByte;
    $ab304b52b02b1119$var$SHORT_TO_HEX[$ab304b52b02b1119$var$i] = $ab304b52b02b1119$var$encodedByte;
    $ab304b52b02b1119$var$HEX_TO_SHORT[$ab304b52b02b1119$var$encodedByte] = $ab304b52b02b1119$var$i;
}
function $ab304b52b02b1119$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $ab304b52b02b1119$var$HEX_TO_SHORT) out[i / 2] = $ab304b52b02b1119$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $ab304b52b02b1119$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $ab304b52b02b1119$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



var $6Wce5 = parcelRequire("6Wce5");
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $f7ab2abe85eab923$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var $f7ab2abe85eab923$var$FIVE_MINUTES_IN_MS = 300000;
var $f7ab2abe85eab923$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($f7ab2abe85eab923$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $f7ab2abe85eab923$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $f7ab2abe85eab923$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $f7ab2abe85eab923$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function(header) {
        var _a = $f7ab2abe85eab923$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $f7ab2abe85eab923$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $f7ab2abe85eab923$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            'BadRequestException',
            'InvalidSignatureException'
        ].includes(headers['x-amzn-errortype']) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $f7ab2abe85eab923$export$3e048df13f4eb60b.clockOffset = offset;
    }
};


var $795038822263781c$var$__assign = undefined && undefined.__assign || function() {
    $795038822263781c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $795038822263781c$var$__assign.apply(this, arguments);
};
var $795038822263781c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $795038822263781c$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Signer');
var $795038822263781c$var$DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var $795038822263781c$var$IOT_SERVICE_NAME = 'iotdevicegateway';
var $795038822263781c$var$encrypt = function(key, src) {
    var hash = new (0, $b55bfb59b21d9d6a$exports.Sha256)(key);
    hash.update(src);
    return hash.digestSync();
};
var $795038822263781c$var$hash = function(src) {
    var arg = src || '';
    var hash = new (0, $b55bfb59b21d9d6a$exports.Sha256)();
    hash.update(arg);
    return (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $795038822263781c$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $795038822263781c$var$canonical_query = function(query) {
    if (!query || query.length === 0) return '';
    return query.split('&').map(function(e) {
        var key_val = e.split('=');
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $795038822263781c$var$escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $795038822263781c$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $795038822263781c$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $795038822263781c$var$canonical_request = function(request) {
    var url_info = (0, $6Wce5.parse)(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        $795038822263781c$var$canonical_query(url_info.query),
        $795038822263781c$var$canonical_headers(request.headers),
        $795038822263781c$var$signed_headers(request.headers),
        $795038822263781c$var$hash(request.data)
    ].join('\n');
};
var $795038822263781c$var$parse_service_info = function(request) {
    var url_info = (0, $6Wce5.parse)(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $795038822263781c$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $795038822263781c$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $795038822263781c$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $795038822263781c$var$get_signing_key = function(secret_key, d_str, service_info) {
    $795038822263781c$var$logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = $795038822263781c$var$encrypt(k, d_str), k_region = $795038822263781c$var$encrypt(k_date, service_info.region), k_service = $795038822263781c$var$encrypt(k_region, service_info.service), k_signing = $795038822263781c$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $795038822263781c$var$get_signature = function(signing_key, str_to_sign) {
    return (0, $ab304b52b02b1119$export$7ea66e3774a60b67)($795038822263781c$var$encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $795038822263781c$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
var $795038822263781c$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        // datetime string and date string
        var dt = (0, $f7ab2abe85eab923$export$3e048df13f4eb60b).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = (0, $6Wce5.parse)(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $795038822263781c$var$canonical_request(request);
        $795038822263781c$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $795038822263781c$var$parse_service_info(request), scope = $795038822263781c$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $795038822263781c$var$string_to_sign($795038822263781c$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $795038822263781c$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $795038822263781c$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $795038822263781c$var$get_authorization_header($795038822263781c$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $795038822263781c$var$signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = (0, $f7ab2abe85eab923$export$3e048df13f4eb60b).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = (0, $6Wce5.parse)(urlToSign, true, true), search = _a.search, parsedUrl = $795038822263781c$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $795038822263781c$var$parse_service_info({
            url: (0, $6Wce5.format)(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $795038822263781c$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $795038822263781c$var$IOT_SERVICE_NAME;
        var queryParams = $795038822263781c$var$__assign($795038822263781c$var$__assign($795038822263781c$var$__assign({
            'X-Amz-Algorithm': $795038822263781c$var$DEFAULT_ALGORITHM,
            'X-Amz-Credential': [
                accessInfo.access_key,
                credentialScope
            ].join('/'),
            'X-Amz-Date': now.substr(0, 16)
        }, sessionTokenRequired ? {
            'X-Amz-Security-Token': "" + accessInfo.session_token
        } : {}), expiration ? {
            'X-Amz-Expires': "" + expiration
        } : {}), {
            'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',')
        });
        var canonicalRequest = $795038822263781c$var$canonical_request({
            method: method,
            url: (0, $6Wce5.format)($795038822263781c$var$__assign($795038822263781c$var$__assign({}, parsedUrl), {
                query: $795038822263781c$var$__assign($795038822263781c$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $795038822263781c$var$string_to_sign($795038822263781c$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $795038822263781c$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $795038822263781c$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $795038822263781c$var$__assign({
            'X-Amz-Signature': signature
        }, accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token
        });
        var result = (0, $6Wce5.format)({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $795038822263781c$var$__assign($795038822263781c$var$__assign($795038822263781c$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var /**
 * @deprecated use per-function import
 */ $795038822263781c$export$2e2bcd8739ae039 = $795038822263781c$export$fdf54fdde81cc9f0;



var $7b9bdee1f3af029c$var$__assign = undefined && undefined.__assign || function() {
    $7b9bdee1f3af029c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b9bdee1f3af029c$var$__assign.apply(this, arguments);
};
var $7b9bdee1f3af029c$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Parser');
var $7b9bdee1f3af029c$export$33f4f68299e2efa8 = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region']
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) amplifyConfig.Auth = {
        userPoolId: config['aws_user_pools_id'],
        userPoolWebClientId: config['aws_user_pools_web_client_id'],
        region: config['aws_cognito_region'],
        identityPoolId: config['aws_cognito_identity_pool_id'],
        identityPoolRegion: config['aws_cognito_region'],
        mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable',
        signUpVerificationMethod: config['aws_cognito_sign_up_verification_method'] || 'code'
    };
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) storageConfig = {
        AWSS3: {
            bucket: config['aws_user_files_s3_bucket'],
            region: config['aws_user_files_s3_bucket_region'],
            dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing']
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config['Logging']) amplifyConfig.Logging = $7b9bdee1f3af029c$var$__assign($7b9bdee1f3af029c$var$__assign({}, config['Logging']), {
        region: config['aws_project_region']
    });
    // Geo
    if (config['geo']) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo['amazon_location_service']) amplifyConfig.Geo = {
            AmazonLocationService: config.geo['amazon_location_service']
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    $7b9bdee1f3af029c$var$logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */ var $7b9bdee1f3af029c$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = $7b9bdee1f3af029c$export$33f4f68299e2efa8;
    return Parser;
}();
var /**
 * @deprecated use per-function export
 */ $7b9bdee1f3af029c$export$2e2bcd8739ae039 = $7b9bdee1f3af029c$export$7acfa6ed01010e37;






/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $95dac8785b133953$var$dataMemory = {};
/** @class */ var $95dac8785b133953$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $95dac8785b133953$var$dataMemory[key] = value;
        return $95dac8785b133953$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($95dac8785b133953$var$dataMemory, key) ? $95dac8785b133953$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $95dac8785b133953$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $95dac8785b133953$var$dataMemory = {};
        return $95dac8785b133953$var$dataMemory;
    };
    return MemoryStorage;
}();
var $95dac8785b133953$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        } catch (exception) {
            this.storageWindow = $95dac8785b133953$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var /**
 * @deprecated use named import
 */ $95dac8785b133953$export$2e2bcd8739ae039 = $95dac8785b133953$export$a2bd19c49e4760e8;



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


var $f0e9cd56ec245870$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f0e9cd56ec245870$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f0e9cd56ec245870$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f0e9cd56ec245870$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f0e9cd56ec245870$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f0e9cd56ec245870$var$__read(arguments[i]));
    return ar;
};
var $f0e9cd56ec245870$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Util');
var $f0e9cd56ec245870$export$1e38badc838ad384 = /** @class */ function(_super) {
    $f0e9cd56ec245870$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $f0e9cd56ec245870$var$isNonRetryableError = function(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $f0e9cd56ec245870$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    return $f0e9cd56ec245870$var$__awaiter(this, void 0, void 0, function() {
        var _this = this;
        return $f0e9cd56ec245870$var$__generator(this, function(_a) {
            if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return $f0e9cd56ec245870$var$__awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return $f0e9cd56ec245870$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _a, _b, err_1, retryIn_1;
                                        return $f0e9cd56ec245870$var$__generator(this, function(_c) {
                                            switch(_c.label){
                                                case 0:
                                                    attempt++;
                                                    $f0e9cd56ec245870$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                                                    _c.label = 1;
                                                case 1:
                                                    _c.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _a = {};
                                                    _b = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, $f0e9cd56ec245870$var$__spread(args))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_a.value = _b.apply(void 0, [
                                                            _c.sent()
                                                        ]), _a)
                                                    ];
                                                case 3:
                                                    err_1 = _c.sent();
                                                    lastError = err_1;
                                                    $f0e9cd56ec245870$var$logger.debug("error on " + functionToRetry.name, err_1);
                                                    if ($f0e9cd56ec245870$var$isNonRetryableError(err_1)) {
                                                        $f0e9cd56ec245870$var$logger.debug(functionToRetry.name + " non retryable error", err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    $f0e9cd56ec245870$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _c.sent();
                                                    _c.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var $f0e9cd56ec245870$var$MAX_DELAY_MS = 300000;
function $f0e9cd56ec245870$export$caea50bde345f648(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $f0e9cd56ec245870$var$MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $f0e9cd56ec245870$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = $f0e9cd56ec245870$var$MAX_DELAY_MS;
    return $f0e9cd56ec245870$export$9369b12211e1fce4(functionToRetry, args, $f0e9cd56ec245870$export$caea50bde345f648(maxDelayMs), onTerminate);
};


var $e2b7dc5e150c43dc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e2b7dc5e150c43dc$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e2b7dc5e150c43dc$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('CognitoCredentials');
var $e2b7dc5e150c43dc$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser) {
        $e2b7dc5e150c43dc$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        $e2b7dc5e150c43dc$var$logger.debug('google api already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $e2b7dc5e150c43dc$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $e2b7dc5e150c43dc$var$__awaiter(this, void 0, void 0, function() {
            return $e2b7dc5e150c43dc$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $e2b7dc5e150c43dc$var$logger.debug('need to wait for the Google SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $e2b7dc5e150c43dc$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $e2b7dc5e150c43dc$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser) ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            $e2b7dc5e150c43dc$var$logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $e2b7dc5e150c43dc$var$logger.debug('google Auth undefined');
                    rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $e2b7dc5e150c43dc$var$logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === 'network_error') // Not using NonRetryableError so handler will be retried
                        rej('Network error reloading google auth response');
                        else rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)('Failed to reload google auth response'));
                    });
                } else rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)('User is not signed in with Google'));
            }).catch(function(err) {
                $e2b7dc5e150c43dc$var$logger.debug('Failed to refresh google token', err);
                rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}();
var /**
 * @deprecated use named import
 */ $e2b7dc5e150c43dc$export$2e2bcd8739ae039 = $e2b7dc5e150c43dc$export$75ace714083c1340;





var $d73e4f284a69e1bd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d73e4f284a69e1bd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d73e4f284a69e1bd$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('CognitoCredentials');
var $d73e4f284a69e1bd$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser) {
        $d73e4f284a69e1bd$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        $d73e4f284a69e1bd$var$logger.debug('FB SDK already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $d73e4f284a69e1bd$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $d73e4f284a69e1bd$var$__awaiter(this, void 0, void 0, function() {
            return $d73e4f284a69e1bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $d73e4f284a69e1bd$var$logger.debug('need to wait for the Facebook SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $d73e4f284a69e1bd$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $d73e4f284a69e1bd$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser) fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            $d73e4f284a69e1bd$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    $d73e4f284a69e1bd$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        $d73e4f284a69e1bd$var$logger.debug(errorMessage);
                        rej(new (0, $f0e9cd56ec245870$export$1e38badc838ad384)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: 'public_profile,email'
            });
        });
    };
    return FacebookOAuth;
}();
var /**
 * @deprecated use named import
 */ $d73e4f284a69e1bd$export$2e2bcd8739ae039 = $d73e4f284a69e1bd$export$1b6b8b5328e38349;


var $c0973eff25c5eafe$export$75ace714083c1340 = new (0, $e2b7dc5e150c43dc$export$75ace714083c1340)();
var $c0973eff25c5eafe$export$1b6b8b5328e38349 = new (0, $d73e4f284a69e1bd$export$1b6b8b5328e38349)();





var $2R3UW = parcelRequire("2R3UW");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $2e58fe9d375f2959$var$extendStatics = function(d, b) {
    $2e58fe9d375f2959$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2e58fe9d375f2959$var$extendStatics(d, b);
};
function $2e58fe9d375f2959$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2e58fe9d375f2959$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2e58fe9d375f2959$export$18ce0697a983be9b = function() {
    $2e58fe9d375f2959$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e58fe9d375f2959$export$18ce0697a983be9b.apply(this, arguments);
};
function $2e58fe9d375f2959$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2e58fe9d375f2959$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2e58fe9d375f2959$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2e58fe9d375f2959$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2e58fe9d375f2959$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2e58fe9d375f2959$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2e58fe9d375f2959$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2e58fe9d375f2959$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2e58fe9d375f2959$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2e58fe9d375f2959$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2e58fe9d375f2959$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2e58fe9d375f2959$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2e58fe9d375f2959$export$45d3717a4c69092e(o, m, p);
}
function $2e58fe9d375f2959$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2e58fe9d375f2959$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2e58fe9d375f2959$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2e58fe9d375f2959$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2e58fe9d375f2959$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2e58fe9d375f2959$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2e58fe9d375f2959$export$10c90e4f7922046c(v) {
    return this instanceof $2e58fe9d375f2959$export$10c90e4f7922046c ? (this.v = v, this) : new $2e58fe9d375f2959$export$10c90e4f7922046c(v);
}
function $2e58fe9d375f2959$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2e58fe9d375f2959$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2e58fe9d375f2959$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2e58fe9d375f2959$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2e58fe9d375f2959$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2e58fe9d375f2959$export$19a8beecd37a4c45 === "function" ? $2e58fe9d375f2959$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2e58fe9d375f2959$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2e58fe9d375f2959$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $2e58fe9d375f2959$var$ownKeys = function(o) {
    $2e58fe9d375f2959$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $2e58fe9d375f2959$var$ownKeys(o);
};
function $2e58fe9d375f2959$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $2e58fe9d375f2959$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $2e58fe9d375f2959$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $2e58fe9d375f2959$var$__setModuleDefault(result, mod);
    return result;
}
function $2e58fe9d375f2959$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2e58fe9d375f2959$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2e58fe9d375f2959$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2e58fe9d375f2959$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2e58fe9d375f2959$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2e58fe9d375f2959$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2e58fe9d375f2959$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2e58fe9d375f2959$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $2e58fe9d375f2959$export$889dfb5d17574b0b(path, preserveJsx, extraExtensions, ignoreCase) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        if (extraExtensions) for(var extension in extraExtensions){
            var suffix = path.slice(-extension.length);
            if (suffix === extension || ignoreCase && suffix.toLowerCase() === extension.toLowerCase()) {
                var output = extraExtensions[extension];
                return output === extension ? path : path.slice(0, -extension.length) + output;
            }
        }
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
        });
    }
    return path;
}
var $2e58fe9d375f2959$export$2e2bcd8739ae039 = {
    __extends: $2e58fe9d375f2959$export$a8ba968b8961cb8a,
    __assign: $2e58fe9d375f2959$export$18ce0697a983be9b,
    __rest: $2e58fe9d375f2959$export$3c9a16f847548506,
    __decorate: $2e58fe9d375f2959$export$29e00dfd3077644b,
    __param: $2e58fe9d375f2959$export$d5ad3fd78186038f,
    __esDecorate: $2e58fe9d375f2959$export$3a84e1ae4e97e9b0,
    __runInitializers: $2e58fe9d375f2959$export$d831c04e792af3d,
    __propKey: $2e58fe9d375f2959$export$6a2a36740a146cb8,
    __setFunctionName: $2e58fe9d375f2959$export$d1a06452d3489bc7,
    __metadata: $2e58fe9d375f2959$export$f1db080c865becb9,
    __awaiter: $2e58fe9d375f2959$export$1050f835b63b671e,
    __generator: $2e58fe9d375f2959$export$67ebef60e6f28a6,
    __createBinding: $2e58fe9d375f2959$export$45d3717a4c69092e,
    __exportStar: $2e58fe9d375f2959$export$f33643c0debef087,
    __values: $2e58fe9d375f2959$export$19a8beecd37a4c45,
    __read: $2e58fe9d375f2959$export$8d051b38c9118094,
    __spread: $2e58fe9d375f2959$export$afc72e2116322959,
    __spreadArrays: $2e58fe9d375f2959$export$6388937ca91ccae8,
    __spreadArray: $2e58fe9d375f2959$export$1216008129fb82ed,
    __await: $2e58fe9d375f2959$export$10c90e4f7922046c,
    __asyncGenerator: $2e58fe9d375f2959$export$e427f37a30a4de9b,
    __asyncDelegator: $2e58fe9d375f2959$export$bbd80228419bb833,
    __asyncValues: $2e58fe9d375f2959$export$e3b29a3d6162315f,
    __makeTemplateObject: $2e58fe9d375f2959$export$4fb47efe1390b86f,
    __importStar: $2e58fe9d375f2959$export$c21735bcef00d192,
    __importDefault: $2e58fe9d375f2959$export$da59b14a69baef04,
    __classPrivateFieldGet: $2e58fe9d375f2959$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2e58fe9d375f2959$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2e58fe9d375f2959$export$81fdc39f203e4e04,
    __addDisposableResource: $2e58fe9d375f2959$export$88ac25d8e944e405,
    __disposeResources: $2e58fe9d375f2959$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $2e58fe9d375f2959$export$889dfb5d17574b0b
};



var $b1268222fff5fb4c$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($b1268222fff5fb4c$export$dc00db384271fff6 || ($b1268222fff5fb4c$export$dc00db384271fff6 = {}));
var $b1268222fff5fb4c$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8a7902a72d4cb6dd || ($b1268222fff5fb4c$export$8a7902a72d4cb6dd = {}));
var $b1268222fff5fb4c$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$2d7512435854af72 || ($b1268222fff5fb4c$export$2d7512435854af72 = {}));
var $b1268222fff5fb4c$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8d556ce24d00472 || ($b1268222fff5fb4c$export$8d556ce24d00472 = {}));
var $b1268222fff5fb4c$export$8b0f706f4df56c63;
(function(InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8b0f706f4df56c63 || ($b1268222fff5fb4c$export$8b0f706f4df56c63 = {}));
var $b1268222fff5fb4c$export$fa781b52e13bf866;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$fa781b52e13bf866 || ($b1268222fff5fb4c$export$fa781b52e13bf866 = {}));
var $b1268222fff5fb4c$export$cd419aa7f32ec382;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$cd419aa7f32ec382 || ($b1268222fff5fb4c$export$cd419aa7f32ec382 = {}));
var $b1268222fff5fb4c$export$82cff5e5a0a874dd;
(function(NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$82cff5e5a0a874dd || ($b1268222fff5fb4c$export$82cff5e5a0a874dd = {}));
var $b1268222fff5fb4c$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$cbdaf31887dd0603 || ($b1268222fff5fb4c$export$cbdaf31887dd0603 = {}));
var $b1268222fff5fb4c$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$4a67805ad445f61 || ($b1268222fff5fb4c$export$4a67805ad445f61 = {}));
var $b1268222fff5fb4c$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$6ce299b58e0ab8fe || ($b1268222fff5fb4c$export$6ce299b58e0ab8fe = {}));
var $b1268222fff5fb4c$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($b1268222fff5fb4c$export$d4e71bc0b80dc0fb || ($b1268222fff5fb4c$export$d4e71bc0b80dc0fb = {}));
var $b1268222fff5fb4c$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$7235a8ee19d2bee3 || ($b1268222fff5fb4c$export$7235a8ee19d2bee3 = {}));
var $b1268222fff5fb4c$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$2b5603236acc81d9 || ($b1268222fff5fb4c$export$2b5603236acc81d9 = {}));
var $b1268222fff5fb4c$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$cb6981b8f9a703c2 || ($b1268222fff5fb4c$export$cb6981b8f9a703c2 = {}));
var $b1268222fff5fb4c$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$ecba565262f8bb2 || ($b1268222fff5fb4c$export$ecba565262f8bb2 = {}));
var $b1268222fff5fb4c$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$46587acc7855d6e2 || ($b1268222fff5fb4c$export$46587acc7855d6e2 = {}));
var $b1268222fff5fb4c$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$16e1ea20d4f13fa7 || ($b1268222fff5fb4c$export$16e1ea20d4f13fa7 = {}));
var $b1268222fff5fb4c$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$4b5909fe2abc147d || ($b1268222fff5fb4c$export$4b5909fe2abc147d = {}));
var $b1268222fff5fb4c$export$cb77a58cb7dbb17;
(function(ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$cb77a58cb7dbb17 || ($b1268222fff5fb4c$export$cb77a58cb7dbb17 = {}));
var $b1268222fff5fb4c$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$bb51e43959182308 || ($b1268222fff5fb4c$export$bb51e43959182308 = {}));
var $b1268222fff5fb4c$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$a9627919734faa48 || ($b1268222fff5fb4c$export$a9627919734faa48 = {}));
var $b1268222fff5fb4c$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$ba56c4cb277a72f9 || ($b1268222fff5fb4c$export$ba56c4cb277a72f9 = {}));
var $b1268222fff5fb4c$export$90d12448d3766cda;
(function(InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$90d12448d3766cda || ($b1268222fff5fb4c$export$90d12448d3766cda = {}));
var $b1268222fff5fb4c$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$badc3094716a9faa || ($b1268222fff5fb4c$export$badc3094716a9faa = {}));
var $b1268222fff5fb4c$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$c3ec238968a6e7ac || ($b1268222fff5fb4c$export$c3ec238968a6e7ac = {}));
var $b1268222fff5fb4c$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$f5f529c0b4e5eb30 || ($b1268222fff5fb4c$export$f5f529c0b4e5eb30 = {}));
var $b1268222fff5fb4c$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($b1268222fff5fb4c$export$819b5ceb37e06be || ($b1268222fff5fb4c$export$819b5ceb37e06be = {}));
var $b1268222fff5fb4c$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$3f8398961535c3a || ($b1268222fff5fb4c$export$3f8398961535c3a = {}));
var $b1268222fff5fb4c$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$269dcf2519324984 || ($b1268222fff5fb4c$export$269dcf2519324984 = {}));
var $b1268222fff5fb4c$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($b1268222fff5fb4c$export$c726ef784882c23e || ($b1268222fff5fb4c$export$c726ef784882c23e = {}));
var $b1268222fff5fb4c$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$c8be61b857de8364 || ($b1268222fff5fb4c$export$c8be61b857de8364 = {}));
var $b1268222fff5fb4c$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$69a6cbc1a215fcdf || ($b1268222fff5fb4c$export$69a6cbc1a215fcdf = {}));
var $b1268222fff5fb4c$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$e31993063e9290fd || ($b1268222fff5fb4c$export$e31993063e9290fd = {}));
var $b1268222fff5fb4c$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$c2cdb3ad9240cf7d || ($b1268222fff5fb4c$export$c2cdb3ad9240cf7d = {}));
var $b1268222fff5fb4c$export$f9e8c5d2069aeea4;
(function(DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$f9e8c5d2069aeea4 || ($b1268222fff5fb4c$export$f9e8c5d2069aeea4 = {}));
var $b1268222fff5fb4c$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$b30c26022c4ccb98 || ($b1268222fff5fb4c$export$b30c26022c4ccb98 = {}));
var $b1268222fff5fb4c$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$39b050249a579e7b || ($b1268222fff5fb4c$export$39b050249a579e7b = {}));
var $b1268222fff5fb4c$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8c1e5f4b8dc33aa1 || ($b1268222fff5fb4c$export$8c1e5f4b8dc33aa1 = {}));
var $b1268222fff5fb4c$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$5270c3e17502575a || ($b1268222fff5fb4c$export$5270c3e17502575a = {}));
var $b1268222fff5fb4c$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$1d38161f8b62ad || ($b1268222fff5fb4c$export$1d38161f8b62ad = {}));
var $b1268222fff5fb4c$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$5a7a0c97755dcf8e || ($b1268222fff5fb4c$export$5a7a0c97755dcf8e = {}));
var $b1268222fff5fb4c$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$f862a07a4a7c6250 || ($b1268222fff5fb4c$export$f862a07a4a7c6250 = {}));
var $b1268222fff5fb4c$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8eb1e3f42ea35fee || ($b1268222fff5fb4c$export$8eb1e3f42ea35fee = {}));
var $b1268222fff5fb4c$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$6db0c8c0f26e7fec || ($b1268222fff5fb4c$export$6db0c8c0f26e7fec = {}));
var $b1268222fff5fb4c$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$1624698866821668 || ($b1268222fff5fb4c$export$1624698866821668 = {}));
var $b1268222fff5fb4c$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$fb0cf3531245501b || ($b1268222fff5fb4c$export$fb0cf3531245501b = {}));
var $b1268222fff5fb4c$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$8f282934b0cfbc4a || ($b1268222fff5fb4c$export$8f282934b0cfbc4a = {}));
var $b1268222fff5fb4c$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$13aa23992eef667b || ($b1268222fff5fb4c$export$13aa23992eef667b = {}));
var $b1268222fff5fb4c$export$21f15e80c2bbca09;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$21f15e80c2bbca09 || ($b1268222fff5fb4c$export$21f15e80c2bbca09 = {}));
var $b1268222fff5fb4c$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$20f43a93eb8d3b02 || ($b1268222fff5fb4c$export$20f43a93eb8d3b02 = {}));
var $b1268222fff5fb4c$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$a5e7dff780e8dcb0 || ($b1268222fff5fb4c$export$a5e7dff780e8dcb0 = {}));
var $b1268222fff5fb4c$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$2d5279802486e8b0 || ($b1268222fff5fb4c$export$2d5279802486e8b0 = {}));
var $b1268222fff5fb4c$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$b977eb1c8f754bfa || ($b1268222fff5fb4c$export$b977eb1c8f754bfa = {}));
var $b1268222fff5fb4c$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$2415026a66f5e70b || ($b1268222fff5fb4c$export$2415026a66f5e70b = {}));
var $b1268222fff5fb4c$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$4dbbd8ede80c9c36 || ($b1268222fff5fb4c$export$4dbbd8ede80c9c36 = {}));
var $b1268222fff5fb4c$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, obj);
    };
})($b1268222fff5fb4c$export$2128f49a7cd2e47f || ($b1268222fff5fb4c$export$2128f49a7cd2e47f = {}));



var $f2e608cd2926439a$export$1d94dfe0d9d1f1e7 = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();



var $2R3UW = parcelRequire("2R3UW");
var $56390c7aad80e533$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, this), {
            headers: (0, $2R3UW.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $56390c7aad80e533$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $56390c7aad80e533$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $2R3UW.__spread)(param) : param, _a));
    }, {});
}




function $53487573f48c9aa3$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}




var $9474d445386c7765$export$44d8caf684388429 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$900e66311faca63a = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$f0f695bb22170112 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$24669e6016ff61f7 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$88af91ae17f8527c = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$83083ba13837129b = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$291166950901964 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$dcc2b10f333c963c = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$aea8c8426f72de9a = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$3ddf979554ffe001 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$5d3f7522269fe239 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$50298d3eb327ab40 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$be03555111349623 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$43e326e2b54f124a = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$7a962066e209647 = function(input, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($9474d445386c7765$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2 /*return*/ ,
                $9474d445386c7765$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $9474d445386c7765$export$2065e670c73ee068 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$a14663734e0f26e7 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$77baf36526f7cd7e = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$1457f79b69c648d1 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$ebea9103431f9a50 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$731e618e28a38bab = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$a2439911ac8089ba = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$36b32c966a7eefbd = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$efb57976dadbc12b = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$6476ab94d95217ab = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$4d01436d85148f27 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$d8ee329529310a85 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$4e56caf614610ee8 = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $9474d445386c7765$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $9474d445386c7765$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, [
                        (0, $2e58fe9d375f2959$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $9474d445386c7765$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "DeveloperUserAlreadyRegisteredException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1InternalErrorException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            contents = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $9474d445386c7765$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $9474d445386c7765$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.ClientId !== undefined && input.ClientId !== null && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && input.ProviderName !== null && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && input.ServerSideTokenCheck !== null && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $9474d445386c7765$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $9474d445386c7765$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $9474d445386c7765$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $9474d445386c7765$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $9474d445386c7765$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $9474d445386c7765$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityIdsToDelete !== undefined && input.IdentityIdsToDelete !== null && {
        IdentityIdsToDelete: $9474d445386c7765$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $9474d445386c7765$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    });
};
var $9474d445386c7765$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $9474d445386c7765$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.CustomRoleArn !== undefined && input.CustomRoleArn !== null && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $9474d445386c7765$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $9474d445386c7765$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.AccountId !== undefined && input.AccountId !== null && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $9474d445386c7765$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $9474d445386c7765$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.TokenDuration !== undefined && input.TokenDuration !== null && {
        TokenDuration: input.TokenDuration
    });
};
var $9474d445386c7765$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $9474d445386c7765$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $9474d445386c7765$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $9474d445386c7765$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $9474d445386c7765$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $9474d445386c7765$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.HideDisabled !== undefined && input.HideDisabled !== null && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $9474d445386c7765$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $9474d445386c7765$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    });
};
var $9474d445386c7765$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $9474d445386c7765$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.Claim !== undefined && input.Claim !== null && {
        Claim: input.Claim
    }), input.MatchType !== undefined && input.MatchType !== null && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var $9474d445386c7765$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $9474d445386c7765$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.DestinationUserIdentifier !== undefined && input.DestinationUserIdentifier !== null && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && input.SourceUserIdentifier !== null && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $9474d445386c7765$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.AmbiguousRoleResolution !== undefined && input.AmbiguousRoleResolution !== null && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && input.RulesConfiguration !== null && {
        RulesConfiguration: $9474d445386c7765$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var $9474d445386c7765$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $9474d445386c7765$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $9474d445386c7765$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.Rules !== undefined && input.Rules !== null && {
        Rules: $9474d445386c7765$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && input.RoleMappings !== null && {
        RoleMappings: $9474d445386c7765$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && input.Roles !== null && {
        Roles: $9474d445386c7765$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $9474d445386c7765$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $9474d445386c7765$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && input.LoginsToRemove !== null && {
        LoginsToRemove: $9474d445386c7765$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $9474d445386c7765$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: $9474d445386c7765$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null ? output.ServerSideTokenCheck : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? new Date(Math.round(output.Expiration * 1000)) : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $9474d445386c7765$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $9474d445386c7765$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $9474d445386c7765$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $9474d445386c7765$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? new Date(Math.round(output.CreationDate * 1000)) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? new Date(Math.round(output.LastModifiedDate * 1000)) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $9474d445386c7765$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null ? output.AllowUnauthenticatedIdentities : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $9474d445386c7765$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null ? output.DeveloperProviderName : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $9474d445386c7765$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $9474d445386c7765$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $9474d445386c7765$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $9474d445386c7765$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $9474d445386c7765$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1LoginsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $9474d445386c7765$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$deserializeAws_json1_1MappingRule(entry, context);
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null ? output.AmbiguousRoleResolution : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $9474d445386c7765$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $9474d445386c7765$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $9474d445386c7765$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2e58fe9d375f2959$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $9474d445386c7765$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $9474d445386c7765$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $9474d445386c7765$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $9474d445386c7765$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $9474d445386c7765$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var $9474d445386c7765$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $9474d445386c7765$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $9474d445386c7765$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $9474d445386c7765$var$collectBodyString = function(streamBody, context) {
    return $9474d445386c7765$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $9474d445386c7765$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $2e58fe9d375f2959$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, $2e58fe9d375f2959$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)(contents)
                    ];
            }
        });
    });
};
var $9474d445386c7765$var$parseBody = function(streamBody, context) {
    return $9474d445386c7765$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var $9474d445386c7765$var$loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};



var $2R3UW = parcelRequire("2R3UW");
var $76f051d0cb3cbb33$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};



var $2R3UW = parcelRequire("2R3UW");
var $626611fbfb2f17a8$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};




var $46e9f99dae7fdceb$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var $46e9f99dae7fdceb$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $46e9f99dae7fdceb$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $76f051d0cb3cbb33$export$d10196e291075f95)(config, deserializer), $46e9f99dae7fdceb$export$f5d82b333b4f39c9);
            commandStack.add((0, $626611fbfb2f17a8$export$125a23d36094c5de)(config, serializer), $46e9f99dae7fdceb$export$1bd449976e9c484d);
        }
    };
}





var $2R3UW = parcelRequire("2R3UW");
var $dd7641f6da039a78$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $dd7641f6da039a78$var$stepWeights[b.step] - $dd7641f6da039a78$var$stepWeights[a.step] || $dd7641f6da039a78$var$priorityWeights[b.priority || "normal"] - $dd7641f6da039a78$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, $2R3UW.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, $2R3UW.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $2R3UW.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $2R3UW.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, $2R3UW.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, $2R3UW.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"" + name + "\" middleware with " + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, $2R3UW.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"" + name + "\" middleware " + toOverride.relation + " \"" + toOverride.toMiddleware + "\" middleware cannot be overridden " + ("by same-name middleware " + entry.relation + " \"" + entry.toMiddleware + "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($dd7641f6da039a78$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($dd7641f6da039a78$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $2R3UW.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $dd7641f6da039a78$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $dd7641f6da039a78$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




var $ad5f68adc06fa5bd$export$1f2bb630327ac4b6 = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, $dd7641f6da039a78$export$73604a93307363d8)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();



var $805ce49cff93934b$export$cc7e12c76513e857 = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, $dd7641f6da039a78$export$73604a93307363d8)();
    }
    return Command;
}();






/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ function $b2af4e6928b4a23c$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}


/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var $c532f6997c845207$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};


/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var $df2312d9b5942d77$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $df2312d9b5942d77$export$113d90026b452881(obj[key]);
    }
    return obj;
};


/**
 * Lazy String holder for JSON typed contents.
 */ 
var $2R3UW = parcelRequire("2R3UW");
var $2b26692359d90f7d$export$40e2db4f1ce24b10 = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $2R3UW.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$2b26692359d90f7d$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $2b26692359d90f7d$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($2b26692359d90f7d$export$40e2db4f1ce24b10, String);
var $2b26692359d90f7d$export$494ed5148690ecaf = /** @class */ function(_super) {
    (0, $2R3UW.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($2b26692359d90f7d$export$40e2db4f1ce24b10);


/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var $8da7524b6eed4f00$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var $8da7524b6eed4f00$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $8da7524b6eed4f00$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $8da7524b6eed4f00$var$days[dayOfWeek] + ", " + dayOfMonthString + " " + $8da7524b6eed4f00$var$months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}


/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ function $c06e010da361f66f$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}


var $17132e2fc00ff395$export$17127055dc9ac067 = "***SensitiveInformation***";








/**
 * <p>Returns credentials for the provided identity ID. Any provided logins will be
 *          validated against supported login providers. If the token is for
 *          cognito-identity.amazonaws.com, it will be passed through to AWS Security Token Service
 *          with the appropriate role for the token.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $ac812dcb62eea806$export$e08b3308c36761ec = /** @class */ function(_super) {
    (0, $2e58fe9d375f2959$export$a8ba968b8961cb8a)(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $b1268222fff5fb4c$export$bb51e43959182308).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $b1268222fff5fb4c$export$ba56c4cb277a72f9).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $9474d445386c7765$export$88af91ae17f8527c)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $9474d445386c7765$export$ebea9103431f9a50)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));



var $2R3UW = parcelRequire("2R3UW");

var $2R3UW = parcelRequire("2R3UW");
/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */ var $0c1c5a103d9bfc7b$export$478ec1fdae99aa79 = /** @class */ function(_super) {
    (0, $2R3UW.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error);


function $3d5ad95d9e31f1d6$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $0c1c5a103d9bfc7b$export$478ec1fdae99aa79)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $2R3UW.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}


var $1350d4e5534e4d2e$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};



var $2R3UW = parcelRequire("2R3UW");
var $4a579cc8c5b80883$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) // This is a static memoization; no need to incorporate refreshing
    return function() {
        if (!hasResult) {
            result = provider();
            hasResult = true;
        }
        return result;
    };
    var isConstant = false;
    return function() {
        return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
            var resolved;
            return (0, $2R3UW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!hasResult) {
                            result = provider();
                            hasResult = true;
                        }
                        if (isConstant) return [
                            2 /*return*/ ,
                            result
                        ];
                        return [
                            4 /*yield*/ ,
                            result
                        ];
                    case 1:
                        resolved = _a.sent();
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2 /*return*/ ,
                                resolved
                            ];
                        }
                        if (isExpired(resolved)) return [
                            2 /*return*/ ,
                            result = provider()
                        ];
                        return [
                            2 /*return*/ ,
                            resolved
                        ];
                }
            });
        });
    };
};






var $2R3UW = parcelRequire("2R3UW");
function $d3b1b5c181dbd25d$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $2R3UW.__read)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}


function $a4e05f336396bc38$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $2R3UW.__generator)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $ac812dcb62eea806$export$e08b3308c36761ec).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $d3b1b5c181dbd25d$export$fb1e896f6704b6a6)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _f.apply(_e, [
                                new (_g.apply((0, $ac812dcb62eea806$export$e08b3308c36761ec), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $a4e05f336396bc38$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $a4e05f336396bc38$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $a4e05f336396bc38$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2 /*return*/ ,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $a4e05f336396bc38$var$throwOnMissingAccessKeyId() {
    throw new (0, $0c1c5a103d9bfc7b$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no access key ID");
}
function $a4e05f336396bc38$var$throwOnMissingCredentials() {
    throw new (0, $0c1c5a103d9bfc7b$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no credentials");
}
function $a4e05f336396bc38$var$throwOnMissingSecretKey() {
    throw new (0, $0c1c5a103d9bfc7b$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no secret key");
}


var $2R3UW = parcelRequire("2R3UW");





/**
 * <p>Generates (or retrieves) a Cognito ID. Supplying multiple logins will create an
 *          implicit linked account.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $0c824b600c63edcc$export$41ceb4ced4f97a44 = /** @class */ function(_super) {
    (0, $2e58fe9d375f2959$export$a8ba968b8961cb8a)(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $b1268222fff5fb4c$export$badc3094716a9faa).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $b1268222fff5fb4c$export$c3ec238968a6e7ac).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $9474d445386c7765$export$83083ba13837129b)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $9474d445386c7765$export$9f5769abdc93f0b4)(output, context);
    };
    return GetIdCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));




var $f662922ad7052459$var$STORE_NAME = "IdentityIds";
var $f662922ad7052459$export$55d38e5384f402 = /** @class */ function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($f662922ad7052459$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($f662922ad7052459$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($f662922ad7052459$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();


var $b1cd721c2df36451$export$e4315e25b840a0ea = /** @class */ function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();


var $0739884302895858$var$inMemoryStorage = new (0, $b1cd721c2df36451$export$e4315e25b840a0ea)();
function $0739884302895858$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $f662922ad7052459$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $0739884302895858$var$inMemoryStorage;
}



function $cb0e39c9ed8a9eaa$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $0739884302895858$export$c2ed3351cac403d1)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $2R3UW.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3 /*break*/ ,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $0c824b600c63edcc$export$41ceb4ced4f97a44).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $d3b1b5c181dbd25d$export$fb1e896f6704b6a6)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _d.apply(_c, [
                                new (_e.apply((0, $0c824b600c63edcc$export$41ceb4ced4f97a44), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $cb0e39c9ed8a9eaa$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $a4e05f336396bc38$export$4d624d71eb462130)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2 /*return*/ ,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                return (0, $2R3UW.__generator)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $cb0e39c9ed8a9eaa$var$throwOnMissingId() {
    throw new (0, $0c1c5a103d9bfc7b$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no identity ID");
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $5ae9f5b58c3f1597$exports = {};
$5ae9f5b58c3f1597$exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@aws-sdk/client-iam\":\"3.6.1\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");


var $884a5260025384f7$exports = {};
"use strict";
Object.defineProperty($884a5260025384f7$exports, "__esModule", {
    value: true
});
$884a5260025384f7$exports.WebCryptoSha256 = $884a5260025384f7$exports.Ie11Sha256 = void 0;

var $2R3UW = parcelRequire("2R3UW");

(0, $2R3UW.__exportStar)((parcelRequire("i9mdb")), $884a5260025384f7$exports);

var $lPRYN = parcelRequire("lPRYN");
Object.defineProperty($884a5260025384f7$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $lPRYN.Sha256;
    }
});

var $bbsdH = parcelRequire("bbsdH");
Object.defineProperty($884a5260025384f7$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $bbsdH.Sha256;
    }
});



var $2R3UW = parcelRequire("2R3UW");


var $2R3UW = parcelRequire("2R3UW");
var $34a3db2e1651452d$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $34a3db2e1651452d$var$hexEncode);
};
var $34a3db2e1651452d$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $8b8c39c5783004b7$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $34a3db2e1651452d$export$c3b4775ad75a73db)).join("/");
};




function $abcb7d8a595a3dde$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $2R3UW.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}


function $c4c8291ddecc22d1$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


var $4f85640929636496$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $abcb7d8a595a3dde$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $2R3UW.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $f2e608cd2926439a$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $f2e608cd2926439a$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $c4c8291ddecc22d1$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();



var $2R3UW = parcelRequire("2R3UW");
var $7cbce5b9f8516cac$var$alphabetByEncoding = {};
var $7cbce5b9f8516cac$var$alphabetByValue = new Array(64);
for(var $7cbce5b9f8516cac$var$i = 0, $7cbce5b9f8516cac$var$start = "A".charCodeAt(0), $7cbce5b9f8516cac$var$limit = "Z".charCodeAt(0); $7cbce5b9f8516cac$var$i + $7cbce5b9f8516cac$var$start <= $7cbce5b9f8516cac$var$limit; $7cbce5b9f8516cac$var$i++){
    var $7cbce5b9f8516cac$var$char = String.fromCharCode($7cbce5b9f8516cac$var$i + $7cbce5b9f8516cac$var$start);
    $7cbce5b9f8516cac$var$alphabetByEncoding[$7cbce5b9f8516cac$var$char] = $7cbce5b9f8516cac$var$i;
    $7cbce5b9f8516cac$var$alphabetByValue[$7cbce5b9f8516cac$var$i] = $7cbce5b9f8516cac$var$char;
}
for(var $7cbce5b9f8516cac$var$i = 0, $7cbce5b9f8516cac$var$start = "a".charCodeAt(0), $7cbce5b9f8516cac$var$limit = "z".charCodeAt(0); $7cbce5b9f8516cac$var$i + $7cbce5b9f8516cac$var$start <= $7cbce5b9f8516cac$var$limit; $7cbce5b9f8516cac$var$i++){
    var $7cbce5b9f8516cac$var$char = String.fromCharCode($7cbce5b9f8516cac$var$i + $7cbce5b9f8516cac$var$start);
    var $7cbce5b9f8516cac$var$index = $7cbce5b9f8516cac$var$i + 26;
    $7cbce5b9f8516cac$var$alphabetByEncoding[$7cbce5b9f8516cac$var$char] = $7cbce5b9f8516cac$var$index;
    $7cbce5b9f8516cac$var$alphabetByValue[$7cbce5b9f8516cac$var$index] = $7cbce5b9f8516cac$var$char;
}
for(var $7cbce5b9f8516cac$var$i = 0; $7cbce5b9f8516cac$var$i < 10; $7cbce5b9f8516cac$var$i++){
    $7cbce5b9f8516cac$var$alphabetByEncoding[$7cbce5b9f8516cac$var$i.toString(10)] = $7cbce5b9f8516cac$var$i + 52;
    var $7cbce5b9f8516cac$var$char = $7cbce5b9f8516cac$var$i.toString(10);
    var $7cbce5b9f8516cac$var$index = $7cbce5b9f8516cac$var$i + 52;
    $7cbce5b9f8516cac$var$alphabetByEncoding[$7cbce5b9f8516cac$var$char] = $7cbce5b9f8516cac$var$index;
    $7cbce5b9f8516cac$var$alphabetByValue[$7cbce5b9f8516cac$var$index] = $7cbce5b9f8516cac$var$char;
}
$7cbce5b9f8516cac$var$alphabetByEncoding["+"] = 62;
$7cbce5b9f8516cac$var$alphabetByValue[62] = "+";
$7cbce5b9f8516cac$var$alphabetByEncoding["/"] = 63;
$7cbce5b9f8516cac$var$alphabetByValue[63] = "/";
var $7cbce5b9f8516cac$var$bitsPerLetter = 6;
var $7cbce5b9f8516cac$var$bitsPerByte = 8;
var $7cbce5b9f8516cac$var$maxLetterValue = 63;
function $7cbce5b9f8516cac$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= $7cbce5b9f8516cac$var$alphabetByEncoding[input[j]] << (limit - j) * $7cbce5b9f8516cac$var$bitsPerLetter;
            bitLength += $7cbce5b9f8516cac$var$bitsPerLetter;
        } else bits >>= $7cbce5b9f8516cac$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $7cbce5b9f8516cac$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $7cbce5b9f8516cac$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $7cbce5b9f8516cac$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $7cbce5b9f8516cac$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $7cbce5b9f8516cac$var$bitsPerByte;
            bitLength += $7cbce5b9f8516cac$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $7cbce5b9f8516cac$var$bitsPerLetter);
        bits <<= bitClusterCount * $7cbce5b9f8516cac$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $7cbce5b9f8516cac$var$bitsPerLetter;
            str += $7cbce5b9f8516cac$var$alphabetByValue[(bits & $7cbce5b9f8516cac$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}


var $12afb2b1a2425333$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $12afb2b1a2425333$var$collectBlob(stream);
    return $12afb2b1a2425333$var$collectStream(stream);
};
function $12afb2b1a2425333$var$collectBlob(blob) {
    return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $2R3UW.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $12afb2b1a2425333$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $7cbce5b9f8516cac$export$c537b38001c583b7)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $12afb2b1a2425333$var$collectStream(stream) {
    return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $2R3UW.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function $12afb2b1a2425333$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}




var $afbe43275a6c0572$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};


var $f7ad0cbdfcbdd3bf$export$d59dd53963f8f3d5 = function(message) {
    return function() {
        return Promise.reject(message);
    };
};





var $2R3UW = parcelRequire("2R3UW");
var $2d8b999fb8b8d488$export$a3922aa5f87bae85 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var _a;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, $2R3UW.__spread)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var $2d8b999fb8b8d488$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var $2d8b999fb8b8d488$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($2d8b999fb8b8d488$export$a3922aa5f87bae85(options), $2d8b999fb8b8d488$export$44d3d03587957ce9);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");

/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var $819688fb6b707fd5$export$7067ba90effbd789 = 100;
var $819688fb6b707fd5$export$2412c80d04e902c6 = 20000;
var $819688fb6b707fd5$export$4af31f8250b48e23 = 500;
var $819688fb6b707fd5$export$f8c3d11675a1153 = 500;
var $819688fb6b707fd5$export$797febae1136bc84 = 5;
var $819688fb6b707fd5$export$b643545eaf9af837 = 10;
var $819688fb6b707fd5$export$a25da3406dc148e4 = 1;
var $819688fb6b707fd5$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
var $819688fb6b707fd5$export$d4f764f0ec4f52f = "amz-sdk-request";


var $5ff3ca15e6e99c6a$export$536b11ee0b9c4a95 = function() {
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) {
                        delete request.headers[0, $819688fb6b707fd5$export$197fd517bf66ccb2];
                        delete request.headers[0, $819688fb6b707fd5$export$d4f764f0ec4f52f];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $5ff3ca15e6e99c6a$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var $5ff3ca15e6e99c6a$export$fa165e6edc16c2a2 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($5ff3ca15e6e99c6a$export$536b11ee0b9c4a95(), $5ff3ca15e6e99c6a$export$3ec587d8f35e7a2c);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");

/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var $eed4473d75e9b1ba$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $eed4473d75e9b1ba$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var $eed4473d75e9b1ba$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $eed4473d75e9b1ba$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];


var $3ac34ffddb064a6c$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $3ac34ffddb064a6c$export$7b87435661177a94 = function(error) {
    return (0, $eed4473d75e9b1ba$export$9fde012b8b2a10ca).includes(error.name);
};
var $3ac34ffddb064a6c$export$cbecb89f6256ccc8 = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, $eed4473d75e9b1ba$export$89cd1b0ccfcb99d).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var $3ac34ffddb064a6c$export$31778435da988512 = function(error) {
    var _a;
    return (0, $eed4473d75e9b1ba$export$18bd3bfe89ded398).includes(error.name) || (0, $eed4473d75e9b1ba$export$38bf589d26009e4f).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};


var $8047a95edcd95fb7$exports = {};
var $e90517493221b6c9$exports = {};
var $66e4d6ca7f3e49f0$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $66e4d6ca7f3e49f0$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($66e4d6ca7f3e49f0$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $66e4d6ca7f3e49f0$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $66e4d6ca7f3e49f0$exports = function whatwgRNG() {
        $66e4d6ca7f3e49f0$var$getRandomValues($66e4d6ca7f3e49f0$var$rnds8);
        return $66e4d6ca7f3e49f0$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $66e4d6ca7f3e49f0$var$rnds = new Array(16);
    $66e4d6ca7f3e49f0$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $66e4d6ca7f3e49f0$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $66e4d6ca7f3e49f0$var$rnds;
    };
}


var $7a18bab8c5ea59fc$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $7a18bab8c5ea59fc$var$byteToHex = [];
for(var $7a18bab8c5ea59fc$var$i = 0; $7a18bab8c5ea59fc$var$i < 256; ++$7a18bab8c5ea59fc$var$i)$7a18bab8c5ea59fc$var$byteToHex[$7a18bab8c5ea59fc$var$i] = ($7a18bab8c5ea59fc$var$i + 0x100).toString(16).substr(1);
function $7a18bab8c5ea59fc$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $7a18bab8c5ea59fc$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$7a18bab8c5ea59fc$exports = $7a18bab8c5ea59fc$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $e90517493221b6c9$var$_nodeId;
var $e90517493221b6c9$var$_clockseq;
// Previous uuid creation time
var $e90517493221b6c9$var$_lastMSecs = 0;
var $e90517493221b6c9$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $e90517493221b6c9$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $e90517493221b6c9$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $e90517493221b6c9$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $66e4d6ca7f3e49f0$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $e90517493221b6c9$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $e90517493221b6c9$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $e90517493221b6c9$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $e90517493221b6c9$var$_lastMSecs + (nsecs - $e90517493221b6c9$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $e90517493221b6c9$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $e90517493221b6c9$var$_lastMSecs = msecs;
    $e90517493221b6c9$var$_lastNSecs = nsecs;
    $e90517493221b6c9$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $7a18bab8c5ea59fc$exports(b);
}
$e90517493221b6c9$exports = $e90517493221b6c9$var$v1;


var $c0aca177e7a14b46$exports = {};


function $c0aca177e7a14b46$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $66e4d6ca7f3e49f0$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $7a18bab8c5ea59fc$exports(rnds);
}
$c0aca177e7a14b46$exports = $c0aca177e7a14b46$var$v4;


var $8047a95edcd95fb7$var$uuid = $c0aca177e7a14b46$exports;
$8047a95edcd95fb7$var$uuid.v1 = $e90517493221b6c9$exports;
$8047a95edcd95fb7$var$uuid.v4 = $c0aca177e7a14b46$exports;
$8047a95edcd95fb7$exports = $8047a95edcd95fb7$var$uuid;




var $96cec20677f246b1$export$2ebe7988802fc284 = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, $819688fb6b707fd5$export$b643545eaf9af837) : (0, $819688fb6b707fd5$export$797febae1136bc84);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, $819688fb6b707fd5$export$a25da3406dc148e4);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



var $614c3894b4d6a8e2$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $819688fb6b707fd5$export$2412c80d04e902c6), Math.random() * Math.pow(2, attempts) * delayBase));
};



var $3f9811d418444fd5$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $3ac34ffddb064a6c$export$46428803f4bd8a0c)(error) || (0, $3ac34ffddb064a6c$export$7b87435661177a94)(error) || (0, $3ac34ffddb064a6c$export$cbecb89f6256ccc8)(error) || (0, $3ac34ffddb064a6c$export$31778435da988512)(error);
};


var $cc9220ec102b8f39$export$2c7e51f38ba5a406 = 3;
var $cc9220ec102b8f39$export$41315747b7c5d042 = "standard";
var $cc9220ec102b8f39$export$64af437cce00eae8 = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = $cc9220ec102b8f39$export$41315747b7c5d042;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $3f9811d418444fd5$export$3839fd261f89ec2);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $614c3894b4d6a8e2$export$1cddd42598a3b1f6);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $96cec20677f246b1$export$2ebe7988802fc284)((0, $819688fb6b707fd5$export$f8c3d11675a1153));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $2R3UW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = $cc9220ec102b8f39$export$2c7e51f38ba5a406;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $2R3UW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) request.headers[0, $819688fb6b707fd5$export$197fd517bf66ccb2] = (0, $8047a95edcd95fb7$exports.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, $2R3UW.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) request.headers[0, $819688fb6b707fd5$export$d4f764f0ec4f52f] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, $3ac34ffddb064a6c$export$cbecb89f6256ccc8)(err_1) ? (0, $819688fb6b707fd5$export$4af31f8250b48e23) : (0, $819688fb6b707fd5$export$7067ba90effbd789), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();



var $2R3UW = parcelRequire("2R3UW");

var $ffd161ca6b258fc7$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $ffd161ca6b258fc7$export$9ae8a04532f798bc = "max_attempts";
var $ffd161ca6b258fc7$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$ffd161ca6b258fc7$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $ffd161ca6b258fc7$export$a19952f9e421517c + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$ffd161ca6b258fc7$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $ffd161ca6b258fc7$export$9ae8a04532f798bc + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, $cc9220ec102b8f39$export$2c7e51f38ba5a406)
};
var $ffd161ca6b258fc7$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $ffd161ca6b258fc7$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, $cc9220ec102b8f39$export$64af437cce00eae8)(maxAttempts)
    });
};
var $ffd161ca6b258fc7$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $cc9220ec102b8f39$export$2c7e51f38ba5a406);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $ffd161ca6b258fc7$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $ffd161ca6b258fc7$export$c5c0171a17765aea = "retry_mode";
var $ffd161ca6b258fc7$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$ffd161ca6b258fc7$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$ffd161ca6b258fc7$export$c5c0171a17765aea];
    },
    default: (0, $cc9220ec102b8f39$export$41315747b7c5d042)
};







function $04ceec2b4b32d579$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}



var $2R3UW = parcelRequire("2R3UW");
var $8d2b943a01d89bd0$exports = {};
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2026
 */ !function(e, t) {
    $8d2b943a01d89bd0$exports = t();
}($8d2b943a01d89bd0$exports, function() {
    var e = {
        AmazonBot: "amazonbot",
        "Amazon Silk": "amazon_silk",
        "Android Browser": "android",
        BaiduSpider: "baiduspider",
        Bada: "bada",
        BingCrawler: "bingcrawler",
        Brave: "brave",
        BlackBerry: "blackberry",
        "ChatGPT-User": "chatgpt_user",
        Chrome: "chrome",
        ClaudeBot: "claudebot",
        Chromium: "chromium",
        Diffbot: "diffbot",
        DuckDuckBot: "duckduckbot",
        DuckDuckGo: "duckduckgo",
        Electron: "electron",
        Epiphany: "epiphany",
        FacebookExternalHit: "facebookexternalhit",
        Firefox: "firefox",
        Focus: "focus",
        Generic: "generic",
        "Google Search": "google_search",
        Googlebot: "googlebot",
        GPTBot: "gptbot",
        "HeyTap Browser": "heytap",
        "Internet Explorer": "ie",
        InternetArchiveCrawler: "internetarchivecrawler",
        "K-Meleon": "k_meleon",
        Ladybird: "ladybird",
        LibreWolf: "librewolf",
        Linespider: "linespider",
        Maxthon: "maxthon",
        "Meta-ExternalAds": "meta_externalads",
        "Meta-ExternalAgent": "meta_externalagent",
        "Meta-ExternalFetcher": "meta_externalfetcher",
        "Meta-WebIndexer": "meta_webindexer",
        "Microsoft Edge": "edge",
        "MZ Browser": "mz",
        "NAVER Whale Browser": "naver",
        "OAI-SearchBot": "oai_searchbot",
        Omgilibot: "omgilibot",
        Opera: "opera",
        "Opera Coast": "opera_coast",
        "Pale Moon": "pale_moon",
        PerplexityBot: "perplexitybot",
        "Perplexity-User": "perplexity_user",
        PhantomJS: "phantomjs",
        PingdomBot: "pingdombot",
        Puffin: "puffin",
        QQ: "qq",
        QQLite: "qqlite",
        QupZilla: "qupzilla",
        Roku: "roku",
        Safari: "safari",
        Sailfish: "sailfish",
        "Samsung Internet for Android": "samsung_internet",
        SlackBot: "slackbot",
        SeaMonkey: "seamonkey",
        Sleipnir: "sleipnir",
        "Sogou Browser": "sogou",
        Swing: "swing",
        Tizen: "tizen",
        "UC Browser": "uc",
        "Vivo Browser": "vivo",
        Vivaldi: "vivaldi",
        "WebOS Browser": "webos",
        WeChat: "wechat",
        YahooSlurp: "yahooslurp",
        "Yandex Browser": "yandex",
        YandexBot: "yandexbot",
        YouBot: "youbot"
    }, t = {
        amazonbot: "AmazonBot",
        amazon_silk: "Amazon Silk",
        android: "Android Browser",
        baiduspider: "BaiduSpider",
        bada: "Bada",
        bingcrawler: "BingCrawler",
        blackberry: "BlackBerry",
        brave: "Brave",
        chatgpt_user: "ChatGPT-User",
        chrome: "Chrome",
        claudebot: "ClaudeBot",
        chromium: "Chromium",
        diffbot: "Diffbot",
        duckduckbot: "DuckDuckBot",
        duckduckgo: "DuckDuckGo",
        edge: "Microsoft Edge",
        electron: "Electron",
        epiphany: "Epiphany",
        facebookexternalhit: "FacebookExternalHit",
        firefox: "Firefox",
        focus: "Focus",
        generic: "Generic",
        google_search: "Google Search",
        googlebot: "Googlebot",
        gptbot: "GPTBot",
        heytap: "HeyTap Browser",
        ie: "Internet Explorer",
        internetarchivecrawler: "InternetArchiveCrawler",
        k_meleon: "K-Meleon",
        ladybird: "Ladybird",
        librewolf: "LibreWolf",
        linespider: "Linespider",
        maxthon: "Maxthon",
        meta_externalads: "Meta-ExternalAds",
        meta_externalagent: "Meta-ExternalAgent",
        meta_externalfetcher: "Meta-ExternalFetcher",
        meta_webindexer: "Meta-WebIndexer",
        mz: "MZ Browser",
        naver: "NAVER Whale Browser",
        oai_searchbot: "OAI-SearchBot",
        omgilibot: "Omgilibot",
        opera: "Opera",
        opera_coast: "Opera Coast",
        pale_moon: "Pale Moon",
        perplexitybot: "PerplexityBot",
        perplexity_user: "Perplexity-User",
        phantomjs: "PhantomJS",
        pingdombot: "PingdomBot",
        puffin: "Puffin",
        qq: "QQ Browser",
        qqlite: "QQ Browser Lite",
        qupzilla: "QupZilla",
        roku: "Roku",
        safari: "Safari",
        sailfish: "Sailfish",
        samsung_internet: "Samsung Internet for Android",
        seamonkey: "SeaMonkey",
        slackbot: "SlackBot",
        sleipnir: "Sleipnir",
        sogou: "Sogou Browser",
        swing: "Swing",
        tizen: "Tizen",
        uc: "UC Browser",
        vivo: "Vivo Browser",
        vivaldi: "Vivaldi",
        webos: "WebOS Browser",
        wechat: "WeChat",
        yahooslurp: "YahooSlurp",
        yandex: "Yandex Browser",
        yandexbot: "YandexBot",
        youbot: "YouBot"
    }, r = {
        bot: "bot",
        desktop: "desktop",
        mobile: "mobile",
        tablet: "tablet",
        tv: "tv"
    }, i = {
        Android: "Android",
        Bada: "Bada",
        BlackBerry: "BlackBerry",
        ChromeOS: "Chrome OS",
        HarmonyOS: "HarmonyOS",
        iOS: "iOS",
        Linux: "Linux",
        MacOS: "macOS",
        PlayStation4: "PlayStation 4",
        Roku: "Roku",
        Tizen: "Tizen",
        WebOS: "WebOS",
        Windows: "Windows",
        WindowsPhone: "Windows Phone"
    }, n = {
        Blink: "Blink",
        EdgeHTML: "EdgeHTML",
        Gecko: "Gecko",
        LibWeb: "LibWeb",
        Presto: "Presto",
        Trident: "Trident",
        WebKit: "WebKit"
    }, s = function() {
        function r() {}
        return r.getFirstMatch = function(e, t) {
            var r = t.match(e);
            return r && r.length > 0 && r[1] || "";
        }, r.getSecondMatch = function(e, t) {
            var r = t.match(e);
            return r && r.length > 1 && r[2] || "";
        }, r.matchAndReturnConst = function(e, t, r) {
            if (e.test(t)) return r;
        }, r.isFirefoxOnIpad = function(e) {
            var t = e.indexOf("Macintosh");
            if (-1 === t) return !1;
            var r = e.indexOf(" FxiOS", t + 9);
            return -1 !== r && -1 !== e.indexOf("/", r + 6);
        }, r.getWindowsVersionName = function(e) {
            switch(e){
                case "NT":
                    return "NT";
                case "XP":
                case "NT 5.1":
                    return "XP";
                case "NT 5.0":
                    return "2000";
                case "NT 5.2":
                    return "2003";
                case "NT 6.0":
                    return "Vista";
                case "NT 6.1":
                    return "7";
                case "NT 6.2":
                    return "8";
                case "NT 6.3":
                    return "8.1";
                case "NT 10.0":
                    return "10";
                default:
                    return;
            }
        }, r.getMacOSVersionName = function(e) {
            var t = e.split(".").splice(0, 2).map(function(e) {
                return parseInt(e, 10) || 0;
            });
            t.push(0);
            var r = t[0], i = t[1];
            if (10 === r) switch(i){
                case 5:
                    return "Leopard";
                case 6:
                    return "Snow Leopard";
                case 7:
                    return "Lion";
                case 8:
                    return "Mountain Lion";
                case 9:
                    return "Mavericks";
                case 10:
                    return "Yosemite";
                case 11:
                    return "El Capitan";
                case 12:
                    return "Sierra";
                case 13:
                    return "High Sierra";
                case 14:
                    return "Mojave";
                case 15:
                    return "Catalina";
                default:
                    return;
            }
            switch(r){
                case 11:
                    return "Big Sur";
                case 12:
                    return "Monterey";
                case 13:
                    return "Ventura";
                case 14:
                    return "Sonoma";
                case 15:
                    return "Sequoia";
                default:
                    return;
            }
        }, r.getAndroidVersionName = function(e) {
            var t = e.split(".").splice(0, 2).map(function(e) {
                return parseInt(e, 10) || 0;
            });
            if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
        }, r.getVersionPrecision = function(e) {
            return e.split(".").length;
        }, r.compareVersions = function(e, t, i) {
            void 0 === i && (i = !1);
            var n = r.getVersionPrecision(e), s = r.getVersionPrecision(t), o = Math.max(n, s), a = 0, c = r.map([
                e,
                t
            ], function(e) {
                var t = o - r.getVersionPrecision(e), i = e + new Array(t + 1).join(".0");
                return r.map(i.split("."), function(e) {
                    return new Array(20 - e.length).join("0") + e;
                }).reverse();
            });
            for(i && (a = o - Math.min(n, s)), o -= 1; o >= a;){
                if (c[0][o] > c[1][o]) return 1;
                if (c[0][o] === c[1][o]) {
                    if (o === a) return 0;
                    o -= 1;
                } else if (c[0][o] < c[1][o]) return -1;
            }
        }, r.map = function(e, t) {
            var r, i = [];
            if (Array.prototype.map) return Array.prototype.map.call(e, t);
            for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
            return i;
        }, r.find = function(e, t) {
            var r, i;
            if (Array.prototype.find) return Array.prototype.find.call(e, t);
            for(r = 0, i = e.length; r < i; r += 1){
                var n = e[r];
                if (t(n, r)) return n;
            }
        }, r.assign = function(e) {
            for(var t, r, i = e, n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)s[o - 1] = arguments[o];
            if (Object.assign) return Object.assign.apply(Object, [
                e
            ].concat(s));
            var a = function() {
                var e = s[t];
                "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                    i[t] = e[t];
                });
            };
            for(t = 0, r = s.length; t < r; t += 1)a();
            return e;
        }, r.getBrowserAlias = function(t) {
            return e[t];
        }, r.getBrowserTypeByAlias = function(e) {
            return t[e] || "";
        }, r;
    }(), o = /version\/(\d+(\.?_?\d+)+)/i, a = [
        {
            test: [
                /gptbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "GPTBot"
                }, r = s.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /chatgpt-user/i
            ],
            describe: function(e) {
                var t = {
                    name: "ChatGPT-User"
                }, r = s.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /oai-searchbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "OAI-SearchBot"
                }, r = s.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /claudebot/i,
                /claude-web/i,
                /claude-user/i,
                /claude-searchbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "ClaudeBot"
                }, r = s.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /omgilibot/i,
                /webzio-extended/i
            ],
            describe: function(e) {
                var t = {
                    name: "Omgilibot"
                }, r = s.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /diffbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "Diffbot"
                }, r = s.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /perplexitybot/i
            ],
            describe: function(e) {
                var t = {
                    name: "PerplexityBot"
                }, r = s.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /perplexity-user/i
            ],
            describe: function(e) {
                var t = {
                    name: "Perplexity-User"
                }, r = s.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /youbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "YouBot"
                }, r = s.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /meta-webindexer/i
            ],
            describe: function(e) {
                var t = {
                    name: "Meta-WebIndexer"
                }, r = s.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /meta-externalads/i
            ],
            describe: function(e) {
                var t = {
                    name: "Meta-ExternalAds"
                }, r = s.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /meta-externalagent/i
            ],
            describe: function(e) {
                var t = {
                    name: "Meta-ExternalAgent"
                }, r = s.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /meta-externalfetcher/i
            ],
            describe: function(e) {
                var t = {
                    name: "Meta-ExternalFetcher"
                }, r = s.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /googlebot/i
            ],
            describe: function(e) {
                var t = {
                    name: "Googlebot"
                }, r = s.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /linespider/i
            ],
            describe: function(e) {
                var t = {
                    name: "Linespider"
                }, r = s.getFirstMatch(/(?:linespider)(?:-[-\w]{1,64})?[\s/](\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /amazonbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "AmazonBot"
                }, r = s.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /bingbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "BingCrawler"
                }, r = s.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /baiduspider/i
            ],
            describe: function(e) {
                var t = {
                    name: "BaiduSpider"
                }, r = s.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /duckduckbot/i
            ],
            describe: function(e) {
                var t = {
                    name: "DuckDuckBot"
                }, r = s.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /ia_archiver/i
            ],
            describe: function(e) {
                var t = {
                    name: "InternetArchiveCrawler"
                }, r = s.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /facebookexternalhit/i,
                /facebookcatalog/i
            ],
            describe: function() {
                return {
                    name: "FacebookExternalHit"
                };
            }
        },
        {
            test: [
                /slackbot/i,
                /slack-imgProxy/i
            ],
            describe: function(e) {
                var t = {
                    name: "SlackBot"
                }, r = s.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]{1,64})?[\s/](\d+(\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /yahoo!?[\s/]*slurp/i
            ],
            describe: function() {
                return {
                    name: "YahooSlurp"
                };
            }
        },
        {
            test: [
                /yandexbot/i,
                /yandexmobilebot/i
            ],
            describe: function() {
                return {
                    name: "YandexBot"
                };
            }
        },
        {
            test: [
                /pingdom/i
            ],
            describe: function() {
                return {
                    name: "PingdomBot"
                };
            }
        },
        {
            test: [
                /opera/i
            ],
            describe: function(e) {
                var t = {
                    name: "Opera"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /opr\/|opios/i
            ],
            describe: function(e) {
                var t = {
                    name: "Opera"
                }, r = s.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /SamsungBrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "Samsung Internet for Android"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /Whale/i
            ],
            describe: function(e) {
                var t = {
                    name: "NAVER Whale Browser"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /PaleMoon/i
            ],
            describe: function(e) {
                var t = {
                    name: "Pale Moon"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /HeyTapBrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "HeyTap Browser"
                }, r = s.getFirstMatch(/(?:HeyTapBrowser)[\s/](\d+(?:\.\d+)*)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /VivoBrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "Vivo Browser"
                }, r = s.getFirstMatch(/(?:VivoBrowser)[\s/](\d+(?:\.\d+)*)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /MZBrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "MZ Browser"
                }, r = s.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /focus/i
            ],
            describe: function(e) {
                var t = {
                    name: "Focus"
                }, r = s.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /swing/i
            ],
            describe: function(e) {
                var t = {
                    name: "Swing"
                }, r = s.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /coast/i
            ],
            describe: function(e) {
                var t = {
                    name: "Opera Coast"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /opt\/\d+(?:.?_?\d+)+/i
            ],
            describe: function(e) {
                var t = {
                    name: "Opera Touch"
                }, r = s.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /yabrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "Yandex Browser"
                }, r = s.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /ucbrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "UC Browser"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /Maxthon|mxios/i
            ],
            describe: function(e) {
                var t = {
                    name: "Maxthon"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /epiphany/i
            ],
            describe: function(e) {
                var t = {
                    name: "Epiphany"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /puffin/i
            ],
            describe: function(e) {
                var t = {
                    name: "Puffin"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /sleipnir/i
            ],
            describe: function(e) {
                var t = {
                    name: "Sleipnir"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /k-meleon/i
            ],
            describe: function(e) {
                var t = {
                    name: "K-Meleon"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /micromessenger/i
            ],
            describe: function(e) {
                var t = {
                    name: "WeChat"
                }, r = s.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /qqbrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                }, r = s.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /msie|trident/i
            ],
            describe: function(e) {
                var t = {
                    name: "Internet Explorer"
                }, r = s.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /\sedg\//i
            ],
            describe: function(e) {
                var t = {
                    name: "Microsoft Edge"
                }, r = s.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /edg([ea]|ios)\//i
            ],
            describe: function(e) {
                var t = {
                    name: "Microsoft Edge"
                }, r = s.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: function(e) {
                return !!e.hasBrand("Vivaldi") || e.test(/vivaldi/i);
            },
            describe: function(e, t) {
                var r = {
                    name: "Vivaldi"
                };
                if (t) {
                    var i = t.getBrandVersion("Vivaldi");
                    if (i) return r.version = i, r;
                }
                var n = s.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                return n && (r.version = n), r;
            }
        },
        {
            test: [
                /seamonkey/i
            ],
            describe: function(e) {
                var t = {
                    name: "SeaMonkey"
                }, r = s.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /sailfish/i
            ],
            describe: function(e) {
                var t = {
                    name: "Sailfish"
                }, r = s.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /silk/i
            ],
            describe: function(e) {
                var t = {
                    name: "Amazon Silk"
                }, r = s.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /phantom/i
            ],
            describe: function(e) {
                var t = {
                    name: "PhantomJS"
                }, r = s.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /slimerjs/i
            ],
            describe: function(e) {
                var t = {
                    name: "SlimerJS"
                }, r = s.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /blackberry|\bbb\d+/i,
                /rim\stablet/i
            ],
            describe: function(e) {
                var t = {
                    name: "BlackBerry"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /(web|hpw)[o0]s/i
            ],
            describe: function(e) {
                var t = {
                    name: "WebOS Browser"
                }, r = s.getFirstMatch(o, e) || s.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /bada/i
            ],
            describe: function(e) {
                var t = {
                    name: "Bada"
                }, r = s.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /tizen/i
            ],
            describe: function(e) {
                var t = {
                    name: "Tizen"
                }, r = s.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /qupzilla/i
            ],
            describe: function(e) {
                var t = {
                    name: "QupZilla"
                }, r = s.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /librewolf/i
            ],
            describe: function(e) {
                var t = {
                    name: "LibreWolf"
                }, r = s.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /firefox|iceweasel|fxios/i
            ],
            describe: function(e) {
                var t = {
                    name: "Firefox"
                }, r = s.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /electron/i
            ],
            describe: function(e) {
                var t = {
                    name: "Electron"
                }, r = s.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /sogoumobilebrowser/i,
                /metasr/i,
                /se 2\.[x]/i
            ],
            describe: function(e) {
                var t = {
                    name: "Sogou Browser"
                }, r = s.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), i = s.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), n = s.getFirstMatch(/se ([\d.]+)x/i, e), o = r || i || n;
                return o && (t.version = o), t;
            }
        },
        {
            test: [
                /MiuiBrowser/i
            ],
            describe: function(e) {
                var t = {
                    name: "Miui"
                }, r = s.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: function(e) {
                return !!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i);
            },
            describe: function(e, t) {
                var r = {
                    name: "DuckDuckGo"
                };
                if (t) {
                    var i = t.getBrandVersion("DuckDuckGo");
                    if (i) return r.version = i, r;
                }
                var n = s.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
                return n && (r.version = n), r;
            }
        },
        {
            test: function(e) {
                return e.hasBrand("Brave");
            },
            describe: function(e, t) {
                var r = {
                    name: "Brave"
                };
                if (t) {
                    var i = t.getBrandVersion("Brave");
                    if (i) return r.version = i, r;
                }
                return r;
            }
        },
        {
            test: [
                /chromium/i
            ],
            describe: function(e) {
                var t = {
                    name: "Chromium"
                }, r = s.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /ladybird/i
            ],
            describe: function(e) {
                var t = {
                    name: "Ladybird"
                }, r = s.getFirstMatch(/ladybird\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /chrome|crios|crmo/i
            ],
            describe: function(e) {
                var t = {
                    name: "Chrome"
                }, r = s.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /GSA/i
            ],
            describe: function(e) {
                var t = {
                    name: "Google Search"
                }, r = s.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: function(e) {
                var t = !e.test(/like android/i), r = e.test(/android/i);
                return t && r;
            },
            describe: function(e) {
                var t = {
                    name: "Android Browser"
                }, r = s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /playstation 4/i
            ],
            describe: function(e) {
                var t = {
                    name: "PlayStation 4"
                }, r = s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /safari|applewebkit/i
            ],
            describe: function(e) {
                var t = {
                    name: "Safari"
                }, r = s.getFirstMatch(o, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /.*/i
            ],
            describe: function(e) {
                var t = -1 !== e.search("\\(") ? /^(.*)\/([^/]*)[ \t]\((.*)/ : /^(.*)\/([^/]*) /;
                return {
                    name: s.getFirstMatch(t, e),
                    version: s.getSecondMatch(t, e)
                };
            }
        }
    ], c = [
        {
            test: [
                /Roku\/DVP/
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                return {
                    name: i.Roku,
                    version: t
                };
            }
        },
        {
            test: [
                /windows phone/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                return {
                    name: i.WindowsPhone,
                    version: t
                };
            }
        },
        {
            test: [
                /windows /i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = s.getWindowsVersionName(t);
                return {
                    name: i.Windows,
                    version: t,
                    versionName: r
                };
            }
        },
        {
            test: function(e) {
                return s.isFirefoxOnIpad(e.getUA());
            },
            describe: function(e) {
                var t = {
                    name: i.iOS
                }, r = s.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /macintosh/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = s.getMacOSVersionName(t), n = {
                    name: i.MacOS,
                    version: t
                };
                return r && (n.versionName = r), n;
            }
        },
        {
            test: [
                /(ipod|iphone|ipad)/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                return {
                    name: i.iOS,
                    version: t
                };
            }
        },
        {
            test: [
                /OpenHarmony/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
                return {
                    name: i.HarmonyOS,
                    version: t
                };
            }
        },
        {
            test: function(e) {
                var t = !e.test(/like android/i), r = e.test(/android/i);
                return t && r;
            },
            describe: function(e) {
                var t = s.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = s.getAndroidVersionName(t), n = {
                    name: i.Android,
                    version: t
                };
                return r && (n.versionName = r), n;
            }
        },
        {
            test: [
                /(web|hpw)[o0]s/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                    name: i.WebOS
                };
                return t && t.length && (r.version = t), r;
            }
        },
        {
            test: [
                /blackberry|\bbb\d+/i,
                /rim\stablet/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || s.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || s.getFirstMatch(/\bbb(\d+)/i, e);
                return {
                    name: i.BlackBerry,
                    version: t
                };
            }
        },
        {
            test: [
                /bada/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                return {
                    name: i.Bada,
                    version: t
                };
            }
        },
        {
            test: [
                /tizen/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                return {
                    name: i.Tizen,
                    version: t
                };
            }
        },
        {
            test: [
                /linux/i
            ],
            describe: function() {
                return {
                    name: i.Linux
                };
            }
        },
        {
            test: [
                /CrOS/
            ],
            describe: function() {
                return {
                    name: i.ChromeOS
                };
            }
        },
        {
            test: [
                /PlayStation 4/
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                return {
                    name: i.PlayStation4,
                    version: t
                };
            }
        }
    ], u = [
        {
            test: [
                /googlebot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Google"
                };
            }
        },
        {
            test: [
                /linespider/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Line"
                };
            }
        },
        {
            test: [
                /amazonbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Amazon"
                };
            }
        },
        {
            test: [
                /gptbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "OpenAI"
                };
            }
        },
        {
            test: [
                /chatgpt-user/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "OpenAI"
                };
            }
        },
        {
            test: [
                /oai-searchbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "OpenAI"
                };
            }
        },
        {
            test: [
                /baiduspider/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Baidu"
                };
            }
        },
        {
            test: [
                /bingbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Bing"
                };
            }
        },
        {
            test: [
                /duckduckbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "DuckDuckGo"
                };
            }
        },
        {
            test: [
                /claudebot/i,
                /claude-web/i,
                /claude-user/i,
                /claude-searchbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Anthropic"
                };
            }
        },
        {
            test: [
                /omgilibot/i,
                /webzio-extended/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Webz.io"
                };
            }
        },
        {
            test: [
                /diffbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Diffbot"
                };
            }
        },
        {
            test: [
                /perplexitybot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Perplexity AI"
                };
            }
        },
        {
            test: [
                /perplexity-user/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Perplexity AI"
                };
            }
        },
        {
            test: [
                /youbot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "You.com"
                };
            }
        },
        {
            test: [
                /ia_archiver/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Internet Archive"
                };
            }
        },
        {
            test: [
                /meta-webindexer/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Meta"
                };
            }
        },
        {
            test: [
                /meta-externalads/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Meta"
                };
            }
        },
        {
            test: [
                /meta-externalagent/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Meta"
                };
            }
        },
        {
            test: [
                /meta-externalfetcher/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Meta"
                };
            }
        },
        {
            test: [
                /facebookexternalhit/i,
                /facebookcatalog/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Meta"
                };
            }
        },
        {
            test: [
                /slackbot/i,
                /slack-imgProxy/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Slack"
                };
            }
        },
        {
            test: [
                /yahoo/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Yahoo"
                };
            }
        },
        {
            test: [
                /yandexbot/i,
                /yandexmobilebot/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Yandex"
                };
            }
        },
        {
            test: [
                /pingdom/i
            ],
            describe: function() {
                return {
                    type: r.bot,
                    vendor: "Pingdom"
                };
            }
        },
        {
            test: [
                /huawei/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/(can-l01)/i, e) && "Nova", i = {
                    type: r.mobile,
                    vendor: "Huawei"
                };
                return t && (i.model = t), i;
            }
        },
        {
            test: [
                /nexus\s*(?:7|8|9|10).*/i
            ],
            describe: function() {
                return {
                    type: r.tablet,
                    vendor: "Nexus"
                };
            }
        },
        {
            test: [
                /ipad/i
            ],
            describe: function() {
                return {
                    type: r.tablet,
                    vendor: "Apple",
                    model: "iPad"
                };
            }
        },
        {
            test: function(e) {
                return s.isFirefoxOnIpad(e.getUA());
            },
            describe: function() {
                return {
                    type: r.tablet,
                    vendor: "Apple",
                    model: "iPad"
                };
            }
        },
        {
            test: [
                /kftt build/i
            ],
            describe: function() {
                return {
                    type: r.tablet,
                    vendor: "Amazon",
                    model: "Kindle Fire HD 7"
                };
            }
        },
        {
            test: [
                /silk/i
            ],
            describe: function() {
                return {
                    type: r.tablet,
                    vendor: "Amazon"
                };
            }
        },
        {
            test: [
                /tablet(?! pc)/i
            ],
            describe: function() {
                return {
                    type: r.tablet
                };
            }
        },
        {
            test: function(e) {
                var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                return t && !r;
            },
            describe: function(e) {
                var t = s.getFirstMatch(/(ipod|iphone)/i, e);
                return {
                    type: r.mobile,
                    vendor: "Apple",
                    model: t
                };
            }
        },
        {
            test: [
                /nexus\s*[0-6].*/i,
                /galaxy nexus/i
            ],
            describe: function() {
                return {
                    type: r.mobile,
                    vendor: "Nexus"
                };
            }
        },
        {
            test: [
                /Nokia/i
            ],
            describe: function(e) {
                var t = s.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), i = {
                    type: r.mobile,
                    vendor: "Nokia"
                };
                return t && (i.model = t), i;
            }
        },
        {
            test: [
                /[^-]mobi/i
            ],
            describe: function() {
                return {
                    type: r.mobile
                };
            }
        },
        {
            test: function(e) {
                return "blackberry" === e.getBrowserName(!0);
            },
            describe: function() {
                return {
                    type: r.mobile,
                    vendor: "BlackBerry"
                };
            }
        },
        {
            test: function(e) {
                return "bada" === e.getBrowserName(!0);
            },
            describe: function() {
                return {
                    type: r.mobile
                };
            }
        },
        {
            test: function(e) {
                return "windows phone" === e.getBrowserName();
            },
            describe: function() {
                return {
                    type: r.mobile,
                    vendor: "Microsoft"
                };
            }
        },
        {
            test: function(e) {
                var t = Number(String(e.getOSVersion()).split(".")[0]);
                return "android" === e.getOSName(!0) && t >= 3;
            },
            describe: function() {
                return {
                    type: r.tablet
                };
            }
        },
        {
            test: function(e) {
                return "android" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.mobile
                };
            }
        },
        {
            test: [
                /smart-?tv|smarttv/i
            ],
            describe: function() {
                return {
                    type: r.tv
                };
            }
        },
        {
            test: [
                /netcast/i
            ],
            describe: function() {
                return {
                    type: r.tv
                };
            }
        },
        {
            test: function(e) {
                return "macos" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.desktop,
                    vendor: "Apple"
                };
            }
        },
        {
            test: function(e) {
                return "windows" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.desktop
                };
            }
        },
        {
            test: function(e) {
                return "linux" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.desktop
                };
            }
        },
        {
            test: function(e) {
                return "playstation 4" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.tv
                };
            }
        },
        {
            test: function(e) {
                return "roku" === e.getOSName(!0);
            },
            describe: function() {
                return {
                    type: r.tv
                };
            }
        }
    ], d = [
        {
            test: function(e) {
                return "microsoft edge" === e.getBrowserName(!0);
            },
            describe: function(e) {
                if (/\sedg\//i.test(e)) return {
                    name: n.Blink
                };
                var t = s.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                return {
                    name: n.EdgeHTML,
                    version: t
                };
            }
        },
        {
            test: function(e) {
                return "ladybird" === e.getBrowserName(!0);
            },
            describe: function() {
                return {
                    name: n.LibWeb
                };
            }
        },
        {
            test: [
                /trident/i
            ],
            describe: function(e) {
                var t = {
                    name: n.Trident
                }, r = s.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: function(e) {
                return e.test(/presto/i);
            },
            describe: function(e) {
                var t = {
                    name: n.Presto
                }, r = s.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: function(e) {
                var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                return t && !r;
            },
            describe: function(e) {
                var t = {
                    name: n.Gecko
                }, r = s.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        },
        {
            test: [
                /(apple)?webkit\/537\.36/i
            ],
            describe: function() {
                return {
                    name: n.Blink
                };
            }
        },
        {
            test: [
                /(apple)?webkit/i
            ],
            describe: function(e) {
                var t = {
                    name: n.WebKit
                }, r = s.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                return r && (t.version = r), t;
            }
        }
    ], f = function() {
        function e(e, t, r) {
            if (void 0 === t && (t = !1), void 0 === r && (r = null), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
            this._ua = e;
            var i = !1;
            "boolean" == typeof t ? (i = t, this._hints = r) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== i && this.parse();
        }
        var t = e.prototype;
        return t.getHints = function() {
            return this._hints;
        }, t.hasBrand = function(e) {
            if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
            var t = e.toLowerCase();
            return this._hints.brands.some(function(e) {
                return e.brand && e.brand.toLowerCase() === t;
            });
        }, t.getBrandVersion = function(e) {
            if (this._hints && Array.isArray(this._hints.brands)) {
                var t = e.toLowerCase(), r = s.find(this._hints.brands, function(e) {
                    return e.brand && e.brand.toLowerCase() === t;
                });
                return r ? r.version : void 0;
            }
        }, t.getUA = function() {
            return this._ua;
        }, t.test = function(e) {
            return e.test(this._ua);
        }, t.parseBrowser = function() {
            var e = this;
            this.parsedResult.browser = {};
            var t = s.find(a, function(t) {
                if ("function" == typeof t.test) return t.test(e);
                if (Array.isArray(t.test)) return t.test.some(function(t) {
                    return e.test(t);
                });
                throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.browser = t.describe(this.getUA(), this)), this.parsedResult.browser;
        }, t.getBrowser = function() {
            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
        }, t.getBrowserName = function(e) {
            return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
        }, t.getBrowserVersion = function() {
            return this.getBrowser().version;
        }, t.getOS = function() {
            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
        }, t.parseOS = function() {
            var e = this;
            this.parsedResult.os = {};
            var t = s.find(c, function(t) {
                if ("function" == typeof t.test) return t.test(e);
                if (Array.isArray(t.test)) return t.test.some(function(t) {
                    return e.test(t);
                });
                throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
        }, t.getOSName = function(e) {
            var t = this.getOS().name;
            return e ? String(t).toLowerCase() || "" : t || "";
        }, t.getOSVersion = function() {
            return this.getOS().version;
        }, t.getPlatform = function() {
            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
        }, t.getPlatformType = function(e) {
            void 0 === e && (e = !1);
            var t = this.getPlatform().type;
            return e ? String(t).toLowerCase() || "" : t || "";
        }, t.parsePlatform = function() {
            var e = this;
            this.parsedResult.platform = {};
            var t = s.find(u, function(t) {
                if ("function" == typeof t.test) return t.test(e);
                if (Array.isArray(t.test)) return t.test.some(function(t) {
                    return e.test(t);
                });
                throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
        }, t.getEngine = function() {
            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
        }, t.getEngineName = function(e) {
            return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
        }, t.parseEngine = function() {
            var e = this;
            this.parsedResult.engine = {};
            var t = s.find(d, function(t) {
                if ("function" == typeof t.test) return t.test(e);
                if (Array.isArray(t.test)) return t.test.some(function(t) {
                    return e.test(t);
                });
                throw new Error("Browser's test function is not valid");
            });
            return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
        }, t.parse = function() {
            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
        }, t.getResult = function() {
            return s.assign({}, this.parsedResult);
        }, t.satisfies = function(e) {
            var t = this, r = {}, i = 0, n = {}, o = 0;
            if (Object.keys(e).forEach(function(t) {
                var s = e[t];
                "string" == typeof s || Array.isArray(s) ? (n[t] = s, o += 1) : "object" == typeof s && (r[t] = s, i += 1);
            }), i > 0) {
                var a = Object.keys(r), c = s.find(a, function(e) {
                    return t.isOS(e);
                });
                if (c) {
                    var u = this.satisfies(r[c]);
                    if (void 0 !== u) return u;
                }
                var d = s.find(a, function(e) {
                    return t.isPlatform(e);
                });
                if (d) {
                    var f = this.satisfies(r[d]);
                    if (void 0 !== f) return f;
                }
            }
            if (o > 0) {
                var b = Object.keys(n), l = s.find(b, function(e) {
                    return t.isBrowser(e, !0);
                });
                if (void 0 !== l) return this.compareVersions(n[l]);
            }
        }, t.isBrowser = function(e, t) {
            void 0 === t && (t = !1);
            var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = s.getBrowserTypeByAlias(i);
            return t && n && (i = n.toLowerCase()), i === r;
        }, t.compareVersions = function(e) {
            var t = this;
            return "string" == typeof e ? this.compareVersion(e) : e.some(function(e) {
                return t.compareVersion(e);
            });
        }, t.compareVersion = function(e) {
            var t = [
                0
            ], r = e, i = !1, n = this.getBrowserVersion();
            if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(s.compareVersions(n, r, i)) > -1;
        }, t.isOS = function(e) {
            return this.getOSName(!0) === String(e).toLowerCase();
        }, t.isPlatform = function(e) {
            return this.getPlatformType(!0) === String(e).toLowerCase();
        }, t.isEngine = function(e) {
            return this.getEngineName(!0) === String(e).toLowerCase();
        }, t.is = function(e, t) {
            return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
        }, t.some = function(e) {
            var t = this;
            return void 0 === e && (e = []), e.some(function(e) {
                return t.is(e);
            });
        }, e;
    }();
    function b(e) {
        var t = function(e) {
            if ("object" != typeof e || !e) return e;
            var t = e[Symbol.toPrimitive];
            if (void 0 !== t) {
                var r = t.call(e, "string");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(e);
        }(e);
        return "symbol" == typeof t ? t : t + "";
    }
    var l = function() {
        function e() {}
        var s, o;
        return e.getParser = function(e, t, r) {
            if (void 0 === t && (t = !1), void 0 === r && (r = null), "string" != typeof e) throw new Error("UserAgent should be a string");
            return new f(e, t, r);
        }, e.parse = function(e, t) {
            return void 0 === t && (t = null), new f(e, t).getResult();
        }, s = e, o = [
            {
                key: "BROWSER_MAP",
                get: function() {
                    return t;
                }
            },
            {
                key: "ENGINE_MAP",
                get: function() {
                    return n;
                }
            },
            {
                key: "OS_MAP",
                get: function() {
                    return i;
                }
            },
            {
                key: "PLATFORMS_MAP",
                get: function() {
                    return r;
                }
            }
        ], /*!
  	* Bowser - a browser detector
  	* https://github.com/bowser-js/bowser
  	* MIT License | (c) Dustin Diaz 2012-2015
  	* MIT License | (c) Denis Demchenko 2015-2026
  	*/ function(e, t) {
            for(var r = 0; r < t.length; r++){
                var i = t[r];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, b(i.key), i);
            }
        }(s, o), Object.defineProperty(s, "prototype", {
            writable: !1
        }), s;
    }();
    return l.parse, l.getParser, l;
});


var $01291e50efc3ae48$export$69d579f32876892f = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, $2R3UW.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($8d2b943a01d89bd0$exports))).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};


/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $14a38cdd9d031bcf$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $14a38cdd9d031bcf$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $76117ac3dc586dcd$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $76117ac3dc586dcd$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $dea068437d015b4c$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $76117ac3dc586dcd$export$c7c5cef950a4d2fc)(input) : (0, $14a38cdd9d031bcf$export$c7c5cef950a4d2fc)(input);
};
var $dea068437d015b4c$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $76117ac3dc586dcd$export$b4b216764bb846eb)(input) : (0, $14a38cdd9d031bcf$export$b4b216764bb846eb)(input);
};



// Partition default templates
var $b25637d950d6de8d$var$AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var $b25637d950d6de8d$var$AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var $b25637d950d6de8d$var$AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var $b25637d950d6de8d$var$AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var $b25637d950d6de8d$var$AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var $b25637d950d6de8d$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $b25637d950d6de8d$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $b25637d950d6de8d$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $b25637d950d6de8d$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $b25637d950d6de8d$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $b25637d950d6de8d$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "cognito-identity.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "cognito-identity.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "cognito-identity.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($b25637d950d6de8d$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($b25637d950d6de8d$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($b25637d950d6de8d$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($b25637d950d6de8d$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($b25637d950d6de8d$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $b25637d950d6de8d$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({
        signingService: "cognito-identity"
    }, regionInfo));
};



var $2R3UW = parcelRequire("2R3UW");
function $05c0f3078ba61b85$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $2R3UW.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $2R3UW.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}


var $fa9ba959cb452661$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $05c0f3078ba61b85$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};


var $57f7e921482035c6$export$608864383388f904 = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $b25637d950d6de8d$export$2e4318bf13462aa2),
    serviceId: "Cognito Identity",
    urlParser: (0, $fa9ba959cb452661$export$7a5253c0f62e0150)
};


var $ceed2b762fccbc5a$export$b1f2d721b555a243 = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, (0, $57f7e921482035c6$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $7cbce5b9f8516cac$export$c537b38001c583b7),
    base64Encoder: (0, $7cbce5b9f8516cac$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $04ceec2b4b32d579$export$967f3527bf233bc0),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $01291e50efc3ae48$export$69d579f32876892f)({
        serviceId: (0, $57f7e921482035c6$export$608864383388f904).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($5ae9f5b58c3f1597$exports))).version
    }),
    maxAttempts: (0, $cc9220ec102b8f39$export$2c7e51f38ba5a406),
    region: (0, $f7ad0cbdfcbdd3bf$export$d59dd53963f8f3d5)("Region is missing"),
    requestHandler: new (0, $4f85640929636496$export$83588b87edbfa7e0)(),
    sha256: (0, $884a5260025384f7$exports.Sha256),
    streamCollector: (0, $12afb2b1a2425333$export$17bf97b72e307d52),
    utf8Decoder: (0, $dea068437d015b4c$export$c7c5cef950a4d2fc),
    utf8Encoder: (0, $dea068437d015b4c$export$b4b216764bb846eb)
});



var $2R3UW = parcelRequire("2R3UW");
var $44bd1ce362a3c380$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? $44bd1ce362a3c380$var$normalizeEndpoint(input) : function() {
            return $44bd1ce362a3c380$var$getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var $44bd1ce362a3c380$var$normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var $44bd1ce362a3c380$var$getEndPointFromRegion = function(input) {
    return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $2R3UW.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};



var $2R3UW = parcelRequire("2R3UW");
var $67e7c06acfe8e883$export$26513716e2900bad = "AWS_REGION";
var $67e7c06acfe8e883$export$8afb1c306a7d01b = "region";
var $67e7c06acfe8e883$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$67e7c06acfe8e883$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$67e7c06acfe8e883$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $67e7c06acfe8e883$export$9a37503ca194454d = {
    preferredFile: "credentials"
};
var $67e7c06acfe8e883$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        region: $67e7c06acfe8e883$var$normalizeRegion(input.region)
    });
};
var $67e7c06acfe8e883$var$normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};





var $2R3UW = parcelRequire("2R3UW");

var $e1f251a56385836a$var$CONTENT_LENGTH_HEADER = "content-length";
function $e1f251a56385836a$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($e1f251a56385836a$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, request.headers), (_a = {}, _a[$e1f251a56385836a$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $e1f251a56385836a$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var $e1f251a56385836a$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($e1f251a56385836a$export$940b29eb2788b975(options.bodyLengthChecker), $e1f251a56385836a$export$1f7816f8f350b2f5);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");

function $ff12c45aae4e0594$export$c1625bf0b32b4481(input) {
    return input;
}
var $ff12c45aae4e0594$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $ff12c45aae4e0594$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var $ff12c45aae4e0594$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($ff12c45aae4e0594$export$858685d7aeef192d(options), $ff12c45aae4e0594$export$696d244ba96181e8);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");
var $5e7a24de912cecc7$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, $2R3UW.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $5e7a24de912cecc7$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var $5e7a24de912cecc7$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($5e7a24de912cecc7$export$fe0e777ee4f58cde(), $5e7a24de912cecc7$export$877c148ab4ad0722);
        }
    };
};






var $2R3UW = parcelRequire("2R3UW");

var $2R3UW = parcelRequire("2R3UW");

var $0e6b98a49897d626$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $0e6b98a49897d626$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $0e6b98a49897d626$export$6e114beec37430d7 = "X-Amz-Date";
var $0e6b98a49897d626$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $0e6b98a49897d626$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $0e6b98a49897d626$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $0e6b98a49897d626$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $0e6b98a49897d626$export$9924a64a4b8b0d58 = "authorization";
var $0e6b98a49897d626$export$acf4b8bdf24aab34 = $0e6b98a49897d626$export$6e114beec37430d7.toLowerCase();
var $0e6b98a49897d626$export$c65c8c9f514da472 = "date";
var $0e6b98a49897d626$export$20d6a73fd0b10982 = [
    $0e6b98a49897d626$export$9924a64a4b8b0d58,
    $0e6b98a49897d626$export$acf4b8bdf24aab34,
    $0e6b98a49897d626$export$c65c8c9f514da472
];
var $0e6b98a49897d626$export$29961f34c719157e = $0e6b98a49897d626$export$41ae838dc1e0f082.toLowerCase();
var $0e6b98a49897d626$export$eaef12179141669a = "x-amz-content-sha256";
var $0e6b98a49897d626$export$fdc81b663012a8d2 = $0e6b98a49897d626$export$8e1383b7eea7bee.toLowerCase();
var $0e6b98a49897d626$export$96307741595055fc = "host";
var $0e6b98a49897d626$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $0e6b98a49897d626$export$8085db98abbe0597 = /^proxy-/;
var $0e6b98a49897d626$export$758380400526c39 = /^sec-/;
var $0e6b98a49897d626$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $0e6b98a49897d626$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $0e6b98a49897d626$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $0e6b98a49897d626$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $0e6b98a49897d626$export$bf665777b4a1722f = 50;
var $0e6b98a49897d626$export$c4bf0942098f6bb = "aws4_request";
var $0e6b98a49897d626$export$274df788bdcca184 = 604800;


var $2c5372712a173b97$var$signingKeyCache = {};
var $2c5372712a173b97$var$cacheQueue = [];
function $2c5372712a173b97$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $0e6b98a49897d626$export$c4bf0942098f6bb);
}
var $2c5372712a173b97$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $2R3UW.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $2c5372712a173b97$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $2c5372712a173b97$var$signingKeyCache) return [
                        2 /*return*/ ,
                        $2c5372712a173b97$var$signingKeyCache[cacheKey]
                    ];
                    $2c5372712a173b97$var$cacheQueue.push(cacheKey);
                    while($2c5372712a173b97$var$cacheQueue.length > (0, $0e6b98a49897d626$export$bf665777b4a1722f))delete $2c5372712a173b97$var$signingKeyCache[$2c5372712a173b97$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $2R3UW.__values)([
                        shortDate,
                        region,
                        service,
                        (0, $0e6b98a49897d626$export$c4bf0942098f6bb)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        $2c5372712a173b97$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        $2c5372712a173b97$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function $2c5372712a173b97$export$a31b95746ea0a30a() {
    $2c5372712a173b97$var$cacheQueue.length = 0;
    Object.keys($2c5372712a173b97$var$signingKeyCache).forEach(function(cacheKey) {
        delete $2c5372712a173b97$var$signingKeyCache[cacheKey];
    });
}
function $2c5372712a173b97$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}



var $2R3UW = parcelRequire("2R3UW");




var $2R3UW = parcelRequire("2R3UW");

function $1e32616971f6932f$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $2R3UW.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $0e6b98a49897d626$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $0e6b98a49897d626$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $0e6b98a49897d626$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}



var $2R3UW = parcelRequire("2R3UW");


function $c3f3096327c813dc$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $0e6b98a49897d626$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(key) + "=" + (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(key) + "=" + (0, $34a3db2e1651452d$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $2R3UW.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}



var $2R3UW = parcelRequire("2R3UW");
var $01a0b463a62225e1$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};




function $953f9fe0e9e734f0$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $2R3UW.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $2R3UW.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $0e6b98a49897d626$export$eaef12179141669a)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $01a0b463a62225e1$export$9dd3754ae86f0017)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $ab304b52b02b1119$export$7ea66e3774a60b67);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $0e6b98a49897d626$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
}



var $2R3UW = parcelRequire("2R3UW");
function $8f4c1c254db458fb$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $2R3UW.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}



var $2R3UW = parcelRequire("2R3UW");

var $2R3UW = parcelRequire("2R3UW");
function $8b4c5899159ec633$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $2R3UW.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, rest), {
        headers: (0, $2R3UW.__assign)({}, headers),
        query: query ? $8b4c5899159ec633$var$cloneQuery(query) : undefined
    });
}
function $8b4c5899159ec633$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $2R3UW.__spread)(param) : param, _a));
    }, {});
}


function $d5c79008701d40e5$export$bfc08a76d4bd60f6(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $8b4c5899159ec633$export$d043aa0bf7223286)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $2R3UW.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, request), {
        headers: headers,
        query: query
    });
}



var $2R3UW = parcelRequire("2R3UW");


function $0915fa7ce01eb1a3$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $8b4c5899159ec633$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $2R3UW.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $0e6b98a49897d626$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}


function $1aebf1715865ee5b$export$b65d57190c224ef2(time) {
    return $1aebf1715865ee5b$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $1aebf1715865ee5b$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}


var $7b8a7d6416660eac$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $7b8a7d6416660eac$var$normalizeRegionProvider(region);
        this.credentialProvider = $7b8a7d6416660eac$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $2R3UW.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $7b8a7d6416660eac$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $0e6b98a49897d626$export$274df788bdcca184)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $2c5372712a173b97$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $d5c79008701d40e5$export$bfc08a76d4bd60f6)((0, $0915fa7ce01eb1a3$export$a7cfe9131aa06be4)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $0e6b98a49897d626$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $0e6b98a49897d626$export$186cd8495ba0377d] = (0, $0e6b98a49897d626$export$863a63fba5b2ddf5);
                        request.query[0, $0e6b98a49897d626$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $0e6b98a49897d626$export$6e114beec37430d7] = longDate;
                        request.query[0, $0e6b98a49897d626$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $1e32616971f6932f$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $0e6b98a49897d626$export$2dcbb254f883c238] = $7b8a7d6416660eac$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $0e6b98a49897d626$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $953f9fe0e9e734f0$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            return (0, $2R3UW.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $2R3UW.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $7b8a7d6416660eac$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $2c5372712a173b97$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $953f9fe0e9e734f0$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $ab304b52b02b1119$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $0e6b98a49897d626$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $2R3UW.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $7b8a7d6416660eac$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $ab304b52b02b1119$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $2R3UW.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $0915fa7ce01eb1a3$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $7b8a7d6416660eac$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $2c5372712a173b97$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $0e6b98a49897d626$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $0e6b98a49897d626$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $953f9fe0e9e734f0$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $8f4c1c254db458fb$export$17944590be865217)((0, $0e6b98a49897d626$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $0e6b98a49897d626$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $1e32616971f6932f$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $0e6b98a49897d626$export$9924a64a4b8b0d58] = (0, $0e6b98a49897d626$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $7b8a7d6416660eac$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $c3f3096327c813dc$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $2R3UW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $0e6b98a49897d626$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $2R3UW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $ab304b52b02b1119$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $2c5372712a173b97$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $7b8a7d6416660eac$var$formatDate = function(now) {
    var longDate = (0, $1aebf1715865ee5b$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $7b8a7d6416660eac$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $7b8a7d6416660eac$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $7b8a7d6416660eac$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};




function $f475582ef4ec5a2f$export$1dd62920de1feabb(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = $f475582ef4ec5a2f$var$normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = $f475582ef4ec5a2f$var$normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return $f475582ef4ec5a2f$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                return (0, $2R3UW.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $2R3UW.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, $7b8a7d6416660eac$export$20baf4d3f65eb30c)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function $f475582ef4ec5a2f$var$normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}



var $2R3UW = parcelRequire("2R3UW");

var $fd36231d159a06aa$var$isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs($fd36231d159a06aa$var$getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var $fd36231d159a06aa$var$getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function $fd36231d159a06aa$export$78af9708f8cf3422(options) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, $2R3UW.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, $2R3UW.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, $2R3UW.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if ($fd36231d159a06aa$var$isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var $fd36231d159a06aa$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var $fd36231d159a06aa$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($fd36231d159a06aa$export$78af9708f8cf3422(options), $fd36231d159a06aa$export$29f4b3a6e94017d3);
        }
    };
};





var $2R3UW = parcelRequire("2R3UW");
function $8b3b0e8537f7bde2$export$ec9a2d5663958cb(input) {
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}



var $2R3UW = parcelRequire("2R3UW");

var $af76c3eaf0e24e85$export$97a08a1bb7ee0545 = "user-agent";
var $af76c3eaf0e24e85$export$e010e3d6246262a3 = "x-amz-user-agent";
var $af76c3eaf0e24e85$export$27b7b95a5fde2b31 = " ";
var $af76c3eaf0e24e85$export$92df4a8c4ea32a70 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;


var $cd71f90f32b2eb9a$export$62c460923941c0b0 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, $2R3UW.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map($cd71f90f32b2eb9a$var$escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map($cd71f90f32b2eb9a$var$escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map($cd71f90f32b2eb9a$var$escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, $af76c3eaf0e24e85$export$e010e3d6246262a3] = (0, $2R3UW.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, $af76c3eaf0e24e85$export$27b7b95a5fde2b31));
                            normalUAValue = (0, $2R3UW.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, $af76c3eaf0e24e85$export$27b7b95a5fde2b31));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, $af76c3eaf0e24e85$export$97a08a1bb7ee0545] = headers[0, $af76c3eaf0e24e85$export$97a08a1bb7ee0545] ? headers[0, $af76c3eaf0e24e85$export$97a08a1bb7ee0545] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var $cd71f90f32b2eb9a$var$escapeUserAgent = function(_a) {
    var _b = (0, $2R3UW.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, $af76c3eaf0e24e85$export$92df4a8c4ea32a70), "_");
    }).join("/");
};
var $cd71f90f32b2eb9a$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var $cd71f90f32b2eb9a$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($cd71f90f32b2eb9a$export$62c460923941c0b0(config), $cd71f90f32b2eb9a$export$29eb04da6afef73f);
        }
    };
};





/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */ var $ebbb5b6085ccbb85$export$e576def690e850f7 = /** @class */ function(_super) {
    (0, $2e58fe9d375f2959$export$a8ba968b8961cb8a)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $2e58fe9d375f2959$export$18ce0697a983be9b)((0, $2e58fe9d375f2959$export$18ce0697a983be9b)({}, (0, $ceed2b762fccbc5a$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $67e7c06acfe8e883$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $44bd1ce362a3c380$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $f475582ef4ec5a2f$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $ffd161ca6b258fc7$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $ff12c45aae4e0594$export$c1625bf0b32b4481)(_config_4);
        var _config_6 = (0, $8b3b0e8537f7bde2$export$ec9a2d5663958cb)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $2d8b999fb8b8d488$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $e1f251a56385836a$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $ff12c45aae4e0594$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $5e7a24de912cecc7$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $cd71f90f32b2eb9a$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $ad5f68adc06fa5bd$export$1f2bb630327ac4b6));



var $4f8ea70a17dc70ac$var$__assign = undefined && undefined.__assign || function() {
    $4f8ea70a17dc70ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f8ea70a17dc70ac$var$__assign.apply(this, arguments);
};
function $4f8ea70a17dc70ac$export$4dc42d1682bf6ec4(config) {
    var client = new (0, $ebbb5b6085ccbb85$export$e576def690e850f7)({
        region: config.region,
        customUserAgent: (0, $8eca817bf49e3d6a$export$ede38edb26c0bfdf)()
    });
    client.middlewareStack.add(function(next, _) {
        return function(args) {
            return next($4f8ea70a17dc70ac$export$43d5d423bebf581b(args));
        };
    }, {
        step: 'build',
        name: 'cacheControlMiddleWare'
    });
    return client;
}
function $4f8ea70a17dc70ac$export$43d5d423bebf581b(args) {
    return $4f8ea70a17dc70ac$var$__assign($4f8ea70a17dc70ac$var$__assign({}, args), {
        request: $4f8ea70a17dc70ac$var$__assign($4f8ea70a17dc70ac$var$__assign({}, args.request), {
            headers: $4f8ea70a17dc70ac$var$__assign($4f8ea70a17dc70ac$var$__assign({}, args.request.headers), {
                'cache-control': 'no-store'
            })
        })
    });
}


var $99c5343f38dbb45f$var$__assign = undefined && undefined.__assign || function() {
    $99c5343f38dbb45f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $99c5343f38dbb45f$var$__assign.apply(this, arguments);
};
var $99c5343f38dbb45f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $99c5343f38dbb45f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $99c5343f38dbb45f$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Credentials');
var $99c5343f38dbb45f$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $99c5343f38dbb45f$var$COGNITO_IDENTITY_KEY_PREFIX = 'CognitoIdentityId-';
var $99c5343f38dbb45f$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = (0, $c0973eff25c5eafe$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers['facebook'] = (0, $c0973eff25c5eafe$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $99c5343f38dbb45f$var$__assign($99c5343f38dbb45f$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $95dac8785b133953$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $99c5343f38dbb45f$var$logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "" + $99c5343f38dbb45f$var$COGNITO_IDENTITY_KEY_PREFIX + identityPoolId;
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $99c5343f38dbb45f$var$logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $99c5343f38dbb45f$var$logger.debug('getting new cred promise');
            this._gettingCredPromise = (0, $1436837d4e301e07$export$8f33cb495ca11832)(this._keepAlive());
        } else $99c5343f38dbb45f$var$logger.debug('getting old cred promise');
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $99c5343f38dbb45f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $99c5343f38dbb45f$var$logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $99c5343f38dbb45f$var$logger.debug('credentials not changed and not expired, directly return');
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $99c5343f38dbb45f$var$logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? (0, $5af950529fc36b5c$export$a3858a9a153cffc7).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') return [
                            2 /*return*/ ,
                            Promise.reject('No Auth module registered in Amplify')
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $99c5343f38dbb45f$var$logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $99c5343f38dbb45f$var$logger.debug('Error attempting to refreshing the session', err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $99c5343f38dbb45f$var$logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $99c5343f38dbb45f$var$logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            $99c5343f38dbb45f$var$logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
            $99c5343f38dbb45f$var$logger.debug('getting refreshed jwt token from federation provider');
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $99c5343f38dbb45f$var$logger.debug('no refresh handler for provider:', provider);
            this.clear();
            return Promise.reject('no refresh handler for provider');
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $f0e9cd56ec245870$export$a24aa7705df9cf44)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $99c5343f38dbb45f$var$logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === 'string' && e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) _this.clear();
            $99c5343f38dbb45f$var$logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $99c5343f38dbb45f$var$logger.debug('no credentials for expiration check');
            return true;
        }
        $99c5343f38dbb45f$var$logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, mandatorySignIn, identityId, _b, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return $99c5343f38dbb45f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $99c5343f38dbb45f$var$logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject('cannot get guest credentials when mandatory signin enabled')
                        ];
                        if (!identityPoolId) {
                            $99c5343f38dbb45f$var$logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [
                                2 /*return*/ ,
                                Promise.reject('No Cognito Identity pool provided for unauthenticated access')
                            ];
                        }
                        if (!region) {
                            $99c5343f38dbb45f$var$logger.debug('region is not configured for getting the credentials');
                            return [
                                2 /*return*/ ,
                                Promise.reject('region is not configured for getting the credentials')
                            ];
                        }
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _b._identityId = _c.sent();
                        cognitoClient = (0, $4f8ea70a17dc70ac$export$4dc42d1682bf6ec4)({
                            region: region
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient
                            };
                            credentials = (0, $a4e05f336396bc38$export$4d624d71eb462130)(cognitoIdentityParams)();
                        } else {
                            credentialsProvider = function() {
                                return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                    return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    cognitoClient.send(new (0, $0c824b600c63edcc$export$41ceb4ced4f97a44)({
                                                        IdentityPoolId: identityPoolId
                                                    }))
                                                ];
                                            case 1:
                                                IdentityId = _a.sent().IdentityId;
                                                this._identityId = IdentityId;
                                                cognitoIdentityParams = {
                                                    client: cognitoClient,
                                                    identityId: IdentityId
                                                };
                                                credentialsFromCognitoIdentity = (0, $a4e05f336396bc38$export$4d624d71eb462130)(cognitoIdentityParams);
                                                return [
                                                    2 /*return*/ ,
                                                    credentialsFromCognitoIdentity()
                                                ];
                                        }
                                    });
                                });
                            };
                            credentials = credentialsProvider().catch(function(err) {
                                return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                                    return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                                        throw err;
                                    });
                                });
                            });
                        }
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, 'guest', false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                                    var credentialsProvider;
                                    var _this = this;
                                    return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === 'ResourceNotFoundException' && e.message === "Identity '" + identityId + "' not found.")) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                $99c5343f38dbb45f$var$logger.debug('Failed to load guest credentials');
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                credentialsProvider = function() {
                                                    return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                        return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        cognitoClient.send(new (0, $0c824b600c63edcc$export$41ceb4ced4f97a44)({
                                                                            IdentityPoolId: identityPoolId
                                                                        }))
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    cognitoIdentityParams = {
                                                                        client: cognitoClient,
                                                                        identityId: IdentityId
                                                                    };
                                                                    credentialsFromCognitoIdentity = (0, $a4e05f336396bc38$export$4d624d71eb462130)(cognitoIdentityParams);
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        credentialsFromCognitoIdentity()
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = credentialsProvider().catch(function(err) {
                                                    return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                                                        return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, 'guest', false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com'
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject('You must specify a federated provider');
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $99c5343f38dbb45f$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $99c5343f38dbb45f$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoClient = (0, $4f8ea70a17dc70ac$export$4dc42d1682bf6ec4)({
            region: region
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient
            };
            credentials = (0, $a4e05f336396bc38$export$4d624d71eb462130)(cognitoIdentityParams)();
        } else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient
            };
            credentials = (0, $cb0e39c9ed8a9eaa$export$6c7d622e9507a2e)(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $99c5343f38dbb45f$var$logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $99c5343f38dbb45f$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $99c5343f38dbb45f$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = (0, $4f8ea70a17dc70ac$export$4dc42d1682bf6ec4)({
            region: region
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return $99c5343f38dbb45f$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $0c824b600c63edcc$export$41ceb4ced4f97a44)({
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                }))
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $ac812dcb62eea806$export$e08b3308c36761ec)({
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                }))
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            $99c5343f38dbb45f$var$logger.debug("The guest identity " + guestIdentityId + " has been successfully linked to the logins");
                            if (guestIdentityId === primaryIdentityId) $99c5343f38dbb45f$var$logger.debug("The guest identity " + guestIdentityId + " has become the primary identity");
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $99c5343f38dbb45f$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $99c5343f38dbb45f$var$logger.debug('Load credentials successfully', credentials);
                                if (this._identityId && !credentials.identityId) credentials['identityId'] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $99c5343f38dbb45f$var$CREDENTIALS_TTL;
                                if (source === 'federated') {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $99c5343f38dbb45f$var$logger.debug('Failed to put federated info into auth storage', e);
                                    }
                                }
                                if (!(source === 'guest')) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $99c5343f38dbb45f$var$logger.debug('Failed to load credentials', credentials);
                    $99c5343f38dbb45f$var$logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === 'session') return this._setCredentialsFromSession(params);
        else if (source === 'federation') return this._setCredentialsFromFederation(params);
        else if (source === 'guest') return this._setCredentialsForGuest();
        else {
            $99c5343f38dbb45f$var$logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $99c5343f38dbb45f$var$logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        $99c5343f38dbb45f$var$logger.debug('Failed to get the cached guest identityId', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        $99c5343f38dbb45f$var$logger.debug('Failed to cache guest identityId', e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return $99c5343f38dbb45f$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return $99c5343f38dbb45f$var$__generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                $99c5343f38dbb45f$var$logger.debug("removing " + this._getCognitoIdentityIdStorageKey(identityPoolId) + " from storage");
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $99c5343f38dbb45f$export$a9627919734faa48 = new $99c5343f38dbb45f$export$9be509043bd0c09a(null);
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).register($99c5343f38dbb45f$export$a9627919734faa48);
var /**
 * @deprecated use named import
 */ $99c5343f38dbb45f$export$2e2bcd8739ae039 = $99c5343f38dbb45f$export$a9627919734faa48;


/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $501a52dd801880e3$export$efa87b877bb98f58 = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = '/service-worker.js';
        if (scope === void 0) scope = '/';
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $5af950529fc36b5c$export$a3858a9a153cffc7).Analytics && typeof (0, $5af950529fc36b5c$export$a3858a9a153cffc7).Analytics.record === 'function') (0, $5af950529fc36b5c$export$a3858a9a153cffc7).Analytics.record({
                name: 'ServiceWorker',
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener('message', function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var /**
 * @deprecated use named import
 */ $501a52dd801880e3$export$2e2bcd8739ae039 = $501a52dd801880e3$export$efa87b877bb98f58;



/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $b886433cba6a7bca$export$98e6a39c04603d36;
var $b886433cba6a7bca$export$dfdc1655ccc5b9cb;
'use strict';
$b886433cba6a7bca$export$98e6a39c04603d36 = $b886433cba6a7bca$var$parse;
$b886433cba6a7bca$export$dfdc1655ccc5b9cb = $b886433cba6a7bca$var$serialize;
/**
 * Module variables.
 * @private
 */ var $b886433cba6a7bca$var$decode = decodeURIComponent;
var $b886433cba6a7bca$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $b886433cba6a7bca$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $b886433cba6a7bca$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $b886433cba6a7bca$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $b886433cba6a7bca$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $b886433cba6a7bca$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $b886433cba6a7bca$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$b886433cba6a7bca$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$b886433cba6a7bca$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$b886433cba6a7bca$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$b886433cba6a7bca$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $b886433cba6a7bca$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $da5a5ed7a0a267a4$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $da5a5ed7a0a267a4$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $da5a5ed7a0a267a4$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $b886433cba6a7bca$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $da5a5ed7a0a267a4$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $da5a5ed7a0a267a4$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $da5a5ed7a0a267a4$var$cleanupCookieValue(value);
    if ($da5a5ed7a0a267a4$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $da5a5ed7a0a267a4$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $bbe26ad2aadc7573$var$__assign = undefined && undefined.__assign || function() {
    $bbe26ad2aadc7573$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbe26ad2aadc7573$var$__assign.apply(this, arguments);
};
var $bbe26ad2aadc7573$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $da5a5ed7a0a267a4$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $da5a5ed7a0a267a4$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $b886433cba6a7bca$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $da5a5ed7a0a267a4$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $da5a5ed7a0a267a4$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $bbe26ad2aadc7573$var$__assign($bbe26ad2aadc7573$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b886433cba6a7bca$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $bbe26ad2aadc7573$var$__assign($bbe26ad2aadc7573$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $bbe26ad2aadc7573$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $b886433cba6a7bca$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $bbe26ad2aadc7573$export$2e2bcd8739ae039 = $bbe26ad2aadc7573$var$Cookies;


var $f4679304ac26a560$export$2e2bcd8739ae039 = (0, $bbe26ad2aadc7573$export$2e2bcd8739ae039);



var $0c332331e284d949$var$isBrowser = (0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser;
var $0c332331e284d949$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $f4679304ac26a560$export$2e2bcd8739ae039)();
        this.store = $0c332331e284d949$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $f4679304ac26a560$export$2e2bcd8739ae039)(context.req.headers.cookie) : new (0, $f4679304ac26a560$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: '/'
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        switch(tokenType){
            // LastAuthUser is needed for computing other key names
            case 'LastAuthUser':
            // accessToken is required for CognitoUserSession
            case 'accessToken':
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            case 'refreshToken':
            // Required for CognitoUserSession
            case 'idToken':
                $0c332331e284d949$var$isBrowser ? this.setUniversalItem(key, value) : this.setLocalItem(key, value);
        }
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value) {
        this.cookies.set(key, value, {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === 'localhost' ? false : true
        });
    };
    return UniversalStorage;
}();


/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $007702ee4802c713$var$hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var $007702ee4802c713$export$36df2663cc7faf97 = $007702ee4802c713$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER';
var $007702ee4802c713$export$ea26e09ecef8d08d = $007702ee4802c713$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var $007702ee4802c713$export$16032fc466434892 = 'x-amz-user-agent';


var $0f010a6d227814af$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0f010a6d227814af$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0f010a6d227814af$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0f010a6d227814af$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @private For internal Amplify use.
 *
 * Creates a new scope for promises, observables, and other types of work or
 * processes that may be running in the background. This manager provides
 * an singular entrypoint to request termination and await completion.
 *
 * As work completes on its own prior to close, the manager removes them
 * from the registry to avoid holding references to completed jobs.
 */ var $0f010a6d227814af$export$b71e3cae52831d64 = /** @class */ function() {
    /**
     * Creates a new manager for promises, observables, and other types
     * of work that may be running in the background. This manager provides
     * a centralized mechanism to request termination and await completion.
     */ function BackgroundProcessManager() {
        /**
         * A string indicating whether the manager is accepting new work ("Open"),
         * waiting for work to complete ("Closing"), or fully done with all
         * submitted work and *not* accepting new jobs ("Closed").
         */ this._state = $0f010a6d227814af$export$54444b4fe9e958cc.Open;
        /**
         * The list of outstanding jobs we'll need to wait for upon `close()`
         */ this.jobs = new Set();
    }
    BackgroundProcessManager.prototype.add = function(jobOrDescription, optionalDescription) {
        var job;
        var description;
        if (typeof jobOrDescription === 'string') {
            job = undefined;
            description = jobOrDescription;
        } else {
            job = jobOrDescription;
            description = optionalDescription;
        }
        var error = this.closedFailure(description);
        if (error) return error;
        if (job === undefined) return this.addHook(description);
        else if (typeof job === 'function') return this.addFunction(job, description);
        else if (job instanceof BackgroundProcessManager) return this.addManager(job, description);
        else throw new Error('If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.');
    };
    /**
     * Adds a **cleaner** function that doesn't immediately get executed.
     * Instead, the caller gets a **terminate** function back. The *cleaner* is
     * invoked only once the mananger *closes* or the returned **terminate**
     * function is called.
     *
     * @param clean The cleanup function.
     * @param description Optional description to help identify pending jobs.
     * @returns A terminate function.
     */ BackgroundProcessManager.prototype.addCleaner = function(clean, description) {
        var _this = this;
        var _a = this.addHook(description), resolve = _a.resolve, onTerminate = _a.onTerminate;
        var proxy = function() {
            return $0f010a6d227814af$var$__awaiter(_this, void 0, void 0, function() {
                return $0f010a6d227814af$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                clean()
                            ];
                        case 1:
                            _a.sent();
                            resolve();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        onTerminate.then(proxy);
        return proxy;
    };
    BackgroundProcessManager.prototype.addFunction = function(job, description) {
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolve) {
            terminate = resolve;
        });
        // finally! start the job.
        var jobResult = job(onTerminate);
        // depending on what the job gives back, register the result
        // so we can monitor for completion.
        if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === 'function') this.registerPromise(jobResult, terminate, description);
        // At the end of the day, or you know, method call, it doesn't matter
        // what the return value is at all; we just pass it through to the
        // caller.
        return jobResult;
    };
    BackgroundProcessManager.prototype.addManager = function(manager, description) {
        var _this = this;
        this.addCleaner(function() {
            return $0f010a6d227814af$var$__awaiter(_this, void 0, void 0, function() {
                return $0f010a6d227814af$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                manager.close()
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        }, description);
    };
    /**
     * Creates and registers a fabricated job for processes that need to operate
     * with callbacks/hooks. The returned `resolve` and `reject`
     * functions can be used to signal the job is done successfully or not.
     * The returned `onTerminate` is a promise that will resolve when the
     * manager is requesting the termination of the job.
     *
     * @param description Optional description to help identify pending jobs.
     * @returns `{ resolve, reject, onTerminate }`
     */ BackgroundProcessManager.prototype.addHook = function(description) {
        // the resolve/reject functions we'll provide to the caller to signal
        // the state of the job.
        var resolve;
        var reject;
        // the underlying promise we'll use to manage it, pretty much like
        // any other promise.
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolveTerminate) {
            terminate = resolveTerminate;
        });
        this.registerPromise(promise, terminate, description);
        return {
            resolve: resolve,
            reject: reject,
            onTerminate: onTerminate
        };
    };
    /**
     * Adds a Promise based job to the list of jobs for monitoring and listens
     * for either a success or failure, upon which the job is considered "done"
     * and removed from the registry.
     *
     * @param promise A promise that is on its way to being returned to a
     * caller, which needs to be tracked as a background job.
     * @param terminate The termination function to register, which can be
     * invoked to request the job stop.
     * @param description Optional description to help identify pending jobs.
     */ BackgroundProcessManager.prototype.registerPromise = function(promise, terminate, description) {
        var _this = this;
        var jobEntry = {
            promise: promise,
            terminate: terminate,
            description: description
        };
        this.jobs.add(jobEntry);
        // in all of my testing, it is safe to multi-subscribe to a promise.
        // so, rather than create another layer of promising, we're just going
        // to hook into the promise we already have, and when it's done
        // (successfully or not), we no longer need to wait for it upon close.
        //
        // sorry this is a bit hand-wavy:
        //
        // i believe we use `.then` and `.catch` instead of `.finally` because
        // `.finally` is invoked in a different order in the sequence, and this
        // breaks assumptions throughout and causes failures.
        promise.then(function() {
            _this.jobs.delete(jobEntry);
        }).catch(function() {
            _this.jobs.delete(jobEntry);
        });
    };
    Object.defineProperty(BackgroundProcessManager.prototype, "length", {
        /**
         * The number of jobs being waited on.
         *
         * We don't use this for anything. It's just informational for the caller,
         * and can be used in logging and testing.
         *
         * @returns the number of jobs.
         */ get: function() {
            return this.jobs.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "state", {
        /**
         * The execution state of the manager. One of:
         *
         * 1. "Open" -> Accepting new jobs
         * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
         * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
         */ get: function() {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "pending", {
        /**
         * The registered `description` of all still-pending jobs.
         *
         * @returns descriptions as an array.
         */ get: function() {
            return Array.from(this.jobs).map(function(job) {
                return job.description;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isOpen", {
        /**
         * Whether the manager is accepting new jobs.
         */ get: function() {
            return this._state === $0f010a6d227814af$export$54444b4fe9e958cc.Open;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosing", {
        /**
         * Whether the manager is rejecting new work, but still waiting for
         * submitted work to complete.
         */ get: function() {
            return this._state === $0f010a6d227814af$export$54444b4fe9e958cc.Closing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosed", {
        /**
         * Whether the manager is rejecting work and done waiting for submitted
         * work to complete.
         */ get: function() {
            return this._state === $0f010a6d227814af$export$54444b4fe9e958cc.Closed;
        },
        enumerable: true,
        configurable: true
    });
    BackgroundProcessManager.prototype.closedFailure = function(description) {
        if (!this.isOpen) return Promise.reject(new $0f010a6d227814af$export$561e7021452eb6a4([
            "The manager is " + this.state + ".",
            "You tried to add \"" + description + "\".",
            "Pending jobs: [\n" + this.pending.map(function(t) {
                return '    ' + t;
            }).join(',\n') + "\n]"
        ].join('\n')));
    };
    /**
     * Signals jobs to stop (for those that accept interruptions) and waits
     * for confirmation that jobs have stopped.
     *
     * This immediately puts the manager into a closing state and just begins
     * to reject new work. After all work in the manager is complete, the
     * manager goes into a `Completed` state and `close()` returns.
     *
     * This call is idempotent.
     *
     * If the manager is already closing or closed, `finalCleaup` is not executed.
     *
     * @param onClosed
     * @returns The settled results of each still-running job's promise. If the
     * manager is already closed, this will contain the results as of when the
     * manager's `close()` was called in an `Open` state.
     */ BackgroundProcessManager.prototype.close = function() {
        return $0f010a6d227814af$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, job;
            var e_1, _c;
            return $0f010a6d227814af$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!this.isOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._state = $0f010a6d227814af$export$54444b4fe9e958cc.Closing;
                        try {
                            for(_a = $0f010a6d227814af$var$__values(Array.from(this.jobs)), _b = _a.next(); !_b.done; _b = _a.next()){
                                job = _b.value;
                                try {
                                    job.terminate();
                                } catch (error) {
                                    // Due to potential races with a job's natural completion, it's
                                    // reasonable to expect the termination call to fail. Hence,
                                    // not logging as an error.
                                    console.warn("Failed to send termination signal to job. Error: " + error.message, job);
                                }
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        // Use `allSettled()` because we want to wait for all to finish. We do
                        // not want to stop waiting if there is a failure.
                        this._closingPromise = Promise.allSettled(Array.from(this.jobs).map(function(j) {
                            return j.promise;
                        }));
                        return [
                            4 /*yield*/ ,
                            this._closingPromise
                        ];
                    case 1:
                        _d.sent();
                        this._state = $0f010a6d227814af$export$54444b4fe9e958cc.Closed;
                        _d.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._closingPromise
                        ];
                }
            });
        });
    };
    /**
     * Signals the manager to start accepting work (again) and returns once
     * the manager is ready to do so.
     *
     * If the state is already `Open`, this call is a no-op.
     *
     * If the state is `Closed`, this call simply updates state and returns.
     *
     * If the state is `Closing`, this call waits for completion before it
     * updates the state and returns.
     */ BackgroundProcessManager.prototype.open = function() {
        return $0f010a6d227814af$var$__awaiter(this, void 0, void 0, function() {
            return $0f010a6d227814af$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isClosing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this._state = $0f010a6d227814af$export$54444b4fe9e958cc.Open;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackgroundProcessManager;
}();
/**
 *
 */ var $0f010a6d227814af$export$561e7021452eb6a4 = /** @class */ function(_super) {
    $0f010a6d227814af$var$__extends(BackgroundManagerNotOpenError, _super);
    function BackgroundManagerNotOpenError(message) {
        return _super.call(this, "BackgroundManagerNotOpenError: " + message) || this;
    }
    return BackgroundManagerNotOpenError;
}(Error);
var $0f010a6d227814af$export$54444b4fe9e958cc;
(function(BackgroundProcessManagerState) {
    /**
     * Accepting new jobs.
     */ BackgroundProcessManagerState["Open"] = "Open";
    /**
     * Not accepting new jobs. Waiting for submitted jobs to complete.
     */ BackgroundProcessManagerState["Closing"] = "Closing";
    /**
     * Not accepting new jobs. All submitted jobs are complete.
     */ BackgroundProcessManagerState["Closed"] = "Closed";
})($0f010a6d227814af$export$54444b4fe9e958cc || ($0f010a6d227814af$export$54444b4fe9e958cc = {}));

/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $b7cc9345c25d5a10$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
var $b7cc9345c25d5a10$export$2e2bcd8739ae039 = $b7cc9345c25d5a10$var$Mutex;


var $651fb6bdf0596089$exports = {};

$651fb6bdf0596089$exports = (parcelRequire("hafja")).Observable;


var $65df470d97709e59$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($651fb6bdf0596089$exports)));
var $65df470d97709e59$export$2e2bcd8739ae039 = $65df470d97709e59$export$77cea355fa80b5f4;


var $1e10311bfa29fb52$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $1e10311bfa29fb52$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isNode) return (0, $65df470d97709e59$export$2e2bcd8739ae039).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, $1436837d4e301e07$export$97b87b8868ff7a3c)() ? self : window;
        return new (0, $65df470d97709e59$export$2e2bcd8739ae039)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = $1e10311bfa29fb52$var$__values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
var $1e10311bfa29fb52$export$2e2bcd8739ae039 = $1e10311bfa29fb52$var$ReachabilityNavigator;

function $00ce6ce4cfd3fe72$export$b855308a44508212(str) {
    return str.split('').map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, '0');
    }).join('');
}
function $00ce6ce4cfd3fe72$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join('');
}


var $652b26c6fd02e7c5$export$a002182e51710d39 = {
    userAgent: (0, $8eca817bf49e3d6a$export$2dffd0b5373a4389).userAgent
};
var /**
 * @deprecated use named import
 */ $652b26c6fd02e7c5$export$2e2bcd8739ae039 = (0, $5af950529fc36b5c$export$a3858a9a153cffc7);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $b5a0c32b0da1da73$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($b5a0c32b0da1da73$export$eeb013770cb92342 || ($b5a0c32b0da1da73$export$eeb013770cb92342 = {}));
function $b5a0c32b0da1da73$export$9b905d6895bdc426(obj) {
    var keys = [
        'provider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b5a0c32b0da1da73$export$828f8efbdf71714b(obj) {
    var keys = [
        'customProvider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b5a0c32b0da1da73$export$6bae5520ca265d22(obj) {
    var keys = [
        'customState'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b5a0c32b0da1da73$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $b5a0c32b0da1da73$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})($b5a0c32b0da1da73$export$edb367c0a140d3db || ($b5a0c32b0da1da73$export$edb367c0a140d3db = {}));
function $b5a0c32b0da1da73$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $b5a0c32b0da1da73$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($b5a0c32b0da1da73$export$cfce9c15015bef96 || ($b5a0c32b0da1da73$export$cfce9c15015bef96 = {}));



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $2f5def01e0ed5376$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getPassword = function getPassword() {
        return this.password;
    };
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    };
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    };
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3cb46725526d023e$export$a143d493d941bafc;
var $3cb46725526d023e$export$e4cf37d7f6fb9e0a;
var $3cb46725526d023e$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $3cb46725526d023e$export$599f31c3813fae4d;
'use strict';

var $iImIH = parcelRequire("iImIH");

var $fO9md = parcelRequire("fO9md");
var $29858b21d3bc25d9$exports = {};
var $29858b21d3bc25d9$var$toString = {}.toString;
$29858b21d3bc25d9$exports = Array.isArray || function(arr) {
    return $29858b21d3bc25d9$var$toString.call(arr) == '[object Array]';
};


$3cb46725526d023e$export$a143d493d941bafc = $3cb46725526d023e$var$Buffer;
$3cb46725526d023e$export$e4cf37d7f6fb9e0a = $3cb46725526d023e$var$SlowBuffer;
$3cb46725526d023e$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $3cb46725526d023e$var$typedArraySupport();
$3cb46725526d023e$export$599f31c3813fae4d = $3cb46725526d023e$var$kMaxLength();
function $3cb46725526d023e$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $3cb46725526d023e$var$kMaxLength() {
    return $3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $3cb46725526d023e$var$createBuffer(that, length) {
    if ($3cb46725526d023e$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $3cb46725526d023e$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $3cb46725526d023e$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3cb46725526d023e$var$Buffer(arg, encodingOrOffset, length) {
    if (!$3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $3cb46725526d023e$var$Buffer)) return new $3cb46725526d023e$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $3cb46725526d023e$var$allocUnsafe(this, arg);
    }
    return $3cb46725526d023e$var$from(this, arg, encodingOrOffset, length);
}
$3cb46725526d023e$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$3cb46725526d023e$var$Buffer._augment = function(arr) {
    arr.__proto__ = $3cb46725526d023e$var$Buffer.prototype;
    return arr;
};
function $3cb46725526d023e$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $3cb46725526d023e$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $3cb46725526d023e$var$fromString(that, value, encodingOrOffset);
    return $3cb46725526d023e$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3cb46725526d023e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3cb46725526d023e$var$from(null, value, encodingOrOffset, length);
};
if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $3cb46725526d023e$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $3cb46725526d023e$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $3cb46725526d023e$var$Buffer[Symbol.species] === $3cb46725526d023e$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($3cb46725526d023e$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $3cb46725526d023e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $3cb46725526d023e$var$alloc(that, size, fill, encoding) {
    $3cb46725526d023e$var$assertSize(size);
    if (size <= 0) return $3cb46725526d023e$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $3cb46725526d023e$var$createBuffer(that, size).fill(fill, encoding) : $3cb46725526d023e$var$createBuffer(that, size).fill(fill);
    return $3cb46725526d023e$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3cb46725526d023e$var$Buffer.alloc = function(size, fill, encoding) {
    return $3cb46725526d023e$var$alloc(null, size, fill, encoding);
};
function $3cb46725526d023e$var$allocUnsafe(that, size) {
    $3cb46725526d023e$var$assertSize(size);
    that = $3cb46725526d023e$var$createBuffer(that, size < 0 ? 0 : $3cb46725526d023e$var$checked(size) | 0);
    if (!$3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3cb46725526d023e$var$Buffer.allocUnsafe = function(size) {
    return $3cb46725526d023e$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3cb46725526d023e$var$Buffer.allocUnsafeSlow = function(size) {
    return $3cb46725526d023e$var$allocUnsafe(null, size);
};
function $3cb46725526d023e$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3cb46725526d023e$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $3cb46725526d023e$var$byteLength(string, encoding) | 0;
    that = $3cb46725526d023e$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $3cb46725526d023e$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $3cb46725526d023e$var$checked(array.length) | 0;
    that = $3cb46725526d023e$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $3cb46725526d023e$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $3cb46725526d023e$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $3cb46725526d023e$var$fromArrayLike(that, array);
    return that;
}
function $3cb46725526d023e$var$fromObject(that, obj) {
    if ($3cb46725526d023e$var$Buffer.isBuffer(obj)) {
        var len = $3cb46725526d023e$var$checked(obj.length) | 0;
        that = $3cb46725526d023e$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $3cb46725526d023e$var$isnan(obj.length)) return $3cb46725526d023e$var$createBuffer(that, 0);
            return $3cb46725526d023e$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $29858b21d3bc25d9$exports(obj.data)) return $3cb46725526d023e$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $3cb46725526d023e$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3cb46725526d023e$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3cb46725526d023e$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $3cb46725526d023e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3cb46725526d023e$var$Buffer.alloc(+length);
}
$3cb46725526d023e$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$3cb46725526d023e$var$Buffer.compare = function compare(a, b) {
    if (!$3cb46725526d023e$var$Buffer.isBuffer(a) || !$3cb46725526d023e$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3cb46725526d023e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3cb46725526d023e$var$Buffer.concat = function concat(list, length) {
    if (!$29858b21d3bc25d9$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3cb46725526d023e$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $3cb46725526d023e$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$3cb46725526d023e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3cb46725526d023e$var$byteLength(string, encoding) {
    if ($3cb46725526d023e$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $3cb46725526d023e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3cb46725526d023e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $3cb46725526d023e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3cb46725526d023e$var$Buffer.byteLength = $3cb46725526d023e$var$byteLength;
function $3cb46725526d023e$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3cb46725526d023e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3cb46725526d023e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3cb46725526d023e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3cb46725526d023e$var$latin1Slice(this, start, end);
        case 'base64':
            return $3cb46725526d023e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3cb46725526d023e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$3cb46725526d023e$var$Buffer.prototype._isBuffer = true;
function $3cb46725526d023e$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3cb46725526d023e$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$3cb46725526d023e$var$swap(this, i, i + 1);
    return this;
};
$3cb46725526d023e$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $3cb46725526d023e$var$swap(this, i, i + 3);
        $3cb46725526d023e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3cb46725526d023e$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $3cb46725526d023e$var$swap(this, i, i + 7);
        $3cb46725526d023e$var$swap(this, i + 1, i + 6);
        $3cb46725526d023e$var$swap(this, i + 2, i + 5);
        $3cb46725526d023e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3cb46725526d023e$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $3cb46725526d023e$var$utf8Slice(this, 0, length);
    return $3cb46725526d023e$var$slowToString.apply(this, arguments);
};
$3cb46725526d023e$var$Buffer.prototype.equals = function equals(b) {
    if (!$3cb46725526d023e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3cb46725526d023e$var$Buffer.compare(this, b) === 0;
};
$3cb46725526d023e$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $3cb46725526d023e$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$3cb46725526d023e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$3cb46725526d023e$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3cb46725526d023e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3cb46725526d023e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3cb46725526d023e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3cb46725526d023e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3cb46725526d023e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3cb46725526d023e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3cb46725526d023e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3cb46725526d023e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3cb46725526d023e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3cb46725526d023e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3cb46725526d023e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3cb46725526d023e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3cb46725526d023e$var$utf8Write(buf, string, offset, length) {
    return $3cb46725526d023e$var$blitBuffer($3cb46725526d023e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3cb46725526d023e$var$asciiWrite(buf, string, offset, length) {
    return $3cb46725526d023e$var$blitBuffer($3cb46725526d023e$var$asciiToBytes(string), buf, offset, length);
}
function $3cb46725526d023e$var$latin1Write(buf, string, offset, length) {
    return $3cb46725526d023e$var$asciiWrite(buf, string, offset, length);
}
function $3cb46725526d023e$var$base64Write(buf, string, offset, length) {
    return $3cb46725526d023e$var$blitBuffer($3cb46725526d023e$var$base64ToBytes(string), buf, offset, length);
}
function $3cb46725526d023e$var$ucs2Write(buf, string, offset, length) {
    return $3cb46725526d023e$var$blitBuffer($3cb46725526d023e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3cb46725526d023e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3cb46725526d023e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3cb46725526d023e$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $3cb46725526d023e$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $3cb46725526d023e$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3cb46725526d023e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3cb46725526d023e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3cb46725526d023e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3cb46725526d023e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iImIH.fromByteArray(buf);
    else return $iImIH.fromByteArray(buf.slice(start, end));
}
function $3cb46725526d023e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3cb46725526d023e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $3cb46725526d023e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3cb46725526d023e$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $3cb46725526d023e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3cb46725526d023e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3cb46725526d023e$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3cb46725526d023e$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3cb46725526d023e$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $3cb46725526d023e$var$toHex(buf[i]);
    return out;
}
function $3cb46725526d023e$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3cb46725526d023e$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $3cb46725526d023e$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $3cb46725526d023e$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3cb46725526d023e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3cb46725526d023e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3cb46725526d023e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3cb46725526d023e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3cb46725526d023e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3cb46725526d023e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3cb46725526d023e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3cb46725526d023e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3cb46725526d023e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3cb46725526d023e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3cb46725526d023e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3cb46725526d023e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3cb46725526d023e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3cb46725526d023e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3cb46725526d023e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3cb46725526d023e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return $fO9md.read(this, offset, true, 23, 4);
};
$3cb46725526d023e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 4, this.length);
    return $fO9md.read(this, offset, false, 23, 4);
};
$3cb46725526d023e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 8, this.length);
    return $fO9md.read(this, offset, true, 52, 8);
};
$3cb46725526d023e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkOffset(offset, 8, this.length);
    return $fO9md.read(this, offset, false, 52, 8);
};
function $3cb46725526d023e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3cb46725526d023e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3cb46725526d023e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3cb46725526d023e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3cb46725526d023e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3cb46725526d023e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3cb46725526d023e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $3cb46725526d023e$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$3cb46725526d023e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $3cb46725526d023e$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$3cb46725526d023e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $3cb46725526d023e$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $3cb46725526d023e$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$3cb46725526d023e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $3cb46725526d023e$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$3cb46725526d023e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $3cb46725526d023e$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$3cb46725526d023e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3cb46725526d023e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3cb46725526d023e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $3cb46725526d023e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3cb46725526d023e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3cb46725526d023e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $3cb46725526d023e$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$3cb46725526d023e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $3cb46725526d023e$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$3cb46725526d023e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $3cb46725526d023e$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$3cb46725526d023e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $3cb46725526d023e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $3cb46725526d023e$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $3cb46725526d023e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3cb46725526d023e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $fO9md.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3cb46725526d023e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3cb46725526d023e$var$writeFloat(this, value, offset, true, noAssert);
};
$3cb46725526d023e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3cb46725526d023e$var$writeFloat(this, value, offset, false, noAssert);
};
function $3cb46725526d023e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $3cb46725526d023e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $fO9md.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3cb46725526d023e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3cb46725526d023e$var$writeDouble(this, value, offset, true, noAssert);
};
$3cb46725526d023e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3cb46725526d023e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3cb46725526d023e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$3cb46725526d023e$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3cb46725526d023e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3cb46725526d023e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $3cb46725526d023e$var$Buffer.isBuffer(val) ? val : $3cb46725526d023e$var$utf8ToBytes(new $3cb46725526d023e$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $3cb46725526d023e$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $3cb46725526d023e$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $3cb46725526d023e$var$stringtrim(str).replace($3cb46725526d023e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3cb46725526d023e$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $3cb46725526d023e$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $3cb46725526d023e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3cb46725526d023e$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3cb46725526d023e$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3cb46725526d023e$var$base64ToBytes(str) {
    return $iImIH.toByteArray($3cb46725526d023e$var$base64clean(str));
}
function $3cb46725526d023e$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $3cb46725526d023e$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}



var $2DpkE = parcelRequire("2DpkE");
parcelRequire("ivs1Y");

var $evCD1 = parcelRequire("evCD1");

var $CJImr = parcelRequire("CJImr");
var $c48d0cdad83c163d$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) $c48d0cdad83c163d$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$c48d0cdad83c163d$var$crypto && typeof window !== 'undefined' && window.msCrypto) $c48d0cdad83c163d$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$c48d0cdad83c163d$var$crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) $c48d0cdad83c163d$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$c48d0cdad83c163d$var$crypto && true) try {
    $c48d0cdad83c163d$var$crypto = (parcelRequire("7K7Bf"));
} catch (err) {}
function $c48d0cdad83c163d$export$2e2bcd8739ae039() {
    if ($c48d0cdad83c163d$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $c48d0cdad83c163d$var$crypto.getRandomValues === 'function') try {
            return $c48d0cdad83c163d$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $c48d0cdad83c163d$var$crypto.randomBytes === 'function') try {
            return $c48d0cdad83c163d$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $2ffd9402ea81821d$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var $2ffd9402ea81821d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $c48d0cdad83c163d$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $2ffd9402ea81821d$var$hexStringify(this);
    };
    return WordArray;
}();


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $c8077a85c918f5c7$export$2e2bcd8739ae039 = $c8077a85c918f5c7$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $c8077a85c918f5c7$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $c8077a85c918f5c7$var$nbi() {
    return new $c8077a85c918f5c7$var$BigInteger(null);
}
// Bits per digit
var $c8077a85c918f5c7$var$dbits;
// JavaScript engine analysis
var $c8077a85c918f5c7$var$canary = 0xdeadbeefcafe;
var $c8077a85c918f5c7$var$j_lm = ($c8077a85c918f5c7$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $c8077a85c918f5c7$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $c8077a85c918f5c7$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $c8077a85c918f5c7$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $c8077a85c918f5c7$var$inBrowser = typeof navigator !== 'undefined';
if ($c8077a85c918f5c7$var$inBrowser && $c8077a85c918f5c7$var$j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    $c8077a85c918f5c7$var$BigInteger.prototype.am = $c8077a85c918f5c7$var$am2;
    $c8077a85c918f5c7$var$dbits = 30;
} else if ($c8077a85c918f5c7$var$inBrowser && $c8077a85c918f5c7$var$j_lm && navigator.appName != 'Netscape') {
    $c8077a85c918f5c7$var$BigInteger.prototype.am = $c8077a85c918f5c7$var$am1;
    $c8077a85c918f5c7$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $c8077a85c918f5c7$var$BigInteger.prototype.am = $c8077a85c918f5c7$var$am3;
    $c8077a85c918f5c7$var$dbits = 28;
}
$c8077a85c918f5c7$var$BigInteger.prototype.DB = $c8077a85c918f5c7$var$dbits;
$c8077a85c918f5c7$var$BigInteger.prototype.DM = (1 << $c8077a85c918f5c7$var$dbits) - 1;
$c8077a85c918f5c7$var$BigInteger.prototype.DV = 1 << $c8077a85c918f5c7$var$dbits;
var $c8077a85c918f5c7$var$BI_FP = 52;
$c8077a85c918f5c7$var$BigInteger.prototype.FV = Math.pow(2, $c8077a85c918f5c7$var$BI_FP);
$c8077a85c918f5c7$var$BigInteger.prototype.F1 = $c8077a85c918f5c7$var$BI_FP - $c8077a85c918f5c7$var$dbits;
$c8077a85c918f5c7$var$BigInteger.prototype.F2 = 2 * $c8077a85c918f5c7$var$dbits - $c8077a85c918f5c7$var$BI_FP;
// Digit conversions
var $c8077a85c918f5c7$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var $c8077a85c918f5c7$var$BI_RC = new Array();
var $c8077a85c918f5c7$var$rr, $c8077a85c918f5c7$var$vv;
$c8077a85c918f5c7$var$rr = '0'.charCodeAt(0);
for($c8077a85c918f5c7$var$vv = 0; $c8077a85c918f5c7$var$vv <= 9; ++$c8077a85c918f5c7$var$vv)$c8077a85c918f5c7$var$BI_RC[$c8077a85c918f5c7$var$rr++] = $c8077a85c918f5c7$var$vv;
$c8077a85c918f5c7$var$rr = 'a'.charCodeAt(0);
for($c8077a85c918f5c7$var$vv = 10; $c8077a85c918f5c7$var$vv < 36; ++$c8077a85c918f5c7$var$vv)$c8077a85c918f5c7$var$BI_RC[$c8077a85c918f5c7$var$rr++] = $c8077a85c918f5c7$var$vv;
$c8077a85c918f5c7$var$rr = 'A'.charCodeAt(0);
for($c8077a85c918f5c7$var$vv = 10; $c8077a85c918f5c7$var$vv < 36; ++$c8077a85c918f5c7$var$vv)$c8077a85c918f5c7$var$BI_RC[$c8077a85c918f5c7$var$rr++] = $c8077a85c918f5c7$var$vv;
function $c8077a85c918f5c7$var$int2char(n) {
    return $c8077a85c918f5c7$var$BI_RM.charAt(n);
}
function $c8077a85c918f5c7$var$intAt(s, i) {
    var c = $c8077a85c918f5c7$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $c8077a85c918f5c7$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $c8077a85c918f5c7$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $c8077a85c918f5c7$var$nbv(i) {
    var r = $c8077a85c918f5c7$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $c8077a85c918f5c7$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $c8077a85c918f5c7$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $c8077a85c918f5c7$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $c8077a85c918f5c7$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $c8077a85c918f5c7$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $c8077a85c918f5c7$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $c8077a85c918f5c7$var$int2char(d);
        }
    }
    return m ? r : '0';
}
// (public) -this
function $c8077a85c918f5c7$var$bnNegate() {
    var r = $c8077a85c918f5c7$var$nbi();
    $c8077a85c918f5c7$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $c8077a85c918f5c7$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $c8077a85c918f5c7$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $c8077a85c918f5c7$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $c8077a85c918f5c7$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $c8077a85c918f5c7$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $c8077a85c918f5c7$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $c8077a85c918f5c7$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $c8077a85c918f5c7$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $c8077a85c918f5c7$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $c8077a85c918f5c7$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $c8077a85c918f5c7$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $c8077a85c918f5c7$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $c8077a85c918f5c7$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $c8077a85c918f5c7$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $c8077a85c918f5c7$var$nbi();
    var y = $c8077a85c918f5c7$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $c8077a85c918f5c7$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $c8077a85c918f5c7$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $c8077a85c918f5c7$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $c8077a85c918f5c7$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $c8077a85c918f5c7$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $c8077a85c918f5c7$var$bnMod(a) {
    var r = $c8077a85c918f5c7$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($c8077a85c918f5c7$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $c8077a85c918f5c7$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $c8077a85c918f5c7$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $c8077a85c918f5c7$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $c8077a85c918f5c7$var$bnAdd(a) {
    var r = $c8077a85c918f5c7$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $c8077a85c918f5c7$var$bnSubtract(a) {
    var r = $c8077a85c918f5c7$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $c8077a85c918f5c7$var$bnMultiply(a) {
    var r = $c8077a85c918f5c7$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $c8077a85c918f5c7$var$bnDivide(a) {
    var r = $c8077a85c918f5c7$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $c8077a85c918f5c7$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $c8077a85c918f5c7$var$montConvert(x) {
    var r = $c8077a85c918f5c7$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($c8077a85c918f5c7$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $c8077a85c918f5c7$var$montRevert(x) {
    var r = $c8077a85c918f5c7$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $c8077a85c918f5c7$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $c8077a85c918f5c7$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $c8077a85c918f5c7$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$c8077a85c918f5c7$var$Montgomery.prototype.convert = $c8077a85c918f5c7$var$montConvert;
$c8077a85c918f5c7$var$Montgomery.prototype.revert = $c8077a85c918f5c7$var$montRevert;
$c8077a85c918f5c7$var$Montgomery.prototype.reduce = $c8077a85c918f5c7$var$montReduce;
$c8077a85c918f5c7$var$Montgomery.prototype.mulTo = $c8077a85c918f5c7$var$montMulTo;
$c8077a85c918f5c7$var$Montgomery.prototype.sqrTo = $c8077a85c918f5c7$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $c8077a85c918f5c7$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $c8077a85c918f5c7$var$nbv(1), z = new $c8077a85c918f5c7$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $c8077a85c918f5c7$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $c8077a85c918f5c7$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $c8077a85c918f5c7$var$nbi(), t;
    i = $c8077a85c918f5c7$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$c8077a85c918f5c7$var$BigInteger.prototype.copyTo = $c8077a85c918f5c7$var$bnpCopyTo;
$c8077a85c918f5c7$var$BigInteger.prototype.fromInt = $c8077a85c918f5c7$var$bnpFromInt;
$c8077a85c918f5c7$var$BigInteger.prototype.fromString = $c8077a85c918f5c7$var$bnpFromString;
$c8077a85c918f5c7$var$BigInteger.prototype.clamp = $c8077a85c918f5c7$var$bnpClamp;
$c8077a85c918f5c7$var$BigInteger.prototype.dlShiftTo = $c8077a85c918f5c7$var$bnpDLShiftTo;
$c8077a85c918f5c7$var$BigInteger.prototype.drShiftTo = $c8077a85c918f5c7$var$bnpDRShiftTo;
$c8077a85c918f5c7$var$BigInteger.prototype.lShiftTo = $c8077a85c918f5c7$var$bnpLShiftTo;
$c8077a85c918f5c7$var$BigInteger.prototype.rShiftTo = $c8077a85c918f5c7$var$bnpRShiftTo;
$c8077a85c918f5c7$var$BigInteger.prototype.subTo = $c8077a85c918f5c7$var$bnpSubTo;
$c8077a85c918f5c7$var$BigInteger.prototype.multiplyTo = $c8077a85c918f5c7$var$bnpMultiplyTo;
$c8077a85c918f5c7$var$BigInteger.prototype.squareTo = $c8077a85c918f5c7$var$bnpSquareTo;
$c8077a85c918f5c7$var$BigInteger.prototype.divRemTo = $c8077a85c918f5c7$var$bnpDivRemTo;
$c8077a85c918f5c7$var$BigInteger.prototype.invDigit = $c8077a85c918f5c7$var$bnpInvDigit;
$c8077a85c918f5c7$var$BigInteger.prototype.addTo = $c8077a85c918f5c7$var$bnpAddTo;
// public
$c8077a85c918f5c7$var$BigInteger.prototype.toString = $c8077a85c918f5c7$var$bnToString;
$c8077a85c918f5c7$var$BigInteger.prototype.negate = $c8077a85c918f5c7$var$bnNegate;
$c8077a85c918f5c7$var$BigInteger.prototype.abs = $c8077a85c918f5c7$var$bnAbs;
$c8077a85c918f5c7$var$BigInteger.prototype.compareTo = $c8077a85c918f5c7$var$bnCompareTo;
$c8077a85c918f5c7$var$BigInteger.prototype.bitLength = $c8077a85c918f5c7$var$bnBitLength;
$c8077a85c918f5c7$var$BigInteger.prototype.mod = $c8077a85c918f5c7$var$bnMod;
$c8077a85c918f5c7$var$BigInteger.prototype.equals = $c8077a85c918f5c7$var$bnEquals;
$c8077a85c918f5c7$var$BigInteger.prototype.add = $c8077a85c918f5c7$var$bnAdd;
$c8077a85c918f5c7$var$BigInteger.prototype.subtract = $c8077a85c918f5c7$var$bnSubtract;
$c8077a85c918f5c7$var$BigInteger.prototype.multiply = $c8077a85c918f5c7$var$bnMultiply;
$c8077a85c918f5c7$var$BigInteger.prototype.divide = $c8077a85c918f5c7$var$bnDivide;
$c8077a85c918f5c7$var$BigInteger.prototype.modPow = $c8077a85c918f5c7$var$bnModPow;
// "constants"
$c8077a85c918f5c7$var$BigInteger.ZERO = $c8077a85c918f5c7$var$nbv(0);
$c8077a85c918f5c7$var$BigInteger.ONE = $c8077a85c918f5c7$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $3882660d886f01b1$var$randomBytes(nBytes) {
    return (0, $3cb46725526d023e$export$a143d493d941bafc).from(new (0, $2ffd9402ea81821d$export$2e2bcd8739ae039)().random(nBytes).toString(), 'hex');
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $3882660d886f01b1$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $3882660d886f01b1$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $3882660d886f01b1$var$newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var $3882660d886f01b1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)($3882660d886f01b1$var$initN, 16);
        this.g = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)('2', 16);
        this.k = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $3cb46725526d023e$export$a143d493d941bafc).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    };
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    };
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $3882660d886f01b1$var$randomBytes(128).toString('hex');
        var randomBigInt = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    };
    _proto.generateRandomString = function generateRandomString() {
        return $3882660d886f01b1$var$randomBytes(40).toString('base64');
    };
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    };
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    };
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    };
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $3882660d886f01b1$var$randomBytes(16).toString('hex');
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    };
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $c8077a85c918f5c7$export$2e2bcd8739ae039).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    };
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    };
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $3cb46725526d023e$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($evCD1)))(str).toString();
        return new Array(64 - hashHex.length).join('0') + hashHex;
    };
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $3cb46725526d023e$export$a143d493d941bafc).from(hexStr, 'hex'));
    };
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create((0, $3cb46725526d023e$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $3cb46725526d023e$export$a143d493d941bafc).from(String.fromCharCode(1), 'utf8')
        ]));
        var ikmWordArray = ikm instanceof (0, $3cb46725526d023e$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $3cb46725526d023e$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($CJImr)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($CJImr)))(infoBitsWordArray, prk);
        return (0, $3cb46725526d023e$export$a143d493d941bafc).from(hmac.toString(), 'hex').slice(0, 16);
    };
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $c8077a85c918f5c7$export$2e2bcd8739ae039).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $c8077a85c918f5c7$export$2e2bcd8739ae039).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $3cb46725526d023e$export$a143d493d941bafc).from(_this4.padHex(sValue), 'hex'), (0, $3cb46725526d023e$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), 'hex'));
            callback(null, hkdf);
        });
    };
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    };
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $3882660d886f01b1$var$newPasswordRequiredChallengeUserAttributePrefix;
    };
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $c8077a85c918f5c7$export$2e2bcd8739ae039))) throw new Error('Not a BigInteger');
        var isNegative = bigInt.compareTo((0, $c8077a85c918f5c7$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $3882660d886f01b1$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split('').map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return '0123456789ABCDEF'.charAt(invertedNibble);
            }).join('');
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $c8077a85c918f5c7$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $404f15b0876a435f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    };
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    };
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    };
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, $3cb46725526d023e$export$a143d493d941bafc).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $2fa966c8aee9cf9e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2fa966c8aee9cf9e$var$_setPrototypeOf(subClass, superClass);
}
function $2fa966c8aee9cf9e$var$_setPrototypeOf(o, p) {
    $2fa966c8aee9cf9e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2fa966c8aee9cf9e$var$_setPrototypeOf(o, p);
}
/** @class */ var $2fa966c8aee9cf9e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $2fa966c8aee9cf9e$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    return CognitoAccessToken;
}((0, $404f15b0876a435f$export$2e2bcd8739ae039));



function $94f71146a23a56cb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $94f71146a23a56cb$var$_setPrototypeOf(subClass, superClass);
}
function $94f71146a23a56cb$var$_setPrototypeOf(o, p) {
    $94f71146a23a56cb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $94f71146a23a56cb$var$_setPrototypeOf(o, p);
}
/** @class */ var $94f71146a23a56cb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $94f71146a23a56cb$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    return CognitoIdToken;
}((0, $404f15b0876a435f$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $741b7c34058d72c2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $2DpkE = parcelRequire("2DpkE");
parcelRequire("ivs1Y");

var $qxxev = parcelRequire("qxxev");

var $CJImr = parcelRequire("CJImr");





/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $600a9e099cd11969$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    };
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    };
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    };
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    };
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    };
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $1a5caafd17f22d9b$var$monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var $1a5caafd17f22d9b$var$weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var $1a5caafd17f22d9b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $1a5caafd17f22d9b$var$weekNames[now.getUTCDay()];
        var month = $1a5caafd17f22d9b$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c6f3224d956604db$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    };
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    };
    _proto.getName = function getName() {
        return this.Name;
    };
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    };
    _proto.toString = function toString() {
        return JSON.stringify(this);
    };
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $b0e63581d785b20b$var$dataMemory = {};
var $b0e63581d785b20b$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $b0e63581d785b20b$var$dataMemory[key] = value;
        return $b0e63581d785b20b$var$dataMemory[key];
    };
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($b0e63581d785b20b$var$dataMemory, key) ? $b0e63581d785b20b$var$dataMemory[key] : undefined;
    };
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $b0e63581d785b20b$var$dataMemory[key];
    };
    MemoryStorage.clear = function clear() {
        $b0e63581d785b20b$var$dataMemory = {};
        return $b0e63581d785b20b$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $b0e63581d785b20b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = $b0e63581d785b20b$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $e1a4d309ff047fc2$var$isBrowser = typeof navigator !== 'undefined';
var $e1a4d309ff047fc2$var$userAgent = $e1a4d309ff047fc2$var$isBrowser ? navigator.userAgent : 'nodejs';
/** @class */ var $e1a4d309ff047fc2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, $b0e63581d785b20b$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    };
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    };
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    };
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    };
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    };
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    };
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $1a5caafd17f22d9b$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create((0, $3cb46725526d023e$export$a143d493d941bafc).concat([
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), 'utf8'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(_this2.username, 'utf8'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($qxxev))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($CJImr)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    };
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    };
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $3cb46725526d023e$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, $3cb46725526d023e$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $e1a4d309ff047fc2$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    };
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    };
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $1a5caafd17f22d9b$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $c8077a85c918f5c7$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create((0, $3cb46725526d023e$export$a143d493d941bafc).concat([
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(_this6.deviceGroupKey, 'utf8'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(_this6.deviceKey, 'utf8'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $3cb46725526d023e$export$a143d493d941bafc).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($2DpkE))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($qxxev))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($CJImr)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    };
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    };
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    };
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $3882660d886f01b1$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $3cb46725526d023e$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, $3cb46725526d023e$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $e1a4d309ff047fc2$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    };
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    };
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $c6f3224d956604db$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    };
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    };
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    };
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    };
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    };
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    };
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    };
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    };
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    };
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    };
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $94f71146a23a56cb$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $2fa966c8aee9cf9e$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $741b7c34058d72c2$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $600a9e099cd11969$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    };
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    };
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    };
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    };
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    };
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    };
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    };
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    };
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    };
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $94f71146a23a56cb$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $2fa966c8aee9cf9e$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $741b7c34058d72c2$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $600a9e099cd11969$export$2e2bcd8739ae039)(sessionData);
    };
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    };
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
    };
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    };
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== 'function') {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== 'function') throw new Error('Invalid revokeTokenCallback. It should be a function.');
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error('User is not authenticated');
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error('No Access token available');
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === 'function') try {
            var _token$decodePayload2 = token.decodePayload(), origin_jti = _token$decodePayload2.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry('RevokeToken', {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    };
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    };
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    };
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    };
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $1f8f18e18988fb5f$exports = {};


$1f8f18e18988fb5f$exports = self.fetch || (self.fetch = (parcelRequire("3XTjv")).default || (parcelRequire("3XTjv")));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $f8d36f4564deceb2$export$83d89fbfd8236492 = '5.0.4';


var $99d4a7c39cb09796$var$BASE_USER_AGENT = "aws-amplify/" + (0, $f8d36f4564deceb2$export$83d89fbfd8236492);
var $99d4a7c39cb09796$export$2dffd0b5373a4389 = {
    userAgent: $99d4a7c39cb09796$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $99d4a7c39cb09796$export$2dffd0b5373a4389.product = navigator.product || '';
    $99d4a7c39cb09796$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $99d4a7c39cb09796$export$2dffd0b5373a4389.userAgent = $99d4a7c39cb09796$var$BASE_USER_AGENT + " react-native";
            $99d4a7c39cb09796$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $99d4a7c39cb09796$export$2dffd0b5373a4389.userAgent = $99d4a7c39cb09796$var$BASE_USER_AGENT + " js";
            $99d4a7c39cb09796$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $99d4a7c39cb09796$export$7935961ef7719cb0 = function getUserAgent() {
    return $99d4a7c39cb09796$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $99d4a7c39cb09796$export$2e2bcd8739ae039 = $99d4a7c39cb09796$export$2dffd0b5373a4389;


// constructor
function $d1518f167e77bc46$var$UserAgent() {}
// public
$d1518f167e77bc46$var$UserAgent.prototype.userAgent = (0, $99d4a7c39cb09796$export$7935961ef7719cb0)();
var $d1518f167e77bc46$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($d1518f167e77bc46$var$UserAgent.prototype.userAgent && !$d1518f167e77bc46$var$UserAgent.prototype.userAgent.includes(content)) $d1518f167e77bc46$var$UserAgent.prototype.userAgent = $d1518f167e77bc46$var$UserAgent.prototype.userAgent.concat(' ', content);
    if (!$d1518f167e77bc46$var$UserAgent.prototype.userAgent || $d1518f167e77bc46$var$UserAgent.prototype.userAgent === '') $d1518f167e77bc46$var$UserAgent.prototype.userAgent = content;
};
var // class for defining the amzn user-agent
$d1518f167e77bc46$export$2e2bcd8739ae039 = $d1518f167e77bc46$var$UserAgent;


function $db6aa7569fc39783$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $db6aa7569fc39783$var$_setPrototypeOf(subClass, superClass);
}
function $db6aa7569fc39783$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $db6aa7569fc39783$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$db6aa7569fc39783$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $db6aa7569fc39783$var$_construct(Class, arguments, $db6aa7569fc39783$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $db6aa7569fc39783$var$_setPrototypeOf(Wrapper, Class);
    };
    return $db6aa7569fc39783$var$_wrapNativeSuper(Class);
}
function $db6aa7569fc39783$var$_construct(Parent, args, Class) {
    if ($db6aa7569fc39783$var$_isNativeReflectConstruct()) $db6aa7569fc39783$var$_construct = Reflect.construct.bind();
    else $db6aa7569fc39783$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $db6aa7569fc39783$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $db6aa7569fc39783$var$_construct.apply(null, arguments);
}
function $db6aa7569fc39783$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $db6aa7569fc39783$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $db6aa7569fc39783$var$_setPrototypeOf(o, p) {
    $db6aa7569fc39783$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $db6aa7569fc39783$var$_setPrototypeOf(o, p);
}
function $db6aa7569fc39783$var$_getPrototypeOf(o) {
    $db6aa7569fc39783$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $db6aa7569fc39783$var$_getPrototypeOf(o);
}
var $db6aa7569fc39783$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $db6aa7569fc39783$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $db6aa7569fc39783$var$_wrapNativeSuper(Error));
/** @class */ var $db6aa7569fc39783$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $db6aa7569fc39783$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $db6aa7569fc39783$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    };
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, $d1518f167e77bc46$export$2e2bcd8739ae039).prototype.userAgent,
            'Cache-Control': 'no-store'
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === 'Network error') err.code = 'NetworkError';
            return callback(err);
        });
    };
    return Client;
}();
var $db6aa7569fc39783$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $db6aa7569fc39783$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $db6aa7569fc39783$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $db6aa7569fc39783$var$_wrapNativeSuper(Error));
var $db6aa7569fc39783$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $db6aa7569fc39783$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
    $db6aa7569fc39783$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $db6aa7569fc39783$var$logger.debug("error on " + functionToRetry.name, err);
        if ($db6aa7569fc39783$var$isNonRetryableError(err)) {
            $db6aa7569fc39783$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $db6aa7569fc39783$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $db6aa7569fc39783$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $db6aa7569fc39783$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $db6aa7569fc39783$var$MAX_DELAY_MS = 300000;
function $db6aa7569fc39783$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $db6aa7569fc39783$var$MAX_DELAY_MS;
    return $db6aa7569fc39783$var$retry(functionToRetry, args, $db6aa7569fc39783$var$jitteredBackoff(maxDelayMs));
}




var $e2ad8c45736bbeec$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $e2ad8c45736bbeec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (UserPoolId.length > $e2ad8c45736bbeec$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $db6aa7569fc39783$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $b0e63581d785b20b$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    };
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split('_')[1];
    };
    _proto.getClientId = function getClientId() {
        return this.clientId;
    };
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $e1a4d309ff047fc2$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    };
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $e1a4d309ff047fc2$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    };
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $7ff70d756a73cc34$exports = {};
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $7ff70d756a73cc34$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $4cb20fb2c1098d33$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error('The domain of cookieStorage can not be undefined.');
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $7ff70d756a73cc34$exports.set(key, value, options);
        return $7ff70d756a73cc34$exports.get(key);
    };
    _proto.getItem = function getItem(key) {
        return $7ff70d756a73cc34$exports.get(key);
    };
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $7ff70d756a73cc34$exports.remove(key, options);
    };
    _proto.clear = function clear() {
        var cookies = $7ff70d756a73cc34$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();








var $6Wce5 = parcelRequire("6Wce5");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $6Wce5 = parcelRequire("6Wce5");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $def77271c9e83bb6$var$SELF = '_self';
var $def77271c9e83bb6$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $def77271c9e83bb6$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $e6668fcaadd8851e$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var $e6668fcaadd8851e$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var $e6668fcaadd8851e$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var $e6668fcaadd8851e$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var $e6668fcaadd8851e$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};





var $evCD1 = parcelRequire("evCD1");

var $qxxev = parcelRequire("qxxev");
var $f6ea85b43f73e69f$var$__assign = undefined && undefined.__assign || function() {
    $f6ea85b43f73e69f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6ea85b43f73e69f$var$__assign.apply(this, arguments);
};
var $f6ea85b43f73e69f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f6ea85b43f73e69f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f6ea85b43f73e69f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f6ea85b43f73e69f$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $f6ea85b43f73e69f$var$dispatchAuthEvent = function(event, data, message) {
    (0, $6c553752040387ec$export$8c41bb232f1008b1).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $f6ea85b43f73e69f$var$AMPLIFY_SYMBOL);
};
var $f6ea85b43f73e69f$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('OAuth');
var $f6ea85b43f73e69f$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $def77271c9e83bb6$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === 'string';
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = 'code';
        if (provider === void 0) provider = (0, $b5a0c32b0da1da73$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $00ce6ce4cfd3fe72$export$b855308a44508212)(customState) : generatedState;
        $e6668fcaadd8851e$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $e6668fcaadd8851e$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries($f6ea85b43f73e69f$var$__assign($f6ea85b43f73e69f$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === 'code' ? {
            code_challenge: code_challenge
        } : {}), responseType === 'code' ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = $f6ea85b43f73e69f$var$__read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $f6ea85b43f73e69f$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $f6ea85b43f73e69f$var$__awaiter(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $f6ea85b43f73e69f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $6Wce5.parse)(currentUrl).query || '').split('&').map(function(pairings) {
                            return pairings.split('=');
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = $f6ea85b43f73e69f$var$__read(_a, 2), k = _c[0], v = _c[1];
                            return $f6ea85b43f73e69f$var$__assign($f6ea85b43f73e69f$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $6Wce5.parse)(currentUrl).pathname || '/';
                        redirectSignInPathname = (0, $6Wce5.parse)(this._config.redirectSignIn).pathname || '/';
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        $f6ea85b43f73e69f$var$dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $e6668fcaadd8851e$export$742ac7ded61fbfce();
                        oAuthTokenBody = $f6ea85b43f73e69f$var$__assign({
                            grant_type: 'authorization_code',
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $f6ea85b43f73e69f$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = $f6ea85b43f73e69f$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join('&');
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $f6ea85b43f73e69f$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $f6ea85b43f73e69f$var$__generator(this, function(_b) {
                _a = ((0, $6Wce5.parse)(currentUrl).hash || '#').substr(1) // Remove # from returned code
                .split('&').map(function(pairings) {
                    return pairings.split('=');
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = $f6ea85b43f73e69f$var$__read(_a, 2), k = _c[0], v = _c[1];
                    return $f6ea85b43f73e69f$var$__assign($f6ea85b43f73e69f$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $f6ea85b43f73e69f$var$dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                $f6ea85b43f73e69f$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $f6ea85b43f73e69f$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $f6ea85b43f73e69f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $f6ea85b43f73e69f$var$__assign($f6ea85b43f73e69f$var$__assign({}, ((0, $6Wce5.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $f6ea85b43f73e69f$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $6Wce5.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $f6ea85b43f73e69f$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $f6ea85b43f73e69f$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $f6ea85b43f73e69f$var$__assign.apply(void 0, [
                                $f6ea85b43f73e69f$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $f6ea85b43f73e69f$var$__assign.apply(void 0, [
                                $f6ea85b43f73e69f$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $f6ea85b43f73e69f$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $e6668fcaadd8851e$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error('Invalid state in OAuth flow');
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $f6ea85b43f73e69f$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $f6ea85b43f73e69f$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = $f6ea85b43f73e69f$var$__read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join('&');
                $f6ea85b43f73e69f$var$dispatchAuthEvent('oAuthSignOut', {
                    oAuth: 'signOut'
                }, "Signing out from " + oAuthLogoutEndpoint);
                $f6ea85b43f73e69f$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL((0, (/*@__PURE__*/$parcel$interopDefault($evCD1)))(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString((0, (/*@__PURE__*/$parcel$interopDefault($qxxev)))).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}();
var $f6ea85b43f73e69f$export$2e2bcd8739ae039 = $f6ea85b43f73e69f$var$OAuth;


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $af02be57d9e8a9ae$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isNode) ;
    else throw new Error('Not supported');
};


/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $f6f846f905c9d240$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})($f6f846f905c9d240$export$c3070468b9d65120 || ($f6f846f905c9d240$export$c3070468b9d65120 = {}));


var $2b253133451dca32$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2b253133451dca32$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('AuthError');
var $2b253133451dca32$export$145273558d58e0ac = /** @class */ function(_super) {
    $2b253133451dca32$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $2b253133451dca32$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        $2b253133451dca32$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $2b253133451dca32$export$71192787e041818c = /** @class */ function(_super) {
    $2b253133451dca32$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}($2b253133451dca32$export$145273558d58e0ac);
var $2b253133451dca32$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n\t\t\t\tRefer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $f6f846f905c9d240$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $f759aa5a9826e8c0$var$__assign = undefined && undefined.__assign || function() {
    $f759aa5a9826e8c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f759aa5a9826e8c0$var$__assign.apply(this, arguments);
};
var $f759aa5a9826e8c0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f759aa5a9826e8c0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f759aa5a9826e8c0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f759aa5a9826e8c0$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('AuthClass');
var $f759aa5a9826e8c0$var$USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $f759aa5a9826e8c0$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $f759aa5a9826e8c0$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $f759aa5a9826e8c0$var$dispatchAuthEvent = function(event, data, message) {
    (0, $6c553752040387ec$export$8c41bb232f1008b1).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $f759aa5a9826e8c0$var$AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var $f759aa5a9826e8c0$var$MAX_DEVICES = 60;
var $f759aa5a9826e8c0$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var $f759aa5a9826e8c0$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.Credentials = (0, $99c5343f38dbb45f$export$a9627919734faa48);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $f759aa5a9826e8c0$var$dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                else $f759aa5a9826e8c0$var$dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $6c553752040387ec$export$8c41bb232f1008b1).listen('auth', function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return 'Auth';
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $f759aa5a9826e8c0$var$logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, (0, $7b9bdee1f3af029c$export$7acfa6ed01010e37).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $4cb20fb2c1098d33$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $0c332331e284d949$export$ded9c57084144144)() : new (0, $95dac8785b133953$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $f759aa5a9826e8c0$var$logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $e2ad8c45736bbeec$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new (0, $f6ea85b43f73e69f$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $af02be57d9e8a9ae$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $f759aa5a9826e8c0$var$dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage['getItem'] === 'function') {
            var pollingInitiated = this.isTrueStorageValue('amplify-polling-started');
            if (pollingInitiated) {
                $f759aa5a9826e8c0$var$dispatchAuthEvent('autoSignIn_failure', null, (0, $b5a0c32b0da1da73$export$edb367c0a140d3db).AutoSignInError);
                this._storage.removeItem('amplify-auto-sign-in');
            }
            this._storage.removeItem('amplify-polling-started');
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $c6f3224d956604db$export$2e2bcd8739ae039)({
                Name: 'email',
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $c6f3224d956604db$export$2e2bcd8739ae039)({
                Name: 'phone_number',
                Value: phone_number
            }));
        } else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params['attributes'];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $c6f3224d956604db$export$2e2bcd8739ae039)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params['validationData'];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $c6f3224d956604db$export$2e2bcd8739ae039)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem('amplify-auto-sign-in', 'true');
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyPassword);
        $f759aa5a9826e8c0$var$logger.debug('signUp attrs:', attributes);
        $f759aa5a9826e8c0$var$logger.debug('signUp validation data:', validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                } else {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, $2f5def01e0ed5376$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === 'link') this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === 'confirmSignUp') _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, $6c553752040387ec$export$8c41bb232f1008b1).listen('auth', listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem('amplify-polling-started', 'true');
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > $f759aa5a9826e8c0$var$MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                $f759aa5a9826e8c0$var$dispatchAuthEvent('autoSignIn_failure', null, 'Please confirm your account and use your credentials to sign in.');
                _this._storage.removeItem('amplify-auto-sign-in');
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                $f759aa5a9826e8c0$var$dispatchAuthEvent('autoSignIn', value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, $6c553752040387ec$export$8c41bb232f1008b1).remove('auth', listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem('amplify-polling-started');
                                }
                                _this._storage.removeItem('amplify-auto-sign-in');
                            }, function(error) {
                                $f759aa5a9826e8c0$var$logger.error(error);
                                _this._storage.removeItem('amplify-auto-sign-in');
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean' ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('confirmSignUp', data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue('amplify-auto-sign-in');
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('autoSignIn_failure', null, (0, $b5a0c32b0da1da73$export$edb367c0a140d3db).AutoSignInError);
                        _this._storage.removeItem('amplify-auto-sign-in');
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === 'true' : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $b5a0c32b0da1da73$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') $f759aa5a9826e8c0$var$logger.warn('The password should be defined under the first parameter object!');
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $2f5def01e0ed5376$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $f759aa5a9826e8c0$var$logger.debug(session);
                                delete user['challengeName'];
                                delete user['challengeParam'];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, 'session')
                                ];
                            case 3:
                                cred = _a.sent();
                                $f759aa5a9826e8c0$var$logger.debug('succeed to get cognito credentials', cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $f759aa5a9826e8c0$var$logger.debug('cannot get cognito credentials', e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $f759aa5a9826e8c0$var$logger.error('Failed to get the signed in user', e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $f759aa5a9826e8c0$var$logger.debug('signIn failure', err);
                $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $f759aa5a9826e8c0$var$logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $f759aa5a9826e8c0$var$logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $f759aa5a9826e8c0$var$logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $f759aa5a9826e8c0$var$logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $f759aa5a9826e8c0$var$logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $f759aa5a9826e8c0$var$logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error('Pending sign-in attempt already in progress');
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $f759aa5a9826e8c0$var$logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                $f759aa5a9826e8c0$var$logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $f759aa5a9826e8c0$var$logger.debug('getting preferred mfa failed', err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej('invalid MFA Type');
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = 'SMS_MFA';
                else ret = 'NOMFA';
            } else if (mfaList.length === 0) ret = 'NOMFA';
            else $f759aa5a9826e8c0$var$logger.debug('invalid case for getPreferredMFA', data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $f759aa5a9826e8c0$var$logger.debug('getting user data failed', err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case 'TOTP':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SOFTWARE_TOKEN_MFA':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SMS':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'SMS_MFA':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'NOMFA':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') return [
                            2 /*return*/ ,
                            Promise.resolve('No change for mfa type')
                        ];
                        else if (currentMFAType === 'SMS_MFA') smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === 'SMS_MFA') smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $f759aa5a9826e8c0$var$logger.debug('no validmfa method provided');
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $f759aa5a9826e8c0$var$logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    $f759aa5a9826e8c0$var$logger.debug('Set user mfa success', result);
                                    $f759aa5a9826e8c0$var$logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $f759aa5a9826e8c0$var$logger.debug('getting user data failed', err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $f759aa5a9826e8c0$var$logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                $f759aa5a9826e8c0$var$logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $f759aa5a9826e8c0$var$logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                $f759aa5a9826e8c0$var$logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $f759aa5a9826e8c0$var$logger.debug('associateSoftwareToken sucess', secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $f759aa5a9826e8c0$var$logger.debug('verification totp token', user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    $f759aa5a9826e8c0$var$logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $f759aa5a9826e8c0$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $f759aa5a9826e8c0$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $f759aa5a9826e8c0$var$logger.debug('cannot get cognito credentials', e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $f759aa5a9826e8c0$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $f759aa5a9826e8c0$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $f759aa5a9826e8c0$var$logger.debug('cannot get cognito credentials', e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$logger.debug('completeNewPassword failure', err);
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $f759aa5a9826e8c0$var$logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $f759aa5a9826e8c0$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $f759aa5a9826e8c0$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var e_5, isSignedInHostedUI;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_5 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Failed to sync cache info into memory', e_5);
                        throw new Error(e_5);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                $f759aa5a9826e8c0$var$logger.debug('Failed to get user from user pool');
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error('No current user.'))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                $f759aa5a9826e8c0$var$logger.debug('Failed to get the user session', err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        $f759aa5a9826e8c0$var$dispatchAuthEvent('userDeleted', result, 'The authenticated user has been deleted.');
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            $f759aa5a9826e8c0$var$logger.debug('failed to clear cached items');
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            $f759aa5a9826e8c0$var$dispatchAuthEvent('signOut', _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            $f759aa5a9826e8c0$var$logger.debug('no Congito User pool');
                                            rej(new Error('Cognito User pool does not exist'));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== 'sub' && key.indexOf('_verified') < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) verified['email'] = attrs['email'];
                else unverified['email'] = attrs['email'];
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) verified['phone_number'] = attrs['phone_number'];
                else unverified['phone_number'] = attrs['phone_number'];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === 'object' && Object.prototype.hasOwnProperty.call(err, 'message');
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Access Token has been revoked';
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Refresh Token has been revoked';
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'User is disabled.';
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'User does not exist.';
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Refresh Token has expired';
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var e_6;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_6 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else $f759aa5a9826e8c0$var$dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                    var user, clientMetadata;
                    var _this = this;
                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $f759aa5a9826e8c0$var$logger.debug('OAuth signIn in progress, waiting for resolution...');
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $f759aa5a9826e8c0$var$logger.debug('OAuth signIn in progress timeout');
                                            (0, $6c553752040387ec$export$8c41bb232f1008b1).remove('auth', hostedUISignCallback);
                                            res();
                                        }, $f759aa5a9826e8c0$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $6c553752040387ec$export$8c41bb232f1008b1).listen('auth', hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === 'cognitoHostedUI' || event === 'cognitoHostedUI_failure') {
                                                $f759aa5a9826e8c0$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $6c553752040387ec$export$8c41bb232f1008b1).remove('auth', hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $f759aa5a9826e8c0$var$logger.debug('Failed to get user from user pool');
                                    rej('No current user');
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                clientMetadata = this._config.clientMetadata;
                                // refresh the session if the session expired.
                                user.getSession(function(err, session) {
                                    return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                        var cleanUpError_5, bypassCache, clientMetadata, _a, scope;
                                        var _this = this;
                                        return $f759aa5a9826e8c0$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    $f759aa5a9826e8c0$var$logger.debug('Failed to get the user session', err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    _b.label = 1;
                                                case 1:
                                                    _b.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _b.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _b.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 5:
                                                    bypassCache = params ? params.bypassCache : false;
                                                    if (!bypassCache) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.Credentials.clear()
                                                    ];
                                                case 6:
                                                    _b.sent();
                                                    _b.label = 7;
                                                case 7:
                                                    clientMetadata = this._config.clientMetadata;
                                                    _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                                    if (scope.split(' ').includes($f759aa5a9826e8c0$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                                        return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                                            var cleanUpError_6, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                                            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        if (!err) return [
                                                                            3 /*break*/ ,
                                                                            7
                                                                        ];
                                                                        $f759aa5a9826e8c0$var$logger.debug('getting user data failed', err);
                                                                        if (!this.isSessionInvalid(err)) return [
                                                                            3 /*break*/ ,
                                                                            5
                                                                        ];
                                                                        _a.label = 1;
                                                                    case 1:
                                                                        _a.trys.push([
                                                                            1,
                                                                            3,
                                                                            ,
                                                                            4
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.cleanUpInvalidSession(user)
                                                                        ];
                                                                    case 2:
                                                                        _a.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            4
                                                                        ];
                                                                    case 3:
                                                                        cleanUpError_6 = _a.sent();
                                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 4:
                                                                        rej(err);
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            6
                                                                        ];
                                                                    case 5:
                                                                        res(user);
                                                                        _a.label = 6;
                                                                    case 6:
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 7:
                                                                        preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                                        attributeList = [];
                                                                        for(i = 0; i < data.UserAttributes.length; i++){
                                                                            attribute = {
                                                                                Name: data.UserAttributes[i].Name,
                                                                                Value: data.UserAttributes[i].Value
                                                                            };
                                                                            userAttribute = new (0, $c6f3224d956604db$export$2e2bcd8739ae039)(attribute);
                                                                            attributeList.push(userAttribute);
                                                                        }
                                                                        attributes = this.attributesToObject(attributeList);
                                                                        Object.assign(user, {
                                                                            attributes: attributes,
                                                                            preferredMFA: preferredMFA
                                                                        });
                                                                        return [
                                                                            2 /*return*/ ,
                                                                            res(user)
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, {
                                                        bypassCache: bypassCache,
                                                        clientMetadata: clientMetadata
                                                    });
                                                    else {
                                                        $f759aa5a9826e8c0$var$logger.debug("Unable to get the user data because the " + $f759aa5a9826e8c0$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                                        return [
                                                            2 /*return*/ ,
                                                            res(user)
                                                        ];
                                                    }
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    clientMetadata: clientMetadata
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $f759aa5a9826e8c0$var$logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_7, federatedInfo, user, e_8;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $f759aa5a9826e8c0$var$logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Failed to sync cache info into memory', e_7);
                        throw e_7;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) federatedUser = $f759aa5a9826e8c0$var$__assign($f759aa5a9826e8c0$var$__assign({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $f759aa5a9826e8c0$var$logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $f759aa5a9826e8c0$var$logger.debug('get current authenticated federated user', this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $f759aa5a9826e8c0$var$logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_8 = _a.sent();
                        if (e_8 === 'No userPool') $f759aa5a9826e8c0$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $f759aa5a9826e8c0$var$logger.debug('The user is not authenticated by the error', e_8);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $f759aa5a9826e8c0$var$logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error('No User Pool in the configuration.'));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $f759aa5a9826e8c0$var$logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $f759aa5a9826e8c0$var$logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        var _this = this;
        if (!user) {
            $f759aa5a9826e8c0$var$logger.debug('the user is null');
            return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NoUserSession);
        }
        var clientMetadata = this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
        return new Promise(function(res, rej) {
            $f759aa5a9826e8c0$var$logger.debug('Getting the session from this user:', user);
            user.getSession(function(err, session) {
                return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                    var cleanUpError_7;
                    return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $f759aa5a9826e8c0$var$logger.debug('Failed to get the session from user', user);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_7 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                $f759aa5a9826e8c0$var$logger.debug('Succeed to get the user session', session);
                                res(session);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                clientMetadata: clientMetadata
            });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var e_9, federatedInfo;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $f759aa5a9826e8c0$var$logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_9 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Failed to sync cache info into memory', e_9);
                        throw e_9;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        } catch (e) {
                            $f759aa5a9826e8c0$var$logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $f759aa5a9826e8c0$var$logger.debug('getting session success', session);
                                return _this.Credentials.set(session, 'session');
                            }).catch(function() {
                                $f759aa5a9826e8c0$var$logger.debug('getting guest credentials');
                                return _this.Credentials.set(null, 'guest');
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $f759aa5a9826e8c0$var$logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var e_10, isSignedInHostedUI;
            var _this = this;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_10 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Failed to sync cache info into memory', e_10);
                        throw e_10;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $f759aa5a9826e8c0$var$logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return $f759aa5a9826e8c0$var$__awaiter(_this, void 0, void 0, function() {
                                            var cleanUpError_8;
                                            var _this = this;
                                            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $f759aa5a9826e8c0$var$logger.debug('failed to get the user session', err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_8 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_8.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                $f759aa5a9826e8c0$var$logger.debug('global sign out success');
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                $f759aa5a9826e8c0$var$logger.debug('global sign out failed', err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $f759aa5a9826e8c0$var$logger.debug('user sign out', user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error('Signout timeout fail'));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var e_11, user;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $f759aa5a9826e8c0$var$logger.debug('no current Cognito user');
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $f759aa5a9826e8c0$var$logger.debug('no Cognito User pool');
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $f759aa5a9826e8c0$var$dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $f759aa5a9826e8c0$var$logger.debug('change password failure', err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$logger.debug('forgot password failure', err);
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    $f759aa5a9826e8c0$var$dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_12, info, err_1, user;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $f759aa5a9826e8c0$var$logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_12 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Failed to retrieve credentials while getting current user info', e_12);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.error('currentUserInfo error', err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $b5a0c32b0da1da73$export$9b905d6895bdc426)(providerOrOptions) || (0, $b5a0c32b0da1da73$export$828f8efbdf71714b)(providerOrOptions) || (0, $b5a0c32b0da1da73$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === 'undefined')) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $b5a0c32b0da1da73$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $b5a0c32b0da1da73$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $b5a0c32b0da1da73$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $b5a0c32b0da1da73$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) $f759aa5a9826e8c0$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, 'federation')
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        $f759aa5a9826e8c0$var$logger.debug('federated sign in credentials', credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $f759aa5a9826e8c0$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $f759aa5a9826e8c0$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('parsingCallbackUrl', {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $1436837d4e301e07$export$a2708fdb45cd35f)().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!((0, $6Wce5.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $f759aa5a9826e8c0$var$__read(_a, 1), k = _b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!((0, $6Wce5.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $f759aa5a9826e8c0$var$__read(_a, 1), k = _b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $600a9e099cd11969$export$2e2bcd8739ae039)({
                            IdToken: new (0, $94f71146a23a56cb$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $741b7c34058d72c2$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $2fa966c8aee9cf9e$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, 'session')
                        ];
                    case 4:
                        credentials = _b.sent();
                        $f759aa5a9826e8c0$var$logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split('-').splice(1).join('-');
                            $f759aa5a9826e8c0$var$dispatchAuthEvent('customOAuthState', (0, $00ce6ce4cfd3fe72$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_2 = _b.sent();
                        $f759aa5a9826e8c0$var$logger.debug('Error in cognito hosted auth response', err_2);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== 'undefined') window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('signIn_failure', err_2, "The OAuth response flow failed");
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('cognitoHostedUI_failure', err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $f759aa5a9826e8c0$var$dispatchAuthEvent('customState_failure', err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === 'email_verified' || attribute.Name === 'phone_number_verified') obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === 'function' && value.toLowerCase() === 'true';
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $e1a4d309ff047fc2$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === 'function' && typeof obj.setItem === 'function' && typeof obj.removeItem === 'function' && typeof obj.clear === 'function';
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $b5a0c32b0da1da73$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $2b253133451dca32$export$145273558d58e0ac)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $2b253133451dca32$export$71192787e041818c)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_2;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('The user is not authenticated by the error', error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_3;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('The user is not authenticated by the error', error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return $f759aa5a9826e8c0$var$__awaiter(this, void 0, void 0, function() {
            var currUser, error_4;
            return $f759aa5a9826e8c0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        $f759aa5a9826e8c0$var$logger.debug('The user is not authenticated by the error', error_4);
                        throw new Error('The user is not authenticated');
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === 'device_name';
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, $2b253133451dca32$export$145273558d58e0ac)((0, $b5a0c32b0da1da73$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices($f759aa5a9826e8c0$var$MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var $f759aa5a9826e8c0$export$334c29725a78c21d = new $f759aa5a9826e8c0$export$eeff9d1a8b8c057b(null);
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).register($f759aa5a9826e8c0$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $ef4defd567009aff$export$2e2bcd8739ae039 = (0, $f759aa5a9826e8c0$export$334c29725a78c21d);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7724987292203433$export$f84bd70098573c5c = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $95dac8785b133953$export$a2bd19c49e4760e8)().getStorage()
};
function $7724987292203433$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $7724987292203433$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $7724987292203433$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $7724987292203433$var$_isInteger(value);
}
function $7724987292203433$var$_isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $7724987292203433$var$store = {};
var $7724987292203433$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $7724987292203433$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $7724987292203433$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $7724987292203433$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $7724987292203433$var$store[key];
    };
    return CacheObject;
}();


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $25c5a694e95564d3$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('StorageCache');
/**
 * Initialization of the cache
 *
 */ var $25c5a694e95564d3$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $7724987292203433$export$a287f47fed4544b8)(this.config.capacityInBytes)) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = (0, $7724987292203433$export$f84bd70098573c5c).capacityInBytes;
        }
        if (!(0, $7724987292203433$export$a287f47fed4544b8)(this.config.itemMaxSize)) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = (0, $7724987292203433$export$f84bd70098573c5c).itemMaxSize;
        }
        if (!(0, $7724987292203433$export$a287f47fed4544b8)(this.config.defaultTTL)) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = (0, $7724987292203433$export$f84bd70098573c5c).defaultTTL;
        }
        if (!(0, $7724987292203433$export$a287f47fed4544b8)(this.config.defaultPriority)) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = (0, $7724987292203433$export$f84bd70098573c5c).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, $7724987292203433$export$f84bd70098573c5c).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, $7724987292203433$export$f84bd70098573c5c).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $25c5a694e95564d3$var$logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, $7724987292203433$export$f84bd70098573c5c).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $25c5a694e95564d3$var$logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, $7724987292203433$export$f84bd70098573c5c).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $7724987292203433$export$dd144842d7b22d3a)(),
            visitedTime: (0, $7724987292203433$export$dd144842d7b22d3a)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $7724987292203433$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $7724987292203433$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $25c5a694e95564d3$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var /**
 * @deprecated use named import
 */ $25c5a694e95564d3$export$2e2bcd8739ae039 = $25c5a694e95564d3$export$947ed1997bd112b4;



var $2304dc79b3eccfd5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2304dc79b3eccfd5$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $2304dc79b3eccfd5$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    $2304dc79b3eccfd5$var$__extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $7724987292203433$export$f84bd70098573c5c), config) : (0, $7724987292203433$export$f84bd70098573c5c);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $7724987292203433$export$dd144842d7b22d3a)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $7724987292203433$export$dd144842d7b22d3a)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $2304dc79b3eccfd5$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $2304dc79b3eccfd5$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $2304dc79b3eccfd5$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            $2304dc79b3eccfd5$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $7724987292203433$export$dd144842d7b22d3a)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $2304dc79b3eccfd5$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $2304dc79b3eccfd5$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $2304dc79b3eccfd5$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $2304dc79b3eccfd5$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $2304dc79b3eccfd5$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $2304dc79b3eccfd5$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $2304dc79b3eccfd5$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $2304dc79b3eccfd5$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $2304dc79b3eccfd5$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $2304dc79b3eccfd5$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $7724987292203433$export$f84bd70098573c5c).keyPrefix) {
            $2304dc79b3eccfd5$var$logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, $7724987292203433$export$dd144842d7b22d3a).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $25c5a694e95564d3$export$947ed1997bd112b4));
var $2304dc79b3eccfd5$export$2a9787695d97e2c4 = new $2304dc79b3eccfd5$export$e6fda0405fa98d6d();
var /**
 * @deprecated use named import
 */ $2304dc79b3eccfd5$export$2e2bcd8739ae039 = $2304dc79b3eccfd5$export$2a9787695d97e2c4;



var /**
 * @deprecated use named import
 */ $9b53bbc03928953c$export$2e2bcd8739ae039 = (0, $2304dc79b3eccfd5$export$2a9787695d97e2c4);
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).register((0, $2304dc79b3eccfd5$export$2a9787695d97e2c4));



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $284cdd41a966f3e0$var$extendStatics = function(d, b) {
    $284cdd41a966f3e0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $284cdd41a966f3e0$var$extendStatics(d, b);
};
function $284cdd41a966f3e0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $284cdd41a966f3e0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $284cdd41a966f3e0$export$18ce0697a983be9b = function() {
    $284cdd41a966f3e0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $284cdd41a966f3e0$export$18ce0697a983be9b.apply(this, arguments);
};
function $284cdd41a966f3e0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $284cdd41a966f3e0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $284cdd41a966f3e0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $284cdd41a966f3e0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $284cdd41a966f3e0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $284cdd41a966f3e0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $284cdd41a966f3e0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $284cdd41a966f3e0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $284cdd41a966f3e0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $284cdd41a966f3e0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $284cdd41a966f3e0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $284cdd41a966f3e0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $284cdd41a966f3e0$export$45d3717a4c69092e(o, m, p);
}
function $284cdd41a966f3e0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $284cdd41a966f3e0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $284cdd41a966f3e0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($284cdd41a966f3e0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $284cdd41a966f3e0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $284cdd41a966f3e0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $284cdd41a966f3e0$export$10c90e4f7922046c(v) {
    return this instanceof $284cdd41a966f3e0$export$10c90e4f7922046c ? (this.v = v, this) : new $284cdd41a966f3e0$export$10c90e4f7922046c(v);
}
function $284cdd41a966f3e0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $284cdd41a966f3e0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $284cdd41a966f3e0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $284cdd41a966f3e0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $284cdd41a966f3e0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $284cdd41a966f3e0$export$19a8beecd37a4c45 === "function" ? $284cdd41a966f3e0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $284cdd41a966f3e0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $284cdd41a966f3e0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $284cdd41a966f3e0$var$ownKeys = function(o) {
    $284cdd41a966f3e0$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $284cdd41a966f3e0$var$ownKeys(o);
};
function $284cdd41a966f3e0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $284cdd41a966f3e0$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $284cdd41a966f3e0$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $284cdd41a966f3e0$var$__setModuleDefault(result, mod);
    return result;
}
function $284cdd41a966f3e0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $284cdd41a966f3e0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $284cdd41a966f3e0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $284cdd41a966f3e0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $284cdd41a966f3e0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $284cdd41a966f3e0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $284cdd41a966f3e0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $284cdd41a966f3e0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $284cdd41a966f3e0$export$889dfb5d17574b0b(path, preserveJsx, extraExtensions, ignoreCase) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        if (extraExtensions) for(var extension in extraExtensions){
            var suffix = path.slice(-extension.length);
            if (suffix === extension || ignoreCase && suffix.toLowerCase() === extension.toLowerCase()) {
                var output = extraExtensions[extension];
                return output === extension ? path : path.slice(0, -extension.length) + output;
            }
        }
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
        });
    }
    return path;
}
var $284cdd41a966f3e0$export$2e2bcd8739ae039 = {
    __extends: $284cdd41a966f3e0$export$a8ba968b8961cb8a,
    __assign: $284cdd41a966f3e0$export$18ce0697a983be9b,
    __rest: $284cdd41a966f3e0$export$3c9a16f847548506,
    __decorate: $284cdd41a966f3e0$export$29e00dfd3077644b,
    __param: $284cdd41a966f3e0$export$d5ad3fd78186038f,
    __esDecorate: $284cdd41a966f3e0$export$3a84e1ae4e97e9b0,
    __runInitializers: $284cdd41a966f3e0$export$d831c04e792af3d,
    __propKey: $284cdd41a966f3e0$export$6a2a36740a146cb8,
    __setFunctionName: $284cdd41a966f3e0$export$d1a06452d3489bc7,
    __metadata: $284cdd41a966f3e0$export$f1db080c865becb9,
    __awaiter: $284cdd41a966f3e0$export$1050f835b63b671e,
    __generator: $284cdd41a966f3e0$export$67ebef60e6f28a6,
    __createBinding: $284cdd41a966f3e0$export$45d3717a4c69092e,
    __exportStar: $284cdd41a966f3e0$export$f33643c0debef087,
    __values: $284cdd41a966f3e0$export$19a8beecd37a4c45,
    __read: $284cdd41a966f3e0$export$8d051b38c9118094,
    __spread: $284cdd41a966f3e0$export$afc72e2116322959,
    __spreadArrays: $284cdd41a966f3e0$export$6388937ca91ccae8,
    __spreadArray: $284cdd41a966f3e0$export$1216008129fb82ed,
    __await: $284cdd41a966f3e0$export$10c90e4f7922046c,
    __asyncGenerator: $284cdd41a966f3e0$export$e427f37a30a4de9b,
    __asyncDelegator: $284cdd41a966f3e0$export$bbd80228419bb833,
    __asyncValues: $284cdd41a966f3e0$export$e3b29a3d6162315f,
    __makeTemplateObject: $284cdd41a966f3e0$export$4fb47efe1390b86f,
    __importStar: $284cdd41a966f3e0$export$c21735bcef00d192,
    __importDefault: $284cdd41a966f3e0$export$da59b14a69baef04,
    __classPrivateFieldGet: $284cdd41a966f3e0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $284cdd41a966f3e0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $284cdd41a966f3e0$export$81fdc39f203e4e04,
    __addDisposableResource: $284cdd41a966f3e0$export$88ac25d8e944e405,
    __disposeResources: $284cdd41a966f3e0$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $284cdd41a966f3e0$export$889dfb5d17574b0b
};




var $0c0d1970b55e47a3$export$ff1e75b1e93a2588;
(function(AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ff1e75b1e93a2588 || ($0c0d1970b55e47a3$export$ff1e75b1e93a2588 = {}));
var $0c0d1970b55e47a3$export$80a5621784397e06;
(function(AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$80a5621784397e06 || ($0c0d1970b55e47a3$export$80a5621784397e06 = {}));
var $0c0d1970b55e47a3$export$2509116d04cdd782;
(function(AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2509116d04cdd782 || ($0c0d1970b55e47a3$export$2509116d04cdd782 = {}));
var $0c0d1970b55e47a3$export$1de06065cff890a8;
(function(NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$1de06065cff890a8 || ($0c0d1970b55e47a3$export$1de06065cff890a8 = {}));
var $0c0d1970b55e47a3$export$b73224f1e3e6ea55;
(function(AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b73224f1e3e6ea55 || ($0c0d1970b55e47a3$export$b73224f1e3e6ea55 = {}));
var $0c0d1970b55e47a3$export$4882adf346b33e1a;
(function(Grantee) {
    Grantee.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4882adf346b33e1a || ($0c0d1970b55e47a3$export$4882adf346b33e1a = {}));
var $0c0d1970b55e47a3$export$16844950929e022f;
(function(Grant) {
    Grant.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$16844950929e022f || ($0c0d1970b55e47a3$export$16844950929e022f = {}));
var $0c0d1970b55e47a3$export$25fb39c3824c9c44;
(function(Owner) {
    Owner.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$25fb39c3824c9c44 || ($0c0d1970b55e47a3$export$25fb39c3824c9c44 = {}));
var $0c0d1970b55e47a3$export$6a42fa102a072c77;
(function(AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6a42fa102a072c77 || ($0c0d1970b55e47a3$export$6a42fa102a072c77 = {}));
var $0c0d1970b55e47a3$export$3db5322b6b5badd4;
(function(AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3db5322b6b5badd4 || ($0c0d1970b55e47a3$export$3db5322b6b5badd4 = {}));
var $0c0d1970b55e47a3$export$edcc5df28126c9bc;
(function(CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$edcc5df28126c9bc || ($0c0d1970b55e47a3$export$edcc5df28126c9bc = {}));
var $0c0d1970b55e47a3$export$76f56660c9039ec5;
(function(CompletedPart) {
    CompletedPart.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$76f56660c9039ec5 || ($0c0d1970b55e47a3$export$76f56660c9039ec5 = {}));
var $0c0d1970b55e47a3$export$394f3a16361c2a83;
(function(CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$394f3a16361c2a83 || ($0c0d1970b55e47a3$export$394f3a16361c2a83 = {}));
var $0c0d1970b55e47a3$export$2998881f143b41ec;
(function(CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2998881f143b41ec || ($0c0d1970b55e47a3$export$2998881f143b41ec = {}));
var $0c0d1970b55e47a3$export$32f1916074d2607f;
(function(CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$32f1916074d2607f || ($0c0d1970b55e47a3$export$32f1916074d2607f = {}));
var $0c0d1970b55e47a3$export$a9f99871811ebc49;
(function(CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$a9f99871811ebc49 || ($0c0d1970b55e47a3$export$a9f99871811ebc49 = {}));
var $0c0d1970b55e47a3$export$e84f0e76c8b259eb;
(function(CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$e84f0e76c8b259eb || ($0c0d1970b55e47a3$export$e84f0e76c8b259eb = {}));
var $0c0d1970b55e47a3$export$77615b2f7cde9dd7;
(function(ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$77615b2f7cde9dd7 || ($0c0d1970b55e47a3$export$77615b2f7cde9dd7 = {}));
var $0c0d1970b55e47a3$export$b6b374c2bfd60422;
(function(BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b6b374c2bfd60422 || ($0c0d1970b55e47a3$export$b6b374c2bfd60422 = {}));
var $0c0d1970b55e47a3$export$3d44152d602e5b07;
(function(BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3d44152d602e5b07 || ($0c0d1970b55e47a3$export$3d44152d602e5b07 = {}));
var $0c0d1970b55e47a3$export$b9395efd4905ea2f;
(function(CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b9395efd4905ea2f || ($0c0d1970b55e47a3$export$b9395efd4905ea2f = {}));
var $0c0d1970b55e47a3$export$80fb9034e13a84f5;
(function(CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$80fb9034e13a84f5 || ($0c0d1970b55e47a3$export$80fb9034e13a84f5 = {}));
var $0c0d1970b55e47a3$export$8aca1806c1d8d130;
(function(CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8aca1806c1d8d130 || ($0c0d1970b55e47a3$export$8aca1806c1d8d130 = {}));
var $0c0d1970b55e47a3$export$196bb0482ff68428;
(function(CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$196bb0482ff68428 || ($0c0d1970b55e47a3$export$196bb0482ff68428 = {}));
var $0c0d1970b55e47a3$export$f65faae2a46e45c2;
(function(CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$f65faae2a46e45c2 || ($0c0d1970b55e47a3$export$f65faae2a46e45c2 = {}));
var $0c0d1970b55e47a3$export$8b74a2c46a921740;
(function(DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8b74a2c46a921740 || ($0c0d1970b55e47a3$export$8b74a2c46a921740 = {}));
var $0c0d1970b55e47a3$export$c5ab088f35618173;
(function(DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c5ab088f35618173 || ($0c0d1970b55e47a3$export$c5ab088f35618173 = {}));
var $0c0d1970b55e47a3$export$eedf1d80102f9cff;
(function(DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$eedf1d80102f9cff || ($0c0d1970b55e47a3$export$eedf1d80102f9cff = {}));
var $0c0d1970b55e47a3$export$67cbcb88080a155a;
(function(DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$67cbcb88080a155a || ($0c0d1970b55e47a3$export$67cbcb88080a155a = {}));
var $0c0d1970b55e47a3$export$301f370253f11f3b;
(function(DeleteBucketIntelligentTieringConfigurationRequest) {
    DeleteBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$301f370253f11f3b || ($0c0d1970b55e47a3$export$301f370253f11f3b = {}));
var $0c0d1970b55e47a3$export$3603c2e1b3558471;
(function(DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3603c2e1b3558471 || ($0c0d1970b55e47a3$export$3603c2e1b3558471 = {}));
var $0c0d1970b55e47a3$export$6c38b78c3c77b60c;
(function(DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6c38b78c3c77b60c || ($0c0d1970b55e47a3$export$6c38b78c3c77b60c = {}));
var $0c0d1970b55e47a3$export$ff4b8fc3fb36fbd;
(function(DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ff4b8fc3fb36fbd || ($0c0d1970b55e47a3$export$ff4b8fc3fb36fbd = {}));
var $0c0d1970b55e47a3$export$4c49e000fa5b0b86;
(function(DeleteBucketOwnershipControlsRequest) {
    DeleteBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4c49e000fa5b0b86 || ($0c0d1970b55e47a3$export$4c49e000fa5b0b86 = {}));
var $0c0d1970b55e47a3$export$cce16146386a1316;
(function(DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$cce16146386a1316 || ($0c0d1970b55e47a3$export$cce16146386a1316 = {}));
var $0c0d1970b55e47a3$export$238256546e65e80f;
(function(DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$238256546e65e80f || ($0c0d1970b55e47a3$export$238256546e65e80f = {}));
var $0c0d1970b55e47a3$export$e9cefd124b305be3;
(function(DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e9cefd124b305be3 || ($0c0d1970b55e47a3$export$e9cefd124b305be3 = {}));
var $0c0d1970b55e47a3$export$15e654f934b26a7b;
(function(DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$15e654f934b26a7b || ($0c0d1970b55e47a3$export$15e654f934b26a7b = {}));
var $0c0d1970b55e47a3$export$64d4f4fac943bc25;
(function(DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$64d4f4fac943bc25 || ($0c0d1970b55e47a3$export$64d4f4fac943bc25 = {}));
var $0c0d1970b55e47a3$export$7d123f24a24f15cf;
(function(DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$7d123f24a24f15cf || ($0c0d1970b55e47a3$export$7d123f24a24f15cf = {}));
var $0c0d1970b55e47a3$export$d17347461b0f9a2b;
(function(DeletedObject) {
    DeletedObject.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d17347461b0f9a2b || ($0c0d1970b55e47a3$export$d17347461b0f9a2b = {}));
var $0c0d1970b55e47a3$export$afd90478dc782af0;
(function(_Error) {
    _Error.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$afd90478dc782af0 || ($0c0d1970b55e47a3$export$afd90478dc782af0 = {}));
var $0c0d1970b55e47a3$export$e1c86a39185a896f;
(function(DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e1c86a39185a896f || ($0c0d1970b55e47a3$export$e1c86a39185a896f = {}));
var $0c0d1970b55e47a3$export$84d9d258efc6700d;
(function(ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$84d9d258efc6700d || ($0c0d1970b55e47a3$export$84d9d258efc6700d = {}));
var $0c0d1970b55e47a3$export$bfadae053a633538;
(function(Delete) {
    Delete.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$bfadae053a633538 || ($0c0d1970b55e47a3$export$bfadae053a633538 = {}));
var $0c0d1970b55e47a3$export$c19f81fd3ccd8fc2;
(function(DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c19f81fd3ccd8fc2 || ($0c0d1970b55e47a3$export$c19f81fd3ccd8fc2 = {}));
var $0c0d1970b55e47a3$export$4d816bf2553d6082;
(function(DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4d816bf2553d6082 || ($0c0d1970b55e47a3$export$4d816bf2553d6082 = {}));
var $0c0d1970b55e47a3$export$2d561b57455087e8;
(function(DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2d561b57455087e8 || ($0c0d1970b55e47a3$export$2d561b57455087e8 = {}));
var $0c0d1970b55e47a3$export$cac29ea1b5d93b5d;
(function(DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$cac29ea1b5d93b5d || ($0c0d1970b55e47a3$export$cac29ea1b5d93b5d = {}));
var $0c0d1970b55e47a3$export$d592399f8c69d061;
(function(GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d592399f8c69d061 || ($0c0d1970b55e47a3$export$d592399f8c69d061 = {}));
var $0c0d1970b55e47a3$export$c2ed0589b585987a;
(function(GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c2ed0589b585987a || ($0c0d1970b55e47a3$export$c2ed0589b585987a = {}));
var $0c0d1970b55e47a3$export$1e656ec1fa0dbccd;
(function(GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$1e656ec1fa0dbccd || ($0c0d1970b55e47a3$export$1e656ec1fa0dbccd = {}));
var $0c0d1970b55e47a3$export$5543bf3f517c214;
(function(GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$5543bf3f517c214 || ($0c0d1970b55e47a3$export$5543bf3f517c214 = {}));
var $0c0d1970b55e47a3$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3288d34c523a1192 || ($0c0d1970b55e47a3$export$3288d34c523a1192 = {}));
var $0c0d1970b55e47a3$export$b9ae9bceb2811d5d;
(function(AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b9ae9bceb2811d5d || ($0c0d1970b55e47a3$export$b9ae9bceb2811d5d = {}));
var $0c0d1970b55e47a3$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    AnalyticsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $0c0d1970b55e47a3$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $0c0d1970b55e47a3$export$b9ae9bceb2811d5d.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($0c0d1970b55e47a3$export$c9ec61557dcb764a || ($0c0d1970b55e47a3$export$c9ec61557dcb764a = {}));
var $0c0d1970b55e47a3$export$fc566d9f8f854701;
(function(AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$fc566d9f8f854701 || ($0c0d1970b55e47a3$export$fc566d9f8f854701 = {}));
var $0c0d1970b55e47a3$export$20f751b8dcd24833;
(function(AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$20f751b8dcd24833 || ($0c0d1970b55e47a3$export$20f751b8dcd24833 = {}));
var $0c0d1970b55e47a3$export$a14156deb587d512;
(function(StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a14156deb587d512 || ($0c0d1970b55e47a3$export$a14156deb587d512 = {}));
var $0c0d1970b55e47a3$export$13f5184561469c95;
(function(StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$13f5184561469c95 || ($0c0d1970b55e47a3$export$13f5184561469c95 = {}));
var $0c0d1970b55e47a3$export$15f94404a081a771;
(function(AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $0c0d1970b55e47a3$export$c9ec61557dcb764a.filterSensitiveLog(obj.Filter)
        });
    };
})($0c0d1970b55e47a3$export$15f94404a081a771 || ($0c0d1970b55e47a3$export$15f94404a081a771 = {}));
var $0c0d1970b55e47a3$export$32ac99bb59e9ea35;
(function(GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $0c0d1970b55e47a3$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$32ac99bb59e9ea35 || ($0c0d1970b55e47a3$export$32ac99bb59e9ea35 = {}));
var $0c0d1970b55e47a3$export$a4b635f541d39c02;
(function(GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a4b635f541d39c02 || ($0c0d1970b55e47a3$export$a4b635f541d39c02 = {}));
var $0c0d1970b55e47a3$export$483798435237259b;
(function(CORSRule) {
    CORSRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$483798435237259b || ($0c0d1970b55e47a3$export$483798435237259b = {}));
var $0c0d1970b55e47a3$export$3ff8c9c489aa7ab5;
(function(GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3ff8c9c489aa7ab5 || ($0c0d1970b55e47a3$export$3ff8c9c489aa7ab5 = {}));
var $0c0d1970b55e47a3$export$cdc36c4a20d66833;
(function(GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$cdc36c4a20d66833 || ($0c0d1970b55e47a3$export$cdc36c4a20d66833 = {}));
var $0c0d1970b55e47a3$export$5e055b8b357210fd;
(function(ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$5e055b8b357210fd || ($0c0d1970b55e47a3$export$5e055b8b357210fd = {}));
var $0c0d1970b55e47a3$export$614e3b57594b8702;
(function(ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $0c0d1970b55e47a3$export$5e055b8b357210fd.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
        });
    };
})($0c0d1970b55e47a3$export$614e3b57594b8702 || ($0c0d1970b55e47a3$export$614e3b57594b8702 = {}));
var $0c0d1970b55e47a3$export$d53e5f9e3c3507bf;
(function(ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $0c0d1970b55e47a3$export$614e3b57594b8702.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$d53e5f9e3c3507bf || ($0c0d1970b55e47a3$export$d53e5f9e3c3507bf = {}));
var $0c0d1970b55e47a3$export$a5d815db4065bb4e;
(function(GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $0c0d1970b55e47a3$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$a5d815db4065bb4e || ($0c0d1970b55e47a3$export$a5d815db4065bb4e = {}));
var $0c0d1970b55e47a3$export$3871e35cee114580;
(function(GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3871e35cee114580 || ($0c0d1970b55e47a3$export$3871e35cee114580 = {}));
var $0c0d1970b55e47a3$export$538012949ecb1f02;
(function(IntelligentTieringAndOperator) {
    IntelligentTieringAndOperator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$538012949ecb1f02 || ($0c0d1970b55e47a3$export$538012949ecb1f02 = {}));
var $0c0d1970b55e47a3$export$ee31c5d57e861da9;
(function(IntelligentTieringFilter) {
    IntelligentTieringFilter.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ee31c5d57e861da9 || ($0c0d1970b55e47a3$export$ee31c5d57e861da9 = {}));
var $0c0d1970b55e47a3$export$45a8dbc307fd1b69;
(function(Tiering) {
    Tiering.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$45a8dbc307fd1b69 || ($0c0d1970b55e47a3$export$45a8dbc307fd1b69 = {}));
var $0c0d1970b55e47a3$export$a9d6845d45635cd6;
(function(IntelligentTieringConfiguration) {
    IntelligentTieringConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a9d6845d45635cd6 || ($0c0d1970b55e47a3$export$a9d6845d45635cd6 = {}));
var $0c0d1970b55e47a3$export$a5c98daa4e4d0978;
(function(GetBucketIntelligentTieringConfigurationOutput) {
    GetBucketIntelligentTieringConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a5c98daa4e4d0978 || ($0c0d1970b55e47a3$export$a5c98daa4e4d0978 = {}));
var $0c0d1970b55e47a3$export$2bc70aedd92acdd9;
(function(GetBucketIntelligentTieringConfigurationRequest) {
    GetBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2bc70aedd92acdd9 || ($0c0d1970b55e47a3$export$2bc70aedd92acdd9 = {}));
var $0c0d1970b55e47a3$export$51ca0161a096cac2;
(function(SSEKMS) {
    SSEKMS.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.KeyId && {
            KeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$51ca0161a096cac2 || ($0c0d1970b55e47a3$export$51ca0161a096cac2 = {}));
var $0c0d1970b55e47a3$export$e6fda754462bc5e9;
(function(SSES3) {
    SSES3.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e6fda754462bc5e9 || ($0c0d1970b55e47a3$export$e6fda754462bc5e9 = {}));
var $0c0d1970b55e47a3$export$4507106f7965dad8;
(function(InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMS && {
            SSEKMS: $0c0d1970b55e47a3$export$51ca0161a096cac2.filterSensitiveLog(obj.SSEKMS)
        });
    };
})($0c0d1970b55e47a3$export$4507106f7965dad8 || ($0c0d1970b55e47a3$export$4507106f7965dad8 = {}));
var $0c0d1970b55e47a3$export$dbf61758afa382d2;
(function(InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: $0c0d1970b55e47a3$export$4507106f7965dad8.filterSensitiveLog(obj.Encryption)
        });
    };
})($0c0d1970b55e47a3$export$dbf61758afa382d2 || ($0c0d1970b55e47a3$export$dbf61758afa382d2 = {}));
var $0c0d1970b55e47a3$export$95a07687ea92cc86;
(function(InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.S3BucketDestination && {
            S3BucketDestination: $0c0d1970b55e47a3$export$dbf61758afa382d2.filterSensitiveLog(obj.S3BucketDestination)
        });
    };
})($0c0d1970b55e47a3$export$95a07687ea92cc86 || ($0c0d1970b55e47a3$export$95a07687ea92cc86 = {}));
var $0c0d1970b55e47a3$export$9cab1f8eb4898ac3;
(function(InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$9cab1f8eb4898ac3 || ($0c0d1970b55e47a3$export$9cab1f8eb4898ac3 = {}));
var $0c0d1970b55e47a3$export$80a40dd3d0e79f33;
(function(InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$80a40dd3d0e79f33 || ($0c0d1970b55e47a3$export$80a40dd3d0e79f33 = {}));
var $0c0d1970b55e47a3$export$e13e8ea2fe7b5717;
(function(InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Destination && {
            Destination: $0c0d1970b55e47a3$export$95a07687ea92cc86.filterSensitiveLog(obj.Destination)
        });
    };
})($0c0d1970b55e47a3$export$e13e8ea2fe7b5717 || ($0c0d1970b55e47a3$export$e13e8ea2fe7b5717 = {}));
var $0c0d1970b55e47a3$export$4b7c0b968f94593a;
(function(GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $0c0d1970b55e47a3$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$4b7c0b968f94593a || ($0c0d1970b55e47a3$export$4b7c0b968f94593a = {}));
var $0c0d1970b55e47a3$export$2bcb6519092e8dbf;
(function(GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2bcb6519092e8dbf || ($0c0d1970b55e47a3$export$2bcb6519092e8dbf = {}));
var $0c0d1970b55e47a3$export$87e69778058ef73d;
(function(LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$87e69778058ef73d || ($0c0d1970b55e47a3$export$87e69778058ef73d = {}));
var $0c0d1970b55e47a3$export$70a8e907770d2a36;
(function(LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$70a8e907770d2a36 || ($0c0d1970b55e47a3$export$70a8e907770d2a36 = {}));
var $0c0d1970b55e47a3$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    LifecycleRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $0c0d1970b55e47a3$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $0c0d1970b55e47a3$export$70a8e907770d2a36.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($0c0d1970b55e47a3$export$4338dba1e93ddaf4 || ($0c0d1970b55e47a3$export$4338dba1e93ddaf4 = {}));
var $0c0d1970b55e47a3$export$a99742a437d0fdf9;
(function(NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a99742a437d0fdf9 || ($0c0d1970b55e47a3$export$a99742a437d0fdf9 = {}));
var $0c0d1970b55e47a3$export$9250e73c985ce931;
(function(NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$9250e73c985ce931 || ($0c0d1970b55e47a3$export$9250e73c985ce931 = {}));
var $0c0d1970b55e47a3$export$be58926105124dd4;
(function(Transition) {
    Transition.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$be58926105124dd4 || ($0c0d1970b55e47a3$export$be58926105124dd4 = {}));
var $0c0d1970b55e47a3$export$1ac30bbe41f1f9ef;
(function(LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $0c0d1970b55e47a3$export$4338dba1e93ddaf4.filterSensitiveLog(obj.Filter)
        });
    };
})($0c0d1970b55e47a3$export$1ac30bbe41f1f9ef || ($0c0d1970b55e47a3$export$1ac30bbe41f1f9ef = {}));
var $0c0d1970b55e47a3$export$f2f23f80c8c1c7c4;
(function(GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $0c0d1970b55e47a3$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$f2f23f80c8c1c7c4 || ($0c0d1970b55e47a3$export$f2f23f80c8c1c7c4 = {}));
var $0c0d1970b55e47a3$export$86e3489ab08ca98d;
(function(GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$86e3489ab08ca98d || ($0c0d1970b55e47a3$export$86e3489ab08ca98d = {}));
var $0c0d1970b55e47a3$export$ed9828a2500d585f;
(function(GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ed9828a2500d585f || ($0c0d1970b55e47a3$export$ed9828a2500d585f = {}));
var $0c0d1970b55e47a3$export$4109a69a89893a5d;
(function(GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4109a69a89893a5d || ($0c0d1970b55e47a3$export$4109a69a89893a5d = {}));
var $0c0d1970b55e47a3$export$cf4abd6ae8fde913;
(function(TargetGrant) {
    TargetGrant.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$cf4abd6ae8fde913 || ($0c0d1970b55e47a3$export$cf4abd6ae8fde913 = {}));
var $0c0d1970b55e47a3$export$a1484d354b9c56b2;
(function(LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a1484d354b9c56b2 || ($0c0d1970b55e47a3$export$a1484d354b9c56b2 = {}));
var $0c0d1970b55e47a3$export$f9d2a0e32a2aa91f;
(function(GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f9d2a0e32a2aa91f || ($0c0d1970b55e47a3$export$f9d2a0e32a2aa91f = {}));
var $0c0d1970b55e47a3$export$182d23383f8b69bd;
(function(GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$182d23383f8b69bd || ($0c0d1970b55e47a3$export$182d23383f8b69bd = {}));
var $0c0d1970b55e47a3$export$4774797e6eda832;
(function(MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4774797e6eda832 || ($0c0d1970b55e47a3$export$4774797e6eda832 = {}));
var $0c0d1970b55e47a3$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    MetricsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $0c0d1970b55e47a3$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $0c0d1970b55e47a3$export$4774797e6eda832.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($0c0d1970b55e47a3$export$564a1f9c338cae45 || ($0c0d1970b55e47a3$export$564a1f9c338cae45 = {}));
var $0c0d1970b55e47a3$export$908bafa154008a5e;
(function(MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $0c0d1970b55e47a3$export$564a1f9c338cae45.filterSensitiveLog(obj.Filter)
        });
    };
})($0c0d1970b55e47a3$export$908bafa154008a5e || ($0c0d1970b55e47a3$export$908bafa154008a5e = {}));
var $0c0d1970b55e47a3$export$a52baffc56d738d2;
(function(GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $0c0d1970b55e47a3$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$a52baffc56d738d2 || ($0c0d1970b55e47a3$export$a52baffc56d738d2 = {}));
var $0c0d1970b55e47a3$export$af907f7627ae4ae9;
(function(GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$af907f7627ae4ae9 || ($0c0d1970b55e47a3$export$af907f7627ae4ae9 = {}));
var $0c0d1970b55e47a3$export$f00ac87a35076252;
(function(GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f00ac87a35076252 || ($0c0d1970b55e47a3$export$f00ac87a35076252 = {}));
var $0c0d1970b55e47a3$export$74fc6120f048b9bc;
(function(FilterRule) {
    FilterRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$74fc6120f048b9bc || ($0c0d1970b55e47a3$export$74fc6120f048b9bc = {}));
var $0c0d1970b55e47a3$export$46101b74c47ec83a;
(function(S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$46101b74c47ec83a || ($0c0d1970b55e47a3$export$46101b74c47ec83a = {}));
var $0c0d1970b55e47a3$export$c3d4fc0e09105ced;
(function(NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c3d4fc0e09105ced || ($0c0d1970b55e47a3$export$c3d4fc0e09105ced = {}));
var $0c0d1970b55e47a3$export$4916e52bc544d4ef;
(function(LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4916e52bc544d4ef || ($0c0d1970b55e47a3$export$4916e52bc544d4ef = {}));
var $0c0d1970b55e47a3$export$b48f9efe98802c25;
(function(QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b48f9efe98802c25 || ($0c0d1970b55e47a3$export$b48f9efe98802c25 = {}));
var $0c0d1970b55e47a3$export$c98b07f3d2e31343;
(function(TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c98b07f3d2e31343 || ($0c0d1970b55e47a3$export$c98b07f3d2e31343 = {}));
var $0c0d1970b55e47a3$export$165cf006a6abc4b3;
(function(NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$165cf006a6abc4b3 || ($0c0d1970b55e47a3$export$165cf006a6abc4b3 = {}));
var $0c0d1970b55e47a3$export$403b2dc6ec5b8d13;
(function(OwnershipControlsRule) {
    OwnershipControlsRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$403b2dc6ec5b8d13 || ($0c0d1970b55e47a3$export$403b2dc6ec5b8d13 = {}));
var $0c0d1970b55e47a3$export$ae516ccf061cd7d1;
(function(OwnershipControls) {
    OwnershipControls.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ae516ccf061cd7d1 || ($0c0d1970b55e47a3$export$ae516ccf061cd7d1 = {}));
var $0c0d1970b55e47a3$export$bb1e71315d618124;
(function(GetBucketOwnershipControlsOutput) {
    GetBucketOwnershipControlsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$bb1e71315d618124 || ($0c0d1970b55e47a3$export$bb1e71315d618124 = {}));
var $0c0d1970b55e47a3$export$55fbc6554b27a2f6;
(function(GetBucketOwnershipControlsRequest) {
    GetBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$55fbc6554b27a2f6 || ($0c0d1970b55e47a3$export$55fbc6554b27a2f6 = {}));
var $0c0d1970b55e47a3$export$29a8c95926d10996;
(function(GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$29a8c95926d10996 || ($0c0d1970b55e47a3$export$29a8c95926d10996 = {}));
var $0c0d1970b55e47a3$export$fde59d57a80f46c6;
(function(GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$fde59d57a80f46c6 || ($0c0d1970b55e47a3$export$fde59d57a80f46c6 = {}));
var $0c0d1970b55e47a3$export$77c4d21e3fd2b633;
(function(PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$77c4d21e3fd2b633 || ($0c0d1970b55e47a3$export$77c4d21e3fd2b633 = {}));
var $0c0d1970b55e47a3$export$c9cb93f92e1c4228;
(function(GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c9cb93f92e1c4228 || ($0c0d1970b55e47a3$export$c9cb93f92e1c4228 = {}));
var $0c0d1970b55e47a3$export$2e3b292047386a35;
(function(GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2e3b292047386a35 || ($0c0d1970b55e47a3$export$2e3b292047386a35 = {}));
var $0c0d1970b55e47a3$export$594f35c535ed76a3;
(function(DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$594f35c535ed76a3 || ($0c0d1970b55e47a3$export$594f35c535ed76a3 = {}));
var $0c0d1970b55e47a3$export$949641a4ad7f11d4;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$949641a4ad7f11d4 || ($0c0d1970b55e47a3$export$949641a4ad7f11d4 = {}));
var $0c0d1970b55e47a3$export$d9823a04d7ef0d38;
(function(ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d9823a04d7ef0d38 || ($0c0d1970b55e47a3$export$d9823a04d7ef0d38 = {}));
var $0c0d1970b55e47a3$export$ed9166ec0f465b5e;
(function(Metrics) {
    Metrics.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ed9166ec0f465b5e || ($0c0d1970b55e47a3$export$ed9166ec0f465b5e = {}));
var $0c0d1970b55e47a3$export$666325b7ed44b812;
(function(ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$666325b7ed44b812 || ($0c0d1970b55e47a3$export$666325b7ed44b812 = {}));
var $0c0d1970b55e47a3$export$5c4bdf44e1e9cea1;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$5c4bdf44e1e9cea1 || ($0c0d1970b55e47a3$export$5c4bdf44e1e9cea1 = {}));
var $0c0d1970b55e47a3$export$18e0c6d9cc0aaef5;
(function(ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$18e0c6d9cc0aaef5 || ($0c0d1970b55e47a3$export$18e0c6d9cc0aaef5 = {}));
var $0c0d1970b55e47a3$export$f149404143b7fc4f;
(function(ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f149404143b7fc4f || ($0c0d1970b55e47a3$export$f149404143b7fc4f = {}));
var $0c0d1970b55e47a3$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    ReplicationRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $0c0d1970b55e47a3$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $0c0d1970b55e47a3$export$f149404143b7fc4f.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($0c0d1970b55e47a3$export$c5652b893758d9eb || ($0c0d1970b55e47a3$export$c5652b893758d9eb = {}));
var $0c0d1970b55e47a3$export$79ea81eaeed7f3c8;
(function(ReplicaModifications) {
    ReplicaModifications.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$79ea81eaeed7f3c8 || ($0c0d1970b55e47a3$export$79ea81eaeed7f3c8 = {}));
var $0c0d1970b55e47a3$export$d6dbaa0624096385;
(function(SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d6dbaa0624096385 || ($0c0d1970b55e47a3$export$d6dbaa0624096385 = {}));
var $0c0d1970b55e47a3$export$8f4bdf07a780e3ac;
(function(SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8f4bdf07a780e3ac || ($0c0d1970b55e47a3$export$8f4bdf07a780e3ac = {}));
var $0c0d1970b55e47a3$export$4ef0a2a837294f64;
(function(ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Filter && {
            Filter: $0c0d1970b55e47a3$export$c5652b893758d9eb.filterSensitiveLog(obj.Filter)
        });
    };
})($0c0d1970b55e47a3$export$4ef0a2a837294f64 || ($0c0d1970b55e47a3$export$4ef0a2a837294f64 = {}));
var $0c0d1970b55e47a3$export$74f8efd37d5209b2;
(function(ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $0c0d1970b55e47a3$export$4ef0a2a837294f64.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$74f8efd37d5209b2 || ($0c0d1970b55e47a3$export$74f8efd37d5209b2 = {}));
var $0c0d1970b55e47a3$export$8ec47a87cc54e339;
(function(GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $0c0d1970b55e47a3$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$8ec47a87cc54e339 || ($0c0d1970b55e47a3$export$8ec47a87cc54e339 = {}));
var $0c0d1970b55e47a3$export$e8f64af8ca33bbfd;
(function(GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e8f64af8ca33bbfd || ($0c0d1970b55e47a3$export$e8f64af8ca33bbfd = {}));
var $0c0d1970b55e47a3$export$8b846c4a43a75e9e;
(function(GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8b846c4a43a75e9e || ($0c0d1970b55e47a3$export$8b846c4a43a75e9e = {}));
var $0c0d1970b55e47a3$export$a3b6600fe888f873;
(function(GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a3b6600fe888f873 || ($0c0d1970b55e47a3$export$a3b6600fe888f873 = {}));
var $0c0d1970b55e47a3$export$b794c693046ccc37;
(function(GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b794c693046ccc37 || ($0c0d1970b55e47a3$export$b794c693046ccc37 = {}));
var $0c0d1970b55e47a3$export$4cb4643c20453b75;
(function(GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4cb4643c20453b75 || ($0c0d1970b55e47a3$export$4cb4643c20453b75 = {}));
var $0c0d1970b55e47a3$export$6f458e80d9a168b;
(function(GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6f458e80d9a168b || ($0c0d1970b55e47a3$export$6f458e80d9a168b = {}));
var $0c0d1970b55e47a3$export$199936fd6251213c;
(function(GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$199936fd6251213c || ($0c0d1970b55e47a3$export$199936fd6251213c = {}));
var $0c0d1970b55e47a3$export$4afca95d558fb444;
(function(ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4afca95d558fb444 || ($0c0d1970b55e47a3$export$4afca95d558fb444 = {}));
var $0c0d1970b55e47a3$export$c07750ef20ad8d6c;
(function(IndexDocument) {
    IndexDocument.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c07750ef20ad8d6c || ($0c0d1970b55e47a3$export$c07750ef20ad8d6c = {}));
var $0c0d1970b55e47a3$export$98dc4d8bbaac5b7c;
(function(RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$98dc4d8bbaac5b7c || ($0c0d1970b55e47a3$export$98dc4d8bbaac5b7c = {}));
var $0c0d1970b55e47a3$export$fcea0b2db26e6b18;
(function(Condition) {
    Condition.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$fcea0b2db26e6b18 || ($0c0d1970b55e47a3$export$fcea0b2db26e6b18 = {}));
var $0c0d1970b55e47a3$export$2d8d895a0a0f636e;
(function(Redirect) {
    Redirect.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2d8d895a0a0f636e || ($0c0d1970b55e47a3$export$2d8d895a0a0f636e = {}));
var $0c0d1970b55e47a3$export$6464c2c4399038e2;
(function(RoutingRule) {
    RoutingRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6464c2c4399038e2 || ($0c0d1970b55e47a3$export$6464c2c4399038e2 = {}));
var $0c0d1970b55e47a3$export$4632dcd1018fd6bd;
(function(GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4632dcd1018fd6bd || ($0c0d1970b55e47a3$export$4632dcd1018fd6bd = {}));
var $0c0d1970b55e47a3$export$b51e2df1df27d690;
(function(GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b51e2df1df27d690 || ($0c0d1970b55e47a3$export$b51e2df1df27d690 = {}));
var $0c0d1970b55e47a3$export$9fb6bec1a5c954d6;
(function(GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$9fb6bec1a5c954d6 || ($0c0d1970b55e47a3$export$9fb6bec1a5c954d6 = {}));
var $0c0d1970b55e47a3$export$3373ea9743883feb;
(function(GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$3373ea9743883feb || ($0c0d1970b55e47a3$export$3373ea9743883feb = {}));
var $0c0d1970b55e47a3$export$6424f05126e7daf8;
(function(InvalidObjectState) {
    InvalidObjectState.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6424f05126e7daf8 || ($0c0d1970b55e47a3$export$6424f05126e7daf8 = {}));
var $0c0d1970b55e47a3$export$1f6f8c73c651f3ca;
(function(NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$1f6f8c73c651f3ca || ($0c0d1970b55e47a3$export$1f6f8c73c651f3ca = {}));
var $0c0d1970b55e47a3$export$7c40a2227fecdc12;
(function(GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$7c40a2227fecdc12 || ($0c0d1970b55e47a3$export$7c40a2227fecdc12 = {}));
var $0c0d1970b55e47a3$export$cb1a4ad2e0f38f95;
(function(GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$cb1a4ad2e0f38f95 || ($0c0d1970b55e47a3$export$cb1a4ad2e0f38f95 = {}));
var $0c0d1970b55e47a3$export$f3dff23941310d9;
(function(ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f3dff23941310d9 || ($0c0d1970b55e47a3$export$f3dff23941310d9 = {}));
var $0c0d1970b55e47a3$export$9939dc80bbea1acd;
(function(GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$9939dc80bbea1acd || ($0c0d1970b55e47a3$export$9939dc80bbea1acd = {}));
var $0c0d1970b55e47a3$export$5f8862ba76850511;
(function(GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$5f8862ba76850511 || ($0c0d1970b55e47a3$export$5f8862ba76850511 = {}));
var $0c0d1970b55e47a3$export$705dac3c9e25f673;
(function(DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$705dac3c9e25f673 || ($0c0d1970b55e47a3$export$705dac3c9e25f673 = {}));
var $0c0d1970b55e47a3$export$62ac1d02f31163e0;
(function(ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$62ac1d02f31163e0 || ($0c0d1970b55e47a3$export$62ac1d02f31163e0 = {}));
var $0c0d1970b55e47a3$export$262d239426342c96;
(function(ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$262d239426342c96 || ($0c0d1970b55e47a3$export$262d239426342c96 = {}));
var $0c0d1970b55e47a3$export$486dc804d3714e8e;
(function(GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$486dc804d3714e8e || ($0c0d1970b55e47a3$export$486dc804d3714e8e = {}));
var $0c0d1970b55e47a3$export$43efa1cb9cbd5c84;
(function(GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$43efa1cb9cbd5c84 || ($0c0d1970b55e47a3$export$43efa1cb9cbd5c84 = {}));
var $0c0d1970b55e47a3$export$a0bcf720e4ebfa6b;
(function(ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a0bcf720e4ebfa6b || ($0c0d1970b55e47a3$export$a0bcf720e4ebfa6b = {}));
var $0c0d1970b55e47a3$export$5a061f69fa492eee;
(function(GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$5a061f69fa492eee || ($0c0d1970b55e47a3$export$5a061f69fa492eee = {}));
var $0c0d1970b55e47a3$export$bd618fd4d0be1150;
(function(GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$bd618fd4d0be1150 || ($0c0d1970b55e47a3$export$bd618fd4d0be1150 = {}));
var $0c0d1970b55e47a3$export$21e84ade4ffc813f;
(function(GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$21e84ade4ffc813f || ($0c0d1970b55e47a3$export$21e84ade4ffc813f = {}));
var $0c0d1970b55e47a3$export$e8c3f2a82ba22432;
(function(GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e8c3f2a82ba22432 || ($0c0d1970b55e47a3$export$e8c3f2a82ba22432 = {}));
var $0c0d1970b55e47a3$export$c7be7807f0a3eea;
(function(GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c7be7807f0a3eea || ($0c0d1970b55e47a3$export$c7be7807f0a3eea = {}));
var $0c0d1970b55e47a3$export$93e32e1b0e5460eb;
(function(GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$93e32e1b0e5460eb || ($0c0d1970b55e47a3$export$93e32e1b0e5460eb = {}));
var $0c0d1970b55e47a3$export$d5abbb05d727be20;
(function(PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d5abbb05d727be20 || ($0c0d1970b55e47a3$export$d5abbb05d727be20 = {}));
var $0c0d1970b55e47a3$export$3606af58a9ffe87;
(function(GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3606af58a9ffe87 || ($0c0d1970b55e47a3$export$3606af58a9ffe87 = {}));
var $0c0d1970b55e47a3$export$f768b28d574460bb;
(function(GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f768b28d574460bb || ($0c0d1970b55e47a3$export$f768b28d574460bb = {}));
var $0c0d1970b55e47a3$export$ce473fe6d5e62bdd;
(function(HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ce473fe6d5e62bdd || ($0c0d1970b55e47a3$export$ce473fe6d5e62bdd = {}));
var $0c0d1970b55e47a3$export$bbe89283205bd874;
(function(NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$bbe89283205bd874 || ($0c0d1970b55e47a3$export$bbe89283205bd874 = {}));
var $0c0d1970b55e47a3$export$fd185f7330520684;
(function(HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$fd185f7330520684 || ($0c0d1970b55e47a3$export$fd185f7330520684 = {}));
var $0c0d1970b55e47a3$export$e9eaca65791fc4c;
(function(HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$e9eaca65791fc4c || ($0c0d1970b55e47a3$export$e9eaca65791fc4c = {}));
var $0c0d1970b55e47a3$export$cccced7f72820034;
(function(ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfigurationList && {
            AnalyticsConfigurationList: obj.AnalyticsConfigurationList.map(function(item) {
                return $0c0d1970b55e47a3$export$15f94404a081a771.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$cccced7f72820034 || ($0c0d1970b55e47a3$export$cccced7f72820034 = {}));
var $0c0d1970b55e47a3$export$397b8f33cb9cfc07;
(function(ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$397b8f33cb9cfc07 || ($0c0d1970b55e47a3$export$397b8f33cb9cfc07 = {}));
var $0c0d1970b55e47a3$export$b33d88b03a3d62f7;
(function(ListBucketIntelligentTieringConfigurationsOutput) {
    ListBucketIntelligentTieringConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b33d88b03a3d62f7 || ($0c0d1970b55e47a3$export$b33d88b03a3d62f7 = {}));
var $0c0d1970b55e47a3$export$8bc390bdd26b4fe7;
(function(ListBucketIntelligentTieringConfigurationsRequest) {
    ListBucketIntelligentTieringConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8bc390bdd26b4fe7 || ($0c0d1970b55e47a3$export$8bc390bdd26b4fe7 = {}));
var $0c0d1970b55e47a3$export$9e6dae27db161fe4;
(function(ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
                return $0c0d1970b55e47a3$export$e13e8ea2fe7b5717.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$9e6dae27db161fe4 || ($0c0d1970b55e47a3$export$9e6dae27db161fe4 = {}));
var $0c0d1970b55e47a3$export$443f8cd22179a9b7;
(function(ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$443f8cd22179a9b7 || ($0c0d1970b55e47a3$export$443f8cd22179a9b7 = {}));
var $0c0d1970b55e47a3$export$a94e91ae224bc393;
(function(ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.MetricsConfigurationList && {
            MetricsConfigurationList: obj.MetricsConfigurationList.map(function(item) {
                return $0c0d1970b55e47a3$export$908bafa154008a5e.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$a94e91ae224bc393 || ($0c0d1970b55e47a3$export$a94e91ae224bc393 = {}));
var $0c0d1970b55e47a3$export$18bea5a661e91351;
(function(ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$18bea5a661e91351 || ($0c0d1970b55e47a3$export$18bea5a661e91351 = {}));
var $0c0d1970b55e47a3$export$356eb44c374cfc19;
(function(Bucket) {
    Bucket.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$356eb44c374cfc19 || ($0c0d1970b55e47a3$export$356eb44c374cfc19 = {}));
var $0c0d1970b55e47a3$export$fb68aea51fc1aaa8;
(function(ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$fb68aea51fc1aaa8 || ($0c0d1970b55e47a3$export$fb68aea51fc1aaa8 = {}));
var $0c0d1970b55e47a3$export$70a8419756bd30c7;
(function(CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$70a8419756bd30c7 || ($0c0d1970b55e47a3$export$70a8419756bd30c7 = {}));
var $0c0d1970b55e47a3$export$f2cea2a27584e4aa;
(function(Initiator) {
    Initiator.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f2cea2a27584e4aa || ($0c0d1970b55e47a3$export$f2cea2a27584e4aa = {}));
var $0c0d1970b55e47a3$export$60e639cfe2512bff;
(function(MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$60e639cfe2512bff || ($0c0d1970b55e47a3$export$60e639cfe2512bff = {}));
var $0c0d1970b55e47a3$export$ed83d15740b9f76d;
(function(ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ed83d15740b9f76d || ($0c0d1970b55e47a3$export$ed83d15740b9f76d = {}));
var $0c0d1970b55e47a3$export$d96c3e2cf9803f5e;
(function(ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d96c3e2cf9803f5e || ($0c0d1970b55e47a3$export$d96c3e2cf9803f5e = {}));
var $0c0d1970b55e47a3$export$dcacc4a8f6015c36;
(function(_Object) {
    _Object.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$dcacc4a8f6015c36 || ($0c0d1970b55e47a3$export$dcacc4a8f6015c36 = {}));
var $0c0d1970b55e47a3$export$bd5de99c03e50bdf;
(function(ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$bd5de99c03e50bdf || ($0c0d1970b55e47a3$export$bd5de99c03e50bdf = {}));
var $0c0d1970b55e47a3$export$b17e2bd91a04aa76;
(function(ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b17e2bd91a04aa76 || ($0c0d1970b55e47a3$export$b17e2bd91a04aa76 = {}));
var $0c0d1970b55e47a3$export$6fb2827b4fe28be3;
(function(ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$6fb2827b4fe28be3 || ($0c0d1970b55e47a3$export$6fb2827b4fe28be3 = {}));
var $0c0d1970b55e47a3$export$32fa6adfa8e5165a;
(function(ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$32fa6adfa8e5165a || ($0c0d1970b55e47a3$export$32fa6adfa8e5165a = {}));
var $0c0d1970b55e47a3$export$a834fe68df71f671;
(function(DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a834fe68df71f671 || ($0c0d1970b55e47a3$export$a834fe68df71f671 = {}));
var $0c0d1970b55e47a3$export$3288b5b55ddbb34f;
(function(ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3288b5b55ddbb34f || ($0c0d1970b55e47a3$export$3288b5b55ddbb34f = {}));
var $0c0d1970b55e47a3$export$4037923dade2a143;
(function(ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4037923dade2a143 || ($0c0d1970b55e47a3$export$4037923dade2a143 = {}));
var $0c0d1970b55e47a3$export$7420470087543a24;
(function(ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$7420470087543a24 || ($0c0d1970b55e47a3$export$7420470087543a24 = {}));
var $0c0d1970b55e47a3$export$7b5bf7981d51054e;
(function(Part) {
    Part.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$7b5bf7981d51054e || ($0c0d1970b55e47a3$export$7b5bf7981d51054e = {}));
var $0c0d1970b55e47a3$export$8c83b46649a5c089;
(function(ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8c83b46649a5c089 || ($0c0d1970b55e47a3$export$8c83b46649a5c089 = {}));
var $0c0d1970b55e47a3$export$756cf37efa2403e6;
(function(ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$756cf37efa2403e6 || ($0c0d1970b55e47a3$export$756cf37efa2403e6 = {}));
var $0c0d1970b55e47a3$export$95f02e50cfd87383;
(function(PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$95f02e50cfd87383 || ($0c0d1970b55e47a3$export$95f02e50cfd87383 = {}));
var $0c0d1970b55e47a3$export$15919ea85d7751db;
(function(PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$15919ea85d7751db || ($0c0d1970b55e47a3$export$15919ea85d7751db = {}));
var $0c0d1970b55e47a3$export$b29e71de1c43092d;
(function(PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $0c0d1970b55e47a3$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$b29e71de1c43092d || ($0c0d1970b55e47a3$export$b29e71de1c43092d = {}));
var $0c0d1970b55e47a3$export$4efc44a8f577c4c6;
(function(CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$4efc44a8f577c4c6 || ($0c0d1970b55e47a3$export$4efc44a8f577c4c6 = {}));
var $0c0d1970b55e47a3$export$48388c72802bf3b4;
(function(PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$48388c72802bf3b4 || ($0c0d1970b55e47a3$export$48388c72802bf3b4 = {}));
var $0c0d1970b55e47a3$export$b9464fee92783639;
(function(PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $0c0d1970b55e47a3$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$b9464fee92783639 || ($0c0d1970b55e47a3$export$b9464fee92783639 = {}));
var $0c0d1970b55e47a3$export$8ecc19836abd960;
(function(PutBucketIntelligentTieringConfigurationRequest) {
    PutBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$8ecc19836abd960 || ($0c0d1970b55e47a3$export$8ecc19836abd960 = {}));
var $0c0d1970b55e47a3$export$7bce979f7abe4f73;
(function(PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $0c0d1970b55e47a3$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$7bce979f7abe4f73 || ($0c0d1970b55e47a3$export$7bce979f7abe4f73 = {}));
var $0c0d1970b55e47a3$export$2bad5a8856023522;
(function(BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $0c0d1970b55e47a3$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($0c0d1970b55e47a3$export$2bad5a8856023522 || ($0c0d1970b55e47a3$export$2bad5a8856023522 = {}));
var $0c0d1970b55e47a3$export$b1f1a3c5136805f6;
(function(PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.LifecycleConfiguration && {
            LifecycleConfiguration: $0c0d1970b55e47a3$export$2bad5a8856023522.filterSensitiveLog(obj.LifecycleConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$b1f1a3c5136805f6 || ($0c0d1970b55e47a3$export$b1f1a3c5136805f6 = {}));
var $0c0d1970b55e47a3$export$c183b06f38322f46;
(function(BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$c183b06f38322f46 || ($0c0d1970b55e47a3$export$c183b06f38322f46 = {}));
var $0c0d1970b55e47a3$export$b7513dc0595a23bf;
(function(PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b7513dc0595a23bf || ($0c0d1970b55e47a3$export$b7513dc0595a23bf = {}));
var $0c0d1970b55e47a3$export$848d3e19e2b6526f;
(function(PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $0c0d1970b55e47a3$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$848d3e19e2b6526f || ($0c0d1970b55e47a3$export$848d3e19e2b6526f = {}));
var $0c0d1970b55e47a3$export$832249f88bdec051;
(function(PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$832249f88bdec051 || ($0c0d1970b55e47a3$export$832249f88bdec051 = {}));
var $0c0d1970b55e47a3$export$dd5b80748bfa876c;
(function(PutBucketOwnershipControlsRequest) {
    PutBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$dd5b80748bfa876c || ($0c0d1970b55e47a3$export$dd5b80748bfa876c = {}));
var $0c0d1970b55e47a3$export$a3745e522d5251e6;
(function(PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a3745e522d5251e6 || ($0c0d1970b55e47a3$export$a3745e522d5251e6 = {}));
var $0c0d1970b55e47a3$export$80d3d606687bccbe;
(function(PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $0c0d1970b55e47a3$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($0c0d1970b55e47a3$export$80d3d606687bccbe || ($0c0d1970b55e47a3$export$80d3d606687bccbe = {}));
var $0c0d1970b55e47a3$export$5b5564785205c8b6;
(function(RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$5b5564785205c8b6 || ($0c0d1970b55e47a3$export$5b5564785205c8b6 = {}));
var $0c0d1970b55e47a3$export$efe882c45e4d54c5;
(function(PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$efe882c45e4d54c5 || ($0c0d1970b55e47a3$export$efe882c45e4d54c5 = {}));
var $0c0d1970b55e47a3$export$2c6436847badca04;
(function(Tagging) {
    Tagging.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$2c6436847badca04 || ($0c0d1970b55e47a3$export$2c6436847badca04 = {}));
var $0c0d1970b55e47a3$export$907025fe881c3d35;
(function(PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$907025fe881c3d35 || ($0c0d1970b55e47a3$export$907025fe881c3d35 = {}));
var $0c0d1970b55e47a3$export$12496b4e466310a9;
(function(VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$12496b4e466310a9 || ($0c0d1970b55e47a3$export$12496b4e466310a9 = {}));
var $0c0d1970b55e47a3$export$b342a4ff3cacc8f6;
(function(PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$b342a4ff3cacc8f6 || ($0c0d1970b55e47a3$export$b342a4ff3cacc8f6 = {}));
var $0c0d1970b55e47a3$export$aec172fe960d640d;
(function(WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$aec172fe960d640d || ($0c0d1970b55e47a3$export$aec172fe960d640d = {}));
var $0c0d1970b55e47a3$export$98e48334698c13d8;
(function(PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$98e48334698c13d8 || ($0c0d1970b55e47a3$export$98e48334698c13d8 = {}));
var $0c0d1970b55e47a3$export$792cedced515bdbd;
(function(PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$792cedced515bdbd || ($0c0d1970b55e47a3$export$792cedced515bdbd = {}));
var $0c0d1970b55e47a3$export$90c5c1bf0f634d21;
(function(PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$90c5c1bf0f634d21 || ($0c0d1970b55e47a3$export$90c5c1bf0f634d21 = {}));
var $0c0d1970b55e47a3$export$e533775617728d56;
(function(PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e533775617728d56 || ($0c0d1970b55e47a3$export$e533775617728d56 = {}));
var $0c0d1970b55e47a3$export$3dc01ad48475bf08;
(function(PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$3dc01ad48475bf08 || ($0c0d1970b55e47a3$export$3dc01ad48475bf08 = {}));
var $0c0d1970b55e47a3$export$d9144478e705d522;
(function(PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d9144478e705d522 || ($0c0d1970b55e47a3$export$d9144478e705d522 = {}));
var $0c0d1970b55e47a3$export$71c3c7a041df44ca;
(function(PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$71c3c7a041df44ca || ($0c0d1970b55e47a3$export$71c3c7a041df44ca = {}));
var $0c0d1970b55e47a3$export$93f296cba8bc1760;
(function(PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$93f296cba8bc1760 || ($0c0d1970b55e47a3$export$93f296cba8bc1760 = {}));
var $0c0d1970b55e47a3$export$693145724507a617;
(function(PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$693145724507a617 || ($0c0d1970b55e47a3$export$693145724507a617 = {}));
var $0c0d1970b55e47a3$export$edd40f596f5fa31e;
(function(PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$edd40f596f5fa31e || ($0c0d1970b55e47a3$export$edd40f596f5fa31e = {}));
var $0c0d1970b55e47a3$export$117e9cab66df5006;
(function(PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$117e9cab66df5006 || ($0c0d1970b55e47a3$export$117e9cab66df5006 = {}));
var $0c0d1970b55e47a3$export$d9e3a7e4f51c31d5;
(function(PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$d9e3a7e4f51c31d5 || ($0c0d1970b55e47a3$export$d9e3a7e4f51c31d5 = {}));
var $0c0d1970b55e47a3$export$f5517f211c9a0baf;
(function(PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$f5517f211c9a0baf || ($0c0d1970b55e47a3$export$f5517f211c9a0baf = {}));
var $0c0d1970b55e47a3$export$11868106b24a9ab0;
(function(PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$11868106b24a9ab0 || ($0c0d1970b55e47a3$export$11868106b24a9ab0 = {}));
var $0c0d1970b55e47a3$export$a97e3c65be291319;
(function(ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$a97e3c65be291319 || ($0c0d1970b55e47a3$export$a97e3c65be291319 = {}));
var $0c0d1970b55e47a3$export$ee3cf9307c2a87ae;
(function(RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$ee3cf9307c2a87ae || ($0c0d1970b55e47a3$export$ee3cf9307c2a87ae = {}));
var $0c0d1970b55e47a3$export$e9e40009732846c;
(function(GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($0c0d1970b55e47a3$export$e9e40009732846c || ($0c0d1970b55e47a3$export$e9e40009732846c = {}));
var $0c0d1970b55e47a3$export$d60a27d0da10cee5;
(function(Encryption) {
    Encryption.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.KMSKeyId && {
            KMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($0c0d1970b55e47a3$export$d60a27d0da10cee5 || ($0c0d1970b55e47a3$export$d60a27d0da10cee5 = {}));







var $2R3UW = parcelRequire("2R3UW");
/**
 * Escapes characters that can not be in an XML attribute.
 */ function $d03c75b2e0d0853a$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}


/**
 * Represents an XML node.
 */ var $d84d4d9496a1e020$export$e775a15d806cbddc = /** @class */ function() {
    function XmlNode(name, children) {
        if (children === void 0) children = [];
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.withName = function(name) {
        this.name = name;
        return this;
    };
    XmlNode.prototype.addAttribute = function(name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function(child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function(name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function() {
        var e_1, _a;
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        try {
            for(var _b = (0, $2R3UW.__values)(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var attributeName = _c.value;
                var attribute = attributes[attributeName];
                if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + "=\"" + (0, $d03c75b2e0d0853a$export$30330f3d5eb70e11)("" + attribute) + "\"";
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
            return c.toString();
        }).join("") + "</" + this.name + ">";
    };
    return XmlNode;
}();


/**
 * Escapes characters that can not be in an XML element.
 */ function $1fd1510fcfdf7c76$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * Represents an XML text value.
 */ var $764de912faeee494$export$b35b8f45887823df = /** @class */ function() {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function() {
        return (0, $1fd1510fcfdf7c76$export$e5104ffd394b43ec)("" + this.value);
    };
    return XmlText;
}();




var $ba664335f27bea63$export$98e6a39c04603d36;
var $ba664335f27bea63$export$e4f0b40d01c251ab;
var $ba664335f27bea63$export$2ca3eb0a2f8a693a;
var $ba664335f27bea63$export$e31c2b05678acf26;
var $ba664335f27bea63$export$54ffaacfc0931fb0;
var $ba664335f27bea63$export$a22775fa5e2eebd9;
var $ba664335f27bea63$export$30384b60aedf98a5;
var $ba664335f27bea63$export$3a5cfc971f52ee31;
'use strict';
var $cb786f1b68dfff20$export$e31c2b05678acf26;
'use strict';

var $jfqRo = parcelRequire("jfqRo");
const $cb786f1b68dfff20$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if (!options.alwaysCreateTextNode && (!node.child || $jfqRo.isEmptyObject(node.child)) && (!node.attrsMap || $jfqRo.isEmptyObject(node.attrsMap))) return $jfqRo.isExist(node.val) ? node.val : '';
    // otherwise create a textnode if node has some text
    if ($jfqRo.isExist(node.val) && !(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
        const asArray = $jfqRo.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $jfqRo.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($cb786f1b68dfff20$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $cb786f1b68dfff20$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === 'object' || $jfqRo.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$cb786f1b68dfff20$export$e31c2b05678acf26 = $cb786f1b68dfff20$var$convertToJson;



var $a9fXZ = parcelRequire("a9fXZ");

var $a9fXZ = parcelRequire("a9fXZ");

var $jfqRo = parcelRequire("jfqRo");
var $ba664335f27bea63$require$buildOptions = $jfqRo.buildOptions;
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $85b785e65e0bcef9$export$a22775fa5e2eebd9;
'use strict';

var $jfqRo = parcelRequire("jfqRo");
const $85b785e65e0bcef9$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $85b785e65e0bcef9$var$props = [
    'allowBooleanAttributes'
];
$85b785e65e0bcef9$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $jfqRo.buildOptions(options, $85b785e65e0bcef9$var$defaultOptions, $85b785e65e0bcef9$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $85b785e65e0bcef9$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $85b785e65e0bcef9$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$85b785e65e0bcef9$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $85b785e65e0bcef9$var$getErrorObject('InvalidTag', msg, $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $85b785e65e0bcef9$var$readAttributeStr(xmlData, i);
                if (result === false) return $85b785e65e0bcef9$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $85b785e65e0bcef9$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $85b785e65e0bcef9$var$getErrorObject(isValid.err.code, isValid.err.msg, $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $85b785e65e0bcef9$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $85b785e65e0bcef9$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $85b785e65e0bcef9$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $85b785e65e0bcef9$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $85b785e65e0bcef9$var$getErrorObject(isValid.err.code, isValid.err.msg, $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $85b785e65e0bcef9$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $85b785e65e0bcef9$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $85b785e65e0bcef9$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $85b785e65e0bcef9$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $85b785e65e0bcef9$var$getErrorObject('InvalidChar', "char '&' is not expected.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') continue;
            return $85b785e65e0bcef9$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $85b785e65e0bcef9$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $85b785e65e0bcef9$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $85b785e65e0bcef9$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $85b785e65e0bcef9$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $85b785e65e0bcef9$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $85b785e65e0bcef9$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $85b785e65e0bcef9$var$doubleQuote = '"';
const $85b785e65e0bcef9$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $85b785e65e0bcef9$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $85b785e65e0bcef9$var$doubleQuote || xmlData[i] === $85b785e65e0bcef9$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $85b785e65e0bcef9$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $85b785e65e0bcef9$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $jfqRo.getAllMatches(attrStr, $85b785e65e0bcef9$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $85b785e65e0bcef9$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $85b785e65e0bcef9$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $85b785e65e0bcef9$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $85b785e65e0bcef9$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$85b785e65e0bcef9$var$validateAttrName(attrName)) return $85b785e65e0bcef9$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $85b785e65e0bcef9$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $85b785e65e0bcef9$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $85b785e65e0bcef9$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $85b785e65e0bcef9$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $85b785e65e0bcef9$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $85b785e65e0bcef9$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $85b785e65e0bcef9$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $85b785e65e0bcef9$var$validateAttrName(attrName) {
    return $jfqRo.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $85b785e65e0bcef9$var$validateTagName(tagname) {
    return $jfqRo.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $85b785e65e0bcef9$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $85b785e65e0bcef9$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


$ba664335f27bea63$export$98e6a39c04603d36 = function(xmlData, givenOptions = {}, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $85b785e65e0bcef9$export$a22775fa5e2eebd9(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) givenOptions.numParseOptions = {
        leadingZeros: false
    };
    let options = $ba664335f27bea63$require$buildOptions(givenOptions, $a9fXZ.defaultOptions, $a9fXZ.props);
    const traversableObj = $a9fXZ.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $cb786f1b68dfff20$export$e31c2b05678acf26(traversableObj, options);
};

$ba664335f27bea63$export$e4f0b40d01c251ab = (parcelRequire("9jbE1")).convert2nimn;
$ba664335f27bea63$export$2ca3eb0a2f8a693a = $a9fXZ.getTraversalObj;
$ba664335f27bea63$export$e31c2b05678acf26 = $cb786f1b68dfff20$export$e31c2b05678acf26;

$ba664335f27bea63$export$54ffaacfc0931fb0 = (parcelRequire("b8ump")).convertToJsonString;
$ba664335f27bea63$export$a22775fa5e2eebd9 = $85b785e65e0bcef9$export$a22775fa5e2eebd9;

$ba664335f27bea63$export$30384b60aedf98a5 = (parcelRequire("hPBK7"));
$ba664335f27bea63$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $ba664335f27bea63$export$e4f0b40d01c251ab($ba664335f27bea63$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $ba664335f27bea63$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
        if (xmlNode.parent) console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
        console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
        console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + "\"child\": {");
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + "\"" + key + "\" :[");
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $ba664335f27bea63$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + " \"" + key + "\" : {");
                    $ba664335f27bea63$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}


var $90d6831a7e5c0072$export$a7d2d025c66f9235 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "AbortMultipartUpload"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$2a09fb9495f08c55 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.MultipartUpload !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3fa883360ffbe82d = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.MetadataDirective) && {
                        "x-amz-metadata-directive": input.MetadataDirective
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.TaggingDirective) && {
                        "x-amz-tagging-directive": input.TaggingDirective
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "CopyObject"
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ff9b8bd3304a2cc2 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
                        "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.CreateBucketConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4730de34492fdc2 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        uploads: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4c739e7bdecdc09e = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$1599103c79e9cc48 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$328eda7443168fa1 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a935f4341563a8e5 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c04145b770da67a8 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ea4a1894e3000c1a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ff5be01ded2fe32 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$f050fc1ef4eb3607 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9809275ad1405c95 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$d35e7f7cfb4671a8 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9a7bb1ffbd4a4abf = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$898454ff9153710a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$55003dd0346cc6e0 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$400c19cbac9616f7 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "DeleteObject"
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6867c23377cf4e18 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        delete: ""
                    };
                    if (input.Delete !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlDelete(input.Delete, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c5216ce889528f85 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6e75832e2b10791c = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$401fbb1296db6719 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$36598b1e884464d4 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4d648e59e03d69d2 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "GetBucketAnalyticsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c50cfec8b08a5bc7 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$59a2b88153b9bcd3 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$f5f10fa8975a8db2 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "intelligent-tiering": "",
                        "x-id": "GetBucketIntelligentTieringConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$27733aaa6f8bdfce = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "GetBucketInventoryConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a45e301366f2d4b7 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$57578b49828da279 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        location: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$fba64f4839ba2759 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$55cedf3b8782e93a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "GetBucketMetricsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$28aa3066de46a217 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8ff61553a991ad45 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9c4ddc2418c2498a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$5cc8b1c7c38eaa70 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policyStatus: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7bfb07297b27feda = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c40582f35b41168f = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7fe7f3d9e83c1258 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$33bb47afa1d36b = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$86d6bcc10cc7214f = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$713ae52666bf2204 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "GetObject"
                    }, input.ResponseCacheControl !== undefined && {
                        "response-cache-control": input.ResponseCacheControl
                    }), input.ResponseContentDisposition !== undefined && {
                        "response-content-disposition": input.ResponseContentDisposition
                    }), input.ResponseContentEncoding !== undefined && {
                        "response-content-encoding": input.ResponseContentEncoding
                    }), input.ResponseContentLanguage !== undefined && {
                        "response-content-language": input.ResponseContentLanguage
                    }), input.ResponseContentType !== undefined && {
                        "response-content-type": input.ResponseContentType
                    }), input.ResponseExpires !== undefined && {
                        "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$915aba65107b1e0b = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9c08e676bdd74a0 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6b8bcfdbd9049617 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$73761af73f60c98c = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9eb633d3ed47ffa4 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$19b09331a932f5f6 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        torrent: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$96bfd3c7dd0a4d0a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$33042663db00ac59 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7d02887d047f6825 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$1af1bbf8ced1a360 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "ListBucketAnalyticsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$471f09a61710187f = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "intelligent-tiering": "",
                        "x-id": "ListBucketIntelligentTieringConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$84049d82728011d8 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "ListBucketInventoryConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4386fb1e1f56eefe = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "ListBucketMetricsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$94ca891f34564e01 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/";
                    body = "";
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$67092c8b2bd6afb9 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        uploads: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxUploads !== undefined && {
                        "max-uploads": input.MaxUploads.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.UploadIdMarker !== undefined && {
                        "upload-id-marker": input.UploadIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$acd8b176cbc51cb9 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.Marker !== undefined && {
                        marker: input.Marker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ea6ee77e40f86bd9 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "list-type": "2"
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    }), input.FetchOwner !== undefined && {
                        "fetch-owner": input.FetchOwner.toString()
                    }), input.StartAfter !== undefined && {
                        "start-after": input.StartAfter
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e9deb593aaba1069 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        versions: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.VersionIdMarker !== undefined && {
                        "version-id-marker": input.VersionIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$b2b39cf3937e8c76 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "ListParts"
                    }, input.MaxParts !== undefined && {
                        "max-parts": input.MaxParts.toString()
                    }), input.PartNumberMarker !== undefined && {
                        "part-number-marker": input.PartNumberMarker
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4d770bb452c6d670 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    if (input.AccelerateConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$415e832013d5f94b = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$82791d7115b07b04 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.AnalyticsConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c86e5c4d1766d14 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    if (input.CORSConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c279f7b43c9bb310 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    if (input.ServerSideEncryptionConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c9101820ff6720b2 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/xml"
                    };
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.IntelligentTieringConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6d95946d99f43eaa = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.InventoryConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$70f4fe83400d730d = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    if (input.LifecycleConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$2426ada7dacc12b9 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    if (input.BucketLoggingStatus !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$dd9ccb6c86dc9b75 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.MetricsConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$cc9aba63382b97f4 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    if (input.NotificationConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$cd645fbb22474aad = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    if (input.OwnershipControls !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$46f7931bb495aaa = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "text/plain"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
                        "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    if (input.Policy !== undefined) {
                        contents = input.Policy;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$bc85604c47270690 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    if (input.ReplicationConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$d688e45835bb412b = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    if (input.RequestPaymentConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$fb33aa4addeb7925 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    if (input.Tagging !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$b2b33319a5c1fa1b = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    if (input.VersioningConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3684a013c739abf7 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    if (input.WebsiteConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6c3f9d82bec72a8d = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/octet-stream"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "PutObject"
                    };
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c5f7c1bb4a245310 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3cae5f4de1f7d8e0 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.LegalHold !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e85a5935e0b9ebcf = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    if (input.ObjectLockConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$401e449dfbceed84 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Retention !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockRetention(input.Retention, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c73061b6e5d6a95a = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Tagging !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9f1c307a4d5bd5b3 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    if (input.PublicAccessBlockConfiguration !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$99a912d071900c76 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        restore: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.RestoreRequest !== undefined) {
                        contents = $90d6831a7e5c0072$var$serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$47ebf91740d2ce6f = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/xml"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        select: "",
                        "select-type": "2"
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SelectObjectContentRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Expression !== undefined) {
                        node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Expression)).withName("Expression");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ExpressionType !== undefined) {
                        node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
                        bodyNode.addChildNode(node);
                    }
                    if (input.InputSerialization !== undefined) {
                        node = $90d6831a7e5c0072$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.OutputSerialization !== undefined) {
                        node = $90d6831a7e5c0072$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.RequestProgress !== undefined) {
                        node = $90d6831a7e5c0072$var$serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ScanRange !== undefined) {
                        node = $90d6831a7e5c0072$var$serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6dfc42032d3f37d4 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "content-type": "application/octet-stream"
                    }, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "UploadPart"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$90763da135bbc5f9 = function(input, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $8da7524b6eed4f00$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceRange) && {
                        "x-amz-copy-source-range": input.CopySourceRange
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $90d6831a7e5c0072$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b2af4e6928b4a23c$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
                        "x-id": "UploadPartCopy"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $56390c7aad80e533$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$87447564e9ee4b69 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ee5aaa25931389ce = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Key: undefined,
                        Location: undefined,
                        RequestCharged: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["ETag"] !== undefined) contents.ETag = data["ETag"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["Location"] !== undefined) contents.Location = data["Location"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a5d77c8b6651b993 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlCopyObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyObjectResult: undefined,
                        CopySourceVersionId: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyObjectResult = $90d6831a7e5c0072$var$deserializeAws_restXmlCopyObjectResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$b4e8f8f452bdb204 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlCreateBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Location: undefined
                    };
                    if (output.headers["location"] !== undefined) contents.Location = output.headers["location"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCreateBucketCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$95cf7bc6357ae5a8 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        Key: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c5d62536e1c56e82 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$820ce8b5969d2c78 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$dea26f8b4dad38ea = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketCorsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$48d65b1878f8cb7f = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$bfa9d8ef1df37dec = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$dc33768e2651b6cb = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$1660bb2bbec5b369 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ea7eb03b8f77dc6a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$649e1231e4f3b774 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$470e22ed3eb8b871 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketPolicyCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a8348308c83bfe9d = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketReplicationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8f5814a38b853d38 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$bc95350311fac763 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$987b292ae9f16665 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        DeleteMarker: undefined,
                        RequestCharged: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ebb9378c7c531fa5 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Deleted: undefined,
                        Errors: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Deleted === "") contents.Deleted = [];
                    if (data["Deleted"] !== undefined) contents.Deleted = $90d6831a7e5c0072$var$deserializeAws_restXmlDeletedObjects((0, $c532f6997c845207$export$52272e038712c64e)(data["Deleted"]), context);
                    if (data.Error === "") contents.Errors = [];
                    if (data["Error"] !== undefined) contents.Errors = $90d6831a7e5c0072$var$deserializeAws_restXmlErrors((0, $c532f6997c845207$export$52272e038712c64e)(data["Error"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7021ac5189f9792d = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteObjectTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$4cf24390776e8eb6 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$30393acaf6414a50 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$56e18e7cfcb102eb = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $90d6831a7e5c0072$var$deserializeAws_restXmlGrants((0, $c532f6997c845207$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAclCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8103ef82db64a4aa = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        AnalyticsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.AnalyticsConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$472fdec99155a887 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        CORSRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CORSRule === "") contents.CORSRules = [];
                    if (data["CORSRule"] !== undefined) contents.CORSRules = $90d6831a7e5c0072$var$deserializeAws_restXmlCORSRules((0, $c532f6997c845207$export$52272e038712c64e)(data["CORSRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketCorsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$d83d67d0bf5676cb = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ServerSideEncryptionConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ServerSideEncryptionConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketEncryptionCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3055c22f7a188cb2 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        IntelligentTieringConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.IntelligentTieringConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$cd1101fd9c222af8 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        InventoryConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.InventoryConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$b85a74c7951988c1 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Rules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Rule === "") contents.Rules = [];
                    if (data["Rule"] !== undefined) contents.Rules = $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRules((0, $c532f6997c845207$export$52272e038712c64e)(data["Rule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$d332d0a204c1f2de = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLocationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        LocationConstraint: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = data["LocationConstraint"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLocationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$99325a82aa21e152 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        LoggingEnabled: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $90d6831a7e5c0072$var$deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketLoggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$33f849a042e960f2 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        MetricsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.MetricsConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$f7ea4be33406a0a0 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        LambdaFunctionConfigurations: undefined,
                        QueueConfigurations: undefined,
                        TopicConfigurations: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
                    if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $90d6831a7e5c0072$var$deserializeAws_restXmlLambdaFunctionConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["CloudFunctionConfiguration"]), context);
                    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
                    if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $90d6831a7e5c0072$var$deserializeAws_restXmlQueueConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["QueueConfiguration"]), context);
                    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
                    if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $90d6831a7e5c0072$var$deserializeAws_restXmlTopicConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["TopicConfiguration"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e51b6b0868913b77 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        OwnershipControls: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.OwnershipControls = $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControls(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$74beb134589fee09 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Policy: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Policy"] !== undefined) contents.Policy = data["Policy"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketPolicyCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$bb27e87cf2face4 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        PolicyStatus: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PolicyStatus = $90d6831a7e5c0072$var$deserializeAws_restXmlPolicyStatus(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$640745a275665c3f = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ReplicationConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ReplicationConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketReplicationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$95dd746113207b99 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Payer: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Payer"] !== undefined) contents.Payer = data["Payer"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e91d7dc8d3f2bb37 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        TagSet: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$87fb664bdbc56c8d = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        MFADelete: undefined,
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["MfaDelete"] !== undefined) contents.MFADelete = data["MfaDelete"];
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketVersioningCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e9648c335e4af37a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ErrorDocument: undefined,
                        IndexDocument: undefined,
                        RedirectAllRequestsTo: undefined,
                        RoutingRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $90d6831a7e5c0072$var$deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
                    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $90d6831a7e5c0072$var$deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
                    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $90d6831a7e5c0072$var$deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
                    if (data.RoutingRules === "") contents.RoutingRules = [];
                    if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $90d6831a7e5c0072$var$deserializeAws_restXmlRoutingRules((0, $c532f6997c845207$export$52272e038712c64e)(data["RoutingRules"]["RoutingRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetBucketWebsiteCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$c8faba1b7abd4024 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectCommandError(output, context)
            ];
            contents = {
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                AcceptRanges: undefined,
                Body: undefined,
                BucketKeyEnabled: undefined,
                CacheControl: undefined,
                ContentDisposition: undefined,
                ContentEncoding: undefined,
                ContentLanguage: undefined,
                ContentLength: undefined,
                ContentRange: undefined,
                ContentType: undefined,
                DeleteMarker: undefined,
                ETag: undefined,
                Expiration: undefined,
                Expires: undefined,
                LastModified: undefined,
                Metadata: undefined,
                MissingMeta: undefined,
                ObjectLockLegalHoldStatus: undefined,
                ObjectLockMode: undefined,
                ObjectLockRetainUntilDate: undefined,
                PartsCount: undefined,
                ReplicationStatus: undefined,
                RequestCharged: undefined,
                Restore: undefined,
                SSECustomerAlgorithm: undefined,
                SSECustomerKeyMD5: undefined,
                SSEKMSKeyId: undefined,
                ServerSideEncryption: undefined,
                StorageClass: undefined,
                TagCount: undefined,
                VersionId: undefined,
                WebsiteRedirectLocation: undefined
            };
            if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
            if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
            if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
            if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
            if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
            if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
            if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
            if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
            if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
            if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
            if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
            if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
            if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
            if (output.headers["content-range"] !== undefined) contents.ContentRange = output.headers["content-range"];
            if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
            if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
            if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
            if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
            if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
            if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
            if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
            if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
            if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
            if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
            if (output.headers["x-amz-tagging-count"] !== undefined) contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
            if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
            if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
            if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
            Object.keys(output.headers).forEach(function(header) {
                if (contents.Metadata === undefined) contents.Metadata = {};
                if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
            });
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlInvalidObjectStateResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7334ba1348400806 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $90d6831a7e5c0072$var$deserializeAws_restXmlGrants((0, $c532f6997c845207$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectAclCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3fe12927f071d9c2 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        LegalHold: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.LegalHold = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockLegalHold(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectLegalHoldCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8a6b0973efae922a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ObjectLockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ObjectLockConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e8bb8c760a500abf = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Retention: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Retention = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockRetention(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectRetentionCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$b55a093fbe745f1a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        TagSet: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$77cab76edb05348f = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectTorrentCommandError(output, context)
            ];
            contents = {
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                Body: undefined,
                RequestCharged: undefined
            };
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetObjectTorrentCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ca2eb582f189d59e = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        PublicAccessBlockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PublicAccessBlockConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGetPublicAccessBlockCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7da61a6d1be4855c = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlHeadBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlHeadBucketCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$6facb3b50649bd07 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlHeadObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        AcceptRanges: undefined,
                        ArchiveStatus: undefined,
                        BucketKeyEnabled: undefined,
                        CacheControl: undefined,
                        ContentDisposition: undefined,
                        ContentEncoding: undefined,
                        ContentLanguage: undefined,
                        ContentLength: undefined,
                        ContentType: undefined,
                        DeleteMarker: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Expires: undefined,
                        LastModified: undefined,
                        Metadata: undefined,
                        MissingMeta: undefined,
                        ObjectLockLegalHoldStatus: undefined,
                        ObjectLockMode: undefined,
                        ObjectLockRetainUntilDate: undefined,
                        PartsCount: undefined,
                        ReplicationStatus: undefined,
                        RequestCharged: undefined,
                        Restore: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        StorageClass: undefined,
                        VersionId: undefined,
                        WebsiteRedirectLocation: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
                    if (output.headers["x-amz-archive-status"] !== undefined) contents.ArchiveStatus = output.headers["x-amz-archive-status"];
                    if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
                    if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
                    if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
                    if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
                    if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
                    if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
                    if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
                    if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
                    if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
                    if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
                    if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
                    if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
                    Object.keys(output.headers).forEach(function(header) {
                        if (contents.Metadata === undefined) contents.Metadata = {};
                        if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
                    });
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7c3a4eeaff09f66a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        AnalyticsConfigurationList: undefined,
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
                    if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["AnalyticsConfiguration"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e5945e65caff371e = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IntelligentTieringConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.IntelligentTieringConfiguration === "") contents.IntelligentTieringConfigurationList = [];
                    if (data["IntelligentTieringConfiguration"] !== undefined) contents.IntelligentTieringConfigurationList = $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["IntelligentTieringConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$690ef4b20b3078b6 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        InventoryConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
                    if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["InventoryConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$906cb5e8f067f67 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        MetricsConfigurationList: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
                    if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsConfigurationList((0, $c532f6997c845207$export$52272e038712c64e)(data["MetricsConfiguration"]), context);
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$63be43683e761a25 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Buckets: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Buckets === "") contents.Buckets = [];
                    if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $90d6831a7e5c0072$var$deserializeAws_restXmlBuckets((0, $c532f6997c845207$export$52272e038712c64e)(data["Buckets"]["Bucket"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListBucketsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8da47d46285c7a0 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListMultipartUploadsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        Bucket: undefined,
                        CommonPrefixes: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxUploads: undefined,
                        NextKeyMarker: undefined,
                        NextUploadIdMarker: undefined,
                        Prefix: undefined,
                        UploadIdMarker: undefined,
                        Uploads: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefixList((0, $c532f6997c845207$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxUploads"] !== undefined) contents.MaxUploads = parseInt(data["MaxUploads"]);
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = data["NextUploadIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = data["UploadIdMarker"];
                    if (data.Upload === "") contents.Uploads = [];
                    if (data["Upload"] !== undefined) contents.Uploads = $90d6831a7e5c0072$var$deserializeAws_restXmlMultipartUploadList((0, $c532f6997c845207$export$52272e038712c64e)(data["Upload"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListMultipartUploadsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$f8d39cd754f5521d = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        Marker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextMarker: undefined,
                        Prefix: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefixList((0, $c532f6997c845207$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectList((0, $c532f6997c845207$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Marker"] !== undefined) contents.Marker = data["Marker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextMarker"] !== undefined) contents.NextMarker = data["NextMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$2b371fcdd686ba8b = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectsV2CommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        ContinuationToken: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyCount: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextContinuationToken: undefined,
                        Prefix: undefined,
                        StartAfter: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefixList((0, $c532f6997c845207$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectList((0, $c532f6997c845207$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyCount"] !== undefined) contents.KeyCount = parseInt(data["KeyCount"]);
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["StartAfter"] !== undefined) contents.StartAfter = data["StartAfter"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$637e7cd668cf8615 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        DeleteMarkers: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextKeyMarker: undefined,
                        NextVersionIdMarker: undefined,
                        Prefix: undefined,
                        VersionIdMarker: undefined,
                        Versions: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefixList((0, $c532f6997c845207$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
                    if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkers((0, $c532f6997c845207$export$52272e038712c64e)(data["DeleteMarker"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = data["NextVersionIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = data["VersionIdMarker"];
                    if (data.Version === "") contents.Versions = [];
                    if (data["Version"] !== undefined) contents.Versions = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectVersionList((0, $c532f6997c845207$export$52272e038712c64e)(data["Version"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListObjectVersionsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$584d994fd27ec2bb = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlListPartsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Initiator: undefined,
                        IsTruncated: undefined,
                        Key: undefined,
                        MaxParts: undefined,
                        NextPartNumberMarker: undefined,
                        Owner: undefined,
                        PartNumberMarker: undefined,
                        Parts: undefined,
                        RequestCharged: undefined,
                        StorageClass: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Initiator"] !== undefined) contents.Initiator = $90d6831a7e5c0072$var$deserializeAws_restXmlInitiator(data["Initiator"], context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["MaxParts"] !== undefined) contents.MaxParts = parseInt(data["MaxParts"]);
                    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = data["NextPartNumberMarker"];
                    if (data["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = data["PartNumberMarker"];
                    if (data.Part === "") contents.Parts = [];
                    if (data["Part"] !== undefined) contents.Parts = $90d6831a7e5c0072$var$deserializeAws_restXmlParts((0, $c532f6997c845207$export$52272e038712c64e)(data["Part"]), context);
                    if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlListPartsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e654cd63b770e3c4 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$468a83c548434951 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAclCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$488c2e199ebb898d = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3eb4d44bdf561f91 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketCorsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$d0f1e0a2cb4f5db6 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketEncryptionCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$96bb8c8575dc5439 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a7487a3c5377a809 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9e27fb99395eb8b3 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$9e24aeee62aeef65 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketLoggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$3a85a94ca87604e2 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ec8129277a63ef1e = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8d1d3805e977d457 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$2b7b6f0e8b2cc8a1 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketPolicyCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$8ea9e7fadc7c189a = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketReplicationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$12b0ab2c5846a509 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$5bf4de3b4501436e = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$ef405e59c399a368 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketVersioningCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$514d37c55d4fb4b5 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutBucketWebsiteCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$45bbdbf5181c3607 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$e0d1dc79dd7bc4d6 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectAclCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$a32f5469ffeef979 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectLegalHoldCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$470735cd3fe9e5b5 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$5377eccfb6cedf8b = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectRetentionCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$cecf7bb838bf1182 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutObjectTaggingCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$7a1b291f9ae3d668 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPutPublicAccessBlockCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$317606d55789efe9 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlRestoreObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        RequestCharged: undefined,
                        RestoreOutputPath: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-restore-output-path"] !== undefined) contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRestoreObjectCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$285881e5f25758a3 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $90d6831a7e5c0072$var$deserializeAws_restXmlSelectObjectContentCommandError(output, context)
            ];
            contents = {
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                Payload: undefined
            };
            data = context.eventStreamMarshaller.deserialize(output.body, function(event) {
                return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                    var eventName, eventHeaders, eventMessage, parsedEvent;
                    var _a;
                    return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                eventName = Object.keys(event)[0];
                                eventHeaders = Object.entries(event[eventName].headers).reduce(function(accummulator, curr) {
                                    accummulator[curr[0]] = curr[1].value;
                                    return accummulator;
                                }, {});
                                eventMessage = {
                                    headers: eventHeaders,
                                    body: event[eventName].body
                                };
                                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                                return [
                                    4 /*yield*/ ,
                                    $90d6831a7e5c0072$var$deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _b.sent()
                                ];
                        }
                    });
                });
            });
            contents.Payload = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSelectObjectContentCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$176ef954f1bec178 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlUploadPartCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlUploadPartCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$export$460d1831a8acdf23 = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlUploadPartCopyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyPartResult: undefined,
                        CopySourceVersionId: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyPartResult = $90d6831a7e5c0072$var$deserializeAws_restXmlCopyPartResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlUploadPartCopyCommandError = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $284cdd41a966f3e0$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $90d6831a7e5c0072$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $90d6831a7e5c0072$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSelectObjectContentEventStream_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, _b, _c, _d, _e;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!(output["Records"] !== undefined)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlRecordsEvent_event(output["Records"], context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        (_a.Records = _f.sent(), _a)
                    ];
                case 2:
                    if (!(output["Stats"] !== undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlStatsEvent_event(output["Stats"], context)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_b.Stats = _f.sent(), _b)
                    ];
                case 4:
                    if (!(output["Progress"] !== undefined)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlProgressEvent_event(output["Progress"], context)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        (_c.Progress = _f.sent(), _c)
                    ];
                case 6:
                    if (!(output["Cont"] !== undefined)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        (_d.Cont = _f.sent(), _d)
                    ];
                case 8:
                    if (!(output["End"] !== undefined)) return [
                        3 /*break*/ ,
                        10
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$deserializeAws_restXmlEndEvent_event(output["End"], context)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        (_e.End = _f.sent(), _e)
                    ];
                case 10:
                    return [
                        2 /*return*/ ,
                        {
                            $unknown: output
                        }
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlContinuationEvent_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlEndEvent_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlProgressEvent_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRecordsEvent_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            contents.Payload = output.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlStatsEvent_event = function(output, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $90d6831a7e5c0072$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlBucketAlreadyExistsResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyExists",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyOwnedByYou",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInvalidObjectStateResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidObjectState",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput),
                AccessTier: undefined,
                StorageClass: undefined
            };
            data = parsedOutput.body;
            if (data["AccessTier"] !== undefined) contents.AccessTier = data["AccessTier"];
            if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchBucket",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchKey",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchUpload",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectAlreadyInActiveTierError",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $284cdd41a966f3e0$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $284cdd41a966f3e0$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectNotInActiveTierError",
                $fault: "client",
                $metadata: $90d6831a7e5c0072$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAbortIncompleteMultipartUpload = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation !== undefined && input.DaysAfterInitiation !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DaysAfterInitiation").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAccelerateConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccelerateConfiguration");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketAccelerateStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAccessControlPolicy = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccessControlPolicy");
    if (input.Grants !== undefined && input.Grants !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlGrants(input.Grants, context);
        var containerNode_1 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_1.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_1);
    }
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAccessControlTranslation = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccessControlTranslation");
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OwnerOverride").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Owner)).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAllowedHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AllowedHeader").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAllowedMethods = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AllowedMethod").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAllowedOrigins = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AllowedOrigin").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsAndOperator = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClassAnalysis !== undefined && input.StorageClassAnalysis !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsExportDestination = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsExportDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsFilter");
    (0, $0c0d1970b55e47a3$export$c9ec61557dcb764a).visit(input, {
        Prefix: function(value) {
            var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $d84d4d9496a1e020$export$e775a15d806cbddc) || value instanceof (0, $764de912faeee494$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsS3BucketDestination");
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AnalyticsS3ExportFileFormat").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId !== undefined && input.BucketAccountId !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.BucketAccountId)).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlBucketLifecycleConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketLifecycleConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlBucketLoggingStatus = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketLoggingStatus");
    if (input.LoggingEnabled !== undefined && input.LoggingEnabled !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CompletedMultipartUpload");
    if (input.Parts !== undefined && input.Parts !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlCompletedPartList(input.Parts, context);
        nodes.map(function(node) {
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCompletedPart = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CompletedPart");
    if (input.ETag !== undefined && input.ETag !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ETag").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ETag)).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber !== undefined && input.PartNumber !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("PartNumber").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.PartNumber))).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCompletedPartList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlCompletedPart(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCondition = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Condition");
    if (input.HttpErrorCodeReturnedEquals !== undefined && input.HttpErrorCodeReturnedEquals !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("HttpErrorCodeReturnedEquals").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    if (input.KeyPrefixEquals !== undefined && input.KeyPrefixEquals !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("KeyPrefixEquals").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCORSConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CORSConfiguration");
    if (input.CORSRules !== undefined && input.CORSRules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlCORSRules(input.CORSRules, context);
        nodes.map(function(node) {
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCORSRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CORSRule");
    if (input.AllowedHeaders !== undefined && input.AllowedHeaders !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
        nodes.map(function(node) {
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods !== undefined && input.AllowedMethods !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
        nodes.map(function(node) {
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins !== undefined && input.AllowedOrigins !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
        nodes.map(function(node) {
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.ExposeHeaders !== undefined && input.ExposeHeaders !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
        nodes.map(function(node) {
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds !== undefined && input.MaxAgeSeconds !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MaxAgeSeconds").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCORSRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlCORSRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCreateBucketConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CreateBucketConfiguration");
    if (input.LocationConstraint !== undefined && input.LocationConstraint !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketLocationConstraint").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.LocationConstraint)).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCSVInput = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CSVInput");
    if (input.FileHeaderInfo !== undefined && input.FileHeaderInfo !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FileHeaderInfo").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.FileHeaderInfo)).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.Comments !== undefined && input.Comments !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Comments").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Comments)).withName("Comments");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter !== undefined && input.AllowQuotedRecordDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AllowQuotedRecordDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlCSVOutput = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CSVOutput");
    if (input.QuoteFields !== undefined && input.QuoteFields !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QuoteFields").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QuoteFields)).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlDefaultRetention = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DefaultRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Years !== undefined && input.Years !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Years").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Years))).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlDelete = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Delete");
    if (input.Objects !== undefined && input.Objects !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlObjectIdentifierList(input.Objects, context);
        nodes.map(function(node) {
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet !== undefined && input.Quiet !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Quiet").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Quiet))).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlDeleteMarkerReplication = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DeleteMarkerReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DeleteMarkerReplicationStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlDestination = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Destination");
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account !== undefined && input.Account !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Account)).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation !== undefined && input.AccessControlTranslation !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime !== undefined && input.ReplicationTime !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics !== undefined && input.Metrics !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlEncryption = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Encryption");
    if (input.EncryptionType !== undefined && input.EncryptionType !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.EncryptionType)).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    if (input.KMSKeyId !== undefined && input.KMSKeyId !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.KMSKeyId)).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext !== undefined && input.KMSContext !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("KMSContext").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.KMSContext)).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID !== undefined && input.ReplicaKmsKeyID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicaKmsKeyID").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlErrorDocument = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ErrorDocument");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlEventList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Event").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlExistingObjectReplication = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExistingObjectReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExistingObjectReplicationStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlExposeHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExposeHeader").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlFilterRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FilterRule");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FilterRuleName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("FilterRuleValue").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlFilterRuleList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlFilterRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlGlacierJobParameters = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("GlacierJobParameters");
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlGrant = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Grant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Permission").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlGrantee = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Grantee");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.EmailAddress !== undefined && input.EmailAddress !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("EmailAddress").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.EmailAddress)).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ID").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.URI !== undefined && input.URI !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("URI").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.URI)).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlGrant(entry, context);
        return node.withName("Grant");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlIndexDocument = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IndexDocument");
    if (input.Suffix !== undefined && input.Suffix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Suffix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Suffix)).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInputSerialization = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType !== undefined && input.CompressionType !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("CompressionType").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.CompressionType)).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet !== undefined && input.Parquet !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringAndOperator = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Tierings !== undefined && input.Tierings !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTieringList(input.Tierings, context);
        nodes.map(function(node) {
            node = node.withName("Tiering");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined && input.Tag !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined && input.And !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlIntelligentTieringAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryConfiguration");
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled !== undefined && input.IsEnabled !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IsEnabled").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.IsEnabled))).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.IncludedObjectVersions !== undefined && input.IncludedObjectVersions !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryIncludedObjectVersions").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields !== undefined && input.OptionalFields !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
        var containerNode_2 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OptionalFields");
        nodes.map(function(node) {
            containerNode_2.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_2);
    }
    if (input.Schedule !== undefined && input.Schedule !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryDestination = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryEncryption = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryEncryption");
    if (input.SSES3 !== undefined && input.SSES3 !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    if (input.SSEKMS !== undefined && input.SSEKMS !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryOptionalFields = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryOptionalField").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(entry));
        return node.withName("Field");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventoryS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryS3BucketDestination");
    if (input.AccountId !== undefined && input.AccountId !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.AccountId)).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryFormat").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlInventorySchedule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventorySchedule");
    if (input.Frequency !== undefined && input.Frequency !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("InventoryFrequency").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Frequency)).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlJSONInput = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("JSONInput");
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("JSONType").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlJSONOutput = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("JSONOutput");
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLambdaFunctionConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LambdaFunctionConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn !== undefined && input.LambdaFunctionArn !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LambdaFunctionArn").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.LambdaFunctionArn)).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLambdaFunctionConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleExpiration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LifecycleExpiration");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Date").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker !== undefined && input.ExpiredObjectDeleteMarker !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExpiredObjectDeleteMarker").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LifecycleRule");
    if (input.Expiration !== undefined && input.Expiration !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ID").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExpirationStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions !== undefined && input.Transitions !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTransitionList(input.Transitions, context);
        nodes.map(function(node) {
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionTransitions !== undefined && input.NoncurrentVersionTransitions !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map(function(node) {
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionExpiration !== undefined && input.NoncurrentVersionExpiration !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload !== undefined && input.AbortIncompleteMultipartUpload !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LifecycleRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRuleFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LifecycleRuleFilter");
    (0, $0c0d1970b55e47a3$export$4338dba1e93ddaf4).visit(input, {
        Prefix: function(value) {
            var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $d84d4d9496a1e020$export$e775a15d806cbddc) || value instanceof (0, $764de912faeee494$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlLifecycleRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlLoggingEnabled = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LoggingEnabled");
    if (input.TargetBucket !== undefined && input.TargetBucket !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TargetBucket").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.TargetBucket)).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetGrants !== undefined && input.TargetGrants !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTargetGrants(input.TargetGrants, context);
        var containerNode_3 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TargetGrants");
        nodes.map(function(node) {
            containerNode_3.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_3);
    }
    if (input.TargetPrefix !== undefined && input.TargetPrefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TargetPrefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.TargetPrefix)).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlMetadataEntry = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetadataEntry");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetadataKey").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetadataValue").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlMetrics = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Metrics");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetricsStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold !== undefined && input.EventThreshold !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlMetricsAndOperator = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetricsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlMetricsConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetricsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetricsId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlMetricsFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MetricsFilter");
    (0, $0c0d1970b55e47a3$export$564a1f9c338cae45).visit(input, {
        Prefix: function(value) {
            var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlMetricsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $d84d4d9496a1e020$export$e775a15d806cbddc) || value instanceof (0, $764de912faeee494$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionExpiration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionTransition = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NoncurrentVersionTransition");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlNoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NotificationConfiguration");
    if (input.TopicConfigurations !== undefined && input.TopicConfigurations !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations !== undefined && input.QueueConfigurations !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations !== undefined && input.LambdaFunctionConfigurations !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfigurationFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NotificationConfigurationFilter");
    if (input.Key !== undefined && input.Key !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectIdentifier = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectIdentifier");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId !== undefined && input.VersionId !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectVersionId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.VersionId)).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectIdentifierList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled !== undefined && input.ObjectLockEnabled !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockEnabled").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule !== undefined && input.Rule !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockLegalHold = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockLegalHold");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockLegalHoldStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockRetention = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate !== undefined && input.RetainUntilDate !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Date").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlObjectLockRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectLockRule");
    if (input.DefaultRetention !== undefined && input.DefaultRetention !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOutputLocation = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OutputLocation");
    if (input.S3 !== undefined && input.S3 !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlS3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOutputSerialization = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OutputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOwner = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Owner");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ID").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControls = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OwnershipControls");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControlsRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("OwnershipControlsRule");
    if (input.ObjectOwnership !== undefined && input.ObjectOwnership !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectOwnership").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ObjectOwnership)).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControlsRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlOwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlParquetInput = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ParquetInput");
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlPublicAccessBlockConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("PublicAccessBlockConfiguration");
    if (input.BlockPublicAcls !== undefined && input.BlockPublicAcls !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls !== undefined && input.IgnorePublicAcls !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicPolicy !== undefined && input.BlockPublicPolicy !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets !== undefined && input.RestrictPublicBuckets !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlQueueConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QueueConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn !== undefined && input.QueueArn !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("QueueArn").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.QueueArn)).withName("Queue");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlQueueConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlQueueConfiguration(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRedirect = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Redirect");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.HttpRedirectCode !== undefined && input.HttpRedirectCode !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("HttpRedirectCode").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.HttpRedirectCode)).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith !== undefined && input.ReplaceKeyPrefixWith !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplaceKeyPrefixWith").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith !== undefined && input.ReplaceKeyWith !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplaceKeyWith").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRedirectAllRequestsTo = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RedirectAllRequestsTo");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicaModifications = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicaModifications");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicaModificationsStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationConfiguration");
    if (input.Role !== undefined && input.Role !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Role").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Role)).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationRule");
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ID").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Priority !== undefined && input.Priority !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Priority").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Priority))).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationRuleStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria !== undefined && input.SourceSelectionCriteria !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication !== undefined && input.ExistingObjectReplication !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication !== undefined && input.DeleteMarkerReplication !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRuleFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationRuleFilter");
    (0, $0c0d1970b55e47a3$export$c5652b893758d9eb).visit(input, {
        Prefix: function(value) {
            var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $d84d4d9496a1e020$export$e775a15d806cbddc) || value instanceof (0, $764de912faeee494$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationTime = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationTime");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationTimeStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Time !== undefined && input.Time !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlReplicationTimeValue = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ReplicationTimeValue");
    if (input.Minutes !== undefined && input.Minutes !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Minutes").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Minutes))).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRequestPaymentConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RequestPaymentConfiguration");
    if (input.Payer !== undefined && input.Payer !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Payer").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Payer)).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRequestProgress = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RequestProgress");
    if (input.Enabled !== undefined && input.Enabled !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("EnableRequestProgress").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Enabled))).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRestoreRequest = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RestoreRequest");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.GlacierJobParameters !== undefined && input.GlacierJobParameters !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RestoreRequestType").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description !== undefined && input.Description !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Description").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Description)).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters !== undefined && input.SelectParameters !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation !== undefined && input.OutputLocation !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRoutingRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RoutingRule");
    if (input.Condition !== undefined && input.Condition !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    if (input.Redirect !== undefined && input.Redirect !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlRoutingRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlRoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlS3KeyFilter = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("S3KeyFilter");
    if (input.FilterRules !== undefined && input.FilterRules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlFilterRuleList(input.FilterRules, context);
        nodes.map(function(node) {
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlS3Location = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("S3Location");
    if (input.BucketName !== undefined && input.BucketName !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.BucketName)).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("LocationPrefix").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL !== undefined && input.CannedACL !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectCannedACL").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.CannedACL)).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList !== undefined && input.AccessControlList !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlGrants(input.AccessControlList, context);
        var containerNode_4 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_4.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_4);
    }
    if (input.Tagging !== undefined && input.Tagging !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata !== undefined && input.UserMetadata !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlUserMetadata(input.UserMetadata, context);
        var containerNode_5 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("UserMetadata");
        nodes.map(function(node) {
            containerNode_5.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_5);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlScanRange = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ScanRange");
    if (input.Start !== undefined && input.Start !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Start").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Start))).withName("Start");
        bodyNode.addChildNode(node);
    }
    if (input.End !== undefined && input.End !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("End").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.End))).withName("End");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlSelectParameters = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SelectParameters");
    if (input.InputSerialization !== undefined && input.InputSerialization !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.ExpressionType !== undefined && input.ExpressionType !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Expression !== undefined && input.Expression !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Expression)).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined && input.OutputSerialization !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionByDefault = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm !== undefined && input.SSEAlgorithm !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.SSEAlgorithm)).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID !== undefined && input.KMSMasterKeyID !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ServerSideEncryptionConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionRule = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault !== undefined && input.ApplyServerSideEncryptionByDefault !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    if (input.BucketKeyEnabled !== undefined && input.BucketKeyEnabled !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketKeyEnabled").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.BucketKeyEnabled))).withName("BucketKeyEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlSourceSelectionCriteria = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects !== undefined && input.SseKmsEncryptedObjects !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicaModifications !== undefined && input.ReplicaModifications !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlReplicaModifications(input.ReplicaModifications, context).withName("ReplicaModifications");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlSSEKMS = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SSE-KMS");
    if (input.KeyId !== undefined && input.KeyId !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.KeyId)).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlSseKmsEncryptedObjects = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SseKmsEncryptedObjects");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SseKmsEncryptedObjectsStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlSSES3 = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("SSE-S3");
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlStorageClassAnalysis = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("StorageClassAnalysis");
    if (input.DataExport !== undefined && input.DataExport !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlStorageClassAnalysisDataExport = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion !== undefined && input.OutputSchemaVersion !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("StorageClassAnalysisSchemaVersion").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTag = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Tag");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Value").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTagging = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Tagging");
    if (input.TagSet !== undefined && input.TagSet !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlTagSet(input.TagSet, context);
        var containerNode_6 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TagSet");
        nodes.map(function(node) {
            containerNode_6.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_6);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTagSet = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTag(entry, context);
        return node.withName("Tag");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTargetGrant = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TargetGrant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketLogsPermission").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTargetGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTargetGrant(entry, context);
        return node.withName("Grant");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTiering = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Tiering");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringDays").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.AccessTier !== undefined && input.AccessTier !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("IntelligentTieringAccessTier").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.AccessTier)).withName("AccessTier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTieringList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTiering(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTopicConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TopicConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn !== undefined && input.TopicArn !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TopicArn").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.TopicArn)).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTopicConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTopicConfiguration(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTransition = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Transition");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Date").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("Days").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlTransition(entry, context);
        return node.withName("member");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlUserMetadata = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlMetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
var $90d6831a7e5c0072$var$serializeAws_restXmlVersioningConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("VersioningConfiguration");
    if (input.MFADelete !== undefined && input.MFADelete !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("MFADelete").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.MFADelete)).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("BucketVersioningStatus").addChildNode(new (0, $764de912faeee494$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$serializeAws_restXmlWebsiteConfiguration = function(input, context) {
    var bodyNode = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("WebsiteConfiguration");
    if (input.ErrorDocument !== undefined && input.ErrorDocument !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument !== undefined && input.IndexDocument !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo !== undefined && input.RedirectAllRequestsTo !== null) {
        var node = $90d6831a7e5c0072$var$serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules !== undefined && input.RoutingRules !== null) {
        var nodes = $90d6831a7e5c0072$var$serializeAws_restXmlRoutingRules(input.RoutingRules, context);
        var containerNode_7 = new (0, $d84d4d9496a1e020$export$e775a15d806cbddc)("RoutingRules");
        nodes.map(function(node) {
            containerNode_7.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_7);
    }
    return bodyNode;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAbortIncompleteMultipartUpload = function(output, context) {
    var contents = {
        DaysAfterInitiation: undefined
    };
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAccessControlTranslation = function(output, context) {
    var contents = {
        Owner: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = output["Owner"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedMethods = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedOrigins = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        StorageClassAnalysis: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $90d6831a7e5c0072$var$deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsExportDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $90d6831a7e5c0072$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsS3BucketDestination = function(output, context) {
    var contents = {
        Format: undefined,
        BucketAccountId: undefined,
        Bucket: undefined,
        Prefix: undefined
    };
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = output["BucketAccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlBucket = function(output, context) {
    var contents = {
        Name: undefined,
        CreationDate: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["CreationDate"] !== undefined) contents.CreationDate = new Date(output["CreationDate"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlBuckets = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlBucket(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefix = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefixList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlCommonPrefix(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCondition = function(output, context) {
    var contents = {
        HttpErrorCodeReturnedEquals: undefined,
        KeyPrefixEquals: undefined
    };
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = output["KeyPrefixEquals"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCopyObjectResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCopyPartResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCORSRule = function(output, context) {
    var contents = {
        AllowedHeaders: undefined,
        AllowedMethods: undefined,
        AllowedOrigins: undefined,
        ExposeHeaders: undefined,
        MaxAgeSeconds: undefined
    };
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedHeaders((0, $c532f6997c845207$export$52272e038712c64e)(output["AllowedHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedMethods((0, $c532f6997c845207$export$52272e038712c64e)(output["AllowedMethod"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $90d6831a7e5c0072$var$deserializeAws_restXmlAllowedOrigins((0, $c532f6997c845207$export$52272e038712c64e)(output["AllowedOrigin"]), context);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $90d6831a7e5c0072$var$deserializeAws_restXmlExposeHeaders((0, $c532f6997c845207$export$52272e038712c64e)(output["ExposeHeader"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlCORSRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlCORSRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDefaultRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        Days: undefined,
        Years: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Years"] !== undefined) contents.Years = parseInt(output["Years"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeletedObject = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        DeleteMarker: undefined,
        DeleteMarkerVersionId: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = output["DeleteMarker"] == "true";
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeletedObjects = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlDeletedObject(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkerEntry = function(output, context) {
    var contents = {
        Owner: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkerReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkers = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkerEntry(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlDestination = function(output, context) {
    var contents = {
        Bucket: undefined,
        Account: undefined,
        StorageClass: undefined,
        AccessControlTranslation: undefined,
        EncryptionConfiguration: undefined,
        ReplicationTime: undefined,
        Metrics: undefined
    };
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Account"] !== undefined) contents.Account = output["Account"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $90d6831a7e5c0072$var$deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $90d6831a7e5c0072$var$deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
    if (output["Metrics"] !== undefined) contents.Metrics = $90d6831a7e5c0072$var$deserializeAws_restXmlMetrics(output["Metrics"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlEncryptionConfiguration = function(output, context) {
    var contents = {
        ReplicaKmsKeyID: undefined
    };
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXml_Error = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        Code: undefined,
        Message: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["Code"] !== undefined) contents.Code = output["Code"];
    if (output["Message"] !== undefined) contents.Message = output["Message"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlErrorDocument = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlErrors = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXml_Error(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlEventList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlExistingObjectReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlExposeHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlFilterRule = function(output, context) {
    var contents = {
        Name: undefined,
        Value: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlFilterRuleList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlFilterRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $90d6831a7e5c0072$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGrantee = function(output, context) {
    var contents = {
        DisplayName: undefined,
        EmailAddress: undefined,
        ID: undefined,
        URI: undefined,
        Type: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = output["EmailAddress"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["URI"] !== undefined) contents.URI = output["URI"];
    if (output["xsi:type"] !== undefined) contents.Type = output["xsi:type"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlGrant(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlIndexDocument = function(output, context) {
    var contents = {
        Suffix: undefined
    };
    if (output["Suffix"] !== undefined) contents.Suffix = output["Suffix"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInitiator = function(output, context) {
    var contents = {
        ID: undefined,
        DisplayName: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        Status: undefined,
        Tierings: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Tiering === "") contents.Tierings = [];
    if (output["Tiering"] !== undefined) contents.Tierings = $90d6831a7e5c0072$var$deserializeAws_restXmlTieringList((0, $c532f6997c845207$export$52272e038712c64e)(output["Tiering"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringFilter = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tag: undefined,
        And: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $90d6831a7e5c0072$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $90d6831a7e5c0072$var$deserializeAws_restXmlIntelligentTieringAndOperator(output["And"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryConfiguration = function(output, context) {
    var contents = {
        Destination: undefined,
        IsEnabled: undefined,
        Filter: undefined,
        Id: undefined,
        IncludedObjectVersions: undefined,
        OptionalFields: undefined,
        Schedule: undefined
    };
    if (output["Destination"] !== undefined) contents.Destination = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryDestination(output["Destination"], context);
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = output["IsEnabled"] == "true";
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = output["IncludedObjectVersions"];
    if (output.OptionalFields === "") contents.OptionalFields = [];
    if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryOptionalFields((0, $c532f6997c845207$export$52272e038712c64e)(output["OptionalFields"]["Field"]), context);
    if (output["Schedule"] !== undefined) contents.Schedule = $90d6831a7e5c0072$var$deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryEncryption = function(output, context) {
    var contents = {
        SSES3: undefined,
        SSEKMS: undefined
    };
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $90d6831a7e5c0072$var$deserializeAws_restXmlSSES3(output["SSE-S3"], context);
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $90d6831a7e5c0072$var$deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryFilter = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryOptionalFields = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryS3BucketDestination = function(output, context) {
    var contents = {
        AccountId: undefined,
        Bucket: undefined,
        Format: undefined,
        Prefix: undefined,
        Encryption: undefined
    };
    if (output["AccountId"] !== undefined) contents.AccountId = output["AccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Encryption"] !== undefined) contents.Encryption = $90d6831a7e5c0072$var$deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlInventorySchedule = function(output, context) {
    var contents = {
        Frequency: undefined
    };
    if (output["Frequency"] !== undefined) contents.Frequency = output["Frequency"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLambdaFunctionConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        LambdaFunctionArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = output["CloudFunction"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $90d6831a7e5c0072$var$deserializeAws_restXmlEventList((0, $c532f6997c845207$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLambdaFunctionConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleExpiration = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        ExpiredObjectDeleteMarker: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRule = function(output, context) {
    var contents = {
        Expiration: undefined,
        ID: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        Transitions: undefined,
        NoncurrentVersionTransitions: undefined,
        NoncurrentVersionExpiration: undefined,
        AbortIncompleteMultipartUpload: undefined
    };
    if (output["Expiration"] !== undefined) contents.Expiration = $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Transition === "") contents.Transitions = [];
    if (output["Transition"] !== undefined) contents.Transitions = $90d6831a7e5c0072$var$deserializeAws_restXmlTransitionList((0, $c532f6997c845207$export$52272e038712c64e)(output["Transition"]), context);
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionTransitionList((0, $c532f6997c845207$export$52272e038712c64e)(output["NoncurrentVersionTransition"]), context);
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $90d6831a7e5c0072$var$deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $90d6831a7e5c0072$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlLifecycleRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlLoggingEnabled = function(output, context) {
    var contents = {
        TargetBucket: undefined,
        TargetGrants: undefined,
        TargetPrefix: undefined
    };
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = output["TargetBucket"];
    if (output.TargetGrants === "") contents.TargetGrants = [];
    if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $90d6831a7e5c0072$var$deserializeAws_restXmlTargetGrants((0, $c532f6997c845207$export$52272e038712c64e)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = output["TargetPrefix"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMetrics = function(output, context) {
    var contents = {
        Status: undefined,
        EventThreshold: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsFilter(output["Filter"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $90d6831a7e5c0072$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $90d6831a7e5c0072$var$deserializeAws_restXmlMetricsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMultipartUpload = function(output, context) {
    var contents = {
        UploadId: undefined,
        Key: undefined,
        Initiated: undefined,
        StorageClass: undefined,
        Owner: undefined,
        Initiator: undefined
    };
    if (output["UploadId"] !== undefined) contents.UploadId = output["UploadId"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Initiated"] !== undefined) contents.Initiated = new Date(output["Initiated"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Initiator"] !== undefined) contents.Initiator = $90d6831a7e5c0072$var$deserializeAws_restXmlInitiator(output["Initiator"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlMultipartUploadList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlMultipartUpload(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionExpiration = function(output, context) {
    var contents = {
        NoncurrentDays: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionTransition = function(output, context) {
    var contents = {
        NoncurrentDays: undefined,
        StorageClass: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlNotificationConfigurationFilter = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["S3Key"] !== undefined) contents.Key = $90d6831a7e5c0072$var$deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXml_Object = function(output, context) {
    var contents = {
        Key: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Owner: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXml_Object(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockConfiguration = function(output, context) {
    var contents = {
        ObjectLockEnabled: undefined,
        Rule: undefined
    };
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = output["ObjectLockEnabled"];
    if (output["Rule"] !== undefined) contents.Rule = $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockRule(output["Rule"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockLegalHold = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        RetainUntilDate: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectLockRule = function(output, context) {
    var contents = {
        DefaultRetention: undefined
    };
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $90d6831a7e5c0072$var$deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectVersion = function(output, context) {
    var contents = {
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined,
        Owner: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["Owner"] !== undefined) contents.Owner = $90d6831a7e5c0072$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlObjectVersionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlObjectVersion(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlOwner = function(output, context) {
    var contents = {
        DisplayName: undefined,
        ID: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControls = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControlsRules((0, $c532f6997c845207$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControlsRule = function(output, context) {
    var contents = {
        ObjectOwnership: undefined
    };
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = output["ObjectOwnership"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControlsRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlOwnershipControlsRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPart = function(output, context) {
    var contents = {
        PartNumber: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined
    };
    if (output["PartNumber"] !== undefined) contents.PartNumber = parseInt(output["PartNumber"]);
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlParts = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlPart(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPolicyStatus = function(output, context) {
    var contents = {
        IsPublic: undefined
    };
    if (output["IsPublic"] !== undefined) contents.IsPublic = output["IsPublic"] == "true";
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlPublicAccessBlockConfiguration = function(output, context) {
    var contents = {
        BlockPublicAcls: undefined,
        IgnorePublicAcls: undefined,
        BlockPublicPolicy: undefined,
        RestrictPublicBuckets: undefined
    };
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlQueueConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        QueueArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Queue"] !== undefined) contents.QueueArn = output["Queue"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $90d6831a7e5c0072$var$deserializeAws_restXmlEventList((0, $c532f6997c845207$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlQueueConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlQueueConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRedirect = function(output, context) {
    var contents = {
        HostName: undefined,
        HttpRedirectCode: undefined,
        Protocol: undefined,
        ReplaceKeyPrefixWith: undefined,
        ReplaceKeyWith: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = output["HttpRedirectCode"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = output["ReplaceKeyWith"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRedirectAllRequestsTo = function(output, context) {
    var contents = {
        HostName: undefined,
        Protocol: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicaModifications = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationConfiguration = function(output, context) {
    var contents = {
        Role: undefined,
        Rules: undefined
    };
    if (output["Role"] !== undefined) contents.Role = output["Role"];
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRules((0, $c532f6997c845207$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRule = function(output, context) {
    var contents = {
        ID: undefined,
        Priority: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        SourceSelectionCriteria: undefined,
        ExistingObjectReplication: undefined,
        Destination: undefined,
        DeleteMarkerReplication: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Priority"] !== undefined) contents.Priority = parseInt(output["Priority"]);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $90d6831a7e5c0072$var$deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $90d6831a7e5c0072$var$deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $90d6831a7e5c0072$var$deserializeAws_restXmlDestination(output["Destination"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $90d6831a7e5c0072$var$deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet((0, $c532f6997c845207$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $90d6831a7e5c0072$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationTime = function(output, context) {
    var contents = {
        Status: undefined,
        Time: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["Time"] !== undefined) contents.Time = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlReplicationTimeValue = function(output, context) {
    var contents = {
        Minutes: undefined
    };
    if (output["Minutes"] !== undefined) contents.Minutes = parseInt(output["Minutes"]);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRoutingRule = function(output, context) {
    var contents = {
        Condition: undefined,
        Redirect: undefined
    };
    if (output["Condition"] !== undefined) contents.Condition = $90d6831a7e5c0072$var$deserializeAws_restXmlCondition(output["Condition"], context);
    if (output["Redirect"] !== undefined) contents.Redirect = $90d6831a7e5c0072$var$deserializeAws_restXmlRedirect(output["Redirect"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlRoutingRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlRoutingRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlS3KeyFilter = function(output, context) {
    var contents = {
        FilterRules: undefined
    };
    if (output.FilterRule === "") contents.FilterRules = [];
    if (output["FilterRule"] !== undefined) contents.FilterRules = $90d6831a7e5c0072$var$deserializeAws_restXmlFilterRuleList((0, $c532f6997c845207$export$52272e038712c64e)(output["FilterRule"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionByDefault = function(output, context) {
    var contents = {
        SSEAlgorithm: undefined,
        KMSMasterKeyID: undefined
    };
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = output["SSEAlgorithm"];
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = output["KMSMasterKeyID"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionConfiguration = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionRules((0, $c532f6997c845207$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionRule = function(output, context) {
    var contents = {
        ApplyServerSideEncryptionByDefault: undefined,
        BucketKeyEnabled: undefined
    };
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    if (output["BucketKeyEnabled"] !== undefined) contents.BucketKeyEnabled = output["BucketKeyEnabled"] == "true";
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlServerSideEncryptionRule(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSourceSelectionCriteria = function(output, context) {
    var contents = {
        SseKmsEncryptedObjects: undefined,
        ReplicaModifications: undefined
    };
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $90d6831a7e5c0072$var$deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    if (output["ReplicaModifications"] !== undefined) contents.ReplicaModifications = $90d6831a7e5c0072$var$deserializeAws_restXmlReplicaModifications(output["ReplicaModifications"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSSEKMS = function(output, context) {
    var contents = {
        KeyId: undefined
    };
    if (output["KeyId"] !== undefined) contents.KeyId = output["KeyId"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSseKmsEncryptedObjects = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlSSES3 = function(output, context) {
    var contents = {};
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlStorageClassAnalysis = function(output, context) {
    var contents = {
        DataExport: undefined
    };
    if (output["DataExport"] !== undefined) contents.DataExport = $90d6831a7e5c0072$var$deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlStorageClassAnalysisDataExport = function(output, context) {
    var contents = {
        OutputSchemaVersion: undefined,
        Destination: undefined
    };
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = output["OutputSchemaVersion"];
    if (output["Destination"] !== undefined) contents.Destination = $90d6831a7e5c0072$var$deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTag = function(output, context) {
    var contents = {
        Key: undefined,
        Value: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTagSet = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlTag(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTargetGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $90d6831a7e5c0072$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTargetGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlTargetGrant(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTiering = function(output, context) {
    var contents = {
        Days: undefined,
        AccessTier: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["AccessTier"] !== undefined) contents.AccessTier = output["AccessTier"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTieringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlTiering(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTopicConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        TopicArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Topic"] !== undefined) contents.TopicArn = output["Topic"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $90d6831a7e5c0072$var$deserializeAws_restXmlEventList((0, $c532f6997c845207$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $90d6831a7e5c0072$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTopicConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlTopicConfiguration(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTransition = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        StorageClass: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $90d6831a7e5c0072$var$deserializeAws_restXmlTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $90d6831a7e5c0072$var$deserializeAws_restXmlTransition(entry, context);
    });
};
var $90d6831a7e5c0072$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $90d6831a7e5c0072$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $90d6831a7e5c0072$var$collectBodyString = function(streamBody, context) {
    return $90d6831a7e5c0072$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $90d6831a7e5c0072$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $90d6831a7e5c0072$var$decodeEscapedXML = function(str) {
    return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var $90d6831a7e5c0072$var$parseBody = function(streamBody, context) {
    return $90d6831a7e5c0072$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $ba664335f27bea63$export$98e6a39c04603d36)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                tagValueProcessor: function(val, tagName) {
                    return $90d6831a7e5c0072$var$decodeEscapedXML(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $df2312d9b5942d77$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
};
var $90d6831a7e5c0072$var$loadRestXmlErrorCode = function(output, data) {
    if (data.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};



var $2R3UW = parcelRequire("2R3UW");


var $2R3UW = parcelRequire("2R3UW");
var $eed3434c8e549594$export$a22775fa5e2eebd9 = function(str) {
    return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var $eed3434c8e549594$export$98e6a39c04603d36 = function(arn) {
    var segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    var _a = (0, $2R3UW.__read)(segments), //Skip "arn" literal
    partition = _a[1], service = _a[2], region = _a[3], accountId = _a[4], resource = _a.slice(5);
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
var $eed3434c8e549594$export$3f8fe6489e95757d = function(arnObject) {
    var _a = arnObject.partition, partition = _a === void 0 ? "aws" : _a, service = arnObject.service, region = arnObject.region, accountId = arnObject.accountId, resource = arnObject.resource;
    if ([
        service,
        region,
        accountId,
        resource
    ].some(function(segment) {
        return typeof segment !== "string";
    })) throw new Error("Input ARN object is invalid");
    return "arn:" + partition + ":" + service + ":" + region + ":" + accountId + ":" + resource;
};



var $2R3UW = parcelRequire("2R3UW");

var $2R3UW = parcelRequire("2R3UW");
var $a791f66905186165$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $a791f66905186165$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $a791f66905186165$var$DOTS_PATTERN = /\.\./;
var $a791f66905186165$export$b0b24e5455be29b0 = /\./;
var $a791f66905186165$export$43f53815580748f = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var $a791f66905186165$var$S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var $a791f66905186165$var$AWS_PARTITION_SUFFIX = "amazonaws.com";
var $a791f66905186165$export$5b522ec9d0d23583 = function(options) {
    return typeof options.bucketName === "string";
};
var $a791f66905186165$export$2041e7d2db741fc6 = function(region) {
    return $a791f66905186165$var$isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var $a791f66905186165$export$360a1e07839d0d27 = function(bucketName) {
    return $a791f66905186165$var$DOMAIN_PATTERN.test(bucketName) && !$a791f66905186165$var$IP_ADDRESS_PATTERN.test(bucketName) && !$a791f66905186165$var$DOTS_PATTERN.test(bucketName);
};
var $a791f66905186165$var$getRegionalSuffix = function(hostname) {
    var parts = hostname.match($a791f66905186165$export$43f53815580748f);
    return [
        parts[2],
        hostname.replace(new RegExp("^" + parts[0]), "")
    ];
};
var $a791f66905186165$export$661d620f7edbf69d = function(hostname) {
    return $a791f66905186165$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        "us-east-1",
        $a791f66905186165$var$AWS_PARTITION_SUFFIX
    ] : $a791f66905186165$var$getRegionalSuffix(hostname);
};
var $a791f66905186165$export$9822f1db281a24ef = function(hostname) {
    return $a791f66905186165$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        hostname.replace("." + $a791f66905186165$var$AWS_PARTITION_SUFFIX, ""),
        $a791f66905186165$var$AWS_PARTITION_SUFFIX
    ] : $a791f66905186165$var$getRegionalSuffix(hostname);
};
var $a791f66905186165$export$9d570635889bea10 = function(options) {
    if (options.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
    if (options.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
    if (!options.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN");
};
var $a791f66905186165$export$56395344d8f6da92 = function(service) {
    if (service !== "s3" && service !== "s3-outposts") throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
};
var $a791f66905186165$export$ee796dc843960f7e = function(service) {
    if (service !== "s3") throw new Error("Expect 's3' in Accesspoint ARN service component");
};
var $a791f66905186165$export$32ff3a9330dbd031 = function(service) {
    if (service !== "s3-outposts") throw new Error("Expect 's3-posts' in Outpost ARN service component");
};
var $a791f66905186165$export$2514cb957fb286b = function(partition, options) {
    if (partition !== options.clientPartition) throw new Error("Partition in ARN is incompatible, got \"" + partition + "\" but expected \"" + options.clientPartition + "\"");
};
var $a791f66905186165$export$6cc2fb0ca7159d47 = function(region, options) {
    if (region === "") throw new Error("ARN region is empty");
    if (!options.useArnRegion && !$a791f66905186165$var$isEqualRegions(region, options.clientRegion) && !$a791f66905186165$var$isEqualRegions(region, options.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
    if (options.useArnRegion && $a791f66905186165$var$isFipsRegion(region)) throw new Error("Endpoint does not support FIPS region");
};
var $a791f66905186165$var$isFipsRegion = function(region) {
    return region.startsWith("fips-") || region.endsWith("-fips");
};
var $a791f66905186165$var$isEqualRegions = function(regionA, regionB) {
    return regionA === regionB || $a791f66905186165$export$2041e7d2db741fc6(regionA) === regionB || regionA === $a791f66905186165$export$2041e7d2db741fc6(regionB);
};
var $a791f66905186165$export$311f0c1e79834f5a = function(accountId) {
    if (!/[0-9]{12}/.exec(accountId)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
};
var $a791f66905186165$export$eab3c0a6ee9b0457 = function(label, options) {
    if (options === void 0) options = {
        tlsCompatible: true
    };
    // reference: https://tools.ietf.org/html/rfc3986#section-3.2.2
    if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && $a791f66905186165$export$b0b24e5455be29b0.test(label)) throw new Error("Invalid DNS label " + label);
};
var $a791f66905186165$export$6b274ce9ea6c3c3a = function(resource) {
    var delimiter = resource.includes(":") ? ":" : "/";
    var _a = (0, $2R3UW.__read)(resource.split(delimiter)), resourceType = _a[0], rest = _a.slice(1);
    if (resourceType === "accesspoint") {
        // Parse accesspoint ARN
        if (rest.length !== 1 || rest[0] === "") throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
        return {
            accesspointName: rest[0]
        };
    } else if (resourceType === "outpost") {
        // Parse outpost ARN
        if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
        var _b = (0, $2R3UW.__read)(rest, 3), outpostId = _b[0], _ = _b[1], accesspointName = _b[2];
        return {
            outpostId: outpostId,
            accesspointName: accesspointName
        };
    } else throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
};
var $a791f66905186165$export$76b09f028141bdfc = function(dualstackEndpoint) {
    if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with Outpost");
};
var $a791f66905186165$export$8b4c0cb10287799f = function(region) {
    if ($a791f66905186165$var$isFipsRegion(region !== null && region !== void 0 ? region : "")) throw new Error("FIPS region is not supported with Outpost, got " + region);
};


var $65d2b53be0f991ca$export$92dc36ff3a4794f7 = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname, dualstackEndpoint = options.dualstackEndpoint, accelerateEndpoint = options.accelerateEndpoint;
    if (isCustomEndpoint) {
        if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with custom endpoint");
        if (accelerateEndpoint) throw new Error("Accelerate endpoint is not supported with custom endpoint");
    }
    return (0, $a791f66905186165$export$5b522ec9d0d23583)(options) ? $65d2b53be0f991ca$var$getEndpointFromBucketName((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    })) : $65d2b53be0f991ca$var$getEndpointFromArn((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    }));
};
var $65d2b53be0f991ca$var$getEndpointFromArn = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname;
    var _a = (0, $2R3UW.__read)(isCustomEndpoint ? [
        options.clientRegion,
        baseHostname
    ] : (0, $a791f66905186165$export$9822f1db281a24ef)(baseHostname), 2), clientRegion = _a[0], hostnameSuffix = _a[1];
    var pathStyleEndpoint = options.pathStyleEndpoint, _b = options.dualstackEndpoint, dualstackEndpoint = _b === void 0 ? false : _b, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
    (0, $a791f66905186165$export$9d570635889bea10)({
        pathStyleEndpoint: pathStyleEndpoint,
        accelerateEndpoint: accelerateEndpoint,
        tlsCompatible: tlsCompatible
    });
    // Validate and parse the ARN supplied as a bucket name
    var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
    (0, $a791f66905186165$export$56395344d8f6da92)(service);
    (0, $a791f66905186165$export$2514cb957fb286b)(partition, {
        clientPartition: clientPartition
    });
    (0, $a791f66905186165$export$311f0c1e79834f5a)(accountId);
    (0, $a791f66905186165$export$6cc2fb0ca7159d47)(region, {
        useArnRegion: useArnRegion,
        clientRegion: clientRegion,
        clientSigningRegion: clientSigningRegion
    });
    var _g = (0, $a791f66905186165$export$6b274ce9ea6c3c3a)(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
    (0, $a791f66905186165$export$eab3c0a6ee9b0457)(accesspointName + "-" + accountId, {
        tlsCompatible: tlsCompatible
    });
    var endpointRegion = useArnRegion ? region : clientRegion;
    var signingRegion = useArnRegion ? region : clientSigningRegion;
    if (outpostId) {
        // if this is an Outpost ARN
        (0, $a791f66905186165$export$32ff3a9330dbd031)(service);
        (0, $a791f66905186165$export$eab3c0a6ee9b0457)(outpostId, {
            tlsCompatible: tlsCompatible
        });
        (0, $a791f66905186165$export$76b09f028141bdfc)(dualstackEndpoint);
        (0, $a791f66905186165$export$8b4c0cb10287799f)(endpointRegion);
        var hostnamePrefix_1 = accesspointName + "-" + accountId + "." + outpostId;
        return {
            bucketEndpoint: true,
            hostname: "" + hostnamePrefix_1 + (isCustomEndpoint ? "" : ".s3-outposts." + endpointRegion) + "." + hostnameSuffix,
            signingRegion: signingRegion,
            signingService: "s3-outposts"
        };
    }
    // construct endpoint from Accesspoint ARN
    (0, $a791f66905186165$export$ee796dc843960f7e)(service);
    var hostnamePrefix = accesspointName + "-" + accountId;
    return {
        bucketEndpoint: true,
        hostname: "" + hostnamePrefix + (isCustomEndpoint ? "" : ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion) + "." + hostnameSuffix,
        signingRegion: signingRegion
    };
};
var $65d2b53be0f991ca$var$getEndpointFromBucketName = function(_a) {
    var _b = _a.accelerateEndpoint, accelerateEndpoint = _b === void 0 ? false : _b, region = _a.clientRegion, baseHostname = _a.baseHostname, bucketName = _a.bucketName, _c = _a.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e, _f = _a.isCustomEndpoint, isCustomEndpoint = _f === void 0 ? false : _f;
    var _g = (0, $2R3UW.__read)(isCustomEndpoint ? [
        region,
        baseHostname
    ] : (0, $a791f66905186165$export$661d620f7edbf69d)(baseHostname), 2), clientRegion = _g[0], hostnameSuffix = _g[1];
    if (pathStyleEndpoint || !(0, $a791f66905186165$export$360a1e07839d0d27)(bucketName) || tlsCompatible && (0, $a791f66905186165$export$b0b24e5455be29b0).test(bucketName)) return {
        bucketEndpoint: false,
        hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
    if (accelerateEndpoint) baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
    else if (dualstackEndpoint) baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
    return {
        bucketEndpoint: true,
        hostname: bucketName + "." + baseHostname
    };
};



var $42663689ef2a8539$export$f49f3b47ec112939 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, clientRegion, _e, _f, hostname, bucketEndpoint;
                return (0, $2R3UW.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            bucketName = args.input.Bucket;
                            replaceBucketInPath = options.bucketEndpoint;
                            request = args.request;
                            if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) return [
                                3 /*break*/ ,
                                8
                            ];
                            if (!options.bucketEndpoint) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = bucketName;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 1:
                            if (!(0, $eed3434c8e549594$export$a22775fa5e2eebd9)(bucketName)) return [
                                3 /*break*/ ,
                                5
                            ];
                            bucketArn = (0, $eed3434c8e549594$export$98e6a39c04603d36)(bucketName);
                            _a = (0, $a791f66905186165$export$2041e7d2db741fc6);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 2:
                            clientRegion = _a.apply(void 0, [
                                _g.sent()
                            ]);
                            return [
                                4 /*yield*/ ,
                                options.regionInfoProvider(clientRegion)
                            ];
                        case 3:
                            _b = _g.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
                            return [
                                4 /*yield*/ ,
                                options.useArnRegion()
                            ];
                        case 4:
                            useArnRegion = _g.sent();
                            _d = (0, $65d2b53be0f991ca$export$92dc36ff3a4794f7)({
                                bucketName: bucketArn,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                useArnRegion: useArnRegion,
                                clientPartition: partition,
                                clientSigningRegion: signingRegion,
                                clientRegion: clientRegion,
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
                            // If the request needs to use a region or service name inferred from ARN that different from client region, we
                            // need to set them in the handler context so the signer will use them
                            if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) context["signing_region"] = modifiedSigningRegion;
                            if (signingService && signingService !== "s3") context["signing_service"] = signingService;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 5:
                            _e = (0, $a791f66905186165$export$2041e7d2db741fc6);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 6:
                            clientRegion = _e.apply(void 0, [
                                _g.sent()
                            ]);
                            _f = (0, $65d2b53be0f991ca$export$92dc36ff3a4794f7)({
                                bucketName: bucketName,
                                clientRegion: clientRegion,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _f.hostname, bucketEndpoint = _f.bucketEndpoint;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            _g.label = 7;
                        case 7:
                            if (replaceBucketInPath) {
                                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                                if (request.path === "") request.path = "/";
                            }
                            _g.label = 8;
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $42663689ef2a8539$export$3912e6e4bed18209 = {
    tags: [
        "BUCKET_ENDPOINT"
    ],
    name: "bucketEndpointMiddleware",
    relation: "before",
    toMiddleware: "hostHeaderMiddleware",
    override: true
};
var $42663689ef2a8539$export$6b750e866330f2fe = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($42663689ef2a8539$export$f49f3b47ec112939(options), $42663689ef2a8539$export$3912e6e4bed18209);
        }
    };
};




var $2R3UW = parcelRequire("2R3UW");
function $16bf2ba28079505f$export$9810f1a949e3136(input) {
    var _a = input.bucketEndpoint, bucketEndpoint = _a === void 0 ? false : _a, _b = input.forcePathStyle, forcePathStyle = _b === void 0 ? false : _b, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        bucketEndpoint: bucketEndpoint,
        forcePathStyle: forcePathStyle,
        useAccelerateEndpoint: useAccelerateEndpoint,
        useDualstackEndpoint: useDualstackEndpoint,
        useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
            return Promise.resolve(useArnRegion);
        }
    });
}
var $16bf2ba28079505f$export$7eb281bbdddd5d12 = "AWS_S3_USE_ARN_REGION";
var $16bf2ba28079505f$export$812c693bf225d32a = "s3_use_arn_region";
var $16bf2ba28079505f$export$bac037ab69dc2bd4 = {
    environmentVariableSelector: function(env) {
        if (!Object.prototype.hasOwnProperty.call(env, $16bf2ba28079505f$export$7eb281bbdddd5d12)) return undefined;
        if (env[$16bf2ba28079505f$export$7eb281bbdddd5d12] === "true") return true;
        if (env[$16bf2ba28079505f$export$7eb281bbdddd5d12] === "false") return false;
        throw new Error("Cannot load env " + $16bf2ba28079505f$export$7eb281bbdddd5d12 + ". Expected \"true\" or \"false\", got " + env[$16bf2ba28079505f$export$7eb281bbdddd5d12] + ".");
    },
    configFileSelector: function(profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, $16bf2ba28079505f$export$812c693bf225d32a)) return undefined;
        if (profile[$16bf2ba28079505f$export$812c693bf225d32a] === "true") return true;
        if (profile[$16bf2ba28079505f$export$812c693bf225d32a] === "false") return false;
        throw new Error("Cannot load shared config entry " + $16bf2ba28079505f$export$812c693bf225d32a + ". Expected \"true\" or \"false\", got " + profile[$16bf2ba28079505f$export$812c693bf225d32a] + ".");
    },
    default: false
};






var $2R3UW = parcelRequire("2R3UW");

function $613a372f210c2330$export$97e70cdcaaace32a() {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                var Bucket, err;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    Bucket = args.input.Bucket;
                    if (typeof Bucket === "string" && !(0, $eed3434c8e549594$export$a22775fa5e2eebd9)(Bucket) && Bucket.indexOf("/") >= 0) {
                        err = new Error("Bucket name shouldn't contain '/', received '" + Bucket + "'");
                        err.name = "InvalidBucketName";
                        throw err;
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $2R3UW.__assign)({}, args))
                    ];
                });
            });
        };
    };
}
var $613a372f210c2330$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware",
    override: true
};
var $613a372f210c2330$export$c30d61978fbb3ad8 = function(unused) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($613a372f210c2330$export$97e70cdcaaace32a(), $613a372f210c2330$export$db8005617bec77bd);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");

var $3eca2cc053a5f942$export$47830883dba0cb3a = function(config) {
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            request = args.request;
                            if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request) || config.isCustomEndpoint) return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)({}, args))
                            ];
                            if (!(request.hostname === "s3.amazonaws.com")) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = "s3.us-east-1.amazonaws.com";
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            _a = "aws-global";
                            return [
                                4 /*yield*/ ,
                                config.region()
                            ];
                        case 2:
                            if (_a === _b.sent()) request.hostname = "s3.amazonaws.com";
                            _b.label = 3;
                        case 3:
                            return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)({}, args))
                            ];
                    }
                });
            });
        };
    };
};
var $3eca2cc053a5f942$export$984fdb6c4de63240 = {
    step: "build",
    tags: [
        "USE_REGIONAL_ENDPOINT",
        "S3"
    ],
    name: "useRegionalEndpointMiddleware",
    override: true
};
var $3eca2cc053a5f942$export$8512187c26b3935b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($3eca2cc053a5f942$export$47830883dba0cb3a(config), $3eca2cc053a5f942$export$984fdb6c4de63240);
        }
    };
};



var $2R3UW = parcelRequire("2R3UW");

var $2d7f04572123fd3f$export$61d7988259be6660 = function(config) {
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                var result, response, statusCode, body, bodyBytes, bodyString, err;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            result = _a.sent();
                            response = result.response;
                            if (!(0, $f2e608cd2926439a$export$1d94dfe0d9d1f1e7).isInstance(response)) return [
                                2 /*return*/ ,
                                result
                            ];
                            statusCode = response.statusCode, body = response.body;
                            if (statusCode < 200 && statusCode >= 300) return [
                                2 /*return*/ ,
                                result
                            ];
                            return [
                                4 /*yield*/ ,
                                $2d7f04572123fd3f$var$collectBody(body, config)
                            ];
                        case 2:
                            bodyBytes = _a.sent();
                            return [
                                4 /*yield*/ ,
                                $2d7f04572123fd3f$var$collectBodyString(bodyBytes, config)
                            ];
                        case 3:
                            bodyString = _a.sent();
                            if (bodyBytes.length === 0) {
                                err = new Error("S3 aborted request");
                                err.name = "InternalError";
                                throw err;
                            }
                            if (bodyString && bodyString.match("<Error>")) // Set the error code to 4XX so that error deserializer can parse them
                            response.statusCode = 400;
                            // Body stream is consumed and paused at this point. So replace the response.body to the collected bytes.
                            // So that the deserializer can consume the body as normal.
                            response.body = bodyBytes;
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
    };
};
// Collect low-level response body stream to Uint8Array.
var $2d7f04572123fd3f$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $2d7f04572123fd3f$var$collectBodyString = function(streamBody, context) {
    return $2d7f04572123fd3f$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $2d7f04572123fd3f$export$ea0247469da1888 = {
    relation: "after",
    toMiddleware: "deserializerMiddleware",
    tags: [
        "THROW_200_EXCEPTIONS",
        "S3"
    ],
    name: "throw200ExceptionsMiddleware",
    override: true
};
var $2d7f04572123fd3f$export$97cbbd0d754f3189 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($2d7f04572123fd3f$export$61d7988259be6660(config), $2d7f04572123fd3f$export$ea0247469da1888);
        }
    };
};






var $2R3UW = parcelRequire("2R3UW");
function $298fba8493d5052b$export$16515ae394ee1bc8(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a, _b, _c, _d, e_1_1;
                var e_1, _e, _f;
                return (0, $2R3UW.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            input = (0, $2R3UW.__assign)({}, args.input);
                            properties = [
                                {
                                    target: "SSECustomerKey",
                                    hash: "SSECustomerKeyMD5"
                                },
                                {
                                    target: "CopySourceSSECustomerKey",
                                    hash: "CopySourceSSECustomerKeyMD5"
                                }
                            ];
                            _g.label = 1;
                        case 1:
                            _g.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            properties_1 = (0, $2R3UW.__values)(properties), properties_1_1 = properties_1.next();
                            _g.label = 2;
                        case 2:
                            if (!!properties_1_1.done) return [
                                3 /*break*/ ,
                                5
                            ];
                            prop = properties_1_1.value;
                            value = input[prop.target];
                            if (!value) return [
                                3 /*break*/ ,
                                4
                            ];
                            valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                            encoded = options.base64Encoder(valueView);
                            hash = new options.md5();
                            hash.update(valueView);
                            _a = [
                                (0, $2R3UW.__assign)({}, input)
                            ];
                            _f = {}, _f[prop.target] = encoded;
                            _b = prop.hash;
                            _d = (_c = options).base64Encoder;
                            return [
                                4 /*yield*/ ,
                                hash.digest()
                            ];
                        case 3:
                            input = (0, $2R3UW.__assign).apply(void 0, _a.concat([
                                (_f[_b] = _d.apply(_c, [
                                    _g.sent()
                                ]), _f)
                            ]));
                            _g.label = 4;
                        case 4:
                            properties_1_1 = properties_1.next();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 6:
                            e_1_1 = _g.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            try {
                                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return)) _e.call(properties_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                                    input: input
                                }))
                            ];
                    }
                });
            });
        };
    };
}
var $298fba8493d5052b$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ],
    override: true
};
var $298fba8493d5052b$export$baf25e0187b0946b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($298fba8493d5052b$export$16515ae394ee1bc8(config), $298fba8493d5052b$export$bd3ed071b8ca05b3);
        }
    };
};



/**
 * <p>Creates a copy of an object that is already stored in Amazon S3.</p>
 *          <note>
 *             <p>You can store individual objects of up to 5 TB in Amazon S3. You create a copy of your
 *             object up to 5 GB in size in a single atomic operation using this API. However, to copy
 *             an object greater than 5 GB, you must use the multipart upload Upload Part - Copy API.
 *             For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/CopyingObjctsUsingRESTMPUapi.html">Copy Object Using the REST Multipart Upload API</a>.</p>
 *          </note>
 *          <p>All copy requests must be authenticated. Additionally, you must have
 *             <i>read</i> access to the source object and <i>write</i>
 *          access to the destination bucket. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/RESTAuthentication.html">REST Authentication</a>. Both the Region
 *          that you want to copy the object from and the Region that you want to copy the object to
 *          must be enabled for your account.</p>
 *          <p>A copy request might return an error when Amazon S3 receives the copy request or while Amazon S3
 *          is copying the files. If the error occurs before the copy operation starts, you receive a
 *          standard Amazon S3 error. If the error occurs during the copy operation, the error response is
 *          embedded in the <code>200 OK</code> response. This means that a <code>200 OK</code>
 *          response can contain either a success or an error. Design your application to parse the
 *          contents of the response and handle it appropriately.</p>
 *          <p>If the copy is successful, you receive a response with information about the copied
 *          object.</p>
 *          <note>
 *             <p>If the request is an HTTP 1.1 request, the response is chunk encoded. If it were not,
 *             it would not contain the content-length, and you would need to read the entire
 *             body.</p>
 *          </note>
 *          <p>The copy request charge is based on the storage class and Region that you specify for
 *          the destination object. For pricing information, see <a href="https://aws.amazon.com/s3/pricing/">Amazon S3 pricing</a>.</p>
 *          <important>
 *             <p>Amazon S3 transfer acceleration does not support cross-Region copies. If you request a
 *             cross-Region copy using a transfer acceleration endpoint, you get a 400 <code>Bad
 *                Request</code> error. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/transfer-acceleration.html">Transfer Acceleration</a>.</p>
 *          </important>
 *          <p>
 *             <b>Metadata</b>
 *          </p>
 *          <p>When copying an object, you can preserve all metadata (default) or specify new metadata.
 *          However, the ACL is not preserved and is set to private for the user making the request. To
 *          override the default ACL setting, specify a new ACL when generating a copy request. For
 *          more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3_ACLs_UsingACLs.html">Using ACLs</a>. </p>
 *          <p>To specify whether you want the object metadata copied from the source object or
 *          replaced with metadata provided in the request, you can optionally add the
 *             <code>x-amz-metadata-directive</code> header. When you grant permissions, you can use
 *          the <code>s3:x-amz-metadata-directive</code> condition key to enforce certain metadata
 *          behavior when objects are uploaded. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/amazon-s3-policy-keys.html">Specifying Conditions in a
 *             Policy</a> in the <i>Amazon S3 Developer Guide</i>. For a complete list of
 *          Amazon S3-specific condition keys, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/list_amazons3.html">Actions, Resources, and Condition Keys for
 *             Amazon S3</a>.</p>
 *          <p>
 *             <b>
 *                <code>x-amz-copy-source-if</code> Headers</b>
 *          </p>
 *          <p>To only copy an object under certain conditions, such as whether the <code>Etag</code>
 *          matches or whether the object was modified before or after a specified date, use the
 *          following request parameters:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-match</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-none-match</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-unmodified-since</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-modified-since</code>
 *                </p>
 *             </li>
 *          </ul>
 *          <p> If both the <code>x-amz-copy-source-if-match</code> and
 *             <code>x-amz-copy-source-if-unmodified-since</code> headers are present in the request
 *          and evaluate as follows, Amazon S3 returns <code>200 OK</code> and copies the data:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-match</code> condition evaluates to true</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-unmodified-since</code> condition evaluates to
 *                false</p>
 *             </li>
 *          </ul>
 *
 *          <p>If both the <code>x-amz-copy-source-if-none-match</code> and
 *             <code>x-amz-copy-source-if-modified-since</code> headers are present in the request and
 *          evaluate as follows, Amazon S3 returns the <code>412 Precondition Failed</code> response
 *          code:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-none-match</code> condition evaluates to false</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>x-amz-copy-source-if-modified-since</code> condition evaluates to
 *                true</p>
 *             </li>
 *          </ul>
 *
 *          <note>
 *             <p>All headers with the <code>x-amz-</code> prefix, including
 *                <code>x-amz-copy-source</code>, must be signed.</p>
 *          </note>
 *          <p>
 *             <b>Server-side encryption</b>
 *          </p>
 *          <p>When you perform a CopyObject operation, you can optionally use the appropriate encryption-related headers to encrypt the object using server-side encryption with AWS managed encryption keys (SSE-S3 or SSE-KMS) or a customer-provided encryption key. With server-side encryption, Amazon S3 encrypts your data as it writes it to disks in its data centers and decrypts the data when you access it. For more information about server-side encryption, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/serv-side-encryption.html">Using
 *          Server-Side Encryption</a>.</p>
 *          <p>If a target object uses SSE-KMS, you can enable an S3 Bucket Key for the object. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/bucket-key.html">Amazon S3 Bucket Keys</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Access Control List (ACL)-Specific Request
 *          Headers</b>
 *          </p>
 *          <p>When copying an object, you can optionally use headers to grant ACL-based permissions.
 *          By default, all objects are private. Only the owner has full access control. When adding a
 *          new object, you can grant permissions to individual AWS accounts or to predefined groups
 *          defined by Amazon S3. These permissions are then added to the ACL on the object. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List (ACL) Overview</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-using-rest-api.html">Managing ACLs Using the REST
 *             API</a>. </p>
 *
 *          <p>
 *             <b>Storage Class Options</b>
 *          </p>
 *          <p>You can use the <code>CopyObject</code> operation to change the storage class of an
 *          object that is already stored in Amazon S3 using the <code>StorageClass</code> parameter. For
 *          more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/storage-class-intro.html">Storage
 *             Classes</a> in the <i>Amazon S3 Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>By default, <code>x-amz-copy-source</code> identifies the current version of an object
 *          to copy. If the current version is a delete marker, Amazon S3 behaves as if the object was
 *          deleted. To copy a different version, use the <code>versionId</code> subresource.</p>
 *          <p>If you enable versioning on the target bucket, Amazon S3 generates a unique version ID for
 *          the object being copied. This version ID is different from the version ID of the source
 *          object. Amazon S3 returns the version ID of the copied object in the
 *             <code>x-amz-version-id</code> response header in the response.</p>
 *          <p>If you do not enable versioning or suspend it on the target bucket, the version ID that
 *          Amazon S3 generates is always null.</p>
 *          <p>If the source object's storage class is GLACIER, you must restore a copy of this object
 *          before you can use it as a source object for the copy operation. For more information, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_RestoreObject.html">RestoreObject</a>.</p>
 *          <p>The following operations are related to <code>CopyObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObject.html">GetObject</a>
 *                </p>
 *             </li>
 *          </ul>
 *          <p>For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/CopyingObjectsExamples.html">Copying
 *             Objects</a>.</p>
 */ var $00fdd9074c84ffcd$export$dae1e139b4ba0d49 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(CopyObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CopyObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CopyObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $2d7f04572123fd3f$export$97cbbd0d754f3189)(configuration));
        this.middlewareStack.use((0, $298fba8493d5052b$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CopyObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$e84f0e76c8b259eb).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$a9f99871811ebc49).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CopyObjectCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$3fa883360ffbe82d)(input, context);
    };
    CopyObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$a5d77c8b6651b993)(output, context);
    };
    return CopyObjectCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));







/**
 * <p>Removes the null version (if there is one) of an object and inserts a delete marker,
 *          which becomes the latest version of the object. If there isn't a null version, Amazon S3 does
 *          not remove any objects.</p>
 *
 *          <p>To remove a specific version, you must be the bucket owner and you must use the version
 *          Id subresource. Using this subresource permanently deletes the version. If the object
 *          deleted is a delete marker, Amazon S3 sets the response header,
 *          <code>x-amz-delete-marker</code>, to true. </p>
 *
 *          <p>If the object you want to delete is in a bucket where the bucket versioning
 *          configuration is MFA Delete enabled, you must include the <code>x-amz-mfa</code> request
 *          header in the DELETE <code>versionId</code> request. Requests that include
 *             <code>x-amz-mfa</code> must use HTTPS. </p>
 *
 *          <p> For more information about MFA Delete, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMFADelete.html">Using MFA Delete</a>. To see sample requests that use versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/RESTObjectDELETE.html#ExampleVersionObjectDelete">Sample Request</a>. </p>
 *
 *          <p>You can delete objects by explicitly calling the DELETE Object API or configure its
 *          lifecycle (<a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketLifecycle.html">PutBucketLifecycle</a>) to
 *          enable Amazon S3 to remove them for you. If you want to block users or accounts from removing or
 *          deleting objects from your bucket, you must deny them the <code>s3:DeleteObject</code>,
 *             <code>s3:DeleteObjectVersion</code>, and <code>s3:PutLifeCycleConfiguration</code>
 *          actions. </p>
 *
 *          <p>The following operation is related to <code>DeleteObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $7b3e3a34c31e036b$export$d60592d05571c4ef = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(DeleteObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DeleteObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$7d123f24a24f15cf).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$64d4f4fac943bc25).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$400c19cbac9616f7)(input, context);
    };
    DeleteObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$987b292ae9f16665)(output, context);
    };
    return DeleteObjectCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));








/**
 * <p>Retrieves objects from Amazon S3. To use <code>GET</code>, you must have <code>READ</code>
 *          access to the object. If you grant <code>READ</code> access to the anonymous user, you can
 *          return the object without using an authorization header.</p>
 *
 *          <p>An Amazon S3 bucket has no directory hierarchy such as you would find in a typical computer
 *          file system. You can, however, create a logical hierarchy by using object key names that
 *          imply a folder structure. For example, instead of naming an object <code>sample.jpg</code>,
 *          you can name it <code>photos/2006/February/sample.jpg</code>.</p>
 *
 *          <p>To get an object from such a logical hierarchy, specify the full key name for the object
 *          in the <code>GET</code> operation. For a virtual hosted-style request example, if you have
 *          the object <code>photos/2006/February/sample.jpg</code>, specify the resource as
 *             <code>/photos/2006/February/sample.jpg</code>. For a path-style request example, if you
 *          have the object <code>photos/2006/February/sample.jpg</code> in the bucket named
 *             <code>examplebucket</code>, specify the resource as
 *             <code>/examplebucket/photos/2006/February/sample.jpg</code>. For more information about
 *          request types, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/VirtualHosting.html#VirtualHostingSpecifyBucket">HTTP Host Header Bucket Specification</a>.</p>
 *
 *          <p>To distribute large files to many people, you can save bandwidth costs by using
 *          BitTorrent. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3Torrent.html">Amazon S3
 *             Torrent</a>. For more information about returning the ACL of an object, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>.</p>
 *
 *          <p>If the object you are retrieving is stored in the S3 Glacier or
 *          S3 Glacier Deep Archive storage class, or S3 Intelligent-Tiering Archive or
 *          S3 Intelligent-Tiering Deep Archive tiers, before you can retrieve the object you must first restore a
 *          copy using <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_RestoreObject.html">RestoreObject</a>. Otherwise, this operation returns an
 *             <code>InvalidObjectStateError</code> error. For information about restoring archived
 *          objects, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/restoring-objects.html">Restoring Archived
 *             Objects</a>.</p>
 *
 *          <p>Encryption request headers, like <code>x-amz-server-side-encryption</code>, should not
 *          be sent for GET requests if your object uses server-side encryption with CMKs stored in AWS
 *          KMS (SSE-KMS) or server-side encryption with Amazon S3–managed encryption keys (SSE-S3). If your
 *          object does use these types of keys, you’ll get an HTTP 400 BadRequest error.</p>
 *          <p>If you encrypt an object by using server-side encryption with customer-provided
 *          encryption keys (SSE-C) when you store the object in Amazon S3, then when you GET the object,
 *          you must use the following headers:</p>
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *          <p>For more information about SSE-C, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ServerSideEncryptionCustomerKeys.html">Server-Side Encryption (Using
 *             Customer-Provided Encryption Keys)</a>.</p>
 *
 *          <p>Assuming you have permission to read object tags (permission for the
 *             <code>s3:GetObjectVersionTagging</code> action), the response also returns the
 *             <code>x-amz-tagging-count</code> header that provides the count of number of tags
 *          associated with the object. You can use <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectTagging.html">GetObjectTagging</a> to retrieve
 *          the tag set associated with an object.</p>
 *
 *          <p>
 *             <b>Permissions</b>
 *          </p>
 *          <p>You need the <code>s3:GetObject</code> permission for this operation. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/using-with-s3-actions.html">Specifying Permissions
 *             in a Policy</a>. If the object you request does not exist, the error Amazon S3 returns
 *          depends on whether you also have the <code>s3:ListBucket</code> permission.</p>
 *          <ul>
 *             <li>
 *                <p>If you have the <code>s3:ListBucket</code> permission on the bucket, Amazon S3 will
 *                return an HTTP status code 404 ("no such key") error.</p>
 *             </li>
 *             <li>
 *                <p>If you don’t have the <code>s3:ListBucket</code> permission, Amazon S3 will return an
 *                HTTP status code 403 ("access denied") error.</p>
 *             </li>
 *          </ul>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>By default, the GET operation returns the current version of an object. To return a
 *          different version, use the <code>versionId</code> subresource.</p>
 *
 *          <note>
 *             <p>If the current version of the object is a delete marker, Amazon S3 behaves as if the
 *             object was deleted and includes <code>x-amz-delete-marker: true</code> in the
 *             response.</p>
 *          </note>
 *
 *
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketVersioning.html">PutBucketVersioning</a>. </p>
 *
 *          <p>
 *             <b>Overriding Response Header Values</b>
 *          </p>
 *          <p>There are times when you want to override certain response header values in a GET
 *          response. For example, you might override the Content-Disposition response header value in
 *          your GET request.</p>
 *
 *          <p>You can override values for a set of response headers using the following query
 *          parameters. These response header values are sent only on a successful request, that is,
 *          when status code 200 OK is returned. The set of headers you can override using these
 *          parameters is a subset of the headers that Amazon S3 accepts when you create an object. The
 *          response headers that you can override for the GET response are <code>Content-Type</code>,
 *             <code>Content-Language</code>, <code>Expires</code>, <code>Cache-Control</code>,
 *             <code>Content-Disposition</code>, and <code>Content-Encoding</code>. To override these
 *          header values in the GET response, you use the following request parameters.</p>
 *
 *          <note>
 *             <p>You must sign the request, either using an Authorization header or a presigned URL,
 *             when using these parameters. They cannot be used with an unsigned (anonymous)
 *             request.</p>
 *          </note>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>response-content-type</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-language</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-expires</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-cache-control</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-disposition</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-encoding</code>
 *                </p>
 *             </li>
 *          </ul>
 *
 *          <p>
 *             <b>Additional Considerations about Request Headers</b>
 *          </p>
 *
 *          <p>If both of the <code>If-Match</code> and <code>If-Unmodified-Since</code> headers are
 *          present in the request as follows: <code>If-Match</code> condition evaluates to
 *             <code>true</code>, and; <code>If-Unmodified-Since</code> condition evaluates to
 *             <code>false</code>; then, S3 returns 200 OK and the data requested. </p>
 *
 *          <p>If both of the <code>If-None-Match</code> and <code>If-Modified-Since</code> headers are
 *          present in the request as follows:<code> If-None-Match</code> condition evaluates to
 *             <code>false</code>, and; <code>If-Modified-Since</code> condition evaluates to
 *             <code>true</code>; then, S3 returns 304 Not Modified response code.</p>
 *
 *          <p>For more information about conditional requests, see <a href="https://tools.ietf.org/html/rfc7232">RFC 7232</a>.</p>
 *
 *          <p>The following operations are related to <code>GetObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $bd3eb4860b3b163e$export$25364b3fa12a4666 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(GetObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $298fba8493d5052b$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$3373ea9743883feb).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$9fb6bec1a5c954d6).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$713ae52666bf2204)(input, context);
    };
    GetObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$c8faba1b7abd4024)(output, context);
    };
    return GetObjectCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));







/**
 * <p>Returns some or all (up to 1,000) of the objects in a bucket. You can use the request
 *          parameters as selection criteria to return a subset of the objects in a bucket. A <code>200
 *             OK</code> response can contain valid or invalid XML. Make sure to design your
 *          application to parse the contents of the response and handle it appropriately.</p>
 *
 *          <p>To use this operation, you must have READ access to the bucket.</p>
 *
 *          <p>To use this operation in an AWS Identity and Access Management (IAM) policy, you must
 *          have permissions to perform the <code>s3:ListBucket</code> action. The bucket owner has
 *          this permission by default and can grant this permission to others. For more information
 *          about permissions, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/using-with-s3-actions.html#using-with-s3-actions-related-to-bucket-subresources">Permissions Related to Bucket Subresource Operations</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/s3-access-control.html">Managing Access Permissions to Your Amazon S3
 *             Resources</a>.</p>
 *          <important>
 *             <p>This section describes the latest revision of the API. We recommend that you use this
 *             revised API for application development. For backward compatibility, Amazon S3 continues to
 *             support the prior version of this API, <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListObjects.html">ListObjects</a>.</p>
 *          </important>
 *
 *          <p>To get a list of your buckets, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>.</p>
 *
 *          <p>The following operations are related to <code>ListObjectsV2</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObject.html">GetObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateBucket.html">CreateBucket</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $c1bd55dc3f94b37f$export$479061a53a55f030 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(ListObjectsV2Command, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsV2Command(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListObjectsV2Command.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListObjectsV2Command";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$32fa6adfa8e5165a).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$6fb2827b4fe28be3).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsV2Command.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$ea6ee77e40f86bd9)(input, context);
    };
    ListObjectsV2Command.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$2b371fcdd686ba8b)(output, context);
    };
    return ListObjectsV2Command;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));



function $d08e61eb983553d6$export$75025487296cba38(request) {
    var port = request.port, query = request.query;
    var protocol = request.protocol, path = request.path, hostname = request.hostname;
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    if (port) hostname += ":" + port;
    if (path && path.charAt(0) !== "/") path = "/" + path;
    var queryString = query ? (0, $abcb7d8a595a3dde$export$6b17a39e52c8ee53)(query) : "";
    if (queryString && queryString[0] !== "?") queryString = "?" + queryString;
    return protocol + "//" + hostname + path + queryString;
}



var $2R3UW = parcelRequire("2R3UW");
function $146355dbdccc18f4$export$72e3afa9ac8966be(client, command) {
    return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
        var interceptMiddleware, clientStack, handler;
        var _this = this;
        return (0, $2R3UW.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    interceptMiddleware = function(next) {
                        return function(args) {
                            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                                return (0, $2R3UW.__generator)(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            output: {
                                                request: args.request
                                            },
                                            response: undefined
                                        }
                                    ];
                                });
                            });
                        };
                    };
                    clientStack = client.middlewareStack.clone();
                    // @ts-ignore: add middleware to the last of 'build' step
                    clientStack.add(interceptMiddleware, {
                        step: "build",
                        priority: "low"
                    });
                    handler = command.resolveMiddleware(clientStack, client.config, undefined);
                    return [
                        4 /*yield*/ ,
                        handler(command).then(function(output) {
                            return output.output.request;
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}



var $2R3UW = parcelRequire("2R3UW");

var $65bf5eabc9bc0b8b$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $65bf5eabc9bc0b8b$export$eaef12179141669a = "X-Amz-Content-Sha256";
var $65bf5eabc9bc0b8b$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $65bf5eabc9bc0b8b$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $65bf5eabc9bc0b8b$export$6e114beec37430d7 = "X-Amz-Date";
var $65bf5eabc9bc0b8b$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $65bf5eabc9bc0b8b$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $65bf5eabc9bc0b8b$export$96307741595055fc = "host";
var $65bf5eabc9bc0b8b$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";


var $82c40c9e44f2041b$export$a1673011a6b3560f = /** @class */ function() {
    function S3RequestPresigner(options) {
        var resolvedOptions = (0, $2R3UW.__assign)({
            // Allow `signingName` because we want to support usecase of supply client's resolved config
            // directly. Where service equals signingName.
            service: options.signingName || options.service || "s3",
            uriEscapePath: options.uriEscapePath || false
        }, options);
        this.signer = new (0, $7b8a7d6416660eac$export$20baf4d3f65eb30c)(resolvedOptions);
    }
    S3RequestPresigner.prototype.presign = function(requestToSign, _a) {
        if (_a === void 0) _a = {};
        var _b = _a.unsignableHeaders, unsignableHeaders = _b === void 0 ? new Set() : _b, _c = _a.unhoistableHeaders, unhoistableHeaders = _c === void 0 ? new Set() : _c, options = (0, $2R3UW.__rest)(_a, [
            "unsignableHeaders",
            "unhoistableHeaders"
        ]);
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            return (0, $2R3UW.__generator)(this, function(_d) {
                unsignableHeaders.add("content-type");
                // S3 requires SSE headers to be signed in headers instead of query
                // See: https://github.com/aws/aws-sdk-js-v3/issues/1576
                Object.keys(requestToSign.headers).map(function(header) {
                    return header.toLowerCase();
                }).filter(function(header) {
                    return header.startsWith("x-amz-server-side-encryption");
                }).forEach(function(header) {
                    unhoistableHeaders.add(header);
                });
                requestToSign.headers[0, $65bf5eabc9bc0b8b$export$eaef12179141669a] = (0, $65bf5eabc9bc0b8b$export$91f7321b40d9fd07);
                if (!requestToSign.headers["host"]) requestToSign.headers.host = requestToSign.hostname;
                return [
                    2 /*return*/ ,
                    this.signer.presign(requestToSign, (0, $2R3UW.__assign)({
                        expiresIn: 900,
                        unsignableHeaders: unsignableHeaders,
                        unhoistableHeaders: unhoistableHeaders
                    }, options))
                ];
            });
        });
    };
    return S3RequestPresigner;
}();



var $2R3UW = parcelRequire("2R3UW");



var $216a315db834a91f$export$d6e65e470b2c127c = function(client, command, options) {
    if (options === void 0) options = {};
    return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
        var s3Presigner, presignInterceptMiddleware, middlewareName, presigned, output;
        return (0, $2R3UW.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    s3Presigner = new (0, $82c40c9e44f2041b$export$a1673011a6b3560f)((0, $2R3UW.__assign)({}, client.config));
                    presignInterceptMiddleware = function(next, context) {
                        return function(args) {
                            return (0, $2R3UW.__awaiter)(void 0, void 0, void 0, function() {
                                var request, presigned;
                                var _a, _b;
                                return (0, $2R3UW.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            request = args.request;
                                            if (!(0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request)) throw new Error("Request to be presigned is not an valid HTTP request.");
                                            // Retry information headers are not meaningful in presigned URLs
                                            delete request.headers["amz-sdk-invocation-id"];
                                            delete request.headers["amz-sdk-request"];
                                            return [
                                                4 /*yield*/ ,
                                                s3Presigner.presign(request, (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, options), {
                                                    signingRegion: (_a = options.signingRegion) !== null && _a !== void 0 ? _a : context["signing_region"],
                                                    signingService: (_b = options.signingService) !== null && _b !== void 0 ? _b : context["signing_service"]
                                                }))
                                            ];
                                        case 1:
                                            presigned = _c.sent();
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    // Intercept the middleware stack by returning fake response
                                                    response: {},
                                                    output: {
                                                        $metadata: {
                                                            httpStatusCode: 200
                                                        },
                                                        presigned: presigned
                                                    }
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                    };
                    middlewareName = "presignInterceptMiddleware";
                    client.middlewareStack.addRelativeTo(presignInterceptMiddleware, {
                        name: middlewareName,
                        relation: "before",
                        toMiddleware: "awsAuthMiddleware",
                        override: true
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        client.send(command)
                    ];
                case 2:
                    output = _a.sent();
                    //@ts-ignore the output is faked, so it's not actually OutputType
                    presigned = output.presigned;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    client.middlewareStack.remove(middlewareName);
                    return [
                        7 /*endfinally*/ 
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        (0, $d08e61eb983553d6$export$75025487296cba38)(presigned)
                    ];
            }
        });
    });
};




/*
 * Copyright 2017-2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $b065ee753212adbd$exports = {};

$b065ee753212adbd$exports = (parcelRequire("lb8R8"));



var $af8567358603a938$export$148a3867c72aff96;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = "source param should be an object with the property \"key\" with value of type string";
    StorageErrorStrings["NO_DEST_KEY"] = "destination param should be an object with the property \"key\" with value of type string";
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})($af8567358603a938$export$148a3867c72aff96 || ($af8567358603a938$export$148a3867c72aff96 = {}));
var $af8567358603a938$export$85f5425ead1c79c0;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})($af8567358603a938$export$85f5425ead1c79c0 || ($af8567358603a938$export$85f5425ead1c79c0 = {}));
var $af8567358603a938$export$179814ca32efa022;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})($af8567358603a938$export$179814ca32efa022 || ($af8567358603a938$export$179814ca32efa022 = {}));


var $150069abd9b86342$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $150069abd9b86342$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $150069abd9b86342$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('axios-http-handler');
var $150069abd9b86342$export$c5e6923933be22a0 = 'sendUploadProgress';
var $150069abd9b86342$export$660a92f3322ba11a = 'sendDownloadProgress';
function $150069abd9b86342$var$isBlob(body) {
    return typeof Blob !== 'undefined' && body instanceof Blob;
}
function $150069abd9b86342$var$hasErrorResponse(error) {
    return typeof error !== 'undefined' && Object.prototype.hasOwnProperty.call(error, 'response') && typeof error.response !== 'undefined' && Object.prototype.hasOwnProperty.call(error.response, 'status') && typeof error.response.status === 'number';
}
var $150069abd9b86342$var$normalizeHeaders = function(headers, normalizedName) {
    var e_1, _a;
    try {
        for(var _b = $150069abd9b86342$var$__values(Object.entries(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $150069abd9b86342$var$__read(_c.value, 2), k = _d[0], v = _d[1];
            if (k !== normalizedName && k.toUpperCase() === normalizedName.toUpperCase()) {
                headers[normalizedName] = v;
                delete headers[k];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
};
var $150069abd9b86342$export$7415af030ea6a2ae = [
    function(data, headers) {
        if ($150069abd9b86342$var$isBlob(data)) {
            $150069abd9b86342$var$normalizeHeaders(headers, 'Content-Type');
            $150069abd9b86342$var$normalizeHeaders(headers, 'Accept');
            return data;
        }
        // Axios' default transformRequest is an array
        return (0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).defaults.transformRequest[0].call(null, data, headers);
    }
];
var $150069abd9b86342$export$43af02f23afacda3 = /** @class */ function() {
    function AxiosHttpHandler(httpOptions, emitter, cancelTokenSource) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
        this.emitter = emitter;
        this.cancelTokenSource = cancelTokenSource;
    }
    AxiosHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    AxiosHttpHandler.prototype.handle = function(request, options) {
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        // prioritize the call specific event emitter, this is useful for multipart upload as each individual parts has
        // their own event emitter, without having to create s3client for every individual calls.
        var emitter = options.emitter || this.emitter;
        var path = request.path;
        if (request.query) {
            var queryString = (0, $abcb7d8a595a3dde$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : '') + path;
        var axiosRequest = {};
        axiosRequest.url = url;
        axiosRequest.method = request.method;
        axiosRequest.headers = request.headers;
        // The host header is automatically added by the browser and adding it explicitly in the
        // axios request throws an error https://github.com/aws-amplify/amplify-js/issues/5376
        // This is because the host header is a forbidden header for the http client to set
        // see https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name and
        // https://fetch.spec.whatwg.org/#forbidden-header-name
        // The reason we are removing this header here instead of in the aws-sdk's client
        // middleware is that the host header is required to be in the request signature and if
        // we remove it from the middlewares, then the request fails because the header is added
        // by the browser but is absent from the signature.
        delete axiosRequest.headers['host'];
        if (request.body) axiosRequest.data = request.body;
        else // Fix for https://github.com/aws-amplify/amplify-js/issues/5432
        // If the POST request body is empty but content-type header is set, axios is forcibly removing it
        // See https://github.com/axios/axios/issues/1535 and refusing to fix it https://github.com/axios/axios/issues/755
        // This change is a workaround to set the data as null (instead of undefined) to prevent axios from
        // removing the content-type header. Link for the source code
        // https://github.com/axios/axios/blob/dc4bc49673943e35280e5df831f5c3d0347a9393/lib/adapters/xhr.js#L121-L123
        if (axiosRequest.headers[Object.keys(axiosRequest.headers).find(function(key) {
            return key.toLowerCase() === 'content-type';
        })]) axiosRequest.data = null;
        if (emitter) {
            // TODO: Unify linting rules across JS repo
            axiosRequest.onUploadProgress = function(event) {
                emitter.emit($150069abd9b86342$export$c5e6923933be22a0, event);
                $150069abd9b86342$var$logger.debug(event);
            };
            // TODO: Unify linting rules across JS repo
            axiosRequest.onDownloadProgress = function(event) {
                emitter.emit($150069abd9b86342$export$660a92f3322ba11a, event);
                $150069abd9b86342$var$logger.debug(event);
            };
        }
        // If a cancel token source is passed down from the provider, allows cancellation of in-flight requests
        if (this.cancelTokenSource) axiosRequest.cancelToken = this.cancelTokenSource.token;
        if (options.cancelTokenSource) axiosRequest.cancelToken = options.cancelTokenSource.token;
        // From gamma release, aws-sdk now expects all response type to be of blob or streams
        axiosRequest.responseType = 'blob';
        // In Axios, Blobs are identified by calling Object.prototype.toString on the object. However, on React Native,
        // calling Object.prototype.toString on a Blob returns '[object Object]' instead of '[object Blob]', which causes
        // Axios to treat Blobs as generic Javascript objects. Therefore we need a to use a custom request transformer
        // to correctly handle Blob in React Native.
        if ((0, $8eca817bf49e3d6a$export$2dffd0b5373a4389).isReactNative) axiosRequest.transformRequest = $150069abd9b86342$export$7415af030ea6a2ae;
        var raceOfPromises = [
            (0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).request(axiosRequest).then(function(response) {
                return {
                    response: new (0, $f2e608cd2926439a$export$1d94dfe0d9d1f1e7)({
                        headers: response.headers,
                        statusCode: response.status,
                        body: response.data
                    })
                };
            }).catch(function(error) {
                var _a, _b;
                // Error
                if (error.message !== (0, $af8567358603a938$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE) $150069abd9b86342$var$logger.error(error.message);
                // for axios' cancel error, we should re-throw it back so it's not considered an s3client error
                // if we return empty, or an abitrary error HttpResponse, it will be hard to debug down the line.
                //
                // for errors that does not have a 'response' object, it's very likely that it is an unexpected error for
                // example a disconnect. Without it we cannot meaningfully reconstruct a HttpResponse, and the AWS SDK might
                // consider the request successful by mistake. In this case we should also re-throw the error.
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).isCancel(error) || !$150069abd9b86342$var$hasErrorResponse(error)) throw error;
                // otherwise, we should re-construct an HttpResponse from the error, so that it can be passed down to other
                // aws sdk middleware (e.g retry, clock skew correction, error message serializing)
                return {
                    response: new (0, $f2e608cd2926439a$export$1d94dfe0d9d1f1e7)({
                        statusCode: error.response.status,
                        body: (_a = error.response) === null || _a === void 0 ? void 0 : _a.data,
                        headers: (_b = error.response) === null || _b === void 0 ? void 0 : _b.headers
                    })
                };
            }),
            $150069abd9b86342$var$requestTimeout(requestTimeoutInMs)
        ];
        return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler;
}();
function $150069abd9b86342$var$requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = 'TimeoutError';
            reject(timeoutError);
        }, timeoutInMs);
    });
}




var $d8b1b885535830c6$export$aadf71dd9875dd20 = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $d8b1b885535830c6$export$8179b8ba0ab1e018 = 'contentLengthMiddleware';
var $d8b1b885535830c6$export$b7bd51f6ce311d83 = 'http://localhost:20005';
var $d8b1b885535830c6$export$b9acc545d1bd0170 = '__uploadInProgress';


var $1327559aa0e26375$export$a48f0734ac7c2329 = function(x) {
    if (typeof x === 'string') return x.length;
    else if ($1327559aa0e26375$var$isArrayBuffer(x)) return x.byteLength;
    else if ($1327559aa0e26375$export$5bcd6e94ed871c88(x)) return x.size;
    else throw new Error('Cannot determine byte length of ' + x);
};
var $1327559aa0e26375$export$f4575af7aa417855 = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data['metrics'] = metrics;
        (0, $6c553752040387ec$export$8c41bb232f1008b1).dispatch('storage', {
            event: event,
            data: data,
            message: message
        }, 'Storage', (0, $d8b1b885535830c6$export$aadf71dd9875dd20));
    }
};
var $1327559aa0e26375$export$be78b3111c50efdd = function(x) {
    return typeof x !== 'undefined' && x instanceof File;
};
var $1327559aa0e26375$export$5bcd6e94ed871c88 = function(x) {
    return typeof x !== 'undefined' && x instanceof Blob;
};
var $1327559aa0e26375$var$isArrayBuffer = function(x) {
    return typeof x !== 'undefined' && x instanceof ArrayBuffer;
};





var $38dc0325c29fd9f1$exports = {};
$38dc0325c29fd9f1$exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/eventstream-serde-browser\":\"3.6.1\",\"@aws-sdk/eventstream-serde-config-resolver\":\"3.6.1\",\"@aws-sdk/eventstream-serde-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-blob-browser\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/hash-stream-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/md5-js\":\"3.6.1\",\"@aws-sdk/middleware-apply-body-checksum\":\"3.6.1\",\"@aws-sdk/middleware-bucket-endpoint\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-expect-continue\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-location-constraint\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-sdk-s3\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-ssec\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"@aws-sdk/util-waiter\":\"3.6.1\",\"@aws-sdk/xml-builder\":\"3.6.1\",\"fast-xml-parser\":\"^3.16.0\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");



var $00b4f3fa92171d41$exports = {};
"use strict";
Object.defineProperty($00b4f3fa92171d41$exports, "__esModule", {
    value: true
});
$00b4f3fa92171d41$exports.AwsCrc32 = $00b4f3fa92171d41$exports.Crc32 = $00b4f3fa92171d41$exports.crc32 = void 0;

var $2R3UW = parcelRequire("2R3UW");

var $4OHCC = parcelRequire("4OHCC");
function $00b4f3fa92171d41$var$crc32(data) {
    return new $00b4f3fa92171d41$var$Crc32().update(data).digest();
}
$00b4f3fa92171d41$exports.crc32 = $00b4f3fa92171d41$var$crc32;
var $00b4f3fa92171d41$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $2R3UW.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $00b4f3fa92171d41$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
$00b4f3fa92171d41$exports.Crc32 = $00b4f3fa92171d41$var$Crc32;
// prettier-ignore
var $00b4f3fa92171d41$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $00b4f3fa92171d41$var$lookupTable = (0, $4OHCC.uint32ArrayFrom)($00b4f3fa92171d41$var$a_lookUpTable);
var $5a60e1d02dc59290$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($5a60e1d02dc59290$exports, "__esModule", {
    value: true
});
$5a60e1d02dc59290$exports.AwsCrc32 = void 0;

var $2R3UW = parcelRequire("2R3UW");

var $4OHCC = parcelRequire("4OHCC");

var $5a60e1d02dc59290$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $00b4f3fa92171d41$exports.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $4OHCC.isEmptyData)(toHash)) return;
        this.crc32.update((0, $4OHCC.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            return (0, $2R3UW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $4OHCC.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
$5a60e1d02dc59290$exports.AwsCrc32 = $5a60e1d02dc59290$var$AwsCrc32;


Object.defineProperty($00b4f3fa92171d41$exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $5a60e1d02dc59290$exports.AwsCrc32;
    }
});



var $2R3UW = parcelRequire("2R3UW");


/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $9ce26dcca034a315$export$8a5e19712a0a5deb = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $9ce26dcca034a315$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $9ce26dcca034a315$var$negate(bytes);
        return parseInt((0, $ab304b52b02b1119$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function $9ce26dcca034a315$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


/**
 * @internal
 */ var $6e10142e843950d2$export$74fd41a85c5dcec9 = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, $2R3UW.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, $2R3UW.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, $9ce26dcca034a315$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$6e10142e843950d2$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, $ab304b52b02b1119$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$LONG_TAG,
                        value: new (0, $9ce26dcca034a315$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $6e10142e843950d2$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $6e10142e843950d2$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $6e10142e843950d2$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $9ce26dcca034a315$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $6e10142e843950d2$var$UUID_TAG,
                        value: (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4)) + "-" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6)) + "-" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8)) + "-" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10)) + "-" + (0, $ab304b52b02b1119$export$7ea66e3774a60b67)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var $6e10142e843950d2$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($6e10142e843950d2$var$HEADER_VALUE_TYPE || ($6e10142e843950d2$var$HEADER_VALUE_TYPE = {}));
var $6e10142e843950d2$var$BOOLEAN_TAG = "boolean";
var $6e10142e843950d2$var$BYTE_TAG = "byte";
var $6e10142e843950d2$var$SHORT_TAG = "short";
var $6e10142e843950d2$var$INT_TAG = "integer";
var $6e10142e843950d2$var$LONG_TAG = "long";
var $6e10142e843950d2$var$BINARY_TAG = "binary";
var $6e10142e843950d2$var$STRING_TAG = "string";
var $6e10142e843950d2$var$TIMESTAMP_TAG = "timestamp";
var $6e10142e843950d2$var$UUID_TAG = "uuid";
var $6e10142e843950d2$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



// All prelude components are unsigned, 32-bit integers
var $8f56461913738602$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $8f56461913738602$var$PRELUDE_LENGTH = $8f56461913738602$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $8f56461913738602$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $8f56461913738602$var$MINIMUM_MESSAGE_LENGTH = $8f56461913738602$var$PRELUDE_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH * 2;
function $8f56461913738602$export$546b6bc432bd9a53(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $8f56461913738602$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($8f56461913738602$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($8f56461913738602$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $8f56461913738602$var$CHECKSUM_LENGTH, false);
    var checksummer = new (0, $00b4f3fa92171d41$exports.Crc32)().update(new Uint8Array(buffer, byteOffset, $8f56461913738602$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $8f56461913738602$var$PRELUDE_LENGTH, byteLength - ($8f56461913738602$var$PRELUDE_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $8f56461913738602$var$PRELUDE_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $8f56461913738602$var$PRELUDE_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($8f56461913738602$var$PRELUDE_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH + $8f56461913738602$var$CHECKSUM_LENGTH))
    };
}


/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $94746148ec84ac49$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, $6e10142e843950d2$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, $00b4f3fa92171d41$exports.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, $8f56461913738602$export$546b6bc432bd9a53)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();








var $2R3UW = parcelRequire("2R3UW");


var $2R3UW = parcelRequire("2R3UW");
function $74eceefdaa8e9ee2$export$3071cd8be9cd01e0(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, $2R3UW.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, $2R3UW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}



var $2R3UW = parcelRequire("2R3UW");
function $75e2673fc66d08cc$export$a1a364c5c6ddc1b4(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $2R3UW.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, $2R3UW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, $2R3UW.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}


var $940b1a54c9553f6d$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $94746148ec84ac49$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, $74eceefdaa8e9ee2$export$3071cd8be9cd01e0)(body);
        var unmarshalledStream = (0, $75e2673fc66d08cc$export$a1a364c5c6ddc1b4)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, $2R3UW.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, $2R3UW.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $2R3UW.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, $2R3UW.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $2R3UW.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, $2R3UW.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();


var $ad7ee43dcf5aff6f$export$9d23a885702ebafb = function(options) {
    return new (0, $940b1a54c9553f6d$export$b64afa0aa6ce60e2)(options);
};






var $2R3UW = parcelRequire("2R3UW");
var $52615d35f2df9c7f$export$2346526b0991dd88 = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $2R3UW.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, $2R3UW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, $2R3UW.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var $52615d35f2df9c7f$export$92326f9d37f111f = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, $2R3UW.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};


/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var $ca175abff1ee227d$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $94746148ec84ac49$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, $940b1a54c9553f6d$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = $ca175abff1ee227d$var$isReadableStream(body) ? (0, $52615d35f2df9c7f$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $52615d35f2df9c7f$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var $ca175abff1ee227d$var$isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};


var $6109f6749b555afc$export$9d23a885702ebafb = function(options) {
    return new (0, $ca175abff1ee227d$export$b64afa0aa6ce60e2)(options);
};








var $2R3UW = parcelRequire("2R3UW");
function $611b61eba9a36179$export$7541dba16c2127c8(blob, onChunk, chunkSize) {
    if (chunkSize === void 0) chunkSize = 1048576;
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        var size = blob.size;
        var totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", function(event) {
            var result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            // read the next block
            read();
        });
        // kick off the read
        read();
    });
}


var $b6856f0ab57b456a$export$ea66e9c498b7933c = function blobHasher(hashCtor, blob) {
    return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
        var hash;
        return (0, $2R3UW.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    hash = new hashCtor();
                    return [
                        4 /*yield*/ ,
                        (0, $611b61eba9a36179$export$7541dba16c2127c8)(blob, function(chunk) {
                            hash.update(chunk);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        hash.digest()
                    ];
            }
        });
    });
};




var $2R3UW = parcelRequire("2R3UW");
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $7e42d7a4999c4c43$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $7e42d7a4999c4c43$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $88d049303451c8f5$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $88d049303451c8f5$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $5abfb705e661f63c$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $88d049303451c8f5$export$c7c5cef950a4d2fc)(input) : (0, $7e42d7a4999c4c43$export$c7c5cef950a4d2fc)(input);
};
var $5abfb705e661f63c$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $88d049303451c8f5$export$b4b216764bb846eb)(input) : (0, $7e42d7a4999c4c43$export$b4b216764bb846eb)(input);
};


/**
 * @internal
 */ var $3e8457a4c8d39ef8$export$b2e3d6d444266a5c = 64;
var $3e8457a4c8d39ef8$export$d7bd469488748c5f = 16;
var $3e8457a4c8d39ef8$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


var $fc34a9e330aa19f1$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $3e8457a4c8d39ef8$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($fc34a9e330aa19f1$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $fc34a9e330aa19f1$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $2R3UW.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $2R3UW.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c) >= (0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c) - 8) {
                        for(i = this.bufferLength; i < (0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $3e8457a4c8d39ef8$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $3e8457a4c8d39ef8$export$d7bd469488748c5f)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $fc34a9e330aa19f1$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $fc34a9e330aa19f1$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $fc34a9e330aa19f1$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $fc34a9e330aa19f1$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $fc34a9e330aa19f1$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $fc34a9e330aa19f1$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $fc34a9e330aa19f1$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $fc34a9e330aa19f1$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $fc34a9e330aa19f1$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $fc34a9e330aa19f1$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $fc34a9e330aa19f1$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $fc34a9e330aa19f1$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $fc34a9e330aa19f1$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $fc34a9e330aa19f1$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $fc34a9e330aa19f1$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $fc34a9e330aa19f1$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $fc34a9e330aa19f1$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $fc34a9e330aa19f1$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $fc34a9e330aa19f1$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $fc34a9e330aa19f1$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $fc34a9e330aa19f1$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $fc34a9e330aa19f1$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $fc34a9e330aa19f1$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $fc34a9e330aa19f1$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $fc34a9e330aa19f1$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $fc34a9e330aa19f1$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $fc34a9e330aa19f1$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $fc34a9e330aa19f1$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $fc34a9e330aa19f1$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $fc34a9e330aa19f1$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $fc34a9e330aa19f1$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $fc34a9e330aa19f1$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $fc34a9e330aa19f1$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $fc34a9e330aa19f1$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $fc34a9e330aa19f1$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $fc34a9e330aa19f1$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $fc34a9e330aa19f1$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $fc34a9e330aa19f1$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $fc34a9e330aa19f1$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $fc34a9e330aa19f1$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $fc34a9e330aa19f1$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $fc34a9e330aa19f1$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $fc34a9e330aa19f1$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $fc34a9e330aa19f1$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $fc34a9e330aa19f1$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $fc34a9e330aa19f1$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $fc34a9e330aa19f1$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $fc34a9e330aa19f1$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $fc34a9e330aa19f1$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $fc34a9e330aa19f1$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $fc34a9e330aa19f1$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $fc34a9e330aa19f1$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $fc34a9e330aa19f1$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $fc34a9e330aa19f1$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $fc34a9e330aa19f1$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $fc34a9e330aa19f1$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $fc34a9e330aa19f1$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $fc34a9e330aa19f1$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $fc34a9e330aa19f1$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $fc34a9e330aa19f1$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $fc34a9e330aa19f1$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $fc34a9e330aa19f1$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $fc34a9e330aa19f1$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $fc34a9e330aa19f1$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $fc34a9e330aa19f1$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $fc34a9e330aa19f1$var$ff(a, b, c, d, x, s, t) {
    return $fc34a9e330aa19f1$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $fc34a9e330aa19f1$var$gg(a, b, c, d, x, s, t) {
    return $fc34a9e330aa19f1$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $fc34a9e330aa19f1$var$hh(a, b, c, d, x, s, t) {
    return $fc34a9e330aa19f1$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $fc34a9e330aa19f1$var$ii(a, b, c, d, x, s, t) {
    return $fc34a9e330aa19f1$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $fc34a9e330aa19f1$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $fc34a9e330aa19f1$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $5abfb705e661f63c$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}






/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $796286b4e5480879$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $796286b4e5480879$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $43fed78eafdeee61$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $43fed78eafdeee61$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $381084f638b5b97e$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $43fed78eafdeee61$export$c7c5cef950a4d2fc)(input) : (0, $796286b4e5480879$export$c7c5cef950a4d2fc)(input);
};
var $381084f638b5b97e$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $43fed78eafdeee61$export$b4b216764bb846eb)(input) : (0, $796286b4e5480879$export$b4b216764bb846eb)(input);
};



// Partition default templates
var $84bfc9cd1861f36c$var$AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var $84bfc9cd1861f36c$var$AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var $84bfc9cd1861f36c$var$AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var $84bfc9cd1861f36c$var$AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var $84bfc9cd1861f36c$var$AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var $84bfc9cd1861f36c$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $84bfc9cd1861f36c$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $84bfc9cd1861f36c$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $84bfc9cd1861f36c$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $84bfc9cd1861f36c$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $84bfc9cd1861f36c$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "s3.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "aws-global":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "s3.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($84bfc9cd1861f36c$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($84bfc9cd1861f36c$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($84bfc9cd1861f36c$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($84bfc9cd1861f36c$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($84bfc9cd1861f36c$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $84bfc9cd1861f36c$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({
        signingService: "s3"
    }, regionInfo));
};



var $d8e5a4c4834eef04$export$608864383388f904 = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $84bfc9cd1861f36c$export$2e4318bf13462aa2),
    serviceId: "S3",
    signingEscapePath: false,
    urlParser: (0, $fa9ba959cb452661$export$7a5253c0f62e0150),
    useArnRegion: false
};


var $d733c5d93de69f10$export$b1f2d721b555a243 = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, (0, $d8e5a4c4834eef04$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $7cbce5b9f8516cac$export$c537b38001c583b7),
    base64Encoder: (0, $7cbce5b9f8516cac$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $04ceec2b4b32d579$export$967f3527bf233bc0),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $01291e50efc3ae48$export$69d579f32876892f)({
        serviceId: (0, $d8e5a4c4834eef04$export$608864383388f904).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($38dc0325c29fd9f1$exports))).version
    }),
    eventStreamSerdeProvider: (0, $6109f6749b555afc$export$9d23a885702ebafb),
    maxAttempts: (0, $cc9220ec102b8f39$export$2c7e51f38ba5a406),
    md5: (0, $fc34a9e330aa19f1$export$9f5a3dfc7a9f5dd),
    region: (0, $f7ad0cbdfcbdd3bf$export$d59dd53963f8f3d5)("Region is missing"),
    requestHandler: new (0, $4f85640929636496$export$83588b87edbfa7e0)(),
    sha256: (0, $884a5260025384f7$exports.Sha256),
    streamCollector: (0, $12afb2b1a2425333$export$17bf97b72e307d52),
    streamHasher: (0, $b6856f0ab57b456a$export$ea66e9c498b7933c),
    utf8Decoder: (0, $381084f638b5b97e$export$c7c5cef950a4d2fc),
    utf8Encoder: (0, $381084f638b5b97e$export$b4b216764bb846eb)
});




var $2R3UW = parcelRequire("2R3UW");
var $62f92e5dcb041118$export$5e2ae00bf65442f0 = function(input) {
    return (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};







var $2R3UW = parcelRequire("2R3UW");

function $6481ce4763ce41b7$export$ea55ca13ab589d75(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $2R3UW.__awaiter)(_this, void 0, void 0, function() {
                var request;
                return (0, $2R3UW.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, $56390c7aad80e533$export$7587955500404ec3).isInstance(request) && request.body && options.runtime === "node") request.headers = (0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, request.headers), {
                        Expect: "100-continue"
                    });
                    return [
                        2 /*return*/ ,
                        next((0, $2R3UW.__assign)((0, $2R3UW.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $6481ce4763ce41b7$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware",
    override: true
};
var $6481ce4763ce41b7$export$7692e5e7214e5cd1 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($6481ce4763ce41b7$export$ea55ca13ab589d75(options), $6481ce4763ce41b7$export$582010bfa3126ad3);
        }
    };
};









/**
 * <p></p>
 */ var $0919fdd88f98061d$export$b5be36c66bc46237 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(S3Client, _super);
    function S3Client(configuration) {
        var _this = this;
        var _config_0 = (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, (0, $d733c5d93de69f10$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $67e7c06acfe8e883$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $44bd1ce362a3c380$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $f475582ef4ec5a2f$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $ffd161ca6b258fc7$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $ff12c45aae4e0594$export$c1625bf0b32b4481)(_config_4);
        var _config_6 = (0, $16bf2ba28079505f$export$9810f1a949e3136)(_config_5);
        var _config_7 = (0, $8b3b0e8537f7bde2$export$ec9a2d5663958cb)(_config_6);
        var _config_8 = (0, $62f92e5dcb041118$export$5e2ae00bf65442f0)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, $fd36231d159a06aa$export$59c2b7ad30ed4046)(_this.config));
        _this.middlewareStack.use((0, $2d8b999fb8b8d488$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $e1f251a56385836a$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $ff12c45aae4e0594$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $5e7a24de912cecc7$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $613a372f210c2330$export$c30d61978fbb3ad8)(_this.config));
        _this.middlewareStack.use((0, $3eca2cc053a5f942$export$8512187c26b3935b)(_this.config));
        _this.middlewareStack.use((0, $6481ce4763ce41b7$export$7692e5e7214e5cd1)(_this.config));
        _this.middlewareStack.use((0, $cd71f90f32b2eb9a$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    S3Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return S3Client;
}((0, $ad5f68adc06fa5bd$export$1f2bb630327ac4b6));




var $fad6f390597158c6$var$__assign = undefined && undefined.__assign || function() {
    $fad6f390597158c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fad6f390597158c6$var$__assign.apply(this, arguments);
};
var $fad6f390597158c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fad6f390597158c6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fad6f390597158c6$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('S3ClientUtils');
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var $fad6f390597158c6$var$INVALID_CRED = {
    accessKeyId: '',
    secretAccessKey: ''
};
var $fad6f390597158c6$export$36e24695f02d4503 = function(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : 'private/') + resolvedIdentityId + '/';
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : 'protected/') + resolvedIdentityId + '/';
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : 'public/';
    switch(level){
        case 'private':
            return privatePath;
        case 'protected':
            return protectedPath;
        default:
            return publicPath;
    }
};
var $fad6f390597158c6$export$95bc4f3188064861 = function(opt, key) {
    return function(next, _context) {
        return function(args) {
            return $fad6f390597158c6$var$__awaiter(void 0, void 0, void 0, function() {
                var credentials, cred, prefix, clonedInput, result;
                return $fad6f390597158c6$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $99c5343f38dbb45f$export$a9627919734faa48).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            cred = (0, $99c5343f38dbb45f$export$a9627919734faa48).shear(credentials);
                            prefix = $fad6f390597158c6$export$36e24695f02d4503($fad6f390597158c6$var$__assign($fad6f390597158c6$var$__assign({}, opt), {
                                credentials: cred
                            }));
                            clonedInput = Object.assign({}, args.input);
                            if (Object.prototype.hasOwnProperty.call(args.input, 'Key')) {
                                clonedInput.Key = prefix + key;
                                args.input = clonedInput;
                            } else if (Object.prototype.hasOwnProperty.call(args.input, 'Prefix')) {
                                clonedInput.Prefix = prefix + key;
                                args.input = clonedInput;
                            }
                            result = next(args);
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
    };
};
var $fad6f390597158c6$var$isTimeSkewedError = function(err) {
    return err.ServerTime && typeof err.Code === 'string' && err.Code === 'RequestTimeTooSkewed';
};
var $fad6f390597158c6$export$d1971fb9f9448f = function(config) {
    return function(next, _context) {
        return function(args) {
            return $fad6f390597158c6$var$__awaiter(void 0, void 0, void 0, function() {
                var err_1, serverDate;
                return $fad6f390597158c6$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 2:
                            err_1 = _a.sent();
                            if ($fad6f390597158c6$var$isTimeSkewedError(err_1)) {
                                serverDate = new Date(err_1.ServerTime);
                                config.systemClockOffset = serverDate.getTime() - Date.now();
                            }
                            throw err_1;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var $fad6f390597158c6$export$2edd0200412be327 = {
    step: 'finalizeRequest',
    name: 'autoAdjustClockskewMiddleware'
};
var $fad6f390597158c6$export$52daf78b33f1adcd = {
    step: 'initialize',
    name: 'addPrefixMiddleware'
};
var $fad6f390597158c6$export$ae4c744fb23e6d32 = function() {
    return $fad6f390597158c6$var$__awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return $fad6f390597158c6$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $99c5343f38dbb45f$export$a9627919734faa48).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        $fad6f390597158c6$var$INVALID_CRED
                    ];
                    cred = (0, $99c5343f38dbb45f$export$a9627919734faa48).shear(credentials);
                    $fad6f390597158c6$var$logger.debug('credentials provider get credentials', cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    $fad6f390597158c6$var$logger.warn('credentials provider error', error_1);
                    return [
                        2 /*return*/ ,
                        $fad6f390597158c6$var$INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $fad6f390597158c6$export$4cdd37a0748e6ad9 = function(config, emitter) {
    var region = config.region, cancelTokenSource = config.cancelTokenSource, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting, useAccelerateEndpoint = config.useAccelerateEndpoint;
    var localTestingConfig = {};
    if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
        endpoint: (0, $d8b1b885535830c6$export$b7bd51f6ce311d83),
        tls: false,
        bucketEndpoint: false,
        forcePathStyle: true
    };
    var s3client = new (0, $0919fdd88f98061d$export$b5be36c66bc46237)($fad6f390597158c6$var$__assign($fad6f390597158c6$var$__assign({
        region: region,
        // Using provider instead of a static credentials, so that if an upload task was in progress, but credentials gets
        // changed or invalidated (e.g user signed out), the subsequent requests will fail.
        credentials: $fad6f390597158c6$export$ae4c744fb23e6d32,
        customUserAgent: (0, $8eca817bf49e3d6a$export$ede38edb26c0bfdf)()
    }, localTestingConfig), {
        requestHandler: new (0, $150069abd9b86342$export$43af02f23afacda3)({}, emitter, cancelTokenSource),
        useAccelerateEndpoint: useAccelerateEndpoint
    }));
    s3client.middlewareStack.remove((0, $d8b1b885535830c6$export$8179b8ba0ab1e018));
    return s3client;
};


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 






/**
 * <p>This operation aborts a multipart upload. After a multipart upload is aborted, no
 *          additional parts can be uploaded using that upload ID. The storage consumed by any
 *          previously uploaded parts will be freed. However, if any part uploads are currently in
 *          progress, those part uploads might or might not succeed. As a result, it might be necessary
 *          to abort a given multipart upload multiple times in order to completely free all storage
 *          consumed by all parts. </p>
 *          <p>To verify that all parts have been removed, so you don't get charged for the part
 *          storage, you should call the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a> operation and ensure that
 *          the parts list is empty.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *          <p>The following operations are related to <code>AbortMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $f1e687e9d7f64702$export$87d2388f8662d995 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(AbortMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AbortMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ AbortMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "AbortMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$2509116d04cdd782).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$80a5621784397e06).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$a7d2d025c66f9235)(input, context);
    };
    AbortMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$87447564e9ee4b69)(output, context);
    };
    return AbortMultipartUploadCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));








/**
 * <p>Completes a multipart upload by assembling previously uploaded parts.</p>
 *          <p>You first initiate the multipart upload and then upload all parts using the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *          operation. After successfully uploading all relevant parts of an upload, you call this
 *          operation to complete the upload. Upon receiving this request, Amazon S3 concatenates all
 *          the parts in ascending order by part number to create a new object. In the Complete
 *          Multipart Upload request, you must provide the parts list. You must ensure that the parts
 *          list is complete. This operation concatenates the parts that you provide in the list. For
 *          each part in the list, you must provide the part number and the <code>ETag</code> value,
 *          returned after that part was uploaded.</p>
 *          <p>Processing of a Complete Multipart Upload request could take several minutes to
 *          complete. After Amazon S3 begins processing the request, it sends an HTTP response header that
 *          specifies a 200 OK response. While processing is in progress, Amazon S3 periodically sends white
 *          space characters to keep the connection from timing out. Because a request could fail after
 *          the initial 200 OK response has been sent, it is important that you check the response body
 *          to determine whether the request succeeded.</p>
 *          <p>Note that if <code>CompleteMultipartUpload</code> fails, applications should be prepared
 *          to retry the failed requests. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ErrorBestPractices.html">Amazon S3 Error Best Practices</a>.</p>
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *
 *          <p>
 *             <code>CompleteMultipartUpload</code> has the following special errors:</p>
 *          <ul>
 *             <li>
 *                <p>Error code: <code>EntityTooSmall</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: Your proposed upload is smaller than the minimum allowed object
 *                      size. Each part must be at least 5 MB in size, except the last part.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPart</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: One or more of the specified parts could not be found. The part
 *                      might not have been uploaded, or the specified entity tag might not have
 *                      matched the part's entity tag.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPartOrder</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The list of parts was not in ascending order. The parts list
 *                      must be specified in order by part number.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>NoSuchUpload</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The specified multipart upload does not exist. The upload ID
 *                      might be invalid, or the multipart upload might have been aborted or
 *                      completed.</p>
 *                   </li>
 *                   <li>
 *                      <p>404 Not Found</p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *          <p>The following operations are related to <code>CompleteMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $1e184024b66a3f63$export$f827ea0301b4eeff = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(CompleteMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompleteMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CompleteMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $2d7f04572123fd3f$export$97cbbd0d754f3189)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CompleteMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$2998881f143b41ec).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$edcc5df28126c9bc).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$2a09fb9495f08c55)(input, context);
    };
    CompleteMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$ee5aaa25931389ce)(output, context);
    };
    return CompleteMultipartUploadCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));








/**
 * <p>This operation initiates a multipart upload and returns an upload ID. This upload ID is
 *          used to associate all of the parts in the specific multipart upload. You specify this
 *          upload ID in each of your subsequent upload part requests (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>). You also include this
 *          upload ID in the final request to either complete or abort the multipart upload
 *          request.</p>
 *
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a>.</p>
 *
 *          <p>If you have configured a lifecycle rule to abort incomplete multipart uploads, the
 *          upload must complete within the number of days specified in the bucket lifecycle
 *          configuration. Otherwise, the incomplete multipart upload becomes eligible for an abort
 *          operation and Amazon S3 aborts the multipart upload. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html#mpu-abort-incomplete-mpu-lifecycle-config">Aborting
 *             Incomplete Multipart Uploads Using a Bucket Lifecycle Policy</a>.</p>
 *
 *          <p>For information about the permissions required to use the multipart upload API, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a>.</p>
 *
 *          <p>For request signing, multipart upload is just a series of regular requests. You initiate
 *          a multipart upload, send one or more requests to upload parts, and then complete the
 *          multipart upload process. You sign each request individually. There is nothing special
 *          about signing multipart upload requests. For more information about signing, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sig-v4-authenticating-requests.html">Authenticating
 *             Requests (AWS Signature Version 4)</a>.</p>
 *
 *          <note>
 *             <p> After you initiate a multipart upload and upload one or more parts, to stop being
 *             charged for storing the uploaded parts, you must either complete or abort the multipart
 *             upload. Amazon S3 frees up the space used to store the parts and stop charging you for
 *             storing them only after you either complete or abort a multipart upload. </p>
 *          </note>
 *
 *          <p>You can optionally request server-side encryption. For server-side encryption, Amazon S3
 *          encrypts your data as it writes it to disks in its data centers and decrypts it when you
 *          access it. You can provide your own encryption key, or use AWS Key Management Service (AWS
 *          KMS) customer master keys (CMKs) or Amazon S3-managed encryption keys. If you choose to provide
 *          your own encryption key, the request headers you provide in <a href="AmazonS3/latest/API/API_UploadPart.html">UploadPart</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> requests must match the headers you used in the request to
 *          initiate the upload by using <code>CreateMultipartUpload</code>. </p>
 *          <p>To perform a multipart upload with encryption using an AWS KMS CMK, the requester must
 *          have permission to the <code>kms:Encrypt</code>, <code>kms:Decrypt</code>,
 *             <code>kms:ReEncrypt*</code>, <code>kms:GenerateDataKey*</code>, and
 *             <code>kms:DescribeKey</code> actions on the key. These permissions are required because
 *          Amazon S3 must decrypt and read data from the encrypted file parts before it completes the
 *          multipart upload.</p>
 *
 *          <p>If your AWS Identity and Access Management (IAM) user or role is in the same AWS account
 *          as the AWS KMS CMK, then you must have these permissions on the key policy. If your IAM
 *          user or role belongs to a different account than the key, then you must have the
 *          permissions on both the key policy and your IAM user or role.</p>
 *
 *
 *          <p> For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/serv-side-encryption.html">Protecting
 *             Data Using Server-Side Encryption</a>.</p>
 *
 *          <dl>
 *             <dt>Access Permissions</dt>
 *             <dd>
 *                <p>When copying an object, you can optionally specify the accounts or groups that
 *                   should be granted specific permissions on the new object. There are two ways to
 *                   grant the permissions using the request headers:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL with the <code>x-amz-acl</code> request header. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly with the
 *                            <code>x-amz-grant-read</code>, <code>x-amz-grant-read-acp</code>,
 *                            <code>x-amz-grant-write-acp</code>, and
 *                            <code>x-amz-grant-full-control</code> headers. These parameters map to
 *                         the set of permissions that Amazon S3 supports in an ACL. For more information,
 *                         see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List (ACL)
 *                            Overview</a>.</p>
 *                   </li>
 *                </ul>
 *                <p>You can use either a canned ACL or specify access permissions explicitly. You
 *                   cannot do both.</p>
 *             </dd>
 *             <dt>Server-Side- Encryption-Specific Request Headers</dt>
 *             <dd>
 *                <p>You can optionally tell Amazon S3 to encrypt data at rest using server-side
 *                   encryption. Server-side encryption is for data encryption at rest. Amazon S3 encrypts
 *                   your data as it writes it to disks in its data centers and decrypts it when you
 *                   access it. The option you use depends on whether you want to use AWS managed
 *                   encryption keys or provide your own encryption key. </p>
 *                <ul>
 *                   <li>
 *                      <p>Use encryption keys managed by Amazon S3 or customer master keys (CMKs) stored
 *                         in AWS Key Management Service (AWS KMS) – If you want AWS to manage the keys
 *                         used to encrypt data, specify the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-aws-kms-key-id</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-context</p>
 *                         </li>
 *                      </ul>
 *                      <note>
 *                         <p>If you specify <code>x-amz-server-side-encryption:aws:kms</code>, but
 *                            don't provide <code>x-amz-server-side-encryption-aws-kms-key-id</code>,
 *                            Amazon S3 uses the AWS managed CMK in AWS KMS to protect the data.</p>
 *                      </note>
 *                      <important>
 *                         <p>All GET and PUT requests for an object protected by AWS KMS fail if
 *                            you don't make them with SSL or by using SigV4.</p>
 *                      </important>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Use customer-provided encryption keys – If you want to manage your own
 *                         encryption keys, provide all the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-algorithm</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *                         </li>
 *                      </ul>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                </ul>
 *             </dd>
 *             <dt>Access-Control-List (ACL)-Specific Request Headers</dt>
 *             <dd>
 *                <p>You also can use the following access control–related headers with this
 *                   operation. By default, all objects are private. Only the owner has full access
 *                   control. When adding a new object, you can grant permissions to individual AWS
 *                   accounts or to predefined groups defined by Amazon S3. These permissions are then added
 *                   to the access control list (ACL) on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3_ACLs_UsingACLs.html">Using ACLs</a>. With this
 *                   operation, you can grant access permissions using one of the following two
 *                   methods:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL (<code>x-amz-acl</code>) — Amazon S3 supports a set of
 *                         predefined ACLs, known as <i>canned ACLs</i>. Each canned ACL
 *                         has a predefined set of grantees and permissions. For more information, see
 *                            <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned
 *                         ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly — To explicitly grant access
 *                         permissions to specific AWS accounts or groups, use the following headers.
 *                         Each header maps to specific permissions that Amazon S3 supports in an ACL. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access
 *                            Control List (ACL) Overview</a>. In the header, you specify a list of
 *                         grantees who get the specific permission. To grant permissions explicitly,
 *                         use:</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-grant-read</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-read-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-full-control</p>
 *                         </li>
 *                      </ul>
 *                      <p>You specify each grantee as a type=value pair, where the type is one of
 *                         the following:</p>
 *                      <ul>
 *                         <li>
 *                            <p>
 *                               <code>id</code> – if the value specified is the canonical user ID
 *                               of an AWS account</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>uri</code> – if you are granting permissions to a predefined
 *                               group</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>emailAddress</code> – if the value specified is the email
 *                               address of an AWS account</p>
 *                            <note>
 *                               <p>Using email addresses to specify a grantee is only supported in the following AWS Regions: </p>
 *                               <ul>
 *                                  <li>
 *                                     <p>US East (N. Virginia)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>US West (N. California)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> US West (Oregon)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> Asia Pacific (Singapore)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Sydney)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Tokyo)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Europe (Ireland)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>South America (São Paulo)</p>
 *                                  </li>
 *                               </ul>
 *                               <p>For a list of all the Amazon S3 supported Regions and endpoints, see <a href="https://docs.aws.amazon.com/general/latest/gr/rande.html#s3_region">Regions and Endpoints</a> in the AWS General Reference.</p>
 *                            </note>
 *                         </li>
 *                      </ul>
 *                      <p>For example, the following <code>x-amz-grant-read</code> header grants the AWS accounts identified by account IDs permissions to read object data and its metadata:</p>
 *                      <p>
 *                         <code>x-amz-grant-read: id="11112222333", id="444455556666" </code>
 *                      </p>
 *                   </li>
 *                </ul>
 *
 *             </dd>
 *          </dl>
 *
 *          <p>The following operations are related to <code>CreateMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $446af679b4f8200b$export$76155123c96043b8 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(CreateMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $298fba8493d5052b$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$f65faae2a46e45c2).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$196bb0482ff68428).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$4730de34492fdc2)(input, context);
    };
    CreateMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$95cf7bc6357ae5a8)(output, context);
    };
    return CreateMultipartUploadCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));







/**
 * <p>Lists the parts that have been uploaded for a specific multipart upload. This operation
 *          must include the upload ID, which you obtain by sending the initiate multipart upload
 *          request (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>).
 *          This request returns a maximum of 1,000 uploaded parts. The default number of parts
 *          returned is 1,000 parts. You can restrict the number of parts returned by specifying the
 *             <code>max-parts</code> request parameter. If your multipart upload consists of more than
 *          1,000 parts, the response returns an <code>IsTruncated</code> field with the value of true,
 *          and a <code>NextPartNumberMarker</code> element. In subsequent <code>ListParts</code>
 *          requests you can include the part-number-marker query string parameter and set its value to
 *          the <code>NextPartNumberMarker</code> field value from the previous response.</p>
 *
 *          <p>For more information on multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *
 *          <p>For information on permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *          <p>The following operations are related to <code>ListParts</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $2f1b9239518d1a7c$export$17fb27d830090508 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(ListPartsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListPartsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListPartsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListPartsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$756cf37efa2403e6).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$8c83b46649a5c089).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListPartsCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$b2b39cf3937e8c76)(input, context);
    };
    ListPartsCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$584d994fd27ec2bb)(output, context);
    };
    return ListPartsCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));








/**
 * <p>Adds an object to a bucket. You must have WRITE permissions on a bucket to add an object
 *          to it.</p>
 *
 *
 *          <p>Amazon S3 never adds partial objects; if you receive a success response, Amazon S3 added the
 *          entire object to the bucket.</p>
 *
 *          <p>Amazon S3 is a distributed system. If it receives multiple write requests for the same object
 *          simultaneously, it overwrites all but the last object written. Amazon S3 does not provide object
 *          locking; if you need this, make sure to build it into your application layer or use
 *          versioning instead.</p>
 *
 *          <p>To ensure that data is not corrupted traversing the network, use the
 *             <code>Content-MD5</code> header. When you use this header, Amazon S3 checks the object
 *          against the provided MD5 value and, if they do not match, returns an error. Additionally,
 *          you can calculate the MD5 while putting an object to Amazon S3 and compare the returned ETag to
 *          the calculated MD5 value.</p>
 *          <note>
 *             <p> The <code>Content-MD5</code> header is required for any request to upload an object
 *             with a retention period configured using Amazon S3 Object Lock. For more information about
 *             Amazon S3 Object Lock, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/object-lock-overview.html">Amazon S3 Object Lock Overview</a>
 *             in the <i>Amazon Simple Storage Service Developer Guide</i>. </p>
 *          </note>
 *
 *
 *          <p>
 *             <b>Server-side Encryption</b>
 *          </p>
 *          <p>You can optionally request server-side encryption. With server-side encryption, Amazon S3 encrypts your data as it writes it to disks in its data centers and decrypts the data
 *          when you access it. You have the option to provide your own encryption key or use AWS
 *          managed encryption keys (SSE-S3 or SSE-KMS). For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side
 *             Encryption</a>.</p>
 *          <p>If you request server-side encryption using AWS Key Management Service (SSE-KMS), you can enable an S3 Bucket Key at the object-level. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/bucket-key.html">Amazon S3 Bucket Keys</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Access Control List (ACL)-Specific Request
 *          Headers</b>
 *          </p>
 *          <p>You can use headers to grant ACL- based permissions. By default, all objects are
 *          private. Only the owner has full access control. When adding a new object, you can grant
 *          permissions to individual AWS accounts or to predefined groups defined by Amazon S3. These
 *          permissions are then added to the ACL on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List
 *             (ACL) Overview</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-using-rest-api.html">Managing ACLs Using the REST
 *             API</a>. </p>
 *
 *          <p>
 *             <b>Storage Class Options</b>
 *          </p>
 *          <p>By default, Amazon S3 uses the STANDARD Storage Class to store newly created objects. The
 *          STANDARD storage class provides high durability and high availability. Depending on
 *          performance needs, you can specify a different Storage Class. Amazon S3 on Outposts only uses
 *          the OUTPOSTS Storage Class. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/storage-class-intro.html">Storage Classes</a> in the <i>Amazon S3
 *             Service Developer Guide</i>.</p>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>If you enable versioning for a bucket, Amazon S3 automatically generates a unique version ID
 *          for the object being stored. Amazon S3 returns this ID in the response. When you enable
 *          versioning for a bucket, if Amazon S3 receives multiple write requests for the same object
 *          simultaneously, it stores all of the objects.</p>
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/AddingObjectstoVersioningEnabledBuckets.html">Adding Objects to
 *             Versioning Enabled Buckets</a>. For information about returning the versioning state
 *          of a bucket, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetBucketVersioning.html">GetBucketVersioning</a>. </p>
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CopyObject.html">CopyObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_DeleteObject.html">DeleteObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $c54882f0e5c487be$export$4afa2352f8871c26 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(PutObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $298fba8493d5052b$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$90c5c1bf0f634d21).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $0c0d1970b55e47a3$export$792cedced515bdbd).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$6c3f9d82bec72a8d)(input, context);
    };
    PutObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$45bbdbf5181c3607)(output, context);
    };
    return PutObjectCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));





var $f01225993cfc23bf$export$9c5e83992d724a63;
(function(MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$9c5e83992d724a63 || ($f01225993cfc23bf$export$9c5e83992d724a63 = {}));
var $f01225993cfc23bf$export$7bb542410b46ffb9;
(function(S3Location) {
    S3Location.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: (0, $0c0d1970b55e47a3$export$d60a27d0da10cee5).filterSensitiveLog(obj.Encryption)
        });
    };
})($f01225993cfc23bf$export$7bb542410b46ffb9 || ($f01225993cfc23bf$export$7bb542410b46ffb9 = {}));
var $f01225993cfc23bf$export$cc3fbbd78713fc6c;
(function(OutputLocation) {
    OutputLocation.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.S3 && {
            S3: $f01225993cfc23bf$export$7bb542410b46ffb9.filterSensitiveLog(obj.S3)
        });
    };
})($f01225993cfc23bf$export$cc3fbbd78713fc6c || ($f01225993cfc23bf$export$cc3fbbd78713fc6c = {}));
var $f01225993cfc23bf$export$e0a8b40ee8e7958f;
(function(FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})($f01225993cfc23bf$export$e0a8b40ee8e7958f || ($f01225993cfc23bf$export$e0a8b40ee8e7958f = {}));
var $f01225993cfc23bf$export$cd4a4cfd0598253e;
(function(CSVInput) {
    CSVInput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$cd4a4cfd0598253e || ($f01225993cfc23bf$export$cd4a4cfd0598253e = {}));
var $f01225993cfc23bf$export$b8d04dd3765058e2;
(function(JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})($f01225993cfc23bf$export$b8d04dd3765058e2 || ($f01225993cfc23bf$export$b8d04dd3765058e2 = {}));
var $f01225993cfc23bf$export$1bc8a3cf179ad9c;
(function(JSONInput) {
    JSONInput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$1bc8a3cf179ad9c || ($f01225993cfc23bf$export$1bc8a3cf179ad9c = {}));
var $f01225993cfc23bf$export$a457f185006c756f;
(function(ParquetInput) {
    ParquetInput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$a457f185006c756f || ($f01225993cfc23bf$export$a457f185006c756f = {}));
var $f01225993cfc23bf$export$71ed8fe19d426eb7;
(function(InputSerialization) {
    InputSerialization.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$71ed8fe19d426eb7 || ($f01225993cfc23bf$export$71ed8fe19d426eb7 = {}));
var $f01225993cfc23bf$export$b4890521754421ba;
(function(QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})($f01225993cfc23bf$export$b4890521754421ba || ($f01225993cfc23bf$export$b4890521754421ba = {}));
var $f01225993cfc23bf$export$623bc581753795b3;
(function(CSVOutput) {
    CSVOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$623bc581753795b3 || ($f01225993cfc23bf$export$623bc581753795b3 = {}));
var $f01225993cfc23bf$export$403a844dcc531976;
(function(JSONOutput) {
    JSONOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$403a844dcc531976 || ($f01225993cfc23bf$export$403a844dcc531976 = {}));
var $f01225993cfc23bf$export$cb22c2d1ef9f03c1;
(function(OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$cb22c2d1ef9f03c1 || ($f01225993cfc23bf$export$cb22c2d1ef9f03c1 = {}));
var $f01225993cfc23bf$export$722dd036ddb6b3f;
(function(SelectParameters) {
    SelectParameters.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$722dd036ddb6b3f || ($f01225993cfc23bf$export$722dd036ddb6b3f = {}));
var $f01225993cfc23bf$export$ee855080cc4fa5a8;
(function(RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})($f01225993cfc23bf$export$ee855080cc4fa5a8 || ($f01225993cfc23bf$export$ee855080cc4fa5a8 = {}));
var $f01225993cfc23bf$export$116b002a1c4d25c0;
(function(RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.OutputLocation && {
            OutputLocation: $f01225993cfc23bf$export$cc3fbbd78713fc6c.filterSensitiveLog(obj.OutputLocation)
        });
    };
})($f01225993cfc23bf$export$116b002a1c4d25c0 || ($f01225993cfc23bf$export$116b002a1c4d25c0 = {}));
var $f01225993cfc23bf$export$bd1b29d0f94512e7;
(function(RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.RestoreRequest && {
            RestoreRequest: $f01225993cfc23bf$export$116b002a1c4d25c0.filterSensitiveLog(obj.RestoreRequest)
        });
    };
})($f01225993cfc23bf$export$bd1b29d0f94512e7 || ($f01225993cfc23bf$export$bd1b29d0f94512e7 = {}));
var $f01225993cfc23bf$export$d20e6aaa08a7363f;
(function(ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$d20e6aaa08a7363f || ($f01225993cfc23bf$export$d20e6aaa08a7363f = {}));
var $f01225993cfc23bf$export$2066b1507471daea;
(function(EndEvent) {
    EndEvent.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$2066b1507471daea || ($f01225993cfc23bf$export$2066b1507471daea = {}));
var $f01225993cfc23bf$export$b25a304ec7d746bb;
(function(Progress) {
    Progress.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$b25a304ec7d746bb || ($f01225993cfc23bf$export$b25a304ec7d746bb = {}));
var $f01225993cfc23bf$export$863d066dc35784fb;
(function(ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$863d066dc35784fb || ($f01225993cfc23bf$export$863d066dc35784fb = {}));
var $f01225993cfc23bf$export$bb48554e89f06bf8;
(function(RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$bb48554e89f06bf8 || ($f01225993cfc23bf$export$bb48554e89f06bf8 = {}));
var $f01225993cfc23bf$export$3cdec2bba15e3523;
(function(Stats) {
    Stats.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$3cdec2bba15e3523 || ($f01225993cfc23bf$export$3cdec2bba15e3523 = {}));
var $f01225993cfc23bf$export$72935df6390a4cde;
(function(StatsEvent) {
    StatsEvent.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$72935df6390a4cde || ($f01225993cfc23bf$export$72935df6390a4cde = {}));
var $f01225993cfc23bf$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function(value, visitor) {
        if (value.Records !== undefined) return visitor.Records(value.Records);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.End !== undefined) return visitor.End(value.End);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Records !== undefined) return {
            Records: $f01225993cfc23bf$export$bb48554e89f06bf8.filterSensitiveLog(obj.Records)
        };
        if (obj.Stats !== undefined) return {
            Stats: $f01225993cfc23bf$export$72935df6390a4cde.filterSensitiveLog(obj.Stats)
        };
        if (obj.Progress !== undefined) return {
            Progress: $f01225993cfc23bf$export$863d066dc35784fb.filterSensitiveLog(obj.Progress)
        };
        if (obj.Cont !== undefined) return {
            Cont: $f01225993cfc23bf$export$d20e6aaa08a7363f.filterSensitiveLog(obj.Cont)
        };
        if (obj.End !== undefined) return {
            End: $f01225993cfc23bf$export$2066b1507471daea.filterSensitiveLog(obj.End)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($f01225993cfc23bf$export$4c951f3462fad8ac || ($f01225993cfc23bf$export$4c951f3462fad8ac = {}));
var $f01225993cfc23bf$export$5bf8ed4e571234e3;
(function(SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.Payload && {
            Payload: "STREAMING_CONTENT"
        });
    };
})($f01225993cfc23bf$export$5bf8ed4e571234e3 || ($f01225993cfc23bf$export$5bf8ed4e571234e3 = {}));
var $f01225993cfc23bf$export$b8081f25e3a7bfbd;
(function(RequestProgress) {
    RequestProgress.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$b8081f25e3a7bfbd || ($f01225993cfc23bf$export$b8081f25e3a7bfbd = {}));
var $f01225993cfc23bf$export$33f7c3433c085364;
(function(ScanRange) {
    ScanRange.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$33f7c3433c085364 || ($f01225993cfc23bf$export$33f7c3433c085364 = {}));
var $f01225993cfc23bf$export$852c159401aad03e;
(function(SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($f01225993cfc23bf$export$852c159401aad03e || ($f01225993cfc23bf$export$852c159401aad03e = {}));
var $f01225993cfc23bf$export$1e083fd90afa2f51;
(function(UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($f01225993cfc23bf$export$1e083fd90afa2f51 || ($f01225993cfc23bf$export$1e083fd90afa2f51 = {}));
var $f01225993cfc23bf$export$ecf841796ea7b1f0;
(function(UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($f01225993cfc23bf$export$ecf841796ea7b1f0 || ($f01225993cfc23bf$export$ecf841796ea7b1f0 = {}));
var $f01225993cfc23bf$export$ff4e5952953c0084;
(function(CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj);
    };
})($f01225993cfc23bf$export$ff4e5952953c0084 || ($f01225993cfc23bf$export$ff4e5952953c0084 = {}));
var $f01225993cfc23bf$export$d6a8bd15a4edcee7;
(function(UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($f01225993cfc23bf$export$d6a8bd15a4edcee7 || ($f01225993cfc23bf$export$d6a8bd15a4edcee7 = {}));
var $f01225993cfc23bf$export$b68c35e4811b33e;
(function(UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function(obj) {
        return (0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)((0, $284cdd41a966f3e0$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $17132e2fc00ff395$export$17127055dc9ac067)
        });
    };
})($f01225993cfc23bf$export$b68c35e4811b33e || ($f01225993cfc23bf$export$b68c35e4811b33e = {}));







/**
 * <p>Uploads a part in a multipart upload.</p>
 *          <note>
 *             <p>In this operation, you provide part data in your request. However, you have an option
 *             to specify your existing Amazon S3 object as a data source for the part you are uploading. To
 *             upload a part from an existing object, you use the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> operation.
 *          </p>
 *          </note>
 *
 *          <p>You must initiate a multipart upload (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>)
 *          before you can upload any part. In response to your initiate request, Amazon S3 returns an
 *          upload ID, a unique identifier, that you must include in your upload part request.</p>
 *          <p>Part numbers can be any number from 1 to 10,000, inclusive. A part number uniquely
 *          identifies a part and also defines its position within the object being created. If you
 *          upload a new part using the same part number that was used with a previous part, the
 *          previously uploaded part is overwritten. Each part must be at least 5 MB in size, except
 *          the last part. There is no size limit on the last part of your multipart upload.</p>
 *          <p>To ensure that data is not corrupted when traversing the network, specify the
 *             <code>Content-MD5</code> header in the upload part request. Amazon S3 checks the part data
 *          against the provided MD5 value. If they do not match, Amazon S3 returns an error. </p>
 *
 *          <p>If the upload request is signed with Signature Version 4, then AWS S3 uses the
 *             <code>x-amz-content-sha256</code> header as a checksum instead of
 *             <code>Content-MD5</code>. For more information see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-auth-using-authorization-header.html">Authenticating Requests: Using the Authorization Header (AWS Signature Version
 *             4)</a>. </p>
 *
 *
 *
 *          <p>
 *             <b>Note:</b> After you initiate multipart upload and upload
 *          one or more parts, you must either complete or abort multipart upload in order to stop
 *          getting charged for storage of the uploaded parts. Only after you either complete or abort
 *          multipart upload, Amazon S3 frees up the parts storage and stops charging you for the parts
 *          storage.</p>
 *
 *          <p>For more information on multipart uploads, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a> in the
 *             <i>Amazon Simple Storage Service Developer Guide </i>.</p>
 *          <p>For information on the permissions required to use the multipart upload API, go to
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>You can optionally request server-side encryption where Amazon S3 encrypts your data as it
 *          writes it to disks in its data centers and decrypts it for you when you access it. You have
 *          the option of providing your own encryption key, or you can use the AWS managed encryption
 *          keys. If you choose to provide your own encryption key, the request headers you provide in
 *          the request must match the headers you used in the request to initiate the upload by using
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>. For more information, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side Encryption</a> in
 *          the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>Server-side encryption is supported by the S3 Multipart Upload actions. Unless you are
 *          using a customer-provided encryption key, you don't need to specify the encryption
 *          parameters in each UploadPart request. Instead, you only need to specify the server-side
 *          encryption parameters in the initial Initiate Multipart request. For more information, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>.</p>
 *
 *          <p>If you requested server-side encryption using a customer-provided encryption key in your
 *          initiate multipart upload request, you must provide identical encryption information in
 *          each part upload using the following headers.</p>
 *
 *
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *
 *          <p class="title">
 *             <b>Special Errors</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <ul>
 *                   <li>
 *                      <p>
 *                         <i>Code: NoSuchUpload</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>Cause: The specified multipart upload does not exist. The upload
 *                         ID might be invalid, or the multipart upload might have been aborted or
 *                         completed.</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i> HTTP Status Code: 404 Not Found </i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>SOAP Fault Code Prefix: Client</i>
 *                      </p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *
 *
 *
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $c1dcc65391ab1b6e$export$20fd13f6cebe56f0 = /** @class */ function(_super) {
    (0, $284cdd41a966f3e0$export$a8ba968b8961cb8a)(UploadPartCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ UploadPartCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $46e9f99dae7fdceb$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $298fba8493d5052b$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $42663689ef2a8539$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "UploadPartCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $f01225993cfc23bf$export$ecf841796ea7b1f0).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $f01225993cfc23bf$export$1e083fd90afa2f51).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCommand.prototype.serialize = function(input, context) {
        return (0, $90d6831a7e5c0072$export$6dfc42032d3f37d4)(input, context);
    };
    UploadPartCommand.prototype.deserialize = function(output, context) {
        return (0, $90d6831a7e5c0072$export$176ef954f1bec178)(output, context);
    };
    return UploadPartCommand;
}((0, $805ce49cff93934b$export$cc7e12c76513e857));



var $bbad41731d45e2a3$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $bbad41731d45e2a3$var$R = typeof Reflect === 'object' ? Reflect : null;
var $bbad41731d45e2a3$var$ReflectApply = $bbad41731d45e2a3$var$R && typeof $bbad41731d45e2a3$var$R.apply === 'function' ? $bbad41731d45e2a3$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $bbad41731d45e2a3$var$ReflectOwnKeys;
if ($bbad41731d45e2a3$var$R && typeof $bbad41731d45e2a3$var$R.ownKeys === 'function') $bbad41731d45e2a3$var$ReflectOwnKeys = $bbad41731d45e2a3$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $bbad41731d45e2a3$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $bbad41731d45e2a3$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $bbad41731d45e2a3$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $bbad41731d45e2a3$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $bbad41731d45e2a3$var$EventEmitter() {
    $bbad41731d45e2a3$var$EventEmitter.init.call(this);
}
$bbad41731d45e2a3$exports = $bbad41731d45e2a3$var$EventEmitter;
$bbad41731d45e2a3$exports.once = $bbad41731d45e2a3$var$once;
// Backwards-compat with node 0.10.x
$bbad41731d45e2a3$var$EventEmitter.EventEmitter = $bbad41731d45e2a3$var$EventEmitter;
$bbad41731d45e2a3$var$EventEmitter.prototype._events = undefined;
$bbad41731d45e2a3$var$EventEmitter.prototype._eventsCount = 0;
$bbad41731d45e2a3$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $bbad41731d45e2a3$var$defaultMaxListeners = 10;
function $bbad41731d45e2a3$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($bbad41731d45e2a3$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $bbad41731d45e2a3$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $bbad41731d45e2a3$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $bbad41731d45e2a3$var$defaultMaxListeners = arg;
    }
});
$bbad41731d45e2a3$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$bbad41731d45e2a3$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $bbad41731d45e2a3$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $bbad41731d45e2a3$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $bbad41731d45e2a3$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$bbad41731d45e2a3$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $bbad41731d45e2a3$var$_getMaxListeners(this);
};
$bbad41731d45e2a3$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $bbad41731d45e2a3$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $bbad41731d45e2a3$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$bbad41731d45e2a3$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $bbad41731d45e2a3$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $bbad41731d45e2a3$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $bbad41731d45e2a3$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $bbad41731d45e2a3$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$bbad41731d45e2a3$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $bbad41731d45e2a3$var$_addListener(this, type, listener, false);
};
$bbad41731d45e2a3$var$EventEmitter.prototype.on = $bbad41731d45e2a3$var$EventEmitter.prototype.addListener;
$bbad41731d45e2a3$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $bbad41731d45e2a3$var$_addListener(this, type, listener, true);
};
function $bbad41731d45e2a3$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $bbad41731d45e2a3$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $bbad41731d45e2a3$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$bbad41731d45e2a3$var$EventEmitter.prototype.once = function once(type, listener) {
    $bbad41731d45e2a3$var$checkListener(listener);
    this.on(type, $bbad41731d45e2a3$var$_onceWrap(this, type, listener));
    return this;
};
$bbad41731d45e2a3$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $bbad41731d45e2a3$var$checkListener(listener);
    this.prependListener(type, $bbad41731d45e2a3$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$bbad41731d45e2a3$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $bbad41731d45e2a3$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $bbad41731d45e2a3$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$bbad41731d45e2a3$var$EventEmitter.prototype.off = $bbad41731d45e2a3$var$EventEmitter.prototype.removeListener;
$bbad41731d45e2a3$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $bbad41731d45e2a3$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $bbad41731d45e2a3$var$unwrapListeners(evlistener) : $bbad41731d45e2a3$var$arrayClone(evlistener, evlistener.length);
}
$bbad41731d45e2a3$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $bbad41731d45e2a3$var$_listeners(this, type, true);
};
$bbad41731d45e2a3$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $bbad41731d45e2a3$var$_listeners(this, type, false);
};
$bbad41731d45e2a3$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $bbad41731d45e2a3$var$listenerCount.call(emitter, type);
};
$bbad41731d45e2a3$var$EventEmitter.prototype.listenerCount = $bbad41731d45e2a3$var$listenerCount;
function $bbad41731d45e2a3$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$bbad41731d45e2a3$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $bbad41731d45e2a3$var$ReflectOwnKeys(this._events) : [];
};
function $bbad41731d45e2a3$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $bbad41731d45e2a3$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $bbad41731d45e2a3$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $bbad41731d45e2a3$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $bbad41731d45e2a3$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $bbad41731d45e2a3$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $bbad41731d45e2a3$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $bbad41731d45e2a3$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $bbad41731d45e2a3$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}



var $fc8b3946f721e38c$var$__assign = undefined && undefined.__assign || function() {
    $fc8b3946f721e38c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc8b3946f721e38c$var$__assign.apply(this, arguments);
};
var $fc8b3946f721e38c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fc8b3946f721e38c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fc8b3946f721e38c$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('AWSS3ProviderManagedUpload');
var $fc8b3946f721e38c$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        // Defaults
        this.minPartSize = 5242880; // in MB
        this.queueSize = 4;
        // Data for current upload
        this.body = null;
        this.params = null;
        this.opts = null;
        this.completedParts = [];
        this.uploadId = null;
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = opts;
        this.emitter = emitter;
        this.s3client = this._createNewS3Client(opts, emitter);
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            var _a, putObjectCommand, _b, numberOfPartsToUpload, parts, start, error_1;
            var _this = this;
            return $fc8b3946f721e38c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            10,
                            ,
                            12
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.validateAndSanitizeBody(this.params.Body)
                        ];
                    case 1:
                        _a.body = _c.sent();
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= this.minPartSize)) return [
                            3 /*break*/ ,
                            2
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        putObjectCommand = new (0, $c54882f0e5c487be$export$4afa2352f8871c26)(this.params);
                        return [
                            2 /*return*/ ,
                            this.s3client.send(putObjectCommand)
                        ];
                    case 2:
                        // Step 1: Initiate the multi part upload
                        _b = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 3:
                        // Step 1: Initiate the multi part upload
                        _b.uploadId = _c.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.minPartSize);
                        parts = this.createParts();
                        start = 0;
                        _c.label = 4;
                    case 4:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            7
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + this.queueSize))
                        ];
                    case 5:
                        // Upload as many as `queueSize` parts simultaneously
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        start += this.queueSize;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 7:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 8:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        error_1 = _c.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 11:
                        // if any error is thrown, call cleanup
                        _c.sent();
                        $fc8b3946f721e38c$var$logger.error('Error. Cancelling the multipart upload.');
                        throw error_1;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.minPartSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new $bbad41731d45e2a3$exports.EventEmitter(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.minPartSize;
            }
            return parts;
        } catch (error) {
            $fc8b3946f721e38c$var$logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            var createMultiPartUploadCommand, response, error_2;
            return $fc8b3946f721e38c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        createMultiPartUploadCommand = new (0, $446af679b4f8200b$export$76155123c96043b8)(this.params);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(createMultiPartUploadCommand)
                        ];
                    case 1:
                        response = _a.sent();
                        $fc8b3946f721e38c$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $fc8b3946f721e38c$var$logger.error(error_2);
                        throw error_2;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return $fc8b3946f721e38c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return $fc8b3946f721e38c$var$__awaiter(_this, void 0, void 0, function() {
                                    var options, _a, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, res;
                                    return $fc8b3946f721e38c$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                options = {
                                                    emitter: part.emitter
                                                };
                                                _a = this.params, Key = _a.Key, Bucket = _a.Bucket, SSECustomerAlgorithm = _a.SSECustomerAlgorithm, SSECustomerKey = _a.SSECustomerKey, SSECustomerKeyMD5 = _a.SSECustomerKeyMD5;
                                                return [
                                                    4 /*yield*/ ,
                                                    this.s3client.send(new (0, $c1dcc65391ab1b6e$export$20fd13f6cebe56f0)($fc8b3946f721e38c$var$__assign($fc8b3946f721e38c$var$__assign($fc8b3946f721e38c$var$__assign({
                                                        PartNumber: part.partNumber,
                                                        Body: part.bodyPart,
                                                        UploadId: uploadId,
                                                        Key: Key,
                                                        Bucket: Bucket
                                                    }, SSECustomerAlgorithm && {
                                                        SSECustomerAlgorithm: SSECustomerAlgorithm
                                                    }), SSECustomerKey && {
                                                        SSECustomerKey: SSECustomerKey
                                                    }), SSECustomerKeyMD5 && {
                                                        SSECustomerKeyMD5: SSECustomerKeyMD5
                                                    })), options)
                                                ];
                                            case 1:
                                                res = _b.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $fc8b3946f721e38c$var$logger.error('Error happened while uploading a part. Cancelling the multipart upload');
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            var input, completeUploadCommand, data, error_4;
            return $fc8b3946f721e38c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId,
                            MultipartUpload: {
                                Parts: this.completedParts
                            }
                        };
                        completeUploadCommand = new (0, $1e184024b66a3f63$export$f827ea0301b4eeff)(input);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(completeUploadCommand)
                        ];
                    case 2:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.Key
                        ];
                    case 3:
                        error_4 = _a.sent();
                        $fc8b3946f721e38c$var$logger.error('Error happened while finishing the upload.');
                        throw error_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            var input, data;
            return $fc8b3946f721e38c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId
                        };
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $f1e687e9d7f64702$export$87d2388f8662d995)(input))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $2f1b9239518d1a7c$export$17fb27d830090508)(input))
                        ];
                    case 2:
                        data = _a.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error('Multipart upload clean up failed.');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, $150069abd9b86342$export$c5e6923933be22a0));
        part.emitter.removeAllListeners((0, $150069abd9b86342$export$660a92f3322ba11a));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $150069abd9b86342$export$c5e6923933be22a0), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $150069abd9b86342$export$c5e6923933be22a0), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === 'number') return input.byteLength;
        else if (typeof input.length === 'number') return input.length;
        else if (typeof input.size === 'number') return input.size;
        else if (typeof input.path === 'string') ;
        else throw new Error('Cannot determine length of ' + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        return $fc8b3946f721e38c$var$__awaiter(this, void 0, void 0, function() {
            return $fc8b3946f721e38c$var$__generator(this, function(_a) {
                if (this.isGenericObject(body)) // Any javascript object
                return [
                    2 /*return*/ ,
                    JSON.stringify(body)
                ];
                else // Files, arrayBuffer etc
                return [
                    2 /*return*/ ,
                    body
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === 'object') try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype._createNewS3Client = function(config, emitter) {
        var s3client = (0, $fad6f390597158c6$export$4cdd37a0748e6ad9)(config, emitter);
        s3client.middlewareStack.add((0, $fad6f390597158c6$export$95bc4f3188064861)(this.opts, this.params.Key), (0, $fad6f390597158c6$export$52daf78b33f1adcd));
        s3client.middlewareStack.add((0, $fad6f390597158c6$export$d1971fb9f9448f)(s3client.config), (0, $fad6f390597158c6$export$2edd0200412be327));
        return s3client;
    };
    return AWSS3ProviderManagedUpload;
}();








var $30fad0a8146fbb95$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $30fad0a8146fbb95$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $30fad0a8146fbb95$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $30fad0a8146fbb95$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($30fad0a8146fbb95$var$__read(arguments[i]));
    return ar;
};
var $30fad0a8146fbb95$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('AWSS3UploadTask');
var $30fad0a8146fbb95$export$badc82e7c9337824;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})($30fad0a8146fbb95$export$badc82e7c9337824 || ($30fad0a8146fbb95$export$badc82e7c9337824 = {}));
var $30fad0a8146fbb95$export$1c9379601995aced;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})($30fad0a8146fbb95$export$1c9379601995aced || ($30fad0a8146fbb95$export$1c9379601995aced = {}));
// maximum number of parts per upload request according the S3 spec,
// see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/qfacts.html
var $30fad0a8146fbb95$var$MAX_PARTS = 10000;
// 5MB in bytes
var $30fad0a8146fbb95$var$PART_SIZE = 5242880;
var $30fad0a8146fbb95$var$DEFAULT_QUEUE_SIZE = 4;
function $30fad0a8146fbb95$var$comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var $30fad0a8146fbb95$export$ca4ab80441206528 = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Client = _a.s3Client, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.partSize = $30fad0a8146fbb95$var$PART_SIZE;
        this.queueSize = $30fad0a8146fbb95$var$DEFAULT_QUEUE_SIZE;
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.INIT;
        this.prefixPromise = prefixPromise;
        this.s3client = s3Client;
        this.s3client.middlewareStack.remove((0, $d8b1b885535830c6$export$8179b8ba0ab1e018));
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage['sync'] === 'function') this.storageSync = this.storage['sync']();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on($30fad0a8146fbb95$export$1c9379601995aced.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function() {
            return this.state === $30fad0a8146fbb95$export$badc82e7c9337824.IN_PROGRESS;
        },
        enumerable: true,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var listObjectRes, _b, Contents, prefix, obj;
            return $30fad0a8146fbb95$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $c1bd55dc3f94b37f$export$479061a53a55f030)({
                                Bucket: bucket,
                                Prefix: key
                            }))
                        ];
                    case 1:
                        listObjectRes = _c.sent();
                        _b = listObjectRes.Contents, Contents = _b === void 0 ? [] : _b;
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        prefix = _c.sent();
                        obj = Contents.find(function(o) {
                            return o.Key === "" + prefix + key;
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, $1327559aa0e26375$export$be78b3111c50efdd)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join('-');
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join('-');
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, listPartsOutput;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, $d8b1b885535830c6$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $2f1b9239518d1a7c$export$17fb27d830090508)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: cachedUploadFileData.uploadId
                            }))
                        ];
                    case 2:
                        listPartsOutput = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                parts: listPartsOutput.Parts || [],
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.file.size / this.partSize > $30fad0a8146fbb95$var$MAX_PARTS) throw new Error("Too many parts. Number of parts is " + this.file.size / this.partSize + ", maximum is " + $30fad0a8146fbb95$var$MAX_PARTS + ".");
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var tasks;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, $d8b1b885535830c6$export$b9acc545d1bd0170)) || '{}';
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, $d8b1b885535830c6$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return $30fad0a8146fbb95$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, $d8b1b885535830c6$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            return $30fad0a8146fbb95$var$__generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, $1327559aa0e26375$export$a48f0734ac7c2329)(chunk);
                this._emitEvent($30fad0a8146fbb95$export$1c9379601995aced.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== $30fad0a8146fbb95$export$badc82e7c9337824.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var err_1;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $1e184024b66a3f63$export$f827ea0301b4eeff)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: this.uploadId,
                                MultipartUpload: {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: this.completedParts.sort($30fad0a8146fbb95$var$comparePartNumber)
                                }
                            }))
                        ];
                    case 1:
                        _a.sent();
                        this._verifyFileSize();
                        this._emitEvent($30fad0a8146fbb95$export$1c9379601995aced.UPLOAD_COMPLETE, {
                            key: this.params.Bucket + "/" + this.params.Key
                        });
                        this._removeFromCache();
                        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.COMPLETED;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        $30fad0a8146fbb95$var$logger.error('error completing upload', err_1);
                        this._emitEvent($30fad0a8146fbb95$export$1c9379601995aced.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, cancelTokenSource) {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var res, err_2;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $c1dcc65391ab1b6e$export$20fd13f6cebe56f0)(input), {
                                cancelTokenSource: cancelTokenSource
                            })
                        ];
                    case 1:
                        res = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_2 = _a.sent();
                        if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.PAUSED) $30fad0a8146fbb95$var$logger.log('upload paused');
                        else if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.CANCELLED) $30fad0a8146fbb95$var$logger.log('upload aborted');
                        else $30fad0a8146fbb95$var$logger.error('error starting next part of upload: ', err_2);
                        // axios' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).isCancel(err_2) && err_2.message !== (0, $af8567358603a938$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE) {
                            this._emitEvent($30fad0a8146fbb95$export$1c9379601995aced.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== $30fad0a8146fbb95$export$badc82e7c9337824.PAUSED) {
            var cancelTokenSource = (0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).CancelToken.source();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, cancelTokenSource),
                cancel: cancelTokenSource.cancel
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var obj, valid;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        if (!valid) throw new Error('File size does not match between local file and file on s3');
                        return [
                            2 /*return*/ ,
                            valid
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent($30fad0a8146fbb95$export$1c9379601995aced.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var res;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $446af679b4f8200b$export$76155123c96043b8)(this.params))
                        ];
                    case 1:
                        res = _a.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ''
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return $30fad0a8146fbb95$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.IN_PROGRESS;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).isCancel(err_3)) $30fad0a8146fbb95$var$logger.error('Error initializing the upload task', err_3);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.CANCELLED) $30fad0a8146fbb95$var$logger.warn('This task has already been cancelled');
        else if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.COMPLETED) $30fad0a8146fbb95$var$logger.warn('This task has already been completed');
        else if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.IN_PROGRESS) $30fad0a8146fbb95$var$logger.warn('Upload task already in progress');
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return $30fad0a8146fbb95$var$__awaiter(this, void 0, void 0, function() {
            var err_4;
            return $30fad0a8146fbb95$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.state === $30fad0a8146fbb95$export$badc82e7c9337824.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        $30fad0a8146fbb95$var$logger.warn('This task has already been cancelled');
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === $30fad0a8146fbb95$export$badc82e7c9337824.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        $30fad0a8146fbb95$var$logger.warn('This task has already been completed');
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.CANCELLED;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.s3client.send(new (0, $f1e687e9d7f64702$export$87d2388f8662d995)({
                                Bucket: this.params.Bucket,
                                Key: this.params.Key,
                                UploadId: this.uploadId
                            }))
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 6:
                        err_4 = _a.sent();
                        $30fad0a8146fbb95$var$logger.error('Error cancelling upload task', err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.CANCELLED) $30fad0a8146fbb95$var$logger.warn('This task has already been cancelled');
        else if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.COMPLETED) $30fad0a8146fbb95$var$logger.warn('This task has already been completed');
        else if (this.state === $30fad0a8146fbb95$export$badc82e7c9337824.PAUSED) $30fad0a8146fbb95$var$logger.warn('This task is already paused');
        this.state = $30fad0a8146fbb95$export$badc82e7c9337824.PAUSED;
        // Use axios cancel token to abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.cancel((0, $af8567358603a938$export$179814ca32efa022).UPLOAD_PAUSED_MESSAGE);
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, $30fad0a8146fbb95$var$__spread(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })));
    };
    return AWSS3UploadTask;
}();




var $2c1da9fc10eb5af3$var$__assign = undefined && undefined.__assign || function() {
    $2c1da9fc10eb5af3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c1da9fc10eb5af3$var$__assign.apply(this, arguments);
};
var $2c1da9fc10eb5af3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2c1da9fc10eb5af3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2c1da9fc10eb5af3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2c1da9fc10eb5af3$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2c1da9fc10eb5af3$var$__read(arguments[i]));
    return ar;
};
var $2c1da9fc10eb5af3$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('AWSS3Provider');
var $2c1da9fc10eb5af3$var$DEFAULT_STORAGE_LEVEL = 'public';
var $2c1da9fc10eb5af3$var$DEFAULT_PRESIGN_EXPIRATION = 900;
/**
 * Provide storage methods to use AWS S3
 */ var $2c1da9fc10eb5af3$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, $95dac8785b133953$export$a2bd19c49e4760e8)().getStorage();
        (0, $6c553752040387ec$export$8c41bb232f1008b1).listen('auth', function(data) {
            var payload = data.payload;
            if (payload.event === 'signOut' || payload.event === 'signIn') _this._storage.removeItem((0, $d8b1b885535830c6$export$b9acc545d1bd0170));
        });
        $2c1da9fc10eb5af3$var$logger.debug('Storage Options', this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $2c1da9fc10eb5af3$var$logger.debug('configure Storage', config);
        if (!config) return this._config;
        var amplifyConfig = (0, $7b9bdee1f3af029c$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $2c1da9fc10eb5af3$var$logger.debug('Do not have bucket yet');
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var s3Client = addTaskInput.s3Client, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, _a = config.track, track = _a === void 0 ? false : _a;
        if (!(file instanceof Blob)) throw new Error((0, $af8567358603a938$export$148a3867c72aff96).INVALID_BLOB);
        emitter.on((0, $30fad0a8146fbb95$export$1c9379601995aced).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === 'function') progressCallback(event);
                else $2c1da9fc10eb5af3$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
            }
        });
        emitter.on((0, $30fad0a8146fbb95$export$1c9379601995aced).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === 'function') completeCallback(event);
                else $2c1da9fc10eb5af3$var$logger.warn('completeCallback should be a function, not a ' + typeof completeCallback);
            }
        });
        emitter.on((0, $30fad0a8146fbb95$export$1c9379601995aced).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === 'function') errorCallback(err);
                else $2c1da9fc10eb5af3$var$logger.warn('errorCallback should be a function, not a ' + typeof errorCallback);
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, $99c5343f38dbb45f$export$a9627919734faa48).get().then(function(credentials) {
            var cred = (0, $99c5343f38dbb45f$export$a9627919734faa48).shear(credentials);
            return (0, $fad6f390597158c6$export$36e24695f02d4503)($2c1da9fc10eb5af3$var$__assign($2c1da9fc10eb5af3$var$__assign({}, config), {
                credentials: cred
            }));
        });
        var task = new (0, $30fad0a8146fbb95$export$ca4ab80441206528)({
            s3Client: s3Client,
            file: file,
            emitter: emitter,
            level: config.level,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'upload', {
            method: 'put',
            result: 'success'
        }, null, "Upload Task created successfully for " + key);
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, _a, srcLevel, srcIdentityId, srcKey, _b, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, s3, error_1;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        _a = src.level, srcLevel = _a === void 0 ? $2c1da9fc10eb5af3$var$DEFAULT_STORAGE_LEVEL : _a, srcIdentityId = src.identityId, srcKey = src.key;
                        _b = dest.level, destLevel = _b === void 0 ? $2c1da9fc10eb5af3$var$DEFAULT_STORAGE_LEVEL : _b, destKey = dest.key;
                        if (!srcKey || typeof srcKey !== 'string') throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== 'string') throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_DEST_KEY);
                        if (srcLevel !== 'protected' && srcIdentityId) $2c1da9fc10eb5af3$var$logger.warn("You may copy files from another user if the source level is \"protected\", currently it's " + srcLevel);
                        srcPrefix = this._prefix($2c1da9fc10eb5af3$var$__assign($2c1da9fc10eb5af3$var$__assign($2c1da9fc10eb5af3$var$__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix($2c1da9fc10eb5af3$var$__assign($2c1da9fc10eb5af3$var$__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = bucket + "/" + srcPrefix + srcKey;
                        finalDestKey = "" + destPrefix + destKey;
                        $2c1da9fc10eb5af3$var$logger.debug("copying " + finalSrcKey + " to " + finalDestKey);
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: 'COPY'
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        s3 = this._createNewS3Client(opt);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $00fdd9074c84ffcd$export$dae1e139b4ba0d49)(params))
                        ];
                    case 3:
                        _c.sent();
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'copy', {
                            method: 'copy',
                            result: 'success'
                        }, null, "Copy success from " + srcKey + " to " + destKey);
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'copy', {
                            method: 'copy',
                            result: 'failed'
                        }, null, "Copy failed from " + srcKey + " to " + destKey);
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, prefix, final_key, emitter, s3, params, getObjectCommand, response, error_2, signer, request, url, _a, error_3;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new $bbad41731d45e2a3$exports.EventEmitter();
                        s3 = this._createNewS3Client(opt, emitter);
                        $2c1da9fc10eb5af3$var$logger.debug('get ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        getObjectCommand = new (0, $bd3eb4860b3b163e$export$25364b3fa12a4666)(params);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === 'function') emitter.on((0, $150069abd9b86342$export$660a92f3322ba11a), function(progress) {
                                progressCallback(progress);
                            });
                            else $2c1da9fc10eb5af3$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
                        }
                        return [
                            4 /*yield*/ ,
                            s3.send(getObjectCommand)
                        ];
                    case 3:
                        response = _b.sent();
                        emitter.removeAllListeners((0, $150069abd9b86342$export$660a92f3322ba11a));
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'download', {
                            method: 'get',
                            result: 'success'
                        }, {
                            fileSize: Number(response.Body['size'] || response.Body['length'])
                        }, "Download success for " + key);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _b.sent();
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'download', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Download failed with " + error_2.message);
                        throw error_2;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        signer = new (0, $82c40c9e44f2041b$export$a1673011a6b3560f)($2c1da9fc10eb5af3$var$__assign({}, s3.config));
                        return [
                            4 /*yield*/ ,
                            (0, $146355dbdccc18f4$export$72e3afa9ac8966be)(s3, new (0, $bd3eb4860b3b163e$export$25364b3fa12a4666)(params))
                        ];
                    case 6:
                        request = _b.sent();
                        _a = (0, $d08e61eb983553d6$export$75025487296cba38);
                        return [
                            4 /*yield*/ ,
                            signer.presign(request, {
                                expiresIn: expires || $2c1da9fc10eb5af3$var$DEFAULT_PRESIGN_EXPIRATION
                            })
                        ];
                    case 7:
                        url = _a.apply(void 0, [
                            _b.sent()
                        ]);
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'success'
                        }, null, "Signed URL: " + url);
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 8:
                        error_3 = _b.sent();
                        $2c1da9fc10eb5af3$var$logger.warn('get signed url error', error_3);
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Could not get a signed URL for " + key);
                        throw error_3;
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : 'binary/octet-stream';
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new $bbad41731d45e2a3$exports.EventEmitter();
        var uploader = new (0, $fc8b3946f721e38c$export$da75ae8ad0285104)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Client = this._createNewS3Client(opt);
            // we are using aws sdk middleware to inject the prefix to key, this way we don't have to call
            // this._ensureCredentials() which allows us to make this function sync so we can return non-Promise like UploadTask
            s3Client.middlewareStack.add((0, $fad6f390597158c6$export$95bc4f3188064861)(opt, key), (0, $fad6f390597158c6$export$52daf78b33f1adcd));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Client: s3Client,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === 'function') emitter.on((0, $150069abd9b86342$export$c5e6923933be22a0), function(progress) {
                    progressCallback(progress);
                });
                else $2c1da9fc10eb5af3$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
            }
            return uploader.upload().then(function(response) {
                $2c1da9fc10eb5af3$var$logger.debug('upload result', response);
                (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'upload', {
                    method: 'put',
                    result: 'success'
                }, null, "Upload success for " + key);
                return {
                    key: key
                };
            });
        } catch (error) {
            $2c1da9fc10eb5af3$var$logger.warn('error uploading', error);
            (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'upload', {
                method: 'put',
                result: 'failed'
            }, null, "Error uploading " + key);
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_4;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $2c1da9fc10eb5af3$var$logger.debug('remove ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        deleteObjectCommand = new (0, $7b3e3a34c31e036b$export$d60592d05571c4ef)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(deleteObjectCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'delete', {
                            method: 'remove',
                            result: 'success'
                        }, null, "Deleted " + key + " successfully");
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_4 = _a.sent();
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'delete', {
                            method: 'remove',
                            result: 'failed'
                        }, null, "Deletion of " + key + " failed with " + error_4);
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var result, s3, listObjectsV2Command, response;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        result = {
                            contents: [],
                            nextToken: ''
                        };
                        s3 = this._createNewS3Client(opt);
                        listObjectsV2Command = new (0, $c1bd55dc3f94b37f$export$479061a53a55f030)($2c1da9fc10eb5af3$var$__assign({}, params));
                        return [
                            4 /*yield*/ ,
                            s3.send(listObjectsV2Command)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            result.contents = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            result.nextToken = response.NextContinuationToken;
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified and file size for
     * all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, list, token, listResult, params, error_5;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $af8567358603a938$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        $2c1da9fc10eb5af3$var$logger.debug('list ' + path + ' from ' + final_path);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = [];
                        token = void 0;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: 1000
                        };
                        if (!(maxKeys === 'ALL')) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a.label = 3;
                    case 3:
                        params.ContinuationToken = token;
                        params.MaxKeys = 1000;
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _a.sent();
                        list.push.apply(list, $2c1da9fc10eb5af3$var$__spread(listResult.contents));
                        if (listResult.nextToken) token = listResult.nextToken;
                        _a.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        maxKeys < 1000 || typeof maxKeys === 'string' ? params.MaxKeys = maxKeys : params.MaxKeys = 1000;
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _a.sent();
                        list.push.apply(list, $2c1da9fc10eb5af3$var$__spread(listResult.contents));
                        if (maxKeys > 1000) $2c1da9fc10eb5af3$var$logger.warn("maxkeys can be from 0 - 1000 or 'ALL'. To list all files you can set maxKeys to 'ALL'.");
                        _a.label = 9;
                    case 9:
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'list', {
                            method: 'list',
                            result: 'success'
                        }, null, list.length + " items returned from list operation");
                        $2c1da9fc10eb5af3$var$logger.debug('list', list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_5 = _a.sent();
                        $2c1da9fc10eb5af3$var$logger.warn('list error', error_5);
                        (0, $1327559aa0e26375$export$f4575af7aa417855)(track, 'list', {
                            method: 'list',
                            result: 'failed'
                        }, null, "Listing items failed: " + error_5.message);
                        throw error_5;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return $2c1da9fc10eb5af3$var$__awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_6;
            return $2c1da9fc10eb5af3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $99c5343f38dbb45f$export$a9627919734faa48).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, $99c5343f38dbb45f$export$a9627919734faa48).shear(credentials);
                        $2c1da9fc10eb5af3$var$logger.debug('set credentials for storage', cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_6 = _a.sent();
                        $2c1da9fc10eb5af3$var$logger.warn('ensure credentials error', error_6);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return typeof config === 'object' && config.hasOwnProperty('credentials');
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : 'private/') + identityId + '/';
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : 'protected/') + identityId + '/';
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : 'public/';
        switch(level){
            case 'private':
                return privatePath;
            case 'protected':
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * Creates an S3 client with new V3 aws sdk
     */ AWSS3Provider.prototype._createNewS3Client = function(config, emitter) {
        var s3client = (0, $fad6f390597158c6$export$4cdd37a0748e6ad9)(config, emitter);
        s3client.middlewareStack.add((0, $fad6f390597158c6$export$d1971fb9f9448f)(s3client.config), (0, $fad6f390597158c6$export$2edd0200412be327));
        return s3client;
    };
    AWSS3Provider.CATEGORY = 'Storage';
    AWSS3Provider.PROVIDER_NAME = 'AWSS3';
    return AWSS3Provider;
}();
var /**
 * @deprecated use named import
 */ $2c1da9fc10eb5af3$export$2e2bcd8739ae039 = $2c1da9fc10eb5af3$export$a8628d9eb315b139;




var $7744c68cdfaf0174$var$__assign = undefined && undefined.__assign || function() {
    $7744c68cdfaf0174$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7744c68cdfaf0174$var$__assign.apply(this, arguments);
};
var $7744c68cdfaf0174$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7744c68cdfaf0174$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('StorageClass');
var $7744c68cdfaf0174$var$DEFAULT_PROVIDER = 'AWSS3';
/**
 * Provide storage methods to use AWS S3
 */ var $7744c68cdfaf0174$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._cancelTokenSourceMap = new WeakMap();
        $7744c68cdfaf0174$var$logger.debug('Storage Options', this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return 'Storage';
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Storage') {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        $7744c68cdfaf0174$var$logger.debug('configure Storage');
        if (!config) return this._config;
        var amplifyConfig = (0, $7b9bdee1f3af029c$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            'bucket',
            'region',
            'level',
            'track',
            'customPrefix',
            'serverSideEncryption',
            'SSECustomerAlgorithm',
            'SSECustomerKey',
            'SSECustomerKeyMD5',
            'SSEKMSKeyId'
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$7744c68cdfaf0174$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$7744c68cdfaf0174$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var _b = $7744c68cdfaf0174$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$7744c68cdfaf0174$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== 'string') _this._config[providerName] = $7744c68cdfaf0174$var$__assign($7744c68cdfaf0174$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $2c1da9fc10eb5af3$export$a8628d9eb315b139)());
        return this._config;
    };
    Storage.prototype.getCancellableTokenSource = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).CancelToken.source();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, cancelTokenSource) {
        this._cancelTokenSourceMap.set(request, cancelTokenSource);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== 'undefined' && typeof x['pause'] === 'function' && typeof x['resume'] === 'function';
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, $30fad0a8146fbb95$export$ca4ab80441206528)) return request._cancel();
        var cancelTokenSource = this._cancelTokenSourceMap.get(request);
        if (cancelTokenSource) cancelTokenSource.cancel(message);
        else $7744c68cdfaf0174$var$logger.debug('The request does not map to any cancel token');
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $7744c68cdfaf0174$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        if (typeof prov.copy !== 'function') return Promise.reject(".copy is not implemented on provider " + prov.getProviderName());
        var responsePromise = prov.copy(src, dest, $7744c68cdfaf0174$var$__assign($7744c68cdfaf0174$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $7744c68cdfaf0174$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var responsePromise = prov.get(key, $7744c68cdfaf0174$var$__assign($7744c68cdfaf0174$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b065ee753212adbd$exports))).isCancel(error);
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $7744c68cdfaf0174$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var response = prov.put(key, object, $7744c68cdfaf0174$var$__assign($7744c68cdfaf0174$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, cancelTokenSource);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $7744c68cdfaf0174$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        return prov.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $7744c68cdfaf0174$var$DEFAULT_PROVIDER;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $7744c68cdfaf0174$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        return prov.list(path, config);
    };
    return Storage;
}();
var /**
 * @deprecated use named import
 */ $7744c68cdfaf0174$export$2e2bcd8739ae039 = $7744c68cdfaf0174$export$bf2a15d34f3c441c;




var $ef4da9a40ff7e000$var$__assign = undefined && undefined.__assign || function() {
    $ef4da9a40ff7e000$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef4da9a40ff7e000$var$__assign.apply(this, arguments);
};
var $ef4da9a40ff7e000$var$logger = new (0, $169cd1937805fb62$export$ba6a9c7ac8291f7f)('Storage');
var $ef4da9a40ff7e000$var$_instance = null;
var $ef4da9a40ff7e000$var$getInstance = function() {
    if ($ef4da9a40ff7e000$var$_instance) return $ef4da9a40ff7e000$var$_instance;
    $ef4da9a40ff7e000$var$logger.debug('Create Storage Instance, debug');
    $ef4da9a40ff7e000$var$_instance = new (0, $7744c68cdfaf0174$export$bf2a15d34f3c441c)();
    $ef4da9a40ff7e000$var$_instance.vault = new (0, $7744c68cdfaf0174$export$bf2a15d34f3c441c)();
    var old_configure = $ef4da9a40ff7e000$var$_instance.configure;
    $ef4da9a40ff7e000$var$_instance.configure = function(options) {
        $ef4da9a40ff7e000$var$logger.debug('storage configure called');
        var vaultConfig = $ef4da9a40ff7e000$var$__assign({}, old_configure.call($ef4da9a40ff7e000$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== 'string') vaultConfig[providerName] = $ef4da9a40ff7e000$var$__assign($ef4da9a40ff7e000$var$__assign({}, vaultConfig[providerName]), {
                level: 'private'
            });
        });
        $ef4da9a40ff7e000$var$logger.debug('storage vault configure called');
        $ef4da9a40ff7e000$var$_instance.vault.configure(vaultConfig);
    };
    return $ef4da9a40ff7e000$var$_instance;
};
var $ef4da9a40ff7e000$export$bf2a15d34f3c441c = $ef4da9a40ff7e000$var$getInstance();
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).register($ef4da9a40ff7e000$export$bf2a15d34f3c441c);
var /**
 * @deprecated use named import
 */ $ef4da9a40ff7e000$export$2e2bcd8739ae039 = $ef4da9a40ff7e000$export$bf2a15d34f3c441c;






var $9a2170a1daa0d0fd$exports = {};
!function(t, _) {
    $9a2170a1daa0d0fd$exports = _();
}($9a2170a1daa0d0fd$exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});






/** Always importing Auth when users import Amplify such that
    for unauthenticated access (no sign in and sign up),
    users don't have to import Auth explicitly **/ (0, $5af950529fc36b5c$export$a3858a9a153cffc7).Auth = (0, $f759aa5a9826e8c0$export$334c29725a78c21d);
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).Cache = (0, $2304dc79b3eccfd5$export$2a9787695d97e2c4);
(0, $5af950529fc36b5c$export$a3858a9a153cffc7).ServiceWorker = (0, $501a52dd801880e3$export$efa87b877bb98f58);
var /**
 * @deprecated use named import
 */ $402b8719785b6ed6$export$2e2bcd8739ae039 = (0, $5af950529fc36b5c$export$a3858a9a153cffc7);


var $cd730a104af6804b$exports = {};

$cd730a104af6804b$exports = (parcelRequire("i8TFP"));


/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $6439b24cc7104459$export$2e2bcd8739ae039 = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();


/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
(0, $6439b24cc7104459$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ = (0, $6439b24cc7104459$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ || {
    key: undefined
};
class $332fe187cd95a041$export$2c56d2e2ae515eeb {
    static getLicenseInfo() {
        // eslint-disable-next-line no-underscore-dangle
        return (0, $6439b24cc7104459$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__;
    }
    static getLicenseKey() {
        return $332fe187cd95a041$export$2c56d2e2ae515eeb.getLicenseInfo().key;
    }
    static setLicenseKey(key) {
        const licenseInfo = $332fe187cd95a041$export$2c56d2e2ae515eeb.getLicenseInfo();
        licenseInfo.key = key;
    }
}



var $jSIPP = parcelRequire("jSIPP");
var $3ab9800416b64e29$exports = {};
'use strict';
function $3ab9800416b64e29$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3ab9800416b64e29$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3ab9800416b64e29$var$checkDCE();

$3ab9800416b64e29$exports = (parcelRequire("6iqOz"));



var $jSIPP = parcelRequire("jSIPP");


var $jSIPP = parcelRequire("jSIPP");
var $38466c51aa421565$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(null);
var $38466c51aa421565$export$2e2bcd8739ae039 = $38466c51aa421565$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $d2bbd54d45fd1796$var$defaultNoopBatch(callback) {
    callback();
}
var $d2bbd54d45fd1796$var$batch = $d2bbd54d45fd1796$var$defaultNoopBatch; // Allow injecting another batching function later
var $d2bbd54d45fd1796$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $d2bbd54d45fd1796$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $d2bbd54d45fd1796$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $d2bbd54d45fd1796$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $fc949115e5b74a0d$var$createListenerCollection() {
    var batch = (0, $d2bbd54d45fd1796$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $fc949115e5b74a0d$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $fc949115e5b74a0d$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $fc949115e5b74a0d$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $fc949115e5b74a0d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $fc949115e5b74a0d$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $jSIPP = parcelRequire("jSIPP");
var $2dc67fb1d5f0574d$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $jSIPP.useLayoutEffect) : (0, $jSIPP.useEffect);


function $44c0ca333985c71b$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $jSIPP.useMemo)(function() {
        var subscription = (0, $fc949115e5b74a0d$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $jSIPP.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $2dc67fb1d5f0574d$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $38466c51aa421565$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $44c0ca333985c71b$export$2e2bcd8739ae039 = $44c0ca333985c71b$var$Provider;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $lvZzf = parcelRequire("lvZzf");

var $jSIPP = parcelRequire("jSIPP");
var $5873eb05407f18b2$exports = {};
'use strict';

$5873eb05407f18b2$exports = (parcelRequire("3qqzO"));





var $171aed46f1d11c14$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $171aed46f1d11c14$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $171aed46f1d11c14$var$EMPTY_ARRAY = [];
var $171aed46f1d11c14$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $171aed46f1d11c14$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $171aed46f1d11c14$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $171aed46f1d11c14$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $2dc67fb1d5f0574d$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $171aed46f1d11c14$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $171aed46f1d11c14$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $171aed46f1d11c14$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $171aed46f1d11c14$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $38466c51aa421565$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $cMu4A.default)(_ref2, $171aed46f1d11c14$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $erOpW.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $jSIPP.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $jSIPP.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $cMu4A.default)(props, $171aed46f1d11c14$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $jSIPP.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $5873eb05407f18b2$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $jSIPP.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $jSIPP.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $jSIPP.useMemo)(function() {
                if (!shouldHandleStateChanges) return $171aed46f1d11c14$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $fc949115e5b74a0d$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $jSIPP.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $erOpW.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $jSIPP.useReducer)($171aed46f1d11c14$var$storeStateUpdatesReducer, $171aed46f1d11c14$var$EMPTY_ARRAY, $171aed46f1d11c14$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $jSIPP.useRef)();
            var lastWrapperProps = (0, $jSIPP.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $jSIPP.useRef)();
            var renderIsScheduled = (0, $jSIPP.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $171aed46f1d11c14$var$useIsomorphicLayoutEffectWithArgs($171aed46f1d11c14$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $171aed46f1d11c14$var$useIsomorphicLayoutEffectWithArgs($171aed46f1d11c14$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $jSIPP.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(WrappedComponent, (0, $erOpW.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $jSIPP.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Connect, (0, $erOpW.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(Connect, WrappedComponent);
    };
}




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

function $ab8ed5f348aa1647$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ab8ed5f348aa1647$export$2e2bcd8739ae039(objA, objB) {
    if ($ab8ed5f348aa1647$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$ab8ed5f348aa1647$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $d574f57fbb7cd424$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f6b937a2aad22a79$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e0fac6da02db5ce7$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $212a79cdf3bdcd83$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $f6b937a2aad22a79$export$2e2bcd8739ae039)(value)) (0, $e0fac6da02db5ce7$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $8f84477f0d652316$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $8f84477f0d652316$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $8f84477f0d652316$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $8f84477f0d652316$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $8f84477f0d652316$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $41e6095968b3b3aa$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8f84477f0d652316$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $41e6095968b3b3aa$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8f84477f0d652316$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $41e6095968b3b3aa$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8f84477f0d652316$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $d574f57fbb7cd424$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $41e6095968b3b3aa$export$2e2bcd8739ae039 = [
    $41e6095968b3b3aa$export$a9f27b4b187c1166,
    $41e6095968b3b3aa$export$ba20d1a7aa0c4a90,
    $41e6095968b3b3aa$export$94a6e55709d4d961
];



function $9e53c8c46cce22e4$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8f84477f0d652316$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $9e53c8c46cce22e4$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8f84477f0d652316$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $9e53c8c46cce22e4$export$2e2bcd8739ae039 = [
    $9e53c8c46cce22e4$export$23fc470827b14aa,
    $9e53c8c46cce22e4$export$514bc8c1a53c1d66
];



var $erOpW = parcelRequire("erOpW");

function $c552d12d878d73a1$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $erOpW.default)({}, ownProps, stateProps, dispatchProps);
}
function $c552d12d878d73a1$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c552d12d878d73a1$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $c552d12d878d73a1$export$5b105939c84b5234(mergeProps) : undefined;
}
function $c552d12d878d73a1$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $c552d12d878d73a1$export$691c327fc30bc857;
    } : undefined;
}
var $c552d12d878d73a1$export$2e2bcd8739ae039 = [
    $c552d12d878d73a1$export$d61b680184bc3f00,
    $c552d12d878d73a1$export$a13ba70ef50dda6d
];



var $cMu4A = parcelRequire("cMu4A");

function $ea8f1f127b30a74f$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $e0fac6da02db5ce7$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $ea8f1f127b30a74f$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $ea8f1f127b30a74f$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $ea8f1f127b30a74f$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $ea8f1f127b30a74f$var$verify(mergeProps, 'mergeProps', displayName);
}


var $8b57d421537b2144$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $8b57d421537b2144$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $8b57d421537b2144$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $8b57d421537b2144$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $cMu4A.default)(_ref2, $8b57d421537b2144$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $8b57d421537b2144$export$d20c0c2ca6eb2b6f : $8b57d421537b2144$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $379c131c18570461$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $379c131c18570461$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $379c131c18570461$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $379c131c18570461$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $171aed46f1d11c14$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $9e53c8c46cce22e4$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $41e6095968b3b3aa$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $c552d12d878d73a1$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $8b57d421537b2144$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $379c131c18570461$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ab8ed5f348aa1647$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ab8ed5f348aa1647$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ab8ed5f348aa1647$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $cMu4A.default)(_ref3, $379c131c18570461$var$_excluded);
        var initMapStateToProps = $379c131c18570461$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $379c131c18570461$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $379c131c18570461$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $erOpW.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $379c131c18570461$export$2e2bcd8739ae039 = /*#__PURE__*/ $379c131c18570461$export$9f9feb656dec1fc4();




var $jSIPP = parcelRequire("jSIPP");


var $jSIPP = parcelRequire("jSIPP");

function $1fa32aa4affee142$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $jSIPP.useContext)((0, $38466c51aa421565$export$cc80c08dc91f1c00));
    return contextValue;
}


function $666e13307cd679f8$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $38466c51aa421565$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $38466c51aa421565$export$cc80c08dc91f1c00) ? (0, $1fa32aa4affee142$export$c1275ca9a6fd3ec5) : function() {
        return (0, $jSIPP.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $666e13307cd679f8$export$6ccbb43953eebf8 = /*#__PURE__*/ $666e13307cd679f8$export$671dba69185d0304();


function $612b05aeb1ec34f5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $38466c51aa421565$export$cc80c08dc91f1c00);
    var useStore = context === (0, $38466c51aa421565$export$cc80c08dc91f1c00) ? (0, $666e13307cd679f8$export$6ccbb43953eebf8) : (0, $666e13307cd679f8$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $612b05aeb1ec34f5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $612b05aeb1ec34f5$export$bc9b55530897c558();



var $jSIPP = parcelRequire("jSIPP");




var $af024b80000f7590$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $af024b80000f7590$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $jSIPP.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $jSIPP.useMemo)(function() {
        return (0, $fc949115e5b74a0d$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $jSIPP.useRef)();
    var latestSelector = (0, $jSIPP.useRef)();
    var latestStoreState = (0, $jSIPP.useRef)();
    var latestSelectedState = (0, $jSIPP.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $2dc67fb1d5f0574d$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $2dc67fb1d5f0574d$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $af024b80000f7590$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $38466c51aa421565$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $38466c51aa421565$export$cc80c08dc91f1c00) ? (0, $1fa32aa4affee142$export$c1275ca9a6fd3ec5) : function() {
        return (0, $jSIPP.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $af024b80000f7590$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $af024b80000f7590$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $jSIPP.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $af024b80000f7590$export$2105062e25df4afe = /*#__PURE__*/ $af024b80000f7590$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $d2bbd54d45fd1796$export$4b9874722d0da7bc)((0, $3ab9800416b64e29$exports.unstable_batchedUpdates));



var $erOpW = parcelRequire("erOpW");

var $erOpW = parcelRequire("erOpW");
var $f475b7f36e97a121$export$6acf61af03e62db = typeof window === 'undefined';
function $f475b7f36e97a121$export$8793edee2d425525() {
    return undefined;
}
function $f475b7f36e97a121$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $f475b7f36e97a121$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $f475b7f36e97a121$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $f475b7f36e97a121$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $f475b7f36e97a121$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $f475b7f36e97a121$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $f475b7f36e97a121$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$f475b7f36e97a121$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $erOpW.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $erOpW.default)({}, arg2, {
        queryKey: arg1
    });
}
function $f475b7f36e97a121$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($f475b7f36e97a121$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $erOpW.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $erOpW.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $erOpW.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $erOpW.default)({}, arg1);
}
function $f475b7f36e97a121$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $f475b7f36e97a121$export$aaae5295ec3351c9(arg1) ? [
        (0, $erOpW.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f475b7f36e97a121$export$42387eeaac09cf54(arg1, arg2) {
    return $f475b7f36e97a121$export$aaae5295ec3351c9(arg1) ? (0, $erOpW.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $f475b7f36e97a121$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $f475b7f36e97a121$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($f475b7f36e97a121$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $f475b7f36e97a121$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$f475b7f36e97a121$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $f475b7f36e97a121$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $f475b7f36e97a121$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($f475b7f36e97a121$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($f475b7f36e97a121$export$5fcb678681417b54(mutation.options.mutationKey) !== $f475b7f36e97a121$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$f475b7f36e97a121$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $f475b7f36e97a121$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $f475b7f36e97a121$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $f475b7f36e97a121$export$5fcb678681417b54(queryKey) {
    var asArray = $f475b7f36e97a121$export$4d32d63f64b825b9(queryKey);
    return $f475b7f36e97a121$export$e7f2f041280beb00(asArray);
}
function $f475b7f36e97a121$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $f475b7f36e97a121$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $f475b7f36e97a121$export$2f07189bb9fa26a7(a, b) {
    return $f475b7f36e97a121$export$3bc9138b70293839($f475b7f36e97a121$export$4d32d63f64b825b9(a), $f475b7f36e97a121$export$4d32d63f64b825b9(b));
}
function $f475b7f36e97a121$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$f475b7f36e97a121$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $f475b7f36e97a121$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $f475b7f36e97a121$export$53b83ca8eaab0383(a) && $f475b7f36e97a121$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $f475b7f36e97a121$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $f475b7f36e97a121$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $f475b7f36e97a121$export$53b83ca8eaab0383(o) {
    if (!$f475b7f36e97a121$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$f475b7f36e97a121$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $f475b7f36e97a121$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $f475b7f36e97a121$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $f475b7f36e97a121$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $f475b7f36e97a121$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $f475b7f36e97a121$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $f475b7f36e97a121$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}



var $22rg6 = parcelRequire("22rg6");


var $erOpW = parcelRequire("erOpW");


var $cbf8c5f2b92f05e5$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $f475b7f36e97a121$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $f475b7f36e97a121$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $cbf8c5f2b92f05e5$export$520687f44db6e1ab = new $cbf8c5f2b92f05e5$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $9cf630baa4cda8dd$var$logger = console;
function $9cf630baa4cda8dd$export$2b1d391cd05230fd() {
    return $9cf630baa4cda8dd$var$logger;
}
function $9cf630baa4cda8dd$export$3abbd92f765bee58(newLogger) {
    $9cf630baa4cda8dd$var$logger = newLogger;
}



var $22rg6 = parcelRequire("22rg6");
var $13d05f6590f10ccf$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $0d0092eb9d08ff1e$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $f475b7f36e97a121$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));
var $0d0092eb9d08ff1e$export$6bf54661be5b02cf = new $0d0092eb9d08ff1e$export$86f1af424b2ca4de();



var $22rg6 = parcelRequire("22rg6");


var $494cb678b9a89773$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $f475b7f36e97a121$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));
var $494cb678b9a89773$export$b113e788b2dd3fdc = new $494cb678b9a89773$export$58774fb55d5ff7fc();



function $274f85cdb96d6994$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $274f85cdb96d6994$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $274f85cdb96d6994$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $274f85cdb96d6994$export$986cc6445c1d323(value) {
    return value instanceof $274f85cdb96d6994$export$a8430ed4188f35a9;
} // CLASS
var $274f85cdb96d6994$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $274f85cdb96d6994$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($274f85cdb96d6994$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $274f85cdb96d6994$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $274f85cdb96d6994$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $f475b7f36e97a121$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $0d0092eb9d08ff1e$export$6bf54661be5b02cf).isFocused() || !(0, $494cb678b9a89773$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $bcaaacf43b670838$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $erOpW.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $f475b7f36e97a121$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $f475b7f36e97a121$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $f475b7f36e97a121$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $f475b7f36e97a121$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $f475b7f36e97a121$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $f475b7f36e97a121$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $274f85cdb96d6994$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $274f85cdb96d6994$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $274f85cdb96d6994$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $9cf630baa4cda8dd$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $erOpW.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $erOpW.default)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $erOpW.default)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $erOpW.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $erOpW.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $274f85cdb96d6994$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $erOpW.default)({}, this.revertState);
                return (0, $erOpW.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $erOpW.default)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $erOpW.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $8edae5deee65b73a$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $f475b7f36e97a121$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $bcaaacf43b670838$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $f475b7f36e97a121$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $f475b7f36e97a121$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));



var $22rg6 = parcelRequire("22rg6");


var $erOpW = parcelRequire("erOpW");




var $2ad83d6eb1d3cdf3$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $erOpW.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $2ad83d6eb1d3cdf3$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $9cf630baa4cda8dd$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $274f85cdb96d6994$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $2ad83d6eb1d3cdf3$var$reducer(this.state, action);
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $2ad83d6eb1d3cdf3$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $2ad83d6eb1d3cdf3$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $erOpW.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $erOpW.default)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $erOpW.default)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $erOpW.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $erOpW.default)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $erOpW.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $erOpW.default)({}, state, action.state);
        default:
            return state;
    }
}




var $179a3d9ba6e38c3a$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $2ad83d6eb1d3cdf3$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $f475b7f36e97a121$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $f475b7f36e97a121$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $f475b7f36e97a121$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));







function $0bbec87ec7e51043$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $f475b7f36e97a121$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $274f85cdb96d6994$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $0bbec87ec7e51043$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $0bbec87ec7e51043$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $0bbec87ec7e51043$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $274f85cdb96d6994$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $0bbec87ec7e51043$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $0bbec87ec7e51043$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $0bbec87ec7e51043$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $0bbec87ec7e51043$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $0bbec87ec7e51043$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $0bbec87ec7e51043$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $a51662f755b146ff$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $8edae5deee65b73a$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $179a3d9ba6e38c3a$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $0d0092eb9d08ff1e$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $0d0092eb9d08ff1e$export$6bf54661be5b02cf).isFocused() && (0, $494cb678b9a89773$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $494cb678b9a89773$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $0d0092eb9d08ff1e$export$6bf54661be5b02cf).isFocused() && (0, $494cb678b9a89773$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $erOpW.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $f475b7f36e97a121$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $erOpW.default)({}, filters, {
            active: true
        });
        return (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $erOpW.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $f475b7f36e97a121$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $erOpW.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $f475b7f36e97a121$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $f475b7f36e97a121$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $f475b7f36e97a121$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $f475b7f36e97a121$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $0bbec87ec7e51043$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $f475b7f36e97a121$export$8793edee2d425525)).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $f475b7f36e97a121$export$5fcb678681417b54)(queryKey) === (0, $f475b7f36e97a121$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $f475b7f36e97a121$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $f475b7f36e97a121$export$5fcb678681417b54)(mutationKey) === (0, $f475b7f36e97a121$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $f475b7f36e97a121$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $erOpW.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $f475b7f36e97a121$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $erOpW.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $5da80f07f11cfb14$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($3ab9800416b64e29$exports))).unstable_batchedUpdates;


(0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).setBatchNotifyFunction((0, $5da80f07f11cfb14$export$c78a37762a8d58e1));



var $975e9fdbaafdb523$export$af88d00dbe7f521 = console;


(0, $9cf630baa4cda8dd$export$3abbd92f765bee58)((0, $975e9fdbaafdb523$export$af88d00dbe7f521));



var $jSIPP = parcelRequire("jSIPP");
var $0e83aeae07108916$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(undefined);
var $0e83aeae07108916$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0e83aeae07108916$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0e83aeae07108916$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $0e83aeae07108916$var$defaultContext;
}
var $0e83aeae07108916$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext($0e83aeae07108916$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext($0e83aeae07108916$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $0e83aeae07108916$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $0e83aeae07108916$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($0e83aeae07108916$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Context.Provider, {
        value: client
    }, children));
};






var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $erOpW = parcelRequire("erOpW");

var $22rg6 = parcelRequire("22rg6");



var $3ea81c9434c74460$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $erOpW.default)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $2ad83d6eb1d3cdf3$export$a1659b54bac3252a)();
        var result = (0, $erOpW.default)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));



function $5fc37c1b2003112a$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $74568c0a766c827d$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $f475b7f36e97a121$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $3ea81c9434c74460$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $f475b7f36e97a121$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $5fc37c1b2003112a$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $erOpW.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}



var $erOpW = parcelRequire("erOpW");

var $22rg6 = parcelRequire("22rg6");






var $7ede1f4fde0ad3e5$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $22rg6.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($7ede1f4fde0ad3e5$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $7ede1f4fde0ad3e5$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $7ede1f4fde0ad3e5$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $7ede1f4fde0ad3e5$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $erOpW.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $f475b7f36e97a121$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $f475b7f36e97a121$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $f475b7f36e97a121$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $f475b7f36e97a121$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $f475b7f36e97a121$export$6acf61af03e62db) || this.options.enabled === false || !(0, $f475b7f36e97a121$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $0d0092eb9d08ff1e$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $7ede1f4fde0ad3e5$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $7ede1f4fde0ad3e5$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $f475b7f36e97a121$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $9cf630baa4cda8dd$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $f475b7f36e97a121$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $9cf630baa4cda8dd$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: $7ede1f4fde0ad3e5$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $f475b7f36e97a121$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $erOpW.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, $274f85cdb96d6994$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, $13d05f6590f10ccf$export$d26086b469ecdbcc));
function $7ede1f4fde0ad3e5$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $7ede1f4fde0ad3e5$var$shouldFetchOnMount(query, options) {
    return $7ede1f4fde0ad3e5$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $7ede1f4fde0ad3e5$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $7ede1f4fde0ad3e5$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $7ede1f4fde0ad3e5$var$isStale(query, options);
    }
    return false;
}
function $7ede1f4fde0ad3e5$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $7ede1f4fde0ad3e5$var$isStale(query, options);
}
function $7ede1f4fde0ad3e5$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $jSIPP = parcelRequire("jSIPP");


var $jSIPP = parcelRequire("jSIPP");
function $b6a4330a51b800d2$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $b6a4330a51b800d2$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext($b6a4330a51b800d2$var$createValue()); // HOOK
var $b6a4330a51b800d2$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext($b6a4330a51b800d2$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $b6a4330a51b800d2$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(function() {
        return $b6a4330a51b800d2$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($b6a4330a51b800d2$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




function $e182fa140143d817$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $b6a4330a51b800d2$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $cbf8c5f2b92f05e5$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $5fc37c1b2003112a$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $41632140e88fef11$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $f475b7f36e97a121$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $e182fa140143d817$export$fff0865807e996c5)(parsedOptions, (0, $7ede1f4fde0ad3e5$export$a06cf8c0066f0d4c));
}











var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");

parcelRequire("jSIPP");


var $emEIf = parcelRequire("emEIf");
var $j3GPk = parcelRequire("j3GPk");

var $gDcI8 = parcelRequire("gDcI8");

var $jSIPP = parcelRequire("jSIPP");
parcelRequire("lebkq");
var $eNcJv = parcelRequire("eNcJv");
'use client';
function $dfd29db2c1d2712c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $dfd29db2c1d2712c$var$useTheme(defaultTheme = null) {
    const contextTheme = $jSIPP.useContext((0, $eNcJv.T));
    return !contextTheme || $dfd29db2c1d2712c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $dfd29db2c1d2712c$export$2e2bcd8739ae039 = $dfd29db2c1d2712c$var$useTheme;


'use client';
const $3400e724fe4dbcd5$export$35e57303dbd8a66 = (0, $gDcI8.default)();
function $3400e724fe4dbcd5$var$useTheme(defaultTheme = $3400e724fe4dbcd5$export$35e57303dbd8a66) {
    return (0, $dfd29db2c1d2712c$export$2e2bcd8739ae039)(defaultTheme);
}
var $3400e724fe4dbcd5$export$2e2bcd8739ae039 = $3400e724fe4dbcd5$var$useTheme;



var $4uaIU = parcelRequire("4uaIU");
'use client';
function $44432562592eb4fa$var$wrapGlobalLayer(styles) {
    const serialized = (0, $j3GPk.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $44432562592eb4fa$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $3400e724fe4dbcd5$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $44432562592eb4fa$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $44432562592eb4fa$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $44432562592eb4fa$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $emEIf.default), {
        styles: globalStyles
    });
}
var $44432562592eb4fa$export$2e2bcd8739ae039 = $44432562592eb4fa$var$GlobalStyles;



var $kq7Gb = parcelRequire("kq7Gb");

var $iX5qO = parcelRequire("iX5qO");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $a1e9f964671d18b0$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44432562592eb4fa$export$2e2bcd8739ae039), (0, $erOpW.default)({}, props, {
        defaultTheme: (0, $kq7Gb.default),
        themeId: (0, $iX5qO.default)
    }));
}
var $a1e9f964671d18b0$export$2e2bcd8739ae039 = $a1e9f964671d18b0$var$GlobalStyles;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $4fc1f3d6474feb67$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $erOpW.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $4fc1f3d6474feb67$export$32180ef41b15b513 = (theme)=>(0, $erOpW.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $4fc1f3d6474feb67$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $erOpW.default)({
        html: $4fc1f3d6474feb67$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $erOpW.default)({
            margin: 0
        }, $4fc1f3d6474feb67$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $4fc1f3d6474feb67$var$CssBaseline(inProps) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a1e9f964671d18b0$export$2e2bcd8739ae039), {
                styles: (theme)=>$4fc1f3d6474feb67$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $4fc1f3d6474feb67$export$2e2bcd8739ae039 = $4fc1f3d6474feb67$var$CssBaseline;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $jSIPP = parcelRequire("jSIPP");
const $c0c0b393a39f6ef3$var$ThemeContext = /*#__PURE__*/ $jSIPP.createContext(null);
var $c0c0b393a39f6ef3$export$2e2bcd8739ae039 = $c0c0b393a39f6ef3$var$ThemeContext;



var $jSIPP = parcelRequire("jSIPP");

function $a231dca6dd31ff9d$export$2e2bcd8739ae039() {
    const theme = $jSIPP.useContext((0, $c0c0b393a39f6ef3$export$2e2bcd8739ae039));
    return theme;
}


const $ef17e1ab3c895f89$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $ef17e1ab3c895f89$export$2e2bcd8739ae039 = $ef17e1ab3c895f89$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $4uaIU = parcelRequire("4uaIU");
function $253e88d319361686$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $erOpW.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $253e88d319361686$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $a231dca6dd31ff9d$export$2e2bcd8739ae039)();
    const theme = $jSIPP.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $253e88d319361686$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $ef17e1ab3c895f89$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c0c0b393a39f6ef3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $253e88d319361686$export$2e2bcd8739ae039 = $253e88d319361686$var$ThemeProvider;



parcelRequire("lebkq");
var $eNcJv = parcelRequire("eNcJv");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
const $075f43d5cf6cf500$var$_excluded = [
    "value"
];
const $075f43d5cf6cf500$var$RtlContext = /*#__PURE__*/ $jSIPP.createContext();
function $075f43d5cf6cf500$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cMu4A.default)(_ref, $075f43d5cf6cf500$var$_excluded);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($075f43d5cf6cf500$var$RtlContext.Provider, (0, $erOpW.default)({
        value: value != null ? value : true
    }, props));
}
const $075f43d5cf6cf500$export$b2dd014b6c321cb = ()=>{
    const value = $jSIPP.useContext($075f43d5cf6cf500$var$RtlContext);
    return value != null ? value : false;
};
var $075f43d5cf6cf500$export$2e2bcd8739ae039 = $075f43d5cf6cf500$var$RtlProvider;



var $RDVEV = parcelRequire("RDVEV");
parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $73bd5ff9c4beec0a$var$useEnhancedEffect = typeof window !== 'undefined' ? $jSIPP.useLayoutEffect : $jSIPP.useEffect;
var $73bd5ff9c4beec0a$export$2e2bcd8739ae039 = $73bd5ff9c4beec0a$var$useEnhancedEffect;



var $jSIPP = parcelRequire("jSIPP");
'use client';
let $0edf2a5582d0a9d6$var$globalId = 0;
function $0edf2a5582d0a9d6$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $jSIPP.useState(idOverride);
    const id = idOverride || defaultId;
    $jSIPP.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $0edf2a5582d0a9d6$var$globalId += 1;
            setDefaultId(`mui-${$0edf2a5582d0a9d6$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $0edf2a5582d0a9d6$var$maybeReactUseId = $jSIPP['useId'.toString()];
function $0edf2a5582d0a9d6$export$2e2bcd8739ae039(idOverride) {
    if ($0edf2a5582d0a9d6$var$maybeReactUseId !== undefined) {
        const reactId = $0edf2a5582d0a9d6$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $0edf2a5582d0a9d6$var$useGlobalId(idOverride);
}





var $4uaIU = parcelRequire("4uaIU");
'use client';
function $cdd8735c407bf886$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $dfd29db2c1d2712c$export$2e2bcd8739ae039)();
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44432562592eb4fa$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $a0a01b663027806f$var$EMPTY_THEME = {};
function $a0a01b663027806f$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $jSIPP.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $erOpW.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $erOpW.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $erOpW.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $a0a01b663027806f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $dfd29db2c1d2712c$export$2e2bcd8739ae039)($a0a01b663027806f$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $a231dca6dd31ff9d$export$2e2bcd8739ae039)() || $a0a01b663027806f$var$EMPTY_THEME;
    const engineTheme = $a0a01b663027806f$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $a0a01b663027806f$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $cdd8735c407bf886$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $253e88d319361686$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $eNcJv.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $075f43d5cf6cf500$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $RDVEV.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $a0a01b663027806f$export$2e2bcd8739ae039 = $a0a01b663027806f$var$ThemeProvider;



var $iX5qO = parcelRequire("iX5qO");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $9a8ba91331ea601c$var$_excluded = [
    "theme"
];
function $9a8ba91331ea601c$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cMu4A.default)(_ref, $9a8ba91331ea601c$var$_excluded);
    const scopedTheme = themeInput[0, $iX5qO.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $erOpW.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $erOpW.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a0a01b663027806f$export$2e2bcd8739ae039), (0, $erOpW.default)({}, props, {
        themeId: scopedTheme ? (0, $iX5qO.default) : undefined,
        theme: finalTheme
    }));
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $3Tcpe = parcelRequire("3Tcpe");
function $38f0ad633ce6fd51$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $3Tcpe.default)(theme.components[name].defaultProps, props);
}



'use client';
function $0a9fb94c18c7f261$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $3400e724fe4dbcd5$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $38f0ad633ce6fd51$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $kq7Gb = parcelRequire("kq7Gb");

var $iX5qO = parcelRequire("iX5qO");
'use client';
function $a116d4defba36cdd$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $0a9fb94c18c7f261$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $kq7Gb.default,
        themeId: (0, $iX5qO.default)
    });
}



var $4uaIU = parcelRequire("4uaIU");
const $90e85bbb3ec20250$var$_excluded = [
    "localeText"
];
const $90e85bbb3ec20250$export$544976378534cf9 = /*#__PURE__*/ $jSIPP.createContext(null);
function $90e85bbb3ec20250$export$dc45bdc734ce6f1e(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $cMu4A.default)(inProps, $90e85bbb3ec20250$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $jSIPP.useContext($90e85bbb3ec20250$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $jSIPP.useMemo(()=>(0, $erOpW.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $jSIPP.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $jSIPP.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $jSIPP.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($90e85bbb3ec20250$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
}



var $erOpW = parcelRequire("erOpW");
var $0d4c78486377ebd0$exports = {};
!function(t, e) {
    $0d4c78486377ebd0$exports = e();
}($0d4c78486377ebd0$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $e583060be1d61807$exports = {};
!function(e, t) {
    $e583060be1d61807$exports = t();
}($e583060be1d61807$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $5c247122dd8c041a$exports = {};
!function(e, t) {
    $5c247122dd8c041a$exports = t();
}($5c247122dd8c041a$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $310e3ee5e918c2c9$exports = {};
!function(e, t) {
    $310e3ee5e918c2c9$exports = t();
}($310e3ee5e918c2c9$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $ffd8c6715d4266ca$exports = {};
!function(e, i) {
    $ffd8c6715d4266ca$exports = i();
}($ffd8c6715d4266ca$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


const $d5bf33e6e4561cd0$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $d5bf33e6e4561cd0$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


(0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5c247122dd8c041a$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($310e3ee5e918c2c9$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($ffd8c6715d4266ca$exports))));
const $f63005c1ab87d561$var$localeNotFoundWarning = (0, $d5bf33e6e4561cd0$export$baf331755d84b871)([
    'Your locale has not been found.',
    'Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale',
    "Or you forget to import the locale with `require('dayjs/locale/{localeUsed}')`",
    'fallback on English locale'
]);
const $f63005c1ab87d561$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: 'year',
    // Month
    M: 'month',
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: 'day',
    DD: 'day',
    Do: 'day',
    // Day of the week
    d: 'weekDay',
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: 'hours',
    HH: 'hours',
    h: 'hours',
    hh: 'hours',
    // Minutes
    m: 'minutes',
    mm: 'minutes',
    // Seconds
    s: 'seconds',
    ss: 'seconds'
};
const $f63005c1ab87d561$var$defaultFormats = {
    normalDateWithWeekday: 'ddd, MMM D',
    normalDate: 'D MMMM',
    shortDate: 'MMM D',
    monthAndDate: 'MMMM D',
    dayOfMonth: 'D',
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    monthAndYear: 'MMMM YYYY',
    weekday: 'dddd',
    weekdayShort: 'ddd',
    minutes: 'mm',
    hours12h: 'hh',
    hours24h: 'HH',
    seconds: 'ss',
    fullTime: 'LT',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    fullDate: 'll',
    fullDateWithWeekday: 'dddd, LL',
    fullDateTime: 'lll',
    fullDateTime12h: 'll hh:mm A',
    fullDateTime24h: 'll HH:mm',
    keyboardDate: 'L',
    keyboardDateTime: 'L LT',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $f63005c1ab87d561$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $f63005c1ab87d561$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats, instance: instance } = {}){
        this.isMUIAdapter = true;
        this.rawDayJsInstance = void 0;
        this.lib = 'dayjs';
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: '[',
            end: ']'
        };
        this.formatTokenMap = $f63005c1ab87d561$var$formatTokenMap;
        this.getLocaleFormats = ()=>{
            var _this$rawDayJsInstanc;
            const locales = (_this$rawDayJsInstanc = this.rawDayJsInstance.Ls) != null ? _this$rawDayJsInstanc : (0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) {
                $f63005c1ab87d561$var$localeNotFoundWarning();
                localeObject = locales.en;
            }
            return localeObject.formats;
        };
        this.date = (value)=>{
            if (value === null) return null;
            return this.dayjs(value);
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parseISO = (isoString)=>{
            return this.dayjs(isoString);
        };
        this.toISO = (value)=>{
            return value.toISOString();
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || 'en';
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/a/gi, '(a|p)m').toLocaleLowerCase();
        };
        this.isNull = (date)=>{
            return date === null;
        };
        this.isValid = (value)=>{
            return this.dayjs(value).isValid();
        };
        this.format = (date, formatKey)=>{
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString)=>{
            return this.dayjs(date).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (date, comparing, units)=>{
            return date.diff(comparing, units);
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return this.dayjs(value).isSame(comparing);
        };
        this.isSameYear = (date, comparing)=>{
            return date.isSame(comparing, 'year');
        };
        this.isSameMonth = (date, comparing)=>{
            return date.isSame(comparing, 'month');
        };
        this.isSameDay = (date, comparing)=>{
            return date.isSame(comparing, 'day');
        };
        this.isSameHour = (date, comparing)=>{
            return date.isSame(comparing, 'hour');
        };
        this.isAfter = (date, value)=>{
            return date.isAfter(value);
        };
        this.isAfterYear = (date, value)=>{
            return date.isAfter(value, 'year');
        };
        this.isAfterDay = (date, value)=>{
            return date.isAfter(value, 'day');
        };
        this.isBefore = (date, value)=>{
            return date.isBefore(value);
        };
        this.isBeforeYear = (date, value)=>{
            return date.isBefore(value, 'year');
        };
        this.isBeforeDay = (date, value)=>{
            return date.isBefore(value, 'day');
        };
        this.isWithinRange = (date, [start, end])=>{
            return date.isBetween(start, end, null, '[]');
        };
        this.startOfYear = (date)=>{
            return date.startOf('year');
        };
        this.startOfMonth = (date)=>{
            return date.startOf('month');
        };
        this.endOfYear = (date)=>{
            return date.endOf('year');
        };
        this.startOfWeek = (date)=>{
            return date.startOf('week');
        };
        this.startOfDay = (date)=>{
            return date.startOf('day');
        };
        this.endOfMonth = (date)=>{
            return date.endOf('month');
        };
        this.endOfWeek = (date)=>{
            return date.endOf('week');
        };
        this.endOfDay = (date)=>{
            return date.endOf('day');
        };
        this.addYears = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'year') : date.add(count, 'year');
        };
        this.addMonths = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'month') : date.add(count, 'month');
        };
        this.addWeeks = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'week') : date.add(count, 'week');
        };
        this.addDays = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'day') : date.add(count, 'day');
        };
        this.addHours = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'hour') : date.add(count, 'hour');
        };
        this.addMinutes = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'minute') : date.add(count, 'minute');
        };
        this.addSeconds = (date, count)=>{
            return count < 0 ? date.subtract(Math.abs(count), 'second') : date.add(count, 'second');
        };
        this.getYear = (date)=>{
            return date.year();
        };
        this.getMonth = (date)=>{
            return date.month();
        };
        this.getDate = (date)=>{
            return date.date();
        };
        this.getHours = (date)=>{
            return date.hour();
        };
        this.getMinutes = (date)=>{
            return date.minute();
        };
        this.getSeconds = (date)=>{
            return date.second();
        };
        this.setYear = (date, year)=>{
            return date.set('year', year);
        };
        this.setMonth = (date, count)=>{
            return date.set('month', count);
        };
        this.setDate = (date, count)=>{
            return date.set('date', count);
        };
        this.setHours = (date, count)=>{
            return date.set('hour', count);
        };
        this.setMinutes = (date, count)=>{
            return date.set('minute', count);
        };
        this.setSeconds = (date, count)=>{
            return date.set('second', count);
        };
        this.getDaysInMonth = (date)=>{
            return date.daysInMonth();
        };
        this.getNextMonth = (date)=>{
            return date.add(1, 'month');
        };
        this.getPreviousMonth = (date)=>{
            return date.subtract(1, 'month');
        };
        this.getMonthArray = (date)=>{
            const firstMonth = date.startOf('year');
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (date, time)=>{
            return date.hour(time.hour()).minute(time.minute()).second(time.second());
        };
        this.getWeekdays = ()=>{
            const start = this.dayjs().startOf('week');
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((diff)=>this.formatByString(start.add(diff, 'day'), 'dd'));
        };
        this.getWeekArray = (date)=>{
            const start = this.dayjs(date).startOf('month').startOf('week');
            const end = this.dayjs(date).endOf('month').endOf('week');
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current.isBefore(end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = current.add(1, 'day');
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (date)=>{
            return date.week();
        };
        this.getYearRange = (start, end)=>{
            const startDate = this.dayjs(start).startOf('year');
            const endDate = this.dayjs(end).endOf('year');
            const years = [];
            let current = startDate;
            while(current.isBefore(endDate)){
                years.push(current);
                current = current.add(1, 'year');
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === 'am' ? 'AM' : 'PM';
        };
        this.rawDayJsInstance = instance || (0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports)));
        this.dayjs = $f63005c1ab87d561$var$withLocale(this.rawDayJsInstance, _locale);
        this.locale = _locale;
        this.formats = (0, $erOpW.default)({}, $f63005c1ab87d561$var$defaultFormats, formats);
        (0, (/*@__PURE__*/$parcel$interopDefault($0d4c78486377ebd0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($e583060be1d61807$exports))));
    }
}


var $8de0f85cc7605310$exports = {};
$8de0f85cc7605310$exports = {
    ReactQueryDevtools: function() {
        return null;
    },
    ReactQueryDevtoolsPanel: function() {
        return null;
    }
};



var $22rg6 = parcelRequire("22rg6");

var $jSIPP = parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

var $erOpW = parcelRequire("erOpW");
function $ae6b60187326afc5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $ae6b60187326afc5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $ae6b60187326afc5$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $ae6b60187326afc5$var$isAbsolute(to);
    var isFromAbs = from && $ae6b60187326afc5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $ae6b60187326afc5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $ae6b60187326afc5$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $ae6b60187326afc5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $ae6b60187326afc5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$ae6b60187326afc5$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $ae6b60187326afc5$export$2e2bcd8739ae039 = $ae6b60187326afc5$var$resolvePathname;


function $d9f2998555fe4329$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d9f2998555fe4329$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d9f2998555fe4329$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $d9f2998555fe4329$var$valueOf(a);
        var bValue = $d9f2998555fe4329$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d9f2998555fe4329$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d9f2998555fe4329$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d9f2998555fe4329$export$2e2bcd8739ae039 = $d9f2998555fe4329$var$valueEqual;



var $4c450c2d3fccc61f$var$isProduction = true;
var $4c450c2d3fccc61f$var$prefix = 'Invariant failed';
function $4c450c2d3fccc61f$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($4c450c2d3fccc61f$var$isProduction) throw new Error($4c450c2d3fccc61f$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($4c450c2d3fccc61f$var$prefix, ": ").concat(provided) : $4c450c2d3fccc61f$var$prefix;
    throw new Error(value);
}


function $6447ace2c8a52fd7$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $6447ace2c8a52fd7$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $6447ace2c8a52fd7$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $6447ace2c8a52fd7$var$stripBasename(path, prefix) {
    return $6447ace2c8a52fd7$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $6447ace2c8a52fd7$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $6447ace2c8a52fd7$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $6447ace2c8a52fd7$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $6447ace2c8a52fd7$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $erOpW.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $ae6b60187326afc5$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $6447ace2c8a52fd7$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d9f2998555fe4329$export$2e2bcd8739ae039)(a.state, b.state);
}
function $6447ace2c8a52fd7$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $6447ace2c8a52fd7$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $6447ace2c8a52fd7$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $6447ace2c8a52fd7$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $6447ace2c8a52fd7$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $6447ace2c8a52fd7$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $6447ace2c8a52fd7$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $6447ace2c8a52fd7$var$PopStateEvent = 'popstate';
var $6447ace2c8a52fd7$var$HashChangeEvent = 'hashchange';
function $6447ace2c8a52fd7$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $6447ace2c8a52fd7$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$6447ace2c8a52fd7$var$canUseDOM && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $6447ace2c8a52fd7$var$supportsHistory();
    var needsHashChangeListener = !$6447ace2c8a52fd7$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6447ace2c8a52fd7$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $6447ace2c8a52fd7$var$stripTrailingSlash($6447ace2c8a52fd7$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $6447ace2c8a52fd7$var$stripBasename(path, basename);
        return $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $6447ace2c8a52fd7$var$createTransitionManager();
    function setState(nextState) {
        (0, $erOpW.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($6447ace2c8a52fd7$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($6447ace2c8a52fd7$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($6447ace2c8a52fd7$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $6447ace2c8a52fd7$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($6447ace2c8a52fd7$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($6447ace2c8a52fd7$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($6447ace2c8a52fd7$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($6447ace2c8a52fd7$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $6447ace2c8a52fd7$var$HashChangeEvent$1 = 'hashchange';
var $6447ace2c8a52fd7$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $6447ace2c8a52fd7$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $6447ace2c8a52fd7$var$stripLeadingSlash,
        decodePath: $6447ace2c8a52fd7$var$addLeadingSlash
    },
    slash: {
        encodePath: $6447ace2c8a52fd7$var$addLeadingSlash,
        decodePath: $6447ace2c8a52fd7$var$addLeadingSlash
    }
};
function $6447ace2c8a52fd7$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $6447ace2c8a52fd7$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $6447ace2c8a52fd7$var$pushHashPath(path) {
    window.location.hash = path;
}
function $6447ace2c8a52fd7$var$replaceHashPath(path) {
    window.location.replace($6447ace2c8a52fd7$var$stripHash(window.location.href) + '#' + path);
}
function $6447ace2c8a52fd7$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$6447ace2c8a52fd7$var$canUseDOM && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $6447ace2c8a52fd7$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6447ace2c8a52fd7$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $6447ace2c8a52fd7$var$stripTrailingSlash($6447ace2c8a52fd7$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $6447ace2c8a52fd7$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($6447ace2c8a52fd7$var$getHashPath());
        if (basename) path = $6447ace2c8a52fd7$var$stripBasename(path, basename);
        return $6447ace2c8a52fd7$export$90c043f1c57770b8(path);
    }
    var transitionManager = $6447ace2c8a52fd7$var$createTransitionManager();
    function setState(nextState) {
        (0, $erOpW.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $6447ace2c8a52fd7$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $6447ace2c8a52fd7$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $6447ace2c8a52fd7$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($6447ace2c8a52fd7$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($6447ace2c8a52fd7$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $6447ace2c8a52fd7$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $6447ace2c8a52fd7$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $6447ace2c8a52fd7$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $6447ace2c8a52fd7$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $6447ace2c8a52fd7$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6447ace2c8a52fd7$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6447ace2c8a52fd7$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6447ace2c8a52fd7$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($6447ace2c8a52fd7$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6447ace2c8a52fd7$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6447ace2c8a52fd7$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6447ace2c8a52fd7$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($6447ace2c8a52fd7$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($6447ace2c8a52fd7$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($6447ace2c8a52fd7$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $6447ace2c8a52fd7$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $6447ace2c8a52fd7$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $6447ace2c8a52fd7$var$createTransitionManager();
    function setState(nextState) {
        (0, $erOpW.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $6447ace2c8a52fd7$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $6447ace2c8a52fd7$export$90c043f1c57770b8(entry, undefined, createKey()) : $6447ace2c8a52fd7$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $6447ace2c8a52fd7$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6447ace2c8a52fd7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $6447ace2c8a52fd7$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $erOpW = parcelRequire("erOpW");
var $d37a529b68c2839a$exports = {};
var $7a4fbb944014e063$exports = {};
$7a4fbb944014e063$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $d37a529b68c2839a$exports = $d37a529b68c2839a$var$pathToRegexp;
$d37a529b68c2839a$exports.parse = $d37a529b68c2839a$var$parse;
$d37a529b68c2839a$exports.compile = $d37a529b68c2839a$var$compile;
$d37a529b68c2839a$exports.tokensToFunction = $d37a529b68c2839a$var$tokensToFunction;
$d37a529b68c2839a$exports.tokensToRegExp = $d37a529b68c2839a$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $d37a529b68c2839a$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $d37a529b68c2839a$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $d37a529b68c2839a$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $d37a529b68c2839a$var$escapeGroup(pattern) : asterisk ? '.*' : $d37a529b68c2839a$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $d37a529b68c2839a$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $d37a529b68c2839a$var$escapeString(delimiter) + ']+?';
    return $d37a529b68c2839a$var$escapeString(prevText) + '|(?:(?!' + $d37a529b68c2839a$var$escapeString(prevText) + ')[^' + $d37a529b68c2839a$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $d37a529b68c2839a$var$compile(str, options) {
    return $d37a529b68c2839a$var$tokensToFunction($d37a529b68c2839a$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $d37a529b68c2839a$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $d37a529b68c2839a$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $d37a529b68c2839a$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $d37a529b68c2839a$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $d37a529b68c2839a$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($7a4fbb944014e063$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $d37a529b68c2839a$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $d37a529b68c2839a$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $d37a529b68c2839a$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $d37a529b68c2839a$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $d37a529b68c2839a$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($d37a529b68c2839a$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $d37a529b68c2839a$var$flags(options));
    return $d37a529b68c2839a$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$stringToRegexp(path, keys, options) {
    return $d37a529b68c2839a$var$tokensToRegExp($d37a529b68c2839a$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$tokensToRegExp(tokens, keys, options) {
    if (!$7a4fbb944014e063$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $d37a529b68c2839a$var$escapeString(token);
        else {
            var prefix = $d37a529b68c2839a$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $d37a529b68c2839a$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $d37a529b68c2839a$var$attachKeys(new RegExp('^' + route, $d37a529b68c2839a$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $d37a529b68c2839a$var$pathToRegexp(path, keys, options) {
    if (!$7a4fbb944014e063$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $d37a529b68c2839a$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($7a4fbb944014e063$exports(path)) return $d37a529b68c2839a$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $d37a529b68c2839a$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $5357a9bbabb7124f$exports = {};
'use strict';

$5357a9bbabb7124f$exports = (parcelRequire("eC0uE"));



var $cMu4A = parcelRequire("cMu4A");

var $lvZzf = parcelRequire("lvZzf");
var $418bff895eee7f39$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $418bff895eee7f39$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $418bff895eee7f39$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $418bff895eee7f39$var$commonjsGlobal[key] = ($418bff895eee7f39$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $418bff895eee7f39$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $418bff895eee7f39$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $418bff895eee7f39$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $418bff895eee7f39$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $418bff895eee7f39$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $22rg6.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $418bff895eee7f39$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($418bff895eee7f39$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $418bff895eee7f39$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $22rg6.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $418bff895eee7f39$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $418bff895eee7f39$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $418bff895eee7f39$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $418bff895eee7f39$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext || $418bff895eee7f39$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $418bff895eee7f39$var$createNamedContext = function createNamedContext(name) {
    var context = $418bff895eee7f39$var$createContext();
    context.displayName = name;
    return context;
};
var $418bff895eee7f39$export$c213558b66925821 = /*#__PURE__*/ $418bff895eee7f39$var$createNamedContext("Router-History");
var $418bff895eee7f39$export$63baa8ccbe60bb07 = /*#__PURE__*/ $418bff895eee7f39$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $418bff895eee7f39$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $418bff895eee7f39$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6447ace2c8a52fd7$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
var $418bff895eee7f39$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $418bff895eee7f39$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $418bff895eee7f39$var$messageType;
var $418bff895eee7f39$var$cache = {};
var $418bff895eee7f39$var$cacheLimit = 10000;
var $418bff895eee7f39$var$cacheCount = 0;
function $418bff895eee7f39$var$compilePath(path) {
    if ($418bff895eee7f39$var$cache[path]) return $418bff895eee7f39$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($d37a529b68c2839a$exports))).compile(path);
    if ($418bff895eee7f39$var$cacheCount < $418bff895eee7f39$var$cacheLimit) {
        $418bff895eee7f39$var$cache[path] = generator;
        $418bff895eee7f39$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $418bff895eee7f39$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $418bff895eee7f39$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $418bff895eee7f39$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $6447ace2c8a52fd7$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $418bff895eee7f39$export$82476f982757e71e(to, computedMatch.params) : (0, $erOpW.default)({}, to, {
            pathname: $418bff895eee7f39$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $6447ace2c8a52fd7$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $6447ace2c8a52fd7$export$c3e8bb440bd55b18)(prevLocation, (0, $erOpW.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $418bff895eee7f39$var$cache$1 = {};
var $418bff895eee7f39$var$cacheLimit$1 = 10000;
var $418bff895eee7f39$var$cacheCount$1 = 0;
function $418bff895eee7f39$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $418bff895eee7f39$var$cache$1[cacheKey] || ($418bff895eee7f39$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($d37a529b68c2839a$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($418bff895eee7f39$var$cacheCount$1 < $418bff895eee7f39$var$cacheLimit$1) {
        pathCache[path] = result;
        $418bff895eee7f39$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $418bff895eee7f39$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $418bff895eee7f39$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $418bff895eee7f39$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Children.count(children) === 0;
}
function $418bff895eee7f39$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $418bff895eee7f39$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $418bff895eee7f39$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $erOpW.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $418bff895eee7f39$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
function $418bff895eee7f39$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $418bff895eee7f39$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $erOpW.default)({}, location, {
        pathname: $418bff895eee7f39$var$addLeadingSlash(basename) + location.pathname
    });
}
function $418bff895eee7f39$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $418bff895eee7f39$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $erOpW.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $418bff895eee7f39$var$createURL(location) {
    return typeof location === "string" ? location : (0, $6447ace2c8a52fd7$export$fe53371bee54353d)(location);
}
function $418bff895eee7f39$var$staticHandler(methodName) {
    return function() {
        (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
    };
}
function $418bff895eee7f39$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $418bff895eee7f39$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $418bff895eee7f39$var$noop;
        };
        _this.handleBlock = function() {
            return $418bff895eee7f39$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $418bff895eee7f39$var$addBasename(basename, (0, $6447ace2c8a52fd7$export$90c043f1c57770b8)(location));
        context.url = $418bff895eee7f39$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cMu4A.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $418bff895eee7f39$var$addLeadingSlash(basename + $418bff895eee7f39$var$createURL(path));
            },
            action: "POP",
            location: $418bff895eee7f39$var$stripBasename(basename, (0, $6447ace2c8a52fd7$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $418bff895eee7f39$var$staticHandler("go"),
            goBack: $418bff895eee7f39$var$staticHandler("goBack"),
            goForward: $418bff895eee7f39$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$55185c17a0fcbe46, (0, $erOpW.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $418bff895eee7f39$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $418bff895eee7f39$export$81336c211d5ff295(location.pathname, (0, $erOpW.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $418bff895eee7f39$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cMu4A.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($418bff895eee7f39$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Component, (0, $erOpW.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvZzf)))(C, Component);
}
var $418bff895eee7f39$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext;
function $418bff895eee7f39$export$3420e1dc2c4a518c() {
    return $418bff895eee7f39$var$useContext($418bff895eee7f39$export$c213558b66925821);
}
function $418bff895eee7f39$export$45d76561a5302f2b() {
    return $418bff895eee7f39$var$useContext($418bff895eee7f39$export$63baa8ccbe60bb07).location;
}
function $418bff895eee7f39$export$99eaa27ddbbb95ef() {
    var match = $418bff895eee7f39$var$useContext($418bff895eee7f39$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $418bff895eee7f39$export$632be4bb944c1bc7(path) {
    var location = $418bff895eee7f39$export$45d76561a5302f2b();
    var match = $418bff895eee7f39$var$useContext($418bff895eee7f39$export$63baa8ccbe60bb07).match;
    return path ? $418bff895eee7f39$export$81336c211d5ff295(location.pathname, path) : match;
}
var $418bff895eee7f39$var$global$1, $418bff895eee7f39$var$key, $418bff895eee7f39$var$buildNames, $418bff895eee7f39$var$initialBuildName, $418bff895eee7f39$var$secondaryBuildName;



var $22rg6 = parcelRequire("22rg6");

var $jSIPP = parcelRequire("jSIPP");




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $b2d572a11ba9d27b$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6447ace2c8a52fd7$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $418bff895eee7f39$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $b2d572a11ba9d27b$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6447ace2c8a52fd7$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $418bff895eee7f39$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
var $b2d572a11ba9d27b$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $b2d572a11ba9d27b$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $6447ace2c8a52fd7$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $b2d572a11ba9d27b$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $b2d572a11ba9d27b$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).forwardRef;
if (typeof $b2d572a11ba9d27b$var$forwardRef === "undefined") $b2d572a11ba9d27b$var$forwardRef = $b2d572a11ba9d27b$var$forwardRefShim;
function $b2d572a11ba9d27b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $b2d572a11ba9d27b$var$LinkAnchor = $b2d572a11ba9d27b$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $cMu4A.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $erOpW.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$b2d572a11ba9d27b$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($b2d572a11ba9d27b$var$forwardRefShim !== $b2d572a11ba9d27b$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $b2d572a11ba9d27b$export$a6c7ac8248d6e38a = $b2d572a11ba9d27b$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $b2d572a11ba9d27b$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $cMu4A.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $418bff895eee7f39$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $b2d572a11ba9d27b$var$normalizeToLocation($b2d572a11ba9d27b$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $erOpW.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $b2d572a11ba9d27b$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $6447ace2c8a52fd7$export$fe53371bee54353d)(context.location) === (0, $6447ace2c8a52fd7$export$fe53371bee54353d)($b2d572a11ba9d27b$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($b2d572a11ba9d27b$var$forwardRefShim !== $b2d572a11ba9d27b$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(component, props);
    });
});
var $b2d572a11ba9d27b$var$toType, $b2d572a11ba9d27b$var$refType;
var $b2d572a11ba9d27b$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $b2d572a11ba9d27b$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).forwardRef;
if (typeof $b2d572a11ba9d27b$var$forwardRef$1 === "undefined") $b2d572a11ba9d27b$var$forwardRef$1 = $b2d572a11ba9d27b$var$forwardRefShim$1;
function $b2d572a11ba9d27b$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $b2d572a11ba9d27b$export$b0d92dbee9b5b60d = $b2d572a11ba9d27b$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $cMu4A.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $418bff895eee7f39$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $4c450c2d3fccc61f$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $b2d572a11ba9d27b$var$normalizeToLocation($b2d572a11ba9d27b$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $418bff895eee7f39$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $b2d572a11ba9d27b$var$joinClassnames(className, activeClassName);
            style = (0, $erOpW.default)({}, style, activeStyle);
        }
        var props = (0, $erOpW.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($b2d572a11ba9d27b$var$forwardRefShim$1 !== $b2d572a11ba9d27b$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($b2d572a11ba9d27b$export$a6c7ac8248d6e38a, props);
    });
});
var $b2d572a11ba9d27b$var$ariaCurrentType;


parcelRequire("jSIPP");

var $ct73g = parcelRequire("ct73g");
// Colour values are taken from the Tailwind scale, which the ngest-rockset-dbt webapp
// frontend already uses. Sharing one set of values means the two front ends can converge
// without a re-pick, and the scale is well tested for contrast.
//
// Every pairing below meets WCAG AA (4.5:1 for body text). Two pairings in the previous
// palette did not: white-ish text on the primary green was 3.07:1, and the secondary grey
// on the page background was 3.23:1.
//
//   white on primary #047857   5.48:1
//   primary as link on white   5.48:1   (emerald-600 would be 3.77:1, so 700 is the floor)
//   text.primary on paper     17.85:1
//   text.secondary on paper    7.58:1
//   white on error #DC2626     4.83:1
//
// Warning is the exception: white on amber is only 3.19:1, so it carries dark text.
var $a9ce7c8f92595c85$export$2e2bcd8739ae039 = {
    mode: 'light',
    // v5 name; the previous `type` key was MUI v4 and was ignored
    primary: {
        main: '#047857',
        // emerald-700
        light: '#10B981',
        // emerald-500, for hover and subtle fills
        dark: '#065F46',
        // emerald-800
        contrastText: '#FFFFFF'
    },
    secondary: {
        main: '#475569',
        // slate-600
        light: '#64748B',
        // slate-500
        dark: '#334155',
        // slate-700
        contrastText: '#FFFFFF'
    },
    error: {
        main: '#DC2626',
        // red-600
        contrastText: '#FFFFFF'
    },
    warning: {
        main: '#D97706',
        // amber-600
        contrastText: '#1F2937' // dark text: white on amber fails AA
    },
    info: {
        main: '#0369A1',
        // sky-700
        contrastText: '#FFFFFF'
    },
    success: {
        main: '#047857',
        // matches primary, so "good" reads consistently
        contrastText: '#FFFFFF'
    },
    text: {
        primary: '#0F172A',
        // slate-900
        secondary: '#475569',
        // slate-600
        disabled: '#94A3B8' // slate-400
    },
    background: {
        default: '#F8FAFC',
        // slate-50, so white surfaces lift off the page
        paper: '#FFFFFF'
    },
    divider: '#CBD5E1',
    // slate-300
    action: {
        hover: 'rgba(15, 23, 42, 0.04)',
        selected: 'rgba(4, 120, 87, 0.08)',
        disabled: '#CBD5E1',
        // slate-300
        disabledBackground: '#F1F5F9' // slate-100
    }
};


// Softer, larger-radius shadows in a cool grey rather than the previous warm near-black.
// The old set used rgba(63,63,68,...) and rgba(0,0,0,0.31) with tight blur, which reads as
// a hard drop shadow; modern surfaces sit on a wider, lighter spread.
//
// MUI requires exactly 25 entries, index 0 being 'none'.
var $0e23034b6157fdb9$export$2e2bcd8739ae039 = [
    'none',
    '0 0.85px 2.4px rgba(15, 23, 42, 0.054), 0 1.7px 4.8px rgba(15, 23, 42, 0.045)',
    '0 1.2px 3.3px rgba(15, 23, 42, 0.058), 0 2.4px 6.6px rgba(15, 23, 42, 0.05)',
    '0 1.55px 4.2px rgba(15, 23, 42, 0.062), 0 3.1px 8.4px rgba(15, 23, 42, 0.055)',
    '0 1.9px 5.1px rgba(15, 23, 42, 0.066), 0 3.8px 10.2px rgba(15, 23, 42, 0.06)',
    '0 2.25px 6.0px rgba(15, 23, 42, 0.07), 0 4.5px 12.0px rgba(15, 23, 42, 0.065)',
    '0 2.6px 6.9px rgba(15, 23, 42, 0.074), 0 5.2px 13.8px rgba(15, 23, 42, 0.07)',
    '0 2.95px 7.8px rgba(15, 23, 42, 0.078), 0 5.9px 15.6px rgba(15, 23, 42, 0.075)',
    '0 3.3px 8.7px rgba(15, 23, 42, 0.082), 0 6.6px 17.4px rgba(15, 23, 42, 0.08)',
    '0 3.65px 9.6px rgba(15, 23, 42, 0.086), 0 7.3px 19.2px rgba(15, 23, 42, 0.085)',
    '0 4.0px 10.5px rgba(15, 23, 42, 0.09), 0 8.0px 21.0px rgba(15, 23, 42, 0.09)',
    '0 4.35px 11.4px rgba(15, 23, 42, 0.094), 0 8.7px 22.8px rgba(15, 23, 42, 0.095)',
    '0 4.7px 12.3px rgba(15, 23, 42, 0.098), 0 9.4px 24.6px rgba(15, 23, 42, 0.1)',
    '0 5.05px 13.2px rgba(15, 23, 42, 0.1), 0 10.1px 26.4px rgba(15, 23, 42, 0.105)',
    '0 5.4px 14.1px rgba(15, 23, 42, 0.1), 0 10.8px 28.2px rgba(15, 23, 42, 0.11)',
    '0 5.75px 15.0px rgba(15, 23, 42, 0.1), 0 11.5px 30.0px rgba(15, 23, 42, 0.115)',
    '0 6.1px 15.9px rgba(15, 23, 42, 0.1), 0 12.2px 31.8px rgba(15, 23, 42, 0.12)',
    '0 6.45px 16.8px rgba(15, 23, 42, 0.1), 0 12.9px 33.6px rgba(15, 23, 42, 0.12)',
    '0 6.8px 17.7px rgba(15, 23, 42, 0.1), 0 13.6px 35.4px rgba(15, 23, 42, 0.12)',
    '0 7.15px 18.6px rgba(15, 23, 42, 0.1), 0 14.3px 37.2px rgba(15, 23, 42, 0.12)',
    '0 7.5px 19.5px rgba(15, 23, 42, 0.1), 0 15.0px 39.0px rgba(15, 23, 42, 0.12)',
    '0 7.85px 20.4px rgba(15, 23, 42, 0.1), 0 15.7px 40.8px rgba(15, 23, 42, 0.12)',
    '0 8.2px 21.3px rgba(15, 23, 42, 0.1), 0 16.4px 42.6px rgba(15, 23, 42, 0.12)',
    '0 8.55px 22.2px rgba(15, 23, 42, 0.1), 0 17.1px 44.4px rgba(15, 23, 42, 0.12)',
    '0 8.9px 23.1px rgba(15, 23, 42, 0.1), 0 17.8px 46.2px rgba(15, 23, 42, 0.12)'
];



var // Montserrat is kept. What changed is the scale, which had two defects:
//
//   h6 was 24px — larger than h5 (16px) and equal to h3, so heading order did not
//   correspond to size, and
//
//   fontWeight was given as 'medium' and 'bold' on h1/h2. 'medium' is not a valid CSS
//   font-weight keyword, so the browser discarded it and those headings rendered at the
//   default weight.
//
// Sizes are rem so they respond to the user's browser text size. Line heights are set
// explicitly: the previous scale had none, so headings inherited body leading and looked
// cramped. Negative letter-spacing is kept only on the large sizes where it helps.
$b989fe3aa70a852c$export$2e2bcd8739ae039 = {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
        fontWeight: 700,
        fontSize: '2rem',
        // 32px
        lineHeight: 1.2,
        letterSpacing: '-0.02em'
    },
    h2: {
        fontWeight: 700,
        fontSize: '1.625rem',
        // 26px
        lineHeight: 1.25,
        letterSpacing: '-0.015em'
    },
    h3: {
        fontWeight: 600,
        fontSize: '1.375rem',
        // 22px
        lineHeight: 1.3,
        letterSpacing: '-0.01em'
    },
    h4: {
        fontWeight: 600,
        fontSize: '1.125rem',
        // 18px
        lineHeight: 1.35
    },
    h5: {
        fontWeight: 600,
        fontSize: '1rem',
        // 16px
        lineHeight: 1.4
    },
    h6: {
        fontWeight: 600,
        fontSize: '0.9375rem',
        // 15px — now the smallest heading, as the level implies
        lineHeight: 1.4
    },
    subtitle1: {
        fontWeight: 500,
        fontSize: '0.9375rem',
        lineHeight: 1.5
    },
    subtitle2: {
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: 1.5
    },
    body1: {
        fontSize: '0.9375rem',
        // 15px, up from the MUI default 16 being used unstyled
        lineHeight: 1.6
    },
    body2: {
        fontSize: '0.875rem',
        // 14px
        lineHeight: 1.6
    },
    button: {
        fontWeight: 600,
        fontSize: '0.875rem',
        letterSpacing: '0.01em',
        textTransform: 'none' // ALL CAPS buttons are the single strongest dated signal
    },
    caption: {
        fontSize: '0.75rem',
        lineHeight: 1.5
    },
    overline: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase'
    }
};


parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");
function $5c4886e154f6e8eb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $5c4886e154f6e8eb$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $5c4886e154f6e8eb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $5c4886e154f6e8eb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5c4886e154f6e8eb$export$2e2bcd8739ae039 = $5c4886e154f6e8eb$export$4f5d2d50c9deca37;




var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");
var $jSIPP = parcelRequire("jSIPP");
'use client';
function $be4698e2c00258a0$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $jSIPP.useRef(controlled !== undefined);
    const [valueState, setValue] = $jSIPP.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $jSIPP.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $jSIPP = parcelRequire("jSIPP");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $55503225f0104895$var$useEventCallback(fn) {
    const ref = $jSIPP.useRef(fn);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $jSIPP.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $55503225f0104895$export$2e2bcd8739ae039 = $55503225f0104895$var$useEventCallback;



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");
const $a3d9be5ae8dc4060$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $erOpW.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $7d1dcea77433b7ca$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $7d1dcea77433b7ca$export$1af4c7e47ad72f44 = $7d1dcea77433b7ca$var$enUSPickers;
const $7d1dcea77433b7ca$export$137380d9ce54f7f = (0, $a3d9be5ae8dc4060$export$67c96d35a1b010b3)($7d1dcea77433b7ca$var$enUSPickers);


const $a5c70c775eb8908d$export$4b5a24245de9f7f9 = ()=>{
    const localization = $jSIPP.useContext((0, $90e85bbb3ec20250$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $jSIPP.useMemo(()=>(0, $erOpW.default)({}, (0, $7d1dcea77433b7ca$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $jSIPP.useMemo(()=>(0, $erOpW.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $a5c70c775eb8908d$export$1163b47e39508a46 = ()=>$a5c70c775eb8908d$export$4b5a24245de9f7f9().utils;
const $a5c70c775eb8908d$export$7c38da3a2e90fa83 = ()=>$a5c70c775eb8908d$export$4b5a24245de9f7f9().defaultDates;
const $a5c70c775eb8908d$export$24fdeaa0f591a73e = ()=>$a5c70c775eb8908d$export$4b5a24245de9f7f9().localeText;
const $a5c70c775eb8908d$export$3a404aece3dff2fa = ()=>{
    const utils = $a5c70c775eb8908d$export$1163b47e39508a46();
    const now = $jSIPP.useRef(utils.date());
    return now.current;
};



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $4IZqw = parcelRequire("4IZqw");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $094db3e3eaa48a26$export$24c1f8f60cbac79e(slot) {
    return (0, $geF11.default)('MuiTypography', slot);
}
const $094db3e3eaa48a26$var$typographyClasses = (0, $rARwS.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $094db3e3eaa48a26$export$2e2bcd8739ae039 = $094db3e3eaa48a26$var$typographyClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $4acc79473d417315$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $4acc79473d417315$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $iLAKr.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $094db3e3eaa48a26$export$24c1f8f60cbac79e), classes);
};
const $4acc79473d417315$export$140e2f5526d3cad8 = (0, $28RyA.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $iLAKr.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $4acc79473d417315$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $4acc79473d417315$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $4acc79473d417315$var$transformDeprecatedColors = (color)=>{
    return $4acc79473d417315$var$colorTransformations[color] || color;
};
const $4acc79473d417315$var$Typography = /*#__PURE__*/ $jSIPP.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $4acc79473d417315$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $4IZqw.default)((0, $erOpW.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $4acc79473d417315$var$defaultVariantMapping } = props, other = (0, $cMu4A.default)(props, $4acc79473d417315$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $4acc79473d417315$var$defaultVariantMapping[variant]) || 'span';
    const classes = $4acc79473d417315$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($4acc79473d417315$export$140e2f5526d3cad8, (0, $erOpW.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className)
    }, other));
});
var $4acc79473d417315$export$2e2bcd8739ae039 = $4acc79473d417315$var$Typography;



var $28RyA = parcelRequire("28RyA");parcelRequire("jSIPP");


var $kq7Gb = parcelRequire("kq7Gb");

var $iX5qO = parcelRequire("iX5qO");
'use client';
function $2fa84d090238929f$export$2e2bcd8739ae039() {
    const theme = (0, $3400e724fe4dbcd5$export$2e2bcd8739ae039)((0, $kq7Gb.default));
    return theme[0, $iX5qO.default] || theme;
}



var $i3Yji = parcelRequire("i3Yji");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $6eff9e987b06ce22$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $c9ba6c1361f28d92$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $jSIPP.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $6eff9e987b06ce22$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $erOpW = parcelRequire("erOpW");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $6388f16c5f351c5b$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $6388f16c5f351c5b$export$2e2bcd8739ae039 = $6388f16c5f351c5b$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $82d40f9825b384d1$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $erOpW.default)({}, otherProps, {
        ownerState: (0, $erOpW.default)({}, otherProps.ownerState, ownerState)
    });
}
var $82d40f9825b384d1$export$2e2bcd8739ae039 = $82d40f9825b384d1$var$appendOwnerState;



var $erOpW = parcelRequire("erOpW");

var $86B3v = parcelRequire("86B3v");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $b4a0caeebed92054$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $b4a0caeebed92054$export$2e2bcd8739ae039 = $b4a0caeebed92054$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $0b6e68a9b7858651$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $0b6e68a9b7858651$export$2e2bcd8739ae039 = $0b6e68a9b7858651$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $e10599cdc4641760$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $86B3v.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $erOpW.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $erOpW.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $b4a0caeebed92054$export$2e2bcd8739ae039)((0, $erOpW.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $0b6e68a9b7858651$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $0b6e68a9b7858651$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $86B3v.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $erOpW.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $erOpW.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $e10599cdc4641760$export$2e2bcd8739ae039 = $e10599cdc4641760$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $0afa2b041c6cd8ec$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $0afa2b041c6cd8ec$export$2e2bcd8739ae039 = $0afa2b041c6cd8ec$var$resolveComponentProps;


'use client';
const $c522819850191c59$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $c522819850191c59$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cMu4A.default)(parameters, $c522819850191c59$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $0afa2b041c6cd8ec$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e10599cdc4641760$export$2e2bcd8739ae039)((0, $erOpW.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(elementType, (0, $erOpW.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $c522819850191c59$export$2e2bcd8739ae039 = $c522819850191c59$var$useSlotProps;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

'use client';
var $b93ec20acf1e421a$export$2e2bcd8739ae039 = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039);



'use client';
var $c310764ec7eb15ca$export$2e2bcd8739ae039 = (0, $55503225f0104895$export$2e2bcd8739ae039);



var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
'use client';
const $5e9da08cd2d53e3e$var$UNINITIALIZED = {};
function $5e9da08cd2d53e3e$export$2e2bcd8739ae039(init, initArg) {
    const ref = $jSIPP.useRef($5e9da08cd2d53e3e$var$UNINITIALIZED);
    if (ref.current === $5e9da08cd2d53e3e$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $jSIPP = parcelRequire("jSIPP");
'use client';
const $f058237c6dda571d$var$EMPTY = [];
function $f058237c6dda571d$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $jSIPP.useEffect(fn, $f058237c6dda571d$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $43303828b5822c3b$export$786b4da70f00938b {
    static create() {
        return new $43303828b5822c3b$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $43303828b5822c3b$export$2e2bcd8739ae039() {
    const timeout = (0, $5e9da08cd2d53e3e$export$2e2bcd8739ae039)($43303828b5822c3b$export$786b4da70f00938b.create).current;
    (0, $f058237c6dda571d$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $cac2fb6eb3c47486$var$hadKeyboardEvent = true;
let $cac2fb6eb3c47486$var$hadFocusVisibleRecently = false;
const $cac2fb6eb3c47486$var$hadFocusVisibleRecentlyTimeout = new (0, $43303828b5822c3b$export$786b4da70f00938b)();
const $cac2fb6eb3c47486$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $cac2fb6eb3c47486$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $cac2fb6eb3c47486$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $cac2fb6eb3c47486$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $cac2fb6eb3c47486$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $cac2fb6eb3c47486$var$handlePointerDown() {
    $cac2fb6eb3c47486$var$hadKeyboardEvent = false;
}
function $cac2fb6eb3c47486$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($cac2fb6eb3c47486$var$hadFocusVisibleRecently) $cac2fb6eb3c47486$var$hadKeyboardEvent = true;
    }
}
function $cac2fb6eb3c47486$var$prepare(doc) {
    doc.addEventListener('keydown', $cac2fb6eb3c47486$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $cac2fb6eb3c47486$var$handleVisibilityChange, true);
}
function $cac2fb6eb3c47486$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $cac2fb6eb3c47486$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $cac2fb6eb3c47486$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $cac2fb6eb3c47486$var$handleVisibilityChange, true);
}
function $cac2fb6eb3c47486$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $cac2fb6eb3c47486$var$hadKeyboardEvent || $cac2fb6eb3c47486$var$focusTriggersKeyboardModality(target);
}
function $cac2fb6eb3c47486$export$2e2bcd8739ae039() {
    const ref = $jSIPP.useCallback((node)=>{
        if (node != null) $cac2fb6eb3c47486$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $jSIPP.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $cac2fb6eb3c47486$var$hadFocusVisibleRecently = true;
            $cac2fb6eb3c47486$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $cac2fb6eb3c47486$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($cac2fb6eb3c47486$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $f01db555e582cbc1$export$2e2bcd8739ae039 = (0, $cac2fb6eb3c47486$export$2e2bcd8739ae039);



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $ccFUg = parcelRequire("ccFUg");

var $22rg6 = parcelRequire("22rg6");


var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
var $ab981673135f95bd$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(null);



var $jSIPP = parcelRequire("jSIPP");
function $a9bbfa0195df6644$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $jSIPP.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $jSIPP.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $a9bbfa0195df6644$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $a9bbfa0195df6644$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $a9bbfa0195df6644$export$fa71e2345c31d7a2(props, onExited) {
    return $a9bbfa0195df6644$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $jSIPP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $a9bbfa0195df6644$var$getProp(child, 'appear', props),
            enter: $a9bbfa0195df6644$var$getProp(child, 'enter', props),
            exit: $a9bbfa0195df6644$var$getProp(child, 'exit', props)
        });
    });
}
function $a9bbfa0195df6644$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $a9bbfa0195df6644$export$bbc8a025727ea824(nextProps.children);
    var children = $a9bbfa0195df6644$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $jSIPP.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $jSIPP.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $jSIPP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $a9bbfa0195df6644$var$getProp(child, 'exit', nextProps),
            enter: $a9bbfa0195df6644$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $jSIPP.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $jSIPP.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $jSIPP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $a9bbfa0195df6644$var$getProp(child, 'exit', nextProps),
            enter: $a9bbfa0195df6644$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $420bdf9d8119ed9d$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $420bdf9d8119ed9d$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $420bdf9d8119ed9d$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $ccFUg.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $a9bbfa0195df6644$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $a9bbfa0195df6644$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $a9bbfa0195df6644$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $erOpW.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cMu4A.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $420bdf9d8119ed9d$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $ab981673135f95bd$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $ab981673135f95bd$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
$420bdf9d8119ed9d$var$TransitionGroup.propTypes = {};
$420bdf9d8119ed9d$var$TransitionGroup.defaultProps = $420bdf9d8119ed9d$var$defaultProps;
var $420bdf9d8119ed9d$export$2e2bcd8739ae039 = $420bdf9d8119ed9d$var$TransitionGroup;



var $86B3v = parcelRequire("86B3v");

var $lebkq = parcelRequire("lebkq");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $4uaIU = parcelRequire("4uaIU");
'use client';
function $88164dc0ca0de5c2$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $jSIPP.useState(false);
    const rippleClassName = (0, $86B3v.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $86B3v.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $jSIPP.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
            className: childClassName
        })
    });
}
var $88164dc0ca0de5c2$export$2e2bcd8739ae039 = $88164dc0ca0de5c2$var$Ripple;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $5e48e7dd471e7b62$export$b464606f735ab902(slot) {
    return (0, $geF11.default)('MuiTouchRipple', slot);
}
const $5e48e7dd471e7b62$var$touchRippleClasses = (0, $rARwS.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $5e48e7dd471e7b62$export$2e2bcd8739ae039 = $5e48e7dd471e7b62$var$touchRippleClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
let $3d58ac2824430f61$var$_ = (t)=>t, $3d58ac2824430f61$var$t, $3d58ac2824430f61$var$t1, $3d58ac2824430f61$var$t2, $3d58ac2824430f61$var$t3;
const $3d58ac2824430f61$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3d58ac2824430f61$var$_1 = (t)=>t, $3d58ac2824430f61$var$_t, $3d58ac2824430f61$var$_t2, $3d58ac2824430f61$var$_t3, $3d58ac2824430f61$var$_t4;
const $3d58ac2824430f61$var$DURATION = 550;
const $3d58ac2824430f61$export$95d0c9356b2231a3 = 80;
const $3d58ac2824430f61$var$enterKeyframe = (0, $lebkq.keyframes)($3d58ac2824430f61$var$_t || ($3d58ac2824430f61$var$_t = $3d58ac2824430f61$var$_1($3d58ac2824430f61$var$t || ($3d58ac2824430f61$var$t = $3d58ac2824430f61$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3d58ac2824430f61$var$exitKeyframe = (0, $lebkq.keyframes)($3d58ac2824430f61$var$_t2 || ($3d58ac2824430f61$var$_t2 = $3d58ac2824430f61$var$_1($3d58ac2824430f61$var$t1 || ($3d58ac2824430f61$var$t1 = $3d58ac2824430f61$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3d58ac2824430f61$var$pulsateKeyframe = (0, $lebkq.keyframes)($3d58ac2824430f61$var$_t3 || ($3d58ac2824430f61$var$_t3 = $3d58ac2824430f61$var$_1($3d58ac2824430f61$var$t2 || ($3d58ac2824430f61$var$t2 = $3d58ac2824430f61$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3d58ac2824430f61$export$f6b7418508c72c25 = (0, $28RyA.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3d58ac2824430f61$export$676cfe7b12693c4b = (0, $28RyA.default)((0, $88164dc0ca0de5c2$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($3d58ac2824430f61$var$_t4 || ($3d58ac2824430f61$var$_t4 = $3d58ac2824430f61$var$_1($3d58ac2824430f61$var$t3 || ($3d58ac2824430f61$var$t3 = $3d58ac2824430f61$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).rippleVisible, $3d58ac2824430f61$var$enterKeyframe, $3d58ac2824430f61$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).child, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).childLeaving, $3d58ac2824430f61$var$exitKeyframe, $3d58ac2824430f61$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).childPulsate, $3d58ac2824430f61$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3d58ac2824430f61$var$TouchRipple = /*#__PURE__*/ $jSIPP.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cMu4A.default)(props, $3d58ac2824430f61$var$_excluded);
    const [ripples, setRipples] = $jSIPP.useState([]);
    const nextKey = $jSIPP.useRef(0);
    const rippleCallback = $jSIPP.useRef(null);
    $jSIPP.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $jSIPP.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $jSIPP.useRef(null);
    const container = $jSIPP.useRef(null);
    const startCommit = $jSIPP.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $4uaIU.jsx)($3d58ac2824430f61$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $86B3v.default)(classes.ripple, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $86B3v.default)(classes.rippleVisible, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $86B3v.default)(classes.ripplePulsate, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $86B3v.default)(classes.child, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $86B3v.default)(classes.childLeaving, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $86B3v.default)(classes.childPulsate, (0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3d58ac2824430f61$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $jSIPP.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3d58ac2824430f61$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $jSIPP.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $jSIPP.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $jSIPP.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($3d58ac2824430f61$export$f6b7418508c72c25, (0, $erOpW.default)({
        className: (0, $86B3v.default)((0, $5e48e7dd471e7b62$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $420bdf9d8119ed9d$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3d58ac2824430f61$export$2e2bcd8739ae039 = $3d58ac2824430f61$var$TouchRipple;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $7b0c70222ff65a00$export$fccb0498dcd99783(slot) {
    return (0, $geF11.default)('MuiButtonBase', slot);
}
const $7b0c70222ff65a00$var$buttonBaseClasses = (0, $rARwS.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $7b0c70222ff65a00$export$2e2bcd8739ae039 = $7b0c70222ff65a00$var$buttonBaseClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $631d68b9552365dc$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $631d68b9552365dc$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $7b0c70222ff65a00$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $631d68b9552365dc$export$7ec0dcc5e3cdcd36 = (0, $28RyA.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $7b0c70222ff65a00$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $631d68b9552365dc$var$ButtonBase = /*#__PURE__*/ $jSIPP.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cMu4A.default)(props, $631d68b9552365dc$var$_excluded);
    const buttonRef = $jSIPP.useRef(null);
    const rippleRef = $jSIPP.useRef(null);
    const handleRippleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $f01db555e582cbc1$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $jSIPP.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $jSIPP.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $jSIPP.useState(false);
    $jSIPP.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $jSIPP.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $jSIPP.useRef(false);
    const handleKeyDown = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $erOpW.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $631d68b9552365dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($631d68b9552365dc$export$7ec0dcc5e3cdcd36, (0, $erOpW.default)({
        as: ComponentProp,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $4uaIU.jsx)((0, $3d58ac2824430f61$export$2e2bcd8739ae039), (0, $erOpW.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $631d68b9552365dc$export$2e2bcd8739ae039 = $631d68b9552365dc$var$ButtonBase;



var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $f85c7232c4ff55d9$export$5e8702d71474f093(slot) {
    return (0, $geF11.default)('MuiIconButton', slot);
}
const $f85c7232c4ff55d9$var$iconButtonClasses = (0, $rARwS.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $f85c7232c4ff55d9$export$2e2bcd8739ae039 = $f85c7232c4ff55d9$var$iconButtonClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f39aadf3bf12995a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f39aadf3bf12995a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $iLAKr.default)(color)}`,
            edge && `edge${(0, $iLAKr.default)(edge)}`,
            `size${(0, $iLAKr.default)(size)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $f85c7232c4ff55d9$export$5e8702d71474f093), classes);
};
const $f39aadf3bf12995a$var$IconButtonRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $iLAKr.default)(ownerState.edge)}`],
            styles[`size${(0, $iLAKr.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $erOpW.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $erOpW.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $erOpW.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $f85c7232c4ff55d9$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f39aadf3bf12995a$var$IconButton = /*#__PURE__*/ $jSIPP.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $cMu4A.default)(props, $f39aadf3bf12995a$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f39aadf3bf12995a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f39aadf3bf12995a$var$IconButtonRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $f39aadf3bf12995a$export$2e2bcd8739ae039 = $f39aadf3bf12995a$var$IconButton;



var $gVlpF = parcelRequire("gVlpF");

var $jSIPP = parcelRequire("jSIPP");

var $4uaIU = parcelRequire("4uaIU");
const $6b5658f8e1b18874$export$6243d250c3142fa2 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $6b5658f8e1b18874$export$e4c291d45fea4cd0 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $6b5658f8e1b18874$export$acad20503ad73ac1 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $6b5658f8e1b18874$export$e1aef45b828286de = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $6b5658f8e1b18874$export$9735c82c4bae3302 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
    children: [
        /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $6b5658f8e1b18874$export$829bd850c745b6e = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $6b5658f8e1b18874$export$680ea196effce5f = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
    children: [
        /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');



var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $866a42440afcca57$export$cef978c25740de90(slot) {
    return (0, $geF11.default)('MuiPickersArrowSwitcher', slot);
}
const $866a42440afcca57$export$f8819209558cd362 = (0, $rARwS.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);



var $4uaIU = parcelRequire("4uaIU");
const $531748f435611027$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $531748f435611027$var$_excluded2 = [
    "ownerState"
], $531748f435611027$var$_excluded3 = [
    "ownerState"
];
const $531748f435611027$var$PickersArrowSwitcherRoot = (0, $28RyA.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $531748f435611027$var$PickersArrowSwitcherSpacer = (0, $28RyA.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $531748f435611027$var$PickersArrowSwitcherButton = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $531748f435611027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $866a42440afcca57$export$cef978c25740de90), classes);
};
const $531748f435611027$export$597b7cbdb7b2a24c = /*#__PURE__*/ $jSIPP.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $cMu4A.default)(props, $531748f435611027$var$_excluded);
    const ownerState = props;
    const classes = $531748f435611027$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const [leftProps, rightProps] = isRTL ? [
        nextProps,
        previousProps
    ] : [
        previousProps,
        nextProps
    ];
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $531748f435611027$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: leftProps.label,
            'aria-label': leftProps.label,
            disabled: leftProps.isDisabled,
            edge: 'end',
            onClick: leftProps.goTo
        },
        ownerState: (0, $erOpW.default)({}, ownerState, {
            hidden: leftProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $531748f435611027$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: rightProps.label,
            'aria-label': rightProps.label,
            disabled: rightProps.isDisabled,
            edge: 'start',
            onClick: rightProps.goTo
        },
        ownerState: (0, $erOpW.default)({}, ownerState, {
            hidden: rightProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $6b5658f8e1b18874$export$e4c291d45fea4cd0);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $cMu4A.default)(_useSlotProps, $531748f435611027$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $6b5658f8e1b18874$export$acad20503ad73ac1);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $cMu4A.default)(_useSlotProps2, $531748f435611027$var$_excluded3);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($531748f435611027$var$PickersArrowSwitcherRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $5c4886e154f6e8eb$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(PreviousIconButton, (0, $erOpW.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $4uaIU.jsx)(RightArrowIcon, (0, $erOpW.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $4uaIU.jsx)(LeftArrowIcon, (0, $erOpW.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $4uaIU.jsx)($531748f435611027$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)(NextIconButton, (0, $erOpW.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $4uaIU.jsx)(LeftArrowIcon, (0, $erOpW.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $4uaIU.jsx)(RightArrowIcon, (0, $erOpW.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});


const $5544c98cb47f8a07$export$8f04d380cefd5a0d = (view)=>[
        'hours',
        'minutes',
        'seconds'
    ].includes(view);
const $5544c98cb47f8a07$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $5544c98cb47f8a07$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $5544c98cb47f8a07$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $5544c98cb47f8a07$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $5544c98cb47f8a07$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $5544c98cb47f8a07$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $5544c98cb47f8a07$export$888a1ce13aa61986(dateLeft, utils) > $5544c98cb47f8a07$export$888a1ce13aa61986(dateRight, utils);
    };



var $jSIPP = parcelRequire("jSIPP");


let $ae73ffed65ce838b$var$warnedOnceNotValidView = false;
function $ae73ffed65ce838b$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $jSIPP.useRef(openTo);
    const previousViews = $jSIPP.useRef(views);
    const defaultView = $jSIPP.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $jSIPP.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $jSIPP.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) setView(views.includes(openTo) ? openTo : views[0]);
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleChangeView = (0, $55503225f0104895$export$2e2bcd8739ae039)((newView)=>{
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $55503225f0104895$export$2e2bcd8739ae039)((value, currentViewSelectionState)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    const handleFocusedViewChange = (0, $55503225f0104895$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        defaultView: defaultView.current,
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



var $jSIPP = parcelRequire("jSIPP");


function $3a9967b0c8d2b8fc$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate }) {
    const utils = (0, $a5c70c775eb8908d$export$1163b47e39508a46)();
    return $jSIPP.useMemo(()=>{
        const now = utils.date();
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils
    ]);
}
function $3a9967b0c8d2b8fc$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate }) {
    const utils = (0, $a5c70c775eb8908d$export$1163b47e39508a46)();
    return $jSIPP.useMemo(()=>{
        const now = utils.date();
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils
    ]);
}
function $3a9967b0c8d2b8fc$export$6aaabc31cb076d17(date, ampm, onChange) {
    const utils = (0, $a5c70c775eb8908d$export$1163b47e39508a46)();
    const meridiemMode = (0, $5544c98cb47f8a07$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $jSIPP.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $5544c98cb47f8a07$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, 'partial');
    }, [
        ampm,
        date,
        onChange,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $28RyA = parcelRequire("28RyA");
const $e915721d16092e2b$export$3f0060ce4cc8f4d0 = 36;
const $e915721d16092e2b$export$dde58b009b497666 = 2;
const $e915721d16092e2b$export$ee46b8a74d6c94d3 = 320;
const $e915721d16092e2b$export$f2fef360e2df0cb7 = 358;


const $40da211ba9b477b3$export$512b066b8abdfde4 = (0, $28RyA.default)('div')({
    overflow: 'hidden',
    width: (0, $e915721d16092e2b$export$ee46b8a74d6c94d3),
    maxHeight: (0, $e915721d16092e2b$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});



var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $b327e0fdf20edd89$export$148b188041a720e4(slot) {
    return (0, $geF11.default)('MuiTimeClock', slot);
}
const $b327e0fdf20edd89$export$191dec874db3257b = (0, $rARwS.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");
const $49e707cb8bafcd1b$export$8c8ec20d3854d7e6 = 220;
const $49e707cb8bafcd1b$export$729c0e543e4dc21d = 36;
const $49e707cb8bafcd1b$var$clockCenter = {
    x: $49e707cb8bafcd1b$export$8c8ec20d3854d7e6 / 2,
    y: $49e707cb8bafcd1b$export$8c8ec20d3854d7e6 / 2
};
const $49e707cb8bafcd1b$var$baseClockPoint = {
    x: $49e707cb8bafcd1b$var$clockCenter.x,
    y: 0
};
const $49e707cb8bafcd1b$var$cx = $49e707cb8bafcd1b$var$baseClockPoint.x - $49e707cb8bafcd1b$var$clockCenter.x;
const $49e707cb8bafcd1b$var$cy = $49e707cb8bafcd1b$var$baseClockPoint.y - $49e707cb8bafcd1b$var$clockCenter.y;
const $49e707cb8bafcd1b$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $49e707cb8bafcd1b$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $49e707cb8bafcd1b$var$clockCenter.x;
    const y = offsetY - $49e707cb8bafcd1b$var$clockCenter.y;
    const atan = Math.atan2($49e707cb8bafcd1b$var$cx, $49e707cb8bafcd1b$var$cy) - Math.atan2(x, y);
    let deg = $49e707cb8bafcd1b$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $49e707cb8bafcd1b$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $49e707cb8bafcd1b$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $49e707cb8bafcd1b$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $49e707cb8bafcd1b$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $49e707cb8bafcd1b$export$8c8ec20d3854d7e6 / 2 - $49e707cb8bafcd1b$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $44b1ae31b57e2011$export$12faa62796978e2f(slot) {
    return (0, $geF11.default)('MuiClockPointer', slot);
}
const $44b1ae31b57e2011$export$64afeec9352615cb = (0, $rARwS.default)('MuiClockPointer', [
    'root',
    'thumb'
]);



var $4uaIU = parcelRequire("4uaIU");
const $bd9fa6bba38e5d46$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $bd9fa6bba38e5d46$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $44b1ae31b57e2011$export$12faa62796978e2f), classes);
};
const $bd9fa6bba38e5d46$var$ClockPointerRoot = (0, $28RyA.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px'
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            'transform',
            'height'
        ])
    }));
const $bd9fa6bba38e5d46$var$ClockPointerThumb = (0, $28RyA.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb',
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $49e707cb8bafcd1b$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $49e707cb8bafcd1b$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box'
    }, ownerState.hasSelected && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }));
function $bd9fa6bba38e5d46$export$f257f213e6c08f97(inProps) {
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $cMu4A.default)(props, $bd9fa6bba38e5d46$var$_excluded);
    const previousType = $jSIPP.useRef(type);
    $jSIPP.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $bd9fa6bba38e5d46$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $49e707cb8bafcd1b$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)($bd9fa6bba38e5d46$var$ClockPointerRoot, (0, $erOpW.default)({
        style: getAngleStyle(),
        className: (0, $5c4886e154f6e8eb$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($bd9fa6bba38e5d46$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $79658f29308160a8$export$e44ecab24167799b(slot) {
    return (0, $geF11.default)('MuiClock', slot);
}
const $79658f29308160a8$export$4626e3a61e161c64 = (0, $rARwS.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton'
]);



var $4uaIU = parcelRequire("4uaIU");
const $4533cf3d9fefe2c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton'
        ],
        pmButton: [
            'pmButton'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $79658f29308160a8$export$e44ecab24167799b), classes);
};
const $4533cf3d9fefe2c0$var$ClockRoot = (0, $28RyA.default)('div', {
    name: 'MuiClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $4533cf3d9fefe2c0$var$ClockClock = (0, $28RyA.default)('div', {
    name: 'MuiClock',
    slot: 'Clock',
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $4533cf3d9fefe2c0$var$ClockWrapper = (0, $28RyA.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper',
    overridesResolver: (_, styles)=>styles.wrapper
})({
    '&:focus': {
        outline: 'none'
    }
});
const $4533cf3d9fefe2c0$var$ClockSquareMask = (0, $28RyA.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask',
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        pointerEvents: 'auto',
        outline: 0,
        // Disable scroll capabilities.
        touchAction: 'none',
        userSelect: 'none'
    }, ownerState.disabled ? {} : {
        '@media (pointer: fine)': {
            cursor: 'pointer',
            borderRadius: '50%'
        },
        '&:active': {
            cursor: 'move'
        }
    }));
const $4533cf3d9fefe2c0$var$ClockPin = (0, $28RyA.default)('div', {
    name: 'MuiClock',
    slot: 'Pin',
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $4533cf3d9fefe2c0$var$ClockAmButton = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'AmButton',
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        left: 8
    }, ownerState.meridiemMode === 'am' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $4533cf3d9fefe2c0$var$ClockPmButton = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'PmButton',
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        right: 8
    }, ownerState.meridiemMode === 'pm' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
function $4533cf3d9fefe2c0$export$9735c82c4bae3302(inProps) {
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $a5c70c775eb8908d$export$1163b47e39508a46)();
    const localeText = (0, $a5c70c775eb8908d$export$24fdeaa0f591a73e)();
    const isMoving = $jSIPP.useRef(false);
    const classes = $4533cf3d9fefe2c0$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $49e707cb8bafcd1b$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $49e707cb8bafcd1b$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = $jSIPP.useMemo(()=>{
        if (type === 'hours') return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $jSIPP.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // annulate both hours and minutes
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(viewValue + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(viewValue - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($4533cf3d9fefe2c0$var$ClockRoot, {
        className: (0, $5c4886e154f6e8eb$export$2e2bcd8739ae039)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)($4533cf3d9fefe2c0$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)($4533cf3d9fefe2c0$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)($4533cf3d9fefe2c0$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bd9fa6bba38e5d46$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)($4533cf3d9fefe2c0$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)($4533cf3d9fefe2c0$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                            variant: "caption",
                            children: "AM"
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)($4533cf3d9fefe2c0$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                            variant: "caption",
                            children: "PM"
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("jSIPP");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");


var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $71e4d234be4fea31$export$527226d166658911(slot) {
    return (0, $geF11.default)('MuiClockNumber', slot);
}
const $71e4d234be4fea31$export$c8efb3a779c9844a = (0, $rARwS.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);



var $4uaIU = parcelRequire("4uaIU");
const $f4d70e8f656ce0b3$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $f4d70e8f656ce0b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $71e4d234be4fea31$export$527226d166658911), classes);
};
const $f4d70e8f656ce0b3$var$ClockNumberRoot = (0, $28RyA.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $71e4d234be4fea31$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $71e4d234be4fea31$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        height: (0, $49e707cb8bafcd1b$export$729c0e543e4dc21d),
        width: (0, $49e707cb8bafcd1b$export$729c0e543e4dc21d),
        position: 'absolute',
        left: `calc((100% - ${(0, $49e707cb8bafcd1b$export$729c0e543e4dc21d)}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $71e4d234be4fea31$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $71e4d234be4fea31$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.inner && (0, $erOpW.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary
    })));
function $f4d70e8f656ce0b3$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $cMu4A.default)(props, $f4d70e8f656ce0b3$var$_excluded);
    const ownerState = props;
    const classes = $f4d70e8f656ce0b3$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $49e707cb8bafcd1b$export$8c8ec20d3854d7e6) - (0, $49e707cb8bafcd1b$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f4d70e8f656ce0b3$var$ClockNumberRoot, (0, $erOpW.default)({
        className: (0, $5c4886e154f6e8eb$export$2e2bcd8739ae039)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $49e707cb8bafcd1b$export$8c8ec20d3854d7e6) - (0, $49e707cb8bafcd1b$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $4uaIU = parcelRequire("4uaIU");
const $f6a4337a96a9fd73$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $4uaIU.jsx)((0, $f4d70e8f656ce0b3$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $f6a4337a96a9fd73$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f4d70e8f656ce0b3$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};



var $erOpW = parcelRequire("erOpW");
const $1acc4ce8f2d02e85$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $erOpW.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};



var $4uaIU = parcelRequire("4uaIU");
const $a0dd375b0e94201e$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "defaultValue",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "className",
    "disabled",
    "readOnly"
];
const $a0dd375b0e94201e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $b327e0fdf20edd89$export$148b188041a720e4), classes);
};
const $a0dd375b0e94201e$var$TimeClockRoot = (0, $28RyA.default)((0, $40da211ba9b477b3$export$512b066b8abdfde4), {
    name: 'MuiTimeClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $a0dd375b0e94201e$var$TimeClockArrowSwitcher = (0, $28RyA.default)((0, $531748f435611027$export$597b7cbdb7b2a24c), {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $a0dd375b0e94201e$export$7e96244e18c4be57 = /*#__PURE__*/ $jSIPP.forwardRef(function TimeClock(inProps, ref) {
    const localeText = (0, $a5c70c775eb8908d$export$24fdeaa0f591a73e)();
    const now = (0, $a5c70c775eb8908d$export$3a404aece3dff2fa)();
    const utils = (0, $a5c70c775eb8908d$export$1163b47e39508a46)();
    const props = (0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps, value: valueProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, defaultValue: defaultValue, view: inView, views: views = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, className: className, disabled: disabled, readOnly: readOnly } = props, other = (0, $cMu4A.default)(props, $a0dd375b0e94201e$var$_excluded);
    const slots = innerSlots != null ? innerSlots : (0, $1acc4ce8f2d02e85$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const [value, setValue] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        name: 'DateCalendar',
        state: 'value',
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : null
    });
    const handleValueChange = (0, $55503225f0104895$export$2e2bcd8739ae039)((newValue, selectionState)=>{
        setValue(newValue);
        onChange == null || onChange(newValue, selectionState);
    });
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $ae73ffed65ce838b$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange
    });
    const selectedTimeOrMidnight = $jSIPP.useMemo(()=>value || utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0), [
        value,
        now,
        utils
    ]);
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $3a9967b0c8d2b8fc$export$6aaabc31cb076d17)(selectedTimeOrMidnight, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $jSIPP.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $5544c98cb47f8a07$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(selectedTimeOrMidnight, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(selectedTimeOrMidnight, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(selectedTimeOrMidnight, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $5544c98cb47f8a07$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(selectedTimeOrMidnight, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(selectedTimeOrMidnight, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(selectedTimeOrMidnight, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        selectedTimeOrMidnight,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const viewProps = $jSIPP.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $5544c98cb47f8a07$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(selectedTimeOrMidnight, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(selectedTimeOrMidnight),
                        children: (0, $f6a4337a96a9fd73$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(selectedTimeOrMidnight);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(selectedTimeOrMidnight, minuteValue), isFinish);
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $f6a4337a96a9fd73$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(selectedTimeOrMidnight);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(selectedTimeOrMidnight, secondValue), isFinish);
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $f6a4337a96a9fd73$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        selectedTimeOrMidnight,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $a0dd375b0e94201e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($a0dd375b0e94201e$var$TimeClockRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $5c4886e154f6e8eb$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4533cf3d9fefe2c0$export$9735c82c4bae3302), (0, $erOpW.default)({
                autoFocus: autoFocus,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $4uaIU.jsx)($a0dd375b0e94201e$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});



var $4uaIU = parcelRequire("4uaIU");
const $d0c8c915af3e571a$var$isTimePickerView = (view)=>view === 'hours' || view === 'minutes' || view === 'seconds';
const $d0c8c915af3e571a$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, views: views, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $a0dd375b0e94201e$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter($d0c8c915af3e571a$var$isTimePickerView),
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation
    });


const $d2cc57e9a89cc3bf$var$drawerWidthRem = 7;
// The MuiIcon and MuiTableCell variants below are referenced by name from components —
// do not rename them.
const $d2cc57e9a89cc3bf$var$theme = (0, $ct73g.default)({
    palette: $a9ce7c8f92595c85$export$2e2bcd8739ae039,
    typography: $b989fe3aa70a852c$export$2e2bcd8739ae039,
    shape: {
        borderRadius: 8
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.paper,
                    color: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).text.primary,
                    borderBottom: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                }
            }
        },
        MuiBottomNavigation: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.paper,
                    borderTop: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                }
            }
        },
        MuiButton: {
            defaultProps: {
                size: 'medium',
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    paddingInline: '1rem'
                },
                containedPrimary: {
                    '&:hover': {
                        backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).primary.dark
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    fontWeight: 500
                }
            }
        },
        MuiDesktopDateTimePicker: {
            defaultProps: {
                viewRenderers: {
                    hours: (0, $d0c8c915af3e571a$export$a3ad21a1b07c504f),
                    minutes: (0, $d0c8c915af3e571a$export$a3ad21a1b07c504f),
                    seconds: (0, $d0c8c915af3e571a$export$a3ad21a1b07c504f)
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    height: 'fit-content',
                    maxHeight: '90vh',
                    padding: '1rem',
                    borderRadius: 12
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.paper,
                    border: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`,
                    borderRadius: 8
                },
                columnHeaders: {
                    backgroundColor: '#F1F5F9',
                    // slate-100, a shade up from the page
                    borderBottom: `2px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                },
                columnHeaderTitle: {
                    fontWeight: 600
                },
                cell: {
                    borderBottom: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                },
                footerContainer: {
                    borderTop: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    paddingBottom: '0.5rem'
                }
            }
        },
        MuiDrawer: {
            defaultProps: {
                variant: 'temporary',
                ModalProps: {
                    keepMounted: true
                },
                PaperProps: {
                    elevation: 8
                }
            },
            styleOverrides: {
                root: {
                    width: `${$d2cc57e9a89cc3bf$var$drawerWidthRem}rem`,
                    flexShrink: {
                        sm: 0
                    },
                    display: {
                        xs: 'none',
                        md: 'block'
                    }
                },
                paper: {
                    boxSizing: 'border-box',
                    width: `${$d2cc57e9a89cc3bf$var$drawerWidthRem}rem`,
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.paper,
                    borderRight: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                }
            }
        },
        MuiIcon: {
            defaultProps: {
                color: 'secondary'
            },
            variants: [
                {
                    props: {
                        variant: 'notifyDisabled'
                    },
                    style: {
                        color: '#744fbf'
                    }
                },
                {
                    props: {
                        variant: 'clickable'
                    },
                    style: {
                        cursor: 'pointer'
                    }
                }
            ]
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.paper,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).secondary.light
                    }
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                position: 'static'
            },
            styleOverrides: {
                rounded: {
                    borderRadius: 12
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).background.default
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    borderBottom: `1px solid ${(0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).divider}`
                },
                head: {
                    fontWeight: 600,
                    color: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).text.secondary
                }
            },
            variants: [
                {
                    props: {
                        variant: 'enabled'
                    }
                },
                {
                    props: {
                        variant: 'disabled'
                    },
                    style: {
                        color: "#94A3B8"
                    }
                }
            ]
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: (0, $a9ce7c8f92595c85$export$2e2bcd8739ae039).text.primary,
                    fontSize: '0.75rem',
                    borderRadius: 6
                }
            }
        }
    },
    shadows: $0e23034b6157fdb9$export$2e2bcd8739ae039
});
var $d2cc57e9a89cc3bf$export$2e2bcd8739ae039 = $d2cc57e9a89cc3bf$var$theme;



function $47c4a91078405b28$var$e(e) {
    this.message = e;
}
$47c4a91078405b28$var$e.prototype = new Error, $47c4a91078405b28$var$e.prototype.name = "InvalidCharacterError";
var $47c4a91078405b28$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $47c4a91078405b28$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $47c4a91078405b28$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($47c4a91078405b28$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $47c4a91078405b28$var$r(t);
    }
}
function $47c4a91078405b28$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $47c4a91078405b28$var$o(e, r) {
    if ("string" != typeof e) throw new $47c4a91078405b28$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($47c4a91078405b28$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $47c4a91078405b28$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$47c4a91078405b28$export$b9721ef022f71a68.prototype = new Error, $47c4a91078405b28$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $47c4a91078405b28$export$2e2bcd8739ae039 = $47c4a91078405b28$var$o;


const $875b725466af1357$var$login = async (user, pass)=>(0, $f759aa5a9826e8c0$export$334c29725a78c21d).signIn(user, pass);
const $875b725466af1357$var$getUser = async ()=>{
    const userFetch = await (0, $f759aa5a9826e8c0$export$334c29725a78c21d).currentAuthenticatedUser();
    return userFetch.username;
};
const $875b725466af1357$var$getIdToken = async ()=>{
    try {
        const session = await (0, $f759aa5a9826e8c0$export$334c29725a78c21d).currentSession();
        return session.getIdToken().getJwtToken();
    } catch (err) {
        console.debug('Could not get ID token', err);
    }
};
const $875b725466af1357$var$getUserId = async ()=>{
    let token = await $875b725466af1357$var$getIdToken();
    let decodedToken = (0, $47c4a91078405b28$export$2e2bcd8739ae039)(token);
    return decodedToken.user_id;
};
const $875b725466af1357$var$isLoggedIn = async ()=>!!await $875b725466af1357$var$getIdToken();
const $875b725466af1357$var$logout = async ()=>await (0, $f759aa5a9826e8c0$export$334c29725a78c21d).signOut();
var $875b725466af1357$export$2e2bcd8739ae039 = {
    login: $875b725466af1357$var$login,
    getUser: $875b725466af1357$var$getUser,
    getIdToken: $875b725466af1357$var$getIdToken,
    isLoggedIn: $875b725466af1357$var$isLoggedIn,
    logout: $875b725466af1357$var$logout,
    getUserId: $875b725466af1357$var$getUserId
};



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


const $44ddebeabffdcc65$var$HubListener = ({ setSessionUpdate: setSessionUpdate })=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    (0, $jSIPP.useEffect)(()=>{
        (0, $6c553752040387ec$export$8c41bb232f1008b1).listen('auth', ({ payload: { event: event, data: data } })=>{
            switch(event){
                case 'signIn':
                    setSessionUpdate(true);
                    break;
                case 'signOut':
                    setSessionUpdate(true);
                    break;
                case 'signIn_failure':
                    if (data.code === 'UserNotConfirmedException') history.push('/confirm');
                    break;
                case 'signUp':
                case 'signUp_failure':
                    break;
                default:
                    console.info('Hub::UnhandledCase', event);
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
};
var $44ddebeabffdcc65$export$2e2bcd8739ae039 = $44ddebeabffdcc65$var$HubListener;


function $dfb8d665a0f6a70e$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $7e9b970aebca32bd$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dfb8d665a0f6a70e$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");

var $j3GPk = parcelRequire("j3GPk");

var $4bG06 = parcelRequire("4bG06");
var $4IZqw = parcelRequire("4IZqw");


var $4uaIU = parcelRequire("4uaIU");
'use client';
const $4bf3c3915ff1b66d$var$_excluded = [
    "className",
    "component"
];
function $4bf3c3915ff1b66d$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $j3GPk.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $4bG06.default));
    const Box = /*#__PURE__*/ $jSIPP.forwardRef(function Box(inProps, ref) {
        const theme = (0, $3400e724fe4dbcd5$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $4IZqw.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $cMu4A.default)(_extendSxProp, $4bf3c3915ff1b66d$var$_excluded);
        return /*#__PURE__*/ (0, $4uaIU.jsx)(BoxRoot, (0, $erOpW.default)({
            as: component,
            ref: ref,
            className: (0, $86B3v.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $9vnzz = parcelRequire("9vnzz");

var $ct73g = parcelRequire("ct73g");

var $iX5qO = parcelRequire("iX5qO");

var $rARwS = parcelRequire("rARwS");
const $1d9906c9738ddbe9$var$boxClasses = (0, $rARwS.default)('MuiBox', [
    'root'
]);
var $1d9906c9738ddbe9$export$2e2bcd8739ae039 = $1d9906c9738ddbe9$var$boxClasses;


'use client';
const $b72d1b571cb9f93d$var$defaultTheme = (0, $ct73g.default)();
const $b72d1b571cb9f93d$var$Box = (0, $4bf3c3915ff1b66d$export$2e2bcd8739ae039)({
    themeId: (0, $iX5qO.default),
    defaultTheme: $b72d1b571cb9f93d$var$defaultTheme,
    defaultClassName: (0, $1d9906c9738ddbe9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $9vnzz.default).generate
});
var $b72d1b571cb9f93d$export$2e2bcd8739ae039 = $b72d1b571cb9f93d$var$Box;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $geF11 = parcelRequire("geF11");

var $i3Yji = parcelRequire("i3Yji");

var $61i5U = parcelRequire("61i5U");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $j3GPk = parcelRequire("j3GPk");

var $2TupR = parcelRequire("2TupR");



var $gDcI8 = parcelRequire("gDcI8");

var $4bG06 = parcelRequire("4bG06");
const $f1b45763ec802877$var$_excluded = [
    "ownerState"
], $f1b45763ec802877$var$_excluded2 = [
    "variants"
], $f1b45763ec802877$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $f1b45763ec802877$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f1b45763ec802877$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $f1b45763ec802877$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $f1b45763ec802877$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $f1b45763ec802877$export$35e57303dbd8a66 = (0, $gDcI8.default)();
const $f1b45763ec802877$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $f1b45763ec802877$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $f1b45763ec802877$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $f1b45763ec802877$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $f1b45763ec802877$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $cMu4A.default)(_ref, $f1b45763ec802877$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $erOpW.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$f1b45763ec802877$var$processStyleArg(resolvedStyle, (0, $erOpW.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $cMu4A.default)(resolvedStylesArg, $f1b45763ec802877$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $erOpW.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $erOpW.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $f1b45763ec802877$var$shallowLayer((0, $j3GPk.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $f1b45763ec802877$var$shallowLayer((0, $j3GPk.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $f1b45763ec802877$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $f1b45763ec802877$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $f1b45763ec802877$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $f1b45763ec802877$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $4bG06.default)((0, $erOpW.default)({}, props, {
            theme: $f1b45763ec802877$var$resolveTheme((0, $erOpW.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $j3GPk.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $f1b45763ec802877$var$defaultOverridesResolver($f1b45763ec802877$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cMu4A.default)(inputOptions, $f1b45763ec802877$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $f1b45763ec802877$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f1b45763ec802877$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $j3GPk.default)(tag, (0, $erOpW.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $2TupR.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $f1b45763ec802877$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $f1b45763ec802877$var$processStyleArg(stylesArg, (0, $erOpW.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f1b45763ec802877$var$resolveTheme((0, $erOpW.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $f1b45763ec802877$var$processStyleArg(slotStyle, (0, $erOpW.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $f1b45763ec802877$var$resolveTheme((0, $erOpW.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $f1b45763ec802877$var$processStyleArg({
                    variants: themeVariants
                }, (0, $erOpW.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $4d3abc332db30b81$var$styled = (0, $f1b45763ec802877$export$2e2bcd8739ae039)();
var $4d3abc332db30b81$export$2e2bcd8739ae039 = $4d3abc332db30b81$var$styled;



var $gDcI8 = parcelRequire("gDcI8");

var $4uaIU = parcelRequire("4uaIU");
const $9cce922ae7d533e4$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9cce922ae7d533e4$var$defaultTheme = (0, $gDcI8.default)();
const $9cce922ae7d533e4$var$defaultCreateStyledComponent = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $61i5U.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9cce922ae7d533e4$var$useThemePropsDefault = (inProps)=>(0, $0a9fb94c18c7f261$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9cce922ae7d533e4$var$defaultTheme
    });
const $9cce922ae7d533e4$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $geF11.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $61i5U.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $i3Yji.default)(slots, getContainerUtilityClass, classes);
};
function $9cce922ae7d533e4$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9cce922ae7d533e4$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9cce922ae7d533e4$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $jSIPP.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $cMu4A.default)(props, $9cce922ae7d533e4$var$_excluded);
        const ownerState = (0, $erOpW.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9cce922ae7d533e4$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $4uaIU.jsx)(ContainerRoot, (0, $erOpW.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $86B3v.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $iLAKr = parcelRequire("iLAKr");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");
'use client';
const $47d5907b0888e07d$var$Container = (0, $9cce922ae7d533e4$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $28RyA.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $iLAKr.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $eyQWd.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $47d5907b0888e07d$export$2e2bcd8739ae039 = $47d5907b0888e07d$var$Container;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $8ebe4b43cac4b3fe$export$b12cb262231eef32(slot) {
    return (0, $geF11.default)('MuiToolbar', slot);
}
const $8ebe4b43cac4b3fe$var$toolbarClasses = (0, $rARwS.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $8ebe4b43cac4b3fe$export$2e2bcd8739ae039 = $8ebe4b43cac4b3fe$var$toolbarClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $d29ae86b84b6db22$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $d29ae86b84b6db22$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $8ebe4b43cac4b3fe$export$b12cb262231eef32), classes);
};
const $d29ae86b84b6db22$var$ToolbarRoot = (0, $28RyA.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $d29ae86b84b6db22$var$Toolbar = /*#__PURE__*/ $jSIPP.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $cMu4A.default)(props, $d29ae86b84b6db22$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $d29ae86b84b6db22$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d29ae86b84b6db22$var$ToolbarRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $d29ae86b84b6db22$export$2e2bcd8739ae039 = $d29ae86b84b6db22$var$Toolbar;


const $c32036e189f278ac$var$defaultContainerSx = {};
const $c32036e189f278ac$var$NavigationLayout = ({ isLoggedIn: isLoggedIn, topbar: topbar, sidebar: sidebar, bottombar: bottombar, children: children, containerSx: containerSx })=>{
    var _theme_components_MuiDrawer_styleOverrides_root, _theme_components_MuiDrawer_styleOverrides, _theme_components_MuiDrawer;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const TopBar = topbar || (()=>{
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
    });
    const SideBar = sidebar || (()=>{
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
    });
    const BottomBar = bottombar || (()=>{
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            isLoggedIn && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(TopBar, {})
            }),
            isLoggedIn && /*#__PURE__*/ (0, $4uaIU.jsx)(SideBar, {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d29ae86b84b6db22$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                component: "main",
                sx: {
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: `calc(100% - ${((_theme_components_MuiDrawer = theme.components.MuiDrawer) === null || _theme_components_MuiDrawer === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides = _theme_components_MuiDrawer.styleOverrides) === null || _theme_components_MuiDrawer_styleOverrides === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides_root = _theme_components_MuiDrawer_styleOverrides.root) === null || _theme_components_MuiDrawer_styleOverrides_root === void 0 ? void 0 : _theme_components_MuiDrawer_styleOverrides_root.width) || '0px'})`
                    },
                    float: 'right',
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $47d5907b0888e07d$export$2e2bcd8739ae039), {
                    sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $c32036e189f278ac$var$defaultContainerSx, containerSx),
                    maxWidth: "100%",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            pt: 2.4
                        },
                        children: children
                    })
                })
            }),
            isLoggedIn && /*#__PURE__*/ (0, $4uaIU.jsx)(BottomBar, {})
        ]
    });
};
var $c32036e189f278ac$export$2e2bcd8739ae039 = $c32036e189f278ac$var$NavigationLayout;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $ed5cc7b26020e328$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $ed5cc7b26020e328$export$2e2bcd8739ae039 = $ed5cc7b26020e328$var$getOverlayAlpha;



var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $845ac306bd787407$export$29cdb466b9b6f20b(slot) {
    return (0, $geF11.default)('MuiPaper', slot);
}
const $845ac306bd787407$var$paperClasses = (0, $rARwS.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $845ac306bd787407$export$2e2bcd8739ae039 = $845ac306bd787407$var$paperClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f1b71e2e3f4830a6$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $f1b71e2e3f4830a6$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $845ac306bd787407$export$29cdb466b9b6f20b), classes);
};
const $f1b71e2e3f4830a6$var$PaperRoot = (0, $28RyA.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $erOpW.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $erOpW.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $hnF8Y.alpha)('#fff', (0, $ed5cc7b26020e328$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $hnF8Y.alpha)('#fff', (0, $ed5cc7b26020e328$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $f1b71e2e3f4830a6$var$Paper = /*#__PURE__*/ $jSIPP.forwardRef(function Paper(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $cMu4A.default)(props, $f1b71e2e3f4830a6$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $f1b71e2e3f4830a6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f1b71e2e3f4830a6$var$PaperRoot, (0, $erOpW.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref
    }, other));
});
var $f1b71e2e3f4830a6$export$2e2bcd8739ae039 = $f1b71e2e3f4830a6$var$Paper;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $68b75f7ef83be3a1$export$47a2da616e55e8e9(slot) {
    return (0, $geF11.default)('MuiAppBar', slot);
}
const $68b75f7ef83be3a1$var$appBarClasses = (0, $rARwS.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $68b75f7ef83be3a1$export$2e2bcd8739ae039 = $68b75f7ef83be3a1$var$appBarClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $16163943546fd5cc$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $16163943546fd5cc$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iLAKr.default)(color)}`,
            `position${(0, $iLAKr.default)(position)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $68b75f7ef83be3a1$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $16163943546fd5cc$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $16163943546fd5cc$var$AppBarRoot = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $iLAKr.default)(ownerState.position)}`],
            styles[`color${(0, $iLAKr.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $erOpW.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $erOpW.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $erOpW.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $erOpW.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $16163943546fd5cc$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $16163943546fd5cc$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $16163943546fd5cc$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $16163943546fd5cc$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $16163943546fd5cc$var$AppBar = /*#__PURE__*/ $jSIPP.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $cMu4A.default)(props, $16163943546fd5cc$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $16163943546fd5cc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($16163943546fd5cc$var$AppBarRoot, (0, $erOpW.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $86B3v.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $16163943546fd5cc$export$2e2bcd8739ae039 = $16163943546fd5cc$var$AppBar;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");



var $jSIPP = parcelRequire("jSIPP");
function $26305578246e3ab6$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($jSIPP.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");





var $cMu4A = parcelRequire("cMu4A");

var $22rg6 = parcelRequire("22rg6");


var $jSIPP = parcelRequire("jSIPP");

var $6e27ee8915b91392$export$2e2bcd8739ae039 = {
    disabled: false
};




var $59d34c73ff6bcd5f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $5b7c23598e1f29a1$export$bb38bb9a1161268 = 'unmounted';
var $5b7c23598e1f29a1$export$84cbff306f539230 = 'exited';
var $5b7c23598e1f29a1$export$df38205c966be359 = 'entering';
var $5b7c23598e1f29a1$export$78e9e6e3e014d60a = 'entered';
var $5b7c23598e1f29a1$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5b7c23598e1f29a1$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $22rg6.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5b7c23598e1f29a1$export$84cbff306f539230;
                _this.appearStatus = $5b7c23598e1f29a1$export$df38205c966be359;
            } else initialStatus = $5b7c23598e1f29a1$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5b7c23598e1f29a1$export$bb38bb9a1161268;
        else initialStatus = $5b7c23598e1f29a1$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5b7c23598e1f29a1$export$bb38bb9a1161268) return {
            status: $5b7c23598e1f29a1$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5b7c23598e1f29a1$export$df38205c966be359 && status !== $5b7c23598e1f29a1$export$78e9e6e3e014d60a) nextStatus = $5b7c23598e1f29a1$export$df38205c966be359;
            } else if (status === $5b7c23598e1f29a1$export$df38205c966be359 || status === $5b7c23598e1f29a1$export$78e9e6e3e014d60a) nextStatus = $5b7c23598e1f29a1$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5b7c23598e1f29a1$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3ab9800416b64e29$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $59d34c73ff6bcd5f$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5b7c23598e1f29a1$export$84cbff306f539230) this.setState({
            status: $5b7c23598e1f29a1$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3ab9800416b64e29$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $6e27ee8915b91392$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5b7c23598e1f29a1$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5b7c23598e1f29a1$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5b7c23598e1f29a1$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3ab9800416b64e29$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $6e27ee8915b91392$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5b7c23598e1f29a1$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5b7c23598e1f29a1$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5b7c23598e1f29a1$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3ab9800416b64e29$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5b7c23598e1f29a1$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cMu4A.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement((0, $ab981673135f95bd$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component);
$5b7c23598e1f29a1$var$Transition.contextType = (0, $ab981673135f95bd$export$2e2bcd8739ae039);
$5b7c23598e1f29a1$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5b7c23598e1f29a1$var$noop() {}
$5b7c23598e1f29a1$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5b7c23598e1f29a1$var$noop,
    onEntering: $5b7c23598e1f29a1$var$noop,
    onEntered: $5b7c23598e1f29a1$var$noop,
    onExit: $5b7c23598e1f29a1$var$noop,
    onExiting: $5b7c23598e1f29a1$var$noop,
    onExited: $5b7c23598e1f29a1$var$noop
};
$5b7c23598e1f29a1$var$Transition.UNMOUNTED = $5b7c23598e1f29a1$export$bb38bb9a1161268;
$5b7c23598e1f29a1$var$Transition.EXITED = $5b7c23598e1f29a1$export$84cbff306f539230;
$5b7c23598e1f29a1$var$Transition.ENTERING = $5b7c23598e1f29a1$export$df38205c966be359;
$5b7c23598e1f29a1$var$Transition.ENTERED = $5b7c23598e1f29a1$export$78e9e6e3e014d60a;
$5b7c23598e1f29a1$var$Transition.EXITING = $5b7c23598e1f29a1$export$4aacc83d4d59139f;
var $5b7c23598e1f29a1$export$2e2bcd8739ae039 = $5b7c23598e1f29a1$var$Transition;



const $0413a8e252ff8408$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $0413a8e252ff8408$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f0165b03f861203f$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $f0165b03f861203f$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $f0165b03f861203f$var$styles = {
    entering: {
        opacity: 1,
        transform: $f0165b03f861203f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $f0165b03f861203f$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $f0165b03f861203f$var$Grow = /*#__PURE__*/ $jSIPP.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5b7c23598e1f29a1$export$2e2bcd8739ae039) } = props, other = (0, $cMu4A.default)(props, $f0165b03f861203f$var$_excluded);
    const timer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const autoTimeout = $jSIPP.useRef();
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const nodeRef = $jSIPP.useRef(null);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(nodeRef, (0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0413a8e252ff8408$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $f0165b03f861203f$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $f0165b03f861203f$var$isWebKit154 ? duration : duration * 0.666,
                delay: $f0165b03f861203f$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $f0165b03f861203f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $jSIPP.cloneElement(children, (0, $erOpW.default)({
                style: (0, $erOpW.default)({
                    opacity: 0,
                    transform: $f0165b03f861203f$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $f0165b03f861203f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$f0165b03f861203f$var$Grow.muiSupportAuto = true;
var $f0165b03f861203f$export$2e2bcd8739ae039 = $f0165b03f861203f$var$Grow;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
var $654d98f546346f77$exports = {};
"use strict";
'use client';
Object.defineProperty($654d98f546346f77$exports, "__esModule", {
    value: true
});
$654d98f546346f77$exports.default = void 0;

var $654d98f546346f77$var$React = $654d98f546346f77$var$_interopRequireWildcard((parcelRequire("jSIPP")));
parcelRequire("lebkq");
var $eNcJv = parcelRequire("eNcJv");
function $654d98f546346f77$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($654d98f546346f77$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $654d98f546346f77$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $654d98f546346f77$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $654d98f546346f77$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $654d98f546346f77$var$useTheme(defaultTheme = null) {
    const contextTheme = $654d98f546346f77$var$React.useContext($eNcJv.T);
    return !contextTheme || $654d98f546346f77$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $654d98f546346f77$var$_default = $654d98f546346f77$exports.default = $654d98f546346f77$var$useTheme;






var $jSIPP = parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");
function $5721b9ce22c1f3fc$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $c9cb303e12d0896e$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $30b1b8f388e90d99$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $30b1b8f388e90d99$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $30b1b8f388e90d99$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $aa69e6c608df2a68$export$8960430cfd85939f = Math.max;
var $aa69e6c608df2a68$export$96ec731ed4dcb222 = Math.min;
var $aa69e6c608df2a68$export$2077e0241d6afd3c = Math.round;



function $3d1426b5175c7cf3$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $0f260ed2eef8f5bc$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $3d1426b5175c7cf3$export$2e2bcd8739ae039)());
}


function $77d5e66a24aea7af$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(element) ? (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $0f260ed2eef8f5bc$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $890dd8e9c0ffc9f6$export$2e2bcd8739ae039(node) {
    var win = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $77af71312519e116$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $1fb500452185b1ec$export$2e2bcd8739ae039(node) {
    if (node === (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(node) || !(0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(node)) return (0, $890dd8e9c0ffc9f6$export$2e2bcd8739ae039)(node);
    else return (0, $77af71312519e116$export$2e2bcd8739ae039)(node);
}


function $583ac36e0776d500$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $c264d1d39186d716$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $791d179a4b4bf4c0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)((0, $c264d1d39186d716$export$2e2bcd8739ae039)(element)).left + (0, $890dd8e9c0ffc9f6$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $b4a7453e41d5c066$export$2e2bcd8739ae039(element) {
    return (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $730ec018bd7fe791$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $a0ab0bc9dcc15d64$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a0ab0bc9dcc15d64$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(offsetParent) && $a0ab0bc9dcc15d64$var$isElementScaled(offsetParent);
    var documentElement = (0, $c264d1d39186d716$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $583ac36e0776d500$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $730ec018bd7fe791$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $1fb500452185b1ec$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $791d179a4b4bf4c0$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $f377e619f58802f1$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $51a6065241cb4ab3$export$2e2bcd8739ae039(element) {
    if ((0, $583ac36e0776d500$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $30b1b8f388e90d99$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $c264d1d39186d716$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $d229d1ac7147472d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $583ac36e0776d500$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(node) && (0, $730ec018bd7fe791$export$2e2bcd8739ae039)(node)) return node;
    return $d229d1ac7147472d$export$2e2bcd8739ae039((0, $51a6065241cb4ab3$export$2e2bcd8739ae039)(node));
}





function $36eea1b46c01e118$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $d229d1ac7147472d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $730ec018bd7fe791$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($36eea1b46c01e118$export$2e2bcd8739ae039((0, $51a6065241cb4ab3$export$2e2bcd8739ae039)(target)));
}







function $f2cfc746f0e6693e$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $583ac36e0776d500$export$2e2bcd8739ae039)(element)) >= 0;
}




function $b07d330f81b5576c$var$getTrueOffsetParent(element) {
    if (!(0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b07d330f81b5576c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $3d1426b5175c7cf3$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $3d1426b5175c7cf3$export$2e2bcd8739ae039)());
    if (isIE && (0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $51a6065241cb4ab3$export$2e2bcd8739ae039)(element);
    if ((0, $30b1b8f388e90d99$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $583ac36e0776d500$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b07d330f81b5576c$export$2e2bcd8739ae039(element) {
    var window = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(element);
    var offsetParent = $b07d330f81b5576c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $f2cfc746f0e6693e$export$2e2bcd8739ae039)(offsetParent) && (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $b07d330f81b5576c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $583ac36e0776d500$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $583ac36e0776d500$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $b07d330f81b5576c$var$getContainingBlock(element) || window;
}


var $b8e8a9103eb2729c$export$1e95b668f3b82d = 'top';
var $b8e8a9103eb2729c$export$40e543e69a8b3fbb = 'bottom';
var $b8e8a9103eb2729c$export$79ffe56a765070d2 = 'right';
var $b8e8a9103eb2729c$export$eabcd2c8791e7bf4 = 'left';
var $b8e8a9103eb2729c$export$dfb5619354ba860 = 'auto';
var $b8e8a9103eb2729c$export$aec2ce47c367b8c3 = [
    $b8e8a9103eb2729c$export$1e95b668f3b82d,
    $b8e8a9103eb2729c$export$40e543e69a8b3fbb,
    $b8e8a9103eb2729c$export$79ffe56a765070d2,
    $b8e8a9103eb2729c$export$eabcd2c8791e7bf4
];
var $b8e8a9103eb2729c$export$b3571188c770cc5a = 'start';
var $b8e8a9103eb2729c$export$bd5df0f255a350f8 = 'end';
var $b8e8a9103eb2729c$export$390fd549c5303b4d = 'clippingParents';
var $b8e8a9103eb2729c$export$d7b7311ec04a3e8f = 'viewport';
var $b8e8a9103eb2729c$export$ae5ab1c730825774 = 'popper';
var $b8e8a9103eb2729c$export$ca50aac9f3ba507f = 'reference';
var $b8e8a9103eb2729c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $b8e8a9103eb2729c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $b8e8a9103eb2729c$export$b3571188c770cc5a,
        placement + "-" + $b8e8a9103eb2729c$export$bd5df0f255a350f8
    ]);
}, []);
var $b8e8a9103eb2729c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($b8e8a9103eb2729c$export$aec2ce47c367b8c3, [
    $b8e8a9103eb2729c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $b8e8a9103eb2729c$export$b3571188c770cc5a,
        placement + "-" + $b8e8a9103eb2729c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $b8e8a9103eb2729c$export$421679a7c3d56e = 'beforeRead';
var $b8e8a9103eb2729c$export$aafa59e2e03f2942 = 'read';
var $b8e8a9103eb2729c$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $b8e8a9103eb2729c$export$c65e99957a05207c = 'beforeMain';
var $b8e8a9103eb2729c$export$f22da7240b7add18 = 'main';
var $b8e8a9103eb2729c$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $b8e8a9103eb2729c$export$8d4d2d70e7d46032 = 'beforeWrite';
var $b8e8a9103eb2729c$export$68d8715fc104d294 = 'write';
var $b8e8a9103eb2729c$export$70a6e5159acce2e6 = 'afterWrite';
var $b8e8a9103eb2729c$export$d087d3878fdf71d5 = [
    $b8e8a9103eb2729c$export$421679a7c3d56e,
    $b8e8a9103eb2729c$export$aafa59e2e03f2942,
    $b8e8a9103eb2729c$export$6964f6c886723980,
    $b8e8a9103eb2729c$export$c65e99957a05207c,
    $b8e8a9103eb2729c$export$f22da7240b7add18,
    $b8e8a9103eb2729c$export$bab79516f2d662fe,
    $b8e8a9103eb2729c$export$8d4d2d70e7d46032,
    $b8e8a9103eb2729c$export$68d8715fc104d294,
    $b8e8a9103eb2729c$export$70a6e5159acce2e6
];


function $427888bfc800a515$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $427888bfc800a515$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $427888bfc800a515$var$order(modifiers); // order based on phase
    return (0, $b8e8a9103eb2729c$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b574e9bdf20749d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $2ce723578f71c750$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $54fd13231f849f12$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $54fd13231f849f12$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $54fd13231f849f12$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $54fd13231f849f12$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $54fd13231f849f12$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(reference) ? (0, $36eea1b46c01e118$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $36eea1b46c01e118$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $36eea1b46c01e118$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $427888bfc800a515$export$2e2bcd8739ae039)((0, $2ce723578f71c750$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$54fd13231f849f12$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $a0ab0bc9dcc15d64$export$2e2bcd8739ae039)(reference, (0, $b07d330f81b5576c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $f377e619f58802f1$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b574e9bdf20749d$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$54fd13231f849f12$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $54fd13231f849f12$export$8f7491d57c8f97a9 = /*#__PURE__*/ $54fd13231f849f12$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $983e465542db7f65$var$passive = {
    passive: true
};
function $983e465542db7f65$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $983e465542db7f65$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $983e465542db7f65$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $983e465542db7f65$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $983e465542db7f65$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $983e465542db7f65$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $983e465542db7f65$var$effect,
    data: {}
};



function $1368c6e1bb4a92d4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $c15ef3bb7fb2c891$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $a510e7f7b4a5317d$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $44fc898df6b671f2$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $b8e8a9103eb2729c$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $b8e8a9103eb2729c$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $a510e7f7b4a5317d$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $b8e8a9103eb2729c$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $b8e8a9103eb2729c$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $d510b945063fc044$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $44fc898df6b671f2$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d510b945063fc044$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $d510b945063fc044$var$popperOffsets,
    data: {}
};










var $ec0807baf44c0461$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ec0807baf44c0461$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $aa69e6c608df2a68$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ec0807baf44c0461$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4);
    var sideY = (0, $b8e8a9103eb2729c$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $b07d330f81b5576c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $c264d1d39186d716$export$2e2bcd8739ae039)(popper);
            if ((0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $b8e8a9103eb2729c$export$1e95b668f3b82d) || (placement === (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4) || placement === (0, $b8e8a9103eb2729c$export$79ffe56a765070d2)) && variation === (0, $b8e8a9103eb2729c$export$bd5df0f255a350f8)) {
            sideY = (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4) || (placement === (0, $b8e8a9103eb2729c$export$1e95b668f3b82d) || placement === (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb)) && variation === (0, $b8e8a9103eb2729c$export$bd5df0f255a350f8)) {
            sideX = (0, $b8e8a9103eb2729c$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ec0807baf44c0461$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ec0807baf44c0461$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $ec0807baf44c0461$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ec0807baf44c0461$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ec0807baf44c0461$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ec0807baf44c0461$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $ec0807baf44c0461$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $05904922805cfacf$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element) || !(0, $583ac36e0776d500$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $05904922805cfacf$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element) || !(0, $583ac36e0776d500$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $05904922805cfacf$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $05904922805cfacf$var$applyStyles,
    effect: $05904922805cfacf$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a65fe5b27e3392c1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4),
        (0, $b8e8a9103eb2729c$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4),
        (0, $b8e8a9103eb2729c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a65fe5b27e3392c1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $b8e8a9103eb2729c$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a65fe5b27e3392c1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a65fe5b27e3392c1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a65fe5b27e3392c1$var$offset
};


var $5b70b28b364048ea$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $5b70b28b364048ea$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $5b70b28b364048ea$var$hash[matched];
    });
}



var $d39632b62257f77f$var$hash = {
    start: 'end',
    end: 'start'
};
function $d39632b62257f77f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d39632b62257f77f$var$hash[matched];
    });
}







function $675873b5d22c3e3b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $c9cb303e12d0896e$export$2e2bcd8739ae039)(element);
    var html = (0, $c264d1d39186d716$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $0f260ed2eef8f5bc$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $791d179a4b4bf4c0$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f21e2f06efc80a37$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $c264d1d39186d716$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $890dd8e9c0ffc9f6$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $aa69e6c608df2a68$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $aa69e6c608df2a68$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $791d179a4b4bf4c0$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $aa69e6c608df2a68$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $cb2b7a4fb46daf76$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $30b1b8f388e90d99$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5e957ffa335b093$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $0e48b7a9dbf9c591$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $0e48b7a9dbf9c591$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $b8e8a9103eb2729c$export$d7b7311ec04a3e8f) ? (0, $d5e957ffa335b093$export$2e2bcd8739ae039)((0, $675873b5d22c3e3b$export$2e2bcd8739ae039)(element, strategy)) : (0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(clippingParent) ? $0e48b7a9dbf9c591$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5e957ffa335b093$export$2e2bcd8739ae039)((0, $f21e2f06efc80a37$export$2e2bcd8739ae039)((0, $c264d1d39186d716$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $0e48b7a9dbf9c591$var$getClippingParents(element) {
    var clippingParents = (0, $36eea1b46c01e118$export$2e2bcd8739ae039)((0, $51a6065241cb4ab3$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $b4a7453e41d5c066$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $30b1b8f388e90d99$export$1b3bfaa9684536aa)(element) ? (0, $b07d330f81b5576c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(clippingParent) && (0, $cb2b7a4fb46daf76$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $583ac36e0776d500$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $0e48b7a9dbf9c591$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $0e48b7a9dbf9c591$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $0e48b7a9dbf9c591$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $aa69e6c608df2a68$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $aa69e6c608df2a68$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $aa69e6c608df2a68$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $aa69e6c608df2a68$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $0e48b7a9dbf9c591$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $179304dca407ae19$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $b110685967e5891d$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $179304dca407ae19$export$2e2bcd8739ae039)(), paddingObject);
}


function $ec9ae8a400b53a4c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $d85307f35884b4b0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $b8e8a9103eb2729c$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $b8e8a9103eb2729c$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $b8e8a9103eb2729c$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $b110685967e5891d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $ec9ae8a400b53a4c$export$2e2bcd8739ae039)(padding, (0, $b8e8a9103eb2729c$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $b8e8a9103eb2729c$export$ae5ab1c730825774) ? (0, $b8e8a9103eb2729c$export$ca50aac9f3ba507f) : (0, $b8e8a9103eb2729c$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $0e48b7a9dbf9c591$export$2e2bcd8739ae039)((0, $30b1b8f388e90d99$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $c264d1d39186d716$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $77d5e66a24aea7af$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $44fc898df6b671f2$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5e957ffa335b093$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $b8e8a9103eb2729c$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $b8e8a9103eb2729c$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $b8e8a9103eb2729c$export$79ffe56a765070d2),
                (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $b8e8a9103eb2729c$export$1e95b668f3b82d),
                (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $72e5780bdd442e8f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $b8e8a9103eb2729c$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $b8e8a9103eb2729c$export$368f9a87e87fa4e1) : (0, $b8e8a9103eb2729c$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $b8e8a9103eb2729c$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $d85307f35884b4b0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $e33f73f14bf09b30$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement) === (0, $b8e8a9103eb2729c$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $5b70b28b364048ea$export$2e2bcd8739ae039)(placement);
    return [
        (0, $d39632b62257f77f$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $d39632b62257f77f$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $e33f73f14bf09b30$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5b70b28b364048ea$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $e33f73f14bf09b30$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement) === (0, $b8e8a9103eb2729c$export$dfb5619354ba860) ? (0, $72e5780bdd442e8f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(placement) === (0, $b8e8a9103eb2729c$export$b3571188c770cc5a);
        var isVertical = [
            (0, $b8e8a9103eb2729c$export$1e95b668f3b82d),
            (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $d85307f35884b4b0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $b8e8a9103eb2729c$export$79ffe56a765070d2) : (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb) : (0, $b8e8a9103eb2729c$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5b70b28b364048ea$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $5b70b28b364048ea$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $e33f73f14bf09b30$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $e33f73f14bf09b30$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $3c67191112415100$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $b47209ec255dd26f$export$f28d906d67a997f3(min, value, max) {
    return (0, $aa69e6c608df2a68$export$8960430cfd85939f)(min, (0, $aa69e6c608df2a68$export$96ec731ed4dcb222)(value, max));
}
function $b47209ec255dd26f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b47209ec255dd26f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $1c1dba7d741824c1$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $d85307f35884b4b0$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $c15ef3bb7fb2c891$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $a510e7f7b4a5317d$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $3c67191112415100$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $b8e8a9103eb2729c$export$1e95b668f3b82d) : (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb) : (0, $b8e8a9103eb2729c$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $b8e8a9103eb2729c$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $b8e8a9103eb2729c$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $f377e619f58802f1$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $179304dca407ae19$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b47209ec255dd26f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $b07d330f81b5576c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b47209ec255dd26f$export$f28d906d67a997f3)(tether ? (0, $aa69e6c608df2a68$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $aa69e6c608df2a68$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $b8e8a9103eb2729c$export$1e95b668f3b82d) : (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb) : (0, $b8e8a9103eb2729c$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $b8e8a9103eb2729c$export$1e95b668f3b82d),
            (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b47209ec255dd26f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b47209ec255dd26f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1c1dba7d741824c1$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $1c1dba7d741824c1$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $a9923308f0538a6e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $b110685967e5891d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $ec9ae8a400b53a4c$export$2e2bcd8739ae039)(padding, (0, $b8e8a9103eb2729c$export$aec2ce47c367b8c3)));
};
function $a9923308f0538a6e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1368c6e1bb4a92d4$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $a510e7f7b4a5317d$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4),
        (0, $b8e8a9103eb2729c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a9923308f0538a6e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $f377e619f58802f1$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $b8e8a9103eb2729c$export$1e95b668f3b82d) : (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb) : (0, $b8e8a9103eb2729c$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $b07d330f81b5576c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b47209ec255dd26f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a9923308f0538a6e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $cb2b7a4fb46daf76$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a9923308f0538a6e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $a9923308f0538a6e$var$arrow,
    effect: $a9923308f0538a6e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $fd7d5425752abf02$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $fd7d5425752abf02$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $b8e8a9103eb2729c$export$1e95b668f3b82d),
        (0, $b8e8a9103eb2729c$export$79ffe56a765070d2),
        (0, $b8e8a9103eb2729c$export$40e543e69a8b3fbb),
        (0, $b8e8a9103eb2729c$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $fd7d5425752abf02$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $d85307f35884b4b0$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $d85307f35884b4b0$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $fd7d5425752abf02$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $fd7d5425752abf02$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $fd7d5425752abf02$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $fd7d5425752abf02$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd7d5425752abf02$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $fd7d5425752abf02$var$hide
};




var $827e7139244d05a3$export$d34966752335dd47 = [
    (0, $983e465542db7f65$export$2e2bcd8739ae039),
    (0, $d510b945063fc044$export$2e2bcd8739ae039),
    (0, $ec0807baf44c0461$export$2e2bcd8739ae039),
    (0, $05904922805cfacf$export$2e2bcd8739ae039),
    (0, $a65fe5b27e3392c1$export$2e2bcd8739ae039),
    (0, $e33f73f14bf09b30$export$2e2bcd8739ae039),
    (0, $1c1dba7d741824c1$export$2e2bcd8739ae039),
    (0, $a9923308f0538a6e$export$2e2bcd8739ae039),
    (0, $fd7d5425752abf02$export$2e2bcd8739ae039)
];
var $827e7139244d05a3$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $54fd13231f849f12$export$ed5e13716264f202)({
    defaultModifiers: $827e7139244d05a3$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $i3Yji = parcelRequire("i3Yji");


var $jSIPP = parcelRequire("jSIPP");




var $4uaIU = parcelRequire("4uaIU");
'use client';
function $34bbc7ccd9eca5e5$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $34bbc7ccd9eca5e5$var$Portal = /*#__PURE__*/ $jSIPP.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $jSIPP.useState(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(/*#__PURE__*/ $jSIPP.isValidElement(children) ? (0, $26305578246e3ab6$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($34bbc7ccd9eca5e5$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $6eff9e987b06ce22$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $6eff9e987b06ce22$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $jSIPP.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $jSIPP.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $4uaIU.jsx)($jSIPP.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $4uaIU.jsx)($jSIPP.Fragment, {
        children: mountNode ? /*#__PURE__*/ $3ab9800416b64e29$exports.createPortal(children, mountNode) : mountNode
    });
});
var $34bbc7ccd9eca5e5$export$2e2bcd8739ae039 = $34bbc7ccd9eca5e5$var$Portal;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $e26a9a774e0dc893$export$1b69b6cd0fa638a1(slot) {
    return (0, $geF11.default)('MuiPopper', slot);
}
const $e26a9a774e0dc893$var$popperClasses = (0, $rARwS.default)('MuiPopper', [
    'root'
]);
var $e26a9a774e0dc893$export$2e2bcd8739ae039 = $e26a9a774e0dc893$var$popperClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $95c56904baab9785$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $95c56904baab9785$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $95c56904baab9785$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $95c56904baab9785$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $95c56904baab9785$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $95c56904baab9785$var$isVirtualElement(element) {
    return !$95c56904baab9785$var$isHTMLElement(element);
}
const $95c56904baab9785$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $e26a9a774e0dc893$export$1b69b6cd0fa638a1), classes);
};
const $95c56904baab9785$var$defaultPopperOptions = {};
const $95c56904baab9785$var$PopperTooltip = /*#__PURE__*/ $jSIPP.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cMu4A.default)(props, $95c56904baab9785$var$_excluded);
    const tooltipRef = $jSIPP.useRef(null);
    const ownRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $jSIPP.useRef(null);
    const handlePopperRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $jSIPP.useRef(handlePopperRef);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $jSIPP.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $95c56904baab9785$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $jSIPP.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $jSIPP.useState($95c56904baab9785$var$resolveAnchorEl(anchorEl));
    $jSIPP.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $jSIPP.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($95c56904baab9785$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $827e7139244d05a3$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $erOpW.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $95c56904baab9785$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)(Root, (0, $erOpW.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $95c56904baab9785$var$Popper = /*#__PURE__*/ $jSIPP.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $95c56904baab9785$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cMu4A.default)(props, $95c56904baab9785$var$_excluded2);
    const [exited, setExited] = $jSIPP.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $95c56904baab9785$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $95c56904baab9785$var$isHTMLElement(resolvedAnchorEl) ? (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $34bbc7ccd9eca5e5$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($95c56904baab9785$var$PopperTooltip, (0, $erOpW.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $erOpW.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $95c56904baab9785$export$2e2bcd8739ae039 = $95c56904baab9785$var$Popper;



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $b774b692670e0e71$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $b774b692670e0e71$var$PopperRoot = (0, $28RyA.default)((0, $95c56904baab9785$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $b774b692670e0e71$var$Popper = /*#__PURE__*/ $jSIPP.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($654d98f546346f77$exports)))();
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cMu4A.default)(props, $b774b692670e0e71$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $erOpW.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($b774b692670e0e71$var$PopperRoot, (0, $erOpW.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $b774b692670e0e71$export$2e2bcd8739ae039 = $b774b692670e0e71$var$Popper;





'use client';
var $b2e317da5452a23f$export$2e2bcd8739ae039 = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039);




'use client';
var $7981abc7b5093fe8$export$2e2bcd8739ae039 = (0, $be4698e2c00258a0$export$2e2bcd8739ae039);



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $a11e461c98b8a867$export$837848f5f6cee923(slot) {
    return (0, $geF11.default)('MuiTooltip', slot);
}
const $a11e461c98b8a867$var$tooltipClasses = (0, $rARwS.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $a11e461c98b8a867$export$2e2bcd8739ae039 = $a11e461c98b8a867$var$tooltipClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $49843c171a30b5aa$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $49843c171a30b5aa$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $49843c171a30b5aa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $iLAKr.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $a11e461c98b8a867$export$837848f5f6cee923), classes);
};
const $49843c171a30b5aa$var$TooltipPopper = (0, $28RyA.default)((0, $b774b692670e0e71$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $erOpW.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).arrow}`]: (0, $erOpW.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).arrow}`]: (0, $erOpW.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $49843c171a30b5aa$var$TooltipTooltip = (0, $28RyA.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $iLAKr.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $hnF8Y.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$49843c171a30b5aa$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $erOpW.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $erOpW.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $erOpW.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $erOpW.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $erOpW.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $erOpW.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $erOpW.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $a11e461c98b8a867$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $erOpW.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $49843c171a30b5aa$var$TooltipArrow = (0, $28RyA.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $hnF8Y.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $49843c171a30b5aa$var$hystersisOpen = false;
const $49843c171a30b5aa$var$hystersisTimer = new (0, $43303828b5822c3b$export$786b4da70f00938b)();
let $49843c171a30b5aa$var$cursorPosition = {
    x: 0,
    y: 0
};
function $49843c171a30b5aa$export$b9ee5a7ace0541f8() {
    $49843c171a30b5aa$var$hystersisOpen = false;
    $49843c171a30b5aa$var$hystersisTimer.clear();
}
function $49843c171a30b5aa$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $49843c171a30b5aa$var$Tooltip = /*#__PURE__*/ $jSIPP.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $f0165b03f861203f$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $cMu4A.default)(props, $49843c171a30b5aa$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $jSIPP.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $jSIPP.useState();
    const [arrowRef, setArrowRef] = $jSIPP.useState(null);
    const ignoreNonTouchEvents = $jSIPP.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const enterTimer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const touchTimer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $7981abc7b5093fe8$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $b2e317da5452a23f$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $jSIPP.useRef();
    const stopTouchInteraction = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $jSIPP.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $49843c171a30b5aa$var$hystersisTimer.clear();
        $49843c171a30b5aa$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $49843c171a30b5aa$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $49843c171a30b5aa$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $49843c171a30b5aa$var$hystersisOpen && enterNextDelay) enterTimer.start($49843c171a30b5aa$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f01db555e582cbc1$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $jSIPP.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $jSIPP.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)((0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $jSIPP.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $49843c171a30b5aa$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $erOpW.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $86B3v.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $49843c171a30b5aa$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $49843c171a30b5aa$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $49843c171a30b5aa$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $49843c171a30b5aa$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $jSIPP.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $erOpW.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $49843c171a30b5aa$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $49843c171a30b5aa$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $f0165b03f861203f$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $49843c171a30b5aa$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $49843c171a30b5aa$var$TooltipArrow;
    const popperProps = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(PopperComponent, (0, $erOpW.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $86B3v.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(TransitionComponent, (0, $erOpW.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(TooltipComponent, (0, $erOpW.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $86B3v.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(ArrowComponent, (0, $erOpW.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $86B3v.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ $jSIPP.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $4uaIU.jsx)(PopperComponent, (0, $erOpW.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $b774b692670e0e71$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $49843c171a30b5aa$var$cursorPosition.y,
                            left: $49843c171a30b5aa$var$cursorPosition.x,
                            right: $49843c171a30b5aa$var$cursorPosition.x,
                            bottom: $49843c171a30b5aa$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $4uaIU.jsxs)(TooltipComponent, (0, $erOpW.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $4uaIU.jsx)(ArrowComponent, (0, $erOpW.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $49843c171a30b5aa$export$2e2bcd8739ae039 = $49843c171a30b5aa$var$Tooltip;



var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $b2cf82681d9ad200$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $0687164827b29e58$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z"
}), 'NotificationsNoneOutlined');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $24ba8a9e95709c58$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4"
}), 'PersonOutline');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $e1169d4212503850$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

const $bd1f60c2e68e18de$var$dropDownStyle = {
    mx: '1.5rem',
    my: '1.5rem',
    borderRadius: '30px',
    borderColor: 'primary',
    backgroundColor: 'white',
    height: '2.5rem',
    fontSize: '0.8rem'
};
const $bd1f60c2e68e18de$var$NavigationTopBarContent = ({ children: children, dropDownSx: dropDownSx })=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 4,
            display: 'flex',
            flexDirection: 'row'
        },
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
            sx: {
                flexGrow: 4,
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'right'
            },
            children: children
        })
    });
};
var $bd1f60c2e68e18de$export$2e2bcd8739ae039 = $bd1f60c2e68e18de$var$NavigationTopBarContent;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");
const $da8c0916be2f7f28$var$HelpMenu = ({})=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
};
var $da8c0916be2f7f28$export$2e2bcd8739ae039 = $da8c0916be2f7f28$var$HelpMenu;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");


var $faa4cbee9e7297c6$exports = {};
"use strict";
var $faa4cbee9e7297c6$var$__importDefault = $faa4cbee9e7297c6$exports && $faa4cbee9e7297c6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($faa4cbee9e7297c6$exports, "__esModule", {
    value: true
});
$faa4cbee9e7297c6$exports.SyncLoader = $faa4cbee9e7297c6$exports.SquareLoader = $faa4cbee9e7297c6$exports.SkewLoader = $faa4cbee9e7297c6$exports.ScaleLoader = $faa4cbee9e7297c6$exports.RotateLoader = $faa4cbee9e7297c6$exports.RiseLoader = $faa4cbee9e7297c6$exports.RingLoader = $faa4cbee9e7297c6$exports.PuffLoader = $faa4cbee9e7297c6$exports.PulseLoader = $faa4cbee9e7297c6$exports.PropagateLoader = $faa4cbee9e7297c6$exports.PacmanLoader = $faa4cbee9e7297c6$exports.MoonLoader = $faa4cbee9e7297c6$exports.HashLoader = $faa4cbee9e7297c6$exports.GridLoader = $faa4cbee9e7297c6$exports.FadeLoader = $faa4cbee9e7297c6$exports.DotLoader = $faa4cbee9e7297c6$exports.ClockLoader = $faa4cbee9e7297c6$exports.ClipLoader = $faa4cbee9e7297c6$exports.ClimbingBoxLoader = $faa4cbee9e7297c6$exports.CircleLoader = $faa4cbee9e7297c6$exports.BounceLoader = $faa4cbee9e7297c6$exports.BeatLoader = $faa4cbee9e7297c6$exports.BarLoader = void 0;
var $a1f2fcad7e29a48b$exports = {};
"use strict";
var $a1f2fcad7e29a48b$var$__makeTemplateObject = $a1f2fcad7e29a48b$exports && $a1f2fcad7e29a48b$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $a1f2fcad7e29a48b$var$__extends = $a1f2fcad7e29a48b$exports && $a1f2fcad7e29a48b$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a1f2fcad7e29a48b$var$__createBinding = $a1f2fcad7e29a48b$exports && $a1f2fcad7e29a48b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a1f2fcad7e29a48b$var$__setModuleDefault = $a1f2fcad7e29a48b$exports && $a1f2fcad7e29a48b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a1f2fcad7e29a48b$var$__importStar = $a1f2fcad7e29a48b$exports && $a1f2fcad7e29a48b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a1f2fcad7e29a48b$var$__createBinding(result, mod, k);
    }
    $a1f2fcad7e29a48b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a1f2fcad7e29a48b$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $a1f2fcad7e29a48b$var$React = $a1f2fcad7e29a48b$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");
var $40cd3856ba228dd7$exports = {};
"use strict";
var $40cd3856ba228dd7$var$__createBinding = $40cd3856ba228dd7$exports && $40cd3856ba228dd7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $40cd3856ba228dd7$var$__exportStar = $40cd3856ba228dd7$exports && $40cd3856ba228dd7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $40cd3856ba228dd7$var$__createBinding(exports1, m, p);
};
Object.defineProperty($40cd3856ba228dd7$exports, "__esModule", {
    value: true
});

$40cd3856ba228dd7$var$__exportStar((parcelRequire("eB22U")), $40cd3856ba228dd7$exports);

$40cd3856ba228dd7$var$__exportStar((parcelRequire("5Ulum")), $40cd3856ba228dd7$exports);

$40cd3856ba228dd7$var$__exportStar((parcelRequire("eQnTi")), $40cd3856ba228dd7$exports);


var $a1f2fcad7e29a48b$var$long = $lebkq.keyframes($a1f2fcad7e29a48b$var$templateObject_1 || ($a1f2fcad7e29a48b$var$templateObject_1 = $a1f2fcad7e29a48b$var$__makeTemplateObject([
    "\n  0% {left: -35%;right: 100%}\n  60% {left: 100%;right: -90%}\n  100% {left: 100%;right: -90%}\n"
], [
    "\n  0% {left: -35%;right: 100%}\n  60% {left: 100%;right: -90%}\n  100% {left: 100%;right: -90%}\n"
])));
var $a1f2fcad7e29a48b$var$short = $lebkq.keyframes($a1f2fcad7e29a48b$var$templateObject_2 || ($a1f2fcad7e29a48b$var$templateObject_2 = $a1f2fcad7e29a48b$var$__makeTemplateObject([
    "\n  0% {left: -200%;right: 100%}\n  60% {left: 107%;right: -8%}\n  100% {left: 107%;right: -8%}\n"
], [
    "\n  0% {left: -200%;right: 100%}\n  60% {left: 107%;right: -8%}\n  100% {left: 107%;right: -8%}\n"
])));
var $a1f2fcad7e29a48b$var$Loader = /** @class */ function(_super) {
    $a1f2fcad7e29a48b$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, height = _a.height, color = _a.color, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($a1f2fcad7e29a48b$var$templateObject_3 || ($a1f2fcad7e29a48b$var$templateObject_3 = $a1f2fcad7e29a48b$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n      display: block;\n      border-radius: 2px;\n      will-change: left, right;\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s\n        ",
                "\n        ",
                "\n        infinite;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n      display: block;\n      border-radius: 2px;\n      will-change: left, right;\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s\n        ",
                "\n        ",
                "\n        infinite;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(height), color, i === 1 ? $a1f2fcad7e29a48b$var$long : $a1f2fcad7e29a48b$var$short, 2.1 / speedMultiplier, i === 2 ? 1.15 / speedMultiplier + "s" : "", i === 1 ? "cubic-bezier(0.65, 0.815, 0.735, 0.395)" : "cubic-bezier(0.165, 0.84, 0.44, 1)");
        };
        _this.wrapper = function() {
            var _a = _this.props, width = _a.width, height = _a.height, color = _a.color;
            return $lebkq.css($a1f2fcad7e29a48b$var$templateObject_4 || ($a1f2fcad7e29a48b$var$templateObject_4 = $a1f2fcad7e29a48b$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      overflow: hidden;\n      background-color: ",
                ";\n      background-clip: padding-box;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(width), $40cd3856ba228dd7$exports.cssValue(height), $40cd3856ba228dd7$exports.calculateRgba(color, 0.2));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.heightWidthDefaults(4, 100);
    return Loader;
}($a1f2fcad7e29a48b$var$React.PureComponent);
$a1f2fcad7e29a48b$exports.default = $a1f2fcad7e29a48b$var$Loader;
var $a1f2fcad7e29a48b$var$templateObject_1, $a1f2fcad7e29a48b$var$templateObject_2, $a1f2fcad7e29a48b$var$templateObject_3, $a1f2fcad7e29a48b$var$templateObject_4;


Object.defineProperty($faa4cbee9e7297c6$exports, "BarLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($a1f2fcad7e29a48b$exports).default;
    }
});
var $07f315fa380080ea$exports = {};
"use strict";
var $07f315fa380080ea$var$__makeTemplateObject = $07f315fa380080ea$exports && $07f315fa380080ea$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $07f315fa380080ea$var$__extends = $07f315fa380080ea$exports && $07f315fa380080ea$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $07f315fa380080ea$var$__createBinding = $07f315fa380080ea$exports && $07f315fa380080ea$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $07f315fa380080ea$var$__setModuleDefault = $07f315fa380080ea$exports && $07f315fa380080ea$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $07f315fa380080ea$var$__importStar = $07f315fa380080ea$exports && $07f315fa380080ea$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $07f315fa380080ea$var$__createBinding(result, mod, k);
    }
    $07f315fa380080ea$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($07f315fa380080ea$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $07f315fa380080ea$var$React = $07f315fa380080ea$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $07f315fa380080ea$var$beat = $lebkq.keyframes($07f315fa380080ea$var$templateObject_1 || ($07f315fa380080ea$var$templateObject_1 = $07f315fa380080ea$var$__makeTemplateObject([
    "\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"
], [
    "\n  50% {transform: scale(0.75);opacity: 0.2}\n  100% {transform: scale(1);opacity: 1}\n"
])));
var $07f315fa380080ea$var$Loader = /** @class */ function(_super) {
    $07f315fa380080ea$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($07f315fa380080ea$var$templateObject_2 || ($07f315fa380080ea$var$templateObject_2 = $07f315fa380080ea$var$__makeTemplateObject([
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation: ",
                " ",
                "s ",
                "\n        infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation: ",
                " ",
                "s ",
                "\n        infinite linear;\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(margin), $07f315fa380080ea$var$beat, 0.7 / speedMultiplier, i % 2 ? "0s" : 0.35 / speedMultiplier + "s");
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(15);
    return Loader;
}($07f315fa380080ea$var$React.PureComponent);
$07f315fa380080ea$exports.default = $07f315fa380080ea$var$Loader;
var $07f315fa380080ea$var$templateObject_1, $07f315fa380080ea$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "BeatLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($07f315fa380080ea$exports).default;
    }
});
var $f996c6af08511023$exports = {};
"use strict";
var $f996c6af08511023$var$__makeTemplateObject = $f996c6af08511023$exports && $f996c6af08511023$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $f996c6af08511023$var$__extends = $f996c6af08511023$exports && $f996c6af08511023$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f996c6af08511023$var$__createBinding = $f996c6af08511023$exports && $f996c6af08511023$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f996c6af08511023$var$__setModuleDefault = $f996c6af08511023$exports && $f996c6af08511023$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f996c6af08511023$var$__importStar = $f996c6af08511023$exports && $f996c6af08511023$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f996c6af08511023$var$__createBinding(result, mod, k);
    }
    $f996c6af08511023$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f996c6af08511023$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $f996c6af08511023$var$React = $f996c6af08511023$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $f996c6af08511023$var$bounce = $lebkq.keyframes($f996c6af08511023$var$templateObject_1 || ($f996c6af08511023$var$templateObject_1 = $f996c6af08511023$var$__makeTemplateObject([
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
], [
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
])));
var $f996c6af08511023$var$Loader = /** @class */ function(_super) {
    $f996c6af08511023$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($f996c6af08511023$var$templateObject_2 || ($f996c6af08511023$var$templateObject_2 = $f996c6af08511023$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      opacity: 0.6;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s ",
                "\n        infinite ease-in-out;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      opacity: 0.6;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s ",
                "\n        infinite ease-in-out;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), color, $f996c6af08511023$var$bounce, 2.1 / speedMultiplier, i === 1 ? 1 / speedMultiplier + "s" : "0s");
        };
        _this.wrapper = function() {
            var size = _this.props.size;
            return $lebkq.css($f996c6af08511023$var$templateObject_3 || ($f996c6af08511023$var$templateObject_3 = $f996c6af08511023$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(60);
    return Loader;
}($f996c6af08511023$var$React.PureComponent);
$f996c6af08511023$exports.default = $f996c6af08511023$var$Loader;
var $f996c6af08511023$var$templateObject_1, $f996c6af08511023$var$templateObject_2, $f996c6af08511023$var$templateObject_3;


Object.defineProperty($faa4cbee9e7297c6$exports, "BounceLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($f996c6af08511023$exports).default;
    }
});
var $c13c22b6c30923df$exports = {};
"use strict";
var $c13c22b6c30923df$var$__makeTemplateObject = $c13c22b6c30923df$exports && $c13c22b6c30923df$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $c13c22b6c30923df$var$__extends = $c13c22b6c30923df$exports && $c13c22b6c30923df$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c13c22b6c30923df$var$__createBinding = $c13c22b6c30923df$exports && $c13c22b6c30923df$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c13c22b6c30923df$var$__setModuleDefault = $c13c22b6c30923df$exports && $c13c22b6c30923df$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c13c22b6c30923df$var$__importStar = $c13c22b6c30923df$exports && $c13c22b6c30923df$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c13c22b6c30923df$var$__createBinding(result, mod, k);
    }
    $c13c22b6c30923df$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c13c22b6c30923df$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $c13c22b6c30923df$var$React = $c13c22b6c30923df$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $c13c22b6c30923df$var$circle = $lebkq.keyframes($c13c22b6c30923df$var$templateObject_1 || ($c13c22b6c30923df$var$templateObject_1 = $c13c22b6c30923df$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
])));
var $c13c22b6c30923df$var$Loader = /** @class */ function(_super) {
    $c13c22b6c30923df$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, color = _a.color, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($c13c22b6c30923df$var$templateObject_2 || ($c13c22b6c30923df$var$templateObject_2 = $c13c22b6c30923df$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: 1px solid ",
                ";\n      border-radius: 100%;\n      transition: 2s;\n      border-bottom: none;\n      border-right: none;\n      top: ",
                "%;\n      left: ",
                "%;\n      animation-fill-mode: \"\";\n      animation: ",
                " ",
                "s ",
                "s infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: 1px solid ",
                ";\n      border-radius: 100%;\n      transition: 2s;\n      border-bottom: none;\n      border-right: none;\n      top: ",
                "%;\n      left: ",
                "%;\n      animation-fill-mode: \"\";\n      animation: ",
                " ",
                "s ",
                "s infinite linear;\n    "
            ])), "" + value * (1 - i / 10) + unit, "" + value * (1 - i / 10) + unit, color, i * 1.75, i * 0.875, $c13c22b6c30923df$var$circle, 1 / speedMultiplier, i * 0.2 / speedMultiplier);
        };
        _this.wrapper = function() {
            var size = _this.props.size;
            return $lebkq.css($c13c22b6c30923df$var$templateObject_3 || ($c13c22b6c30923df$var$templateObject_3 = $c13c22b6c30923df$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(0)
        }), $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        }), $lebkq.jsx("span", {
            css: this.style(4)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(50);
    return Loader;
}($c13c22b6c30923df$var$React.PureComponent);
$c13c22b6c30923df$exports.default = $c13c22b6c30923df$var$Loader;
var $c13c22b6c30923df$var$templateObject_1, $c13c22b6c30923df$var$templateObject_2, $c13c22b6c30923df$var$templateObject_3;


Object.defineProperty($faa4cbee9e7297c6$exports, "CircleLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($c13c22b6c30923df$exports).default;
    }
});
var $58f0139fd44bd52c$exports = {};
"use strict";
var $58f0139fd44bd52c$var$__makeTemplateObject = $58f0139fd44bd52c$exports && $58f0139fd44bd52c$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $58f0139fd44bd52c$var$__extends = $58f0139fd44bd52c$exports && $58f0139fd44bd52c$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $58f0139fd44bd52c$var$__createBinding = $58f0139fd44bd52c$exports && $58f0139fd44bd52c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $58f0139fd44bd52c$var$__setModuleDefault = $58f0139fd44bd52c$exports && $58f0139fd44bd52c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $58f0139fd44bd52c$var$__importStar = $58f0139fd44bd52c$exports && $58f0139fd44bd52c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $58f0139fd44bd52c$var$__createBinding(result, mod, k);
    }
    $58f0139fd44bd52c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($58f0139fd44bd52c$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $58f0139fd44bd52c$var$React = $58f0139fd44bd52c$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $58f0139fd44bd52c$var$climbingBox = $lebkq.keyframes($58f0139fd44bd52c$var$templateObject_1 || ($58f0139fd44bd52c$var$templateObject_1 = $58f0139fd44bd52c$var$__makeTemplateObject([
    "\n  0% {transform:translate(0, -1em) rotate(-45deg)}\n  5% {transform:translate(0, -1em) rotate(-50deg)}\n  20% {transform:translate(1em, -2em) rotate(47deg)}\n  25% {transform:translate(1em, -2em) rotate(45deg)}\n  30% {transform:translate(1em, -2em) rotate(40deg)}\n  45% {transform:translate(2em, -3em) rotate(137deg)}\n  50% {transform:translate(2em, -3em) rotate(135deg)}\n  55% {transform:translate(2em, -3em) rotate(130deg)}\n  70% {transform:translate(3em, -4em) rotate(217deg)}\n  75% {transform:translate(3em, -4em) rotate(220deg)}\n  100% {transform:translate(0, -1em) rotate(-225deg)}\n"
], [
    "\n  0% {transform:translate(0, -1em) rotate(-45deg)}\n  5% {transform:translate(0, -1em) rotate(-50deg)}\n  20% {transform:translate(1em, -2em) rotate(47deg)}\n  25% {transform:translate(1em, -2em) rotate(45deg)}\n  30% {transform:translate(1em, -2em) rotate(40deg)}\n  45% {transform:translate(2em, -3em) rotate(137deg)}\n  50% {transform:translate(2em, -3em) rotate(135deg)}\n  55% {transform:translate(2em, -3em) rotate(130deg)}\n  70% {transform:translate(3em, -4em) rotate(217deg)}\n  75% {transform:translate(3em, -4em) rotate(220deg)}\n  100% {transform:translate(0, -1em) rotate(-225deg)}\n"
])));
var $58f0139fd44bd52c$var$Loader = /** @class */ function(_super) {
    $58f0139fd44bd52c$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, color = _a.color, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($58f0139fd44bd52c$var$templateObject_2 || ($58f0139fd44bd52c$var$templateObject_2 = $58f0139fd44bd52c$var$__makeTemplateObject([
                "\n      position: absolute;\n      left: 0;\n      bottom: -0.1em;\n      height: 1em;\n      width: 1em;\n      background-color: transparent;\n      border-radius: 15%;\n      border: 0.25em solid ",
                ";\n      transform: translate(0, -1em) rotate(-45deg);\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s infinite cubic-bezier(0.79, 0, 0.47, 0.97);\n    "
            ], [
                "\n      position: absolute;\n      left: 0;\n      bottom: -0.1em;\n      height: 1em;\n      width: 1em;\n      background-color: transparent;\n      border-radius: 15%;\n      border: 0.25em solid ",
                ";\n      transform: translate(0, -1em) rotate(-45deg);\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s infinite cubic-bezier(0.79, 0, 0.47, 0.97);\n    "
            ])), color, $58f0139fd44bd52c$var$climbingBox, 2.5 / speedMultiplier);
        };
        _this.wrapper = function() {
            var size = _this.props.size;
            return $lebkq.css($58f0139fd44bd52c$var$templateObject_3 || ($58f0139fd44bd52c$var$templateObject_3 = $58f0139fd44bd52c$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -2.7em;\n      margin-left: -2.7em;\n      width: 5.4em;\n      height: 5.4em;\n      font-size: ",
                ";\n    "
            ], [
                "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -2.7em;\n      margin-left: -2.7em;\n      width: 5.4em;\n      height: 5.4em;\n      font-size: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size));
        };
        _this.hill = function() {
            var color = _this.props.color;
            return $lebkq.css($58f0139fd44bd52c$var$templateObject_4 || ($58f0139fd44bd52c$var$templateObject_4 = $58f0139fd44bd52c$var$__makeTemplateObject([
                "\n      position: absolute;\n      width: 7.1em;\n      height: 7.1em;\n      top: 1.7em;\n      left: 1.7em;\n      border-left: 0.25em solid ",
                ";\n      transform: rotate(45deg);\n    "
            ], [
                "\n      position: absolute;\n      width: 7.1em;\n      height: 7.1em;\n      top: 1.7em;\n      left: 1.7em;\n      border-left: 0.25em solid ",
                ";\n      transform: rotate(45deg);\n    "
            ])), color);
        };
        _this.container = function() {
            return $lebkq.css($58f0139fd44bd52c$var$templateObject_5 || ($58f0139fd44bd52c$var$templateObject_5 = $58f0139fd44bd52c$var$__makeTemplateObject([
                "\n      position: relative;\n      width: 7.1em;\n      height: 7.1em;\n    "
            ], [
                "\n      position: relative;\n      width: 7.1em;\n      height: 7.1em;\n    "
            ])));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.container(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.wrapper()
        }, $lebkq.jsx("span", {
            css: this.style()
        }), $lebkq.jsx("span", {
            css: this.hill()
        }))) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(15);
    return Loader;
}($58f0139fd44bd52c$var$React.PureComponent);
$58f0139fd44bd52c$exports.default = $58f0139fd44bd52c$var$Loader;
var $58f0139fd44bd52c$var$templateObject_1, $58f0139fd44bd52c$var$templateObject_2, $58f0139fd44bd52c$var$templateObject_3, $58f0139fd44bd52c$var$templateObject_4, $58f0139fd44bd52c$var$templateObject_5;


Object.defineProperty($faa4cbee9e7297c6$exports, "ClimbingBoxLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($58f0139fd44bd52c$exports).default;
    }
});
var $05f3ba8a4daf0360$exports = {};
"use strict";
var $05f3ba8a4daf0360$var$__makeTemplateObject = $05f3ba8a4daf0360$exports && $05f3ba8a4daf0360$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $05f3ba8a4daf0360$var$__extends = $05f3ba8a4daf0360$exports && $05f3ba8a4daf0360$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $05f3ba8a4daf0360$var$__createBinding = $05f3ba8a4daf0360$exports && $05f3ba8a4daf0360$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $05f3ba8a4daf0360$var$__setModuleDefault = $05f3ba8a4daf0360$exports && $05f3ba8a4daf0360$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $05f3ba8a4daf0360$var$__importStar = $05f3ba8a4daf0360$exports && $05f3ba8a4daf0360$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $05f3ba8a4daf0360$var$__createBinding(result, mod, k);
    }
    $05f3ba8a4daf0360$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($05f3ba8a4daf0360$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $05f3ba8a4daf0360$var$React = $05f3ba8a4daf0360$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $05f3ba8a4daf0360$var$clip = $lebkq.keyframes($05f3ba8a4daf0360$var$templateObject_1 || ($05f3ba8a4daf0360$var$templateObject_1 = $05f3ba8a4daf0360$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg) scale(1)}\n  50% {transform: rotate(180deg) scale(0.8)}\n  100% {transform: rotate(360deg) scale(1)}\n"
], [
    "\n  0% {transform: rotate(0deg) scale(1)}\n  50% {transform: rotate(180deg) scale(0.8)}\n  100% {transform: rotate(360deg) scale(1)}\n"
])));
var $05f3ba8a4daf0360$var$Loader = /** @class */ function(_super) {
    $05f3ba8a4daf0360$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, size = _a.size, color = _a.color, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($05f3ba8a4daf0360$var$templateObject_2 || ($05f3ba8a4daf0360$var$templateObject_2 = $05f3ba8a4daf0360$var$__makeTemplateObject([
                "\n      background: transparent !important;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n      border: 2px solid;\n      border-color: ",
                ";\n      border-bottom-color: transparent;\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background: transparent !important;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n      border: 2px solid;\n      border-color: ",
                ";\n      border-bottom-color: transparent;\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: both;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), color, $05f3ba8a4daf0360$var$clip, 0.75 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(35);
    return Loader;
}($05f3ba8a4daf0360$var$React.PureComponent);
$05f3ba8a4daf0360$exports.default = $05f3ba8a4daf0360$var$Loader;
var $05f3ba8a4daf0360$var$templateObject_1, $05f3ba8a4daf0360$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "ClipLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($05f3ba8a4daf0360$exports).default;
    }
});
var $b3cab79fe303f7da$exports = {};
"use strict";
var $b3cab79fe303f7da$var$__makeTemplateObject = $b3cab79fe303f7da$exports && $b3cab79fe303f7da$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $b3cab79fe303f7da$var$__extends = $b3cab79fe303f7da$exports && $b3cab79fe303f7da$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b3cab79fe303f7da$var$__createBinding = $b3cab79fe303f7da$exports && $b3cab79fe303f7da$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3cab79fe303f7da$var$__setModuleDefault = $b3cab79fe303f7da$exports && $b3cab79fe303f7da$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b3cab79fe303f7da$var$__importStar = $b3cab79fe303f7da$exports && $b3cab79fe303f7da$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b3cab79fe303f7da$var$__createBinding(result, mod, k);
    }
    $b3cab79fe303f7da$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b3cab79fe303f7da$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $b3cab79fe303f7da$var$React = $b3cab79fe303f7da$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $b3cab79fe303f7da$var$rotate = $lebkq.keyframes($b3cab79fe303f7da$var$templateObject_1 || ($b3cab79fe303f7da$var$templateObject_1 = $b3cab79fe303f7da$var$__makeTemplateObject([
    "\n  100% { transform: rotate(360deg) }\n"
], [
    "\n  100% { transform: rotate(360deg) }\n"
])));
var $b3cab79fe303f7da$var$Loader = /** @class */ function(_super) {
    $b3cab79fe303f7da$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, color = _a.color, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($b3cab79fe303f7da$var$templateObject_2 || ($b3cab79fe303f7da$var$templateObject_2 = $b3cab79fe303f7da$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      background-color: transparent;\n      box-shadow: inset 0px 0px 0px 2px ",
                ";\n      border-radius: 50%;\n\n      &:after,\n      &:before {\n        position: absolute;\n        content: \"\";\n        background-color: ",
                ";\n      }\n\n      &:after {\n        width: ",
                "px;\n        height: 2px;\n        top: ",
                "px;\n        left: ",
                "px;\n        transform-origin: 1px 1px;\n        animation: ",
                " ",
                "s linear infinite;\n      }\n\n      &:before {\n        width: ",
                "px;\n        height: 2px;\n        top: ",
                "px;\n        left: ",
                "px;\n        transform-origin: 1px 1px;\n        animation: ",
                " ",
                "s linear infinite;\n      }\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      background-color: transparent;\n      box-shadow: inset 0px 0px 0px 2px ",
                ";\n      border-radius: 50%;\n\n      &:after,\n      &:before {\n        position: absolute;\n        content: \"\";\n        background-color: ",
                ";\n      }\n\n      &:after {\n        width: ",
                "px;\n        height: 2px;\n        top: ",
                "px;\n        left: ",
                "px;\n        transform-origin: 1px 1px;\n        animation: ",
                " ",
                "s linear infinite;\n      }\n\n      &:before {\n        width: ",
                "px;\n        height: 2px;\n        top: ",
                "px;\n        left: ",
                "px;\n        transform-origin: 1px 1px;\n        animation: ",
                " ",
                "s linear infinite;\n      }\n    "
            ])), "" + value + unit, "" + value + unit, color, color, value / 2.4, value / 2 - 1, value / 2 - 1, $b3cab79fe303f7da$var$rotate, 2 / speedMultiplier, value / 3, value / 2 - 1, value / 2 - 1, $b3cab79fe303f7da$var$rotate, 8 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(50);
    return Loader;
}($b3cab79fe303f7da$var$React.PureComponent);
$b3cab79fe303f7da$exports.default = $b3cab79fe303f7da$var$Loader;
var $b3cab79fe303f7da$var$templateObject_1, $b3cab79fe303f7da$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "ClockLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($b3cab79fe303f7da$exports).default;
    }
});
var $2df6db764c03b26c$exports = {};
"use strict";
var $2df6db764c03b26c$var$__makeTemplateObject = $2df6db764c03b26c$exports && $2df6db764c03b26c$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $2df6db764c03b26c$var$__extends = $2df6db764c03b26c$exports && $2df6db764c03b26c$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2df6db764c03b26c$var$__createBinding = $2df6db764c03b26c$exports && $2df6db764c03b26c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2df6db764c03b26c$var$__setModuleDefault = $2df6db764c03b26c$exports && $2df6db764c03b26c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2df6db764c03b26c$var$__importStar = $2df6db764c03b26c$exports && $2df6db764c03b26c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2df6db764c03b26c$var$__createBinding(result, mod, k);
    }
    $2df6db764c03b26c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2df6db764c03b26c$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $2df6db764c03b26c$var$React = $2df6db764c03b26c$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $2df6db764c03b26c$var$rotate = $lebkq.keyframes($2df6db764c03b26c$var$templateObject_1 || ($2df6db764c03b26c$var$templateObject_1 = $2df6db764c03b26c$var$__makeTemplateObject([
    "\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  100% {transform: rotate(360deg)}\n"
])));
var $2df6db764c03b26c$var$bounce = $lebkq.keyframes($2df6db764c03b26c$var$templateObject_2 || ($2df6db764c03b26c$var$templateObject_2 = $2df6db764c03b26c$var$__makeTemplateObject([
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
], [
    "\n  0%, 100% {transform: scale(0)}\n  50% {transform: scale(1.0)}\n"
])));
var $2df6db764c03b26c$var$Loader = /** @class */ function(_super) {
    $2df6db764c03b26c$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, color = _a.color, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($2df6db764c03b26c$var$templateObject_3 || ($2df6db764c03b26c$var$templateObject_3 = $2df6db764c03b26c$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: ",
                ";\n      bottom: ",
                ";\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s ",
                " infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      top: ",
                ";\n      bottom: ",
                ";\n      height: ",
                ";\n      width: ",
                ";\n      background-color: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s ",
                " infinite linear;\n    "
            ])), i % 2 ? "0" : "auto", i % 2 ? "auto" : "0", "" + value / 2 + unit, "" + value / 2 + unit, color, $2df6db764c03b26c$var$bounce, 2 / speedMultiplier, i === 2 ? "-1s" : "0s");
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($2df6db764c03b26c$var$templateObject_4 || ($2df6db764c03b26c$var$templateObject_4 = $2df6db764c03b26c$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s 0s infinite linear;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation-fill-mode: forwards;\n      animation: ",
                " ",
                "s 0s infinite linear;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $2df6db764c03b26c$var$rotate, 2 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(60);
    return Loader;
}($2df6db764c03b26c$var$React.PureComponent);
$2df6db764c03b26c$exports.default = $2df6db764c03b26c$var$Loader;
var $2df6db764c03b26c$var$templateObject_1, $2df6db764c03b26c$var$templateObject_2, $2df6db764c03b26c$var$templateObject_3, $2df6db764c03b26c$var$templateObject_4;


Object.defineProperty($faa4cbee9e7297c6$exports, "DotLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($2df6db764c03b26c$exports).default;
    }
});
var $6a8b6ab150875ca0$exports = {};
"use strict";
var $6a8b6ab150875ca0$var$__makeTemplateObject = $6a8b6ab150875ca0$exports && $6a8b6ab150875ca0$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $6a8b6ab150875ca0$var$__extends = $6a8b6ab150875ca0$exports && $6a8b6ab150875ca0$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a8b6ab150875ca0$var$__createBinding = $6a8b6ab150875ca0$exports && $6a8b6ab150875ca0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6a8b6ab150875ca0$var$__setModuleDefault = $6a8b6ab150875ca0$exports && $6a8b6ab150875ca0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6a8b6ab150875ca0$var$__importStar = $6a8b6ab150875ca0$exports && $6a8b6ab150875ca0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6a8b6ab150875ca0$var$__createBinding(result, mod, k);
    }
    $6a8b6ab150875ca0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($6a8b6ab150875ca0$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $6a8b6ab150875ca0$var$React = $6a8b6ab150875ca0$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $6a8b6ab150875ca0$var$fade = $lebkq.keyframes($6a8b6ab150875ca0$var$templateObject_1 || ($6a8b6ab150875ca0$var$templateObject_1 = $6a8b6ab150875ca0$var$__makeTemplateObject([
    "\n  50% {opacity: 0.3}\n  100% {opacity: 1}\n"
], [
    "\n  50% {opacity: 0.3}\n  100% {opacity: 1}\n"
])));
var $6a8b6ab150875ca0$var$Loader = /** @class */ function(_super) {
    $6a8b6ab150875ca0$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radius = function() {
            var margin = _this.props.margin;
            var value = $40cd3856ba228dd7$exports.parseLengthAndUnit(margin).value;
            return value + 18;
        };
        _this.quarter = function() {
            return _this.radius() / 2 + _this.radius() / 5.5;
        };
        _this.style = function(i) {
            var _a = _this.props, height = _a.height, width = _a.width, margin = _a.margin, color = _a.color, radius = _a.radius, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_2 || ($6a8b6ab150875ca0$var$templateObject_2 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n      position: absolute;\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      background-color: ",
                ";\n      border-radius: ",
                ";\n      transition: 2s;\n      animation-fill-mode: \"both\";\n      animation: ",
                " ",
                "s ",
                "s infinite ease-in-out;\n    "
            ], [
                "\n      position: absolute;\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      background-color: ",
                ";\n      border-radius: ",
                ";\n      transition: 2s;\n      animation-fill-mode: \"both\";\n      animation: ",
                " ",
                "s ",
                "s infinite ease-in-out;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(width), $40cd3856ba228dd7$exports.cssValue(height), $40cd3856ba228dd7$exports.cssValue(margin), color, $40cd3856ba228dd7$exports.cssValue(radius), $6a8b6ab150875ca0$var$fade, 1.2 / speedMultiplier, i * 0.12);
        };
        _this.wrapper = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_3 || ($6a8b6ab150875ca0$var$templateObject_3 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n      position: relative;\n      font-size: 0;\n      top: ",
                "px;\n      left: ",
                "px;\n      width: ",
                "px;\n      height: ",
                "px;\n    "
            ], [
                "\n      position: relative;\n      font-size: 0;\n      top: ",
                "px;\n      left: ",
                "px;\n      width: ",
                "px;\n      height: ",
                "px;\n    "
            ])), _this.radius(), _this.radius(), _this.radius() * 3, _this.radius() * 3);
        };
        _this.a = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_4 || ($6a8b6ab150875ca0$var$templateObject_4 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ])), _this.style(1), _this.radius());
        };
        _this.b = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_5 || ($6a8b6ab150875ca0$var$templateObject_5 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ])), _this.style(2), _this.quarter(), _this.quarter());
        };
        _this.c = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_6 || ($6a8b6ab150875ca0$var$templateObject_6 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ], [
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ])), _this.style(3), _this.radius());
        };
        _this.d = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_7 || ($6a8b6ab150875ca0$var$templateObject_7 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ])), _this.style(4), -_this.quarter(), _this.quarter());
        };
        _this.e = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_8 || ($6a8b6ab150875ca0$var$templateObject_8 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: 0;\n  "
            ])), _this.style(5), -_this.radius());
        };
        _this.f = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_9 || ($6a8b6ab150875ca0$var$templateObject_9 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(-45deg);\n  "
            ])), _this.style(6), -_this.quarter(), -_this.quarter());
        };
        _this.g = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_10 || ($6a8b6ab150875ca0$var$templateObject_10 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ], [
                "\n    ",
                ";\n    top: 0;\n    left: ",
                "px;\n    transform: rotate(90deg);\n  "
            ])), _this.style(7), -_this.radius());
        };
        _this.h = function() {
            return $lebkq.css($6a8b6ab150875ca0$var$templateObject_11 || ($6a8b6ab150875ca0$var$templateObject_11 = $6a8b6ab150875ca0$var$__makeTemplateObject([
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ], [
                "\n    ",
                ";\n    top: ",
                "px;\n    left: ",
                "px;\n    transform: rotate(45deg);\n  "
            ])), _this.style(8), _this.quarter(), -_this.quarter());
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.a()
        }), $lebkq.jsx("span", {
            css: this.b()
        }), $lebkq.jsx("span", {
            css: this.c()
        }), $lebkq.jsx("span", {
            css: this.d()
        }), $lebkq.jsx("span", {
            css: this.e()
        }), $lebkq.jsx("span", {
            css: this.f()
        }), $lebkq.jsx("span", {
            css: this.g()
        }), $lebkq.jsx("span", {
            css: this.h()
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.heightWidthRadiusDefaults(15, 5, 2);
    return Loader;
}($6a8b6ab150875ca0$var$React.PureComponent);
$6a8b6ab150875ca0$exports.default = $6a8b6ab150875ca0$var$Loader;
var $6a8b6ab150875ca0$var$templateObject_1, $6a8b6ab150875ca0$var$templateObject_2, $6a8b6ab150875ca0$var$templateObject_3, $6a8b6ab150875ca0$var$templateObject_4, $6a8b6ab150875ca0$var$templateObject_5, $6a8b6ab150875ca0$var$templateObject_6, $6a8b6ab150875ca0$var$templateObject_7, $6a8b6ab150875ca0$var$templateObject_8, $6a8b6ab150875ca0$var$templateObject_9, $6a8b6ab150875ca0$var$templateObject_10, $6a8b6ab150875ca0$var$templateObject_11;


Object.defineProperty($faa4cbee9e7297c6$exports, "FadeLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($6a8b6ab150875ca0$exports).default;
    }
});
var $b597c85fb3bbb1b2$exports = {};
"use strict";
var $b597c85fb3bbb1b2$var$__makeTemplateObject = $b597c85fb3bbb1b2$exports && $b597c85fb3bbb1b2$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $b597c85fb3bbb1b2$var$__extends = $b597c85fb3bbb1b2$exports && $b597c85fb3bbb1b2$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b597c85fb3bbb1b2$var$__createBinding = $b597c85fb3bbb1b2$exports && $b597c85fb3bbb1b2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b597c85fb3bbb1b2$var$__setModuleDefault = $b597c85fb3bbb1b2$exports && $b597c85fb3bbb1b2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b597c85fb3bbb1b2$var$__importStar = $b597c85fb3bbb1b2$exports && $b597c85fb3bbb1b2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b597c85fb3bbb1b2$var$__createBinding(result, mod, k);
    }
    $b597c85fb3bbb1b2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b597c85fb3bbb1b2$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $b597c85fb3bbb1b2$var$React = $b597c85fb3bbb1b2$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $b597c85fb3bbb1b2$var$grid = $lebkq.keyframes($b597c85fb3bbb1b2$var$templateObject_1 || ($b597c85fb3bbb1b2$var$templateObject_1 = $b597c85fb3bbb1b2$var$__makeTemplateObject([
    "\n  0% {transform: scale(1)}\n  50% {transform: scale(0.5); opacity: 0.7}\n  100% {transform: scale(1);opacity: 1}\n"
], [
    "\n  0% {transform: scale(1)}\n  50% {transform: scale(0.5); opacity: 0.7}\n  100% {transform: scale(1);opacity: 1}\n"
])));
var $b597c85fb3bbb1b2$var$random = function(top) {
    return Math.random() * top;
};
var $b597c85fb3bbb1b2$var$Loader = /** @class */ function(_super) {
    $b597c85fb3bbb1b2$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(rand) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($b597c85fb3bbb1b2$var$templateObject_2 || ($b597c85fb3bbb1b2$var$templateObject_2 = $b597c85fb3bbb1b2$var$__makeTemplateObject([
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: \"both\";\n      animation: ",
                " ",
                "s ",
                "s infinite ease;\n    "
            ], [
                "\n      display: inline-block;\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      animation-fill-mode: \"both\";\n      animation: ",
                " ",
                "s ",
                "s infinite ease;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(margin), $b597c85fb3bbb1b2$var$grid, (rand / 100 + 0.6) / speedMultiplier, rand / 100 - 0.2);
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, margin = _a.margin;
            var sizeWithUnit = $40cd3856ba228dd7$exports.parseLengthAndUnit(size);
            var marginWithUnit = $40cd3856ba228dd7$exports.parseLengthAndUnit(margin);
            var width = "" + (parseFloat(sizeWithUnit.value.toString()) * 3 + parseFloat(marginWithUnit.value.toString()) * 6) + sizeWithUnit.unit;
            return $lebkq.css($b597c85fb3bbb1b2$var$templateObject_3 || ($b597c85fb3bbb1b2$var$templateObject_3 = $b597c85fb3bbb1b2$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      font-size: 0;\n    "
            ], [
                "\n      width: ",
                ";\n      font-size: 0;\n    "
            ])), width);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        }), $lebkq.jsx("span", {
            css: this.style($b597c85fb3bbb1b2$var$random(100))
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(15);
    return Loader;
}($b597c85fb3bbb1b2$var$React.PureComponent);
$b597c85fb3bbb1b2$exports.default = $b597c85fb3bbb1b2$var$Loader;
var $b597c85fb3bbb1b2$var$templateObject_1, $b597c85fb3bbb1b2$var$templateObject_2, $b597c85fb3bbb1b2$var$templateObject_3;


Object.defineProperty($faa4cbee9e7297c6$exports, "GridLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($b597c85fb3bbb1b2$exports).default;
    }
});
var $4593e291fa5e1496$exports = {};
"use strict";
var $4593e291fa5e1496$var$__extends = $4593e291fa5e1496$exports && $4593e291fa5e1496$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4593e291fa5e1496$var$__makeTemplateObject = $4593e291fa5e1496$exports && $4593e291fa5e1496$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $4593e291fa5e1496$var$__createBinding = $4593e291fa5e1496$exports && $4593e291fa5e1496$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4593e291fa5e1496$var$__setModuleDefault = $4593e291fa5e1496$exports && $4593e291fa5e1496$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4593e291fa5e1496$var$__importStar = $4593e291fa5e1496$exports && $4593e291fa5e1496$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4593e291fa5e1496$var$__createBinding(result, mod, k);
    }
    $4593e291fa5e1496$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4593e291fa5e1496$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $4593e291fa5e1496$var$React = $4593e291fa5e1496$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $4593e291fa5e1496$var$Loader = /** @class */ function(_super) {
    $4593e291fa5e1496$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thickness = function() {
            var size = _this.props.size;
            var value = $40cd3856ba228dd7$exports.parseLengthAndUnit(size).value;
            return value / 5;
        };
        _this.lat = function() {
            var size = _this.props.size;
            var value = $40cd3856ba228dd7$exports.parseLengthAndUnit(size).value;
            return (value - _this.thickness()) / 2;
        };
        _this.offset = function() {
            return _this.lat() - _this.thickness();
        };
        _this.color = function() {
            var color = _this.props.color;
            return $40cd3856ba228dd7$exports.calculateRgba(color, 0.75);
        };
        _this.before = function() {
            var size = _this.props.size;
            var color = _this.color();
            var lat = _this.lat();
            var thickness = _this.thickness();
            var offset = _this.offset();
            return $lebkq.keyframes($4593e291fa5e1496$var$templateObject_1 || ($4593e291fa5e1496$var$templateObject_1 = $4593e291fa5e1496$var$__makeTemplateObject([
                "\n      0% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {width: ",
                ";box-shadow: 0 ",
                "px ",
                ", 0 ",
                "px ",
                "}\n      70% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ], [
                "\n      0% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {width: ",
                ";box-shadow: 0 ",
                "px ",
                ", 0 ",
                "px ",
                "}\n      70% {width: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ])), thickness, lat, -offset, color, -lat, offset, color, $40cd3856ba228dd7$exports.cssValue(size), -offset, color, offset, color, thickness, -lat, -offset, color, lat, offset, color, lat, -offset, color, -lat, offset, color);
        };
        _this.after = function() {
            var size = _this.props.size;
            var color = _this.color();
            var lat = _this.lat();
            var thickness = _this.thickness();
            var offset = _this.offset();
            return $lebkq.keyframes($4593e291fa5e1496$var$templateObject_2 || ($4593e291fa5e1496$var$templateObject_2 = $4593e291fa5e1496$var$__makeTemplateObject([
                "\n      0% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {height: ",
                ";box-shadow: ",
                "px 0 ",
                ", ",
                "px 0 ",
                "}\n      70% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ], [
                "\n      0% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      35% {height: ",
                ";box-shadow: ",
                "px 0 ",
                ", ",
                "px 0 ",
                "}\n      70% {height: ",
                "px;box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n      100% {box-shadow: ",
                "px ",
                "px ",
                ", ",
                "px ",
                "px ",
                "}\n    "
            ])), thickness, offset, lat, color, -offset, -lat, color, $40cd3856ba228dd7$exports.cssValue(size), offset, color, -offset, color, thickness, offset, -lat, color, -offset, lat, color, offset, lat, color, -offset, -lat, color);
        };
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($4593e291fa5e1496$var$templateObject_3 || ($4593e291fa5e1496$var$templateObject_3 = $4593e291fa5e1496$var$__makeTemplateObject([
                "\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: ",
                ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ",
                " ",
                "s infinite;\n    "
            ], [
                "\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      display: block;\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: ",
                ";\n      transform: translate(-50%, -50%);\n      animation-fill-mode: none;\n      animation: ",
                " ",
                "s infinite;\n    "
            ])), "" + value / 5 + unit, "" + value / 5 + unit, "" + value / 10 + unit, i === 1 ? _this.before() : _this.after(), 2 / speedMultiplier);
        };
        _this.wrapper = function() {
            var size = _this.props.size;
            return $lebkq.css($4593e291fa5e1496$var$templateObject_4 || ($4593e291fa5e1496$var$templateObject_4 = $4593e291fa5e1496$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      transform: rotate(165deg);\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      transform: rotate(165deg);\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(50);
    return Loader;
}($4593e291fa5e1496$var$React.PureComponent);
$4593e291fa5e1496$exports.default = $4593e291fa5e1496$var$Loader;
var $4593e291fa5e1496$var$templateObject_1, $4593e291fa5e1496$var$templateObject_2, $4593e291fa5e1496$var$templateObject_3, $4593e291fa5e1496$var$templateObject_4;


Object.defineProperty($faa4cbee9e7297c6$exports, "HashLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($4593e291fa5e1496$exports).default;
    }
});
var $5f6401247548b219$exports = {};
"use strict";
var $5f6401247548b219$var$__makeTemplateObject = $5f6401247548b219$exports && $5f6401247548b219$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $5f6401247548b219$var$__extends = $5f6401247548b219$exports && $5f6401247548b219$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5f6401247548b219$var$__createBinding = $5f6401247548b219$exports && $5f6401247548b219$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5f6401247548b219$var$__setModuleDefault = $5f6401247548b219$exports && $5f6401247548b219$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5f6401247548b219$var$__importStar = $5f6401247548b219$exports && $5f6401247548b219$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5f6401247548b219$var$__createBinding(result, mod, k);
    }
    $5f6401247548b219$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5f6401247548b219$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $5f6401247548b219$var$React = $5f6401247548b219$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $5f6401247548b219$var$moon = $lebkq.keyframes($5f6401247548b219$var$templateObject_1 || ($5f6401247548b219$var$templateObject_1 = $5f6401247548b219$var$__makeTemplateObject([
    "\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  100% {transform: rotate(360deg)}\n"
])));
var $5f6401247548b219$var$Loader = /** @class */ function(_super) {
    $5f6401247548b219$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moonSize = function() {
            var size = _this.props.size;
            var value = $40cd3856ba228dd7$exports.parseLengthAndUnit(size).value;
            return value / 7;
        };
        _this.ballStyle = function(size) {
            return $lebkq.css($5f6401247548b219$var$templateObject_2 || ($5f6401247548b219$var$templateObject_2 = $5f6401247548b219$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size));
        };
        _this.wrapper = function() {
            var _a = _this.props, size = _a.size, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($5f6401247548b219$var$templateObject_3 || ($5f6401247548b219$var$templateObject_3 = $5f6401247548b219$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ])), "" + (value + _this.moonSize() * 2) + unit, "" + (value + _this.moonSize() * 2) + unit, $5f6401247548b219$var$moon, 0.6 / speedMultiplier);
        };
        _this.ball = function() {
            var _a = _this.props, color = _a.color, size = _a.size, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($5f6401247548b219$var$templateObject_4 || ($5f6401247548b219$var$templateObject_4 = $5f6401247548b219$var$__makeTemplateObject([
                "\n      ",
                ";\n      background-color: ",
                ";\n      opacity: 0.8;\n      position: absolute;\n      top: ",
                ";\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      ",
                ";\n      background-color: ",
                ";\n      opacity: 0.8;\n      position: absolute;\n      top: ",
                ";\n      animation: ",
                " ",
                "s 0s infinite linear;\n      animation-fill-mode: forwards;\n    "
            ])), _this.ballStyle(_this.moonSize()), color, "" + (value / 2 - _this.moonSize() / 2) + unit, $5f6401247548b219$var$moon, 0.6 / speedMultiplier);
        };
        _this.circle = function() {
            var _a = _this.props, size = _a.size, color = _a.color;
            var value = $40cd3856ba228dd7$exports.parseLengthAndUnit(size).value;
            return $lebkq.css($5f6401247548b219$var$templateObject_5 || ($5f6401247548b219$var$templateObject_5 = $5f6401247548b219$var$__makeTemplateObject([
                "\n      ",
                ";\n      border: ",
                "px solid ",
                ";\n      opacity: 0.1;\n      box-sizing: content-box;\n      position: absolute;\n    "
            ], [
                "\n      ",
                ";\n      border: ",
                "px solid ",
                ";\n      opacity: 0.1;\n      box-sizing: content-box;\n      position: absolute;\n    "
            ])), _this.ballStyle(value), _this.moonSize(), color);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.ball()
        }), $lebkq.jsx("span", {
            css: this.circle()
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(60);
    return Loader;
}($5f6401247548b219$var$React.PureComponent);
$5f6401247548b219$exports.default = $5f6401247548b219$var$Loader;
var $5f6401247548b219$var$templateObject_1, $5f6401247548b219$var$templateObject_2, $5f6401247548b219$var$templateObject_3, $5f6401247548b219$var$templateObject_4, $5f6401247548b219$var$templateObject_5;


Object.defineProperty($faa4cbee9e7297c6$exports, "MoonLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($5f6401247548b219$exports).default;
    }
});
var $e9a7cc0536c44215$exports = {};
"use strict";
var $e9a7cc0536c44215$var$__makeTemplateObject = $e9a7cc0536c44215$exports && $e9a7cc0536c44215$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $e9a7cc0536c44215$var$__extends = $e9a7cc0536c44215$exports && $e9a7cc0536c44215$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e9a7cc0536c44215$var$__createBinding = $e9a7cc0536c44215$exports && $e9a7cc0536c44215$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9a7cc0536c44215$var$__setModuleDefault = $e9a7cc0536c44215$exports && $e9a7cc0536c44215$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e9a7cc0536c44215$var$__importStar = $e9a7cc0536c44215$exports && $e9a7cc0536c44215$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9a7cc0536c44215$var$__createBinding(result, mod, k);
    }
    $e9a7cc0536c44215$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e9a7cc0536c44215$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $e9a7cc0536c44215$var$React = $e9a7cc0536c44215$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $e9a7cc0536c44215$var$pacman = [
    $lebkq.keyframes($e9a7cc0536c44215$var$templateObject_1 || ($e9a7cc0536c44215$var$templateObject_1 = $e9a7cc0536c44215$var$__makeTemplateObject([
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "
    ], [
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "
    ]))),
    $lebkq.keyframes($e9a7cc0536c44215$var$templateObject_2 || ($e9a7cc0536c44215$var$templateObject_2 = $e9a7cc0536c44215$var$__makeTemplateObject([
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "
    ], [
        "\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "
    ])))
];
var $e9a7cc0536c44215$var$Loader = /** @class */ function(_super) {
    $e9a7cc0536c44215$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ball = function() {
            var size = _this.props.size;
            var _a = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _a.value, unit = _a.unit;
            return $lebkq.keyframes($e9a7cc0536c44215$var$templateObject_3 || ($e9a7cc0536c44215$var$templateObject_3 = $e9a7cc0536c44215$var$__makeTemplateObject([
                "\n      75% {opacity: 0.7}\n      100% {transform: translate(",
                ", ",
                ")}\n    "
            ], [
                "\n      75% {opacity: 0.7}\n      100% {transform: translate(",
                ", ",
                ")}\n    "
            ])), "" + -4 * value + unit, "" + -value / 4 + unit);
        };
        _this.ballStyle = function(i) {
            var _a = _this.props, color = _a.color, margin = _a.margin, size = _a.size, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($e9a7cc0536c44215$var$templateObject_4 || ($e9a7cc0536c44215$var$templateObject_4 = $e9a7cc0536c44215$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      background-color: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      transform: translate(0, ",
                ");\n      position: absolute;\n      top: ",
                ";\n      left: ",
                ";\n      animation: ",
                " ",
                "s ",
                "s infinite linear;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      background-color: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      transform: translate(0, ",
                ");\n      position: absolute;\n      top: ",
                ";\n      left: ",
                ";\n      animation: ",
                " ",
                "s ",
                "s infinite linear;\n      animation-fill-mode: both;\n    "
            ])), "" + value / 3 + unit, "" + value / 3 + unit, color, $40cd3856ba228dd7$exports.cssValue(margin), "" + -value / 4 + unit, "" + value + unit, "" + value * 4 + unit, _this.ball(), 1 / speedMultiplier, i * 0.25);
        };
        _this.s1 = function() {
            return $40cd3856ba228dd7$exports.cssValue(_this.props.size) + " solid transparent";
        };
        _this.s2 = function() {
            var color = _this.props.color;
            return $40cd3856ba228dd7$exports.cssValue(_this.props.size) + " solid " + color;
        };
        _this.pacmanStyle = function(i) {
            var _a = _this.props, size = _a.size, speedMultiplier = _a.speedMultiplier;
            var s1 = _this.s1();
            var s2 = _this.s2();
            return $lebkq.css($e9a7cc0536c44215$var$templateObject_5 || ($e9a7cc0536c44215$var$templateObject_5 = $e9a7cc0536c44215$var$__makeTemplateObject([
                "\n      width: 0;\n      height: 0;\n      border-right: ",
                ";\n      border-top: ",
                ";\n      border-left: ",
                ";\n      border-bottom: ",
                ";\n      border-radius: ",
                ";\n      position: absolute;\n      animation: ",
                " ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: 0;\n      height: 0;\n      border-right: ",
                ";\n      border-top: ",
                ";\n      border-left: ",
                ";\n      border-bottom: ",
                ";\n      border-radius: ",
                ";\n      position: absolute;\n      animation: ",
                " ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ])), s1, i === 0 ? s1 : s2, s2, i === 0 ? s2 : s1, $40cd3856ba228dd7$exports.cssValue(size), $e9a7cc0536c44215$var$pacman[i], 0.8 / speedMultiplier);
        };
        _this.wrapper = function() {
            return $lebkq.css($e9a7cc0536c44215$var$templateObject_6 || ($e9a7cc0536c44215$var$templateObject_6 = $e9a7cc0536c44215$var$__makeTemplateObject([
                "\n      position: relative;\n      font-size: 0;\n      height: ",
                ";\n      width: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      font-size: 0;\n      height: ",
                ";\n      width: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(_this.props.size), $40cd3856ba228dd7$exports.cssValue(_this.props.size));
        };
        _this.pac = function() {
            return _this.pacmanStyle(0);
        };
        _this.man = function() {
            return _this.pacmanStyle(1);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.pac()
        }), $lebkq.jsx("span", {
            css: this.man()
        }), $lebkq.jsx("span", {
            css: this.ballStyle(2)
        }), $lebkq.jsx("span", {
            css: this.ballStyle(3)
        }), $lebkq.jsx("span", {
            css: this.ballStyle(4)
        }), $lebkq.jsx("span", {
            css: this.ballStyle(5)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(25);
    return Loader;
}($e9a7cc0536c44215$var$React.PureComponent);
$e9a7cc0536c44215$exports.default = $e9a7cc0536c44215$var$Loader;
var $e9a7cc0536c44215$var$templateObject_1, $e9a7cc0536c44215$var$templateObject_2, $e9a7cc0536c44215$var$templateObject_3, $e9a7cc0536c44215$var$templateObject_4, $e9a7cc0536c44215$var$templateObject_5, $e9a7cc0536c44215$var$templateObject_6;


Object.defineProperty($faa4cbee9e7297c6$exports, "PacmanLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($e9a7cc0536c44215$exports).default;
    }
});
var $1344bb6b7fdfbc3e$exports = {};
"use strict";
var $1344bb6b7fdfbc3e$var$__makeTemplateObject = $1344bb6b7fdfbc3e$exports && $1344bb6b7fdfbc3e$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $1344bb6b7fdfbc3e$var$__extends = $1344bb6b7fdfbc3e$exports && $1344bb6b7fdfbc3e$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1344bb6b7fdfbc3e$var$__createBinding = $1344bb6b7fdfbc3e$exports && $1344bb6b7fdfbc3e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1344bb6b7fdfbc3e$var$__setModuleDefault = $1344bb6b7fdfbc3e$exports && $1344bb6b7fdfbc3e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1344bb6b7fdfbc3e$var$__importStar = $1344bb6b7fdfbc3e$exports && $1344bb6b7fdfbc3e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1344bb6b7fdfbc3e$var$__createBinding(result, mod, k);
    }
    $1344bb6b7fdfbc3e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1344bb6b7fdfbc3e$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $1344bb6b7fdfbc3e$var$React = $1344bb6b7fdfbc3e$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

// 1.5 4.5 7.5
var $1344bb6b7fdfbc3e$var$distance = [
    1,
    3,
    5
];
var $1344bb6b7fdfbc3e$var$propagate = [
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_1 || ($1344bb6b7fdfbc3e$var$templateObject_1 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[1], $1344bb6b7fdfbc3e$var$distance[2]),
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_2 || ($1344bb6b7fdfbc3e$var$templateObject_2 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      50% {transform: translateX(-",
        "rem) scale(0.6)}\n      75% {transform: translateX(-",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[1], $1344bb6b7fdfbc3e$var$distance[1]),
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_3 || ($1344bb6b7fdfbc3e$var$templateObject_3 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      75% {transform: translateX(-",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(-",
        "rem) scale(0.75)}\n      75% {transform: translateX(-",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[0]),
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_4 || ($1344bb6b7fdfbc3e$var$templateObject_4 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      75% {transform: translateX(",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      75% {transform: translateX(",
        "rem) scale(0.75)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[0]),
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_5 || ($1344bb6b7fdfbc3e$var$templateObject_5 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.6)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[1], $1344bb6b7fdfbc3e$var$distance[1]),
    $lebkq.keyframes($1344bb6b7fdfbc3e$var$templateObject_6 || ($1344bb6b7fdfbc3e$var$templateObject_6 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ], [
        "\n      25% {transform: translateX(",
        "rem) scale(0.75)}\n      50% {transform: translateX(",
        "rem) scale(0.6)}\n      75% {transform: translateX(",
        "rem) scale(0.5)}\n      95% {transform: translateX(0rem) scale(1)}\n    "
    ])), $1344bb6b7fdfbc3e$var$distance[0], $1344bb6b7fdfbc3e$var$distance[1], $1344bb6b7fdfbc3e$var$distance[2])
];
var $1344bb6b7fdfbc3e$var$Loader = /** @class */ function(_super) {
    $1344bb6b7fdfbc3e$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, size = _a.size, color = _a.color, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
            return $lebkq.css($1344bb6b7fdfbc3e$var$templateObject_7 || ($1344bb6b7fdfbc3e$var$templateObject_7 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
                "\n      position: absolute;\n      font-size: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      background: ",
                ";\n      border-radius: 50%;\n      animation: ",
                " ",
                "s infinite;\n      animation-fill-mode: forwards;\n    "
            ], [
                "\n      position: absolute;\n      font-size: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      background: ",
                ";\n      border-radius: 50%;\n      animation: ",
                " ",
                "s infinite;\n      animation-fill-mode: forwards;\n    "
            ])), "" + value / 3 + unit, "" + value + unit, "" + value + unit, color, $1344bb6b7fdfbc3e$var$propagate[i], 1.5 / speedMultiplier);
        };
        _this.wrapper = function() {
            return $lebkq.css($1344bb6b7fdfbc3e$var$templateObject_8 || ($1344bb6b7fdfbc3e$var$templateObject_8 = $1344bb6b7fdfbc3e$var$__makeTemplateObject([
                "\n      position: relative;\n    "
            ], [
                "\n      position: relative;\n    "
            ])));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(0)
        }), $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        }), $lebkq.jsx("span", {
            css: this.style(4)
        }), $lebkq.jsx("span", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(15);
    return Loader;
}($1344bb6b7fdfbc3e$var$React.PureComponent);
$1344bb6b7fdfbc3e$exports.default = $1344bb6b7fdfbc3e$var$Loader;
var $1344bb6b7fdfbc3e$var$templateObject_1, $1344bb6b7fdfbc3e$var$templateObject_2, $1344bb6b7fdfbc3e$var$templateObject_3, $1344bb6b7fdfbc3e$var$templateObject_4, $1344bb6b7fdfbc3e$var$templateObject_5, $1344bb6b7fdfbc3e$var$templateObject_6, $1344bb6b7fdfbc3e$var$templateObject_7, $1344bb6b7fdfbc3e$var$templateObject_8;


Object.defineProperty($faa4cbee9e7297c6$exports, "PropagateLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($1344bb6b7fdfbc3e$exports).default;
    }
});
var $82b0f37b9705a3b7$exports = {};
"use strict";
var $82b0f37b9705a3b7$var$__makeTemplateObject = $82b0f37b9705a3b7$exports && $82b0f37b9705a3b7$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $82b0f37b9705a3b7$var$__extends = $82b0f37b9705a3b7$exports && $82b0f37b9705a3b7$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $82b0f37b9705a3b7$var$__createBinding = $82b0f37b9705a3b7$exports && $82b0f37b9705a3b7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82b0f37b9705a3b7$var$__setModuleDefault = $82b0f37b9705a3b7$exports && $82b0f37b9705a3b7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $82b0f37b9705a3b7$var$__importStar = $82b0f37b9705a3b7$exports && $82b0f37b9705a3b7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $82b0f37b9705a3b7$var$__createBinding(result, mod, k);
    }
    $82b0f37b9705a3b7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($82b0f37b9705a3b7$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $82b0f37b9705a3b7$var$React = $82b0f37b9705a3b7$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $82b0f37b9705a3b7$var$pulse = $lebkq.keyframes($82b0f37b9705a3b7$var$templateObject_1 || ($82b0f37b9705a3b7$var$templateObject_1 = $82b0f37b9705a3b7$var$__makeTemplateObject([
    "\n  0% {transform: scale(1);opacity: 1}\n  45% {transform: scale(0.1);opacity: 0.7}\n  80% {transform: scale(1);opacity: 1}\n"
], [
    "\n  0% {transform: scale(1);opacity: 1}\n  45% {transform: scale(0.1);opacity: 0.7}\n  80% {transform: scale(1);opacity: 1}\n"
])));
var $82b0f37b9705a3b7$var$Loader = /** @class */ function(_super) {
    $82b0f37b9705a3b7$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($82b0f37b9705a3b7$var$templateObject_2 || ($82b0f37b9705a3b7$var$templateObject_2 = $82b0f37b9705a3b7$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite\n        cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite\n        cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(margin), $82b0f37b9705a3b7$var$pulse, 0.75 / speedMultiplier, i * 0.12 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(15);
    return Loader;
}($82b0f37b9705a3b7$var$React.PureComponent);
$82b0f37b9705a3b7$exports.default = $82b0f37b9705a3b7$var$Loader;
var $82b0f37b9705a3b7$var$templateObject_1, $82b0f37b9705a3b7$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "PulseLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($82b0f37b9705a3b7$exports).default;
    }
});
var $3240132cae58feb5$exports = {};
"use strict";
var $3240132cae58feb5$var$__makeTemplateObject = $3240132cae58feb5$exports && $3240132cae58feb5$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $3240132cae58feb5$var$__extends = $3240132cae58feb5$exports && $3240132cae58feb5$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3240132cae58feb5$var$__createBinding = $3240132cae58feb5$exports && $3240132cae58feb5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3240132cae58feb5$var$__setModuleDefault = $3240132cae58feb5$exports && $3240132cae58feb5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3240132cae58feb5$var$__importStar = $3240132cae58feb5$exports && $3240132cae58feb5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3240132cae58feb5$var$__createBinding(result, mod, k);
    }
    $3240132cae58feb5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3240132cae58feb5$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $3240132cae58feb5$var$React = $3240132cae58feb5$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $3240132cae58feb5$var$puff = [
    $lebkq.keyframes($3240132cae58feb5$var$templateObject_1 || ($3240132cae58feb5$var$templateObject_1 = $3240132cae58feb5$var$__makeTemplateObject([
        "\n  0%  {transform: scale(0)}\n  100% {transform: scale(1.0)}\n"
    ], [
        "\n  0%  {transform: scale(0)}\n  100% {transform: scale(1.0)}\n"
    ]))),
    $lebkq.keyframes($3240132cae58feb5$var$templateObject_2 || ($3240132cae58feb5$var$templateObject_2 = $3240132cae58feb5$var$__makeTemplateObject([
        "\n  0%  {opacity: 1}\n  100% {opacity: 0}\n"
    ], [
        "\n  0%  {opacity: 1}\n  100% {opacity: 0}\n"
    ])))
];
var $3240132cae58feb5$var$Loader = /** @class */ function(_super) {
    $3240132cae58feb5$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSize = function() {
            return _this.props.size;
        };
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($3240132cae58feb5$var$templateObject_3 || ($3240132cae58feb5$var$templateObject_3 = $3240132cae58feb5$var$__makeTemplateObject([
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: thick solid ",
                ";\n      border-radius: 50%;\n      opacity: 1;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                ", ",
                ";\n      animation-duration: ",
                "s;\n      animation-iteration-count: infinite;\n      animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1), cubic-bezier(0.3, 0.61, 0.355, 1);\n      animation-delay: ",
                ";\n    "
            ], [
                "\n      position: absolute;\n      height: ",
                ";\n      width: ",
                ";\n      border: thick solid ",
                ";\n      border-radius: 50%;\n      opacity: 1;\n      top: 0;\n      left: 0;\n      animation-fill-mode: both;\n      animation: ",
                ", ",
                ";\n      animation-duration: ",
                "s;\n      animation-iteration-count: infinite;\n      animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1), cubic-bezier(0.3, 0.61, 0.355, 1);\n      animation-delay: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(_this.getSize()), $40cd3856ba228dd7$exports.cssValue(_this.getSize()), color, $3240132cae58feb5$var$puff[0], $3240132cae58feb5$var$puff[1], 2 / speedMultiplier, i === 1 ? "-1s" : "0s");
        };
        _this.wrapper = function() {
            return $lebkq.css($3240132cae58feb5$var$templateObject_4 || ($3240132cae58feb5$var$templateObject_4 = $3240132cae58feb5$var$__makeTemplateObject([
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ], [
                "\n      position: relative;\n      width: ",
                ";\n      height: ",
                ";\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(_this.getSize()), $40cd3856ba228dd7$exports.cssValue(_this.getSize()));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(60);
    return Loader;
}($3240132cae58feb5$var$React.PureComponent);
$3240132cae58feb5$exports.default = $3240132cae58feb5$var$Loader;
var $3240132cae58feb5$var$templateObject_1, $3240132cae58feb5$var$templateObject_2, $3240132cae58feb5$var$templateObject_3, $3240132cae58feb5$var$templateObject_4;


Object.defineProperty($faa4cbee9e7297c6$exports, "PuffLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($3240132cae58feb5$exports).default;
    }
});
var $17345e0b88225f83$exports = {};
"use strict";
var $17345e0b88225f83$var$__makeTemplateObject = $17345e0b88225f83$exports && $17345e0b88225f83$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $17345e0b88225f83$var$__extends = $17345e0b88225f83$exports && $17345e0b88225f83$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $17345e0b88225f83$var$__createBinding = $17345e0b88225f83$exports && $17345e0b88225f83$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17345e0b88225f83$var$__setModuleDefault = $17345e0b88225f83$exports && $17345e0b88225f83$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $17345e0b88225f83$var$__importStar = $17345e0b88225f83$exports && $17345e0b88225f83$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17345e0b88225f83$var$__createBinding(result, mod, k);
    }
    $17345e0b88225f83$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($17345e0b88225f83$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $17345e0b88225f83$var$React = $17345e0b88225f83$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $17345e0b88225f83$var$right = $lebkq.keyframes($17345e0b88225f83$var$templateObject_1 || ($17345e0b88225f83$var$templateObject_1 = $17345e0b88225f83$var$__makeTemplateObject([
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}\n"
], [
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}\n"
])));
var $17345e0b88225f83$var$left = $lebkq.keyframes($17345e0b88225f83$var$templateObject_2 || ($17345e0b88225f83$var$templateObject_2 = $17345e0b88225f83$var$__makeTemplateObject([
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}\n"
], [
    "\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}\n"
])));
var $17345e0b88225f83$var$Loader = /** @class */ function(_super) {
    $17345e0b88225f83$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSize = function() {
            return _this.props.size;
        };
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, speedMultiplier = _a.speedMultiplier;
            var _b = $40cd3856ba228dd7$exports.parseLengthAndUnit(_this.getSize()), value = _b.value, unit = _b.unit;
            return $lebkq.css($17345e0b88225f83$var$templateObject_3 || ($17345e0b88225f83$var$templateObject_3 = $17345e0b88225f83$var$__makeTemplateObject([
                "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ",
                ";\n      height: ",
                ";\n      border: ",
                " solid ",
                ";\n      opacity: 0.4;\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      perspective: 800px;\n      animation: ",
                " ",
                "s 0s infinite linear;\n    "
            ], [
                "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ",
                ";\n      height: ",
                ";\n      border: ",
                " solid ",
                ";\n      opacity: 0.4;\n      border-radius: 100%;\n      animation-fill-mode: forwards;\n      perspective: 800px;\n      animation: ",
                " ",
                "s 0s infinite linear;\n    "
            ])), "" + value + unit, "" + value + unit, "" + value / 10 + unit, color, i === 1 ? $17345e0b88225f83$var$right : $17345e0b88225f83$var$left, 2 / speedMultiplier);
        };
        _this.wrapper = function() {
            return $lebkq.css($17345e0b88225f83$var$templateObject_4 || ($17345e0b88225f83$var$templateObject_4 = $17345e0b88225f83$var$__makeTemplateObject([
                "\n      width: ",
                ";\n      height: ",
                ";\n      position: relative;\n    "
            ], [
                "\n      width: ",
                ";\n      height: ",
                ";\n      position: relative;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(_this.getSize()), $40cd3856ba228dd7$exports.cssValue(_this.getSize()));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(60);
    return Loader;
}($17345e0b88225f83$var$React.PureComponent);
$17345e0b88225f83$exports.default = $17345e0b88225f83$var$Loader;
var $17345e0b88225f83$var$templateObject_1, $17345e0b88225f83$var$templateObject_2, $17345e0b88225f83$var$templateObject_3, $17345e0b88225f83$var$templateObject_4;


Object.defineProperty($faa4cbee9e7297c6$exports, "RingLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($17345e0b88225f83$exports).default;
    }
});
var $3d0b7bbdc880e01f$exports = {};
"use strict";
var $3d0b7bbdc880e01f$var$__makeTemplateObject = $3d0b7bbdc880e01f$exports && $3d0b7bbdc880e01f$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $3d0b7bbdc880e01f$var$__extends = $3d0b7bbdc880e01f$exports && $3d0b7bbdc880e01f$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3d0b7bbdc880e01f$var$__createBinding = $3d0b7bbdc880e01f$exports && $3d0b7bbdc880e01f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d0b7bbdc880e01f$var$__setModuleDefault = $3d0b7bbdc880e01f$exports && $3d0b7bbdc880e01f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3d0b7bbdc880e01f$var$__importStar = $3d0b7bbdc880e01f$exports && $3d0b7bbdc880e01f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d0b7bbdc880e01f$var$__createBinding(result, mod, k);
    }
    $3d0b7bbdc880e01f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3d0b7bbdc880e01f$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $3d0b7bbdc880e01f$var$React = $3d0b7bbdc880e01f$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $3d0b7bbdc880e01f$var$riseAmount = 30;
var $3d0b7bbdc880e01f$var$even = $lebkq.keyframes($3d0b7bbdc880e01f$var$templateObject_1 || ($3d0b7bbdc880e01f$var$templateObject_1 = $3d0b7bbdc880e01f$var$__makeTemplateObject([
    "\n  0% {transform: scale(1.1)}\n  25% {transform: translateY(-",
    "px)}\n  50% {transform: scale(0.4)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(1.0)}\n"
], [
    "\n  0% {transform: scale(1.1)}\n  25% {transform: translateY(-",
    "px)}\n  50% {transform: scale(0.4)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(1.0)}\n"
])), $3d0b7bbdc880e01f$var$riseAmount, $3d0b7bbdc880e01f$var$riseAmount);
var $3d0b7bbdc880e01f$var$odd = $lebkq.keyframes($3d0b7bbdc880e01f$var$templateObject_2 || ($3d0b7bbdc880e01f$var$templateObject_2 = $3d0b7bbdc880e01f$var$__makeTemplateObject([
    "\n  0% {transform: scale(0.4)}\n  25% {transform: translateY(",
    "px)}\n  50% {transform: scale(1.1)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(0.75)}\n"
], [
    "\n  0% {transform: scale(0.4)}\n  25% {transform: translateY(",
    "px)}\n  50% {transform: scale(1.1)}\n  75% {transform: translateY(",
    "px)}\n  100% {transform: translateY(0) scale(0.75)}\n"
])), $3d0b7bbdc880e01f$var$riseAmount, -$3d0b7bbdc880e01f$var$riseAmount);
var $3d0b7bbdc880e01f$var$Loader = /** @class */ function(_super) {
    $3d0b7bbdc880e01f$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($3d0b7bbdc880e01f$var$templateObject_3 || ($3d0b7bbdc880e01f$var$templateObject_3 = $3d0b7bbdc880e01f$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.15, 0.46, 0.9, 0.6);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.15, 0.46, 0.9, 0.6);\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(margin), i % 2 === 0 ? $3d0b7bbdc880e01f$var$even : $3d0b7bbdc880e01f$var$odd, 1 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        }), $lebkq.jsx("span", {
            css: this.style(4)
        }), $lebkq.jsx("span", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(15);
    return Loader;
}($3d0b7bbdc880e01f$var$React.PureComponent);
$3d0b7bbdc880e01f$exports.default = $3d0b7bbdc880e01f$var$Loader;
var $3d0b7bbdc880e01f$var$templateObject_1, $3d0b7bbdc880e01f$var$templateObject_2, $3d0b7bbdc880e01f$var$templateObject_3;


Object.defineProperty($faa4cbee9e7297c6$exports, "RiseLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($3d0b7bbdc880e01f$exports).default;
    }
});
var $52f95ee7349b5987$exports = {};
"use strict";
var $52f95ee7349b5987$var$__makeTemplateObject = $52f95ee7349b5987$exports && $52f95ee7349b5987$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $52f95ee7349b5987$var$__extends = $52f95ee7349b5987$exports && $52f95ee7349b5987$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $52f95ee7349b5987$var$__createBinding = $52f95ee7349b5987$exports && $52f95ee7349b5987$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $52f95ee7349b5987$var$__setModuleDefault = $52f95ee7349b5987$exports && $52f95ee7349b5987$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $52f95ee7349b5987$var$__importStar = $52f95ee7349b5987$exports && $52f95ee7349b5987$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $52f95ee7349b5987$var$__createBinding(result, mod, k);
    }
    $52f95ee7349b5987$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($52f95ee7349b5987$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $52f95ee7349b5987$var$React = $52f95ee7349b5987$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $52f95ee7349b5987$var$rotate = $lebkq.keyframes($52f95ee7349b5987$var$templateObject_1 || ($52f95ee7349b5987$var$templateObject_1 = $52f95ee7349b5987$var$__makeTemplateObject([
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
], [
    "\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n"
])));
var $52f95ee7349b5987$var$Loader = /** @class */ function(_super) {
    $52f95ee7349b5987$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var margin = _this.props.margin;
            var _a = $40cd3856ba228dd7$exports.parseLengthAndUnit(margin), value = _a.value, unit = _a.unit;
            var left = (i % 2 ? -1 : 1) * (26 + value);
            return $lebkq.css($52f95ee7349b5987$var$templateObject_2 || ($52f95ee7349b5987$var$templateObject_2 = $52f95ee7349b5987$var$__makeTemplateObject([
                "\n      opacity: 0.8;\n      position: absolute;\n      top: 0;\n      left: ",
                "",
                ";\n    "
            ], [
                "\n      opacity: 0.8;\n      position: absolute;\n      top: 0;\n      left: ",
                "",
                ";\n    "
            ])), left, unit);
        };
        _this.ball = function() {
            var _a = _this.props, color = _a.color, size = _a.size;
            return $lebkq.css($52f95ee7349b5987$var$templateObject_3 || ($52f95ee7349b5987$var$templateObject_3 = $52f95ee7349b5987$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      border-radius: 100%;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size));
        };
        _this.wrapper = function() {
            var speedMultiplier = _this.props.speedMultiplier;
            return $lebkq.css($52f95ee7349b5987$var$templateObject_4 || ($52f95ee7349b5987$var$templateObject_4 = $52f95ee7349b5987$var$__makeTemplateObject([
                "\n      ",
                ";\n      display: inline-block;\n      position: relative;\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.7, -0.13, 0.22, 0.86);\n    "
            ], [
                "\n      ",
                ";\n      display: inline-block;\n      position: relative;\n      animation-fill-mode: both;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.7, -0.13, 0.22, 0.86);\n    "
            ])), _this.ball(), $52f95ee7349b5987$var$rotate, 1 / speedMultiplier);
        };
        _this.long = function() {
            return $lebkq.css($52f95ee7349b5987$var$templateObject_5 || ($52f95ee7349b5987$var$templateObject_5 = $52f95ee7349b5987$var$__makeTemplateObject([
                "\n    ",
                ";\n    ",
                ";\n  "
            ], [
                "\n    ",
                ";\n    ",
                ";\n  "
            ])), _this.ball(), _this.style(1));
        };
        _this.short = function() {
            return $lebkq.css($52f95ee7349b5987$var$templateObject_6 || ($52f95ee7349b5987$var$templateObject_6 = $52f95ee7349b5987$var$__makeTemplateObject([
                "\n    ",
                ";\n    ",
                ";\n  "
            ], [
                "\n    ",
                ";\n    ",
                ";\n  "
            ])), _this.ball(), _this.style(2));
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.wrapper(),
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.long()
        }), $lebkq.jsx("span", {
            css: this.short()
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeMarginDefaults(15);
    return Loader;
}($52f95ee7349b5987$var$React.PureComponent);
$52f95ee7349b5987$exports.default = $52f95ee7349b5987$var$Loader;
var $52f95ee7349b5987$var$templateObject_1, $52f95ee7349b5987$var$templateObject_2, $52f95ee7349b5987$var$templateObject_3, $52f95ee7349b5987$var$templateObject_4, $52f95ee7349b5987$var$templateObject_5, $52f95ee7349b5987$var$templateObject_6;


Object.defineProperty($faa4cbee9e7297c6$exports, "RotateLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($52f95ee7349b5987$exports).default;
    }
});
var $4f928730178e29b8$exports = {};
"use strict";
var $4f928730178e29b8$var$__makeTemplateObject = $4f928730178e29b8$exports && $4f928730178e29b8$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $4f928730178e29b8$var$__extends = $4f928730178e29b8$exports && $4f928730178e29b8$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4f928730178e29b8$var$__createBinding = $4f928730178e29b8$exports && $4f928730178e29b8$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f928730178e29b8$var$__setModuleDefault = $4f928730178e29b8$exports && $4f928730178e29b8$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4f928730178e29b8$var$__importStar = $4f928730178e29b8$exports && $4f928730178e29b8$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4f928730178e29b8$var$__createBinding(result, mod, k);
    }
    $4f928730178e29b8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4f928730178e29b8$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $4f928730178e29b8$var$React = $4f928730178e29b8$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $4f928730178e29b8$var$scale = $lebkq.keyframes($4f928730178e29b8$var$templateObject_1 || ($4f928730178e29b8$var$templateObject_1 = $4f928730178e29b8$var$__makeTemplateObject([
    "\n  0% {transform: scaley(1.0)}\n  50% {transform: scaley(0.4)}\n  100% {transform: scaley(1.0)}\n"
], [
    "\n  0% {transform: scaley(1.0)}\n  50% {transform: scaley(0.4)}\n  100% {transform: scaley(1.0)}\n"
])));
var $4f928730178e29b8$var$Loader = /** @class */ function(_super) {
    $4f928730178e29b8$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, width = _a.width, height = _a.height, margin = _a.margin, radius = _a.radius, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($4f928730178e29b8$var$templateObject_2 || ($4f928730178e29b8$var$templateObject_2 = $4f928730178e29b8$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(width), $40cd3856ba228dd7$exports.cssValue(height), $40cd3856ba228dd7$exports.cssValue(margin), $40cd3856ba228dd7$exports.cssValue(radius), $4f928730178e29b8$var$scale, 1 / speedMultiplier, i * 0.1);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        }), $lebkq.jsx("span", {
            css: this.style(4)
        }), $lebkq.jsx("span", {
            css: this.style(5)
        })) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.heightWidthRadiusDefaults(35, 4, 2);
    return Loader;
}($4f928730178e29b8$var$React.PureComponent);
$4f928730178e29b8$exports.default = $4f928730178e29b8$var$Loader;
var $4f928730178e29b8$var$templateObject_1, $4f928730178e29b8$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "ScaleLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($4f928730178e29b8$exports).default;
    }
});
var $17ffd88ba9f4d537$exports = {};
"use strict";
var $17ffd88ba9f4d537$var$__makeTemplateObject = $17ffd88ba9f4d537$exports && $17ffd88ba9f4d537$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $17ffd88ba9f4d537$var$__extends = $17ffd88ba9f4d537$exports && $17ffd88ba9f4d537$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $17ffd88ba9f4d537$var$__createBinding = $17ffd88ba9f4d537$exports && $17ffd88ba9f4d537$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17ffd88ba9f4d537$var$__setModuleDefault = $17ffd88ba9f4d537$exports && $17ffd88ba9f4d537$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $17ffd88ba9f4d537$var$__importStar = $17ffd88ba9f4d537$exports && $17ffd88ba9f4d537$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17ffd88ba9f4d537$var$__createBinding(result, mod, k);
    }
    $17ffd88ba9f4d537$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($17ffd88ba9f4d537$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $17ffd88ba9f4d537$var$React = $17ffd88ba9f4d537$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $17ffd88ba9f4d537$var$skew = $lebkq.keyframes($17ffd88ba9f4d537$var$templateObject_1 || ($17ffd88ba9f4d537$var$templateObject_1 = $17ffd88ba9f4d537$var$__makeTemplateObject([
    "\n  25% {transform: perspective(100px) rotateX(180deg) rotateY(0)}\n  50% {transform: perspective(100px) rotateX(180deg) rotateY(180deg)}\n  75% {transform: perspective(100px) rotateX(0) rotateY(180deg)}\n  100% {transform: perspective(100px) rotateX(0) rotateY(0)}\n"
], [
    "\n  25% {transform: perspective(100px) rotateX(180deg) rotateY(0)}\n  50% {transform: perspective(100px) rotateX(180deg) rotateY(180deg)}\n  75% {transform: perspective(100px) rotateX(0) rotateY(180deg)}\n  100% {transform: perspective(100px) rotateX(0) rotateY(0)}\n"
])));
var $17ffd88ba9f4d537$var$Loader = /** @class */ function(_super) {
    $17ffd88ba9f4d537$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, color = _a.color, speedMultiplier = _a.speedMultiplier, size = _a.size;
            return $lebkq.css($17ffd88ba9f4d537$var$templateObject_2 || ($17ffd88ba9f4d537$var$templateObject_2 = $17ffd88ba9f4d537$var$__makeTemplateObject([
                "\n      width: 0;\n      height: 0;\n      border-left: ",
                " solid transparent;\n      border-right: ",
                " solid transparent;\n      border-bottom: ",
                " solid ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      width: 0;\n      height: 0;\n      border-left: ",
                " solid transparent;\n      border-right: ",
                " solid transparent;\n      border-bottom: ",
                " solid ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ])), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), color, $17ffd88ba9f4d537$var$skew, 3 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(20);
    return Loader;
}($17ffd88ba9f4d537$var$React.PureComponent);
$17ffd88ba9f4d537$exports.default = $17ffd88ba9f4d537$var$Loader;
var $17ffd88ba9f4d537$var$templateObject_1, $17ffd88ba9f4d537$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "SkewLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($17ffd88ba9f4d537$exports).default;
    }
});
var $df270bfc41c7975d$exports = {};
"use strict";
var $df270bfc41c7975d$var$__makeTemplateObject = $df270bfc41c7975d$exports && $df270bfc41c7975d$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $df270bfc41c7975d$var$__extends = $df270bfc41c7975d$exports && $df270bfc41c7975d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $df270bfc41c7975d$var$__createBinding = $df270bfc41c7975d$exports && $df270bfc41c7975d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $df270bfc41c7975d$var$__setModuleDefault = $df270bfc41c7975d$exports && $df270bfc41c7975d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $df270bfc41c7975d$var$__importStar = $df270bfc41c7975d$exports && $df270bfc41c7975d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $df270bfc41c7975d$var$__createBinding(result, mod, k);
    }
    $df270bfc41c7975d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($df270bfc41c7975d$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $df270bfc41c7975d$var$React = $df270bfc41c7975d$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $df270bfc41c7975d$var$square = $lebkq.keyframes($df270bfc41c7975d$var$templateObject_1 || ($df270bfc41c7975d$var$templateObject_1 = $df270bfc41c7975d$var$__makeTemplateObject([
    "\n  25% {transform: rotateX(180deg) rotateY(0)}\n  50% {transform: rotateX(180deg) rotateY(180deg)}\n  75% {transform: rotateX(0) rotateY(180deg)}\n  100% {transform: rotateX(0) rotateY(0)}\n"
], [
    "\n  25% {transform: rotateX(180deg) rotateY(0)}\n  50% {transform: rotateX(180deg) rotateY(180deg)}\n  75% {transform: rotateX(0) rotateY(180deg)}\n  100% {transform: rotateX(0) rotateY(0)}\n"
])));
var $df270bfc41c7975d$var$Loader = /** @class */ function(_super) {
    $df270bfc41c7975d$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function() {
            var _a = _this.props, color = _a.color, size = _a.size, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($df270bfc41c7975d$var$templateObject_2 || ($df270bfc41c7975d$var$templateObject_2 = $df270bfc41c7975d$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      display: inline-block;\n      animation: ",
                " ",
                "s 0s infinite cubic-bezier(0.09, 0.57, 0.49, 0.9);\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $df270bfc41c7975d$var$square, 3 / speedMultiplier);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                this.style(),
                css
            ]
        }) : null;
    };
    Loader.defaultProps = $40cd3856ba228dd7$exports.sizeDefaults(50);
    return Loader;
}($df270bfc41c7975d$var$React.PureComponent);
$df270bfc41c7975d$exports.default = $df270bfc41c7975d$var$Loader;
var $df270bfc41c7975d$var$templateObject_1, $df270bfc41c7975d$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "SquareLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($df270bfc41c7975d$exports).default;
    }
});
var $8052dc0c17ae4542$exports = {};
"use strict";
var $8052dc0c17ae4542$var$__makeTemplateObject = $8052dc0c17ae4542$exports && $8052dc0c17ae4542$exports.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $8052dc0c17ae4542$var$__extends = $8052dc0c17ae4542$exports && $8052dc0c17ae4542$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8052dc0c17ae4542$var$__createBinding = $8052dc0c17ae4542$exports && $8052dc0c17ae4542$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8052dc0c17ae4542$var$__setModuleDefault = $8052dc0c17ae4542$exports && $8052dc0c17ae4542$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8052dc0c17ae4542$var$__importStar = $8052dc0c17ae4542$exports && $8052dc0c17ae4542$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8052dc0c17ae4542$var$__createBinding(result, mod, k);
    }
    $8052dc0c17ae4542$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8052dc0c17ae4542$exports, "__esModule", {
    value: true
});

/** @jsx jsx */ var $8052dc0c17ae4542$var$React = $8052dc0c17ae4542$var$__importStar((parcelRequire("jSIPP")));

var $lebkq = parcelRequire("lebkq");

var $eB22U = parcelRequire("eB22U");

var $8052dc0c17ae4542$var$sync = $lebkq.keyframes($8052dc0c17ae4542$var$templateObject_1 || ($8052dc0c17ae4542$var$templateObject_1 = $8052dc0c17ae4542$var$__makeTemplateObject([
    "\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n"
], [
    "\n  33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}\n"
])));
var $8052dc0c17ae4542$var$Loader = /** @class */ function(_super) {
    $8052dc0c17ae4542$var$__extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.style = function(i) {
            var _a = _this.props, color = _a.color, size = _a.size, margin = _a.margin, speedMultiplier = _a.speedMultiplier;
            return $lebkq.css($8052dc0c17ae4542$var$templateObject_2 || ($8052dc0c17ae4542$var$templateObject_2 = $8052dc0c17ae4542$var$__makeTemplateObject([
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ], [
                "\n      background-color: ",
                ";\n      width: ",
                ";\n      height: ",
                ";\n      margin: ",
                ";\n      border-radius: 100%;\n      display: inline-block;\n      animation: ",
                " ",
                "s ",
                "s infinite ease-in-out;\n      animation-fill-mode: both;\n    "
            ])), color, $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(size), $40cd3856ba228dd7$exports.cssValue(margin), $8052dc0c17ae4542$var$sync, 0.6 / speedMultiplier, i * 0.07);
        };
        return _this;
    }
    Loader.prototype.render = function() {
        var _a = this.props, loading = _a.loading, css = _a.css;
        return loading ? $lebkq.jsx("span", {
            css: [
                css
            ]
        }, $lebkq.jsx("span", {
            css: this.style(1)
        }), $lebkq.jsx("span", {
            css: this.style(2)
        }), $lebkq.jsx("span", {
            css: this.style(3)
        })) : null;
    };
    Loader.defaultProps = $eB22U.sizeMarginDefaults(15);
    return Loader;
}($8052dc0c17ae4542$var$React.PureComponent);
$8052dc0c17ae4542$exports.default = $8052dc0c17ae4542$var$Loader;
var $8052dc0c17ae4542$var$templateObject_1, $8052dc0c17ae4542$var$templateObject_2;


Object.defineProperty($faa4cbee9e7297c6$exports, "SyncLoader", {
    enumerable: true,
    get: function() {
        return $faa4cbee9e7297c6$var$__importDefault($8052dc0c17ae4542$exports).default;
    }
});



var $lebkq = parcelRequire("lebkq");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $1e5363d70c91535a$export$46f01d01378ec5a2(slot) {
    return (0, $geF11.default)('MuiDivider', slot);
}
const $1e5363d70c91535a$var$dividerClasses = (0, $rARwS.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $1e5363d70c91535a$export$2e2bcd8739ae039 = $1e5363d70c91535a$var$dividerClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $7c3d5f6d6fb23b64$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $7c3d5f6d6fb23b64$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $1e5363d70c91535a$export$46f01d01378ec5a2), classes);
};
const $7c3d5f6d6fb23b64$var$DividerRoot = (0, $28RyA.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $hnF8Y.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $7c3d5f6d6fb23b64$var$DividerWrapper = (0, $28RyA.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $7c3d5f6d6fb23b64$var$Divider = /*#__PURE__*/ $jSIPP.forwardRef(function Divider(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $cMu4A.default)(props, $7c3d5f6d6fb23b64$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $7c3d5f6d6fb23b64$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($7c3d5f6d6fb23b64$var$DividerRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $4uaIU.jsx)($7c3d5f6d6fb23b64$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $7c3d5f6d6fb23b64$var$Divider.muiSkipListHighlight = true;
var $7c3d5f6d6fb23b64$export$2e2bcd8739ae039 = $7c3d5f6d6fb23b64$var$Divider;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");



var $hnF8Y = parcelRequire("hnF8Y");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $jSIPP = parcelRequire("jSIPP");
function $1f5925ba04d03ad0$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $jSIPP.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $df8809f1fe6fe9b8$export$2e2bcd8739ae039 = (0, $1f5925ba04d03ad0$export$2e2bcd8739ae039);



'use client';
var $b84d98ac1a64e1e6$export$2e2bcd8739ae039 = (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039);




var $jSIPP = parcelRequire("jSIPP");
'use client';
/**
 * @ignore - internal component.
 */ const $d6636f4a32427e55$var$ListContext = /*#__PURE__*/ $jSIPP.createContext({});
var $d6636f4a32427e55$export$2e2bcd8739ae039 = $d6636f4a32427e55$var$ListContext;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $2ef1683180bd3785$export$5682c366c0c669d9(slot) {
    return (0, $geF11.default)('MuiListItem', slot);
}
const $2ef1683180bd3785$var$listItemClasses = (0, $rARwS.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $2ef1683180bd3785$export$2e2bcd8739ae039 = $2ef1683180bd3785$var$listItemClasses;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $838ddd48e93a7ef3$export$c09531d8563c67a5(slot) {
    return (0, $geF11.default)('MuiListItemButton', slot);
}
const $838ddd48e93a7ef3$var$listItemButtonClasses = (0, $rARwS.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $838ddd48e93a7ef3$export$2e2bcd8739ae039 = $838ddd48e93a7ef3$var$listItemButtonClasses;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $5cb4b207baa9b3e8$export$ccdb26aeba48a86e(slot) {
    return (0, $geF11.default)('MuiListItemSecondaryAction', slot);
}
const $5cb4b207baa9b3e8$var$listItemSecondaryActionClasses = (0, $rARwS.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $5cb4b207baa9b3e8$export$2e2bcd8739ae039 = $5cb4b207baa9b3e8$var$listItemSecondaryActionClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $da2e844eb8725d2e$var$_excluded = [
    "className"
];
const $da2e844eb8725d2e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $5cb4b207baa9b3e8$export$ccdb26aeba48a86e), classes);
};
const $da2e844eb8725d2e$var$ListItemSecondaryActionRoot = (0, $28RyA.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $da2e844eb8725d2e$var$ListItemSecondaryAction = /*#__PURE__*/ $jSIPP.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $cMu4A.default)(props, $da2e844eb8725d2e$var$_excluded);
    const context = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    const ownerState = (0, $erOpW.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $da2e844eb8725d2e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($da2e844eb8725d2e$var$ListItemSecondaryActionRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$da2e844eb8725d2e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $da2e844eb8725d2e$export$2e2bcd8739ae039 = $da2e844eb8725d2e$var$ListItemSecondaryAction;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $727e74205c3a5c3a$var$_excluded = [
    "className"
], $727e74205c3a5c3a$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $727e74205c3a5c3a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $727e74205c3a5c3a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $2ef1683180bd3785$export$5682c366c0c669d9), classes);
};
const $727e74205c3a5c3a$export$aed538f7519abe89 = (0, $28RyA.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $727e74205c3a5c3a$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $erOpW.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $2ef1683180bd3785$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $2ef1683180bd3785$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $2ef1683180bd3785$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $2ef1683180bd3785$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $2ef1683180bd3785$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $727e74205c3a5c3a$var$ListItemContainer = (0, $28RyA.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $727e74205c3a5c3a$var$ListItem = /*#__PURE__*/ $jSIPP.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cMu4A.default)(props.ContainerProps, $727e74205c3a5c3a$var$_excluded), other = (0, $cMu4A.default)(props, $727e74205c3a5c3a$var$_excluded2);
    const context = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    const childContext = $jSIPP.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $jSIPP.useRef(null);
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $jSIPP.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $df8809f1fe6fe9b8$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $727e74205c3a5c3a$var$useUtilityClasses(ownerState);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $727e74205c3a5c3a$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $86B3v.default)((0, $2ef1683180bd3785$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $631d68b9552365dc$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d6636f4a32427e55$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $4uaIU.jsxs)($727e74205c3a5c3a$var$ListItemContainer, (0, $erOpW.default)({
                as: ContainerComponent,
                className: (0, $86B3v.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(Root, (0, $erOpW.default)({}, rootProps, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $erOpW.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d6636f4a32427e55$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)(Root, (0, $erOpW.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $erOpW.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $da2e844eb8725d2e$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $727e74205c3a5c3a$export$2e2bcd8739ae039 = $727e74205c3a5c3a$var$ListItem;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $2c5c2c36d42c25cf$export$81478e24460c57f2(slot) {
    return (0, $geF11.default)('MuiListItemIcon', slot);
}
const $2c5c2c36d42c25cf$var$listItemIconClasses = (0, $rARwS.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $2c5c2c36d42c25cf$export$2e2bcd8739ae039 = $2c5c2c36d42c25cf$var$listItemIconClasses;




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $1acb14d046f50c17$var$_excluded = [
    "className"
];
const $1acb14d046f50c17$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $2c5c2c36d42c25cf$export$81478e24460c57f2), classes);
};
const $1acb14d046f50c17$var$ListItemIconRoot = (0, $28RyA.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $1acb14d046f50c17$var$ListItemIcon = /*#__PURE__*/ $jSIPP.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $cMu4A.default)(props, $1acb14d046f50c17$var$_excluded);
    const context = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    const ownerState = (0, $erOpW.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $1acb14d046f50c17$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($1acb14d046f50c17$var$ListItemIconRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $1acb14d046f50c17$export$2e2bcd8739ae039 = $1acb14d046f50c17$var$ListItemIcon;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $2ec73871339adc46$export$2e2bcd8739ae039 = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039);



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $12f78e6e59b7c8a6$export$c6bd6795ed6e3203(slot) {
    return (0, $geF11.default)('MuiList', slot);
}
const $12f78e6e59b7c8a6$var$listClasses = (0, $rARwS.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $12f78e6e59b7c8a6$export$2e2bcd8739ae039 = $12f78e6e59b7c8a6$var$listClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $024b907af2115d57$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $024b907af2115d57$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $12f78e6e59b7c8a6$export$c6bd6795ed6e3203), classes);
};
const $024b907af2115d57$var$ListRoot = (0, $28RyA.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $024b907af2115d57$var$List = /*#__PURE__*/ $jSIPP.forwardRef(function List(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cMu4A.default)(props, $024b907af2115d57$var$_excluded);
    const context = $jSIPP.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $024b907af2115d57$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d6636f4a32427e55$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)($024b907af2115d57$var$ListRoot, (0, $erOpW.default)({
            as: component,
            className: (0, $86B3v.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $024b907af2115d57$export$2e2bcd8739ae039 = $024b907af2115d57$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0e7fc4429164223d$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $bd86ee6e52fc8aba$export$2e2bcd8739ae039 = (0, $0e7fc4429164223d$export$2e2bcd8739ae039);





var $4uaIU = parcelRequire("4uaIU");
'use client';
const $5b20d74b3d0610a4$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $5b20d74b3d0610a4$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $5b20d74b3d0610a4$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $5b20d74b3d0610a4$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $5b20d74b3d0610a4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$5b20d74b3d0610a4$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $5b20d74b3d0610a4$var$MenuList = /*#__PURE__*/ $jSIPP.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $cMu4A.default)(props, $5b20d74b3d0610a4$var$_excluded);
    const listRef = $jSIPP.useRef(null);
    const textCriteriaRef = $jSIPP.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $jSIPP.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $bd86ee6e52fc8aba$export$2e2bcd8739ae039)((0, $2ec73871339adc46$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $2ec73871339adc46$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $5b20d74b3d0610a4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $5b20d74b3d0610a4$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $5b20d74b3d0610a4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $5b20d74b3d0610a4$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $5b20d74b3d0610a4$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $5b20d74b3d0610a4$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $5b20d74b3d0610a4$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $5b20d74b3d0610a4$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $5b20d74b3d0610a4$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $5b20d74b3d0610a4$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $5b20d74b3d0610a4$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $jSIPP.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $jSIPP.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $jSIPP.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $024b907af2115d57$export$2e2bcd8739ae039), (0, $erOpW.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $5b20d74b3d0610a4$export$2e2bcd8739ae039 = $5b20d74b3d0610a4$var$MenuList;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");








var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $73208469ed38da03$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $e0d5cb0991583f89$export$2e2bcd8739ae039 = (0, $73208469ed38da03$export$2e2bcd8739ae039);




function $59925aae262a63be$export$2e2bcd8739ae039(node) {
    const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $87890d34d49f3e82$export$2e2bcd8739ae039 = (0, $59925aae262a63be$export$2e2bcd8739ae039);





var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");


var $jSIPP = parcelRequire("jSIPP");



var $4uaIU = parcelRequire("4uaIU");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $52a926e13f10426d$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $52a926e13f10426d$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $52a926e13f10426d$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $52a926e13f10426d$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $52a926e13f10426d$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $52a926e13f10426d$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($52a926e13f10426d$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $52a926e13f10426d$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$52a926e13f10426d$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $52a926e13f10426d$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $52a926e13f10426d$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $52a926e13f10426d$var$defaultGetTabbable, isEnabled: isEnabled = $52a926e13f10426d$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $jSIPP.useRef(false);
    const sentinelStart = $jSIPP.useRef(null);
    const sentinelEnd = $jSIPP.useRef(null);
    const nodeToRestore = $jSIPP.useRef(null);
    const reactFocusEventTarget = $jSIPP.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $jSIPP.useRef(false);
    const rootRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)((0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $jSIPP.useRef(null);
    $jSIPP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $jSIPP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $jSIPP.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $jSIPP.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $52a926e13f10426d$export$2e2bcd8739ae039 = $52a926e13f10426d$var$FocusTrap;




var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");








var $4uaIU = parcelRequire("4uaIU");
'use client';
const $bab57f2e05a2f14d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $bab57f2e05a2f14d$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $bab57f2e05a2f14d$var$Fade = /*#__PURE__*/ $jSIPP.forwardRef(function Fade(props, ref) {
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5b7c23598e1f29a1$export$2e2bcd8739ae039) } = props, other = (0, $cMu4A.default)(props, $bab57f2e05a2f14d$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $jSIPP.useRef(null);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(nodeRef, (0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0413a8e252ff8408$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $jSIPP.cloneElement(children, (0, $erOpW.default)({
                style: (0, $erOpW.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $bab57f2e05a2f14d$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $bab57f2e05a2f14d$export$2e2bcd8739ae039 = $bab57f2e05a2f14d$var$Fade;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $ab772a40e2d28398$export$9927a91fd93152bd(slot) {
    return (0, $geF11.default)('MuiBackdrop', slot);
}
const $ab772a40e2d28398$var$backdropClasses = (0, $rARwS.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $ab772a40e2d28398$export$2e2bcd8739ae039 = $ab772a40e2d28398$var$backdropClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $34b1b4b654c83e53$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $34b1b4b654c83e53$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $ab772a40e2d28398$export$9927a91fd93152bd), classes);
};
const $34b1b4b654c83e53$var$BackdropRoot = (0, $28RyA.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $34b1b4b654c83e53$var$Backdrop = /*#__PURE__*/ $jSIPP.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $bab57f2e05a2f14d$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $cMu4A.default)(props, $34b1b4b654c83e53$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $34b1b4b654c83e53$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($34b1b4b654c83e53$var$BackdropRoot, (0, $erOpW.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $86B3v.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $erOpW.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $34b1b4b654c83e53$export$2e2bcd8739ae039 = $34b1b4b654c83e53$var$Backdrop;



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $379cdb551edd191f$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $0cb9d96187c28e65$var$isOverflowing(container) {
    const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $59925aae262a63be$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0cb9d96187c28e65$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $0cb9d96187c28e65$var$getPaddingRight(element) {
    return parseInt((0, $59925aae262a63be$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0cb9d96187c28e65$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $0cb9d96187c28e65$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$0cb9d96187c28e65$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0cb9d96187c28e65$export$e1bd0c6150f13d96(element, show);
    });
}
function $0cb9d96187c28e65$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0cb9d96187c28e65$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0cb9d96187c28e65$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0e7fc4429164223d$export$2e2bcd8739ae039)((0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0cb9d96187c28e65$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$0cb9d96187c28e65$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $59925aae262a63be$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0cb9d96187c28e65$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0cb9d96187c28e65$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0cb9d96187c28e65$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0cb9d96187c28e65$var$getHiddenSiblings(container);
        $0cb9d96187c28e65$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0cb9d96187c28e65$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0cb9d96187c28e65$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0cb9d96187c28e65$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0cb9d96187c28e65$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0cb9d96187c28e65$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0cb9d96187c28e65$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0cb9d96187c28e65$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


'use client';
function $d27e0f6ef142d5dd$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $d27e0f6ef142d5dd$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $d27e0f6ef142d5dd$var$defaultManager = new (0, $0cb9d96187c28e65$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $d27e0f6ef142d5dd$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $d27e0f6ef142d5dd$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $jSIPP.useRef({});
    const mountNodeRef = $jSIPP.useRef(null);
    const modalRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $jSIPP.useState(!open);
    const hasTransition = $d27e0f6ef142d5dd$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $d27e0f6ef142d5dd$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $jSIPP.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $55503225f0104895$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0cb9d96187c28e65$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $jSIPP.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $jSIPP.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $jSIPP.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $b4a0caeebed92054$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $erOpW.default)({}, propsEventHandlers, otherHandlers);
        return (0, $erOpW.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $erOpW.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $379cdb551edd191f$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $379cdb551edd191f$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $d27e0f6ef142d5dd$export$2e2bcd8739ae039 = $d27e0f6ef142d5dd$var$useModal;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $114615b34a550449$export$67960e22b12a638d(slot) {
    return (0, $geF11.default)('MuiModal', slot);
}
const $114615b34a550449$var$modalClasses = (0, $rARwS.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $114615b34a550449$export$2e2bcd8739ae039 = $114615b34a550449$var$modalClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $77354a49315afd41$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $77354a49315afd41$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $114615b34a550449$export$67960e22b12a638d), classes);
};
const $77354a49315afd41$var$ModalRoot = (0, $28RyA.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $77354a49315afd41$var$ModalBackdrop = (0, $28RyA.default)((0, $34b1b4b654c83e53$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $77354a49315afd41$var$Modal = /*#__PURE__*/ $jSIPP.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $eyQWd.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $77354a49315afd41$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cMu4A.default)(props, $77354a49315afd41$var$_excluded);
    const propsWithDefaults = (0, $erOpW.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $d27e0f6ef142d5dd$export$2e2bcd8739ae039)((0, $erOpW.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $erOpW.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $77354a49315afd41$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $77354a49315afd41$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $86B3v.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $erOpW.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $86B3v.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $34bbc7ccd9eca5e5$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)(RootSlot, (0, $erOpW.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $4uaIU.jsx)(BackdropSlot, (0, $erOpW.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $52a926e13f10426d$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $jSIPP.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $77354a49315afd41$export$2e2bcd8739ae039 = $77354a49315afd41$var$Modal;




var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $4b6a6a5d2cf45888$export$88f455dd56c95edb(slot) {
    return (0, $geF11.default)('MuiPopover', slot);
}
const $4b6a6a5d2cf45888$var$popoverClasses = (0, $rARwS.default)('MuiPopover', [
    'root',
    'paper'
]);
var $4b6a6a5d2cf45888$export$2e2bcd8739ae039 = $4b6a6a5d2cf45888$var$popoverClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $ef9bb5d67e4c2d21$var$_excluded = [
    "onEntering"
], $ef9bb5d67e4c2d21$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $ef9bb5d67e4c2d21$var$_excluded3 = [
    "slotProps"
];
function $ef9bb5d67e4c2d21$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $ef9bb5d67e4c2d21$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $ef9bb5d67e4c2d21$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $ef9bb5d67e4c2d21$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $ef9bb5d67e4c2d21$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4b6a6a5d2cf45888$export$88f455dd56c95edb), classes);
};
const $ef9bb5d67e4c2d21$export$bcce13685275fc99 = (0, $28RyA.default)((0, $77354a49315afd41$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $ef9bb5d67e4c2d21$export$821346c38a2d9390 = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $ef9bb5d67e4c2d21$var$Popover = /*#__PURE__*/ $jSIPP.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $f0165b03f861203f$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cMu4A.default)(props.TransitionProps, $ef9bb5d67e4c2d21$var$_excluded), other = (0, $cMu4A.default)(props, $ef9bb5d67e4c2d21$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $jSIPP.useRef();
    const handlePaperRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $erOpW.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $ef9bb5d67e4c2d21$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $jSIPP.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $ef9bb5d67e4c2d21$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $2ec73871339adc46$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $ef9bb5d67e4c2d21$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $ef9bb5d67e4c2d21$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $jSIPP.useCallback((elemRect)=>{
        return {
            vertical: $ef9bb5d67e4c2d21$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $ef9bb5d67e4c2d21$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $jSIPP.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $ef9bb5d67e4c2d21$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)($ef9bb5d67e4c2d21$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $ef9bb5d67e4c2d21$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $jSIPP.useState(open);
    const setPositioningStyles = $jSIPP.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $jSIPP.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $jSIPP.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $jSIPP.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $jSIPP.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $e0d5cb0991583f89$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $2ec73871339adc46$export$2e2bcd8739ae039)($ef9bb5d67e4c2d21$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $ef9bb5d67e4c2d21$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $ef9bb5d67e4c2d21$export$821346c38a2d9390;
    const paperProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $erOpW.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $erOpW.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cMu4A.default)(_useSlotProps, $ef9bb5d67e4c2d21$var$_excluded3);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(RootSlot, (0, $erOpW.default)({}, rootProps, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4uaIU.jsx)(PaperSlot, (0, $erOpW.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $ef9bb5d67e4c2d21$export$2e2bcd8739ae039 = $ef9bb5d67e4c2d21$var$Popover;



var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $c05df3cd3331cbdd$export$2cf86a63a84fe23d(slot) {
    return (0, $geF11.default)('MuiMenu', slot);
}
const $c05df3cd3331cbdd$var$menuClasses = (0, $rARwS.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $c05df3cd3331cbdd$export$2e2bcd8739ae039 = $c05df3cd3331cbdd$var$menuClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $49de72d6edae6669$var$_excluded = [
    "onEntering"
], $49de72d6edae6669$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $49de72d6edae6669$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $49de72d6edae6669$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $49de72d6edae6669$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $c05df3cd3331cbdd$export$2cf86a63a84fe23d), classes);
};
const $49de72d6edae6669$var$MenuRoot = (0, $28RyA.default)((0, $ef9bb5d67e4c2d21$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $49de72d6edae6669$export$4f7c51a5920c9f33 = (0, $28RyA.default)((0, $ef9bb5d67e4c2d21$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $49de72d6edae6669$var$MenuMenuList = (0, $28RyA.default)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $49de72d6edae6669$var$Menu = /*#__PURE__*/ $jSIPP.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cMu4A.default)(props.TransitionProps, $49de72d6edae6669$var$_excluded), other = (0, $cMu4A.default)(props, $49de72d6edae6669$var$_excluded2);
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const ownerState = (0, $erOpW.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $49de72d6edae6669$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $jSIPP.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $jSIPP.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $49de72d6edae6669$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)($49de72d6edae6669$var$MenuRoot, (0, $erOpW.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $49de72d6edae6669$var$RTL_ORIGIN : $49de72d6edae6669$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $erOpW.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($49de72d6edae6669$var$MenuMenuList, (0, $erOpW.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $86B3v.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $49de72d6edae6669$export$2e2bcd8739ae039 = $49de72d6edae6669$var$Menu;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");







var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $2d8e1b37dcfe2bf4$export$1061006a0db3aeb5(slot) {
    return (0, $geF11.default)('MuiListItemText', slot);
}
const $2d8e1b37dcfe2bf4$var$listItemTextClasses = (0, $rARwS.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2d8e1b37dcfe2bf4$export$2e2bcd8739ae039 = $2d8e1b37dcfe2bf4$var$listItemTextClasses;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $15ff19484c728f6b$export$515f8c67b5305377(slot) {
    return (0, $geF11.default)('MuiMenuItem', slot);
}
const $15ff19484c728f6b$var$menuItemClasses = (0, $rARwS.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $15ff19484c728f6b$export$2e2bcd8739ae039 = $15ff19484c728f6b$var$menuItemClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $382a7c17a1ce115b$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $382a7c17a1ce115b$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $382a7c17a1ce115b$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $15ff19484c728f6b$export$515f8c67b5305377), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $382a7c17a1ce115b$var$MenuItemRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $382a7c17a1ce115b$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $15ff19484c728f6b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $15ff19484c728f6b$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $15ff19484c728f6b$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $15ff19484c728f6b$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $15ff19484c728f6b$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $1e5363d70c91535a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $1e5363d70c91535a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2d8e1b37dcfe2bf4$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2d8e1b37dcfe2bf4$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $2c5c2c36d42c25cf$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $erOpW.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $2c5c2c36d42c25cf$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $382a7c17a1ce115b$var$MenuItem = /*#__PURE__*/ $jSIPP.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $cMu4A.default)(props, $382a7c17a1ce115b$var$_excluded);
    const context = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    const childContext = $jSIPP.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $jSIPP.useRef(null);
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $382a7c17a1ce115b$var$useUtilityClasses(props);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d6636f4a32427e55$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($382a7c17a1ce115b$var$MenuItemRoot, (0, $erOpW.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $86B3v.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $86B3v.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $382a7c17a1ce115b$export$2e2bcd8739ae039 = $382a7c17a1ce115b$var$MenuItem;



var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $ea61997a00ae89e4$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), 'Logout');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $32f52c28d3e62f25$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');



let $1a27ad101ee89785$var$_ = (t)=>t, $1a27ad101ee89785$var$t;
const $1a27ad101ee89785$var$AccountInfoMenu = ({ open: open, anchorElement: anchorElement, onClose: onClose })=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const pulseLoaderCss = (0, $lebkq.css)($1a27ad101ee89785$var$t || ($1a27ad101ee89785$var$t = $1a27ad101ee89785$var$_`
    justify-content: center;
    align-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  `));
    const username = (0, $41632140e88fef11$export$dd0a697e1782aedd)('username', (0, $875b725466af1357$export$2e2bcd8739ae039).getUser);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $49de72d6edae6669$export$2e2bcd8739ae039), {
        anchorEl: anchorElement,
        open: open,
        onClose: onClose,
        onClick: onClose,
        PaperProps: {
            elevation: 0,
            sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: 'right',
            vertical: 'top'
        },
        anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $727e74205c3a5c3a$export$2e2bcd8739ae039), {
                children: username.data || /*#__PURE__*/ (0, $4uaIU.jsx)((0, $faa4cbee9e7297c6$exports.PulseLoader), {
                    color: "green",
                    css: pulseLoaderCss
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32f52c28d3e62f25$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        })
                    }),
                    "Settings"
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                onClick: ()=>(0, $875b725466af1357$export$2e2bcd8739ae039).logout().then((success)=>history.push('/login')),
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ea61997a00ae89e4$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        })
                    }),
                    "Logout"
                ]
            })
        ]
    });
};
var $1a27ad101ee89785$export$2e2bcd8739ae039 = $1a27ad101ee89785$var$AccountInfoMenu;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");
const $73bf8eec3f8ad359$var$NotificationsMenu = ({})=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
};
var $73bf8eec3f8ad359$export$2e2bcd8739ae039 = $73bf8eec3f8ad359$var$NotificationsMenu;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");
const $3513b9a6261719ab$var$SearchMenu = ({})=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
};
var $3513b9a6261719ab$export$2e2bcd8739ae039 = $3513b9a6261719ab$var$SearchMenu;





const $abb606ea4efaa7cc$var$tooltipSx = {
    m: '1rem'
};
const $abb606ea4efaa7cc$var$buttonColor = 'secondary';
/**
 * Creates the top bar on an iYOTAH application.
 * @param dropDownSx (optional) Material-UI style object for the business drop-down
 * @param buttonSx (optional) Material-UI style object for the menu buttons
 * @returns {JSX.Element} a React component
 * @constructor
 */ const $abb606ea4efaa7cc$var$NavigationTopBar = ({ dropDownSx: dropDownSx, buttonSx: buttonSx })=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const [anchor, setAnchor] = (0, $jSIPP.useState)(null);
    const [accountInfoOpen, setAccountInfoOpen] = (0, $jSIPP.useState)(false);
    const [helpOpen, setHelpOpen] = (0, $jSIPP.useState)(false);
    const [searchOpen, setSearchOpen] = (0, $jSIPP.useState)(false);
    const [notificationsOpen, setNotificationsOpen] = (0, $jSIPP.useState)(false);
    const handleAccountInfoClose = ()=>{
        setAccountInfoOpen(false);
        setAnchor(null);
    };
    const handleHelpClose = ()=>{
        setHelpOpen(false);
        setAnchor(null);
    };
    const handleSearchClose = ()=>{
        setSearchOpen(false);
        setAnchor(null);
    };
    const handleNotificationsClose = ()=>{
        setNotificationsOpen(false);
        setAnchor(null);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $16163943546fd5cc$export$2e2bcd8739ae039), {
        sx: {
            zIndex: (theme)=>theme.zIndex.drawer,
            display: 'flex',
            flexDirection: 'row'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    flexBasis: (theme)=>{
                        var _theme_components_MuiDrawer_styleOverrides_root, _theme_components_MuiDrawer_styleOverrides, _theme_components_MuiDrawer;
                        return (_theme_components_MuiDrawer = theme.components.MuiDrawer) === null || _theme_components_MuiDrawer === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides = _theme_components_MuiDrawer.styleOverrides) === null || _theme_components_MuiDrawer_styleOverrides === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides_root = _theme_components_MuiDrawer_styleOverrides.root) === null || _theme_components_MuiDrawer_styleOverrides_root === void 0 ? void 0 : _theme_components_MuiDrawer_styleOverrides_root.width;
                    }
                }
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $bd1f60c2e68e18de$export$2e2bcd8739ae039), {
                dropDownSx: dropDownSx,
                logoutCallback: ()=>(0, $875b725466af1357$export$2e2bcd8739ae039).logout().then((_)=>history.push('/login')),
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        sx: $abb606ea4efaa7cc$var$tooltipSx,
                        title: "Search Features",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            onClick: ()=>setSearchOpen(true),
                            size: "small",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e1169d4212503850$export$2e2bcd8739ae039), {
                                color: $abb606ea4efaa7cc$var$buttonColor,
                                sx: buttonSx
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        sx: $abb606ea4efaa7cc$var$tooltipSx,
                        title: "Help",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            onClick: ()=>setHelpOpen(true),
                            size: "small",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b2cf82681d9ad200$export$2e2bcd8739ae039), {
                                color: $abb606ea4efaa7cc$var$buttonColor,
                                sx: buttonSx
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        sx: $abb606ea4efaa7cc$var$tooltipSx,
                        title: "Account settings",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            onClick: ()=>setAccountInfoOpen(true),
                            size: "small",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $24ba8a9e95709c58$export$2e2bcd8739ae039), {
                                color: $abb606ea4efaa7cc$var$buttonColor,
                                sx: buttonSx
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        sx: $abb606ea4efaa7cc$var$tooltipSx,
                        title: "Notifications",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            onClick: ()=>setNotificationsOpen(true),
                            size: "small",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0687164827b29e58$export$2e2bcd8739ae039), {
                                color: $abb606ea4efaa7cc$var$buttonColor,
                                sx: buttonSx
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1a27ad101ee89785$export$2e2bcd8739ae039), {
                open: accountInfoOpen,
                anchorElement: anchor,
                onClose: handleAccountInfoClose
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $da8c0916be2f7f28$export$2e2bcd8739ae039), {
                open: helpOpen,
                anchor: anchor,
                onClose: handleHelpClose
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $3513b9a6261719ab$export$2e2bcd8739ae039), {
                open: searchOpen,
                anchor: anchor,
                onClose: handleSearchClose
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $73bf8eec3f8ad359$export$2e2bcd8739ae039), {
                open: notificationsOpen,
                anchor: anchor,
                onClose: handleNotificationsClose
            })
        ]
    });
};
var $abb606ea4efaa7cc$export$2e2bcd8739ae039 = $abb606ea4efaa7cc$var$NavigationTopBar;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");












var $4uaIU = parcelRequire("4uaIU");
'use client';
const $cffd9a96dba2f325$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $cffd9a96dba2f325$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $cffd9a96dba2f325$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $cffd9a96dba2f325$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $cffd9a96dba2f325$var$resolveContainer(containerProp);
    const transform = $cffd9a96dba2f325$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $cffd9a96dba2f325$var$Slide = /*#__PURE__*/ $jSIPP.forwardRef(function Slide(props, ref) {
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5b7c23598e1f29a1$export$2e2bcd8739ae039) } = props, other = (0, $cMu4A.default)(props, $cffd9a96dba2f325$var$_excluded);
    const childrenRef = $jSIPP.useRef(null);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)((0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $cffd9a96dba2f325$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $0413a8e252ff8408$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $erOpW.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $erOpW.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $cffd9a96dba2f325$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $jSIPP.useCallback(()=>{
        if (childrenRef.current) $cffd9a96dba2f325$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $jSIPP.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $e0d5cb0991583f89$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $cffd9a96dba2f325$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $jSIPP.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $jSIPP.cloneElement(children, (0, $erOpW.default)({
                ref: handleRef,
                style: (0, $erOpW.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $cffd9a96dba2f325$export$2e2bcd8739ae039 = $cffd9a96dba2f325$var$Slide;




var $iLAKr = parcelRequire("iLAKr");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $5b4edb0201f3f4c6$export$b801318a856c9cd2(slot) {
    return (0, $geF11.default)('MuiDrawer', slot);
}
const $5b4edb0201f3f4c6$var$drawerClasses = (0, $rARwS.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $5b4edb0201f3f4c6$export$2e2bcd8739ae039 = $5b4edb0201f3f4c6$var$drawerClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $5453556d10c0b59f$var$_excluded = [
    "BackdropProps"
], $5453556d10c0b59f$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $5453556d10c0b59f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $5453556d10c0b59f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $iLAKr.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $iLAKr.default)(anchor)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $5b4edb0201f3f4c6$export$b801318a856c9cd2), classes);
};
const $5453556d10c0b59f$var$DrawerRoot = (0, $28RyA.default)((0, $77354a49315afd41$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $5453556d10c0b59f$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $5453556d10c0b59f$var$DrawerDockedRoot = (0, $28RyA.default)('div', {
    shouldForwardProp: (0, $hDFpT.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $5453556d10c0b59f$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $5453556d10c0b59f$var$DrawerPaper = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $iLAKr.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $iLAKr.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $5453556d10c0b59f$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $5453556d10c0b59f$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $5453556d10c0b59f$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $5453556d10c0b59f$export$2a62b49acb270576(anchor) ? $5453556d10c0b59f$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $5453556d10c0b59f$var$Drawer = /*#__PURE__*/ $jSIPP.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $cffd9a96dba2f325$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $cMu4A.default)(props.ModalProps, $5453556d10c0b59f$var$_excluded), other = (0, $cMu4A.default)(props, $5453556d10c0b59f$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $jSIPP.useRef(false);
    $jSIPP.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $5453556d10c0b59f$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $erOpW.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $5453556d10c0b59f$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $4uaIU.jsx)($5453556d10c0b59f$var$DrawerPaper, (0, $erOpW.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $86B3v.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $4uaIU.jsx)($5453556d10c0b59f$var$DrawerDockedRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        in: open,
        direction: $5453556d10c0b59f$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $4uaIU.jsx)($5453556d10c0b59f$var$DrawerDockedRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $4uaIU.jsx)($5453556d10c0b59f$var$DrawerRoot, (0, $erOpW.default)({
        BackdropProps: (0, $erOpW.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $86B3v.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $5453556d10c0b59f$export$2e2bcd8739ae039 = $5453556d10c0b59f$var$Drawer;



var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $9a4a40369a948bf0$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"
}), 'Business');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $5502709f5bcd6809$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1m-1 9h-4v-7h4z"
}), 'Devices');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $871efd7d06c16c30$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5M22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1m-1 10h-4v-8h4z"
}), 'DevicesOther');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $2b718c20f051d14e$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-6 12v-3h-4v-4h4V8l5 5z"
}), 'DriveFileMove');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $d51c17d0a0c17744$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2zm-5-5.17 1 1V10h-2V7.83l.41-.41zm-4 0 .59.59.41.41V10h-2V7.83l.41-.41zM11 14v-2h2v2zm2 2v2h-2v-2zM7 7.83l1-1 .59.59.41.41V10H7zM7 12h2v2H7zm0 4h2v2H7zm10 2h-2v-2h2zm0-4h-2v-2h2z"
}), 'Fence');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $8e60f071a6b5a073$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M18 6H9V4H7v2H6l-4 4v9h20v-9zM4 12h10v5H4zm16 5h-4v-6.17l2-2 2 2z"
}), 'Gite');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $fd3afa68e7175ef8$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M3 17v2h6v-2zM3 5v2h10V5zm10 16v-2h8v-2h-8v-2h-2v6zM7 9v2H3v2h4v2h2V9zm14 4v-2H11v2zm-6-4h2V7h4V5h-4V3h-2z"
}), 'Tune');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $626ddfa286c0f1fd$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M5 20h14v-2H5zm0-10h4v6h6v-6h4l-7-7z"
}), 'Upload');



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");






var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f3ccabdfeb3cc4ff$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $f3ccabdfeb3cc4ff$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $f3ccabdfeb3cc4ff$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $838ddd48e93a7ef3$export$c09531d8563c67a5), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $f3ccabdfeb3cc4ff$var$ListItemButtonRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $f3ccabdfeb3cc4ff$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $838ddd48e93a7ef3$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $f3ccabdfeb3cc4ff$var$ListItemButton = /*#__PURE__*/ $jSIPP.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $cMu4A.default)(props, $f3ccabdfeb3cc4ff$var$_excluded);
    const context = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    const childContext = $jSIPP.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $jSIPP.useRef(null);
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $f3ccabdfeb3cc4ff$var$useUtilityClasses(ownerState);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d6636f4a32427e55$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($f3ccabdfeb3cc4ff$var$ListItemButtonRoot, (0, $erOpW.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $86B3v.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $86B3v.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $f3ccabdfeb3cc4ff$export$2e2bcd8739ae039 = $f3ccabdfeb3cc4ff$var$ListItemButton;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");



var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");


var $4uaIU = parcelRequire("4uaIU");
'use client';
const $0f9d457d20374390$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0f9d457d20374390$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $2d8e1b37dcfe2bf4$export$1061006a0db3aeb5), classes);
};
const $0f9d457d20374390$var$ListItemTextRoot = (0, $28RyA.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2d8e1b37dcfe2bf4$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2d8e1b37dcfe2bf4$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0f9d457d20374390$var$ListItemText = /*#__PURE__*/ $jSIPP.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $cMu4A.default)(props, $0f9d457d20374390$var$_excluded);
    const { dense: dense } = $jSIPP.useContext((0, $d6636f4a32427e55$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $erOpW.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0f9d457d20374390$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $4acc79473d417315$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), (0, $erOpW.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $4acc79473d417315$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), (0, $erOpW.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($0f9d457d20374390$var$ListItemTextRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0f9d457d20374390$export$2e2bcd8739ae039 = $0f9d457d20374390$var$ListItemText;


const $20f2ad87ec5c7ace$var$defaultItemSx = {
    flexFlow: 'column'
};
const $20f2ad87ec5c7ace$var$defaultIconSx = {
    mx: 'auto'
};
const $20f2ad87ec5c7ace$var$defaultTextSx = {
    fontSize: '.6rem',
    fontWeight: '700',
    textAlign: 'center'
};
const $20f2ad87ec5c7ace$var$SidebarAction = ({ actionCallback: actionCallback, label: label, icon: icon, isActive: isActive, itemSx: itemSx, iconSx: iconSx, textSx: textSx })=>{
    const Icon = icon;
    const color = isActive ? 'primary' : 'secondary';
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f3ccabdfeb3cc4ff$export$2e2bcd8739ae039), {
        onClick: actionCallback,
        sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $20f2ad87ec5c7ace$var$defaultItemSx, itemSx),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                sx: {
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, {
                    color: color,
                    fontSize: "large",
                    sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $20f2ad87ec5c7ace$var$defaultIconSx, iconSx)
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                primary: label,
                primaryTypographyProps: {
                    color: color,
                    sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $20f2ad87ec5c7ace$var$defaultTextSx, textSx)
                }
            })
        ]
    });
};
var $20f2ad87ec5c7ace$export$2e2bcd8739ae039 = $20f2ad87ec5c7ace$var$SidebarAction;



const $859d4f8d61c2422d$var$SidebarLink = ({ link: link, postAction: postAction, label: label, icon: icon, itemSx: itemSx, iconSx: iconSx, textSx: textSx })=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const redirect = ()=>history.push(link);
    const fn = postAction ? async ()=>{
        redirect();
        await postAction();
    } : redirect;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $20f2ad87ec5c7ace$export$2e2bcd8739ae039), {
        label: label,
        icon: icon,
        actionCallback: fn,
        isActive: window.location.pathname.includes(link),
        itemSx: itemSx || {},
        textSx: textSx || {},
        iconSx: iconSx || {}
    });
};
var $859d4f8d61c2422d$export$2e2bcd8739ae039 = $859d4f8d61c2422d$var$SidebarLink;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $12414453a5cd0541$exports = {};
$12414453a5cd0541$exports = $parcel$resolve("3FzEg");


const $279650a9b597db44$var$SidebarImage = ()=>{
    var _theme_components_MuiDrawer_styleOverrides_root, _theme_components_MuiDrawer_styleOverrides, _theme_components_MuiDrawer;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const maxWidth = (_theme_components_MuiDrawer = theme.components.MuiDrawer) === null || _theme_components_MuiDrawer === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides = _theme_components_MuiDrawer.styleOverrides) === null || _theme_components_MuiDrawer_styleOverrides === void 0 ? void 0 : (_theme_components_MuiDrawer_styleOverrides_root = _theme_components_MuiDrawer_styleOverrides.root) === null || _theme_components_MuiDrawer_styleOverrides_root === void 0 ? void 0 : _theme_components_MuiDrawer_styleOverrides_root.width;
    // return (<img src={logo} alt='Logo' style={{maxWidth}} />);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {});
};
var $279650a9b597db44$export$2e2bcd8739ae039 = $279650a9b597db44$var$SidebarImage;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

const $7079582c2da0c4de$var$Home = ({ color: color })=>{
    // Colours come from the theme so the icon tracks it.
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const tempColor = color === 'secondary' ? theme.palette.text.secondary : theme.palette.primary.main;
    return /*#__PURE__*/ (0, $4uaIU.jsx)("svg", {
        width: "29",
        height: "26",
        viewBox: "0 0 29 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
            d: "M28.7332 11.9976L25.7783 9.36558V2.43648C25.7783 2.22099 25.6934 2.01433 25.5423 1.86196C25.3913 1.70958 25.1864 1.62398 24.9727 1.62398H21.7505C21.5369 1.62398 21.332 1.70958 21.1809 1.86196C21.0298 2.01433 20.9449 2.22099 20.9449 2.43648V5.06136L15.8473 0.522536C15.4785 0.186213 14.999 0 14.5018 0C14.0045 0 13.5251 0.186213 13.1562 0.522536L0.267341 11.9991C0.188609 12.0704 0.124577 12.1567 0.078903 12.2529C0.0332295 12.3492 0.00680944 12.4536 0.00115213 12.5602C-0.00450517 12.6668 0.0107111 12.7734 0.0459318 12.8741C0.0811524 12.9747 0.135687 13.0674 0.206421 13.1468L1.28435 14.3548C1.35505 14.4343 1.44057 14.4988 1.53602 14.5449C1.63148 14.591 1.73499 14.6176 1.84066 14.6233C1.94632 14.629 2.05207 14.6137 2.15185 14.5782C2.25163 14.5426 2.3435 14.4876 2.4222 14.4163L13.9678 4.14425C14.115 4.0133 14.3045 3.94104 14.5008 3.94104C14.697 3.94104 14.8865 4.0133 15.0337 4.14425L26.5793 14.4158C26.658 14.4871 26.7499 14.5421 26.8497 14.5776C26.9494 14.6132 27.0552 14.6285 27.1608 14.6228C27.2665 14.6171 27.37 14.5905 27.4655 14.5444C27.5609 14.4983 27.6465 14.4337 27.7171 14.3543L28.7946 13.1447C28.9372 12.9844 29.0109 12.7734 28.9994 12.5583C28.9878 12.3432 28.8921 12.1415 28.7332 11.9976ZM14.5005 5.83882L3.49812 15.6249C3.41656 15.699 3.31234 15.7336 3.22272 15.795V25.1865C3.22272 25.402 3.30759 25.6086 3.45866 25.761C3.60974 25.9134 3.81463 25.999 4.02828 25.999H10.4727C10.6864 25.999 10.8913 25.9134 11.0423 25.761C11.1934 25.6086 11.2783 25.402 11.2783 25.1865V18.6865C11.2783 18.471 11.3631 18.2643 11.5142 18.112C11.6653 17.9596 11.8702 17.874 12.0838 17.874H16.9172C17.1308 17.874 17.3357 17.9596 17.4868 18.112C17.6379 18.2643 17.7227 18.471 17.7227 18.6865V25.1865C17.7227 25.402 17.8076 25.6086 17.9587 25.761C18.1097 25.9134 18.3146 25.999 18.5283 25.999H24.9727C25.1864 25.999 25.3913 25.9134 25.5423 25.761C25.6934 25.6086 25.7783 25.402 25.7783 25.1865V15.797C25.6927 15.7381 25.591 15.7046 25.5135 15.6345L14.5005 5.83882Z",
            fill: tempColor
        })
    });
};
var $7079582c2da0c4de$export$2e2bcd8739ae039 = $7079582c2da0c4de$var$Home;




const $87d570419464f5a2$var$NavigationSideBar = ()=>{
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const [_, setActivePath] = (0, $jSIPP.useState)(window.location.pathname);
    const updateActiveLink = ()=>setActivePath(window.location.pathname);
    const itemSpacing = 8;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $5453556d10c0b59f$export$2e2bcd8739ae039), {
        anchor: "left",
        open: true,
        variant: "permanent",
        PaperProps: {
            sx: {
                boxSizing: 'border-box',
                boxShadow: 24,
                [theme.breakpoints.down('md')]: {
                    display: 'none'
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $279650a9b597db44$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    overflow: 'auto'
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $024b907af2115d57$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: 4
                            },
                            link: '/home',
                            label: "HOME",
                            icon: (0, $7079582c2da0c4de$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/owners',
                            label: "OWNERS",
                            icon: (0, $8e60f071a6b5a073$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/providers',
                            label: "PROVIDERS",
                            icon: (0, $5502709f5bcd6809$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/provider-thresholds',
                            label: "PROVIDER THRESHOLDS",
                            icon: (0, $fd3afa68e7175ef8$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/pen-health',
                            label: "PEN HEALTH",
                            icon: (0, $d51c17d0a0c17744$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/data-streams',
                            label: "DATASTREAMS",
                            icon: (0, $2b718c20f051d14e$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/consumers',
                            label: "CONSUMERS",
                            icon: (0, $9a4a40369a948bf0$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/consumerTypes',
                            label: "CONSUMER TYPES",
                            icon: (0, $626ddfa286c0f1fd$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $859d4f8d61c2422d$export$2e2bcd8739ae039), {
                            itemSx: {
                                mt: itemSpacing
                            },
                            link: '/devices',
                            label: "DEVICES",
                            icon: (0, $871efd7d06c16c30$export$2e2bcd8739ae039),
                            postAction: updateActiveLink
                        })
                    ]
                })
            })
        ]
    });
};
var $87d570419464f5a2$export$2e2bcd8739ae039 = $87d570419464f5a2$var$NavigationSideBar;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $302e93b3634afd5b$export$5524f0b1f990b0b8(slot) {
    return (0, $geF11.default)('MuiBottomNavigation', slot);
}
const $302e93b3634afd5b$var$bottomNavigationClasses = (0, $rARwS.default)('MuiBottomNavigation', [
    'root'
]);
var $302e93b3634afd5b$export$2e2bcd8739ae039 = $302e93b3634afd5b$var$bottomNavigationClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $6734f0ebac21d317$var$_excluded = [
    "children",
    "className",
    "component",
    "onChange",
    "showLabels",
    "value"
];
const $6734f0ebac21d317$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $302e93b3634afd5b$export$5524f0b1f990b0b8), classes);
};
const $6734f0ebac21d317$var$BottomNavigationRoot = (0, $28RyA.default)('div', {
    name: 'MuiBottomNavigation',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        height: 56,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $6734f0ebac21d317$var$BottomNavigation = /*#__PURE__*/ $jSIPP.forwardRef(function BottomNavigation(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigation'
    });
    const { children: children, className: className, component: component = 'div', onChange: onChange, showLabels: showLabels = false, value: value } = props, other = (0, $cMu4A.default)(props, $6734f0ebac21d317$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        showLabels: showLabels
    });
    const classes = $6734f0ebac21d317$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($6734f0ebac21d317$var$BottomNavigationRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: $jSIPP.Children.map(children, (child, childIndex)=>{
            if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) return null;
            const childValue = child.props.value === undefined ? childIndex : child.props.value;
            return /*#__PURE__*/ $jSIPP.cloneElement(child, {
                selected: childValue === value,
                showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
                value: childValue,
                onChange: onChange
            });
        })
    }));
});
var $6734f0ebac21d317$export$2e2bcd8739ae039 = $6734f0ebac21d317$var$BottomNavigation;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $d3d6da774e29adce$export$c91cad6db86415ef(slot) {
    return (0, $geF11.default)('MuiBottomNavigationAction', slot);
}
const $d3d6da774e29adce$var$bottomNavigationActionClasses = (0, $rARwS.default)('MuiBottomNavigationAction', [
    'root',
    'iconOnly',
    'selected',
    'label'
]);
var $d3d6da774e29adce$export$2e2bcd8739ae039 = $d3d6da774e29adce$var$bottomNavigationActionClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $1724e373d7fa3af3$var$_excluded = [
    "className",
    "icon",
    "label",
    "onChange",
    "onClick",
    "selected",
    "showLabel",
    "value"
];
const $1724e373d7fa3af3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, showLabel: showLabel, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ],
        label: [
            'label',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $d3d6da774e29adce$export$c91cad6db86415ef), classes);
};
const $1724e373d7fa3af3$var$BottomNavigationActionRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    name: 'MuiBottomNavigationAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.showLabel && !ownerState.selected && styles.iconOnly
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        transition: theme.transitions.create([
            'color',
            'padding-top'
        ], {
            duration: theme.transitions.duration.short
        }),
        padding: '0px 12px',
        minWidth: 80,
        maxWidth: 168,
        color: (theme.vars || theme).palette.text.secondary,
        flexDirection: 'column',
        flex: '1'
    }, !ownerState.showLabel && !ownerState.selected && {
        paddingTop: 14
    }, !ownerState.showLabel && !ownerState.selected && !ownerState.label && {
        paddingTop: 0
    }, {
        [`&.${(0, $d3d6da774e29adce$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        }
    }));
const $1724e373d7fa3af3$var$BottomNavigationActionLabel = (0, $28RyA.default)('span', {
    name: 'MuiBottomNavigationAction',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        opacity: 1,
        transition: 'font-size 0.2s, opacity 0.2s',
        transitionDelay: '0.1s'
    }, !ownerState.showLabel && !ownerState.selected && {
        opacity: 0,
        transitionDelay: '0s'
    }, {
        [`&.${(0, $d3d6da774e29adce$export$2e2bcd8739ae039).selected}`]: {
            fontSize: theme.typography.pxToRem(14)
        }
    }));
const $1724e373d7fa3af3$var$BottomNavigationAction = /*#__PURE__*/ $jSIPP.forwardRef(function BottomNavigationAction(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigationAction'
    });
    const { className: className, icon: icon, label: label, onChange: onChange, onClick: onClick, value: value } = props, other = (0, $cMu4A.default)(props, $1724e373d7fa3af3$var$_excluded);
    const ownerState = props;
    const classes = $1724e373d7fa3af3$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($1724e373d7fa3af3$var$BottomNavigationActionRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        focusRipple: true,
        onClick: handleChange,
        ownerState: ownerState
    }, other, {
        children: [
            icon,
            /*#__PURE__*/ (0, $4uaIU.jsx)($1724e373d7fa3af3$var$BottomNavigationActionLabel, {
                className: classes.label,
                ownerState: ownerState,
                children: label
            })
        ]
    }));
});
var $1724e373d7fa3af3$export$2e2bcd8739ae039 = $1724e373d7fa3af3$var$BottomNavigationAction;




const $3699162d32a732ad$var$NavigationBottomBar = ()=>{
    const [activeButton, setActiveButton] = (0, $jSIPP.useState)(window.location.pathname);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
        elevation: 3,
        sx: {
            display: {
                xs: 'flex',
                md: 'none'
            },
            height: '4.3rem',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0
        },
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $6734f0ebac21d317$export$2e2bcd8739ae039), {
            sx: {
                width: '100%',
                height: '100%'
            },
            showLabels: true,
            value: activeButton,
            onChange: (event, newValue)=>{
                setActiveButton(newValue);
            },
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1724e373d7fa3af3$export$2e2bcd8739ae039), {
                    label: "Home",
                    icon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7079582c2da0c4de$export$2e2bcd8739ae039), {}),
                    component: (0, $b2d572a11ba9d27b$export$a6c7ac8248d6e38a),
                    to: "/"
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1724e373d7fa3af3$export$2e2bcd8739ae039), {
                    label: "Owners",
                    icon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8e60f071a6b5a073$export$2e2bcd8739ae039), {}),
                    component: (0, $b2d572a11ba9d27b$export$a6c7ac8248d6e38a),
                    to: "/owners"
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1724e373d7fa3af3$export$2e2bcd8739ae039), {
                    label: "Providers",
                    icon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5502709f5bcd6809$export$2e2bcd8739ae039), {}),
                    component: (0, $b2d572a11ba9d27b$export$a6c7ac8248d6e38a),
                    to: "/providers"
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1724e373d7fa3af3$export$2e2bcd8739ae039), {
                    label: "Consumers",
                    icon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9a4a40369a948bf0$export$2e2bcd8739ae039), {}),
                    component: (0, $b2d572a11ba9d27b$export$a6c7ac8248d6e38a),
                    to: "/consumers"
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1724e373d7fa3af3$export$2e2bcd8739ae039), {
                    label: "Data Streams",
                    icon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2b718c20f051d14e$export$2e2bcd8739ae039), {}),
                    component: (0, $b2d572a11ba9d27b$export$a6c7ac8248d6e38a),
                    to: "/data-streams"
                })
            ]
        })
    });
};
var $3699162d32a732ad$export$2e2bcd8739ae039 = $3699162d32a732ad$var$NavigationBottomBar;




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");
function $88acaab230877f70$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $287e58e413d8005e$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $88acaab230877f70$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

function $5775f7ba75513da6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5775f7ba75513da6$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $5775f7ba75513da6$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


/**
 * Sets up a route that is only accessible under specified conditions.
 * When making a new conditional route, make sure to double-check the redirect logic in both your new route, the
 * redirected route, and wherever that route may redirect.  It is very possible to end up in "Redirect Hell", where the
 * UI redirects to many different pages.  You can also end up in an infinite redirect loop this way.
 *
 * @param conditionCallback async callback function to determine accessibility.
 * @param render components to render when route is accessible.
 * @param failRedirect if inaccessible, specify where to redirect.  Defaults to 404 page.
 * @param loadMessage message to display while determining page accessibility.
 * @param props any additional props to pass the inner Route component.
 * @returns {JSX.Element} a conditionally accessible Route.
 * @constructor
 */ const $1792dc418e70ff3a$var$ConditionalRoute = ({ conditionCallback: conditionCallback, render: render, failRedirect: failRedirect = '/404', loadMessage: loadMessage = 'Loading...', props: routeProps })=>{
    const [toRender, setToRender] = (0, $jSIPP.useState)();
    (0, $jSIPP.useEffect)(()=>{
        conditionCallback().then((bool)=>setToRender(bool));
    }, [
        setToRender
    ]);
    if (toRender === false) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$2d8d895a0a0f636e), {
        to: {
            pathname: failRedirect
        }
    });
    else if (toRender === true) {
        const _render = render || ((_)=>children);
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$e7b0ac011bb776c6), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, routeProps), {
            render: (props)=>_render(props)
        }));
    } else return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
        variant: "h3",
        children: loadMessage
    });
};
var $1792dc418e70ff3a$export$2e2bcd8739ae039 = $1792dc418e70ff3a$var$ConditionalRoute;



const $32beac86d7bb7278$var$PrivateRoute = (_param)=>{
    var { children: children, render: render } = _param, att = (0, $287e58e413d8005e$export$71511d61b312f219)(_param, [
        "children",
        "render"
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1792dc418e70ff3a$export$2e2bcd8739ae039), {
        conditionCallback: (0, $875b725466af1357$export$2e2bcd8739ae039).isLoggedIn,
        render: render || ((_)=>children),
        failRedirect: "/login",
        loadMessage: "Checking for Session...",
        props: att
    });
};
var $32beac86d7bb7278$export$2e2bcd8739ae039 = $32beac86d7bb7278$var$PrivateRoute;



var $4uaIU = parcelRequire("4uaIU");

var $ghfJh = parcelRequire("ghfJh");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");




'use client';
const $7d68be6e87e0e274$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $7d68be6e87e0e274$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $7d68be6e87e0e274$var$_excluded3 = [
    "component"
];
function $7d68be6e87e0e274$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $cMu4A.default)(parameters, $7d68be6e87e0e274$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $cMu4A.default)(externalForwardedProps, $7d68be6e87e0e274$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $0afa2b041c6cd8ec$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $e10599cdc4641760$export$2e2bcd8739ae039)((0, $erOpW.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $cMu4A.default)(_mergeSlotProps.props, $7d68be6e87e0e274$var$_excluded3);
    const ref = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $erOpW.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $82d40f9825b384d1$export$2e2bcd8739ae039)(elementType, (0, $erOpW.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $iLAKr = parcelRequire("iLAKr");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $25d3159a5585e505$export$69aecd24bc2cf7e3(slot) {
    return (0, $geF11.default)('MuiAlert', slot);
}
const $25d3159a5585e505$var$alertClasses = (0, $rARwS.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $25d3159a5585e505$export$2e2bcd8739ae039 = $25d3159a5585e505$var$alertClasses;



parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $2133e20efef458c5$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $921907d25ae05e9c$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $969ea87ee02660c0$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $d4c36881b7713553$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $6782c963a94e5c86$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $b26ccb6af59d84c4$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $b26ccb6af59d84c4$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iLAKr.default)(color || severity)}`,
            `${variant}${(0, $iLAKr.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $25d3159a5585e505$export$69aecd24bc2cf7e3), classes);
};
const $b26ccb6af59d84c4$var$AlertRoot = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iLAKr.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $hnF8Y.darken) : (0, $hnF8Y.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $hnF8Y.lighten) : (0, $hnF8Y.darken);
    return (0, $erOpW.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $25d3159a5585e505$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $25d3159a5585e505$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $erOpW.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $b26ccb6af59d84c4$var$AlertIcon = (0, $28RyA.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $b26ccb6af59d84c4$var$AlertMessage = (0, $28RyA.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $b26ccb6af59d84c4$var$AlertAction = (0, $28RyA.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $b26ccb6af59d84c4$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2133e20efef458c5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $921907d25ae05e9c$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $969ea87ee02660c0$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d4c36881b7713553$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $b26ccb6af59d84c4$var$Alert = /*#__PURE__*/ $jSIPP.forwardRef(function Alert(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $b26ccb6af59d84c4$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $cMu4A.default)(props, $b26ccb6af59d84c4$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $b26ccb6af59d84c4$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $erOpW.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $erOpW.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $7d68be6e87e0e274$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $f39aadf3bf12995a$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $7d68be6e87e0e274$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $6782c963a94e5c86$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($b26ccb6af59d84c4$var$AlertRoot, (0, $erOpW.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $4uaIU.jsx)($b26ccb6af59d84c4$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $b26ccb6af59d84c4$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $4uaIU.jsx)($b26ccb6af59d84c4$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $4uaIU.jsx)($b26ccb6af59d84c4$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $4uaIU.jsx)($b26ccb6af59d84c4$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(CloseButtonSlot, (0, $erOpW.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)(CloseIconSlot, (0, $erOpW.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $b26ccb6af59d84c4$export$2e2bcd8739ae039 = $b26ccb6af59d84c4$var$Alert;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $091d080cd8904216$export$5269a5bce2c2f987(slot) {
    return (0, $geF11.default)('MuiAlertTitle', slot);
}
const $091d080cd8904216$var$alertTitleClasses = (0, $rARwS.default)('MuiAlertTitle', [
    'root'
]);
var $091d080cd8904216$export$2e2bcd8739ae039 = $091d080cd8904216$var$alertTitleClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $bf1395812ba8dabb$var$_excluded = [
    "className"
];
const $bf1395812ba8dabb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $091d080cd8904216$export$5269a5bce2c2f987), classes);
};
const $bf1395812ba8dabb$var$AlertTitleRoot = (0, $28RyA.default)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $bf1395812ba8dabb$var$AlertTitle = /*#__PURE__*/ $jSIPP.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className } = props, other = (0, $cMu4A.default)(props, $bf1395812ba8dabb$var$_excluded);
    const ownerState = props;
    const classes = $bf1395812ba8dabb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($bf1395812ba8dabb$var$AlertTitleRoot, (0, $erOpW.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className)
    }, other));
});
var $bf1395812ba8dabb$export$2e2bcd8739ae039 = $bf1395812ba8dabb$var$AlertTitle;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $3Tcpe = parcelRequire("3Tcpe");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");


var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $c012e2d42bcddb72$export$5a6f9035944c8119(slot) {
    return (0, $geF11.default)('MuiButton', slot);
}
const $c012e2d42bcddb72$var$buttonClasses = (0, $rARwS.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $c012e2d42bcddb72$export$2e2bcd8739ae039 = $c012e2d42bcddb72$var$buttonClasses;



var $jSIPP = parcelRequire("jSIPP");
/**
 * @ignore - internal component.
 */ const $de1b57a2a7305b47$var$ButtonGroupContext = /*#__PURE__*/ $jSIPP.createContext({});
var $de1b57a2a7305b47$export$2e2bcd8739ae039 = $de1b57a2a7305b47$var$ButtonGroupContext;



var $jSIPP = parcelRequire("jSIPP");
/**
 * @ignore - internal component.
 */ const $63166dd08f8b5163$var$ButtonGroupButtonContext = /*#__PURE__*/ $jSIPP.createContext(undefined);
var $63166dd08f8b5163$export$2e2bcd8739ae039 = $63166dd08f8b5163$var$ButtonGroupButtonContext;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $681a423b309f05b8$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $681a423b309f05b8$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $iLAKr.default)(color)}`,
            `size${(0, $iLAKr.default)(size)}`,
            `${variant}Size${(0, $iLAKr.default)(size)}`,
            `color${(0, $iLAKr.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $iLAKr.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $iLAKr.default)(size)}`
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $c012e2d42bcddb72$export$5a6f9035944c8119), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $681a423b309f05b8$var$commonIconStyles = (ownerState)=>(0, $erOpW.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $681a423b309f05b8$var$ButtonRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iLAKr.default)(ownerState.color)}`],
            styles[`size${(0, $iLAKr.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $iLAKr.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $erOpW.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $erOpW.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $erOpW.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $c012e2d42bcddb72$export$2e2bcd8739ae039).focusVisible}`]: (0, $erOpW.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $c012e2d42bcddb72$export$2e2bcd8739ae039).disabled}`]: (0, $erOpW.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $c012e2d42bcddb72$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $c012e2d42bcddb72$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $681a423b309f05b8$var$ButtonStartIcon = (0, $28RyA.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $iLAKr.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $681a423b309f05b8$var$commonIconStyles(ownerState)));
const $681a423b309f05b8$var$ButtonEndIcon = (0, $28RyA.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $iLAKr.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $681a423b309f05b8$var$commonIconStyles(ownerState)));
const $681a423b309f05b8$var$Button = /*#__PURE__*/ $jSIPP.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $jSIPP.useContext((0, $de1b57a2a7305b47$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $jSIPP.useContext((0, $63166dd08f8b5163$export$2e2bcd8739ae039));
    const resolvedProps = (0, $3Tcpe.default)(contextProps, inProps);
    const props = (0, $eyQWd.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $cMu4A.default)(props, $681a423b309f05b8$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $681a423b309f05b8$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $4uaIU.jsx)($681a423b309f05b8$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $4uaIU.jsx)($681a423b309f05b8$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($681a423b309f05b8$var$ButtonRoot, (0, $erOpW.default)({
        ownerState: ownerState,
        className: (0, $86B3v.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $86B3v.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $681a423b309f05b8$export$2e2bcd8739ae039 = $681a423b309f05b8$var$Button;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");

var $2TupR = parcelRequire("2TupR");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $7ONYC = parcelRequire("7ONYC");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $7e56d2b1b5a50cdb$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $7e56d2b1b5a50cdb$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $7e56d2b1b5a50cdb$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $7e56d2b1b5a50cdb$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $7e56d2b1b5a50cdb$var$isEmpty(obj) {
    return $7e56d2b1b5a50cdb$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $7e56d2b1b5a50cdb$var$TextareaAutosize = /*#__PURE__*/ $jSIPP.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cMu4A.default)(props, $7e56d2b1b5a50cdb$var$_excluded);
    const { current: isControlled } = $jSIPP.useRef(value != null);
    const textareaRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $jSIPP.useRef(null);
    const hiddenTextareaRef = $jSIPP.useRef(null);
    const calculateTextareaStyles = $jSIPP.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $59925aae262a63be$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $7e56d2b1b5a50cdb$var$getStyleValue(computedStyle.paddingBottom) + $7e56d2b1b5a50cdb$var$getStyleValue(computedStyle.paddingTop);
        const border = $7e56d2b1b5a50cdb$var$getStyleValue(computedStyle.borderBottomWidth) + $7e56d2b1b5a50cdb$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $7e56d2b1b5a50cdb$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $jSIPP.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $7e56d2b1b5a50cdb$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $jSIPP.useRef(-1);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $73208469ed38da03$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $59925aae262a63be$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)("textarea", (0, $erOpW.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $4uaIU.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $erOpW.default)({}, $7e56d2b1b5a50cdb$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $7e56d2b1b5a50cdb$export$2e2bcd8739ae039 = $7e56d2b1b5a50cdb$var$TextareaAutosize;


function $01c7c49eae24a908$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $jSIPP = parcelRequire("jSIPP");
/**
 * @ignore - internal component.
 */ const $8405841daa1d27d3$var$FormControlContext = /*#__PURE__*/ $jSIPP.createContext(undefined);
var $8405841daa1d27d3$export$2e2bcd8739ae039 = $8405841daa1d27d3$var$FormControlContext;



var $jSIPP = parcelRequire("jSIPP");

'use client';
function $21312b33e5d7b320$export$2e2bcd8739ae039() {
    return $jSIPP.useContext((0, $8405841daa1d27d3$export$2e2bcd8739ae039));
}



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $12d88e466f3e1b61$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $12d88e466f3e1b61$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($12d88e466f3e1b61$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $12d88e466f3e1b61$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $12d88e466f3e1b61$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $dff798b0c97c1e5a$export$ef57d5c8ca2278f6(slot) {
    return (0, $geF11.default)('MuiInputBase', slot);
}
const $dff798b0c97c1e5a$var$inputBaseClasses = (0, $rARwS.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $dff798b0c97c1e5a$export$2e2bcd8739ae039 = $dff798b0c97c1e5a$var$inputBaseClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $495d300f509482ea$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $495d300f509482ea$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $495d300f509482ea$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $495d300f509482ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iLAKr.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $iLAKr.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $dff798b0c97c1e5a$export$ef57d5c8ca2278f6), classes);
};
const $495d300f509482ea$export$298a043133d72a38 = (0, $28RyA.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $495d300f509482ea$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $erOpW.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $495d300f509482ea$export$a1ad29c901026019 = (0, $28RyA.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $495d300f509482ea$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $erOpW.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $erOpW.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $495d300f509482ea$var$inputGlobalStyles = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a1e9f964671d18b0$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $495d300f509482ea$var$InputBase = /*#__PURE__*/ $jSIPP.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $cMu4A.default)(props, $495d300f509482ea$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $jSIPP.useRef(value != null);
    const inputRef = $jSIPP.useRef();
    const handleInputRefWarning = $jSIPP.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $jSIPP.useState(false);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $jSIPP.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $jSIPP.useCallback((obj)=>{
        if ((0, $12d88e466f3e1b61$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7ONYC.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $jSIPP.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $erOpW.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $erOpW.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $7e56d2b1b5a50cdb$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $jSIPP.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $495d300f509482ea$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $495d300f509482ea$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $495d300f509482ea$export$a1ad29c901026019;
    inputProps = (0, $erOpW.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $495d300f509482ea$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $4uaIU.jsxs)(Root, (0, $erOpW.default)({}, rootProps, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $erOpW.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $86B3v.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8405841daa1d27d3$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)(Input, (0, $erOpW.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $erOpW.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $86B3v.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $erOpW.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $495d300f509482ea$export$2e2bcd8739ae039 = $495d300f509482ea$var$InputBase;



var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");

function $e047bbac9fd281f1$export$cdb270390122322b(slot) {
    return (0, $geF11.default)('MuiInput', slot);
}
const $e047bbac9fd281f1$var$inputClasses = (0, $erOpW.default)({}, (0, $dff798b0c97c1e5a$export$2e2bcd8739ae039), (0, $rARwS.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $e047bbac9fd281f1$export$2e2bcd8739ae039 = $e047bbac9fd281f1$var$inputClasses;




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $6fdfa18fd6abc684$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $6fdfa18fd6abc684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $e047bbac9fd281f1$export$cdb270390122322b), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $6fdfa18fd6abc684$var$InputRoot = (0, $28RyA.default)((0, $495d300f509482ea$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $495d300f509482ea$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $erOpW.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).disabled}, .${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $6fdfa18fd6abc684$var$InputInput = (0, $28RyA.default)((0, $495d300f509482ea$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $495d300f509482ea$export$cf507b112810e72d)
})({});
const $6fdfa18fd6abc684$var$Input = /*#__PURE__*/ $jSIPP.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cMu4A.default)(props, $6fdfa18fd6abc684$var$_excluded);
    const classes = $6fdfa18fd6abc684$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $2TupR.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6fdfa18fd6abc684$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $6fdfa18fd6abc684$var$InputInput;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $495d300f509482ea$export$2e2bcd8739ae039), (0, $erOpW.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$6fdfa18fd6abc684$var$Input.muiName = 'Input';
var $6fdfa18fd6abc684$export$2e2bcd8739ae039 = $6fdfa18fd6abc684$var$Input;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $2TupR = parcelRequire("2TupR");



var $i3Yji = parcelRequire("i3Yji");


var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");

var $erOpW = parcelRequire("erOpW");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");

function $f0db40177fe65f41$export$3331e419f1a48437(slot) {
    return (0, $geF11.default)('MuiFilledInput', slot);
}
const $f0db40177fe65f41$var$filledInputClasses = (0, $erOpW.default)({}, (0, $dff798b0c97c1e5a$export$2e2bcd8739ae039), (0, $rARwS.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $f0db40177fe65f41$export$2e2bcd8739ae039 = $f0db40177fe65f41$var$filledInputClasses;




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $6f0aa78cb8ca03eb$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $6f0aa78cb8ca03eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $f0db40177fe65f41$export$3331e419f1a48437), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $6f0aa78cb8ca03eb$var$FilledInputRoot = (0, $28RyA.default)((0, $495d300f509482ea$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $495d300f509482ea$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $erOpW.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).disabled}, .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $erOpW.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $6f0aa78cb8ca03eb$var$FilledInputInput = (0, $28RyA.default)((0, $495d300f509482ea$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $495d300f509482ea$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $6f0aa78cb8ca03eb$var$FilledInput = /*#__PURE__*/ $jSIPP.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cMu4A.default)(props, $6f0aa78cb8ca03eb$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $6f0aa78cb8ca03eb$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $2TupR.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6f0aa78cb8ca03eb$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $6f0aa78cb8ca03eb$var$FilledInputInput;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $495d300f509482ea$export$2e2bcd8739ae039), (0, $erOpW.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$6f0aa78cb8ca03eb$var$FilledInput.muiName = 'Input';
var $6f0aa78cb8ca03eb$export$2e2bcd8739ae039 = $6f0aa78cb8ca03eb$var$FilledInput;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $i3Yji = parcelRequire("i3Yji");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $9c42a8b61635e32b$var$_span;
const $9c42a8b61635e32b$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $9c42a8b61635e32b$var$NotchedOutlineRoot = (0, $28RyA.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $hDFpT.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $9c42a8b61635e32b$var$NotchedOutlineLegend = (0, $28RyA.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $hDFpT.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $erOpW.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $9c42a8b61635e32b$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cMu4A.default)(props, $9c42a8b61635e32b$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $erOpW.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)($9c42a8b61635e32b$var$NotchedOutlineRoot, (0, $erOpW.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($9c42a8b61635e32b$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
                children: label
            }) : $9c42a8b61635e32b$var$_span || ($9c42a8b61635e32b$var$_span = /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $erOpW = parcelRequire("erOpW");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");

function $26a42e2294231948$export$89922944c7227687(slot) {
    return (0, $geF11.default)('MuiOutlinedInput', slot);
}
const $26a42e2294231948$var$outlinedInputClasses = (0, $erOpW.default)({}, (0, $dff798b0c97c1e5a$export$2e2bcd8739ae039), (0, $rARwS.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $26a42e2294231948$export$2e2bcd8739ae039 = $26a42e2294231948$var$outlinedInputClasses;




var $eyQWd = parcelRequire("eyQWd");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $6ee74b9ab47804f3$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $6ee74b9ab47804f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $26a42e2294231948$export$89922944c7227687), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $6ee74b9ab47804f3$var$OutlinedInputRoot = (0, $28RyA.default)((0, $495d300f509482ea$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $495d300f509482ea$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $erOpW.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $26a42e2294231948$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $26a42e2294231948$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $26a42e2294231948$export$2e2bcd8739ae039).focused} .${(0, $26a42e2294231948$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $26a42e2294231948$export$2e2bcd8739ae039).error} .${(0, $26a42e2294231948$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $26a42e2294231948$export$2e2bcd8739ae039).disabled} .${(0, $26a42e2294231948$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $erOpW.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $6ee74b9ab47804f3$var$NotchedOutlineRoot = (0, $28RyA.default)((0, $9c42a8b61635e32b$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $6ee74b9ab47804f3$var$OutlinedInputInput = (0, $28RyA.default)((0, $495d300f509482ea$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $495d300f509482ea$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $6ee74b9ab47804f3$var$OutlinedInput = /*#__PURE__*/ $jSIPP.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $cMu4A.default)(props, $6ee74b9ab47804f3$var$_excluded);
    const classes = $6ee74b9ab47804f3$var$useUtilityClasses(props);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6ee74b9ab47804f3$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $6ee74b9ab47804f3$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $495d300f509482ea$export$2e2bcd8739ae039), (0, $erOpW.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $4uaIU.jsx)($6ee74b9ab47804f3$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $erOpW.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$6ee74b9ab47804f3$var$OutlinedInput.muiName = 'Input';
var $6ee74b9ab47804f3$export$2e2bcd8739ae039 = $6ee74b9ab47804f3$var$OutlinedInput;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");

var $86B3v = parcelRequire("86B3v");



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");



var $iLAKr = parcelRequire("iLAKr");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $128d6669d24e388e$export$f7d501e40371cd17(slot) {
    return (0, $geF11.default)('MuiFormLabel', slot);
}
const $128d6669d24e388e$var$formLabelClasses = (0, $rARwS.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $128d6669d24e388e$export$2e2bcd8739ae039 = $128d6669d24e388e$var$formLabelClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $381c3dfca693c440$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $381c3dfca693c440$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iLAKr.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $128d6669d24e388e$export$f7d501e40371cd17), classes);
};
const $381c3dfca693c440$export$aa5bc7f8a4705b27 = (0, $28RyA.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $erOpW.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $128d6669d24e388e$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $128d6669d24e388e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $128d6669d24e388e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $381c3dfca693c440$var$AsteriskComponent = (0, $28RyA.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $128d6669d24e388e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $381c3dfca693c440$var$FormLabel = /*#__PURE__*/ $jSIPP.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $cMu4A.default)(props, $381c3dfca693c440$var$_excluded);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $381c3dfca693c440$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($381c3dfca693c440$export$aa5bc7f8a4705b27, (0, $erOpW.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $4uaIU.jsxs)($381c3dfca693c440$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $381c3dfca693c440$export$2e2bcd8739ae039 = $381c3dfca693c440$var$FormLabel;



var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $e2edd1cecc8246e1$export$c1c4b4545ad2ea5f(slot) {
    return (0, $geF11.default)('MuiInputLabel', slot);
}
const $e2edd1cecc8246e1$var$inputLabelClasses = (0, $rARwS.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $e2edd1cecc8246e1$export$2e2bcd8739ae039 = $e2edd1cecc8246e1$var$inputLabelClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $1d035bfeea196a4a$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $1d035bfeea196a4a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $iLAKr.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $e2edd1cecc8246e1$export$c1c4b4545ad2ea5f), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $1d035bfeea196a4a$var$InputLabelRoot = (0, $28RyA.default)((0, $381c3dfca693c440$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $128d6669d24e388e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $erOpW.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $erOpW.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $erOpW.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $1d035bfeea196a4a$var$InputLabel = /*#__PURE__*/ $jSIPP.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cMu4A.default)(props, $1d035bfeea196a4a$var$_excluded);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $1d035bfeea196a4a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($1d035bfeea196a4a$var$InputLabelRoot, (0, $erOpW.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $1d035bfeea196a4a$export$2e2bcd8739ae039 = $1d035bfeea196a4a$var$InputLabel;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");


var $iLAKr = parcelRequire("iLAKr");



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $c6b8e57e939c9d08$export$149c8b8bab2289d1(slot) {
    return (0, $geF11.default)('MuiFormControl', slot);
}
const $c6b8e57e939c9d08$var$formControlClasses = (0, $rARwS.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $c6b8e57e939c9d08$export$2e2bcd8739ae039 = $c6b8e57e939c9d08$var$formControlClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $50dd07d34beb4b6b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $50dd07d34beb4b6b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $iLAKr.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $c6b8e57e939c9d08$export$149c8b8bab2289d1), classes);
};
const $50dd07d34beb4b6b$var$FormControlRoot = (0, $28RyA.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $erOpW.default)({}, styles.root, styles[`margin${(0, $iLAKr.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $50dd07d34beb4b6b$var$FormControl = /*#__PURE__*/ $jSIPP.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $cMu4A.default)(props, $50dd07d34beb4b6b$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $50dd07d34beb4b6b$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $jSIPP.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $jSIPP.Children.forEach(children, (child)=>{
            if (!(0, $df8809f1fe6fe9b8$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $df8809f1fe6fe9b8$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $12d88e466f3e1b61$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $jSIPP.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $jSIPP.Children.forEach(children, (child)=>{
            if (!(0, $df8809f1fe6fe9b8$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $12d88e466f3e1b61$export$d652b828d7fdeff8)(child.props, true) || (0, $12d88e466f3e1b61$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $jSIPP.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $jSIPP.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8405841daa1d27d3$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($50dd07d34beb4b6b$var$FormControlRoot, (0, $erOpW.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $86B3v.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $50dd07d34beb4b6b$export$2e2bcd8739ae039 = $50dd07d34beb4b6b$var$FormControl;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");



var $28RyA = parcelRequire("28RyA");

var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $1198a10b365e7a40$export$a394fa61b1d583a9(slot) {
    return (0, $geF11.default)('MuiFormHelperText', slot);
}
const $1198a10b365e7a40$var$formHelperTextClasses = (0, $rARwS.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $1198a10b365e7a40$export$2e2bcd8739ae039 = $1198a10b365e7a40$var$formHelperTextClasses;



var $eyQWd = parcelRequire("eyQWd");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $72bcdcc29c24edd9$var$_span;
const $72bcdcc29c24edd9$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $72bcdcc29c24edd9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $iLAKr.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $1198a10b365e7a40$export$a394fa61b1d583a9), classes);
};
const $72bcdcc29c24edd9$var$FormHelperTextRoot = (0, $28RyA.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $iLAKr.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $1198a10b365e7a40$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1198a10b365e7a40$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $72bcdcc29c24edd9$var$FormHelperText = /*#__PURE__*/ $jSIPP.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $cMu4A.default)(props, $72bcdcc29c24edd9$var$_excluded);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $72bcdcc29c24edd9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($72bcdcc29c24edd9$var$FormHelperTextRoot, (0, $erOpW.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $72bcdcc29c24edd9$var$_span || ($72bcdcc29c24edd9$var$_span = /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $72bcdcc29c24edd9$export$2e2bcd8739ae039 = $72bcdcc29c24edd9$var$FormHelperText;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $2TupR = parcelRequire("2TupR");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $7ONYC = parcelRequire("7ONYC");

var $jSIPP = parcelRequire("jSIPP");



var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $iLAKr = parcelRequire("iLAKr");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $92205e8f7ba9843f$export$1ee13051fd9e2ab5(slot) {
    return (0, $geF11.default)('MuiNativeSelect', slot);
}
const $92205e8f7ba9843f$var$nativeSelectClasses = (0, $rARwS.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $92205e8f7ba9843f$export$2e2bcd8739ae039 = $92205e8f7ba9843f$var$nativeSelectClasses;



var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $22478df5842982da$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $22478df5842982da$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iLAKr.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $92205e8f7ba9843f$export$1ee13051fd9e2ab5), classes);
};
const $22478df5842982da$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $erOpW.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $92205e8f7ba9843f$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $22478df5842982da$var$NativeSelectSelect = (0, $28RyA.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $hDFpT.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $92205e8f7ba9843f$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($22478df5842982da$export$c1eccd1617458c87);
const $22478df5842982da$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $92205e8f7ba9843f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $22478df5842982da$var$NativeSelectIcon = (0, $28RyA.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iLAKr.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($22478df5842982da$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $22478df5842982da$var$NativeSelectInput = /*#__PURE__*/ $jSIPP.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $cMu4A.default)(props, $22478df5842982da$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $22478df5842982da$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($22478df5842982da$var$NativeSelectSelect, (0, $erOpW.default)({
                ownerState: ownerState,
                className: (0, $86B3v.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $4uaIU.jsx)($22478df5842982da$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $22478df5842982da$export$2e2bcd8739ae039 = $22478df5842982da$var$NativeSelectInput;




var $28RyA = parcelRequire("28RyA");
var $aSAhh = parcelRequire("aSAhh");



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $502324a88a19f392$export$2c0c1ee5a3392e(slot) {
    return (0, $geF11.default)('MuiSelect', slot);
}
const $502324a88a19f392$var$selectClasses = (0, $rARwS.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $502324a88a19f392$export$2e2bcd8739ae039 = $502324a88a19f392$var$selectClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
var $360de4552b4d9b97$var$_span;
const $360de4552b4d9b97$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $360de4552b4d9b97$var$SelectSelect = (0, $28RyA.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $502324a88a19f392$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $502324a88a19f392$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $502324a88a19f392$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $502324a88a19f392$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $22478df5842982da$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $502324a88a19f392$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $360de4552b4d9b97$var$SelectIcon = (0, $28RyA.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iLAKr.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $22478df5842982da$export$e7a817afd12a40d0));
const $360de4552b4d9b97$var$SelectNativeInput = (0, $28RyA.default)('input', {
    shouldForwardProp: (prop)=>(0, $aSAhh.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $360de4552b4d9b97$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $360de4552b4d9b97$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $360de4552b4d9b97$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iLAKr.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $502324a88a19f392$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $360de4552b4d9b97$var$SelectInput = /*#__PURE__*/ $jSIPP.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $cMu4A.default)(props, $360de4552b4d9b97$var$_excluded);
    const [value, setValueState] = (0, $7981abc7b5093fe8$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $7981abc7b5093fe8$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $jSIPP.useRef(null);
    const displayRef = $jSIPP.useRef(null);
    const [displayNode, setDisplayNode] = $jSIPP.useState(null);
    const { current: isOpenControlled } = $jSIPP.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $jSIPP.useState();
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $jSIPP.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $jSIPP.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $jSIPP.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $jSIPP.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $jSIPP.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $2ec73871339adc46$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $jSIPP.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $12d88e466f3e1b61$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7ONYC.default)(2));
            selected = value.some((v)=>$360de4552b4d9b97$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $360de4552b4d9b97$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $jSIPP.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $erOpW.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $360de4552b4d9b97$var$useUtilityClasses(ownerState);
    const paperProps = (0, $erOpW.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($360de4552b4d9b97$var$SelectSelect, (0, $erOpW.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $86B3v.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $360de4552b4d9b97$var$isEmpty(display) ? $360de4552b4d9b97$var$_span || ($360de4552b4d9b97$var$_span = /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)($360de4552b4d9b97$var$SelectNativeInput, (0, $erOpW.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $4uaIU.jsx)($360de4552b4d9b97$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49de72d6edae6669$export$2e2bcd8739ae039), (0, $erOpW.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $erOpW.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $erOpW.default)({}, MenuProps.slotProps, {
                    paper: (0, $erOpW.default)({}, paperProps, {
                        style: (0, $erOpW.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $360de4552b4d9b97$export$2e2bcd8739ae039 = $360de4552b4d9b97$var$SelectInput;




parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $9216b12485694825$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $eyQWd = parcelRequire("eyQWd");


var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $4uaIU = parcelRequire("4uaIU");
'use client';
const $0e329553cea51e59$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $0e329553cea51e59$var$_excluded2 = [
    "root"
];
const $0e329553cea51e59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $0e329553cea51e59$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $0e329553cea51e59$var$StyledInput = (0, $28RyA.default)((0, $6fdfa18fd6abc684$export$2e2bcd8739ae039), $0e329553cea51e59$var$styledRootConfig)('');
const $0e329553cea51e59$var$StyledOutlinedInput = (0, $28RyA.default)((0, $6ee74b9ab47804f3$export$2e2bcd8739ae039), $0e329553cea51e59$var$styledRootConfig)('');
const $0e329553cea51e59$var$StyledFilledInput = (0, $28RyA.default)((0, $6f0aa78cb8ca03eb$export$2e2bcd8739ae039), $0e329553cea51e59$var$styledRootConfig)('');
const $0e329553cea51e59$var$Select = /*#__PURE__*/ $jSIPP.forwardRef(function Select(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $9216b12485694825$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $cMu4A.default)(props, $0e329553cea51e59$var$_excluded);
    const inputComponent = native ? (0, $22478df5842982da$export$2e2bcd8739ae039) : (0, $360de4552b4d9b97$export$2e2bcd8739ae039);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $erOpW.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $0e329553cea51e59$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cMu4A.default)(classes, $0e329553cea51e59$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $4uaIU.jsx)($0e329553cea51e59$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $4uaIU.jsx)($0e329553cea51e59$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $4uaIU.jsx)($0e329553cea51e59$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(ref, (0, $26305578246e3ab6$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $4uaIU.jsx)($jSIPP.Fragment, {
        children: /*#__PURE__*/ $jSIPP.cloneElement(InputComponent, (0, $erOpW.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $erOpW.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $erOpW.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $2TupR.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $86B3v.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$0e329553cea51e59$var$Select.muiName = 'Select';
var $0e329553cea51e59$export$2e2bcd8739ae039 = $0e329553cea51e59$var$Select;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $a877759e0a2c3f8e$export$c1bdcbaf0596aeda(slot) {
    return (0, $geF11.default)('MuiTextField', slot);
}
const $a877759e0a2c3f8e$var$textFieldClasses = (0, $rARwS.default)('MuiTextField', [
    'root'
]);
var $a877759e0a2c3f8e$export$2e2bcd8739ae039 = $a877759e0a2c3f8e$var$textFieldClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $ccc5b601331ac202$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $ccc5b601331ac202$var$variantComponent = {
    standard: (0, $6fdfa18fd6abc684$export$2e2bcd8739ae039),
    filled: (0, $6f0aa78cb8ca03eb$export$2e2bcd8739ae039),
    outlined: (0, $6ee74b9ab47804f3$export$2e2bcd8739ae039)
};
const $ccc5b601331ac202$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $a877759e0a2c3f8e$export$c1bdcbaf0596aeda), classes);
};
const $ccc5b601331ac202$var$TextFieldRoot = (0, $28RyA.default)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $ccc5b601331ac202$var$TextField = /*#__PURE__*/ $jSIPP.forwardRef(function TextField(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $cMu4A.default)(props, $ccc5b601331ac202$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $ccc5b601331ac202$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $ccc5b601331ac202$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $4uaIU.jsx)(InputComponent, (0, $erOpW.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($ccc5b601331ac202$var$TextFieldRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), (0, $erOpW.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), (0, $erOpW.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $72bcdcc29c24edd9$export$2e2bcd8739ae039), (0, $erOpW.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $ccc5b601331ac202$export$2e2bcd8739ae039 = $ccc5b601331ac202$var$TextField;



var $jSIPP = parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");
var $d4e37058828855df$exports = {};
'use strict';
function $d4e37058828855df$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $jSIPP = parcelRequire("jSIPP");
var $d4e37058828855df$var$React__default = $d4e37058828855df$var$_interopDefault($jSIPP);
function $d4e37058828855df$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d4e37058828855df$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $d4e37058828855df$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $d4e37058828855df$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $d4e37058828855df$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $d4e37058828855df$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($jSIPP.PureComponent);
        $d4e37058828855df$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $d4e37058828855df$var$_defineProperty(SideEffect, "canUseDOM", $d4e37058828855df$var$canUseDOM);
        return SideEffect;
    };
}
$d4e37058828855df$exports = $d4e37058828855df$var$withSideEffect;


var $adb1d69bc13389df$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $adb1d69bc13389df$var$hasElementType = typeof Element !== 'undefined';
var $adb1d69bc13389df$var$hasMap = typeof Map === 'function';
var $adb1d69bc13389df$var$hasSet = typeof Set === 'function';
var $adb1d69bc13389df$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $adb1d69bc13389df$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$adb1d69bc13389df$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($adb1d69bc13389df$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$adb1d69bc13389df$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($adb1d69bc13389df$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($adb1d69bc13389df$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($adb1d69bc13389df$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$adb1d69bc13389df$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$adb1d69bc13389df$exports = function isEqual(a, b) {
    try {
        return $adb1d69bc13389df$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $jSIPP = parcelRequire("jSIPP");

var $gj7pJ = parcelRequire("gj7pJ");
var $19efb1c1755d1d62$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $19efb1c1755d1d62$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $19efb1c1755d1d62$var$VALID_TAG_NAMES = Object.keys($19efb1c1755d1d62$var$TAG_NAMES).map(function(name) {
    return $19efb1c1755d1d62$var$TAG_NAMES[name];
});
var $19efb1c1755d1d62$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $19efb1c1755d1d62$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $19efb1c1755d1d62$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $19efb1c1755d1d62$var$HTML_TAG_MAP = Object.keys($19efb1c1755d1d62$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$19efb1c1755d1d62$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $19efb1c1755d1d62$var$SELF_CLOSING_TAGS = [
    $19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT,
    $19efb1c1755d1d62$var$TAG_NAMES.SCRIPT,
    $19efb1c1755d1d62$var$TAG_NAMES.STYLE
];
var $19efb1c1755d1d62$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $19efb1c1755d1d62$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $19efb1c1755d1d62$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $19efb1c1755d1d62$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $19efb1c1755d1d62$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $19efb1c1755d1d62$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $19efb1c1755d1d62$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $19efb1c1755d1d62$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $19efb1c1755d1d62$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $19efb1c1755d1d62$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$TAG_NAMES.TITLE);
    var innermostTemplate = $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $19efb1c1755d1d62$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $19efb1c1755d1d62$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $19efb1c1755d1d62$var$_extends({}, tagAttrs, current);
    }, {});
};
var $19efb1c1755d1d62$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$19efb1c1755d1d62$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$19efb1c1755d1d62$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $19efb1c1755d1d62$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $19efb1c1755d1d62$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $19efb1c1755d1d62$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $19efb1c1755d1d62$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $19efb1c1755d1d62$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $19efb1c1755d1d62$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $19efb1c1755d1d62$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($gj7pJ)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $19efb1c1755d1d62$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $19efb1c1755d1d62$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $19efb1c1755d1d62$var$getBaseTagFromPropsList([
            $19efb1c1755d1d62$var$TAG_PROPERTIES.HREF,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $19efb1c1755d1d62$var$getAttributesFromPropsList($19efb1c1755d1d62$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$HELMET_PROPS.DEFER),
        encode: $19efb1c1755d1d62$var$getInnermostProperty(propsList, $19efb1c1755d1d62$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $19efb1c1755d1d62$var$getAttributesFromPropsList($19efb1c1755d1d62$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $19efb1c1755d1d62$var$getTagsFromPropsList($19efb1c1755d1d62$var$TAG_NAMES.LINK, [
            $19efb1c1755d1d62$var$TAG_PROPERTIES.REL,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $19efb1c1755d1d62$var$getTagsFromPropsList($19efb1c1755d1d62$var$TAG_NAMES.META, [
            $19efb1c1755d1d62$var$TAG_PROPERTIES.NAME,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.CHARSET,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.HTTPEQUIV,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.PROPERTY,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $19efb1c1755d1d62$var$getTagsFromPropsList($19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT, [
            $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $19efb1c1755d1d62$var$getOnChangeClientState(propsList),
        scriptTags: $19efb1c1755d1d62$var$getTagsFromPropsList($19efb1c1755d1d62$var$TAG_NAMES.SCRIPT, [
            $19efb1c1755d1d62$var$TAG_PROPERTIES.SRC,
            $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $19efb1c1755d1d62$var$getTagsFromPropsList($19efb1c1755d1d62$var$TAG_NAMES.STYLE, [
            $19efb1c1755d1d62$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $19efb1c1755d1d62$var$getTitleFromPropsList(propsList),
        titleAttributes: $19efb1c1755d1d62$var$getAttributesFromPropsList($19efb1c1755d1d62$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $19efb1c1755d1d62$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $19efb1c1755d1d62$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $19efb1c1755d1d62$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $19efb1c1755d1d62$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $19efb1c1755d1d62$var$rafPolyfill : $parcel$global.requestAnimationFrame || $19efb1c1755d1d62$var$rafPolyfill;
var $19efb1c1755d1d62$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $19efb1c1755d1d62$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $19efb1c1755d1d62$var$cafPolyfill;
var $19efb1c1755d1d62$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $19efb1c1755d1d62$var$_helmetCallback = null;
var $19efb1c1755d1d62$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($19efb1c1755d1d62$var$_helmetCallback) $19efb1c1755d1d62$var$cancelAnimationFrame($19efb1c1755d1d62$var$_helmetCallback);
    if (newState.defer) $19efb1c1755d1d62$var$_helmetCallback = $19efb1c1755d1d62$var$requestAnimationFrame(function() {
        $19efb1c1755d1d62$var$commitTagChanges(newState, function() {
            $19efb1c1755d1d62$var$_helmetCallback = null;
        });
    });
    else {
        $19efb1c1755d1d62$var$commitTagChanges(newState);
        $19efb1c1755d1d62$var$_helmetCallback = null;
    }
};
var $19efb1c1755d1d62$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $19efb1c1755d1d62$var$updateAttributes($19efb1c1755d1d62$var$TAG_NAMES.BODY, bodyAttributes);
    $19efb1c1755d1d62$var$updateAttributes($19efb1c1755d1d62$var$TAG_NAMES.HTML, htmlAttributes);
    $19efb1c1755d1d62$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.BASE, baseTag),
        linkTags: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.LINK, linkTags),
        metaTags: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.META, metaTags),
        noscriptTags: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $19efb1c1755d1d62$var$updateTags($19efb1c1755d1d62$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $19efb1c1755d1d62$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $19efb1c1755d1d62$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $19efb1c1755d1d62$var$flattenArray(title);
    $19efb1c1755d1d62$var$updateAttributes($19efb1c1755d1d62$var$TAG_NAMES.TITLE, attributes);
};
var $19efb1c1755d1d62$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($19efb1c1755d1d62$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($19efb1c1755d1d62$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($19efb1c1755d1d62$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($19efb1c1755d1d62$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $19efb1c1755d1d62$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($19efb1c1755d1d62$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $19efb1c1755d1d62$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($19efb1c1755d1d62$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $19efb1c1755d1d62$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $19efb1c1755d1d62$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $19efb1c1755d1d62$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $19efb1c1755d1d62$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $19efb1c1755d1d62$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $19efb1c1755d1d62$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $19efb1c1755d1d62$var$HELMET_ATTRIBUTE + "=\"true\">" + $19efb1c1755d1d62$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $19efb1c1755d1d62$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML || attribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $19efb1c1755d1d62$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $19efb1c1755d1d62$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $19efb1c1755d1d62$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $19efb1c1755d1d62$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$19efb1c1755d1d62$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $19efb1c1755d1d62$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$19efb1c1755d1d62$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $19efb1c1755d1d62$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$19efb1c1755d1d62$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $19efb1c1755d1d62$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($19efb1c1755d1d62$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $19efb1c1755d1d62$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$19efb1c1755d1d62$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $19efb1c1755d1d62$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $19efb1c1755d1d62$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(type, mappedTag);
    });
};
var $19efb1c1755d1d62$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $19efb1c1755d1d62$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $19efb1c1755d1d62$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $19efb1c1755d1d62$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $19efb1c1755d1d62$var$ATTRIBUTE_NAMES.BODY:
        case $19efb1c1755d1d62$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $19efb1c1755d1d62$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $19efb1c1755d1d62$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $19efb1c1755d1d62$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $19efb1c1755d1d62$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $19efb1c1755d1d62$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.META, metaTags, encode),
        noscript: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $19efb1c1755d1d62$var$getMethodsForTag($19efb1c1755d1d62$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $19efb1c1755d1d62$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $19efb1c1755d1d62$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $19efb1c1755d1d62$var$classCallCheck(this, HelmetWrapper);
            return $19efb1c1755d1d62$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($adb1d69bc13389df$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $19efb1c1755d1d62$var$TAG_NAMES.SCRIPT:
                case $19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $19efb1c1755d1d62$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $19efb1c1755d1d62$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $19efb1c1755d1d62$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $19efb1c1755d1d62$var$TAG_NAMES.TITLE:
                    return $19efb1c1755d1d62$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $19efb1c1755d1d62$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $19efb1c1755d1d62$var$TAG_NAMES.BODY:
                    return $19efb1c1755d1d62$var$_extends({}, newProps, {
                        bodyAttributes: $19efb1c1755d1d62$var$_extends({}, newChildProps)
                    });
                case $19efb1c1755d1d62$var$TAG_NAMES.HTML:
                    return $19efb1c1755d1d62$var$_extends({}, newProps, {
                        htmlAttributes: $19efb1c1755d1d62$var$_extends({}, newChildProps)
                    });
            }
            return $19efb1c1755d1d62$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $19efb1c1755d1d62$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $19efb1c1755d1d62$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $19efb1c1755d1d62$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $19efb1c1755d1d62$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $19efb1c1755d1d62$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $19efb1c1755d1d62$var$TAG_NAMES.LINK:
                    case $19efb1c1755d1d62$var$TAG_NAMES.META:
                    case $19efb1c1755d1d62$var$TAG_NAMES.NOSCRIPT:
                    case $19efb1c1755d1d62$var$TAG_NAMES.SCRIPT:
                    case $19efb1c1755d1d62$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $19efb1c1755d1d62$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $19efb1c1755d1d62$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(Component, newProps);
        };
        $19efb1c1755d1d62$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $19efb1c1755d1d62$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $19efb1c1755d1d62$var$NullComponent = function NullComponent() {
    return null;
};
var $19efb1c1755d1d62$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($d4e37058828855df$exports)))($19efb1c1755d1d62$var$reducePropsToState, $19efb1c1755d1d62$var$handleClientStateChange, $19efb1c1755d1d62$var$mapStateOnServer)($19efb1c1755d1d62$var$NullComponent);
var $19efb1c1755d1d62$export$dcef8f9bb9a41431 = $19efb1c1755d1d62$var$Helmet($19efb1c1755d1d62$var$HelmetSideEffects);
$19efb1c1755d1d62$export$dcef8f9bb9a41431.renderStatic = $19efb1c1755d1d62$export$dcef8f9bb9a41431.rewind;
var $19efb1c1755d1d62$export$2e2bcd8739ae039 = $19efb1c1755d1d62$export$dcef8f9bb9a41431;




// ES6 Map
var $f2ed487758709380$var$map;
try {
    $f2ed487758709380$var$map = Map;
} catch (_) {}
var $f2ed487758709380$var$set;
// ES6 Set
try {
    $f2ed487758709380$var$set = Set;
} catch (_) {}
function $f2ed487758709380$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($f2ed487758709380$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($f2ed487758709380$var$map && src instanceof $f2ed487758709380$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($f2ed487758709380$var$set && src instanceof $f2ed487758709380$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $f2ed487758709380$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $f2ed487758709380$export$2e2bcd8739ae039(src) {
    return $f2ed487758709380$var$baseClone(src, [], []);
}


const $eb9e77a8f4af3aeb$var$toString = Object.prototype.toString;
const $eb9e77a8f4af3aeb$var$errorToString = Error.prototype.toString;
const $eb9e77a8f4af3aeb$var$regExpToString = RegExp.prototype.toString;
const $eb9e77a8f4af3aeb$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $eb9e77a8f4af3aeb$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $eb9e77a8f4af3aeb$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $eb9e77a8f4af3aeb$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $eb9e77a8f4af3aeb$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $eb9e77a8f4af3aeb$var$symbolToString.call(val).replace($eb9e77a8f4af3aeb$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $eb9e77a8f4af3aeb$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $eb9e77a8f4af3aeb$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $eb9e77a8f4af3aeb$var$regExpToString.call(val);
    return null;
}
function $eb9e77a8f4af3aeb$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $eb9e77a8f4af3aeb$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $eb9e77a8f4af3aeb$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $6290250a2ab08af2$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $6290250a2ab08af2$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $6290250a2ab08af2$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $6290250a2ab08af2$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $6290250a2ab08af2$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $6290250a2ab08af2$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $6290250a2ab08af2$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $6290250a2ab08af2$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $6290250a2ab08af2$export$9b30b6294c1449a8,
    string: $6290250a2ab08af2$export$22b082955e083ec3,
    number: $6290250a2ab08af2$export$98e628dec113755e,
    date: $6290250a2ab08af2$export$324d90190a8b822a,
    object: $6290250a2ab08af2$export$be5493f9613cbbe,
    array: $6290250a2ab08af2$export$2f23118c22fb2630,
    boolean: $6290250a2ab08af2$export$4a21f16c33752377
});


var $46c2c57422564351$exports = {};
var $d760b7ab49711fe3$exports = {};
/** Used for built-in method references. */ var $d760b7ab49711fe3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d760b7ab49711fe3$var$hasOwnProperty = $d760b7ab49711fe3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d760b7ab49711fe3$var$baseHas(object, key) {
    return object != null && $d760b7ab49711fe3$var$hasOwnProperty.call(object, key);
}
$d760b7ab49711fe3$exports = $d760b7ab49711fe3$var$baseHas;


var $50b7a46188d0e6a9$exports = {};
var $992132bc1453647e$exports = {};
var $0dad9fd8605a15e0$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0dad9fd8605a15e0$var$isArray = Array.isArray;
$0dad9fd8605a15e0$exports = $0dad9fd8605a15e0$var$isArray;


var $0ddcb46fa3e04a1d$exports = {};

var $d6f9cc72255262a9$exports = {};
var $3c36286fb8e110d4$exports = {};
var $44b18937e9955607$exports = {};

var $ad9xy = parcelRequire("ad9xy");
/** Built-in value references. */ var $44b18937e9955607$var$Symbol = $ad9xy.Symbol;
$44b18937e9955607$exports = $44b18937e9955607$var$Symbol;


var $3655603229e8b26f$exports = {};

/** Used for built-in method references. */ var $3655603229e8b26f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3655603229e8b26f$var$hasOwnProperty = $3655603229e8b26f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3655603229e8b26f$var$nativeObjectToString = $3655603229e8b26f$var$objectProto.toString;
/** Built-in value references. */ var $3655603229e8b26f$var$symToStringTag = $44b18937e9955607$exports ? $44b18937e9955607$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3655603229e8b26f$var$getRawTag(value) {
    var isOwn = $3655603229e8b26f$var$hasOwnProperty.call(value, $3655603229e8b26f$var$symToStringTag), tag = value[$3655603229e8b26f$var$symToStringTag];
    try {
        value[$3655603229e8b26f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3655603229e8b26f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3655603229e8b26f$var$symToStringTag] = tag;
        else delete value[$3655603229e8b26f$var$symToStringTag];
    }
    return result;
}
$3655603229e8b26f$exports = $3655603229e8b26f$var$getRawTag;


var $b3c056979449bb59$exports = {};
/** Used for built-in method references. */ var $b3c056979449bb59$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b3c056979449bb59$var$nativeObjectToString = $b3c056979449bb59$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b3c056979449bb59$var$objectToString(value) {
    return $b3c056979449bb59$var$nativeObjectToString.call(value);
}
$b3c056979449bb59$exports = $b3c056979449bb59$var$objectToString;


/** `Object#toString` result references. */ var $3c36286fb8e110d4$var$nullTag = '[object Null]', $3c36286fb8e110d4$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $3c36286fb8e110d4$var$symToStringTag = $44b18937e9955607$exports ? $44b18937e9955607$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3c36286fb8e110d4$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3c36286fb8e110d4$var$undefinedTag : $3c36286fb8e110d4$var$nullTag;
    return $3c36286fb8e110d4$var$symToStringTag && $3c36286fb8e110d4$var$symToStringTag in Object(value) ? $3655603229e8b26f$exports(value) : $b3c056979449bb59$exports(value);
}
$3c36286fb8e110d4$exports = $3c36286fb8e110d4$var$baseGetTag;


var $081ff81630beaefd$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $081ff81630beaefd$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$081ff81630beaefd$exports = $081ff81630beaefd$var$isObjectLike;


/** `Object#toString` result references. */ var $d6f9cc72255262a9$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d6f9cc72255262a9$var$isSymbol(value) {
    return typeof value == 'symbol' || $081ff81630beaefd$exports(value) && $3c36286fb8e110d4$exports(value) == $d6f9cc72255262a9$var$symbolTag;
}
$d6f9cc72255262a9$exports = $d6f9cc72255262a9$var$isSymbol;


/** Used to match property names within property paths. */ var $0ddcb46fa3e04a1d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $0ddcb46fa3e04a1d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $0ddcb46fa3e04a1d$var$isKey(value, object) {
    if ($0dad9fd8605a15e0$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $d6f9cc72255262a9$exports(value)) return true;
    return $0ddcb46fa3e04a1d$var$reIsPlainProp.test(value) || !$0ddcb46fa3e04a1d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$0ddcb46fa3e04a1d$exports = $0ddcb46fa3e04a1d$var$isKey;


var $714bc0a107af1b09$exports = {};
var $29c7e774861703f5$exports = {};
var $4753e2a83435654c$exports = {};
var $5859dee247a60293$exports = {};
var $a269778c69e0cac5$exports = {};
var $e9a215d42c0f4d2f$exports = {};
var $8469752f853e8a51$exports = {};
var $3b5af330f636ad24$exports = {};
var $70a39ef513b95a52$exports = {};
var $dc5073ca6f38a53f$exports = {};
var $34b74e9746582d66$exports = {};

var $ef750d4bab473ce5$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ef750d4bab473ce5$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$ef750d4bab473ce5$exports = $ef750d4bab473ce5$var$isObject;


/** `Object#toString` result references. */ var $34b74e9746582d66$var$asyncTag = '[object AsyncFunction]', $34b74e9746582d66$var$funcTag = '[object Function]', $34b74e9746582d66$var$genTag = '[object GeneratorFunction]', $34b74e9746582d66$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $34b74e9746582d66$var$isFunction(value) {
    if (!$ef750d4bab473ce5$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $3c36286fb8e110d4$exports(value);
    return tag == $34b74e9746582d66$var$funcTag || tag == $34b74e9746582d66$var$genTag || tag == $34b74e9746582d66$var$asyncTag || tag == $34b74e9746582d66$var$proxyTag;
}
$34b74e9746582d66$exports = $34b74e9746582d66$var$isFunction;


var $d6c7c88af5ea40a3$exports = {};
var $845a18d316e5afb9$exports = {};

var $ad9xy = parcelRequire("ad9xy");
/** Used to detect overreaching core-js shims. */ var $845a18d316e5afb9$var$coreJsData = $ad9xy["__core-js_shared__"];
$845a18d316e5afb9$exports = $845a18d316e5afb9$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $d6c7c88af5ea40a3$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($845a18d316e5afb9$exports && $845a18d316e5afb9$exports.keys && $845a18d316e5afb9$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $d6c7c88af5ea40a3$var$isMasked(func) {
    return !!$d6c7c88af5ea40a3$var$maskSrcKey && $d6c7c88af5ea40a3$var$maskSrcKey in func;
}
$d6c7c88af5ea40a3$exports = $d6c7c88af5ea40a3$var$isMasked;



var $2b82d45a377e45f5$exports = {};
/** Used for built-in method references. */ var $2b82d45a377e45f5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $2b82d45a377e45f5$var$funcToString = $2b82d45a377e45f5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $2b82d45a377e45f5$var$toSource(func) {
    if (func != null) {
        try {
            return $2b82d45a377e45f5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$2b82d45a377e45f5$exports = $2b82d45a377e45f5$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $dc5073ca6f38a53f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $dc5073ca6f38a53f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $dc5073ca6f38a53f$var$funcProto = Function.prototype, $dc5073ca6f38a53f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $dc5073ca6f38a53f$var$funcToString = $dc5073ca6f38a53f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $dc5073ca6f38a53f$var$hasOwnProperty = $dc5073ca6f38a53f$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $dc5073ca6f38a53f$var$reIsNative = RegExp('^' + $dc5073ca6f38a53f$var$funcToString.call($dc5073ca6f38a53f$var$hasOwnProperty).replace($dc5073ca6f38a53f$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $dc5073ca6f38a53f$var$baseIsNative(value) {
    if (!$ef750d4bab473ce5$exports(value) || $d6c7c88af5ea40a3$exports(value)) return false;
    var pattern = $34b74e9746582d66$exports(value) ? $dc5073ca6f38a53f$var$reIsNative : $dc5073ca6f38a53f$var$reIsHostCtor;
    return pattern.test($2b82d45a377e45f5$exports(value));
}
$dc5073ca6f38a53f$exports = $dc5073ca6f38a53f$var$baseIsNative;


var $d22313de3c04dd50$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d22313de3c04dd50$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d22313de3c04dd50$exports = $d22313de3c04dd50$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $70a39ef513b95a52$var$getNative(object, key) {
    var value = $d22313de3c04dd50$exports(object, key);
    return $dc5073ca6f38a53f$exports(value) ? value : undefined;
}
$70a39ef513b95a52$exports = $70a39ef513b95a52$var$getNative;


/* Built-in method references that are verified to be native. */ var $3b5af330f636ad24$var$nativeCreate = $70a39ef513b95a52$exports(Object, 'create');
$3b5af330f636ad24$exports = $3b5af330f636ad24$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8469752f853e8a51$var$hashClear() {
    this.__data__ = $3b5af330f636ad24$exports ? $3b5af330f636ad24$exports(null) : {};
    this.size = 0;
}
$8469752f853e8a51$exports = $8469752f853e8a51$var$hashClear;


var $b1bb5108b20b4a31$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b1bb5108b20b4a31$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$b1bb5108b20b4a31$exports = $b1bb5108b20b4a31$var$hashDelete;


var $5c8f5cde635faca4$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $5c8f5cde635faca4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $5c8f5cde635faca4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5c8f5cde635faca4$var$hasOwnProperty = $5c8f5cde635faca4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5c8f5cde635faca4$var$hashGet(key) {
    var data = this.__data__;
    if ($3b5af330f636ad24$exports) {
        var result = data[key];
        return result === $5c8f5cde635faca4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $5c8f5cde635faca4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$5c8f5cde635faca4$exports = $5c8f5cde635faca4$var$hashGet;


var $c5222e9de1259899$exports = {};

/** Used for built-in method references. */ var $c5222e9de1259899$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c5222e9de1259899$var$hasOwnProperty = $c5222e9de1259899$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c5222e9de1259899$var$hashHas(key) {
    var data = this.__data__;
    return $3b5af330f636ad24$exports ? data[key] !== undefined : $c5222e9de1259899$var$hasOwnProperty.call(data, key);
}
$c5222e9de1259899$exports = $c5222e9de1259899$var$hashHas;


var $b0642392a78fe61e$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $b0642392a78fe61e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b0642392a78fe61e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3b5af330f636ad24$exports && value === undefined ? $b0642392a78fe61e$var$HASH_UNDEFINED : value;
    return this;
}
$b0642392a78fe61e$exports = $b0642392a78fe61e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e9a215d42c0f4d2f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e9a215d42c0f4d2f$var$Hash.prototype.clear = $8469752f853e8a51$exports;
$e9a215d42c0f4d2f$var$Hash.prototype['delete'] = $b1bb5108b20b4a31$exports;
$e9a215d42c0f4d2f$var$Hash.prototype.get = $5c8f5cde635faca4$exports;
$e9a215d42c0f4d2f$var$Hash.prototype.has = $c5222e9de1259899$exports;
$e9a215d42c0f4d2f$var$Hash.prototype.set = $b0642392a78fe61e$exports;
$e9a215d42c0f4d2f$exports = $e9a215d42c0f4d2f$var$Hash;


var $0dcc562088c5ea1f$exports = {};
var $82fe0395b8c32a17$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $82fe0395b8c32a17$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$82fe0395b8c32a17$exports = $82fe0395b8c32a17$var$listCacheClear;


var $54ff1950751044dd$exports = {};
var $cfefc883cfed6a6a$exports = {};
var $c5a6945c8153f400$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c5a6945c8153f400$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$c5a6945c8153f400$exports = $c5a6945c8153f400$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cfefc883cfed6a6a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($c5a6945c8153f400$exports(array[length][0], key)) return length;
    }
    return -1;
}
$cfefc883cfed6a6a$exports = $cfefc883cfed6a6a$var$assocIndexOf;


/** Used for built-in method references. */ var $54ff1950751044dd$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $54ff1950751044dd$var$splice = $54ff1950751044dd$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $54ff1950751044dd$var$listCacheDelete(key) {
    var data = this.__data__, index = $cfefc883cfed6a6a$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $54ff1950751044dd$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$54ff1950751044dd$exports = $54ff1950751044dd$var$listCacheDelete;


var $e3c224eb46e3fd1b$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e3c224eb46e3fd1b$var$listCacheGet(key) {
    var data = this.__data__, index = $cfefc883cfed6a6a$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e3c224eb46e3fd1b$exports = $e3c224eb46e3fd1b$var$listCacheGet;


var $5b836111f0578646$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5b836111f0578646$var$listCacheHas(key) {
    return $cfefc883cfed6a6a$exports(this.__data__, key) > -1;
}
$5b836111f0578646$exports = $5b836111f0578646$var$listCacheHas;


var $b749e561131cfda4$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b749e561131cfda4$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cfefc883cfed6a6a$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b749e561131cfda4$exports = $b749e561131cfda4$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0dcc562088c5ea1f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0dcc562088c5ea1f$var$ListCache.prototype.clear = $82fe0395b8c32a17$exports;
$0dcc562088c5ea1f$var$ListCache.prototype['delete'] = $54ff1950751044dd$exports;
$0dcc562088c5ea1f$var$ListCache.prototype.get = $e3c224eb46e3fd1b$exports;
$0dcc562088c5ea1f$var$ListCache.prototype.has = $5b836111f0578646$exports;
$0dcc562088c5ea1f$var$ListCache.prototype.set = $b749e561131cfda4$exports;
$0dcc562088c5ea1f$exports = $0dcc562088c5ea1f$var$ListCache;


var $7f8f1cf0e34db950$exports = {};


var $ad9xy = parcelRequire("ad9xy");
/* Built-in method references that are verified to be native. */ var $7f8f1cf0e34db950$var$Map = $70a39ef513b95a52$exports($ad9xy, 'Map');
$7f8f1cf0e34db950$exports = $7f8f1cf0e34db950$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a269778c69e0cac5$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $e9a215d42c0f4d2f$exports,
        'map': new ($7f8f1cf0e34db950$exports || $0dcc562088c5ea1f$exports),
        'string': new $e9a215d42c0f4d2f$exports
    };
}
$a269778c69e0cac5$exports = $a269778c69e0cac5$var$mapCacheClear;


var $5ccdafc0842f5c11$exports = {};
var $b436e59d3c28dffa$exports = {};
var $d58144a261e55dfd$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d58144a261e55dfd$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$d58144a261e55dfd$exports = $d58144a261e55dfd$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b436e59d3c28dffa$var$getMapData(map, key) {
    var data = map.__data__;
    return $d58144a261e55dfd$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$b436e59d3c28dffa$exports = $b436e59d3c28dffa$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5ccdafc0842f5c11$var$mapCacheDelete(key) {
    var result = $b436e59d3c28dffa$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$5ccdafc0842f5c11$exports = $5ccdafc0842f5c11$var$mapCacheDelete;


var $88ab502486caac5a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $88ab502486caac5a$var$mapCacheGet(key) {
    return $b436e59d3c28dffa$exports(this, key).get(key);
}
$88ab502486caac5a$exports = $88ab502486caac5a$var$mapCacheGet;


var $cb62e1606d86f933$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cb62e1606d86f933$var$mapCacheHas(key) {
    return $b436e59d3c28dffa$exports(this, key).has(key);
}
$cb62e1606d86f933$exports = $cb62e1606d86f933$var$mapCacheHas;


var $636795ff4b8bad57$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $636795ff4b8bad57$var$mapCacheSet(key, value) {
    var data = $b436e59d3c28dffa$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$636795ff4b8bad57$exports = $636795ff4b8bad57$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5859dee247a60293$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5859dee247a60293$var$MapCache.prototype.clear = $a269778c69e0cac5$exports;
$5859dee247a60293$var$MapCache.prototype['delete'] = $5ccdafc0842f5c11$exports;
$5859dee247a60293$var$MapCache.prototype.get = $88ab502486caac5a$exports;
$5859dee247a60293$var$MapCache.prototype.has = $cb62e1606d86f933$exports;
$5859dee247a60293$var$MapCache.prototype.set = $636795ff4b8bad57$exports;
$5859dee247a60293$exports = $5859dee247a60293$var$MapCache;


/** Error message constants. */ var $4753e2a83435654c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4753e2a83435654c$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($4753e2a83435654c$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4753e2a83435654c$var$memoize.Cache || $5859dee247a60293$exports);
    return memoized;
}
// Expose `MapCache`.
$4753e2a83435654c$var$memoize.Cache = $5859dee247a60293$exports;
$4753e2a83435654c$exports = $4753e2a83435654c$var$memoize;


/** Used as the maximum memoize cache size. */ var $29c7e774861703f5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $29c7e774861703f5$var$memoizeCapped(func) {
    var result = $4753e2a83435654c$exports(func, function(key) {
        if (cache.size === $29c7e774861703f5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$29c7e774861703f5$exports = $29c7e774861703f5$var$memoizeCapped;


/** Used to match property names within property paths. */ var $714bc0a107af1b09$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $714bc0a107af1b09$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $714bc0a107af1b09$var$stringToPath = $29c7e774861703f5$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($714bc0a107af1b09$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($714bc0a107af1b09$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$714bc0a107af1b09$exports = $714bc0a107af1b09$var$stringToPath;


var $be7b080aded3ae30$exports = {};
var $6b06e0dfcf334e4d$exports = {};

var $a85d44099b7eb489$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a85d44099b7eb489$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a85d44099b7eb489$exports = $a85d44099b7eb489$var$arrayMap;




/** Used as references for various `Number` constants. */ var $6b06e0dfcf334e4d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $6b06e0dfcf334e4d$var$symbolProto = $44b18937e9955607$exports ? $44b18937e9955607$exports.prototype : undefined, $6b06e0dfcf334e4d$var$symbolToString = $6b06e0dfcf334e4d$var$symbolProto ? $6b06e0dfcf334e4d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $6b06e0dfcf334e4d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0dad9fd8605a15e0$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a85d44099b7eb489$exports(value, $6b06e0dfcf334e4d$var$baseToString) + '';
    if ($d6f9cc72255262a9$exports(value)) return $6b06e0dfcf334e4d$var$symbolToString ? $6b06e0dfcf334e4d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$6b06e0dfcf334e4d$var$INFINITY ? '-0' : result;
}
$6b06e0dfcf334e4d$exports = $6b06e0dfcf334e4d$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $be7b080aded3ae30$var$toString(value) {
    return value == null ? '' : $6b06e0dfcf334e4d$exports(value);
}
$be7b080aded3ae30$exports = $be7b080aded3ae30$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $992132bc1453647e$var$castPath(value, object) {
    if ($0dad9fd8605a15e0$exports(value)) return value;
    return $0ddcb46fa3e04a1d$exports(value, object) ? [
        value
    ] : $714bc0a107af1b09$exports($be7b080aded3ae30$exports(value));
}
$992132bc1453647e$exports = $992132bc1453647e$var$castPath;


var $e8677f883373cf17$exports = {};
var $cf3e42f23148d47e$exports = {};


/** `Object#toString` result references. */ var $cf3e42f23148d47e$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $cf3e42f23148d47e$var$baseIsArguments(value) {
    return $081ff81630beaefd$exports(value) && $3c36286fb8e110d4$exports(value) == $cf3e42f23148d47e$var$argsTag;
}
$cf3e42f23148d47e$exports = $cf3e42f23148d47e$var$baseIsArguments;



/** Used for built-in method references. */ var $e8677f883373cf17$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e8677f883373cf17$var$hasOwnProperty = $e8677f883373cf17$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $e8677f883373cf17$var$propertyIsEnumerable = $e8677f883373cf17$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $e8677f883373cf17$var$isArguments = $cf3e42f23148d47e$exports(function() {
    return arguments;
}()) ? $cf3e42f23148d47e$exports : function(value) {
    return $081ff81630beaefd$exports(value) && $e8677f883373cf17$var$hasOwnProperty.call(value, 'callee') && !$e8677f883373cf17$var$propertyIsEnumerable.call(value, 'callee');
};
$e8677f883373cf17$exports = $e8677f883373cf17$var$isArguments;



var $7f250765c2f42779$exports = {};
/** Used as references for various `Number` constants. */ var $7f250765c2f42779$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $7f250765c2f42779$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $7f250765c2f42779$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $7f250765c2f42779$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $7f250765c2f42779$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$7f250765c2f42779$exports = $7f250765c2f42779$var$isIndex;


var $e8c6af7c97bda4d0$exports = {};
/** Used as references for various `Number` constants. */ var $e8c6af7c97bda4d0$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e8c6af7c97bda4d0$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e8c6af7c97bda4d0$var$MAX_SAFE_INTEGER;
}
$e8c6af7c97bda4d0$exports = $e8c6af7c97bda4d0$var$isLength;


var $1cc1e009721d8d16$exports = {};

/** Used as references for various `Number` constants. */ var $1cc1e009721d8d16$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1cc1e009721d8d16$var$toKey(value) {
    if (typeof value == 'string' || $d6f9cc72255262a9$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$1cc1e009721d8d16$var$INFINITY ? '-0' : result;
}
$1cc1e009721d8d16$exports = $1cc1e009721d8d16$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $50b7a46188d0e6a9$var$hasPath(object, path, hasFunc) {
    path = $992132bc1453647e$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $1cc1e009721d8d16$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $e8c6af7c97bda4d0$exports(length) && $7f250765c2f42779$exports(key, length) && ($0dad9fd8605a15e0$exports(object) || $e8677f883373cf17$exports(object));
}
$50b7a46188d0e6a9$exports = $50b7a46188d0e6a9$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $46c2c57422564351$var$has(object, path) {
    return object != null && $50b7a46188d0e6a9$exports(object, path, $d760b7ab49711fe3$exports);
}
$46c2c57422564351$exports = $46c2c57422564351$var$has;


const $119ff91a5e84d9ca$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $119ff91a5e84d9ca$export$2e2bcd8739ae039 = $119ff91a5e84d9ca$var$isSchema;


class $c676831fc0e5e9d1$var$Condition {
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $119ff91a5e84d9ca$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($46c2c57422564351$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
}
var $c676831fc0e5e9d1$export$2e2bcd8739ae039 = $c676831fc0e5e9d1$var$Condition;



function $759075e61dac8d60$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $aba2b35f38aa11b0$var$_extends() {
    $aba2b35f38aa11b0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aba2b35f38aa11b0$var$_extends.apply(this, arguments);
}
let $aba2b35f38aa11b0$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $aba2b35f38aa11b0$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $aba2b35f38aa11b0$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($aba2b35f38aa11b0$var$strReg, (_, key)=>(0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $759075e61dac8d60$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($aba2b35f38aa11b0$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $aba2b35f38aa11b0$export$2e2bcd8739ae039);
    }
}


const $1b760d2b001126f1$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $1b760d2b001126f1$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $1b760d2b001126f1$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $aba2b35f38aa11b0$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $aba2b35f38aa11b0$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $0bf76c4b7d3bebed$exports = {};
var $176d4886c53a8766$exports = {};
var $c8c616e5fcbea58b$exports = {};

var $c8c616e5fcbea58b$var$defineProperty = function() {
    try {
        var func = $70a39ef513b95a52$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$c8c616e5fcbea58b$exports = $c8c616e5fcbea58b$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $176d4886c53a8766$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $c8c616e5fcbea58b$exports) $c8c616e5fcbea58b$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$176d4886c53a8766$exports = $176d4886c53a8766$var$baseAssignValue;


var $9bc3071b9813d0d8$exports = {};
var $a421c09b84600e30$exports = {};
var $79061880ffcf8032$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $79061880ffcf8032$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$79061880ffcf8032$exports = $79061880ffcf8032$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a421c09b84600e30$var$baseFor = $79061880ffcf8032$exports();
$a421c09b84600e30$exports = $a421c09b84600e30$var$baseFor;


var $9914303b6dbcafc6$exports = {};
var $74985e1f8fb69663$exports = {};
var $d784d8b78baaae79$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d784d8b78baaae79$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$d784d8b78baaae79$exports = $d784d8b78baaae79$var$baseTimes;





var $ePjyc = parcelRequire("ePjyc");

var $8771188c58b1b7b7$exports = {};
var $90dc171f9c4584bd$exports = {};



/** `Object#toString` result references. */ var $90dc171f9c4584bd$var$argsTag = '[object Arguments]', $90dc171f9c4584bd$var$arrayTag = '[object Array]', $90dc171f9c4584bd$var$boolTag = '[object Boolean]', $90dc171f9c4584bd$var$dateTag = '[object Date]', $90dc171f9c4584bd$var$errorTag = '[object Error]', $90dc171f9c4584bd$var$funcTag = '[object Function]', $90dc171f9c4584bd$var$mapTag = '[object Map]', $90dc171f9c4584bd$var$numberTag = '[object Number]', $90dc171f9c4584bd$var$objectTag = '[object Object]', $90dc171f9c4584bd$var$regexpTag = '[object RegExp]', $90dc171f9c4584bd$var$setTag = '[object Set]', $90dc171f9c4584bd$var$stringTag = '[object String]', $90dc171f9c4584bd$var$weakMapTag = '[object WeakMap]';
var $90dc171f9c4584bd$var$arrayBufferTag = '[object ArrayBuffer]', $90dc171f9c4584bd$var$dataViewTag = '[object DataView]', $90dc171f9c4584bd$var$float32Tag = '[object Float32Array]', $90dc171f9c4584bd$var$float64Tag = '[object Float64Array]', $90dc171f9c4584bd$var$int8Tag = '[object Int8Array]', $90dc171f9c4584bd$var$int16Tag = '[object Int16Array]', $90dc171f9c4584bd$var$int32Tag = '[object Int32Array]', $90dc171f9c4584bd$var$uint8Tag = '[object Uint8Array]', $90dc171f9c4584bd$var$uint8ClampedTag = '[object Uint8ClampedArray]', $90dc171f9c4584bd$var$uint16Tag = '[object Uint16Array]', $90dc171f9c4584bd$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $90dc171f9c4584bd$var$typedArrayTags = {};
$90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$float32Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$float64Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$int8Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$int16Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$int32Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$uint8Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$uint8ClampedTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$uint16Tag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$uint32Tag] = true;
$90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$argsTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$arrayTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$arrayBufferTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$boolTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$dataViewTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$dateTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$errorTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$funcTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$mapTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$numberTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$objectTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$regexpTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$setTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$stringTag] = $90dc171f9c4584bd$var$typedArrayTags[$90dc171f9c4584bd$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $90dc171f9c4584bd$var$baseIsTypedArray(value) {
    return $081ff81630beaefd$exports(value) && $e8c6af7c97bda4d0$exports(value.length) && !!$90dc171f9c4584bd$var$typedArrayTags[$3c36286fb8e110d4$exports(value)];
}
$90dc171f9c4584bd$exports = $90dc171f9c4584bd$var$baseIsTypedArray;


var $25658711b9e1139b$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $25658711b9e1139b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$25658711b9e1139b$exports = $25658711b9e1139b$var$baseUnary;



var $21HyH = parcelRequire("21HyH");
/* Node.js helper references. */ var $8771188c58b1b7b7$var$nodeIsTypedArray = $21HyH && $21HyH.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8771188c58b1b7b7$var$isTypedArray = $8771188c58b1b7b7$var$nodeIsTypedArray ? $25658711b9e1139b$exports($8771188c58b1b7b7$var$nodeIsTypedArray) : $90dc171f9c4584bd$exports;
$8771188c58b1b7b7$exports = $8771188c58b1b7b7$var$isTypedArray;


/** Used for built-in method references. */ var $74985e1f8fb69663$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $74985e1f8fb69663$var$hasOwnProperty = $74985e1f8fb69663$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $74985e1f8fb69663$var$arrayLikeKeys(value, inherited) {
    var isArr = $0dad9fd8605a15e0$exports(value), isArg = !isArr && $e8677f883373cf17$exports(value), isBuff = !isArr && !isArg && $ePjyc(value), isType = !isArr && !isArg && !isBuff && $8771188c58b1b7b7$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $d784d8b78baaae79$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $74985e1f8fb69663$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $7f250765c2f42779$exports(key, length)))) result.push(key);
    return result;
}
$74985e1f8fb69663$exports = $74985e1f8fb69663$var$arrayLikeKeys;


var $6e2f47c6dc1b9cf1$exports = {};
var $78a898c5ec379853$exports = {};
/** Used for built-in method references. */ var $78a898c5ec379853$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $78a898c5ec379853$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $78a898c5ec379853$var$objectProto;
    return value === proto;
}
$78a898c5ec379853$exports = $78a898c5ec379853$var$isPrototype;


var $01b96054a65095c4$exports = {};
var $3c869d02d181d4b7$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3c869d02d181d4b7$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$3c869d02d181d4b7$exports = $3c869d02d181d4b7$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $01b96054a65095c4$var$nativeKeys = $3c869d02d181d4b7$exports(Object.keys, Object);
$01b96054a65095c4$exports = $01b96054a65095c4$var$nativeKeys;


/** Used for built-in method references. */ var $6e2f47c6dc1b9cf1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6e2f47c6dc1b9cf1$var$hasOwnProperty = $6e2f47c6dc1b9cf1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6e2f47c6dc1b9cf1$var$baseKeys(object) {
    if (!$78a898c5ec379853$exports(object)) return $01b96054a65095c4$exports(object);
    var result = [];
    for(var key in Object(object))if ($6e2f47c6dc1b9cf1$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$6e2f47c6dc1b9cf1$exports = $6e2f47c6dc1b9cf1$var$baseKeys;


var $1bd4ff927d0f18a2$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1bd4ff927d0f18a2$var$isArrayLike(value) {
    return value != null && $e8c6af7c97bda4d0$exports(value.length) && !$34b74e9746582d66$exports(value);
}
$1bd4ff927d0f18a2$exports = $1bd4ff927d0f18a2$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9914303b6dbcafc6$var$keys(object) {
    return $1bd4ff927d0f18a2$exports(object) ? $74985e1f8fb69663$exports(object) : $6e2f47c6dc1b9cf1$exports(object);
}
$9914303b6dbcafc6$exports = $9914303b6dbcafc6$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $9bc3071b9813d0d8$var$baseForOwn(object, iteratee) {
    return object && $a421c09b84600e30$exports(object, iteratee, $9914303b6dbcafc6$exports);
}
$9bc3071b9813d0d8$exports = $9bc3071b9813d0d8$var$baseForOwn;


var $d19bc8e0ee83495b$exports = {};
var $0bb08d2dd2ab63f4$exports = {};
var $2da7a681af640058$exports = {};
var $75791010ddfd1370$exports = {};

var $4a3e2cad38fcfb67$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $4a3e2cad38fcfb67$var$stackClear() {
    this.__data__ = new $0dcc562088c5ea1f$exports;
    this.size = 0;
}
$4a3e2cad38fcfb67$exports = $4a3e2cad38fcfb67$var$stackClear;


var $7c56a5359910082a$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7c56a5359910082a$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$7c56a5359910082a$exports = $7c56a5359910082a$var$stackDelete;


var $6caba1ed3d5b2d45$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6caba1ed3d5b2d45$var$stackGet(key) {
    return this.__data__.get(key);
}
$6caba1ed3d5b2d45$exports = $6caba1ed3d5b2d45$var$stackGet;


var $f8bec89c50f01121$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f8bec89c50f01121$var$stackHas(key) {
    return this.__data__.has(key);
}
$f8bec89c50f01121$exports = $f8bec89c50f01121$var$stackHas;


var $f065115feef7aa9b$exports = {};



/** Used as the size to enable large array optimizations. */ var $f065115feef7aa9b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f065115feef7aa9b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $0dcc562088c5ea1f$exports) {
        var pairs = data.__data__;
        if (!$7f8f1cf0e34db950$exports || pairs.length < $f065115feef7aa9b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $5859dee247a60293$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$f065115feef7aa9b$exports = $f065115feef7aa9b$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75791010ddfd1370$var$Stack(entries) {
    var data = this.__data__ = new $0dcc562088c5ea1f$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$75791010ddfd1370$var$Stack.prototype.clear = $4a3e2cad38fcfb67$exports;
$75791010ddfd1370$var$Stack.prototype['delete'] = $7c56a5359910082a$exports;
$75791010ddfd1370$var$Stack.prototype.get = $6caba1ed3d5b2d45$exports;
$75791010ddfd1370$var$Stack.prototype.has = $f8bec89c50f01121$exports;
$75791010ddfd1370$var$Stack.prototype.set = $f065115feef7aa9b$exports;
$75791010ddfd1370$exports = $75791010ddfd1370$var$Stack;


var $8da19427461b61a4$exports = {};
var $848083ed1e324885$exports = {};

var $d2838cff9f175881$exports = {};
var $20a2ebb849bf804e$exports = {};

var $a40b8aa3389b55d7$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $a40b8aa3389b55d7$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $a40b8aa3389b55d7$var$setCacheAdd(value) {
    this.__data__.set(value, $a40b8aa3389b55d7$var$HASH_UNDEFINED);
    return this;
}
$a40b8aa3389b55d7$exports = $a40b8aa3389b55d7$var$setCacheAdd;


var $c24e664dd804e525$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $c24e664dd804e525$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$c24e664dd804e525$exports = $c24e664dd804e525$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $20a2ebb849bf804e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $5859dee247a60293$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$20a2ebb849bf804e$var$SetCache.prototype.add = $20a2ebb849bf804e$var$SetCache.prototype.push = $a40b8aa3389b55d7$exports;
$20a2ebb849bf804e$var$SetCache.prototype.has = $c24e664dd804e525$exports;
$20a2ebb849bf804e$exports = $20a2ebb849bf804e$var$SetCache;


var $88470b9415552302$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $88470b9415552302$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$88470b9415552302$exports = $88470b9415552302$var$arraySome;


var $cf2ed798ad27a518$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cf2ed798ad27a518$var$cacheHas(cache, key) {
    return cache.has(key);
}
$cf2ed798ad27a518$exports = $cf2ed798ad27a518$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $d2838cff9f175881$var$COMPARE_PARTIAL_FLAG = 1, $d2838cff9f175881$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d2838cff9f175881$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d2838cff9f175881$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d2838cff9f175881$var$COMPARE_UNORDERED_FLAG ? new $20a2ebb849bf804e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$88470b9415552302$exports(other, function(othValue, othIndex) {
                if (!$cf2ed798ad27a518$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$d2838cff9f175881$exports = $d2838cff9f175881$var$equalArrays;


var $83580ee98ac38196$exports = {};

var $71f286c16065c8f3$exports = {};

var $ad9xy = parcelRequire("ad9xy");
/** Built-in value references. */ var $71f286c16065c8f3$var$Uint8Array = $ad9xy.Uint8Array;
$71f286c16065c8f3$exports = $71f286c16065c8f3$var$Uint8Array;




var $72ba528730521d35$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $72ba528730521d35$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$72ba528730521d35$exports = $72ba528730521d35$var$mapToArray;


var $ee8fd0ab5bf987a9$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $ee8fd0ab5bf987a9$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$ee8fd0ab5bf987a9$exports = $ee8fd0ab5bf987a9$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $83580ee98ac38196$var$COMPARE_PARTIAL_FLAG = 1, $83580ee98ac38196$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $83580ee98ac38196$var$boolTag = '[object Boolean]', $83580ee98ac38196$var$dateTag = '[object Date]', $83580ee98ac38196$var$errorTag = '[object Error]', $83580ee98ac38196$var$mapTag = '[object Map]', $83580ee98ac38196$var$numberTag = '[object Number]', $83580ee98ac38196$var$regexpTag = '[object RegExp]', $83580ee98ac38196$var$setTag = '[object Set]', $83580ee98ac38196$var$stringTag = '[object String]', $83580ee98ac38196$var$symbolTag = '[object Symbol]';
var $83580ee98ac38196$var$arrayBufferTag = '[object ArrayBuffer]', $83580ee98ac38196$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $83580ee98ac38196$var$symbolProto = $44b18937e9955607$exports ? $44b18937e9955607$exports.prototype : undefined, $83580ee98ac38196$var$symbolValueOf = $83580ee98ac38196$var$symbolProto ? $83580ee98ac38196$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $83580ee98ac38196$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $83580ee98ac38196$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $83580ee98ac38196$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $71f286c16065c8f3$exports(object), new $71f286c16065c8f3$exports(other))) return false;
            return true;
        case $83580ee98ac38196$var$boolTag:
        case $83580ee98ac38196$var$dateTag:
        case $83580ee98ac38196$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $c5a6945c8153f400$exports(+object, +other);
        case $83580ee98ac38196$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $83580ee98ac38196$var$regexpTag:
        case $83580ee98ac38196$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $83580ee98ac38196$var$mapTag:
            var convert = $72ba528730521d35$exports;
        case $83580ee98ac38196$var$setTag:
            var isPartial = bitmask & $83580ee98ac38196$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $ee8fd0ab5bf987a9$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $83580ee98ac38196$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d2838cff9f175881$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $83580ee98ac38196$var$symbolTag:
            if ($83580ee98ac38196$var$symbolValueOf) return $83580ee98ac38196$var$symbolValueOf.call(object) == $83580ee98ac38196$var$symbolValueOf.call(other);
    }
    return false;
}
$83580ee98ac38196$exports = $83580ee98ac38196$var$equalByTag;


var $adecdc7a04f5f934$exports = {};
var $6cd11188c66d1529$exports = {};
var $34f7f23ba2b87651$exports = {};
var $8308f38c5d4ce5e5$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8308f38c5d4ce5e5$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$8308f38c5d4ce5e5$exports = $8308f38c5d4ce5e5$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $34f7f23ba2b87651$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0dad9fd8605a15e0$exports(object) ? result : $8308f38c5d4ce5e5$exports(result, symbolsFunc(object));
}
$34f7f23ba2b87651$exports = $34f7f23ba2b87651$var$baseGetAllKeys;


var $b5e2196a3b8646f6$exports = {};
var $f12aa677189a2bbd$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f12aa677189a2bbd$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$f12aa677189a2bbd$exports = $f12aa677189a2bbd$var$arrayFilter;


var $e7997430cc340cf9$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e7997430cc340cf9$var$stubArray() {
    return [];
}
$e7997430cc340cf9$exports = $e7997430cc340cf9$var$stubArray;


/** Used for built-in method references. */ var $b5e2196a3b8646f6$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b5e2196a3b8646f6$var$propertyIsEnumerable = $b5e2196a3b8646f6$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b5e2196a3b8646f6$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b5e2196a3b8646f6$var$getSymbols = !$b5e2196a3b8646f6$var$nativeGetSymbols ? $e7997430cc340cf9$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $f12aa677189a2bbd$exports($b5e2196a3b8646f6$var$nativeGetSymbols(object), function(symbol) {
        return $b5e2196a3b8646f6$var$propertyIsEnumerable.call(object, symbol);
    });
};
$b5e2196a3b8646f6$exports = $b5e2196a3b8646f6$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6cd11188c66d1529$var$getAllKeys(object) {
    return $34f7f23ba2b87651$exports(object, $9914303b6dbcafc6$exports, $b5e2196a3b8646f6$exports);
}
$6cd11188c66d1529$exports = $6cd11188c66d1529$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $adecdc7a04f5f934$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $adecdc7a04f5f934$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $adecdc7a04f5f934$var$hasOwnProperty = $adecdc7a04f5f934$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $adecdc7a04f5f934$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $adecdc7a04f5f934$var$COMPARE_PARTIAL_FLAG, objProps = $6cd11188c66d1529$exports(object), objLength = objProps.length, othProps = $6cd11188c66d1529$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $adecdc7a04f5f934$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$adecdc7a04f5f934$exports = $adecdc7a04f5f934$var$equalObjects;


var $c3176be4b2e3b044$exports = {};
var $867f45561a7d918a$exports = {};


var $ad9xy = parcelRequire("ad9xy");
/* Built-in method references that are verified to be native. */ var $867f45561a7d918a$var$DataView = $70a39ef513b95a52$exports($ad9xy, 'DataView');
$867f45561a7d918a$exports = $867f45561a7d918a$var$DataView;



var $75af7e1802c8f953$exports = {};


var $ad9xy = parcelRequire("ad9xy");
/* Built-in method references that are verified to be native. */ var $75af7e1802c8f953$var$Promise = $70a39ef513b95a52$exports($ad9xy, 'Promise');
$75af7e1802c8f953$exports = $75af7e1802c8f953$var$Promise;


var $8e81c2ccc2a6deed$exports = {};


var $ad9xy = parcelRequire("ad9xy");
/* Built-in method references that are verified to be native. */ var $8e81c2ccc2a6deed$var$Set = $70a39ef513b95a52$exports($ad9xy, 'Set');
$8e81c2ccc2a6deed$exports = $8e81c2ccc2a6deed$var$Set;


var $f20565e9cf0ab1f0$exports = {};


var $ad9xy = parcelRequire("ad9xy");
/* Built-in method references that are verified to be native. */ var $f20565e9cf0ab1f0$var$WeakMap = $70a39ef513b95a52$exports($ad9xy, 'WeakMap');
$f20565e9cf0ab1f0$exports = $f20565e9cf0ab1f0$var$WeakMap;




/** `Object#toString` result references. */ var $c3176be4b2e3b044$var$mapTag = '[object Map]', $c3176be4b2e3b044$var$objectTag = '[object Object]', $c3176be4b2e3b044$var$promiseTag = '[object Promise]', $c3176be4b2e3b044$var$setTag = '[object Set]', $c3176be4b2e3b044$var$weakMapTag = '[object WeakMap]';
var $c3176be4b2e3b044$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c3176be4b2e3b044$var$dataViewCtorString = $2b82d45a377e45f5$exports($867f45561a7d918a$exports), $c3176be4b2e3b044$var$mapCtorString = $2b82d45a377e45f5$exports($7f8f1cf0e34db950$exports), $c3176be4b2e3b044$var$promiseCtorString = $2b82d45a377e45f5$exports($75af7e1802c8f953$exports), $c3176be4b2e3b044$var$setCtorString = $2b82d45a377e45f5$exports($8e81c2ccc2a6deed$exports), $c3176be4b2e3b044$var$weakMapCtorString = $2b82d45a377e45f5$exports($f20565e9cf0ab1f0$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c3176be4b2e3b044$var$getTag = $3c36286fb8e110d4$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($867f45561a7d918a$exports && $c3176be4b2e3b044$var$getTag(new $867f45561a7d918a$exports(new ArrayBuffer(1))) != $c3176be4b2e3b044$var$dataViewTag || $7f8f1cf0e34db950$exports && $c3176be4b2e3b044$var$getTag(new $7f8f1cf0e34db950$exports) != $c3176be4b2e3b044$var$mapTag || $75af7e1802c8f953$exports && $c3176be4b2e3b044$var$getTag($75af7e1802c8f953$exports.resolve()) != $c3176be4b2e3b044$var$promiseTag || $8e81c2ccc2a6deed$exports && $c3176be4b2e3b044$var$getTag(new $8e81c2ccc2a6deed$exports) != $c3176be4b2e3b044$var$setTag || $f20565e9cf0ab1f0$exports && $c3176be4b2e3b044$var$getTag(new $f20565e9cf0ab1f0$exports) != $c3176be4b2e3b044$var$weakMapTag) $c3176be4b2e3b044$var$getTag = function(value) {
    var result = $3c36286fb8e110d4$exports(value), Ctor = result == $c3176be4b2e3b044$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $2b82d45a377e45f5$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c3176be4b2e3b044$var$dataViewCtorString:
            return $c3176be4b2e3b044$var$dataViewTag;
        case $c3176be4b2e3b044$var$mapCtorString:
            return $c3176be4b2e3b044$var$mapTag;
        case $c3176be4b2e3b044$var$promiseCtorString:
            return $c3176be4b2e3b044$var$promiseTag;
        case $c3176be4b2e3b044$var$setCtorString:
            return $c3176be4b2e3b044$var$setTag;
        case $c3176be4b2e3b044$var$weakMapCtorString:
            return $c3176be4b2e3b044$var$weakMapTag;
    }
    return result;
};
$c3176be4b2e3b044$exports = $c3176be4b2e3b044$var$getTag;




var $ePjyc = parcelRequire("ePjyc");

/** Used to compose bitmasks for value comparisons. */ var $848083ed1e324885$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $848083ed1e324885$var$argsTag = '[object Arguments]', $848083ed1e324885$var$arrayTag = '[object Array]', $848083ed1e324885$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $848083ed1e324885$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $848083ed1e324885$var$hasOwnProperty = $848083ed1e324885$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $848083ed1e324885$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0dad9fd8605a15e0$exports(object), othIsArr = $0dad9fd8605a15e0$exports(other), objTag = objIsArr ? $848083ed1e324885$var$arrayTag : $c3176be4b2e3b044$exports(object), othTag = othIsArr ? $848083ed1e324885$var$arrayTag : $c3176be4b2e3b044$exports(other);
    objTag = objTag == $848083ed1e324885$var$argsTag ? $848083ed1e324885$var$objectTag : objTag;
    othTag = othTag == $848083ed1e324885$var$argsTag ? $848083ed1e324885$var$objectTag : othTag;
    var objIsObj = objTag == $848083ed1e324885$var$objectTag, othIsObj = othTag == $848083ed1e324885$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ePjyc(object)) {
        if (!$ePjyc(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $75791010ddfd1370$exports);
        return objIsArr || $8771188c58b1b7b7$exports(object) ? $d2838cff9f175881$exports(object, other, bitmask, customizer, equalFunc, stack) : $83580ee98ac38196$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $848083ed1e324885$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $848083ed1e324885$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $848083ed1e324885$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $75791010ddfd1370$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $75791010ddfd1370$exports);
    return $adecdc7a04f5f934$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$848083ed1e324885$exports = $848083ed1e324885$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8da19427461b61a4$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$081ff81630beaefd$exports(value) && !$081ff81630beaefd$exports(other)) return value !== value && other !== other;
    return $848083ed1e324885$exports(value, other, bitmask, customizer, $8da19427461b61a4$var$baseIsEqual, stack);
}
$8da19427461b61a4$exports = $8da19427461b61a4$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $2da7a681af640058$var$COMPARE_PARTIAL_FLAG = 1, $2da7a681af640058$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2da7a681af640058$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $75791010ddfd1370$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $8da19427461b61a4$exports(srcValue, objValue, $2da7a681af640058$var$COMPARE_PARTIAL_FLAG | $2da7a681af640058$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2da7a681af640058$exports = $2da7a681af640058$var$baseIsMatch;


var $30dc19fc6f54781d$exports = {};
var $9e61e49e43f4f45f$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9e61e49e43f4f45f$var$isStrictComparable(value) {
    return value === value && !$ef750d4bab473ce5$exports(value);
}
$9e61e49e43f4f45f$exports = $9e61e49e43f4f45f$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $30dc19fc6f54781d$var$getMatchData(object) {
    var result = $9914303b6dbcafc6$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9e61e49e43f4f45f$exports(value)
        ];
    }
    return result;
}
$30dc19fc6f54781d$exports = $30dc19fc6f54781d$var$getMatchData;


var $1036dbe17a0e4f03$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1036dbe17a0e4f03$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1036dbe17a0e4f03$exports = $1036dbe17a0e4f03$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0bb08d2dd2ab63f4$var$baseMatches(source) {
    var matchData = $30dc19fc6f54781d$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1036dbe17a0e4f03$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2da7a681af640058$exports(object, source, matchData);
    };
}
$0bb08d2dd2ab63f4$exports = $0bb08d2dd2ab63f4$var$baseMatches;


var $0ff15313ad6e4199$exports = {};

var $b0ff9c5bcfed5a7a$exports = {};
var $c881ec148364e4ad$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c881ec148364e4ad$var$baseGet(object, path) {
    path = $992132bc1453647e$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$1cc1e009721d8d16$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$c881ec148364e4ad$exports = $c881ec148364e4ad$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $b0ff9c5bcfed5a7a$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c881ec148364e4ad$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$b0ff9c5bcfed5a7a$exports = $b0ff9c5bcfed5a7a$var$get;


var $d801bce6c1f9a514$exports = {};
var $ed134aa64b8b2226$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ed134aa64b8b2226$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ed134aa64b8b2226$exports = $ed134aa64b8b2226$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $d801bce6c1f9a514$var$hasIn(object, path) {
    return object != null && $50b7a46188d0e6a9$exports(object, path, $ed134aa64b8b2226$exports);
}
$d801bce6c1f9a514$exports = $d801bce6c1f9a514$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $0ff15313ad6e4199$var$COMPARE_PARTIAL_FLAG = 1, $0ff15313ad6e4199$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0ff15313ad6e4199$var$baseMatchesProperty(path, srcValue) {
    if ($0ddcb46fa3e04a1d$exports(path) && $9e61e49e43f4f45f$exports(srcValue)) return $1036dbe17a0e4f03$exports($1cc1e009721d8d16$exports(path), srcValue);
    return function(object) {
        var objValue = $b0ff9c5bcfed5a7a$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $d801bce6c1f9a514$exports(object, path) : $8da19427461b61a4$exports(srcValue, objValue, $0ff15313ad6e4199$var$COMPARE_PARTIAL_FLAG | $0ff15313ad6e4199$var$COMPARE_UNORDERED_FLAG);
    };
}
$0ff15313ad6e4199$exports = $0ff15313ad6e4199$var$baseMatchesProperty;


var $f957370e65677092$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f957370e65677092$var$identity(value) {
    return value;
}
$f957370e65677092$exports = $f957370e65677092$var$identity;



var $8ed823400e3e06c5$exports = {};
var $935b75cdbde8913f$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $935b75cdbde8913f$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$935b75cdbde8913f$exports = $935b75cdbde8913f$var$baseProperty;


var $4a6ff1b09732dee2$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4a6ff1b09732dee2$var$basePropertyDeep(path) {
    return function(object) {
        return $c881ec148364e4ad$exports(object, path);
    };
}
$4a6ff1b09732dee2$exports = $4a6ff1b09732dee2$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $8ed823400e3e06c5$var$property(path) {
    return $0ddcb46fa3e04a1d$exports(path) ? $935b75cdbde8913f$exports($1cc1e009721d8d16$exports(path)) : $4a6ff1b09732dee2$exports(path);
}
$8ed823400e3e06c5$exports = $8ed823400e3e06c5$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $d19bc8e0ee83495b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $f957370e65677092$exports;
    if (typeof value == 'object') return $0dad9fd8605a15e0$exports(value) ? $0ff15313ad6e4199$exports(value[0], value[1]) : $0bb08d2dd2ab63f4$exports(value);
    return $8ed823400e3e06c5$exports(value);
}
$d19bc8e0ee83495b$exports = $d19bc8e0ee83495b$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $0bf76c4b7d3bebed$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $d19bc8e0ee83495b$exports(iteratee, 3);
    $9bc3071b9813d0d8$exports(object, function(value, key, object) {
        $176d4886c53a8766$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$0bf76c4b7d3bebed$exports = $0bf76c4b7d3bebed$var$mapValues;



var $5d5d4787cd7031b8$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $5d5d4787cd7031b8$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$5d5d4787cd7031b8$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$5d5d4787cd7031b8$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$5d5d4787cd7031b8$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $5d5d4787cd7031b8$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $5d5d4787cd7031b8$var$DIGIT_REGEX = /^\d+$/, $5d5d4787cd7031b8$var$LEAD_DIGIT_REGEX = /^\d/, $5d5d4787cd7031b8$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $5d5d4787cd7031b8$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $5d5d4787cd7031b8$var$MAX_CACHE_SIZE = 512;
var $5d5d4787cd7031b8$var$pathCache = new $5d5d4787cd7031b8$var$Cache($5d5d4787cd7031b8$var$MAX_CACHE_SIZE), $5d5d4787cd7031b8$var$setCache = new $5d5d4787cd7031b8$var$Cache($5d5d4787cd7031b8$var$MAX_CACHE_SIZE), $5d5d4787cd7031b8$var$getCache = new $5d5d4787cd7031b8$var$Cache($5d5d4787cd7031b8$var$MAX_CACHE_SIZE);
var $5d5d4787cd7031b8$var$config;
$5d5d4787cd7031b8$exports = {
    Cache: $5d5d4787cd7031b8$var$Cache,
    split: $5d5d4787cd7031b8$var$split,
    normalizePath: $5d5d4787cd7031b8$var$normalizePath,
    setter: function(path) {
        var parts = $5d5d4787cd7031b8$var$normalizePath(path);
        return $5d5d4787cd7031b8$var$setCache.get(path) || $5d5d4787cd7031b8$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $5d5d4787cd7031b8$var$normalizePath(path);
        return $5d5d4787cd7031b8$var$getCache.get(path) || $5d5d4787cd7031b8$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($5d5d4787cd7031b8$var$isQuoted(part) || $5d5d4787cd7031b8$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $5d5d4787cd7031b8$var$forEach(Array.isArray(path) ? path : $5d5d4787cd7031b8$var$split(path), cb, thisArg);
    }
};
function $5d5d4787cd7031b8$var$normalizePath(path) {
    return $5d5d4787cd7031b8$var$pathCache.get(path) || $5d5d4787cd7031b8$var$pathCache.set(path, $5d5d4787cd7031b8$var$split(path).map(function(part) {
        return part.replace($5d5d4787cd7031b8$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $5d5d4787cd7031b8$var$split(path) {
    return path.match($5d5d4787cd7031b8$var$SPLIT_REGEX) || [
        ''
    ];
}
function $5d5d4787cd7031b8$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($5d5d4787cd7031b8$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $5d5d4787cd7031b8$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $5d5d4787cd7031b8$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $5d5d4787cd7031b8$var$hasLeadingNumber(part) {
    return part.match($5d5d4787cd7031b8$var$LEAD_DIGIT_REGEX) && !part.match($5d5d4787cd7031b8$var$DIGIT_REGEX);
}
function $5d5d4787cd7031b8$var$hasSpecialChars(part) {
    return $5d5d4787cd7031b8$var$SPEC_CHAR_REGEX.test(part);
}
function $5d5d4787cd7031b8$var$shouldBeQuoted(part) {
    return !$5d5d4787cd7031b8$var$isQuoted(part) && ($5d5d4787cd7031b8$var$hasLeadingNumber(part) || $5d5d4787cd7031b8$var$hasSpecialChars(part));
}


const $22394e2b7741d4e7$var$prefixes = {
    context: '$',
    value: '.'
};
function $22394e2b7741d4e7$export$185802fd694ee1f5(key, options) {
    return new $22394e2b7741d4e7$export$2e2bcd8739ae039(key, options);
}
class $22394e2b7741d4e7$export$2e2bcd8739ae039 {
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $22394e2b7741d4e7$var$prefixes.context;
        this.isValue = this.key[0] === $22394e2b7741d4e7$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $22394e2b7741d4e7$var$prefixes.context : this.isValue ? $22394e2b7741d4e7$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $5d5d4787cd7031b8$exports.getter)(this.path, true);
        this.map = options.map;
    }
} // @ts-ignore
$22394e2b7741d4e7$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $bb6c52c519899e24$var$_extends() {
    $bb6c52c519899e24$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb6c52c519899e24$var$_extends.apply(this, arguments);
}
function $bb6c52c519899e24$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bb6c52c519899e24$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $bb6c52c519899e24$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($0bf76c4b7d3bebed$exports)))($bb6c52c519899e24$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $aba2b35f38aa11b0$export$2e2bcd8739ae039)((0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $bb6c52c519899e24$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $1c8fa0d4cae1dc45$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $1c8fa0d4cae1dc45$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $5d5d4787cd7031b8$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $1c8fa0d4cae1dc45$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $1c8fa0d4cae1dc45$var$reach = (obj, path, value, context)=>$1c8fa0d4cae1dc45$export$c52e5867d5879e24(obj, path, value, context).schema;
var $1c8fa0d4cae1dc45$export$2e2bcd8739ae039 = $1c8fa0d4cae1dc45$var$reach;




class $66559d9c3af5f6b3$export$2e2bcd8739ae039 {
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $66559d9c3af5f6b3$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
}



function $26e8c42a8d20d137$var$_extends() {
    $26e8c42a8d20d137$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $26e8c42a8d20d137$var$_extends.apply(this, arguments);
}
class $26e8c42a8d20d137$export$2e2bcd8739ae039 {
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $26e8c42a8d20d137$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $f2ed487758709380$export$2e2bcd8739ae039)($26e8c42a8d20d137$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $26e8c42a8d20d137$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($26e8c42a8d20d137$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $26e8c42a8d20d137$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $1b760d2b001126f1$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $1b760d2b001126f1$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($26e8c42a8d20d137$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($26e8c42a8d20d137$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $26e8c42a8d20d137$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $f2ed487758709380$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $6290250a2ab08af2$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $6290250a2ab08af2$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $6290250a2ab08af2$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $bb6c52c519899e24$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $759075e61dac8d60$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $22394e2b7741d4e7$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $c676831fc0e5e9d1$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $bb6c52c519899e24$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $6290250a2ab08af2$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $bb6c52c519899e24$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $6290250a2ab08af2$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $bb6c52c519899e24$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $66559d9c3af5f6b3$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $66559d9c3af5f6b3$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $6290250a2ab08af2$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $26e8c42a8d20d137$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$26e8c42a8d20d137$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$26e8c42a8d20d137$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $1c8fa0d4cae1dc45$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $26e8c42a8d20d137$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$26e8c42a8d20d137$export$2e2bcd8739ae039.prototype[alias] = $26e8c42a8d20d137$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$26e8c42a8d20d137$export$2e2bcd8739ae039.prototype[alias] = $26e8c42a8d20d137$export$2e2bcd8739ae039.prototype.notOneOf;
$26e8c42a8d20d137$export$2e2bcd8739ae039.prototype.optional = $26e8c42a8d20d137$export$2e2bcd8739ae039.prototype.notRequired;


const $7f1023be860832a5$var$Mixed = (0, $26e8c42a8d20d137$export$2e2bcd8739ae039);
var $7f1023be860832a5$export$2e2bcd8739ae039 = $7f1023be860832a5$var$Mixed;
function $7f1023be860832a5$export$185802fd694ee1f5() {
    return new $7f1023be860832a5$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$7f1023be860832a5$export$185802fd694ee1f5.prototype = $7f1023be860832a5$var$Mixed.prototype;




const $0c619856b5d5e27e$var$isAbsent = (value)=>value == null;
var $0c619856b5d5e27e$export$2e2bcd8739ae039 = $0c619856b5d5e27e$var$isAbsent;


function $73627cc0de58773f$export$185802fd694ee1f5() {
    return new $73627cc0de58773f$export$2e2bcd8739ae039();
}
class $73627cc0de58773f$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $6290250a2ab08af2$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $6290250a2ab08af2$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
}
$73627cc0de58773f$export$185802fd694ee1f5.prototype = $73627cc0de58773f$export$2e2bcd8739ae039.prototype;





let $7a974168aa28ad85$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $7a974168aa28ad85$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $7a974168aa28ad85$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $7a974168aa28ad85$var$isTrimmed = (value)=>(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === value.trim();
let $7a974168aa28ad85$var$objStringTag = ({}).toString();
function $7a974168aa28ad85$export$185802fd694ee1f5() {
    return new $7a974168aa28ad85$export$2e2bcd8739ae039();
}
class $7a974168aa28ad85$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $6290250a2ab08af2$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $6290250a2ab08af2$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $6290250a2ab08af2$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $6290250a2ab08af2$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).email) {
        return this.matches($7a974168aa28ad85$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).url) {
        return this.matches($7a974168aa28ad85$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).uuid) {
        return this.matches($7a974168aa28ad85$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $7a974168aa28ad85$var$isTrimmed
        });
    }
    lowercase(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $6290250a2ab08af2$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $7a974168aa28ad85$var$objStringTag) return value;
                return strValue;
            });
        });
    }
}
$7a974168aa28ad85$export$185802fd694ee1f5.prototype = $7a974168aa28ad85$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $892f03a053dca93f$var$isNaN = (value)=>value != +value;
function $892f03a053dca93f$export$185802fd694ee1f5() {
    return new $892f03a053dca93f$export$2e2bcd8739ae039();
}
class $892f03a053dca93f$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$892f03a053dca93f$var$isNaN(value);
    }
    min(min, message = (0, $6290250a2ab08af2$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $6290250a2ab08af2$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $6290250a2ab08af2$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $6290250a2ab08af2$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $6290250a2ab08af2$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $6290250a2ab08af2$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $6290250a2ab08af2$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
}
$892f03a053dca93f$export$185802fd694ee1f5.prototype = $892f03a053dca93f$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7ec02c2aa01c2d71$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7ec02c2aa01c2d71$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7ec02c2aa01c2d71$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $42174a7cad720bf1$var$invalidDate = new Date('');
let $42174a7cad720bf1$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $42174a7cad720bf1$export$185802fd694ee1f5() {
    return new $42174a7cad720bf1$export$2e2bcd8739ae039();
}
class $42174a7cad720bf1$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(v) {
        return $42174a7cad720bf1$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $6290250a2ab08af2$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $6290250a2ab08af2$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $7ec02c2aa01c2d71$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $42174a7cad720bf1$var$invalidDate;
            });
        });
    }
}
$42174a7cad720bf1$export$2e2bcd8739ae039.INVALID_DATE = $42174a7cad720bf1$var$invalidDate;
$42174a7cad720bf1$export$185802fd694ee1f5.prototype = $42174a7cad720bf1$export$2e2bcd8739ae039.prototype;
$42174a7cad720bf1$export$185802fd694ee1f5.INVALID_DATE = $42174a7cad720bf1$var$invalidDate;



var $f94f40929760d654$exports = {};
var $5eb1a20a655cecf6$exports = {};
var $6b1710bb74df1a4e$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $6b1710bb74df1a4e$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$6b1710bb74df1a4e$exports = $6b1710bb74df1a4e$var$arrayReduce;


var $ff9ee56e6bb91dd6$exports = {};
var $e76a18bd0d552c4a$exports = {};
var $6a1a249c085ff5bc$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $6a1a249c085ff5bc$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$6a1a249c085ff5bc$exports = $6a1a249c085ff5bc$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $e76a18bd0d552c4a$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $e76a18bd0d552c4a$var$deburrLetter = $6a1a249c085ff5bc$exports($e76a18bd0d552c4a$var$deburredLetters);
$e76a18bd0d552c4a$exports = $e76a18bd0d552c4a$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ff9ee56e6bb91dd6$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ff9ee56e6bb91dd6$var$rsComboMarksRange = '\\u0300-\\u036f', $ff9ee56e6bb91dd6$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ff9ee56e6bb91dd6$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ff9ee56e6bb91dd6$var$rsComboRange = $ff9ee56e6bb91dd6$var$rsComboMarksRange + $ff9ee56e6bb91dd6$var$reComboHalfMarksRange + $ff9ee56e6bb91dd6$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ff9ee56e6bb91dd6$var$rsCombo = '[' + $ff9ee56e6bb91dd6$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ff9ee56e6bb91dd6$var$reComboMark = RegExp($ff9ee56e6bb91dd6$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ff9ee56e6bb91dd6$var$deburr(string) {
    string = $be7b080aded3ae30$exports(string);
    return string && string.replace($ff9ee56e6bb91dd6$var$reLatin, $e76a18bd0d552c4a$exports).replace($ff9ee56e6bb91dd6$var$reComboMark, '');
}
$ff9ee56e6bb91dd6$exports = $ff9ee56e6bb91dd6$var$deburr;


var $7645f0b8cc0630e0$exports = {};
var $fc2a0cb801ef493f$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $fc2a0cb801ef493f$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $fc2a0cb801ef493f$var$asciiWords(string) {
    return string.match($fc2a0cb801ef493f$var$reAsciiWord) || [];
}
$fc2a0cb801ef493f$exports = $fc2a0cb801ef493f$var$asciiWords;


var $e211520b3f51a505$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $e211520b3f51a505$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $e211520b3f51a505$var$hasUnicodeWord(string) {
    return $e211520b3f51a505$var$reHasUnicodeWord.test(string);
}
$e211520b3f51a505$exports = $e211520b3f51a505$var$hasUnicodeWord;



var $aee821145e9caaf6$exports = {};
/** Used to compose unicode character classes. */ var $aee821145e9caaf6$var$rsAstralRange = '\\ud800-\\udfff', $aee821145e9caaf6$var$rsComboMarksRange = '\\u0300-\\u036f', $aee821145e9caaf6$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $aee821145e9caaf6$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $aee821145e9caaf6$var$rsComboRange = $aee821145e9caaf6$var$rsComboMarksRange + $aee821145e9caaf6$var$reComboHalfMarksRange + $aee821145e9caaf6$var$rsComboSymbolsRange, $aee821145e9caaf6$var$rsDingbatRange = '\\u2700-\\u27bf', $aee821145e9caaf6$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $aee821145e9caaf6$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $aee821145e9caaf6$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $aee821145e9caaf6$var$rsPunctuationRange = '\\u2000-\\u206f', $aee821145e9caaf6$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $aee821145e9caaf6$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $aee821145e9caaf6$var$rsVarRange = '\\ufe0e\\ufe0f', $aee821145e9caaf6$var$rsBreakRange = $aee821145e9caaf6$var$rsMathOpRange + $aee821145e9caaf6$var$rsNonCharRange + $aee821145e9caaf6$var$rsPunctuationRange + $aee821145e9caaf6$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $aee821145e9caaf6$var$rsApos = "['\u2019]", $aee821145e9caaf6$var$rsBreak = '[' + $aee821145e9caaf6$var$rsBreakRange + ']', $aee821145e9caaf6$var$rsCombo = '[' + $aee821145e9caaf6$var$rsComboRange + ']', $aee821145e9caaf6$var$rsDigits = '\\d+', $aee821145e9caaf6$var$rsDingbat = '[' + $aee821145e9caaf6$var$rsDingbatRange + ']', $aee821145e9caaf6$var$rsLower = '[' + $aee821145e9caaf6$var$rsLowerRange + ']', $aee821145e9caaf6$var$rsMisc = '[^' + $aee821145e9caaf6$var$rsAstralRange + $aee821145e9caaf6$var$rsBreakRange + $aee821145e9caaf6$var$rsDigits + $aee821145e9caaf6$var$rsDingbatRange + $aee821145e9caaf6$var$rsLowerRange + $aee821145e9caaf6$var$rsUpperRange + ']', $aee821145e9caaf6$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $aee821145e9caaf6$var$rsModifier = '(?:' + $aee821145e9caaf6$var$rsCombo + '|' + $aee821145e9caaf6$var$rsFitz + ')', $aee821145e9caaf6$var$rsNonAstral = '[^' + $aee821145e9caaf6$var$rsAstralRange + ']', $aee821145e9caaf6$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $aee821145e9caaf6$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $aee821145e9caaf6$var$rsUpper = '[' + $aee821145e9caaf6$var$rsUpperRange + ']', $aee821145e9caaf6$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $aee821145e9caaf6$var$rsMiscLower = '(?:' + $aee821145e9caaf6$var$rsLower + '|' + $aee821145e9caaf6$var$rsMisc + ')', $aee821145e9caaf6$var$rsMiscUpper = '(?:' + $aee821145e9caaf6$var$rsUpper + '|' + $aee821145e9caaf6$var$rsMisc + ')', $aee821145e9caaf6$var$rsOptContrLower = '(?:' + $aee821145e9caaf6$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $aee821145e9caaf6$var$rsOptContrUpper = '(?:' + $aee821145e9caaf6$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $aee821145e9caaf6$var$reOptMod = $aee821145e9caaf6$var$rsModifier + '?', $aee821145e9caaf6$var$rsOptVar = '[' + $aee821145e9caaf6$var$rsVarRange + ']?', $aee821145e9caaf6$var$rsOptJoin = '(?:' + $aee821145e9caaf6$var$rsZWJ + '(?:' + [
    $aee821145e9caaf6$var$rsNonAstral,
    $aee821145e9caaf6$var$rsRegional,
    $aee821145e9caaf6$var$rsSurrPair
].join('|') + ')' + $aee821145e9caaf6$var$rsOptVar + $aee821145e9caaf6$var$reOptMod + ')*', $aee821145e9caaf6$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $aee821145e9caaf6$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $aee821145e9caaf6$var$rsSeq = $aee821145e9caaf6$var$rsOptVar + $aee821145e9caaf6$var$reOptMod + $aee821145e9caaf6$var$rsOptJoin, $aee821145e9caaf6$var$rsEmoji = '(?:' + [
    $aee821145e9caaf6$var$rsDingbat,
    $aee821145e9caaf6$var$rsRegional,
    $aee821145e9caaf6$var$rsSurrPair
].join('|') + ')' + $aee821145e9caaf6$var$rsSeq;
/** Used to match complex or compound words. */ var $aee821145e9caaf6$var$reUnicodeWord = RegExp([
    $aee821145e9caaf6$var$rsUpper + '?' + $aee821145e9caaf6$var$rsLower + '+' + $aee821145e9caaf6$var$rsOptContrLower + '(?=' + [
        $aee821145e9caaf6$var$rsBreak,
        $aee821145e9caaf6$var$rsUpper,
        '$'
    ].join('|') + ')',
    $aee821145e9caaf6$var$rsMiscUpper + '+' + $aee821145e9caaf6$var$rsOptContrUpper + '(?=' + [
        $aee821145e9caaf6$var$rsBreak,
        $aee821145e9caaf6$var$rsUpper + $aee821145e9caaf6$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $aee821145e9caaf6$var$rsUpper + '?' + $aee821145e9caaf6$var$rsMiscLower + '+' + $aee821145e9caaf6$var$rsOptContrLower,
    $aee821145e9caaf6$var$rsUpper + '+' + $aee821145e9caaf6$var$rsOptContrUpper,
    $aee821145e9caaf6$var$rsOrdUpper,
    $aee821145e9caaf6$var$rsOrdLower,
    $aee821145e9caaf6$var$rsDigits,
    $aee821145e9caaf6$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $aee821145e9caaf6$var$unicodeWords(string) {
    return string.match($aee821145e9caaf6$var$reUnicodeWord) || [];
}
$aee821145e9caaf6$exports = $aee821145e9caaf6$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $7645f0b8cc0630e0$var$words(string, pattern, guard) {
    string = $be7b080aded3ae30$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $e211520b3f51a505$exports(string) ? $aee821145e9caaf6$exports(string) : $fc2a0cb801ef493f$exports(string);
    return string.match(pattern) || [];
}
$7645f0b8cc0630e0$exports = $7645f0b8cc0630e0$var$words;


/** Used to compose unicode capture groups. */ var $5eb1a20a655cecf6$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $5eb1a20a655cecf6$var$reApos = RegExp($5eb1a20a655cecf6$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $5eb1a20a655cecf6$var$createCompounder(callback) {
    return function(string) {
        return $6b1710bb74df1a4e$exports($7645f0b8cc0630e0$exports($ff9ee56e6bb91dd6$exports(string).replace($5eb1a20a655cecf6$var$reApos, '')), callback, '');
    };
}
$5eb1a20a655cecf6$exports = $5eb1a20a655cecf6$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $f94f40929760d654$var$snakeCase = $5eb1a20a655cecf6$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$f94f40929760d654$exports = $f94f40929760d654$var$snakeCase;


var $125733eb3ceee5a7$exports = {};
var $6e2ff67809e3ad49$exports = {};

var $5cf598ad90522951$exports = {};
var $f565f1e8dfa0f234$exports = {};
var $cedfa86d9254241f$exports = {};
var $4a8a1931ff6c5b43$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $4a8a1931ff6c5b43$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$4a8a1931ff6c5b43$exports = $4a8a1931ff6c5b43$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cedfa86d9254241f$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $4a8a1931ff6c5b43$exports(array, start, end);
}
$cedfa86d9254241f$exports = $cedfa86d9254241f$var$castSlice;


var $2619b88372bf0a10$exports = {};
/** Used to compose unicode character classes. */ var $2619b88372bf0a10$var$rsAstralRange = '\\ud800-\\udfff', $2619b88372bf0a10$var$rsComboMarksRange = '\\u0300-\\u036f', $2619b88372bf0a10$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $2619b88372bf0a10$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $2619b88372bf0a10$var$rsComboRange = $2619b88372bf0a10$var$rsComboMarksRange + $2619b88372bf0a10$var$reComboHalfMarksRange + $2619b88372bf0a10$var$rsComboSymbolsRange, $2619b88372bf0a10$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $2619b88372bf0a10$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $2619b88372bf0a10$var$reHasUnicode = RegExp('[' + $2619b88372bf0a10$var$rsZWJ + $2619b88372bf0a10$var$rsAstralRange + $2619b88372bf0a10$var$rsComboRange + $2619b88372bf0a10$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $2619b88372bf0a10$var$hasUnicode(string) {
    return $2619b88372bf0a10$var$reHasUnicode.test(string);
}
$2619b88372bf0a10$exports = $2619b88372bf0a10$var$hasUnicode;


var $dead2fee4cc7da14$exports = {};
var $d99f0168ee5ef42a$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $d99f0168ee5ef42a$var$asciiToArray(string) {
    return string.split('');
}
$d99f0168ee5ef42a$exports = $d99f0168ee5ef42a$var$asciiToArray;



var $1f58abf395c4469e$exports = {};
/** Used to compose unicode character classes. */ var $1f58abf395c4469e$var$rsAstralRange = '\\ud800-\\udfff', $1f58abf395c4469e$var$rsComboMarksRange = '\\u0300-\\u036f', $1f58abf395c4469e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1f58abf395c4469e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1f58abf395c4469e$var$rsComboRange = $1f58abf395c4469e$var$rsComboMarksRange + $1f58abf395c4469e$var$reComboHalfMarksRange + $1f58abf395c4469e$var$rsComboSymbolsRange, $1f58abf395c4469e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1f58abf395c4469e$var$rsAstral = '[' + $1f58abf395c4469e$var$rsAstralRange + ']', $1f58abf395c4469e$var$rsCombo = '[' + $1f58abf395c4469e$var$rsComboRange + ']', $1f58abf395c4469e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $1f58abf395c4469e$var$rsModifier = '(?:' + $1f58abf395c4469e$var$rsCombo + '|' + $1f58abf395c4469e$var$rsFitz + ')', $1f58abf395c4469e$var$rsNonAstral = '[^' + $1f58abf395c4469e$var$rsAstralRange + ']', $1f58abf395c4469e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $1f58abf395c4469e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $1f58abf395c4469e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $1f58abf395c4469e$var$reOptMod = $1f58abf395c4469e$var$rsModifier + '?', $1f58abf395c4469e$var$rsOptVar = '[' + $1f58abf395c4469e$var$rsVarRange + ']?', $1f58abf395c4469e$var$rsOptJoin = '(?:' + $1f58abf395c4469e$var$rsZWJ + '(?:' + [
    $1f58abf395c4469e$var$rsNonAstral,
    $1f58abf395c4469e$var$rsRegional,
    $1f58abf395c4469e$var$rsSurrPair
].join('|') + ')' + $1f58abf395c4469e$var$rsOptVar + $1f58abf395c4469e$var$reOptMod + ')*', $1f58abf395c4469e$var$rsSeq = $1f58abf395c4469e$var$rsOptVar + $1f58abf395c4469e$var$reOptMod + $1f58abf395c4469e$var$rsOptJoin, $1f58abf395c4469e$var$rsSymbol = '(?:' + [
    $1f58abf395c4469e$var$rsNonAstral + $1f58abf395c4469e$var$rsCombo + '?',
    $1f58abf395c4469e$var$rsCombo,
    $1f58abf395c4469e$var$rsRegional,
    $1f58abf395c4469e$var$rsSurrPair,
    $1f58abf395c4469e$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $1f58abf395c4469e$var$reUnicode = RegExp($1f58abf395c4469e$var$rsFitz + '(?=' + $1f58abf395c4469e$var$rsFitz + ')|' + $1f58abf395c4469e$var$rsSymbol + $1f58abf395c4469e$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1f58abf395c4469e$var$unicodeToArray(string) {
    return string.match($1f58abf395c4469e$var$reUnicode) || [];
}
$1f58abf395c4469e$exports = $1f58abf395c4469e$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $dead2fee4cc7da14$var$stringToArray(string) {
    return $2619b88372bf0a10$exports(string) ? $1f58abf395c4469e$exports(string) : $d99f0168ee5ef42a$exports(string);
}
$dead2fee4cc7da14$exports = $dead2fee4cc7da14$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $f565f1e8dfa0f234$var$createCaseFirst(methodName) {
    return function(string) {
        string = $be7b080aded3ae30$exports(string);
        var strSymbols = $2619b88372bf0a10$exports(string) ? $dead2fee4cc7da14$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cedfa86d9254241f$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$f565f1e8dfa0f234$exports = $f565f1e8dfa0f234$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5cf598ad90522951$var$upperFirst = $f565f1e8dfa0f234$exports('toUpperCase');
$5cf598ad90522951$exports = $5cf598ad90522951$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $6e2ff67809e3ad49$var$capitalize(string) {
    return $5cf598ad90522951$exports($be7b080aded3ae30$exports(string).toLowerCase());
}
$6e2ff67809e3ad49$exports = $6e2ff67809e3ad49$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $125733eb3ceee5a7$var$camelCase = $5eb1a20a655cecf6$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $6e2ff67809e3ad49$exports(word) : word);
});
$125733eb3ceee5a7$exports = $125733eb3ceee5a7$var$camelCase;


var $1429cb34ec20d8f0$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $1429cb34ec20d8f0$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $d19bc8e0ee83495b$exports(iteratee, 3);
    $9bc3071b9813d0d8$exports(object, function(value, key, object) {
        $176d4886c53a8766$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$1429cb34ec20d8f0$exports = $1429cb34ec20d8f0$var$mapKeys;






var $3d037155053518d6$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $3d037155053518d6$exports = function(edges) {
    return $3d037155053518d6$var$toposort($3d037155053518d6$var$uniqueNodes(edges), edges);
};
$3d037155053518d6$exports.array = $3d037155053518d6$var$toposort;
function $3d037155053518d6$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $3d037155053518d6$var$makeOutgoingEdges(edges), nodesHash = $3d037155053518d6$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $3d037155053518d6$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $3d037155053518d6$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $3d037155053518d6$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $8f14bdf914a0ca9f$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $5d5d4787cd7031b8$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($46c2c57422564351$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $22394e2b7741d4e7$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $119ff91a5e84d9ca$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3d037155053518d6$exports))).array(Array.from(nodes), edges).reverse();
}


function $4efdd07ff786578a$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $4efdd07ff786578a$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $4efdd07ff786578a$var$findIndex(keys, a) - $4efdd07ff786578a$var$findIndex(keys, b);
    };
}





function $f986b6e4122227d2$var$_extends() {
    $f986b6e4122227d2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f986b6e4122227d2$var$_extends.apply(this, arguments);
}
let $f986b6e4122227d2$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $f986b6e4122227d2$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $f986b6e4122227d2$var$defaultSort = (0, $4efdd07ff786578a$export$2e2bcd8739ae039)([]);
class $f986b6e4122227d2$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(value) {
        return $f986b6e4122227d2$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $f986b6e4122227d2$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($46c2c57422564351$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$f986b6e4122227d2$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $f986b6e4122227d2$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $1b760d2b001126f1$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $f986b6e4122227d2$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $26e8c42a8d20d137$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $4efdd07ff786578a$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $8f14bdf914a0ca9f$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $5d5d4787cd7031b8$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($46c2c57422564351$exports)))(obj, from)) {
                newObj = $f986b6e4122227d2$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $6290250a2ab08af2$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $f986b6e4122227d2$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $6290250a2ab08af2$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($1429cb34ec20d8f0$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($125733eb3ceee5a7$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($f94f40929760d654$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($f94f40929760d654$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($0bf76c4b7d3bebed$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $f986b6e4122227d2$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
}
function $f986b6e4122227d2$export$185802fd694ee1f5(spec) {
    return new $f986b6e4122227d2$export$2e2bcd8739ae039(spec);
}
$f986b6e4122227d2$export$185802fd694ee1f5.prototype = $f986b6e4122227d2$export$2e2bcd8739ae039.prototype;









function $f07cf38414d7ce0e$var$_extends() {
    $f07cf38414d7ce0e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f07cf38414d7ce0e$var$_extends.apply(this, arguments);
}
function $f07cf38414d7ce0e$export$185802fd694ee1f5(type) {
    return new $f07cf38414d7ce0e$export$2e2bcd8739ae039(type);
}
class $f07cf38414d7ce0e$export$2e2bcd8739ae039 extends (0, $26e8c42a8d20d137$export$2e2bcd8739ae039) {
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $f07cf38414d7ce0e$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $aba2b35f38aa11b0$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $f07cf38414d7ce0e$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $1b760d2b001126f1$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $119ff91a5e84d9ca$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $eb9e77a8f4af3aeb$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $6290250a2ab08af2$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $6290250a2ab08af2$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $6290250a2ab08af2$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $0c619856b5d5e27e$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
}
$f07cf38414d7ce0e$export$185802fd694ee1f5.prototype = $f07cf38414d7ce0e$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $56335e93017261f8$export$185802fd694ee1f5(builder) {
    return new $56335e93017261f8$var$Lazy(builder);
}
class $56335e93017261f8$var$Lazy {
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $119ff91a5e84d9ca$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
}
var $56335e93017261f8$export$2e2bcd8739ae039 = $56335e93017261f8$var$Lazy;






function $86b6a2495367f022$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $6290250a2ab08af2$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $47369000a0aaa62a$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $119ff91a5e84d9ca$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}






var $58bog = parcelRequire("58bog");

var $dBoEs = parcelRequire("dBoEs");
function $910386c6a9d28c9e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dBoEs.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $7deb8d1393f88723$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7deb8d1393f88723$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7deb8d1393f88723$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $910386c6a9d28c9e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7deb8d1393f88723$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $53d826f09d43b6fa$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $53d826f09d43b6fa$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $53d826f09d43b6fa$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $53d826f09d43b6fa$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $53d826f09d43b6fa$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $53d826f09d43b6fa$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $53d826f09d43b6fa$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $53d826f09d43b6fa$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $53d826f09d43b6fa$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($53d826f09d43b6fa$var$isDate(val)) return 'date';
    if ($53d826f09d43b6fa$var$isError(val)) return 'error';
    var constructorName = $53d826f09d43b6fa$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $53d826f09d43b6fa$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $53d826f09d43b6fa$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $53d826f09d43b6fa$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $53d826f09d43b6fa$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $53d826f09d43b6fa$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(1));
        return enhancer($53d826f09d43b6fa$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$53d826f09d43b6fa$var$isPlainObject(action)) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $53d826f09d43b6fa$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$53d826f09d43b6fa$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $53d826f09d43b6fa$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$53d826f09d43b6fa$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $53d826f09d43b6fa$export$8928921ea2d3b126 = $53d826f09d43b6fa$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $53d826f09d43b6fa$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $53d826f09d43b6fa$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $53d826f09d43b6fa$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$53d826f09d43b6fa$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $53d826f09d43b6fa$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $53d826f09d43b6fa$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $53d826f09d43b6fa$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $53d826f09d43b6fa$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $53d826f09d43b6fa$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $53d826f09d43b6fa$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $53d826f09d43b6fa$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $53d826f09d43b6fa$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $53d826f09d43b6fa$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $53d826f09d43b6fa$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $53d826f09d43b6fa$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $53d826f09d43b6fa$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $53d826f09d43b6fa$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($53d826f09d43b6fa$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $53d826f09d43b6fa$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $7deb8d1393f88723$export$2e2bcd8739ae039)((0, $7deb8d1393f88723$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $0895266d24a2801f$var$NOT_FOUND = 'NOT_FOUND';
function $0895266d24a2801f$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $0895266d24a2801f$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $0895266d24a2801f$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $0895266d24a2801f$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $0895266d24a2801f$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $0895266d24a2801f$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $0895266d24a2801f$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $0895266d24a2801f$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $0895266d24a2801f$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $0895266d24a2801f$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $0895266d24a2801f$var$createSingletonCache(comparator) : $0895266d24a2801f$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $0895266d24a2801f$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $8dc4dc351c50db34$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $8dc4dc351c50db34$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $8dc4dc351c50db34$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $8dc4dc351c50db34$export$595d22ed68ca2841 = /* #__PURE__ */ $8dc4dc351c50db34$export$5943f4447f6ef248((0, $0895266d24a2801f$export$281bff7f05488aa2));
var $8dc4dc351c50db34$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $8dc4dc351c50db34$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $724e72f913db7337$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $724e72f913db7337$var$thunk = $724e72f913db7337$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$724e72f913db7337$var$thunk.withExtraArgument = $724e72f913db7337$var$createThunkMiddleware;
var $724e72f913db7337$export$2e2bcd8739ae039 = $724e72f913db7337$var$thunk;


var $840ab42532c4ded2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $840ab42532c4ded2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $840ab42532c4ded2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $840ab42532c4ded2$var$__defProp = Object.defineProperty;
var $840ab42532c4ded2$var$__defProps = Object.defineProperties;
var $840ab42532c4ded2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $840ab42532c4ded2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $840ab42532c4ded2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $840ab42532c4ded2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $840ab42532c4ded2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $840ab42532c4ded2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $840ab42532c4ded2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($840ab42532c4ded2$var$__hasOwnProp.call(b, prop)) $840ab42532c4ded2$var$__defNormalProp(a, prop, b[prop]);
    if ($840ab42532c4ded2$var$__getOwnPropSymbols) for(var _i = 0, _c = $840ab42532c4ded2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($840ab42532c4ded2$var$__propIsEnum.call(b, prop)) $840ab42532c4ded2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $840ab42532c4ded2$var$__spreadProps = function(a, b) {
    return $840ab42532c4ded2$var$__defProps(a, $840ab42532c4ded2$var$__getOwnPropDescs(b));
};
var $840ab42532c4ded2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $840ab42532c4ded2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $8dc4dc351c50db34$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $840ab42532c4ded2$var$__spreadArray([
            (0, $58bog.isDraft)(value) ? (0, $58bog.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $840ab42532c4ded2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $53d826f09d43b6fa$export$f672e0b6f7222cd7;
    return (0, $53d826f09d43b6fa$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $840ab42532c4ded2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $840ab42532c4ded2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $840ab42532c4ded2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $840ab42532c4ded2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $840ab42532c4ded2$var$__spreadValues($840ab42532c4ded2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $840ab42532c4ded2$export$b956e38827fca970(action) {
    return $840ab42532c4ded2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $840ab42532c4ded2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $840ab42532c4ded2$var$hasMatchFunction(action);
}
function $840ab42532c4ded2$export$ebd532f9034651f3(action) {
    return $840ab42532c4ded2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($840ab42532c4ded2$var$isValidKey);
}
function $840ab42532c4ded2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $840ab42532c4ded2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $840ab42532c4ded2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $840ab42532c4ded2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $840ab42532c4ded2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $840ab42532c4ded2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $840ab42532c4ded2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $840ab42532c4ded2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $840ab42532c4ded2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $840ab42532c4ded2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $840ab42532c4ded2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $840ab42532c4ded2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $840ab42532c4ded2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $840ab42532c4ded2$var$freezeDraftable(val) {
    return (0, $58bog.isDraftable)(val) ? (0, $58bog.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $840ab42532c4ded2$var$isProduction = true;
var $840ab42532c4ded2$var$prefix = "Invariant failed";
function $840ab42532c4ded2$var$invariant(condition, message) {
    if (condition) return;
    if ($840ab42532c4ded2$var$isProduction) throw new Error($840ab42532c4ded2$var$prefix);
    throw new Error($840ab42532c4ded2$var$prefix + ": " + (message || ""));
}
function $840ab42532c4ded2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $840ab42532c4ded2$var$getSerialize(serializer, decycler), indent);
}
function $840ab42532c4ded2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $840ab42532c4ded2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $840ab42532c4ded2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $840ab42532c4ded2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $840ab42532c4ded2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $840ab42532c4ded2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $840ab42532c4ded2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $840ab42532c4ded2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $840ab42532c4ded2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $840ab42532c4ded2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $840ab42532c4ded2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $840ab42532c4ded2$export$53b83ca8eaab0383(val);
}
function $840ab42532c4ded2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $840ab42532c4ded2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $840ab42532c4ded2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $840ab42532c4ded2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $840ab42532c4ded2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$840ab42532c4ded2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $840ab42532c4ded2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $840ab42532c4ded2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $840ab42532c4ded2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $840ab42532c4ded2$export$36c1185aeee5b0a6(options);
    };
}
function $840ab42532c4ded2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $840ab42532c4ded2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($840ab42532c4ded2$var$isBoolean(thunk)) middlewareArray.push((0, $724e72f913db7337$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $724e72f913db7337$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $840ab42532c4ded2$var$IS_PRODUCTION = true;
function $840ab42532c4ded2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $840ab42532c4ded2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($840ab42532c4ded2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $53d826f09d43b6fa$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$840ab42532c4ded2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$840ab42532c4ded2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $53d826f09d43b6fa$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $53d826f09d43b6fa$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $840ab42532c4ded2$var$composeWithDevTools($840ab42532c4ded2$var$__spreadValues({
        trace: !$840ab42532c4ded2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $840ab42532c4ded2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $840ab42532c4ded2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $53d826f09d43b6fa$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $840ab42532c4ded2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $840ab42532c4ded2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $840ab42532c4ded2$var$hasWarnedAboutObjectNotation = false;
function $840ab42532c4ded2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $840ab42532c4ded2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($840ab42532c4ded2$var$isStateFunction(initialState)) getInitialState = function() {
        return $840ab42532c4ded2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $840ab42532c4ded2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $840ab42532c4ded2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $58bog.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $58bog.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $58bog.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $840ab42532c4ded2$var$hasWarnedAboutObjectNotation2 = false;
function $840ab42532c4ded2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $840ab42532c4ded2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $840ab42532c4ded2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $840ab42532c4ded2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $840ab42532c4ded2$export$309c7a02b0b0bc62(type, prepareCallback) : $840ab42532c4ded2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $840ab42532c4ded2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $840ab42532c4ded2$var$__spreadValues($840ab42532c4ded2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $840ab42532c4ded2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $840ab42532c4ded2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $840ab42532c4ded2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($840ab42532c4ded2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $840ab42532c4ded2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $840ab42532c4ded2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $840ab42532c4ded2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $840ab42532c4ded2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $840ab42532c4ded2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $840ab42532c4ded2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $840ab42532c4ded2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $840ab42532c4ded2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $840ab42532c4ded2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $840ab42532c4ded2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $840ab42532c4ded2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $840ab42532c4ded2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $840ab42532c4ded2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $58bog.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $58bog.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $840ab42532c4ded2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $840ab42532c4ded2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $840ab42532c4ded2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $840ab42532c4ded2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $840ab42532c4ded2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $840ab42532c4ded2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $840ab42532c4ded2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $840ab42532c4ded2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $840ab42532c4ded2$var$__spreadValues($840ab42532c4ded2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $840ab42532c4ded2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $840ab42532c4ded2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $840ab42532c4ded2$var$createStateOperator(addOneMutably),
        addMany: $840ab42532c4ded2$var$createStateOperator(addManyMutably),
        setOne: $840ab42532c4ded2$var$createStateOperator(setOneMutably),
        setMany: $840ab42532c4ded2$var$createStateOperator(setManyMutably),
        setAll: $840ab42532c4ded2$var$createStateOperator(setAllMutably),
        updateOne: $840ab42532c4ded2$var$createStateOperator(updateOneMutably),
        updateMany: $840ab42532c4ded2$var$createStateOperator(updateManyMutably),
        upsertOne: $840ab42532c4ded2$var$createStateOperator(upsertOneMutably),
        upsertMany: $840ab42532c4ded2$var$createStateOperator(upsertManyMutably),
        removeOne: $840ab42532c4ded2$var$createStateOperator(removeOneMutably),
        removeMany: $840ab42532c4ded2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $840ab42532c4ded2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $840ab42532c4ded2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($840ab42532c4ded2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $840ab42532c4ded2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $840ab42532c4ded2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $840ab42532c4ded2$var$createStateOperator(addOneMutably),
        updateOne: $840ab42532c4ded2$var$createStateOperator(updateOneMutably),
        upsertOne: $840ab42532c4ded2$var$createStateOperator(upsertOneMutably),
        setOne: $840ab42532c4ded2$var$createStateOperator(setOneMutably),
        setMany: $840ab42532c4ded2$var$createStateOperator(setManyMutably),
        setAll: $840ab42532c4ded2$var$createStateOperator(setAllMutably),
        addMany: $840ab42532c4ded2$var$createStateOperator(addManyMutably),
        updateMany: $840ab42532c4ded2$var$createStateOperator(updateManyMutably),
        upsertMany: $840ab42532c4ded2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $840ab42532c4ded2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $840ab42532c4ded2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $840ab42532c4ded2$var$createInitialStateFactory();
    var selectorsFactory = $840ab42532c4ded2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $840ab42532c4ded2$var$createSortedStateAdapter(selectId, sortComparer) : $840ab42532c4ded2$var$createUnsortedStateAdapter(selectId);
    return $840ab42532c4ded2$var$__spreadValues($840ab42532c4ded2$var$__spreadValues($840ab42532c4ded2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $840ab42532c4ded2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $840ab42532c4ded2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $840ab42532c4ded2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $840ab42532c4ded2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $840ab42532c4ded2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $840ab42532c4ded2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $840ab42532c4ded2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $840ab42532c4ded2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $840ab42532c4ded2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $840ab42532c4ded2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $840ab42532c4ded2$var$__spreadProps($840ab42532c4ded2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $840ab42532c4ded2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $840ab42532c4ded2$var$__spreadProps($840ab42532c4ded2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $840ab42532c4ded2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $840ab42532c4ded2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $840ab42532c4ded2$var$__spreadProps($840ab42532c4ded2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $840ab42532c4ded2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $840ab42532c4ded2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $840ab42532c4ded2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$840ab42532c4ded2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $840ab42532c4ded2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $840ab42532c4ded2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $840ab42532c4ded2$var$RejectWithValue) throw result;
                                                if (result instanceof $840ab42532c4ded2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $840ab42532c4ded2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($840ab42532c4ded2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $840ab42532c4ded2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $840ab42532c4ded2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $840ab42532c4ded2$var$matches = function(matcher, action) {
    if ($840ab42532c4ded2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $840ab42532c4ded2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $840ab42532c4ded2$var$matches(matcher, action);
        });
    };
}
function $840ab42532c4ded2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $840ab42532c4ded2$var$matches(matcher, action);
        });
    };
}
function $840ab42532c4ded2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $840ab42532c4ded2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $840ab42532c4ded2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $840ab42532c4ded2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$840ab42532c4ded2$var$isAsyncThunkArray(asyncThunks)) return $840ab42532c4ded2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $840ab42532c4ded2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $840ab42532c4ded2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $840ab42532c4ded2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$840ab42532c4ded2$var$isAsyncThunkArray(asyncThunks)) return $840ab42532c4ded2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $840ab42532c4ded2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $840ab42532c4ded2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $840ab42532c4ded2$export$9dd1fb32974da385($840ab42532c4ded2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$840ab42532c4ded2$var$isAsyncThunkArray(asyncThunks)) return $840ab42532c4ded2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $840ab42532c4ded2$export$9dd1fb32974da385($840ab42532c4ded2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $840ab42532c4ded2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $840ab42532c4ded2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$840ab42532c4ded2$var$isAsyncThunkArray(asyncThunks)) return $840ab42532c4ded2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $840ab42532c4ded2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $840ab42532c4ded2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $840ab42532c4ded2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$840ab42532c4ded2$var$isAsyncThunkArray(asyncThunks)) return $840ab42532c4ded2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $840ab42532c4ded2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $840ab42532c4ded2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $840ab42532c4ded2$var$noop = function() {};
var $840ab42532c4ded2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $840ab42532c4ded2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $840ab42532c4ded2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $840ab42532c4ded2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $840ab42532c4ded2$var$task = "task";
var $840ab42532c4ded2$var$listener = "listener";
var $840ab42532c4ded2$var$completed = "completed";
var $840ab42532c4ded2$var$cancelled = "cancelled";
var $840ab42532c4ded2$var$taskCancelled = "task-" + $840ab42532c4ded2$var$cancelled;
var $840ab42532c4ded2$var$taskCompleted = "task-" + $840ab42532c4ded2$var$completed;
var $840ab42532c4ded2$var$listenerCancelled = $840ab42532c4ded2$var$listener + "-" + $840ab42532c4ded2$var$cancelled;
var $840ab42532c4ded2$var$listenerCompleted = $840ab42532c4ded2$var$listener + "-" + $840ab42532c4ded2$var$completed;
var $840ab42532c4ded2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $840ab42532c4ded2$var$task + " " + $840ab42532c4ded2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $840ab42532c4ded2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $840ab42532c4ded2$export$cb1bdac908fed7f(signal.reason);
};
function $840ab42532c4ded2$var$raceWithSignal(signal, promise2) {
    var cleanup = $840ab42532c4ded2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $840ab42532c4ded2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $840ab42532c4ded2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $840ab42532c4ded2$var$noop;
    });
}
var $840ab42532c4ded2$var$runTask = function(task2, cleanUp) {
    return $840ab42532c4ded2$var$__async(void 0, null, function() {
        var value, error_1;
        return $840ab42532c4ded2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $840ab42532c4ded2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $840ab42532c4ded2$var$createPause = function(signal) {
    return function(promise2) {
        return $840ab42532c4ded2$var$catchRejection($840ab42532c4ded2$var$raceWithSignal(signal, promise2).then(function(output) {
            $840ab42532c4ded2$var$validateActive(signal);
            return output;
        }));
    };
};
var $840ab42532c4ded2$var$createDelay = function(signal) {
    var pause = $840ab42532c4ded2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $840ab42532c4ded2$var$assign = Object.assign;
var $840ab42532c4ded2$var$INTERNAL_NIL_TOKEN = {};
var $840ab42532c4ded2$var$alm = "listenerMiddleware";
var $840ab42532c4ded2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $840ab42532c4ded2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $840ab42532c4ded2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $840ab42532c4ded2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $840ab42532c4ded2$var$runTask(function() {
            return $840ab42532c4ded2$var$__async(void 0, null, function() {
                var result2;
                return $840ab42532c4ded2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $840ab42532c4ded2$var$validateActive(parentAbortSignal);
                            $840ab42532c4ded2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $840ab42532c4ded2$var$createPause(childAbortController.signal),
                                    delay: $840ab42532c4ded2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $840ab42532c4ded2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $840ab42532c4ded2$var$abortControllerWithReason(childAbortController, $840ab42532c4ded2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $840ab42532c4ded2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $840ab42532c4ded2$var$abortControllerWithReason(childAbortController, $840ab42532c4ded2$var$taskCancelled);
            }
        };
    };
};
var $840ab42532c4ded2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $840ab42532c4ded2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $840ab42532c4ded2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $840ab42532c4ded2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $840ab42532c4ded2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $840ab42532c4ded2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $840ab42532c4ded2$var$catchRejection(take(predicate, timeout));
    };
};
var $840ab42532c4ded2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $840ab42532c4ded2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $840ab42532c4ded2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $840ab42532c4ded2$var$createListenerEntry = function(options) {
    var _c = $840ab42532c4ded2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $840ab42532c4ded2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $840ab42532c4ded2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $840ab42532c4ded2$var$abortControllerWithReason(controller, $840ab42532c4ded2$var$listenerCancelled);
    });
};
var $840ab42532c4ded2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($840ab42532c4ded2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $840ab42532c4ded2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $840ab42532c4ded2$export$f03a6b845d3fb58b = $840ab42532c4ded2$export$309c7a02b0b0bc62($840ab42532c4ded2$var$alm + "/add");
var $840ab42532c4ded2$export$b1b8022855fb2b71 = $840ab42532c4ded2$export$309c7a02b0b0bc62($840ab42532c4ded2$var$alm + "/removeAll");
var $840ab42532c4ded2$export$b03e9483f936dccb = $840ab42532c4ded2$export$309c7a02b0b0bc62($840ab42532c4ded2$var$alm + "/remove");
var $840ab42532c4ded2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $840ab42532c4ded2$var$__spreadArray([
        $840ab42532c4ded2$var$alm + "/error"
    ], args));
};
function $840ab42532c4ded2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $840ab42532c4ded2$var$defaultErrorHandler : _c;
    $840ab42532c4ded2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $840ab42532c4ded2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $840ab42532c4ded2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $840ab42532c4ded2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $840ab42532c4ded2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $840ab42532c4ded2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $840ab42532c4ded2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $840ab42532c4ded2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $840ab42532c4ded2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $840ab42532c4ded2$var$createDelay(internalTaskController.signal),
                                pause: $840ab42532c4ded2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $840ab42532c4ded2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $840ab42532c4ded2$var$abortControllerWithReason(controller, $840ab42532c4ded2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $840ab42532c4ded2$export$cb1bdac908fed7f)) $840ab42532c4ded2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $840ab42532c4ded2$var$abortControllerWithReason(internalTaskController, $840ab42532c4ded2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $840ab42532c4ded2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$840ab42532c4ded2$export$b956e38827fca970(action)) return next(action);
                if ($840ab42532c4ded2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($840ab42532c4ded2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($840ab42532c4ded2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $840ab42532c4ded2$var$INTERNAL_NIL_TOKEN) throw new Error($840ab42532c4ded2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $840ab42532c4ded2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $840ab42532c4ded2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $840ab42532c4ded2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $840ab42532c4ded2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$840ab42532c4ded2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $840ab42532c4ded2$var$promise;
var $840ab42532c4ded2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($840ab42532c4ded2$var$promise || ($840ab42532c4ded2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $840ab42532c4ded2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $840ab42532c4ded2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $840ab42532c4ded2$var$createQueueWithTimer(10);
var $840ab42532c4ded2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $840ab42532c4ded2$var$queueMicrotaskShim : options.type === "raf" ? $840ab42532c4ded2$var$rAF : options.type === "callback" ? options.queueNotification : $840ab42532c4ded2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$840ab42532c4ded2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $58bog.enableES5)();


const $f091004a6ec177a3$var$initialState = {
    businessId: '0',
    businessName: 'Init Business Name',
    status: 'idle',
    roles: [],
    attemptedLogin: ''
};
const $f091004a6ec177a3$export$d8ba9d20bef4ea7d = (0, $840ab42532c4ded2$export$6abd22dc03e5063f)('userContext/fetchUserContext', async (business)=>{
    const roleResponse = await RolesService.fetchAllByBusinessId(business.id);
    const roles = roleResponse.data.map((role)=>role.name);
    return {
        businessId: business.id,
        businessName: business.name,
        roles: roles
    };
});
const $f091004a6ec177a3$export$45991e2a615f157e = (0, $840ab42532c4ded2$export$4d8d9bd83c24ae8b)({
    name: 'userContext',
    initialState: $f091004a6ec177a3$var$initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setBusiness: (state, action)=>{
            return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, state), {
                businessId: action.payload.id,
                businessName: action.payload.name
            });
        },
        setAttemptedLogin: (state, action)=>{
            return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, state), {
                attemptedLoginUser: action.payload.attemptedLoginUser,
                attemptedLoginPass: action.payload.attemptedLoginPass
            });
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder)=>{
        builder.addCase($f091004a6ec177a3$export$d8ba9d20bef4ea7d.pending, (state)=>{
            return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, state), {
                status: 'loading'
            });
        }).addCase($f091004a6ec177a3$export$d8ba9d20bef4ea7d.fulfilled, (state, action)=>{
            const results = action.payload;
            return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, state), {
                status: 'idle',
                businessId: results.businessId,
                businessName: results.businessName,
                roles: results.roles
            });
        });
    }
});
const { setAttemptedLogin: $f091004a6ec177a3$export$feee787cf338b1ab } = $f091004a6ec177a3$export$45991e2a615f157e.actions;
const $f091004a6ec177a3$export$1acb7bb2a487a164 = (state)=>state.userContext.attemptedLoginUser;
const $f091004a6ec177a3$export$24459b23206f809a = (state)=>state.userContext.attemptedLoginPass;
var $f091004a6ec177a3$export$2e2bcd8739ae039 = $f091004a6ec177a3$export$45991e2a615f157e.reducer;


const $38463fdc530198f4$var$Login = ()=>{
    const dispatch = (0, $612b05aeb1ec34f5$export$8ad76b76a4c905f8)();
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const [error, setError] = (0, $jSIPP.useState)(null);
    const handleLoginSubmit = (values, actions)=>{
        const payload = {
            attemptedLoginUser: values.username,
            attemptedLoginPass: values.password
        };
        dispatch((0, $f091004a6ec177a3$export$feee787cf338b1ab)(payload));
        (0, $875b725466af1357$export$2e2bcd8739ae039).login(values.username, values.password).then((user)=>{
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') history.push('/changepassword');
            else history.push('/');
        }).catch((error)=>{
            console.log(error);
            setError(error);
            actions.setSubmitting(false);
        });
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $19efb1c1755d1d62$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)("title", {
                    children: "Login | nGEST"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: 'background.default',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $47d5907b0888e07d$export$2e2bcd8739ae039), {
                    maxWidth: "sm",
                    children: [
                        (error === null || error === void 0 ? void 0 : error.message) ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
                            severity: "error",
                            sx: {
                                my: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bf1395812ba8dabb$export$2e2bcd8739ae039), {
                                    children: "Login Failed"
                                }),
                                "Invalid user/credentials"
                            ]
                        }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {}),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                            initialValues: {
                                username: '',
                                password: ''
                            },
                            validationSchema: $f986b6e4122227d2$export$185802fd694ee1f5().shape({
                                username: $7a974168aa28ad85$export$185802fd694ee1f5().max(255).required('Username is required'),
                                password: $7a974168aa28ad85$export$185802fd694ee1f5().max(255).required('Password is required')
                            }),
                            onSubmit: (values, actions)=>handleLoginSubmit(values, actions),
                            children: ({ errors: errors, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting, touched: touched, values: values })=>/*#__PURE__*/ (0, $4uaIU.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                            sx: {
                                                mb: 3
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                color: "textPrimary",
                                                variant: "h2",
                                                children: "Sign in"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                            error: Boolean(touched.username && errors.username),
                                            fullWidth: true,
                                            helperText: touched.username && errors.username,
                                            label: "Username",
                                            margin: "normal",
                                            name: "username",
                                            onBlur: handleBlur,
                                            onChange: handleChange,
                                            type: "username",
                                            value: values.username,
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                            error: Boolean(touched.password && errors.password),
                                            fullWidth: true,
                                            helperText: touched.password && errors.password,
                                            label: "Password",
                                            margin: "normal",
                                            name: "password",
                                            onBlur: handleBlur,
                                            onChange: handleChange,
                                            type: "password",
                                            value: values.password,
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                            sx: {
                                                py: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                disabled: isSubmitting,
                                                fullWidth: true,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Sign in now"
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                })
            })
        ]
    });
};
var $38463fdc530198f4$export$2e2bcd8739ae039 = $38463fdc530198f4$var$Login;




var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $78dc747797abcf2b$export$f3b76d2cce458caa(slot) {
    return (0, $geF11.default)('MuiCard', slot);
}
const $78dc747797abcf2b$var$cardClasses = (0, $rARwS.default)('MuiCard', [
    'root'
]);
var $78dc747797abcf2b$export$2e2bcd8739ae039 = $78dc747797abcf2b$var$cardClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f3110a0a945b54d9$var$_excluded = [
    "className",
    "raised"
];
const $f3110a0a945b54d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $78dc747797abcf2b$export$f3b76d2cce458caa), classes);
};
const $f3110a0a945b54d9$var$CardRoot = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $f3110a0a945b54d9$var$Card = /*#__PURE__*/ $jSIPP.forwardRef(function Card(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $cMu4A.default)(props, $f3110a0a945b54d9$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        raised: raised
    });
    const classes = $f3110a0a945b54d9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f3110a0a945b54d9$var$CardRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $f3110a0a945b54d9$export$2e2bcd8739ae039 = $f3110a0a945b54d9$var$Card;


const $cf6066d05ea77742$var$SessionInfo = ()=>{
    const [user, setUser] = (0, $jSIPP.useState)();
    const [authIdToken, setAuthIdToken] = (0, $jSIPP.useState)(null);
    const [isLoggedIn, setLoggedIn] = (0, $jSIPP.useState)(false);
    (0, $jSIPP.useEffect)(()=>{
        (0, $875b725466af1357$export$2e2bcd8739ae039).getIdToken().then((token)=>{
            console.log('ID Token=', token);
            setAuthIdToken(JSON.stringify(token));
        });
        (0, $875b725466af1357$export$2e2bcd8739ae039).getUser().then((myUser)=>{
            setUser(myUser);
        });
        (0, $875b725466af1357$export$2e2bcd8739ae039).isLoggedIn().then((bool)=>{
            setLoggedIn(bool);
        });
    }, []);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f3110a0a945b54d9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "h1",
                children: "nGEST"
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)("br", {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)("br", {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)("br", {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)("br", {}),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "h4",
                children: [
                    "Auth:idToken",
                    authIdToken
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "h4",
                children: [
                    "isLoggedIn:",
                    isLoggedIn
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "h4",
                children: [
                    "user:",
                    user
                ]
            })
        ]
    });
};
var $cf6066d05ea77742$export$2e2bcd8739ae039 = $cf6066d05ea77742$var$SessionInfo;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
'use client';
const $2e229f2081955271$var$usePreviousProps = (value)=>{
    const ref = $jSIPP.useRef({});
    $jSIPP.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $2e229f2081955271$export$2e2bcd8739ae039 = $2e229f2081955271$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $b51c52e6b3da82bb$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $b51c52e6b3da82bb$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $b51c52e6b3da82bb$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $b51c52e6b3da82bb$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $b51c52e6b3da82bb$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $b51c52e6b3da82bb$var$defaultFilterOptions = $b51c52e6b3da82bb$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $b51c52e6b3da82bb$var$pageSize = 5;
const $b51c52e6b3da82bb$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $b51c52e6b3da82bb$var$MULTIPLE_DEFAULT_VALUE = [];
function $b51c52e6b3da82bb$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $b51c52e6b3da82bb$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $b51c52e6b3da82bb$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $b51c52e6b3da82bb$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $jSIPP.useRef(false);
    const firstFocus = $jSIPP.useRef(true);
    const inputRef = $jSIPP.useRef(null);
    const listboxRef = $jSIPP.useRef(null);
    const [anchorEl, setAnchorEl] = $jSIPP.useState(null);
    const [focusedTag, setFocusedTag] = $jSIPP.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $jSIPP.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $jSIPP.useState(false);
    const resetInputValue = $jSIPP.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $be4698e2c00258a0$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $jSIPP.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $2e229f2081955271$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $jSIPP.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $55503225f0104895$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $jSIPP.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $55503225f0104895$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $55503225f0104895$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $b51c52e6b3da82bb$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $jSIPP.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $b51c52e6b3da82bb$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $b51c52e6b3da82bb$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $55503225f0104895$export$2e2bcd8739ae039)((node)=>{
        (0, $6eff9e987b06ce22$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $jSIPP.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $jSIPP.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $b51c52e6b3da82bb$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$b51c52e6b3da82bb$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $b51c52e6b3da82bb$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $erOpW.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $erOpW.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $b51c52e6b3da82bb$export$2e2bcd8739ae039 = $b51c52e6b3da82bb$var$useAutocomplete;




var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $64b0f84e0860bf60$export$6816d4fc0981ec7(slot) {
    return (0, $geF11.default)('MuiListSubheader', slot);
}
const $64b0f84e0860bf60$var$listSubheaderClasses = (0, $rARwS.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $64b0f84e0860bf60$export$2e2bcd8739ae039 = $64b0f84e0860bf60$var$listSubheaderClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $5b0c6c95d7095727$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5b0c6c95d7095727$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $iLAKr.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $64b0f84e0860bf60$export$6816d4fc0981ec7), classes);
};
const $5b0c6c95d7095727$var$ListSubheaderRoot = (0, $28RyA.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5b0c6c95d7095727$var$ListSubheader = /*#__PURE__*/ $jSIPP.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $cMu4A.default)(props, $5b0c6c95d7095727$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5b0c6c95d7095727$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($5b0c6c95d7095727$var$ListSubheaderRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5b0c6c95d7095727$var$ListSubheader.muiSkipListHighlight = true;
var $5b0c6c95d7095727$export$2e2bcd8739ae039 = $5b0c6c95d7095727$var$ListSubheader;





var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");
parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $f929823075b4b06d$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $iLAKr = parcelRequire("iLAKr");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $4581272005080a0e$export$31444911e4ee6fdd(slot) {
    return (0, $geF11.default)('MuiChip', slot);
}
const $4581272005080a0e$var$chipClasses = (0, $rARwS.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $4581272005080a0e$export$2e2bcd8739ae039 = $4581272005080a0e$var$chipClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $dbaa881ad628c459$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $dbaa881ad628c459$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $iLAKr.default)(size)}`,
            `color${(0, $iLAKr.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $iLAKr.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $iLAKr.default)(color)}`,
            `${variant}${(0, $iLAKr.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $iLAKr.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $iLAKr.default)(size)}`,
            `avatarColor${(0, $iLAKr.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $iLAKr.default)(size)}`,
            `iconColor${(0, $iLAKr.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $iLAKr.default)(size)}`,
            `deleteIconColor${(0, $iLAKr.default)(color)}`,
            `deleteIcon${(0, $iLAKr.default)(variant)}Color${(0, $iLAKr.default)(color)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4581272005080a0e$export$31444911e4ee6fdd), classes);
};
const $dbaa881ad628c459$var$ChipRoot = (0, $28RyA.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $iLAKr.default)(size)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $iLAKr.default)(color)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $iLAKr.default)(size)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $iLAKr.default)(iconColor)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iLAKr.default)(size)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $iLAKr.default)(color)}`]
            },
            {
                [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $iLAKr.default)(variant)}Color${(0, $iLAKr.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $iLAKr.default)(size)}`],
            styles[`color${(0, $iLAKr.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $iLAKr.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $iLAKr.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $iLAKr.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $erOpW.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).icon}`]: (0, $erOpW.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $erOpW.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: (0, $erOpW.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $hnF8Y.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $hnF8Y.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $4581272005080a0e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $4581272005080a0e$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $hnF8Y.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $dbaa881ad628c459$var$ChipLabel = (0, $28RyA.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $iLAKr.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $dbaa881ad628c459$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $dbaa881ad628c459$var$Chip = /*#__PURE__*/ $jSIPP.forwardRef(function Chip(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $cMu4A.default)(props, $dbaa881ad628c459$var$_excluded);
    const chipRef = $jSIPP.useRef(null);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $dbaa881ad628c459$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $dbaa881ad628c459$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $631d68b9552365dc$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $jSIPP.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $dbaa881ad628c459$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $631d68b9552365dc$export$2e2bcd8739ae039) ? (0, $erOpW.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $jSIPP.isValidElement(deleteIconProp) ? /*#__PURE__*/ $jSIPP.cloneElement(deleteIconProp, {
        className: (0, $86B3v.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f929823075b4b06d$export$2e2bcd8739ae039), {
        className: (0, $86B3v.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $jSIPP.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $jSIPP.cloneElement(avatarProp, {
        className: (0, $86B3v.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $jSIPP.isValidElement(iconProp)) icon = /*#__PURE__*/ $jSIPP.cloneElement(iconProp, {
        className: (0, $86B3v.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($dbaa881ad628c459$var$ChipRoot, (0, $erOpW.default)({
        as: component,
        className: (0, $86B3v.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $4uaIU.jsx)($dbaa881ad628c459$var$ChipLabel, {
                className: (0, $86B3v.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $dbaa881ad628c459$export$2e2bcd8739ae039 = $dbaa881ad628c459$var$Chip;









var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $8d8c0c8ee445086e$export$8ee01529667e66d9(slot) {
    return (0, $geF11.default)('MuiAutocomplete', slot);
}
const $8d8c0c8ee445086e$var$autocompleteClasses = (0, $rARwS.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $8d8c0c8ee445086e$export$2e2bcd8739ae039 = $8d8c0c8ee445086e$var$autocompleteClasses;



var $iLAKr = parcelRequire("iLAKr");


var $4uaIU = parcelRequire("4uaIU");
'use client';
var $f5c73759a36ab9b5$var$_ClearIcon, $f5c73759a36ab9b5$var$_ArrowDropDownIcon;
const $f5c73759a36ab9b5$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $f5c73759a36ab9b5$var$_excluded2 = [
    "ref"
], $f5c73759a36ab9b5$var$_excluded3 = [
    "key"
], $f5c73759a36ab9b5$var$_excluded4 = [
    "key"
];
const $f5c73759a36ab9b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $iLAKr.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $8d8c0c8ee445086e$export$8ee01529667e66d9), classes);
};
const $f5c73759a36ab9b5$var$AutocompleteRoot = (0, $28RyA.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $iLAKr.default)(size)}`]
            },
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).focused} .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).root}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $e047bbac9fd281f1$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $26a42e2294231948$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $26a42e2294231948$export$2e2bcd8739ae039).root}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).root}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).root}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $f0db40177fe65f41$export$2e2bcd8739ae039).root}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).hiddenLabel}.${(0, $dff798b0c97c1e5a$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $f5c73759a36ab9b5$var$AutocompleteEndAdornment = (0, $28RyA.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $f5c73759a36ab9b5$var$AutocompleteClearIndicator = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $f5c73759a36ab9b5$var$AutocompletePopupIndicator = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $erOpW.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $f5c73759a36ab9b5$var$AutocompletePopper = (0, $28RyA.default)((0, $b774b692670e0e71$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $f5c73759a36ab9b5$var$AutocompletePaper = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $erOpW.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $f5c73759a36ab9b5$var$AutocompleteLoading = (0, $28RyA.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $f5c73759a36ab9b5$var$AutocompleteNoOptions = (0, $28RyA.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $f5c73759a36ab9b5$var$AutocompleteListbox = (0, $28RyA.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $f5c73759a36ab9b5$var$AutocompleteGroupLabel = (0, $28RyA.default)((0, $5b0c6c95d7095727$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $f5c73759a36ab9b5$var$AutocompleteGroupUl = (0, $28RyA.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $8d8c0c8ee445086e$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $f5c73759a36ab9b5$var$Autocomplete = /*#__PURE__*/ $jSIPP.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $f5c73759a36ab9b5$var$_ClearIcon || ($f5c73759a36ab9b5$var$_ClearIcon = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6782c963a94e5c86$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $b774b692670e0e71$export$2e2bcd8739ae039), popupIcon: popupIcon = $f5c73759a36ab9b5$var$_ArrowDropDownIcon || ($f5c73759a36ab9b5$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9216b12485694825$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $cMu4A.default)(props, $f5c73759a36ab9b5$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $b51c52e6b3da82bb$export$2e2bcd8739ae039)((0, $erOpW.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $cMu4A.default)(_getListboxProps, $f5c73759a36ab9b5$var$_excluded2);
    const combinedListboxRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $erOpW.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $f5c73759a36ab9b5$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $erOpW.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $cMu4A.default)(_getCustomizedTagProp, $f5c73759a36ab9b5$var$_excluded3);
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), (0, $erOpW.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $4uaIU.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $4uaIU.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $cMu4A.default)(props2, $f5c73759a36ab9b5$var$_excluded4);
        return /*#__PURE__*/ (0, $4uaIU.jsx)("li", (0, $erOpW.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $erOpW.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteRoot, (0, $erOpW.default)({
                ref: ref,
                className: (0, $86B3v.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $erOpW.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $4uaIU.jsxs)($f5c73759a36ab9b5$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteClearIndicator, (0, $erOpW.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $86B3v.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompletePopupIndicator, (0, $erOpW.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $86B3v.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $erOpW.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompletePopper, (0, $erOpW.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $86B3v.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)($f5c73759a36ab9b5$var$AutocompletePaper, (0, $erOpW.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $86B3v.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $4uaIU.jsx)($f5c73759a36ab9b5$var$AutocompleteListbox, (0, $erOpW.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $f5c73759a36ab9b5$export$2e2bcd8739ae039 = $f5c73759a36ab9b5$var$Autocomplete;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $iLAKr = parcelRequire("iLAKr");




var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $a604d8571b21c413$export$4b135a4b3a6c4550(slot) {
    return (0, $geF11.default)('MuiInputAdornment', slot);
}
const $a604d8571b21c413$var$inputAdornmentClasses = (0, $rARwS.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $a604d8571b21c413$export$2e2bcd8739ae039 = $a604d8571b21c413$var$inputAdornmentClasses;



var $eyQWd = parcelRequire("eyQWd");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $1753741dd156a1b5$var$_span;
const $1753741dd156a1b5$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $1753741dd156a1b5$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $iLAKr.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $1753741dd156a1b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $iLAKr.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $iLAKr.default)(size)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $a604d8571b21c413$export$4b135a4b3a6c4550), classes);
};
const $1753741dd156a1b5$var$InputAdornmentRoot = (0, $28RyA.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $1753741dd156a1b5$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $a604d8571b21c413$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $a604d8571b21c413$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $1753741dd156a1b5$var$InputAdornment = /*#__PURE__*/ $jSIPP.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cMu4A.default)(props, $1753741dd156a1b5$var$_excluded);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $erOpW.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $1753741dd156a1b5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8405841daa1d27d3$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($1753741dd156a1b5$var$InputAdornmentRoot, (0, $erOpW.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $86B3v.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $1753741dd156a1b5$var$_span || ($1753741dd156a1b5$var$_span = /*#__PURE__*/ (0, $4uaIU.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $1753741dd156a1b5$export$2e2bcd8739ae039 = $1753741dd156a1b5$var$InputAdornment;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $lebkq = parcelRequire("lebkq");

var $hnF8Y = parcelRequire("hnF8Y");


var $iLAKr = parcelRequire("iLAKr");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $835496fd344e90a3$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $geF11.default)('MuiLinearProgress', slot);
}
const $835496fd344e90a3$var$linearProgressClasses = (0, $rARwS.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $835496fd344e90a3$export$2e2bcd8739ae039 = $835496fd344e90a3$var$linearProgressClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
let $6216cc7e50b683a3$var$_ = (t)=>t, $6216cc7e50b683a3$var$t, $6216cc7e50b683a3$var$t1, $6216cc7e50b683a3$var$t2, $6216cc7e50b683a3$var$t3, $6216cc7e50b683a3$var$t4, $6216cc7e50b683a3$var$t5;
const $6216cc7e50b683a3$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $6216cc7e50b683a3$var$_1 = (t)=>t, $6216cc7e50b683a3$var$_t, $6216cc7e50b683a3$var$_t2, $6216cc7e50b683a3$var$_t3, $6216cc7e50b683a3$var$_t4, $6216cc7e50b683a3$var$_t5, $6216cc7e50b683a3$var$_t6;
const $6216cc7e50b683a3$var$TRANSITION_DURATION = 4; // seconds
const $6216cc7e50b683a3$var$indeterminate1Keyframe = (0, $lebkq.keyframes)($6216cc7e50b683a3$var$_t || ($6216cc7e50b683a3$var$_t = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t || ($6216cc7e50b683a3$var$t = $6216cc7e50b683a3$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`))));
const $6216cc7e50b683a3$var$indeterminate2Keyframe = (0, $lebkq.keyframes)($6216cc7e50b683a3$var$_t2 || ($6216cc7e50b683a3$var$_t2 = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t1 || ($6216cc7e50b683a3$var$t1 = $6216cc7e50b683a3$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`))));
const $6216cc7e50b683a3$var$bufferKeyframe = (0, $lebkq.keyframes)($6216cc7e50b683a3$var$_t3 || ($6216cc7e50b683a3$var$_t3 = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t2 || ($6216cc7e50b683a3$var$t2 = $6216cc7e50b683a3$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`))));
const $6216cc7e50b683a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iLAKr.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $iLAKr.default)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, $iLAKr.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, $iLAKr.default)(color)}`,
            variant === 'buffer' && `color${(0, $iLAKr.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $835496fd344e90a3$export$bc8a6ea1eb17d7c6), classes);
};
const $6216cc7e50b683a3$var$getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $hnF8Y.lighten)(theme.palette[color].main, 0.62) : (0, $hnF8Y.darken)(theme.palette[color].main, 0.5);
};
const $6216cc7e50b683a3$var$LinearProgressRoot = (0, $28RyA.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: $6216cc7e50b683a3$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const $6216cc7e50b683a3$var$LinearProgressDashed = (0, $28RyA.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $iLAKr.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $6216cc7e50b683a3$var$getColorShade(theme, ownerState.color);
    return (0, $erOpW.default)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, $lebkq.css)($6216cc7e50b683a3$var$_t4 || ($6216cc7e50b683a3$var$_t4 = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t3 || ($6216cc7e50b683a3$var$t3 = $6216cc7e50b683a3$var$_`
    animation: ${0} 3s infinite linear;
  `), 0)), $6216cc7e50b683a3$var$bufferKeyframe));
const $6216cc7e50b683a3$var$LinearProgressBar1 = (0, $28RyA.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $iLAKr.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${$6216cc7e50b683a3$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${$6216cc7e50b683a3$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $lebkq.css)($6216cc7e50b683a3$var$_t5 || ($6216cc7e50b683a3$var$_t5 = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t4 || ($6216cc7e50b683a3$var$t4 = $6216cc7e50b683a3$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), 0)), $6216cc7e50b683a3$var$indeterminate1Keyframe));
const $6216cc7e50b683a3$var$LinearProgressBar2 = (0, $28RyA.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $iLAKr.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: $6216cc7e50b683a3$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$6216cc7e50b683a3$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $lebkq.css)($6216cc7e50b683a3$var$_t6 || ($6216cc7e50b683a3$var$_t6 = $6216cc7e50b683a3$var$_1($6216cc7e50b683a3$var$t5 || ($6216cc7e50b683a3$var$t5 = $6216cc7e50b683a3$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), 0)), $6216cc7e50b683a3$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $6216cc7e50b683a3$var$LinearProgress = /*#__PURE__*/ $jSIPP.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate' } = props, other = (0, $cMu4A.default)(props, $6216cc7e50b683a3$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $6216cc7e50b683a3$var$useUtilityClasses(ownerState);
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($6216cc7e50b683a3$var$LinearProgressRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $4uaIU.jsx)($6216cc7e50b683a3$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $4uaIU.jsx)($6216cc7e50b683a3$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $4uaIU.jsx)($6216cc7e50b683a3$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $6216cc7e50b683a3$export$2e2bcd8739ae039 = $6216cc7e50b683a3$var$LinearProgress;


var $879642966eaf6ce6$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($879642966eaf6ce6$exports, "__esModule", {
    value: true
});
$879642966eaf6ce6$exports.default = void 0;

var $879642966eaf6ce6$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $879642966eaf6ce6$var$_default = $879642966eaf6ce6$exports.default = (0, $879642966eaf6ce6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");



var $26IBV = parcelRequire("26IBV");
/**
 * A Canvas object that handles the boilerplate for rendering components to the canvas.
 * @param appName the app name displayed in the header (e.g. nABLE or nTELL)
 * @param title the name of the current view, displayed in the header and the canvas page title.
 * @param children The content of the view.
 * @returns {JSX.Element}
 * @constructor
 */ const $b3c751be1355b7b5$var$Canvas = ({ appName: appName, title: title, children: children, sx: sx })=>{
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $19efb1c1755d1d62$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)("title", {
                    children: [
                        title,
                        " | ",
                        appName,
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                    p: '1rem',
                    flex: '1 1 auto'
                }, sx),
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                        sx: {
                            my: '1.5rem'
                        }
                    }),
                    children
                ]
            })
        ]
    });
};
$b3c751be1355b7b5$var$Canvas.propTypes = {
    appName: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).node
};
var $b3c751be1355b7b5$export$2e2bcd8739ae039 = $b3c751be1355b7b5$var$Canvas;



const $a9106d6db699107c$export$a6cdc56e425d0d0a = (x)=>{
    return x != null && typeof x === 'object';
};
const $a9106d6db699107c$export$844ec244b1367d54 = (x)=>{
    const val = Object.prototype.toString.call(x) === "[object String]";
    return val;
};
const $a9106d6db699107c$export$1811237fdf5ac5d = (param)=>{
    let configValue;
    const fetchParam = $a9106d6db699107c$export$14b5894a03ab9021(param);
    if (fetchParam) configValue = fetchParam[param];
    else {
        const error = `${param} config value is not valid!`;
        throw error;
    }
    return configValue;
};
const $a9106d6db699107c$export$14b5894a03ab9021 = (paramArray, missingParamArray)=>{
    let paramObj = {};
    let paramList;
    if ($a9106d6db699107c$export$844ec244b1367d54(paramArray)) paramList = [
        paramArray
    ];
    else paramList = [
        ...paramArray
    ];
    let hasValues = true;
    for (let param of paramList){
        const paramValue = window.amplifyConfig[param];
        if (!window.amplifyConfig || !paramValue) {
            if (missingParamArray) missingParamArray.push(param);
            hasValues = false;
        } else paramObj[param] = paramValue;
    }
    if (hasValues) return paramObj;
    else return false;
};
const $a9106d6db699107c$export$9a216cca07bece15 = (str, fragment)=>{
    if (!fragment) fragment = '';
    let myStr = '';
    let toUpper = true;
    for(let i = 0; i < str.length; i++){
        if (str[i] === '_') {
            myStr += fragment;
            toUpper = true;
        } else if (toUpper) {
            myStr += str[i].toUpperCase();
            toUpper = false;
        } else myStr += str[i];
    }
    return myStr;
};
const $a9106d6db699107c$export$7973aed45b22124c = (queryParams = {})=>{
    let additionalQueryStringParams = '';
    for (const key of Object.keys(queryParams)){
        additionalQueryStringParams += additionalQueryStringParams === '' ? '?' : '&';
        additionalQueryStringParams += `${key}=${queryParams[key]}`;
    }
    return additionalQueryStringParams;
};
// Patterns are applied by BigQuery's RE2, which lacks lookaround and backreferences.
// Named groups ARE supported, so the lookbehind probes must match (?<= and (?<! rather
// than any '(?<'.
const $a9106d6db699107c$var$NEGATION_HINT = "Match on what the name does start with, as an alternation such as ^(Wardsprings|iYotah).";
const $a9106d6db699107c$var$RE2_UNSUPPORTED = [
    [
        /\(\?=/,
        'lookahead, (?=...)',
        $a9106d6db699107c$var$NEGATION_HINT
    ],
    [
        /\(\?!/,
        'negative lookahead, (?!...)',
        $a9106d6db699107c$var$NEGATION_HINT
    ],
    [
        /\(\?<=/,
        'lookbehind, (?<=...)',
        $a9106d6db699107c$var$NEGATION_HINT
    ],
    [
        /\(\?<!/,
        'negative lookbehind, (?<!...)',
        $a9106d6db699107c$var$NEGATION_HINT
    ],
    [
        /(^|[^\\])\\[1-9]/,
        'a backreference, such as \\1',
        'Write the repeated text out in full.'
    ]
];
const $a9106d6db699107c$export$83c7b33f3da8f9f1 = (pattern)=>{
    if (!pattern) return null;
    for (const [probe, description, hint] of $a9106d6db699107c$var$RE2_UNSUPPORTED){
        if (probe.test(pattern)) return `BigQuery cannot use ${description}. ${hint}`;
    }
    return null;
};
const $a9106d6db699107c$export$1e301ffa4bd66559 = (pattern)=>pattern.replace(/\(\?P</g, '(?<').replace(/\(\?[imsU-]+:/g, '(?:').replace(/\(\?[imsU-]+\)/g, '');
const $a9106d6db699107c$export$493a1a324e74fde0 = (pattern)=>{
    try {
        new RegExp($a9106d6db699107c$export$1e301ffa4bd66559(pattern));
        return true;
    } catch (err) {
        return false;
    }
};
const $a9106d6db699107c$export$364b559aabb27140 = (pattern)=>{
    if (!pattern) return null;
    const unsupported = $a9106d6db699107c$export$83c7b33f3da8f9f1(pattern);
    if (unsupported) return unsupported;
    return $a9106d6db699107c$export$493a1a324e74fde0(pattern) ? null : 'Not a valid regular expression.';
};


const $6ea4f0a608034787$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $6ea4f0a608034787$var$getOneById = async (ownerId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$6ea4f0a608034787$var$HOST_URL}/consumer/${ownerId}`)).data;
};
const $6ea4f0a608034787$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$6ea4f0a608034787$var$HOST_URL}/consumer`)).data;
};
const $6ea4f0a608034787$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$6ea4f0a608034787$var$HOST_URL}/consumer`, data)).data;
};
const $6ea4f0a608034787$var$put = async (ownerId, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$6ea4f0a608034787$var$HOST_URL}/consumer/${ownerId}`, data)).data;
};
var $6ea4f0a608034787$export$2e2bcd8739ae039 = {
    getOneById: $6ea4f0a608034787$var$getOneById,
    getAll: $6ea4f0a608034787$var$getAll,
    post: $6ea4f0a608034787$var$post,
    put: $6ea4f0a608034787$var$put
};




const $17fe0060be69a0cc$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $17fe0060be69a0cc$var$getOneById = async (ownerId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$17fe0060be69a0cc$var$HOST_URL}/owner/${ownerId}`)).data;
};
const $17fe0060be69a0cc$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$17fe0060be69a0cc$var$HOST_URL}/owner`)).data;
};
// The owner pickers and the data stream grid share one 'getOwners' cache entry, so they
// have to agree on the order: whichever mounts first is the one that fetches.
const $17fe0060be69a0cc$var$getAllSortedByName = async ()=>{
    const data = await $17fe0060be69a0cc$var$getAll();
    return [
        ...data
    ].sort((a, b)=>String(a.name).localeCompare(String(b.name)));
};
const $17fe0060be69a0cc$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$17fe0060be69a0cc$var$HOST_URL}/owner`, data)).data;
};
const $17fe0060be69a0cc$var$put = async (ownerId, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$17fe0060be69a0cc$var$HOST_URL}/owner/${ownerId}`, data)).data;
};
var $17fe0060be69a0cc$export$2e2bcd8739ae039 = {
    getOneById: $17fe0060be69a0cc$var$getOneById,
    getAll: $17fe0060be69a0cc$var$getAll,
    getAllSortedByName: $17fe0060be69a0cc$var$getAllSortedByName,
    post: $17fe0060be69a0cc$var$post,
    put: $17fe0060be69a0cc$var$put
};




const $04fdf08493329c97$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $04fdf08493329c97$var$getOneById = async (providerId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$04fdf08493329c97$var$HOST_URL}/provider/${providerId}`)).data;
};
const $04fdf08493329c97$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$04fdf08493329c97$var$HOST_URL}/provider`)).data;
};
// As with owners: the provider picker and the home search share one 'getProviders' cache
// entry, so they have to agree on the order.
const $04fdf08493329c97$var$getAllSortedByName = async ()=>{
    const data = await $04fdf08493329c97$var$getAll();
    return [
        ...data
    ].sort((a, b)=>String(a.name).localeCompare(String(b.name)));
};
const $04fdf08493329c97$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$04fdf08493329c97$var$HOST_URL}/provider`, data)).data;
};
const $04fdf08493329c97$var$put = async (id, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$04fdf08493329c97$var$HOST_URL}/provider/${id}`, data)).data;
};
var $04fdf08493329c97$export$2e2bcd8739ae039 = {
    getOneById: $04fdf08493329c97$var$getOneById,
    getAll: $04fdf08493329c97$var$getAll,
    getAllSortedByName: $04fdf08493329c97$var$getAllSortedByName,
    post: $04fdf08493329c97$var$post,
    put: $04fdf08493329c97$var$put
};




const $e35ffebe245b57e7$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $e35ffebe245b57e7$var$getOneById = async (dataStreamId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$e35ffebe245b57e7$var$HOST_URL}/data-stream/${dataStreamId}`)).data;
};
const $e35ffebe245b57e7$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$e35ffebe245b57e7$var$HOST_URL}/data-stream`)).data;
};
const $e35ffebe245b57e7$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$e35ffebe245b57e7$var$HOST_URL}/data-stream`, data)).data;
};
const $e35ffebe245b57e7$var$put = async (dataStreamId, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$e35ffebe245b57e7$var$HOST_URL}/data-stream/${dataStreamId}`, data)).data;
};
var $e35ffebe245b57e7$export$2e2bcd8739ae039 = {
    getOneById: $e35ffebe245b57e7$var$getOneById,
    getAll: $e35ffebe245b57e7$var$getAll,
    post: $e35ffebe245b57e7$var$post,
    put: $e35ffebe245b57e7$var$put
};


// Builds and searches the home page's index of everything the console manages.
//
// Every list is already fetched whole elsewhere in the app under these same query keys, so
// the index is built client side from the cache rather than from a search endpoint.
// route is where a hit sends you; the page opens that row's edit dialog from ?id=.
const $f5e552fe77fec668$var$TYPES = [
    {
        type: 'owner',
        label: 'Owners',
        route: '/owners',
        // Fields worth matching on, beyond name and id. Kept short on purpose: matching every
        // column turns a search for "milk" into a list of everything a farm ever touched.
        fields: [
            'description',
            'timezone',
            'business_id'
        ]
    },
    {
        type: 'provider',
        label: 'Providers',
        route: '/providers',
        fields: [
            'description',
            'partition_scheme'
        ]
    },
    {
        type: 'data_stream',
        label: 'Data Streams',
        route: '/data-streams',
        fields: [
            'description',
            'owner_name',
            'provider_name'
        ]
    },
    {
        type: 'consumer',
        label: 'Consumers',
        route: '/consumers',
        fields: [
            'description',
            'consumer_type_name'
        ]
    }
];
// What each hit shows under its name, so two streams called "Milk Weights" can be told
// apart without opening them.
const $f5e552fe77fec668$var$SUBTITLES = {
    owner: (row)=>[
            row.timezone,
            row.description
        ].filter(Boolean).join(" \xb7 "),
    provider: (row)=>[
            row.partition_scheme,
            row.description
        ].filter(Boolean).join(" \xb7 "),
    data_stream: (row)=>[
            row.owner_name,
            row.provider_name
        ].filter(Boolean).join(" \xb7 "),
    consumer: (row)=>[
            row.consumer_type_name,
            row.description
        ].filter(Boolean).join(" \xb7 ")
};
const $f5e552fe77fec668$var$text = (value)=>value === null || value === undefined ? '' : String(value);
const $f5e552fe77fec668$var$buildIndex = (rowsByType)=>$f5e552fe77fec668$var$TYPES.flatMap(({ type: type, label: label, route: route, fields: fields })=>(rowsByType[type] || []).map((row)=>({
                type: type,
                typeLabel: label,
                route: route,
                id: row.id,
                name: $f5e552fe77fec668$var$text(row.name) || `(unnamed ${type})`,
                subtitle: $f5e552fe77fec668$var$SUBTITLES[type](row),
                disabled: Boolean(row.disabled),
                // Lowercased once at build time; searching re-lowercases nothing per keystroke.
                haystack: [
                    row.name,
                    ...fields.map((field)=>row[field])
                ].map($f5e552fe77fec668$var$text).join(' ').toLowerCase()
            })));
// Rank so the thing you typed the start of comes first: an exact id, then a name that
// starts with the query, then a name containing it, then a match anywhere else.
const $f5e552fe77fec668$var$rank = (entry, query)=>{
    if (String(entry.id) === query) return 0;
    const name = entry.name.toLowerCase();
    if (name.startsWith(query)) return 1;
    if (name.includes(query)) return 2;
    return entry.haystack.includes(query) ? 3 : -1;
};
const $f5e552fe77fec668$var$search = (index, rawQuery, limit = 25)=>{
    const query = rawQuery.trim().toLowerCase();
    if (!query) return [];
    const scored = [];
    for (const entry of index){
        const score = $f5e552fe77fec668$var$rank(entry, query);
        if (score >= 0) scored.push({
            entry: entry,
            score: score
        });
    }
    scored.sort((a, b)=>a.score - b.score || a.entry.name.localeCompare(b.entry.name) || Number(a.entry.id) - Number(b.entry.id));
    return scored.slice(0, limit).map((hit)=>hit.entry);
};
// Where selecting a hit goes. The target page reads ?id= and opens that row.
const $f5e552fe77fec668$var$linkTo = (entry)=>`${entry.route}?id=${entry.id}`;
var $f5e552fe77fec668$export$2e2bcd8739ae039 = {
    TYPES: $f5e552fe77fec668$var$TYPES,
    buildIndex: $f5e552fe77fec668$var$buildIndex,
    search: $f5e552fe77fec668$var$search,
    linkTo: $f5e552fe77fec668$var$linkTo
};


// Every list the search covers, on the query keys the rest of the app already uses: landing
// here warms the cache the list pages read, rather than duplicating their fetches.
const $d42abd0b1794984f$var$useSearchData = ()=>{
    const owners = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getOwners', (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAllSortedByName, {
        staleTime: Infinity
    });
    const providers = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviders', (0, $04fdf08493329c97$export$2e2bcd8739ae039).getAllSortedByName, {
        staleTime: Infinity
    });
    const dataStreams = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDataStreams', (0, $e35ffebe245b57e7$export$2e2bcd8739ae039).getAll, {
        staleTime: Infinity
    });
    const consumers = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getConsumers', (0, $6ea4f0a608034787$export$2e2bcd8739ae039).getAll, {
        staleTime: Infinity
    });
    const index = (0, $jSIPP.useMemo)(()=>(0, $f5e552fe77fec668$export$2e2bcd8739ae039).buildIndex({
            owner: owners.data,
            provider: providers.data,
            data_stream: dataStreams.data,
            consumer: consumers.data
        }), [
        owners.data,
        providers.data,
        dataStreams.data,
        consumers.data
    ]);
    // A list that failed is named rather than silently missing from the results.
    const unavailable = [
        [
            'owners',
            owners
        ],
        [
            'providers',
            providers
        ],
        [
            'data streams',
            dataStreams
        ],
        [
            'consumers',
            consumers
        ]
    ].filter(([, query])=>query.isError).map(([name])=>name);
    const loading = [
        owners,
        providers,
        dataStreams,
        consumers
    ].some((query)=>query.isLoading);
    return {
        index: index,
        loading: loading,
        unavailable: unavailable
    };
};
const $d42abd0b1794984f$var$TYPE_COLORS = {
    owner: 'primary',
    provider: 'secondary',
    data_stream: 'default',
    consumer: 'default'
};
const $d42abd0b1794984f$var$Home = ()=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const { index: index, loading: loading, unavailable: unavailable } = $d42abd0b1794984f$var$useSearchData();
    const [query, setQuery] = (0, $jSIPP.useState)('');
    const results = (0, $jSIPP.useMemo)(()=>(0, $f5e552fe77fec668$export$2e2bcd8739ae039).search(index, query), [
        index,
        query
    ]);
    const open = (entry)=>{
        if (entry) history.push((0, $f5e552fe77fec668$export$2e2bcd8739ae039).linkTo(entry));
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
        appName: "nGEST",
        title: "Home",
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '55vh',
                px: 2
            },
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                    variant: "h4",
                    sx: {
                        mb: 1
                    },
                    children: "What are you looking for?"
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                    variant: "body2",
                    color: "textSecondary",
                    sx: {
                        mb: 3,
                        textAlign: 'center'
                    },
                    children: "Search owners, providers, data streams and consumers by name or id. Pick a result to open it."
                }),
                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    sx: {
                        width: '100%',
                        maxWidth: 720
                    },
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), {
                            options: results,
                            // Ranking and matching are done in Search.search; MUI must not filter again.
                            filterOptions: (options)=>options,
                            getOptionLabel: (option)=>option.name,
                            isOptionEqualToValue: (option, selected)=>option.type === selected.type && option.id === selected.id,
                            inputValue: query,
                            onInputChange: (event, next)=>setQuery(next),
                            // Kept unselected: a hit is a destination, not a value the box should hold on to.
                            value: null,
                            onChange: (event, option)=>open(option),
                            autoHighlight: true,
                            openOnFocus: true,
                            clearOnBlur: false,
                            noOptionsText: loading ? "Loading\u2026" : query.trim() ? 'No matches' : 'Start typing',
                            renderOption: (props, option)=>/*#__PURE__*/ (0, $jSIPP.createElement)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
                                    component: "li"
                                }, props), {
                                    key: `${option.type}-${option.id}`,
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                                            size: "small",
                                            variant: "outlined",
                                            color: $d42abd0b1794984f$var$TYPE_COLORS[option.type],
                                            label: option.typeLabel.replace(/s$/, ''),
                                            sx: {
                                                minWidth: 96
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                            sx: {
                                                minWidth: 0,
                                                flex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                    variant: "body2",
                                                    noWrap: true,
                                                    children: [
                                                        option.name,
                                                        " (",
                                                        option.id,
                                                        ")",
                                                        option.disabled && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            variant: "caption",
                                                            color: "textSecondary",
                                                            children: [
                                                                ' ',
                                                                "\u2014 disabled"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                option.subtitle && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    color: "textSecondary",
                                                    noWrap: true,
                                                    sx: {
                                                        display: 'block'
                                                    },
                                                    children: option.subtitle
                                                })
                                            ]
                                        })
                                    ]
                                })),
                            renderInput: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params), {
                                    autoFocus: true,
                                    placeholder: "Search by name or id\u2026",
                                    variant: "outlined",
                                    InputProps: (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params.InputProps), {
                                        startAdornment: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1753741dd156a1b5$export$2e2bcd8739ae039), {
                                            position: "start",
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($879642966eaf6ce6$exports))), {
                                                color: "action"
                                            })
                                        })
                                    })
                                }))
                        }),
                        loading && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6216cc7e50b683a3$export$2e2bcd8739ae039), {
                            sx: {
                                mt: 1
                            }
                        }),
                        unavailable.length > 0 && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                            variant: "caption",
                            color: "error",
                            sx: {
                                mt: 1,
                                display: 'block'
                            },
                            children: [
                                "Could not load ",
                                unavailable.join(', '),
                                ", so nothing from",
                                ' ',
                                unavailable.length > 1 ? 'those lists' : 'that list',
                                " will appear here."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $d42abd0b1794984f$export$2e2bcd8739ae039 = $d42abd0b1794984f$var$Home;




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");


/**
 * A Route which is only accessible by users while they are not logged in.  If user is logged in, they will be
 * redirected to the main page.
 *
 * @param children child component to render
 * @param render command to render components
 * @param att additional props to pass the inner Route component
 * @returns {JSX.Element} a Route which is only accessible when not logged in
 * @constructor
 */ const $3b00fc86dbf3c073$var$PublicOnlyRoute = (_param)=>{
    var { children: children, render: render } = _param, att = (0, $287e58e413d8005e$export$71511d61b312f219)(_param, [
        "children",
        "render"
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1792dc418e70ff3a$export$2e2bcd8739ae039), {
        conditionCallback: async ()=>!await (0, $875b725466af1357$export$2e2bcd8739ae039).isLoggedIn(),
        render: render || ((_)=>children),
        failRedirect: "/home",
        loadMessage: "Checking for Session...",
        props: att
    });
};
var $3b00fc86dbf3c073$export$2e2bcd8739ae039 = $3b00fc86dbf3c073$var$PublicOnlyRoute;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");

var $a6be52b93098825b$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($a6be52b93098825b$exports, "__esModule", {
    value: true
});
$a6be52b93098825b$exports.default = void 0;

var $a6be52b93098825b$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $a6be52b93098825b$var$_default = $a6be52b93098825b$exports.default = (0, $a6be52b93098825b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $3ecd719ca051060c$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($3ecd719ca051060c$exports, "__esModule", {
    value: true
});
$3ecd719ca051060c$exports.default = void 0;

var $3ecd719ca051060c$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $3ecd719ca051060c$var$_default = $3ecd719ca051060c$exports.default = (0, $3ecd719ca051060c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7m4 8h-3v3h-2v-3H8V8h3V5h2v3h3z"
}), 'AddLocation');


var $9763220a10bead63$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($9763220a10bead63$exports, "__esModule", {
    value: true
});
$9763220a10bead63$exports.default = void 0;

var $9763220a10bead63$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $9763220a10bead63$var$_default = $9763220a10bead63$exports.default = (0, $9763220a10bead63$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');


var $b096330a1aa10551$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($b096330a1aa10551$exports, "__esModule", {
    value: true
});
$b096330a1aa10551$exports.default = void 0;

var $b096330a1aa10551$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $b096330a1aa10551$var$_default = $b096330a1aa10551$exports.default = (0, $b096330a1aa10551$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');




var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");
/* eslint-disable */ const $026bf94bfd54d979$var$_keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $026bf94bfd54d979$var$utf8Encode(str) {
    for(let n = 0; n < str.length; n++){
        const c = str.charCodeAt(n);
        if (c >= 128) throw new Error('ASCII only support');
    }
    return str;
}
const $026bf94bfd54d979$export$c62426fdd000a97e = (input)=>{
    let output = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    while(i < input.length){
        enc1 = $026bf94bfd54d979$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $026bf94bfd54d979$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $026bf94bfd54d979$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $026bf94bfd54d979$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) output = output + String.fromCharCode(chr2);
        if (enc4 != 64) output = output + String.fromCharCode(chr3);
    }
    return output;
};
const $026bf94bfd54d979$export$e510a73ee562749 = (input)=>{
    let output = '';
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = $026bf94bfd54d979$var$utf8Encode(input);
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output = output + $026bf94bfd54d979$var$_keyStr.charAt(enc1) + $026bf94bfd54d979$var$_keyStr.charAt(enc2) + $026bf94bfd54d979$var$_keyStr.charAt(enc3) + $026bf94bfd54d979$var$_keyStr.charAt(enc4);
    }
    return output;
};


/* eslint-disable */ // See "precomputation" in notes
const $c0c20a73b09d7a1e$var$k = [];
let $c0c20a73b09d7a1e$var$i = 0;
for(; $c0c20a73b09d7a1e$var$i < 64;)$c0c20a73b09d7a1e$var$k[$c0c20a73b09d7a1e$var$i] = 0 | Math.sin(++$c0c20a73b09d7a1e$var$i % Math.PI) * 4294967296;
function $c0c20a73b09d7a1e$export$a58ec6a60c09ca72(s) {
    const words = [];
    let b, c, d, j = unescape(encodeURI(s)) + '\x80', a = j.length;
    const h = [
        b = 0x67452301,
        c = 0xefcdab89,
        ~b,
        ~c
    ];
    s = --a / 4 + 2 | 15;
    // See "Length bits" in notes
    words[--s] = a * 8;
    for(; ~a;)// a !== -1
    words[a >> 2] |= j.charCodeAt(a) << 8 * a--;
    for($c0c20a73b09d7a1e$var$i = j = 0; $c0c20a73b09d7a1e$var$i < s; $c0c20a73b09d7a1e$var$i += 16){
        a = h;
        for(; j < 64; a = [
            d = a[3],
            b + ((d = a[0] + [
                b & c | ~b & d,
                d & b | ~d & c,
                b ^ c ^ d,
                c ^ (b | ~d)
            ][a = j >> 4] + $c0c20a73b09d7a1e$var$k[j] + ~~words[$c0c20a73b09d7a1e$var$i | [
                j,
                5 * j + 1,
                3 * j + 5,
                7 * j
            ][a] & 15]) << (a = [
                7,
                12,
                17,
                22,
                5,
                9,
                14,
                20,
                4,
                11,
                16,
                23,
                6,
                10,
                15,
                21
            ][4 * a + j++ % 4]) | d >>> -a),
            b,
            c
        ]){
            b = a[1] | 0;
            c = a[2];
        }
        // See "Integer safety" in notes
        for(j = 4; j;)h[--j] += a[j];
    // j === 0
    }
    for(s = ''; j < 32;)s += (h[j >> 3] >> (1 ^ j++) * 4 & 15).toString(16);
    return s;
}


// eslint-disable-next-line @typescript-eslint/naming-convention
let $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc = /*#__PURE__*/ function(LICENSE_STATUS) {
    LICENSE_STATUS["NotFound"] = "NotFound";
    LICENSE_STATUS["Invalid"] = "Invalid";
    LICENSE_STATUS["ExpiredAnnual"] = "ExpiredAnnual";
    LICENSE_STATUS["ExpiredAnnualGrace"] = "ExpiredAnnualGrace";
    LICENSE_STATUS["ExpiredVersion"] = "ExpiredVersion";
    LICENSE_STATUS["Valid"] = "Valid";
    LICENSE_STATUS["OutOfScope"] = "OutOfScope";
    return LICENSE_STATUS;
}({});


const $65cb2dc93fdc54e5$export$57aff84a372c3edc = [
    'pro',
    'premium'
];


const $44da1726342c2249$export$328a1b19c1ed31de = [
    /**
 * A license is outdated if the current version of the software was released after the expiry date of the license.
 * But the license can be used indefinitely with an older version of the software.
 */ 'perpetual',
    /**
 * On development, a license is outdated if the expiry date has been reached
 * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
 */ 'annual',
    /**
 * TODO 2025 remove, legacy name of annual.
 */ 'subscription'
];


const $f19994a76f89355d$var$getDefaultReleaseDate = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function $f19994a76f89355d$export$4c9b7f7dacd07671(releaseDate = $f19994a76f89355d$var$getDefaultReleaseDate()) {
    return (0, $026bf94bfd54d979$export$e510a73ee562749)(releaseDate.getTime().toString());
}
const $f19994a76f89355d$var$expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ const $f19994a76f89355d$var$decodeLicenseVersion1 = (license)=>{
    let expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match($f19994a76f89355d$var$expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) expiryTimestamp = null;
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        scope: 'pro',
        licensingModel: 'perpetual',
        expiryTimestamp: expiryTimestamp
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${scope},LM=${licensingModel},KV=2`;
 */ const $f19994a76f89355d$var$decodeLicenseVersion2 = (license)=>{
    const licenseInfo = {
        scope: null,
        licensingModel: null,
        expiryTimestamp: null
    };
    license.split(',').map((token)=>token.split('=')).filter((el)=>el.length === 2).forEach(([key, value])=>{
        if (key === 'S') licenseInfo.scope = value;
        if (key === 'LM') licenseInfo.licensingModel = value;
        if (key === 'E') {
            const expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) licenseInfo.expiryTimestamp = expiryTimestamp;
        }
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ const $f19994a76f89355d$var$decodeLicense = (encodedLicense)=>{
    const license = (0, $026bf94bfd54d979$export$c62426fdd000a97e)(encodedLicense);
    if (license.includes('KEYVERSION=1')) return $f19994a76f89355d$var$decodeLicenseVersion1(license);
    if (license.includes('KV=2')) return $f19994a76f89355d$var$decodeLicenseVersion2(license);
    return null;
};
function $f19994a76f89355d$export$65cf4e2e0f5c4c60({ releaseInfo: releaseInfo, licenseKey: licenseKey, acceptedScopes: acceptedScopes }) {
    if (!releaseInfo) throw new Error('MUI: The release information is missing. Not able to validate license.');
    if (!licenseKey) return {
        status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).NotFound
    };
    const hash = licenseKey.substr(0, 32);
    const encoded = licenseKey.substr(32);
    if (hash !== (0, $c0c20a73b09d7a1e$export$a58ec6a60c09ca72)(encoded)) return {
        status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid
    };
    const license = $f19994a76f89355d$var$decodeLicense(encoded);
    if (license == null) {
        console.error('Error checking license. Key version not found!');
        return {
            status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.licensingModel == null || !(0, $44da1726342c2249$export$328a1b19c1ed31de).includes(license.licensingModel)) {
        console.error('Error checking license. Licensing model not found or invalid!');
        return {
            status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error('Error checking license. Expiry timestamp not found or invalid!');
        return {
            status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    license.licensingModel;
    {
        const pkgTimestamp = parseInt((0, $026bf94bfd54d979$export$c62426fdd000a97e)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) throw new Error('MUI: The release information is invalid. Not able to validate license.');
        if (license.expiryTimestamp < pkgTimestamp) return {
            status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredVersion
        };
    }
    if (license.scope == null || !(0, $65cb2dc93fdc54e5$export$57aff84a372c3edc).includes(license.scope)) {
        console.error('Error checking license. scope not found or invalid!');
        return {
            status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (!acceptedScopes.includes(license.scope)) return {
        status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).OutOfScope
    };
    return {
        status: (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Valid
    };
}



function $9986797c5008fae6$var$showError(message) {
    console.error([
        '*************************************************************',
        '',
        ...message,
        '',
        '*************************************************************'
    ].join('\n'));
}
function $9986797c5008fae6$export$e03bc902b0abb5bd() {
    $9986797c5008fae6$var$showError([
        'MUI: Invalid license key.',
        '',
        "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.",
        '',
        'To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument',
        'Please check the license key installation https://mui.com/r/x-license-key-installation.'
    ]);
}
function $9986797c5008fae6$export$d0a8365d54384f87() {
    $9986797c5008fae6$var$showError([
        'MUI: License key plan mismatch.',
        '',
        'Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use `DataGridPremium` with a license key for the Pro plan.',
        '',
        'To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.',
        "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."
    ]);
}
function $9986797c5008fae6$export$bfbf7dff305ffa2a({ plan: plan, packageName: packageName }) {
    $9986797c5008fae6$var$showError([
        'MUI: Missing license key.',
        '',
        `The license key is missing. You might not be allowed to use \`${packageName}\` which is part of MUI X ${plan}.`,
        '',
        'To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.',
        'If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately.'
    ]);
}
function $9986797c5008fae6$export$242a1b9acf4255b9({ packageName: packageName }) {
    $9986797c5008fae6$var$showError([
        'MUI: Expired package version.',
        '',
        `You have installed a version of \`${packageName}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`,
        '',
        'To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key.'
    ]);
}
function $9986797c5008fae6$export$1ba1f66631f7b541({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    $9986797c5008fae6$var$showError([
        'MUI: Expired license key.',
        '',
        `Your annual license key to use MUI X ${plan}'s on non-production environments is expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        '',
        'To solve the problem you can either:',
        '',
        '- Renew your license https://mui.com/r/x-get-license and use the new key',
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        '',
        'Note that your license is perpetual in production environments with any version released before your license term ends.',
        '',
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ''
    ]);
}
function $9986797c5008fae6$export$89cdc76bbf22084e({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    throw new Error([
        'MUI: Expired license key.',
        '',
        `Your annual license key to use MUI X ${plan}'s on non-production environments is expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        '',
        'To solve the problem you can either:',
        '',
        '- Renew your license https://mui.com/r/x-get-license and use the new key',
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        '',
        'Note that your license is perpetual in production environments with any version released before your license term ends.',
        '',
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ''
    ].join('\n'));
}




var $jSIPP = parcelRequire("jSIPP");
var $fc4160ffa34bee58$export$2e2bcd8739ae039 = /*#__PURE__*/ $jSIPP.createContext({
    key: undefined
});


const $f03b582a784d53b6$export$dc1f6c076f2a5d88 = {};
function $f03b582a784d53b6$export$bd780281ba7bfd9(packageName, releaseInfo) {
    const { key: contextKey } = $jSIPP.useContext((0, $fc4160ffa34bee58$export$2e2bcd8739ae039));
    return $jSIPP.useMemo(()=>{
        const licenseKey = contextKey != null ? contextKey : (0, $332fe187cd95a041$export$2c56d2e2ae515eeb).getLicenseKey();
        // Cache the response to not trigger the error twice.
        if ($f03b582a784d53b6$export$dc1f6c076f2a5d88[packageName] && $f03b582a784d53b6$export$dc1f6c076f2a5d88[packageName].key === licenseKey) return $f03b582a784d53b6$export$dc1f6c076f2a5d88[packageName].licenseVerifier;
        const acceptedScopes = packageName.includes('premium') ? [
            'premium'
        ] : [
            'pro',
            'premium'
        ];
        const plan = packageName.includes('premium') ? 'Premium' : 'Pro';
        const licenseStatus = (0, $f19994a76f89355d$export$65cf4e2e0f5c4c60)({
            releaseInfo: releaseInfo,
            licenseKey: licenseKey,
            acceptedScopes: acceptedScopes
        });
        $f03b582a784d53b6$export$dc1f6c076f2a5d88[packageName] = {
            key: licenseKey,
            licenseVerifier: licenseStatus
        };
        const fullPackageName = `@mui/${packageName}`;
        if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Valid) ;
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid) (0, $9986797c5008fae6$export$e03bc902b0abb5bd)();
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).OutOfScope) (0, $9986797c5008fae6$export$d0a8365d54384f87)();
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).NotFound) (0, $9986797c5008fae6$export$bfbf7dff305ffa2a)({
            plan: plan,
            packageName: fullPackageName
        });
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace) (0, $9986797c5008fae6$export$1ba1f66631f7b541)((0, $erOpW.default)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredAnnual) (0, $9986797c5008fae6$export$89cdc76bbf22084e)((0, $erOpW.default)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredVersion) (0, $9986797c5008fae6$export$242a1b9acf4255b9)({
            packageName: fullPackageName
        });
        return licenseStatus;
    }, [
        packageName,
        releaseInfo,
        contextKey
    ]);
}

parcelRequire("jSIPP");



var $4uaIU = parcelRequire("4uaIU");
function $631869056872638e$var$getLicenseErrorMessage(licenseStatus) {
    switch(licenseStatus){
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace:
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredAnnual:
            return 'MUI X Expired license key';
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).ExpiredVersion:
            return 'MUI X Expired package version';
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Invalid:
            return 'MUI X Invalid license key';
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).OutOfScope:
            return 'MUI X License key plan mismatch';
        case (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).NotFound:
            return 'MUI X Missing license key';
        default:
            throw new Error('MUI: Unhandled MUI X license status.');
    }
}
function $631869056872638e$export$e94943a72132ebdf(props) {
    const { packageName: packageName, releaseInfo: releaseInfo } = props;
    const licenseStatus = (0, $f03b582a784d53b6$export$bd780281ba7bfd9)(packageName, releaseInfo);
    if (licenseStatus.status === (0, $0ec093ad67db4d0a$export$4d5a447ae2d3c7bc).Valid) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            color: '#8282829e',
            zIndex: 100000,
            width: '100%',
            textAlign: 'center',
            bottom: '50%',
            right: 0,
            letterSpacing: 5,
            fontSize: 24
        },
        children: $631869056872638e$var$getLicenseErrorMessage(licenseStatus.status)
    });
}


function $0486e26d06bac8e6$export$2e2bcd8739ae039(propType1, propType2) {
    return ()=>null;
}



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $jSIPP = parcelRequire("jSIPP");
const $aeac8d48234fe666$export$37099e7a34cbf988 = /*#__PURE__*/ $jSIPP.createContext(undefined);
function $aeac8d48234fe666$export$e1fd9274eb96ee18() {
    const privateApiRef = $jSIPP.useContext($aeac8d48234fe666$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        'MUI: Could not find the data grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the data grid.'
    ].join('\n'));
    return privateApiRef;
}



var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
const $9feaeb5783bf167a$var$UNINITIALIZED = {};
function $9feaeb5783bf167a$export$fd27aa36f007ec3d(init, initArg) {
    const ref = $jSIPP.useRef($9feaeb5783bf167a$var$UNINITIALIZED);
    if (ref.current === $9feaeb5783bf167a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $jSIPP = parcelRequire("jSIPP");
const $bb236c258f259a9e$var$EMPTY = [];
function $bb236c258f259a9e$export$820558710db2d9c6(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $jSIPP.useEffect(fn, $bb236c258f259a9e$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


const $a7033f4d29fa444a$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const $a7033f4d29fa444a$export$eeb37579de885205 = (method, message)=>{
    var args;
    return method;
};


const $de90e10b480940f8$var$is = Object.is;
function $de90e10b480940f8$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$de90e10b480940f8$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    /* eslint-enable no-restricted-syntax */ /* eslint-enable guard-for-in */ return aLength === bLength;
}


const $190d0dc02079d828$var$stateNotInitializedWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: `useGridSelector` has been called before the initialization of the state.',
    'This hook can only be used inside the context of the grid.'
]);
function $190d0dc02079d828$var$isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
function $190d0dc02079d828$var$applySelector(apiRef, selector) {
    if ($190d0dc02079d828$var$isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
const $190d0dc02079d828$var$defaultCompare = Object.is;
const $190d0dc02079d828$export$8da4c691e5695191 = (0, $de90e10b480940f8$export$84d14f151b531ccb);
const $190d0dc02079d828$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null
    });
const $190d0dc02079d828$export$f96fd476863f2e4a = (apiRef, selector, equals = $190d0dc02079d828$var$defaultCompare)=>{
    const refs = (0, $9feaeb5783bf167a$export$fd27aa36f007ec3d)($190d0dc02079d828$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $jSIPP.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $190d0dc02079d828$var$applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    (0, $bb236c258f259a9e$export$820558710db2d9c6)(()=>{
        return apiRef.current.store.subscribe(()=>{
            const newState = $190d0dc02079d828$var$applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
    });
    return state;
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");


var $geF11 = parcelRequire("geF11");
var $rARwS = parcelRequire("rARwS");
function $4d97f950d65e57e8$export$a2aa36217b862c23(slot) {
    return (0, $geF11.default)('MuiDataGrid', slot);
}
const $4d97f950d65e57e8$export$2100d54e36406477 = (0, $rARwS.default)('MuiDataGrid', [
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'autoHeight',
    'autosizing',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--withRenderer',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--selectionMode',
    'cell',
    'cellContent',
    'cellCheckbox',
    'cellSkeleton',
    'checkboxInput',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderDropZone',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnGroupHeader',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeader--showColumnBorder',
    'columnHeaders',
    'columnHeadersInner',
    'columnHeadersInner--scrollable',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsPanel',
    'columnsPanelRow',
    'detailPanel',
    'detailPanels',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'row',
    'row--editable',
    'row--editing',
    'row--lastVisible',
    'row--dragging',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea',
    'selectedRowCount',
    'sortIcon',
    'toolbarContainer',
    'toolbarFilterList',
    'virtualScroller',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'pinnedColumns',
    'pinnedColumns--left',
    'pinnedColumns--right',
    'pinnedColumnHeaders',
    'pinnedColumnHeaders--left',
    'pinnedColumnHeaders--right',
    'withBorderColor',
    'cell--withRightBorder',
    'columnHeader--withRightBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pinnedRowsRenderZone'
]);



var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
const $7c0877bef82025e5$export$e00c5fe7e13db7ba = /*#__PURE__*/ $jSIPP.createContext(undefined);


const $f257fd85b572d216$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $jSIPP.useContext((0, $7c0877bef82025e5$export$e00c5fe7e13db7ba));
    if (!contextValue) throw new Error('MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};




const $cf9e768be0a96dbe$var$cacheContainer = {
    cache: new WeakMap()
};
const $cf9e768be0a96dbe$var$missingInstanceIdWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.',
    'To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g. `mySelector(state, apiRef.current.instanceId)`.'
]);
function $cf9e768be0a96dbe$var$checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
const $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID = {
    id: 'default'
};
const $cf9e768be0a96dbe$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...rest)=>{
    if (rest.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $cf9e768be0a96dbe$export$2a3ca4704a61d1f4 = (...args)=>{
    const selector = (...selectorArgs)=>{
        var _cache$get, _cache$get3;
        const [stateOrApiRef, instanceId] = selectorArgs;
        const isAPIRef = $cf9e768be0a96dbe$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId != null ? instanceId : $cf9e768be0a96dbe$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const { cache: cache } = $cf9e768be0a96dbe$var$cacheContainer;
        if (cache.get(cacheKey) && (_cache$get = cache.get(cacheKey)) != null && _cache$get.get(args)) {
            var _cache$get2;
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return (_cache$get2 = cache.get(cacheKey)) == null ? void 0 : _cache$get2.get(args)(state, cacheKey);
        }
        const newSelector = (0, $8dc4dc351c50db34$export$595d22ed68ca2841)(...args);
        if (!cache.get(cacheKey)) cache.set(cacheKey, new Map());
        (_cache$get3 = cache.get(cacheKey)) == null || _cache$get3.set(args, newSelector);
        return newSelector(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $cf9e768be0a96dbe$export$73ae0dfa3bbc446f = ()=>{
    $cf9e768be0a96dbe$var$cacheContainer.cache = new WeakMap();
};


const $90c6bb88bfe45f18$export$858d15abb6cddc08 = (state)=>state.columns;
const $90c6bb88bfe45f18$export$d8a3dfbb129c80db = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($90c6bb88bfe45f18$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $90c6bb88bfe45f18$export$8a3a9a6db584d7fd = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($90c6bb88bfe45f18$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $90c6bb88bfe45f18$export$da85f06e3c19f1fd = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$d8a3dfbb129c80db, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $90c6bb88bfe45f18$export$eb0d33595fe29bb4 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($90c6bb88bfe45f18$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $90c6bb88bfe45f18$export$16a65a9447d3dda9 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$da85f06e3c19f1fd, $90c6bb88bfe45f18$export$eb0d33595fe29bb4, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $90c6bb88bfe45f18$export$c9491722e1d6e8d3 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $90c6bb88bfe45f18$export$fce7d810e48021e3 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $90c6bb88bfe45f18$export$ab20f9d33edc7794 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($90c6bb88bfe45f18$export$16a65a9447d3dda9, $90c6bb88bfe45f18$export$fce7d810e48021e3, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});
const $90c6bb88bfe45f18$export$2cad659ba95fed71 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $90c6bb88bfe45f18$export$e84218276cc24419 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($90c6bb88bfe45f18$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));





const $24c0f923081db0c8$export$6f71a66e6e099ab2 = (state)=>state.columnGrouping;
const $24c0f923081db0c8$export$78f140ad2e1dbc2b = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($24c0f923081db0c8$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$unwra;
    return (_columnGrouping$unwra = columnGrouping == null ? void 0 : columnGrouping.unwrappedGroupingModel) != null ? _columnGrouping$unwra : {};
});
const $24c0f923081db0c8$export$bdc2ff4432d8b29b = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($24c0f923081db0c8$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$looku;
    return (_columnGrouping$looku = columnGrouping == null ? void 0 : columnGrouping.lookup) != null ? _columnGrouping$looku : {};
});
const $24c0f923081db0c8$export$8f859ed1f2777746 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($24c0f923081db0c8$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$heade;
    return (_columnGrouping$heade = columnGrouping == null ? void 0 : columnGrouping.headerStructure) != null ? _columnGrouping$heade : [];
});
const $24c0f923081db0c8$export$4cf0369c079b29be = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($24c0f923081db0c8$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$maxDe;
    return (_columnGrouping$maxDe = columnGrouping == null ? void 0 : columnGrouping.maxDepth) != null ? _columnGrouping$maxDe : 0;
});



const $d7530f53594a6a47$var$gridRowsStateSelector = (state)=>state.rows;
const $d7530f53594a6a47$export$1641ef9d08e265ca = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $d7530f53594a6a47$export$3c966d405f950b08 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.loading);
const $d7530f53594a6a47$export$800ab0a68a9efc4f = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const $d7530f53594a6a47$export$37767f9110c99048 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const $d7530f53594a6a47$export$451ff98f7dd9f13f = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const $d7530f53594a6a47$export$de9a43d646a9821d = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.tree);
const $d7530f53594a6a47$export$c263d91fb644e7a0 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $d7530f53594a6a47$export$eb24598525413286 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $d7530f53594a6a47$export$4cdbe576751dd8e2 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] + 1;
});
const $d7530f53594a6a47$export$c7dcaab5e573753 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $d7530f53594a6a47$export$e8db8ec5e43400fa = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$var$gridRowsStateSelector, (rows)=>rows == null ? void 0 : rows.additionalRowGroups);
const $d7530f53594a6a47$export$ffe7071c481e32b0 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($d7530f53594a6a47$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    var _rawPinnedRows$bottom, _rawPinnedRows$top;
    const rawPinnedRows = additionalRowGroups == null ? void 0 : additionalRowGroups.pinnedRows;
    return {
        bottom: rawPinnedRows == null || (_rawPinnedRows$bottom = rawPinnedRows.bottom) == null ? void 0 : _rawPinnedRows$bottom.map((rowEntry)=>{
            var _rowEntry$model;
            return {
                id: rowEntry.id,
                model: (_rowEntry$model = rowEntry.model) != null ? _rowEntry$model : {}
            };
        }),
        top: rawPinnedRows == null || (_rawPinnedRows$top = rawPinnedRows.top) == null ? void 0 : _rawPinnedRows$top.map((rowEntry)=>{
            var _rowEntry$model2;
            return {
                id: rowEntry.id,
                model: (_rowEntry$model2 = rowEntry.model) != null ? _rowEntry$model2 : {}
            };
        })
    };
});
const $d7530f53594a6a47$export$8e3fb3525d7db988 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($d7530f53594a6a47$export$ffe7071c481e32b0, (pinnedRows)=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    return ((pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.length) || 0) + ((pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.length) || 0);
});



const $e48fa34a791e1f09$export$89716d1110d32214 = ()=>{
    var _rootProps$experiment;
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9));
    const totalRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$1641ef9d08e265ca));
    const headerGroupingMaxDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $24c0f923081db0c8$export$4cf0369c079b29be));
    const pinnedRowsCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$8e3fb3525d7db988));
    let role = 'grid';
    if ((_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 && rootProps.treeData) role = 'treegrid';
    return {
        role: role,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
        'aria-multiselectable': !rootProps.disableMultipleRowSelection
    };
};



var $4uaIU = parcelRequire("4uaIU");
const $8c8f1ff083e69aea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'main'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $8c8f1ff083e69aea$var$GridMainContainerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>styles.main
})(()=>({
        position: 'relative',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }));
const $8c8f1ff083e69aea$export$74039dccf215bc2a = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    var _rootProps$experiment;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $8c8f1ff083e69aea$var$useUtilityClasses(rootProps);
    const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
     ? (0, $e48fa34a791e1f09$export$89716d1110d32214) : null;
    const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($8c8f1ff083e69aea$var$GridMainContainerRoot, (0, $erOpW.default)({
        ref: ref,
        className: classes.root,
        ownerState: rootProps
    }, ariaAttributes, {
        children: props.children
    }));
});







/**
 * @category Sorting
 * @ignore - do not document.
 */ const $fd4beb3eff079ebd$var$gridSortingStateSelector = (state)=>state.sorting;
const $fd4beb3eff079ebd$export$e4979ad0a2db8752 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($fd4beb3eff079ebd$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $fd4beb3eff079ebd$export$8919e81647813e61 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($fd4beb3eff079ebd$export$e4979ad0a2db8752, (0, $d7530f53594a6a47$export$37767f9110c99048), // TODO rows v6: Is this the best approach ?
(sortedIds, idRowsLookup)=>sortedIds.map((id)=>{
        var _idRowsLookup$id;
        return {
            id: id,
            model: (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
        };
    }));
const $fd4beb3eff079ebd$export$55dcc66b73d9a0f9 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($fd4beb3eff079ebd$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $fd4beb3eff079ebd$export$4dfdcc434a6c5081 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($fd4beb3eff079ebd$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});




/**
 * @category Filtering
 */ const $dcdbd4f8634a4b8d$var$gridFilterStateSelector = (state)=>state.filter;
const $dcdbd4f8634a4b8d$export$280aedb9454597a5 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $dcdbd4f8634a4b8d$export$6f9fe133e2c56816 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $dcdbd4f8634a4b8d$export$7dcadad908a379a4 = (state)=>state.visibleRowsLookup;
const $dcdbd4f8634a4b8d$export$6d031b6e8cbaf41c = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $dcdbd4f8634a4b8d$export$28e99d5260ff82e7 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $dcdbd4f8634a4b8d$export$2f31562143a3e5d4 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$7dcadad908a379a4, (0, $fd4beb3eff079ebd$export$8919e81647813e61), (visibleRowsLookup, sortedRows)=>sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false));
const $dcdbd4f8634a4b8d$export$7a99837e2fd93e42 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $dcdbd4f8634a4b8d$export$cd53824a2b232e36 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$6d031b6e8cbaf41c, (0, $fd4beb3eff079ebd$export$8919e81647813e61), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $dcdbd4f8634a4b8d$export$4e2a9d76902d271c = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $dcdbd4f8634a4b8d$export$b8a7110d1a4c4623 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$2f31562143a3e5d4, (0, $d7530f53594a6a47$export$de9a43d646a9821d), (0, $d7530f53594a6a47$export$4cdbe576751dd8e2), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>{
        var _rowTree$row$id;
        return ((_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth) === 0;
    });
});
const $dcdbd4f8634a4b8d$export$96919017bbfaec0d = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $dcdbd4f8634a4b8d$export$f88efd30675963d1 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($dcdbd4f8634a4b8d$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $dcdbd4f8634a4b8d$export$c7447bfbd4ecafcc = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$280aedb9454597a5, (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd), (filterModel, columnLookup)=>{
    var _filterModel$items;
    return (_filterModel$items = filterModel.items) == null ? void 0 : _filterModel$items.filter((item)=>{
        var _column$filterOperato, _item$value;
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!(column != null && column.filterOperators) || (column == null || (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.length) === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && ((_item$value = item.value) == null ? void 0 : _item$value.toString()) !== '';
    });
});
const $dcdbd4f8634a4b8d$export$6b2da1ecc84b757a = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($dcdbd4f8634a4b8d$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});




const $196c4c77eabe7b5f$export$ce21bef7bd3a9c4e = (state)=>state.focus;
const $196c4c77eabe7b5f$export$74af8aada6269d3 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $196c4c77eabe7b5f$export$cefd405855792f4a = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $196c4c77eabe7b5f$export$ddbc5e79a3870366 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $196c4c77eabe7b5f$export$7442f29af2d5c4da = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $196c4c77eabe7b5f$export$3ab3abde27f70192 = (state)=>state.tabIndex;
const $196c4c77eabe7b5f$export$2c47652a1f657d56 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$3ab3abde27f70192, (state)=>state.cell);
const $196c4c77eabe7b5f$export$29da670438604dbd = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $196c4c77eabe7b5f$export$6e4ac1bbcaf7689e = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $196c4c77eabe7b5f$export$2ed1808619944d47 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($196c4c77eabe7b5f$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);



const $2591c618679f9496$export$806a039ece4425b4 = (state)=>state.density;
const $2591c618679f9496$export$8483bbb6eba91abb = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($2591c618679f9496$export$806a039ece4425b4, (density)=>density.value);
const $2591c618679f9496$export$c646201fb1d3e7a6 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($2591c618679f9496$export$806a039ece4425b4, (density)=>density.factor);



const $ef0056c5ae7ef8bc$export$5479c2fb8e9fd070 = (state)=>state.columnMenu;



var $4uaIU = parcelRequire("4uaIU");
function $aa2a07ba1ec68c30$export$d79f740c0338b156(props) {
    const { VirtualScrollerComponent: VirtualScrollerComponent, ColumnHeadersProps: ColumnHeadersProps, children: children } = props;
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const rootRef = $jSIPP.useRef(null);
    const visibleColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9));
    const filterColumnLookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$6b2da1ecc84b757a));
    const sortColumnLookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$4dfdcc434a6c5081));
    const columnPositions = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$fce7d810e48021e3));
    const columnHeaderTabIndexState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$29da670438604dbd));
    const cellTabIndexState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$2c47652a1f657d56));
    const columnGroupHeaderTabIndexState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$2ed1808619944d47));
    const columnHeaderFocus = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$cefd405855792f4a));
    const columnGroupHeaderFocus = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$7442f29af2d5c4da));
    const densityFactor = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$c646201fb1d3e7a6));
    const headerGroupingMaxDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $24c0f923081db0c8$export$4cf0369c079b29be));
    const columnMenuState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $ef0056c5ae7ef8bc$export$5479c2fb8e9fd070));
    const columnVisibility = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4));
    const columnGroupsHeaderStructure = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $24c0f923081db0c8$export$8f859ed1f2777746));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && cellTabIndexState === null);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
        const elementToObserve = rootRef.current;
        if (typeof ResizeObserver === 'undefined') return ()=>{};
        let animationFrame;
        const observer = new ResizeObserver(()=>{
            // See https://github.com/mui/mui-x/issues/8733
            animationFrame = requestAnimationFrame(()=>{
                apiRef.current.computeSizeAndPublishResizeEvent();
            });
        });
        if (elementToObserve) observer.observe(elementToObserve);
        return ()=>{
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
            if (elementToObserve) observer.unobserve(elementToObserve);
        };
    }, [
        apiRef
    ]);
    const columnHeadersRef = $jSIPP.useRef(null);
    const columnsContainerRef = $jSIPP.useRef(null);
    const virtualScrollerRef = $jSIPP.useRef(null);
    apiRef.current.register('private', {
        columnHeadersContainerElementRef: columnsContainerRef,
        columnHeadersElementRef: columnHeadersRef,
        virtualScrollerRef: virtualScrollerRef,
        mainElementRef: rootRef
    });
    const hasDimensions = !!apiRef.current.getRootDimensions();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $8c8f1ff083e69aea$export$74039dccf215bc2a), {
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnHeaders, (0, $erOpW.default)({
                ref: columnsContainerRef,
                innerRef: columnHeadersRef,
                visibleColumns: visibleColumns,
                filterColumnLookup: filterColumnLookup,
                sortColumnLookup: sortColumnLookup,
                columnPositions: columnPositions,
                columnHeaderTabIndexState: columnHeaderTabIndexState,
                columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
                columnHeaderFocus: columnHeaderFocus,
                columnGroupHeaderFocus: columnGroupHeaderFocus,
                densityFactor: densityFactor,
                headerGroupingMaxDepth: headerGroupingMaxDepth,
                columnMenuState: columnMenuState,
                columnVisibility: columnVisibility,
                columnGroupsHeaderStructure: columnGroupsHeaderStructure,
                hasOtherElementInTabSequence: hasOtherElementInTabSequence
            }, ColumnHeadersProps)),
            hasDimensions && /*#__PURE__*/ (0, $4uaIU.jsx)(VirtualScrollerComponent, {
                ref: virtualScrollerRef
            }),
            children
        ]
    });
}


var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
const $e7c73d6134452b49$export$70c437c2dab15e52 = /*#__PURE__*/ $jSIPP.createContext(undefined);





var $4uaIU = parcelRequire("4uaIU");
function $60d2b150beada1be$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, props: props, children: children }) {
    const apiRef = $jSIPP.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c0877bef82025e5$export$e00c5fe7e13db7ba).Provider, {
        value: props,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $aeac8d48234fe666$export$37099e7a34cbf988).Provider, {
            value: privateApiRef,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e7c73d6134452b49$export$70c437c2dab15e52).Provider, {
                value: apiRef,
                children: children
            })
        })
    });
}


var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
function $96f637e3dcb55f7b$export$6d80c98441abb3ab() {
    var _rootProps$slotProps;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.footer, (0, $erOpW.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footer));
}


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
function $df0d976711ba23f2$export$74ac40502a3200d3() {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.preferencesPanel, (0, $erOpW.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.preferencesPanel)),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.toolbar, (0, $erOpW.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.toolbar))
        ]
    });
}


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");

var $erOpW = parcelRequire("erOpW");

var $7ONYC = parcelRequire("7ONYC");

var $5dz9b = parcelRequire("5dz9b");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d8a747b22caa35d8$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $5dz9b.default)(value, min, max);
}
function $d8a747b22caa35d8$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d8a747b22caa35d8$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $d8a747b22caa35d8$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d8a747b22caa35d8$export$677b39864803984e($d8a747b22caa35d8$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $7ONYC.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $7ONYC.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $d8a747b22caa35d8$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $d8a747b22caa35d8$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $d8a747b22caa35d8$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $d8a747b22caa35d8$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $d8a747b22caa35d8$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $d8a747b22caa35d8$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $d8a747b22caa35d8$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$d8a747b22caa35d8$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $d8a747b22caa35d8$export$29fb7152bd3f781a(color) {
    color = $d8a747b22caa35d8$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d8a747b22caa35d8$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $d8a747b22caa35d8$export$c852d90bf7403b62(color) {
    color = $d8a747b22caa35d8$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d8a747b22caa35d8$export$677b39864803984e($d8a747b22caa35d8$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $d8a747b22caa35d8$export$d061e26956a60b0a(foreground, background) {
    const lumA = $d8a747b22caa35d8$export$c852d90bf7403b62(foreground);
    const lumB = $d8a747b22caa35d8$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $d8a747b22caa35d8$export$58f0f39f63f3cf42(color, value) {
    color = $d8a747b22caa35d8$export$677b39864803984e(color);
    value = $d8a747b22caa35d8$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d8a747b22caa35d8$export$211a73f2b8c10ce4(color);
}
function $d8a747b22caa35d8$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $d8a747b22caa35d8$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $d8a747b22caa35d8$export$4b073707ff63303(color, coefficient) {
    color = $d8a747b22caa35d8$export$677b39864803984e(color);
    coefficient = $d8a747b22caa35d8$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d8a747b22caa35d8$export$211a73f2b8c10ce4(color);
}
function $d8a747b22caa35d8$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $d8a747b22caa35d8$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d8a747b22caa35d8$export$c0816ed86df316af(color, coefficient) {
    color = $d8a747b22caa35d8$export$677b39864803984e(color);
    coefficient = $d8a747b22caa35d8$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d8a747b22caa35d8$export$211a73f2b8c10ce4(color);
}
function $d8a747b22caa35d8$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $d8a747b22caa35d8$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d8a747b22caa35d8$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $d8a747b22caa35d8$export$c852d90bf7403b62(color) > 0.5 ? $d8a747b22caa35d8$export$4b073707ff63303(color, coefficient) : $d8a747b22caa35d8$export$c0816ed86df316af(color, coefficient);
}
function $d8a747b22caa35d8$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $d8a747b22caa35d8$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d8a747b22caa35d8$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d8a747b22caa35d8$export$677b39864803984e(background);
    const overlayColor = $d8a747b22caa35d8$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d8a747b22caa35d8$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $28RyA = parcelRequire("28RyA");

function $f6f9555a62a00a3b$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $d8a747b22caa35d8$export$c0816ed86df316af)((0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.88);
    return (0, $d8a747b22caa35d8$export$4b073707ff63303)((0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.68);
}
const $f6f9555a62a00a3b$var$columnHeadersStyles = {
    [`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnSeparator}, .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizing']}`]: {
        visibility: 'visible',
        width: 'auto'
    }
};
const $f6f9555a62a00a3b$var$columnHeaderStyles = {
    [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).iconButtonContainer}`]: {
        visibility: 'visible',
        width: 'auto'
    },
    [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}`]: {
        width: 'auto',
        visibility: 'visible'
    }
};
const $f6f9555a62a00a3b$export$42458c7ae3a97297 = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).aggregationColumnHeader}`]: styles.aggregationColumnHeader
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['aggregationColumnHeader--alignLeft']}`]: styles['aggregationColumnHeader--alignLeft']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['aggregationColumnHeader--alignCenter']}`]: styles['aggregationColumnHeader--alignCenter']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['aggregationColumnHeader--alignRight']}`]: styles['aggregationColumnHeader--alignRight']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['root--disableUserSelection']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).autosizing}`]: styles.autosizing
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textRight']}`]: styles['cell--textRight']
            },
            // TODO v6: Remove
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--withRenderer']}`]: styles['cell--withRenderer']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: styles.cell
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cellContent}`]: styles.cellContent
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).row}`]: styles.row
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            styles.root
        ]
})(({ theme: theme })=>{
    const borderColor = $f6f9555a62a00a3b$var$getBorderColor(theme);
    const radius = theme.shape.borderRadius;
    const gridStyle = (0, $erOpW.default)({
        '--unstable_DataGrid-radius': typeof radius === 'number' ? `${radius}px` : radius,
        '--unstable_DataGrid-headWeight': theme.typography.fontWeightMedium,
        '--unstable_DataGrid-overlayBackground': theme.vars ? `rgba(${theme.vars.palette.background.defaultChannel} / ${theme.vars.palette.action.disabledOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.background.default, theme.palette.action.disabledOpacity),
        '--DataGrid-cellOffsetMultiplier': 2,
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: borderColor,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body2, {
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).autoHeight}`]: {
            height: 'auto',
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--lastVisible']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
                borderBottomColor: 'transparent'
            }
        },
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).autosizing}`]: {
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell} > *`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap'
            }
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['virtualScrollerContent--overflowed']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--lastVisible']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            borderBottomColor: 'transparent'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            lineHeight: null,
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:focus-within, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}:focus-within`]: {
            outline: `solid ${theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.5)` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.5)} 1px`,
            outlineWidth: 1,
            outlineOffset: -1
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:focus, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}:focus`]: {
            outline: `solid ${theme.palette.primary.main} 1px`
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderCheckbox}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sorted']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).iconButtonContainer}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--filtered']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:not(.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sorted']}) .${(0, $4d97f950d65e57e8$export$2100d54e36406477).sortIcon}`]: {
            opacity: 0,
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            })
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            // to anchor the aggregation label
            position: 'relative'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--filledGroup']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--filledGroup']}.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--showColumnBorder']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            borderBottom: `none`
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--filledGroup']}.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--showColumnBorder']}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).headerFilterRow}`]: {
            borderTop: `1px solid ${borderColor}`
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).sortIcon}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477).filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDraggableContainer}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -6
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -10
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--moving']}`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnSeparator}`]: {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: borderColor
        },
        '@media (hover: hover)': {
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaders}:hover`]: $f6f9555a62a00a3b$var$columnHeadersStyles,
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:hover`]: $f6f9555a62a00a3b$var$columnHeaderStyles,
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:not(.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--sorted']}):hover .${(0, $4d97f950d65e57e8$export$2100d54e36406477).sortIcon}`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaders}`]: $f6f9555a62a00a3b$var$columnHeadersStyles,
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}`]: $f6f9555a62a00a3b$var$columnHeaderStyles
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: {
            left: -12
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--sideRight']}`]: {
            right: -12
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            '&:hover': {
                color: (theme.vars || theme).palette.text.primary,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    color: borderColor
                }
            },
            [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizing']}`]: {
                color: (theme.vars || theme).palette.text.primary
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).iconSeparator}`]: {
            color: 'inherit'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -10,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).row}`]: {
            display: 'flex',
            width: 'fit-content',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '&:hover, &.Mui-hovered': {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(
                ${theme.vars.palette.action.selectedOpacity} + 
                ${theme.vars.palette.action.hoverOpacity}
              ))` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid',
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity + theme.palette.action.hoverOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['root--disableUserSelection']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            userSelect: 'none'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).row}:not(.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--dynamicHeight']}) > .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cellContent}`]: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: theme.shadows[2],
            backgroundColor: (theme.vars || theme).palette.background.paper,
            '&:focus-within': {
                outline: `solid ${(theme.vars || theme).palette.primary.main} 1px`,
                outlineOffset: '-1px'
            }
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--editing']}`]: {
            boxShadow: theme.shadows[2]
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--editing']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`]: {
            boxShadow: theme.shadows[0],
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).booleanCell}[data-value="true"]`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).booleanCell}[data-value="false"]`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: theme.spacing(1)
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['rowReorderCell--draggable']}`]: {
            cursor: 'move',
            opacity: 1
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCellContainer}`]: {
            padding: 0,
            alignItems: 'stretch'
        },
        [`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).withBorderColor}`]: {
            borderColor: borderColor
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--withRightBorder']}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textLeft']}`]: {
            justifyContent: 'flex-start'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textRight']}`]: {
            justifyContent: 'flex-end'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--textCenter']}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeader--dragging']}, & .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--dragging']}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477)['row--dragging']}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
                display: 'flex'
            }
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        }
    });
    return gridStyle;
});









var $4uaIU = parcelRequire("4uaIU");
const $65e12aad905f864d$var$_excluded = [
    "children",
    "className"
];
const $65e12aad905f864d$var$useUtilityClasses = (ownerState)=>{
    const { autoHeight: autoHeight, density: density, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $61i5U.default)(density)}`,
            'withBorderColor'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $65e12aad905f864d$export$8cdbcd3b320d39bf = /*#__PURE__*/ $jSIPP.forwardRef(function GridRoot(props, ref) {
    var _rootProps$experiment;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const { children: children, className: className } = props, other = (0, $cMu4A.default)(props, $65e12aad905f864d$var$_excluded);
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const densityValue = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$8483bbb6eba91abb));
    const rootContainerRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(rootContainerRef, ref);
    const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
     ? null : (0, $e48fa34a791e1f09$export$89716d1110d32214);
    const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        density: densityValue
    });
    const classes = $65e12aad905f864d$var$useUtilityClasses(ownerState);
    apiRef.current.register('public', {
        rootElementRef: rootContainerRef
    });
    // Our implementation of <NoSsr />
    const [mountedState, setMountedState] = $jSIPP.useState(false);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        setMountedState(true);
    }, []);
    if (!mountedState) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f6f9555a62a00a3b$export$42458c7ae3a97297), (0, $erOpW.default)({
        ref: handleRef,
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: ownerState
    }, ariaAttributes, other, {
        children: children
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");
function $b458945063b88d36$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 




var $jSIPP = parcelRequire("jSIPP");
function $841c59db2853e965$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}



function $a4e890cf7e68aae0$export$7e4aa119212bc614(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $a4e890cf7e68aae0$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $a4e890cf7e68aae0$export$a6cdc56e425d0d0a(value) {
    return typeof value === 'object' && value !== null;
}
function $a4e890cf7e68aae0$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $a4e890cf7e68aae0$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $a4e890cf7e68aae0$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$a4e890cf7e68aae0$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$a4e890cf7e68aae0$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$a4e890cf7e68aae0$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $a4e890cf7e68aae0$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $a4e890cf7e68aae0$export$ffd8c9a5b80f1e57(seed, min, max) {
    const random = $a4e890cf7e68aae0$var$mulberry32(seed);
    return ()=>min + (max - min) * random();
}
function $a4e890cf7e68aae0$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}


// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $0c6015ed51f2e924$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $b458945063b88d36$export$e132ced8f644a612)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $0c6015ed51f2e924$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $0c6015ed51f2e924$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $0c6015ed51f2e924$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $0c6015ed51f2e924$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>{
        var _unwrappedGroupingMod;
        return (_unwrappedGroupingMod = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod : [];
    };
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>(0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (pinnedFields != null && pinnedFields.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (pinnedFields != null && pinnedFields.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            var _getParents$depth;
            const groupId = (_getParents$depth = getParents(newField)[depth]) != null ? _getParents$depth : null;
            if (structure.length === 0) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) // It's a new group
            return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            // It extends the previous group
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId: groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};



var $jSIPP = parcelRequire("jSIPP");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $8e36019bcbb8e38c$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $8e36019bcbb8e38c$export$c16cf791cc6bf0c7 {
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
    constructor(timeout = $8e36019bcbb8e38c$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $8e36019bcbb8e38c$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
}


class $c393ce3baf590aff$export$86b678dc9d8f7603 {
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
}


/**
 * Signal to the underlying logic what version of the public component API
 * of the data grid is exposed.
 */ var $51ad73708acc0b23$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    return GridSignature;
}($51ad73708acc0b23$export$544be0bdf85b5af1 || {});
// We use class to make it easier to detect in heap snapshots by name
class $51ad73708acc0b23$var$ObjectToBeRetainedByReact {
}
function $51ad73708acc0b23$export$4c5a9251aa47d2f8(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $c393ce3baf590aff$export$86b678dc9d8f7603)() : new (0, $8e36019bcbb8e38c$export$c16cf791cc6bf0c7)();
        const [objectRetainedByReact] = $jSIPP.useState(new $51ad73708acc0b23$var$ObjectToBeRetainedByReact());
        const subscription = $jSIPP.useRef(null);
        const handlerRef = $jSIPP.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = $jSIPP.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) {
                    var _handlerRef$current;
                    (_handlerRef$current = handlerRef.current) == null || _handlerRef$current.call(handlerRef, params, event, details);
                }
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                var _subscription$current;
                (_subscription$current = subscription.current) == null || _subscription$current.call(subscription);
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $jSIPP.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) {
                        var _handlerRef$current2;
                        (_handlerRef$current2 = handlerRef.current) == null || _handlerRef$current2.call(handlerRef, params, event, details);
                    }
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                var _subscription$current2;
                (_subscription$current2 = subscription.current) == null || _subscription$current2.call(subscription);
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const $51ad73708acc0b23$var$registryContainer = {
    registry: null
};
const $51ad73708acc0b23$export$c5af18cc30c6146f = ()=>{
    var _registryContainer$re;
    (_registryContainer$re = $51ad73708acc0b23$var$registryContainer.registry) == null || _registryContainer$re.reset();
    $51ad73708acc0b23$var$registryContainer.registry = null;
};
const $51ad73708acc0b23$export$223e28bfc0254c87 = $51ad73708acc0b23$export$4c5a9251aa47d2f8($51ad73708acc0b23$var$registryContainer);
const $51ad73708acc0b23$var$optionsSubscriberOptions = {
    isFirst: true
};
function $51ad73708acc0b23$export$d55ddab8b28954db(apiRef, eventName, handler) {
    // Validate that only one per event name?
    $51ad73708acc0b23$export$223e28bfc0254c87(apiRef, eventName, handler, $51ad73708acc0b23$var$optionsSubscriberOptions);
}



const $fef4d614ea2b6749$var$_excluded = [
    "groupId",
    "children"
];
const $fef4d614ea2b6749$var$createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, $b458945063b88d36$export$e132ced8f644a612)(node)) return;
        const { groupId: groupId, children: children } = node, other = (0, $cMu4A.default)(node, $fef4d614ea2b6749$var$_excluded);
        if (!groupId) throw new Error('MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        if (!children) console.warn(`MUI: group groupId=${groupId} has no children.`);
        const groupParam = (0, $erOpW.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $fef4d614ea2b6749$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, $erOpW.default)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, $erOpW.default)({}, groupLookup);
};
const $fef4d614ea2b6749$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    var _props$experimentalFe, _props$columnGrouping, _props$columnGrouping2, _apiRef$current$state;
    if (!((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.columnGrouping)) return state;
    const columnFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
    const visibleColumnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef);
    const groupLookup = $fef4d614ea2b6749$var$createGroupLookup((_props$columnGrouping = props.columnGroupingModel) != null ? _props$columnGrouping : []);
    const unwrappedGroupingModel = (0, $0c6015ed51f2e924$export$ea425f87fd536c4d)((_props$columnGrouping2 = props.columnGroupingModel) != null ? _props$columnGrouping2 : []);
    const columnGroupsHeaderStructure = (0, $0c6015ed51f2e924$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, (_apiRef$current$state = apiRef.current.state.pinnedColumns) != null ? _apiRef$current$state : {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>{
        var _unwrappedGroupingMod, _unwrappedGroupingMod2;
        return (_unwrappedGroupingMod = (_unwrappedGroupingMod2 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod2.length) != null ? _unwrappedGroupingMod : 0;
    }));
    return (0, $erOpW.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $fef4d614ea2b6749$export$510984a37e2e33f3 = (apiRef, props)=>{
    var _props$experimentalFe3;
    /**
   * API METHODS
   */ const getColumnGroupPath = $jSIPP.useCallback((field)=>{
        var _unwrappedGroupingMod3;
        const unwrappedGroupingModel = (0, $24c0f923081db0c8$export$78f140ad2e1dbc2b)(apiRef);
        return (_unwrappedGroupingMod3 = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod3 : [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $jSIPP.useCallback(()=>{
        const columnGroupLookup = (0, $24c0f923081db0c8$export$bdc2ff4432d8b29b)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        unstable_getColumnGroupPath: getColumnGroupPath,
        unstable_getAllGroupDetails: getAllGroupDetails
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $jSIPP.useCallback(()=>{
        var _props$columnGrouping3;
        const unwrappedGroupingModel = (0, $0c6015ed51f2e924$export$ea425f87fd536c4d)((_props$columnGrouping3 = props.columnGroupingModel) != null ? _props$columnGrouping3 : []);
        apiRef.current.setState((state)=>{
            var _state$columns$ordere, _state$columns, _state$pinnedColumns;
            const orderedFields = (_state$columns$ordere = (_state$columns = state.columns) == null ? void 0 : _state$columns.orderedFields) != null ? _state$columns$ordere : [];
            // @ts-expect-error Move this logic to `Pro` package
            const pinnedColumns = (_state$pinnedColumns = state.pinnedColumns) != null ? _state$pinnedColumns : {};
            const columnGroupsHeaderStructure = (0, $0c6015ed51f2e924$export$c41225ff45feeb0e)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $erOpW.default)({}, state, {
                columnGrouping: (0, $erOpW.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $jSIPP.useCallback((columnGroupingModel)=>{
        var _props$experimentalFe2, _apiRef$current$getPi, _apiRef$current$getPi2, _apiRef$current;
        if (!((_props$experimentalFe2 = props.experimentalFeatures) != null && _props$experimentalFe2.columnGrouping)) return;
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = (_apiRef$current$getPi = (_apiRef$current$getPi2 = (_apiRef$current = apiRef.current).getPinnedColumns) == null ? void 0 : _apiRef$current$getPi2.call(_apiRef$current)) != null ? _apiRef$current$getPi : {};
        const columnFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        const visibleColumnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef);
        const groupLookup = $fef4d614ea2b6749$var$createGroupLookup(columnGroupingModel != null ? columnGroupingModel : []);
        const unwrappedGroupingModel = (0, $0c6015ed51f2e924$export$ea425f87fd536c4d)(columnGroupingModel != null ? columnGroupingModel : []);
        const columnGroupsHeaderStructure = (0, $0c6015ed51f2e924$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>{
            var _unwrappedGroupingMod4, _unwrappedGroupingMod5;
            return (_unwrappedGroupingMod4 = (_unwrappedGroupingMod5 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod5.length) != null ? _unwrappedGroupingMod4 : 0;
        }));
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef,
        (_props$experimentalFe3 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe3.columnGrouping
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $jSIPP.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
function $ec0fc4f020f08d83$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $jSIPP.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}




const $a2c680012da94ced$export$8574ffe06bf26347 = (state)=>(0, $erOpW.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $a2c680012da94ced$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridColumnMenu');
    /**
   * API METHODS
   */ const showColumnMenu = $jSIPP.useCallback((field)=>{
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (state.columnMenu.open && state.columnMenu.field === field) return state;
            logger.debug('Opening Column Menu');
            return (0, $erOpW.default)({}, state, {
                columnMenu: {
                    open: true,
                    field: field
                }
            });
        });
        if (shouldUpdate) {
            apiRef.current.hidePreferences();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $jSIPP.useCallback(()=>{
        const columnMenuState = (0, $ef0056c5ae7ef8bc$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (!state.columnMenu.open && state.columnMenu.field === undefined) return state;
            logger.debug('Hiding Column Menu');
            return (0, $erOpW.default)({}, state, {
                columnMenu: (0, $erOpW.default)({}, state.columnMenu, {
                    open: false,
                    field: undefined
                })
            });
        });
        if (shouldUpdate) apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $jSIPP.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $ef0056c5ae7ef8bc$export$5479c2fb8e9fd070)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnMenuApi, 'public');
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', hideColumnMenu);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");





var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");
const $35a9d8cff430e714$export$c5623aa1c38918b6 = (callback)=>{
    const isFirstRender = $jSIPP.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};


const $9babb3636382b74b$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $jSIPP.useRef();
    const id = $jSIPP.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $jSIPP.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};


var $jSIPP = parcelRequire("jSIPP");

const $e51f1635c25cd339$export$faa98381ad228894 = (apiRef, group, callback)=>{
    const cleanup = $jSIPP.useRef();
    const id = $jSIPP.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $jSIPP.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");




var $jSIPP = parcelRequire("jSIPP");

function $a9fd235d25e1c808$export$2d14edd3a7db3bbf() {
    const apiRef = $jSIPP.useContext((0, $e7c73d6134452b49$export$70c437c2dab15e52));
    if (apiRef === undefined) throw new Error([
        'MUI: Could not find the data grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the data grid.'
    ].join('\n'));
    return apiRef;
}



var $4uaIU = parcelRequire("4uaIU");
const $f75ede83a30c7d15$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const $f75ede83a30c7d15$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $f75ede83a30c7d15$var$GridEditInputCellRoot = (0, $28RyA.default)((0, $495d300f509482ea$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'EditInputCell',
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme: theme })=>(0, $erOpW.default)({}, theme.typography.body2, {
        padding: '1px 0',
        '& input': {
            padding: '0 16px',
            height: '100%'
        }
    }));
const $f75ede83a30c7d15$export$cd10ed3250a4d414 = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange } = props, other = (0, $cMu4A.default)(props, $f75ede83a30c7d15$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const inputRef = $jSIPP.useRef();
    const [valueState, setValueState] = $jSIPP.useState(value);
    const classes = $f75ede83a30c7d15$var$useUtilityClasses(rootProps);
    const handleChange = $jSIPP.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getCellParams(id, field));
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $jSIPP.useEffect(()=>{
        if ((meta == null ? void 0 : meta.changeReason) !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f75ede83a30c7d15$var$GridEditInputCellRoot, (0, $erOpW.default)({
        ref: ref,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState != null ? valueState : '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other));
});
const $f75ede83a30c7d15$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($f75ede83a30c7d15$export$cd10ed3250a4d414, (0, $erOpW.default)({}, params));



var $erOpW = parcelRequire("erOpW");

const $bf59eac7c63b5f3b$var$sortModelDisableMultiColumnsSortingWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const $bf59eac7c63b5f3b$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        $bf59eac7c63b5f3b$var$sortModelDisableMultiColumnsSortingWarning();
        return [
            model[0]
        ];
    }
    return model;
};
const $bf59eac7c63b5f3b$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $erOpW.default)({}, state, {
            sorting: (0, $erOpW.default)({}, state.sorting, {
                sortModel: $bf59eac7c63b5f3b$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $bf59eac7c63b5f3b$var$isDesc = (direction)=>direction === 'desc';
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $bf59eac7c63b5f3b$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column) return null;
    const comparator = $bf59eac7c63b5f3b$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: apiRef.current.getRowNode(id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $bf59eac7c63b5f3b$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $bf59eac7c63b5f3b$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$bf59eac7c63b5f3b$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$bf59eac7c63b5f3b$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $bf59eac7c63b5f3b$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $bf59eac7c63b5f3b$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $bf59eac7c63b5f3b$var$collator = new Intl.Collator();
const $bf59eac7c63b5f3b$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $bf59eac7c63b5f3b$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $bf59eac7c63b5f3b$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $bf59eac7c63b5f3b$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $bf59eac7c63b5f3b$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $bf59eac7c63b5f3b$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $bf59eac7c63b5f3b$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");




class $700e89e09f25b054$var$Timeout {
    static create() {
        return new $700e89e09f25b054$var$Timeout();
    }
    start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(fn, delay);
    }
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $700e89e09f25b054$export$d8e6abf214c9ec0f() {
    const timeout = (0, $9feaeb5783bf167a$export$fd27aa36f007ec3d)($700e89e09f25b054$var$Timeout.create).current;
    (0, $bb236c258f259a9e$export$820558710db2d9c6)(timeout.disposeEffect);
    return timeout;
}




var $4uaIU = parcelRequire("4uaIU");
const $7aec56bdc407c0b9$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps"
];
function $7aec56bdc407c0b9$export$99d1f108a3f21b3(props) {
    var _item$value, _rootProps$slotProps;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, clearButton: clearButton, InputProps: InputProps } = props, others = (0, $cMu4A.default)(props, $7aec56bdc407c0b9$var$_excluded);
    const filterTimeout = (0, $700e89e09f25b054$export$d8e6abf214c9ec0f)();
    const [filterValueState, setFilterValueState] = $jSIPP.useState((_item$value = item.value) != null ? _item$value : '');
    const [applying, setIsApplying] = $jSIPP.useState(false);
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $jSIPP.useCallback((event)=>{
        const { value: value } = event.target;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $erOpW.default)({}, item, {
                value: value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        id,
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $jSIPP.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value === undefined) {
            var _item$value2;
            setFilterValueState(String((_item$value2 = item.value) != null ? _item$value2 : ''));
        }
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTextField, (0, $erOpW.default)({
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputProps: (0, $erOpW.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $erOpW.default)({
                tabIndex: tabIndex
            }, InputProps == null ? void 0 : InputProps.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");





var $4uaIU = parcelRequire("4uaIU");
const $24683e8b1ac95606$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
function $24683e8b1ac95606$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant } = props, other = (0, $cMu4A.default)(props, $24683e8b1ac95606$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const [filterValueState, setFilterValueState] = $jSIPP.useState(item.value || []);
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    $jSIPP.useEffect(()=>{
        var _item$value;
        const itemValue = (_item$value = item.value) != null ? _item$value : [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $jSIPP.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $erOpW.default)({}, item, {
            value: [
                ...value
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), (0, $erOpW.default)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue: inputValue } = params;
            return inputValue == null || inputValue === '' ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseChip, (0, $erOpW.default)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTextField, (0, $erOpW.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $erOpW.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || 'text'
            }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}



var $erOpW = parcelRequire("erOpW");
const $4a98d49c28421b08$export$dc2a297931ebeaa6 = {
    current: null
};
function $4a98d49c28421b08$export$8e08ca6d174bacf9(fn) {
    fn.isInternal = true;
    return fn;
}
function $4a98d49c28421b08$export$4edd066b85c94822(fn) {
    return fn !== undefined && fn.isInternal === true;
}
function $4a98d49c28421b08$export$28f04b77854cffd1(fn) {
    return $4a98d49c28421b08$export$8e08ca6d174bacf9((filterItem, column)=>{
        const filterFn = fn(filterItem, column);
        if (!filterFn) return filterFn;
        return (cellParams)=>{
            return filterFn(cellParams.value, cellParams.row, column, $4a98d49c28421b08$export$dc2a297931ebeaa6.current);
        };
    });
}
function $4a98d49c28421b08$export$b905c4c483a689a6(ops) {
    return ops.map((op)=>{
        return (0, $erOpW.default)({}, op, {
            getApplyFilterFn: $4a98d49c28421b08$export$28f04b77854cffd1(op.getApplyFilterFnV7),
            getApplyFilterFnV7: $4a98d49c28421b08$export$8e08ca6d174bacf9(op.getApplyFilterFnV7)
        });
    });
}
function $4a98d49c28421b08$export$50dff96f00486a5c(fn) {
    return $4a98d49c28421b08$export$8e08ca6d174bacf9((filterItem, column, apiRef)=>{
        const filterFn = fn(filterItem, column, apiRef);
        if (!filterFn) return filterFn;
        return (cellParams)=>{
            return filterFn(cellParams.value, cellParams.row, column, apiRef);
        };
    });
}



var $erOpW = parcelRequire("erOpW");
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $e657c7843f6f7af4$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($e657c7843f6f7af4$export$90be184ccbab1c7a || {});




const $09826dcd962fda6e$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And
    }); /**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 



function $33b70822907dbb10$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}



// Fixes https://github.com/mui/mui-x/issues/10056
const $c80d7fdca78f3c04$var$globalScope = typeof window === 'undefined' ? globalThis : window;
const $c80d7fdca78f3c04$var$evalCode = $c80d7fdca78f3c04$var$globalScope[atob('ZXZhbA==')];
let $c80d7fdca78f3c04$var$hasEval;
try {
    $c80d7fdca78f3c04$var$hasEval = $c80d7fdca78f3c04$var$evalCode('true');
} catch (_) {
    $c80d7fdca78f3c04$var$hasEval = false;
}
const $c80d7fdca78f3c04$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $erOpW.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $c80d7fdca78f3c04$var$filterModelDisableMultiColumnsFilteringWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const $c80d7fdca78f3c04$var$filterModelMissingItemIdWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)('MUI: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
const $c80d7fdca78f3c04$var$filterModelMissingItemOperatorWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)('MUI: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
const $c80d7fdca78f3c04$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        $c80d7fdca78f3c04$var$filterModelDisableMultiColumnsFilteringWarning();
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemsWithoutIds) $c80d7fdca78f3c04$var$filterModelMissingItemIdWarning();
    if (hasItemWithoutOperator) $c80d7fdca78f3c04$var$filterModelMissingItemOperatorWarning();
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $erOpW.default)({}, model, {
        items: items.map((item)=>$c80d7fdca78f3c04$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $erOpW.default)({}, model, {
        items: items
    });
    return model;
};
const $c80d7fdca78f3c04$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $erOpW.default)({}, filteringState, {
            filterModel: $c80d7fdca78f3c04$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $c80d7fdca78f3c04$export$626da389515c02b3 = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const $c80d7fdca78f3c04$var$getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        var _filterItem$value;
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? (_filterItem$value = filterItem.value) == null ? void 0 : _filterItem$value.map((x)=>parser(x)) : parser(filterItem.value);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $c80d7fdca78f3c04$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $erOpW.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!(filterOperators != null && filterOperators.length)) throw new Error(`MUI: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const hasUserFunctionLegacy = !(0, $4a98d49c28421b08$export$4edd066b85c94822)(filterOperator.getApplyFilterFn);
    const hasUserFunctionV7 = !(0, $4a98d49c28421b08$export$4edd066b85c94822)(filterOperator.getApplyFilterFnV7);
    const publicApiRef = (0, $33b70822907dbb10$export$fbb0da9fc679f98a)(apiRef);
    if (filterOperator.getApplyFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) {
        const applyFilterOnRow = filterOperator.getApplyFilterFnV7(newFilterItem, column);
        if (typeof applyFilterOnRow !== 'function') return null;
        return {
            v7: true,
            item: newFilterItem,
            fn: (row)=>{
                let value = apiRef.current.getRowValue(row, column);
                if (ignoreDiacritics) value = $c80d7fdca78f3c04$export$626da389515c02b3(value);
                return applyFilterOnRow(value, row, column, publicApiRef);
            }
        };
    }
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        v7: false,
        item: newFilterItem,
        fn: (rowId)=>{
            const params = apiRef.current.getCellParams(rowId, newFilterItem.field);
            (0, $4a98d49c28421b08$export$dc2a297931ebeaa6).current = publicApiRef;
            if (ignoreDiacritics) params.value = $c80d7fdca78f3c04$export$626da389515c02b3(params.value);
            const result = applyFilterOnRow(params);
            (0, $4a98d49c28421b08$export$dc2a297931ebeaa6).current = null;
            return result;
        }
    };
};
let $c80d7fdca78f3c04$var$filterItemsApplierId = 1;
/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $c80d7fdca78f3c04$var$buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$c80d7fdca78f3c04$var$getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (!$c80d7fdca78f3c04$var$hasEval || disableEval) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.v7 ? applier.fn(row) : applier.fn(apiRef.current.getRowId(row));
        }
        return resultPerItemId;
    };
    // We generate a new function with `eval()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, e.g. `{ [dynamicKey]: value }`.
    const filterItemTemplate = `(function filterItem$$(getRowId, appliers, row, shouldApplyFilter) {
      ${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

      const result$$ = {
      ${appliers.map((applier, i)=>`${JSON.stringify(String(applier.item.id))}:
          !shouldApply${i} ?
            false :
            ${applier.v7 ? `appliers[${i}].fn(row)` : `appliers[${i}].fn(getRowId(row))`},
      `).join('\n')}};

      return result$$;
    })`;
    const filterItemCore = $c80d7fdca78f3c04$var$evalCode(filterItemTemplate.replaceAll('$$', String($c80d7fdca78f3c04$var$filterItemsApplierId)));
    const filterItem = (row, shouldApplyItem)=>{
        return filterItemCore(apiRef.current.getRowId, appliers, row, shouldApplyItem);
    };
    $c80d7fdca78f3c04$var$filterItemsApplierId += 1;
    return filterItem;
};
/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $c80d7fdca78f3c04$var$buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    var _filterModel$quickFil, _filterModel$quickFil2, _filterModel$quickFil3;
    const quickFilterValues = (_filterModel$quickFil = (_filterModel$quickFil2 = filterModel.quickFilterValues) == null ? void 0 : _filterModel$quickFil2.filter(Boolean)) != null ? _filterModel$quickFil : [];
    if (quickFilterValues.length === 0) return null;
    const quickFilterExcludeHiddenColumns = (_filterModel$quickFil3 = filterModel.quickFilterExcludeHiddenColumns) != null ? _filterModel$quickFil3 : false;
    const columnFields = quickFilterExcludeHiddenColumns ? (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef) : (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $33b70822907dbb10$export$fbb0da9fc679f98a)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column == null ? void 0 : column.getApplyQuickFilterFn;
        const getApplyQuickFilterFnV7 = column == null ? void 0 : column.getApplyQuickFilterFnV7;
        const hasUserFunctionLegacy = !(0, $4a98d49c28421b08$export$4edd066b85c94822)(getApplyQuickFilterFn);
        const hasUserFunctionV7 = !(0, $4a98d49c28421b08$export$4edd066b85c94822)(getApplyQuickFilterFnV7);
        if (getApplyQuickFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $c80d7fdca78f3c04$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    v7: true,
                    fn: getApplyQuickFilterFnV7(value, column, publicApiRef)
                };
            })
        });
        else if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $c80d7fdca78f3c04$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    v7: false,
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        const usedCellParams = {};
        /* eslint-disable no-restricted-syntax, no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (applier.fn === null) continue;
                if (applier.v7) {
                    if (ignoreDiacritics) value = $c80d7fdca78f3c04$export$626da389515c02b3(value);
                    const isMatching = applier.fn(value, row, column, publicApiRef);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                } else {
                    var _usedCellParams$field;
                    const cellParams = (_usedCellParams$field = usedCellParams[field]) != null ? _usedCellParams$field : apiRef.current.getCellParams(apiRef.current.getRowId(row), field);
                    if (ignoreDiacritics) cellParams.value = $c80d7fdca78f3c04$export$626da389515c02b3(cellParams.value);
                    usedCellParams[field] = cellParams;
                    const isMatching = applier.fn(cellParams);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                }
            }
            result[filterValue] = false;
        }
        /* eslint-enable no-restricted-syntax, no-labels */ return result;
    };
};
const $c80d7fdca78f3c04$export$1c795c7c9654905e = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $c80d7fdca78f3c04$var$buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = $c80d7fdca78f3c04$var$buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        var _isRowMatchingFilterI, _isRowMatchingQuickFi;
        result.passingFilterItems = (_isRowMatchingFilterI = isRowMatchingFilterItems == null ? void 0 : isRowMatchingFilterItems(row, shouldApplyFilter)) != null ? _isRowMatchingFilterI : null;
        result.passingQuickFilterValues = (_isRowMatchingQuickFi = isRowMatchingQuickFilter == null ? void 0 : isRowMatchingQuickFilter(row, shouldApplyFilter)) != null ? _isRowMatchingQuickFi : null;
    };
};
const $c80d7fdca78f3c04$var$isNotNull = (result)=>result != null;
const $c80d7fdca78f3c04$var$filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$c80d7fdca78f3c04$var$getFilterCallbackFromItem(item, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $c80d7fdca78f3c04$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = $c80d7fdca78f3c04$var$filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($c80d7fdca78f3c04$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($c80d7fdca78f3c04$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        var _filterModel$logicOpe;
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = (_filterModel$logicOpe = filterModel.logicOperator) != null ? _filterModel$logicOpe : (0, $09826dcd962fda6e$export$7ea23129b8e10cdb)().logicOperator;
        if (logicOperator === (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        var _filterModel$quickFil4;
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = (_filterModel$quickFil4 = filterModel.quickFilterLogicOperator) != null ? _filterModel$quickFil4 : (0, $09826dcd962fda6e$export$7ea23129b8e10cdb)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};


const $2b1d8b5ba34e5849$export$4326c0ebf0c2f84b = (0, $4a98d49c28421b08$export$8e08ca6d174bacf9)((value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $a4e890cf7e68aae0$export$7c57da42ce8e346f)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $c80d7fdca78f3c04$export$626da389515c02b3)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
});
const $2b1d8b5ba34e5849$export$dff3a5bcde5c5e41 = (disableTrim = false)=>(0, $4a98d49c28421b08$export$b905c4c483a689a6)([
        {
            value: 'contains',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp((0, $a4e890cf7e68aae0$export$7c57da42ce8e346f)(filterItemValue), 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(String(value)) : false;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3)
        },
        {
            value: 'equals',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>{
                    return value != null ? collator.compare(filterItemValue, value.toString()) === 0 : false;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3)
        },
        {
            value: 'startsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $a4e890cf7e68aae0$export$7c57da42ce8e346f)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3)
        },
        {
            value: 'endsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $a4e890cf7e68aae0$export$7c57da42ce8e346f)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3)
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value === '' || value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value !== '' && value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: (0, $24683e8b1ac95606$export$fec959c3691e0645)
        }
    ]);



const $b946d2cd507e31d9$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, $bf59eac7c63b5f3b$export$db324d0b741f4529),
    type: 'string',
    align: 'left',
    filterOperators: (0, $2b1d8b5ba34e5849$export$dff3a5bcde5c5e41)(),
    renderEditCell: (0, $f75ede83a30c7d15$export$d1015f41e7e48c2e),
    getApplyQuickFilterFn: (0, $4a98d49c28421b08$export$50dff96f00486a5c)((0, $2b1d8b5ba34e5849$export$4326c0ebf0c2f84b)),
    getApplyQuickFilterFnV7: (0, $2b1d8b5ba34e5849$export$4326c0ebf0c2f84b)
};



var $erOpW = parcelRequire("erOpW");





const $4280479ef6d5f7c1$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $4280479ef6d5f7c1$export$78c55b2f3096aac8 = (0, $4a98d49c28421b08$export$8e08ca6d174bacf9)((value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $4280479ef6d5f7c1$var$parseNumericValue(columnValue) === $4280479ef6d5f7c1$var$parseNumericValue(value);
    };
});
const $4280479ef6d5f7c1$export$37d963e5ee49abc6 = ()=>(0, $4a98d49c28421b08$export$b905c4c483a689a6)([
        {
            value: '=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $4280479ef6d5f7c1$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $7aec56bdc407c0b9$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $24683e8b1ac95606$export$fec959c3691e0645),
            InputComponentProps: {
                type: 'number'
            }
        }
    ]);




const $067299df9d67306e$export$ba08f73736670f91 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: (0, $bf59eac7c63b5f3b$export$ecfdaa3722003888),
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: ({ value: value })=>(0, $a4e890cf7e68aae0$export$7e4aa119212bc614)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $4280479ef6d5f7c1$export$37d963e5ee49abc6)(),
    getApplyQuickFilterFn: (0, $4a98d49c28421b08$export$50dff96f00486a5c)((0, $4280479ef6d5f7c1$export$78c55b2f3096aac8)),
    getApplyQuickFilterFnV7: (0, $4280479ef6d5f7c1$export$78c55b2f3096aac8)
});



var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");





var $4uaIU = parcelRequire("4uaIU");
const $c097c8ad17cb41f6$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $c097c8ad17cb41f6$export$f82b14e11ca0a1b4(props) {
    var _item$value, _rootProps$slotProps;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, InputProps: InputProps, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $cMu4A.default)(props, $c097c8ad17cb41f6$var$_excluded);
    const filterTimeout = (0, $700e89e09f25b054$export$d8e6abf214c9ec0f)();
    const [filterValueState, setFilterValueState] = $jSIPP.useState((_item$value = item.value) != null ? _item$value : '');
    const [applying, setIsApplying] = $jSIPP.useState(false);
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $jSIPP.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            applyValue((0, $erOpW.default)({}, item, {
                value: value
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $jSIPP.useEffect(()=>{
        var _item$value2;
        const itemValue = (_item$value2 = item.value) != null ? _item$value2 : '';
        setFilterValueState(String(itemValue));
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTextField, (0, $erOpW.default)({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, $erOpW.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $erOpW.default)({
                max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                tabIndex: tabIndex
            }, InputProps == null ? void 0 : InputProps.inputProps)
        })
    }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}



const $1b47f50ed8094a24$var$dateRegex = /(\d+)-(\d+)-(\d+)/;
const $1b47f50ed8094a24$var$dateTimeRegex = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const [year, month, day, hour, minute] = filterItem.value.match(showTime ? $1b47f50ed8094a24$var$dateTimeRegex : $1b47f50ed8094a24$var$dateRegex).slice(1).map(Number);
    const time = new Date(year, month - 1, day, hour || 0, minute || 0).getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        const timeToCompare = dateCopy.setHours(showTime ? value.getHours() : 0, showTime ? value.getMinutes() : 0, 0, 0);
        return compareFn(timeToCompare, time);
    };
}
const $1b47f50ed8094a24$export$2fa54515db89172d = (showTime)=>(0, $4a98d49c28421b08$export$b905c4c483a689a6)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFnV7: (filterItem)=>{
                return $1b47f50ed8094a24$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $c097c8ad17cb41f6$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ]);




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");


var $28RyA = parcelRequire("28RyA");




var $4uaIU = parcelRequire("4uaIU");
const $4e8ce0e69d4dc99f$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const $4e8ce0e69d4dc99f$var$StyledInputBase = (0, $28RyA.default)((0, $495d300f509482ea$export$2e2bcd8739ae039))({
    fontSize: 'inherit'
});
const $4e8ce0e69d4dc99f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $4e8ce0e69d4dc99f$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, inputProps: inputProps, onValueChange: onValueChange } = props, other = (0, $cMu4A.default)(props, $4e8ce0e69d4dc99f$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const inputRef = $jSIPP.useRef();
    const valueTransformed = $jSIPP.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp != null ? valueProp : '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $jSIPP.useState(valueTransformed);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $4e8ce0e69d4dc99f$var$useUtilityClasses(ownerState);
    const parseValueToDate = $jSIPP.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $jSIPP.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $jSIPP.useEffect(()=>{
        setValueState((state)=>{
            var _valueTransformed$par, _state$parsed;
            if (valueTransformed.parsed !== state.parsed && ((_valueTransformed$par = valueTransformed.parsed) == null ? void 0 : _valueTransformed$par.getTime()) !== ((_state$parsed = state.parsed) == null ? void 0 : _state$parsed.getTime())) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($4e8ce0e69d4dc99f$var$StyledInputBase, (0, $erOpW.default)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        inputProps: (0, $erOpW.default)({
            max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const $4e8ce0e69d4dc99f$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($4e8ce0e69d4dc99f$export$b4fb7433f4444e3f, (0, $erOpW.default)({}, params));


function $f8b5b8cb2b25ab95$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
function $f8b5b8cb2b25ab95$export$c46cd449e66842a5({ value: value, field: field, id: id }) {
    if (!value) return '';
    $f8b5b8cb2b25ab95$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: id,
        field: field
    });
    return value.toLocaleDateString();
}
function $f8b5b8cb2b25ab95$export$a62990620750ce8c({ value: value, field: field, id: id }) {
    if (!value) return '';
    $f8b5b8cb2b25ab95$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: id,
        field: field
    });
    return value.toLocaleString();
}
const $f8b5b8cb2b25ab95$export$4c3b89749ea40e50 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'date',
    sortComparator: (0, $bf59eac7c63b5f3b$export$74e685f55e96d6bc),
    valueFormatter: $f8b5b8cb2b25ab95$export$c46cd449e66842a5,
    filterOperators: (0, $1b47f50ed8094a24$export$2fa54515db89172d)(),
    renderEditCell: (0, $4e8ce0e69d4dc99f$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $f8b5b8cb2b25ab95$export$5bc7079eed6f3d7f = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'dateTime',
    sortComparator: (0, $bf59eac7c63b5f3b$export$74e685f55e96d6bc),
    valueFormatter: $f8b5b8cb2b25ab95$export$a62990620750ce8c,
    filterOperators: (0, $1b47f50ed8094a24$export$2fa54515db89172d)(true),
    renderEditCell: (0, $4e8ce0e69d4dc99f$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});



var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");




var $erOpW = parcelRequire("erOpW");


const $db5319c56f201804$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $db5319c56f201804$export$e8632b32bb8837db = Symbol('mui.id_autogenerated');
const $db5319c56f201804$export$96a607054e9bfd0c = ()=>({
        type: 'group',
        id: $db5319c56f201804$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $db5319c56f201804$export$de0419c0281531ca(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI: The data grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $db5319c56f201804$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $db5319c56f201804$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $db5319c56f201804$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $db5319c56f201804$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $db5319c56f201804$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$db5319c56f201804$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $db5319c56f201804$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $erOpW.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $db5319c56f201804$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp
    });
};
const $db5319c56f201804$export$fc9d832f40054590 = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const $db5319c56f201804$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$db5319c56f201804$export$fc9d832f40054590(tree[child])) validDescendants.push(child);
        validDescendants.push(...$db5319c56f201804$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows));
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $db5319c56f201804$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates })=>{
    var _previousCache$update, _previousCache$update2, _previousCache$update3;
    if (previousCache.updates.type === 'full') throw new Error('MUI: Unable to prepare a partial update if a full update is not applied yet');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $db5319c56f201804$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $erOpW.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...(_previousCache$update = previousCache.updates.actions.insert) != null ? _previousCache$update : []
            ],
            modify: [
                ...(_previousCache$update2 = previousCache.updates.actions.modify) != null ? _previousCache$update2 : []
            ],
            remove: [
                ...(_previousCache$update3 = previousCache.updates.actions.remove) != null ? _previousCache$update3 : []
            ]
        },
        idToActionLookup: (0, $erOpW.default)({}, previousCache.updates.idToActionLookup)
    };
    const dataRowIdToModelLookup = (0, $erOpW.default)({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $erOpW.default)({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $erOpW.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
function $db5319c56f201804$export$d299da5915ed6fec(apiRef) {
    var _pinnedRows$top, _pinnedRows$bottom;
    const pinnedRows = (0, $d7530f53594a6a47$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    const bottomPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    return {
        top: topPinnedRowsHeight,
        bottom: bottomPinnedRowsHeight
    };
}
function $db5319c56f201804$export$5475857f45a72a6e(apiRef, rowHeight) {
    const densityFactor = (0, $2591c618679f9496$export$c646201fb1d3e7a6)(apiRef);
    return `var(--DataGrid-overlayHeight, ${2 * Math.floor(rowHeight * densityFactor)}px)`;
}



var $4uaIU = parcelRequire("4uaIU");
const $f66fca8f944da823$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex"
];
const $f66fca8f944da823$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $f66fca8f944da823$var$GridBooleanCellRaw(props) {
    const { value: value } = props, other = (0, $cMu4A.default)(props, $f66fca8f944da823$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $f66fca8f944da823$var$useUtilityClasses(ownerState);
    const Icon = $jSIPP.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, (0, $erOpW.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $f66fca8f944da823$export$9cc4d0e939884340 = /*#__PURE__*/ $jSIPP.memo($f66fca8f944da823$var$GridBooleanCellRaw);
const $f66fca8f944da823$export$6c5a2392a8d4c6d6 = (params)=>{
    if ((0, $db5319c56f201804$export$fc9d832f40054590)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $4uaIU.jsx)($f66fca8f944da823$export$9cc4d0e939884340, (0, $erOpW.default)({}, params));
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $2ba73560abcac0f0$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $2ba73560abcac0f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $2ba73560abcac0f0$export$22bee653ea92336f(props) {
    var _rootProps$slotProps;
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $cMu4A.default)(props, $2ba73560abcac0f0$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const inputRef = $jSIPP.useRef(null);
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const [valueState, setValueState] = $jSIPP.useState(value);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $2ba73560abcac0f0$var$useUtilityClasses(ownerState);
    const handleChange = $jSIPP.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $jSIPP.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)("label", (0, $erOpW.default)({
        htmlFor: id,
        className: (0, $86B3v.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseCheckbox, (0, $erOpW.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox))
    }));
}
const $2ba73560abcac0f0$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($2ba73560abcac0f0$export$22bee653ea92336f, (0, $erOpW.default)({}, params));




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $28RyA = parcelRequire("28RyA");


var $4uaIU = parcelRequire("4uaIU");
const $0434f3897efe0f1e$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "InputLabelProps"
];
const $0434f3897efe0f1e$var$BooleanOperatorContainer = (0, $28RyA.default)('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $0434f3897efe0f1e$export$f1030df85ee00af9(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2, _rootProps$slotProps3;
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, clearButton: clearButton, tabIndex: tabIndex, label: labelProp } = props, others = (0, $cMu4A.default)(props, $0434f3897efe0f1e$var$_excluded);
    const [filterValueState, setFilterValueState] = $jSIPP.useState(item.value || '');
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const labelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const selectId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const baseSelectOptionProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelectOption) || {};
    const onFilterChange = $jSIPP.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(value);
        applyValue((0, $erOpW.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $jSIPP.useEffect(()=>{
        setFilterValueState(item.value || '');
    }, [
        item.value
    ]);
    const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($0434f3897efe0f1e$var$BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseInputLabel, (0, $erOpW.default)({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: "standard",
                        children: label
                    })),
                    /*#__PURE__*/ (0, $4uaIU.jsxs)(rootProps.slots.baseSelect, (0, $erOpW.default)({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: "standard",
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others, baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}



const $f394568943f2c829$export$906a46f6c2359ef6 = ()=>(0, $4a98d49c28421b08$export$b905c4c483a689a6)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const valueAsBoolean = filterItem.value === 'true';
                return (value)=>{
                    return Boolean(value) === valueAsBoolean;
                };
            },
            InputComponent: (0, $0434f3897efe0f1e$export$f1030df85ee00af9)
        }
    ]);


function $b736d978a99d81de$var$gridBooleanFormatter({ value: value, api: api }) {
    return value ? api.getLocaleText('booleanCellTrueLabel') : api.getLocaleText('booleanCellFalseLabel');
}
const $b736d978a99d81de$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $b736d978a99d81de$export$220b51460e149ea9 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'boolean',
    align: 'center',
    headerAlign: 'center',
    renderCell: (0, $f66fca8f944da823$export$6c5a2392a8d4c6d6),
    renderEditCell: (0, $2ba73560abcac0f0$export$9ef52be99fb661),
    sortComparator: (0, $bf59eac7c63b5f3b$export$ecfdaa3722003888),
    valueFormatter: $b736d978a99d81de$var$gridBooleanFormatter,
    filterOperators: (0, $f394568943f2c829$export$906a46f6c2359ef6)(),
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined,
    // @ts-ignore
    aggregable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$b736d978a99d81de$var$stringToBoolean(value)
});



var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $a96927ef953bb8d5$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($a96927ef953bb8d5$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $a96927ef953bb8d5$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($a96927ef953bb8d5$export$73fccbaa325472ee || {});


const $2200ee459e36b6d0$export$a6587fe901c3baf7 = (key)=>key === 'Escape'; // TODO remove
const $2200ee459e36b6d0$export$b043658e6147d6f8 = (key)=>key === 'Enter'; // TODO remove
const $2200ee459e36b6d0$export$34e5042f80daa3dd = (key)=>key === 'Tab'; // TODO remove
const $2200ee459e36b6d0$export$f2db841f07bb1f8e = (key)=>key === ' ';
const $2200ee459e36b6d0$export$beff32ba02dcfc32 = (key)=>key.indexOf('Arrow') === 0;
const $2200ee459e36b6d0$export$8f13b7ff72c94db5 = (key)=>key === 'Home' || key === 'End';
const $2200ee459e36b6d0$export$258861a58bef8261 = (key)=>key.indexOf('Page') === 0;
const $2200ee459e36b6d0$export$384e0678699eaafd = (key)=>key === 'Delete' || key === 'Backspace';
function $2200ee459e36b6d0$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $2200ee459e36b6d0$export$b7d709ba679d3811 = [
    'Meta',
    'Control',
    'Shift'
];
const $2200ee459e36b6d0$export$cb76cac5e13767b3 = [
    'Enter',
    'Escape',
    'Tab'
];
const $2200ee459e36b6d0$export$88516d667267d515 = [
    'Enter',
    'Tab'
];
const $2200ee459e36b6d0$export$6ac2fcffa1f825f7 = (key)=>$2200ee459e36b6d0$export$b7d709ba679d3811.indexOf(key) > -1;
const $2200ee459e36b6d0$export$a8f5f024431d9642 = (event)=>$2200ee459e36b6d0$export$b043658e6147d6f8(event.key) || $2200ee459e36b6d0$export$384e0678699eaafd(event.key) || $2200ee459e36b6d0$export$b3f2c64190cf8c4(event);
const $2200ee459e36b6d0$export$f6a96f75820f81fd = (key)=>$2200ee459e36b6d0$export$cb76cac5e13767b3.indexOf(key) > -1;
const $2200ee459e36b6d0$export$d3e9cf1edead7ecb = (key)=>$2200ee459e36b6d0$export$88516d667267d515.indexOf(key) > -1;
const $2200ee459e36b6d0$export$e13d96c38a470518 = (key)=>$2200ee459e36b6d0$export$8f13b7ff72c94db5(key) || $2200ee459e36b6d0$export$beff32ba02dcfc32(key) || $2200ee459e36b6d0$export$258861a58bef8261(key) || $2200ee459e36b6d0$export$f2db841f07bb1f8e(key);
const $2200ee459e36b6d0$export$130b789831072f4c = (event)=>!!event.key;
const $2200ee459e36b6d0$export$81301abbcd0c8143 = (key)=>$2200ee459e36b6d0$export$34e5042f80daa3dd(key) || $2200ee459e36b6d0$export$a6587fe901c3baf7(key);



var $57b3ed5f9013058b$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($57b3ed5f9013058b$export$bad6b7a934346f26 || {});
var $57b3ed5f9013058b$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($57b3ed5f9013058b$export$84e4fdd8f295ca31 || {});
var $57b3ed5f9013058b$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($57b3ed5f9013058b$export$d98c76b959bb0b5c || {});


function $e7dced82ec40eefc$export$74006a51f68c6262(colDef) {
    return (colDef == null ? void 0 : colDef.type) === 'singleSelect';
}
function $e7dced82ec40eefc$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}
const $e7dced82ec40eefc$export$f3eb784638ed9dd8 = (valueOption)=>{
    const label = typeof valueOption === 'object' ? valueOption.label : valueOption;
    return label != null ? String(label) : '';
};




var $4uaIU = parcelRequire("4uaIU");
const $dc91d3e71a676521$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "getOptionLabel",
    "getOptionValue"
], $dc91d3e71a676521$var$_excluded2 = [
    "MenuProps"
];
function $dc91d3e71a676521$var$isKeyboardEvent(event) {
    return !!event.key;
}
function $dc91d3e71a676521$export$df7446df636ddbed(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Cell, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = (0, $cMu4A.default)(props, $dc91d3e71a676521$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const ref = $jSIPP.useRef();
    const inputRef = $jSIPP.useRef();
    const [open, setOpen] = $jSIPP.useState(initialOpen);
    const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : false;
    const _ref = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {}, { MenuProps: MenuProps } = _ref, otherBaseSelectProps = (0, $cMu4A.default)(_ref, $dc91d3e71a676521$var$_excluded2);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) {
            var _inputRef$current;
            (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
        }
    }, [
        hasFocus
    ]);
    if (!(0, $e7dced82ec40eefc$export$74006a51f68c6262)(colDef)) return null;
    let valueOptions;
    if (typeof (colDef == null ? void 0 : colDef.valueOptions) === 'function') valueOptions = colDef == null ? void 0 : colDef.valueOptions({
        id: id,
        row: row,
        field: field
    });
    else valueOptions = colDef == null ? void 0 : colDef.valueOptions;
    if (!valueOptions) return null;
    const getOptionValue = getOptionValueProp || colDef.getOptionValue;
    const getOptionLabel = getOptionLabelProp || colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $e7dced82ec40eefc$export$74006a51f68c6262)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $e7dced82ec40eefc$export$b31a7985e33f7505)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || (0, $2200ee459e36b6d0$export$a6587fe901c3baf7)(event.key)) {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $erOpW.default)({}, params, {
                reason: (0, $2200ee459e36b6d0$export$a6587fe901c3baf7)(event.key) ? (0, $a96927ef953bb8d5$export$73fccbaa325472ee).escapeKeyDown : (0, $a96927ef953bb8d5$export$73fccbaa325472ee).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($dc91d3e71a676521$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelect, (0, $erOpW.default)({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: (0, $erOpW.default)({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            var _rootProps$slotProps3;
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $jSIPP.createElement)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelectOption) || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $dc91d3e71a676521$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($dc91d3e71a676521$export$df7446df636ddbed, (0, $erOpW.default)({}, params));



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $28RyA = parcelRequire("28RyA");



var $4uaIU = parcelRequire("4uaIU");
const $d1254d05fc256ddc$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "getOptionLabel",
    "getOptionValue",
    "placeholder",
    "tabIndex",
    "label",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const $d1254d05fc256ddc$var$renderSingleSelectOptions = ({ column: { valueOptions: valueOptions, field: field }, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = typeof valueOptions === 'function' ? [
        '',
        ...valueOptions({
            field: field
        })
    ] : [
        '',
        ...valueOptions || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        const label = getOptionLabel(option);
        return /*#__PURE__*/ (0, $jSIPP.createElement)(OptionComponent, (0, $erOpW.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const $d1254d05fc256ddc$var$SingleSelectOperatorContainer = (0, $28RyA.default)('div')({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $d1254d05fc256ddc$export$760eb819dd95d361(props) {
    var _item$value, _rootProps$slotProps$, _rootProps$slotProps, _resolvedColumn, _resolvedColumn2, _rootProps$slotProps2, _rootProps$slotProps3, _rootProps$slotProps4;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp, placeholder: placeholder, tabIndex: tabIndex, label: labelProp, clearButton: clearButton } = props, others = (0, $cMu4A.default)(props, $d1254d05fc256ddc$var$_excluded);
    const [filterValueState, setFilterValueState] = $jSIPP.useState((_item$value = item.value) != null ? _item$value : '');
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const labelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const isSelectNative = (_rootProps$slotProps$ = (_rootProps$slotProps = rootProps.slotProps) == null || (_rootProps$slotProps = _rootProps$slotProps.baseSelect) == null ? void 0 : _rootProps$slotProps.native) != null ? _rootProps$slotProps$ : true;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $e7dced82ec40eefc$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
    const currentValueOptions = $jSIPP.useMemo(()=>{
        if (!resolvedColumn) return undefined;
        return typeof resolvedColumn.valueOptions === 'function' ? resolvedColumn.valueOptions({
            field: resolvedColumn.field
        }) : resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $jSIPP.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $e7dced82ec40eefc$export$b31a7985e33f7505)(value, currentValueOptions, getOptionValue);
        setFilterValueState(String(value));
        applyValue((0, $erOpW.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    $jSIPP.useEffect(()=>{
        var _itemValue;
        let itemValue;
        if (currentValueOptions !== undefined) {
            // sanitize if valueOptions are provided
            itemValue = (0, $e7dced82ec40eefc$export$b31a7985e33f7505)(item.value, currentValueOptions, getOptionValue);
            if (itemValue !== item.value) {
                applyValue((0, $erOpW.default)({}, item, {
                    value: itemValue
                }));
                return;
            }
        } else itemValue = item.value;
        itemValue = (_itemValue = itemValue) != null ? _itemValue : '';
        setFilterValueState(String(itemValue));
    }, [
        item,
        currentValueOptions,
        applyValue,
        getOptionValue
    ]);
    if (!(0, $e7dced82ec40eefc$export$74006a51f68c6262)(resolvedColumn)) return null;
    if (!(0, $e7dced82ec40eefc$export$74006a51f68c6262)(resolvedColumn)) return null;
    const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($d1254d05fc256ddc$var$SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)(rootProps.slots.baseFormControl, {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseInputLabel, (0, $erOpW.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: "standard",
                        children: label
                    })),
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelect, (0, $erOpW.default)({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: "standard",
                        type: type || 'text',
                        inputProps: {
                            tabIndex: tabIndex,
                            ref: focusElementRef,
                            placeholder: placeholder != null ? placeholder : apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                        },
                        native: isSelectNative
                    }, others, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelect, {
                        children: $d1254d05fc256ddc$var$renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel: getOptionLabel,
                            getOptionValue: getOptionValue,
                            isSelectNative: isSelectNative,
                            baseSelectOptionProps: (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");






var $4uaIU = parcelRequire("4uaIU");
const $ae5155682bcdbe04$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant",
    "getOptionLabel",
    "getOptionValue"
];
const $ae5155682bcdbe04$var$filter = (0, $b51c52e6b3da82bb$export$f76f94b238d946d8)();
function $ae5155682bcdbe04$export$a61be354e4fcf2c5(props) {
    var _resolvedColumn, _resolvedColumn2;
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard', getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = (0, $cMu4A.default)(props, $ae5155682bcdbe04$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $e7dced82ec40eefc$export$74006a51f68c6262)(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
    const isOptionEqualToValue = $jSIPP.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $jSIPP.useMemo(()=>{
        var _resolvedColumn3;
        if (!((_resolvedColumn3 = resolvedColumn) != null && _resolvedColumn3.valueOptions)) return [];
        if (typeof resolvedColumn.valueOptions === 'function') return resolvedColumn.valueOptions({
            field: resolvedColumn.field
        });
        return resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const resolvedFormattedValueOptions = $jSIPP.useMemo(()=>{
        return resolvedValueOptions == null ? void 0 : resolvedValueOptions.map(getOptionValue);
    }, [
        resolvedValueOptions,
        getOptionValue
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $jSIPP.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        if (resolvedValueOptions !== undefined) {
            const itemValueIndexes = item.value.map((element)=>{
                // Gets the index matching between values and valueOptions
                return resolvedFormattedValueOptions == null ? void 0 : resolvedFormattedValueOptions.findIndex((formattedOption)=>formattedOption === element);
            });
            return itemValueIndexes.filter((index)=>index >= 0).map((index)=>resolvedValueOptions[index]);
        }
        return item.value;
    }, [
        item.value,
        resolvedValueOptions,
        resolvedFormattedValueOptions
    ]);
    $jSIPP.useEffect(()=>{
        if (!Array.isArray(item.value) || filteredValues.length !== item.value.length) // Updates the state if the filter value has been cleaned by the component
        applyValue((0, $erOpW.default)({}, item, {
            value: filteredValues.map(getOptionValue)
        }));
    }, [
        item,
        filteredValues,
        applyValue,
        getOptionValue
    ]);
    const handleChange = $jSIPP.useCallback((event, value)=>{
        applyValue((0, $erOpW.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), (0, $erOpW.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: $ae5155682bcdbe04$var$filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseChip, (0, $erOpW.default)({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTextField, (0, $erOpW.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $erOpW.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}




const $edbbc0fa4d6a09e5$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $a4e890cf7e68aae0$export$a6cdc56e425d0d0a)(value)) return value;
    return value.value;
};
const $edbbc0fa4d6a09e5$export$fe632a61ba1bdc90 = ()=>(0, $4a98d49c28421b08$export$b905c4c483a689a6)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$edbbc0fa4d6a09e5$var$parseObjectValue(value) === $edbbc0fa4d6a09e5$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $d1254d05fc256ddc$export$760eb819dd95d361)
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$edbbc0fa4d6a09e5$var$parseObjectValue(value) !== $edbbc0fa4d6a09e5$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $d1254d05fc256ddc$export$760eb819dd95d361)
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($edbbc0fa4d6a09e5$var$parseObjectValue);
                return (value)=>filterItemValues.includes($edbbc0fa4d6a09e5$var$parseObjectValue(value));
            },
            InputComponent: (0, $ae5155682bcdbe04$export$a61be354e4fcf2c5)
        }
    ]);




const $cf8aadb3c8be752d$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $cf8aadb3c8be752d$var$defaultGetOptionValue = (value)=>{
    return (0, $a4e890cf7e68aae0$export$a6cdc56e425d0d0a)(value) ? value.value : value;
};
const $cf8aadb3c8be752d$var$defaultGetOptionLabel = (value)=>{
    return (0, $a4e890cf7e68aae0$export$a6cdc56e425d0d0a)(value) ? value.label : String(value);
};
const $cf8aadb3c8be752d$export$7acf0d6e5e468a51 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'singleSelect',
    getOptionLabel: $cf8aadb3c8be752d$var$defaultGetOptionLabel,
    getOptionValue: $cf8aadb3c8be752d$var$defaultGetOptionValue,
    valueFormatter (params) {
        const { id: id, field: field, value: value, api: api } = params;
        const colDef = params.api.getColumn(field);
        if (!(0, $e7dced82ec40eefc$export$74006a51f68c6262)(colDef)) return '';
        let valueOptions;
        if (typeof colDef.valueOptions === 'function') valueOptions = colDef.valueOptions({
            id: id,
            row: id ? api.getRow(id) : null,
            field: field
        });
        else valueOptions = colDef.valueOptions;
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$cf8aadb3c8be752d$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: (0, $dc91d3e71a676521$export$13060fab7d49b7a1),
    filterOperators: (0, $edbbc0fa4d6a09e5$export$fe632a61ba1bdc90)(),
    // @ts-ignore
    pastedValueParser: (value, params)=>{
        const colDef = params.colDef;
        const colDefValueOptions = colDef.valueOptions;
        const valueOptions = typeof colDefValueOptions === 'function' ? colDefValueOptions({
            field: colDef.field
        }) : colDefValueOptions || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});



var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");






var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $jSIPP = parcelRequire("jSIPP");




var $4uaIU = parcelRequire("4uaIU");
'use client';
function $1f8be5e6d94a1f79$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $1f8be5e6d94a1f79$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $1f8be5e6d94a1f79$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $jSIPP.useRef(false);
    const nodeRef = $jSIPP.useRef(null);
    const activatedRef = $jSIPP.useRef(false);
    const syntheticEventRef = $jSIPP.useRef(false);
    $jSIPP.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)((0, $26305578246e3ab6$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $1f8be5e6d94a1f79$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $jSIPP.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $1f8be5e6d94a1f79$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $jSIPP.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $1f8be5e6d94a1f79$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($jSIPP.Fragment, {
        children: /*#__PURE__*/ $jSIPP.cloneElement(children, childrenProps)
    });
}



var $i3Yji = parcelRequire("i3Yji");




var $28RyA = parcelRequire("28RyA");




var $4uaIU = parcelRequire("4uaIU");
const $67217aef89f147e8$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $67217aef89f147e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $67217aef89f147e8$var$GridMenuRoot = (0, $28RyA.default)((0, $b774b692670e0e71$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Menu',
    overridesResolver: (_, styles)=>styles.menu
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, $4d97f950d65e57e8$export$2100d54e36406477).menuList}`]: {
            outline: 0
        }
    }));
const $67217aef89f147e8$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $67217aef89f147e8$export$237948c71948075(props) {
    var _rootProps$slotProps;
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $cMu4A.default)(props, $67217aef89f147e8$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $67217aef89f147e8$var$useUtilityClasses(rootProps);
    const savedFocusRef = $jSIPP.useRef(null);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            var _savedFocusRef$curren, _savedFocusRef$curren2;
            (_savedFocusRef$curren = savedFocusRef.current) == null || (_savedFocusRef$curren2 = _savedFocusRef$curren.focus) == null || _savedFocusRef$curren2.call(_savedFocusRef$curren);
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $jSIPP.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target != null && target.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)($67217aef89f147e8$var$GridMenuRoot, (0, $erOpW.default)({
        as: rootProps.slots.basePopper,
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.basePopper, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $1f8be5e6d94a1f79$export$58385c17fee43f89), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f0165b03f861203f$export$2e2bcd8739ae039), (0, $erOpW.default)({}, TransitionProps, {
                    style: {
                        transformOrigin: $67217aef89f147e8$var$transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps == null ? void 0 : TransitionProps.onExited),
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        children: children
                    })
                }))
            })
    }));
}





var $4uaIU = parcelRequire("4uaIU");
const $3bac1f226f2360f9$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $3bac1f226f2360f9$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $3bac1f226f2360f9$export$e8966cddc2f9f685(props) {
    var _rootProps$slotProps;
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', focusElementRef: focusElementRef } = props, other = (0, $cMu4A.default)(props, $3bac1f226f2360f9$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $jSIPP.useState(-1);
    const [open, setOpen] = $jSIPP.useState(false);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootRef = $jSIPP.useRef(null);
    const buttonRef = $jSIPP.useRef(null);
    const ignoreCallToFocus = $jSIPP.useRef(false);
    const touchRippleRefs = $jSIPP.useRef({});
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const menuId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const buttonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    if (!$3bac1f226f2360f9$var$hasActions(colDef)) throw new Error('MUI: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $jSIPP.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref == null || ref.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $jSIPP.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $jSIPP.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $jSIPP.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $jSIPP.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            var _options;
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = theme.direction === 'rtl' ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return (_options = options[index + indexMod]) != null && _options.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, e.g. ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ([
            'Tab',
            'Enter',
            'Escape'
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, $4d97f950d65e57e8$export$2100d54e36406477).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $jSIPP.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: showMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $67217aef89f147e8$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                onClick: hideMenu,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039), {
                    id: menuId,
                    className: (0, $4d97f950d65e57e8$export$2100d54e36406477).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $jSIPP.cloneElement(button, {
                            key: index
                        }))
                })
            })
        ]
    }));
}
const $3bac1f226f2360f9$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($3bac1f226f2360f9$export$e8966cddc2f9f685, (0, $erOpW.default)({}, params));


const $d8b476ddccfc1f84$export$e2523ab9efeb7465 = 'actions';
const $d8b476ddccfc1f84$export$cc51a5e65f00f971 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $3bac1f226f2360f9$export$974043ff7a6a1028),
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined
});


const $32ea4ace93392787$export$9459349d75dc87fe = '__default__';
const $32ea4ace93392787$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4),
        number: (0, $067299df9d67306e$export$ba08f73736670f91),
        date: (0, $f8b5b8cb2b25ab95$export$4c3b89749ea40e50),
        dateTime: (0, $f8b5b8cb2b25ab95$export$5bc7079eed6f3d7f),
        boolean: (0, $b736d978a99d81de$export$220b51460e149ea9),
        singleSelect: (0, $cf8aadb3c8be752d$export$7acf0d6e5e468a51),
        [(0, $d8b476ddccfc1f84$export$e2523ab9efeb7465)]: (0, $d8b476ddccfc1f84$export$cc51a5e65f00f971),
        [$32ea4ace93392787$export$9459349d75dc87fe]: (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4)
    };
    return nativeColumnTypes;
};






const $50fcb4d7c433ea68$export$cd7252624d377ce0 = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
function $50fcb4d7c433ea68$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $50fcb4d7c433ea68$export$cd8dc1fa232954ad = (rawState, viewportInnerWidth)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute there minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        const newColumn = (0, $erOpW.default)({}, rawState.lookup[columnField]);
        if (rawState.columnVisibilityModel[columnField] === false) newColumn.computedWidth = 0;
        else {
            let computedWidth;
            if (newColumn.flex && newColumn.flex > 0) {
                totalFlexUnits += newColumn.flex;
                computedWidth = 0;
                flexColumns.push(newColumn);
            } else computedWidth = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(newColumn.width || (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4).width, newColumn.minWidth || (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4).minWidth, newColumn.maxWidth || (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
            newColumn.computedWidth = computedWidth;
        }
        columnsLookup[columnField] = newColumn;
    });
    const initialFreeSpace = Math.max(viewportInnerWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && viewportInnerWidth > 0) {
        const computedColumnWidths = $50fcb4d7c433ea68$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, $erOpW.default)({}, rawState, {
        lookup: columnsLookup
    });
};
const $50fcb4d7c433ea68$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $erOpW.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $erOpW.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $erOpW.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $50fcb4d7c433ea68$var$getDefaultColTypeDef(columnTypes, type) {
    let colDef = columnTypes[0, $32ea4ace93392787$export$9459349d75dc87fe];
    if (type && columnTypes[type]) colDef = columnTypes[type];
    return colDef;
}
const $50fcb4d7c433ea68$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnTypes: columnTypes, columnVisibilityModel: columnVisibilityModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false })=>{
    var _apiRef$current$getRo, _apiRef$current$getRo2, _apiRef$current;
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $90c6bb88bfe45f18$export$858d15abb6cddc08)(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $erOpW.default)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>(0, $erOpW.default)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $erOpW.default)({}, $50fcb4d7c433ea68$var$getDefaultColTypeDef(columnTypes, newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $erOpW.default)({}, $50fcb4d7c433ea68$var$getDefaultColTypeDef(columnTypes, newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $50fcb4d7c433ea68$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $erOpW.default)({}, existingState, newColumn, {
            hasBeenResized: hasBeenResized
        });
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $50fcb4d7c433ea68$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $50fcb4d7c433ea68$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, (_apiRef$current$getRo = (_apiRef$current$getRo2 = (_apiRef$current = apiRef.current).getRootDimensions) == null || (_apiRef$current$getRo2 = _apiRef$current$getRo2.call(_apiRef$current)) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0);
};
const $50fcb4d7c433ea68$export$2e21c1239cd8cac2 = (columnsState)=>(state)=>(0, $erOpW.default)({}, state, {
            columns: columnsState
        });
function $50fcb4d7c433ea68$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    for(let i = firstRowToRender; i < lastRowToRender; i += 1){
        const row = visibleRows[i];
        if (row) {
            const rowId = visibleRows[i].id;
            const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
        }
    }
    return firstNonSpannedColumnToRender;
}
function $50fcb4d7c433ea68$export$8ad609d4bbf235b0({ firstColumnIndex: firstColumnIndex, minColumnIndex: minColumnIndex, columnBuffer: columnBuffer, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, apiRef: apiRef, visibleRows: visibleRows }) {
    const initialFirstColumnToRender = Math.max(firstColumnIndex - columnBuffer, minColumnIndex);
    const firstColumnToRender = $50fcb4d7c433ea68$export$6143417adb92779f({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef: apiRef,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: visibleRows
    });
    return firstColumnToRender;
}
function $50fcb4d7c433ea68$export$659109c29172602f(apiRef, headerHeight) {
    const densityFactor = (0, $2591c618679f9496$export$c646201fb1d3e7a6)(apiRef);
    const maxDepth = (0, $24c0f923081db0c8$export$4cf0369c079b29be)(apiRef);
    return Math.floor(headerHeight * densityFactor) * ((maxDepth != null ? maxDepth : 0) + 1);
}


var $8f6bc22f7ecdaff8$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}($8f6bc22f7ecdaff8$export$e7e5652452e44b || {});




var $4uaIU = parcelRequire("4uaIU");
const $855696b52d6fd9a6$var$defaultColumnTypes = (0, $32ea4ace93392787$export$625c4e4511cf2d66)();
const $855696b52d6fd9a6$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    var _props$initialState, _ref, _props$columnVisibili, _props$initialState2;
    const columnsState = (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
        apiRef: apiRef,
        columnTypes: $855696b52d6fd9a6$var$defaultColumnTypes,
        columnsToUpsert: props.columns,
        initialState: (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.columns,
        columnVisibilityModel: (_ref = (_props$columnVisibili = props.columnVisibilityModel) != null ? _props$columnVisibili : (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.columns) == null ? void 0 : _props$initialState2.columnVisibilityModel) != null ? _ref : {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $erOpW.default)({}, state, {
        columns: columnsState
    });
};
function $855696b52d6fd9a6$export$fe9b9b8b4620abff(apiRef, props) {
    var _props$initialState4, _props$slotProps2;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridColumns');
    const columnTypes = $855696b52d6fd9a6$var$defaultColumnTypes;
    const previousColumnsProp = $jSIPP.useRef(props.columns);
    const previousColumnTypesProp = $jSIPP.useRef(columnTypes);
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4),
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $jSIPP.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState((0, $50fcb4d7c433ea68$export$2e21c1239cd8cac2)(columnsState));
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $jSIPP.useCallback((field)=>(0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $jSIPP.useCallback(()=>(0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $jSIPP.useCallback(()=>(0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $jSIPP.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef) : (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $jSIPP.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $90c6bb88bfe45f18$export$fce7d810e48021e3)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $jSIPP.useCallback((model)=>{
        const currentModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                    columns: (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
                        apiRef: apiRef,
                        columnTypes: columnTypes,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        columnTypes
    ]);
    const updateColumns = $jSIPP.useCallback((columns)=>{
        const columnsState = (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: columns,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState,
        columnTypes
    ]);
    const setColumnVisibility = $jSIPP.useCallback((field, isVisible)=>{
        var _columnVisibilityMode;
        const columnVisibilityModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
        const isCurrentlyVisible = (_columnVisibilityMode = columnVisibilityModel[field]) != null ? _columnVisibilityMode : true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $erOpW.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $jSIPP.useCallback((field)=>{
        const allColumns = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $jSIPP.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $erOpW.default)({}, (0, $90c6bb88bfe45f18$export$858d15abb6cddc08)(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $jSIPP.useCallback((field, width)=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $90c6bb88bfe45f18$export$858d15abb6cddc08)(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = (0, $erOpW.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $50fcb4d7c433ea68$export$cd8dc1fa232954ad)((0, $erOpW.default)({}, columnsState, {
            lookup: (0, $erOpW.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnReorderApi, props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState$c, _props$initialState3;
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys((_props$initialState$c = (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.columns) == null ? void 0 : _props$initialState3.columnVisibilityModel) != null ? _props$initialState$c : {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        const columns = (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $50fcb4d7c433ea68$export$cd7252624d377ce0).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $erOpW.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        (_props$initialState4 = props.initialState) == null ? void 0 : _props$initialState4.columns
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        var _context$stateToResto;
        const columnVisibilityModelToImport = (_context$stateToResto = context.stateToRestore.columns) == null ? void 0 : _context$stateToResto.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState((0, $50fcb4d7c433ea68$export$2e21c1239cd8cac2)(columnsState));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef,
        columnTypes
    ]);
    const preferencePanelPreProcessing = $jSIPP.useCallback((initialValue, value)=>{
        if (value === (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).columns) {
            var _props$slotProps;
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $4uaIU.jsx)(ColumnsPanel, (0, $erOpW.default)({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.columnsPanel
    ]);
    const addColumnMenuItems = $jSIPP.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /**
   * EVENTS
   */ const prevInnerWidth = $jSIPP.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            setGridColumnsState((0, $50fcb4d7c433ea68$export$cd8dc1fa232954ad)((0, $90c6bb88bfe45f18$export$858d15abb6cddc08)(apiRef.current.state), viewportInnerSize.width));
        }
    };
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $jSIPP.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        columnTypes
    ]);
    (0, $9babb3636382b74b$export$98b68054bf03cb4)(apiRef, 'hydrateColumns', hydrateColumns);
    /**
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns && previousColumnTypesProp.current === columnTypes) return;
        const columnsState = (0, $50fcb4d7c433ea68$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        previousColumnTypesProp.current = columnTypes;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        columnTypes
    ]);
    $jSIPP.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




const $4ba453ecad7efc86$export$44e428f429332330 = 0.7;
const $4ba453ecad7efc86$export$ff72d9a37c8f7b58 = 1.3;
const $4ba453ecad7efc86$var$DENSITY_FACTORS = {
    compact: $4ba453ecad7efc86$export$44e428f429332330,
    comfortable: $4ba453ecad7efc86$export$ff72d9a37c8f7b58,
    standard: 1
};
const $4ba453ecad7efc86$export$d6d71dbaaa6fec72 = (state, props)=>(0, $erOpW.default)({}, state, {
        density: {
            value: props.density,
            factor: $4ba453ecad7efc86$var$DENSITY_FACTORS[props.density]
        }
    });
const $4ba453ecad7efc86$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useDensity');
    const setDensity = $jSIPP.useCallback((newDensity)=>{
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>{
            const currentDensityState = (0, $2591c618679f9496$export$806a039ece4425b4)(state);
            const newDensityState = {
                value: newDensity,
                factor: $4ba453ecad7efc86$var$DENSITY_FACTORS[newDensity]
            };
            if ((0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(currentDensityState, newDensityState)) return state;
            return (0, $erOpW.default)({}, state, {
                density: newDensityState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        apiRef
    ]);
    $jSIPP.useEffect(()=>{
        apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
    const densityApi = {
        setDensity: setDensity
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, densityApi, 'public');
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $dBoEs = parcelRequire("dBoEs");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




// TODO v6: rename to gridEditingStateSelector
const $3cca1b289e09958d$export$91ed78b95c9e6636 = (state)=>state.editRows;







const $068208c6d0f7ab13$var$_excluded = [
    "id",
    "field"
], $068208c6d0f7ab13$var$_excluded2 = [
    "id",
    "field"
];
const $068208c6d0f7ab13$var$missingOnProcessRowUpdateErrorWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const $068208c6d0f7ab13$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $jSIPP.useState({});
    const cellModesModelRef = $jSIPP.useRef(cellModesModel);
    const prevCellModesModel = $jSIPP.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Cell) callback(...args);
        };
    const throwIfNotEditable = $jSIPP.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $jSIPP.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $jSIPP.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) return;
        const newParams = (0, $erOpW.default)({}, params, {
            reason: (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $jSIPP.useCallback((params, event)=>{
        if (params.cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View) return;
        const newParams = (0, $erOpW.default)({}, params, {
            reason: (0, $a96927ef953bb8d5$export$73fccbaa325472ee).cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        if (params.cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $a96927ef953bb8d5$export$73fccbaa325472ee).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $a96927ef953bb8d5$export$73fccbaa325472ee).enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? (0, $a96927ef953bb8d5$export$73fccbaa325472ee).shiftTabKeyDown : (0, $a96927ef953bb8d5$export$73fccbaa325472ee).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $erOpW.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $2200ee459e36b6d0$export$b3f2c64190cf8c4)(event)) reason = (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === 'v') reason = (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).pasteKeyDown;
            else if (event.key === 'Enter') reason = (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).enterKeyDown;
            else if (event.key === 'Delete' || event.key === 'Backspace') // Delete on Windows, Backspace on macOS
            reason = (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).deleteKeyDown;
            if (reason) {
                const newParams = (0, $erOpW.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $jSIPP.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).printableKeyDown || reason === (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).deleteKeyDown || reason === (0, $a96927ef953bb8d5$export$66744c3b0d0c6217).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $jSIPP.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $a96927ef953bb8d5$export$73fccbaa325472ee).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $a96927ef953bb8d5$export$73fccbaa325472ee).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $a96927ef953bb8d5$export$73fccbaa325472ee).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'cellEditStop', props.onCellEditStop);
    const getCellMode = $jSIPP.useCallback((id, field)=>{
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit : (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $55503225f0104895$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {});
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $jSIPP.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $erOpW.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $erOpW.default)({}, newModel[id], {
            [field]: (0, $erOpW.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $cMu4A.default)(_newModel$id, [
                field
            ].map((0, $dBoEs.default))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $jSIPP.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $erOpW.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $erOpW.default)({}, newEditingState[id], {
                [field]: (0, $erOpW.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $erOpW.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = $jSIPP.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $cMu4A.default)(params, $068208c6d0f7ab13$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View);
        updateFieldInCellModesModel(id, field, (0, $erOpW.default)({
            mode: (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $55503225f0104895$export$2e2bcd8739ae039)((params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        let newValue = apiRef.current.getCellValue(id, field);
        if (deleteValue || initialValue) newValue = deleteValue ? '' : initialValue;
        const newProps = {
            value: newValue,
            error: false,
            isProcessingProps: false
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
    });
    const stopCellEditMode = $jSIPP.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $cMu4A.default)(params, $068208c6d0f7ab13$var$_excluded2);
        throwIfNotInMode(id, field, (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit);
        updateFieldInCellModesModel(id, field, (0, $erOpW.default)({
            mode: (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $55503225f0104895$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else $068208c6d0f7ab13$var$missingOnProcessRowUpdateErrorWarning();
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $jSIPP.useCallback(async (params)=>{
        var _editingState$id;
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $erOpW.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $erOpW.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View) return false;
        editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        newProps = (0, $erOpW.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        return !((_editingState$id = editingState[id]) != null && (_editingState$id = _editingState$id[field]) != null && _editingState$id.error);
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $jSIPP.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter({
            value: value,
            row: row
        }) : (0, $erOpW.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $jSIPP.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        const idToIdLookup = (0, $d7530f53594a6a47$export$451ff98f7dd9f13f)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $a4e890cf7e68aae0$export$b7d58db314e0ac27)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                var _copyOfPrevCellModes$, _idToIdLookup$id;
                const prevMode = ((_copyOfPrevCellModes$ = copyOfPrevCellModes[id]) == null || (_copyOfPrevCellModes$ = _copyOfPrevCellModes$[field]) == null ? void 0 : _copyOfPrevCellModes$.mode) || (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View;
                const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
                if (params.mode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit && prevMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View) updateStateToStartCellEditMode((0, $erOpW.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View && prevMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) updateStateToStopCellEditMode((0, $erOpW.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};




var $dBoEs = parcelRequire("dBoEs");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");










/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $795c3f7e8600b2fe$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($795c3f7e8600b2fe$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $795c3f7e8600b2fe$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($795c3f7e8600b2fe$export$723957c53726785f || {});



const $179e6c85a2afa32c$var$_excluded = [
    "id"
], $179e6c85a2afa32c$var$_excluded2 = [
    "id"
];
const $179e6c85a2afa32c$var$missingOnProcessRowUpdateErrorWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const $179e6c85a2afa32c$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $jSIPP.useState({});
    const rowModesModelRef = $jSIPP.useRef(rowModesModel);
    const prevRowModesModel = $jSIPP.useRef({});
    const focusTimeout = $jSIPP.useRef(null);
    const nextFocusedCell = $jSIPP.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Row) callback(...args);
        };
    const throwIfNotEditable = $jSIPP.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $jSIPP.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $jSIPP.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $erOpW.default)({}, rowParams, {
            field: params.field,
            reason: (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $jSIPP.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $jSIPP.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            var _nextFocusedCell$curr;
            focusTimeout.current = null;
            if (((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $erOpW.default)({}, rowParams, {
                    field: params.field,
                    reason: (0, $795c3f7e8600b2fe$export$723957c53726785f).rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef
    ]);
    $jSIPP.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        if (params.cellMode === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $795c3f7e8600b2fe$export$723957c53726785f).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $795c3f7e8600b2fe$export$723957c53726785f).enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $d8b476ddccfc1f84$export$e2523ab9efeb7465)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $795c3f7e8600b2fe$export$723957c53726785f).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $795c3f7e8600b2fe$export$723957c53726785f).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                const newParams = (0, $erOpW.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $2200ee459e36b6d0$export$b3f2c64190cf8c4)(event)) reason = (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === 'v') reason = (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).printableKeyDown;
            else if (event.key === 'Enter') reason = (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).enterKeyDown;
            else if (event.key === 'Delete' || event.key === 'Backspace') // Delete on Windows, Backspace on macOS
            reason = (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $erOpW.default)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleRowEditStart = $jSIPP.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).printableKeyDown || reason === (0, $795c3f7e8600b2fe$export$535533732d8f5c0a).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $jSIPP.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $795c3f7e8600b2fe$export$723957c53726785f).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $795c3f7e8600b2fe$export$723957c53726785f).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $795c3f7e8600b2fe$export$723957c53726785f).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $jSIPP.useCallback((id)=>{
        if (props.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Cell) return (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View;
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
        return isEditing ? (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit : (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $55503225f0104895$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {});
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $jSIPP.useCallback((id, newProps)=>{
        const newModel = (0, $erOpW.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $erOpW.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $jSIPP.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $erOpW.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $erOpW.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $jSIPP.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $erOpW.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $erOpW.default)({}, newEditingState[id], {
                [field]: (0, $erOpW.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $erOpW.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = $jSIPP.useCallback((params)=>{
        const { id: id } = params, other = (0, $cMu4A.default)(params, $179e6c85a2afa32c$var$_excluded);
        throwIfNotInMode(id, (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View);
        updateRowInRowModesModel(id, (0, $erOpW.default)({
            mode: (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $55503225f0104895$export$2e2bcd8739ae039)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const columnFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        const newProps = columnFields.reduce((acc, field)=>{
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) newValue = deleteValue ? '' : initialValue;
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: false
            };
            return acc;
        }, {});
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
    });
    const stopRowEditMode = $jSIPP.useCallback((params)=>{
        const { id: id } = params, other = (0, $cMu4A.default)(params, $179e6c85a2afa32c$var$_excluded2);
        throwIfNotInMode(id, (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit);
        updateRowInRowModesModel(id, (0, $erOpW.default)({
            mode: (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $55503225f0104895$export$2e2bcd8739ae039)((params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit;
            return;
        }
        const hasSomeFieldWithError = Object.values(editingState[id]).some((fieldProps)=>fieldProps.error);
        if (hasSomeFieldWithError) {
            prevRowModesModel.current[id].mode = (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevRowModesModel.current[id].mode = (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else $179e6c85a2afa32c$var$missingOnProcessRowUpdateErrorWarning();
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $jSIPP.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        let newProps = (0, $erOpW.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $erOpW.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $cMu4A.default)(_editingState$id, [
                    field
                ].map((0, $dBoEs.default)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
                    processedProps = (0, $erOpW.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $erOpW.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $cMu4A.default)(_editingState$id2, [
                    thisField
                ].map((0, $dBoEs.default)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $erOpW.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit) {
                    editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $jSIPP.useCallback((id)=>{
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $erOpW.default)({}, row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            if (column.valueSetter) rowUpdate = column.valueSetter({
                value: fieldProps.value,
                row: rowUpdate
            });
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $jSIPP.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        const idToIdLookup = (0, $d7530f53594a6a47$export$451ff98f7dd9f13f)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $a4e890cf7e68aae0$export$b7d58db314e0ac27)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(rowModesModel).forEach(([id, params])=>{
            var _copyOfPrevRowModesMo, _idToIdLookup$id;
            const prevMode = ((_copyOfPrevRowModesMo = copyOfPrevRowModesModel[id]) == null ? void 0 : _copyOfPrevRowModesMo.mode) || (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View;
            const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
            if (params.mode === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit && prevMode === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View) updateStateToStartRowEditMode((0, $erOpW.default)({
                id: originalId
            }, params));
            else if (params.mode === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).View && prevMode === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit) updateStateToStopRowEditMode((0, $erOpW.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};




const $3e86fc7ff36adb8a$export$1094a2c822d71ffd = (state)=>(0, $erOpW.default)({}, state, {
        editRows: {}
    });
const $3e86fc7ff36adb8a$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $068208c6d0f7ab13$export$2c9a271ac5d3f446)(apiRef, props);
    (0, $179e6c85a2afa32c$export$a43bf4f64ed7f919)(apiRef, props);
    const debounceMap = $jSIPP.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $jSIPP.useCallback((params)=>{
        if ((0, $db5319c56f201804$export$fc9d832f40054590)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $jSIPP.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $jSIPP.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $jSIPP.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $jSIPP.useCallback((id, field)=>{
        return props.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $jSIPP.useCallback((id, field)=>{
        var _editingState$id$fiel, _editingState$id;
        const editingState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        return (_editingState$id$fiel = (_editingState$id = editingState[id]) == null ? void 0 : _editingState$id[field]) != null ? _editingState$id$fiel : null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingSharedApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, editingSharedPrivateApi, 'private');
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");














var $cMu4A = parcelRequire("cMu4A");

var $dBoEs = parcelRequire("dBoEs");

var $jSIPP = parcelRequire("jSIPP");

const $0cb8bc389b379b36$export$84214fbf04c4094 = 'none';
const $0cb8bc389b379b36$export$8c4aa1977ad5d106 = {
    rowTreeCreation: 'rowTree',
    filtering: 'rowTree',
    sorting: 'rowTree',
    visibleRowsLookupCreation: 'rowTree'
};
const $0cb8bc389b379b36$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $jSIPP.useRef(new Map());
    const strategiesCache = $jSIPP.useRef({});
    const registerStrategyProcessor = $jSIPP.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $cMu4A.default)(_ref, [
                strategyName
            ].map((0, $dBoEs.default)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($0cb8bc389b379b36$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $jSIPP.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($0cb8bc389b379b36$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $jSIPP.useCallback((strategyGroup)=>{
        var _availableStrategyEnt;
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return (_availableStrategyEnt = availableStrategyEntry == null ? void 0 : availableStrategyEntry[0]) != null ? _availableStrategyEnt : $0cb8bc389b379b36$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $jSIPP.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, strategyProcessingApi, 'private');
};


var $jSIPP = parcelRequire("jSIPP");

const $1a0ff26229d68413$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $jSIPP.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};





var $4uaIU = parcelRequire("4uaIU");
const $473168580e74bff4$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    var _ref, _props$filterModel, _props$initialState;
    const filterModel = (_ref = (_props$filterModel = props.filterModel) != null ? _props$filterModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.filter) == null ? void 0 : _props$initialState.filterModel) != null ? _ref : (0, $09826dcd962fda6e$export$7ea23129b8e10cdb)();
    return (0, $erOpW.default)({}, state, {
        filter: {
            filterModel: (0, $c80d7fdca78f3c04$export$2a370a0aad2ac7e1)(filterModel, props.disableMultipleColumnsFiltering, apiRef),
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        },
        visibleRowsLookup: {}
    });
};
const $473168580e74bff4$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $473168580e74bff4$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $473168580e74bff4$var$createMemoizedValues() {
    return (0, $0895266d24a2801f$export$281bff7f05488aa2)(Object.values);
}
const $473168580e74bff4$export$42838275cbf666c4 = (apiRef, props)=>{
    var _props$initialState3, _props$slotProps2;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5),
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(state, apiRef.current.instanceId);
            const isRowMatchingFilters = props.filterMode === 'client' ? (0, $c80d7fdca78f3c04$export$1c795c7c9654905e)(filterModel, apiRef, props.disableEval) : null;
            const filteringResult = apiRef.current.applyStrategyProcessor('filtering', {
                isRowMatchingFilters: isRowMatchingFilters,
                filterModel: filterModel != null ? filterModel : (0, $09826dcd962fda6e$export$7ea23129b8e10cdb)()
            });
            const newState = (0, $erOpW.default)({}, state, {
                filter: (0, $erOpW.default)({}, state.filter, filteringResult)
            });
            const visibleRowsLookupState = $473168580e74bff4$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $erOpW.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef,
        props.filterMode,
        props.disableEval
    ]);
    const addColumnMenuItem = $jSIPP.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const applyFilters = $jSIPP.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = $jSIPP.useCallback((item)=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $jSIPP.useCallback((items)=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $jSIPP.useCallback((itemToDelete)=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $jSIPP.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                var _column$filterOperato;
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof (filterOperator == null ? void 0 : filterOperator.requiresFilterValue) === 'undefined' ? true : filterOperator == null ? void 0 : filterOperator.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $c80d7fdca78f3c04$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $c80d7fdca78f3c04$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $jSIPP.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $jSIPP.useCallback((logicOperator)=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $jSIPP.useCallback((values)=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        if ((0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $jSIPP.useCallback((model, reason)=>{
        const currentModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $c80d7fdca78f3c04$export$f4189e6c713e6dd8)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState2;
        const filterModelToExport = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.filter) == null ? void 0 : _props$initialState2.filterModel) != null || // Export if the model is not equal to the default value
        !(0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(filterModelToExport, (0, $09826dcd962fda6e$export$7ea23129b8e10cdb)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $erOpW.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.filter) == null ? void 0 : _props$initialState3.filterModel
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        var _context$stateToResto;
        const filterModel = (_context$stateToResto = context.stateToRestore.filter) == null ? void 0 : _context$stateToResto.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $c80d7fdca78f3c04$export$f4189e6c713e6dd8)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $erOpW.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $jSIPP.useCallback((initialValue, value)=>{
        if (value === (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters) {
            var _props$slotProps;
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $4uaIU.jsx)(FilterPanel, (0, $erOpW.default)({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $9feaeb5783bf167a$export$fd27aa36f007ec3d)($473168580e74bff4$var$createMemoizedValues);
    const flatFilteringMethod = $jSIPP.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters) return {
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        };
        const dataRowIdToModelLookup = (0, $d7530f53594a6a47$export$37767f9110c99048)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $c80d7fdca78f3c04$export$8d82b4490466f182)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(apiRef, (0, $0cb8bc389b379b36$export$84214fbf04c4094), 'filtering', flatFilteringMethod);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(apiRef, (0, $0cb8bc389b379b36$export$84214fbf04c4094), 'visibleRowsLookupCreation', $473168580e74bff4$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $jSIPP.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        const filterableColumnsLookup = (0, $90c6bb88bfe45f18$export$e84218276cc24419)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && filterableColumnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $jSIPP.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                visibleRowsLookup: $473168580e74bff4$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5)(apiRef);
        if (filterModel.quickFilterValues && filterModel.quickFilterExcludeHiddenColumns) // re-apply filters because the quick filter results may have changed
        apiRef.current.unstable_applyFilters();
    });
    /**
   * 1ST RENDER
   */ (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");









var $jSIPP = parcelRequire("jSIPP");





const $854024f5c3119ca0$var$MAX_PAGE_SIZE = 100;
const $854024f5c3119ca0$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $854024f5c3119ca0$export$b287f0ca5dbff6af = (rowCount, pageSize)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    return 0;
};
const $854024f5c3119ca0$export$8861c218874b3f9c = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    "MUI: the 'rowCount' prop is undefined while using paginationMode='server'",
    'For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation'
], 'error');
const $854024f5c3119ca0$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $854024f5c3119ca0$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $854024f5c3119ca0$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid && pageSize > $854024f5c3119ca0$var$MAX_PAGE_SIZE) throw new Error([
        'MUI: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};


const $23354dc00cec9d31$export$24c945ea033ce6cf = (state)=>state.pagination;
const $23354dc00cec9d31$export$ccc9f04e59d0d8e6 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($23354dc00cec9d31$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $23354dc00cec9d31$export$1f7f64fcb62ccdad = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($23354dc00cec9d31$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $23354dc00cec9d31$export$721a46720a2de097 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($23354dc00cec9d31$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $23354dc00cec9d31$export$b81026f1aaf843a4 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($23354dc00cec9d31$export$ccc9f04e59d0d8e6, (0, $dcdbd4f8634a4b8d$export$f88efd30675963d1), (paginationModel, visibleTopLevelRowCount)=>(0, $854024f5c3119ca0$export$b287f0ca5dbff6af)(visibleTopLevelRowCount, paginationModel.pageSize));
const $23354dc00cec9d31$export$b76c99ac6ae901da = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($23354dc00cec9d31$export$ccc9f04e59d0d8e6, (0, $d7530f53594a6a47$export$de9a43d646a9821d), (0, $d7530f53594a6a47$export$4cdbe576751dd8e2), (0, $dcdbd4f8634a4b8d$export$2f31562143a3e5d4), (0, $dcdbd4f8634a4b8d$export$b8a7110d1a4c4623), (paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        var _rowTree$row$id;
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = (_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $23354dc00cec9d31$export$abcd649e974e3e96 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)((0, $dcdbd4f8634a4b8d$export$2f31562143a3e5d4), $23354dc00cec9d31$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $23354dc00cec9d31$export$c1f6a976375edd4a = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)((0, $dcdbd4f8634a4b8d$export$7a99837e2fd93e42), $23354dc00cec9d31$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});



const $0a6b6a2469195bfe$export$79b9fa322a34430b = (apiRef, props)=>{
    let rows;
    let range;
    if (props.pagination && props.paginationMode === 'client') {
        range = (0, $23354dc00cec9d31$export$b76c99ac6ae901da)(apiRef);
        rows = (0, $23354dc00cec9d31$export$abcd649e974e3e96)(apiRef);
    } else {
        rows = (0, $dcdbd4f8634a4b8d$export$2f31562143a3e5d4)(apiRef);
        if (rows.length === 0) range = null;
        else range = {
            firstRowIndex: 0,
            lastRowIndex: rows.length - 1
        };
    }
    return {
        rows: rows,
        range: range
    };
};
const $0a6b6a2469195bfe$export$d1914c80ff11e37a = (apiRef, props)=>{
    const response = $0a6b6a2469195bfe$export$79b9fa322a34430b(apiRef, props);
    return $jSIPP.useMemo(()=>({
            rows: response.rows,
            range: response.range
        }), [
        response.rows,
        response.range
    ]);
};




const $f54188e4704fd08b$export$bfde38b067fac467 = (state)=>(0, $erOpW.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $f54188e4704fd08b$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridFocus');
    const lastClickedCell = $jSIPP.useRef(null);
    const publishCellFocusOut = $jSIPP.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $jSIPP.useCallback((id, field)=>{
        const focusedCell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        if ((focusedCell == null ? void 0 : focusedCell.id) === id && (focusedCell == null ? void 0 : focusedCell.field) === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $erOpW.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $jSIPP.useCallback((field, event = {})=>{
        const cell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $erOpW.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $jSIPP.useCallback((field, event = {})=>{
        const cell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $erOpW.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $jSIPP.useCallback((field, depth, event = {})=>{
        const cell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $jSIPP.useCallback(()=>(0, $196c4c77eabe7b5f$export$7442f29af2d5c4da)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $jSIPP.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
        const currentPage = (0, $0a6b6a2469195bfe$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $d7530f53594a6a47$export$ffe7071c481e32b0)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $jSIPP.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $2200ee459e36b6d0$export$e13d96c38a470518)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $jSIPP.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $jSIPP.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $196c4c77eabe7b5f$export$7442f29af2d5c4da)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $jSIPP.useCallback((_, event)=>{
        var _event$relatedTarget;
        if ((_event$relatedTarget = event.relatedTarget) != null && _event$relatedTarget.className.includes((0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $jSIPP.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $jSIPP.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if ((cellParams == null ? void 0 : cellParams.id) === focusedCell.id && (cellParams == null ? void 0 : cellParams.field) === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement != null && cellElement.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $jSIPP.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        if ((cell == null ? void 0 : cell.id) !== params.id || (cell == null ? void 0 : cell.field) !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $jSIPP.useCallback(()=>{
        const cell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        // If the focused cell is in a row which does not exist anymore, then remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        apiRef
    ]);
    const handlePaginationModelChange = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        const currentFocusedCell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $0a6b6a2469195bfe$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, focusApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, focusPrivateApi, 'private');
    $jSIPP.useEffect(()=>{
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        handleDocumentClick
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowsSet', handleRowSet);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



const $a69c7ce47da1b745$export$e29505bd53a069c8 = (state)=>(0, $erOpW.default)({}, state, {
        headerFiltering: {
            editing: null,
            menuOpen: null
        }
    });
const $a69c7ce47da1b745$export$8ee3ddc1b48b5da9 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridHeaderFiltering');
    const setHeaderFilterState = $jSIPP.useCallback((headerFilterState)=>{
        apiRef.current.setState((state)=>{
            var _headerFilterState$ed, _headerFilterState$me;
            // Safety check to avoid MIT users from using it
            // This hook should ultimately be moved to the Pro package
            if (props.signature === 'DataGrid') return state;
            return (0, $erOpW.default)({}, state, {
                headerFiltering: {
                    editing: (_headerFilterState$ed = headerFilterState.editing) != null ? _headerFilterState$ed : null,
                    menuOpen: (_headerFilterState$me = headerFilterState.menuOpen) != null ? _headerFilterState$me : null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.signature
    ]);
    const startHeaderFilterEditMode = $jSIPP.useCallback((field)=>{
        logger.debug(`Starting edit mode on header filter for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            editing: field
        });
    }, [
        apiRef,
        logger
    ]);
    const stopHeaderFilterEditMode = $jSIPP.useCallback(()=>{
        logger.debug(`Stopping edit mode on header filter`);
        apiRef.current.setHeaderFilterState({
            editing: null
        });
    }, [
        apiRef,
        logger
    ]);
    const showHeaderFilterMenu = $jSIPP.useCallback((field)=>{
        logger.debug(`Opening header filter menu for field: ${field}`);
        apiRef.current.setHeaderFilterState({
            menuOpen: field
        });
    }, [
        apiRef,
        logger
    ]);
    const hideHeaderFilterMenu = $jSIPP.useCallback(()=>{
        logger.debug(`Hiding header filter menu for active field`);
        let fieldToFocus = apiRef.current.state.headerFiltering.menuOpen;
        if (fieldToFocus) {
            const columnLookup = (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setHeaderFilterState({
                menuOpen: null
            });
            apiRef.current.setColumnHeaderFilterFocus(fieldToFocus);
        }
    }, [
        apiRef,
        logger
    ]);
    const headerFilterPrivateApi = {
        setHeaderFilterState: setHeaderFilterState
    };
    const headerFilterApi = {
        startHeaderFilterEditMode: startHeaderFilterEditMode,
        stopHeaderFilterEditMode: stopHeaderFilterEditMode,
        showHeaderFilterMenu: showHeaderFilterMenu,
        hideHeaderFilterMenu: hideHeaderFilterMenu
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, headerFilterApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, headerFilterPrivateApi, 'private');
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");







const $fe5aad41f2d2873c$export$951a05deca7e869f = (state, props)=>{
    var _props$paginationMode, _props$initialState;
    const paginationModel = (0, $erOpW.default)({}, (0, $854024f5c3119ca0$export$73aa7e9d0fff5ee4)(props.autoPageSize), (_props$paginationMode = props.paginationModel) != null ? _props$paginationMode : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.pagination) == null ? void 0 : _props$initialState.paginationModel);
    (0, $854024f5c3119ca0$export$d3cf54bfe8b6931)(paginationModel.pageSize, props.signature);
    return (0, $erOpW.default)({}, state, {
        pagination: {
            paginationModel: paginationModel
        }
    });
};
const $fe5aad41f2d2873c$export$65b7f0a0a8dbd594 = (rowCount, signature, paginationModelProp)=>(paginationState)=>{
        var _paginationModelProp$;
        let paginationModel = paginationState.paginationModel;
        const pageSize = (_paginationModelProp$ = paginationModelProp == null ? void 0 : paginationModelProp.pageSize) != null ? _paginationModelProp$ : paginationModel.pageSize;
        const pageCount = (0, $854024f5c3119ca0$export$b287f0ca5dbff6af)(rowCount, pageSize);
        if (paginationModelProp && ((paginationModelProp == null ? void 0 : paginationModelProp.page) !== paginationModel.page || (paginationModelProp == null ? void 0 : paginationModelProp.pageSize) !== paginationModel.pageSize)) paginationModel = paginationModelProp;
        const validPage = (0, $854024f5c3119ca0$export$41142e40198ee144)(paginationModel.page, pageCount);
        if (validPage !== paginationModel.page) paginationModel = (0, $erOpW.default)({}, paginationModel, {
            page: validPage
        });
        (0, $854024f5c3119ca0$export$d3cf54bfe8b6931)(paginationModel.pageSize, signature);
        return {
            paginationModel: paginationModel
        };
    };
const $fe5aad41f2d2873c$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridPagination');
    const visibleTopLevelRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$f88efd30675963d1));
    const densityFactor = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$c646201fb1d3e7a6));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'pagination',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6),
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $jSIPP.useCallback((page)=>{
        const currentModel = (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $jSIPP.useCallback((pageSize)=>{
        const currentModel = (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $jSIPP.useCallback((paginationModel)=>{
        var _props$rowCount;
        const currentModel = (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.updateControlState('pagination', $fe5aad41f2d2873c$export$65b7f0a0a8dbd594((_props$rowCount = props.rowCount) != null ? _props$rowCount : visibleTopLevelRowCount, props.signature, paginationModel), 'setPaginationModel');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.rowCount,
        props.signature,
        visibleTopLevelRowCount
    ]);
    const pageApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, pageApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState2;
        const paginationModel = (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.pagination) == null ? void 0 : _props$initialState2.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $854024f5c3119ca0$export$d515e179bb47bd84)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $erOpW.default)({}, prevState, {
            pagination: (0, $erOpW.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.pagination) == null ? void 0 : _props$initialState3.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        var _context$stateToResto, _context$stateToResto2, _props$rowCount2;
        const paginationModel = (_context$stateToResto = context.stateToRestore.pagination) != null && _context$stateToResto.paginationModel ? (0, $erOpW.default)({}, (0, $854024f5c3119ca0$export$73aa7e9d0fff5ee4)(props.autoPageSize), (_context$stateToResto2 = context.stateToRestore.pagination) == null ? void 0 : _context$stateToResto2.paginationModel) : (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        apiRef.current.updateControlState('pagination', $fe5aad41f2d2873c$export$65b7f0a0a8dbd594((_props$rowCount2 = props.rowCount) != null ? _props$rowCount2 : visibleTopLevelRowCount, props.signature, paginationModel), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.rowCount,
        props.signature,
        visibleTopLevelRowCount
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        var _apiRef$current$virtu;
        const paginationModel = (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6)(apiRef);
        if ((_apiRef$current$virtu = apiRef.current.virtualScrollerRef) != null && _apiRef$current$virtu.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
        apiRef.current.forceUpdate();
    };
    const handleUpdateAutoPageSize = $jSIPP.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!props.autoPageSize || !dimensions) return;
        const pinnedRowsHeight = (0, $db5319c56f201804$export$d299da5915ed6fec)(apiRef);
        const maximumPageSizeWithoutScrollBar = Math.floor((dimensions.viewportInnerSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom) / rowHeight);
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $jSIPP.useEffect(()=>{}, [
        props.rowCount,
        props.paginationMode
    ]);
    $jSIPP.useEffect(()=>{
        var _props$rowCount3;
        apiRef.current.updateControlState('pagination', $fe5aad41f2d2873c$export$65b7f0a0a8dbd594((_props$rowCount3 = props.rowCount) != null ? _props$rowCount3 : visibleTopLevelRowCount, props.signature, props.paginationModel));
    }, [
        apiRef,
        props.paginationModel,
        props.rowCount,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.signature
    ]);
    $jSIPP.useEffect(()=>{
        handleUpdateAutoPageSize();
    }, [
        handleUpdateAutoPageSize
    ]);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



const $77a28296cab754a7$export$37e5474577e02878 = (state)=>state.preferencePanel;


const $e8c65f8ab2f20672$export$a9f45f767b8ade48 = (state, props)=>{
    var _props$initialState$p, _props$initialState;
    return (0, $erOpW.default)({}, state, {
        preferencePanel: (_props$initialState$p = (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.preferencePanel) != null ? _props$initialState$p : {
            open: false
        }
    });
};
const $e8c65f8ab2f20672$export$343dd9a605dbb75b = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridPreferencesPanel');
    const hideTimeout = $jSIPP.useRef();
    const immediateTimeout = $jSIPP.useRef();
    /**
   * API METHODS
   */ const hidePreferences = $jSIPP.useCallback(()=>{
        logger.debug('Hiding Preferences Panel');
        const preferencePanelState = (0, $77a28296cab754a7$export$37e5474577e02878)(apiRef.current.state);
        if (preferencePanelState.openedPanelValue) apiRef.current.publishEvent('preferencePanelClose', {
            openedPanelValue: preferencePanelState.openedPanelValue
        });
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    // This is to prevent the preferences from closing when you open a select box or another panel,
    // The issue is in MUI core V4 => Fixed in V5
    const doNotHidePanel = $jSIPP.useCallback(()=>{
        immediateTimeout.current = setTimeout(()=>clearTimeout(hideTimeout.current), 0);
    }, []);
    // This is a hack for the issue with Core V4, by delaying hiding the panel on the clickAwayListener,
    // we can cancel the action if the trigger element still need the panel...
    const hidePreferencesDelayed = $jSIPP.useCallback(()=>{
        hideTimeout.current = setTimeout(hidePreferences, 100);
    }, [
        hidePreferences
    ]);
    const showPreferences = $jSIPP.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        doNotHidePanel();
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                preferencePanel: (0, $erOpW.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        doNotHidePanel,
        apiRef
    ]);
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferencesDelayed
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState2;
        const preferencePanelToExport = (0, $77a28296cab754a7$export$37e5474577e02878)(apiRef.current.state);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        ((_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.preferencePanel) != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $erOpW.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        (_props$initialState3 = props.initialState) == null ? void 0 : _props$initialState3.preferencePanel
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $jSIPP.useEffect(()=>{
        return ()=>{
            clearTimeout(hideTimeout.current);
            clearTimeout(immediateTimeout.current);
        };
    }, []);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");






const $8ea15f807bcaac04$export$f663bee74a6091fc = (state)=>state.rowSelection;
const $8ea15f807bcaac04$export$2e16a09b9ae82bd3 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($8ea15f807bcaac04$export$f663bee74a6091fc, (selection)=>selection.length);
const $8ea15f807bcaac04$export$dd53f67f8b4cd8b1 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($8ea15f807bcaac04$export$f663bee74a6091fc, (0, $d7530f53594a6a47$export$37767f9110c99048), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const $8ea15f807bcaac04$export$d5aede24ebfe3c98 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($8ea15f807bcaac04$export$f663bee74a6091fc, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));






var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $65972342878601c3$var$_excluded = [
    "field",
    "id",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $65972342878601c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $65972342878601c3$export$de9fc2d8e98d780 = /*#__PURE__*/ $jSIPP.forwardRef(function GridCellCheckboxRenderer(props, ref) {
    var _rootProps$slotProps;
    const { field: field, id: id, value: isChecked, rowNode: rowNode, hasFocus: hasFocus, tabIndex: tabIndex } = props, other = (0, $cMu4A.default)(props, $65972342878601c3$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $65972342878601c3$var$useUtilityClasses(ownerState);
    const checkboxElement = $jSIPP.useRef(null);
    const rippleRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(checkboxElement, ref);
    const element = apiRef.current.getCellElement(id, field);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $jSIPP.useLayoutEffect(()=>{
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        element,
        tabIndex
    ]);
    $jSIPP.useEffect(()=>{
        if (hasFocus) {
            var _checkboxElement$curr;
            const input = (_checkboxElement$curr = checkboxElement.current) == null ? void 0 : _checkboxElement$curr.querySelector('input');
            input == null || input.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = $jSIPP.useCallback((event)=>{
        if ((0, $2200ee459e36b6d0$export$f2db841f07bb1f8e)(event.key)) // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const isSelectable = apiRef.current.isRowSelectable(id);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseCheckbox, (0, $erOpW.default)({
        ref: handleRef,
        tabIndex: tabIndex,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        onKeyDown: handleKeyDown,
        disabled: !isSelectable,
        touchRippleRef: rippleRef
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
const $65972342878601c3$export$6df0a29182db5ff8 = $65972342878601c3$export$de9fc2d8e98d780;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");









var $4uaIU = parcelRequire("4uaIU");
const $41903f7b4c6a82d9$var$_excluded = [
    "field",
    "colDef"
];
const $41903f7b4c6a82d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $41903f7b4c6a82d9$export$22c0c31c5dd8f5aa = /*#__PURE__*/ $jSIPP.forwardRef(function GridHeaderCheckbox(props, ref) {
    var _rootProps$slotProps;
    const other = (0, $cMu4A.default)(props, $41903f7b4c6a82d9$var$_excluded);
    const [, forceUpdate] = $jSIPP.useState(false);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $41903f7b4c6a82d9$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$29da670438604dbd));
    const selection = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $8ea15f807bcaac04$export$f663bee74a6091fc));
    const visibleRowIds = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$7a99837e2fd93e42));
    const paginatedVisibleRowIds = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $23354dc00cec9d31$export$c1f6a976375edd4a));
    const filteredSelection = $jSIPP.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== 'function') return selection;
        return selection.filter((id)=>{
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $jSIPP.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $jSIPP.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $jSIPP.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $jSIPP.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $jSIPP.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $jSIPP.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseCheckbox, (0, $erOpW.default)({
        ref: ref,
        indeterminate: isIndeterminate,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});





var $4uaIU = parcelRequire("4uaIU");
const $b713438374cc7354$export$322dfed7a1df1b02 = '__check__';
const $b713438374cc7354$export$b2e9ab6103a664ad = (0, $erOpW.default)({}, (0, $b736d978a99d81de$export$220b51460e149ea9), {
    field: $b713438374cc7354$export$322dfed7a1df1b02,
    type: 'checkboxSelection',
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined,
    valueGetter: (params)=>{
        const selectionLookup = (0, $8ea15f807bcaac04$export$d5aede24ebfe3c98)(params.api.state, params.api.instanceId);
        return selectionLookup[params.id] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $41903f7b4c6a82d9$export$22c0c31c5dd8f5aa), (0, $erOpW.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $65972342878601c3$export$6df0a29182db5ff8), (0, $erOpW.default)({}, params))
});





// Can't import from pro package - hence duplication
const $1048d489942eaf21$export$6e5a576305a34719 = '__detail_panel_toggle__';




function $26a7a0c939103688$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $26a7a0c939103688$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $26a7a0c939103688$export$c7408c516f335586(cell) {
    if (!cell) return null;
    return $26a7a0c939103688$export$2a63f1401414fc1a(cell, (0, $4d97f950d65e57e8$export$2100d54e36406477).row);
}
function $26a7a0c939103688$export$50f9854aa9e6e900(elem) {
    return elem != null && elem.classList.contains((0, $4d97f950d65e57e8$export$2100d54e36406477).cell);
}
function $26a7a0c939103688$export$a50bbedaf000c26f(elem) {
    return elem != null && elem.classList.contains((0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader);
}
function $26a7a0c939103688$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $26a7a0c939103688$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$26a7a0c939103688$var$escapeOperandAttributeSelector(field)}"]`);
}
function $26a7a0c939103688$var$getGridRowElementSelector(id) {
    return `.${(0, $4d97f950d65e57e8$export$2100d54e36406477).row}[data-id="${$26a7a0c939103688$var$escapeOperandAttributeSelector(String(id))}"]`;
}
function $26a7a0c939103688$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($26a7a0c939103688$var$getGridRowElementSelector(id));
}
function $26a7a0c939103688$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $26a7a0c939103688$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}[data-field="${$26a7a0c939103688$var$escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $26a7a0c939103688$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $26a7a0c939103688$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $26a7a0c939103688$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}


const $39e47e9472ec3deb$var$getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const $39e47e9472ec3deb$export$73be1d69367eeb5b = (state, props)=>{
    var _getSelectionModelPro;
    return (0, $erOpW.default)({}, state, {
        rowSelection: props.rowSelection ? (_getSelectionModelPro = $39e47e9472ec3deb$var$getSelectionModelPropValue(props.rowSelectionModel)) != null ? _getSelectionModelPro : [] : []
    });
};
const $39e47e9472ec3deb$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = (callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        };
    const propRowSelectionModel = $jSIPP.useMemo(()=>{
        return $39e47e9472ec3deb$var$getSelectionModelPropValue(props.rowSelectionModel, (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = $jSIPP.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $8ea15f807bcaac04$export$f663bee74a6091fc),
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableMultipleRowSelection: disableMultipleRowSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = !disableMultipleRowSelection || checkboxSelection;
    const visibleRows = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, props);
    const expandMouseRowRangeSelection = $jSIPP.useCallback((id)=>{
        var _lastRowToggled$curre;
        let endId = id;
        const startId = (_lastRowToggled$curre = lastRowToggled.current) != null ? _lastRowToggled$curre : id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $dcdbd4f8634a4b8d$export$7a99837e2fd93e42)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /**
   * API METHODS
   */ const setRowSelectionModel = $jSIPP.useCallback((model)=>{
        if (props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid && !props.checkboxSelection && Array.isArray(model) && model.length > 1) throw new Error([
            'MUI: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        props.checkboxSelection
    ]);
    const isRowSelected = $jSIPP.useCallback((id)=>(0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = $jSIPP.useCallback((id)=>{
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = apiRef.current.getRowNode(id);
        if ((rowNode == null ? void 0 : rowNode.type) === 'footer' || (rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        propIsRowSelectable
    ]);
    const getSelectedRows = $jSIPP.useCallback(()=>(0, $8ea15f807bcaac04$export$dd53f67f8b4cd8b1)(apiRef), [
        apiRef
    ]);
    const selectRow = $jSIPP.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            apiRef.current.setRowSelectionModel(isSelected ? [
                id
            ] : []);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state);
            const newSelection = selection.filter((el)=>el !== id);
            if (isSelected) newSelection.push(id);
            const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRows = $jSIPP.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) newSelection = isSelected ? selectableIds : [];
        else {
            // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
            const selectionLookup = (0, $erOpW.default)({}, (0, $8ea15f807bcaac04$export$d5aede24ebfe3c98)(apiRef));
            selectableIds.forEach((id)=>{
                if (isSelected) selectionLookup[id] = id;
                else delete selectionLookup[id];
            });
            newSelection = Object.values(selectionLookup);
        }
        const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRowRange = $jSIPP.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $dcdbd4f8634a4b8d$export$7a99837e2fd93e42)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, selectionPublicApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, selectionPrivateApi, props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /**
   * EVENTS
   */ const removeOutdatedSelection = $jSIPP.useCallback(()=>{
        if (props.keepNonExistentRowsSelected) return;
        const currentSelection = (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state);
        const rowsLookup = (0, $d7530f53594a6a47$export$37767f9110c99048)(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, $erOpW.default)({}, (0, $8ea15f807bcaac04$export$d5aede24ebfe3c98)(apiRef));
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (!rowsLookup[id]) {
                delete selectionLookup[id];
                hasChanged = true;
            }
        });
        if (hasChanged) apiRef.current.setRowSelectionModel(Object.values(selectionLookup));
    }, [
        apiRef,
        props.keepNonExistentRowsSelected
    ]);
    const handleSingleRowSelection = $jSIPP.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $2200ee459e36b6d0$export$130b789831072f4c)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $jSIPP.useCallback((params, event)=>{
        var _closest;
        if (disableRowSelectionOnClick) return;
        const field = (_closest = event.target.closest(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell}`)) == null ? void 0 : _closest.getAttribute('data-field');
        if (field === (0, $b713438374cc7354$export$b2e9ab6103a664ad).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $1048d489942eaf21$export$6e5a576305a34719)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if ((column == null ? void 0 : column.type) === (0, $d8b476ddccfc1f84$export$e2523ab9efeb7465)) return;
        }
        const rowNode = apiRef.current.getRowNode(params.id);
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && (canHaveMultipleSelection || checkboxSelection)) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        checkboxSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $jSIPP.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) {
            var _window$getSelection;
            (_window$getSelection = window.getSelection()) == null || _window$getSelection.removeAllRanges();
        }
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $jSIPP.useCallback((params, event)=>{
        if (event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value);
    }, [
        apiRef,
        expandMouseRowRangeSelection
    ]);
    const handleHeaderSelectionCheckboxChange = $jSIPP.useCallback((params)=>{
        const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
        const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? (0, $23354dc00cec9d31$export$c1f6a976375edd4a)(apiRef) : (0, $dcdbd4f8634a4b8d$export$7a99837e2fd93e42)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination
    ]);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
        if ((0, $2200ee459e36b6d0$export$e13d96c38a470518)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (event.key === 'a' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        visibleRows.rows,
        canHaveMultipleSelection
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(removeOutdatedSelection));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /**
   * EFFECTS
   */ $jSIPP.useEffect(()=>{
        if (propRowSelectionModel !== undefined) apiRef.current.setRowSelectionModel(propRowSelectionModel);
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection
    ]);
    $jSIPP.useEffect(()=>{
        if (!props.rowSelection) apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        props.rowSelection
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $jSIPP.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        // props.isRowSelectable changed
        const currentSelection = (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $jSIPP.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $8ea15f807bcaac04$export$f663bee74a6091fc)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $61i5U = parcelRequire("61i5U");










var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

const $aca9760671f55e3a$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Columns panel text
    columnsPanelTextFieldLabel: 'Find column',
    columnsPanelTextFieldPlaceholder: 'Column title',
    columnsPanelDragIconLabel: 'Reorder column',
    columnsPanelShowAllButton: 'Show all',
    columnsPanelHideAllButton: 'Hide all',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorEquals: 'equals',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size'
};



var $erOpW = parcelRequire("erOpW");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");


'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://next.mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://next.mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $d66b02ad25060b77$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $2e229f2081955271$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $d66b02ad25060b77$export$2e2bcd8739ae039 = $d66b02ad25060b77$var$useBadge;



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $3ef7b9cd86f5c69a$export$aaccef17e6dab084(slot) {
    return (0, $geF11.default)('MuiBadge', slot);
}
const $3ef7b9cd86f5c69a$var$badgeClasses = (0, $rARwS.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $3ef7b9cd86f5c69a$export$2e2bcd8739ae039 = $3ef7b9cd86f5c69a$var$badgeClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $78af997fba0f6bfa$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $78af997fba0f6bfa$var$RADIUS_STANDARD = 10;
const $78af997fba0f6bfa$var$RADIUS_DOT = 4;
const $78af997fba0f6bfa$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $iLAKr.default)(anchorOrigin.vertical)}${(0, $iLAKr.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $iLAKr.default)(anchorOrigin.vertical)}${(0, $iLAKr.default)(anchorOrigin.horizontal)}${(0, $iLAKr.default)(overlap)}`,
            `overlap${(0, $iLAKr.default)(overlap)}`,
            color !== 'default' && `color${(0, $iLAKr.default)(color)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $3ef7b9cd86f5c69a$export$aaccef17e6dab084), classes);
};
const $78af997fba0f6bfa$var$BadgeRoot = (0, $28RyA.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $78af997fba0f6bfa$var$BadgeBadge = (0, $28RyA.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $iLAKr.default)(ownerState.anchorOrigin.vertical)}${(0, $iLAKr.default)(ownerState.anchorOrigin.horizontal)}${(0, $iLAKr.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $78af997fba0f6bfa$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $78af997fba0f6bfa$var$RADIUS_STANDARD * 2,
        borderRadius: $78af997fba0f6bfa$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $78af997fba0f6bfa$var$RADIUS_DOT,
                    height: $78af997fba0f6bfa$var$RADIUS_DOT * 2,
                    minWidth: $78af997fba0f6bfa$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $3ef7b9cd86f5c69a$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $78af997fba0f6bfa$var$Badge = /*#__PURE__*/ $jSIPP.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $cMu4A.default)(props, $78af997fba0f6bfa$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $d66b02ad25060b77$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $2e229f2081955271$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $erOpW.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $78af997fba0f6bfa$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $78af997fba0f6bfa$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $78af997fba0f6bfa$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $86B3v.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)(RootSlot, (0, $erOpW.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $4uaIU.jsx)(BadgeSlot, (0, $erOpW.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $78af997fba0f6bfa$export$2e2bcd8739ae039 = $78af997fba0f6bfa$var$Badge;









var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $24b112bd67dcac97$var$_excluded = [
    "className"
];
const $24b112bd67dcac97$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $24b112bd67dcac97$var$GridIconButtonContainerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer',
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $24b112bd67dcac97$export$e67562d5b709404c = /*#__PURE__*/ $jSIPP.forwardRef(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $24b112bd67dcac97$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $24b112bd67dcac97$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($24b112bd67dcac97$var$GridIconButtonContainerRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});



var $4uaIU = parcelRequire("4uaIU");
const $55b94ab4ae718ba3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $55b94ab4ae718ba3$export$35b5c67d267fafd7(props) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $55b94ab4ae718ba3$var$useUtilityClasses(ownerState);
    const preferencePanel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $77a28296cab754a7$export$37e5474577e02878));
    const labelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const panelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const toggleFilter = $jSIPP.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $77a28296cab754a7$export$37e5474577e02878)(apiRef.current.state);
        if (open && openedPanelValue === (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const open = preferencePanel.open && preferencePanel.labelId === labelId;
    const iconButton = /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? panelId : undefined
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTooltip, (0, $erOpW.default)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseTooltip, {
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $24b112bd67dcac97$export$e67562d5b709404c), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $78af997fba0f6bfa$export$2e2bcd8739ae039), {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $fbfaa3b54750ad9b$export$39f6debbec19b3ba(slot) {
    return (0, $geF11.default)('MuiSwitch', slot);
}
const $fbfaa3b54750ad9b$var$switchClasses = (0, $rARwS.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $fbfaa3b54750ad9b$export$2e2bcd8739ae039 = $fbfaa3b54750ad9b$var$switchClasses;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $2TupR = parcelRequire("2TupR");

var $geF11 = parcelRequire("geF11");

var $i3Yji = parcelRequire("i3Yji");



var $4IZqw = parcelRequire("4IZqw");

var $gDcI8 = parcelRequire("gDcI8");

var $668ih = parcelRequire("668ih");

var $dO3gU = parcelRequire("dO3gU");

var $4uaIU = parcelRequire("4uaIU");
const $e145175dfcec2430$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $e145175dfcec2430$var$defaultTheme = (0, $gDcI8.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $e145175dfcec2430$var$defaultCreateStyledComponent = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $e145175dfcec2430$var$useThemePropsDefault(props) {
    return (0, $0a9fb94c18c7f261$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $e145175dfcec2430$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $e145175dfcec2430$var$joinChildren(children, separator) {
    const childrenArray = $jSIPP.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $jSIPP.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $e145175dfcec2430$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $e145175dfcec2430$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $erOpW.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $668ih.handleBreakpoints)({
        theme: theme
    }, (0, $668ih.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $dO3gU.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $668ih.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $668ih.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $dO3gU.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$e145175dfcec2430$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $dO3gU.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $2TupR.default)(styles, (0, $668ih.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $668ih.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $e145175dfcec2430$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $e145175dfcec2430$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $e145175dfcec2430$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $i3Yji.default)(slots, (slot)=>(0, $geF11.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($e145175dfcec2430$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $jSIPP.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $4IZqw.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cMu4A.default)(props, $e145175dfcec2430$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $4uaIU.jsx)(StackRoot, (0, $erOpW.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $86B3v.default)(classes.root, className)
        }, other, {
            children: divider ? $e145175dfcec2430$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");
'use client';
const $63e3d4055b517dea$var$Stack = (0, $e145175dfcec2430$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $28RyA.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $eyQWd.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $63e3d4055b517dea$export$2e2bcd8739ae039 = $63e3d4055b517dea$var$Stack;




var $iLAKr = parcelRequire("iLAKr");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $b388b7bcc0c92bc8$export$717666c39ec07e12(slot) {
    return (0, $geF11.default)('MuiFormControlLabel', slot);
}
const $b388b7bcc0c92bc8$var$formControlLabelClasses = (0, $rARwS.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $b388b7bcc0c92bc8$export$2e2bcd8739ae039 = $b388b7bcc0c92bc8$var$formControlLabelClasses;




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $97749ece2376eb3c$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $97749ece2376eb3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $iLAKr.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $b388b7bcc0c92bc8$export$717666c39ec07e12), classes);
};
const $97749ece2376eb3c$export$1b479270917a5676 = (0, $28RyA.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b388b7bcc0c92bc8$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $iLAKr.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $b388b7bcc0c92bc8$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $b388b7bcc0c92bc8$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $b388b7bcc0c92bc8$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $97749ece2376eb3c$var$AsteriskComponent = (0, $28RyA.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $b388b7bcc0c92bc8$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $97749ece2376eb3c$var$FormControlLabel = /*#__PURE__*/ $jSIPP.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $cMu4A.default)(props, $97749ece2376eb3c$var$_excluded);
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $01c7c49eae24a908$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $97749ece2376eb3c$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $4acc79473d417315$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), (0, $erOpW.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $86B3v.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($97749ece2376eb3c$export$1b479270917a5676, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $jSIPP.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $63e3d4055b517dea$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $4uaIU.jsxs)($97749ece2376eb3c$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $97749ece2376eb3c$export$2e2bcd8739ae039 = $97749ece2376eb3c$var$FormControlLabel;



var $28RyA = parcelRequire("28RyA");




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $44899978b51916c1$var$_excluded = [
    "className"
];
const $44899978b51916c1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $44899978b51916c1$var$GridPanelContentRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent',
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400
});
function $44899978b51916c1$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $44899978b51916c1$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $44899978b51916c1$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($44899978b51916c1$var$GridPanelContentRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $fa159fc41cef284e$var$_excluded = [
    "className"
];
const $fa159fc41cef284e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $fa159fc41cef284e$var$GridPanelFooterRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter',
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between'
    }));
function $fa159fc41cef284e$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $fa159fc41cef284e$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $fa159fc41cef284e$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($fa159fc41cef284e$var$GridPanelFooterRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $52bd46781b899c0d$var$_excluded = [
    "className"
];
const $52bd46781b899c0d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelHeader'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $52bd46781b899c0d$var$GridPanelHeaderRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelHeader',
    overridesResolver: (props, styles)=>styles.panelHeader
})(({ theme: theme })=>({
        padding: theme.spacing(1)
    }));
function $52bd46781b899c0d$export$f0388ac20c4d2ecc(props) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $52bd46781b899c0d$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $52bd46781b899c0d$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($52bd46781b899c0d$var$GridPanelHeaderRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $c343671a1eca4e8f$var$_excluded = [
    "className",
    "slotProps"
];
const $c343671a1eca4e8f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $c343671a1eca4e8f$var$GridPanelWrapperRoot = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper',
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $c343671a1eca4e8f$var$isEnabled = ()=>true;
const $c343671a1eca4e8f$export$6a36e1ca07bd502c = /*#__PURE__*/ $jSIPP.forwardRef(function GridPanelWrapper(props, ref) {
    const { className: className, slotProps: slotProps = {} } = props, other = (0, $cMu4A.default)(props, $c343671a1eca4e8f$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $c343671a1eca4e8f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $52a926e13f10426d$export$2e2bcd8739ae039), (0, $erOpW.default)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: $c343671a1eca4e8f$var$isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($c343671a1eca4e8f$var$GridPanelWrapperRoot, (0, $erOpW.default)({
            ref: ref,
            tabIndex: -1,
            className: (0, $86B3v.default)(className, classes.root),
            ownerState: rootProps
        }, other))
    }));
});


// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.
const $7e55222633252920$export$db163d1350df1623 = false;





var $4uaIU = parcelRequire("4uaIU");
const $8ebd03dccdb426e8$var$_excluded = [
    "sort",
    "searchPredicate",
    "autoFocusSearchField",
    "disableHideAllButton",
    "disableShowAllButton",
    "getTogglableColumns"
];
const $8ebd03dccdb426e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsPanel'
        ],
        columnsPanelRow: [
            'columnsPanelRow'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $8ebd03dccdb426e8$var$GridColumnsPanelRoot = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanel',
    overridesResolver: (props, styles)=>styles.columnsPanel
})({
    padding: '8px 0px 8px 8px'
});
const $8ebd03dccdb426e8$var$GridColumnsPanelRowRoot = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanelRow',
    overridesResolver: (props, styles)=>styles.columnsPanelRow
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1px 8px 1px 7px',
        [`& .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).root}`]: {
            marginRight: theme.spacing(0.5)
        }
    }));
const $8ebd03dccdb426e8$var$GridIconButtonRoot = (0, $28RyA.default)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039))({
    justifyContent: 'flex-end'
});
const $8ebd03dccdb426e8$var$collator = new Intl.Collator();
const $8ebd03dccdb426e8$var$defaultSearchPredicate = (column, searchValue)=>{
    return (column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
};
function $8ebd03dccdb426e8$export$39d43456ec96cf57(props) {
    var _rootProps$slotProps, _rootProps$slotProps3, _rootProps$slotProps4;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const searchInputRef = $jSIPP.useRef(null);
    const columns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd));
    const columnVisibilityModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4));
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const [searchValue, setSearchValue] = $jSIPP.useState('');
    const classes = $8ebd03dccdb426e8$var$useUtilityClasses(rootProps);
    const { sort: sort, searchPredicate: searchPredicate = $8ebd03dccdb426e8$var$defaultSearchPredicate, autoFocusSearchField: autoFocusSearchField = true, disableHideAllButton: disableHideAllButton = false, disableShowAllButton: disableShowAllButton = false, getTogglableColumns: getTogglableColumns } = props, other = (0, $cMu4A.default)(props, $8ebd03dccdb426e8$var$_excluded);
    const sortedColumns = $jSIPP.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$8ebd03dccdb426e8$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$8ebd03dccdb426e8$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const toggleAllColumns = $jSIPP.useCallback((isVisible)=>{
        const currentModel = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
        const newModel = (0, $erOpW.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        columns.forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns
    ]);
    const handleSearchValueChange = $jSIPP.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const currentColumns = $jSIPP.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const firstSwitchRef = $jSIPP.useRef(null);
    $jSIPP.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $c343671a1eca4e8f$export$6a36e1ca07bd502c), (0, $erOpW.default)({}, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $52bd46781b899c0d$export$f0388ac20c4d2ecc), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTextField, (0, $erOpW.default)({
                    label: apiRef.current.getLocaleText('columnsPanelTextFieldLabel'),
                    placeholder: apiRef.current.getLocaleText('columnsPanelTextFieldPlaceholder'),
                    inputRef: searchInputRef,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "standard",
                    fullWidth: true
                }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField))
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44899978b51916c1$export$1b4102a66373332b), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)($8ebd03dccdb426e8$var$GridColumnsPanelRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: currentColumns.map((column)=>{
                        var _rootProps$slotProps2;
                        return /*#__PURE__*/ (0, $4uaIU.jsxs)($8ebd03dccdb426e8$var$GridColumnsPanelRowRoot, {
                            className: classes.columnsPanelRow,
                            ownerState: rootProps,
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $97749ece2376eb3c$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSwitch, (0, $erOpW.default)({
                                        disabled: column.hideable === false,
                                        checked: columnVisibilityModel[column.field] !== false,
                                        onClick: toggleColumn,
                                        name: column.field,
                                        size: "small",
                                        inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                                    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSwitch)),
                                    label: column.headerName || column.field
                                }),
                                !rootProps.disableColumnReorder && (0, $7e55222633252920$export$db163d1350df1623) && /*#__PURE__*/ (0, $4uaIU.jsx)($8ebd03dccdb426e8$var$GridIconButtonRoot, {
                                    draggable: true,
                                    "aria-label": apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    title: apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    size: "small",
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnReorderIcon, {})
                                })
                            ]
                        }, column.field);
                    })
                })
            }),
            disableShowAllButton && disableHideAllButton ? null : /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $fa159fc41cef284e$export$18e44097a2744a), {
                children: [
                    !disableHideAllButton ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                        onClick: ()=>toggleAllColumns(false)
                    }, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseButton, {
                        disabled: disableHideAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelHideAllButton')
                    })) : /*#__PURE__*/ (0, $4uaIU.jsx)("span", {}),
                    !disableShowAllButton ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                        onClick: ()=>toggleAllColumns(true)
                    }, (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseButton, {
                        disabled: disableShowAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelShowAllButton')
                    })) : null
                ]
            })
        ]
    }));
}


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");







var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $86B3v = parcelRequire("86B3v");








var $4uaIU = parcelRequire("4uaIU");
const $80d32cfc46e950b3$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "multiFilterOperator",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "children"
], $80d32cfc46e950b3$var$_excluded2 = [
    "InputComponentProps"
];
const $80d32cfc46e950b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $80d32cfc46e950b3$var$GridFilterFormRoot = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm',
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme: theme })=>({
        display: 'flex',
        padding: theme.spacing(1)
    }));
const $80d32cfc46e950b3$var$FilterFormDeleteIcon = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon',
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme: theme })=>({
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const $80d32cfc46e950b3$var$FilterFormLogicOperatorInput = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: 'end'
});
const $80d32cfc46e950b3$var$FilterFormColumnInput = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput',
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const $80d32cfc46e950b3$var$FilterFormOperatorInput = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 120
});
const $80d32cfc46e950b3$var$FilterFormValueInput = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput',
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const $80d32cfc46e950b3$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And:
            return 'filterPanelOperatorAnd';
        case (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $80d32cfc46e950b3$var$getColumnLabel = (col)=>col.headerName || col.field;
const $80d32cfc46e950b3$var$collator = new Intl.Collator();
const $80d32cfc46e950b3$export$4c95feba7016dbe7 = /*#__PURE__*/ $jSIPP.forwardRef(function GridFilterForm(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2, _baseSelectProps$nati, _rootProps$slotProps3, _rootProps$slotProps4, _rootProps$slotProps5, _rootProps$slotProps6, _rootProps$slotProps7, _rootProps$slotProps8, _currentColumn$filter2;
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, multiFilterOperator: multiFilterOperator, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And,
        (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {} } = props, other = (0, $cMu4A.default)(props, $80d32cfc46e950b3$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const filterableColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$2cad659ba95fed71));
    const filterModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5));
    const columnSelectId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const columnSelectLabelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const operatorSelectId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const operatorSelectLabelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $80d32cfc46e950b3$var$useUtilityClasses(rootProps);
    const valueRef = $jSIPP.useRef(null);
    const filterSelectorRef = $jSIPP.useRef(null);
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseFormControl) || {};
    const baseSelectProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {};
    const isBaseSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const baseInputLabelProps = ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel) || {};
    const baseSelectOptionProps = ((_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption) || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $cMu4A.default)(valueInputProps, $80d32cfc46e950b3$var$_excluded2);
    const filteredColumns = $jSIPP.useMemo(()=>{
        if (filterColumns === undefined || typeof filterColumns !== 'function') return filterableColumns;
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: (filterModel == null ? void 0 : filterModel.items) || []
        });
        return filterableColumns.filter((column)=>filteredFields.includes(column.field));
    }, [
        filterColumns,
        filterModel == null ? void 0 : filterModel.items,
        filterableColumns,
        item.field
    ]);
    const sortedFilteredColumns = $jSIPP.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$80d32cfc46e950b3$var$collator.compare($80d32cfc46e950b3$var$getColumnLabel(a), $80d32cfc46e950b3$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$80d32cfc46e950b3$var$collator.compare($80d32cfc46e950b3$var$getColumnLabel(a), $80d32cfc46e950b3$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $jSIPP.useMemo(()=>{
        var _currentColumn$filter;
        if (!item.operator || !currentColumn) return null;
        return (_currentColumn$filter = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $jSIPP.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseItemValue = !newOperator.InputComponent || newOperator.InputComponent !== (currentOperator == null ? void 0 : currentOperator.InputComponent) || column.type !== currentColumn.type;
        applyFilterChanges((0, $erOpW.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $jSIPP.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn == null ? void 0 : currentColumn.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !(newOperator != null && newOperator.InputComponent) || (newOperator == null ? void 0 : newOperator.InputComponent) !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
        applyFilterChanges((0, $erOpW.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $jSIPP.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And.toString() ? (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And : (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        if (rootProps.disableMultipleColumnsFiltering) {
            if (item.value === undefined) deleteFilter(item);
            else // TODO v6: simplify the behavior by always remove the filter form
            applyFilterChanges((0, $erOpW.default)({}, item, {
                value: undefined
            }));
        } else deleteFilter(item);
    };
    $jSIPP.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator != null && currentOperator.InputComponent) {
                    var _valueRef$current;
                    valueRef == null || (_valueRef$current = valueRef.current) == null || _valueRef$current.focus();
                } else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($80d32cfc46e950b3$var$GridFilterFormRoot, (0, $erOpW.default)({
        ref: ref,
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($80d32cfc46e950b3$var$FilterFormDeleteIcon, (0, $erOpW.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, $86B3v.default)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small"
                }, (_rootProps$slotProps5 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps5.baseIconButton, {
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)($80d32cfc46e950b3$var$FilterFormLogicOperatorInput, (0, $erOpW.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: (0, $erOpW.default)({
                    display: hasLogicOperatorColumn ? 'flex' : 'none',
                    visibility: showMultiFilterOperators ? 'visible' : 'hidden'
                }, baseFormControlProps.sx || {}, logicOperatorInputProps.sx || {}),
                className: (0, $86B3v.default)(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelect, (0, $erOpW.default)({
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    },
                    value: multiFilterOperator,
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                    native: isBaseSelectNative
                }, (_rootProps$slotProps6 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps6.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $jSIPP.createElement)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText($80d32cfc46e950b3$var$getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, $4uaIU.jsxs)($80d32cfc46e950b3$var$FilterFormColumnInput, (0, $erOpW.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, $86B3v.default)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseInputLabel, (0, $erOpW.default)({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelColumns')
                    })),
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelect, (0, $erOpW.default)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText('filterPanelColumns'),
                        value: item.field || '',
                        onChange: changeColumn,
                        native: isBaseSelectNative
                    }, (_rootProps$slotProps7 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps7.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $jSIPP.createElement)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), $80d32cfc46e950b3$var$getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $4uaIU.jsxs)($80d32cfc46e950b3$var$FilterFormOperatorInput, (0, $erOpW.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, $86B3v.default)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseInputLabel, (0, $erOpW.default)({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelOperator')
                    })),
                    /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseSelect, (0, $erOpW.default)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText('filterPanelOperator'),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef
                    }, (_rootProps$slotProps8 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps8.baseSelect, {
                        children: currentColumn == null || (_currentColumn$filter2 = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter2.map((operator)=>/*#__PURE__*/ (0, $jSIPP.createElement)(rootProps.slots.baseSelectOption, (0, $erOpW.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $61i5U.default)(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)($80d32cfc46e950b3$var$FilterFormValueInput, (0, $erOpW.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, $86B3v.default)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator != null && currentOperator.InputComponent ? /*#__PURE__*/ (0, $4uaIU.jsx)(currentOperator.InputComponent, (0, $erOpW.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef
                }, currentOperator.InputComponentProps, InputComponentProps)) : null
            }))
        ]
    }));
});







var $4uaIU = parcelRequire("4uaIU");
const $e00f3ba538d93e0d$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $e00f3ba538d93e0d$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $e00f3ba538d93e0d$export$32c6e72be8ad862c = /*#__PURE__*/ $jSIPP.forwardRef(function GridFilterPanel(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const filterModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5));
    const filterableColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$2cad659ba95fed71));
    const lastFilterRef = $jSIPP.useRef(null);
    const placeholderFilter = $jSIPP.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).And,
        (0, $e657c7843f6f7af4$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $cMu4A.default)(props, $e00f3ba538d93e0d$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $jSIPP.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $jSIPP.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: (filterModel == null ? void 0 : filterModel.items) || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>{
            var _colDef$filterOperato;
            return (_colDef$filterOperato = colDef.filterOperators) == null ? void 0 : _colDef$filterOperato.length;
        });
        if (!nextColumnWithOperator) return null;
        return $e00f3ba538d93e0d$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel == null ? void 0 : filterModel.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $jSIPP.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $e00f3ba538d93e0d$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $jSIPP.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const addNewFilter = ()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    };
    const deleteFilter = $jSIPP.useCallback((item)=>{
        const shouldCloseFilterPanel = items.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        items.length
    ]);
    const handleRemoveAll = ()=>{
        if (items.length === 1 && items[0].value === undefined) {
            apiRef.current.deleteFilterItem(items[0]);
            apiRef.current.hideFilterPanel();
        }
        apiRef.current.setFilterModel((0, $erOpW.default)({}, filterModel, {
            items: []
        }));
    };
    $jSIPP.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $jSIPP.useEffect(()=>{
        if (items.length > 0) lastFilterRef.current.focus();
    }, [
        items.length
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $c343671a1eca4e8f$export$6a36e1ca07bd502c), (0, $erOpW.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44899978b51916c1$export$1b4102a66373332b), {
                children: items.map((item, index)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $80d32cfc46e950b3$export$4c95feba7016dbe7), (0, $erOpW.default)({
                        item: item,
                        applyFilterChanges: applyFilter,
                        deleteFilter: deleteFilter,
                        hasMultipleFilters: hasMultipleFilters,
                        showMultiFilterOperators: index > 0,
                        multiFilterOperator: filterModel.logicOperator,
                        disableMultiFilterOperator: index !== 1,
                        applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                        focusElementRef: index === items.length - 1 ? lastFilterRef : null,
                        logicOperators: logicOperators,
                        columnsSort: columnsSort
                    }, filterFormProps), item.id == null ? index : item.id))
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $fa159fc41cef284e$export$18e44097a2744a), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $4uaIU.jsx)("span", {}),
                    !disableRemoveAllButton ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");







var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $b142dec89e21c311$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $b142dec89e21c311$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $b142dec89e21c311$var$GridSelectedRowCountRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount',
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2),
        visibility: 'hidden',
        width: 0,
        height: 0,
        [theme.breakpoints.up('sm')]: {
            visibility: 'visible',
            width: 'auto',
            height: 'auto'
        }
    }));
const $b142dec89e21c311$export$e4c9f87515ca4b49 = /*#__PURE__*/ $jSIPP.forwardRef(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $cMu4A.default)(props, $b142dec89e21c311$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $b142dec89e21c311$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($b142dec89e21c311$var$GridSelectedRowCountRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: rowSelectedText
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $3202f1861caf873f$var$_excluded = [
    "className"
];
const $3202f1861caf873f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $3202f1861caf873f$var$GridFooterContainerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer',
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $3202f1861caf873f$export$dc81d5e0847a9805 = /*#__PURE__*/ $jSIPP.forwardRef(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $3202f1861caf873f$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $3202f1861caf873f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($3202f1861caf873f$var$GridFooterContainerRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});




var $4uaIU = parcelRequire("4uaIU");
const $1255ddd7590fafe9$export$6ef0bfefb022d11e = /*#__PURE__*/ $jSIPP.forwardRef(function GridFooter(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const totalTopLevelRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$800ab0a68a9efc4f));
    const selectedRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $8ea15f807bcaac04$export$2e16a09b9ae82bd3));
    const visibleTopLevelRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$f88efd30675963d1));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b142dec89e21c311$export$e4c9f87515ca4b49), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $4uaIU.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.footerRowCount, (0, $erOpW.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.pagination, (0, $erOpW.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.pagination));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $3202f1861caf873f$export$dc81d5e0847a9805), (0, $erOpW.default)({
        ref: ref
    }, props, {
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $lebkq = parcelRequire("lebkq");

var $iLAKr = parcelRequire("iLAKr");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $ebd988bd010af1c2$export$29cad1383b3f235d(slot) {
    return (0, $geF11.default)('MuiCircularProgress', slot);
}
const $ebd988bd010af1c2$var$circularProgressClasses = (0, $rARwS.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $ebd988bd010af1c2$export$2e2bcd8739ae039 = $ebd988bd010af1c2$var$circularProgressClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
let $fc1d6c67a263744c$var$_ = (t)=>t, $fc1d6c67a263744c$var$t, $fc1d6c67a263744c$var$t1, $fc1d6c67a263744c$var$t2, $fc1d6c67a263744c$var$t3;
const $fc1d6c67a263744c$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $fc1d6c67a263744c$var$_1 = (t)=>t, $fc1d6c67a263744c$var$_t, $fc1d6c67a263744c$var$_t2, $fc1d6c67a263744c$var$_t3, $fc1d6c67a263744c$var$_t4;
const $fc1d6c67a263744c$var$SIZE = 44;
const $fc1d6c67a263744c$var$circularRotateKeyframe = (0, $lebkq.keyframes)($fc1d6c67a263744c$var$_t || ($fc1d6c67a263744c$var$_t = $fc1d6c67a263744c$var$_1($fc1d6c67a263744c$var$t || ($fc1d6c67a263744c$var$t = $fc1d6c67a263744c$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $fc1d6c67a263744c$var$circularDashKeyframe = (0, $lebkq.keyframes)($fc1d6c67a263744c$var$_t2 || ($fc1d6c67a263744c$var$_t2 = $fc1d6c67a263744c$var$_1($fc1d6c67a263744c$var$t1 || ($fc1d6c67a263744c$var$t1 = $fc1d6c67a263744c$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $fc1d6c67a263744c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $iLAKr.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $iLAKr.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $ebd988bd010af1c2$export$29cad1383b3f235d), classes);
};
const $fc1d6c67a263744c$var$CircularProgressRoot = (0, $28RyA.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $iLAKr.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $lebkq.css)($fc1d6c67a263744c$var$_t3 || ($fc1d6c67a263744c$var$_t3 = $fc1d6c67a263744c$var$_1($fc1d6c67a263744c$var$t2 || ($fc1d6c67a263744c$var$t2 = $fc1d6c67a263744c$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $fc1d6c67a263744c$var$circularRotateKeyframe));
const $fc1d6c67a263744c$var$CircularProgressSVG = (0, $28RyA.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $fc1d6c67a263744c$var$CircularProgressCircle = (0, $28RyA.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $iLAKr.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $lebkq.css)($fc1d6c67a263744c$var$_t4 || ($fc1d6c67a263744c$var$_t4 = $fc1d6c67a263744c$var$_1($fc1d6c67a263744c$var$t3 || ($fc1d6c67a263744c$var$t3 = $fc1d6c67a263744c$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $fc1d6c67a263744c$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $fc1d6c67a263744c$var$CircularProgress = /*#__PURE__*/ $jSIPP.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $cMu4A.default)(props, $fc1d6c67a263744c$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $fc1d6c67a263744c$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($fc1d6c67a263744c$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $4uaIU.jsx)($fc1d6c67a263744c$var$CircularProgressRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        style: (0, $erOpW.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($fc1d6c67a263744c$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$fc1d6c67a263744c$var$SIZE / 2} ${$fc1d6c67a263744c$var$SIZE / 2} ${$fc1d6c67a263744c$var$SIZE} ${$fc1d6c67a263744c$var$SIZE}`,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)($fc1d6c67a263744c$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $fc1d6c67a263744c$var$SIZE,
                cy: $fc1d6c67a263744c$var$SIZE,
                r: ($fc1d6c67a263744c$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $fc1d6c67a263744c$export$2e2bcd8739ae039 = $fc1d6c67a263744c$var$CircularProgress;



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $d59487dd3f89b782$var$_excluded = [
    "className"
];
const $d59487dd3f89b782$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $d59487dd3f89b782$var$GridOverlayRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay',
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const $d59487dd3f89b782$export$1c41ff9dbe11e487 = /*#__PURE__*/ $jSIPP.forwardRef(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $d59487dd3f89b782$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $d59487dd3f89b782$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d59487dd3f89b782$var$GridOverlayRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});



var $4uaIU = parcelRequire("4uaIU");
const $7d47721ec9d85dc7$export$69e47a4ea5ffa191 = /*#__PURE__*/ $jSIPP.forwardRef(function GridLoadingOverlay(props, ref) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d59487dd3f89b782$export$1c41ff9dbe11e487), (0, $erOpW.default)({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $fc1d6c67a263744c$export$2e2bcd8739ae039), {})
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




var $4uaIU = parcelRequire("4uaIU");
const $77e626fa9f1d4924$export$a25f04494ce53510 = /*#__PURE__*/ $jSIPP.forwardRef(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d59487dd3f89b782$export$1c41ff9dbe11e487), (0, $erOpW.default)({
        ref: ref
    }, props, {
        children: noRowsLabel
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");



var $i3Yji = parcelRequire("i3Yji");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");




var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $iLAKr = parcelRequire("iLAKr");

var $jSIPP = parcelRequire("jSIPP");
'use client';
/**
 * @ignore - internal component.
 */ const $ea91d9ab25de0377$var$TableContext = /*#__PURE__*/ $jSIPP.createContext();
var $ea91d9ab25de0377$export$2e2bcd8739ae039 = $ea91d9ab25de0377$var$TableContext;



var $jSIPP = parcelRequire("jSIPP");
/**
 * @ignore - internal component.
 */ const $22768d29ea78090e$var$Tablelvl2Context = /*#__PURE__*/ $jSIPP.createContext();
var $22768d29ea78090e$export$2e2bcd8739ae039 = $22768d29ea78090e$var$Tablelvl2Context;



var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $1779e7fcb71dba71$export$33a0f07a16a10b1b(slot) {
    return (0, $geF11.default)('MuiTableCell', slot);
}
const $1779e7fcb71dba71$var$tableCellClasses = (0, $rARwS.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $1779e7fcb71dba71$export$2e2bcd8739ae039 = $1779e7fcb71dba71$var$tableCellClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $120d7c5a8852dced$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $120d7c5a8852dced$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $iLAKr.default)(align)}`,
            padding !== 'normal' && `padding${(0, $iLAKr.default)(padding)}`,
            `size${(0, $iLAKr.default)(size)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $1779e7fcb71dba71$export$33a0f07a16a10b1b), classes);
};
const $120d7c5a8852dced$var$TableCellRoot = (0, $28RyA.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $iLAKr.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $iLAKr.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $iLAKr.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $hnF8Y.lighten)((0, $hnF8Y.alpha)(theme.palette.divider, 1), 0.88) : (0, $hnF8Y.darken)((0, $hnF8Y.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $1779e7fcb71dba71$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $120d7c5a8852dced$var$TableCell = /*#__PURE__*/ $jSIPP.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $cMu4A.default)(props, $120d7c5a8852dced$var$_excluded);
    const table = $jSIPP.useContext((0, $ea91d9ab25de0377$export$2e2bcd8739ae039));
    const tablelvl2 = $jSIPP.useContext((0, $22768d29ea78090e$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $erOpW.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $120d7c5a8852dced$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $4uaIU.jsx)($120d7c5a8852dced$var$TableCellRoot, (0, $erOpW.default)({
        as: component,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $120d7c5a8852dced$export$2e2bcd8739ae039 = $120d7c5a8852dced$var$TableCell;




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $0c82a21be9272770$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $4fe623678deec284$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');



parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $0f5effab29f8ede5$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $2cf1aa970d6038c0$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $a39824ba9f4f13ef$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $a39824ba9f4f13ef$var$TablePaginationActions = /*#__PURE__*/ $jSIPP.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $cMu4A.default)(props, $a39824ba9f4f13ef$var$_excluded);
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $f39aadf3bf12995a$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $f39aadf3bf12995a$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $f39aadf3bf12995a$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $f39aadf3bf12995a$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $2cf1aa970d6038c0$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $0f5effab29f8ede5$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $4fe623678deec284$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $0c82a21be9272770$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $4uaIU.jsx)(FirstButtonSlot, (0, $erOpW.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $4uaIU.jsx)(LastButtonIcon, (0, $erOpW.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $4uaIU.jsx)(FirstButtonIcon, (0, $erOpW.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)(PreviousButtonSlot, (0, $erOpW.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $4uaIU.jsx)(NextButtonIcon, (0, $erOpW.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $4uaIU.jsx)(PreviousButtonIcon, (0, $erOpW.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)(NextButtonSlot, (0, $erOpW.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $4uaIU.jsx)(PreviousButtonIcon, (0, $erOpW.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $4uaIU.jsx)(NextButtonIcon, (0, $erOpW.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $4uaIU.jsx)(LastButtonSlot, (0, $erOpW.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $4uaIU.jsx)(FirstButtonIcon, (0, $erOpW.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $4uaIU.jsx)(LastButtonIcon, (0, $erOpW.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $a39824ba9f4f13ef$export$2e2bcd8739ae039 = $a39824ba9f4f13ef$var$TablePaginationActions;




var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $5c014c767d6a9351$export$909e637b22246f4c(slot) {
    return (0, $geF11.default)('MuiTablePagination', slot);
}
const $5c014c767d6a9351$var$tablePaginationClasses = (0, $rARwS.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $5c014c767d6a9351$export$2e2bcd8739ae039 = $5c014c767d6a9351$var$tablePaginationClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
var $e9701aea9d72f38f$var$_InputBase;
const $e9701aea9d72f38f$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $e9701aea9d72f38f$var$TablePaginationRoot = (0, $28RyA.default)((0, $120d7c5a8852dced$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $e9701aea9d72f38f$var$TablePaginationToolbar = (0, $28RyA.default)((0, $d29ae86b84b6db22$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $erOpW.default)({
            [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $e9701aea9d72f38f$var$TablePaginationSpacer = (0, $28RyA.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $e9701aea9d72f38f$var$TablePaginationSelectLabel = (0, $28RyA.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $erOpW.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $e9701aea9d72f38f$var$TablePaginationSelect = (0, $28RyA.default)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $erOpW.default)({
            [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $e9701aea9d72f38f$var$TablePaginationMenuItem = (0, $28RyA.default)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $e9701aea9d72f38f$var$TablePaginationDisplayedRows = (0, $28RyA.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $erOpW.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $e9701aea9d72f38f$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $e9701aea9d72f38f$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $e9701aea9d72f38f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $5c014c767d6a9351$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $e9701aea9d72f38f$var$TablePagination = /*#__PURE__*/ $jSIPP.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $a39824ba9f4f13ef$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $120d7c5a8852dced$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $e9701aea9d72f38f$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $e9701aea9d72f38f$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cMu4A.default)(props, $e9701aea9d72f38f$var$_excluded);
    const ownerState = props;
    const classes = $e9701aea9d72f38f$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $e9701aea9d72f38f$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $120d7c5a8852dced$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $b2e317da5452a23f$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $b2e317da5452a23f$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)($e9701aea9d72f38f$var$TablePaginationRoot, (0, $erOpW.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)($e9701aea9d72f38f$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)($e9701aea9d72f38f$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $4uaIU.jsx)($e9701aea9d72f38f$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $4uaIU.jsx)($e9701aea9d72f38f$var$TablePaginationSelect, (0, $erOpW.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $e9701aea9d72f38f$var$_InputBase || ($e9701aea9d72f38f$var$_InputBase = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $495d300f509482ea$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $erOpW.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $86B3v.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $86B3v.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $86B3v.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $jSIPP.createElement)(MenuItemComponent, (0, $erOpW.default)({}, !(0, $6388f16c5f351c5b$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $4uaIU.jsx)($e9701aea9d72f38f$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $e9701aea9d72f38f$export$2e2bcd8739ae039 = $e9701aea9d72f38f$var$TablePagination;



var $28RyA = parcelRequire("28RyA");






var $4uaIU = parcelRequire("4uaIU");
const $8c901b4423bc4ddb$var$GridPaginationRoot = (0, $28RyA.default)((0, $e9701aea9d72f38f$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${(0, $5c014c767d6a9351$export$2e2bcd8739ae039).input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $8c901b4423bc4ddb$export$fa9a503101f8d472 = /*#__PURE__*/ $jSIPP.forwardRef(function GridPagination(props, ref) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const paginationModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $23354dc00cec9d31$export$ccc9f04e59d0d8e6));
    const visibleTopLevelRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$f88efd30675963d1));
    const rowCount = $jSIPP.useMemo(()=>{
        var _ref, _rootProps$rowCount;
        return (_ref = (_rootProps$rowCount = rootProps.rowCount) != null ? _rootProps$rowCount : visibleTopLevelRowCount) != null ? _ref : 0;
    }, [
        rootProps.rowCount,
        visibleTopLevelRowCount
    ]);
    const lastPage = $jSIPP.useMemo(()=>Math.floor(rowCount / (paginationModel.pageSize || 1)), [
        rowCount,
        paginationModel.pageSize
    ]);
    const handlePageSizeChange = $jSIPP.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $jSIPP.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    var _rootProps$pagination, _rootProps$pagination2;
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, $4uaIU.jsx)($8c901b4423bc4ddb$var$GridPaginationRoot, (0, $erOpW.default)({
        ref: ref,
        component: "div",
        count: rowCount,
        page: paginationModel.page <= lastPage ? paginationModel.page : lastPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, apiRef.current.getLocaleText('MuiTablePagination'), props));
});


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");








var $4uaIU = parcelRequire("4uaIU");
const $d2a530d6fca65d32$var$_excluded = [
    "children",
    "className",
    "classes"
];
const $d2a530d6fca65d32$export$e95ad8c1c287de86 = (0, $rARwS.default)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $d2a530d6fca65d32$var$GridPanelRoot = (0, $28RyA.default)((0, $b774b692670e0e71$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: (props, styles)=>styles.panel
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $d2a530d6fca65d32$var$GridPaperRoot = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex'
    }));
const $d2a530d6fca65d32$export$cf917897ad2588b = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    const { children: children, className: className } = props, other = (0, $cMu4A.default)(props, $d2a530d6fca65d32$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $d2a530d6fca65d32$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $jSIPP.useState(false);
    const handleClickAway = $jSIPP.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = $jSIPP.useCallback((event)=>{
        if ((0, $2200ee459e36b6d0$export$a6587fe901c3baf7)(event.key)) apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = $jSIPP.useMemo(()=>[
            {
                name: 'flip',
                enabled: false
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = $jSIPP.useState(null);
    $jSIPP.useEffect(()=>{
        var _apiRef$current$rootE;
        const columnHeadersElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null || (_apiRef$current$rootE = _apiRef$current$rootE.current) == null ? void 0 : _apiRef$current$rootE.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaders}`);
        if (columnHeadersElement) setAnchorEl(columnHeadersElement);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d2a530d6fca65d32$var$GridPanelRoot, (0, $erOpW.default)({
        ref: ref,
        placement: "bottom-start",
        className: (0, $86B3v.default)(className, classes.panel),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1f8be5e6d94a1f79$export$58385c17fee43f89), {
            mouseEvent: "onMouseUp",
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)($d2a530d6fca65d32$var$GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");







var $4uaIU = parcelRequire("4uaIU");
const $43bb97a9fbb505ee$export$6cff59e5608ce17d = /*#__PURE__*/ $jSIPP.forwardRef(function GridPreferencesPanel(props, ref) {
    var _preferencePanelState, _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const columns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd));
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const preferencePanelState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $77a28296cab754a7$export$37e5474577e02878));
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, (_preferencePanelState = preferencePanelState.openedPanelValue) != null ? _preferencePanelState : (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.panel, (0, $erOpW.default)({
        ref: ref,
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.panel, props, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.basePopper, {
        children: panelContent
    }));
});


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $jSIPP = parcelRequire("jSIPP");

function $2dcb0305bd801431$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $jSIPP.memo(component, (0, $de90e10b480940f8$export$84d14f151b531ccb));
}


















var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");

// Based on https://stackoverflow.com/a/59518678
let $75f51b638879a99a$var$cachedSupportsPreventScroll;
function $75f51b638879a99a$export$ed1f8daf96fc68fb() {
    if ($75f51b638879a99a$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $75f51b638879a99a$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $75f51b638879a99a$var$cachedSupportsPreventScroll;
}









var $jSIPP = parcelRequire("jSIPP");




class $d72289442a7b7d9e$export$f6bd549412d13610 extends Error {
}
function $d72289442a7b7d9e$export$d5da41ef394db9ef(apiRef, props) {
    const { getRowId: getRowId } = props;
    const getColumnHeaderParams = $jSIPP.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $jSIPP.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $d72289442a7b7d9e$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getBaseCellParams = $jSIPP.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $d72289442a7b7d9e$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        const cellTabIndex = (0, $196c4c77eabe7b5f$export$2c47652a1f657d56)(apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            value: row[field],
            colDef: apiRef.current.getColumn(field),
            cellMode: apiRef.current.getCellMode(id, field),
            api: apiRef.current,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $jSIPP.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const value = apiRef.current.getCellValue(id, field);
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $d72289442a7b7d9e$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
        const cellTabIndex = (0, $196c4c77eabe7b5f$export$2c47652a1f657d56)(apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: apiRef.current.getCellMode(id, field),
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            value: value,
            formattedValue: value,
            isEditable: false
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter({
            id: id,
            field: params.field,
            value: params.value,
            api: apiRef.current
        });
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellValue = $jSIPP.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        if (!colDef || !colDef.valueGetter) {
            const rowModel = apiRef.current.getRow(id);
            if (!rowModel) throw new $d72289442a7b7d9e$export$f6bd549412d13610(`No row with id #${id} found`);
            return rowModel[field];
        }
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        apiRef,
        getBaseCellParams
    ]);
    const getRowValue = $jSIPP.useCallback((row, colDef)=>{
        var _getRowId;
        const id = (0, $db5319c56f201804$export$e8632b32bb8837db) in row ? row[0, $db5319c56f201804$export$e8632b32bb8837db] : (_getRowId = getRowId == null ? void 0 : getRowId(row)) != null ? _getRowId : row.id;
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        getBaseCellParams,
        getRowId
    ]);
    const getRowFormattedValue = $jSIPP.useCallback((row, colDef)=>{
        var _ref;
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        const id = (_ref = getRowId ? getRowId(row) : row.id) != null ? _ref : row[0, $db5319c56f201804$export$e8632b32bb8837db];
        const field = colDef.field;
        return colDef.valueFormatter({
            id: id,
            field: field,
            value: value,
            api: apiRef.current
        });
    }, [
        apiRef,
        getRowId,
        getRowValue
    ]);
    const getColumnHeaderElement = $jSIPP.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $26a7a0c939103688$export$94318ffb75913a0b)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $jSIPP.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $26a7a0c939103688$export$9bc8bb868a922a5f)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $jSIPP.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $26a7a0c939103688$export$44827662627a59)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, paramsApi, 'public');
}



var $4uaIU = parcelRequire("4uaIU");
const $314a487430334cd5$var$_excluded = [
    "changeReason",
    "unstable_updateValueOnRender"
], $314a487430334cd5$var$_excluded2 = [
    "align",
    "children",
    "editCellState",
    "colIndex",
    "column",
    "cellMode",
    "field",
    "formattedValue",
    "hasFocus",
    "height",
    "isEditable",
    "isSelected",
    "rowId",
    "tabIndex",
    "style",
    "value",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $314a487430334cd5$var$_excluded3 = [
    "column",
    "rowId",
    "editCellState",
    "align",
    "children",
    "colIndex",
    "height",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver",
    "style"
], $314a487430334cd5$var$_excluded4 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $314a487430334cd5$var$EMPTY_CELL_PARAMS = {
    id: -1,
    field: '__unset__',
    row: {},
    rowNode: {
        id: -1,
        depth: 0,
        type: 'leaf',
        parent: -1,
        groupingKey: null
    },
    colDef: {
        type: 'string',
        field: '__unset__',
        computedWidth: 0
    },
    cellMode: (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).View,
    hasFocus: false,
    tabIndex: -1,
    value: null,
    formattedValue: '__unset__',
    isEditable: false,
    api: {}
};
const $314a487430334cd5$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showRightBorder: showRightBorder, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $61i5U.default)(align)}`,
            isEditable && 'cell--editable',
            isSelected && 'selected',
            showRightBorder && 'cell--withRightBorder',
            isSelectionMode && !isEditable && 'cell--selectionMode',
            'withBorderColor'
        ],
        content: [
            'cellContent'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
let $314a487430334cd5$var$warnedOnce = false;
// GridCellWrapper is a compatibility layer for the V6 cell slot. If we can use the more efficient
// `GridCellV7`, we should. That component is a merge of `GridCellWrapper` and `GridCell`.
// TODO(v7): Remove the wrapper & cellV6 and use the cellV7 exclusively.
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $314a487430334cd5$var$GridCellWrapper = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    const { column: column, rowId: rowId, editCellState: editCellState } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const field = column.field;
    const cellParamsWithAPI = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, ()=>{
        // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
        // associated with `rowId`/`fieldId`, but this selector runs after the state has been
        // updated, while `rowId`/`fieldId` reference an entry in the old state.
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof (0, $d72289442a7b7d9e$export$f6bd549412d13610)) return $314a487430334cd5$var$EMPTY_CELL_PARAMS;
            throw e;
        }
    }, (0, $190d0dc02079d828$export$8da4c691e5695191));
    const isSelected = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    if (cellParamsWithAPI === $314a487430334cd5$var$EMPTY_CELL_PARAMS) return null;
    const { cellMode: cellMode, hasFocus: hasFocus, isEditable: isEditable, value: value, formattedValue: formattedValue } = cellParamsWithAPI;
    const managesOwnFocus = column.type === 'actions';
    const tabIndex = (cellMode === 'view' || !isEditable) && !managesOwnFocus ? cellParamsWithAPI.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field: field
    });
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    let children;
    if (editCellState == null && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push((0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--withRenderer']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (editCellState != null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $cMu4A.default)(editCellState, $314a487430334cd5$var$_excluded);
        const params = (0, $erOpW.default)({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--editing']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
    }
    const { slots: slots } = rootProps;
    const CellComponent = slots.cell;
    const cellProps = (0, $erOpW.default)({}, props, {
        ref: ref,
        field: field,
        formattedValue: formattedValue,
        hasFocus: hasFocus,
        isEditable: isEditable,
        isSelected: isSelected,
        value: value,
        cellMode: cellMode,
        children: children,
        tabIndex: tabIndex,
        className: (0, $86B3v.default)(classNames)
    });
    return /*#__PURE__*/ $jSIPP.createElement(CellComponent, cellProps);
});
const $314a487430334cd5$export$1ce951ee41d30605 = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    var _rootProps$experiment, _rootProps$experiment2;
    const { align: align, children: childrenProp, colIndex: colIndex, column: column, cellMode: cellMode, field: field, formattedValue: formattedValue, hasFocus: hasFocus, height: height, isEditable: isEditable, isSelected: isSelected, rowId: rowId, tabIndex: tabIndex, style: styleProp, value: value, width: width, className: className, showRightBorder: showRightBorder, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $cMu4A.default)(props, $314a487430334cd5$var$_excluded2);
    const valueToRender = formattedValue == null ? value : formattedValue;
    const cellRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, cellRef);
    const focusElementRef = $jSIPP.useRef(null);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        align: align,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        isSelected: isSelected
    };
    const classes = $314a487430334cd5$var$useUtilityClasses(ownerState);
    const publishMouseUp = $jSIPP.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $jSIPP.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $jSIPP.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = $jSIPP.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        };
        const cellStyle = (0, $erOpW.default)({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: height === 'auto' ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    $jSIPP.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) return;
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $75f51b638879a99a$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    let handleFocus = other.onFocus;
    var event;
    const managesOwnFocus = column.type === 'actions';
    let children = childrenProp;
    if (children === undefined) {
        const valueString = valueToRender == null ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ $jSIPP.isValidElement(children) && managesOwnFocus) children = /*#__PURE__*/ $jSIPP.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = (_rootProps$experiment2 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment2.ariaV7;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $4uaIU.jsx)("div", (0, $erOpW.default)({
        ref: handleRef,
        className: (0, $86B3v.default)(className, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    })));
});
const $314a487430334cd5$export$fc5dd9c3875d4ace = (0, $2dcb0305bd801431$export$fa306e0bc9a9d6b4)($314a487430334cd5$var$GridCellWrapper);
const $314a487430334cd5$var$GridCellV7 = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    var _getActions, _ref, _rootProps$unstable_c, _rootProps$experiment3, _rootProps$experiment4;
    const { column: column, rowId: rowId, editCellState: editCellState, align: align, colIndex: colIndex, height: height, width: width, className: className, showRightBorder: showRightBorder, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver, style: styleProp } = props, other = (0, $cMu4A.default)(props, $314a487430334cd5$var$_excluded3);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const field = column.field;
    const cellParamsWithAPI = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, ()=>{
        // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
        // associated with `rowId`/`fieldId`, but this selector runs after the state has been
        // updated, while `rowId`/`fieldId` reference an entry in the old state.
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof (0, $d72289442a7b7d9e$export$f6bd549412d13610)) return $314a487430334cd5$var$EMPTY_CELL_PARAMS;
            throw e;
        }
    }, (0, $190d0dc02079d828$export$8da4c691e5695191));
    const isSelected = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const { cellMode: cellMode, hasFocus: hasFocus, isEditable: isEditable, value: value, formattedValue: formattedValue } = cellParamsWithAPI;
    const canManageOwnFocus = column.type === 'actions' && ((_getActions = (_ref = column).getActions) == null ? void 0 : _getActions.call(_ref, apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled));
    const tabIndex = (cellMode === 'view' || !isEditable) && !canManageOwnFocus ? cellParamsWithAPI.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field: field
    });
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    const valueToRender = formattedValue == null ? value : formattedValue;
    const cellRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, cellRef);
    const focusElementRef = $jSIPP.useRef(null);
    // @ts-expect-error To access `unstable_cellSelection` flag as it's a `premium` feature
    const isSelectionMode = (_rootProps$unstable_c = rootProps.unstable_cellSelection) != null ? _rootProps$unstable_c : false;
    const ownerState = {
        align: align,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $314a487430334cd5$var$useUtilityClasses(ownerState);
    const publishMouseUp = $jSIPP.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $jSIPP.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $jSIPP.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = $jSIPP.useMemo(()=>{
        if (isNotVisible) return (0, $erOpW.default)({
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        }, styleProp);
        const cellStyle = (0, $erOpW.default)({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: height === 'auto' ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    $jSIPP.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) return;
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $75f51b638879a99a$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (cellParamsWithAPI === $314a487430334cd5$var$EMPTY_CELL_PARAMS) return null;
    let handleFocus = other.onFocus;
    var event;
    let children;
    if (editCellState == null && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push((0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--withRenderer']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (editCellState != null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $cMu4A.default)(editCellState, $314a487430334cd5$var$_excluded4);
        const params = (0, $erOpW.default)({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $4d97f950d65e57e8$export$2100d54e36406477)['cell--editing']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender == null ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ $jSIPP.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $jSIPP.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = (_rootProps$experiment4 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment4.ariaV7;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $4uaIU.jsx)("div", (0, $erOpW.default)({
        ref: handleRef,
        className: (0, $86B3v.default)(className, classNames, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    })));
});
const $314a487430334cd5$export$c5671ad6c68d814 = (0, $2dcb0305bd801431$export$fa306e0bc9a9d6b4)($314a487430334cd5$var$GridCellV7);




var $4uaIU = parcelRequire("4uaIU");
const $2447a053873bbd49$var$_excluded = [
    "selected",
    "hovered",
    "rowId",
    "row",
    "index",
    "style",
    "position",
    "rowHeight",
    "className",
    "visibleColumns",
    "renderedColumns",
    "containerWidth",
    "firstColumnToRender",
    "lastColumnToRender",
    "isLastVisible",
    "focusedCellColumnIndexNotInRange",
    "isNotVisible",
    "focusedCell",
    "tabbableCell",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $2447a053873bbd49$var$useUtilityClasses = (ownerState)=>{
    const { editable: editable, editing: editing, selected: selected, isLastVisible: isLastVisible, rowHeight: rowHeight, classes: classes } = ownerState;
    const slots = {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isLastVisible && 'row--lastVisible',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $2447a053873bbd49$var$EmptyCell({ width: width }) {
    if (!width) return null;
    const style = {
        width: width
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
        className: `${(0, $4d97f950d65e57e8$export$2100d54e36406477).cell} ${(0, $4d97f950d65e57e8$export$2100d54e36406477).withBorderColor}`,
        style: style
    }); // TODO change to .MuiDataGrid-emptyCell or .MuiDataGrid-rowFiller
}
const $2447a053873bbd49$var$GridRow = /*#__PURE__*/ $jSIPP.forwardRef(function GridRow(props, refProp) {
    const { selected: selected, hovered: hovered, rowId: rowId, row: row, index: index, style: styleProp, position: position, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, renderedColumns: renderedColumns, containerWidth: containerWidth, firstColumnToRender: firstColumnToRender, isLastVisible: isLastVisible = false, focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange, isNotVisible: isNotVisible, focusedCell: focusedCell, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $cMu4A.default)(props, $2447a053873bbd49$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const ref = $jSIPP.useRef(null);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, rootProps);
    const columnsTotalWidth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$ab20f9d33edc7794));
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$4cdbe576751dd8e2));
    const headerGroupingMaxDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $24c0f923081db0c8$export$4cf0369c079b29be));
    const editRowsState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $3cca1b289e09958d$export$91ed78b95c9e6636));
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, refProp);
    const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
    const ownerState = {
        selected: selected,
        hovered: hovered,
        isLastVisible: isLastVisible,
        classes: rootProps.classes,
        editing: apiRef.current.getRowMode(rowId) === (0, $57b3ed5f9013058b$export$d98c76b959bb0b5c).Edit,
        editable: rootProps.editMode === (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Row,
        rowHeight: rowHeight
    };
    const classes = $2447a053873bbd49$var$useUtilityClasses(ownerState);
    $jSIPP.useLayoutEffect(()=>{
        if (rowHeight === 'auto' && ref.current && typeof ResizeObserver === 'undefined') // Fallback for IE
        apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight, position);
    }, [
        apiRef,
        rowHeight,
        rowId,
        position
    ]);
    $jSIPP.useLayoutEffect(()=>{
        if (currentPage.range) {
            // The index prop is relative to the rows from all pages. As example, the index prop of the
            // first row is 5 if `paginationModel.pageSize=5` and `paginationModel.page=1`. However, the index used by the virtualization
            // doesn't care about pagination and considers the rows from the current page only, so the
            // first row always has index=0. We need to subtract the index of the first row to make it
            // compatible with the index used by the virtualization.
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // pinned rows are not part of the visible rows
            if (rowIndex != null) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        const rootElement = ref.current;
        const hasFixedHeight = rowHeight !== 'auto';
        if (!rootElement || hasFixedHeight || typeof ResizeObserver === 'undefined') return undefined;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.unstable_storeRowHeightMeasurement(rowId, height, position);
        });
        resizeObserver.observe(rootElement);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        currentPage.range,
        index,
        rowHeight,
        rowId,
        position
    ]);
    const publish = $jSIPP.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $jSIPP.useCallback((event)=>{
        const cell = (0, $26a7a0c939103688$export$2a63f1401414fc1a)(event.target, (0, $4d97f950d65e57e8$export$2100d54e36406477).cell);
        const field = cell == null ? void 0 : cell.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $b713438374cc7354$export$b2e9ab6103a664ad).field) return;
            // User opened a detail panel
            if (field === (0, $1048d489942eaf21$export$6e5a576305a34719)) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if ((column == null ? void 0 : column.type) === (0, $d8b476ddccfc1f84$export$e2523ab9efeb7465)) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const CellComponent = slots.cell === (0, $314a487430334cd5$export$c5671ad6c68d814) ? (0, $314a487430334cd5$export$c5671ad6c68d814) : (0, $314a487430334cd5$export$fc5dd9c3875d4ace);
    const rowReordering = rootProps.rowReordering;
    const getCell = (column, cellProps)=>{
        var _editRowsState$rowId$, _editRowsState$rowId;
        const disableDragEvents = disableColumnReorder && column.disableReorder || !rowReordering && !!sortModel.length && treeDepth > 1 && Object.keys(editRowsState).length > 0;
        const editCellState = (_editRowsState$rowId$ = (_editRowsState$rowId = editRowsState[rowId]) == null ? void 0 : _editRowsState$rowId[column.field]) != null ? _editRowsState$rowId$ : null;
        let cellIsNotVisible = false;
        if (focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) cellIsNotVisible = true;
        return /*#__PURE__*/ (0, $4uaIU.jsx)(CellComponent, (0, $erOpW.default)({
            column: column,
            width: cellProps.width,
            rowId: rowId,
            height: rowHeight,
            showRightBorder: cellProps.showRightBorder,
            align: column.align || 'left',
            colIndex: cellProps.indexRelativeToAllColumns,
            colSpan: cellProps.colSpan,
            disableDragEvents: disableDragEvents,
            editCellState: editCellState,
            isNotVisible: cellIsNotVisible
        }, slotProps == null ? void 0 : slotProps.cell), column.field);
    };
    const sizes = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, ()=>(0, $erOpW.default)({}, apiRef.current.unstable_getRowInternalSizes(rowId)), (0, $190d0dc02079d828$export$8da4c691e5695191));
    let minHeight = rowHeight;
    if (minHeight === 'auto' && sizes) {
        let numberOfBaseSizes = 0;
        const maximumSize = Object.entries(sizes).reduce((acc, [key, size])=>{
            const isBaseHeight = /^base[A-Z]/.test(key);
            if (!isBaseHeight) return acc;
            numberOfBaseSizes += 1;
            if (size > acc) return size;
            return acc;
        }, 0);
        if (maximumSize > 0 && numberOfBaseSizes > 1) minHeight = maximumSize;
    }
    const style = $jSIPP.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $erOpW.default)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            minHeight: // max-height doesn't support "auto"
            minHeight
        });
        if (sizes != null && sizes.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = sizes.spacingTop;
        }
        if (sizes != null && sizes.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += sizes.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        minHeight,
        sizes,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    if (typeof rootProps.getRowClassName === 'function') {
        var _currentPage$range;
        const indexRelativeToCurrentPage = index - (((_currentPage$range = currentPage.range) == null ? void 0 : _currentPage$range.firstRowIndex) || 0);
        const rowParams = (0, $erOpW.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const randomNumber = (0, $a4e890cf7e68aae0$export$ffd8c9a5b80f1e57)(10000, 20, 80);
    const rowNode = apiRef.current.getRowNode(rowId);
    if (!rowNode) return null;
    const rowType = rowNode.type;
    const cells = [];
    for(let i = 0; i < renderedColumns.length; i += 1){
        const column = renderedColumns[i];
        let indexRelativeToAllColumns = firstColumnToRender + i;
        if (focusedCellColumnIndexNotInRange !== undefined && focusedCell) {
            if (visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) indexRelativeToAllColumns = focusedCellColumnIndexNotInRange;
            else indexRelativeToAllColumns -= 1;
        }
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) {
            if (rowType !== 'skeletonRow') {
                const { colSpan: colSpan, width: width } = cellColSpanInfo.cellProps;
                const cellProps = {
                    width: width,
                    colSpan: colSpan,
                    showRightBorder: rootProps.showCellVerticalBorder,
                    indexRelativeToAllColumns: indexRelativeToAllColumns
                };
                cells.push(getCell(column, cellProps));
            } else {
                const { width: width } = cellColSpanInfo.cellProps;
                const contentWidth = Math.round(randomNumber());
                cells.push(/*#__PURE__*/ (0, $4uaIU.jsx)(slots.skeletonCell, {
                    width: width,
                    contentWidth: contentWidth,
                    field: column.field,
                    align: column.align
                }, column.field));
            }
        }
    }
    const emptyCellWidth = containerWidth - columnsTotalWidth;
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        ref: handleRef,
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $86B3v.default)(...rowClassNames, classes.root, className, hovered && 'Mui-hovered'),
        "aria-rowindex": ariaRowIndex,
        "aria-selected": selected,
        style: style
    }, eventHandlers, other, {
        children: [
            cells,
            emptyCellWidth > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)($2447a053873bbd49$var$EmptyCell, {
                width: emptyCellWidth
            })
        ]
    }));
});
const $2447a053873bbd49$export$1fc5a7f035870658 = (0, $2dcb0305bd801431$export$fa306e0bc9a9d6b4)($2447a053873bbd49$var$GridRow);


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $af7d1af8ef97ba39$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $af7d1af8ef97ba39$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $af7d1af8ef97ba39$var$GridRowCountRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount',
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2)
    }));
const $af7d1af8ef97ba39$export$b92875c9af3e0a77 = /*#__PURE__*/ $jSIPP.forwardRef(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $cMu4A.default)(props, $af7d1af8ef97ba39$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $af7d1af8ef97ba39$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($af7d1af8ef97ba39$var$GridRowCountRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");


var $lebkq = parcelRequire("lebkq");

var $i3Yji = parcelRequire("i3Yji");
function $07845c77725ecc30$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $07845c77725ecc30$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $07845c77725ecc30$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $07845c77725ecc30$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $07845c77725ecc30$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $07845c77725ecc30$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $07845c77725ecc30$export$8af1d214c6c2f0f1(length) * $07845c77725ecc30$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $07845c77725ecc30$export$8af1d214c6c2f0f1(length) * $07845c77725ecc30$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $07845c77725ecc30$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $07845c77725ecc30$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $07845c77725ecc30$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $07845c77725ecc30$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $07845c77725ecc30$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $6f3cab4209bf0610$export$c987db9fc844f86(slot) {
    return (0, $geF11.default)('MuiSkeleton', slot);
}
const $6f3cab4209bf0610$var$skeletonClasses = (0, $rARwS.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $6f3cab4209bf0610$export$2e2bcd8739ae039 = $6f3cab4209bf0610$var$skeletonClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
let $42d1f96d3d2c8683$var$_ = (t)=>t, $42d1f96d3d2c8683$var$t, $42d1f96d3d2c8683$var$t1, $42d1f96d3d2c8683$var$t2, $42d1f96d3d2c8683$var$t3;
const $42d1f96d3d2c8683$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $42d1f96d3d2c8683$var$_1 = (t)=>t, $42d1f96d3d2c8683$var$_t, $42d1f96d3d2c8683$var$_t2, $42d1f96d3d2c8683$var$_t3, $42d1f96d3d2c8683$var$_t4;
const $42d1f96d3d2c8683$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $6f3cab4209bf0610$export$c987db9fc844f86), classes);
};
const $42d1f96d3d2c8683$var$pulseKeyframe = (0, $lebkq.keyframes)($42d1f96d3d2c8683$var$_t || ($42d1f96d3d2c8683$var$_t = $42d1f96d3d2c8683$var$_1($42d1f96d3d2c8683$var$t || ($42d1f96d3d2c8683$var$t = $42d1f96d3d2c8683$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`))));
const $42d1f96d3d2c8683$var$waveKeyframe = (0, $lebkq.keyframes)($42d1f96d3d2c8683$var$_t2 || ($42d1f96d3d2c8683$var$_t2 = $42d1f96d3d2c8683$var$_1($42d1f96d3d2c8683$var$t1 || ($42d1f96d3d2c8683$var$t1 = $42d1f96d3d2c8683$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`))));
const $42d1f96d3d2c8683$var$SkeletonRoot = (0, $28RyA.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $07845c77725ecc30$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $07845c77725ecc30$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $erOpW.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $lebkq.css)($42d1f96d3d2c8683$var$_t3 || ($42d1f96d3d2c8683$var$_t3 = $42d1f96d3d2c8683$var$_1($42d1f96d3d2c8683$var$t2 || ($42d1f96d3d2c8683$var$t2 = $42d1f96d3d2c8683$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), 0)), $42d1f96d3d2c8683$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $lebkq.css)($42d1f96d3d2c8683$var$_t4 || ($42d1f96d3d2c8683$var$_t4 = $42d1f96d3d2c8683$var$_1($42d1f96d3d2c8683$var$t3 || ($42d1f96d3d2c8683$var$t3 = $42d1f96d3d2c8683$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), 0, 0)), $42d1f96d3d2c8683$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $42d1f96d3d2c8683$var$Skeleton = /*#__PURE__*/ $jSIPP.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $cMu4A.default)(props, $42d1f96d3d2c8683$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $42d1f96d3d2c8683$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($42d1f96d3d2c8683$var$SkeletonRoot, (0, $erOpW.default)({
        as: component,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $erOpW.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $42d1f96d3d2c8683$export$2e2bcd8739ae039 = $42d1f96d3d2c8683$var$Skeleton;



var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $a65687d6e7f8175f$var$_excluded = [
    "field",
    "align",
    "width",
    "contentWidth"
];
const $a65687d6e7f8175f$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${(0, $61i5U.default)(align)}`,
            'withBorderColor'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $a65687d6e7f8175f$export$d922c88d466d9c21(props) {
    const { align: align, width: width, contentWidth: contentWidth } = props, other = (0, $cMu4A.default)(props, $a65687d6e7f8175f$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        align: align
    };
    const classes = $a65687d6e7f8175f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", (0, $erOpW.default)({
        className: classes.root,
        style: {
            width: width
        }
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $42d1f96d3d2c8683$export$2e2bcd8739ae039), {
            width: `${contentWidth}%`
        })
    }));
}




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");




var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $28RyA = parcelRequire("28RyA");






var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");






var $4uaIU = parcelRequire("4uaIU");
const $337a5defede188bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'sortIcon'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $337a5defede188bc$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, (0, $erOpW.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $337a5defede188bc$var$GridColumnHeaderSortIconRaw(props) {
    var _rootProps$slotProps;
    const { direction: direction, index: index, sortingOrder: sortingOrder } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $337a5defede188bc$var$useUtilityClasses(ownerState);
    const iconElement = $337a5defede188bc$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small"
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $24b112bd67dcac97$export$e67562d5b709404c), {
        children: [
            index != null && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $78af997fba0f6bfa$export$2e2bcd8739ae039), {
                badgeContent: index,
                color: "default",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const $337a5defede188bc$export$80cd75c5dceceac6 = /*#__PURE__*/ $jSIPP.memo($337a5defede188bc$var$GridColumnHeaderSortIconRaw);



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $9f2f321998696425$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $9f2f321998696425$export$941072bb8af39847 = /*#__PURE__*/ $jSIPP.memo((props)=>{
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $9f2f321998696425$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $jSIPP.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTooltip, (0, $erOpW.default)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
            children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuLabel'),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseIconButton, {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "small"
                })
            }))
        }))
    });
});



var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");





var $4uaIU = parcelRequire("4uaIU");
function $089d4adcc52e8968$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target != null && target.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $67217aef89f147e8$export$237948c71948075), {
        placement: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(ContentComponent, (0, $erOpW.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}





var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $d78513d0becda452$var$_excluded = [
    "className"
];
const $d78513d0becda452$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $d78513d0becda452$var$GridColumnHeaderTitleRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)'
});
const $d78513d0becda452$var$ColumnHeaderInnerTitle = /*#__PURE__*/ $jSIPP.forwardRef(function ColumnHeaderInnerTitle(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $d78513d0becda452$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $d78513d0becda452$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d78513d0becda452$var$GridColumnHeaderTitleRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $d78513d0becda452$export$926bb04b6af55e42(props) {
    var _rootProps$slotProps;
    const { label: label, description: description } = props;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const titleRef = $jSIPP.useRef(null);
    const [tooltip, setTooltip] = $jSIPP.useState('');
    const handleMouseOver = $jSIPP.useCallback(()=>{
        if (!description && titleRef != null && titleRef.current) {
            const isOver = (0, $26a7a0c939103688$export$c8be9a8325efa7ee)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTooltip, (0, $erOpW.default)({
        title: description || tooltip
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($d78513d0becda452$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $2cfd347288bf55bd$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $2cfd347288bf55bd$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($2cfd347288bf55bd$export$71ed79b4ccf06d60 || {});
const $2cfd347288bf55bd$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $61i5U.default)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $2cfd347288bf55bd$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $2cfd347288bf55bd$export$71ed79b4ccf06d60.Right } = props, other = (0, $cMu4A.default)(props, $2cfd347288bf55bd$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $2cfd347288bf55bd$var$useUtilityClasses(ownerState);
    const stopClick = $jSIPP.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $4uaIU.jsx)("div", (0, $erOpW.default)({
        className: classes.root,
        style: {
            minHeight: height,
            opacity: rootProps.showColumnVerticalBorder ? 0 : 1
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $2cfd347288bf55bd$export$a264529bdbb7adb7 = /*#__PURE__*/ $jSIPP.memo($2cfd347288bf55bd$var$GridColumnHeaderSeparatorRaw);




var $4uaIU = parcelRequire("4uaIU");
const $e3fb16a9b89963a8$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps"
];
const $e3fb16a9b89963a8$export$fd75c0d5b714072b = /*#__PURE__*/ $jSIPP.forwardRef(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, columnMenuOpen: columnMenuOpen, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, hasFocus: hasFocus, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps } = props, other = (0, $cMu4A.default)(props, $e3fb16a9b89963a8$var$_excluded);
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $jSIPP.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $jSIPP.useState(columnMenuOpen);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    $jSIPP.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    $jSIPP.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        ref: handleRef,
        className: (0, $86B3v.default)(classes.root, headerClassName),
        style: {
            height: height,
            width: width,
            minWidth: width,
            maxWidth: width
        },
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort,
        "aria-label": headerComponent == null ? label : undefined
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d78513d0becda452$export$926bb04b6af55e42), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2cfd347288bf55bd$export$a264529bdbb7adb7), (0, $erOpW.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});




var $4uaIU = parcelRequire("4uaIU");
const $abaf24f2c714b016$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, filterItemsCounter: filterItemsCounter } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $abaf24f2c714b016$export$10f6faff2f47edd(props) {
    var _rootProps$slotProps, _colDef$sortingOrder, _rootProps$slotProps2, _colDef$headerName;
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide } = props;
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $jSIPP.useRef(null);
    const columnMenuId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const columnMenuButtonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const iconButtonRef = $jSIPP.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $jSIPP.useState(columnMenuOpen);
    const isDraggable = $jSIPP.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $erOpW.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: rootProps.showColumnVerticalBorder
    });
    const classes = $abaf24f2c714b016$var$useUtilityClasses(ownerState);
    const publish = $jSIPP.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $jSIPP.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $jSIPP.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $jSIPP.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $jSIPP.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $jSIPP.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9f2f321998696425$export$941072bb8af39847), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $089d4adcc52e8968$export$c096196819b00a09), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $erOpW.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.columnHeaderFilterIconButton)),
            colDef.sortable && !colDef.hideSortIcons && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $337a5defede188bc$export$80cd75c5dceceac6), {
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder
            })
        ]
    });
    $jSIPP.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = (_colDef$headerName = colDef.headerName) != null ? _colDef$headerName : colDef.field;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e3fb16a9b89963a8$export$fd75c0d5b714072b), (0, $erOpW.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: headerClassName,
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps
    }, mouseEventsHandlers));
}





var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");













const $dc4794f7e9d46149$export$4f32bfc70efeb4ab = (state)=>state.rowsMeta;





const $c421d0e4a96ab434$export$38fd8a77b05bfddf = (state)=>state.virtualization;
const $c421d0e4a96ab434$export$fb3400598da0ae89 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($c421d0e4a96ab434$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $c421d0e4a96ab434$export$ad2aa1e9d465cafa = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($c421d0e4a96ab434$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);



var $4uaIU = parcelRequire("4uaIU");
const $e9642a68285a9b69$var$_excluded = [
    "style"
], $e9642a68285a9b69$var$_excluded2 = [
    "style"
];
function $e9642a68285a9b69$export$2e0ae67339d5f1ac(offset, positions, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const itemOffset = positions[pivot];
    return offset <= itemOffset ? $e9642a68285a9b69$export$2e0ae67339d5f1ac(offset, positions, sliceStart, pivot) : $e9642a68285a9b69$export$2e0ae67339d5f1ac(offset, positions, pivot + 1, sliceEnd);
}
function $e9642a68285a9b69$var$exponentialSearch(offset, positions, index) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $e9642a68285a9b69$export$2e0ae67339d5f1ac(offset, positions, Math.floor(index / 2), Math.min(index, positions.length));
}
const $e9642a68285a9b69$export$e8e2b5bd6af586c5 = ({ firstIndex: firstIndex, lastIndex: lastIndex, buffer: buffer, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex })=>{
    return [
        (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(firstIndex - buffer, minFirstIndex, maxLastIndex),
        (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(lastIndex + buffer, minFirstIndex, maxLastIndex)
    ];
};
const $e9642a68285a9b69$export$6eb241d16b36f3b8 = (context1, context2)=>{
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
};
// The `maxSize` is 3 so that reselect caches the `renderedColumns` values for the pinned left,
// unpinned, and pinned right sections.
const $e9642a68285a9b69$var$MEMOIZE_OPTIONS = {
    maxSize: 3
};
const $e9642a68285a9b69$export$fbe94079134c8d27 = (props)=>{
    var _currentPage$range3, _currentPage$range4;
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9));
    const enabled = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $c421d0e4a96ab434$export$fb3400598da0ae89));
    const enabledForColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $c421d0e4a96ab434$export$ad2aa1e9d465cafa));
    const { ref: ref, onRenderZonePositioning: onRenderZonePositioning, renderZoneMinColumnIndex: renderZoneMinColumnIndex = 0, renderZoneMaxColumnIndex: renderZoneMaxColumnIndex = visibleColumns.length, getRowProps: getRowProps } = props;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const columnPositions = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$fce7d810e48021e3));
    const columnsTotalWidth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$ab20f9d33edc7794));
    const cellFocus = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$74af8aada6269d3));
    const cellTabIndex = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$2c47652a1f657d56));
    const rowsMeta = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab));
    const selectedRowsLookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $8ea15f807bcaac04$export$d5aede24ebfe3c98));
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, rootProps);
    const renderZoneRef = $jSIPP.useRef(null);
    const rootRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, rootRef);
    const [renderContext, setRenderContextState] = $jSIPP.useState(null);
    const prevRenderContext = $jSIPP.useRef(renderContext);
    const scrollPosition = $jSIPP.useRef({
        top: 0,
        left: 0
    });
    const [containerDimensions, setContainerDimensions] = $jSIPP.useState({
        width: null,
        height: null
    });
    const prevTotalWidth = $jSIPP.useRef(columnsTotalWidth);
    // Each visible row (not to be confused with a filter result) is composed of a central row element
    // and up to two additional row elements for pinned columns (left and right).
    // When hovering any of these elements, the :hover styles are applied only to the row element that
    // was actually hovered, not its additional siblings. To make it look like a contiguous row,
    // we add/remove the .Mui-hovered class to all of the row elements inside one visible row.
    const [hoveredRowId, setHoveredRowId] = $jSIPP.useState(null);
    const rowStyleCache = $jSIPP.useRef(Object.create(null));
    const prevGetRowProps = $jSIPP.useRef();
    const prevRootRowStyle = $jSIPP.useRef();
    const getRenderedColumnsRef = $jSIPP.useRef((0, $0895266d24a2801f$export$281bff7f05488aa2)((columns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, indexOfColumnWithFocusedCell)=>{
        // If the selected column is not within the current range of columns being displayed,
        // we need to render it at either the left or right of the columns,
        // depending on whether it is above or below the range.
        let focusedCellColumnIndexNotInRange;
        const renderedColumns = columns.slice(firstColumnToRender, lastColumnToRender);
        if (indexOfColumnWithFocusedCell > -1) {
            // check if it is not on the left pinned column.
            if (firstColumnToRender > indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell >= minFirstColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
            else if (lastColumnToRender < indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell < maxLastColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
        }
        return {
            focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
            renderedColumns: renderedColumns
        };
    }, $e9642a68285a9b69$var$MEMOIZE_OPTIONS));
    const indexOfColumnWithFocusedCell = $jSIPP.useMemo(()=>{
        if (cellFocus !== null) return visibleColumns.findIndex((column)=>column.field === cellFocus.field);
        return -1;
    }, [
        cellFocus,
        visibleColumns
    ]);
    const getNearestIndexToRender = $jSIPP.useCallback((offset)=>{
        var _currentPage$range, _currentPage$range2;
        const lastMeasuredIndexRelativeToAllRows = apiRef.current.getLastMeasuredRowIndex();
        let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
        if ((_currentPage$range = currentPage.range) != null && _currentPage$range.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
        allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= currentPage.range.lastRowIndex;
        const lastMeasuredIndexRelativeToCurrentPage = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(lastMeasuredIndexRelativeToAllRows - (((_currentPage$range2 = currentPage.range) == null ? void 0 : _currentPage$range2.firstRowIndex) || 0), 0, rowsMeta.positions.length);
        if (allRowsMeasured || rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
        // were measured, then use a binary search because it's faster.
        return $e9642a68285a9b69$export$2e0ae67339d5f1ac(offset, rowsMeta.positions);
        // Otherwise, use an exponential search.
        // If rows have "auto" as height, their positions will be based on estimated heights.
        // In this case, we can skip several steps until we find a position higher than the offset.
        // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
        return $e9642a68285a9b69$var$exponentialSearch(offset, rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage);
    }, [
        apiRef,
        (_currentPage$range3 = currentPage.range) == null ? void 0 : _currentPage$range3.firstRowIndex,
        (_currentPage$range4 = currentPage.range) == null ? void 0 : _currentPage$range4.lastRowIndex,
        rowsMeta.positions
    ]);
    const computeRenderContext = $jSIPP.useCallback(()=>{
        if (!enabled) return {
            firstRowIndex: 0,
            lastRowIndex: currentPage.rows.length,
            firstColumnIndex: 0,
            lastColumnIndex: visibleColumns.length
        };
        const { top: top, left: left } = scrollPosition.current;
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        const firstRowIndex = Math.min(getNearestIndexToRender(top), rowsMeta.positions.length - 1);
        const lastRowIndex = rootProps.autoHeight ? firstRowIndex + currentPage.rows.length : getNearestIndexToRender(top + containerDimensions.height);
        let firstColumnIndex = 0;
        let lastColumnIndex = columnPositions.length;
        if (enabledForColumns) {
            let hasRowWithAutoHeight = false;
            const [firstRowToRender, lastRowToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
                firstIndex: firstRowIndex,
                lastIndex: lastRowIndex,
                minFirstIndex: 0,
                maxLastIndex: currentPage.rows.length,
                buffer: rootProps.rowBuffer
            });
            for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
                const row = currentPage.rows[i];
                hasRowWithAutoHeight = apiRef.current.rowHasAutoHeight(row.id);
            }
            if (!hasRowWithAutoHeight) {
                firstColumnIndex = $e9642a68285a9b69$export$2e0ae67339d5f1ac(Math.abs(left), columnPositions);
                lastColumnIndex = $e9642a68285a9b69$export$2e0ae67339d5f1ac(Math.abs(left) + containerDimensions.width, columnPositions);
            }
        }
        return {
            firstRowIndex: firstRowIndex,
            lastRowIndex: lastRowIndex,
            firstColumnIndex: firstColumnIndex,
            lastColumnIndex: lastColumnIndex
        };
    }, [
        enabled,
        enabledForColumns,
        getNearestIndexToRender,
        rowsMeta.positions.length,
        rootProps.autoHeight,
        rootProps.rowBuffer,
        currentPage.rows,
        columnPositions,
        visibleColumns.length,
        apiRef,
        containerDimensions
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (enabled) {
            // TODO a scroll reset should not be necessary
            rootRef.current.scrollLeft = 0;
            rootRef.current.scrollTop = 0;
        } else renderZoneRef.current.style.transform = `translate3d(0px, 0px, 0px)`;
    }, [
        enabled
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, [
        rowsMeta.currentPageTotalHeight
    ]);
    const handleResize = $jSIPP.useCallback(()=>{
        if (rootRef.current) setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, []);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'debouncedResize', handleResize);
    const updateRenderZonePosition = $jSIPP.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const [initialFirstColumnToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: renderZoneMinColumnIndex,
            maxLastIndex: renderZoneMaxColumnIndex,
            buffer: rootProps.columnBuffer
        });
        const firstColumnToRender = (0, $50fcb4d7c433ea68$export$6143417adb92779f)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        const direction = theme.direction === 'ltr' ? 1 : -1;
        const top = (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab)(apiRef.current.state).positions[firstRowToRender];
        const left = direction * (0, $90c6bb88bfe45f18$export$fce7d810e48021e3)(apiRef)[firstColumnToRender]; // Call directly the selector because it might be outdated when this method is called
        renderZoneRef.current.style.transform = `translate3d(${left}px, ${top}px, 0px)`;
        if (typeof onRenderZonePositioning === 'function') onRenderZonePositioning({
            top: top,
            left: left
        });
    }, [
        apiRef,
        currentPage.rows,
        onRenderZonePositioning,
        renderZoneMinColumnIndex,
        renderZoneMaxColumnIndex,
        rootProps.columnBuffer,
        rootProps.rowBuffer,
        theme.direction
    ]);
    const getRenderContext = $jSIPP.useCallback(()=>prevRenderContext.current, []);
    const setRenderContext = $jSIPP.useCallback((nextRenderContext)=>{
        if (prevRenderContext.current && $e9642a68285a9b69$export$6eb241d16b36f3b8(nextRenderContext, prevRenderContext.current)) {
            updateRenderZonePosition(nextRenderContext);
            return;
        }
        setRenderContextState(nextRenderContext);
        updateRenderZonePosition(nextRenderContext);
        const [firstRowToRender, lastRowToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        apiRef.current.publishEvent('renderedRowsIntervalChange', {
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender
        });
        prevRenderContext.current = nextRenderContext;
    }, [
        apiRef,
        setRenderContextState,
        prevRenderContext,
        currentPage.rows.length,
        rootProps.rowBuffer,
        updateRenderZonePosition
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (containerDimensions.width == null) return;
        const initialRenderContext = computeRenderContext();
        setRenderContext(initialRenderContext);
        const { top: top, left: left } = scrollPosition.current;
        const params = {
            top: top,
            left: left,
            renderContext: initialRenderContext
        };
        apiRef.current.publishEvent('scrollPositionChange', params);
    }, [
        apiRef,
        computeRenderContext,
        containerDimensions.width,
        setRenderContext
    ]);
    const handleScroll = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = event.currentTarget;
        scrollPosition.current.top = scrollTop;
        scrollPosition.current.left = scrollLeft;
        // On iOS and macOS, negative offsets are possible when swiping past the start
        if (!prevRenderContext.current || scrollTop < 0) return;
        if (theme.direction === 'ltr') {
            if (scrollLeft < 0) return;
        }
        if (theme.direction === 'rtl') {
            if (scrollLeft > 0) return;
        }
        // When virtualization is disabled, the context never changes during scroll
        const nextRenderContext = enabled ? computeRenderContext() : prevRenderContext.current;
        const topRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstRowIndex - prevRenderContext.current.firstRowIndex);
        const bottomRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastRowIndex - prevRenderContext.current.lastRowIndex);
        const topColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstColumnIndex - prevRenderContext.current.firstColumnIndex);
        const bottomColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastColumnIndex - prevRenderContext.current.lastColumnIndex);
        const shouldSetState = topRowsScrolledSincePreviousRender >= rootProps.rowThreshold || bottomRowsScrolledSincePreviousRender >= rootProps.rowThreshold || topColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || bottomColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || prevTotalWidth.current !== columnsTotalWidth;
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollTop,
            left: scrollLeft,
            renderContext: shouldSetState ? nextRenderContext : prevRenderContext.current
        }, event);
        if (shouldSetState) {
            // Prevents batching render context changes
            $3ab9800416b64e29$exports.flushSync(()=>{
                setRenderContext(nextRenderContext);
            });
            prevTotalWidth.current = columnsTotalWidth;
        }
    });
    const handleWheel = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
    });
    const handleTouchMove = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
    });
    const indexOfRowWithFocusedCell = $jSIPP.useMemo(()=>{
        if (cellFocus !== null) return currentPage.rows.findIndex((row)=>row.id === cellFocus.id);
        return -1;
    }, [
        cellFocus,
        currentPage.rows
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowMouseOver', (params, event)=>{
        var _params$id;
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId((_params$id = params.id) != null ? _params$id : null);
    });
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowMouseOut', (params, event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId(null);
    });
    const getRows = (params = {
        renderContext: renderContext
    })=>{
        var _rootProps$slotProps;
        const { onRowRender: onRowRender, renderContext: nextRenderContext, minFirstColumn: minFirstColumn = renderZoneMinColumnIndex, maxLastColumn: maxLastColumn = renderZoneMaxColumnIndex, availableSpace: availableSpace = containerDimensions.width, rowIndexOffset: rowIndexOffset = 0, position: position = 'center' } = params;
        if (!nextRenderContext || availableSpace == null) return null;
        const rowBuffer = enabled ? rootProps.rowBuffer : 0;
        const columnBuffer = enabled ? rootProps.columnBuffer : 0;
        const [firstRowToRender, lastRowToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rowBuffer
        });
        const renderedRows = [];
        if (params.rows) params.rows.forEach((row)=>{
            renderedRows.push(row);
            apiRef.current.calculateColSpan({
                rowId: row.id,
                minFirstColumn: minFirstColumn,
                maxLastColumn: maxLastColumn,
                columns: visibleColumns
            });
        });
        else {
            if (!currentPage.range) return null;
            for(let i = firstRowToRender; i < lastRowToRender; i += 1){
                const row = currentPage.rows[i];
                renderedRows.push(row);
                apiRef.current.calculateColSpan({
                    rowId: row.id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        // If the selected row is not within the current range of rows being displayed,
        // we need to render it at either the top or bottom of the rows,
        // depending on whether it is above or below the range.
        let isRowWithFocusedCellNotInRange = false;
        if (indexOfRowWithFocusedCell > -1) {
            const rowWithFocusedCell = currentPage.rows[indexOfRowWithFocusedCell];
            if (firstRowToRender > indexOfRowWithFocusedCell || lastRowToRender < indexOfRowWithFocusedCell) {
                isRowWithFocusedCellNotInRange = true;
                if (indexOfRowWithFocusedCell > firstRowToRender) renderedRows.push(rowWithFocusedCell);
                else renderedRows.unshift(rowWithFocusedCell);
                apiRef.current.calculateColSpan({
                    rowId: rowWithFocusedCell.id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        const [initialFirstColumnToRender, lastColumnToRender] = $e9642a68285a9b69$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: minFirstColumn,
            maxLastIndex: maxLastColumn,
            buffer: columnBuffer
        });
        const firstColumnToRender = (0, $50fcb4d7c433ea68$export$6143417adb92779f)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        let isColumnWihFocusedCellNotInRange = false;
        if (firstColumnToRender > indexOfColumnWithFocusedCell || lastColumnToRender < indexOfColumnWithFocusedCell) isColumnWihFocusedCellNotInRange = true;
        const { focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange, renderedColumns: renderedColumns } = getRenderedColumnsRef.current(visibleColumns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, isColumnWihFocusedCellNotInRange ? indexOfColumnWithFocusedCell : -1);
        const _ref = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.row) || {}, { style: rootRowStyle } = _ref, rootRowProps = (0, $cMu4A.default)(_ref, $e9642a68285a9b69$var$_excluded);
        const invalidatesCachedRowStyle = prevGetRowProps.current !== getRowProps || prevRootRowStyle.current !== rootRowStyle;
        if (invalidatesCachedRowStyle) rowStyleCache.current = Object.create(null);
        const rows = [];
        let isRowWithFocusedCellRendered = false;
        for(let i = 0; i < renderedRows.length; i += 1){
            var _currentPage$range5;
            const { id: id, model: model } = renderedRows[i];
            const isRowNotVisible = isRowWithFocusedCellNotInRange && cellFocus.id === id;
            const lastVisibleRowIndex = isRowWithFocusedCellNotInRange ? firstRowToRender + i === currentPage.rows.length : firstRowToRender + i === currentPage.rows.length - 1;
            const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : 'auto';
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            if (onRowRender) onRowRender(id);
            const focusedCell = cellFocus !== null && cellFocus.id === id ? cellFocus.field : null;
            const columnWithFocusedCellNotInRange = focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange];
            const renderedColumnsWithFocusedCell = columnWithFocusedCellNotInRange && focusedCell ? [
                columnWithFocusedCellNotInRange,
                ...renderedColumns
            ] : renderedColumns;
            let tabbableCell = null;
            if (cellTabIndex !== null && cellTabIndex.id === id) {
                const cellParams = apiRef.current.getCellParams(id, cellTabIndex.field);
                tabbableCell = cellParams.cellMode === 'view' ? cellTabIndex.field : null;
            }
            const _ref2 = typeof getRowProps === 'function' && getRowProps(id, model) || {}, { style: rowStyle } = _ref2, rowProps = (0, $cMu4A.default)(_ref2, $e9642a68285a9b69$var$_excluded2);
            if (!rowStyleCache.current[id]) {
                const style = (0, $erOpW.default)({}, rowStyle, rootRowStyle);
                rowStyleCache.current[id] = style;
            }
            let index = rowIndexOffset + ((currentPage == null || (_currentPage$range5 = currentPage.range) == null ? void 0 : _currentPage$range5.firstRowIndex) || 0) + firstRowToRender + i;
            if (isRowWithFocusedCellNotInRange && (cellFocus == null ? void 0 : cellFocus.id) === id) {
                index = indexOfRowWithFocusedCell;
                isRowWithFocusedCellRendered = true;
            } else if (isRowWithFocusedCellRendered) index -= 1;
            rows.push(/*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.row, (0, $erOpW.default)({
                row: model,
                rowId: id,
                focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
                isNotVisible: isRowNotVisible,
                rowHeight: baseRowHeight,
                focusedCell: focusedCell,
                tabbableCell: tabbableCell,
                renderedColumns: renderedColumnsWithFocusedCell,
                visibleColumns: visibleColumns,
                firstColumnToRender: firstColumnToRender,
                lastColumnToRender: lastColumnToRender,
                selected: isSelected,
                index: index,
                containerWidth: availableSpace,
                isLastVisible: lastVisibleRowIndex,
                position: position
            }, rowProps, rootRowProps, {
                hovered: hoveredRowId === id,
                style: rowStyleCache.current[id]
            }), id));
        }
        prevGetRowProps.current = getRowProps;
        prevRootRowStyle.current = rootRowStyle;
        return rows;
    };
    const needsHorizontalScrollbar = containerDimensions.width && columnsTotalWidth >= containerDimensions.width;
    const contentSize = $jSIPP.useMemo(()=>{
        // In cases where the columns exceed the available width,
        // the horizontal scrollbar should be shown even when there're no rows.
        // Keeping 1px as minimum height ensures that the scrollbar will visible if necessary.
        const height = Math.max(rowsMeta.currentPageTotalHeight, 1);
        let shouldExtendContent = false;
        if (rootRef != null && rootRef.current && height <= (rootRef == null ? void 0 : rootRef.current.clientHeight)) shouldExtendContent = true;
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            height: height,
            minHeight: shouldExtendContent ? '100%' : 'auto'
        };
        if (rootProps.autoHeight && currentPage.rows.length === 0) size.height = (0, $db5319c56f201804$export$5475857f45a72a6e)(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
        return size;
    }, [
        apiRef,
        rootRef,
        columnsTotalWidth,
        rowsMeta.currentPageTotalHeight,
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        rootProps.rowHeight,
        currentPage.rows.length
    ]);
    $jSIPP.useEffect(()=>{
        apiRef.current.publishEvent('virtualScrollerContentSizeChange');
    }, [
        apiRef,
        contentSize
    ]);
    const rootStyle = $jSIPP.useMemo(()=>{
        const style = {};
        if (!needsHorizontalScrollbar) style.overflowX = 'hidden';
        if (rootProps.autoHeight) style.overflowY = 'hidden';
        return style;
    }, [
        needsHorizontalScrollbar,
        rootProps.autoHeight
    ]);
    apiRef.current.register('private', {
        getRenderContext: getRenderContext
    });
    return {
        renderContext: renderContext,
        updateRenderZonePosition: updateRenderZonePosition,
        getRows: getRows,
        getRootProps: (inputProps = {})=>(0, $erOpW.default)({
                ref: handleRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove
            }, inputProps, {
                style: inputProps.style ? (0, $erOpW.default)({}, inputProps.style, rootStyle) : rootStyle,
                role: 'presentation'
            }),
        getContentProps: ({ style: style } = {})=>({
                style: style ? (0, $erOpW.default)({}, style, contentSize) : contentSize,
                role: 'presentation'
            }),
        getRenderZoneProps: ()=>({
                ref: renderZoneRef,
                role: 'rowgroup'
            })
    };
};




var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");








var $4uaIU = parcelRequire("4uaIU");
const $965d84e83a6314af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, showColumnBorder: showColumnBorder, groupId: groupId } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showColumnBorder && 'columnHeader--showColumnBorder',
            showColumnBorder && 'columnHeader--withRightBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $965d84e83a6314af$export$ff426d40d02e21be(props) {
    var _columnGroupsLookup$g;
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn } = props;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $jSIPP.useRef(null);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const columnGroupsLookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $24c0f923081db0c8$export$bdc2ff4432d8b29b));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId != null ? groupId : '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && ((_columnGroupsLookup$g = columnGroupsLookup[groupId]) == null ? void 0 : _columnGroupsLookup$g.renderHeaderGroup);
    const renderParams = $jSIPP.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const showColumnBorder = rootProps.showColumnVerticalBorder;
    const ownerState = (0, $erOpW.default)({}, props, {
        classes: rootProps.classes,
        showColumnBorder: showColumnBorder,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName != null ? headerName : groupId;
    const id = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $965d84e83a6314af$var$useUtilityClasses(ownerState);
    $jSIPP.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $jSIPP.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $jSIPP.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e3fb16a9b89963a8$export$fd75c0d5b714072b), (0, $erOpW.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`
    }, mouseEventsHandlers));
}



var $4uaIU = parcelRequire("4uaIU");
const $5948f1bdd78394e1$var$GridColumnHeaderRow = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: (props, styles)=>styles.columnHeaderRow
})(()=>({
        display: 'flex'
    }));
function $5948f1bdd78394e1$var$isUIEvent(event) {
    return !!event.target;
}
const $5948f1bdd78394e1$export$dd7dbc7d3ee10272 = (props)=>{
    const { innerRef: innerRefProp, minColumnIndex: minColumnIndex = 0, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnPositions: columnPositions, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, densityFactor: densityFactor, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const [dragCol, setDragCol] = $jSIPP.useState('');
    const [resizeCol, setResizeCol] = $jSIPP.useState('');
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const hasVirtualization = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $c421d0e4a96ab434$export$ad2aa1e9d465cafa));
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const innerRef = $jSIPP.useRef(null);
    const handleInnerRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(innerRefProp, innerRef);
    const [renderContext, setRenderContextRaw] = $jSIPP.useState(null);
    const prevRenderContext = $jSIPP.useRef(renderContext);
    const prevScrollLeft = $jSIPP.useRef(0);
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, rootProps);
    const totalHeaderHeight = (0, $50fcb4d7c433ea68$export$659109c29172602f)(apiRef, rootProps.columnHeaderHeight);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const setRenderContext = $jSIPP.useCallback((nextRenderContext)=>{
        if (renderContext && nextRenderContext && (0, $e9642a68285a9b69$export$6eb241d16b36f3b8)(renderContext, nextRenderContext)) return;
        setRenderContextRaw(nextRenderContext);
    }, [
        renderContext
    ]);
    $jSIPP.useEffect(()=>{
        apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }, [
        apiRef
    ]);
    // memoize `getFirstColumnIndexToRender`, since it's called on scroll
    const getFirstColumnIndexToRenderRef = $jSIPP.useRef((0, $0895266d24a2801f$export$281bff7f05488aa2)((0, $50fcb4d7c433ea68$export$8ad609d4bbf235b0), {
        equalityCheck: (a, b)=>[
                'firstColumnIndex',
                'minColumnIndex',
                'columnBuffer'
            ].every((key)=>a[key] === b[key])
    }));
    const updateInnerPosition = $jSIPP.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = (0, $e9642a68285a9b69$export$e8e2b5bd6af586c5)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minColumnIndex,
            columnBuffer: rootProps.columnBuffer,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            apiRef: apiRef,
            visibleRows: currentPage.rows
        });
        const direction = theme.direction === 'ltr' ? 1 : -1;
        const offset = firstColumnToRender > 0 ? prevScrollLeft.current - direction * columnPositions[firstColumnToRender] : prevScrollLeft.current;
        innerRef.current.style.transform = `translate3d(${-offset}px, 0px, 0px)`;
    }, [
        columnPositions,
        minColumnIndex,
        rootProps.columnBuffer,
        apiRef,
        currentPage.rows,
        rootProps.rowBuffer,
        theme.direction
    ]);
    $jSIPP.useLayoutEffect(()=>{
        if (renderContext) updateInnerPosition(renderContext);
    }, [
        renderContext,
        updateInnerPosition
    ]);
    const handleScroll = $jSIPP.useCallback(({ left: left, renderContext: nextRenderContext = null }, event)=>{
        var _prevRenderContext$cu, _prevRenderContext$cu2;
        if (!innerRef.current) return;
        // Ignore vertical scroll.
        // Excepts the first event which sets the previous render context.
        if (prevScrollLeft.current === left && ((_prevRenderContext$cu = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu.firstColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.firstColumnIndex) && ((_prevRenderContext$cu2 = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu2.lastColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.lastColumnIndex)) return;
        prevScrollLeft.current = left;
        // We can only update the position when we guarantee that the render context has been
        // rendered. This is achieved using ReactDOM.flushSync or when the context doesn't change.
        let canUpdateInnerPosition = false;
        if (nextRenderContext !== prevRenderContext.current || !prevRenderContext.current) {
            // ReactDOM.flushSync cannot be called on `scroll` events fired inside effects
            if ($5948f1bdd78394e1$var$isUIEvent(event)) {
                // To prevent flickering, the inner position can only be updated after the new context has
                // been rendered. ReactDOM.flushSync ensures that the state changes will happen before
                // updating the position.
                $3ab9800416b64e29$exports.flushSync(()=>{
                    setRenderContext(nextRenderContext);
                });
                canUpdateInnerPosition = true;
            } else setRenderContext(nextRenderContext);
            prevRenderContext.current = nextRenderContext;
        } else canUpdateInnerPosition = true;
        // Pass directly the render context to avoid waiting for the next render
        if (nextRenderContext && canUpdateInnerPosition) updateInnerPosition(nextRenderContext);
    }, [
        updateInnerPosition,
        setRenderContext
    ]);
    const handleColumnResizeStart = $jSIPP.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $jSIPP.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $jSIPP.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $jSIPP.useCallback(()=>setDragCol(''), []);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'scrollPositionChange', handleScroll);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: nextRenderContext = renderContext, minFirstColumn: minFirstColumn = minColumnIndex, maxLastColumn: maxLastColumn = visibleColumns.length } = params || {};
        if (!nextRenderContext) return null;
        const [firstRowToRender, lastRowToRender] = (0, $e9642a68285a9b69$export$e8e2b5bd6af586c5)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = !hasVirtualization ? 0 : getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minFirstColumn,
            columnBuffer: rootProps.columnBuffer,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        const lastColumnToRender = !hasVirtualization ? maxLastColumn : Math.min(nextRenderContext.lastColumnIndex + rootProps.columnBuffer, maxLastColumn);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender,
            minFirstColumn: minFirstColumn,
            maxLastColumn: maxLastColumn
        };
    };
    const getColumnHeaders = (params, other = {})=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null) return null;
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = columnsToRender;
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            columns.push(/*#__PURE__*/ (0, $4uaIU.jsx)((0, $abaf24f2c714b016$export$10f6faff2f47edd), (0, $erOpW.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            }, other), colDef.field));
        }
        return /*#__PURE__*/ (0, $4uaIU.jsx)($5948f1bdd78394e1$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            children: columns
        });
    };
    const getColumnGroupHeaders = (params)=>{
        if (headerGroupingMaxDepth === 0) return null;
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null || columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const columns = [];
        const headerToRender = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1){
            var _apiRef$current$unsta, _apiRef$current$unsta2;
            const rowStructure = columnGroupsHeaderStructure[depth];
            const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
            const firstGroupToRender = (_apiRef$current$unsta = apiRef.current.unstable_getColumnGroupPath(firstColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta : null;
            const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
            const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
            const lastGroupToRender = (_apiRef$current$unsta2 = apiRef.current.unstable_getColumnGroupPath(lastColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta2 : null;
            const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
            const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
                return (0, $erOpW.default)({}, groupStructure, {
                    columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
                });
            }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
            const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
            const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
            const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
                var _column$computedWidth;
                const column = apiRef.current.getColumn(field);
                return acc + ((_column$computedWidth = column.computedWidth) != null ? _column$computedWidth : 0);
            }, 0);
            let columnIndex = firstColumnToRender;
            const elements = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields })=>{
                const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
                const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
                const headerInfo = {
                    groupId: groupId,
                    width: columnFields.reduce((acc, field)=>acc + apiRef.current.getColumn(field).computedWidth, 0),
                    fields: columnFields,
                    colIndex: columnIndex,
                    hasFocus: hasFocus,
                    tabIndex: tabIndex
                };
                columnIndex += columnFields.length;
                return headerInfo;
            });
            headerToRender.push({
                leftOverflow: leftOverflow,
                elements: elements
            });
        }
        headerToRender.forEach((depthInfo, depthIndex)=>{
            columns.push(/*#__PURE__*/ (0, $4uaIU.jsx)($5948f1bdd78394e1$var$GridColumnHeaderRow, {
                style: {
                    height: `${headerHeight}px`,
                    transform: `translateX(-${depthInfo.leftOverflow}px)`
                },
                role: "row",
                "aria-rowindex": depthIndex + 1,
                ownerState: rootProps,
                children: depthInfo.elements.map(({ groupId: groupId, width: width, fields: fields, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex }, groupIndex)=>{
                    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $965d84e83a6314af$export$ff426d40d02e21be), {
                        groupId: groupId,
                        width: width,
                        fields: fields,
                        colIndex: colIndex,
                        depth: depthIndex,
                        isLastColumn: colIndex === visibleColumns.length - fields.length,
                        maxDepth: headerToRender.length,
                        height: headerHeight,
                        hasFocus: hasFocus,
                        tabIndex: tabIndex
                    }, groupIndex);
                })
            }, depthIndex));
        });
        return columns;
    };
    const rootStyle = {
        minHeight: totalHeaderHeight,
        maxHeight: totalHeaderHeight,
        lineHeight: `${headerHeight}px`
    };
    return {
        renderContext: renderContext,
        getColumnHeaders: getColumnHeaders,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeaders: getColumnGroupHeaders,
        isDragging: !!dragCol,
        getRootProps: (other = {})=>(0, $erOpW.default)({
                style: rootStyle
            }, other),
        getInnerProps: ()=>({
                ref: handleInnerRef,
                role: 'rowgroup'
            }),
        headerHeight: headerHeight
    };
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $9642245410606af3$var$_excluded = [
    "className"
];
const $9642245410606af3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders',
            'withBorderColor'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $9642245410606af3$var$GridColumnHeadersRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders',
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderBottom: '1px solid',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $9642245410606af3$export$de91f7b8bf842ed8 = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $9642245410606af3$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $9642245410606af3$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($9642245410606af3$var$GridColumnHeadersRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps
    }, other, {
        role: "presentation"
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $3490be9d7d9c6ad3$var$_excluded = [
    "isDragging",
    "className"
];
const $3490be9d7d9c6ad3$var$useUtilityClasses = (ownerState)=>{
    const { isDragging: isDragging, hasScrollX: hasScrollX, classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeadersInner',
            isDragging && 'columnHeaderDropZone',
            hasScrollX && 'columnHeadersInner--scrollable'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $3490be9d7d9c6ad3$var$GridColumnHeadersInnerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'columnHeadersInner',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDropZone}`]: styles.columnHeaderDropZone
            },
            styles.columnHeadersInner
        ]
})(()=>({
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDropZone} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderDraggableContainer}`]: {
            cursor: 'move'
        },
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['columnHeadersInner--scrollable']} .${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader}:last-child`]: {
            borderRight: 'none'
        }
    }));
const $3490be9d7d9c6ad3$export$b3c0512acbf05cb7 = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnHeadersInner(props, ref) {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    const { isDragging: isDragging, className: className } = props, other = (0, $cMu4A.default)(props, $3490be9d7d9c6ad3$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        isDragging: isDragging,
        hasScrollX: (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.hasScrollX) != null ? _apiRef$current$getRo : false
    });
    const classes = $3490be9d7d9c6ad3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($3490be9d7d9c6ad3$var$GridColumnHeadersInnerRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: ownerState
    }, other));
});



var $4uaIU = parcelRequire("4uaIU");
const $9ccf5edc77e15449$var$_excluded = [
    "innerRef",
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnPositions",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "densityFactor",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $9ccf5edc77e15449$var$GridColumnHeaders = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnsHeaders(props, ref) {
    const { innerRef: innerRef, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnPositions: columnPositions, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, densityFactor: densityFactor, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $cMu4A.default)(props, $9ccf5edc77e15449$var$_excluded);
    const { isDragging: isDragging, getRootProps: getRootProps, getInnerProps: getInnerProps, getColumnHeaders: getColumnHeaders, getColumnGroupHeaders: getColumnGroupHeaders } = (0, $5948f1bdd78394e1$export$dd7dbc7d3ee10272)({
        innerRef: innerRef,
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnPositions: columnPositions,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        densityFactor: densityFactor,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9642245410606af3$export$de91f7b8bf842ed8), (0, $erOpW.default)({
        ref: ref
    }, getRootProps(other), {
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $3490be9d7d9c6ad3$export$b3c0512acbf05cb7), (0, $erOpW.default)({
            isDragging: isDragging
        }, getInnerProps(), {
            children: [
                getColumnGroupHeaders(),
                getColumnHeaders()
            ]
        }))
    }));
});
const $9ccf5edc77e15449$export$4a3a74c44d0a6c04 = (0, $2dcb0305bd801431$export$fa306e0bc9a9d6b4)($9ccf5edc77e15449$var$GridColumnHeaders);



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


const $d15e08aa8dd19a1a$var$_excluded = [
    "displayOrder"
];
const $d15e08aa8dd19a1a$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $jSIPP.useMemo(()=>(0, $erOpW.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $jSIPP.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $erOpW.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $erOpW.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $jSIPP.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $jSIPP.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps == null ? void 0 : leftItemProps.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps == null ? void 0 : rightItemProps.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $cMu4A.default)(processedComponentProps, $d15e08aa8dd19a1a$var$_excluded);
                itemProps = (0, $erOpW.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    (0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039),
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems
    ]);
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $86B3v = parcelRequire("86B3v");


var $jSIPP = parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");



var $4uaIU = parcelRequire("4uaIU");
const $a29f01c68bab04fc$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $a29f01c68bab04fc$var$StyledMenuList = (0, $28RyA.default)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039))(()=>({
        minWidth: 248
    }));
const $a29f01c68bab04fc$export$595ece458604adc3 = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $cMu4A.default)(props, $a29f01c68bab04fc$var$_excluded);
    const handleListKeyDown = $jSIPP.useCallback((event)=>{
        if ((0, $2200ee459e36b6d0$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $2200ee459e36b6d0$export$81301abbcd0c8143)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($a29f01c68bab04fc$var$StyledMenuList, (0, $erOpW.default)({
        id: id,
        ref: ref,
        className: (0, $86B3v.default)((0, $4d97f950d65e57e8$export$2100d54e36406477).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        children: children
    }));
});



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $jSIPP = parcelRequire("jSIPP");








var $4uaIU = parcelRequire("4uaIU");
function $e0612cd5d229f1cd$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $jSIPP.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuHideColumn')
            })
        ]
    });
}



var $jSIPP = parcelRequire("jSIPP");








var $4uaIU = parcelRequire("4uaIU");
function $25495eea98c924f9$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const showColumns = $jSIPP.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuManageColumns')
            })
        ]
    });
}



var $4uaIU = parcelRequire("4uaIU");
function $a3fd66f5c267a779$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e0612cd5d229f1cd$export$43421c0d197b), (0, $erOpW.default)({}, props)),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $25495eea98c924f9$export$dfc5e58327b7921f), (0, $erOpW.default)({}, props))
        ]
    });
}



var $jSIPP = parcelRequire("jSIPP");







var $4uaIU = parcelRequire("4uaIU");
function $63e5656837af5cf3$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const showFilter = $jSIPP.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('columnMenuFilter')
            })
        ]
    });
}



var $jSIPP = parcelRequire("jSIPP");









var $4uaIU = parcelRequire("4uaIU");
function $cd6a0a4ece529aad$export$e58710c52f856e65(props) {
    var _colDef$sortingOrder;
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const sortDirection = $jSIPP.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem == null ? void 0 : sortItem.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
    const onSortMenuItemClick = $jSIPP.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        apiRef.current.sortColumn(colDef, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (!colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                        children: getLabel('columnMenuSortAsc')
                    })
                ]
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                        children: getLabel('columnMenuSortDesc')
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                        children: apiRef.current.getLocaleText('columnMenuUnsort')
                    })
                ]
            }) : null
        ]
    });
}



var $4uaIU = parcelRequire("4uaIU");
const $d78018028de6f6fc$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $d78018028de6f6fc$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $cd6a0a4ece529aad$export$e58710c52f856e65),
    columnMenuFilterItem: (0, $63e5656837af5cf3$export$a4dd856446268ffe),
    columnMenuColumnsItem: (0, $a3fd66f5c267a779$export$fee567ee855db2cc)
};
const $d78018028de6f6fc$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $d78018028de6f6fc$export$61ffa20907ac4a8e = /*#__PURE__*/ $jSIPP.forwardRef(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $cMu4A.default)(props, $d78018028de6f6fc$var$_excluded);
    const orderedSlots = (0, $d15e08aa8dd19a1a$export$2ba37d64bee4cf68)((0, $erOpW.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a29f01c68bab04fc$export$595ece458604adc3), (0, $erOpW.default)({
        ref: ref
    }, other, {
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $4uaIU.jsx)(Component, (0, $erOpW.default)({}, otherProps), index))
    }));
});
const $d78018028de6f6fc$export$53fbb13480dfeb67 = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d78018028de6f6fc$export$61ffa20907ac4a8e, (0, $erOpW.default)({}, props, {
        ref: ref,
        defaultSlots: $d78018028de6f6fc$export$5983f95fe9d3e659,
        defaultSlotProps: $d78018028de6f6fc$export$c107bd4c779cece6
    }));
});



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $4uaIU = parcelRequire("4uaIU");
const $ade0c7e6be948a25$export$82fb990ffc125278 = /*#__PURE__*/ $jSIPP.forwardRef(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d59487dd3f89b782$export$1c41ff9dbe11e487), (0, $erOpW.default)({
        ref: ref
    }, props, {
        children: noResultsOverlayLabel
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $iLAKr = parcelRequire("iLAKr");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");




var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $1d1b17ac93e8b2fe$export$baa0faa0c7ad8085(slot) {
    return (0, $geF11.default)('PrivateSwitchBase', slot);
}
const $1d1b17ac93e8b2fe$var$switchBaseClasses = (0, $rARwS.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $1d1b17ac93e8b2fe$export$2e2bcd8739ae039 = $1d1b17ac93e8b2fe$var$switchBaseClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f0eba57a5264f550$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f0eba57a5264f550$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $iLAKr.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $1d1b17ac93e8b2fe$export$baa0faa0c7ad8085), classes);
};
const $f0eba57a5264f550$var$SwitchBaseRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $f0eba57a5264f550$var$SwitchBaseInput = (0, $28RyA.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $hDFpT.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f0eba57a5264f550$var$SwitchBase = /*#__PURE__*/ $jSIPP.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $cMu4A.default)(props, $f0eba57a5264f550$var$_excluded);
    const [checked, setCheckedState] = (0, $7981abc7b5093fe8$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $21312b33e5d7b320$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $erOpW.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f0eba57a5264f550$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($f0eba57a5264f550$var$SwitchBaseRoot, (0, $erOpW.default)({
        component: "span",
        className: (0, $86B3v.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($f0eba57a5264f550$var$SwitchBaseInput, (0, $erOpW.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $f0eba57a5264f550$export$2e2bcd8739ae039 = $f0eba57a5264f550$var$SwitchBase;


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $b742a06d43c6832b$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $8ee15fef04c77655$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
'use client';
var $62a011a8883fb87f$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $iLAKr = parcelRequire("iLAKr");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $75250656b311a4d2$export$6c57c6e16b4063b(slot) {
    return (0, $geF11.default)('MuiCheckbox', slot);
}
const $75250656b311a4d2$var$checkboxClasses = (0, $rARwS.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $75250656b311a4d2$export$2e2bcd8739ae039 = $75250656b311a4d2$var$checkboxClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $e208a097995c2a3b$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $e208a097995c2a3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $iLAKr.default)(color)}`,
            `size${(0, $iLAKr.default)(size)}`
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $75250656b311a4d2$export$6c57c6e16b4063b), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $e208a097995c2a3b$var$CheckboxRoot = (0, $28RyA.default)((0, $f0eba57a5264f550$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $iLAKr.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $75250656b311a4d2$export$2e2bcd8739ae039).checked}, &.${(0, $75250656b311a4d2$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $75250656b311a4d2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $e208a097995c2a3b$var$defaultCheckedIcon = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8ee15fef04c77655$export$2e2bcd8739ae039), {});
const $e208a097995c2a3b$var$defaultIcon = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b742a06d43c6832b$export$2e2bcd8739ae039), {});
const $e208a097995c2a3b$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $62a011a8883fb87f$export$2e2bcd8739ae039), {});
const $e208a097995c2a3b$var$Checkbox = /*#__PURE__*/ $jSIPP.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $e208a097995c2a3b$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $e208a097995c2a3b$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $e208a097995c2a3b$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $cMu4A.default)(props, $e208a097995c2a3b$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $e208a097995c2a3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($e208a097995c2a3b$var$CheckboxRoot, (0, $erOpW.default)({
        type: "checkbox",
        inputProps: (0, $erOpW.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $jSIPP.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $jSIPP.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $e208a097995c2a3b$export$2e2bcd8739ae039 = $e208a097995c2a3b$var$Checkbox;






var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $iLAKr = parcelRequire("iLAKr");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $4uaIU = parcelRequire("4uaIU");
'use client';
const $b1783f63238fae0d$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $b1783f63238fae0d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $iLAKr.default)(edge)}`,
            `size${(0, $iLAKr.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $iLAKr.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $fbfaa3b54750ad9b$export$39f6debbec19b3ba), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $b1783f63238fae0d$var$SwitchRoot = (0, $28RyA.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $iLAKr.default)(ownerState.edge)}`],
            styles[`size${(0, $iLAKr.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $b1783f63238fae0d$var$SwitchSwitchBase = (0, $28RyA.default)((0, $f0eba57a5264f550$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $iLAKr.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).checked} + .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).disabled} + .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $hnF8Y.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $hnF8Y.lighten)(theme.palette[color].main, 0.62) : (0, $hnF8Y.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).checked} + .${(0, $fbfaa3b54750ad9b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $b1783f63238fae0d$var$SwitchTrack = (0, $28RyA.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $b1783f63238fae0d$var$SwitchThumb = (0, $28RyA.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $b1783f63238fae0d$var$Switch = /*#__PURE__*/ $jSIPP.forwardRef(function Switch(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $cMu4A.default)(props, $b1783f63238fae0d$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $b1783f63238fae0d$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $4uaIU.jsx)($b1783f63238fae0d$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($b1783f63238fae0d$var$SwitchRoot, {
        className: (0, $86B3v.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($b1783f63238fae0d$var$SwitchSwitchBase, (0, $erOpW.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $erOpW.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)($b1783f63238fae0d$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $b1783f63238fae0d$export$2e2bcd8739ae039 = $b1783f63238fae0d$var$Switch;










var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
const $08bf6f9349ac11b7$var$_excluded = [
    "sortingOrder"
];
const $08bf6f9349ac11b7$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $jSIPP.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $cMu4A.default)(props, $08bf6f9349ac11b7$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, (0, $erOpW.default)({}, other)) : null;
});


parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
const $d1ef23cefba2c3b6$export$6de472a3df735882 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $d1ef23cefba2c3b6$export$1f2d4db4a79871d4 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $d1ef23cefba2c3b6$export$8da6370d9999894a = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $d1ef23cefba2c3b6$export$5b6f85a3ddabf4ca = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $d1ef23cefba2c3b6$export$cb1a577169e125de = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $d1ef23cefba2c3b6$export$4f4f59585ffe8deb = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $d1ef23cefba2c3b6$export$d33e6ad54b379a5d = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $d1ef23cefba2c3b6$export$3c3b03774b2ed8ce = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $d1ef23cefba2c3b6$export$7a7700ab3e9c7e95 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $d1ef23cefba2c3b6$export$10a5a2f68ff67c50 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const $d1ef23cefba2c3b6$export$e918bd395b324de6 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M11 19V5h2v14z"
}), 'Separator');
const $d1ef23cefba2c3b6$export$3bcf566f7053b242 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $d1ef23cefba2c3b6$export$adcade5d1a52a335 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $d1ef23cefba2c3b6$export$60a4c153d2d7b084 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $d1ef23cefba2c3b6$export$2fbf0de7557957a8 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $d1ef23cefba2c3b6$export$cbefef3cfb8e2783 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $d1ef23cefba2c3b6$export$e483c1441c7fca0b = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $d1ef23cefba2c3b6$export$d8fa92cc66e4dec8 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $d1ef23cefba2c3b6$export$52992a9d5fa53c3c = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $d1ef23cefba2c3b6$export$305773dd821bb81d = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $d1ef23cefba2c3b6$export$78df866ac12db1bd = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const $d1ef23cefba2c3b6$export$1f9ec58b2f66f46d = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $d1ef23cefba2c3b6$export$6eaba7fcfbaac527 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $d1ef23cefba2c3b6$export$9267feb6a6149971 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $d1ef23cefba2c3b6$export$109d60d29e96616d = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("g", {
    children: /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $d1ef23cefba2c3b6$export$ab03f96923842ba7 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
const $d1ef23cefba2c3b6$export$4830297c7288dee4 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $d1ef23cefba2c3b6$export$fc6ef585bd0ee189 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");
parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
const $6981317545f12f47$var$_excluded = [
    "native"
];
function $6981317545f12f47$export$2e2bcd8739ae039(_ref) {
    let { native: native } = _ref, props = (0, $cMu4A.default)(_ref, $6981317545f12f47$var$_excluded);
    if (native) return /*#__PURE__*/ (0, $4uaIU.jsx)("option", (0, $erOpW.default)({}, props));
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), (0, $erOpW.default)({}, props));
}


const $2137f0dcab50173b$var$iconSlots = {
    BooleanCellTrueIcon: (0, $d1ef23cefba2c3b6$export$1f9ec58b2f66f46d),
    BooleanCellFalseIcon: (0, $d1ef23cefba2c3b6$export$cbefef3cfb8e2783),
    ColumnMenuIcon: (0, $d1ef23cefba2c3b6$export$2fbf0de7557957a8),
    OpenFilterButtonIcon: (0, $d1ef23cefba2c3b6$export$cb1a577169e125de),
    FilterPanelDeleteIcon: (0, $d1ef23cefba2c3b6$export$cbefef3cfb8e2783),
    ColumnFilteredIcon: (0, $d1ef23cefba2c3b6$export$4f4f59585ffe8deb),
    ColumnSelectorIcon: (0, $d1ef23cefba2c3b6$export$10a5a2f68ff67c50),
    ColumnUnsortedIcon: (0, $08bf6f9349ac11b7$export$9e3e7f6bf3b8c7a7),
    ColumnSortedAscendingIcon: (0, $d1ef23cefba2c3b6$export$6de472a3df735882),
    ColumnSortedDescendingIcon: (0, $d1ef23cefba2c3b6$export$1f2d4db4a79871d4),
    ColumnResizeIcon: (0, $d1ef23cefba2c3b6$export$e918bd395b324de6),
    DensityCompactIcon: (0, $d1ef23cefba2c3b6$export$3bcf566f7053b242),
    DensityStandardIcon: (0, $d1ef23cefba2c3b6$export$adcade5d1a52a335),
    DensityComfortableIcon: (0, $d1ef23cefba2c3b6$export$60a4c153d2d7b084),
    ExportIcon: (0, $d1ef23cefba2c3b6$export$78df866ac12db1bd),
    MoreActionsIcon: (0, $d1ef23cefba2c3b6$export$6eaba7fcfbaac527),
    TreeDataCollapseIcon: (0, $d1ef23cefba2c3b6$export$5b6f85a3ddabf4ca),
    TreeDataExpandIcon: (0, $d1ef23cefba2c3b6$export$8da6370d9999894a),
    GroupingCriteriaCollapseIcon: (0, $d1ef23cefba2c3b6$export$5b6f85a3ddabf4ca),
    GroupingCriteriaExpandIcon: (0, $d1ef23cefba2c3b6$export$8da6370d9999894a),
    DetailPanelExpandIcon: (0, $d1ef23cefba2c3b6$export$e483c1441c7fca0b),
    DetailPanelCollapseIcon: (0, $d1ef23cefba2c3b6$export$d8fa92cc66e4dec8),
    RowReorderIcon: (0, $d1ef23cefba2c3b6$export$305773dd821bb81d),
    QuickFilterIcon: (0, $d1ef23cefba2c3b6$export$d33e6ad54b379a5d),
    QuickFilterClearIcon: (0, $d1ef23cefba2c3b6$export$cbefef3cfb8e2783),
    ColumnMenuHideIcon: (0, $d1ef23cefba2c3b6$export$9267feb6a6149971),
    ColumnMenuSortAscendingIcon: (0, $d1ef23cefba2c3b6$export$6de472a3df735882),
    ColumnMenuSortDescendingIcon: (0, $d1ef23cefba2c3b6$export$1f2d4db4a79871d4),
    ColumnMenuFilterIcon: (0, $d1ef23cefba2c3b6$export$4f4f59585ffe8deb),
    ColumnMenuManageColumnsIcon: (0, $d1ef23cefba2c3b6$export$109d60d29e96616d),
    ColumnMenuClearIcon: (0, $d1ef23cefba2c3b6$export$ab03f96923842ba7),
    LoadIcon: (0, $d1ef23cefba2c3b6$export$52992a9d5fa53c3c),
    FilterPanelAddIcon: (0, $d1ef23cefba2c3b6$export$e483c1441c7fca0b),
    FilterPanelRemoveAllIcon: (0, $d1ef23cefba2c3b6$export$fc6ef585bd0ee189),
    ColumnReorderIcon: (0, $d1ef23cefba2c3b6$export$305773dd821bb81d)
};
const $2137f0dcab50173b$var$materialSlots = (0, $erOpW.default)({}, $2137f0dcab50173b$var$iconSlots, {
    BaseCheckbox: (0, $e208a097995c2a3b$export$2e2bcd8739ae039),
    BaseTextField: (0, $ccc5b601331ac202$export$2e2bcd8739ae039),
    BaseFormControl: (0, $50dd07d34beb4b6b$export$2e2bcd8739ae039),
    BaseSelect: (0, $0e329553cea51e59$export$2e2bcd8739ae039),
    BaseSwitch: (0, $b1783f63238fae0d$export$2e2bcd8739ae039),
    BaseButton: (0, $681a423b309f05b8$export$2e2bcd8739ae039),
    BaseIconButton: (0, $f39aadf3bf12995a$export$2e2bcd8739ae039),
    BaseInputAdornment: (0, $1753741dd156a1b5$export$2e2bcd8739ae039),
    BaseTooltip: (0, $49843c171a30b5aa$export$2e2bcd8739ae039),
    BasePopper: (0, $b774b692670e0e71$export$2e2bcd8739ae039),
    BaseInputLabel: (0, $1d035bfeea196a4a$export$2e2bcd8739ae039),
    BaseSelectOption: (0, $6981317545f12f47$export$2e2bcd8739ae039),
    BaseChip: (0, $dbaa881ad628c459$export$2e2bcd8739ae039)
});
var $2137f0dcab50173b$export$2e2bcd8739ae039 = $2137f0dcab50173b$var$materialSlots;


const $7b061512a793888c$export$8a57bda01657743f = (0, $erOpW.default)({}, (0, $2137f0dcab50173b$export$2e2bcd8739ae039), {
    Cell: (0, $314a487430334cd5$export$c5671ad6c68d814),
    SkeletonCell: (0, $a65687d6e7f8175f$export$d922c88d466d9c21),
    ColumnHeaderFilterIconButton: (0, $55b94ab4ae718ba3$export$35b5c67d267fafd7),
    ColumnMenu: (0, $d78018028de6f6fc$export$53fbb13480dfeb67),
    ColumnHeaders: (0, $9ccf5edc77e15449$export$4a3a74c44d0a6c04),
    Footer: (0, $1255ddd7590fafe9$export$6ef0bfefb022d11e),
    FooterRowCount: (0, $af7d1af8ef97ba39$export$b92875c9af3e0a77),
    Toolbar: null,
    PreferencesPanel: (0, $43bb97a9fbb505ee$export$6cff59e5608ce17d),
    LoadingOverlay: (0, $7d47721ec9d85dc7$export$69e47a4ea5ffa191),
    NoResultsOverlay: (0, $ade0c7e6be948a25$export$82fb990ffc125278),
    NoRowsOverlay: (0, $77e626fa9f1d4924$export$a25f04494ce53510),
    Pagination: (0, $8c901b4423bc4ddb$export$fa9a503101f8d472),
    FilterPanel: (0, $e00f3ba538d93e0d$export$32c6e72be8ad862c),
    ColumnsPanel: (0, $8ebd03dccdb426e8$export$39d43456ec96cf57),
    Panel: (0, $d2a530d6fca65d32$export$cf917897ad2588b),
    Row: (0, $2447a053873bbd49$export$1fc5a7f035870658)
});




var $erOpW = parcelRequire("erOpW");

var $erOpW = parcelRequire("erOpW");
const $3cca6a4880116aa6$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $erOpW.default)({}, acc, {
            [`${key.charAt(0).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};


function $dfef57d122bddda3$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots, components: components }) {
    const overrides = slots != null ? slots : components ? (0, $3cca6a4880116aa6$export$ee17bc394843b249)(components) : null;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $erOpW.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}


var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");
const $a95e5a8118b0b80b$var$_excluded = [
    "components",
    "componentsProps"
];
/** Gathers props for the root element into a single `.forwardedProps` field */ function $a95e5a8118b0b80b$var$groupForwardedProps(props) {
    var _props$forwardedProps;
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith('aria-') || key.startsWith('data-'))) return props;
    const newProps = {};
    const forwardedProps = (_props$forwardedProps = props.forwardedProps) != null ? _props$forwardedProps : {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith('aria-') || key.startsWith('data-')) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function $a95e5a8118b0b80b$export$1f264be2c424fccf(allProps) {
    return $jSIPP.useMemo(()=>{
        const { components: components, componentsProps: componentsProps } = allProps, themedProps = (0, $cMu4A.default)(allProps, $a95e5a8118b0b80b$var$_excluded);
        return [
            components,
            componentsProps,
            $a95e5a8118b0b80b$var$groupForwardedProps(themedProps)
        ];
    }, [
        allProps
    ]);
}


const $da07bdb0211ca176$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    disableMultipleRowSelection: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    disableColumnResize: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid'
};
const $da07bdb0211ca176$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    columnBuffer: 3,
    rowBuffer: 3,
    columnThreshold: 3,
    rowThreshold: 3,
    rowSelection: true,
    density: 'standard',
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnSelector: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleRowSelection: false,
    disableMultipleColumnsSorting: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: (0, $57b3ed5f9013058b$export$bad6b7a934346f26).Cell,
    filterMode: 'client',
    filterDebounceMs: 150,
    columnHeaderHeight: 56,
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    logger: console,
    logLevel: 'error',
    pagination: false,
    paginationMode: 'client',
    rowHeight: 52,
    pageSizeOptions: [
        25,
        50,
        100
    ],
    rowSpacingType: 'margin',
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    sortingMode: 'client',
    throttleRowsMs: 0,
    disableColumnReorder: false,
    disableColumnResize: false,
    keepNonExistentRowsSelected: false,
    keepColumnPositionIfDraggedOutside: false,
    unstable_ignoreValueFormatterDuringExport: false,
    clipboardCopyCellDelimiter: '\t',
    rowPositionsDebounceMs: 166
};
const $da07bdb0211ca176$var$defaultSlots = (0, $3cca6a4880116aa6$export$ee17bc394843b249)((0, $7b061512a793888c$export$8a57bda01657743f));
const $da07bdb0211ca176$export$23366c9f040a985 = (inProps)=>{
    const [components, componentsProps, themedProps] = (0, $a95e5a8118b0b80b$export$1f264be2c424fccf)((0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDataGrid'
    }));
    const localeText = $jSIPP.useMemo(()=>(0, $erOpW.default)({}, (0, $aca9760671f55e3a$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $jSIPP.useMemo(()=>(0, $dfef57d122bddda3$export$247af54f7c54fca)({
            defaultSlots: $da07bdb0211ca176$var$defaultSlots,
            slots: themedProps.slots,
            components: components
        }), [
        components,
        themedProps.slots
    ]);
    return $jSIPP.useMemo(()=>{
        var _themedProps$slotProp;
        return (0, $erOpW.default)({}, $da07bdb0211ca176$export$2733e0e1a1d288e7, themedProps, {
            localeText: localeText,
            slots: slots,
            slotProps: (_themedProps$slotProp = themedProps.slotProps) != null ? _themedProps$slotProp : componentsProps
        }, $da07bdb0211ca176$var$DATA_GRID_FORCED_PROPS);
    }, [
        themedProps,
        localeText,
        slots,
        componentsProps
    ]);
};


const $48f0a363a6ecf2a5$export$4224c70cd0329965 = (state)=>(0, $erOpW.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: 0,
            positions: []
        }
    });
let $48f0a363a6ecf2a5$var$warnedOnceInvalidRowHeight = false;
const $48f0a363a6ecf2a5$var$getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $48f0a363a6ecf2a5$var$rowHeightWarning = [
    `MUI: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $48f0a363a6ecf2a5$var$getRowHeightWarning = [
    `MUI: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');
const $48f0a363a6ecf2a5$export$8a4468671da3a64f = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = props;
    const rowsHeightLookup = $jSIPP.useRef(Object.create(null));
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    const lastMeasuredRowIndex = $jSIPP.useRef(-1);
    const hasRowWithAutoHeight = $jSIPP.useRef(false);
    const densityFactor = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$c646201fb1d3e7a6));
    const filterModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5));
    const paginationState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $23354dc00cec9d31$export$24c945ea033ce6cf));
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, props);
    const pinnedRows = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$ffe7071c481e32b0));
    const validRowHeight = $48f0a363a6ecf2a5$var$getValidRowHeight(props.rowHeight, (0, $da07bdb0211ca176$export$2733e0e1a1d288e7).rowHeight, $48f0a363a6ecf2a5$var$rowHeightWarning);
    const rowHeight = Math.floor(validRowHeight * densityFactor);
    const hydrateRowsMeta = $jSIPP.useCallback(()=>{
        var _pinnedRows$top, _pinnedRows$bottom;
        hasRowWithAutoHeight.current = false;
        const calculateRowProcessedSizes = (row)=>{
            if (!rowsHeightLookup.current[row.id]) rowsHeightLookup.current[row.id] = {
                sizes: {
                    baseCenter: rowHeight
                },
                isResized: false,
                autoHeight: false,
                needsFirstMeasurement: true // Assume all rows will need to be measured by default
            };
            const { isResized: isResized, needsFirstMeasurement: needsFirstMeasurement, sizes: sizes } = rowsHeightLookup.current[row.id];
            let baseRowHeight = typeof rowHeight === 'number' && rowHeight > 0 ? rowHeight : 52;
            const existingBaseRowHeight = sizes.baseCenter;
            if (isResized) // Do not recalculate resized row height and use the value from the lookup
            baseRowHeight = existingBaseRowHeight;
            else if (getRowHeightProp) {
                const rowHeightFromUser = getRowHeightProp((0, $erOpW.default)({}, row, {
                    densityFactor: densityFactor
                }));
                if (rowHeightFromUser === 'auto') {
                    if (needsFirstMeasurement) {
                        const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, $erOpW.default)({}, row, {
                            densityFactor: densityFactor
                        })) : rowHeight;
                        // If the row was not measured yet use the estimated row height
                        baseRowHeight = estimatedRowHeight != null ? estimatedRowHeight : rowHeight;
                    } else baseRowHeight = existingBaseRowHeight;
                    hasRowWithAutoHeight.current = true;
                    rowsHeightLookup.current[row.id].autoHeight = true;
                } else {
                    // Default back to base rowHeight if getRowHeight returns invalid value.
                    baseRowHeight = $48f0a363a6ecf2a5$var$getValidRowHeight(rowHeightFromUser, rowHeight, $48f0a363a6ecf2a5$var$getRowHeightWarning);
                    rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
                    rowsHeightLookup.current[row.id].autoHeight = false;
                }
            } else rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
            const initialHeights = {};
            /* eslint-disable-next-line no-restricted-syntax */ for(const key in sizes)if (/^base[A-Z]/.test(key)) initialHeights[key] = sizes[key];
            initialHeights.baseCenter = baseRowHeight;
            if (getRowSpacing) {
                var _spacing$top, _spacing$bottom;
                const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
                const spacing = getRowSpacing((0, $erOpW.default)({}, row, {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                }));
                initialHeights.spacingTop = (_spacing$top = spacing.top) != null ? _spacing$top : 0;
                initialHeights.spacingBottom = (_spacing$bottom = spacing.bottom) != null ? _spacing$bottom : 0;
            }
            const processedSizes = apiRef.current.unstable_applyPipeProcessors('rowHeight', initialHeights, row);
            rowsHeightLookup.current[row.id].sizes = processedSizes;
            return processedSizes;
        };
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            let maximumBaseSize = 0;
            let otherSizes = 0;
            const processedSizes = calculateRowProcessedSizes(row);
            /* eslint-disable-next-line no-restricted-syntax, guard-for-in */ for(const key in processedSizes){
                const value = processedSizes[key];
                if (/^base[A-Z]/.test(key)) maximumBaseSize = value > maximumBaseSize ? value : maximumBaseSize;
                else otherSizes += value;
            }
            return acc + maximumBaseSize + otherSizes;
        }, 0);
        pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null || _pinnedRows$top.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null || _pinnedRows$bottom.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                rowsMeta: {
                    currentPageTotalHeight: currentPageTotalHeight,
                    positions: positions
                }
            });
        });
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        currentPage.rows,
        rowHeight,
        getRowHeightProp,
        getRowSpacing,
        getEstimatedRowHeight,
        pinnedRows,
        densityFactor
    ]);
    const getRowHeight = $jSIPP.useCallback((rowId)=>{
        const height = rowsHeightLookup.current[rowId];
        return height ? height.sizes.baseCenter : rowHeight;
    }, [
        rowHeight
    ]);
    const getRowInternalSizes = (rowId)=>{
        var _rowsHeightLookup$cur;
        return (_rowsHeightLookup$cur = rowsHeightLookup.current[rowId]) == null ? void 0 : _rowsHeightLookup$cur.sizes;
    };
    const setRowHeight = $jSIPP.useCallback((id, height)=>{
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        rowsHeightLookup.current[id].isResized = true;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const debouncedHydrateRowsMeta = $jSIPP.useMemo(()=>(0, $73208469ed38da03$export$2e2bcd8739ae039)(hydrateRowsMeta, props.rowPositionsDebounceMs), [
        hydrateRowsMeta,
        props.rowPositionsDebounceMs
    ]);
    const storeMeasuredRowHeight = $jSIPP.useCallback((id, height, position)=>{
        if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) return;
        // Only trigger hydration if the value is different, otherwise we trigger a loop
        const needsHydration = rowsHeightLookup.current[id].sizes[`base${(0, $61i5U.default)(position)}`] !== height;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        rowsHeightLookup.current[id].sizes[`base${(0, $61i5U.default)(position)}`] = height;
        if (needsHydration) debouncedHydrateRowsMeta();
    }, [
        debouncedHydrateRowsMeta
    ]);
    const rowHasAutoHeight = $jSIPP.useCallback((id)=>{
        var _rowsHeightLookup$cur2;
        return ((_rowsHeightLookup$cur2 = rowsHeightLookup.current[id]) == null ? void 0 : _rowsHeightLookup$cur2.autoHeight) || false;
    }, []);
    const getLastMeasuredRowIndex = $jSIPP.useCallback(()=>{
        return lastMeasuredRowIndex.current;
    }, []);
    const setLastMeasuredRowIndex = $jSIPP.useCallback((index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    }, []);
    const resetRowHeights = $jSIPP.useCallback(()=>{
        rowsHeightLookup.current = {};
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    $jSIPP.useEffect(()=>{
        hydrateRowsMeta();
    }, [
        rowHeight,
        filterModel,
        paginationState,
        sortModel,
        hydrateRowsMeta
    ]);
    (0, $9babb3636382b74b$export$98b68054bf03cb4)(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_getRowHeight: getRowHeight,
        unstable_getRowInternalSizes: getRowInternalSizes,
        unstable_setRowHeight: setRowHeight,
        unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        rowHasAutoHeight: rowHasAutoHeight
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, rowsMetaApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, rowsMetaPrivateApi, 'private');
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");










const $63ca51c1e6fc3c9e$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    apiRef.current.caches.rows = (0, $db5319c56f201804$export$3496927f169f2d35)({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $erOpW.default)({}, state, {
        rows: (0, $db5319c56f201804$export$4dcb6d8dd06e4f39)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $63ca51c1e6fc3c9e$export$dd1a4469bbd9394e = (apiRef, props)=>{
    var error;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridRows');
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, props);
    const lastUpdateMs = $jSIPP.useRef(Date.now());
    const timeout = (0, $700e89e09f25b054$export$d8e6abf214c9ec0f)();
    const getRow = $jSIPP.useCallback((id)=>{
        const model = (0, $d7530f53594a6a47$export$37767f9110c99048)(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && (0, $db5319c56f201804$export$fc9d832f40054590)(node)) return {
            [(0, $db5319c56f201804$export$e8632b32bb8837db)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowIdProp = props.getRowId;
    const getRowId = $jSIPP.useCallback((row)=>{
        if ((0, $db5319c56f201804$export$e8632b32bb8837db) in row) return row[0, $db5319c56f201804$export$e8632b32bb8837db];
        if (getRowIdProp) return getRowIdProp(row);
        return row.id;
    }, [
        getRowIdProp
    ]);
    const lookup = $jSIPP.useMemo(()=>currentPage.rows.reduce((acc, { id: id }, index)=>{
            acc[id] = index;
            return acc;
        }, {}), [
        currentPage.rows
    ]);
    const throttledRowsChange = $jSIPP.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                    rows: (0, $db5319c56f201804$export$4dcb6d8dd06e4f39)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef),
                        previousTreeDepths: (0, $d7530f53594a6a47$export$eb24598525413286)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $jSIPP.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, $db5319c56f201804$export$3496927f169f2d35)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $jSIPP.useCallback((updates)=>{
        if (props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid && updates.length > 1) throw new Error([
            "MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.",
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        const nonPinnedRowsUpdates = [];
        updates.forEach((update)=>{
            const id = (0, $db5319c56f201804$export$a95fb784d0ca2e72)(update, props.getRowId, 'A row was provided without id when calling updateRows():');
            const rowNode = apiRef.current.getRowNode(id);
            if ((rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') {
                // @ts-ignore because otherwise `release:build` doesn't work
                const pinnedRowsCache = apiRef.current.caches.pinnedRows;
                const prevModel = pinnedRowsCache.idLookup[id];
                if (prevModel) pinnedRowsCache.idLookup[id] = (0, $erOpW.default)({}, prevModel, update);
            } else nonPinnedRowsUpdates.push(update);
        });
        const cache = (0, $db5319c56f201804$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const getRowModels = $jSIPP.useCallback(()=>{
        const dataRows = (0, $d7530f53594a6a47$export$c7dcaab5e573753)(apiRef);
        const idRowsLookup = (0, $d7530f53594a6a47$export$37767f9110c99048)(apiRef);
        return new Map(dataRows.map((id)=>{
            var _idRowsLookup$id;
            return [
                id,
                (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
            ];
        }));
    }, [
        apiRef
    ]);
    const getRowsCount = $jSIPP.useCallback(()=>(0, $d7530f53594a6a47$export$1641ef9d08e265ca)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $jSIPP.useCallback(()=>(0, $d7530f53594a6a47$export$c7dcaab5e573753)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $jSIPP.useCallback((id)=>lookup[id], [
        lookup
    ]);
    const setRowChildrenExpansion = $jSIPP.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI: No row with id #${id} found`);
        if (currentNode.type !== 'group') throw new Error('MUI: Only group nodes can be expanded or collapsed');
        const newNode = (0, $erOpW.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                rows: (0, $erOpW.default)({}, state.rows, {
                    tree: (0, $erOpW.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const getRowNode = $jSIPP.useCallback((id)=>{
        var _ref;
        return (_ref = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef)[id]) != null ? _ref : null;
    }, [
        apiRef
    ]);
    const getRowGroupChildren = $jSIPP.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering })=>{
        const tree = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $fd4beb3eff079ebd$export$e4979ad0a2db8752)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $db5319c56f201804$export$fc9d832f40054590)(tree[id])) children.push(id);
            }
        } else children = (0, $db5319c56f201804$export$9380f4bcafb87e49)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $dcdbd4f8634a4b8d$export$6d031b6e8cbaf41c)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = $jSIPP.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI: No row with id #${rowId} found`);
        if (node.parent !== (0, $db5319c56f201804$export$433b924dc2506913)) throw new Error(`MUI: The row reordering do not support reordering of grouped rows yet`);
        if (node.type !== 'leaf') throw new Error(`MUI: The row reordering do not support reordering of footer or grouping rows`);
        apiRef.current.setState((state)=>{
            const group = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(state, apiRef.current.instanceId)[0, $db5319c56f201804$export$433b924dc2506913];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $erOpW.default)({}, state, {
                rows: (0, $erOpW.default)({}, state.rows, {
                    tree: (0, $erOpW.default)({}, state.rows.tree, {
                        [(0, $db5319c56f201804$export$433b924dc2506913)]: (0, $erOpW.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = $jSIPP.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid && newRows.length > 1) throw new Error([
            "MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.",
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $d7530f53594a6a47$export$4cdbe576751dd8e2)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $erOpW.default)({}, (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef));
        const dataRowIdToModelLookup = (0, $erOpW.default)({}, (0, $d7530f53594a6a47$export$37767f9110c99048)(apiRef));
        const dataRowIdToIdLookup = (0, $erOpW.default)({}, (0, $d7530f53594a6a47$export$451ff98f7dd9f13f)(apiRef));
        const rootGroup = tree[0, $db5319c56f201804$export$433b924dc2506913];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $db5319c56f201804$export$a95fb784d0ca2e72)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [replacedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            delete dataRowIdToModelLookup[replacedRowId];
            delete dataRowIdToIdLookup[replacedRowId];
            delete tree[replacedRowId];
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $db5319c56f201804$export$433b924dc2506913),
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
        }
        tree[0, $db5319c56f201804$export$433b924dc2506913] = (0, $erOpW.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId].type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                rows: (0, $erOpW.default)({}, state.rows, {
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIdToIdLookup: dataRowIdToIdLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow: getRow,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren
    };
    /**
   * EVENTS
   */ const groupRows = $jSIPP.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $erOpW.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $d7530f53594a6a47$export$c7dcaab5e573753)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $db5319c56f201804$export$3496927f169f2d35)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const handleStrategyProcessorChange = $jSIPP.useCallback((methodName)=>{
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows
    ]);
    const handleStrategyActivityChange = $jSIPP.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy('rowTree') !== (0, $d7530f53594a6a47$export$c263d91fb644e7a0)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $d7530f53594a6a47$export$de9a43d646a9821d)(state, apiRef.current.instanceId),
                treeDepths: (0, $d7530f53594a6a47$export$eb24598525413286)(state, apiRef.current.instanceId),
                dataRowIds: (0, $d7530f53594a6a47$export$c7dcaab5e573753)(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: (0, $d7530f53594a6a47$export$37767f9110c99048)(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: (0, $d7530f53594a6a47$export$451ff98f7dd9f13f)(state, apiRef.current.instanceId)
            });
            return (0, $erOpW.default)({}, state, {
                rows: (0, $erOpW.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $db5319c56f201804$export$e6ee03f0394a9759)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $9babb3636382b74b$export$98b68054bf03cb4)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, rowApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, rowProApi, props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                        rows: (0, $erOpW.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                        rows: (0, $erOpW.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            return;
        }
        logger.debug(`Updating all rows, new length ${props.rows.length}`);
        throttledRowsChange({
            cache: (0, $db5319c56f201804$export$3496927f169f2d35)({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");













const $1c843e5e3d1c494d$export$996e35c2eef351ae = (state, props)=>{
    var _ref, _props$sortModel, _props$initialState;
    const sortModel = (_ref = (_props$sortModel = props.sortModel) != null ? _props$sortModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.sorting) == null ? void 0 : _props$initialState.sortModel) != null ? _ref : [];
    return (0, $erOpW.default)({}, state, {
        sorting: {
            sortModel: (0, $bf59eac7c63b5f3b$export$13eeac5ac15e0be5)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $1c843e5e3d1c494d$export$951287757eb5d93c = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9),
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $jSIPP.useCallback((field, sortItem)=>{
        const sortModel = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (!sortItem) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $jSIPP.useCallback((col, directionOverride)=>{
        var _col$sortingOrder2;
        const sortModel = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            var _col$sortingOrder;
            const nextSort = directionOverride === undefined ? (0, $bf59eac7c63b5f3b$export$b3d84351ab2e3580)((_col$sortingOrder = col.sortingOrder) != null ? _col$sortingOrder : props.sortingOrder, existing.sort) : directionOverride;
            return nextSort == null ? undefined : (0, $erOpW.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $bf59eac7c63b5f3b$export$b3d84351ab2e3580)((_col$sortingOrder2 = col.sortingOrder) != null ? _col$sortingOrder2 : props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $jSIPP.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder
    ]);
    /**
   * API METHODS
   */ const applySorting = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $erOpW.default)({}, state, {
                    sorting: (0, $erOpW.default)({}, state.sorting, {
                        sortedRows: (0, $db5319c56f201804$export$9380f4bcafb87e49)((0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef), (0, $db5319c56f201804$export$433b924dc2506913), false)
                    })
                });
            }
            const sortModel = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(state, apiRef.current.instanceId);
            const sortRowList = (0, $bf59eac7c63b5f3b$export$b29e353d1a72dfda)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $erOpW.default)({}, state, {
                sorting: (0, $erOpW.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $jSIPP.useCallback((model)=>{
        const currentModel = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $bf59eac7c63b5f3b$export$3fc28d475ac000c0)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $jSIPP.useCallback((column, direction, allowMultipleSorting)=>{
        if (!column.sortable) return;
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = !sortItem ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $jSIPP.useCallback(()=>(0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $jSIPP.useCallback(()=>{
        const sortedRows = (0, $fd4beb3eff079ebd$export$8919e81647813e61)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $jSIPP.useCallback(()=>(0, $fd4beb3eff079ebd$export$e4979ad0a2db8752)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $jSIPP.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState2;
        const sortModelToExport = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.sorting) == null ? void 0 : _props$initialState2.sortModel) != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $erOpW.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.sorting) == null ? void 0 : _props$initialState3.sortModel
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        var _context$stateToResto;
        const sortModel = (_context$stateToResto = context.stateToRestore.sorting) == null ? void 0 : _context$stateToResto.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $bf59eac7c63b5f3b$export$3fc28d475ac000c0)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $erOpW.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $jSIPP.useCallback((params)=>{
        const rowTree = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef);
        const rootGroupNode = rowTree[0, $db5319c56f201804$export$433b924dc2506913];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(apiRef, (0, $0cb8bc389b379b36$export$84214fbf04c4094), 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $jSIPP.useCallback(({ colDef: colDef }, event)=>{
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(colDef, undefined, allowMultipleSorting);
    }, [
        sortColumn
    ]);
    const handleColumnHeaderKeyDown = $jSIPP.useCallback(({ colDef: colDef }, event)=>{
        // Ctrl + Enter opens the column menu
        if ((0, $2200ee459e36b6d0$export$b043658e6147d6f8)(event.key) && !event.ctrlKey && !event.metaKey) sortColumn(colDef, undefined, event.shiftKey);
    }, [
        sortColumn
    ]);
    const handleColumnsChange = $jSIPP.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9)(apiRef);
        const latestColumns = (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $jSIPP.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};


var $jSIPP = parcelRequire("jSIPP");

var $jSIPP = parcelRequire("jSIPP");


const $51ab574519757f03$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useNativeEventListener');
    const [added, setAdded] = $jSIPP.useState(false);
    const handlerRef = $jSIPP.useRef(handler);
    const wrapHandler = $jSIPP.useCallback((event)=>{
        return handlerRef.current && handlerRef.current(event);
    }, []);
    $jSIPP.useEffect(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    $jSIPP.useEffect(()=>{
        let targetElement;
        if ((0, $a4e890cf7e68aae0$export$f6e2535fb5126e54)(ref)) targetElement = ref();
        else targetElement = ref && ref.current ? ref.current : null;
        if (targetElement && eventName && !added) {
            logger.debug(`Binding native ${eventName} event`);
            targetElement.addEventListener(eventName, wrapHandler, options);
            const boundElem = targetElement;
            setAdded(true);
            const unsubscribe = ()=>{
                logger.debug(`Clearing native ${eventName} event`);
                boundElem.removeEventListener(eventName, wrapHandler, options);
            };
            apiRef.current.subscribeEvent('unmount', unsubscribe);
        }
    }, [
        ref,
        wrapHandler,
        eventName,
        added,
        logger,
        options,
        apiRef
    ]);
};





function $44d9a7dcee15cc41$var$sanitizeCellValue(value, delimiterCharacter) {
    if (typeof value === 'string') {
        // Make sure value containing delimiter or line break won't be split into multiple rows
        if ([
            delimiterCharacter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>value.includes(delimiter))) return `"${value.replace(/"/g, '""')}"`;
        return value;
    }
    return value;
}
const $44d9a7dcee15cc41$export$edda57d2a460473d = (cellParams, options)=>{
    const { delimiterCharacter: delimiterCharacter, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        var _cellParams$value2;
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') {
            var _cellParams$value;
            value = (_cellParams$value = cellParams.value) == null ? void 0 : _cellParams$value.toISOString();
        } else if (typeof ((_cellParams$value2 = cellParams.value) == null ? void 0 : _cellParams$value2.toString) === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $44d9a7dcee15cc41$var$sanitizeCellValue(value, delimiterCharacter);
};
const $44d9a7dcee15cc41$var$objectFormattedValueWarning = (0, $a7033f4d29fa444a$export$baf331755d84b871)([
    'MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.',
    'You can provide a `valueFormatter` with a string representation to be used.'
]);
class $44d9a7dcee15cc41$var$CSVRow {
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.delimiterCharacter;
        if (value === null || value === undefined) this.rowString += '';
        else if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.delimiterCharacter);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
    constructor(options){
        this.options = void 0;
        this.rowString = '';
        this.isEmpty = true;
        this.options = options;
    }
}
const $44d9a7dcee15cc41$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, delimiterCharacter: delimiterCharacter, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $44d9a7dcee15cc41$var$CSVRow({
        delimiterCharacter: delimiterCharacter
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($44d9a7dcee15cc41$export$edda57d2a460473d(cellParams, {
            delimiterCharacter: delimiterCharacter,
            ignoreValueFormatter: ignoreValueFormatter
        }));
    });
    return row.getRowString();
};
function $44d9a7dcee15cc41$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, delimiterCharacter: delimiterCharacter, includeHeaders: includeHeaders, includeColumnGroupsHeaders: includeColumnGroupsHeaders, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$44d9a7dcee15cc41$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            delimiterCharacter: delimiterCharacter,
            ignoreValueFormatter: ignoreValueFormatter
        })}\r\n`, '').trim();
    if (!includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $b713438374cc7354$export$b2e9ab6103a664ad).field);
    const headerRows = [];
    if (includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.unstable_getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.unstable_getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $44d9a7dcee15cc41$var$CSVRow({
                delimiterCharacter: delimiterCharacter,
                sanitizeCellValue: $44d9a7dcee15cc41$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $44d9a7dcee15cc41$var$CSVRow({
        delimiterCharacter: delimiterCharacter,
        sanitizeCellValue: $44d9a7dcee15cc41$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}


function $d4d64b8f1dc7b188$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $d4d64b8f1dc7b188$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $d4d64b8f1dc7b188$var$writeToClipboardPolyfill(data);
    });
    else $d4d64b8f1dc7b188$var$writeToClipboardPolyfill(data);
}
function $d4d64b8f1dc7b188$var$hasNativeSelection(element) {
    var _window$getSelection;
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if ((_window$getSelection = window.getSelection()) != null && _window$getSelection.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $d4d64b8f1dc7b188$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $jSIPP.useCallback((event)=>{
        if (!((event.ctrlKey || event.metaKey) && event.key === 'c')) return;
        // Do nothing if there's a native selection
        if ($d4d64b8f1dc7b188$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            // TODO: make it configurable
            delimiter: clipboardCopyCellDelimiter
        });
        else {
            const focusedCell = (0, $196c4c77eabe7b5f$export$74af8aada6269d3)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $44d9a7dcee15cc41$export$edda57d2a460473d)(cellParams, {
                    delimiterCharacter: clipboardCopyCellDelimiter,
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $d4d64b8f1dc7b188$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $51ab574519757f03$export$265f4c39182036e)(apiRef, apiRef.current.rootElementRef, 'keydown', handleCopy);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};


var $jSIPP = parcelRequire("jSIPP");


const $28c92264bb2fc8fe$export$ce7ce4871097b52e = (apiRef)=>{
    const lookup = $jSIPP.useRef({});
    const setCellColSpanInfo = $jSIPP.useCallback((rowId, columnIndex, cellColSpanInfo)=>{
        const sizes = lookup.current;
        if (!sizes[rowId]) sizes[rowId] = {};
        sizes[rowId][columnIndex] = cellColSpanInfo;
    }, []);
    const getCellColSpanInfo = $jSIPP.useCallback((rowId, columnIndex)=>{
        var _lookup$current$rowId;
        return (_lookup$current$rowId = lookup.current[rowId]) == null ? void 0 : _lookup$current$rowId[columnIndex];
    }, []);
    // Calculate `colSpan` for the cell.
    const calculateCellColSpan = $jSIPP.useCallback((params)=>{
        const { columnIndex: columnIndex, rowId: rowId, minFirstColumnIndex: minFirstColumnIndex, maxLastColumnIndex: maxLastColumnIndex, columns: columns } = params;
        const columnsLength = columns.length;
        const column = columns[columnIndex];
        const colSpan = typeof column.colSpan === 'function' ? column.colSpan(apiRef.current.getCellParams(rowId, column.field)) : column.colSpan;
        if (!colSpan || colSpan === 1) {
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: 1,
                    width: column.computedWidth
                }
            });
            return {
                colSpan: 1
            };
        }
        let width = column.computedWidth;
        for(let j = 1; j < colSpan; j += 1){
            const nextColumnIndex = columnIndex + j;
            // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
            if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
                const nextColumn = columns[nextColumnIndex];
                width += nextColumn.computedWidth;
                setCellColSpanInfo(rowId, columnIndex + j, {
                    spannedByColSpan: true,
                    rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                    leftVisibleCellIndex: columnIndex
                });
            }
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: colSpan,
                    width: width
                }
            });
        }
        return {
            colSpan: colSpan
        };
    }, [
        apiRef,
        setCellColSpanInfo
    ]);
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = $jSIPP.useCallback(({ rowId: rowId, minFirstColumn: minFirstColumn, maxLastColumn: maxLastColumn, columns: columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = calculateCellColSpan({
                columnIndex: i,
                rowId: rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns: columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        calculateCellColSpan
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        calculateColSpan: calculateColSpan
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnSpanningPublicApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnSpanningPrivateApi, 'private');
    const handleColumnReorderChange = $jSIPP.useCallback(()=>{
        // `colSpan` needs to be recalculated after column reordering
        lookup.current = {};
    }, []);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnOrderChange', handleColumnReorderChange);
};


var $jSIPP = parcelRequire("jSIPP");


/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $1fb248bc71e94512$export$f95aebe89510930(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI: exportAs not supported');
}






const $0061577af55363f8$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const $0061577af55363f8$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    const filteredSortedRowIds = (0, $dcdbd4f8634a4b8d$export$4e2a9d76902d271c)(apiRef);
    const rowTree = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $d7530f53594a6a47$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsIds = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.map((row)=>row.id)) || [];
    const bottomPinnedRowsIds = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.map((row)=>row.id)) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");








var $4uaIU = parcelRequire("4uaIU");
const $0d2c3b91287e2bff$var$_excluded = [
    "children",
    "onClick"
];
const $0d2c3b91287e2bff$export$9c3c7dbe6f1101cf = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarExportContainer(props, ref) {
    var _rootProps$slotProps;
    const { children: children, onClick: onClick } = props, other = (0, $cMu4A.default)(props, $0d2c3b91287e2bff$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const exportButtonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const exportMenuId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const [open, setOpen] = $jSIPP.useState(false);
    const buttonRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        onClick == null || onClick(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if ((0, $2200ee459e36b6d0$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $2200ee459e36b6d0$export$81301abbcd0c8143)(event.key)) handleMenuClose();
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                ref: handleRef,
                size: "small",
                startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.exportIcon, {}),
                "aria-expanded": open,
                "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                "aria-haspopup": "menu",
                "aria-controls": open ? exportMenuId : undefined,
                id: exportButtonId
            }, other, {
                onClick: handleMenuOpen
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
                children: apiRef.current.getLocaleText('toolbarExport')
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $67217aef89f147e8$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039), {
                    id: exportMenuId,
                    className: (0, $4d97f950d65e57e8$export$2100d54e36406477).menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: $jSIPP.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) return child;
                        return /*#__PURE__*/ $jSIPP.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});



var $4uaIU = parcelRequire("4uaIU");
const $a62d5bd6410a6559$var$_excluded = [
    "hideMenu",
    "options"
], $a62d5bd6410a6559$var$_excluded2 = [
    "hideMenu",
    "options"
], $a62d5bd6410a6559$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $a62d5bd6410a6559$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $cMu4A.default)(props, $a62d5bd6410a6559$var$_excluded);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), (0, $erOpW.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $a62d5bd6410a6559$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $cMu4A.default)(props, $a62d5bd6410a6559$var$_excluded2);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), (0, $erOpW.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
const $a62d5bd6410a6559$export$ef68b449b329deb5 = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarExport(props, ref) {
    const { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = props, other = (0, $cMu4A.default)(props, $a62d5bd6410a6559$var$_excluded3);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0d2c3b91287e2bff$export$9c3c7dbe6f1101cf), (0, $erOpW.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $jSIPP.cloneElement(button.component, {
                key: index
            }))
    }));
});



var $4uaIU = parcelRequire("4uaIU");
const $9e8a68c78a7db132$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $jSIPP.useCallback((options = {})=>{
        var _options$getRowsToExp, _options$includeHeade, _options$includeColum;
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $0061577af55363f8$export$c5c7f3bb5f79a15d)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = (_options$getRowsToExp = options.getRowsToExport) != null ? _options$getRowsToExp : (0, $0061577af55363f8$export$99156d1572dee776);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $44d9a7dcee15cc41$export$8bfbf32dccc29440)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            delimiterCharacter: options.delimiter || ',',
            includeHeaders: (_options$includeHeade = options.includeHeaders) != null ? _options$includeHeade : true,
            includeColumnGroupsHeaders: (_options$includeColum = options.includeColumnGroupsHeaders) != null ? _options$includeColum : true,
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $jSIPP.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options != null && options.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $1fb248bc71e94512$export$f95aebe89510930)(blob, 'csv', options == null ? void 0 : options.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $jSIPP.useCallback((initialValue, options)=>{
        var _options$csvOptions;
        if ((_options$csvOptions = options.csvOptions) != null && _options$csvOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a62d5bd6410a6559$export$c0e66088a5c9ffbf), {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};


var $jSIPP = parcelRequire("jSIPP");











const $55c6ca5aa8139e95$var$isTestEnvironment = false;
const $55c6ca5aa8139e95$var$hasScroll = ({ content: content, container: container, scrollBarSize: scrollBarSize })=>{
    const hasScrollXIfNoYScrollBar = content.width > container.width;
    const hasScrollYIfNoXScrollBar = content.height > container.height;
    let hasScrollX = false;
    let hasScrollY = false;
    if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
        hasScrollX = hasScrollXIfNoYScrollBar;
        hasScrollY = content.height + (hasScrollX ? scrollBarSize : 0) > container.height;
        // We recalculate the scroll x to consider the size of the y scrollbar.
        if (hasScrollY) hasScrollX = content.width + scrollBarSize > container.width;
    }
    return {
        hasScrollX: hasScrollX,
        hasScrollY: hasScrollY
    };
};
function $55c6ca5aa8139e95$export$b8364994f9eec67d(apiRef, props) {
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useResizeContainer');
    const errorShown = $jSIPP.useRef(false);
    const rootDimensionsRef = $jSIPP.useRef(null);
    const fullDimensionsRef = $jSIPP.useRef(null);
    const rowsMeta = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab));
    const densityFactor = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$c646201fb1d3e7a6));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    const totalHeaderHeight = (0, $50fcb4d7c433ea68$export$659109c29172602f)(apiRef, props.columnHeaderHeight);
    const updateGridDimensionsRef = $jSIPP.useCallback(()=>{
        var _apiRef$current$rootE;
        const rootElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null ? void 0 : _apiRef$current$rootE.current;
        const columnsTotalWidth = (0, $90c6bb88bfe45f18$export$ab20f9d33edc7794)(apiRef);
        const pinnedRowsHeight = (0, $db5319c56f201804$export$d299da5915ed6fec)(apiRef);
        if (!rootDimensionsRef.current) return;
        let scrollBarSize;
        if (props.scrollbarSize != null) scrollBarSize = props.scrollbarSize;
        else if (!columnsTotalWidth || !rootElement) scrollBarSize = 0;
        else {
            const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(rootElement);
            const scrollDiv = doc.createElement('div');
            scrollDiv.style.width = '99px';
            scrollDiv.style.height = '99px';
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.overflow = 'scroll';
            scrollDiv.className = 'scrollDiv';
            rootElement.appendChild(scrollDiv);
            scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            rootElement.removeChild(scrollDiv);
        }
        let viewportOuterSize;
        let hasScrollX;
        let hasScrollY;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rowsMeta.currentPageTotalHeight + (hasScrollX ? scrollBarSize : 0)
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: Math.max(rootDimensionsRef.current.height - totalHeaderHeight, 0)
            };
            const scrollInformation = $55c6ca5aa8139e95$var$hasScroll({
                content: {
                    width: Math.round(columnsTotalWidth),
                    height: rowsMeta.currentPageTotalHeight
                },
                container: {
                    width: Math.round(viewportOuterSize.width),
                    height: viewportOuterSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom
                },
                scrollBarSize: scrollBarSize
            });
            hasScrollY = scrollInformation.hasScrollY;
            hasScrollX = scrollInformation.hasScrollX;
        }
        const viewportInnerSize = {
            width: viewportOuterSize.width - (hasScrollY ? scrollBarSize : 0),
            height: viewportOuterSize.height - (hasScrollX ? scrollBarSize : 0)
        };
        const newFullDimensions = {
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollBarSize: scrollBarSize
        };
        const prevDimensions = fullDimensionsRef.current;
        fullDimensionsRef.current = newFullDimensions;
        if (newFullDimensions.viewportInnerSize.width !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.width) || newFullDimensions.viewportInnerSize.height !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.height)) apiRef.current.publishEvent('viewportInnerSizeChange', newFullDimensions.viewportInnerSize);
    }, [
        apiRef,
        props.scrollbarSize,
        props.autoHeight,
        rowsMeta.currentPageTotalHeight,
        totalHeaderHeight
    ]);
    const [savedSize, setSavedSize] = $jSIPP.useState();
    const debouncedSetSavedSize = $jSIPP.useMemo(()=>(0, $73208469ed38da03$export$2e2bcd8739ae039)(setSavedSize, 60), []);
    const previousSize = $jSIPP.useRef();
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        if (savedSize) {
            updateGridDimensionsRef();
            apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
        }
    }, [
        apiRef,
        savedSize,
        updateGridDimensionsRef
    ]);
    // This is the function called by apiRef.current.resize()
    const resize = $jSIPP.useCallback(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
    }, [
        apiRef
    ]);
    const getRootDimensions = $jSIPP.useCallback(()=>fullDimensionsRef.current, []);
    const getViewportPageSize = $jSIPP.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return 0;
        const currentPage = (0, $0a6b6a2469195bfe$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = apiRef.current.getRenderContext();
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode,
        props.getRowHeight,
        rowHeight
    ]);
    const computeSizeAndPublishResizeEvent = $jSIPP.useCallback(()=>{
        var _apiRef$current$mainE, _previousSize$current, _previousSize$current2;
        const mainEl = (_apiRef$current$mainE = apiRef.current.mainElementRef) == null ? void 0 : _apiRef$current$mainE.current;
        if (!mainEl) return;
        const win = (0, $59925aae262a63be$export$2e2bcd8739ae039)(mainEl);
        const computedStyle = win.getComputedStyle(mainEl);
        const height = parseFloat(computedStyle.height) || 0;
        const width = parseFloat(computedStyle.width) || 0;
        const hasHeightChanged = height !== ((_previousSize$current = previousSize.current) == null ? void 0 : _previousSize$current.height);
        const hasWidthChanged = width !== ((_previousSize$current2 = previousSize.current) == null ? void 0 : _previousSize$current2.width);
        if (!previousSize.current || hasHeightChanged || hasWidthChanged) {
            const size = {
                width: width,
                height: height
            };
            apiRef.current.publishEvent('resize', size);
            previousSize.current = size;
        }
    }, [
        apiRef
    ]);
    const dimensionsApi = {
        resize: resize,
        getRootDimensions: getRootDimensions
    };
    const dimensionsPrivateApi = {
        getViewportPageSize: getViewportPageSize,
        updateGridDimensionsRef: updateGridDimensionsRef,
        computeSizeAndPublishResizeEvent: computeSizeAndPublishResizeEvent
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, dimensionsApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, dimensionsPrivateApi, 'private');
    const isFirstSizing = $jSIPP.useRef(true);
    const handleResize = $jSIPP.useCallback((size)=>{
        rootDimensionsRef.current = size;
        // jsdom has no layout capabilities
        const isJSDOM = /jsdom/.test(window.navigator.userAgent);
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !isJSDOM) {
            logger.error([
                'The parent DOM element of the data grid has an empty height.',
                'Please make sure that this element has an intrinsic height.',
                'The grid displays with a height of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !isJSDOM) {
            logger.error([
                'The parent DOM element of the data grid has an empty width.',
                'Please make sure that this element has an intrinsic width.',
                'The grid displays with a width of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if ($55c6ca5aa8139e95$var$isTestEnvironment) {
            // We don't need to debounce the resize for tests.
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        if (isFirstSizing.current) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        debouncedSetSavedSize(size);
    }, [
        props.autoHeight,
        debouncedSetSavedSize,
        logger
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>updateGridDimensionsRef(), [
        updateGridDimensionsRef
    ]);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'sortedRowsSet', updateGridDimensionsRef);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'paginationModelChange', updateGridDimensionsRef);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnsChange', updateGridDimensionsRef);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'resize', handleResize);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'debouncedResize', props.onResize);
}


function $53925319f95ad051$export$8456f443918812d4(apiRef, props) {
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'cellClick', props.onCellClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'menuClose', props.onMenuClose);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowClick', props.onRowClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'stateChange', props.onStateChange);
}


var $jSIPP = parcelRequire("jSIPP");


const $1fbb48792d0b168c$var$forceDebug = (0, $a4e890cf7e68aae0$export$c43914e0cb16a981)() && window.localStorage.getItem('DEBUG') != null;
const $1fbb48792d0b168c$var$noop = ()=>{};
const $1fbb48792d0b168c$var$noopLogger = {
    debug: $1fbb48792d0b168c$var$noop,
    info: $1fbb48792d0b168c$var$noop,
    warn: $1fbb48792d0b168c$var$noop,
    error: $1fbb48792d0b168c$var$noop
};
const $1fbb48792d0b168c$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $1fbb48792d0b168c$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $1fbb48792d0b168c$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI: Log level ${logLevel} not recognized.`);
    const logger = $1fbb48792d0b168c$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $1fbb48792d0b168c$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $1fbb48792d0b168c$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $jSIPP.useCallback((name)=>{
        if ($1fbb48792d0b168c$var$forceDebug) return $1fbb48792d0b168c$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $1fbb48792d0b168c$var$noopLogger;
        return $1fbb48792d0b168c$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, {
        getLogger: getLogger
    }, 'private');
};



var $jSIPP = parcelRequire("jSIPP");
class $0a8e8522c72658e6$export$390f32400eaf98c9 {
    static create(value) {
        return new $0a8e8522c72658e6$export$390f32400eaf98c9(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}




// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $4e8a53955a6ed991$export$cc74486daaaef499 {
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
}


const $902a289a40ed0412$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $902a289a40ed0412$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $902a289a40ed0412$export$37686f243ec62a21(publicApi) {
    return publicApi[$902a289a40ed0412$var$SYMBOL_API_PRIVATE];
}
let $902a289a40ed0412$var$globalId = 0;
function $902a289a40ed0412$var$createPrivateAPI(publicApiRef) {
    var _publicApiRef$current;
    const existingPrivateApi = (_publicApiRef$current = publicApiRef.current) == null ? void 0 : _publicApiRef$current[$902a289a40ed0412$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $0a8e8522c72658e6$export$390f32400eaf98c9).create(state),
        instanceId: {
            id: $902a289a40ed0412$var$globalId
        }
    };
    $902a289a40ed0412$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if ((currentPrivateMethod == null ? void 0 : currentPrivateMethod.spying) === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if ((currentPublicMethod == null ? void 0 : currentPublicMethod.spying) === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new (0, $4e8a53955a6ed991$export$cc74486daaaef499)()
    });
    return privateApi;
}
function $902a289a40ed0412$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$902a289a40ed0412$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $902a289a40ed0412$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $jSIPP.useRef();
    const privateApiRef = $jSIPP.useRef();
    if (!privateApiRef.current) privateApiRef.current = $902a289a40ed0412$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $902a289a40ed0412$var$createPublicAPI(privateApiRef);
    const publishEvent = $jSIPP.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($902a289a40ed0412$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGridPro ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $jSIPP.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    $jSIPP.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $jSIPP.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}



var $jSIPP = parcelRequire("jSIPP");
const $8c4adb0add69cd15$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $jSIPP.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};



var $cMu4A = parcelRequire("cMu4A");

var $dBoEs = parcelRequire("dBoEs");

var $jSIPP = parcelRequire("jSIPP");

const $6ad0e1c005c699cd$export$1c5794e7ed1dc58f = (apiRef)=>{
    const processorsCache = $jSIPP.useRef({});
    const isRunning = $jSIPP.useRef(false);
    const runAppliers = $jSIPP.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $jSIPP.useCallback((group, id, processor)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        const groupCache = processorsCache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            runAppliers(groupCache);
        }
        return ()=>{
            processorsCache.current[group].processors.set(id, null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = $jSIPP.useCallback((group, id, applier)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        processorsCache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = processorsCache.current[group].appliers, otherAppliers = (0, $cMu4A.default)(_appliers, [
                id
            ].map((0, $dBoEs.default)));
            processorsCache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $jSIPP.useCallback((group)=>{
        const groupCache = processorsCache.current[group];
        runAppliers(groupCache);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $jSIPP.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!processorsCache.current[group]) return value;
        const preProcessors = Array.from(processorsCache.current[group].processors.values());
        return preProcessors.reduce((acc, preProcessor)=>{
            if (!preProcessor) return acc;
            return preProcessor(acc, context);
        }, value);
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, preProcessingPrivateApi, 'private');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, preProcessingPublicApi, 'public');
};




var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



const $7a9f809c9be775cb$export$53c7ec825c1e4d3f = (apiRef, props)=>{
    const controlStateMapRef = $jSIPP.useRef({});
    const [, rawForceUpdate] = $jSIPP.useState();
    const registerControlState = $jSIPP.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $jSIPP.useCallback((state, reason)=>{
        let newState;
        if ((0, $a4e890cf7e68aae0$export$f6e2535fb5126e54)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            if (apiRef.current.publishEvent) apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) {
                const details = props.signature === (0, $51ad73708acc0b23$export$544be0bdf85b5af1).DataGridPro ? {
                    api: apiRef.current,
                    reason: reason
                } : {
                    reason: reason
                };
                controlState.propOnChange(model, details);
            }
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef,
        props.signature
    ]);
    const updateControlState = $jSIPP.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $erOpW.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = $jSIPP.useCallback(()=>rawForceUpdate(()=>apiRef.current.state), [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState,
        forceUpdate: forceUpdate
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, publicStateApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, privateStateApi, 'private');
};


const $1780d7784e2d3c29$export$b77462c86b28bbf0 = (inputApiRef, props)=>{
    const privateApiRef = (0, $902a289a40ed0412$export$72d4a6c5ec1a4b32)(inputApiRef, props);
    (0, $1fbb48792d0b168c$export$db6c72f4003d67df)(privateApiRef, props);
    (0, $7a9f809c9be775cb$export$53c7ec825c1e4d3f)(privateApiRef, props);
    (0, $6ad0e1c005c699cd$export$1c5794e7ed1dc58f)(privateApiRef);
    (0, $0cb8bc389b379b36$export$594711f8e5fa9b04)(privateApiRef);
    (0, $8c4adb0add69cd15$export$9943f2ed4ddf85bf)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
    return privateApiRef;
};


var $jSIPP = parcelRequire("jSIPP");
const $11e04fa43048a7f9$export$f9587d613f2caeec = (initializer, privateApiRef, props)=>{
    const isInitialized = $jSIPP.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};


var $jSIPP = parcelRequire("jSIPP");














/* eslint-disable @typescript-eslint/naming-convention */ 
const $8d80117254c81c02$export$baf6aa65d419d3eb = (state)=>state.headerFiltering;
const $8d80117254c81c02$export$84089ff684fa560a = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($8d80117254c81c02$export$baf6aa65d419d3eb, (headerFilteringState)=>headerFilteringState.editing);
const $8d80117254c81c02$export$1080dcf0065c0872 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($8d80117254c81c02$export$baf6aa65d419d3eb, (headerFilteringState)=>headerFilteringState.menuOpen);




function $6f5781c721454283$var$enrichPageRowsWithPinnedRows(apiRef, rows) {
    const pinnedRows = (0, $d7530f53594a6a47$export$ffe7071c481e32b0)(apiRef) || {};
    return [
        ...pinnedRows.top || [],
        ...rows,
        ...pinnedRows.bottom || []
    ];
}
const $6f5781c721454283$var$getLeftColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === 'rtl') {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (direction === 'ltr') {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $6f5781c721454283$var$getRightColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === 'rtl') {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (direction === 'ltr') {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
const $6f5781c721454283$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridKeyboardNavigation');
    const initialCurrentPageRows = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, props).rows;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const currentPageRows = $jSIPP.useMemo(()=>$6f5781c721454283$var$enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [
        apiRef,
        initialCurrentPageRows
    ]);
    const headerFilteringEnabled = // @ts-expect-error // TODO move relevant code to the `DataGridPro`
    props.signature !== 'DataGrid' && props.unstable_headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {number} rowIndex index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $jSIPP.useCallback((colIndex, rowId, closestColumnToUse = 'left')=>{
        const visibleSortedRows = (0, $dcdbd4f8634a4b8d$export$2f31562143a3e5d4)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === rowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setCellFocus(rowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $jSIPP.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $jSIPP.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $jSIPP.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $jSIPP.useCallback((rowIndex)=>{
        var _currentPageRows$rowI;
        return (_currentPageRows$rowI = currentPageRows[rowIndex]) == null ? void 0 : _currentPageRows$rowI.id;
    }, [
        currentPageRows
    ]);
    const handleColumnHeaderKeyDown = $jSIPP.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $b713438374cc7354$export$b2e9ab6103a664ad).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $24c0f923081db0c8$export$4cf0369c079b29be)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (firstRowIndexInPage !== null) {
                    if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                    else goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                }
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = $6f5781c721454283$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $6f5781c721454283$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        theme.direction,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $jSIPP.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const isEditing = (0, $8d80117254c81c02$export$84089ff684fa560a)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $8d80117254c81c02$export$1080dcf0065c0872)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $2200ee459e36b6d0$export$e13d96c38a470518)(event.key)) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = $6f5781c721454283$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $6f5781c721454283$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeaderFilter,
        theme.direction,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $jSIPP.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const focusedColumnGroup = (0, $196c4c77eabe7b5f$export$7442f29af2d5c4da)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $57b3ed5f9013058b$export$84e4fdd8f295ca31).Edit || !(0, $2200ee459e36b6d0$export$e13d96c38a470518)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const dimensions = apiRef.current.getRootDimensions();
        if (currentPageRows.length === 0 || !dimensions) return;
        const direction = theme.direction;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = $6f5781c721454283$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $6f5781c721454283$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === (0, $1048d489942eaf21$export$6e5a576305a34719)) break;
                    const colDef = params.colDef;
                    if (colDef && colDef.type === 'treeDataGroup') break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        theme.direction,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $jSIPP.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");














var $4uaIU = parcelRequire("4uaIU");
function $320927f1410d6120$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $320927f1410d6120$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $320927f1410d6120$export$41205b2521d4edd4 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridPrintExport');
    const doc = $jSIPP.useRef(null);
    const previousGridState = $jSIPP.useRef(null);
    const previousColumnVisibility = $jSIPP.useRef({});
    const previousRows = $jSIPP.useRef([]);
    $jSIPP.useEffect(()=>{
        doc.current = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
    }, [
        apiRef
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $jSIPP.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $0061577af55363f8$export$c5c7f3bb5f79a15d)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $90c6bb88bfe45f18$export$da85f06e3c19f1fd)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $b713438374cc7354$export$b2e9ab6103a664ad).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $jSIPP.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.map((id)=>apiRef.current.getRow(id));
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $jSIPP.useCallback((printWindow, options)=>{
        var _querySelector, _querySelector2;
        const normalizeOptions = (0, $erOpW.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).main}`);
        gridMain.style.overflow = 'visible';
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = 'size';
        const columnHeaders = gridClone.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaders}`);
        const columnHeadersInner = columnHeaders.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeadersInner}`);
        columnHeadersInner.style.width = '100%';
        let gridToolbarElementHeight = ((_querySelector = gridRootElement.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).toolbarContainer}`)) == null ? void 0 : _querySelector.offsetHeight) || 0;
        let gridFooterElementHeight = ((_querySelector2 = gridRootElement.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).footerContainer}`)) == null ? void 0 : _querySelector2.offsetHeight) || 0;
        if (normalizeOptions.hideToolbar) {
            var _gridClone$querySelec;
            (_gridClone$querySelec = gridClone.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).toolbarContainer}`)) == null || _gridClone$querySelec.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter) {
            var _gridClone$querySelec2;
            (_gridClone$querySelec2 = gridClone.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).footerContainer}`)) == null || _gridClone$querySelec2.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $50fcb4d7c433ea68$export$659109c29172602f)(apiRef, props.columnHeaderHeight) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        // the footer is always being placed at the bottom of the page as if all rows are exported
        // so if getRowsToExport is being used to only export a subset of rows then we need to
        // adjust the footer position to be correctly placed at the bottom of the grid
        if (options != null && options.getRowsToExport) {
            const gridFooterElement = gridClone.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).footerContainer}`);
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === 'STYLE') {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = '';
                        // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute('href')) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener('load', ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props.columnHeaderHeight
    ]);
    const handlePrintWindowAfterPrint = $jSIPP.useCallback((printWindow)=>{
        var _previousGridState$cu;
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!((_previousGridState$cu = previousGridState.current) != null && (_previousGridState$cu = _previousGridState$cu.columns) != null && _previousGridState$cu.columnVisibilityModel)) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.unstable_setVirtualization(true);
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $jSIPP.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $90c6bb88bfe45f18$export$eb0d33595fe29bb4)(apiRef);
        previousRows.current = apiRef.current.getSortedRows();
        if (props.pagination) {
            const visibleRowCount = (0, $dcdbd4f8634a4b8d$export$96919017bbfaec0d)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.updateControlState('pagination', // Using signature `DataGridPro` to allow more than 100 rows in the print export
            (0, $fe5aad41f2d2873c$export$65b7f0a0a8dbd594)(visibleRowCount, 'DataGridPro', paginationModel));
            apiRef.current.forceUpdate();
        }
        await updateGridColumnsForPrint(options == null ? void 0 : options.fields, options == null ? void 0 : options.allColumns, options == null ? void 0 : options.includeCheckboxes);
        if (options != null && options.getRowsToExport) updateGridRowsForPrint(options.getRowsToExport);
        apiRef.current.unstable_setVirtualization(false);
        await $320927f1410d6120$var$raf(); // wait for the state changes to take action
        const printWindow = $320927f1410d6120$var$buildPrintWindow(options == null ? void 0 : options.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $jSIPP.useCallback((initialValue, options)=>{
        var _options$printOptions;
        if ((_options$printOptions = options.printOptions) != null && _options$printOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a62d5bd6410a6559$export$a6cd094b30f69b92), {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");



const $a1d024b4a843f9a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $jSIPP.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $a1d024b4a843f9a5$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $a1d024b4a843f9a5$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $jSIPP.useCallback((columnsState)=>{
        const selectionColumn = (0, $erOpW.default)({}, (0, $b713438374cc7354$export$b2e9ab6103a664ad), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const haveSelectionColumn = columnsState.lookup[0, $b713438374cc7354$export$322dfed7a1df1b02] != null;
        if (shouldHaveSelectionColumn && !haveSelectionColumn) {
            columnsState.lookup[0, $b713438374cc7354$export$322dfed7a1df1b02] = selectionColumn;
            columnsState.orderedFields = [
                (0, $b713438374cc7354$export$322dfed7a1df1b02),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
            delete columnsState.lookup[0, $b713438374cc7354$export$322dfed7a1df1b02];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $b713438374cc7354$export$322dfed7a1df1b02));
        } else if (shouldHaveSelectionColumn && haveSelectionColumn) columnsState.lookup[0, $b713438374cc7354$export$322dfed7a1df1b02] = (0, $erOpW.default)({}, selectionColumn, columnsState.lookup[0, $b713438374cc7354$export$322dfed7a1df1b02]);
        return columnsState;
    }, [
        apiRef,
        classes,
        props.checkboxSelection
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'hydrateColumns', updateSelectionColumn);
};


var $erOpW = parcelRequire("erOpW");


const $d54ed841d5f0e163$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $db5319c56f201804$export$433b924dc2506913)]: (0, $erOpW.default)({}, (0, $db5319c56f201804$export$96a607054e9bfd0c)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $db5319c56f201804$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $0cb8bc389b379b36$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $d54ed841d5f0e163$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $erOpW.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $db5319c56f201804$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $db5319c56f201804$export$433b924dc2506913];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $db5319c56f201804$export$433b924dc2506913] = (0, $erOpW.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $0cb8bc389b379b36$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $d54ed841d5f0e163$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $d54ed841d5f0e163$var$createFlatRowTree(params.updates.rows);
    return $d54ed841d5f0e163$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $d54ed841d5f0e163$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(apiRef, (0, $0cb8bc389b379b36$export$84214fbf04c4094), 'rowTreeCreation', $d54ed841d5f0e163$var$flatRowTreeCreationMethod);
};


var $jSIPP = parcelRequire("jSIPP");










// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $c6cc869fef2f8b95$var$scrollIntoView(dimensions) {
    const { clientHeight: clientHeight, scrollTop: scrollTop, offsetHeight: offsetHeight, offsetTop: offsetTop } = dimensions;
    const elementBottom = offsetTop + offsetHeight;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (offsetHeight > clientHeight) return offsetTop;
    if (elementBottom - clientHeight > scrollTop) return elementBottom - clientHeight;
    if (offsetTop < scrollTop) return offsetTop;
    return undefined;
}
const $c6cc869fef2f8b95$export$d3441dc29db31b8c = (apiRef, props)=>{
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersElementRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$2f31562143a3e5d4));
    const scrollToIndexes = $jSIPP.useCallback((params)=>{
        const totalRowCount = (0, $d7530f53594a6a47$export$1641ef9d08e265ca)(apiRef);
        const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex != null) {
            const columnPositions = (0, $90c6bb88bfe45f18$export$fce7d810e48021e3)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                var _visibleSortedRows$pa;
                const rowId = (_visibleSortedRows$pa = visibleSortedRows[params.rowIndex]) == null ? void 0 : _visibleSortedRows$pa.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $c6cc869fef2f8b95$var$scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientWidth,
                scrollTop: Math.abs(virtualScrollerRef.current.scrollLeft),
                offsetHeight: cellWidth,
                offsetTop: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex != null) {
            var _querySelector, _querySelector2;
            const rowsMeta = (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab)(apiRef.current.state);
            const page = (0, $23354dc00cec9d31$export$1f7f64fcb62ccdad)(apiRef);
            const pageSize = (0, $23354dc00cec9d31$export$721a46720a2de097)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            const topPinnedRowsHeight = ((_querySelector = virtualScrollerRef.current.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedRows--top']}`)) == null ? void 0 : _querySelector.clientHeight) || 0;
            const bottomPinnedRowsHeight = ((_querySelector2 = virtualScrollerRef.current.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedRows--bottom']}`)) == null ? void 0 : _querySelector2.clientHeight) || 0;
            scrollCoordinates.top = $c6cc869fef2f8b95$var$scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientHeight - topPinnedRowsHeight - bottomPinnedRowsHeight,
                scrollTop: virtualScrollerRef.current.scrollTop,
                offsetHeight: targetOffsetHeight,
                offsetTop: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = $jSIPP.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left != null && colRef.current) {
            const direction = theme.direction === 'rtl' ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top != null) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        theme.direction,
        colRef,
        logger
    ]);
    const getScrollPosition = $jSIPP.useCallback(()=>{
        if (!(virtualScrollerRef != null && virtualScrollerRef.current)) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, scrollApi, 'public');
};


var $jSIPP = parcelRequire("jSIPP");

const $0c9ae20818cda34b$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $jSIPP.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $jSIPP.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, statePersistenceApi, 'public');
};


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

const $8c1add1acba927d3$export$42963ad70bb69f54 = (state, props)=>{
    const virtualization = {
        enabled: !props.disableVirtualization,
        enabledForColumns: true
    };
    return (0, $erOpW.default)({}, state, {
        virtualization: virtualization
    });
};
function $8c1add1acba927d3$export$aa0d6df32cccbd53(apiRef, props) {
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                virtualization: (0, $erOpW.default)({}, state.virtualization, {
                    enabled: enabled
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                virtualization: (0, $erOpW.default)({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, api, 'public');
    /*
   * EFFECTS
   */ /* eslint-disable react-hooks/exhaustive-deps */ $jSIPP.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }



var $jSIPP = parcelRequire("jSIPP");


const $5a04cda6c374f8fe$export$ffcbb8895be5a582 = (apiRef, props)=>{
    const visibleColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9));
    const currentPage = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(apiRef, props);
    const rowsMeta = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab));
    const contentHeight = Math.max(rowsMeta.currentPageTotalHeight, 1);
    const isInScrollBottomArea = $jSIPP.useRef(false);
    const handleRowsScrollEnd = $jSIPP.useCallback((scrollPosition)=>{
        const dimensions = apiRef.current.getRootDimensions();
        // Prevent the infite loading working in combination with lazy loading
        if (!dimensions || props.rowsLoadingMode !== 'client') return;
        const scrollPositionBottom = scrollPosition.top + dimensions.viewportOuterSize.height;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        if (scrollPositionBottom < contentHeight - props.scrollEndThreshold) isInScrollBottomArea.current = false;
        if (scrollPositionBottom >= contentHeight - props.scrollEndThreshold && !isInScrollBottomArea.current) {
            const rowScrollEndParam = {
                visibleColumns: visibleColumns,
                viewportPageSize: viewportPageSize,
                visibleRowsCount: currentPage.rows.length
            };
            apiRef.current.publishEvent('rowsScrollEnd', rowScrollEndParam);
            isInScrollBottomArea.current = true;
        }
    }, [
        contentHeight,
        props.scrollEndThreshold,
        props.rowsLoadingMode,
        visibleColumns,
        apiRef,
        currentPage.rows.length
    ]);
    const handleGridScroll = $jSIPP.useCallback(({ left: left, top: top })=>{
        handleRowsScrollEnd({
            left: left,
            top: top
        });
    }, [
        handleRowsScrollEnd
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'scrollPositionChange', handleGridScroll);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowsScrollEnd', props.onRowsScrollEnd);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");



const $4202d6c605217d06$export$72ac47d6066a8a99 = (state)=>state.columnReorder;
const $4202d6c605217d06$export$78d24cc7373bc611 = (0, $cf9e768be0a96dbe$export$595d22ed68ca2841)($4202d6c605217d06$export$72ac47d6066a8a99, (columnReorder)=>columnReorder.dragCol);


const $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_LEFT = 'left';
const $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_RIGHT = 'right';
const $f6681066264e6e88$var$getCursorMoveDirectionX = (currentCoordinates, nextCoordinates)=>{
    return currentCoordinates.x <= nextCoordinates.x ? $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_RIGHT : $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_LEFT;
};
const $f6681066264e6e88$var$hasCursorPositionChanged = (currentCoordinates, nextCoordinates)=>currentCoordinates.x !== nextCoordinates.x || currentCoordinates.y !== nextCoordinates.y;
const $f6681066264e6e88$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        columnHeaderDragging: [
            'columnHeader--dragging'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $f6681066264e6e88$export$c111e737ab642862 = (state)=>(0, $erOpW.default)({}, state, {
        columnReorder: {
            dragCol: ''
        }
    });
const $f6681066264e6e88$export$e060c7667a4364d2 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridColumnReorder');
    const dragColNode = $jSIPP.useRef(null);
    const cursorPosition = $jSIPP.useRef({
        x: 0,
        y: 0
    });
    const originColumnIndex = $jSIPP.useRef(null);
    const forbiddenIndexes = $jSIPP.useRef({});
    const removeDnDStylesTimeout = $jSIPP.useRef();
    const ownerState = {
        classes: props.classes
    };
    const classes = $f6681066264e6e88$var$useUtilityClasses(ownerState);
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    $jSIPP.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    const handleDragStart = $jSIPP.useCallback((params, event)=>{
        if (props.disableColumnReorder || params.colDef.disableReorder) return;
        logger.debug(`Start dragging col ${params.field}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragColNode.current = event.currentTarget;
        dragColNode.current.classList.add(classes.columnHeaderDragging);
        if (event.dataTransfer) event.dataTransfer.effectAllowed = 'move';
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                columnReorder: (0, $erOpW.default)({}, state.columnReorder, {
                    dragCol: params.field
                })
            }));
        apiRef.current.forceUpdate();
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragColNode.current.classList.remove(classes.columnHeaderDragging);
        });
        originColumnIndex.current = apiRef.current.getColumnIndex(params.field, false);
        const draggingColumnGroupPath = apiRef.current.unstable_getColumnGroupPath(params.field);
        const columnIndex = originColumnIndex.current;
        const allColumns = apiRef.current.getAllColumns();
        const groupsLookup = apiRef.current.unstable_getAllGroupDetails();
        const getGroupPathFromColumnIndex = (colIndex)=>{
            const field = allColumns[colIndex].field;
            return apiRef.current.unstable_getColumnGroupPath(field);
        };
        // The limitingGroupId is the id of the group from which the dragged column should not escape
        let limitingGroupId = null;
        draggingColumnGroupPath.forEach((groupId)=>{
            var _groupsLookup$groupId;
            if (!((_groupsLookup$groupId = groupsLookup[groupId]) != null && _groupsLookup$groupId.freeReordering)) {
                // Only consider group that are made of more than one column
                if (columnIndex > 0 && getGroupPathFromColumnIndex(columnIndex - 1).includes(groupId)) limitingGroupId = groupId;
                else if (columnIndex + 1 < allColumns.length && getGroupPathFromColumnIndex(columnIndex + 1).includes(groupId)) limitingGroupId = groupId;
            }
        });
        forbiddenIndexes.current = {};
        for(let indexToForbid = 0; indexToForbid < allColumns.length; indexToForbid += 1){
            const leftIndex = indexToForbid <= columnIndex ? indexToForbid - 1 : indexToForbid;
            const rightIndex = indexToForbid < columnIndex ? indexToForbid : indexToForbid + 1;
            if (limitingGroupId !== null) {
                // verify this indexToForbid will be linked to the limiting group. Otherwise forbid it
                let allowIndex = false;
                if (leftIndex >= 0 && getGroupPathFromColumnIndex(leftIndex).includes(limitingGroupId)) allowIndex = true;
                else if (rightIndex < allColumns.length && getGroupPathFromColumnIndex(rightIndex).includes(limitingGroupId)) allowIndex = true;
                if (!allowIndex) forbiddenIndexes.current[indexToForbid] = true;
            }
            // Verify we are not splitting another group
            if (leftIndex >= 0 && rightIndex < allColumns.length) getGroupPathFromColumnIndex(rightIndex).forEach((groupId)=>{
                if (getGroupPathFromColumnIndex(leftIndex).includes(groupId)) {
                    if (!draggingColumnGroupPath.includes(groupId)) {
                        var _groupsLookup$groupId2;
                        // moving here split the group groupId in two distincts chunks
                        if (!((_groupsLookup$groupId2 = groupsLookup[groupId]) != null && _groupsLookup$groupId2.freeReordering)) forbiddenIndexes.current[indexToForbid] = true;
                    }
                }
            });
        }
    }, [
        props.disableColumnReorder,
        classes.columnHeaderDragging,
        logger,
        apiRef
    ]);
    const handleDragEnter = $jSIPP.useCallback((params, event)=>{
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
    }, []);
    const handleDragOver = $jSIPP.useCallback((params, event)=>{
        const dragColField = (0, $4202d6c605217d06$export$78d24cc7373bc611)(apiRef);
        if (!dragColField) return;
        logger.debug(`Dragging over col ${params.field}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const coordinates = {
            x: event.clientX,
            y: event.clientY
        };
        if (params.field !== dragColField && $f6681066264e6e88$var$hasCursorPositionChanged(cursorPosition.current, coordinates)) {
            const targetColIndex = apiRef.current.getColumnIndex(params.field, false);
            const targetColVisibleIndex = apiRef.current.getColumnIndex(params.field, true);
            const targetCol = apiRef.current.getColumn(params.field);
            const dragColIndex = apiRef.current.getColumnIndex(dragColField, false);
            const visibleColumns = apiRef.current.getVisibleColumns();
            const allColumns = apiRef.current.getAllColumns();
            const cursorMoveDirectionX = $f6681066264e6e88$var$getCursorMoveDirectionX(cursorPosition.current, coordinates);
            const hasMovedLeft = cursorMoveDirectionX === $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_LEFT && (theme.direction === 'rtl' ? dragColIndex < targetColIndex : targetColIndex < dragColIndex);
            const hasMovedRight = cursorMoveDirectionX === $f6681066264e6e88$var$CURSOR_MOVE_DIRECTION_RIGHT && (theme.direction === 'rtl' ? targetColIndex < dragColIndex : dragColIndex < targetColIndex);
            if (hasMovedLeft || hasMovedRight) {
                let canBeReordered;
                let indexOffsetInHiddenColumns = 0;
                if (!targetCol.disableReorder) canBeReordered = true;
                else if (hasMovedLeft) canBeReordered = targetColVisibleIndex > 0 && !visibleColumns[targetColVisibleIndex - 1].disableReorder;
                else canBeReordered = targetColVisibleIndex < visibleColumns.length - 1 && !visibleColumns[targetColVisibleIndex + 1].disableReorder;
                if (forbiddenIndexes.current[targetColIndex]) {
                    let nextVisibleColumnField;
                    let indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                    if (hasMovedLeft) {
                        nextVisibleColumnField = targetColVisibleIndex > 0 ? visibleColumns[targetColVisibleIndex - 1].field : null;
                        while(indexWithOffset > 0 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns -= 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    } else {
                        nextVisibleColumnField = targetColVisibleIndex + 1 < visibleColumns.length ? visibleColumns[targetColVisibleIndex + 1].field : null;
                        while(indexWithOffset < allColumns.length - 1 && allColumns[indexWithOffset].field !== nextVisibleColumnField && forbiddenIndexes.current[indexWithOffset]){
                            indexOffsetInHiddenColumns += 1;
                            indexWithOffset = targetColIndex + indexOffsetInHiddenColumns;
                        }
                    }
                    if (forbiddenIndexes.current[indexWithOffset] || allColumns[indexWithOffset].field === nextVisibleColumnField) // If we ended up on a visible column, or a forbidden one, we can not do the reorder
                    canBeReordered = false;
                }
                const canBeReorderedProcessed = apiRef.current.unstable_applyPipeProcessors('canBeReordered', canBeReordered, {
                    targetIndex: targetColVisibleIndex
                });
                if (canBeReorderedProcessed) apiRef.current.setColumnIndex(dragColField, targetColIndex + indexOffsetInHiddenColumns);
            }
            cursorPosition.current = coordinates;
        }
    }, [
        apiRef,
        logger,
        theme.direction
    ]);
    const handleDragEnd = $jSIPP.useCallback((params, event)=>{
        const dragColField = (0, $4202d6c605217d06$export$78d24cc7373bc611)(apiRef);
        if (props.disableColumnReorder || !dragColField) return;
        logger.debug('End dragging col');
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragColNode.current = null;
        // Check if the column was dropped outside the grid.
        if (event.dataTransfer.dropEffect === 'none' && !props.keepColumnPositionIfDraggedOutside) {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setColumnIndex(dragColField, originColumnIndex.current);
            originColumnIndex.current = null;
        } else {
            // Emit the columnOrderChange event only once when the reordering stops.
            const columnOrderChangeParams = {
                column: apiRef.current.getColumn(dragColField),
                targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(dragColField),
                oldIndex: originColumnIndex.current
            };
            apiRef.current.publishEvent('columnOrderChange', columnOrderChangeParams);
        }
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                columnReorder: (0, $erOpW.default)({}, state.columnReorder, {
                    dragCol: ''
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        props.disableColumnReorder,
        props.keepColumnPositionIfDraggedOutside,
        logger,
        apiRef
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', handleDragStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnter', handleDragEnter);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragOver', handleDragOver);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', handleDragEnd);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDragEnter', handleDragEnter);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDragOver', handleDragOver);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnOrderChange', props.onColumnOrderChange);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


function $21855492216a5f5f$export$7e10cfd0168dec8f() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}





function $13550ef08876bc62$export$2c4260a98d98f894(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $13550ef08876bc62$export$a2d3aec9ff63900b(elem, field) {
    return elem.querySelector(`[data-field="${field}"]`);
}
function $13550ef08876bc62$export$1e5569d10c3ebc8b(elem, field) {
    var _elem$querySelectorAl;
    return Array.from((_elem$querySelectorAl = elem.querySelectorAll(`[data-fields*="|-${field}-|"]`)) != null ? _elem$querySelectorAl : []);
}
function $13550ef08876bc62$export$53d8041b57f0055(col, api) {
    var _api$virtualScrollerR, _api$virtualScrollerR2;
    const root = (0, $26a7a0c939103688$export$2a63f1401414fc1a)(col, (0, $4d97f950d65e57e8$export$2100d54e36406477).root);
    if (!root) throw new Error('MUI: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!((_api$virtualScrollerR = api.virtualScrollerRef) != null && _api$virtualScrollerR.current)) return [];
    const renderedRowElements = (_api$virtualScrollerR2 = api.virtualScrollerRef) == null ? void 0 : _api$virtualScrollerR2.current.querySelectorAll(`:scope > div > div > .${(0, $4d97f950d65e57e8$export$2100d54e36406477).row}` // Use > to ignore rows from nested data grids (e.g. in detail panel)
    );
    renderedRowElements.forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $13550ef08876bc62$export$5c4f873e8f18904d(api, field) {
    const headers = api.columnHeadersContainerElementRef.current;
    return headers.querySelector(`:scope > div > div > [data-field="${field}"][role="columnheader"]`);
}
function $13550ef08876bc62$export$ee9bd404f74f7c9(api, field) {
    const container = api.virtualScrollerRef.current;
    const selectorFor = (role)=>`:scope > div > div > div > [data-field="${field}"][role="${role}"]`;
    // TODO(v7): Keep only the selector for the correct role
    return Array.from(container.querySelectorAll(`${selectorFor('cell')}, ${selectorFor('gridcell')}`));
}


const $7b09f643f6fa31a0$export$9707fe779d390182 = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 


// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $cdec10ca5a75a5a9$var$cachedSupportsTouchActionNone = false;
function $cdec10ca5a75a5a9$var$doesSupportTouchActionNone() {
    if ($cdec10ca5a75a5a9$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $cdec10ca5a75a5a9$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $cdec10ca5a75a5a9$var$cachedSupportsTouchActionNone = true;
    }
    return $cdec10ca5a75a5a9$var$cachedSupportsTouchActionNone;
}
function $cdec10ca5a75a5a9$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $cdec10ca5a75a5a9$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return newWidth;
}
function $cdec10ca5a75a5a9$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $cdec10ca5a75a5a9$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $cdec10ca5a75a5a9$var$getResizeDirection(element, direction) {
    const side = element.classList.contains((0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (direction === 'rtl') // Resizing logic should be mirrored in the RTL case
    return $cdec10ca5a75a5a9$var$flipResizeDirection(side);
    return side;
}
function $cdec10ca5a75a5a9$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $cdec10ca5a75a5a9$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $jSIPP.useRef();
    const selector = ()=>(0, $c421d0e4a96ab434$export$ad2aa1e9d465cafa)(apiRef);
    const value = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, selector);
    $jSIPP.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $21855492216a5f5f$export$7e10cfd0168dec8f)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $cdec10ca5a75a5a9$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (e.g. zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $cdec10ca5a75a5a9$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add((0, $4d97f950d65e57e8$export$2100d54e36406477).autosizing);
    columns.forEach((column)=>{
        const cells = (0, $13550ef08876bc62$export$ee9bd404f74f7c9)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            var _cell$firstElementChi, _cell$firstElementChi2;
            const style = window.getComputedStyle(cell, null);
            const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
            const contentWidth = (_cell$firstElementChi = (_cell$firstElementChi2 = cell.firstElementChild) == null ? void 0 : _cell$firstElementChi2.getBoundingClientRect().width) != null ? _cell$firstElementChi : 0;
            return paddingWidth + contentWidth;
        });
        const filteredWidths = options.includeOutliers ? widths : $cdec10ca5a75a5a9$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $13550ef08876bc62$export$5c4f873e8f18904d)(apiRef.current, column.field);
            if (header) {
                const title = header.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitle}`);
                const content = header.querySelector(`.${(0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
                const element = title != null ? title : content;
                const style = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = element.scrollWidth + 1;
                const width = paddingWidth + contentWidth;
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(maxContent, min, max);
    });
    root.classList.remove((0, $4d97f950d65e57e8$export$2100d54e36406477).autosizing);
    return widthByField;
}
const $cdec10ca5a75a5a9$export$ac6ed2ccd52f643f = (state)=>(0, $erOpW.default)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
const $cdec10ca5a75a5a9$export$6761a7afeb3daa64 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridColumnResize');
    const colDefRef = $jSIPP.useRef();
    const colElementRef = $jSIPP.useRef();
    const headerFilterElementRef = $jSIPP.useRef();
    const colGroupingElementRef = $jSIPP.useRef();
    const colCellElementsRef = $jSIPP.useRef();
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $jSIPP.useRef();
    const resizeDirection = $jSIPP.useRef();
    const stopResizeEventTimeout = (0, $700e89e09f25b054$export$d8e6abf214c9ec0f)();
    const touchId = $jSIPP.useRef();
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${colDefRef.current.field}`);
        const prevWidth = colElementRef.current.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        colDefRef.current.computedWidth = newWidth;
        colDefRef.current.width = newWidth;
        colDefRef.current.flex = 0;
        colElementRef.current.style.width = `${newWidth}px`;
        colElementRef.current.style.minWidth = `${newWidth}px`;
        colElementRef.current.style.maxWidth = `${newWidth}px`;
        const headerFilterElement = headerFilterElementRef.current;
        if (headerFilterElement) {
            headerFilterElement.style.width = `${newWidth}px`;
            headerFilterElement.style.minWidth = `${newWidth}px`;
            headerFilterElement.style.maxWidth = `${newWidth}px`;
        }
        [
            ...colCellElementsRef.current,
            ...colGroupingElementRef.current
        ].forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
            div.style.minWidth = finalWidth;
            div.style.maxWidth = finalWidth;
        });
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        if (colDefRef.current) {
            apiRef.current.setColumnWidth(colDefRef.current.field, colDefRef.current.width);
            logger.debug(`Updating col ${colDefRef.current.field} with new width: ${colDefRef.current.width}`);
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const handleResizeMouseUp = (0, $55503225f0104895$export$2e2bcd8739ae039)(finishResize);
    const handleResizeMouseMove = (0, $55503225f0104895$export$2e2bcd8739ae039)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $cdec10ca5a75a5a9$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, colElementRef.current.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(newWidth, colDefRef.current.minWidth, colDefRef.current.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: colElementRef.current,
            colDef: colDefRef.current,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $55503225f0104895$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $cdec10ca5a75a5a9$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $55503225f0104895$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $cdec10ca5a75a5a9$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $cdec10ca5a75a5a9$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, colElementRef.current.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $a4e890cf7e68aae0$export$7d15b64cf5a3a4c4)(newWidth, colDefRef.current.minWidth, colDefRef.current.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: colElementRef.current,
            colDef: colDefRef.current,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $55503225f0104895$export$2e2bcd8739ae039)((event)=>{
        var _apiRef$current$colum, _apiRef$current$colum2;
        const cellSeparator = (0, $26a7a0c939103688$export$2a63f1401414fc1a)(event.target, (0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$cdec10ca5a75a5a9$var$doesSupportTouchActionNone()) event.preventDefault();
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        colElementRef.current = (0, $26a7a0c939103688$export$2a63f1401414fc1a)(event.target, (0, $4d97f950d65e57e8$export$2100d54e36406477).columnHeader);
        const field = (0, $13550ef08876bc62$export$2c4260a98d98f894)(colElementRef.current);
        const colDef = apiRef.current.getColumn(field);
        colGroupingElementRef.current = (0, $13550ef08876bc62$export$1e5569d10c3ebc8b)((_apiRef$current$colum = apiRef.current.columnHeadersContainerElementRef) == null ? void 0 : _apiRef$current$colum.current, field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        colDefRef.current = colDef;
        colElementRef.current = (0, $13550ef08876bc62$export$a2d3aec9ff63900b)((_apiRef$current$colum2 = apiRef.current.columnHeadersElementRef) == null ? void 0 : _apiRef$current$colum2.current, colDef.field);
        colCellElementsRef.current = (0, $13550ef08876bc62$export$53d8041b57f0055)(colElementRef.current, apiRef.current);
        resizeDirection.current = $cdec10ca5a75a5a9$var$getResizeDirection(event.target, theme.direction);
        initialOffsetToSeparator.current = $cdec10ca5a75a5a9$var$computeOffsetToSeparator(touch.clientX, colElementRef.current.getBoundingClientRect(), resizeDirection.current);
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $jSIPP.useCallback(()=>{
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $cdec10ca5a75a5a9$var$preventClick, true);
        }, 100);
        if (colElementRef.current) colElementRef.current.style.pointerEvents = 'unset';
    }, [
        apiRef,
        colElementRef,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $jSIPP.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                columnResize: (0, $erOpW.default)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleResizeStop = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                columnResize: (0, $erOpW.default)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $55503225f0104895$export$2e2bcd8739ae039)(({ colDef: colDef }, event)=>{
        var _apiRef$current$colum3, _apiRef$current$heade, _apiRef$current$colum4;
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains((0, $4d97f950d65e57e8$export$2100d54e36406477)['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        colDefRef.current = colDef;
        colElementRef.current = (_apiRef$current$colum3 = apiRef.current.columnHeadersContainerElementRef) == null ? void 0 : _apiRef$current$colum3.current.querySelector(`[data-field="${colDef.field}"]`);
        const headerFilterRowElement = (_apiRef$current$heade = apiRef.current.headerFiltersElementRef) == null ? void 0 : _apiRef$current$heade.current;
        if (headerFilterRowElement) headerFilterElementRef.current = headerFilterRowElement.querySelector(`[data-field="${colDef.field}"]`);
        colGroupingElementRef.current = (0, $13550ef08876bc62$export$1e5569d10c3ebc8b)((_apiRef$current$colum4 = apiRef.current.columnHeadersContainerElementRef) == null ? void 0 : _apiRef$current$colum4.current, colDef.field);
        colCellElementsRef.current = (0, $13550ef08876bc62$export$53d8041b57f0055)(colElementRef.current, apiRef.current);
        const doc = (0, $5721b9ce22c1f3fc$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        resizeDirection.current = $cdec10ca5a75a5a9$var$getResizeDirection(event.currentTarget, theme.direction);
        initialOffsetToSeparator.current = $cdec10ca5a75a5a9$var$computeOffsetToSeparator(event.clientX, colElementRef.current.getBoundingClientRect(), resizeDirection.current);
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $cdec10ca5a75a5a9$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $55503225f0104895$export$2e2bcd8739ae039)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $erOpW.default)({}, props.autosizeOptions, {
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $cdec10ca5a75a5a9$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $jSIPP.useRef(false);
    const autosizeColumns = $jSIPP.useCallback(async (userOptions)=>{
        var _apiRef$current$rootE, _userOptions$columns;
        const root = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null ? void 0 : _apiRef$current$rootE.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $90c6bb88bfe45f18$export$858d15abb6cddc08)(apiRef.current.state);
        const options = (0, $erOpW.default)({}, (0, $7b09f643f6fa31a0$export$9707fe779d390182), userOptions, {
            columns: (_userOptions$columns = userOptions == null ? void 0 : userOptions.columns) != null ? _userOptions$columns : state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            apiRef.current.unstable_setColumnVirtualization(false);
            await columnVirtualizationDisabled();
            const widthByField = $cdec10ca5a75a5a9$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $erOpW.default)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field]
                }));
            if (options.expand) {
                var _apiRef$current$getRo, _apiRef$current$getRo2;
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>{
                    var _ref, _widthByField$column$;
                    return total + ((_ref = (_widthByField$column$ = widthByField[column.field]) != null ? _widthByField$column$ : column.computedWidth) != null ? _ref : column.width);
                }, 0);
                const availableWidth = (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
        } finally{
            apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled
    ]);
    /**
   * EFFECTS
   */ $jSIPP.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $bb236c258f259a9e$export$820558710db2d9c6)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $51ab574519757f03$export$265f4c39182036e)(apiRef, ()=>{
        var _apiRef$current$colum5;
        return (_apiRef$current$colum5 = apiRef.current.columnHeadersElementRef) == null ? void 0 : _apiRef$current$colum5.current;
    }, 'touchstart', handleTouchStart, {
        passive: $cdec10ca5a75a5a9$var$doesSupportTouchActionNone()
    });
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnResize', props.onColumnResize);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};



var $jSIPP = parcelRequire("jSIPP");

const $bf54bfb79ee145b1$export$15cdd24474e74350 = (apiRef)=>{
    /**
   * EVENTS
   */ const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.colDef.type === 'treeDataGroup' && event.key === ' ' && !event.shiftKey) {
            if (params.rowNode.type !== 'group') return;
            apiRef.current.setRowChildrenExpansion(params.id, !params.rowNode.childrenExpanded);
        }
    }, [
        apiRef
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
};



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $erOpW = parcelRequire("erOpW");

const $82ca70360e874a6a$export$eed79627d7deb3a5 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    type: 'treeDataGroup',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    disableReorder: true,
    align: 'left',
    width: 200,
    valueGetter: (params)=>params.rowNode.type === 'group' || params.rowNode.type === 'leaf' ? params.rowNode.groupingKey : undefined
});
const $82ca70360e874a6a$export$9cce4aaa860dd90a = '__tree_data_group__';
const $82ca70360e874a6a$export$1a0175c947f58fd3 = {
    field: $82ca70360e874a6a$export$9cce4aaa860dd90a,
    editable: false,
    groupable: false
};



const $f7361d686b5788e8$export$6bd6c3ee4fcd23bc = 'tree-data';
const $f7361d686b5788e8$export$d431177e37819461 = (params)=>{
    const { apiRef: apiRef, rowTree: rowTree, disableChildrenFiltering: disableChildrenFiltering, isRowMatchingFilters: isRowMatchingFilters } = params;
    const filteredRowsLookup = {};
    const filteredDescendantCountLookup = {};
    const filterCache = {};
    const filterResults = {
        passingFilterItems: null,
        passingQuickFilterValues: null
    };
    const filterTreeNode = (node, isParentMatchingFilters, areAncestorsExpanded)=>{
        const shouldSkipFilters = disableChildrenFiltering && node.depth > 0;
        let isMatchingFilters;
        if (shouldSkipFilters) isMatchingFilters = null;
        else if (!isRowMatchingFilters || node.type === 'footer') isMatchingFilters = true;
        else {
            const row = apiRef.current.getRow(node.id);
            isRowMatchingFilters(row, undefined, filterResults);
            isMatchingFilters = (0, $c80d7fdca78f3c04$export$8d82b4490466f182)([
                filterResults.passingFilterItems
            ], [
                filterResults.passingQuickFilterValues
            ], params.filterModel, params.apiRef, filterCache);
        }
        let filteredDescendantCount = 0;
        if (node.type === 'group') node.children.forEach((childId)=>{
            var _isMatchingFilters;
            const childNode = rowTree[childId];
            const childSubTreeSize = filterTreeNode(childNode, (_isMatchingFilters = isMatchingFilters) != null ? _isMatchingFilters : isParentMatchingFilters, areAncestorsExpanded && !!node.childrenExpanded);
            filteredDescendantCount += childSubTreeSize;
        });
        let shouldPassFilters;
        switch(isMatchingFilters){
            case true:
                shouldPassFilters = true;
                break;
            case false:
                shouldPassFilters = filteredDescendantCount > 0;
                break;
            default:
                shouldPassFilters = isParentMatchingFilters;
                break;
        }
        filteredRowsLookup[node.id] = shouldPassFilters;
        if (!shouldPassFilters) return 0;
        filteredDescendantCountLookup[node.id] = filteredDescendantCount;
        if (node.type === 'footer') return filteredDescendantCount;
        return filteredDescendantCount + 1;
    };
    const nodes = Object.values(rowTree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) filterTreeNode(node, true, true);
    }
    return {
        filteredRowsLookup: filteredRowsLookup,
        filteredDescendantCountLookup: filteredDescendantCountLookup
    };
};



var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");



const $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3 = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3);



const $8e32833f8e5c03cf$export$2d14edd3a7db3bbf = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf);



var $4uaIU = parcelRequire("4uaIU");
const $6a78f7fdf87ccd4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'treeDataGroupingCell'
        ],
        toggle: [
            'treeDataGroupingCellToggle'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $6a78f7fdf87ccd4c$export$27e53dafb413f7b(props) {
    var _filteredDescendantCo, _rootProps$slotProps;
    const { id: id, field: field, formattedValue: formattedValue, rowNode: rowNode, hideDescendantCount: hideDescendantCount, offsetMultiplier: offsetMultiplier = 2 } = props;
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $8e32833f8e5c03cf$export$2d14edd3a7db3bbf)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $6a78f7fdf87ccd4c$var$useUtilityClasses(ownerState);
    const filteredDescendantCountLookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$28e99d5260ff82e7));
    const filteredDescendantCount = (_filteredDescendantCo = filteredDescendantCountLookup[rowNode.id]) != null ? _filteredDescendantCo : 0;
    const Icon = rowNode.childrenExpanded ? rootProps.slots.treeDataCollapseIcon : rootProps.slots.treeDataExpandIcon;
    const handleClick = (event)=>{
        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation(); // TODO remove event.stopPropagation
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        className: classes.root,
        sx: {
            ml: rowNode.depth * offsetMultiplier
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                className: classes.toggle,
                children: filteredDescendantCount > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                    size: "small",
                    onClick: handleClick,
                    tabIndex: -1,
                    "aria-label": rowNode.childrenExpanded ? apiRef.current.getLocaleText('treeDataCollapse') : apiRef.current.getLocaleText('treeDataExpand')
                }, rootProps == null || (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, {
                        fontSize: "inherit"
                    })
                }))
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)("span", {
                children: [
                    formattedValue === undefined ? rowNode.groupingKey : formattedValue,
                    !hideDescendantCount && filteredDescendantCount > 0 ? ` (${filteredDescendantCount})` : ''
                ]
            })
        ]
    });
}






var $erOpW = parcelRequire("erOpW");

const $8f25b96ab0d4f5eb$export$d5e283255c81e0fd = (path)=>{
    const pathStr = path.map((groupingCriteria)=>`${groupingCriteria.field}/${groupingCriteria.key}`).join('-');
    return `auto-generated-row-${pathStr}`;
};
const $8f25b96ab0d4f5eb$export$abc1fabe591b697e = ({ id: id, tree: tree })=>{
    const path = [];
    let node = tree[id];
    while(node.id !== (0, $db5319c56f201804$export$433b924dc2506913)){
        path.push({
            field: node.type === 'leaf' ? null : node.groupingField,
            key: node.groupingKey
        });
        node = tree[node.parent];
    }
    path.reverse();
    return path;
};
const $8f25b96ab0d4f5eb$export$5ba8ca32800e0e56 = (node, defaultGroupingExpansionDepth, isGroupExpandedByDefault)=>{
    let childrenExpanded;
    if (node.id === (0, $db5319c56f201804$export$433b924dc2506913)) childrenExpanded = true;
    else if (isGroupExpandedByDefault) childrenExpanded = isGroupExpandedByDefault(node);
    else childrenExpanded = defaultGroupingExpansionDepth === -1 || defaultGroupingExpansionDepth > node.depth;
    node.childrenExpanded = childrenExpanded;
    return node;
};
const $8f25b96ab0d4f5eb$export$e179dd88ba706b74 = (node, tree, treeDepths, previousTree)=>{
    var _treeDepths$node$dept;
    // 1. Insert node in the tree.
    tree[node.id] = node;
    // 2. Increment the `treeDepths` object for the node's depth.
    treeDepths[node.depth] = ((_treeDepths$node$dept = treeDepths[node.depth]) != null ? _treeDepths$node$dept : 0) + 1;
    // 3. Register the new node in its parent.
    const parentNode = tree[node.parent];
    if (node.type === 'group' || node.type === 'leaf') {
        var _groupingField, _groupingKey, _parentNode$childrenF;
        // For groups and leaves,
        // Register the node from its parents `children` and `childrenFromPath` properties.
        const groupingFieldName = (_groupingField = node.groupingField) != null ? _groupingField : '__no_field__';
        const groupingKeyName = (_groupingKey = node.groupingKey) != null ? _groupingKey : '__no_key__';
        const groupingField = (_parentNode$childrenF = parentNode.childrenFromPath) == null ? void 0 : _parentNode$childrenF[groupingFieldName];
        if (previousTree !== null && previousTree[parentNode.id] === tree[parentNode.id]) parentNode.children = [
            ...parentNode.children,
            node.id
        ];
        else parentNode.children.push(node.id);
        if (groupingField == null) parentNode.childrenFromPath[groupingFieldName] = {
            [groupingKeyName.toString()]: node.id
        };
        else groupingField[groupingKeyName.toString()] = node.id;
    } else if (node.type === 'footer') // For footers,
    // Register the node from its parent `footerId` property.
    parentNode.footerId = node.id;
};
const $8f25b96ab0d4f5eb$export$a0e1f1bcb4742ea5 = ({ node: node, tree: tree, treeDepths: treeDepths })=>{
    // 1. Remove node from the tree.
    delete tree[node.id];
    // 2. Decrement the `treeDepths` object for the node's depth.
    const nodeDepth = node.depth;
    const currentNodeCount = treeDepths[nodeDepth];
    if (currentNodeCount === 1) delete treeDepths[nodeDepth];
    else treeDepths[nodeDepth] = currentNodeCount - 1;
    // 3. Unregister the new node in its parent.
    const parentNode = tree[node.parent];
    // For footers,
    // Unregister the node from its parent `footerId` property.
    if (node.type === 'footer') tree[parentNode.id] = (0, $erOpW.default)({}, parentNode, {
        footerId: null
    });
    else {
        var _groupingField2, _groupingKey2;
        const groupingField = (_groupingField2 = node.groupingField) != null ? _groupingField2 : '__no_field__';
        const groupingKey = (_groupingKey2 = node.groupingKey) != null ? _groupingKey2 : '__no_key__';
        // TODO rows v6: Can we avoid this linear complexity ?
        const children = parentNode.children.filter((childId)=>childId !== node.id);
        const childrenFromPath = parentNode.childrenFromPath;
        delete childrenFromPath[groupingField][groupingKey.toString()];
        tree[parentNode.id] = (0, $erOpW.default)({}, parentNode, {
            children: children,
            childrenFromPath: childrenFromPath
        });
    }
};
const $8f25b96ab0d4f5eb$export$8401d879c7fe4ac0 = ({ node: node, updatedNode: updatedNode, previousTree: previousTree, tree: tree, treeDepths: treeDepths })=>{
    // 1. Set the new parent for all children from the old group
    node.children.forEach((childId)=>{
        tree[childId] = (0, $erOpW.default)({}, tree[childId], {
            parent: updatedNode.id
        });
    });
    // 2. Remove the old group from the tree
    $8f25b96ab0d4f5eb$export$a0e1f1bcb4742ea5({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    // 3. Add the new group in the tree
    const groupNode = (0, $erOpW.default)({}, node, updatedNode);
    $8f25b96ab0d4f5eb$export$e179dd88ba706b74(groupNode, tree, treeDepths, previousTree);
};
const $8f25b96ab0d4f5eb$export$3978044dae9c217d = ()=>({
        value: {},
        addAction (groupId, action) {
            if (!this.value[groupId]) this.value[groupId] = {};
            this.value[groupId][action] = true;
        }
    });
const $8f25b96ab0d4f5eb$export$9cf22cc325f95ed4 = ({ tree: tree, filteredRowsLookup: filteredRowsLookup })=>{
    if (!filteredRowsLookup) return {};
    const visibleRowsLookup = {};
    const handleTreeNode = (node, areAncestorsExpanded)=>{
        const isPassingFiltering = filteredRowsLookup[node.id];
        if (node.type === 'group') node.children.forEach((childId)=>{
            const childNode = tree[childId];
            handleTreeNode(childNode, areAncestorsExpanded && !!node.childrenExpanded);
        });
        visibleRowsLookup[node.id] = isPassingFiltering && areAncestorsExpanded;
        // TODO rows v6: Should we keep storing the visibility status of footer independently or rely on the group visibility in the selector ?
        if (node.type === 'group' && node.footerId != null) visibleRowsLookup[node.footerId] = isPassingFiltering && areAncestorsExpanded && !!node.childrenExpanded;
    };
    const nodes = Object.values(tree);
    for(let i = 0; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.depth === 0) handleTreeNode(node, true);
    }
    return visibleRowsLookup;
};


const $673e61ef36cf6dfc$export$8234f639803f3161 = ({ id: id, path: path, updatedGroupsManager: updatedGroupsManager, previousTree: previousTree, tree: tree, treeDepths: treeDepths, onDuplicatePath: onDuplicatePath, isGroupExpandedByDefault: isGroupExpandedByDefault, defaultGroupingExpansionDepth: defaultGroupingExpansionDepth })=>{
    let parentNodeId = (0, $db5319c56f201804$export$433b924dc2506913);
    for(let depth = 0; depth < path.length; depth += 1){
        var _childrenFromPath;
        const { key: key, field: field } = path[depth];
        const fieldWithDefaultValue = field != null ? field : '__no_field__';
        const keyWithDefaultValue = key != null ? key : '__no_key__';
        const existingNodeIdWithPartialPath = (_childrenFromPath = tree[parentNodeId].childrenFromPath) == null || (_childrenFromPath = _childrenFromPath[fieldWithDefaultValue]) == null ? void 0 : _childrenFromPath[keyWithDefaultValue.toString()];
        // When we reach the last step of the path,
        // We need to create a node for the row passed to `insertNodeInTree`
        if (depth === path.length - 1) {
            // If no node matches the full path,
            // We create a leaf node for the data row.
            if (existingNodeIdWithPartialPath == null) {
                const leafNode = {
                    type: 'leaf',
                    id: id,
                    depth: depth,
                    parent: parentNodeId,
                    groupingKey: key
                };
                updatedGroupsManager == null || updatedGroupsManager.addAction(parentNodeId, 'insertChildren');
                (0, $8f25b96ab0d4f5eb$export$e179dd88ba706b74)(leafNode, tree, treeDepths, previousTree);
            } else {
                const existingNodeWithPartialPath = tree[existingNodeIdWithPartialPath];
                // If we already have an auto-generated group matching the partial path,
                // We replace it with the node from of data row passed to `insertNodeInTree`
                if (existingNodeWithPartialPath.type === 'group' && existingNodeWithPartialPath.isAutoGenerated) {
                    updatedGroupsManager == null || updatedGroupsManager.addAction(parentNodeId, 'removeChildren');
                    updatedGroupsManager == null || updatedGroupsManager.addAction(parentNodeId, 'insertChildren');
                    (0, $8f25b96ab0d4f5eb$export$8401d879c7fe4ac0)({
                        tree: tree,
                        previousTree: previousTree,
                        treeDepths: treeDepths,
                        node: existingNodeWithPartialPath,
                        updatedNode: {
                            id: id,
                            isAutoGenerated: false
                        }
                    });
                } else // If we have another row matching the partial path, then there is a duplicate in the dataset.
                // We warn the user and skip the current row.
                onDuplicatePath == null || onDuplicatePath(existingNodeIdWithPartialPath, id, path);
            }
        } else if (existingNodeIdWithPartialPath == null) {
            const nodeId = (0, $8f25b96ab0d4f5eb$export$d5e283255c81e0fd)(path.slice(0, depth + 1));
            const autoGeneratedGroupNode = {
                type: 'group',
                id: nodeId,
                parent: parentNodeId,
                depth: depth,
                isAutoGenerated: true,
                groupingKey: key,
                groupingField: field,
                children: [],
                childrenFromPath: {},
                childrenExpanded: false
            };
            updatedGroupsManager == null || updatedGroupsManager.addAction(parentNodeId, 'insertChildren');
            (0, $8f25b96ab0d4f5eb$export$e179dd88ba706b74)((0, $8f25b96ab0d4f5eb$export$5ba8ca32800e0e56)(autoGeneratedGroupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault), tree, treeDepths, previousTree);
            parentNodeId = nodeId;
        } else {
            const currentGroupNode = tree[existingNodeIdWithPartialPath];
            // If the node matching the partial path is not a group, we turn it into a group
            if (currentGroupNode.type !== 'group') {
                const groupNode = {
                    type: 'group',
                    id: currentGroupNode.id,
                    parent: currentGroupNode.parent,
                    depth: currentGroupNode.depth,
                    isAutoGenerated: false,
                    groupingKey: key,
                    groupingField: field,
                    children: [],
                    childrenFromPath: {},
                    childrenExpanded: false
                };
                tree[existingNodeIdWithPartialPath] = (0, $8f25b96ab0d4f5eb$export$5ba8ca32800e0e56)(groupNode, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
            }
            parentNodeId = currentGroupNode.id;
        }
    }
};


const $eac23ba9cc64bbab$export$230dd60fadcbc35b = (params)=>{
    const dataRowIds = [];
    const tree = {
        [(0, $db5319c56f201804$export$433b924dc2506913)]: (0, $db5319c56f201804$export$96a607054e9bfd0c)()
    };
    const treeDepths = {};
    for(let i = 0; i < params.nodes.length; i += 1){
        const node = params.nodes[i];
        dataRowIds.push(node.id);
        (0, $673e61ef36cf6dfc$export$8234f639803f3161)({
            tree: tree,
            previousTree: params.previousTree,
            id: node.id,
            path: node.path,
            onDuplicatePath: params.onDuplicatePath,
            treeDepths: treeDepths,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
        });
    }
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds
    };
};



// Single-linked list node
class $9d1c69da8425f8c2$var$Node {
    insertAfter(list) {
        if (!list.first || !list.last) return;
        const next = this.next;
        this.next = list.first;
        list.last.next = next;
    }
    constructor(data, next){
        this.next = void 0;
        this.data = void 0;
        this.next = next;
        this.data = data;
    }
}
// Single-linked list container
class $9d1c69da8425f8c2$var$List {
    data() {
        const array = [];
        this.forEach((node)=>{
            array.push(node.data);
        });
        return array;
    }
    forEach(fn) {
        let current = this.first;
        while(current !== null){
            fn(current);
            current = current.next;
        }
    }
    static from(array) {
        if (array.length === 0) return new $9d1c69da8425f8c2$var$List(null, null);
        let index = 0;
        const first = new $9d1c69da8425f8c2$var$Node(array[index], null);
        let current = first;
        while(index + 1 < array.length){
            index += 1;
            const node = new $9d1c69da8425f8c2$var$Node(array[index], null);
            current.next = node;
            current = node;
        }
        return new $9d1c69da8425f8c2$var$List(first, current);
    }
    constructor(first, last){
        this.first = void 0;
        this.last = void 0;
        this.first = first;
        this.last = last;
    }
}
const $9d1c69da8425f8c2$export$3da49b8141c52d70 = (params)=>{
    const { rowTree: rowTree, disableChildrenSorting: disableChildrenSorting, sortRowList: sortRowList, shouldRenderGroupBelowLeaves: shouldRenderGroupBelowLeaves } = params;
    const sortedGroupedByParentRows = new Map();
    const sortGroup = (node)=>{
        const shouldSortGroup = !!sortRowList && (!disableChildrenSorting || node.depth === -1);
        let sortedRowIds;
        if (shouldSortGroup) {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === 'group') sortGroup(childNode);
            }
            sortedRowIds = sortRowList(node.children.map((childId)=>rowTree[childId]));
        } else if (shouldRenderGroupBelowLeaves) {
            const childrenLeaves = [];
            const childrenGroups = [];
            for(let i = 0; i < node.children.length; i += 1){
                const childId = node.children[i];
                const childNode = rowTree[childId];
                if (childNode.type === 'group') {
                    sortGroup(childNode);
                    childrenGroups.push(childId);
                } else if (childNode.type === 'leaf') childrenLeaves.push(childId);
            }
            sortedRowIds = [
                ...childrenLeaves,
                ...childrenGroups
            ];
        } else {
            for(let i = 0; i < node.children.length; i += 1){
                const childNode = rowTree[node.children[i]];
                if (childNode.type === 'group') sortGroup(childNode);
            }
            sortedRowIds = [
                ...node.children
            ];
        }
        if (node.footerId != null) sortedRowIds.push(node.footerId);
        sortedGroupedByParentRows.set(node.id, sortedRowIds);
    };
    sortGroup(rowTree[0, $db5319c56f201804$export$433b924dc2506913]);
    const rootList = $9d1c69da8425f8c2$var$List.from(sortedGroupedByParentRows.get((0, $db5319c56f201804$export$433b924dc2506913)));
    rootList.forEach((node)=>{
        const children = sortedGroupedByParentRows.get(node.data);
        if (children != null && children.length) node.insertAfter($9d1c69da8425f8c2$var$List.from(children));
    });
    return rootList.data();
};



var $erOpW = parcelRequire("erOpW");





const $5f8a607badfb1d1e$var$removeNodeAndCleanParent = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    (0, $8f25b96ab0d4f5eb$export$a0e1f1bcb4742ea5)({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    if (node.type === 'group' && node.footerId != null) (0, $8f25b96ab0d4f5eb$export$a0e1f1bcb4742ea5)({
        node: tree[node.footerId],
        tree: tree,
        treeDepths: treeDepths
    });
    const parentNode = tree[node.parent];
    updatedGroupsManager == null || updatedGroupsManager.addAction(parentNode.id, 'removeChildren');
    const shouldDeleteGroup = parentNode.id !== (0, $db5319c56f201804$export$433b924dc2506913) && parentNode.children.length === 0;
    if (shouldDeleteGroup) {
        if (parentNode.isAutoGenerated) $5f8a607badfb1d1e$var$removeNodeAndCleanParent({
            node: parentNode,
            tree: tree,
            treeDepths: treeDepths
        });
        else tree[parentNode.id] = {
            type: 'leaf',
            id: parentNode.id,
            depth: parentNode.depth,
            parent: parentNode.parent,
            groupingKey: parentNode.groupingKey
        };
    }
};
const $5f8a607badfb1d1e$var$replaceDataGroupWithAutoGeneratedGroup = ({ node: node, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    updatedGroupsManager == null || updatedGroupsManager.addAction(node.parent, 'removeChildren');
    updatedGroupsManager == null || updatedGroupsManager.addAction(node.parent, 'insertChildren');
    (0, $8f25b96ab0d4f5eb$export$8401d879c7fe4ac0)({
        previousTree: null,
        tree: tree,
        treeDepths: treeDepths,
        node: node,
        updatedNode: {
            id: (0, $8f25b96ab0d4f5eb$export$d5e283255c81e0fd)((0, $8f25b96ab0d4f5eb$export$abc1fabe591b697e)({
                id: node.id,
                tree: tree
            })),
            isAutoGenerated: true
        }
    });
};
const $5f8a607badfb1d1e$export$cf388a54c0cc8532 = ({ id: id, tree: tree, treeDepths: treeDepths, updatedGroupsManager: updatedGroupsManager })=>{
    const node = tree[id];
    if (node.type === 'group' && node.children.length > 0) $5f8a607badfb1d1e$var$replaceDataGroupWithAutoGeneratedGroup({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
    else $5f8a607badfb1d1e$var$removeNodeAndCleanParent({
        node: node,
        tree: tree,
        treeDepths: treeDepths,
        updatedGroupsManager: updatedGroupsManager
    });
};



const $838d85113d159db2$export$95db6bdce2927ab = (params)=>{
    const tree = (0, $erOpW.default)({}, params.previousTree);
    const treeDepths = (0, $erOpW.default)({}, params.previousTreeDepth);
    const updatedGroupsManager = (0, $8f25b96ab0d4f5eb$export$3978044dae9c217d)();
    for(let i = 0; i < params.nodes.inserted.length; i += 1){
        const { id: id, path: path } = params.nodes.inserted[i];
        (0, $673e61ef36cf6dfc$export$8234f639803f3161)({
            previousTree: params.previousTree,
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: id,
            path: path,
            onDuplicatePath: params.onDuplicatePath,
            isGroupExpandedByDefault: params.isGroupExpandedByDefault,
            defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
        });
    }
    for(let i = 0; i < params.nodes.removed.length; i += 1){
        const nodeId = params.nodes.removed[i];
        (0, $5f8a607badfb1d1e$export$cf388a54c0cc8532)({
            tree: tree,
            treeDepths: treeDepths,
            updatedGroupsManager: updatedGroupsManager,
            id: nodeId
        });
    }
    for(let i = 0; i < params.nodes.modified.length; i += 1){
        const { id: id, path: path } = params.nodes.modified[i];
        const pathInPreviousTree = (0, $8f25b96ab0d4f5eb$export$abc1fabe591b697e)({
            tree: tree,
            id: id
        });
        const isInSameGroup = (0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(pathInPreviousTree, path);
        if (!isInSameGroup) {
            (0, $5f8a607badfb1d1e$export$cf388a54c0cc8532)({
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id
            });
            (0, $673e61ef36cf6dfc$export$8234f639803f3161)({
                previousTree: params.previousTree,
                tree: tree,
                treeDepths: treeDepths,
                updatedGroupsManager: updatedGroupsManager,
                id: id,
                path: path,
                onDuplicatePath: params.onDuplicatePath,
                isGroupExpandedByDefault: params.isGroupExpandedByDefault,
                defaultGroupingExpansionDepth: params.defaultGroupingExpansionDepth
            });
        } else updatedGroupsManager == null || updatedGroupsManager.addAction(tree[id].parent, 'modifyChildren');
    }
    // TODO rows v6: Avoid walking the whole tree, we should be able to generate the new list only using slices.
    const dataRowIds = (0, $db5319c56f201804$export$9380f4bcafb87e49)(tree, (0, $db5319c56f201804$export$433b924dc2506913), true);
    return {
        tree: tree,
        treeDepths: treeDepths,
        groupingName: params.groupingName,
        dataRowIds: dataRowIds,
        updatedGroupsManager: updatedGroupsManager
    };
};




var $4uaIU = parcelRequire("4uaIU");
const $3292e0876a083190$var$_excluded = [
    "hideDescendantCount"
];
const $3292e0876a083190$export$7e966b04a1d3262a = (privateApiRef, props)=>{
    const setStrategyAvailability = $jSIPP.useCallback(()=>{
        privateApiRef.current.setStrategyAvailability('rowTree', (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc), props.treeData ? ()=>true : ()=>false);
    }, [
        privateApiRef,
        props.treeData
    ]);
    const getGroupingColDef = $jSIPP.useCallback(()=>{
        var _colDefOverride;
        const groupingColDefProp = props.groupingColDef;
        let colDefOverride;
        if (typeof groupingColDefProp === 'function') {
            const params = {
                groupingName: (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc),
                fields: []
            };
            colDefOverride = groupingColDefProp(params);
        } else colDefOverride = groupingColDefProp;
        const _ref = (_colDefOverride = colDefOverride) != null ? _colDefOverride : {}, { hideDescendantCount: hideDescendantCount } = _ref, colDefOverrideProperties = (0, $cMu4A.default)(_ref, $3292e0876a083190$var$_excluded);
        const commonProperties = (0, $erOpW.default)({}, (0, $82ca70360e874a6a$export$eed79627d7deb3a5), {
            renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $6a78f7fdf87ccd4c$export$27e53dafb413f7b), (0, $erOpW.default)({}, params, {
                    hideDescendantCount: hideDescendantCount
                })),
            headerName: privateApiRef.current.getLocaleText('treeDataGroupingHeaderName')
        });
        return (0, $erOpW.default)({}, commonProperties, colDefOverrideProperties, (0, $82ca70360e874a6a$export$1a0175c947f58fd3));
    }, [
        privateApiRef,
        props.groupingColDef
    ]);
    const updateGroupingColumn = $jSIPP.useCallback((columnsState)=>{
        const groupingColDefField = (0, $82ca70360e874a6a$export$1a0175c947f58fd3).field;
        const shouldHaveGroupingColumn = props.treeData;
        const prevGroupingColumn = columnsState.lookup[groupingColDefField];
        if (shouldHaveGroupingColumn) {
            const newGroupingColumn = getGroupingColDef();
            if (prevGroupingColumn) {
                newGroupingColumn.width = prevGroupingColumn.width;
                newGroupingColumn.flex = prevGroupingColumn.flex;
            }
            columnsState.lookup[groupingColDefField] = newGroupingColumn;
            if (prevGroupingColumn == null) {
                const index = columnsState.orderedFields[0] === (0, $b713438374cc7354$export$322dfed7a1df1b02) ? 1 : 0;
                columnsState.orderedFields = [
                    ...columnsState.orderedFields.slice(0, index),
                    groupingColDefField,
                    ...columnsState.orderedFields.slice(index)
                ];
            }
        } else if (!shouldHaveGroupingColumn && prevGroupingColumn) {
            delete columnsState.lookup[groupingColDefField];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== groupingColDefField);
        }
        return columnsState;
    }, [
        props.treeData,
        getGroupingColDef
    ]);
    const createRowTreeForTreeData = $jSIPP.useCallback((params)=>{
        if (!props.getTreeDataPath) throw new Error('MUI: No getTreeDataPath given.');
        const getRowTreeBuilderNode = (rowId)=>({
                id: rowId,
                path: props.getTreeDataPath(params.dataRowIdToModelLookup[rowId]).map((key)=>({
                        key: key,
                        field: null
                    }))
            });
        const onDuplicatePath = (firstId, secondId, path)=>{
            throw new Error([
                'MUI: The path returned by `getTreeDataPath` should be unique.',
                `The rows with id #${firstId} and #${secondId} have the same.`,
                `Path: ${JSON.stringify(path.map((step)=>step.key))}.`
            ].join('\n'));
        };
        if (params.updates.type === 'full') return (0, $eac23ba9cc64bbab$export$230dd60fadcbc35b)({
            previousTree: params.previousTree,
            nodes: params.updates.rows.map(getRowTreeBuilderNode),
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc),
            onDuplicatePath: onDuplicatePath
        });
        return (0, $838d85113d159db2$export$95db6bdce2927ab)({
            nodes: {
                inserted: params.updates.actions.insert.map(getRowTreeBuilderNode),
                modified: params.updates.actions.modify.map(getRowTreeBuilderNode),
                removed: params.updates.actions.remove
            },
            previousTree: params.previousTree,
            previousTreeDepth: params.previousTreeDepths,
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc)
        });
    }, [
        props.getTreeDataPath,
        props.defaultGroupingExpansionDepth,
        props.isGroupExpandedByDefault
    ]);
    const filterRows = $jSIPP.useCallback((params)=>{
        const rowTree = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(privateApiRef);
        return (0, $f7361d686b5788e8$export$d431177e37819461)({
            rowTree: rowTree,
            isRowMatchingFilters: params.isRowMatchingFilters,
            disableChildrenFiltering: props.disableChildrenFiltering,
            filterModel: params.filterModel,
            apiRef: privateApiRef
        });
    }, [
        privateApiRef,
        props.disableChildrenFiltering
    ]);
    const sortRows = $jSIPP.useCallback((params)=>{
        const rowTree = (0, $d7530f53594a6a47$export$de9a43d646a9821d)(privateApiRef);
        return (0, $9d1c69da8425f8c2$export$3da49b8141c52d70)({
            rowTree: rowTree,
            sortRowList: params.sortRowList,
            disableChildrenSorting: props.disableChildrenSorting,
            shouldRenderGroupBelowLeaves: false
        });
    }, [
        privateApiRef,
        props.disableChildrenSorting
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', updateGroupingColumn);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(privateApiRef, (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc), 'rowTreeCreation', createRowTreeForTreeData);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(privateApiRef, (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc), 'filtering', filterRows);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(privateApiRef, (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc), 'sorting', sortRows);
    (0, $1a0ff26229d68413$export$102a3f5a042c47c4)(privateApiRef, (0, $f7361d686b5788e8$export$6bd6c3ee4fcd23bc), 'visibleRowsLookupCreation', (0, $8f25b96ab0d4f5eb$export$9cf22cc325f95ed4));
    /**
   * 1ST RENDER
   */ (0, $35a9d8cff430e714$export$c5623aa1c38918b6)(()=>{
        setStrategyAvailability();
    });
    /**
   * EFFECTS
   */ const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (!isFirstRender.current) setStrategyAvailability();
        else isFirstRender.current = false;
    }, [
        setStrategyAvailability
    ]);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $47048811c4f4effd$export$6e56be315e15ea9e = /*#__PURE__*/ function(GridPinnedPosition) {
    GridPinnedPosition["left"] = "left";
    GridPinnedPosition["right"] = "right";
    return GridPinnedPosition;
}($47048811c4f4effd$export$6e56be315e15ea9e || {});


const $a75735833c020888$export$1eea0bd4db853467 = (state)=>state.pinnedColumns;



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $28RyA = parcelRequire("28RyA");

var $i3Yji = parcelRequire("i3Yji");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $i3Yji = parcelRequire("i3Yji");

var $86B3v = parcelRequire("86B3v");








var $4uaIU = parcelRequire("4uaIU");
const $34426c55a9e6c8ed$var$GridOverlayWrapperRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType',
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType: overlayType })=>({
        position: 'sticky',
        // To stay in place while scrolling
        top: 0,
        left: 0,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    }));
const $34426c55a9e6c8ed$var$GridOverlayWrapperInner = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType',
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const $34426c55a9e6c8ed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $34426c55a9e6c8ed$var$GridOverlayWrapper(props) {
    var _viewportInnerSize$he, _viewportInnerSize$wi;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const [viewportInnerSize, setViewportInnerSize] = $jSIPP.useState(()=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        return (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize) != null ? _apiRef$current$getRo : null;
    });
    const handleViewportSizeChange = $jSIPP.useCallback(()=>{
        var _apiRef$current$getRo3, _apiRef$current$getRo4;
        setViewportInnerSize((_apiRef$current$getRo3 = (_apiRef$current$getRo4 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo4.viewportInnerSize) != null ? _apiRef$current$getRo3 : null);
    }, [
        apiRef
    ]);
    (0, $73bd5ff9c4beec0a$export$2e2bcd8739ae039)(()=>{
        return apiRef.current.subscribeEvent('viewportInnerSizeChange', handleViewportSizeChange);
    }, [
        apiRef,
        handleViewportSizeChange
    ]);
    let height = (_viewportInnerSize$he = viewportInnerSize == null ? void 0 : viewportInnerSize.height) != null ? _viewportInnerSize$he : 0;
    if (rootProps.autoHeight && height === 0) height = (0, $db5319c56f201804$export$5475857f45a72a6e)(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
    const classes = $34426c55a9e6c8ed$var$useUtilityClasses((0, $erOpW.default)({}, props, {
        classes: rootProps.classes
    }));
    if (!viewportInnerSize) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($34426c55a9e6c8ed$var$GridOverlayWrapperRoot, {
        className: (0, $86B3v.default)(classes.root),
        overlayType: props.overlayType,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($34426c55a9e6c8ed$var$GridOverlayWrapperInner, (0, $erOpW.default)({
            className: (0, $86B3v.default)(classes.inner),
            style: {
                height: height,
                width: (_viewportInnerSize$wi = viewportInnerSize == null ? void 0 : viewportInnerSize.width) != null ? _viewportInnerSize$wi : 0
            }
        }, props))
    });
}
function $34426c55a9e6c8ed$export$867f5fc44327bee5() {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const totalRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$1641ef9d08e265ca));
    const visibleRowCount = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$96919017bbfaec0d));
    const loading = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$3c966d405f950b08));
    const showNoRowsOverlay = !loading && totalRowCount === 0;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlay = null;
    let overlayType = '';
    if (showNoRowsOverlay) {
        var _rootProps$slotProps;
        overlay = /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.noRowsOverlay, (0, $erOpW.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.noRowsOverlay));
        overlayType = 'noRowsOverlay';
    }
    if (showNoResultsOverlay) {
        var _rootProps$slotProps2;
        overlay = /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.noResultsOverlay, (0, $erOpW.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.noResultsOverlay));
        overlayType = 'noResultsOverlay';
    }
    if (loading) {
        var _rootProps$slotProps3;
        overlay = /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.loadingOverlay, (0, $erOpW.default)({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.loadingOverlay));
        overlayType = 'loadingOverlay';
    }
    if (overlay === null) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($34426c55a9e6c8ed$var$GridOverlayWrapper, {
        overlayType: overlayType,
        children: overlay
    });
}



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $0fad0ae2e639d202$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScroller'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $0fad0ae2e639d202$var$VirtualScrollerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>styles.virtualScroller
})({
    overflow: 'auto',
    height: '100%',
    // See https://github.com/mui/mui-x/issues/4360
    position: 'relative',
    '@media print': {
        overflow: 'hidden'
    },
    zIndex: 0 // See https://github.com/mui/mui-x/issues/10547
});
const $0fad0ae2e639d202$export$febd8ae712031b27 = /*#__PURE__*/ $jSIPP.forwardRef(function GridVirtualScroller(props, ref) {
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $0fad0ae2e639d202$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($0fad0ae2e639d202$var$VirtualScrollerRoot, (0, $erOpW.default)({
        ref: ref
    }, props, {
        className: (0, $86B3v.default)(classes.root, props.className),
        ownerState: rootProps
    }));
});


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $54f6e6ad05cec6fd$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $54f6e6ad05cec6fd$var$VirtualScrollerContentRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>styles.virtualScrollerContent
})({});
const $54f6e6ad05cec6fd$export$97d48eb8ba00afb8 = /*#__PURE__*/ $jSIPP.forwardRef(function GridVirtualScrollerContent(props, ref) {
    var _props$style;
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const overflowedContent = !rootProps.autoHeight && ((_props$style = props.style) == null ? void 0 : _props$style.minHeight) === 'auto';
    const classes = $54f6e6ad05cec6fd$var$useUtilityClasses(rootProps, overflowedContent);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($54f6e6ad05cec6fd$var$VirtualScrollerContentRoot, (0, $erOpW.default)({
        ref: ref
    }, props, {
        ownerState: rootProps,
        className: (0, $86B3v.default)(classes.root, props.className)
    }));
});


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $035e2bb50f4c6c76$var$_excluded = [
    "className"
];
const $035e2bb50f4c6c76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $035e2bb50f4c6c76$var$VirtualScrollerRenderZoneRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone',
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $035e2bb50f4c6c76$export$95930d31e6a9269f = /*#__PURE__*/ $jSIPP.forwardRef(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $cMu4A.default)(props, $035e2bb50f4c6c76$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $035e2bb50f4c6c76$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($035e2bb50f4c6c76$var$VirtualScrollerRenderZoneRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});



const $8f6cf70f27a49076$export$e1fd9274eb96ee18 = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18);





const $546d2f4a2dbda87a$export$2e51858b6eeff6ad = (state)=>state.detailPanel.expandedRowIds;
const $546d2f4a2dbda87a$export$16fba932632c70f0 = (state)=>state.detailPanel.contentCache;
const $546d2f4a2dbda87a$export$3a5feeef4c4a2bdc = (state)=>state.detailPanel.heightCache;
const $546d2f4a2dbda87a$export$f8466bb36c8b9813 = (0, $cf9e768be0a96dbe$export$2a3ca4704a61d1f4)($546d2f4a2dbda87a$export$3a5feeef4c4a2bdc, (heightCache)=>Object.entries(heightCache).reduce((acc, [id, { height: height }])=>{
        acc[id] = height || 0;
        return acc;
    }, {}));



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");



var $4uaIU = parcelRequire("4uaIU");
const $4fd93f9dffdf537f$var$_excluded = [
    "rowId",
    "height",
    "style"
];
const $4fd93f9dffdf537f$var$DetailPanel = (0, $28RyA.default)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'DetailPanel',
    overridesResolver: (props, styles)=>styles.detailPanel
})(({ theme: theme })=>({
        zIndex: 2,
        width: '100%',
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.background.default,
        overflow: 'auto'
    }));
function $4fd93f9dffdf537f$export$904faaa9b81e46ab(props) {
    const { rowId: rowId, height: height, style: styleProp = {} } = props, other = (0, $cMu4A.default)(props, $4fd93f9dffdf537f$var$_excluded);
    const apiRef = (0, $8f6cf70f27a49076$export$e1fd9274eb96ee18)();
    const ref = $jSIPP.useRef();
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const ownerState = rootProps;
    $jSIPP.useLayoutEffect(()=>{
        if (height === 'auto' && typeof ResizeObserver === 'undefined') // Fallback for IE
        apiRef.current.storeDetailPanelHeight(rowId, ref.current.clientHeight);
    }, [
        apiRef,
        height,
        rowId
    ]);
    $jSIPP.useLayoutEffect(()=>{
        const hasFixedHeight = height !== 'auto';
        if (hasFixedHeight || typeof ResizeObserver === 'undefined') return undefined;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const observedHeight = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.storeDetailPanelHeight(rowId, observedHeight);
        });
        resizeObserver.observe(ref.current);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        height,
        rowId
    ]);
    const style = (0, $erOpW.default)({}, styleProp, {
        height: height
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)($4fd93f9dffdf537f$var$DetailPanel, (0, $erOpW.default)({
        ref: ref,
        ownerState: ownerState,
        style: style
    }, other));
}




var $4uaIU = parcelRequire("4uaIU");
const $f133eb3b0e20e388$var$_excluded = [
    "className",
    "disableVirtualization"
];
const $f133eb3b0e20e388$export$d65e188677517fa1 = (pinnedColumns, columns, invert)=>{
    var _pinnedColumns$left, _pinnedColumns$right;
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return [
        [],
        []
    ];
    if (((_pinnedColumns$left = pinnedColumns.left) == null ? void 0 : _pinnedColumns$left.length) === 0 && ((_pinnedColumns$right = pinnedColumns.right) == null ? void 0 : _pinnedColumns$right.length) === 0) return [
        [],
        []
    ];
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return [
        rightPinnedColumns,
        leftPinnedColumns
    ];
    return [
        leftPinnedColumns,
        rightPinnedColumns
    ];
};
const $f133eb3b0e20e388$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        leftPinnedColumns: [
            'pinnedColumns',
            'pinnedColumns--left'
        ],
        rightPinnedColumns: [
            'pinnedColumns',
            'pinnedColumns--right',
            'withBorderColor'
        ],
        topPinnedRows: [
            'pinnedRows',
            'pinnedRows--top'
        ],
        bottomPinnedRows: [
            'pinnedRows',
            'pinnedRows--bottom'
        ],
        pinnedRowsRenderZone: [
            'pinnedRowsRenderZone'
        ],
        detailPanels: [
            'detailPanels'
        ],
        detailPanel: [
            'detailPanel'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $f133eb3b0e20e388$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return alphaValue / 100;
};
const $f133eb3b0e20e388$var$getBoxShadowColor = (theme)=>{
    return theme.vars ? `rgba(0 0 0 /  0.21)` : (0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.21);
};
const $f133eb3b0e20e388$var$VirtualScrollerDetailPanels = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'DetailPanels',
    overridesResolver: (props, styles)=>styles.detailPanels
})({
    position: 'relative'
});
const $f133eb3b0e20e388$var$darkModeBackgroundImage = `linear-gradient(${(0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)('#fff', $f133eb3b0e20e388$var$getOverlayAlpha(2))}, ${(0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)('#fff', $f133eb3b0e20e388$var$getOverlayAlpha(2))})`;
const $f133eb3b0e20e388$var$VirtualScrollerPinnedColumns = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PinnedColumns',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedColumns--left']}`]: styles['pinnedColumns--left']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedColumns--right']}`]: styles['pinnedColumns--right']
            },
            styles.pinnedColumns
        ]
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    const boxShadowColor = $f133eb3b0e20e388$var$getBoxShadowColor(theme);
    return (0, $erOpW.default)({
        position: 'sticky',
        overflow: 'hidden',
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[2]
    } : (0, $erOpW.default)({}, theme.palette.mode === 'dark' && {
        backgroundImage: $f133eb3b0e20e388$var$darkModeBackgroundImage
    }), ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).left && {
        left: 0,
        float: 'left',
        boxShadow: `2px 0px 4px -2px ${boxShadowColor}`
    }, ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right && {
        right: 0,
        float: 'right',
        boxShadow: `-2px 0px 4px -2px ${boxShadowColor}`
    }, ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right && ownerState.showCellVerticalBorder && {
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid'
    });
});
var $f133eb3b0e20e388$var$PinnedRowsPosition = /*#__PURE__*/ function(PinnedRowsPosition) {
    PinnedRowsPosition["top"] = "top";
    PinnedRowsPosition["bottom"] = "bottom";
    return PinnedRowsPosition;
}($f133eb3b0e20e388$var$PinnedRowsPosition || {});
const $f133eb3b0e20e388$var$VirtualScrollerPinnedRows = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PinnedRows',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedRows--top']}`]: styles['pinnedRows--top']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedRows--bottom']}`]: styles['pinnedRows--bottom']
            },
            styles.pinnedRows
        ]
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays2;
    const boxShadowColor = $f133eb3b0e20e388$var$getBoxShadowColor(theme);
    return (0, $erOpW.default)({
        position: 'sticky',
        // should be above the no rows overlay
        zIndex: 4,
        backgroundColor: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundImage: (_theme$vars$overlays2 = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays2[2]
    } : (0, $erOpW.default)({}, theme.palette.mode === 'dark' && {
        backgroundImage: $f133eb3b0e20e388$var$darkModeBackgroundImage
    }), ownerState.position === 'top' && {
        top: 0,
        boxShadow: `0px 3px 4px -2px ${boxShadowColor}`
    }, ownerState.position === $f133eb3b0e20e388$var$PinnedRowsPosition.bottom && {
        boxShadow: `0px -3px 4px -2px ${boxShadowColor}`,
        bottom: 0
    });
});
const $f133eb3b0e20e388$var$VirtualScrollerPinnedRowsRenderZone = (0, $28RyA.default)('div')({
    position: 'absolute'
});
const $f133eb3b0e20e388$export$6ec28431e2afa72 = /*#__PURE__*/ $jSIPP.forwardRef(function DataGridProVirtualScroller(props, ref) {
    const other = (0, $cMu4A.default)(props, $f133eb3b0e20e388$var$_excluded);
    const apiRef = (0, $8f6cf70f27a49076$export$e1fd9274eb96ee18)();
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const visibleColumnFields = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3));
    const expandedRowIds = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad));
    const detailPanelsContent = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$16fba932632c70f0));
    const detailPanelsHeights = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$f8466bb36c8b9813));
    const leftColumns = $jSIPP.useRef(null);
    const rightColumns = $jSIPP.useRef(null);
    const topPinnedRowsRenderZoneRef = $jSIPP.useRef(null);
    const bottomPinnedRowsRenderZoneRef = $jSIPP.useRef(null);
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const handleRenderZonePositioning = $jSIPP.useCallback(({ top: top, left: left })=>{
        if (leftColumns.current) leftColumns.current.style.transform = `translate3d(0px, ${top}px, 0px)`;
        if (rightColumns.current) rightColumns.current.style.transform = `translate3d(0px, ${top}px, 0px)`;
        if (topPinnedRowsRenderZoneRef.current) topPinnedRowsRenderZoneRef.current.style.transform = `translate3d(${left}px, 0px, 0px)`;
        if (bottomPinnedRowsRenderZoneRef.current) bottomPinnedRowsRenderZoneRef.current.style.transform = `translate3d(${left}px, 0px, 0px)`;
    }, []);
    // Create a lookup for faster check if the row is expanded
    const expandedRowIdsLookup = $jSIPP.useMemo(()=>{
        const lookup = new Set();
        expandedRowIds.forEach((id)=>{
            lookup.add(id);
        });
        return lookup;
    }, [
        expandedRowIds
    ]);
    const getRowProps = $jSIPP.useCallback((id)=>{
        if (!expandedRowIdsLookup.has(id)) return null;
        const height = detailPanelsHeights[id];
        return {
            style: {
                marginBottom: height
            }
        };
    }, [
        detailPanelsHeights,
        expandedRowIdsLookup
    ]);
    const pinnedColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $a75735833c020888$export$1eea0bd4db853467));
    const [leftPinnedColumns, rightPinnedColumns] = $f133eb3b0e20e388$export$d65e188677517fa1(pinnedColumns, visibleColumnFields, theme.direction === 'rtl');
    const pinnedRows = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$ffe7071c481e32b0));
    const topPinnedRowsData = $jSIPP.useMemo(()=>(pinnedRows == null ? void 0 : pinnedRows.top) || [], [
        pinnedRows == null ? void 0 : pinnedRows.top
    ]);
    const bottomPinnedRowsData = $jSIPP.useMemo(()=>(pinnedRows == null ? void 0 : pinnedRows.bottom) || [], [
        pinnedRows == null ? void 0 : pinnedRows.bottom
    ]);
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        classes: rootProps.classes
    });
    const classes = $f133eb3b0e20e388$var$useUtilityClasses(ownerState);
    const { renderContext: renderContext, getRows: getRows, getRootProps: getRootProps, getContentProps: getContentProps, getRenderZoneProps: getRenderZoneProps, updateRenderZonePosition: updateRenderZonePosition } = (0, $e9642a68285a9b69$export$fbe94079134c8d27)((0, $erOpW.default)({
        ref: ref,
        renderZoneMinColumnIndex: leftPinnedColumns.length,
        renderZoneMaxColumnIndex: visibleColumnFields.length - rightPinnedColumns.length,
        onRenderZonePositioning: handleRenderZonePositioning,
        getRowProps: getRowProps
    }, props));
    const refreshRenderZonePosition = $jSIPP.useCallback(()=>{
        if (renderContext) updateRenderZonePosition(renderContext);
    }, [
        renderContext,
        updateRenderZonePosition
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnWidthChange', refreshRenderZonePosition);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnOrderChange', refreshRenderZonePosition);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowOrderChange', refreshRenderZonePosition);
    const leftRenderContext = renderContext && leftPinnedColumns.length > 0 ? (0, $erOpW.default)({}, renderContext, {
        firstColumnIndex: 0,
        lastColumnIndex: leftPinnedColumns.length
    }) : null;
    const rightRenderContext = renderContext && rightPinnedColumns.length > 0 ? (0, $erOpW.default)({}, renderContext, {
        firstColumnIndex: visibleColumnFields.length - rightPinnedColumns.length,
        lastColumnIndex: visibleColumnFields.length
    }) : null;
    const getDetailPanel = (rowId)=>{
        const rowsMeta = (0, $dc4794f7e9d46149$export$4f32bfc70efeb4ab)(apiRef.current.state);
        const content = detailPanelsContent[rowId];
        // Check if the id exists in the current page
        const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
        const exists = rowIndex !== undefined;
        if (/*#__PURE__*/ $jSIPP.isValidElement(content) && exists) {
            const hasAutoHeight = apiRef.current.detailPanelHasAutoHeight(rowId);
            const height = hasAutoHeight ? 'auto' : detailPanelsHeights[rowId];
            const sizes = apiRef.current.unstable_getRowInternalSizes(rowId);
            const spacingTop = (sizes == null ? void 0 : sizes.spacingTop) || 0;
            const top = rowsMeta.positions[rowIndex] + apiRef.current.unstable_getRowHeight(rowId) + spacingTop;
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4fd93f9dffdf537f$export$904faaa9b81e46ab), {
                rowId: rowId,
                style: {
                    top: top
                },
                height: height,
                className: classes.detailPanel,
                children: content
            }, rowId);
        }
        return null;
    };
    const detailPanels = [];
    const topPinnedRows = getRows({
        renderContext: renderContext,
        rows: topPinnedRowsData,
        position: 'center'
    });
    const pinnedRowsHeight = (0, $db5319c56f201804$export$d299da5915ed6fec)(apiRef);
    const mainRows = getRows({
        renderContext: renderContext,
        rowIndexOffset: topPinnedRowsData.length,
        position: 'center',
        onRowRender: (rowId)=>{
            if (rootProps.getDetailPanelContent == null) return;
            if (!expandedRowIdsLookup.has(rowId)) return;
            const detailPanel = getDetailPanel(rowId);
            if (detailPanel) detailPanels.push(detailPanel);
        }
    });
    const bottomPinnedRows = getRows({
        renderContext: renderContext,
        rows: bottomPinnedRowsData,
        rowIndexOffset: topPinnedRowsData.length + (mainRows ? mainRows.length : 0),
        position: 'center'
    });
    const contentProps = getContentProps();
    const pinnedColumnsStyle = {
        minHeight: contentProps.style.minHeight
    };
    if (contentProps.style.minHeight && contentProps.style.minHeight === '100%') contentProps.style.minHeight = `calc(100% - ${pinnedRowsHeight.top}px - ${pinnedRowsHeight.bottom}px)`;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $0fad0ae2e639d202$export$febd8ae712031b27), (0, $erOpW.default)({}, getRootProps(other), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $34426c55a9e6c8ed$export$867f5fc44327bee5), {}),
            topPinnedRowsData.length > 0 ? /*#__PURE__*/ (0, $4uaIU.jsxs)($f133eb3b0e20e388$var$VirtualScrollerPinnedRows, {
                className: classes.topPinnedRows,
                ownerState: (0, $erOpW.default)({}, ownerState, {
                    position: $f133eb3b0e20e388$var$PinnedRowsPosition.top
                }),
                style: {
                    width: contentProps.style.width,
                    height: pinnedRowsHeight.top
                },
                role: "rowgroup",
                children: [
                    leftRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        className: classes.leftPinnedColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).left,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        children: getRows({
                            renderContext: leftRenderContext,
                            minFirstColumn: leftRenderContext.firstColumnIndex,
                            maxLastColumn: leftRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rows: topPinnedRowsData,
                            position: 'left'
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedRowsRenderZone, {
                        className: classes.pinnedRowsRenderZone,
                        ref: topPinnedRowsRenderZoneRef,
                        role: "presentation",
                        children: topPinnedRows
                    }),
                    rightRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        className: classes.rightPinnedColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).right,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        children: getRows({
                            renderContext: rightRenderContext,
                            minFirstColumn: rightRenderContext.firstColumnIndex,
                            maxLastColumn: rightRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rows: topPinnedRowsData,
                            position: 'right'
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $54f6e6ad05cec6fd$export$97d48eb8ba00afb8), (0, $erOpW.default)({}, contentProps, {
                children: [
                    leftRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        ref: leftColumns,
                        className: classes.leftPinnedColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).left,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        style: pinnedColumnsStyle,
                        children: getRows({
                            renderContext: leftRenderContext,
                            minFirstColumn: leftRenderContext.firstColumnIndex,
                            maxLastColumn: leftRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rowIndexOffset: topPinnedRowsData.length,
                            position: 'left'
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $035e2bb50f4c6c76$export$95930d31e6a9269f), (0, $erOpW.default)({}, getRenderZoneProps(), {
                        children: mainRows
                    })),
                    rightRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        ref: rightColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).right,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        className: classes.rightPinnedColumns,
                        style: pinnedColumnsStyle,
                        children: getRows({
                            renderContext: rightRenderContext,
                            minFirstColumn: rightRenderContext.firstColumnIndex,
                            maxLastColumn: rightRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rowIndexOffset: topPinnedRowsData.length,
                            position: 'right'
                        })
                    }),
                    detailPanels.length > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerDetailPanels, {
                        className: classes.detailPanels,
                        ownerState: ownerState,
                        children: detailPanels
                    })
                ]
            })),
            bottomPinnedRowsData.length > 0 ? /*#__PURE__*/ (0, $4uaIU.jsxs)($f133eb3b0e20e388$var$VirtualScrollerPinnedRows, {
                className: classes.bottomPinnedRows,
                ownerState: (0, $erOpW.default)({}, ownerState, {
                    position: $f133eb3b0e20e388$var$PinnedRowsPosition.bottom
                }),
                style: {
                    width: contentProps.style.width,
                    height: pinnedRowsHeight.bottom
                },
                role: "rowgroup",
                children: [
                    leftRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        className: classes.leftPinnedColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).left,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        children: getRows({
                            renderContext: leftRenderContext,
                            minFirstColumn: leftRenderContext.firstColumnIndex,
                            maxLastColumn: leftRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rows: bottomPinnedRowsData,
                            rowIndexOffset: topPinnedRowsData.length + (mainRows ? mainRows.length : 0),
                            position: 'left'
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedRowsRenderZone, {
                        className: classes.pinnedRowsRenderZone,
                        ref: bottomPinnedRowsRenderZoneRef,
                        role: "presentation",
                        children: bottomPinnedRows
                    }),
                    rightRenderContext && /*#__PURE__*/ (0, $4uaIU.jsx)($f133eb3b0e20e388$var$VirtualScrollerPinnedColumns, {
                        className: classes.rightPinnedColumns,
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).right,
                            showCellVerticalBorder: rootProps.showCellVerticalBorder
                        }),
                        children: getRows({
                            renderContext: rightRenderContext,
                            minFirstColumn: rightRenderContext.firstColumnIndex,
                            maxLastColumn: rightRenderContext.lastColumnIndex,
                            availableSpace: 0,
                            rows: bottomPinnedRowsData,
                            rowIndexOffset: topPinnedRowsData.length + (mainRows ? mainRows.length : 0),
                            position: 'right'
                        })
                    })
                ]
            }) : null
        ]
    }));
});


const $95bb03c14b694038$export$5fee0234a63f3519 = (state, props, apiRef)=>{
    var _props$initialState;
    apiRef.current.caches.columnPinning = {
        orderedFieldsBeforePinningColumns: null
    };
    let model;
    if (props.disableColumnPinning) model = {};
    else if (props.pinnedColumns) model = props.pinnedColumns;
    else if ((_props$initialState = props.initialState) != null && _props$initialState.pinnedColumns) {
        var _props$initialState2;
        model = (_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.pinnedColumns;
    } else model = {};
    return (0, $erOpW.default)({}, state, {
        pinnedColumns: model
    });
};
const $95bb03c14b694038$var$mergeStateWithPinnedColumns = (pinnedColumns)=>(state)=>(0, $erOpW.default)({}, state, {
            pinnedColumns: pinnedColumns
        });
const $95bb03c14b694038$export$2534ab700dd48c29 = (apiRef, props)=>{
    var _props$initialState4;
    const pinnedColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $a75735833c020888$export$1eea0bd4db853467));
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    /**
   * PRE-PROCESSING
   */ const calculateScrollLeft = $jSIPP.useCallback((initialValue, params)=>{
        if (props.disableColumnPinning) return initialValue;
        const visibleColumnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef);
        const [leftPinnedColumns, rightPinnedColumns] = (0, $f133eb3b0e20e388$export$d65e188677517fa1)(pinnedColumns, visibleColumnFields, theme.direction === 'rtl');
        if (!params.colIndex || leftPinnedColumns.length === 0 && rightPinnedColumns.length === 0) return initialValue;
        const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
        const columnsTotalWidth = (0, $90c6bb88bfe45f18$export$ab20f9d33edc7794)(apiRef);
        const columnPositions = (0, $90c6bb88bfe45f18$export$fce7d810e48021e3)(apiRef);
        const clientWidth = apiRef.current.virtualScrollerRef.current.clientWidth;
        // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
        const scrollLeft = Math.abs(apiRef.current.virtualScrollerRef.current.scrollLeft);
        const offsetWidth = visibleColumns[params.colIndex].computedWidth;
        const offsetLeft = columnPositions[params.colIndex];
        const leftPinnedColumnsWidth = columnPositions[leftPinnedColumns.length];
        const rightPinnedColumnsWidth = columnsTotalWidth - columnPositions[columnPositions.length - rightPinnedColumns.length];
        const elementBottom = offsetLeft + offsetWidth;
        if (elementBottom - (clientWidth - rightPinnedColumnsWidth) > scrollLeft) {
            const left = elementBottom - (clientWidth - rightPinnedColumnsWidth);
            return (0, $erOpW.default)({}, initialValue, {
                left: left
            });
        }
        if (offsetLeft < scrollLeft + leftPinnedColumnsWidth) {
            const left = offsetLeft - leftPinnedColumnsWidth;
            return (0, $erOpW.default)({}, initialValue, {
                left: left
            });
        }
        return initialValue;
    }, [
        apiRef,
        pinnedColumns,
        props.disableColumnPinning,
        theme.direction
    ]);
    const addColumnMenuItems = $jSIPP.useCallback((columnMenuItems, colDef)=>{
        if (props.disableColumnPinning) return columnMenuItems;
        if (colDef.pinnable === false) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuPinningItem'
        ];
    }, [
        props.disableColumnPinning
    ]);
    const checkIfCanBeReordered = $jSIPP.useCallback((initialValue, { targetIndex: targetIndex })=>{
        const visibleColumnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef);
        const [leftPinnedColumns, rightPinnedColumns] = (0, $f133eb3b0e20e388$export$d65e188677517fa1)(pinnedColumns, visibleColumnFields, theme.direction === 'rtl');
        if (leftPinnedColumns.length === 0 && rightPinnedColumns.length === 0) return initialValue;
        if (leftPinnedColumns.length > 0 && targetIndex < leftPinnedColumns.length) return false;
        if (rightPinnedColumns.length > 0) {
            const visibleColumns = (0, $90c6bb88bfe45f18$export$16a65a9447d3dda9)(apiRef);
            const firstRightPinnedColumnIndex = visibleColumns.length - rightPinnedColumns.length;
            return targetIndex >= firstRightPinnedColumnIndex ? false : initialValue;
        }
        return initialValue;
    }, [
        apiRef,
        pinnedColumns,
        theme.direction
    ]);
    const stateExportPreProcessing = $jSIPP.useCallback((prevState, context)=>{
        var _props$initialState3, _pinnedColumnsToExpor, _pinnedColumnsToExpor2;
        const pinnedColumnsToExport = (0, $a75735833c020888$export$1eea0bd4db853467)(apiRef.current.state);
        const shouldExportPinnedColumns = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.pinnedColumns != null || // Always export if the model has been initialized
        ((_props$initialState3 = props.initialState) == null ? void 0 : _props$initialState3.pinnedColumns) != null || // Export if the model is not empty
        ((_pinnedColumnsToExpor = pinnedColumnsToExport.left) != null ? _pinnedColumnsToExpor : []).length > 0 || ((_pinnedColumnsToExpor2 = pinnedColumnsToExport.right) != null ? _pinnedColumnsToExpor2 : []).length > 0;
        if (!shouldExportPinnedColumns) return prevState;
        return (0, $erOpW.default)({}, prevState, {
            pinnedColumns: pinnedColumnsToExport
        });
    }, [
        apiRef,
        props.pinnedColumns,
        (_props$initialState4 = props.initialState) == null ? void 0 : _props$initialState4.pinnedColumns
    ]);
    const stateRestorePreProcessing = $jSIPP.useCallback((params, context)=>{
        const newPinnedColumns = context.stateToRestore.pinnedColumns;
        if (newPinnedColumns != null) apiRef.current.setState($95bb03c14b694038$var$mergeStateWithPinnedColumns(newPinnedColumns));
        return params;
    }, [
        apiRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'scrollToIndexes', calculateScrollLeft);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'canBeReordered', checkIfCanBeReordered);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    apiRef.current.registerControlState({
        stateId: 'pinnedColumns',
        propModel: props.pinnedColumns,
        propOnChange: props.onPinnedColumnsChange,
        stateSelector: (0, $a75735833c020888$export$1eea0bd4db853467),
        changeEvent: 'pinnedColumnsChange'
    });
    const checkIfEnabled = $jSIPP.useCallback((methodName)=>{
        if (props.disableColumnPinning) throw new Error(`MUI: You cannot call \`apiRef.current.${methodName}\` when \`disableColumnPinning\` is true.`);
    }, [
        props.disableColumnPinning
    ]);
    const pinColumn = $jSIPP.useCallback((field, side)=>{
        checkIfEnabled('pinColumn');
        if (apiRef.current.isColumnPinned(field) === side) return;
        const otherSide = side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right ? (0, $47048811c4f4effd$export$6e56be315e15ea9e).left : (0, $47048811c4f4effd$export$6e56be315e15ea9e).right;
        const newPinnedColumns = {
            [side]: [
                ...pinnedColumns[side] || [],
                field
            ],
            [otherSide]: (pinnedColumns[otherSide] || []).filter((column)=>column !== field)
        };
        apiRef.current.setPinnedColumns(newPinnedColumns);
    }, [
        apiRef,
        checkIfEnabled,
        pinnedColumns
    ]);
    const unpinColumn = $jSIPP.useCallback((field)=>{
        checkIfEnabled('unpinColumn');
        apiRef.current.setPinnedColumns({
            left: (pinnedColumns.left || []).filter((column)=>column !== field),
            right: (pinnedColumns.right || []).filter((column)=>column !== field)
        });
    }, [
        apiRef,
        checkIfEnabled,
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const getPinnedColumns = $jSIPP.useCallback(()=>{
        checkIfEnabled('getPinnedColumns');
        return (0, $a75735833c020888$export$1eea0bd4db853467)(apiRef.current.state);
    }, [
        apiRef,
        checkIfEnabled
    ]);
    const setPinnedColumns = $jSIPP.useCallback((newPinnedColumns)=>{
        checkIfEnabled('setPinnedColumns');
        apiRef.current.setState($95bb03c14b694038$var$mergeStateWithPinnedColumns(newPinnedColumns));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        checkIfEnabled
    ]);
    const isColumnPinned = $jSIPP.useCallback((field)=>{
        checkIfEnabled('isColumnPinned');
        const leftPinnedColumns = pinnedColumns.left || [];
        if (leftPinnedColumns.includes(field)) return (0, $47048811c4f4effd$export$6e56be315e15ea9e).left;
        const rightPinnedColumns = pinnedColumns.right || [];
        if (rightPinnedColumns.includes(field)) return (0, $47048811c4f4effd$export$6e56be315e15ea9e).right;
        return false;
    }, [
        pinnedColumns.left,
        pinnedColumns.right,
        checkIfEnabled
    ]);
    const columnPinningApi = {
        pinColumn: pinColumn,
        unpinColumn: unpinColumn,
        getPinnedColumns: getPinnedColumns,
        setPinnedColumns: setPinnedColumns,
        isColumnPinned: isColumnPinned
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, columnPinningApi, 'public');
    const handleColumnOrderChange = $jSIPP.useCallback((params)=>{
        if (!apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns) return;
        const { column: column, targetIndex: targetIndex, oldIndex: oldIndex } = params;
        const delta = targetIndex > oldIndex ? 1 : -1;
        const latestColumnFields = (0, $90c6bb88bfe45f18$export$d8a3dfbb129c80db)(apiRef);
        /**
     * When a column X is reordered to somewhere else, the position where this column X is dropped
     * on must be moved to left or right to make room for it. The ^^^ below represents the column
     * which gave space to receive X.
     *
     * | X | B | C | D | -> | B | C | D | X | (e.g. X moved to after D, so delta=1)
     *              ^^^              ^^^
     *
     * | A | B | C | X | -> | X | A | B | C | (e.g. X moved before A, so delta=-1)
     *  ^^^                      ^^^
     *
     * If column P is pinned, it will not move to provide space. However, it will jump to the next
     * non-pinned column.
     *
     * | X | B | P | D | -> | B | D | P | X | (e.g. X moved to after D, with P pinned)
     *              ^^^          ^^^
     */ const siblingField = latestColumnFields[targetIndex - delta];
        const newOrderedFieldsBeforePinningColumns = [
            ...apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns
        ];
        // The index to start swapping fields
        let i = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === column.field);
        // The index of the field to swap with
        let j = i + delta;
        // When to stop swapping fields.
        // We stop one field before because the swap is done with i + 1 (if delta=1)
        const stop = newOrderedFieldsBeforePinningColumns.findIndex((currentColumn)=>currentColumn === siblingField);
        while(delta > 0 ? i < stop : i > stop){
            // If the field to swap with is a pinned column, jump to the next
            while(apiRef.current.isColumnPinned(newOrderedFieldsBeforePinningColumns[j]))j += delta;
            const temp = newOrderedFieldsBeforePinningColumns[i];
            newOrderedFieldsBeforePinningColumns[i] = newOrderedFieldsBeforePinningColumns[j];
            newOrderedFieldsBeforePinningColumns[j] = temp;
            i = j;
            j = i + delta;
        }
        apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
    }, [
        apiRef
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnOrderChange', handleColumnOrderChange);
    $jSIPP.useEffect(()=>{
        if (props.pinnedColumns) apiRef.current.setPinnedColumns(props.pinnedColumns);
    }, [
        apiRef,
        props.pinnedColumns
    ]);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");





const $f19311b5b4922e59$export$47a2167ef2ac089d = (apiRef, props)=>{
    const { disableColumnPinning: disableColumnPinning, pinnedColumns: pinnedColumnsProp, initialState: initialState } = props;
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    let pinnedColumns = (0, $a75735833c020888$export$1eea0bd4db853467)(apiRef.current.state);
    if (pinnedColumns == null) {
        // Since the state is not ready yet lets use the initializer to get which
        // columns should be pinned initially.
        const initializedState = (0, $95bb03c14b694038$export$5fee0234a63f3519)(apiRef.current.state, {
            disableColumnPinning: disableColumnPinning,
            pinnedColumns: pinnedColumnsProp,
            initialState: initialState
        }, apiRef);
        pinnedColumns = (0, $a75735833c020888$export$1eea0bd4db853467)(initializedState);
    }
    const prevAllPinnedColumns = $jSIPP.useRef([]);
    const reorderPinnedColumns = $jSIPP.useCallback((columnsState)=>{
        if (columnsState.orderedFields.length === 0 || disableColumnPinning) return columnsState;
        const [leftPinnedColumns, rightPinnedColumns] = (0, $f133eb3b0e20e388$export$d65e188677517fa1)(pinnedColumns, columnsState.orderedFields, theme.direction === 'rtl');
        let newOrderedFields;
        const allPinnedColumns = [
            ...leftPinnedColumns,
            ...rightPinnedColumns
        ];
        const { orderedFieldsBeforePinningColumns: orderedFieldsBeforePinningColumns } = apiRef.current.caches.columnPinning;
        if (orderedFieldsBeforePinningColumns) {
            newOrderedFields = new Array(columnsState.orderedFields.length).fill(null);
            const newOrderedFieldsBeforePinningColumns = [
                ...newOrderedFields
            ];
            // Contains the fields not added to the orderedFields array yet
            const remainingFields = [
                ...columnsState.orderedFields
            ];
            // First, we check if the column was unpinned since the last processing.
            // If yes and it still exists, we move it back to the same position it was before pinning
            prevAllPinnedColumns.current.forEach((field)=>{
                if (!allPinnedColumns.includes(field) && columnsState.lookup[field]) {
                    // Get the position before pinning
                    const index = orderedFieldsBeforePinningColumns.indexOf(field);
                    newOrderedFields[index] = field;
                    newOrderedFieldsBeforePinningColumns[index] = field;
                    // This field was already consumed so we prevent from being added again
                    remainingFields.splice(remainingFields.indexOf(field), 1);
                }
            });
            // For columns still pinned, we keep stored their original positions
            allPinnedColumns.forEach((field)=>{
                let index = orderedFieldsBeforePinningColumns.indexOf(field);
                // If index = -1, the pinned field didn't exist in the last processing, it's possibly being added now
                // If index >= newOrderedFieldsBeforePinningColumns.length, then one or more columns were removed
                // In both cases, use the position from the columns array
                // TODO: detect removed columns and decrease the positions after it
                if (index === -1 || index >= newOrderedFieldsBeforePinningColumns.length) index = columnsState.orderedFields.indexOf(field);
                // The fallback above may make the column to be inserted in a position already occupied
                // In this case, put it in any empty slot available
                if (newOrderedFieldsBeforePinningColumns[index] !== null) {
                    index = 0;
                    while(newOrderedFieldsBeforePinningColumns[index] !== null)index += 1;
                }
                newOrderedFields[index] = field;
                newOrderedFieldsBeforePinningColumns[index] = field;
                // This field was already consumed so we prevent from being added again
                remainingFields.splice(remainingFields.indexOf(field), 1);
            });
            // The fields remaining are those that're neither pinnned nor were unpinned
            // For these, we spread them across both arrays making sure to not override existing values
            let i = 0;
            remainingFields.forEach((field)=>{
                while(newOrderedFieldsBeforePinningColumns[i] !== null)i += 1;
                newOrderedFieldsBeforePinningColumns[i] = field;
                newOrderedFields[i] = field;
            });
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
        } else {
            newOrderedFields = [
                ...columnsState.orderedFields
            ];
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = [
                ...columnsState.orderedFields
            ];
        }
        prevAllPinnedColumns.current = allPinnedColumns;
        const centerColumns = newOrderedFields.filter((field)=>{
            return !leftPinnedColumns.includes(field) && !rightPinnedColumns.includes(field);
        });
        return (0, $erOpW.default)({}, columnsState, {
            orderedFields: [
                ...leftPinnedColumns,
                ...centerColumns,
                ...rightPinnedColumns
            ]
        });
    }, [
        apiRef,
        disableColumnPinning,
        pinnedColumns,
        theme.direction
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'hydrateColumns', reorderPinnedColumns);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $c1771006a8af0566$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isExpanded: isExpanded } = ownerState;
    const slots = {
        root: [
            'detailPanelToggleCell',
            isExpanded && 'detailPanelToggleCell--expanded'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $c1771006a8af0566$export$817e5e2e8d6c93c(props) {
    var _rootProps$slotProps;
    const { id: id, value: isExpanded } = props;
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $8e32833f8e5c03cf$export$2d14edd3a7db3bbf)();
    const ownerState = {
        classes: rootProps.classes,
        isExpanded: isExpanded
    };
    const classes = $c1771006a8af0566$var$useUtilityClasses(ownerState);
    const contentCache = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$16fba932632c70f0));
    const hasContent = /*#__PURE__*/ $jSIPP.isValidElement(contentCache[id]);
    const Icon = isExpanded ? rootProps.slots.detailPanelCollapseIcon : rootProps.slots.detailPanelExpandIcon;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
        size: "small",
        tabIndex: -1,
        disabled: !hasContent,
        className: classes.root,
        "aria-label": isExpanded ? apiRef.current.getLocaleText('collapseDetailPanel') : apiRef.current.getLocaleText('expandDetailPanel')
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, {
            fontSize: "inherit"
        })
    }));
}




var $4uaIU = parcelRequire("4uaIU");
const $05586f3b1b26e0bd$export$6e5a576305a34719 = '__detail_panel_toggle__';
const $05586f3b1b26e0bd$export$cea0a90b26fb973d = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    field: $05586f3b1b26e0bd$export$6e5a576305a34719,
    type: 'detailPanelToggle',
    editable: false,
    sortable: false,
    filterable: false,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    align: 'left',
    width: 40,
    valueGetter: (params)=>{
        const expandedRowIds = (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad)(params.api.state);
        return expandedRowIds.includes(params.id);
    },
    renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $c1771006a8af0566$export$817e5e2e8d6c93c), (0, $erOpW.default)({}, params)),
    renderHeader: ()=>null
});



const $84c1234e78e25e9b$export$c6a1049ecc0f594c = (state, props)=>{
    var _ref, _props$detailPanelExp, _props$initialState;
    return (0, $erOpW.default)({}, state, {
        detailPanel: {
            heightCache: {},
            expandedRowIds: (_ref = (_props$detailPanelExp = props.detailPanelExpandedRowIds) != null ? _props$detailPanelExp : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.detailPanel) == null ? void 0 : _props$initialState.expandedRowIds) != null ? _ref : []
        }
    });
};
function $84c1234e78e25e9b$var$cacheContentAndHeight(apiRef, getDetailPanelContent, getDetailPanelHeight, previousHeightCache) {
    if (typeof getDetailPanelContent !== 'function') return {};
    // TODO change to lazy approach using a Proxy
    // only call getDetailPanelContent when asked for an id
    const rowIds = (0, $d7530f53594a6a47$export$c7dcaab5e573753)(apiRef);
    const contentCache = rowIds.reduce((acc, id)=>{
        const params = apiRef.current.getRowParams(id);
        acc[id] = getDetailPanelContent(params);
        return acc;
    }, {});
    const heightCache = rowIds.reduce((acc, id)=>{
        var _previousHeightCache$;
        if (contentCache[id] == null) return acc;
        const params = apiRef.current.getRowParams(id);
        const height = getDetailPanelHeight(params);
        const autoHeight = height === 'auto';
        acc[id] = {
            autoHeight: autoHeight,
            height: autoHeight ? (_previousHeightCache$ = previousHeightCache[id]) == null ? void 0 : _previousHeightCache$.height : height
        };
        return acc;
    }, {});
    return {
        contentCache: contentCache,
        heightCache: heightCache
    };
}
const $84c1234e78e25e9b$export$b71d7525fdd57704 = (apiRef, props)=>{
    const expandedRowIds = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad));
    const contentCache = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $546d2f4a2dbda87a$export$16fba932632c70f0));
    const handleCellClick = $jSIPP.useCallback((params, event)=>{
        if (params.field !== (0, $05586f3b1b26e0bd$export$6e5a576305a34719) || props.getDetailPanelContent == null) return;
        const content = contentCache[params.id];
        if (!/*#__PURE__*/ $jSIPP.isValidElement(content)) return;
        // Ignore if the user didn't click specifically in the "i" button
        if (event.target === event.currentTarget) return;
        apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const handleCellKeyDown = $jSIPP.useCallback((params, event)=>{
        if (props.getDetailPanelContent == null) return;
        if (params.field === (0, $05586f3b1b26e0bd$export$6e5a576305a34719) && event.key === ' ') apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        props.getDetailPanelContent
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellClick', handleCellClick);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellKeyDown', handleCellKeyDown);
    apiRef.current.registerControlState({
        stateId: 'detailPanels',
        propModel: props.detailPanelExpandedRowIds,
        propOnChange: props.onDetailPanelExpandedRowIdsChange,
        stateSelector: (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad),
        changeEvent: 'detailPanelsExpandedRowIdsChange'
    });
    const toggleDetailPanel = $jSIPP.useCallback((id)=>{
        if (props.getDetailPanelContent == null) return;
        const content = contentCache[id];
        if (!/*#__PURE__*/ $jSIPP.isValidElement(content)) return;
        const ids = apiRef.current.getExpandedDetailPanels();
        apiRef.current.setExpandedDetailPanels(ids.includes(id) ? ids.filter((rowId)=>rowId !== id) : [
            ...ids,
            id
        ]);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    const getExpandedDetailPanels = $jSIPP.useCallback(()=>(0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad)(apiRef.current.state), [
        apiRef
    ]);
    const setExpandedDetailPanels = $jSIPP.useCallback((ids)=>{
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                detailPanel: (0, $erOpW.default)({}, state.detailPanel, {
                    expandedRowIds: ids
                })
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const storeDetailPanelHeight = $jSIPP.useCallback((id, height)=>{
        const heightCache = (0, $546d2f4a2dbda87a$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        if (!heightCache[id] || heightCache[id].height === height) return;
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                detailPanel: (0, $erOpW.default)({}, state.detailPanel, {
                    heightCache: (0, $erOpW.default)({}, heightCache, {
                        [id]: (0, $erOpW.default)({}, heightCache[id], {
                            height: height
                        })
                    })
                })
            });
        });
        apiRef.current.requestPipeProcessorsApplication('rowHeight');
    }, [
        apiRef
    ]);
    const detailPanelHasAutoHeight = $jSIPP.useCallback((id)=>{
        const heightCache = (0, $546d2f4a2dbda87a$export$3a5feeef4c4a2bdc)(apiRef.current.state);
        return heightCache[id] ? heightCache[id].autoHeight : false;
    }, [
        apiRef
    ]);
    const detailPanelPubicApi = {
        toggleDetailPanel: toggleDetailPanel,
        getExpandedDetailPanels: getExpandedDetailPanels,
        setExpandedDetailPanels: setExpandedDetailPanels
    };
    const detailPanelPrivateApi = {
        storeDetailPanelHeight: storeDetailPanelHeight,
        detailPanelHasAutoHeight: detailPanelHasAutoHeight
    };
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, detailPanelPubicApi, 'public');
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, detailPanelPrivateApi, 'private');
    $jSIPP.useEffect(()=>{
        if (props.detailPanelExpandedRowIds) {
            const currentModel = (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad)(apiRef.current.state);
            if (currentModel !== props.detailPanelExpandedRowIds) apiRef.current.setExpandedDetailPanels(props.detailPanelExpandedRowIds);
        }
    }, [
        apiRef,
        props.detailPanelExpandedRowIds
    ]);
    const updateCachesAndForceUpdate = $jSIPP.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                detailPanel: (0, $erOpW.default)({}, state.detailPanel, $84c1234e78e25e9b$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'sortedRowsSet', updateCachesAndForceUpdate);
    const previousGetDetailPanelContentProp = $jSIPP.useRef();
    const previousGetDetailPanelHeightProp = $jSIPP.useRef();
    const updateCachesIfNeeded = $jSIPP.useCallback(()=>{
        if (props.getDetailPanelContent === previousGetDetailPanelContentProp.current && props.getDetailPanelHeight === previousGetDetailPanelHeightProp.current) return;
        apiRef.current.setState((state)=>{
            return (0, $erOpW.default)({}, state, {
                detailPanel: (0, $erOpW.default)({}, state.detailPanel, $84c1234e78e25e9b$var$cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        previousGetDetailPanelContentProp.current = props.getDetailPanelContent;
        previousGetDetailPanelHeightProp.current = props.getDetailPanelHeight;
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    const addDetailHeight = $jSIPP.useCallback((initialValue, row)=>{
        var _heightCache$row$id;
        if (!expandedRowIds || expandedRowIds.length === 0 || !expandedRowIds.includes(row.id)) {
            initialValue.detail = 0;
            return initialValue;
        }
        updateCachesIfNeeded();
        const heightCache = (0, $546d2f4a2dbda87a$export$f8466bb36c8b9813)(apiRef);
        initialValue.detail = (_heightCache$row$id = heightCache[row.id]) != null ? _heightCache$row$id : 0; // Fallback to zero because the cache might not be ready yet (e.g. page was changed)
        return initialValue;
    }, [
        apiRef,
        expandedRowIds,
        updateCachesIfNeeded
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'rowHeight', addDetailHeight);
    const isFirstRender = $jSIPP.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        updateCachesIfNeeded();
    }
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




const $ea58a0d9dacdfbb2$export$77f589f94558bf61 = (privateApiRef, props)=>{
    const addToggleColumn = $jSIPP.useCallback((columnsState)=>{
        if (props.getDetailPanelContent == null) {
            // Remove the toggle column, when it exists
            if (columnsState.lookup[0, $05586f3b1b26e0bd$export$6e5a576305a34719]) {
                delete columnsState.lookup[0, $05586f3b1b26e0bd$export$6e5a576305a34719];
                columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $05586f3b1b26e0bd$export$6e5a576305a34719));
            }
            return columnsState;
        }
        // Don't add the toggle column if there's already one
        // The user might have manually added it to have it in a custom position
        if (columnsState.lookup[0, $05586f3b1b26e0bd$export$6e5a576305a34719]) return columnsState;
        // Otherwise, add the toggle column at the beginning
        columnsState.orderedFields = [
            (0, $05586f3b1b26e0bd$export$6e5a576305a34719),
            ...columnsState.orderedFields
        ];
        columnsState.lookup[0, $05586f3b1b26e0bd$export$6e5a576305a34719] = (0, $erOpW.default)({}, (0, $05586f3b1b26e0bd$export$cea0a90b26fb973d), {
            headerName: privateApiRef.current.getLocaleText('detailPanelToggle')
        });
        return columnsState;
    }, [
        privateApiRef,
        props.getDetailPanelContent
    ]);
    const addExpandedClassToRow = $jSIPP.useCallback((classes, id)=>{
        if (props.getDetailPanelContent == null) return classes;
        const expandedRowIds = (0, $546d2f4a2dbda87a$export$2e51858b6eeff6ad)(privateApiRef.current.state);
        if (!expandedRowIds.includes(id)) return classes;
        return [
            ...classes,
            (0, $4d97f950d65e57e8$export$2100d54e36406477)['row--detailPanelExpanded']
        ];
    }, [
        privateApiRef,
        props.getDetailPanelContent
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', addToggleColumn);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(privateApiRef, 'rowClassName', addExpandedClassToRow);
};



var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");



var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");




var $4uaIU = parcelRequire("4uaIU");
const $c5c61452697bee8d$var$useUtilityClasses = (ownerState)=>{
    const { isDraggable: isDraggable, classes: classes } = ownerState;
    const slots = {
        root: [
            'rowReorderCell',
            isDraggable && 'rowReorderCell--draggable'
        ],
        placeholder: [
            'rowReorderCellPlaceholder'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
function $c5c61452697bee8d$export$5e56cf9b6277d9e5(params) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$4cdbe576751dd8e2));
    const editRowsState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $3cca1b289e09958d$export$91ed78b95c9e6636));
    // eslint-disable-next-line no-underscore-dangle
    const cellValue = params.row.__reorder__ || params.id;
    // TODO: remove sortModel and treeDepth checks once row reorder is compatible
    const isDraggable = $jSIPP.useMemo(()=>!!rootProps.rowReordering && !sortModel.length && treeDepth === 1 && Object.keys(editRowsState).length === 0, [
        rootProps.rowReordering,
        sortModel,
        treeDepth,
        editRowsState
    ]);
    const ownerState = {
        isDraggable: isDraggable,
        classes: rootProps.classes
    };
    const classes = $c5c61452697bee8d$var$useUtilityClasses(ownerState);
    const publish = $jSIPP.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $26a7a0c939103688$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(params.id)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(params.id), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        params.id
    ]);
    const draggableEventHandlers = isDraggable ? {
        onDragStart: publish('rowDragStart'),
        onDragOver: publish('rowDragOver'),
        onDragEnd: publish('rowDragEnd')
    } : null;
    if (params.rowNode.type === 'footer') return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        className: classes.root,
        draggable: isDraggable
    }, draggableEventHandlers, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.rowReorderIcon, {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                className: classes.placeholder,
                children: cellValue
            })
        ]
    }));
}
const $c5c61452697bee8d$export$1346ab9a2305631 = (params)=>{
    if (params.rowNode.type === 'footer' || params.rowNode.type === 'pinnedRow') return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($c5c61452697bee8d$export$5e56cf9b6277d9e5, (0, $erOpW.default)({}, params));
};


const $292554822c3787b5$export$778666d70e672a78 = (0, $erOpW.default)({}, (0, $b946d2cd507e31d9$export$db6fa9d0a45573e4), {
    field: '__reorder__',
    type: 'reorder',
    sortable: false,
    filterable: false,
    width: 50,
    align: 'center',
    headerAlign: 'center',
    disableColumnMenu: true,
    disableExport: true,
    disableReorder: true,
    resizable: false,
    // @ts-ignore
    aggregable: false,
    renderHeader: ()=>' ',
    renderCell: (0, $c5c61452697bee8d$export$1346ab9a2305631)
});


var $e7f0968e28df8aa9$var$Direction = /*#__PURE__*/ function(Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    return Direction;
}($e7f0968e28df8aa9$var$Direction || {});
let $e7f0968e28df8aa9$var$previousMousePosition = null;
let $e7f0968e28df8aa9$var$previousReorderState = {
    previousTargetId: null,
    dragDirection: null
};
const $e7f0968e28df8aa9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        rowDragging: [
            'row--dragging'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $e7f0968e28df8aa9$export$628fe35635cfd286 = (apiRef, props)=>{
    const logger = (0, $ec0fc4f020f08d83$export$eb512164890e58f0)(apiRef, 'useGridRowReorder');
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const treeDepth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $d7530f53594a6a47$export$4cdbe576751dd8e2));
    const dragRowNode = $jSIPP.useRef(null);
    const originRowIndex = $jSIPP.useRef(null);
    const removeDnDStylesTimeout = $jSIPP.useRef();
    const ownerState = {
        classes: props.classes
    };
    const classes = $e7f0968e28df8aa9$var$useUtilityClasses(ownerState);
    const [dragRowId, setDragRowId] = $jSIPP.useState('');
    $jSIPP.useEffect(()=>{
        return ()=>{
            clearTimeout(removeDnDStylesTimeout.current);
        };
    }, []);
    // TODO: remove sortModel check once row reorder is sorting compatible
    // remove treeDepth once row reorder is tree compatible
    const isRowReorderDisabled = $jSIPP.useMemo(()=>{
        return !props.rowReordering || !!sortModel.length || treeDepth !== 1;
    }, [
        props.rowReordering,
        sortModel,
        treeDepth
    ]);
    const handleDragStart = $jSIPP.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        if (isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug(`Start dragging row ${params.id}`);
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        dragRowNode.current = event.currentTarget;
        dragRowNode.current.classList.add(classes.rowDragging);
        setDragRowId(params.id);
        removeDnDStylesTimeout.current = setTimeout(()=>{
            dragRowNode.current.classList.remove(classes.rowDragging);
        });
        originRowIndex.current = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
        apiRef.current.setCellFocus(params.id, (0, $292554822c3787b5$export$778666d70e672a78).field);
    }, [
        isRowReorderDisabled,
        classes.rowDragging,
        logger,
        apiRef
    ]);
    const handleDragOver = $jSIPP.useCallback((params, event)=>{
        if (dragRowId === '') return;
        const rowNode = apiRef.current.getRowNode(params.id);
        if (!rowNode || rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return;
        logger.debug(`Dragging over row ${params.id}`);
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        const mouseMovementDiff = $e7f0968e28df8aa9$var$previousMousePosition ? $e7f0968e28df8aa9$var$previousMousePosition.y - event.clientY : event.clientY;
        if (params.id !== dragRowId) {
            const targetRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
            const dragDirection = mouseMovementDiff > 0 ? $e7f0968e28df8aa9$var$Direction.DOWN : $e7f0968e28df8aa9$var$Direction.UP;
            const currentReorderState = {
                dragDirection: dragDirection,
                previousTargetId: params.id
            };
            const isStateChanged = currentReorderState.dragDirection !== $e7f0968e28df8aa9$var$previousReorderState.dragDirection || currentReorderState.previousTargetId !== $e7f0968e28df8aa9$var$previousReorderState.previousTargetId;
            if ($e7f0968e28df8aa9$var$previousReorderState.dragDirection === null || Math.abs(mouseMovementDiff) >= 1 && isStateChanged) {
                apiRef.current.setRowIndex(dragRowId, targetRowIndex);
                $e7f0968e28df8aa9$var$previousReorderState = currentReorderState;
            }
        }
        $e7f0968e28df8aa9$var$previousMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    }, [
        apiRef,
        logger,
        dragRowId
    ]);
    const handleDragEnd = $jSIPP.useCallback((params, event)=>{
        // Call the gridEditRowsStateSelector directly to avoid infnite loop
        const editRowsState = (0, $3cca1b289e09958d$export$91ed78b95c9e6636)(apiRef.current.state);
        if (dragRowId === '' || isRowReorderDisabled || Object.keys(editRowsState).length !== 0) return;
        logger.debug('End dragging row');
        event.preventDefault();
        // Prevent drag events propagation.
        // For more information check here https://github.com/mui/mui-x/issues/2680.
        event.stopPropagation();
        clearTimeout(removeDnDStylesTimeout.current);
        dragRowNode.current = null;
        $e7f0968e28df8aa9$var$previousReorderState.dragDirection = null;
        // Check if the row was dropped outside the grid.
        if (event.dataTransfer.dropEffect === 'none') {
            // Accessing params.field may contain the wrong field as header elements are reused
            apiRef.current.setRowIndex(dragRowId, originRowIndex.current);
            originRowIndex.current = null;
        } else {
            // Emit the rowOrderChange event only once when the reordering stops.
            const rowOrderChangeParams = {
                row: apiRef.current.getRow(dragRowId),
                targetIndex: apiRef.current.getRowIndexRelativeToVisibleRows(params.id),
                oldIndex: originRowIndex.current
            };
            apiRef.current.publishEvent('rowOrderChange', rowOrderChangeParams);
        }
        setDragRowId('');
    }, [
        isRowReorderDisabled,
        logger,
        apiRef,
        dragRowId
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowDragStart', handleDragStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowDragOver', handleDragOver);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'rowDragEnd', handleDragEnd);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'cellDragOver', handleDragOver);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(apiRef, 'rowOrderChange', props.onRowOrderChange);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $i3Yji = parcelRequire("i3Yji");



const $87eaf36fe36b6fe8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $jSIPP.useMemo(()=>{
        const slots = {
            rowReorderCellContainer: [
                'rowReorderCellContainer'
            ],
            columnHeaderReorder: [
                'columnHeaderReorder'
            ]
        };
        return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $87eaf36fe36b6fe8$export$55f18eb0ec5c02d1 = (privateApiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $87eaf36fe36b6fe8$var$useUtilityClasses(ownerState);
    const updateReorderColumn = $jSIPP.useCallback((columnsState)=>{
        const reorderColumn = (0, $erOpW.default)({}, (0, $292554822c3787b5$export$778666d70e672a78), {
            cellClassName: classes.rowReorderCellContainer,
            headerClassName: classes.columnHeaderReorder,
            headerName: privateApiRef.current.getLocaleText('rowReorderingHeaderName')
        });
        const shouldHaveReorderColumn = props.rowReordering;
        const haveReorderColumn = columnsState.lookup[reorderColumn.field] != null;
        if (shouldHaveReorderColumn && haveReorderColumn) return columnsState;
        if (shouldHaveReorderColumn && !haveReorderColumn) {
            columnsState.lookup[reorderColumn.field] = reorderColumn;
            columnsState.orderedFields = [
                reorderColumn.field,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveReorderColumn && haveReorderColumn) {
            delete columnsState.lookup[reorderColumn.field];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== reorderColumn.field);
        }
        return columnsState;
    }, [
        privateApiRef,
        classes,
        props.rowReordering
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(privateApiRef, 'hydrateColumns', updateReorderColumn);
};



var $jSIPP = parcelRequire("jSIPP");


function $ff10379c5db0437b$var$findSkeletonRowsSection({ apiRef: apiRef, visibleRows: visibleRows, range: range }) {
    let { firstRowIndex: firstRowIndex, lastRowIndex: lastRowIndex } = range;
    const visibleRowsSection = visibleRows.slice(range.firstRowIndex, range.lastRowIndex);
    let startIndex = 0;
    let endIndex = visibleRowsSection.length - 1;
    let isSkeletonSectionFound = false;
    while(!isSkeletonSectionFound && firstRowIndex < lastRowIndex){
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        const isStartingWithASkeletonRow = ((_apiRef$current$getRo = apiRef.current.getRowNode(visibleRowsSection[startIndex].id)) == null ? void 0 : _apiRef$current$getRo.type) === 'skeletonRow';
        const isEndingWithASkeletonRow = ((_apiRef$current$getRo2 = apiRef.current.getRowNode(visibleRowsSection[endIndex].id)) == null ? void 0 : _apiRef$current$getRo2.type) === 'skeletonRow';
        if (isStartingWithASkeletonRow && isEndingWithASkeletonRow) isSkeletonSectionFound = true;
        if (!isStartingWithASkeletonRow) {
            startIndex += 1;
            firstRowIndex += 1;
        }
        if (!isEndingWithASkeletonRow) {
            endIndex -= 1;
            lastRowIndex -= 1;
        }
    }
    return isSkeletonSectionFound ? {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex
    } : undefined;
}
function $ff10379c5db0437b$var$isLazyLoadingDisabled({ lazyLoadingFeatureFlag: lazyLoadingFeatureFlag, rowsLoadingMode: rowsLoadingMode, gridDimensions: gridDimensions }) {
    if (!lazyLoadingFeatureFlag || !gridDimensions) return true;
    if (rowsLoadingMode !== 'server') return true;
    return false;
}
const $ff10379c5db0437b$export$c805ba869d6a5 = (privateApiRef, props)=>{
    var _props$experimentalFe;
    const visibleRows = (0, $0a6b6a2469195bfe$export$d1914c80ff11e37a)(privateApiRef, props);
    const sortModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(privateApiRef, (0, $fd4beb3eff079ebd$export$55dcc66b73d9a0f9));
    const filterModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(privateApiRef, (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5));
    const renderedRowsIntervalCache = $jSIPP.useRef({
        firstRowToRender: 0,
        lastRowToRender: 0
    });
    const { lazyLoading: lazyLoading } = (_props$experimentalFe = props.experimentalFeatures) != null ? _props$experimentalFe : {};
    const getCurrentIntervalToRender = $jSIPP.useCallback(()=>{
        const currentRenderContext = privateApiRef.current.getRenderContext();
        const [firstRowToRender, lastRowToRender] = (0, $e9642a68285a9b69$export$e8e2b5bd6af586c5)({
            firstIndex: currentRenderContext.firstRowIndex,
            lastIndex: currentRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: visibleRows.rows.length,
            buffer: props.rowBuffer
        });
        return {
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender
        };
    }, [
        privateApiRef,
        props.rowBuffer,
        visibleRows.rows.length
    ]);
    const handleRenderedRowsIntervalChange = $jSIPP.useCallback((params)=>{
        const dimensions = privateApiRef.current.getRootDimensions();
        if ($ff10379c5db0437b$var$isLazyLoadingDisabled({
            lazyLoadingFeatureFlag: lazyLoading,
            rowsLoadingMode: props.rowsLoadingMode,
            gridDimensions: dimensions
        })) return;
        const fetchRowsParams = {
            firstRowToRender: params.firstRowToRender,
            lastRowToRender: params.lastRowToRender,
            sortModel: sortModel,
            filterModel: filterModel
        };
        if (renderedRowsIntervalCache.current.firstRowToRender === params.firstRowToRender && renderedRowsIntervalCache.current.lastRowToRender === params.lastRowToRender) return;
        if (sortModel.length === 0 && filterModel.items.length === 0) {
            const skeletonRowsSection = $ff10379c5db0437b$var$findSkeletonRowsSection({
                apiRef: privateApiRef,
                visibleRows: visibleRows.rows,
                range: {
                    firstRowIndex: params.firstRowToRender,
                    lastRowIndex: params.lastRowToRender
                }
            });
            if (!skeletonRowsSection) return;
            fetchRowsParams.firstRowToRender = skeletonRowsSection.firstRowIndex;
            fetchRowsParams.lastRowToRender = skeletonRowsSection.lastRowIndex;
        }
        renderedRowsIntervalCache.current = params;
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        props.rowsLoadingMode,
        sortModel,
        filterModel,
        visibleRows.rows,
        lazyLoading
    ]);
    const handleGridSortModelChange = $jSIPP.useCallback((newSortModel)=>{
        const dimensions = privateApiRef.current.getRootDimensions();
        if ($ff10379c5db0437b$var$isLazyLoadingDisabled({
            lazyLoadingFeatureFlag: lazyLoading,
            rowsLoadingMode: props.rowsLoadingMode,
            gridDimensions: dimensions
        })) return;
        privateApiRef.current.requestPipeProcessorsApplication('hydrateRows');
        const { firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender } = getCurrentIntervalToRender();
        const fetchRowsParams = {
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            sortModel: newSortModel,
            filterModel: filterModel
        };
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        props.rowsLoadingMode,
        filterModel,
        lazyLoading,
        getCurrentIntervalToRender
    ]);
    const handleGridFilterModelChange = $jSIPP.useCallback((newFilterModel)=>{
        const dimensions = privateApiRef.current.getRootDimensions();
        if ($ff10379c5db0437b$var$isLazyLoadingDisabled({
            lazyLoadingFeatureFlag: lazyLoading,
            rowsLoadingMode: props.rowsLoadingMode,
            gridDimensions: dimensions
        })) return;
        privateApiRef.current.requestPipeProcessorsApplication('hydrateRows');
        const { firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender } = getCurrentIntervalToRender();
        const fetchRowsParams = {
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            sortModel: sortModel,
            filterModel: newFilterModel
        };
        privateApiRef.current.publishEvent('fetchRows', fetchRowsParams);
    }, [
        privateApiRef,
        props.rowsLoadingMode,
        sortModel,
        lazyLoading,
        getCurrentIntervalToRender
    ]);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(privateApiRef, 'renderedRowsIntervalChange', handleRenderedRowsIntervalChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(privateApiRef, 'sortModelChange', handleGridSortModelChange);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(privateApiRef, 'filterModelChange', handleGridFilterModelChange);
    (0, $51ad73708acc0b23$export$d55ddab8b28954db)(privateApiRef, 'fetchRows', props.onFetchRows);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


const $f7608e7f0ef01977$export$4fd3c65dfc13fe4b = 'auto-generated-skeleton-row-root';
const $f7608e7f0ef01977$var$getSkeletonRowId = (index)=>`${$f7608e7f0ef01977$export$4fd3c65dfc13fe4b}-${index}`;
const $f7608e7f0ef01977$export$220f673c81926201 = (privateApiRef, props)=>{
    var _props$experimentalFe;
    const { lazyLoading: lazyLoading } = (_props$experimentalFe = props.experimentalFeatures) != null ? _props$experimentalFe : {};
    const addSkeletonRows = $jSIPP.useCallback((groupingParams)=>{
        const rootGroup = groupingParams.tree[0, $db5319c56f201804$export$433b924dc2506913];
        if (!lazyLoading || props.rowsLoadingMode !== 'server' || !props.rowCount || rootGroup.children.length >= props.rowCount) return groupingParams;
        const tree = (0, $erOpW.default)({}, groupingParams.tree);
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        for(let i = 0; i < props.rowCount - rootGroup.children.length; i += 1){
            const skeletonId = $f7608e7f0ef01977$var$getSkeletonRowId(i);
            rootGroupChildren.push(skeletonId);
            const skeletonRowNode = {
                type: 'skeletonRow',
                id: skeletonId,
                parent: (0, $db5319c56f201804$export$433b924dc2506913),
                depth: 0
            };
            tree[skeletonId] = skeletonRowNode;
        }
        tree[0, $db5319c56f201804$export$433b924dc2506913] = (0, $erOpW.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        return (0, $erOpW.default)({}, groupingParams, {
            tree: tree
        });
    }, [
        props.rowCount,
        props.rowsLoadingMode,
        lazyLoading
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(privateApiRef, 'hydrateRows', addSkeletonRows);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


function $8cca0fdca50506d7$var$createPinnedRowsInternalCache(pinnedRows, getRowId) {
    var _pinnedRows$top, _pinnedRows$bottom;
    const cache = {
        topIds: [],
        bottomIds: [],
        idLookup: {}
    };
    pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null || _pinnedRows$top.forEach((rowModel)=>{
        const id = (0, $db5319c56f201804$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.topIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null || _pinnedRows$bottom.forEach((rowModel)=>{
        const id = (0, $db5319c56f201804$export$a95fb784d0ca2e72)(rowModel, getRowId);
        cache.bottomIds.push(id);
        cache.idLookup[id] = rowModel;
    });
    return cache;
}
const $8cca0fdca50506d7$export$68e0b9853cc25422 = (state, props, apiRef)=>{
    var _state$rows;
    apiRef.current.caches.pinnedRows = $8cca0fdca50506d7$var$createPinnedRowsInternalCache(props.pinnedRows, props.getRowId);
    return (0, $erOpW.default)({}, state, {
        rows: (0, $erOpW.default)({}, state.rows, {
            additionalRowGroups: (0, $erOpW.default)({}, (_state$rows = state.rows) == null ? void 0 : _state$rows.additionalRowGroups, {
                pinnedRows: {
                    top: [],
                    bottom: []
                }
            })
        })
    });
};
const $8cca0fdca50506d7$export$d37ff411a3231397 = (apiRef, props)=>{
    const setPinnedRows = $jSIPP.useCallback((newPinnedRows)=>{
        apiRef.current.caches.pinnedRows = $8cca0fdca50506d7$var$createPinnedRowsInternalCache(newPinnedRows, props.getRowId);
        apiRef.current.requestPipeProcessorsApplication('hydrateRows');
    }, [
        apiRef,
        props.getRowId
    ]);
    (0, $841c59db2853e965$export$739f6b6a65e76d6c)(apiRef, {
        unstable_setPinnedRows: setPinnedRows
    }, 'public');
    const isFirstRender = $jSIPP.useRef(true);
    $jSIPP.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        apiRef.current.unstable_setPinnedRows(props.pinnedRows);
    }, [
        apiRef,
        props.pinnedRows
    ]);
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



function $905aa937af39b680$export$a9980a60d1e4cd4d({ groupingParams: groupingParams, rowModel: rowModel, rowId: rowId, position: position, apiRef: apiRef, isAutoGenerated: isAutoGenerated }) {
    var _groupingParams$addit, _groupingParams$addit2;
    const dataRowIdToModelLookup = (0, $erOpW.default)({}, groupingParams.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $erOpW.default)({}, groupingParams.dataRowIdToIdLookup);
    const tree = (0, $erOpW.default)({}, groupingParams.tree);
    const treeDepths = (0, $erOpW.default)({}, groupingParams.treeDepths);
    // TODO: warn if id is already present in `props.rows`
    const node = {
        type: 'pinnedRow',
        id: rowId,
        depth: 0,
        parent: (0, $db5319c56f201804$export$433b924dc2506913),
        isAutoGenerated: isAutoGenerated
    };
    (0, $8f25b96ab0d4f5eb$export$e179dd88ba706b74)(node, tree, treeDepths, null);
    if (!isAutoGenerated) {
        dataRowIdToModelLookup[rowId] = rowModel;
        dataRowIdToIdLookup[rowId] = rowId;
    }
    // Do not push it to ids list so that pagination is not affected by pinned rows
    apiRef.current.caches.rows.dataRowIdToModelLookup[rowId] = (0, $erOpW.default)({}, rowModel);
    apiRef.current.caches.rows.dataRowIdToIdLookup[rowId] = rowId;
    const previousPinnedRows = ((_groupingParams$addit = groupingParams.additionalRowGroups) == null ? void 0 : _groupingParams$addit.pinnedRows) || {};
    const newPinnedRow = {
        id: rowId,
        model: rowModel
    };
    if ((_groupingParams$addit2 = groupingParams.additionalRowGroups) != null && (_groupingParams$addit2 = _groupingParams$addit2.pinnedRows) != null && (_groupingParams$addit2 = _groupingParams$addit2[position]) != null && _groupingParams$addit2.includes(newPinnedRow)) return (0, $erOpW.default)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths
    });
    return (0, $erOpW.default)({}, groupingParams, {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        tree: tree,
        treeDepths: treeDepths,
        additionalRowGroups: (0, $erOpW.default)({}, groupingParams.additionalRowGroups, {
            pinnedRows: (0, $erOpW.default)({}, previousPinnedRows, {
                [position]: [
                    ...previousPinnedRows[position] || [],
                    newPinnedRow
                ]
            })
        })
    });
}
const $905aa937af39b680$export$e392353a5909a7ad = (apiRef)=>{
    const addPinnedRows = $jSIPP.useCallback((groupingParams)=>{
        var _pinnedRowsCache$topI, _pinnedRowsCache$bott, _pinnedRowsCache$bott2, _pinnedRowsCache$topI2;
        const pinnedRowsCache = apiRef.current.caches.pinnedRows || {};
        let newGroupingParams = (0, $erOpW.default)({}, groupingParams, {
            additionalRowGroups: (0, $erOpW.default)({}, groupingParams.additionalRowGroups, {
                // reset pinned rows state
                pinnedRows: {}
            })
        });
        (_pinnedRowsCache$topI = pinnedRowsCache.topIds) == null || _pinnedRowsCache$topI.forEach((rowId)=>{
            newGroupingParams = $905aa937af39b680$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'top',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        (_pinnedRowsCache$bott = pinnedRowsCache.bottomIds) == null || _pinnedRowsCache$bott.forEach((rowId)=>{
            newGroupingParams = $905aa937af39b680$export$a9980a60d1e4cd4d({
                groupingParams: newGroupingParams,
                rowModel: pinnedRowsCache.idLookup[rowId],
                rowId: rowId,
                position: 'bottom',
                apiRef: apiRef,
                isAutoGenerated: false
            });
        });
        // If row with the same `id` is present both in `rows` and `pinnedRows` - remove it from the root group children
        if ((_pinnedRowsCache$bott2 = pinnedRowsCache.bottomIds) != null && _pinnedRowsCache$bott2.length || (_pinnedRowsCache$topI2 = pinnedRowsCache.topIds) != null && _pinnedRowsCache$topI2.length) {
            const shouldKeepRow = (rowId)=>{
                if (newGroupingParams.tree[rowId] && newGroupingParams.tree[rowId].type === 'pinnedRow') return false;
                return true;
            };
            const rootGroupNode = newGroupingParams.tree[0, $db5319c56f201804$export$433b924dc2506913];
            newGroupingParams.tree[0, $db5319c56f201804$export$433b924dc2506913] = (0, $erOpW.default)({}, rootGroupNode, {
                children: rootGroupNode.children.filter(shouldKeepRow)
            });
            newGroupingParams.dataRowIds = newGroupingParams.dataRowIds.filter(shouldKeepRow);
        }
        return newGroupingParams;
    }, [
        apiRef
    ]);
    (0, $e51f1635c25cd339$export$faa98381ad228894)(apiRef, 'hydrateRows', addPinnedRows);
};


const $481a63844d1a5bd7$export$ae01925210967ff3 = (inputApiRef, props)=>{
    const apiRef = (0, $1780d7784e2d3c29$export$b77462c86b28bbf0)(inputApiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $a1d024b4a843f9a5$export$fa1d7b0897c018ea)(apiRef, props);
    (0, $87eaf36fe36b6fe8$export$55f18eb0ec5c02d1)(apiRef, props);
    (0, $3292e0876a083190$export$7e966b04a1d3262a)(apiRef, props);
    (0, $f7608e7f0ef01977$export$220f673c81926201)(apiRef, props);
    (0, $905aa937af39b680$export$e392353a5909a7ad)(apiRef);
    (0, $ea58a0d9dacdfbb2$export$77f589f94558bf61)(apiRef, props);
    // The column pinning `hydrateColumns` pre-processor must be after every other `hydrateColumns` pre-processors
    // Because it changes the order of the columns.
    (0, $f19311b5b4922e59$export$47a2167ef2ac089d)(apiRef, props);
    (0, $d54ed841d5f0e163$export$cc1daa683bbe5702)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $a69c7ce47da1b745$export$e29505bd53a069c8), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $39e47e9472ec3deb$export$73be1d69367eeb5b), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $84c1234e78e25e9b$export$c6a1049ecc0f594c), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $95bb03c14b694038$export$5fee0234a63f3519), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $855696b52d6fd9a6$export$8dcda879a58a8f96), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $8cca0fdca50506d7$export$68e0b9853cc25422), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $63ca51c1e6fc3c9e$export$1a6bb5bb341eadaa), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $3e86fc7ff36adb8a$export$1094a2c822d71ffd), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $f54188e4704fd08b$export$bfde38b067fac467), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $1c843e5e3d1c494d$export$996e35c2eef351ae), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $e8c65f8ab2f20672$export$a9f45f767b8ade48), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $473168580e74bff4$export$a3e5a984fe72a5db), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $4ba453ecad7efc86$export$d6d71dbaaa6fec72), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $f6681066264e6e88$export$c111e737ab642862), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $cdec10ca5a75a5a9$export$ac6ed2ccd52f643f), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $fe5aad41f2d2873c$export$951a05deca7e869f), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $48f0a363a6ecf2a5$export$4224c70cd0329965), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $a2c680012da94ced$export$8574ffe06bf26347), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $fef4d614ea2b6749$export$21c841dc431b3cd0), apiRef, props);
    (0, $11e04fa43048a7f9$export$f9587d613f2caeec)((0, $8c1add1acba927d3$export$42963ad70bb69f54), apiRef, props);
    (0, $a69c7ce47da1b745$export$8ee3ddc1b48b5da9)(apiRef, props);
    (0, $bf54bfb79ee145b1$export$15cdd24474e74350)(apiRef);
    (0, $6f5781c721454283$export$142b8bb1fe6da473)(apiRef, props);
    (0, $39e47e9472ec3deb$export$3e2b6b991d9d83f0)(apiRef, props);
    (0, $95bb03c14b694038$export$2534ab700dd48c29)(apiRef, props);
    (0, $8cca0fdca50506d7$export$d37ff411a3231397)(apiRef, props);
    (0, $855696b52d6fd9a6$export$fe9b9b8b4620abff)(apiRef, props);
    (0, $63ca51c1e6fc3c9e$export$dd1a4469bbd9394e)(apiRef, props);
    (0, $d72289442a7b7d9e$export$d5da41ef394db9ef)(apiRef, props);
    (0, $84c1234e78e25e9b$export$b71d7525fdd57704)(apiRef, props);
    (0, $28c92264bb2fc8fe$export$ce7ce4871097b52e)(apiRef);
    (0, $fef4d614ea2b6749$export$510984a37e2e33f3)(apiRef, props);
    (0, $3e86fc7ff36adb8a$export$3a0db16b152b4c54)(apiRef, props);
    (0, $f54188e4704fd08b$export$8b69791fef06a777)(apiRef, props);
    (0, $e8c65f8ab2f20672$export$343dd9a605dbb75b)(apiRef, props);
    (0, $473168580e74bff4$export$42838275cbf666c4)(apiRef, props);
    (0, $1c843e5e3d1c494d$export$951287757eb5d93c)(apiRef, props);
    (0, $4ba453ecad7efc86$export$836c4be63cf7a42d)(apiRef, props);
    (0, $f6681066264e6e88$export$e060c7667a4364d2)(apiRef, props);
    (0, $cdec10ca5a75a5a9$export$6761a7afeb3daa64)(apiRef, props);
    (0, $fe5aad41f2d2873c$export$f1c8f1c02d202e22)(apiRef, props);
    (0, $48f0a363a6ecf2a5$export$8a4468671da3a64f)(apiRef, props);
    (0, $e7f0968e28df8aa9$export$628fe35635cfd286)(apiRef, props);
    (0, $c6cc869fef2f8b95$export$d3441dc29db31b8c)(apiRef, props);
    (0, $5a04cda6c374f8fe$export$ffcbb8895be5a582)(apiRef, props);
    (0, $ff10379c5db0437b$export$c805ba869d6a5)(apiRef, props);
    (0, $a2c680012da94ced$export$1fc2975c9a725449)(apiRef);
    (0, $9e8a68c78a7db132$export$6178dbab26611702)(apiRef, props);
    (0, $320927f1410d6120$export$41205b2521d4edd4)(apiRef, props);
    (0, $d4d64b8f1dc7b188$export$a44b2f69ac6aef73)(apiRef, props);
    (0, $55c6ca5aa8139e95$export$b8364994f9eec67d)(apiRef, props);
    (0, $53925319f95ad051$export$8456f443918812d4)(apiRef, props);
    (0, $0c9ae20818cda34b$export$971de86bde7f86a1)(apiRef);
    (0, $8c1add1acba927d3$export$aa0d6df32cccbd53)(apiRef, props);
    return apiRef;
};



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




var $erOpW = parcelRequire("erOpW");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $jSIPP = parcelRequire("jSIPP");









var $4uaIU = parcelRequire("4uaIU");
function $7c1023a8e1ef0ee3$export$aaeeda42354cd97c(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $8e32833f8e5c03cf$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const pinColumn = $jSIPP.useCallback((side)=>(event)=>{
            apiRef.current.pinColumn(colDef.field, side);
            onClick(event);
        }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    const unpinColumn = (event)=>{
        apiRef.current.unpinColumn(colDef.field);
        onClick(event);
    };
    const pinToLeftMenuItem = /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $47048811c4f4effd$export$6e56be315e15ea9e).left),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuPinLeftIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('pinToLeft')
            })
        ]
    });
    const pinToRightMenuItem = /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
        onClick: pinColumn((0, $47048811c4f4effd$export$6e56be315e15ea9e).right),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuPinRightIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                children: apiRef.current.getLocaleText('pinToRight')
            })
        ]
    });
    if (!colDef) return null;
    const side = apiRef.current.isColumnPinned(colDef.field);
    if (side) {
        const otherSide = side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right ? (0, $47048811c4f4effd$export$6e56be315e15ea9e).left : (0, $47048811c4f4effd$export$6e56be315e15ea9e).right;
        const label = otherSide === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right ? 'pinToRight' : 'pinToLeft';
        const Icon = side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right ? rootProps.slots.columnMenuPinLeftIcon : rootProps.slots.columnMenuPinRightIcon;
        return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                    onClick: pinColumn(otherSide),
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)(Icon, {
                                fontSize: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText(label)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                    onClick: unpinColumn,
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                            children: apiRef.current.getLocaleText('unpin')
                        })
                    ]
                })
            ]
        });
    }
    if (theme.direction === 'rtl') return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            pinToRightMenuItem,
            pinToLeftMenuItem
        ]
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            pinToLeftMenuItem,
            pinToRightMenuItem
        ]
    });
}



var $4uaIU = parcelRequire("4uaIU");
const $b5aa0ca3b20227f4$export$cd6960cce13e3545 = (0, $erOpW.default)({}, (0, $d78018028de6f6fc$export$5983f95fe9d3e659), {
    columnMenuPinningItem: (0, $7c1023a8e1ef0ee3$export$aaeeda42354cd97c)
});
const $b5aa0ca3b20227f4$export$6e9c8ed52623938a = (0, $erOpW.default)({}, (0, $d78018028de6f6fc$export$c107bd4c779cece6), {
    columnMenuPinningItem: {
        displayOrder: 15
    }
});
const $b5aa0ca3b20227f4$export$49bc76a234ac21c2 = /*#__PURE__*/ $jSIPP.forwardRef(function GridProColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d78018028de6f6fc$export$61ffa20907ac4a8e), (0, $erOpW.default)({
        ref: ref
    }, props, {
        defaultSlots: $b5aa0ca3b20227f4$export$cd6960cce13e3545,
        defaultSlotProps: $b5aa0ca3b20227f4$export$6e9c8ed52623938a
    }));
});



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");






var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");




var $i3Yji = parcelRequire("i3Yji");


var $4uaIU = parcelRequire("4uaIU");
const $82da6403da4ed189$var$_excluded = [
    "getColumnsToRender",
    "getRootProps"
];
const $82da6403da4ed189$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $jSIPP.useMemo(()=>{
        const slots = {
            headerFilterRow: [
                'headerFilterRow'
            ]
        };
        return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $82da6403da4ed189$var$GridHeaderFilterRow = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'HeaderFilterRow',
    overridesResolver: (props, styles)=>styles.headerFilterRow
})(()=>({
        display: 'flex'
    }));
const $82da6403da4ed189$var$filterItemsCache = Object.create(null);
const $82da6403da4ed189$export$dd7dbc7d3ee10272 = (props)=>{
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const { headerGroupingMaxDepth: headerGroupingMaxDepth, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const columnHeaderFilterTabIndexState = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$6e4ac1bbcaf7689e));
    const _useGridColumnHeaders = (0, $5948f1bdd78394e1$export$dd7dbc7d3ee10272)((0, $erOpW.default)({}, props, {
        hasOtherElementInTabSequence: hasOtherElementInTabSequence || columnHeaderFilterTabIndexState !== null
    })), { getColumnsToRender: getColumnsToRender, getRootProps: getRootProps } = _useGridColumnHeaders, otherProps = (0, $cMu4A.default)(_useGridColumnHeaders, $82da6403da4ed189$var$_excluded);
    const headerFiltersRef = $jSIPP.useRef(null);
    apiRef.current.register('private', {
        headerFiltersElementRef: headerFiltersRef
    });
    const headerFilterMenuRef = $jSIPP.useRef(null);
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const classes = $82da6403da4ed189$var$useUtilityClasses(rootProps);
    const disableHeaderFiltering = !rootProps.unstable_headerFilters;
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * props.densityFactor);
    const filterModel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$280aedb9454597a5));
    const totalHeaderHeight = (0, $50fcb4d7c433ea68$export$659109c29172602f)(apiRef, rootProps.columnHeaderHeight) + (disableHeaderFiltering ? 0 : headerHeight);
    const columnHeaderFilterFocus = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $196c4c77eabe7b5f$export$ddbc5e79a3870366));
    const getFilterItem = $jSIPP.useCallback((colDef)=>{
        const filterModelItem = filterModel == null ? void 0 : filterModel.items.find((it)=>it.field === colDef.field && it.operator !== 'isAnyOf');
        if (filterModelItem != null) // there's a valid `filterModelItem` for this column
        return filterModelItem;
        const defaultCachedItem = $82da6403da4ed189$var$filterItemsCache[colDef.field];
        if (defaultCachedItem != null) // there's a cached `defaultItem` for this column
        return defaultCachedItem;
        // there's no cached `defaultItem` for this column, let's generate one and cache it
        const defaultItem = (0, $e00f3ba538d93e0d$export$7530149911670467)(colDef);
        $82da6403da4ed189$var$filterItemsCache[colDef.field] = defaultItem;
        return defaultItem;
    }, [
        filterModel
    ]);
    const getColumnFilters = (params, other = {})=>{
        if (disableHeaderFiltering) return null;
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null) return null;
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = columnsToRender;
        const filters = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            var _colDef$filterOperato, _colDef$filterOperato2, _rootProps$slotProps;
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const hasFocus = (columnHeaderFilterFocus == null ? void 0 : columnHeaderFilterFocus.field) === colDef.field;
            const isFirstColumn = columnIndex === 0;
            const tabIndexField = columnHeaderFilterTabIndexState == null ? void 0 : columnHeaderFilterTabIndexState.field;
            const tabIndex = tabIndexField === colDef.field || isFirstColumn && !props.hasOtherElementInTabSequence ? 0 : -1;
            const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
                field: colDef.field,
                colDef: colDef
            }) : colDef.headerClassName;
            // TODO: Support for `isAnyOf` operator
            const filterOperators = (_colDef$filterOperato = (_colDef$filterOperato2 = colDef.filterOperators) == null ? void 0 : _colDef$filterOperato2.filter((operator)=>operator.value !== 'isAnyOf')) != null ? _colDef$filterOperato : [];
            const item = getFilterItem(colDef);
            filters.push(/*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.headerFilterCell, (0, $erOpW.default)({
                colIndex: columnIndex,
                height: headerHeight,
                width: colDef.computedWidth,
                colDef: colDef,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                headerFilterMenuRef: headerFilterMenuRef,
                headerClassName: headerClassName,
                filterOperators: filterOperators,
                "data-field": colDef.field,
                item: item
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.headerFilterCell, other), `${colDef.field}-filter`));
        }
        return /*#__PURE__*/ (0, $4uaIU.jsx)($82da6403da4ed189$var$GridHeaderFilterRow, {
            ref: headerFiltersRef,
            ownerState: rootProps,
            className: classes.headerFilterRow,
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 2,
            children: filters
        });
    };
    const rootStyle = {
        minHeight: totalHeaderHeight,
        maxHeight: totalHeaderHeight,
        lineHeight: `${headerHeight}px`
    };
    return (0, $erOpW.default)({}, otherProps, {
        getColumnFilters: getColumnFilters,
        getRootProps: disableHeaderFiltering ? getRootProps : (other = {})=>(0, $erOpW.default)({
                style: rootStyle
            }, other)
    });
};




var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");





var $4uaIU = parcelRequire("4uaIU");
const $de3bafc2c92045af$var$CLIFF = 1;
const $de3bafc2c92045af$var$SLOP = 1.5;
const $de3bafc2c92045af$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $de3bafc2c92045af$var$GridScrollAreaRawRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['scrollArea--left']}`]: styles['scrollArea--left']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['scrollArea--right']}`]: styles['scrollArea--right']
            },
            styles.scrollArea
        ]
})(()=>({
        position: 'absolute',
        top: 0,
        zIndex: 101,
        width: 20,
        bottom: 0,
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['scrollArea--left']}`]: {
            left: 0
        },
        [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['scrollArea--right']}`]: {
            right: 0
        }
    }));
function $de3bafc2c92045af$var$GridScrollAreaRaw(props) {
    const { scrollDirection: scrollDirection } = props;
    const rootRef = $jSIPP.useRef(null);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const timeout = (0, $700e89e09f25b054$export$d8e6abf214c9ec0f)();
    const [dragging, setDragging] = $jSIPP.useState(false);
    const [canScrollMore, setCanScrollMore] = $jSIPP.useState(true);
    const densityFactor = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$c646201fb1d3e7a6));
    const columnsTotalWidth = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$ab20f9d33edc7794));
    const scrollPosition = $jSIPP.useRef({
        left: 0,
        top: 0
    });
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $de3bafc2c92045af$var$useUtilityClasses(ownerState);
    const totalHeaderHeight = (0, $50fcb4d7c433ea68$export$659109c29172602f)(apiRef, rootProps.columnHeaderHeight);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const handleScrolling = $jSIPP.useCallback((newScrollPosition)=>{
        scrollPosition.current = newScrollPosition;
        const dimensions = apiRef.current.getRootDimensions();
        setCanScrollMore(()=>{
            if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
            return scrollPosition.current.left > 0;
            if (scrollDirection === 'right') {
                // Only render if the user has not reached yet the end of the list
                const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
                return scrollPosition.current.left < maxScrollLeft;
            }
            return false;
        });
    }, [
        apiRef,
        columnsTotalWidth,
        scrollDirection
    ]);
    const handleDragOver = $jSIPP.useCallback((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI: Wrong drag direction');
        offset = (offset - $de3bafc2c92045af$var$CLIFF) * $de3bafc2c92045af$var$SLOP + $de3bafc2c92045af$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    }, [
        scrollDirection,
        apiRef,
        timeout
    ]);
    const handleColumnHeaderDragStart = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        setDragging(true);
    });
    const handleColumnHeaderDragEnd = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        setDragging(false);
    });
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'scrollPositionChange', handleScrolling);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragStart', handleColumnHeaderDragStart);
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'columnHeaderDragEnd', handleColumnHeaderDragEnd);
    if (!dragging || !canScrollMore) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($de3bafc2c92045af$var$GridScrollAreaRawRoot, {
        ref: rootRef,
        className: (0, $86B3v.default)(classes.root),
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: {
            height: headerHeight,
            top: totalHeaderHeight - headerHeight
        }
    });
}
const $de3bafc2c92045af$export$40bcbdb719b20690 = /*#__PURE__*/ $jSIPP.memo($de3bafc2c92045af$var$GridScrollAreaRaw);



var $4uaIU = parcelRequire("4uaIU");
const $0a7f4d2ee0db0de4$var$_excluded = [
    "style",
    "className",
    "innerRef",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnPositions",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "densityFactor",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence",
    "pinnedColumns"
];
const $0a7f4d2ee0db0de4$var$useUtilityClasses = (ownerState)=>{
    const { leftPinnedColumns: leftPinnedColumns, rightPinnedColumns: rightPinnedColumns, classes: classes } = ownerState;
    const slots = {
        leftPinnedColumns: [
            'pinnedColumnHeaders',
            leftPinnedColumns && leftPinnedColumns.length > 0 && `pinnedColumnHeaders--left`
        ],
        rightPinnedColumns: [
            'pinnedColumnHeaders',
            rightPinnedColumns && rightPinnedColumns.length > 0 && `pinnedColumnHeaders--right`,
            'withBorderColor'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $0a7f4d2ee0db0de4$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return alphaValue / 100;
};
const $0a7f4d2ee0db0de4$var$GridColumnHeadersPinnedColumnHeaders = (0, $28RyA.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PinnedColumnHeaders',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedColumnHeaders--left']}`]: styles['pinnedColumnHeaders--left']
            },
            {
                [`&.${(0, $4d97f950d65e57e8$export$2100d54e36406477)['pinnedColumnHeaders--right']}`]: styles['pinnedColumnHeaders--right']
            },
            styles.pinnedColumnHeaders
        ]
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $erOpW.default)({
        position: 'absolute',
        top: 0,
        overflow: 'hidden',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: theme.shadows[2],
        backgroundColor: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[2]
    } : (0, $erOpW.default)({}, theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)('#fff', $0a7f4d2ee0db0de4$var$getOverlayAlpha(2))}, ${(0, $d8a747b22caa35d8$export$58f0f39f63f3cf42)('#fff', $0a7f4d2ee0db0de4$var$getOverlayAlpha(2))})`
    }), ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).left && {
        left: 0
    }, ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right && {
        right: 0
    }, ownerState.side === (0, $47048811c4f4effd$export$6e56be315e15ea9e).right && ownerState.showCellVerticalBorder && {
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid'
    });
});
$0a7f4d2ee0db0de4$var$GridColumnHeadersPinnedColumnHeaders.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object.isRequired
};
const $0a7f4d2ee0db0de4$export$4a3a74c44d0a6c04 = /*#__PURE__*/ $jSIPP.forwardRef(function GridColumnHeaders(props, ref) {
    const { className: className, innerRef: innerRef, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnPositions: columnPositions, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, densityFactor: densityFactor, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence, pinnedColumns: pinnedColumns } = props, other = (0, $cMu4A.default)(props, $0a7f4d2ee0db0de4$var$_excluded);
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $8e32833f8e5c03cf$export$2d14edd3a7db3bbf)();
    const [scrollbarSize, setScrollbarSize] = $jSIPP.useState(0);
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const handleContentSizeChange = (0, $55503225f0104895$export$2e2bcd8739ae039)(()=>{
        const rootDimensions = apiRef.current.getRootDimensions();
        if (!rootDimensions) return;
        const newScrollbarSize = rootDimensions.hasScrollY ? rootDimensions.scrollBarSize : 0;
        if (scrollbarSize !== newScrollbarSize) setScrollbarSize(newScrollbarSize);
    });
    (0, $51ad73708acc0b23$export$223e28bfc0254c87)(apiRef, 'virtualScrollerContentSizeChange', handleContentSizeChange);
    const visibleColumnFields = $jSIPP.useMemo(()=>visibleColumns.map(({ field: field })=>field), [
        visibleColumns
    ]);
    const [leftPinnedColumns, rightPinnedColumns] = (0, $f133eb3b0e20e388$export$d65e188677517fa1)(pinnedColumns, visibleColumnFields, theme.direction === 'rtl');
    const { isDragging: isDragging, renderContext: renderContext, getRootProps: getRootProps, getInnerProps: getInnerProps, getColumnHeaders: getColumnHeaders, getColumnFilters: getColumnFilters, getColumnGroupHeaders: getColumnGroupHeaders } = (0, $82da6403da4ed189$export$dd7dbc7d3ee10272)({
        innerRef: innerRef,
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnPositions: columnPositions,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        densityFactor: densityFactor,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        minColumnIndex: leftPinnedColumns.length
    });
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        leftPinnedColumns: leftPinnedColumns,
        rightPinnedColumns: rightPinnedColumns,
        classes: rootProps.classes
    });
    const classes = $0a7f4d2ee0db0de4$var$useUtilityClasses(ownerState);
    const leftRenderContext = renderContext && leftPinnedColumns.length ? (0, $erOpW.default)({}, renderContext, {
        firstColumnIndex: 0,
        lastColumnIndex: leftPinnedColumns.length
    }) : null;
    const rightRenderContext = renderContext && rightPinnedColumns.length ? (0, $erOpW.default)({}, renderContext, {
        firstColumnIndex: visibleColumnFields.length - rightPinnedColumns.length,
        lastColumnIndex: visibleColumnFields.length
    }) : null;
    const innerProps = getInnerProps();
    const pinnedColumnHeadersProps = {
        role: innerProps.role
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $9642245410606af3$export$de91f7b8bf842ed8), (0, $erOpW.default)({
        ref: ref,
        className: className
    }, getRootProps(other), {
        children: [
            leftRenderContext && /*#__PURE__*/ (0, $4uaIU.jsxs)($0a7f4d2ee0db0de4$var$GridColumnHeadersPinnedColumnHeaders, (0, $erOpW.default)({
                className: classes.leftPinnedColumns,
                ownerState: (0, $erOpW.default)({}, ownerState, {
                    side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).left,
                    showCellVerticalBorder: rootProps.showCellVerticalBorder
                })
            }, pinnedColumnHeadersProps, {
                children: [
                    getColumnGroupHeaders({
                        renderContext: leftRenderContext,
                        minFirstColumn: leftRenderContext.firstColumnIndex,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }),
                    getColumnHeaders({
                        renderContext: leftRenderContext,
                        minFirstColumn: leftRenderContext.firstColumnIndex,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }, {
                        disableReorder: true
                    }),
                    getColumnFilters({
                        renderContext: leftRenderContext,
                        minFirstColumn: leftRenderContext.firstColumnIndex,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    })
                ]
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $de3bafc2c92045af$export$40bcbdb719b20690), {
                scrollDirection: "left"
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $3490be9d7d9c6ad3$export$b3c0512acbf05cb7), (0, $erOpW.default)({
                isDragging: isDragging
            }, innerProps, {
                children: [
                    getColumnGroupHeaders({
                        renderContext: renderContext,
                        minFirstColumn: leftPinnedColumns.length,
                        maxLastColumn: visibleColumnFields.length - rightPinnedColumns.length
                    }),
                    getColumnHeaders({
                        renderContext: renderContext,
                        minFirstColumn: leftPinnedColumns.length,
                        maxLastColumn: visibleColumnFields.length - rightPinnedColumns.length
                    }),
                    getColumnFilters({
                        renderContext: renderContext,
                        minFirstColumn: leftPinnedColumns.length,
                        maxLastColumn: visibleColumnFields.length - rightPinnedColumns.length
                    })
                ]
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $de3bafc2c92045af$export$40bcbdb719b20690), {
                scrollDirection: "right"
            }),
            rightRenderContext && /*#__PURE__*/ (0, $4uaIU.jsxs)($0a7f4d2ee0db0de4$var$GridColumnHeadersPinnedColumnHeaders, (0, $erOpW.default)({
                ownerState: (0, $erOpW.default)({}, ownerState, {
                    side: (0, $47048811c4f4effd$export$6e56be315e15ea9e).right,
                    showCellVerticalBorder: rootProps.showCellVerticalBorder
                }),
                className: classes.rightPinnedColumns,
                style: {
                    paddingRight: scrollbarSize
                }
            }, pinnedColumnHeadersProps, {
                children: [
                    getColumnGroupHeaders({
                        renderContext: rightRenderContext,
                        minFirstColumn: rightRenderContext.firstColumnIndex,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }),
                    getColumnHeaders({
                        renderContext: rightRenderContext,
                        minFirstColumn: rightRenderContext.firstColumnIndex,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }, {
                        disableReorder: true,
                        separatorSide: (0, $2cfd347288bf55bd$export$71ed79b4ccf06d60).Left
                    }),
                    getColumnFilters({
                        renderContext: rightRenderContext,
                        minFirstColumn: rightRenderContext.firstColumnIndex,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    })
                ]
            }))
        ]
    }));
});



var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");




var $61i5U = parcelRequire("61i5U");


var $4uaIU = parcelRequire("4uaIU");
function $0b0ad4483ae4c5b4$export$5d70bc2c3a60b060({ open: open, field: field, target: target, applyFilterChanges: applyFilterChanges, operators: operators, item: item, id: id, labelledBy: labelledBy }) {
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const hideMenu = $jSIPP.useCallback(()=>{
        apiRef.current.hideHeaderFilterMenu();
    }, [
        apiRef
    ]);
    const handleListKeyDown = $jSIPP.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if (event.key === 'Escape' || event.key === 'Tab') hideMenu();
    }, [
        hideMenu
    ]);
    if (!target) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $67217aef89f147e8$export$237948c71948075), {
        placement: "bottom-end",
        open: open,
        target: target,
        onClose: hideMenu,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039), {
            "aria-labelledby": labelledBy,
            id: id,
            onKeyDown: handleListKeyDown,
            children: operators.map((op, i)=>{
                var _op$headerLabel;
                const label = (_op$headerLabel = op == null ? void 0 : op.headerLabel) != null ? _op$headerLabel : apiRef.current.getLocaleText(`headerFilterOperator${(0, $61i5U.default)(op.value)}`);
                return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        applyFilterChanges((0, $erOpW.default)({}, item, {
                            operator: op.value
                        }));
                        hideMenu();
                    },
                    autoFocus: i === 0 ? open : false,
                    selected: op.value === item.operator,
                    children: label
                }, `${field}-${op.value}`);
            })
        })
    });
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");




var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");






var $4uaIU = parcelRequire("4uaIU");
const $54e4b4e8a5f28217$var$_excluded = [
    "operators",
    "item",
    "field",
    "buttonRef",
    "headerFilterMenuRef"
];
const $54e4b4e8a5f28217$var$sx = {
    width: 22,
    height: 22,
    margin: 'auto 0 10px 5px'
};
function $54e4b4e8a5f28217$export$9b7bd6eff38238f5(props) {
    var _rootProps$slotProps;
    const { operators: operators, item: item, field: field, buttonRef: buttonRef, headerFilterMenuRef: headerFilterMenuRef } = props, others = (0, $cMu4A.default)(props, $54e4b4e8a5f28217$var$_excluded);
    const buttonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const menuId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const open = Boolean((0, $8d80117254c81c02$export$1080dcf0065c0872)(apiRef) === field && headerFilterMenuRef.current);
    const handleClick = (event)=>{
        headerFilterMenuRef.current = event.currentTarget;
        apiRef.current.showHeaderFilterMenu(field);
    };
    if (!rootProps.slots.headerFilterMenu) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                id: buttonId,
                ref: buttonRef,
                "aria-label": apiRef.current.getLocaleText('filterPanelOperator'),
                title: apiRef.current.getLocaleText('filterPanelOperator'),
                "aria-controls": menuId,
                "aria-expanded": open ? 'true' : undefined,
                "aria-haspopup": "true",
                tabIndex: -1,
                size: "small",
                onClick: handleClick,
                sx: $54e4b4e8a5f28217$var$sx
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.openFilterButtonIcon, {
                    fontSize: "small"
                })
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.headerFilterMenu, (0, $erOpW.default)({
                field: field,
                open: open,
                item: item,
                target: headerFilterMenuRef.current,
                operators: operators,
                labelledBy: buttonId,
                id: menuId
            }, others))
        ]
    });
}



var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");


var $4uaIU = parcelRequire("4uaIU");
const $bdab4526850d16cc$var$sx = {
    padding: '2px'
};
function $bdab4526850d16cc$export$a92783e4bfd82db8({ onClick: onClick }) {
    var _rootProps$slotProps;
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
        tabIndex: -1,
        "aria-label": "Clear filter",
        size: "small",
        onClick: onClick,
        sx: $bdab4526850d16cc$var$sx
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnMenuClearIcon, {
            fontSize: "inherit"
        })
    }));
}



var $4uaIU = parcelRequire("4uaIU");
const $4a27c4337137175e$var$_excluded = [
    "colIndex",
    "height",
    "hasFocus",
    "filterOperators",
    "width",
    "headerClassName",
    "colDef",
    "item",
    "headerFilterMenuRef",
    "InputComponentProps",
    "showClearIcon"
];
const $4a27c4337137175e$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, showColumnVerticalBorder: showColumnVerticalBorder } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            'withBorderColor',
            showColumnVerticalBorder && 'columnHeader--withRightBorder'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $4a27c4337137175e$var$dateSx = {
    [`& input[value=""]:not(:focus)`]: {
        color: 'transparent'
    }
};
const $4a27c4337137175e$export$16e397805e5e4138 = /*#__PURE__*/ $jSIPP.forwardRef((props, ref)=>{
    var _filterOperators$find, _currentOperator$head, _colDef$headerName;
    const { colIndex: colIndex, height: height, hasFocus: hasFocus, filterOperators: filterOperators, width: width, headerClassName: headerClassName, colDef: colDef, item: item, headerFilterMenuRef: headerFilterMenuRef, InputComponentProps: InputComponentProps, showClearIcon: showClearIcon = true } = props, other = (0, $cMu4A.default)(props, $4a27c4337137175e$var$_excluded);
    const apiRef = (0, $aeac8d48234fe666$export$e1fd9274eb96ee18)();
    const columnFields = (0, $90c6bb88bfe45f18$export$c9491722e1d6e8d3)(apiRef);
    const rootProps = (0, $6bffe04fce74f5dd$export$8b0f8e71b71b7ed3)();
    const cellRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, cellRef);
    const inputRef = $jSIPP.useRef(null);
    const buttonRef = $jSIPP.useRef(null);
    const isEditing = (0, $8d80117254c81c02$export$84089ff684fa560a)(apiRef) === colDef.field;
    const isMenuOpen = (0, $8d80117254c81c02$export$1080dcf0065c0872)(apiRef) === colDef.field;
    const currentOperator = filterOperators[0];
    const InputComponent = colDef.filterable ? currentOperator.InputComponent : null;
    const applyFilterChanges = $jSIPP.useCallback((updatedItem)=>{
        if (item.value && !updatedItem.value) {
            apiRef.current.deleteFilterItem(updatedItem);
            return;
        }
        apiRef.current.upsertFilterItem(updatedItem);
    }, [
        apiRef,
        item
    ]);
    const clearFilterItem = $jSIPP.useCallback(()=>{
        apiRef.current.deleteFilterItem(item);
    }, [
        apiRef,
        item
    ]);
    let headerFilterComponent;
    if (colDef.renderHeaderFilter) headerFilterComponent = colDef.renderHeaderFilter(props);
    $jSIPP.useLayoutEffect(()=>{
        if (hasFocus && !isMenuOpen) {
            let focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            if (isEditing && InputComponent) focusableElement = inputRef.current;
            const elementToFocus = focusableElement || cellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        InputComponent,
        apiRef,
        hasFocus,
        isEditing,
        isMenuOpen
    ]);
    const onKeyDown = $jSIPP.useCallback((event)=>{
        if (isMenuOpen || (0, $2200ee459e36b6d0$export$e13d96c38a470518)(event.key)) return;
        switch(event.key){
            case 'Escape':
                if (isEditing) apiRef.current.stopHeaderFilterEditMode();
                break;
            case 'Enter':
                if (isEditing) {
                    apiRef.current.stopHeaderFilterEditMode();
                    break;
                }
                if (event.metaKey || event.ctrlKey) {
                    headerFilterMenuRef.current = buttonRef.current;
                    apiRef.current.showHeaderFilterMenu(colDef.field);
                    break;
                }
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
            case 'Tab':
                if (isEditing) {
                    var _columnFields;
                    const fieldToFocus = (_columnFields = columnFields[colIndex + (event.shiftKey ? -1 : 1)]) != null ? _columnFields : null;
                    if (fieldToFocus) {
                        apiRef.current.startHeaderFilterEditMode(fieldToFocus);
                        apiRef.current.setColumnHeaderFilterFocus(fieldToFocus, event);
                    }
                }
                break;
            default:
                if (isEditing || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) break;
                apiRef.current.startHeaderFilterEditMode(colDef.field);
                break;
        }
    }, [
        apiRef,
        colDef.field,
        colIndex,
        columnFields,
        headerFilterMenuRef,
        isEditing,
        isMenuOpen
    ]);
    const publish = $jSIPP.useCallback((eventName, propHandler)=>(event)=>{
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        colDef.field
    ]);
    const onMouseDown = $jSIPP.useCallback((event)=>{
        if (!hasFocus) {
            if (inputRef.current && inputRef.current.contains(event.target)) inputRef.current.focus();
            apiRef.current.setColumnHeaderFilterFocus(colDef.field, event);
        }
    }, [
        apiRef,
        colDef.field,
        hasFocus
    ]);
    const mouseEventsHandlers = $jSIPP.useMemo(()=>({
            onKeyDown: publish('headerFilterKeyDown', onKeyDown),
            onClick: publish('headerFilterClick'),
            onMouseDown: publish('headerFilterMouseDown', onMouseDown),
            onBlur: publish('headerFilterBlur')
        }), [
        onMouseDown,
        onKeyDown,
        publish
    ]);
    const ownerState = (0, $erOpW.default)({}, rootProps, {
        colDef: colDef
    });
    const classes = $4a27c4337137175e$var$useUtilityClasses(ownerState);
    const isNoInputOperator = (filterOperators == null || (_filterOperators$find = filterOperators.find(({ value: value })=>item.operator === value)) == null ? void 0 : _filterOperators$find.requiresFilterValue) === false;
    const isApplied = Boolean(item == null ? void 0 : item.value) || isNoInputOperator;
    const label = (_currentOperator$head = currentOperator.headerLabel) != null ? _currentOperator$head : apiRef.current.getLocaleText(`headerFilterOperator${(0, $61i5U.default)(item.operator)}`);
    const isFilterActive = isApplied || hasFocus;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, headerClassName),
        ref: handleRef,
        style: {
            height: height,
            width: width,
            minWidth: width,
            maxWidth: width
        },
        role: "columnheader",
        "aria-colindex": colIndex + 1,
        "aria-label": headerFilterComponent == null ? (_colDef$headerName = colDef.headerName) != null ? _colDef$headerName : colDef.field : undefined
    }, other, mouseEventsHandlers, {
        children: [
            headerFilterComponent,
            InputComponent && headerFilterComponent === undefined ? /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)(InputComponent, (0, $erOpW.default)({
                        apiRef: apiRef,
                        item: item,
                        inputRef: inputRef,
                        applyValue: applyFilterChanges,
                        onFocus: ()=>apiRef.current.startHeaderFilterEditMode(colDef.field),
                        onBlur: (event)=>{
                            var _event$relatedTarget;
                            apiRef.current.stopHeaderFilterEditMode();
                            // Blurring an input element should reset focus state only if `relatedTarget` is not the header filter cell
                            if (!((_event$relatedTarget = event.relatedTarget) != null && _event$relatedTarget.className.includes('columnHeader'))) apiRef.current.setState((state)=>(0, $erOpW.default)({}, state, {
                                    focus: {
                                        cell: null,
                                        columnHeader: null,
                                        columnHeaderFilter: null,
                                        columnGroupHeader: null
                                    }
                                }));
                        },
                        label: (0, $61i5U.default)(label),
                        placeholder: "",
                        isFilterActive: isFilterActive,
                        clearButton: showClearIcon && isApplied ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bdab4526850d16cc$export$a92783e4bfd82db8), {
                            onClick: clearFilterItem
                        }) : null,
                        disabled: isNoInputOperator,
                        tabIndex: -1,
                        InputLabelProps: null,
                        sx: colDef.type === 'date' || colDef.type === 'dateTime' ? $4a27c4337137175e$var$dateSx : undefined
                    }, isNoInputOperator ? {
                        value: ''
                    } : {}, currentOperator == null ? void 0 : currentOperator.InputComponentProps, InputComponentProps)),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $54e4b4e8a5f28217$export$9b7bd6eff38238f5), {
                        operators: filterOperators,
                        item: item,
                        field: colDef.field,
                        applyFilterChanges: applyFilterChanges,
                        headerFilterMenuRef: headerFilterMenuRef,
                        buttonRef: buttonRef
                    })
                ]
            }) : null
        ]
    }));
});



var $erOpW = parcelRequire("erOpW");
parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
const $9564e383fd72d779$export$8bcde6e7c950b7bb = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("g", {
    transform: "rotate(-30 15 10)",
    children: /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), 'PushPinRight');
const $9564e383fd72d779$export$934f0393007cf804 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("g", {
    transform: "rotate(30 8 12)",
    children: /*#__PURE__*/ (0, $4uaIU.jsx)("path", {
        d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
        fillRule: "evenodd"
    })
}), 'PushPinLeft');


const $ced8de45d2dfa7a8$var$iconSlots = {
    ColumnMenuPinRightIcon: (0, $9564e383fd72d779$export$8bcde6e7c950b7bb),
    ColumnMenuPinLeftIcon: (0, $9564e383fd72d779$export$934f0393007cf804)
};
const $ced8de45d2dfa7a8$var$materialSlots = (0, $erOpW.default)({}, $ced8de45d2dfa7a8$var$iconSlots);
var $ced8de45d2dfa7a8$export$2e2bcd8739ae039 = $ced8de45d2dfa7a8$var$materialSlots;


const $cdc86b00a864f8c0$export$c14e35b3658b0aa7 = (0, $erOpW.default)({}, (0, $7b061512a793888c$export$8a57bda01657743f), (0, $ced8de45d2dfa7a8$export$2e2bcd8739ae039), {
    ColumnMenu: (0, $b5aa0ca3b20227f4$export$49bc76a234ac21c2),
    ColumnHeaders: (0, $0a7f4d2ee0db0de4$export$4a3a74c44d0a6c04),
    HeaderFilterCell: (0, $4a27c4337137175e$export$16e397805e5e4138),
    HeaderFilterMenu: (0, $0b0ad4483ae4c5b4$export$5d70bc2c3a60b060)
});


const $2857bc03173bda94$export$ebb4682394199754 = (0, $erOpW.default)({}, (0, $da07bdb0211ca176$export$2733e0e1a1d288e7), {
    scrollEndThreshold: 80,
    treeData: false,
    defaultGroupingExpansionDepth: 0,
    autosizeOnMount: false,
    disableAutosize: false,
    disableColumnPinning: false,
    keepColumnPositionIfDraggedOutside: false,
    disableChildrenFiltering: false,
    disableChildrenSorting: false,
    rowReordering: false,
    rowsLoadingMode: 'client',
    getDetailPanelHeight: ()=>500,
    unstable_headerFilters: false
});
const $2857bc03173bda94$var$defaultSlots = (0, $3cca6a4880116aa6$export$ee17bc394843b249)((0, $cdc86b00a864f8c0$export$c14e35b3658b0aa7));
const $2857bc03173bda94$export$decfffa8129564f4 = (inProps)=>{
    const [components, componentsProps, themedProps] = (0, $a95e5a8118b0b80b$export$1f264be2c424fccf)((0, $a116d4defba36cdd$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDataGrid'
    }));
    const localeText = $jSIPP.useMemo(()=>(0, $erOpW.default)({}, (0, $aca9760671f55e3a$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $jSIPP.useMemo(()=>(0, $dfef57d122bddda3$export$247af54f7c54fca)({
            defaultSlots: $2857bc03173bda94$var$defaultSlots,
            slots: themedProps.slots,
            components: components
        }), [
        components,
        themedProps.slots
    ]);
    return $jSIPP.useMemo(()=>{
        var _themedProps$slotProp;
        return (0, $erOpW.default)({}, $2857bc03173bda94$export$ebb4682394199754, themedProps, {
            localeText: localeText,
            slots: slots,
            slotProps: (_themedProps$slotProp = themedProps.slotProps) != null ? _themedProps$slotProp : componentsProps,
            signature: 'DataGridPro'
        });
    }, [
        themedProps,
        localeText,
        slots,
        componentsProps
    ]);
};




const $a1b2bb9c65ea8e61$export$edcd7d0b4c3818f = ()=>{
    const releaseInfo = "MTcwMjQ5NDAwMDAwMA==";
    return releaseInfo;
};




var $4uaIU = parcelRequire("4uaIU");
const $d0acaa943fee3c99$var$releaseInfo = (0, $a1b2bb9c65ea8e61$export$edcd7d0b4c3818f)();
const $d0acaa943fee3c99$var$DataGridProRaw = /*#__PURE__*/ $jSIPP.forwardRef(function DataGridPro(inProps, ref) {
    const props = (0, $2857bc03173bda94$export$decfffa8129564f4)(inProps);
    const privateApiRef = (0, $481a63844d1a5bd7$export$ae01925210967ff3)(props.apiRef, props);
    (0, $f03b582a784d53b6$export$bd780281ba7bfd9)('x-data-grid-pro', $d0acaa943fee3c99$var$releaseInfo);
    const pinnedColumns = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(privateApiRef, (0, $a75735833c020888$export$1eea0bd4db853467));
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $60d2b150beada1be$export$4fd26c08a15cabb4), {
        privateApiRef: privateApiRef,
        props: props,
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $65e12aad905f864d$export$8cdbcd3b320d39bf), (0, $erOpW.default)({
            className: props.className,
            style: props.style,
            sx: props.sx,
            ref: ref
        }, props.forwardedProps, {
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $df0d976711ba23f2$export$74ac40502a3200d3), {}),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $aa2a07ba1ec68c30$export$d79f740c0338b156), {
                    VirtualScrollerComponent: (0, $f133eb3b0e20e388$export$6ec28431e2afa72),
                    ColumnHeadersProps: {
                        pinnedColumns: pinnedColumns
                    },
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $631869056872638e$export$e94943a72132ebdf), {
                        packageName: "x-data-grid-pro",
                        releaseInfo: $d0acaa943fee3c99$var$releaseInfo
                    })
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $96f637e3dcb55f7b$export$6d80c98441abb3ab), {})
            ]
        }))
    });
});
const $d0acaa943fee3c99$export$97fd8aadf70de81f = /*#__PURE__*/ $jSIPP.memo($d0acaa943fee3c99$var$DataGridProRaw);
$d0acaa943fee3c99$var$DataGridProRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object.isRequired
    }),
    /**
   * The label of the grid.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    /**
   * The id of the element containing a label for the grid.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    /**
   * If `true`, the grid height is dynamic and follow the number of rows in the grid.
   * @default false
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string),
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        includeHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        includeOutliers: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        outliersFactor: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * If `true`, the grid get a first column with a checkbox that allows to select rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the "Select All" header checkbox selects only the rows on the current page. To be used in combination with `checkboxSelection`.
   * It only works if the pagination is enabled.
   * @default false
   */ checkboxSelectionVisibleOnly: (0, $0486e26d06bac8e6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool, (props)=>{
        if (!props.pagination && props.checkboxSelectionVisibleOnly) return new Error('MUI: The `checkboxSelectionVisibleOnly` prop has no effect when the pagination is not enabled.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    /**
   * Number of extra columns to be rendered before/after the visible slice.
   * @default 3
   */ columnBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
    /**
   * Sets the height in pixel of the column headers in the grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Set of columns of type [[GridColDef[]]].
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object).isRequired,
    /**
   * Number of rows from the `columnBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ columnThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Set the column visibility model of the grid.
   * If defined, the grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Overridable components.
   * @deprecated Use the `slots` prop instead.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   * @deprecated Use the `slotProps` prop instead.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * If above 0, the row children will be expanded up to this depth.
   * If equal to -1, all the row children will be expanded.
   * @default 0
   */ defaultGroupingExpansionDepth: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Set the density of the grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * The row ids to show the detail panel.
   */ detailPanelExpandedRowIds: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
    ]).isRequired),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the filtering will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the sorting will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */ disableChildrenSorting: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the column pinning is disabled.
   * @default false
   */ disableColumnPinning: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, reordering columns is disabled.
   * @default false
   */ disableColumnReorder: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   * @ignore - do not document
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, filtering with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsFiltering: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, sorting with multiple columns is disabled.
   * @default false
   */ disableMultipleColumnsSorting: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, multiple selection using the Ctrl or CMD key is disabled.
   * @default false
   */ disableMultipleRowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'cell',
        'row'
    ]),
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        ariaV7: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        columnGrouping: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        lazyLoading: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, $0486e26d06bac8e6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'client',
        'server'
    ]), (props)=>{
        if (props.treeData && props.filterMode === 'server') return new Error('MUI: The `filterMode="server"` prop is not available when the `treeData` is enabled.');
        return null;
    }),
    /**
   * Set the filter model of the grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array
    }),
    /**
   * Forwarded props for the grid root element.
   * @ignore - do not document.
   */ forwardedProps: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that returns the height of the row detail panel.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {number | string} The height in pixels or "auto" to use the content height.
   * @default "() => 500"
   */ getDetailPanelHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Determines the path of a row in the tree data.
   * For instance, a row with the path ["A", "B"] is the child of the row with the path ["A"].
   * Note that all paths must contain at least one element.
   * @template R
   * @param {R} row The row from which we want the path.
   * @returns {string[]} The path to the row.
   */ getTreeDataPath: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * The grouping column used by the tree data.
   */ groupingColDef: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object
    ]),
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the row count in the footer is hidden.
   * It has no effect if the pagination is enabled.
   * @default false
   */ hideFooterRowCount: (0, $0486e26d06bac8e6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool, (props)=>{
        if (props.pagination && props.hideFooterRowCount) return new Error('MUI: The `hideFooterRowCount` prop has no effect when the pagination is enabled.');
        return null;
    }),
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * The initial state of the DataGridPro.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Determines if a group should be expanded after its creation.
   * This prop takes priority over the `defaultGroupingExpansionDepth` prop.
   * @param {GridGroupNode} node The node of the group to test.
   * @returns {boolean} A boolean indicating if the group is expanded.
   */ isGroupExpandedByDefault: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * If `true`, moving the mouse pointer outside the grid before releasing the mouse button
   * in a column re-order action will not cause the column to jump back to its original position.
   * @default false
   */ keepColumnPositionIfDraggedOutside: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, a  loading overlay is displayed.
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Set the locale text of the grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/grid/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the detail panel of a row is opened or closed.
   * @param {GridRowId[]} ids The ids of the rows which have the detail panel open.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onDetailPanelExpandedRowIdsChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when rowCount is set and the next batch of virtualized rows is rendered.
   * @param {GridFetchRowsParams} params With all properties from [[GridFetchRowsParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFetchRows: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the pinned columns have changed.
   * @param {GridPinnedColumns} pinnedColumns The changed pinned columns.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPinnedColumnsChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the row changes are committed.
   * @param {GridRowId} id The row id.
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditCommit: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when a row is being reordered.
   * @param {GridRowOrderChangeParams} params With all properties from [[GridRowOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when scrolling to the bottom of the grid viewport.
   * @param {GridRowScrollEndParams} params With all properties from [[GridRowScrollEndParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowsScrollEnd: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Callback fired when the state of the grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number.isRequired
        })
    ]).isRequired),
    /**
   * If `true`, pagination is enabled.
   * @default false
   */ pagination: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number.isRequired
    }),
    /**
   * The column fields to display pinned to left or right.
   */ pinnedColumns: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string)
    }),
    /**
   * Rows data to pin on top or bottom.
   */ pinnedRows: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object)
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    /**
   * Number of extra rows to be rendered before/after the visible slice.
   * @default 3
   */ rowBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Sets the height in pixel of a row in the grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   */ rowPositionsDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * If `true`, the reordering of rows is enabled.
   * @default false
   */ rowReordering: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Set of rows of type [[GridRowsProp]].
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object).isRequired,
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Sets the row selection model of the grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
        ]).isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
    ]),
    /**
   * Loading rows can be processed on the server or client-side.
   * Set it to 'client' if you would like enable infnite loading.
   * Set it to 'server' if you would like to enable lazy loading.
   * * @default "client"
   */ rowsLoadingMode: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'border',
        'margin'
    ]),
    /**
   * Number of rows from the `rowBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ rowThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Override the height/width of the grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * Set the area in `px` at the bottom of the grid viewport where onRowsScrollEnd is called.
   * @default 80
   */ scrollEndThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * If `true`, the vertical borders of the cells are displayed.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOf([
            'asc',
            'desc'
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object
    ]),
    /**
   * If positive, the Grid will throttle updates coming from `apiRef.current.updateRows` and `apiRef.current.setRows`.
   * It can be useful if you have a high update rate but do not want to do heavy work like filtering / sorting or rendering on each  individual update.
   * @default 0
   */ throttleRowsMs: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    /**
   * If `true`, the rows will be gathered in a tree structure according to the `getTreeDataPath` prop.
   * @default false
   */ treeData: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, enables the data grid filtering on header feature.
   * @default false
   */ unstable_headerFilters: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    /**
   * If `true`, the grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ unstable_ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool
    ])
};




var $4uaIU = parcelRequire("4uaIU");

parcelRequire("jSIPP");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $i3Yji = parcelRequire("i3Yji");


var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $9593d3533ec5e2c6$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    $jSIPP.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $55503225f0104895$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $55503225f0104895$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $jSIPP.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $jSIPP.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $jSIPP.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $erOpW.default)({}, (0, $b4a0caeebed92054$export$2e2bcd8739ae039)(parameters), (0, $b4a0caeebed92054$export$2e2bcd8739ae039)(externalProps));
        return (0, $erOpW.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $9593d3533ec5e2c6$export$2e2bcd8739ae039 = $9593d3533ec5e2c6$var$useSnackbar;




var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $iLAKr = parcelRequire("iLAKr");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $ff9781e3352be3ab$export$def81488db1a3216(slot) {
    return (0, $geF11.default)('MuiSnackbarContent', slot);
}
const $ff9781e3352be3ab$var$snackbarContentClasses = (0, $rARwS.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $ff9781e3352be3ab$export$2e2bcd8739ae039 = $ff9781e3352be3ab$var$snackbarContentClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $5d87f1d751f7e206$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $5d87f1d751f7e206$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $ff9781e3352be3ab$export$def81488db1a3216), classes);
};
const $5d87f1d751f7e206$var$SnackbarContentRoot = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $hnF8Y.emphasize)(theme.palette.background.default, emphasis);
    return (0, $erOpW.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $5d87f1d751f7e206$var$SnackbarContentMessage = (0, $28RyA.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $5d87f1d751f7e206$var$SnackbarContentAction = (0, $28RyA.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $5d87f1d751f7e206$var$SnackbarContent = /*#__PURE__*/ $jSIPP.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $cMu4A.default)(props, $5d87f1d751f7e206$var$_excluded);
    const ownerState = props;
    const classes = $5d87f1d751f7e206$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($5d87f1d751f7e206$var$SnackbarContentRoot, (0, $erOpW.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)($5d87f1d751f7e206$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $4uaIU.jsx)($5d87f1d751f7e206$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $5d87f1d751f7e206$export$2e2bcd8739ae039 = $5d87f1d751f7e206$var$SnackbarContent;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $0ecc45c730a05ddb$export$6cb096457f5926f4(slot) {
    return (0, $geF11.default)('MuiSnackbar', slot);
}
const $0ecc45c730a05ddb$var$snackbarClasses = (0, $rARwS.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $0ecc45c730a05ddb$export$2e2bcd8739ae039 = $0ecc45c730a05ddb$var$snackbarClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $14192e9e94f1bc21$var$_excluded = [
    "onEnter",
    "onExited"
], $14192e9e94f1bc21$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $14192e9e94f1bc21$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $iLAKr.default)(anchorOrigin.vertical)}${(0, $iLAKr.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $0ecc45c730a05ddb$export$6cb096457f5926f4), classes);
};
const $14192e9e94f1bc21$var$SnackbarRoot = (0, $28RyA.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $iLAKr.default)(ownerState.anchorOrigin.vertical)}${(0, $iLAKr.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $erOpW.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $erOpW.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $14192e9e94f1bc21$var$Snackbar = /*#__PURE__*/ $jSIPP.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $f0165b03f861203f$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $cMu4A.default)(props.TransitionProps, $14192e9e94f1bc21$var$_excluded), other = (0, $cMu4A.default)(props, $14192e9e94f1bc21$var$_excluded2);
    const ownerState = (0, $erOpW.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $14192e9e94f1bc21$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $9593d3533ec5e2c6$export$2e2bcd8739ae039)((0, $erOpW.default)({}, ownerState));
    const [exited, setExited] = $jSIPP.useState(true);
    const rootProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: $14192e9e94f1bc21$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1f8be5e6d94a1f79$export$58385c17fee43f89), (0, $erOpW.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($14192e9e94f1bc21$var$SnackbarRoot, (0, $erOpW.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5d87f1d751f7e206$export$2e2bcd8739ae039), (0, $erOpW.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $14192e9e94f1bc21$export$2e2bcd8739ae039 = $14192e9e94f1bc21$var$Snackbar;



var $26IBV = parcelRequire("26IBV");
/**
 *
 * @param displayText text to display
 * @param duration count in milliseconds to show error
 * @param open true if popup should be open
 * @param setOpen DEPRECATED sets the boolean (really the onClose should be handling this)
 * @param onClose callback to perform on popup close
 * @returns {JSX.Element}
 * @constructor
 */ const $d61e868d178710ba$var$ErrorPopup = ({ displayText: displayText, duration: duration, open: open, setOpen: setOpen = ()=>{}, onClose: onClose })=>{
    let hideDuration = duration ? duration : 60000;
    const handleClose = ()=>{
        setOpen(false);
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $14192e9e94f1bc21$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        autoHideDuration: hideDuration,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
            onClose: handleClose,
            severity: "error",
            children: displayText
        })
    });
};
$d61e868d178710ba$var$ErrorPopup.propTypes = {
    displayText: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func
};
var $d61e868d178710ba$export$2e2bcd8739ae039 = $d61e868d178710ba$var$ErrorPopup;





var $4uaIU = parcelRequire("4uaIU");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $iLAKr = parcelRequire("iLAKr");




var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $238d81d80787215b$export$2177af0aa15c34c2(slot) {
    return (0, $geF11.default)('MuiDialog', slot);
}
const $238d81d80787215b$var$dialogClasses = (0, $rARwS.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $238d81d80787215b$export$2e2bcd8739ae039 = $238d81d80787215b$var$dialogClasses;



var $jSIPP = parcelRequire("jSIPP");
const $2a5013874eb086c1$var$DialogContext = /*#__PURE__*/ $jSIPP.createContext({});
var $2a5013874eb086c1$export$2e2bcd8739ae039 = $2a5013874eb086c1$var$DialogContext;





var $4uaIU = parcelRequire("4uaIU");
'use client';
const $4eb98f32eaddaa19$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4eb98f32eaddaa19$var$DialogBackdrop = (0, $28RyA.default)((0, $34b1b4b654c83e53$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4eb98f32eaddaa19$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $iLAKr.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $iLAKr.default)(scroll)}`,
            `paperWidth${(0, $iLAKr.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $238d81d80787215b$export$2177af0aa15c34c2), classes);
};
const $4eb98f32eaddaa19$var$DialogRoot = (0, $28RyA.default)((0, $77354a49315afd41$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4eb98f32eaddaa19$var$DialogContainer = (0, $28RyA.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $iLAKr.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $4eb98f32eaddaa19$var$DialogPaper = (0, $28RyA.default)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $iLAKr.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $iLAKr.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $238d81d80787215b$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $238d81d80787215b$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $238d81d80787215b$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4eb98f32eaddaa19$var$Dialog = /*#__PURE__*/ $jSIPP.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $bab57f2e05a2f14d$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cMu4A.default)(props, $4eb98f32eaddaa19$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4eb98f32eaddaa19$var$useUtilityClasses(ownerState);
    const backdropClick = $jSIPP.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $jSIPP.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($4eb98f32eaddaa19$var$DialogRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4eb98f32eaddaa19$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $erOpW.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $4uaIU.jsx)($4eb98f32eaddaa19$var$DialogContainer, {
                className: (0, $86B3v.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)($4eb98f32eaddaa19$var$DialogPaper, (0, $erOpW.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $86B3v.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2a5013874eb086c1$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4eb98f32eaddaa19$export$2e2bcd8739ae039 = $4eb98f32eaddaa19$var$Dialog;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $9cbf54a11bec8ce0$export$5e57a444791c63be(slot) {
    return (0, $geF11.default)('MuiDialogActions', slot);
}
const $9cbf54a11bec8ce0$var$dialogActionsClasses = (0, $rARwS.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $9cbf54a11bec8ce0$export$2e2bcd8739ae039 = $9cbf54a11bec8ce0$var$dialogActionsClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $9e1fc1f07bfe7735$var$_excluded = [
    "className",
    "disableSpacing"
];
const $9e1fc1f07bfe7735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $9cbf54a11bec8ce0$export$5e57a444791c63be), classes);
};
const $9e1fc1f07bfe7735$var$DialogActionsRoot = (0, $28RyA.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $9e1fc1f07bfe7735$var$DialogActions = /*#__PURE__*/ $jSIPP.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $cMu4A.default)(props, $9e1fc1f07bfe7735$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $9e1fc1f07bfe7735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($9e1fc1f07bfe7735$var$DialogActionsRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $9e1fc1f07bfe7735$export$2e2bcd8739ae039 = $9e1fc1f07bfe7735$var$DialogActions;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $babe23812b673038$export$61b0ee1f05fb344e(slot) {
    return (0, $geF11.default)('MuiDialogContent', slot);
}
const $babe23812b673038$var$dialogContentClasses = (0, $rARwS.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $babe23812b673038$export$2e2bcd8739ae039 = $babe23812b673038$var$dialogContentClasses;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $4d389d72652b4f17$export$f5d2ec7e4c47e088(slot) {
    return (0, $geF11.default)('MuiDialogTitle', slot);
}
const $4d389d72652b4f17$var$dialogTitleClasses = (0, $rARwS.default)('MuiDialogTitle', [
    'root'
]);
var $4d389d72652b4f17$export$2e2bcd8739ae039 = $4d389d72652b4f17$var$dialogTitleClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $6f8ada62e319d53e$var$_excluded = [
    "className",
    "dividers"
];
const $6f8ada62e319d53e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $babe23812b673038$export$61b0ee1f05fb344e), classes);
};
const $6f8ada62e319d53e$var$DialogContentRoot = (0, $28RyA.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $4d389d72652b4f17$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $6f8ada62e319d53e$var$DialogContent = /*#__PURE__*/ $jSIPP.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cMu4A.default)(props, $6f8ada62e319d53e$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        dividers: dividers
    });
    const classes = $6f8ada62e319d53e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($6f8ada62e319d53e$var$DialogContentRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6f8ada62e319d53e$export$2e2bcd8739ae039 = $6f8ada62e319d53e$var$DialogContent;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $d5488e110ee569e2$var$_excluded = [
    "className",
    "id"
];
const $d5488e110ee569e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d389d72652b4f17$export$f5d2ec7e4c47e088), classes);
};
const $d5488e110ee569e2$var$DialogTitleRoot = (0, $28RyA.default)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $d5488e110ee569e2$var$DialogTitle = /*#__PURE__*/ $jSIPP.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $cMu4A.default)(props, $d5488e110ee569e2$var$_excluded);
    const ownerState = props;
    const classes = $d5488e110ee569e2$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $jSIPP.useContext((0, $2a5013874eb086c1$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $4uaIU.jsx)($d5488e110ee569e2$var$DialogTitleRoot, (0, $erOpW.default)({
        component: "h2",
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $d5488e110ee569e2$export$2e2bcd8739ae039 = $d5488e110ee569e2$var$DialogTitle;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $668ih = parcelRequire("668ih");

var $4IZqw = parcelRequire("4IZqw");

var $i3Yji = parcelRequire("i3Yji");


var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


var $jSIPP = parcelRequire("jSIPP");
'use client';
/**
 * @ignore - internal component.
 */ const $c9426cb0324351b1$var$GridContext = /*#__PURE__*/ $jSIPP.createContext();
var $c9426cb0324351b1$export$2e2bcd8739ae039 = $c9426cb0324351b1$var$GridContext;



var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $d025be9367e43b48$export$9973ac5fd0181f33(slot) {
    return (0, $geF11.default)('MuiGrid', slot);
}
const $d025be9367e43b48$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $d025be9367e43b48$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $d025be9367e43b48$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $d025be9367e43b48$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $d025be9367e43b48$var$gridClasses = (0, $rARwS.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$d025be9367e43b48$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$d025be9367e43b48$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$d025be9367e43b48$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$d025be9367e43b48$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$d025be9367e43b48$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$d025be9367e43b48$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$d025be9367e43b48$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$d025be9367e43b48$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $d025be9367e43b48$export$2e2bcd8739ae039 = $d025be9367e43b48$var$gridClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $1ce7d9cbbe13e769$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $1ce7d9cbbe13e769$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $1ce7d9cbbe13e769$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $668ih.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$1ce7d9cbbe13e769$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $erOpW.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $1ce7d9cbbe13e769$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $668ih.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $668ih.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $d025be9367e43b48$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $1ce7d9cbbe13e769$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $1ce7d9cbbe13e769$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $668ih.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $1ce7d9cbbe13e769$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $668ih.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$1ce7d9cbbe13e769$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $d025be9367e43b48$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $1ce7d9cbbe13e769$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $d025be9367e43b48$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $1ce7d9cbbe13e769$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $668ih.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $1ce7d9cbbe13e769$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $668ih.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$1ce7d9cbbe13e769$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$1ce7d9cbbe13e769$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $d025be9367e43b48$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $1ce7d9cbbe13e769$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $d025be9367e43b48$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $1ce7d9cbbe13e769$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $1ce7d9cbbe13e769$var$GridRoot = (0, $28RyA.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $1ce7d9cbbe13e769$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $1ce7d9cbbe13e769$export$71d4225eeb1bc13e, $1ce7d9cbbe13e769$export$380604d7c79f9e8f, $1ce7d9cbbe13e769$export$4315fba5128fb4a1, $1ce7d9cbbe13e769$export$ca2a698f6020fda);
function $1ce7d9cbbe13e769$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $1ce7d9cbbe13e769$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $1ce7d9cbbe13e769$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $d025be9367e43b48$export$9973ac5fd0181f33), classes);
};
const $1ce7d9cbbe13e769$var$Grid = /*#__PURE__*/ $jSIPP.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const props = (0, $4IZqw.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $cMu4A.default)(props, $1ce7d9cbbe13e769$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $jSIPP.useContext((0, $c9426cb0324351b1$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $erOpW.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $erOpW.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $1ce7d9cbbe13e769$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c9426cb0324351b1$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($1ce7d9cbbe13e769$var$GridRoot, (0, $erOpW.default)({
            ownerState: ownerState,
            className: (0, $86B3v.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $1ce7d9cbbe13e769$export$2e2bcd8739ae039 = $1ce7d9cbbe13e769$var$Grid;


var $22a85ca48859791a$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($22a85ca48859791a$exports, "__esModule", {
    value: true
});
$22a85ca48859791a$exports.default = void 0;

var $22a85ca48859791a$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $22a85ca48859791a$var$_default = $22a85ca48859791a$exports.default = (0, $22a85ca48859791a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $jSIPP = parcelRequire("jSIPP");




var $jSIPP = parcelRequire("jSIPP");
var $d8f0cc4747dfcf2c$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $d8f0cc4747dfcf2c$var$isFileInput = (element)=>element.type === 'file';
var $d8f0cc4747dfcf2c$var$isDateObject = (value1)=>value1 instanceof Date;
var $d8f0cc4747dfcf2c$var$isNullOrUndefined = (value1)=>value1 == null;
const $d8f0cc4747dfcf2c$var$isObjectType = (value1)=>typeof value1 === 'object';
var $d8f0cc4747dfcf2c$var$isObject = (value1)=>!$d8f0cc4747dfcf2c$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $d8f0cc4747dfcf2c$var$isObjectType(value1) && !$d8f0cc4747dfcf2c$var$isDateObject(value1);
var $d8f0cc4747dfcf2c$var$getEventValue = (event)=>$d8f0cc4747dfcf2c$var$isObject(event) && event.target ? $d8f0cc4747dfcf2c$var$isCheckBoxInput(event.target) ? event.target.checked : $d8f0cc4747dfcf2c$var$isFileInput(event.target) ? event.target.files : event.target.value : event;
const $d8f0cc4747dfcf2c$var$FIELD_PATH_RE = /[.[\]'"]/;
var $d8f0cc4747dfcf2c$var$stringToPath = (input)=>input.split($d8f0cc4747dfcf2c$var$FIELD_PATH_RE).filter(Boolean);
function $d8f0cc4747dfcf2c$var$getNullAncestorValue(control, name) {
    const segments = $d8f0cc4747dfcf2c$var$stringToPath(name);
    let formValues = control._formValues;
    let defaultValues = control._defaultValues;
    for(let i = 0; i < segments.length - 1; i++){
        const key = segments[i];
        formValues = formValues == null ? formValues : formValues[key];
        defaultValues = defaultValues == null ? defaultValues : defaultValues[key];
        if (formValues === null || defaultValues === null) return null;
    }
    return undefined;
}
var $d8f0cc4747dfcf2c$var$isNameInFieldArray = (names, name)=>name.split('.').some((part, index, arr)=>!isNaN(Number(part)) && names.has(arr.slice(0, index).join('.')));
var $d8f0cc4747dfcf2c$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $d8f0cc4747dfcf2c$var$cloneObject(data) {
    if (data === null || typeof data !== 'object') return data;
    if (data instanceof Date) return new Date(data);
    const isBlobInstance = typeof Blob !== 'undefined' && data instanceof Blob;
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if ($d8f0cc4747dfcf2c$var$isWeb && (isBlobInstance || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    const prototype = Object.getPrototypeOf(data);
    if (!isArray && prototype && prototype.constructor !== Object) return data;
    const copy = isArray ? new Array(data.length) : Object.create(prototype);
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = $d8f0cc4747dfcf2c$var$cloneObject(data[key]);
    return copy;
}
const $d8f0cc4747dfcf2c$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
    SUBMIT: 'submit',
    TRIGGER: 'trigger',
    VALID: 'valid'
};
const $d8f0cc4747dfcf2c$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $d8f0cc4747dfcf2c$var$REGISTER_VALIDATION_RULES = [
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.required,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.min,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.max,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.minLength,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.maxLength,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.pattern,
    $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.validate
];
const $d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE = 'form';
const $d8f0cc4747dfcf2c$var$ROOT_ERROR_TYPE = 'root';
const $d8f0cc4747dfcf2c$var$PROTOTYPE_KEYWORDS = [
    '__proto__',
    'constructor',
    'prototype'
];
const $d8f0cc4747dfcf2c$var$IS_KEY_RE = /^\w*$/;
var $d8f0cc4747dfcf2c$var$isKey = (value1)=>$d8f0cc4747dfcf2c$var$IS_KEY_RE.test(value1);
var $d8f0cc4747dfcf2c$var$isUndefined = (val)=>val === undefined;
var $d8f0cc4747dfcf2c$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$d8f0cc4747dfcf2c$var$isObject(object)) return defaultValue;
    const paths = $d8f0cc4747dfcf2c$var$isKey(path) ? [
        path
    ] : $d8f0cc4747dfcf2c$var$stringToPath(path);
    if (paths.some((key)=>$d8f0cc4747dfcf2c$var$PROTOTYPE_KEYWORDS.includes(key))) return defaultValue;
    const result = paths.reduce((result, key)=>{
        return $d8f0cc4747dfcf2c$var$isNullOrUndefined(result) ? undefined : result[key];
    }, object);
    return $d8f0cc4747dfcf2c$var$isUndefined(result) || result === object ? $d8f0cc4747dfcf2c$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $d8f0cc4747dfcf2c$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $d8f0cc4747dfcf2c$var$isFunction = (value1)=>typeof value1 === 'function';
var $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $d8f0cc4747dfcf2c$var$isKey(path) ? [
        path
    ] : $d8f0cc4747dfcf2c$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $d8f0cc4747dfcf2c$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if ($d8f0cc4747dfcf2c$var$PROTOTYPE_KEYWORDS.includes(key)) return;
        object[key] = newValue;
        object = object[key];
    }
};
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const $d8f0cc4747dfcf2c$var$HookFormControlContext = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(null);
$d8f0cc4747dfcf2c$var$HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const $d8f0cc4747dfcf2c$var$useFormControlContext = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext($d8f0cc4747dfcf2c$var$HookFormControlContext);
var $d8f0cc4747dfcf2c$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $d8f0cc4747dfcf2c$var$useIsomorphicLayoutEffect = $d8f0cc4747dfcf2c$var$isWeb ? (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect;
var $d8f0cc4747dfcf2c$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $d8f0cc4747dfcf2c$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $d8f0cc4747dfcf2c$var$isPrimitive = (value1)=>$d8f0cc4747dfcf2c$var$isNullOrUndefined(value1) || !$d8f0cc4747dfcf2c$var$isObjectType(value1);
const $d8f0cc4747dfcf2c$var$isEmptyObjectWithCustomPrototype = (object, keys)=>keys.length === 0 && !Array.isArray(object) && Object.getPrototypeOf(object) !== null && !$d8f0cc4747dfcf2c$var$isPlainObject(object);
function $d8f0cc4747dfcf2c$var$deepEqual(object1, object2, isErrorObject = false, visited = new WeakMap()) {
    if (object1 === object2) return true;
    if ($d8f0cc4747dfcf2c$var$isPrimitive(object1) || $d8f0cc4747dfcf2c$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($d8f0cc4747dfcf2c$var$isDateObject(object1) && $d8f0cc4747dfcf2c$var$isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    if (Array.isArray(object1) && Array.isArray(object2) && object1.length !== object2.length) return false;
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if ($d8f0cc4747dfcf2c$var$isEmptyObjectWithCustomPrototype(object1, keys1) || $d8f0cc4747dfcf2c$var$isEmptyObjectWithCustomPrototype(object2, keys2)) return Object.is(object1, object2);
    if (!keys1.length && Array.isArray(object1) !== Array.isArray(object2)) return false;
    const visitedPairs = visited.get(object1);
    if (visitedPairs && visitedPairs.has(object2)) return true;
    if (visitedPairs) visitedPairs.add(object2);
    else {
        const ws = new WeakSet();
        ws.add(object2);
        visited.set(object1, ws);
    }
    for (const key of keys1){
        const val1 = object1[key];
        if (!Object.prototype.hasOwnProperty.call(object2, key)) return false;
        if (!isErrorObject || key !== 'ref') {
            const val2 = object2[key];
            if ($d8f0cc4747dfcf2c$var$isDateObject(val1) && $d8f0cc4747dfcf2c$var$isDateObject(val2) || ($d8f0cc4747dfcf2c$var$isObject(val1) || Array.isArray(val1)) && ($d8f0cc4747dfcf2c$var$isObject(val2) || Array.isArray(val2)) ? !$d8f0cc4747dfcf2c$var$deepEqual(val1, val2, isErrorObject, visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
function $d8f0cc4747dfcf2c$var$useResyncOnReconnect(getInitialValue) {
    const _connected = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    const _initialized = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    const _prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(undefined);
    const _renderCount = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(0);
    _renderCount.current++;
    if (!_initialized.current && getInitialValue) {
        _initialized.current = true;
        _prevValue.current = $d8f0cc4747dfcf2c$var$cloneObject(getInitialValue());
    }
    const resyncIfNeeded = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((enabled, getCurrentValue, setValue)=>{
        if (enabled && (_connected.current || _initialized.current && _renderCount.current > 1)) {
            const currentValue = getCurrentValue();
            if (!$d8f0cc4747dfcf2c$var$deepEqual(_prevValue.current, currentValue)) setValue(currentValue);
        }
        _connected.current = true;
    }, []);
    const snapshot = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((enabled, getCurrentValue)=>{
        if (enabled) _prevValue.current = $d8f0cc4747dfcf2c$var$cloneObject(getCurrentValue());
    }, []);
    return {
        resyncIfNeeded: resyncIfNeeded,
        snapshot: snapshot
    };
}
/**
 * Subscribes to form state with re-renders isolated to this hook.
 * Optionally scope to specific field names to minimize re-render surface.
 *
 * @see [API](https://react-hook-form.com/docs/useformstate)
 *
 * @example
 * ```tsx
 * const { errors, isDirty } = useFormState({ control, name: "email" });
 * ```
 */ function $d8f0cc4747dfcf2c$export$606f11b2eb45ecc6(props) {
    const formControl = $d8f0cc4747dfcf2c$var$useFormControlContext();
    const { control: control = formControl, disabled: disabled, name: name, exact: exact } = props || {};
    const getCurrentFormState = ()=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState), {
            defaultValues: control._defaultValues
        });
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(getCurrentFormState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $d8f0cc4747dfcf2c$var$useResyncOnReconnect(getCurrentFormState);
    $d8f0cc4747dfcf2c$var$useIsomorphicLayoutEffect(()=>{
        resyncIfNeeded(!disabled, getCurrentFormState, updateFormState);
        const unsubscribe = control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState, formState), {
                    defaultValues: control._defaultValues
                }));
            }
        });
        return ()=>{
            unsubscribe();
            snapshot(!disabled, getCurrentFormState);
        };
    }, [
        control,
        name,
        disabled,
        exact,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>$d8f0cc4747dfcf2c$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $d8f0cc4747dfcf2c$var$isString = (value1)=>typeof value1 === 'string';
var $d8f0cc4747dfcf2c$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($d8f0cc4747dfcf2c$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formValues, fieldName, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(defaultValue, fieldName))));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Subscribes to field value changes and isolates re-renders to the hook level.
 *
 * @see [API](https://react-hook-form.com/docs/usewatch)
 *
 * @example
 * ```tsx
 * const email = useWatch({ control, name: "email" });
 * const all   = useWatch({ control });
 * const adult = useWatch({ control, name: "age", compute: (v) => v >= 18 });
 * ```
 */ function $d8f0cc4747dfcf2c$export$3c773aa2b84f29e0(props) {
    const formControl = $d8f0cc4747dfcf2c$var$useFormControlContext();
    const { control: control = formControl, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(compute);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(name);
    _compute.current = compute;
    const getInitialOutput = ()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    };
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(getInitialOutput);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(value1);
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((values)=>{
        const formValues = $d8f0cc4747dfcf2c$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $d8f0cc4747dfcf2c$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$d8f0cc4747dfcf2c$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $d8f0cc4747dfcf2c$var$useResyncOnReconnect(getInitialOutput);
    const _refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(refreshValue);
    _refreshValue.current = refreshValue;
    const _getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(getCurrentOutput);
    _getCurrentOutput.current = getCurrentOutput;
    $d8f0cc4747dfcf2c$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$d8f0cc4747dfcf2c$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            _refreshValue.current();
        } else resyncIfNeeded(!disabled, ()=>_getCurrentOutput.current(), (currentValue)=>{
            const nextValue = $d8f0cc4747dfcf2c$var$cloneObject(currentValue);
            updateValue(nextValue);
            _computeFormValues.current = nextValue;
        });
        const unsubscribe = control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                _refreshValue.current(formState.values);
            }
        });
        return ()=>{
            unsubscribe();
            snapshot(!disabled, ()=>_getCurrentOutput.current());
        };
    }, [
        control,
        exact,
        name,
        disabled,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    const nameChanged = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>!controlChanged && !$d8f0cc4747dfcf2c$var$deepEqual(prevName, name), [
        controlChanged,
        name,
        prevName
    ]);
    if (controlChanged || nameChanged) _defaultValue.current = defaultValue;
    const shouldReturnImmediate = !disabled && (controlChanged || nameChanged);
    return shouldReturnImmediate ? getCurrentOutput() : value1;
}
/**
 * Hook for controlled inputs. Returns `field`, `fieldState`, and `formState`.
 * Re-renders are isolated to the hook level.
 *
 * @see [API](https://react-hook-form.com/docs/usecontroller)
 *
 * @example
 * ```tsx
 * const { field, fieldState } = useController({ control, name: "email" });
 * return <input {...field} />;
 * ```
 */ function $d8f0cc4747dfcf2c$export$e8c786024a2b0a79(props) {
    const formControl = $d8f0cc4747dfcf2c$var$useFormControlContext();
    const { name: name, disabled: disabled, control: control = formControl, shouldUnregister: shouldUnregister, defaultValue: defaultValue, exact: exact = true } = props;
    const isArrayField = $d8f0cc4747dfcf2c$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>{
        const resolved = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue));
        return $d8f0cc4747dfcf2c$var$isUndefined(resolved) ? $d8f0cc4747dfcf2c$var$getNullAncestorValue(control, name) : resolved;
    }, [
        control,
        name,
        defaultValue
    ]);
    const value1 = $d8f0cc4747dfcf2c$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: exact
    });
    const formState = $d8f0cc4747dfcf2c$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: exact
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(props);
    const _proxyRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(null);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(control.register(name, (0, $7e9b970aebca32bd$export$71511d61b312f219)((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props.rules), {
        value: value1
    }), $d8f0cc4747dfcf2c$var$isBoolean(props.disabled) ? {
        disabled: props.disabled
    } : {})));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((event)=>{
        const value1 = $d8f0cc4747dfcf2c$var$getEventValue(event);
        if (!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name)) _registerProps.current = control.register(name, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _props.current.rules), {
            value: value1
        }));
        return _registerProps.current.onChange({
            target: {
                value: $d8f0cc4747dfcf2c$var$getEventValue(event),
                name: name
            },
            type: $d8f0cc4747dfcf2c$var$EVENTS.CHANGE
        });
    }, [
        name,
        control
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(()=>{
        const value1 = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name);
        if (!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name)) _registerProps.current = control.register(name, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _props.current.rules), {
            value: value1
        }));
        return _registerProps.current.onBlur({
            target: {
                value: value1,
                name: name
            },
            type: $d8f0cc4747dfcf2c$var$EVENTS.BLUR
        });
    }, [
        name,
        control
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((elm)=>{
        if (elm) _proxyRef.current = {
            focus: ()=>$d8f0cc4747dfcf2c$var$isFunction(elm.focus) && elm.focus(),
            select: ()=>$d8f0cc4747dfcf2c$var$isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>$d8f0cc4747dfcf2c$var$isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>$d8f0cc4747dfcf2c$var$isFunction(elm.reportValidity) && elm.reportValidity()
        };
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name);
        if (field && field._f && elm) {
            field._f.ref = _proxyRef.current;
            field._f._c = true;
        }
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
            name: name,
            value: value1
        }, $d8f0cc4747dfcf2c$var$isBoolean(disabled) || formState.disabled ? {
            disabled: formState.disabled || disabled
        } : {}), {
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        _registerProps.current = control.register(name, (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _props.current.rules, $d8f0cc4747dfcf2c$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        const updateMounted = (name, value1)=>{
            const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) {
                field._f.mount = value1;
                field._f._c = value1;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $d8f0cc4747dfcf2c$var$cloneObject($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(shouldUnregister ? control._defaultValues : control._options.values || control._defaultValues, name, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue)));
            $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($d8f0cc4747dfcf2c$var$isUndefined($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name))) $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name, (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _props.current.rules, $d8f0cc4747dfcf2c$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        if (_proxyRef.current) {
            const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.ref = _proxyRef.current;
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component wrapper around `useController` for controlled inputs.
 *
 * @see [API](https://react-hook-form.com/docs/usecontroller/controller)
 *
 * @example
 * ```tsx
 * <Controller
 *   control={control}
 *   name="test"
 *   render={({ field, fieldState, formState }) => <input {...field} />}
 * />
 * ```
 */ const $d8f0cc4747dfcf2c$export$bd0bf19f25da8474 = (props)=>props.render($d8f0cc4747dfcf2c$export$e8c786024a2b0a79(props));
/**
 * Displays the validation error for a single field.
 * Reads from `control` when provided, otherwise from the nearest `FormProvider`.
 *
 * @see [API](https://react-hook-form.com/docs/useformstate/errormessage)
 *
 * @example
 * ```tsx
 * <ErrorMessage control={control} name="email" as="p" />
 * <ErrorMessage name="email" as="span" />
 * <ErrorMessage control={control} name="email"
 *   render={({ message }) => <Alert>{message}</Alert>} />
 * ```
 */ const $d8f0cc4747dfcf2c$export$915e9e7bd4f0f96d = ({ as: as, control: control, name: name, render: render })=>{
    const { errors: errors } = $d8f0cc4747dfcf2c$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, name);
    if (!error) return null;
    const message = error.message || '';
    if (render) return render({
        message: message,
        messages: error.types
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement(as || (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).Fragment, null, message);
};
var $d8f0cc4747dfcf2c$var$generateId = ()=>typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
var $d8f0cc4747dfcf2c$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $d8f0cc4747dfcf2c$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$d8f0cc4747dfcf2c$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $d8f0cc4747dfcf2c$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all,
        isOnTouch: mode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onTouched
    });
var $d8f0cc4747dfcf2c$var$isWatched = (name, _names, isBlurEvent)=>{
    if (isBlurEvent) return false;
    if (_names.watchAll || _names.watch.has(name)) return true;
    for (const watchName of _names.watch){
        if (name.startsWith(watchName) && name.charAt(watchName.length) === '.') return true;
    }
    return false;
};
const $d8f0cc4747dfcf2c$var$iterateFieldsByAction = (fields, action, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        if (key === '_f') continue;
        const field = fieldsNames ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(fields, key) : fields[key];
        if (field) {
            const { _f: _f } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], _f.name)) return true;
                else if (_f.ref && action(_f.ref, _f.name)) return true;
                else {
                    if ($d8f0cc4747dfcf2c$var$iterateFieldsByAction(field, action)) return true;
                }
            } else if ($d8f0cc4747dfcf2c$var$isObject(field) || Array.isArray(field)) {
                if ($d8f0cc4747dfcf2c$var$iterateFieldsByAction(field, action)) return true;
            }
        }
    }
    return;
};
var $d8f0cc4747dfcf2c$var$updateFieldArrayRootError = (errors, error, name)=>{
    const existingErrors = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, name);
    const fieldArrayErrors = Array.isArray(existingErrors) ? existingErrors : [];
    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(fieldArrayErrors, $d8f0cc4747dfcf2c$var$ROOT_ERROR_TYPE, error[name]);
    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $d8f0cc4747dfcf2c$var$isEmptyObject = (value1)=>$d8f0cc4747dfcf2c$var$isObject(value1) && !Object.keys(value1).length;
var $d8f0cc4747dfcf2c$var$isHTMLElement = (value1)=>{
    if (!$d8f0cc4747dfcf2c$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $d8f0cc4747dfcf2c$var$isRadioInput = (element)=>element.type === 'radio';
var $d8f0cc4747dfcf2c$var$isRegex = (value1)=>value1 instanceof RegExp;
var $d8f0cc4747dfcf2c$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, errors[name]), {
        types: (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
const $d8f0cc4747dfcf2c$var$defaultResult = {
    value: false,
    isValid: false
};
const $d8f0cc4747dfcf2c$var$validResult = {
    value: true,
    isValid: true
};
var $d8f0cc4747dfcf2c$var$getCheckboxValue = (options)=>{
    if (!Array.isArray(options)) return $d8f0cc4747dfcf2c$var$defaultResult;
    if (options.length > 1) {
        const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
        return {
            value: values,
            isValid: !!values.length
        };
    }
    const option = options[0];
    if (!option || !option.checked || option.disabled) return $d8f0cc4747dfcf2c$var$defaultResult;
    if (!option.attributes || !('value' in option.attributes)) return $d8f0cc4747dfcf2c$var$validResult;
    return $d8f0cc4747dfcf2c$var$isUndefined(option.value) || option.value === '' ? $d8f0cc4747dfcf2c$var$validResult : {
        value: option.value,
        isValid: true
    };
};
const $d8f0cc4747dfcf2c$var$defaultReturn = {
    isValid: false,
    value: null
};
var $d8f0cc4747dfcf2c$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $d8f0cc4747dfcf2c$var$defaultReturn) : $d8f0cc4747dfcf2c$var$defaultReturn;
function $d8f0cc4747dfcf2c$var$getValidateError(result, ref, type = 'validate') {
    if ($d8f0cc4747dfcf2c$var$isString(result) || Array.isArray(result) && !!result.length && result.every($d8f0cc4747dfcf2c$var$isString) || $d8f0cc4747dfcf2c$var$isBoolean(result) && !result) return {
        type: type,
        message: $d8f0cc4747dfcf2c$var$isString(result) ? result : '',
        ref: ref
    };
}
var $d8f0cc4747dfcf2c$var$getValueAndMessage = (validationData)=>$d8f0cc4747dfcf2c$var$isObject(validationData) && !$d8f0cc4747dfcf2c$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $d8f0cc4747dfcf2c$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, _c: _c } = field._f;
    const inputValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            const validityMessage = $d8f0cc4747dfcf2c$var$isBoolean(message) ? '' : message || '';
            if (refs) refs.forEach((ref)=>$d8f0cc4747dfcf2c$var$isFunction(ref.setCustomValidity) && ref.setCustomValidity(validityMessage));
            else inputRef.setCustomValidity(validityMessage);
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = !_c && $d8f0cc4747dfcf2c$var$isRadioInput(ref);
    const isCheckBox = !_c && $d8f0cc4747dfcf2c$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $d8f0cc4747dfcf2c$var$isFileInput(ref)) && $d8f0cc4747dfcf2c$var$isUndefined(ref.value) && $d8f0cc4747dfcf2c$var$isUndefined(inputValue) || $d8f0cc4747dfcf2c$var$isHTMLElement(ref) && ref.value === '' && !_c || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $d8f0cc4747dfcf2c$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.maxLength, minType = $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $d8f0cc4747dfcf2c$var$isNullOrUndefined(inputValue)) || $d8f0cc4747dfcf2c$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$d8f0cc4747dfcf2c$var$getCheckboxValue(refs).isValid || isRadio && !$d8f0cc4747dfcf2c$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $d8f0cc4747dfcf2c$var$isString(required) ? {
            value: !!required,
            message: required
        } : $d8f0cc4747dfcf2c$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                type: $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$d8f0cc4747dfcf2c$var$isNullOrUndefined(min) || !$d8f0cc4747dfcf2c$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $d8f0cc4747dfcf2c$var$getValueAndMessage(max);
        const minOutput = $d8f0cc4747dfcf2c$var$getValueAndMessage(min);
        if (!$d8f0cc4747dfcf2c$var$isNullOrUndefined(inputValue) && !$d8f0cc4747dfcf2c$var$isDateObject(inputValue) && !isNaN(inputValue)) {
            const valueNumber = !_c && ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$d8f0cc4747dfcf2c$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$d8f0cc4747dfcf2c$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = !_c && ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($d8f0cc4747dfcf2c$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($d8f0cc4747dfcf2c$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.max, $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((!$d8f0cc4747dfcf2c$var$isNullOrUndefined(maxLength) || !$d8f0cc4747dfcf2c$var$isNullOrUndefined(minLength)) && !isEmpty && ($d8f0cc4747dfcf2c$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $d8f0cc4747dfcf2c$var$getValueAndMessage(maxLength);
        const minLengthOutput = $d8f0cc4747dfcf2c$var$getValueAndMessage(minLength);
        const exceedMax = !$d8f0cc4747dfcf2c$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$d8f0cc4747dfcf2c$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $d8f0cc4747dfcf2c$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $d8f0cc4747dfcf2c$var$getValueAndMessage(pattern);
        if ($d8f0cc4747dfcf2c$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                type: $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($d8f0cc4747dfcf2c$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $d8f0cc4747dfcf2c$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, validateError, appendErrorsCurry($d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($d8f0cc4747dfcf2c$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$d8f0cc4747dfcf2c$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $d8f0cc4747dfcf2c$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, validateError, appendErrorsCurry(key, validateError.message));
                    if (!validateAllFieldCriteria) setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$d8f0cc4747dfcf2c$var$isEmptyObject(validationResult)) {
                error[name] = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    const fieldError = error[name];
    setCustomValidity(fieldError ? fieldError.message : true);
    return error;
};
var $d8f0cc4747dfcf2c$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $d8f0cc4747dfcf2c$var$appendAt = (data, value1)=>[
        ...data,
        ...$d8f0cc4747dfcf2c$var$convertToArrayPayload(value1)
    ];
var $d8f0cc4747dfcf2c$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $d8f0cc4747dfcf2c$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$d8f0cc4747dfcf2c$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $d8f0cc4747dfcf2c$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($d8f0cc4747dfcf2c$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $d8f0cc4747dfcf2c$var$prependAt = (data, value1)=>[
        ...$d8f0cc4747dfcf2c$var$convertToArrayPayload(value1),
        ...$d8f0cc4747dfcf2c$var$convertToArrayPayload(data)
    ];
var $d8f0cc4747dfcf2c$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
function $d8f0cc4747dfcf2c$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $d8f0cc4747dfcf2c$var$compact(temp).length ? temp : [];
}
var $d8f0cc4747dfcf2c$var$removeArrayAt = (data, index)=>$d8f0cc4747dfcf2c$var$isUndefined(index) ? [] : $d8f0cc4747dfcf2c$var$removeAtIndexes(data, [
        ...new Set($d8f0cc4747dfcf2c$var$convertToArrayPayload(index))
    ].sort((a, b)=>a - b));
var $d8f0cc4747dfcf2c$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $d8f0cc4747dfcf2c$var$baseGet(object, updatePath) {
    const length = updatePath.length - 1;
    let index = 0;
    while(index < length){
        if ($d8f0cc4747dfcf2c$var$isNullOrUndefined(object)) {
            object = undefined;
            break;
        }
        object = object[updatePath[index]];
        index++;
    }
    return object;
}
function $d8f0cc4747dfcf2c$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$d8f0cc4747dfcf2c$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $d8f0cc4747dfcf2c$var$unset(object, path) {
    if ($d8f0cc4747dfcf2c$var$isString(path) && Object.prototype.hasOwnProperty.call(object, path)) {
        delete object[path];
        return object;
    }
    const paths = Array.isArray(path) ? path : $d8f0cc4747dfcf2c$var$isKey(path) ? [
        path
    ] : $d8f0cc4747dfcf2c$var$stringToPath(path);
    if (paths.some((segment)=>$d8f0cc4747dfcf2c$var$PROTOTYPE_KEYWORDS.includes(String(segment)))) return object;
    const childObject = paths.length === 1 ? object : $d8f0cc4747dfcf2c$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($d8f0cc4747dfcf2c$var$isObject(childObject) && $d8f0cc4747dfcf2c$var$isEmptyObject(childObject) || Array.isArray(childObject) && $d8f0cc4747dfcf2c$var$isEmptyArray(childObject))) $d8f0cc4747dfcf2c$var$unset(object, paths.slice(0, -1));
    return object;
}
var $d8f0cc4747dfcf2c$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * Hook for dynamic field arrays. Provides `fields` and mutation methods:
 * `append`, `prepend`, `remove`, `insert`, `swap`, `move`, `update`, `replace`.
 *
 * @see [API](https://react-hook-form.com/docs/usefieldarray)
 *
 * @example
 * ```tsx
 * const { fields, append } = useFieldArray({ control, name: "items" });
 * return fields.map((f, i) => <input key={f.id} {...register(`items.${i}.name`)} />);
 * ```
 */ function $d8f0cc4747dfcf2c$export$310131896651d559(props) {
    const formControl = $d8f0cc4747dfcf2c$var$useFormControlContext();
    const { control: control = formControl, name: name, keyName: keyName = 'id', disabled: disabled, shouldUnregister: shouldUnregister, rules: rules } = props;
    const getCurrentFieldArray = ()=>control._getFieldArray(name);
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(getCurrentFieldArray);
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(control._getFieldArray(name).map($d8f0cc4747dfcf2c$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $d8f0cc4747dfcf2c$var$useResyncOnReconnect(getCurrentFieldArray);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(name);
    if (!disabled) control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>!disabled && rules && fields && control.register(name, rules), [
        control,
        name,
        fields,
        rules,
        disabled
    ]);
    $d8f0cc4747dfcf2c$var$useIsomorphicLayoutEffect(()=>{
        if (disabled) return;
        if (_prevControl.current === control && _prevName.current === name) resyncIfNeeded(true, getCurrentFieldArray, (fieldValues)=>{
            setFields(fieldValues);
            ids.current = fieldValues.map($d8f0cc4747dfcf2c$var$generateId);
        });
        else {
            _prevControl.current = control;
            _prevName.current = name;
            const fieldValues = getCurrentFieldArray();
            if (!$d8f0cc4747dfcf2c$var$deepEqual(fields, fieldValues)) {
                setFields(fieldValues);
                ids.current = fieldValues.map($d8f0cc4747dfcf2c$var$generateId);
            }
            snapshot(true, getCurrentFieldArray);
        }
        const unsubscribe = control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($d8f0cc4747dfcf2c$var$generateId);
                    } else if (!fieldArrayName) {
                        setFields([]);
                        ids.current = [];
                    }
                }
            }
        }).unsubscribe;
        return ()=>{
            unsubscribe();
            snapshot(true, getCurrentFieldArray);
        };
    }, [
        control,
        name,
        disabled,
        resyncIfNeeded,
        snapshot
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        if (disabled) return;
        const appendValue = $d8f0cc4747dfcf2c$var$convertToArrayPayload($d8f0cc4747dfcf2c$var$cloneObject(value1));
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $d8f0cc4747dfcf2c$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $d8f0cc4747dfcf2c$var$appendAt(ids.current, appendValue.map($d8f0cc4747dfcf2c$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$appendAt, {
            argA: $d8f0cc4747dfcf2c$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        if (disabled) return;
        const prependValue = $d8f0cc4747dfcf2c$var$convertToArrayPayload($d8f0cc4747dfcf2c$var$cloneObject(value1));
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $d8f0cc4747dfcf2c$var$getFocusFieldName(name, 0, options);
        ids.current = $d8f0cc4747dfcf2c$var$prependAt(ids.current, prependValue.map($d8f0cc4747dfcf2c$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$prependAt, {
            argA: $d8f0cc4747dfcf2c$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        if (disabled) return;
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $d8f0cc4747dfcf2c$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name)) && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        if (disabled) return;
        const insertValue = $d8f0cc4747dfcf2c$var$convertToArrayPayload($d8f0cc4747dfcf2c$var$cloneObject(value1));
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $d8f0cc4747dfcf2c$var$getFocusFieldName(name, index, options);
        ids.current = $d8f0cc4747dfcf2c$var$insert(ids.current, index, insertValue.map($d8f0cc4747dfcf2c$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$insert, {
            argA: index,
            argB: $d8f0cc4747dfcf2c$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        $d8f0cc4747dfcf2c$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $d8f0cc4747dfcf2c$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        $d8f0cc4747dfcf2c$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $d8f0cc4747dfcf2c$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        if (disabled) return;
        const updateValue = $d8f0cc4747dfcf2c$var$cloneObject(value1);
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $d8f0cc4747dfcf2c$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $d8f0cc4747dfcf2c$var$updateAt, {
            argA: index,
            argB: $d8f0cc4747dfcf2c$var$fillEmptyArray(value1)
        });
    };
    const replace = (value1)=>{
        if (disabled) return;
        const updatedFieldArrayValues = $d8f0cc4747dfcf2c$var$convertToArrayPayload($d8f0cc4747dfcf2c$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($d8f0cc4747dfcf2c$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>Array.isArray(data) ? data.slice(0, updatedFieldArrayValues.length) : data, {});
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (disabled) {
            control._state.actionArrayLengths.delete(name);
            return;
        }
        control._state.action = false;
        control._state.actionArrayLengths.delete(name);
        $d8f0cc4747dfcf2c$var$isWatched(name, control._names) && control._subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState));
        const validationModes = $d8f0cc4747dfcf2c$var$getValidationModes(control._options.mode);
        const reValidateModes = $d8f0cc4747dfcf2c$var$getValidationModes(control._options.reValidateMode);
        if (_actioned.current && (!validationModes.isOnSubmit || control._formState.isSubmitted) && !reValidateModes.isOnSubmit && (!validationModes.isOnBlur || control._formState.isSubmitted && reValidateModes.isOnChange)) {
            const fieldArrayValues = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name);
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                control._updateIsValidating([
                    name
                ]);
                if (fieldArrayValues !== $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name)) return;
                const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formState.errors, name);
                const existingErrorType = existingError && (existingError.type || existingError.root && existingError.root.type);
                const existingErrorMessage = existingError && (existingError.message || existingError.root && existingError.root.message);
                if (existingError ? !error && existingErrorType || error && (existingErrorType !== error.type || existingErrorMessage !== error.message) : error && error.type) {
                    if (error) $d8f0cc4747dfcf2c$var$isObject(error) && !Object.keys(error).some((key)=>!Number.isNaN(+key)) ? $d8f0cc4747dfcf2c$var$updateFieldArrayRootError(control._formState.errors, {
                        [name]: error
                    }, name) : $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(control._formState.errors, name, error);
                    else $d8f0cc4747dfcf2c$var$unset(control._formState.errors, name);
                    control._formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState.errors);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $d8f0cc4747dfcf2c$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>{
                    if (fieldArrayValues !== $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name)) return;
                    if (!$d8f0cc4747dfcf2c$var$isEmptyObject(error)) {
                        $d8f0cc4747dfcf2c$var$updateFieldArrayRootError(control._formState.errors, error, name);
                        control._formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState.errors);
                        control._subjects.state.next({
                            errors: control._formState.errors
                        });
                    } else {
                        const existingError = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formState.errors, name);
                        if (existingError && existingError[$d8f0cc4747dfcf2c$var$ROOT_ERROR_TYPE]) {
                            $d8f0cc4747dfcf2c$var$unset(control._formState.errors, `${name}.${$d8f0cc4747dfcf2c$var$ROOT_ERROR_TYPE}`);
                            control._formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState.errors);
                            control._subjects.state.next({
                                errors: control._formState.errors
                            });
                        }
                    }
                });
            }
        }
        // External updates that change `fields` (e.g. reset() or setValue() on
        // the array) already notify subscribers with the up-to-date values
        // themselves, so only re-broadcast here for genuine array method calls.
        _actioned.current && control._subjects.state.next({
            name: name,
            values: $d8f0cc4747dfcf2c$var$cloneObject(control._formValues)
        });
        control._names.focus && $d8f0cc4747dfcf2c$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control,
        disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (!disabled) $d8f0cc4747dfcf2c$var$isUndefined($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._formValues, name)) && control._setFieldArray(name);
        return ()=>{
            control._state.actionArrayLengths.delete(name);
            control._state.actionArrayLengths.size || (control._state.action = false);
            if (disabled) return;
            const shouldKeepFieldArrayValues = !(control._options.shouldUnregister || shouldUnregister);
            const updateMounted = (name, value1)=>{
                const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            if (_actioned.current && shouldKeepFieldArrayValues) control._subjects.state.next({
                name: name,
                values: $d8f0cc4747dfcf2c$var$cloneObject(control._formValues)
            });
            if (!shouldKeepFieldArrayValues && control._state.action && [
                ...control._state.actionArrayLengths.keys()
            ].some((arrayName)=>name.startsWith(arrayName + '.'))) return;
            shouldKeepFieldArrayValues ? updateMounted(name, false) : control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister,
        disabled
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(swap, [
            updateValues,
            name,
            control,
            disabled
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(move, [
            updateValues,
            name,
            control,
            disabled
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(prepend, [
            updateValues,
            name,
            control,
            disabled
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(append, [
            updateValues,
            name,
            control,
            disabled
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(remove, [
            updateValues,
            name,
            control,
            disabled
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(insert$1, [
            updateValues,
            name,
            control,
            disabled
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(update, [
            updateValues,
            name,
            control,
            disabled
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(replace, [
            updateValues,
            name,
            control,
            disabled
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>fields.map((field, index)=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, field, $d8f0cc4747dfcf2c$var$isBoolean(disabled) ? {
                    disabled: disabled
                } : {}), {
                    [keyName]: ids.current[index] || $d8f0cc4747dfcf2c$var$generateId()
                })), [
            fields,
            keyName,
            disabled
        ])
    };
}
/**
 * Component based on `useFieldArray` hook to work with controlled component.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, register } = useForm<FormValues>({
 *     defaultValues: {
 *       test: [
 *         {
 *           value: '',
 *         },
 *       ],
 *     },
 *   });
 *
 *   return (
 *     <form>
 *       <FieldArray
 *         control={control}
 *         name="test"
 *         render={({ fields }) =>
 *           fields.map((field, index) => (
 *             <input key={field.id} {...register(`test.${index}.value`)} />
 *           ))
 *         }
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $d8f0cc4747dfcf2c$export$2683597413c8b91 = (props)=>props.render($d8f0cc4747dfcf2c$export$310131896651d559(props));
const $d8f0cc4747dfcf2c$var$isFileLike = (value1)=>typeof Blob !== 'undefined' && value1 instanceof Blob || typeof File !== 'undefined' && value1 instanceof File;
const $d8f0cc4747dfcf2c$var$isFileListLike = (value1)=>typeof FileList !== 'undefined' && value1 instanceof FileList;
const $d8f0cc4747dfcf2c$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($d8f0cc4747dfcf2c$var$isObjectType(obj[key]) && obj[key] !== null && !$d8f0cc4747dfcf2c$var$isDateObject(obj[key]) && !$d8f0cc4747dfcf2c$var$isFileLike(obj[key]) && !$d8f0cc4747dfcf2c$var$isFileListLike(obj[key])) {
        const nested = $d8f0cc4747dfcf2c$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
function $d8f0cc4747dfcf2c$var$jsonToFormData(json) {
    const result = new FormData();
    const flattenFormValues = $d8f0cc4747dfcf2c$var$flatten(json);
    for(const key in flattenFormValues){
        const value1 = flattenFormValues[key];
        if ($d8f0cc4747dfcf2c$var$isUndefined(value1)) continue;
        if (typeof FileList !== 'undefined' && value1 instanceof FileList) {
            for(let index = 0; index < value1.length; index++){
                const file = value1[index];
                file && result.append(key, file);
            }
            continue;
        }
        result.append(key, value1);
    }
    return result;
}
function $d8f0cc4747dfcf2c$var$safeJSONStringify(value1) {
    try {
        return JSON.stringify(value1);
    } catch (_a) {
        return '';
    }
}
function $d8f0cc4747dfcf2c$var$noop() {}
const $d8f0cc4747dfcf2c$var$POST_REQUEST = 'post';
function $d8f0cc4747dfcf2c$var$defaultValidateStatus(status) {
    return status >= 200 && status < 300;
}
/**
 * Form component that handles submission, including optional `action` fetch and server error wiring.
 *
 * @see [API](https://react-hook-form.com/docs/useform/form)
 *
 * @example
 * ```tsx
 * <Form action="/api" control={control}>
 *   <input {...register("name")} />
 *   <p>{errors?.root?.server && 'Server error'}</p>
 *   <button>Submit</button>
 * </Form>
 * ```
 */ function $d8f0cc4747dfcf2c$export$a7fed597f4b8afd8(props) {
    const formControl = $d8f0cc4747dfcf2c$var$useFormControlContext();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(false);
    const { control: control = formControl, onSubmit: onSubmit = $d8f0cc4747dfcf2c$var$noop, children: children, action: action, method: method = $d8f0cc4747dfcf2c$var$POST_REQUEST, headers: headers, encType: encType, onError: onError = $d8f0cc4747dfcf2c$var$noop, render: render, onSuccess: onSuccess = $d8f0cc4747dfcf2c$var$noop, validateStatus: validateStatus = $d8f0cc4747dfcf2c$var$defaultValidateStatus } = props, rest = (0, $287e58e413d8005e$export$71511d61b312f219)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    const handleSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>{
        return control.handleSubmit(async (data, event)=>{
            const formData = $d8f0cc4747dfcf2c$var$jsonToFormData(data);
            const formDataJson = $d8f0cc4747dfcf2c$var$safeJSONStringify(data);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if ($d8f0cc4747dfcf2c$var$isString(action)) try {
                const hasContentType = (type)=>headers && Object.entries(headers).some(([name, value1])=>name.toLowerCase() === 'content-type' && type.test(value1)) || encType && type.test(encType);
                let body = formData;
                if (hasContentType(/json/i)) body = formDataJson;
                else if (hasContentType(/^\s*application\/x-www-form-urlencoded\s*(;|$)/i)) body = new URLSearchParams(Array.from(formData, ([name, value1])=>[
                        name,
                        $d8f0cc4747dfcf2c$var$isString(value1) ? value1 : value1.name
                    ]));
                else if (hasContentType(/^\s*text\/plain\s*(;|$)/i)) body = Array.from(formData, ([name, value1])=>`${name}=${$d8f0cc4747dfcf2c$var$isString(value1) ? value1 : value1.name}\r\n`).join('');
                const isMultipart = (value1)=>/^\s*multipart\/form-data\s*(;|$)/i.test(value1);
                const response = await fetch(action, {
                    method: method,
                    headers: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, Object.fromEntries(Object.entries(headers || {}).filter(([name, value1])=>name.toLowerCase() !== 'content-type' || !isMultipart(value1))), encType && !isMultipart(encType) && {
                        'Content-Type': encType
                    }),
                    body: body
                });
                if (response && !validateStatus(response.status)) {
                    onError({
                        response: response
                    });
                    return {
                        type: String(response.status)
                    };
                } else onSuccess({
                    response: response
                });
            } catch (error) {
                onError({
                    error: error
                });
                return {
                    type: ''
                };
            }
            if ($d8f0cc4747dfcf2c$var$isFunction(action)) try {
                await action(formData);
            } catch (error) {
                onError({
                    error: error
                });
                return {
                    type: ''
                };
            }
            // Return nothing when successful.
            return;
        });
    }, [
        control,
        onSubmit,
        method,
        action,
        headers,
        encType,
        validateStatus,
        onError,
        onSuccess
    ]);
    const submit = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useCallback(async (event)=>{
        const err = await handleSubmit(event);
        if (err && control) {
            control._subjects.state.next({
                isSubmitSuccessful: false
            });
            control.setError('root.server', err);
        }
    }, [
        handleSubmit,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        setMounted(true);
    }, []);
    if (render) return render({
        submit: submit
    });
    // React forbids passing `method`/`encType` alongside a function `action`
    // (a Server-Action-style submission) -- it manages those itself and warns
    // if they're present, so they're only rendered for string/URL actions.
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement("form", (0, $7e9b970aebca32bd$export$71511d61b312f219)((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
        noValidate: mounted,
        action: action
    }, !$d8f0cc4747dfcf2c$var$isFunction(action) && {
        method: method,
        encType: encType
    }), {
        onSubmit: submit
    }), rest), children);
}
const $d8f0cc4747dfcf2c$export$35e922fb7c997117 = ({ control: control, disabled: disabled, exact: exact, name: name, render: render })=>render($d8f0cc4747dfcf2c$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        disabled: disabled,
        exact: exact
    }));
/** @deprecated Use `FormState` instead. Kept as an alias for backward compatibility. */ const $d8f0cc4747dfcf2c$export$6136af724020822e = $d8f0cc4747dfcf2c$export$35e922fb7c997117;
var $d8f0cc4747dfcf2c$var$createSubject = ()=>{
    let _observers = new Set();
    let _iterationCount = 0;
    const next = (value1)=>{
        const observers = _observers;
        _iterationCount++;
        for (const observer of observers)observer.next && observer.next(value1);
        observers === _observers && _iterationCount--;
    };
    const subscribe = (observer)=>{
        _observers.add(observer);
        return {
            unsubscribe: ()=>{
                if (_iterationCount) {
                    _observers = new Set(_observers);
                    _iterationCount = 0;
                }
                _observers.delete(observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = new Set();
        _iterationCount = 0;
    };
    return {
        get observers () {
            return Array.from(_observers);
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $d8f0cc4747dfcf2c$var$extractFormValues(fieldsState, formValues) {
    const values = Array.isArray(fieldsState) ? [] : {};
    for(const key in fieldsState)if (Object.prototype.hasOwnProperty.call(fieldsState, key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && ($d8f0cc4747dfcf2c$var$isObject(fieldState) || Array.isArray(fieldState)) && fieldValue) values[key] = $d8f0cc4747dfcf2c$var$extractFormValues(fieldState, fieldValue);
        else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
const $d8f0cc4747dfcf2c$var$hasOwn = (value1, key)=>value1 !== null && $d8f0cc4747dfcf2c$var$isObjectType(value1) && Object.prototype.hasOwnProperty.call(value1, key);
var $d8f0cc4747dfcf2c$var$has = (object, path)=>{
    if (!path) return false;
    let result = object;
    for (const key of $d8f0cc4747dfcf2c$var$isKey(path) ? [
        path
    ] : $d8f0cc4747dfcf2c$var$stringToPath(path)){
        if (!$d8f0cc4747dfcf2c$var$hasOwn(result, key)) // `get` also resolves a path held as a single literal key, eg `{ 'a.b': 1 }`
        return $d8f0cc4747dfcf2c$var$hasOwn(object, path);
        result = result[key];
    }
    return true;
};
var $d8f0cc4747dfcf2c$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
const $d8f0cc4747dfcf2c$var$isSelectEdited = (select)=>{
    const options = [
        ...select.options
    ];
    return !select.multiple && select.size < 2 && !options.some((option)=>option.defaultSelected) ? select.selectedIndex !== options.findIndex((option)=>!option.disabled) : options.some((option)=>option.selected !== option.defaultSelected);
};
var $d8f0cc4747dfcf2c$var$isEdited = (ref)=>$d8f0cc4747dfcf2c$var$isCheckBoxInput(ref) ? ref.checked !== ref.defaultChecked : ref.type === 'select-one' || $d8f0cc4747dfcf2c$var$isMultipleSelect(ref) ? $d8f0cc4747dfcf2c$var$isSelectEdited(ref) : !$d8f0cc4747dfcf2c$var$isRadioInput(ref) && 'defaultValue' in ref && ref.value !== ref.defaultValue;
var $d8f0cc4747dfcf2c$var$isRadioOrCheckbox = (ref)=>$d8f0cc4747dfcf2c$var$isRadioInput(ref) || $d8f0cc4747dfcf2c$var$isCheckBoxInput(ref);
var $d8f0cc4747dfcf2c$var$live = (ref)=>$d8f0cc4747dfcf2c$var$isHTMLElement(ref) && ref.isConnected;
function $d8f0cc4747dfcf2c$var$isDirtyContainer(value1) {
    return Array.isArray(value1) || $d8f0cc4747dfcf2c$var$isObject(value1);
}
function $d8f0cc4747dfcf2c$var$collectDirtyFieldNames(dirtyTree, cachedDirtyFields, prefix = '', names = []) {
    for(const key in dirtyTree){
        const path = prefix ? `${prefix}.${key}` : key;
        const value1 = dirtyTree[key];
        if ($d8f0cc4747dfcf2c$var$isDirtyContainer(value1) && $d8f0cc4747dfcf2c$var$isDirtyContainer($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(cachedDirtyFields, path))) $d8f0cc4747dfcf2c$var$collectDirtyFieldNames(value1, cachedDirtyFields, path, names);
        else names.push(path);
    }
    return names;
}
var $d8f0cc4747dfcf2c$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($d8f0cc4747dfcf2c$var$isFunction(data[key])) return true;
    }
    return false;
};
function $d8f0cc4747dfcf2c$var$isTraversable(value1) {
    return Array.isArray(value1) || $d8f0cc4747dfcf2c$var$isObject(value1) && !$d8f0cc4747dfcf2c$var$objectHasFunction(value1);
}
function $d8f0cc4747dfcf2c$var$isRegisteredLeaf(fieldRef) {
    return !!(fieldRef && '_f' in fieldRef);
}
function $d8f0cc4747dfcf2c$var$isEmptyDirtyContainer(value1) {
    return Array.isArray(value1) ? !value1.some((item)=>!$d8f0cc4747dfcf2c$var$isUndefined(item)) : !Object.keys(value1).length;
}
function $d8f0cc4747dfcf2c$var$clearDirtyField(container, key) {
    if (Array.isArray(container)) container[key] = undefined;
    else delete container[key];
}
function $d8f0cc4747dfcf2c$var$markFieldsDirty(data, fields = {}, fieldRefs) {
    for(const key in data){
        const value1 = data[key];
        const fieldRef = fieldRefs && fieldRefs[key];
        if ($d8f0cc4747dfcf2c$var$isTraversable(value1) && (!Array.isArray(value1) || !$d8f0cc4747dfcf2c$var$isRegisteredLeaf(fieldRef))) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $d8f0cc4747dfcf2c$var$markFieldsDirty(value1, fields[key], fieldRef);
            if ($d8f0cc4747dfcf2c$var$isEmptyDirtyContainer(fields[key])) $d8f0cc4747dfcf2c$var$clearDirtyField(fields, key);
        } else if (!$d8f0cc4747dfcf2c$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $d8f0cc4747dfcf2c$var$getDirtyFields(data, formValues, dirtyFieldsFromValues, fieldRefs) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $d8f0cc4747dfcf2c$var$markFieldsDirty(formValues, Array.isArray($d8f0cc4747dfcf2c$var$isNullOrUndefined(formValues) ? data : formValues) ? [] : {}, fieldRefs);
    for(const key in data){
        const value1 = data[key];
        const fieldRef = fieldRefs && fieldRefs[key];
        if ($d8f0cc4747dfcf2c$var$isTraversable(value1) && (!Array.isArray(value1) || !$d8f0cc4747dfcf2c$var$isRegisteredLeaf(fieldRef))) {
            if ($d8f0cc4747dfcf2c$var$isUndefined(formValues) || $d8f0cc4747dfcf2c$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $d8f0cc4747dfcf2c$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {}, fieldRef);
            else $d8f0cc4747dfcf2c$var$getDirtyFields(value1, $d8f0cc4747dfcf2c$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key], fieldRef);
            if ($d8f0cc4747dfcf2c$var$isEmptyDirtyContainer(dirtyFieldsFromValues[key])) $d8f0cc4747dfcf2c$var$clearDirtyField(dirtyFieldsFromValues, key);
        } else if ($d8f0cc4747dfcf2c$var$deepEqual(value1, $d8f0cc4747dfcf2c$var$isNullOrUndefined(formValues) ? undefined : formValues[key])) $d8f0cc4747dfcf2c$var$clearDirtyField(dirtyFieldsFromValues, key);
        else dirtyFieldsFromValues[key] = true;
    }
    return dirtyFieldsFromValues;
}
var $d8f0cc4747dfcf2c$var$getFieldArrayItemNames = (names, name)=>{
    const segments = name.split('.');
    const matches = [];
    let prefix = segments[0];
    for(let i = 1; i < segments.length; prefix += '.' + segments[i++])if (!isNaN(+segments[i]) && names.has(prefix)) matches.push(`${prefix}.${segments[i]}`);
    return matches;
};
var $d8f0cc4747dfcf2c$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$d8f0cc4747dfcf2c$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $d8f0cc4747dfcf2c$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $d8f0cc4747dfcf2c$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($d8f0cc4747dfcf2c$var$isFileInput(ref)) return ref.files;
    if ($d8f0cc4747dfcf2c$var$isRadioInput(ref)) return $d8f0cc4747dfcf2c$var$getRadioValue(_f.refs).value;
    if ($d8f0cc4747dfcf2c$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($d8f0cc4747dfcf2c$var$isCheckBoxInput(ref)) return $d8f0cc4747dfcf2c$var$getCheckboxValue(_f.refs).value;
    return $d8f0cc4747dfcf2c$var$getFieldValueAs(ref.value, _f);
}
var $d8f0cc4747dfcf2c$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        field && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $d8f0cc4747dfcf2c$var$getRuleValue = (rule)=>$d8f0cc4747dfcf2c$var$isUndefined(rule) ? rule : $d8f0cc4747dfcf2c$var$isRegex(rule) ? rule.source : $d8f0cc4747dfcf2c$var$isObject(rule) ? $d8f0cc4747dfcf2c$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $d8f0cc4747dfcf2c$var$ASYNC_FUNCTION = 'AsyncFunction';
var $d8f0cc4747dfcf2c$var$hasPromiseValidation = (fieldReference)=>{
    if (!fieldReference || !fieldReference.validate) return false;
    if ($d8f0cc4747dfcf2c$var$isFunction(fieldReference.validate)) return fieldReference.validate.constructor.name === $d8f0cc4747dfcf2c$var$ASYNC_FUNCTION;
    if ($d8f0cc4747dfcf2c$var$isObject(fieldReference.validate)) for(const key in fieldReference.validate){
        if (fieldReference.validate[key].constructor.name === $d8f0cc4747dfcf2c$var$ASYNC_FUNCTION) return true;
    }
    return false;
};
var $d8f0cc4747dfcf2c$var$hasValidation = (options)=>options.mount && (options.required || !$d8f0cc4747dfcf2c$var$isUndefined(options.required) && options.required !== false || !$d8f0cc4747dfcf2c$var$isUndefined(options.min) || !$d8f0cc4747dfcf2c$var$isUndefined(options.max) || !$d8f0cc4747dfcf2c$var$isUndefined(options.maxLength) || !$d8f0cc4747dfcf2c$var$isUndefined(options.minLength) || options.pattern || options.validate);
function $d8f0cc4747dfcf2c$var$schemaErrorLookup(errors, _fields, name) {
    const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, name);
    if (error && (error.type || error.message) || Array.isArray(error)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $d8f0cc4747dfcf2c$var$shouldRenderFormState = (formStateData, _proxyFormState, isRoot)=>{
    const keys = Object.keys(formStateData).filter((key)=>key !== 'name');
    return !keys.length || isRoot && keys.length >= Object.keys(_proxyFormState).length || keys.find((key)=>_proxyFormState[key] === (!isRoot || $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all));
};
const $d8f0cc4747dfcf2c$var$isNameMatch = (currentName, signalName, exact)=>exact ? currentName === signalName || currentName.startsWith(signalName + '.') : currentName.startsWith(signalName) || signalName.startsWith(currentName);
var $d8f0cc4747dfcf2c$var$shouldSubscribeByName = (name, signalName, exact)=>{
    if (!name || !signalName || name === signalName) return true;
    if (!Array.isArray(name)) return $d8f0cc4747dfcf2c$var$isNameMatch(name, signalName, exact);
    for (const currentName of name){
        if (currentName && $d8f0cc4747dfcf2c$var$isNameMatch(currentName, signalName, exact)) return true;
    }
    return false;
};
var $d8f0cc4747dfcf2c$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $d8f0cc4747dfcf2c$var$unsetEmptyArray = (ref, name)=>{
    const array = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(ref, name);
    !$d8f0cc4747dfcf2c$var$compact(array).length && !(array && array.root) && $d8f0cc4747dfcf2c$var$unset(ref, name);
};
const $d8f0cc4747dfcf2c$var$defaultOptions = {
    mode: $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $d8f0cc4747dfcf2c$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
const $d8f0cc4747dfcf2c$var$replaceDirtyFieldsInPlace = (dirtyFields, nextDirtyFields)=>{
    for(const key in dirtyFields)delete dirtyFields[key];
    Object.assign(dirtyFields, nextDirtyFields);
};
const $d8f0cc4747dfcf2c$var$DEFAULT_FORM_STATE = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {}
};
function $d8f0cc4747dfcf2c$export$1361f5e0e4cca3c3(props = {}) {
    let _options = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $d8f0cc4747dfcf2c$var$defaultOptions, props);
    let _formState = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $d8f0cc4747dfcf2c$var$cloneObject($d8f0cc4747dfcf2c$var$DEFAULT_FORM_STATE)), {
        isLoading: $d8f0cc4747dfcf2c$var$isFunction(_options.defaultValues),
        errors: $d8f0cc4747dfcf2c$var$cloneObject(_options.errors) || {},
        disabled: _options.disabled || false
    });
    let _fields = {};
    let _defaultValues = $d8f0cc4747dfcf2c$var$isObject(_options.defaultValues) || $d8f0cc4747dfcf2c$var$isObject(_options.values) ? $d8f0cc4747dfcf2c$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $d8f0cc4747dfcf2c$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        actionArrayLengths: new Map(),
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _dirtyFieldsStale = false;
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        registerName: new Set()
    };
    const delayErrorCallbacks = {};
    const timers = {};
    const _valuesSubscribers = new Set();
    let _validationModeBeforeSubmit = $d8f0cc4747dfcf2c$var$getValidationModes(_options.mode);
    let _validationModeAfterSubmit = $d8f0cc4747dfcf2c$var$getValidationModes(_options.reValidateMode);
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, defaultProxyFormState);
    const _proxySubscribeFormState = {};
    const _isTracked = (...keys)=>keys.some((key)=>_proxyFormState[key] || _proxySubscribeFormState[key]);
    const _hasValuesSubscriber = (name)=>{
        for (const subscriber of _valuesSubscribers){
            if ($d8f0cc4747dfcf2c$var$shouldSubscribeByName(subscriber.name, name, subscriber.exact)) return true;
        }
        return false;
    };
    const _subjects = {
        array: $d8f0cc4747dfcf2c$var$createSubject(),
        state: $d8f0cc4747dfcf2c$var$createSubject()
    };
    let _setValidCallId = 0;
    let _resetCallId = 0;
    let _registerCallId = 0;
    const _registerCallIds = {};
    let shouldDisplayAllAssociatedErrors = _options.criteriaMode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all;
    const debounce = (name, callback)=>(wait)=>{
            clearTimeout(timers[name]);
            timers[name] = setTimeout(callback, wait);
        };
    const cancelDelayedError = (name)=>{
        clearTimeout(timers[name]);
        delete timers[name];
        delete delayErrorCallbacks[name];
    };
    const cancelDelayedErrorTree = (name)=>{
        cancelDelayedError(name);
        const prefix = `${name}.`;
        for (const key of Object.keys(delayErrorCallbacks))key.startsWith(prefix) && cancelDelayedError(key);
    };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_isTracked('isValid') || shouldUpdateValid)) {
            const callId = ++_setValidCallId;
            let isValid;
            if (_options.resolver) {
                isValid = $d8f0cc4747dfcf2c$var$isEmptyObject((await _runSchema()).errors);
                callId === _setValidCallId && _updateIsValidating();
            } else isValid = await executeBuiltInValidation({
                fields: _fields,
                onlyCheckValid: true,
                eventType: $d8f0cc4747dfcf2c$var$EVENTS.VALID
            });
            if (callId === _setValidCallId && isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateValidatingFields = (names, isValidating)=>{
        const fieldNames = [
            ...names
        ];
        if (!fieldNames.some((name)=>name && (isValidating ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.validatingFields, name) !== true : $d8f0cc4747dfcf2c$var$has(_formState.validatingFields, name)))) return;
        const validatingFields = $d8f0cc4747dfcf2c$var$cloneObject(_formState.validatingFields);
        for (const name of fieldNames)if (name) isValidating ? $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(validatingFields, name, true) : $d8f0cc4747dfcf2c$var$unset(validatingFields, name);
        if (!$d8f0cc4747dfcf2c$var$deepEqual(_formState.validatingFields, validatingFields)) _formState.validatingFields = validatingFields;
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && _isTracked('isValidating', 'validatingFields')) {
            _updateValidatingFields(names || _names.mount, isValidating);
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$d8f0cc4747dfcf2c$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateDirtyFields = ()=>{
        _formState.dirtyFields = $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields);
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            _state.keepIsValid = false;
            const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
            const rootField = field && field._f;
            const fields = rootField ? Object.assign([], field) : field;
            if (!_state.actionArrayLengths.has(name)) _state.actionArrayLengths.set(name, Array.isArray(fields) ? fields.length : 0);
            if (shouldUpdateFieldsAndState && Array.isArray(fields)) {
                const fieldValues = method(fields, args.argA, args.argB) || fields;
                rootField ? $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_fields, name, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, fieldValues), {
                    _f: rootField
                })) : shouldSetValues && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            const fieldArrayErrors = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name);
            if (shouldUpdateFieldsAndState && Array.isArray(fieldArrayErrors)) {
                const rootError = fieldArrayErrors.root;
                const errors = method(fieldArrayErrors, args.argA, args.argB) || fieldArrayErrors;
                if (rootError) errors.root = rootError;
                shouldSetValues && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $d8f0cc4747dfcf2c$var$unsetEmptyArray(_formState.errors, name);
                _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
            }
            const touchedFieldsArray = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.touchedFields, name);
            const shouldUpdateTouchedFields = shouldUpdateFieldsAndState && Array.isArray(touchedFieldsArray);
            if (shouldUpdateTouchedFields) {
                const touchedFields = method(touchedFieldsArray, args.argA, args.argB);
                shouldSetValues && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            const dirtyFieldsArray = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            if (shouldUpdateFieldsAndState && Array.isArray(dirtyFieldsArray)) {
                const dirtyFields = method(dirtyFieldsArray, args.argA, args.argB) || dirtyFieldsArray;
                shouldSetValues && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, dirtyFields);
            }
            if (_isTracked('dirtyFields')) _updateDirtyFields();
            else _dirtyFieldsStale = true;
            _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields
            }, shouldUpdateTouchedFields && {
                touchedFields: _formState.touchedFields
            }), {
                errors: _formState.errors,
                isValid: _formState.isValid
            }));
        } else $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        Object.keys(delayErrorCallbacks).forEach(cancelDelayedError);
        const hasErrors = !$d8f0cc4747dfcf2c$var$isEmptyObject(errors);
        _formState.errors = $d8f0cc4747dfcf2c$var$cloneObject(errors);
        _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({
            errors: _formState.errors
        }, hasErrors ? {
            isValid: false
        } : {}));
        !hasErrors && _state.mount && _setValid();
    };
    const toPath = (name)=>$d8f0cc4747dfcf2c$var$isKey(name) ? [
            name
        ] : $d8f0cc4747dfcf2c$var$stringToPath(name);
    const hasExplicitNullIntermediate = (name)=>{
        const segments = toPath(name);
        let formValues = _formValues;
        let defaultValues = _defaultValues;
        for(let i = 0; i < segments.length - 1; i++){
            const key = segments[i];
            formValues = $d8f0cc4747dfcf2c$var$isNullOrUndefined(formValues) ? formValues : formValues[key];
            defaultValues = $d8f0cc4747dfcf2c$var$isNullOrUndefined(defaultValues) ? defaultValues : defaultValues[key];
            if (formValues === null && defaultValues !== null) return true;
        }
        return false;
    };
    const isStaleArrayField = (name)=>{
        if (!_state.actionArrayLengths.size) return false;
        const segments = toPath(name);
        let node = _formValues;
        let path = '';
        let ownerDepth = -1;
        let ownerPreActionLength = 0;
        for(let i = 0; i < segments.length; i++){
            if ($d8f0cc4747dfcf2c$var$isNullOrUndefined(node)) return false;
            const key = segments[i];
            path = path ? `${path}.${key}` : key;
            if (Array.isArray(node) && +key >= node.length) return ownerDepth === -1 ? false : i === ownerDepth ? +key < ownerPreActionLength : true;
            if (_state.actionArrayLengths.has(path)) {
                ownerDepth = i + 1;
                ownerPreActionLength = _state.actionArrayLengths.get(path);
            }
            node = node[key];
            if ($d8f0cc4747dfcf2c$var$isUndefined(node) && ownerDepth !== -1 && i > ownerDepth && +segments[ownerDepth] < ownerPreActionLength) return true;
        }
        return false;
    };
    const isPastArrayEnd = (name)=>{
        let node = _formValues;
        for (const key of toPath(name)){
            if (Array.isArray(node) && +key >= node.length) return true;
            node = node && node[key];
        }
        return false;
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            if (hasExplicitNullIntermediate(name) || isStaleArrayField(name)) return;
            const wasUnsetInFormValues = $d8f0cc4747dfcf2c$var$isUndefined($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name));
            const defaultValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name, $d8f0cc4747dfcf2c$var$isUndefined(value1) ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            const isEditedBeforeReady = !!ref && !_formState.isReady && $d8f0cc4747dfcf2c$var$isEdited(ref);
            if ($d8f0cc4747dfcf2c$var$isUndefined(defaultValue) || ref && ref.defaultChecked || isEditedBeforeReady || shouldSkipSetValueAs) {
                const fieldValue = shouldSkipSetValueAs ? defaultValue : $d8f0cc4747dfcf2c$var$getFieldValue(field._f);
                if (!$d8f0cc4747dfcf2c$var$isUndefined(fieldValue) || !isPastArrayEnd(name)) {
                    if (_isTracked('dirtyFields') && !$d8f0cc4747dfcf2c$var$deepEqual($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name), fieldValue)) _dirtyFieldsStale = true;
                    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
                    if (isEditedBeforeReady) updateTouchAndDirty(name, fieldValue);
                }
            } else setFieldValue(name, defaultValue);
            if (_state.mount && !_state.action) {
                if (_options.resolver && _isTracked('isValidating', 'validatingFields')) Promise.resolve().then(()=>_setValid());
                else _setValid();
                if (wasUnsetInFormValues && _formState.isDirty && _isTracked('isDirty')) {
                    const isDirty = _getDirty();
                    if (!isDirty) {
                        _formState.isDirty = false;
                        _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState));
                    }
                }
                if (_options.shouldUnregister && wasUnsetInFormValues && !$d8f0cc4747dfcf2c$var$isUndefined($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name)) && $d8f0cc4747dfcf2c$var$isWatched(name, _names)) _state.watch = true;
            }
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled || shouldDirty === true) {
            if (!isBlurEvent || shouldDirty) {
                const isCurrentFieldPristine = $d8f0cc4747dfcf2c$var$deepEqual($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                if (_isTracked('isDirty')) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = !isCurrentFieldPristine || _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                isPreviousDirty = !!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                if (isCurrentFieldPristine) $d8f0cc4747dfcf2c$var$unset(_formState.dirtyFields, name);
                else {
                    const defaultFieldValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name);
                    const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
                    const dirtyValue = !(field && field._f) && ($d8f0cc4747dfcf2c$var$isObject(defaultFieldValue) || Array.isArray(defaultFieldValue)) ? $d8f0cc4747dfcf2c$var$getDirtyFields(defaultFieldValue, fieldValue, undefined, field) : true;
                    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, dirtyValue);
                }
                let didResyncDirtyFields = false;
                if (_dirtyFieldsStale || isCurrentFieldPristine && (_isTracked('isDirty') ? _formState.isDirty : _getDirty())) {
                    _dirtyFieldsStale = false;
                    const nextDirtyFields = $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields);
                    if (!$d8f0cc4747dfcf2c$var$deepEqual(_formState.dirtyFields, nextDirtyFields)) {
                        didResyncDirtyFields = true;
                        $d8f0cc4747dfcf2c$var$replaceDirtyFieldsInPlace(_formState.dirtyFields, nextDirtyFields);
                    }
                }
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _isTracked('dirtyFields') && (didResyncDirtyFields || isPreviousDirty !== !isCurrentFieldPristine);
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $d8f0cc4747dfcf2c$var$has(_formState.touchedFields, name) ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.touchedFields, name) : undefined;
                if (!isPreviousFieldTouched) {
                    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _isTracked('touchedFields') && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _isTracked('isValid') && $d8f0cc4747dfcf2c$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallbacks[name] = debounce(name, ()=>updateErrors(name, error));
            delayErrorCallbacks[name](_options.delayError);
        } else {
            cancelDelayedError(name);
            error ? $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $d8f0cc4747dfcf2c$var$unset(_formState.errors, name);
            _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        }
        if ((error ? !$d8f0cc4747dfcf2c$var$deepEqual(previousFieldError, error, true) : previousFieldError) || !$d8f0cc4747dfcf2c$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, fieldState, shouldUpdateValid && $d8f0cc4747dfcf2c$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        return await _options.resolver(_formValues, _options.context, $d8f0cc4747dfcf2c$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const resetCallId = _resetCallId;
        const registerCallId = _registerCallId;
        const registeredNames = names ? names.filter((name)=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name)) : [];
        const { errors: errors } = await _runSchema(names);
        if (resetCallId !== _resetCallId) return errors;
        _updateIsValidating(names);
        if (names) {
            for (const name of names){
                if (registeredNames.includes(name) && (!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name) || _registerCallIds[name] > registerCallId)) {
                    $d8f0cc4747dfcf2c$var$unset(errors, name);
                    continue;
                }
                const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, name);
                cancelDelayedErrorTree(name);
                const isFieldArrayRootError = _names.array.has(name) && $d8f0cc4747dfcf2c$var$isObject(error) && !Object.keys(error).some((key)=>!Number.isNaN(Number(key)));
                const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
                const hasNestedFields = $d8f0cc4747dfcf2c$var$isObject(field) && Object.keys(field).some((key)=>key !== '_f');
                isFieldArrayRootError ? $d8f0cc4747dfcf2c$var$updateFieldArrayRootError(_formState.errors, {
                    [name]: error
                }, name) : error && (error.type || error.message) || Array.isArray(error) || $d8f0cc4747dfcf2c$var$isObject(error) && hasNestedFields ? $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $d8f0cc4747dfcf2c$var$unset(_formState.errors, name);
            }
            _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        } else {
            Object.keys(delayErrorCallbacks).forEach(cancelDelayedError);
            _formState.errors = errors;
        }
        return errors;
    };
    const validateForm = async ({ name: name, eventType: eventType })=>{
        if (_options.validate) {
            const resetCallId = _resetCallId;
            const result = await _options.validate({
                formValues: _formValues,
                formState: _formState,
                name: name,
                eventType: eventType
            });
            if (resetCallId !== _resetCallId) return true;
            if ($d8f0cc4747dfcf2c$var$isObject(result)) {
                let isValid = true;
                clearErrors($d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE);
                for(const key in result){
                    const error = result[key];
                    if (error) {
                        isValid = false;
                        setError(`${$d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE}.${key}`, {
                            message: $d8f0cc4747dfcf2c$var$isString(error.message) ? error.message : '',
                            type: error.type || $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.validate
                        });
                    }
                }
                return isValid;
            } else if ($d8f0cc4747dfcf2c$var$isString(result) || !result) {
                setError($d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE, {
                    message: result || '',
                    type: $d8f0cc4747dfcf2c$var$INPUT_VALIDATION_RULES.validate
                });
                return false;
            } else {
                clearErrors($d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE);
                return true;
            }
        }
        return true;
    };
    const executeBuiltInValidation = async ({ fields: fields, onlyCheckValid: onlyCheckValid, name: name, eventType: eventType, context: context = {
        valid: true,
        runRootValidation: false
    } })=>{
        const resetCallId = _resetCallId;
        if (_options.validate && !context.runRootValidation) {
            context.runRootValidation = true;
            const result = await validateForm({
                name: name,
                eventType: eventType
            });
            if (!result) {
                context.valid = false;
                if (onlyCheckValid) return context.valid;
            }
        }
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $287e58e413d8005e$export$71511d61b312f219)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $d8f0cc4747dfcf2c$var$hasPromiseValidation(field._f);
                    const shouldTrackIsValidatingState = _isTracked('isValidating', 'validatingFields');
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ], true);
                    const registerCallId = _registerCallId;
                    const fieldError = await $d8f0cc4747dfcf2c$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !onlyCheckValid, isFieldArrayRoot);
                    if (resetCallId !== _resetCallId) return context.valid;
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ]);
                    if (!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, _f.name) || _registerCallIds[_f.name] > registerCallId) continue;
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (onlyCheckValid) break;
                    }
                    if (!onlyCheckValid) {
                        cancelDelayedError(_f.name);
                        $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $d8f0cc4747dfcf2c$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $d8f0cc4747dfcf2c$var$unset(_formState.errors, _f.name);
                    }
                    if (_options.shouldUseNativeValidation && fieldError[_f.name]) break;
                }
                !$d8f0cc4747dfcf2c$var$isEmptyObject(fieldValue) && await executeBuiltInValidation({
                    context: context,
                    onlyCheckValid: onlyCheckValid,
                    fields: fieldValue,
                    name: name,
                    eventType: eventType
                });
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$d8f0cc4747dfcf2c$var$live(ref)) : !$d8f0cc4747dfcf2c$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && !$d8f0cc4747dfcf2c$var$isUndefined(data) && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, data), !$d8f0cc4747dfcf2c$var$deepEqual(_state.mount ? _formValues : _defaultValues, _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>{
        const values = _state.mount ? _formValues : $d8f0cc4747dfcf2c$var$isUndefined(defaultValue) || !$d8f0cc4747dfcf2c$var$isUndefined(names) ? _defaultValues : defaultValue;
        return $d8f0cc4747dfcf2c$var$generateWatchOutput(names, _names, $d8f0cc4747dfcf2c$var$isUndefined(names) ? (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values) : values, isGlobal, defaultValue);
    };
    const _getFieldArray = (name)=>$d8f0cc4747dfcf2c$var$compact($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {}, skipClone = false, skipRender = false, skipValueRender = false)=>{
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, $d8f0cc4747dfcf2c$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $d8f0cc4747dfcf2c$var$isHTMLElement(fieldReference.ref) && $d8f0cc4747dfcf2c$var$isNullOrUndefined(value1) ? '' : value1;
                if ($d8f0cc4747dfcf2c$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($d8f0cc4747dfcf2c$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($d8f0cc4747dfcf2c$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type && !skipRender && !skipValueRender) _subjects.state.next({
                        name: name,
                        values: skipClone ? _formValues : _hasValuesSubscriber(name) ? $d8f0cc4747dfcf2c$var$cloneObject(_formValues) : undefined
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, field && field._f && !field._f.disabled && (field._f.valueAsNumber || field._f.valueAsDate || field._f.setValueAs) ? $d8f0cc4747dfcf2c$var$getFieldValueAs(value1, field._f) : fieldValue, options.shouldTouch, options.shouldDirty, !skipRender);
        options.shouldValidate && trigger(name, {
            delayError: options.delayError
        });
        if (options.shouldValidate && field && field._f && field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0)) trigger(field._f.deps);
    };
    const setFieldValues = (name, value1, options, skipClone = false, skipRender = false, skipValueRender = false)=>{
        for(const fieldKey in value1){
            if (!Object.prototype.hasOwnProperty.call(value1, fieldKey)) continue;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, fieldName);
            if (_names.array.has(fieldName)) _subjects.array.next({
                name: fieldName,
                values: skipClone ? _formValues : $d8f0cc4747dfcf2c$var$cloneObject(_formValues)
            });
            (_names.array.has(name) || $d8f0cc4747dfcf2c$var$isObject(fieldValue) || field && !field._f) && !$d8f0cc4747dfcf2c$var$isDateObject(fieldValue) ? setFieldValues(fieldName, fieldValue, options, skipClone, skipRender, skipValueRender) : setFieldValue(fieldName, fieldValue, options, skipClone, skipRender, skipValueRender);
        }
    };
    const _setValue = (name, value1, options, skipClone, skipStateEmit = false)=>{
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = skipClone ? value1 : $d8f0cc4747dfcf2c$var$cloneObject(value1);
        const previousValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name);
        const isValueUnchanged = $d8f0cc4747dfcf2c$var$deepEqual(previousValue, cloneValue);
        if (!isValueUnchanged) $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: skipClone ? _formValues : $d8f0cc4747dfcf2c$var$cloneObject(_formValues)
            });
            if (_isTracked('isDirty', 'dirtyFields') && options.shouldDirty) {
                _updateDirtyFields();
                _formState.isDirty = _getDirty(name, cloneValue);
                if (!skipStateEmit) _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _formState.isDirty
                });
            }
            options.shouldValidate && trigger(name, {
                delayError: options.delayError
            });
        } else {
            const isEmpty = Array.isArray(cloneValue) && !cloneValue.length || $d8f0cc4747dfcf2c$var$isEmptyObject(cloneValue);
            const skipValueRender = !isValueUnchanged && !skipStateEmit;
            if (!field || field._f || $d8f0cc4747dfcf2c$var$isNullOrUndefined(cloneValue) || isEmpty) setFieldValue(name, cloneValue, options, skipClone, skipStateEmit, skipValueRender);
            else setFieldValues(name, cloneValue, options, skipClone, skipStateEmit, skipValueRender);
        }
        if (!isValueUnchanged && !skipStateEmit) {
            const watched = $d8f0cc4747dfcf2c$var$isWatched(name, _names);
            const emittedName = _state.mount || watched ? name : undefined;
            const fieldArrayItemNames = isFieldArray ? [] : $d8f0cc4747dfcf2c$var$getFieldArrayItemNames(_names.array, name);
            const values = skipClone ? _formValues : _hasValuesSubscriber(emittedName) || fieldArrayItemNames.some(_hasValuesSubscriber) ? $d8f0cc4747dfcf2c$var$cloneObject(_formValues) : undefined;
            _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, watched && _formState), {
                name: emittedName,
                values: values
            }));
            for (const itemName of fieldArrayItemNames)_subjects.state.next({
                name: itemName,
                values: values
            });
        }
    };
    const setValue = (name, value1, options = {})=>_setValue(name, value1, options, false);
    const setValues = (formValues, options = {})=>{
        const updatedFormValues = $d8f0cc4747dfcf2c$var$isFunction(formValues) ? formValues(_formValues) : formValues;
        if (!$d8f0cc4747dfcf2c$var$deepEqual(_formValues, updatedFormValues)) {
            _formValues = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formValues, updatedFormValues);
            for (const fieldName of new Set([
                ..._names.mount,
                ..._names.array
            ]))if ($d8f0cc4747dfcf2c$var$has(updatedFormValues, fieldName)) _setValue(fieldName, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(updatedFormValues, fieldName), options, true, true);
            _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState), {
                name: undefined,
                type: undefined
            }), _valuesSubscribers.size ? {
                values: _formValues
            } : {}));
            if (options.shouldValidate) _setValid();
        }
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        const registerCallId = _registerCallId;
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = !!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name) && !(_registerCallIds[name] > registerCallId) && $d8f0cc4747dfcf2c$var$deepEqual(fieldValue, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            _state.keepIsValid = false;
            let error;
            let isValid;
            let shouldFlushError = false;
            const fieldValue = target.type ? $d8f0cc4747dfcf2c$var$getFieldValue(field._f) : $d8f0cc4747dfcf2c$var$getEventValue(event);
            const isBlurEvent = event.type === $d8f0cc4747dfcf2c$var$EVENTS.BLUR || event.type === $d8f0cc4747dfcf2c$var$EVENTS.FOCUS_OUT;
            const hasNoValidationEffect = !$d8f0cc4747dfcf2c$var$hasValidation(field._f) && !_options.validate && !_options.resolver && !$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps;
            const shouldSkipValidation = hasNoValidationEffect || $d8f0cc4747dfcf2c$var$skipValidation(isBlurEvent, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, _validationModeAfterSubmit, _validationModeBeforeSubmit);
            const watched = $d8f0cc4747dfcf2c$var$isWatched(name, _names, isBlurEvent);
            $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, name, $d8f0cc4747dfcf2c$var$cloneObject(fieldValue));
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    if (Object.prototype.hasOwnProperty.call(delayErrorCallbacks, name)) {
                        shouldFlushError = true;
                        delayErrorCallbacks[name](0);
                    }
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$d8f0cc4747dfcf2c$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({
                name: name,
                type: event.type
            }, _hasValuesSubscriber(name) ? {
                values: $d8f0cc4747dfcf2c$var$cloneObject(_formValues)
            } : {}));
            if (shouldSkipValidation) {
                if ((!hasNoValidationEffect || !_formState.isValid) && _isTracked('isValid')) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({
                    name: name
                }, watched ? {} : fieldState));
            }
            if (!_options.resolver && _options.validate) await validateForm({
                name: name,
                eventType: event.type
            });
            !isBlurEvent && watched && _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState));
            if (_options.resolver) {
                const resetCallId = _resetCallId;
                const { errors: errors } = await _runSchema([
                    name
                ]);
                if (resetCallId !== _resetCallId) return;
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (!isFieldValueUpdated) {
                    !$d8f0cc4747dfcf2c$var$isEmptyObject(fieldState) && _subjects.state.next(fieldState);
                    return;
                }
                const previousErrorLookupResult = $d8f0cc4747dfcf2c$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $d8f0cc4747dfcf2c$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $d8f0cc4747dfcf2c$var$isEmptyObject(errors);
            } else {
                const resetCallId = _resetCallId;
                const setValidCallId = ++_setValidCallId;
                _updateIsValidating([
                    name
                ], true);
                error = (await $d8f0cc4747dfcf2c$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                if (resetCallId !== _resetCallId) return;
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_isTracked('isValid')) {
                        isValid = await executeBuiltInValidation({
                            fields: _fields,
                            onlyCheckValid: true,
                            name: name,
                            eventType: event.type
                        });
                        if (resetCallId !== _resetCallId) return;
                        _updateIsFieldValueUpdated(fieldValue);
                        if (setValidCallId !== _setValidCallId) isValid = undefined;
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
                shouldFlushError && Object.prototype.hasOwnProperty.call(delayErrorCallbacks, name) && delayErrorCallbacks[name](0);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        _state.keepIsValid = false;
        let isValid;
        let validationResult;
        const fieldNames = $d8f0cc4747dfcf2c$var$convertToArrayPayload(name);
        const resetCallId = _resetCallId;
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($d8f0cc4747dfcf2c$var$isUndefined(name) ? name : fieldNames);
            isValid = $d8f0cc4747dfcf2c$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation({
                    fields: field && field._f ? {
                        [fieldName]: field
                    } : field,
                    eventType: $d8f0cc4747dfcf2c$var$EVENTS.TRIGGER
                });
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation({
            fields: _fields,
            name: name,
            eventType: $d8f0cc4747dfcf2c$var$EVENTS.TRIGGER
        });
        if (resetCallId !== _resetCallId) return validationResult;
        if (options.delayError && _options.delayError && $d8f0cc4747dfcf2c$var$isString(name)) {
            const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name);
            if (error) {
                $d8f0cc4747dfcf2c$var$unset(_formState.errors, name);
                delayErrorCallbacks[name] = debounce(name, ()=>updateErrors(name, error));
                delayErrorCallbacks[name](_options.delayError);
            } else cancelDelayedError(name);
        }
        if (options.shouldTouch) for (const fieldName of name ? fieldNames : _names.mount)!_names.array.has(fieldName) && $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.touchedFields, fieldName, true);
        _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, !$d8f0cc4747dfcf2c$var$isString(name) || _isTracked('isValid') && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver || !name ? {
            isValid: isValid
        } : {}, options.shouldTouch && _isTracked('touchedFields') ? {
            touchedFields: _formState.touchedFields
        } : {}), {
            errors: _formState.errors
        }));
        options.shouldFocus && !validationResult && $d8f0cc4747dfcf2c$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = $d8f0cc4747dfcf2c$var$isUndefined(fieldNames) && !config ? (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _state.mount ? _formValues : _defaultValues) : _state.mount ? _formValues : _defaultValues;
        if (config) values = $d8f0cc4747dfcf2c$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $d8f0cc4747dfcf2c$var$isUndefined(fieldNames) ? values : $d8f0cc4747dfcf2c$var$isString(fieldNames) ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, name));
    };
    const getErrors = (fieldNames)=>$d8f0cc4747dfcf2c$var$isUndefined(fieldNames) ? (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors) : $d8f0cc4747dfcf2c$var$isString(fieldNames) ? $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, fieldNames) : fieldNames.map((name)=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name));
    const getFieldState = (name, formState)=>{
        const targetFormState = formState || _formState;
        const error = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(targetFormState.errors, name);
        return {
            invalid: !!error,
            isDirty: !!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(targetFormState.dirtyFields, name),
            error: error,
            isValidating: !!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(targetFormState.validatingFields, name),
            isTouched: !!$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(targetFormState.touchedFields, name)
        };
    };
    const clearErrors = (name)=>{
        const names = name ? $d8f0cc4747dfcf2c$var$convertToArrayPayload(name) : undefined;
        if (names) names.forEach((inputName)=>{
            cancelDelayedErrorTree(inputName);
            $d8f0cc4747dfcf2c$var$unset(_formState.errors, inputName);
            _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
            _subjects.state.next({
                name: inputName,
                errors: _formState.errors
            });
        });
        else {
            Object.keys(delayErrorCallbacks).forEach(cancelDelayedError);
            _formState.errors = {};
            _subjects.state.next({
                errors: _formState.errors
            });
        }
    };
    const setError = (name, error, options)=>{
        cancelDelayedErrorTree(name);
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        });
        const ref = field._f && field._f.ref;
        const currentError = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.errors, name) || {};
        const { ref: currentRef, message: message, type: type, types: types } = currentError, restOfErrorTree = (0, $287e58e413d8005e$export$71511d61b312f219)(currentError, [
            "ref",
            "message",
            "type",
            "types"
        ]);
        $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, restOfErrorTree, error), {
            ref: ref
        }));
        _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>{
        if ($d8f0cc4747dfcf2c$var$isFunction(name)) {
            const valuesSubscriber = {};
            _valuesSubscribers.add(valuesSubscriber);
            const { unsubscribe: unsubscribe } = _subjects.state.subscribe({
                next: (payload)=>'values' in payload && name(payload.values || _getWatch(undefined, defaultValue), payload)
            });
            return {
                unsubscribe: ()=>{
                    _valuesSubscribers.delete(valuesSubscriber);
                    unsubscribe();
                }
            };
        }
        return _getWatch(name, defaultValue, true);
    };
    const _subscribe = (props)=>{
        const valuesSubscriber = {
            name: props.name,
            exact: props.exact
        };
        props.formState && props.formState.values && _valuesSubscribers.add(valuesSubscriber);
        const { unsubscribe: unsubscribe } = _subjects.state.subscribe({
            next: (formState)=>{
                if ($d8f0cc4747dfcf2c$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $d8f0cc4747dfcf2c$var$shouldRenderFormState(formState, props.formState || _proxyFormState, props.reRenderRoot)) {
                    const values = formState.values || (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formValues);
                    props.callback((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState, formState), {
                        validatingFields: _formState.validatingFields,
                        isValidating: _formState.isValidating,
                        values: values,
                        defaultValues: _defaultValues
                    }));
                }
            }
        });
        return ()=>{
            _valuesSubscribers.delete(valuesSubscriber);
            unsubscribe();
        };
    };
    const subscribe = (props)=>{
        _state.mount = true;
        const trackedKeys = Object.keys(props.formState || {}).filter((key)=>props.formState && props.formState[key]);
        for (const key of trackedKeys)_proxySubscribeFormState[key] = (_proxySubscribeFormState[key] || 0) + 1;
        const unsubscribe = _subscribe((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props), {
            formState: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, defaultProxyFormState, props.formState)
        }));
        return ()=>{
            // splice(0) empties the list, so a repeated unsubscribe releases nothing
            for (const key of trackedKeys.splice(0))_proxySubscribeFormState[key]--;
            unsubscribe();
        };
    };
    const unregister = (name, options = {})=>{
        const fieldNames = name ? $d8f0cc4747dfcf2c$var$convertToArrayPayload(name) : _names.mount;
        if (!options.keepIsValidating) _updateValidatingFields(fieldNames);
        for (const fieldName of fieldNames){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            _names.disabled.delete(fieldName);
            $d8f0cc4747dfcf2c$var$unset(_fields, fieldName);
            !options.keepValue && $d8f0cc4747dfcf2c$var$unset(_formValues, fieldName);
            if (!options.keepError) {
                cancelDelayedErrorTree(fieldName);
                $d8f0cc4747dfcf2c$var$unset(_formState.errors, fieldName);
            }
            !options.keepDirty && $d8f0cc4747dfcf2c$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $d8f0cc4747dfcf2c$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $d8f0cc4747dfcf2c$var$unset(_defaultValues, fieldName);
        }
        if (!options.keepError) _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
        _valuesSubscribers.size && _subjects.state.next({
            values: $d8f0cc4747dfcf2c$var$cloneObject(_formValues)
        });
        _subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState, options.keepDirty ? {} : {
            isDirty: _getDirty()
        }, options.keepIsValidating ? {} : {
            isValidating: !$d8f0cc4747dfcf2c$var$isEmptyObject(_formState.validatingFields)
        }));
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($d8f0cc4747dfcf2c$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $d8f0cc4747dfcf2c$var$isBoolean(options.disabled) || $d8f0cc4747dfcf2c$var$isBoolean(_options.disabled);
        const shouldRevalidateRemount = !_names.registerName.has(name) && field && field._f && !field._f.mount;
        if (!field || !field._f) _registerCallIds[name] = ++_registerCallId;
        $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_fields, name, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, field || {}), {
            _f: (0, $7e9b970aebca32bd$export$71511d61b312f219)((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (field && field._f) {
            const nextField = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
            for (const rule of $d8f0cc4747dfcf2c$var$REGISTER_VALIDATION_RULES)if (!(rule in options)) delete nextField._f[rule];
        }
        if (field && !shouldRevalidateRemount) _setDisabledField({
            disabled: $d8f0cc4747dfcf2c$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, disabledIsDefined ? {
            disabled: options.disabled || _options.disabled
        } : {}, _options.progressive ? {
            required: !!$d8f0cc4747dfcf2c$var$getRuleValue(options.required),
            min: $d8f0cc4747dfcf2c$var$getRuleValue(options.min),
            max: $d8f0cc4747dfcf2c$var$getRuleValue(options.max),
            minLength: $d8f0cc4747dfcf2c$var$getRuleValue(options.minLength),
            maxLength: $d8f0cc4747dfcf2c$var$getRuleValue(options.maxLength),
            pattern: $d8f0cc4747dfcf2c$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    _names.registerName.add(name);
                    register(name, options);
                    _names.registerName.delete(name);
                    field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $d8f0cc4747dfcf2c$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $d8f0cc4747dfcf2c$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    const newField = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, field._f);
                    if (radioOrCheckbox) {
                        newField.refs = [
                            ...refs.filter($d8f0cc4747dfcf2c$var$live),
                            fieldRef,
                            ...Array.isArray($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                {}
                            ] : []
                        ];
                        newField.ref = {
                            type: fieldRef.type,
                            name: name
                        };
                    } else {
                        newField.ref = fieldRef;
                        delete newField.refs;
                    }
                    $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: newField
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($d8f0cc4747dfcf2c$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const _focusError = ()=>_options.shouldFocusError && !_options.shouldUseNativeValidation && $d8f0cc4747dfcf2c$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($d8f0cc4747dfcf2c$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $d8f0cc4747dfcf2c$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let result = undefined;
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $d8f0cc4747dfcf2c$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            const resetCallId = _resetCallId;
            const onSubmitError = (error)=>{
                if (resetCallId === _resetCallId) _subjects.state.next({
                    isSubmitting: false
                });
                throw error;
            };
            if (_options.resolver) {
                let validationResult;
                try {
                    validationResult = await _runSchema();
                } catch (error) {
                    onSubmitError(error);
                }
                const { errors: errors, values: values } = validationResult;
                if (resetCallId !== _resetCallId) return;
                _updateIsValidating();
                Object.keys(delayErrorCallbacks).forEach(cancelDelayedError);
                _formState.errors = errors;
                fieldValues = $d8f0cc4747dfcf2c$var$cloneObject(values);
            } else {
                try {
                    await executeBuiltInValidation({
                        fields: _fields,
                        eventType: $d8f0cc4747dfcf2c$var$EVENTS.SUBMIT
                    });
                } catch (error) {
                    onSubmitError(error);
                }
                if (resetCallId !== _resetCallId) return;
                $d8f0cc4747dfcf2c$var$unset(_formState.errors, $d8f0cc4747dfcf2c$var$ROOT_ERROR_TYPE);
                _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
            }
            if (_names.disabled.size) for (const name of _names.disabled)$d8f0cc4747dfcf2c$var$unset(fieldValues, name);
            if ($d8f0cc4747dfcf2c$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    result = await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) try {
                    await onInvalid((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors), e);
                } catch (error) {
                    onSubmitError(error);
                }
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $d8f0cc4747dfcf2c$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
            return result;
        };
    const resetField = (name, options = {})=>{
        if ($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name)) {
            _updateValidatingFields([
                name
            ]);
            if ($d8f0cc4747dfcf2c$var$isUndefined(options.defaultValue)) setValue(name, $d8f0cc4747dfcf2c$var$cloneObject($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_defaultValues, name, $d8f0cc4747dfcf2c$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $d8f0cc4747dfcf2c$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $d8f0cc4747dfcf2c$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = !$d8f0cc4747dfcf2c$var$isUndefined(options.defaultValue) ? _getDirty(name, $d8f0cc4747dfcf2c$var$cloneObject($d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                cancelDelayedErrorTree(name);
                $d8f0cc4747dfcf2c$var$unset(_formState.errors, name);
                _formState.errors = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState.errors);
                _setValid();
            }
            _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState), {
                isValidating: !$d8f0cc4747dfcf2c$var$isEmptyObject(_formState.validatingFields)
            }));
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        _resetCallId++;
        _setValidCallId++;
        const updatedValues = formValues ? $d8f0cc4747dfcf2c$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $d8f0cc4747dfcf2c$var$cloneObject(updatedValues);
        const isEmptyResetValues = $d8f0cc4747dfcf2c$var$isEmptyObject(formValues);
        const values = cloneUpdatedValues;
        const fieldRefs = _fields;
        Object.keys(delayErrorCallbacks).forEach(cancelDelayedError);
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...$d8f0cc4747dfcf2c$var$collectDirtyFieldNames($d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, fieldRefs), _formState.dirtyFields)
                ]);
                for (const fieldName of fieldsToCheck){
                    const isDirty = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName);
                    const existingValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_formValues, fieldName);
                    const newValue = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, fieldName);
                    if (isDirty && !$d8f0cc4747dfcf2c$var$isUndefined(existingValue)) $d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(values, fieldName, existingValue);
                    else if (!isDirty && !$d8f0cc4747dfcf2c$var$isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if ($d8f0cc4747dfcf2c$var$isWeb && $d8f0cc4747dfcf2c$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($d8f0cc4747dfcf2c$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            if (_options.shouldUnregister) {
                _formValues = keepStateOptions.keepDefaultValues ? $d8f0cc4747dfcf2c$var$cloneObject(_defaultValues) : {};
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)$d8f0cc4747dfcf2c$export$adaa4cf7ef1b65be(_formValues, fieldName, $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(values, fieldName));
            } else _formValues = $d8f0cc4747dfcf2c$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values)
            });
            _subjects.state.next({
                name: undefined,
                type: undefined,
                values: (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values)
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            registerName: new Set(),
            disabled: keepStateOptions.keepValues || keepStateOptions.keepDirtyValues || keepStateOptions.keepFieldsRef ? new Set([
                ..._names.disabled
            ].filter((name)=>$d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name))) : new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$d8f0cc4747dfcf2c$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        _state.actionArrayLengths.clear();
        _dirtyFieldsStale = false;
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : keepStateOptions.keepValues ? _getDirty() : !!(keepStateOptions.keepDefaultValues && formValues && !$d8f0cc4747dfcf2c$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, fieldRefs) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, formValues, undefined, fieldRefs) : keepStateOptions.keepDirty ? _formState.dirtyFields : keepStateOptions.keepValues ? $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, fieldRefs) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {}
        }, !keepStateOptions.keepIsValidating && (_formState.isValidating || !$d8f0cc4747dfcf2c$var$isEmptyObject(_formState.validatingFields)) ? {
            validatingFields: {},
            isValidating: false
        } : null), {
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        }));
    };
    const reset = (formValues, keepStateOptions)=>_reset($d8f0cc4747dfcf2c$var$isFunction(formValues) ? formValues(_formValues) : formValues, (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _options.resetOptions, keepStateOptions));
    const setFocus = (name, options = {})=>{
        const field = $d8f0cc4747dfcf2c$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && $d8f0cc4747dfcf2c$var$isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        // `name`, `type`, and `values` describe the event that produced this
        // update, not the form's persisted state (they aren't part of
        // `FormState`). Merging them in would leak a stale `name`/`type` from
        // one event into a later, unrelated notification that doesn't specify
        // its own.
        const { name: name, type: type, values: values } = updatedFormState, formState = (0, $287e58e413d8005e$export$71511d61b312f219)(updatedFormState, [
            "name",
            "type",
            "values"
        ]);
        if (Object.keys(formState).length) _formState = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState, formState);
    };
    _subjects.state.subscribe({
        next: _setFormState
    });
    const _resetDefaultValues = ()=>$d8f0cc4747dfcf2c$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const resetDefaultValues = (values, options = {})=>{
        _defaultValues = $d8f0cc4747dfcf2c$var$cloneObject(values);
        if (!options.keepDirty) {
            const newDirtyFields = $d8f0cc4747dfcf2c$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields);
            _formState.dirtyFields = newDirtyFields;
            _formState.isDirty = !$d8f0cc4747dfcf2c$var$isEmptyObject(newDirtyFields);
        }
        if (!options.keepIsValid) _setValid();
        _subjects.state.next((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _formState), {
            defaultValues: _defaultValues
        }));
    };
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _updateIsValidating: _updateIsValidating,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, _options, value);
                _validationModeBeforeSubmit = $d8f0cc4747dfcf2c$var$getValidationModes(_options.mode);
                _validationModeAfterSubmit = $d8f0cc4747dfcf2c$var$getValidationModes(_options.reValidateMode);
                shouldDisplayAllAssociatedErrors = _options.criteriaMode === $d8f0cc4747dfcf2c$var$VALIDATION_MODE.all;
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        setValues: setValues,
        getValues: getValues,
        getErrors: getErrors,
        reset: reset,
        resetField: resetField,
        resetDefaultValues: resetDefaultValues,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, methods), {
        formControl: methods
    });
}
const $d8f0cc4747dfcf2c$var$RESET_OPTIONS = {
    mode: $d8f0cc4747dfcf2c$var$defaultOptions.mode,
    reValidateMode: $d8f0cc4747dfcf2c$var$defaultOptions.reValidateMode,
    shouldFocusError: $d8f0cc4747dfcf2c$var$defaultOptions.shouldFocusError,
    resolver: undefined,
    criteriaMode: undefined,
    delayError: undefined,
    shouldUnregister: undefined,
    shouldUseNativeValidation: undefined,
    context: undefined,
    progressive: undefined,
    resetOptions: undefined
};
/**
 * Core hook for managing a form. Returns all methods and state for
 * registration, validation, and submission.
 *
 * @see [API](https://react-hook-form.com/docs/useform)
 *
 * @example
 * ```tsx
 * const { register, handleSubmit, formState: { errors } } = useForm<FormValues>();
 * <form onSubmit={handleSubmit(onSubmit)}>
 *   <input {...register("email", { required: true })} />
 * </form>
 * ```
 */ function $d8f0cc4747dfcf2c$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(undefined);
    const _formControlProp = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(props.formControl);
    const _hadDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    const _hadValidate = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(!!props.validate);
    const _hadErrors = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(!!props.errors);
    const _isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(false);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(()=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, $d8f0cc4747dfcf2c$var$cloneObject($d8f0cc4747dfcf2c$var$DEFAULT_FORM_STATE)), {
            isLoading: $d8f0cc4747dfcf2c$var$isFunction(props.defaultValues),
            errors: props.errors || {},
            disabled: props.disabled || false,
            defaultValues: $d8f0cc4747dfcf2c$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
        }));
    if (!_formControl.current || props.formControl && _formControlProp.current !== props.formControl) {
        _formControlProp.current = props.formControl;
        _hadDisabled.current = false;
        if (props.formControl) {
            _formControl.current = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props.formControl), {
                formState: formState
            });
            if (props.defaultValues && !$d8f0cc4747dfcf2c$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const _createFormControl = $d8f0cc4747dfcf2c$export$1361f5e0e4cca3c3(props), { formControl: formControl } = _createFormControl, rest = (0, $287e58e413d8005e$export$71511d61b312f219)(_createFormControl, [
                "formControl"
            ]);
            _formControl.current = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, rest), {
                formState: formState
            });
        }
    }
    const control = _formControl.current.control;
    const previousOptions = control._options;
    const removedOptions = {};
    for(const key in $d8f0cc4747dfcf2c$var$RESET_OPTIONS)if (key in previousOptions && !(key in props)) removedOptions[key] = $d8f0cc4747dfcf2c$var$RESET_OPTIONS[key];
    if (_hadDisabled.current && !props.disabled) removedOptions.disabled = false;
    control._options = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, removedOptions, props), {
        validate: props.validate
    });
    const getCurrentFormState = ()=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState), {
            defaultValues: control._defaultValues
        });
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $d8f0cc4747dfcf2c$var$useResyncOnReconnect(getCurrentFormState);
    $d8f0cc4747dfcf2c$var$useIsomorphicLayoutEffect(()=>{
        resyncIfNeeded(true, getCurrentFormState, updateFormState);
        const unsubscribe = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState), {
                    defaultValues: control._defaultValues
                })),
            reRenderRoot: true
        });
        updateFormState((data)=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, data), {
                isReady: true
            }));
        control._formState.isReady = true;
        control._subjects.state.next({
            isReady: true
        });
        return ()=>{
            unsubscribe();
            snapshot(true, getCurrentFormState);
        };
    }, [
        control,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        control._disableForm(_hadDisabled.current && !props.disabled ? false : props.disabled);
        _hadDisabled.current = !!props.disabled;
    }, [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        } else if (_hadErrors.current) control._setErrors({});
        _hadErrors.current = !!props.errors;
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (_hadValidate.current && !props.validate) _formControl.current && _formControl.current.clearErrors($d8f0cc4747dfcf2c$var$FORM_ERROR_TYPE);
        _hadValidate.current = !!props.validate;
    }, [
        props.validate
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (props.values && !$d8f0cc4747dfcf2c$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                keepFieldsRef: true
            }, control._options.resetOptions));
            if (!(control._options.resetOptions && control._options.resetOptions.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>(0, $7e9b970aebca32bd$export$71511d61b312f219)({}, state));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useEffect(()=>{
        if (!control._state.mount || !_isMounted.current && !props.values) {
            control._setValid();
            control._state.mount = true;
        }
        _isMounted.current = true;
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>$d8f0cc4747dfcf2c$var$getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
const $d8f0cc4747dfcf2c$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createContext(null);
$d8f0cc4747dfcf2c$var$HookFormContext.displayName = 'HookFormContext';
/**
 * Retrieves all `useForm` methods from the nearest `FormProvider`.
 * Use in deeply nested components to avoid prop-drilling.
 *
 * @see [API](https://react-hook-form.com/docs/useformcontext)
 *
 * @example
 * ```tsx
 * const { register } = useFormContext<FormValues>();
 * ```
 */ const $d8f0cc4747dfcf2c$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useContext($d8f0cc4747dfcf2c$var$HookFormContext);
/**
 * Provides all `useForm` methods to the component tree via React Context.
 * Pair with `useFormContext` to consume them in any descendant.
 *
 * @see [API](https://react-hook-form.com/docs/useformcontext)
 *
 * @example
 * ```tsx
 * <FormProvider {...methods}>
 *   <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
 * </FormProvider>
 * ```
 */ const $d8f0cc4747dfcf2c$export$8ce1ff4f94d08846 = ({ children: children, watch: watch, getValues: getValues, getErrors: getErrors, getFieldState: getFieldState, setError: setError, clearErrors: clearErrors, setValue: setValue, setValues: setValues, trigger: trigger, formState: formState, resetField: resetField, reset: reset, resetDefaultValues: resetDefaultValues, handleSubmit: handleSubmit, unregister: unregister, control: control, register: register, setFocus: setFocus, subscribe: subscribe })=>{
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useMemo(()=>({
            watch: watch,
            getValues: getValues,
            getErrors: getErrors,
            getFieldState: getFieldState,
            setError: setError,
            clearErrors: clearErrors,
            setValue: setValue,
            setValues: setValues,
            trigger: trigger,
            formState: formState,
            resetField: resetField,
            reset: reset,
            resetDefaultValues: resetDefaultValues,
            handleSubmit: handleSubmit,
            unregister: unregister,
            control: control,
            register: register,
            setFocus: setFocus,
            subscribe: subscribe
        }), [
        clearErrors,
        control,
        formState,
        getErrors,
        getFieldState,
        getValues,
        handleSubmit,
        register,
        reset,
        resetDefaultValues,
        resetField,
        setError,
        setFocus,
        setValue,
        setValues,
        subscribe,
        trigger,
        unregister,
        watch
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($d8f0cc4747dfcf2c$var$HookFormContext.Provider, {
        value: memoizedValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).createElement($d8f0cc4747dfcf2c$var$HookFormControlContext.Provider, {
        value: memoizedValue.control
    }, children));
};
/**
 * Component wrapper around `useWatch`. Re-renders only when watched fields change.
 *
 * @see [API](https://react-hook-form.com/docs/usewatch)
 *
 * @example
 * ```tsx
 * <Watch
 *   control={control}
 *   names={["foo", "bar"]}
 *   render={([foo, bar]) => <span>{foo} {bar}</span>}
 * />
 * ```
 */ const $d8f0cc4747dfcf2c$export$4c68f1a79f88778c = (props)=>props.render($d8f0cc4747dfcf2c$export$3c773aa2b84f29e0((0, $7e9b970aebca32bd$export$71511d61b312f219)({
        name: props.names
    }, props)));





var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");


var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

/**
 * One related list, boxed.
 *
 * Four of these tile into a grid, so they have to read as one family: same header shape,
 * same body height whatever they hold. The count sits in the header rather than being left
 * for the reader to tally, and each body scrolls inside its own box so a farm with fifty
 * devices takes no more room than one with two.
 */ const $5f959d974cc19b86$var$RelatedCard = ({ title: title, count: count, action: action, children: children })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
        variant: "outlined",
        sx: {
            p: 2,
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "overline",
                        color: "text.secondary",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                        size: "small",
                        label: count,
                        sx: {
                            height: 20
                        }
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            flex: 1
                        }
                    }),
                    action
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1,
                    minHeight: 0
                },
                children: children
            })
        ]
    });
$5f959d974cc19b86$var$RelatedCard.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string.isRequired,
    count: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).node,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).node
};
$5f959d974cc19b86$var$RelatedCard.defaultProps = {
    count: 0,
    action: null,
    children: null
};
var $5f959d974cc19b86$export$2e2bcd8739ae039 = $5f959d974cc19b86$var$RelatedCard;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $f3c17f086ee08560$export$315cb19215f77ce0(slot) {
    return (0, $geF11.default)('MuiTable', slot);
}
const $f3c17f086ee08560$var$tableClasses = (0, $rARwS.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $f3c17f086ee08560$export$2e2bcd8739ae039 = $f3c17f086ee08560$var$tableClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $4c1fa911bb991a9c$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $4c1fa911bb991a9c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $f3c17f086ee08560$export$315cb19215f77ce0), classes);
};
const $4c1fa911bb991a9c$var$TableRoot = (0, $28RyA.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $erOpW.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $4c1fa911bb991a9c$var$defaultComponent = 'table';
const $4c1fa911bb991a9c$var$Table = /*#__PURE__*/ $jSIPP.forwardRef(function Table(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $4c1fa911bb991a9c$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $cMu4A.default)(props, $4c1fa911bb991a9c$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $4c1fa911bb991a9c$var$useUtilityClasses(ownerState);
    const table = $jSIPP.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ea91d9ab25de0377$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($4c1fa911bb991a9c$var$TableRoot, (0, $erOpW.default)({
            as: component,
            role: component === $4c1fa911bb991a9c$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $86B3v.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $4c1fa911bb991a9c$export$2e2bcd8739ae039 = $4c1fa911bb991a9c$var$Table;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $8646e4bdd4075c24$export$98bd2a9b566ec665(slot) {
    return (0, $geF11.default)('MuiTableBody', slot);
}
const $8646e4bdd4075c24$var$tableBodyClasses = (0, $rARwS.default)('MuiTableBody', [
    'root'
]);
var $8646e4bdd4075c24$export$2e2bcd8739ae039 = $8646e4bdd4075c24$var$tableBodyClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f08662b2a8d952cc$var$_excluded = [
    "className",
    "component"
];
const $f08662b2a8d952cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $8646e4bdd4075c24$export$98bd2a9b566ec665), classes);
};
const $f08662b2a8d952cc$var$TableBodyRoot = (0, $28RyA.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $f08662b2a8d952cc$var$tablelvl2 = {
    variant: 'body'
};
const $f08662b2a8d952cc$var$defaultComponent = 'tbody';
const $f08662b2a8d952cc$var$TableBody = /*#__PURE__*/ $jSIPP.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $f08662b2a8d952cc$var$defaultComponent } = props, other = (0, $cMu4A.default)(props, $f08662b2a8d952cc$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component
    });
    const classes = $f08662b2a8d952cc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $22768d29ea78090e$export$2e2bcd8739ae039).Provider, {
        value: $f08662b2a8d952cc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($f08662b2a8d952cc$var$TableBodyRoot, (0, $erOpW.default)({
            className: (0, $86B3v.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $f08662b2a8d952cc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $f08662b2a8d952cc$export$2e2bcd8739ae039 = $f08662b2a8d952cc$var$TableBody;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $58635b0c0f52e578$export$2e731cea2d1c2392(slot) {
    return (0, $geF11.default)('MuiTableHead', slot);
}
const $58635b0c0f52e578$var$tableHeadClasses = (0, $rARwS.default)('MuiTableHead', [
    'root'
]);
var $58635b0c0f52e578$export$2e2bcd8739ae039 = $58635b0c0f52e578$var$tableHeadClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $010b6fea034b9aac$var$_excluded = [
    "className",
    "component"
];
const $010b6fea034b9aac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $58635b0c0f52e578$export$2e731cea2d1c2392), classes);
};
const $010b6fea034b9aac$var$TableHeadRoot = (0, $28RyA.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $010b6fea034b9aac$var$tablelvl2 = {
    variant: 'head'
};
const $010b6fea034b9aac$var$defaultComponent = 'thead';
const $010b6fea034b9aac$var$TableHead = /*#__PURE__*/ $jSIPP.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $010b6fea034b9aac$var$defaultComponent } = props, other = (0, $cMu4A.default)(props, $010b6fea034b9aac$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component
    });
    const classes = $010b6fea034b9aac$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $22768d29ea78090e$export$2e2bcd8739ae039).Provider, {
        value: $010b6fea034b9aac$var$tablelvl2,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)($010b6fea034b9aac$var$TableHeadRoot, (0, $erOpW.default)({
            as: component,
            className: (0, $86B3v.default)(classes.root, className),
            ref: ref,
            role: component === $010b6fea034b9aac$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $010b6fea034b9aac$export$2e2bcd8739ae039 = $010b6fea034b9aac$var$TableHead;


var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $hnF8Y = parcelRequire("hnF8Y");


var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $097c43af44f7761a$export$ba0a6d6c28940107(slot) {
    return (0, $geF11.default)('MuiTableRow', slot);
}
const $097c43af44f7761a$var$tableRowClasses = (0, $rARwS.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $097c43af44f7761a$export$2e2bcd8739ae039 = $097c43af44f7761a$var$tableRowClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $841f20f01c5d0185$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $841f20f01c5d0185$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $097c43af44f7761a$export$ba0a6d6c28940107), classes);
};
const $841f20f01c5d0185$var$TableRowRoot = (0, $28RyA.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $097c43af44f7761a$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $097c43af44f7761a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $hnF8Y.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $841f20f01c5d0185$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $841f20f01c5d0185$var$TableRow = /*#__PURE__*/ $jSIPP.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $841f20f01c5d0185$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $cMu4A.default)(props, $841f20f01c5d0185$var$_excluded);
    const tablelvl2 = $jSIPP.useContext((0, $22768d29ea78090e$export$2e2bcd8739ae039));
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $841f20f01c5d0185$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($841f20f01c5d0185$var$TableRowRoot, (0, $erOpW.default)({
        as: component,
        ref: ref,
        className: (0, $86B3v.default)(classes.root, className),
        role: component === $841f20f01c5d0185$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $841f20f01c5d0185$export$2e2bcd8739ae039 = $841f20f01c5d0185$var$TableRow;


var $4c5b8df21b27ae95$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($4c5b8df21b27ae95$exports, "__esModule", {
    value: true
});
$4c5b8df21b27ae95$exports.default = void 0;

var $4c5b8df21b27ae95$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $4c5b8df21b27ae95$var$_default = $4c5b8df21b27ae95$exports.default = (0, $4c5b8df21b27ae95$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');


/**
 * The records related to an owner, one list per tab.
 *
 * A plain dense table rather than a data grid: these lists are short, live inside a dialog,
 * and need no sorting or column machinery of their own — the full-featured grid is one
 * click away on the page the rows link to.
 *
 * @param columns [{field, headerName, width, render}] - render is optional
 * @param rows the records to show
 * @param onOpen called with a row when it is clicked; omit to make rows inert
 */ const $0711a1fb9c9917d9$var$RelatedTable = ({ columns: columns, rows: rows, loading: loading, emptyText: emptyText, onOpen: onOpen, maxHeight: maxHeight })=>{
    if (loading) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6216cc7e50b683a3$export$2e2bcd8739ae039), {
        sx: {
            my: 2
        }
    });
    if (!rows.length) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
        variant: "body2",
        color: "textSecondary",
        sx: {
            py: 3,
            textAlign: 'center'
        },
        children: emptyText
    });
    return(// Capped and scrolled so a farm with fifty streams cannot push the dialog's buttons off
    // the screen, and so cards sitting side by side stay the same height.
    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            maxHeight: maxHeight,
            overflowY: 'auto'
        },
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4c1fa911bb991a9c$export$2e2bcd8739ae039), {
            size: "small",
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $010b6fea034b9aac$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $841f20f01c5d0185$export$2e2bcd8739ae039), {
                        children: [
                            columns.map((column)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $120d7c5a8852dced$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: column.width,
                                        fontWeight: 600
                                    },
                                    children: column.headerName
                                }, column.field)),
                            onOpen && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $120d7c5a8852dced$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 48
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f08662b2a8d952cc$export$2e2bcd8739ae039), {
                    children: rows.map((row)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $841f20f01c5d0185$export$2e2bcd8739ae039), {
                            hover: Boolean(onOpen),
                            onClick: onOpen ? ()=>onOpen(row) : undefined,
                            sx: onOpen ? {
                                cursor: 'pointer'
                            } : undefined,
                            children: [
                                columns.map((column)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $120d7c5a8852dced$export$2e2bcd8739ae039), {
                                        children: column.render ? column.render(row) : row[column.field]
                                    }, column.field)),
                                onOpen && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $120d7c5a8852dced$export$2e2bcd8739ae039), {
                                    padding: "none",
                                    align: "right",
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c5b8df21b27ae95$exports))), {
                                        fontSize: "small",
                                        color: "action"
                                    })
                                })
                            ]
                        }, row.id))
                })
            ]
        })
    }));
};
$0711a1fb9c9917d9$var$RelatedTable.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array.isRequired,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    emptyText: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func,
    maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).number
};
$0711a1fb9c9917d9$var$RelatedTable.defaultProps = {
    rows: [],
    loading: false,
    emptyText: 'Nothing to show.',
    onOpen: undefined,
    maxHeight: 232
};
var $0711a1fb9c9917d9$export$2e2bcd8739ae039 = $0711a1fb9c9917d9$var$RelatedTable;


/**
 * The owner's consumers: the one card that both shows and sets its list.
 *
 * The picker stays here rather than in the details form so consumers have a single home -
 * seeing which ones are attached and changing them are the same act.
 */ const $1538f9c92f432cd3$var$COLUMNS = [
    {
        field: 'name',
        headerName: 'Name'
    },
    {
        field: 'consumer_type_name',
        headerName: 'Type',
        render: (row)=>row.consumer_type_name || "\u2014"
    }
];
const $1538f9c92f432cd3$var$ConsumersCard = ({ consumers: consumers, selected: selected, setSelected: setSelected })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $5f959d974cc19b86$export$2e2bcd8739ae039), {
        title: "Consumers",
        count: selected.length,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                fullWidth: true,
                size: "small",
                sx: {
                    mb: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                        id: "consumers-label",
                        children: "Attached consumers"
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                        labelId: "consumers-label",
                        id: "consumers-multi-select",
                        label: "Attached consumers",
                        multiple: true,
                        value: selected,
                        onChange: (event)=>setSelected(event.target.value),
                        input: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6ee74b9ab47804f3$export$2e2bcd8739ae039), {
                            label: "Attached consumers"
                        }),
                        renderValue: (chosen)=>chosen === null || chosen === void 0 ? void 0 : chosen.map((x)=>x.name).join(', '),
                        children: (consumers || []).map((consumer)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                value: consumer,
                                children: [
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e208a097995c2a3b$export$2e2bcd8739ae039), {
                                        checked: (selected === null || selected === void 0 ? void 0 : selected.find((x)=>x.name === consumer.name)) !== undefined
                                    }),
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                                        primary: consumer.name
                                    })
                                ]
                            }, consumer.id))
                    })
                ]
            }),
            selected.length === 0 ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "textSecondary",
                sx: {
                    py: 1,
                    textAlign: 'center'
                },
                children: "No consumers are attached to this owner."
            }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0711a1fb9c9917d9$export$2e2bcd8739ae039), {
                columns: $1538f9c92f432cd3$var$COLUMNS,
                rows: selected,
                maxHeight: 168
            })
        ]
    });
$1538f9c92f432cd3$var$ConsumersCard.propTypes = {
    consumers: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    setSelected: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired
};
$1538f9c92f432cd3$var$ConsumersCard.defaultProps = {
    consumers: [],
    selected: []
};
var $1538f9c92f432cd3$export$2e2bcd8739ae039 = $1538f9c92f432cd3$var$ConsumersCard;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");


/**
 * The editable half of the owner view.
 *
 * Fields are grouped by what they mean rather than laid out one per row: identity first,
 * then the settings that change how the platform treats the owner. Controls are full width
 * within their column so the two columns line up at every breakpoint.
 */ const $597971ee824cdf72$var$Section = ({ title: title, children: children })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                    variant: "subtitle2",
                    color: "textSecondary",
                    sx: {
                        mt: 1
                    },
                    children: title
                })
            }),
            children
        ]
    });
const $597971ee824cdf72$var$OwnerDetailsForm = ({ form: form, businesses: businesses, timezones: timezones })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)($597971ee824cdf72$var$Section, {
                title: "Identity",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                            name: "name",
                            control: form.control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                    label: "Name",
                                    value: field.value || '',
                                    fullWidth: true,
                                    onBlur: field.onBlur,
                                    onChange: field.onChange,
                                    variant: "outlined"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                            name: "description",
                            control: form.control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                    label: "Description",
                                    value: field.value || '',
                                    fullWidth: true,
                                    onBlur: field.onBlur,
                                    onChange: field.onChange,
                                    variant: "outlined"
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)($597971ee824cdf72$var$Section, {
                title: "Configuration",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                            name: "business_id",
                            control: form.control,
                            render: ({ field: field })=>{
                                var _field_value;
                                return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                                            id: "biz-id-label",
                                            children: "Business"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                            labelId: "biz-id-label",
                                            id: "biz-id-select",
                                            label: "Business",
                                            value: (_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : '',
                                            onChange: field.onChange,
                                            children: (businesses || []).map((business)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                                    value: business.id,
                                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                                                        primary: business.name
                                                    })
                                                }, business.id))
                                        })
                                    ]
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                            name: "timezone",
                            control: form.control,
                            render: ({ field: field })=>{
                                var _field_value;
                                return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                                            id: "timezone-label",
                                            children: "Time Zone"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                            labelId: "timezone-label",
                                            label: "Time Zone",
                                            id: "timezone-select",
                                            value: (_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : '',
                                            onChange: field.onChange,
                                            children: (timezones || []).map((tz)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                                    value: tz.name,
                                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0f9d457d20374390$export$2e2bcd8739ae039), {
                                                        primary: tz.name
                                                    })
                                                }, tz.id))
                                        })
                                    ]
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                            name: "multi_site",
                            control: form.control,
                            defaultValue: 0,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $97749ece2376eb3c$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e208a097995c2a3b$export$2e2bcd8739ae039), {
                                        checked: field.value === 1,
                                        onChange: (e)=>field.onChange(e.target.checked ? 1 : 0)
                                    }),
                                    label: "Multi site"
                                })
                        })
                    })
                ]
            })
        ]
    });
$597971ee824cdf72$var$OwnerDetailsForm.propTypes = {
    form: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object.isRequired,
    businesses: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    timezones: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array
};
var $597971ee824cdf72$export$2e2bcd8739ae039 = $597971ee824cdf72$var$OwnerDetailsForm;




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

/**
 * The high level read of an owner: what it is, then how much of the platform it touches.
 *
 * The counts are the same numbers the tabs below are built from, surfaced up front so the
 * shape of an owner is readable without opening a single tab.
 */ const $f8df6c5fe80a0ab4$var$Stat = ({ label: label, value: value, loading: loading })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
        variant: "outlined",
        sx: {
            p: 1.5,
            textAlign: 'center',
            height: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "h5",
                children: loading ? "\u2014" : value
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                color: "textSecondary",
                children: label
            })
        ]
    });
const $f8df6c5fe80a0ab4$var$facts = (owner, businessName)=>[
        [
            'ID',
            owner.id
        ],
        [
            'Business',
            businessName || owner.business_id || "\u2014"
        ],
        [
            'Time zone',
            owner.timezone || "\u2014"
        ],
        [
            'Created',
            owner.created_datetime || "\u2014"
        ],
        [
            'Updated by',
            owner.updated_by || "\u2014"
        ]
    ];
const $f8df6c5fe80a0ab4$var$OwnerSummary = ({ owner: owner, businessName: businessName, stats: stats, loading: loading })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            mb: 2
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    alignItems: 'center',
                    mb: 2
                },
                children: [
                    owner.multi_site === 1 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                        size: "small",
                        color: "primary",
                        label: "Multi-site"
                    }),
                    owner.disabled ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                        size: "small",
                        color: "warning",
                        label: "Disabled"
                    }) : null,
                    owner.timezone && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        label: owner.timezone
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                container: true,
                spacing: 1.5,
                sx: {
                    mb: 2
                },
                children: stats.map((stat)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sm: 3,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)($f8df6c5fe80a0ab4$var$Stat, {
                            label: stat.label,
                            value: stat.value,
                            loading: loading
                        })
                    }, stat.label))
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                container: true,
                spacing: 1,
                children: $f8df6c5fe80a0ab4$var$facts(owner, businessName).map(([label, value])=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        sx: {
                            display: 'flex',
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "body2",
                                color: "textSecondary",
                                sx: {
                                    minWidth: 92
                                },
                                children: label
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "body2",
                                noWrap: true,
                                title: String(value),
                                children: String(value)
                            })
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                sx: {
                    mt: 2
                }
            })
        ]
    });
$f8df6c5fe80a0ab4$var$OwnerSummary.propTypes = {
    owner: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object.isRequired,
    businessName: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    stats: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array.isRequired,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool
};
var $f8df6c5fe80a0ab4$export$2e2bcd8739ae039 = $f8df6c5fe80a0ab4$var$OwnerSummary;






const $48e245a686e30046$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $48e245a686e30046$var$getDevices = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$48e245a686e30046$var$HOST_URL}/device-view`)).data;
};
const $48e245a686e30046$var$getDeviceLogs = async (mac_address)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$48e245a686e30046$var$HOST_URL}/log/${mac_address}`)).data;
};
const $48e245a686e30046$var$createDevice = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$48e245a686e30046$var$HOST_URL}/device`, data)).data;
};
const $48e245a686e30046$var$deleteDevice = async (deviceId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).delete(`${$48e245a686e30046$var$HOST_URL}/device/admin/${deviceId}`)).data;
};
var $48e245a686e30046$export$2e2bcd8739ae039 = {
    getDevices: $48e245a686e30046$var$getDevices,
    getDeviceLogs: $48e245a686e30046$var$getDeviceLogs,
    createDevice: $48e245a686e30046$var$createDevice,
    deleteDevice: $48e245a686e30046$var$deleteDevice
};




const $17b1048d84ada6dd$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $17b1048d84ada6dd$var$getOneByParentId = async (ownerId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$17b1048d84ada6dd$var$HOST_URL}/owner-associations?parent_owner_id=${ownerId}`)).data;
};
const $17b1048d84ada6dd$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$17b1048d84ada6dd$var$HOST_URL}/owner-associations`)).data;
};
const $17b1048d84ada6dd$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$17b1048d84ada6dd$var$HOST_URL}/owner-associations`, data)).data;
};
const $17b1048d84ada6dd$var$put = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$17b1048d84ada6dd$var$HOST_URL}/owner-associations`, data)).data;
};
var $17b1048d84ada6dd$export$2e2bcd8739ae039 = {
    getOneByParentId: $17b1048d84ada6dd$var$getOneByParentId,
    getAll: $17b1048d84ada6dd$var$getAll,
    post: $17b1048d84ada6dd$var$post,
    put: $17b1048d84ada6dd$var$put
};




const $c76c343e5c0b02e6$export$fef51e19f6e4e2f8 = (rows, ownerId)=>(rows || []).filter((row)=>row.owner_id === ownerId);
// device-view carries owner_id, but it is the owner name the grid shows; match on either so
// a view that ever drops the id still lists the right devices.
const $c76c343e5c0b02e6$export$1be5f5272f156c15 = (rows, owner)=>(rows || []).filter((device)=>device.owner_id === (owner === null || owner === void 0 ? void 0 : owner.id) || device.owner_name && (owner === null || owner === void 0 ? void 0 : owner.name) && device.owner_name === owner.name);
// An association names only the child's id, so the owner list supplies the rest. A child
// the list does not carry still gets a row: its absence is worth seeing, not hiding.
const $c76c343e5c0b02e6$export$deb713bc3b362fb2 = (associations, owners)=>(associations || []).map((association)=>{
        const child = (owners || []).find((owner)=>owner.id === association.child_owner_id);
        return {
            id: association.child_owner_id,
            name: (child === null || child === void 0 ? void 0 : child.name) || `Owner ${association.child_owner_id}`,
            timezone: (child === null || child === void 0 ? void 0 : child.timezone) || '',
            disabled: Boolean(child === null || child === void 0 ? void 0 : child.disabled)
        };
    });
// Everything the owner view shows about one owner beyond its own row. Each list is fetched
// under the key the matching page already uses, so opening an owner warms those pages
// rather than fetching a second copy, and none of it runs until the dialog is open.
const $c76c343e5c0b02e6$var$useOwnerRelations = (owner, enabled)=>{
    const ownerId = owner === null || owner === void 0 ? void 0 : owner.id;
    const on = Boolean(enabled && ownerId);
    const dataStreams = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDataStreams', (0, $e35ffebe245b57e7$export$2e2bcd8739ae039).getAll, {
        staleTime: Infinity,
        enabled: on
    });
    const devices = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDevices', (0, $48e245a686e30046$export$2e2bcd8739ae039).getDevices, {
        staleTime: Infinity,
        enabled: on
    });
    // Same key the data stream editor uses for a parent's children.
    const childOwners = (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        'childOwners',
        ownerId
    ], ()=>(0, $17b1048d84ada6dd$export$2e2bcd8739ae039).getOneByParentId(ownerId), {
        enabled: on && Boolean(owner === null || owner === void 0 ? void 0 : owner.multi_site)
    });
    const owners = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getOwners', (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAllSortedByName, {
        staleTime: Infinity,
        enabled: on && Boolean(owner === null || owner === void 0 ? void 0 : owner.multi_site)
    });
    return {
        dataStreams: $c76c343e5c0b02e6$export$fef51e19f6e4e2f8(dataStreams.data, ownerId),
        dataStreamsLoading: dataStreams.isLoading,
        devices: $c76c343e5c0b02e6$export$1be5f5272f156c15(devices.data, owner),
        devicesLoading: devices.isLoading,
        locations: $c76c343e5c0b02e6$export$deb713bc3b362fb2(childOwners.data, owners.data),
        locationsLoading: childOwners.isLoading || owners.isLoading
    };
};
var $c76c343e5c0b02e6$export$2e2bcd8739ae039 = {
    useOwnerRelations: $c76c343e5c0b02e6$var$useOwnerRelations,
    ownedBy: $c76c343e5c0b02e6$export$fef51e19f6e4e2f8,
    devicesOf: $c76c343e5c0b02e6$export$1be5f5272f156c15,
    locationsOf: $c76c343e5c0b02e6$export$deb713bc3b362fb2
};




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

/**
 * One named group of fields in an edit dialog. A long form reads as a few labelled parts
 * rather than one run of inputs, and every dialog groups them the same way.
 *
 * @param title Short heading, set in caps above the fields.
 * @param description Optional line under the heading saying what the group is for.
 * @param accent Marks a panel the form fills in for itself rather than one the reader fills
 * in: tinted, with a bar down the left edge. Reserve it for derived values - it only reads
 * as "this is the result" while the plain sections around it stay plain.
 * @param error Turns the accent bar red. Only meaningful alongside accent.
 * @returns {JSX.Element}
 * @constructor
 */ const $75b894f64939a696$var$IyoFormSection = ({ title: title, description: description, accent: accent = false, error: error = false, children: children })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
        variant: "outlined",
        sx: (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            p: 2,
            height: '100%'
        }, accent && {
            borderLeft: 4,
            borderLeftColor: error ? 'error.main' : 'primary.main',
            bgcolor: 'action.hover'
        }),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "overline",
                component: "div",
                color: "text.secondary",
                children: title
            }),
            description && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                component: "div",
                color: "text.secondary",
                children: description
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    mt: 1.5
                },
                children: children
            })
        ]
    });
var $75b894f64939a696$export$2e2bcd8739ae039 = $75b894f64939a696$var$IyoFormSection;




const $2bef4cfac870de41$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('nableHostUrl');
const $2bef4cfac870de41$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$2bef4cfac870de41$var$HOST_URL}/business-account`)).data;
};
var $2bef4cfac870de41$export$2e2bcd8739ae039 = {
    getAll: $2bef4cfac870de41$var$getAll
};






const $ad8a302f12f32b6f$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)("hostUrl");
const $ad8a302f12f32b6f$var$get = async (owner_id)=>{
    const queryParams = (0, $a9106d6db699107c$export$7973aed45b22124c)({
        owner_id: owner_id
    });
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$ad8a302f12f32b6f$var$HOST_URL}/owner-consumer-default${queryParams}`)).data;
};
const $ad8a302f12f32b6f$var$post = async (owner_id, consumer_id)=>{
    const currentUser = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
    const data = {
        owner_id: owner_id,
        consumer_id: consumer_id,
        created_by: currentUser,
        updated_by: currentUser
    };
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$ad8a302f12f32b6f$var$HOST_URL}/owner-consumer-default`, data)).data;
};
const $ad8a302f12f32b6f$var$del = async (owner_id, consumer_id)=>{
    const queryParams = (0, $a9106d6db699107c$export$7973aed45b22124c)({
        owner_id: owner_id,
        consumer_id: consumer_id
    });
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).delete(`${$ad8a302f12f32b6f$var$HOST_URL}/owner-consumer-default${queryParams}`)).data;
};
var $ad8a302f12f32b6f$export$2e2bcd8739ae039 = {
    get: $ad8a302f12f32b6f$var$get,
    del: $ad8a302f12f32b6f$var$del,
    post: $ad8a302f12f32b6f$var$post
};






const $030520efea0d82ea$var$executeQuery = async (queryName, queryParams)=>{
    const additionalQueryStringParams = $030520efea0d82ea$var$buildQueryParams(queryParams);
    const url = `${(0, $a9106d6db699107c$export$1811237fdf5ac5d)('nableHostUrl')}/rockset/${queryName}${additionalQueryStringParams}`;
    const response = await (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(url)).data;
    return response && response.length > 0 ? response : [];
};
const $030520efea0d82ea$var$buildQueryParams = (queryParams = {})=>{
    let additionalQueryStringParams = '';
    for (const key of Object.keys(queryParams)){
        additionalQueryStringParams += additionalQueryStringParams === '' ? '?' : '&';
        additionalQueryStringParams += `${key}=${queryParams[key]}`;
    }
    return additionalQueryStringParams;
};
var $030520efea0d82ea$export$2e2bcd8739ae039 = {
    executeQuery: $030520efea0d82ea$var$executeQuery
};



// Read-only views of what an owner owns. All four sit on the page at once rather than
// behind tabs: the question the view answers - what does this owner actually have - is not
// worth three clicks, and each list is short enough to box and scroll on its own.
//
// Columns are kept to what identifies a record. The page each list links to is where the
// rest of the columns live.
const $e1c381551f19ef5d$var$DATA_STREAM_COLUMNS = [
    {
        field: 'name',
        headerName: 'Name'
    },
    {
        field: 'provider_name',
        headerName: 'Provider'
    },
    {
        field: 'cron',
        headerName: 'Schedule'
    }
];
const $e1c381551f19ef5d$var$DEVICE_COLUMNS = [
    {
        field: 'mac_address',
        headerName: 'MAC address'
    },
    {
        field: 'active',
        headerName: 'Active',
        render: (row)=>row.active ? 'Yes' : 'No'
    },
    {
        field: 'activation_date',
        headerName: 'Activated'
    },
    {
        field: 'health_timestamp',
        headerName: 'Last health'
    }
];
const $e1c381551f19ef5d$var$LOCATION_COLUMNS = [
    {
        field: 'name',
        headerName: 'Name'
    },
    {
        field: 'id',
        headerName: 'Owner ID',
        width: 110
    },
    {
        field: 'timezone',
        headerName: 'Time zone'
    }
];
const $e1c381551f19ef5d$var$OwnerEditDialog = ({ open: open, setOpen: setOpen, rowEditing: rowEditing, mode: mode, handleError: handleError, parentOwnerId: parentOwnerId })=>{
    var _getTimezones_data_find, _getTimezones_data, _consumersQuery_data, _getBusinesses_data_find, _getBusinesses_data;
    const [selectedConsumers, setSelectedConsumers] = (0, $jSIPP.useState)([]);
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const getTimezones = (0, $41632140e88fef11$export$dd0a697e1782aedd)("getTimezones", async ()=>{
        const data = await (0, $030520efea0d82ea$export$2e2bcd8739ae039).executeQuery("timezones");
        const sortedNames = data.map((rec)=>rec.name).sort();
        return data.sort((a, b)=>sortedNames.indexOf(a.name) - sortedNames.indexOf(b.name)).map((tz)=>(0, $7e9b970aebca32bd$export$71511d61b312f219)({
                id: tz._id
            }, tz));
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const getBusinesses = (0, $41632140e88fef11$export$dd0a697e1782aedd)("getBusinesses", async ()=>(0, $2bef4cfac870de41$export$2e2bcd8739ae039).getAll(), {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const consumersQuery = (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        "allConsumers"
    ], async ()=>(0, $6ea4f0a608034787$export$2e2bcd8739ae039).getAll(), {
        cacheTime: Infinity
    });
    const consumersForOwner = (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        "consumers-by-owner",
        rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id
    ], ()=>(0, $ad8a302f12f32b6f$export$2e2bcd8739ae039).get(rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id), {
        enabled: !!(rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id)
    });
    const form = (0, $d8f0cc4747dfcf2c$export$87c0cf8eb5a167e0)({
        name: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.name) || "",
        description: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.description) || "",
        business_id: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.businessId) || "",
        timezone: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.timezone) ? ((_getTimezones_data = getTimezones.data) === null || _getTimezones_data === void 0 ? void 0 : (_getTimezones_data_find = _getTimezones_data.find((tz)=>tz.name === (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.timezone))) === null || _getTimezones_data_find === void 0 ? void 0 : _getTimezones_data_find.name) || "" : ""
    });
    (0, $jSIPP.useEffect)(()=>{
        if (getTimezones.isSuccess) {
            var _getTimezones_data_find, _getTimezones_data;
            const formVals = {
                name: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.name) || "",
                description: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.description) || "",
                business_id: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.business_id) || "",
                timezone: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.timezone) ? ((_getTimezones_data = getTimezones.data) === null || _getTimezones_data === void 0 ? void 0 : (_getTimezones_data_find = _getTimezones_data.find((tz)=>tz.name === (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.timezone))) === null || _getTimezones_data_find === void 0 ? void 0 : _getTimezones_data_find.name) || "" : "",
                multi_site: (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.multi_site) || 0
            };
            form.reset(formVals);
            if (!rowEditing) setSelectedConsumers([]);
        }
    }, [
        rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id,
        getTimezones.data
    ]);
    (0, $jSIPP.useEffect)(()=>{
        var _consumersQuery_data;
        if ((_consumersQuery_data = consumersQuery.data) === null || _consumersQuery_data === void 0 ? void 0 : _consumersQuery_data.length) setSelectedConsumers(consumersQuery.data.filter((x)=>{
            var _consumersForOwner_data;
            return ((_consumersForOwner_data = consumersForOwner.data) === null || _consumersForOwner_data === void 0 ? void 0 : _consumersForOwner_data.find((y)=>x.id === y.consumer_id)) !== undefined;
        }));
    }, [
        (_consumersQuery_data = consumersQuery.data) === null || _consumersQuery_data === void 0 ? void 0 : _consumersQuery_data.length,
        consumersForOwner.data
    ]);
    const updateConsumers = (0, $74568c0a766c827d$export$609860bf8b0084c)(async (ownerId)=>{
        const ownerConsumersFromDb = consumersForOwner.data;
        const selectedIds = selectedConsumers.map((consumer)=>consumer.id);
        const toDeletePromises = (ownerConsumersFromDb === null || ownerConsumersFromDb === void 0 ? void 0 : ownerConsumersFromDb.filter((consumer)=>!selectedIds.includes(consumer.consumer_id)).map((x)=>(0, $ad8a302f12f32b6f$export$2e2bcd8739ae039).del(ownerId, x.consumer_id))) || [];
        const toAddPromises = selectedIds.filter((consumerId)=>ownerConsumersFromDb !== undefined ? !ownerConsumersFromDb.some((dbConsumer)=>dbConsumer.consumer_id === consumerId) : true).map((x)=>(0, $ad8a302f12f32b6f$export$2e2bcd8739ae039).post(ownerId, x));
        await Promise.all(toDeletePromises.concat(toAddPromises));
        queryClient.invalidateQueries("consumers-by-owner");
        setOpen(false);
    });
    const createOwnerAssociation = async (parentId, childId)=>{
        try {
            const user = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
            const associationData = {
                parent_owner_id: parentId,
                child_owner_id: childId,
                updated_by: user
            };
            return await (0, $17b1048d84ada6dd$export$2e2bcd8739ae039).post(associationData);
        } catch (error) {
            handleError(error);
            throw error;
        }
    };
    const postOwner = (0, $74568c0a766c827d$export$609860bf8b0084c)("postOwner", async (data)=>(0, $17fe0060be69a0cc$export$2e2bcd8739ae039).post(data), {
        onSuccess: async (res)=>{
            await queryClient.invalidateQueries("getOwners");
            if (parentOwnerId) await createOwnerAssociation(parentOwnerId, res.id);
            updateConsumers.mutate(res.id);
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    const putOwner = (0, $74568c0a766c827d$export$609860bf8b0084c)("putOwner", async (data)=>(0, $17fe0060be69a0cc$export$2e2bcd8739ae039).put(rowEditing.id, data), {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries("getOwners");
            updateConsumers.mutate(rowEditing.id);
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    const handleCreateSubmit = async ()=>{
        const values = form.getValues();
        const body = {
            name: values.name,
            description: values.description || undefined,
            business_id: values.business_id || undefined,
            timezone: values.timezone,
            multi_site: values.multi_site || 0,
            created_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser(),
            updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        };
        postOwner.mutate(body);
    // SET SPINNER
    };
    const handleEditSubmit = async ()=>{
        const values = form.getValues();
        const _values = JSON.parse(JSON.stringify(values));
        _values.description = values.description || undefined;
        _values.timezone = _values.timezone || undefined;
        _values.business_id = _values.business_id || undefined;
        const changed = [];
        for(const field in _values)if (_values[field] !== rowEditing[field]) changed.push([
            field,
            _values[field]
        ]);
        if (changed.length === 0) {
            setOpen(false);
            return;
        }
        changed.push([
            "updated_by",
            await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        ]);
        changed.push([
            "id",
            rowEditing.id
        ]);
        const body = Object.fromEntries(changed);
        putOwner.mutate(body);
    // SET SPINNER
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    // Related records, fetched only while an existing owner is open.
    const isEdit = mode === "edit" && Boolean(rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id);
    const relations = (0, $c76c343e5c0b02e6$export$2e2bcd8739ae039).useOwnerRelations(rowEditing, open && isEdit);
    // Leaves for the page that owns the record: these lists are a way in, not a second editor.
    const openElsewhere = (path)=>{
        setOpen(false);
        history.push(path);
    };
    const businessName = (_getBusinesses_data = getBusinesses.data) === null || _getBusinesses_data === void 0 ? void 0 : (_getBusinesses_data_find = _getBusinesses_data.find((b)=>b.id === (rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.business_id))) === null || _getBusinesses_data_find === void 0 ? void 0 : _getBusinesses_data_find.name;
    const stats = [
        {
            label: "Data streams",
            value: relations.dataStreams.length
        },
        {
            label: "Devices",
            value: relations.devices.length
        },
        {
            label: "Consumers",
            value: selectedConsumers.length
        },
        {
            label: "Locations",
            value: relations.locations.length
        }
    ];
    const handleSubmit = ()=>{
        if (mode === "edit") handleEditSubmit();
        else if (mode === "create") handleCreateSubmit();
        else console.error("Invalid edit type");
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        maxWidth: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                id: "alert-dialog-title",
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    pr: 1
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "h6",
                                noWrap: true,
                                children: isEdit ? rowEditing.name || `Owner ${rowEditing.id}` : "Create Owner"
                            }),
                            isEdit && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "caption",
                                color: "textSecondary",
                                children: [
                                    "Owner ",
                                    rowEditing.id,
                                    rowEditing.description ? ` \xb7 ${rowEditing.description}` : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        "aria-label": "Close",
                        size: "small",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22a85ca48859791a$exports))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $6f8ada62e319d53e$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    isEdit && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f8df6c5fe80a0ab4$export$2e2bcd8739ae039), {
                        owner: rowEditing,
                        businessName: businessName,
                        stats: stats,
                        loading: relations.dataStreamsLoading || relations.devicesLoading
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                            title: "Details",
                            description: "What this owner is called, and where it sits.",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $597971ee824cdf72$export$2e2bcd8739ae039), {
                                form: form,
                                businesses: getBusinesses.data,
                                timezones: getTimezones.data
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        alignItems: "stretch",
                        children: [
                            isEdit && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5f959d974cc19b86$export$2e2bcd8739ae039), {
                                    title: "Data streams",
                                    count: relations.dataStreams.length,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0711a1fb9c9917d9$export$2e2bcd8739ae039), {
                                        columns: $e1c381551f19ef5d$var$DATA_STREAM_COLUMNS,
                                        rows: relations.dataStreams,
                                        loading: relations.dataStreamsLoading,
                                        emptyText: "No data streams belong to this owner.",
                                        onOpen: (row)=>openElsewhere(`/data-streams?id=${row.id}`)
                                    })
                                })
                            }),
                            isEdit && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5f959d974cc19b86$export$2e2bcd8739ae039), {
                                    title: "Devices",
                                    count: relations.devices.length,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0711a1fb9c9917d9$export$2e2bcd8739ae039), {
                                        columns: $e1c381551f19ef5d$var$DEVICE_COLUMNS,
                                        rows: relations.devices,
                                        loading: relations.devicesLoading,
                                        emptyText: "No devices are registered to this owner."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1538f9c92f432cd3$export$2e2bcd8739ae039), {
                                    consumers: consumersQuery.data,
                                    selected: selectedConsumers,
                                    setSelected: setSelectedConsumers
                                })
                            }),
                            isEdit && rowEditing.multi_site === 1 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5f959d974cc19b86$export$2e2bcd8739ae039), {
                                    title: "Locations",
                                    count: relations.locations.length,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0711a1fb9c9917d9$export$2e2bcd8739ae039), {
                                        columns: $e1c381551f19ef5d$var$LOCATION_COLUMNS,
                                        rows: relations.locations,
                                        loading: relations.locationsLoading,
                                        emptyText: "No child locations are associated with this owner.",
                                        onOpen: (row)=>openElsewhere(`/owners?id=${row.id}`)
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $9e1fc1f07bfe7735$export$2e2bcd8739ae039), {
                sx: {
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                        color: "primary",
                        disabled: postOwner.isLoading || putOwner.isLoading || updateConsumers.isLoading,
                        onClick: handleClose,
                        size: "large",
                        type: "button",
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                        color: "primary",
                        disabled: postOwner.isLoading || putOwner.isLoading || updateConsumers.isLoading,
                        size: "large",
                        variant: "contained",
                        onClick: handleSubmit,
                        children: [
                            "Save",
                            (postOwner.isLoading || putOwner.isLoading) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $fc1d6c67a263744c$export$2e2bcd8739ae039), {
                                size: 15,
                                sx: {
                                    ml: "8px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e1c381551f19ef5d$export$2e2bcd8739ae039 = $e1c381551f19ef5d$var$OwnerEditDialog;





var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $ced9e6b5f79fda24$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($ced9e6b5f79fda24$exports, "__esModule", {
    value: true
});
$ced9e6b5f79fda24$exports.default = void 0;

var $ced9e6b5f79fda24$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $ced9e6b5f79fda24$var$_default = $ced9e6b5f79fda24$exports.default = (0, $ced9e6b5f79fda24$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');


const $e9b6e418069ba502$var$TableToolbar = ({ editHandler: editHandler, onRefresh: onRefresh })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
            sx: {
                mb: '1rem',
                display: 'flex',
                justifyContent: 'flex-end'
            },
            children: [
                onRefresh && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: "Refresh",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: onRefresh,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ced9e6b5f79fda24$exports))), {})
                    })
                }),
                editHandler && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                    color: "primary",
                    variant: "contained",
                    onClick: editHandler,
                    children: "Create"
                })
            ]
        })
    });
var $e9b6e418069ba502$export$2e2bcd8739ae039 = $e9b6e418069ba502$var$TableToolbar;


const $030c734edfd36e74$export$53b3c91859018cd4 = [
    {
        field: 'id',
        headerName: 'ID',
        description: 'Owner ID',
        minWidth: 75
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'Name',
        minWidth: 250
    },
    {
        field: 'description',
        headerName: 'Description',
        description: 'Description',
        minWidth: 200
    },
    {
        field: 'timezone',
        headerName: 'Time Zone',
        description: 'Time Zone',
        minWidth: 175
    },
    {
        field: 'business_id',
        headerName: 'Business ID',
        description: 'Business ID',
        minWidth: 150
    },
    {
        field: 'created_by',
        headerName: 'Created By',
        description: 'Created By',
        minWidth: 175
    },
    {
        field: 'created_datetime',
        headerName: 'Created Datetime',
        description: 'Created Datetime',
        minWidth: 225
    },
    {
        field: 'updated_by',
        headerName: 'Updated By',
        description: 'Updated By',
        minWidth: 175
    },
    {
        field: 'updated_datetime',
        headerName: 'Updated Datetime',
        description: 'Updated Datetime',
        minWidth: 225
    },
    {
        field: 'multi_site',
        headerName: 'Multi Site',
        description: 'Multi Site Enabled Flag',
        minWidth: 100,
        valueGetter: (params)=>params.value === 1 ? 'true' : 'false'
    }
];





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");

var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $4uaIU = parcelRequire("4uaIU");
const $b4084da674dae987$var$_excluded = [
    "className",
    "children"
];
const $b4084da674dae987$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarContainer'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $b4084da674dae987$var$GridToolbarContainerRoot = (0, $4d3abc332db30b81$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ToolbarContainer',
    overridesResolver: (_, styles)=>styles.toolbarContainer
})(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 0.5, 0)
    }));
const $b4084da674dae987$export$276ebf2f43e1afe0 = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarContainer(props, ref) {
    const { className: className, children: children } = props, other = (0, $cMu4A.default)(props, $b4084da674dae987$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const classes = $b4084da674dae987$var$useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsx)($b4084da674dae987$var$GridToolbarContainerRoot, (0, $erOpW.default)({
        ref: ref,
        className: (0, $86B3v.default)(className, classes.root),
        ownerState: rootProps
    }, other, {
        children: children
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");







var $4uaIU = parcelRequire("4uaIU");
const $e9c128ca030dbc17$var$_excluded = [
    "onClick"
];
const $e9c128ca030dbc17$export$9460f81121783d0f = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarColumnsButton(props, ref) {
    var _rootProps$slotProps;
    const { onClick: onClick } = props, other = (0, $cMu4A.default)(props, $e9c128ca030dbc17$var$_excluded);
    const columnButtonId = (0, $b2e317da5452a23f$export$2e2bcd8739ae039)();
    const columnPanelId = (0, $b2e317da5452a23f$export$2e2bcd8739ae039)();
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const preferencePanel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $77a28296cab754a7$export$37e5474577e02878));
    const showColumns = (event)=>{
        if (preferencePanel.open && preferencePanel.openedPanelValue === (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).columns) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).columns, columnPanelId, columnButtonId);
        onClick == null || onClick(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnSelector) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === columnPanelId;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
        ref: ref,
        id: columnButtonId,
        size: "small",
        "aria-label": apiRef.current.getLocaleText('toolbarColumnsLabel'),
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? columnPanelId : undefined,
        startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.columnSelectorIcon, {})
    }, other, {
        onClick: showColumns
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
        children: apiRef.current.getLocaleText('toolbarColumns')
    }));
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");












var $4uaIU = parcelRequire("4uaIU");
const $c3849e70933ada74$var$_excluded = [
    "onClick"
];
const $c3849e70933ada74$export$39ae0f666777d9ba = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarDensitySelector(props, ref) {
    var _rootProps$slotProps;
    const { onClick: onClick } = props, other = (0, $cMu4A.default)(props, $c3849e70933ada74$var$_excluded);
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const densityValue = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $2591c618679f9496$export$8483bbb6eba91abb));
    const densityButtonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const densityMenuId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const [open, setOpen] = $jSIPP.useState(false);
    const buttonRef = $jSIPP.useRef(null);
    const handleRef = (0, $c9ba6c1361f28d92$export$2e2bcd8739ae039)(ref, buttonRef);
    const densityOptions = [
        {
            icon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityCompactIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityCompact'),
            value: 'compact'
        },
        {
            icon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityStandardIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityStandard'),
            value: 'standard'
        },
        {
            icon: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityComfortableIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityComfortable'),
            value: 'comfortable'
        }
    ];
    const startIcon = $jSIPP.useMemo(()=>{
        switch(densityValue){
            case 'compact':
                return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityCompactIcon, {});
            case 'comfortable':
                return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityComfortableIcon, {});
            default:
                return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.densityStandardIcon, {});
        }
    }, [
        densityValue,
        rootProps
    ]);
    const handleDensitySelectorOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        onClick == null || onClick(event);
    };
    const handleDensitySelectorClose = ()=>{
        setOpen(false);
    };
    const handleDensityUpdate = (newDensity)=>{
        apiRef.current.setDensity(newDensity);
        setOpen(false);
    };
    const handleListKeyDown = (event)=>{
        if ((0, $2200ee459e36b6d0$export$34e5042f80daa3dd)(event.key)) event.preventDefault();
        if ((0, $2200ee459e36b6d0$export$81301abbcd0c8143)(event.key)) setOpen(false);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableDensitySelector) return null;
    const densityElements = densityOptions.map((option, index)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
            onClick: ()=>handleDensityUpdate(option.value),
            selected: option.value === densityValue,
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1acb14d046f50c17$export$2e2bcd8739ae039), {
                    children: option.icon
                }),
                option.label
            ]
        }, index));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
                ref: handleRef,
                size: "small",
                startIcon: startIcon,
                "aria-label": apiRef.current.getLocaleText('toolbarDensityLabel'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? densityMenuId : undefined,
                id: densityButtonId
            }, other, {
                onClick: handleDensitySelectorOpen
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
                children: apiRef.current.getLocaleText('toolbarDensity')
            })),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $67217aef89f147e8$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleDensitySelectorClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5b20d74b3d0610a4$export$2e2bcd8739ae039), {
                    id: densityMenuId,
                    className: (0, $4d97f950d65e57e8$export$2100d54e36406477).menuList,
                    "aria-labelledby": densityButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: densityElements
                })
            })
        ]
    });
});



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");


var $28RyA = parcelRequire("28RyA");

var $61i5U = parcelRequire("61i5U");
var $i3Yji = parcelRequire("i3Yji");










var $4uaIU = parcelRequire("4uaIU");
const $62ef82fcef87d64a$var$_excluded = [
    "componentsProps"
];
const $62ef82fcef87d64a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarFilterList'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $4d97f950d65e57e8$export$a2aa36217b862c23), classes);
};
const $62ef82fcef87d64a$var$GridToolbarFilterListRoot = (0, $28RyA.default)('ul', {
    name: 'MuiDataGrid',
    slot: 'ToolbarFilterList',
    overridesResolver: (_props, styles)=>styles.toolbarFilterList
})(({ theme: theme })=>({
        margin: theme.spacing(1, 1, 0.5),
        padding: theme.spacing(0, 1)
    }));
const $62ef82fcef87d64a$export$eef6782de2aba6b = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbarFilterButton(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { componentsProps: componentsProps = {} } = props, other = (0, $cMu4A.default)(props, $62ef82fcef87d64a$var$_excluded);
    const buttonProps = componentsProps.button || {};
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const activeFilters = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$c7447bfbd4ecafcc));
    const lookup = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $90c6bb88bfe45f18$export$8a3a9a6db584d7fd));
    const preferencePanel = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $77a28296cab754a7$export$37e5474577e02878));
    const classes = $62ef82fcef87d64a$var$useUtilityClasses(rootProps);
    const filterButtonId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const filterPanelId = (0, $0edf2a5582d0a9d6$export$2e2bcd8739ae039)();
    const tooltipContentNode = $jSIPP.useMemo(()=>{
        if (preferencePanel.open) return apiRef.current.getLocaleText('toolbarFiltersTooltipHide');
        if (activeFilters.length === 0) return apiRef.current.getLocaleText('toolbarFiltersTooltipShow');
        const getOperatorLabel = (item)=>lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator).label || apiRef.current.getLocaleText(`filterOperator${(0, $61i5U.default)(item.operator)}`).toString();
        const getFilterItemValue = (item)=>{
            const { getValueAsString: getValueAsString } = lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator);
            return getValueAsString ? getValueAsString(item.value) : item.value;
        };
        return /*#__PURE__*/ (0, $4uaIU.jsxs)("div", {
            children: [
                apiRef.current.getLocaleText('toolbarFiltersTooltipActive')(activeFilters.length),
                /*#__PURE__*/ (0, $4uaIU.jsx)($62ef82fcef87d64a$var$GridToolbarFilterListRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: activeFilters.map((item, index)=>(0, $erOpW.default)({}, lookup[item.field] && /*#__PURE__*/ (0, $4uaIU.jsx)("li", {
                            children: `${lookup[item.field].headerName || item.field}
                  ${getOperatorLabel(item)}
                  ${// implicit check for null and undefined
                            item.value != null ? getFilterItemValue(item) : ''}`
                        }, index)))
                })
            ]
        });
    }, [
        apiRef,
        rootProps,
        preferencePanel.open,
        activeFilters,
        lookup,
        classes
    ]);
    const toggleFilter = (event)=>{
        var _buttonProps$onClick;
        const { open: open, openedPanelValue: openedPanelValue } = preferencePanel;
        if (open && openedPanelValue === (0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $8f6bc22f7ecdaff8$export$e7e5652452e44b).filters, filterPanelId, filterButtonId);
        (_buttonProps$onClick = buttonProps.onClick) == null || _buttonProps$onClick.call(buttonProps, event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnFilter) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === filterPanelId;
    return /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseTooltip, (0, $erOpW.default)({
        title: tooltipContentNode,
        enterDelay: 1000
    }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
        children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseButton, (0, $erOpW.default)({
            ref: ref,
            id: filterButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText('toolbarFiltersLabel'),
            "aria-controls": isOpen ? filterPanelId : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $78af997fba0f6bfa$export$2e2bcd8739ae039), {
                badgeContent: activeFilters.length,
                color: "primary",
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.openFilterButtonIcon, {})
            })
        }, buttonProps, {
            onClick: toggleFilter
        }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseButton, {
            children: apiRef.current.getLocaleText('toolbarFilters')
        }))
    }));
});





var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $28RyA = parcelRequire("28RyA");







var $4uaIU = parcelRequire("4uaIU");
const $94bc59f82fd96604$var$_excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs"
];
const $94bc59f82fd96604$var$GridToolbarQuickFilterRoot = (0, $28RyA.default)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilter',
    overridesResolver: (props, styles)=>styles.toolbarQuickFilter
})(({ theme: theme })=>({
        width: 'auto',
        paddingBottom: theme.spacing(0.5),
        '& input': {
            marginLeft: theme.spacing(0.5)
        },
        '& .MuiInput-underline:before': {
            borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        [`& input[type=search]::-ms-clear,
& input[type=search]::-ms-reveal`]: {
            /* clears the 'X' icon from IE */ display: 'none',
            width: 0,
            height: 0
        },
        [`& input[type="search"]::-webkit-search-decoration,
  & input[type="search"]::-webkit-search-cancel-button,
  & input[type="search"]::-webkit-search-results-button,
  & input[type="search"]::-webkit-search-results-decoration`]: {
            /* clears the 'X' icon from Chrome */ display: 'none'
        }
    }));
const $94bc59f82fd96604$var$defaultSearchValueParser = (searchText)=>searchText.split(' ').filter((word)=>word !== '');
const $94bc59f82fd96604$var$defaultSearchValueFormatter = (values)=>values.join(' ');
function $94bc59f82fd96604$export$d7fbfb032c6d5ccc(props) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $a9fd235d25e1c808$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    const quickFilterValues = (0, $190d0dc02079d828$export$f96fd476863f2e4a)(apiRef, (0, $dcdbd4f8634a4b8d$export$6f9fe133e2c56816));
    const { quickFilterParser: quickFilterParser = $94bc59f82fd96604$var$defaultSearchValueParser, quickFilterFormatter: quickFilterFormatter = $94bc59f82fd96604$var$defaultSearchValueFormatter, debounceMs: debounceMs = rootProps.filterDebounceMs } = props, other = (0, $cMu4A.default)(props, $94bc59f82fd96604$var$_excluded);
    const [searchValue, setSearchValue] = $jSIPP.useState(()=>quickFilterFormatter(quickFilterValues != null ? quickFilterValues : []));
    const prevQuickFilterValuesRef = $jSIPP.useRef(quickFilterValues);
    $jSIPP.useEffect(()=>{
        if (!(0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setSearchValue((prevSearchValue)=>(0, $a4e890cf7e68aae0$export$78fdc9adc3f30400)(quickFilterParser(prevSearchValue), quickFilterValues) ? prevSearchValue : quickFilterFormatter(quickFilterValues != null ? quickFilterValues : []));
        }
    }, [
        quickFilterValues,
        quickFilterFormatter,
        quickFilterParser
    ]);
    const updateSearchValue = $jSIPP.useCallback((newSearchValue)=>{
        const newQuickFilterValues = quickFilterParser(newSearchValue);
        prevQuickFilterValuesRef.current = newQuickFilterValues;
        apiRef.current.setQuickFilterValues(newQuickFilterValues);
    }, [
        apiRef,
        quickFilterParser
    ]);
    const debouncedUpdateSearchValue = $jSIPP.useMemo(()=>(0, $73208469ed38da03$export$2e2bcd8739ae039)(updateSearchValue, debounceMs), [
        updateSearchValue,
        debounceMs
    ]);
    const handleSearchValueChange = $jSIPP.useCallback((event)=>{
        const newSearchValue = event.target.value;
        setSearchValue(newSearchValue);
        debouncedUpdateSearchValue(newSearchValue);
    }, [
        debouncedUpdateSearchValue
    ]);
    const handleSearchReset = $jSIPP.useCallback(()=>{
        setSearchValue('');
        updateSearchValue('');
    }, [
        updateSearchValue
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($94bc59f82fd96604$var$GridToolbarQuickFilterRoot, (0, $erOpW.default)({
        as: rootProps.slots.baseTextField,
        ownerState: rootProps,
        variant: "standard",
        value: searchValue,
        onChange: handleSearchValueChange,
        placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
        "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
        type: "search"
    }, other, {
        InputProps: (0, $erOpW.default)({
            startAdornment: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.quickFilterIcon, {
                fontSize: "small"
            }),
            endAdornment: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.baseIconButton, (0, $erOpW.default)({
                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
                size: "small",
                sx: {
                    visibility: searchValue ? 'visible' : 'hidden'
                },
                onClick: handleSearchReset
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)(rootProps.slots.quickFilterClearIcon, {
                    fontSize: "small"
                })
            }))
        }, other.InputProps)
    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseTextField));
}



var $4uaIU = parcelRequire("4uaIU");
const $dbd8a78836b4353d$var$_excluded = [
    "className",
    "csvOptions",
    "printOptions",
    "excelOptions",
    "showQuickFilter",
    "quickFilterProps"
];
const $dbd8a78836b4353d$export$6f17559aa1de380e = /*#__PURE__*/ $jSIPP.forwardRef(function GridToolbar(props, ref) {
    // TODO v7: think about where export option should be passed.
    // from slotProps={{ toolbarExport: { ...exportOption } }} seems to be more appropriate
    const { csvOptions: csvOptions, printOptions: printOptions, excelOptions: excelOptions, showQuickFilter: showQuickFilter = false, quickFilterProps: quickFilterProps = {} } = props, other = (0, $cMu4A.default)(props, $dbd8a78836b4353d$var$_excluded);
    const rootProps = (0, $f257fd85b572d216$export$8b0f8e71b71b7ed3)();
    if (rootProps.disableColumnFilter && rootProps.disableColumnSelector && rootProps.disableDensitySelector && !showQuickFilter) return null;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b4084da674dae987$export$276ebf2f43e1afe0), (0, $erOpW.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9c128ca030dbc17$export$9460f81121783d0f), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $62ef82fcef87d64a$export$eef6782de2aba6b), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c3849e70933ada74$export$39ae0f666777d9ba), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $a62d5bd6410a6559$export$ef68b449b329deb5), {
                csvOptions: csvOptions,
                printOptions: printOptions,
                excelOptions: excelOptions
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1
                }
            }),
            showQuickFilter && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $94bc59f82fd96604$export$d7fbfb032c6d5ccc), (0, $erOpW.default)({}, quickFilterProps))
        ]
    }));
});


/**
 * Drop-in for GridToolbar with the quick filter always on, focused on mount, and refocused
 * when typing starts anywhere on the page.
 *
 * Search matches hidden columns too — the quick filter works on row values, not on what is
 * rendered.
 */ const $6b19d1fc798f1d65$var$IyoGridToolbar = (props)=>{
    const toolbarRef = (0, $jSIPP.useRef)(null);
    (0, $jSIPP.useEffect)(()=>{
        const findInput = ()=>{
            var _toolbarRef_current;
            return (_toolbarRef_current = toolbarRef.current) === null || _toolbarRef_current === void 0 ? void 0 : _toolbarRef_current.querySelector('.MuiDataGrid-toolbarQuickFilter input');
        };
        const handleKeyDown = (event)=>{
            var // Focus during keydown, not keyup, so this keystroke lands in the field.
            _findInput;
            // Printable characters only; Escape, Tab and arrows belong to the grid.
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            if (event.key.length !== 1) return;
            const active = document.activeElement;
            if (!active) return;
            if (active.isContentEditable) return;
            if ([
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(active.tagName)) return;
            (_findInput = findInput()) === null || _findInput === void 0 ? void 0 : _findInput.focus();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbd8a78836b4353d$export$6f17559aa1de380e), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props), {
        ref: toolbarRef,
        showQuickFilter: true,
        quickFilterProps: (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            autoFocus: true,
            placeholder: "Search\u2026"
        }, props.quickFilterProps)
    }));
};
var $6b19d1fc798f1d65$export$2e2bcd8739ae039 = $6b19d1fc798f1d65$var$IyoGridToolbar;



var $jSIPP = parcelRequire("jSIPP");

/**
 * Opens the row named by ?id= once its list has loaded, then strips the parameter.
 *
 * The home page search links to /owners?id=77 and the like; this is the receiving end.
 * The parameter is cleared after opening so closing the dialog and pressing Edit again
 * behaves normally, and a refresh does not reopen what the user just closed.
 *
 * @param rows the list the id refers to; undefined while the query is in flight
 * @param openRow called once with the matching row
 */ const $fa76533b6a84f8f4$var$useLinkedRow = (rows, openRow)=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const location = (0, $418bff895eee7f39$export$45d76561a5302f2b)();
    const handled = (0, $jSIPP.useRef)(null);
    // Held in a ref so a handler redefined on every render does not retrigger the effect.
    const openRowRef = (0, $jSIPP.useRef)(openRow);
    openRowRef.current = openRow;
    (0, $jSIPP.useEffect)(()=>{
        const id = new URLSearchParams(location.search).get('id');
        if (!id || !rows || handled.current === id) return;
        const row = rows.find((candidate)=>String(candidate.id) === id);
        if (!row) return;
        handled.current = id;
        history.replace(location.pathname);
        openRowRef.current(row);
    }, [
        location.search,
        location.pathname,
        rows,
        history
    ]);
};
var $fa76533b6a84f8f4$export$2e2bcd8739ae039 = $fa76533b6a84f8f4$var$useLinkedRow;


const $bc3a015817250ece$var$Owners = ({})=>{
    var _getOwnerAssociations_data;
    // ####################[ Setup and Initialization ]####################
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const initializeColumns = (initialColumns)=>{
        return initialColumns.concat({
            field: "actions",
            headerName: "Actions",
            description: "Actions",
            minWidth: 175,
            renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Edit",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleEdit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6be52b93098825b$exports))), {})
                            })
                        }),
                        params.row.multi_site === 1 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Add Location",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleAddLocation(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ecd719ca051060c$exports))), {})
                            })
                        }),
                        params.row.disabled ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Enable",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "secondary",
                                onClick: (event)=>handleDisableSubmit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b096330a1aa10551$exports))), {})
                            })
                        }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Disable",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleDisableSubmit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9763220a10bead63$exports))), {})
                            })
                        })
                    ]
                })
        });
    };
    // ####################[ State Definitions ]####################
    const [businessId, setBusinessId] = (0, $jSIPP.useState)(null);
    const [cols, setCols] = (0, $jSIPP.useState)(initializeColumns((0, $030c734edfd36e74$export$53b3c91859018cd4)));
    const [editOpen, setEditOpen] = (0, $jSIPP.useState)(false);
    const [rowEditing, setRowEditing] = (0, $jSIPP.useState)([]);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)("");
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [editMode, setEditMode] = (0, $jSIPP.useState)("");
    const [timezoneName, setTimezoneName] = (0, $jSIPP.useState)(null);
    const [parentOwnerId, setParentOwnerId] = (0, $jSIPP.useState)(null);
    // ####################[ Query Definitions ]####################
    const getOwners = (0, $41632140e88fef11$export$dd0a697e1782aedd)("getOwners", async ()=>{
        return await (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const getOwnerAssociations = (0, $41632140e88fef11$export$dd0a697e1782aedd)("getOwnerAssociations", async ()=>{
        return await (0, $17b1048d84ada6dd$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        staleTime: Infinity
    });
    const postOwner = (0, $74568c0a766c827d$export$609860bf8b0084c)("postOwner", async (data)=>{
        return await (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).post(data);
    }, {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries("getOwners");
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    const putOwner = (0, $74568c0a766c827d$export$609860bf8b0084c)("putOwner", async (data)=>{
        return await (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).put(rowEditing.id, data);
    }, {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries("getOwners");
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    // ####################[ Event Handlers ]####################
    const handleCreate = async ()=>{
        setEditMode("create");
        setRowEditing(null);
        setBusinessId(null);
        setTimezoneName(null);
        setParentOwnerId(null);
        setEditOpen(true);
    };
    const handleAddLocation = async (event, row)=>{
        setEditMode("create");
        setRowEditing(null);
        setBusinessId(null);
        setTimezoneName(null);
        setParentOwnerId(row.id);
        setEditOpen(true);
    };
    const handleDisableSubmit = async (event, row)=>{
        setRowEditing(row);
        const body = {
            id: row.id,
            disabled: row.disabled ? 0 : 1,
            updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        };
        putOwner.mutate(body);
    };
    const handleEdit = async (event, row)=>{
        setEditMode("edit");
        setRowEditing(row);
        setBusinessId(row.business_id);
        setTimezoneName(row.timezone);
        setEditOpen(true);
    };
    // Arriving from the home page search as /owners?id=77 opens that owner.
    (0, $fa76533b6a84f8f4$export$2e2bcd8739ae039)(getOwners.data, (row)=>handleEdit(null, row));
    const handleError = (error)=>{
        var _error_response, _error_response1;
        setErrorOpen(false);
        setErrDisplayText(`${error.message}: ` + `${error.response ? JSON.stringify((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) : error.toString().slice(0, 200)}`);
        setErrorOpen(true);
        console.error(`${error.message}: ${JSON.stringify(((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.data) || error)}`);
    };
    const refreshTable = async ()=>{
        console.info("Refreshing table");
        await queryClient.invalidateQueries("getOwners");
    };
    // ####################[ The Component ]####################
    let childToParent = {};
    (_getOwnerAssociations_data = getOwnerAssociations.data) === null || _getOwnerAssociations_data === void 0 ? void 0 : _getOwnerAssociations_data.forEach((assoc)=>{
        childToParent[assoc.child_owner_id] = assoc.parent_owner_id;
    });
    const ownersMap = (getOwners.data || []).reduce((acc, owner)=>{
        acc[owner.id] = owner;
        return acc;
    }, {});
    function buildPath(ownerId) {
        const path = [];
        let currentId = ownerId;
        while(currentId){
            const currentOwner = ownersMap[currentId];
            if (!currentOwner) break;
            path.unshift(currentOwner.name);
            currentId = childToParent[currentId];
        }
        return path;
    }
    const rows = (getOwners.data || []).map((o)=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, o), {
            path: buildPath(o.id)
        }));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Owners",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                        editHandler: handleCreate,
                        onRefresh: refreshTable
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: "77vh",
                            "& .disabled": {
                                color: "#94A3B8"
                            }
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: rows,
                            getRowClassName: (params)=>params.row.disabled ? "disabled" : "",
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                            },
                            loading: getOwners.isLoading,
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        created_by: false,
                                        created_datetime: false,
                                        updated_by: false,
                                        updated_datetime: false
                                    }
                                }
                            },
                            density: "compact",
                            treeData: true,
                            getTreeDataPath: (row)=>row.path,
                            groupingColDef: {
                                field: "name",
                                headerName: "Name",
                                minWidth: 250
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e1c381551f19ef5d$export$2e2bcd8739ae039), {
                open: editOpen,
                setOpen: setEditOpen,
                rowEditing: rowEditing,
                mode: editMode,
                handleError: handleError,
                parentOwnerId: parentOwnerId
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $bc3a015817250ece$export$2e2bcd8739ae039 = $bc3a015817250ece$var$Owners;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");


var $iLAKr = parcelRequire("iLAKr");

var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $87539d2ef3e44da9$export$72aef224d6115253(slot) {
    return (0, $geF11.default)('MuiTab', slot);
}
const $87539d2ef3e44da9$var$tabClasses = (0, $rARwS.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $87539d2ef3e44da9$export$2e2bcd8739ae039 = $87539d2ef3e44da9$var$tabClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $750ab4e4aedcf19a$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $750ab4e4aedcf19a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $iLAKr.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $87539d2ef3e44da9$export$72aef224d6115253), classes);
};
const $750ab4e4aedcf19a$var$TabRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $iLAKr.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).iconWrapper}`]: (0, $erOpW.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $87539d2ef3e44da9$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $750ab4e4aedcf19a$var$Tab = /*#__PURE__*/ $jSIPP.forwardRef(function Tab(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $cMu4A.default)(props, $750ab4e4aedcf19a$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $750ab4e4aedcf19a$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $jSIPP.isValidElement(iconProp) ? /*#__PURE__*/ $jSIPP.cloneElement(iconProp, {
        className: (0, $86B3v.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($750ab4e4aedcf19a$var$TabRoot, (0, $erOpW.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $4uaIU.jsxs)($jSIPP.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $750ab4e4aedcf19a$export$2e2bcd8739ae039 = $750ab4e4aedcf19a$var$Tab;


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");



var $86B3v = parcelRequire("86B3v");


var $i3Yji = parcelRequire("i3Yji");



var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $a0cec42e6012bc3b$var$cachedType;
function $a0cec42e6012bc3b$export$a10970ffb6510128() {
    if ($a0cec42e6012bc3b$var$cachedType) return $a0cec42e6012bc3b$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $a0cec42e6012bc3b$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $a0cec42e6012bc3b$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $a0cec42e6012bc3b$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $a0cec42e6012bc3b$var$cachedType;
}
function $a0cec42e6012bc3b$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $a0cec42e6012bc3b$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $ab02df2a94a7479a$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $ab02df2a94a7479a$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $ab02df2a94a7479a$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");




var $4uaIU = parcelRequire("4uaIU");
'use client';
const $f78438d37970a608$var$_excluded = [
    "onChange"
];
const $f78438d37970a608$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f78438d37970a608$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $cMu4A.default)(props, $f78438d37970a608$var$_excluded);
    const scrollbarHeight = $jSIPP.useRef();
    const nodeRef = $jSIPP.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $b84d98ac1a64e1e6$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $e0d5cb0991583f89$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $jSIPP.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", (0, $erOpW.default)({
        style: $f78438d37970a608$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");






var $eyQWd = parcelRequire("eyQWd");

var $28RyA = parcelRequire("28RyA");

var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $b08ce9356fc39fb5$export$34861783d3c2eef8(slot) {
    return (0, $geF11.default)('MuiTabScrollButton', slot);
}
const $b08ce9356fc39fb5$var$tabScrollButtonClasses = (0, $rARwS.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $b08ce9356fc39fb5$export$2e2bcd8739ae039 = $b08ce9356fc39fb5$var$tabScrollButtonClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $b1435b873c6175fe$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $b1435b873c6175fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $b08ce9356fc39fb5$export$34861783d3c2eef8), classes);
};
const $b1435b873c6175fe$var$TabScrollButtonRoot = (0, $28RyA.default)((0, $631d68b9552365dc$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $b08ce9356fc39fb5$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $b1435b873c6175fe$var$TabScrollButton = /*#__PURE__*/ $jSIPP.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $cMu4A.default)(props, $b1435b873c6175fe$var$_excluded);
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const ownerState = (0, $erOpW.default)({
        isRtl: isRtl
    }, props);
    const classes = $b1435b873c6175fe$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $0c82a21be9272770$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $4fe623678deec284$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $4uaIU.jsx)($b1435b873c6175fe$var$TabScrollButtonRoot, (0, $erOpW.default)({
        component: "div",
        className: (0, $86B3v.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $4uaIU.jsx)(StartButtonIcon, (0, $erOpW.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $4uaIU.jsx)(EndButtonIcon, (0, $erOpW.default)({}, endButtonIconProps))
    }));
});
var $b1435b873c6175fe$export$2e2bcd8739ae039 = $b1435b873c6175fe$var$TabScrollButton;




var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $f324936ee9bc0d42$export$cdd93bd054dec359(slot) {
    return (0, $geF11.default)('MuiTabs', slot);
}
const $f324936ee9bc0d42$var$tabsClasses = (0, $rARwS.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $f324936ee9bc0d42$export$2e2bcd8739ae039 = $f324936ee9bc0d42$var$tabsClasses;





var $4uaIU = parcelRequire("4uaIU");
'use client';
const $24d3c0f0e1b0f89c$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $24d3c0f0e1b0f89c$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $24d3c0f0e1b0f89c$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $24d3c0f0e1b0f89c$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $24d3c0f0e1b0f89c$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $f324936ee9bc0d42$export$cdd93bd054dec359), classes);
};
const $24d3c0f0e1b0f89c$var$TabsRoot = (0, $28RyA.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f324936ee9bc0d42$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $f324936ee9bc0d42$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $f324936ee9bc0d42$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $24d3c0f0e1b0f89c$var$TabsScroller = (0, $28RyA.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $24d3c0f0e1b0f89c$var$FlexContainer = (0, $28RyA.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $24d3c0f0e1b0f89c$var$TabsIndicator = (0, $28RyA.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $erOpW.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $24d3c0f0e1b0f89c$var$TabsScrollbarSize = (0, $28RyA.default)((0, $f78438d37970a608$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $24d3c0f0e1b0f89c$var$defaultIndicatorStyle = {};
let $24d3c0f0e1b0f89c$var$warnedOnceTabPresent = false;
const $24d3c0f0e1b0f89c$var$Tabs = /*#__PURE__*/ $jSIPP.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const isRtl = (0, $075f43d5cf6cf500$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $b1435b873c6175fe$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $cMu4A.default)(props, $24d3c0f0e1b0f89c$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $erOpW.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $24d3c0f0e1b0f89c$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $c522819850191c59$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $jSIPP.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $jSIPP.useState($24d3c0f0e1b0f89c$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $jSIPP.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $jSIPP.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $jSIPP.useState(false);
    const [scrollerStyle, setScrollerStyle] = $jSIPP.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $jSIPP.useRef(null);
    const tabListRef = $jSIPP.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $a0cec42e6012bc3b$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $ab02df2a94a7479a$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $a0cec42e6012bc3b$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $jSIPP.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $4uaIU.jsx)($24d3c0f0e1b0f89c$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $86B3v.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $4uaIU.jsx)(ScrollButtonComponent, (0, $erOpW.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $86B3v.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $4uaIU.jsx)(ScrollButtonComponent, (0, $erOpW.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $86B3v.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $c310764ec7eb15ca$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $jSIPP.useEffect(()=>{
        const handleResize = (0, $e0d5cb0991583f89$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $87890d34d49f3e82$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $jSIPP.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $jSIPP.useEffect(()=>{
        setMounted(true);
    }, []);
    $jSIPP.useEffect(()=>{
        updateIndicatorState();
    });
    $jSIPP.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($24d3c0f0e1b0f89c$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $jSIPP.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $4uaIU.jsx)($24d3c0f0e1b0f89c$var$TabsIndicator, (0, $erOpW.default)({}, TabIndicatorProps, {
        className: (0, $86B3v.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $erOpW.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $jSIPP.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $jSIPP.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $jSIPP.cloneElement(child, (0, $erOpW.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $2ec73871339adc46$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $24d3c0f0e1b0f89c$var$moveFocus(list, currentFocus, $24d3c0f0e1b0f89c$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $24d3c0f0e1b0f89c$var$moveFocus(list, currentFocus, $24d3c0f0e1b0f89c$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $24d3c0f0e1b0f89c$var$moveFocus(list, null, $24d3c0f0e1b0f89c$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $24d3c0f0e1b0f89c$var$moveFocus(list, null, $24d3c0f0e1b0f89c$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)($24d3c0f0e1b0f89c$var$TabsRoot, (0, $erOpW.default)({
        className: (0, $86B3v.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $4uaIU.jsxs)($24d3c0f0e1b0f89c$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)($24d3c0f0e1b0f89c$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $24d3c0f0e1b0f89c$export$2e2bcd8739ae039 = $24d3c0f0e1b0f89c$var$Tabs;


var $ad317ed5c7ae9683$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($ad317ed5c7ae9683$exports, "__esModule", {
    value: true
});
$ad317ed5c7ae9683$exports.default = void 0;

var $ad317ed5c7ae9683$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $ad317ed5c7ae9683$var$_default = $ad317ed5c7ae9683$exports.default = (0, $ad317ed5c7ae9683$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4.9 13.49-1.4 1.4c-.2.2-.51.2-.71 0l-3.41-3.41c-1.22.43-2.64.17-3.62-.81-1.11-1.11-1.3-2.79-.59-4.1l2.35 2.35 1.41-1.41-2.35-2.34c1.32-.71 2.99-.52 4.1.59.98.98 1.24 2.4.81 3.62l3.41 3.41c.19.19.19.51 0 .7"
}), 'BuildCircle');



var $0eefa11e679f91b4$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($0eefa11e679f91b4$exports, "__esModule", {
    value: true
});
$0eefa11e679f91b4$exports.default = void 0;

var $0eefa11e679f91b4$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $0eefa11e679f91b4$var$_default = $0eefa11e679f91b4$exports.default = (0, $0eefa11e679f91b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');






var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

const $c5b291bc5932a146$var$MessagePopup = ({ displayText: displayText, duration: duration, severity: severity = 'success', open: open, setOpen: setOpen = ()=>{}, onClose: onClose })=>{
    const hideDuration = duration ? duration : 60000;
    const handleClose = ()=>{
        setOpen(false);
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $14192e9e94f1bc21$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        autoHideDuration: hideDuration,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
            onClose: handleClose,
            severity: severity,
            children: displayText
        })
    });
};
var $c5b291bc5932a146$export$2e2bcd8739ae039 = $c5b291bc5932a146$var$MessagePopup;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");



var $ghfJh = parcelRequire("ghfJh");




const $1ed46d3dcbd1a752$var$useProviderQuery = (method, queryClient, state, setState, produceError)=>{
    switch(method){
        case 'POST':
            return (0, $74568c0a766c827d$export$609860bf8b0084c)('postProvider', async (data)=>{
                return await (0, $04fdf08493329c97$export$2e2bcd8739ae039).post(data);
            }, {
                onSuccess: async (resp)=>{
                    setState.setProviderId(resp);
                    setState.setMsgText(`Provider created, id = ${resp.id}`);
                    setState.setMsgOpen(true);
                    await queryClient.invalidateQueries('getProvidersPage');
                },
                onError: (error)=>{
                    produceError(error, setState);
                }
            });
        case 'PUT':
            return (0, $74568c0a766c827d$export$609860bf8b0084c)('putProvider', async (data)=>{
                return await (0, $04fdf08493329c97$export$2e2bcd8739ae039).put(state.rowEditing.id, data);
            }, {
                onSuccess: async ()=>{
                    setState.setMsgText(`Provider ${state.rowEditing.name} updated`);
                    setState.setMsgOpen(true);
                    await queryClient.invalidateQueries('getProvidersPage');
                },
                onError: (error)=>{
                    produceError(error, setState);
                }
            });
        default:
            return;
    }
};
var $1ed46d3dcbd1a752$export$2e2bcd8739ae039 = {
    useProviderQuery: $1ed46d3dcbd1a752$var$useProviderQuery
};




const $885b40e5e295b926$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $885b40e5e295b926$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$885b40e5e295b926$var$HOST_URL}/provider-child-category`)).data;
};
const $885b40e5e295b926$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$885b40e5e295b926$var$HOST_URL}/provider-child-category`, data)).data;
};
const $885b40e5e295b926$var$put = async (id, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$885b40e5e295b926$var$HOST_URL}/provider-child-category/${id}`, data)).data;
};
var $885b40e5e295b926$export$2e2bcd8739ae039 = {
    getAll: $885b40e5e295b926$var$getAll,
    post: $885b40e5e295b926$var$post,
    put: $885b40e5e295b926$var$put
};



var $4uaIU = parcelRequire("4uaIU");

/**
 * A text field with a better helper text and spacing
 */ const $93f88473253fbdd2$var$IyoFormikTextField = ({ name: name, label: label, values: values, touched: touched, errors: errors, handleBlur: handleBlur, handleChange: handleChange, required: required = false, numeric: numeric = false, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
        name: name,
        label: label,
        value: values[name],
        error: Boolean(touched[name] && errors[name]),
        helperText: Boolean(touched[name] && errors[name]) ? '\u25B4 ' + errors[name] : ' ',
        FormHelperTextProps: {
            sx: {
                textAlign: 'right',
                lineHeight: 1,
                mx: 0,
                my: '0.125rem'
            }
        },
        fullWidth: true,
        onBlur: handleBlur,
        onChange: handleChange,
        variant: "outlined",
        inputProps: numeric ? {
            type: 'number'
        } : {},
        required: required,
        disabled: disabled
    });
};
var $93f88473253fbdd2$export$2e2bcd8739ae039 = $93f88473253fbdd2$var$IyoFormikTextField;



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");


var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $fIt1N = parcelRequire("fIt1N");

var $erOpW = parcelRequire("erOpW");

function $8cfca46295686930$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $erOpW.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $c2b9b15677bd9539$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $c2b9b15677bd9539$export$2e2bcd8739ae039 = $c2b9b15677bd9539$var$multiKeyStore;



function $b5dd19ae449f8606$export$2e2bcd8739ae039() {
    var _privateTheme$$$mater;
    const privateTheme = (0, $a231dca6dd31ff9d$export$2e2bcd8739ae039)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}



var $erOpW = parcelRequire("erOpW");

var $cMu4A = parcelRequire("cMu4A");

var $jSIPP = parcelRequire("jSIPP");



var $fIt1N = parcelRequire("fIt1N");

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $ae9870d7747fcf84$var$stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function $ae9870d7747fcf84$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = 'jss', seed: seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($ae9870d7747fcf84$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $ef17e1ab3c895f89$export$2e2bcd8739ae039] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}




var $fIt1N = parcelRequire("fIt1N");
var $d518c1330bac79ab$var$now = Date.now();
var $d518c1330bac79ab$var$fnValuesNs = "fnValues" + $d518c1330bac79ab$var$now;
var $d518c1330bac79ab$var$fnRuleNs = "fnStyle" + ++$d518c1330bac79ab$var$now;
var $d518c1330bac79ab$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $fIt1N.createRule)(name, {}, options);
            rule[$d518c1330bac79ab$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($d518c1330bac79ab$var$fnValuesNs in rule || $d518c1330bac79ab$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$d518c1330bac79ab$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$d518c1330bac79ab$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$d518c1330bac79ab$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $d518c1330bac79ab$export$2e2bcd8739ae039 = $d518c1330bac79ab$var$functionPlugin;



var $erOpW = parcelRequire("erOpW");

var $fIt1N = parcelRequire("fIt1N");
var $a2c84ff23f57ce8c$var$at = '@global';
var $a2c84ff23f57ce8c$var$atPrefix = '@global ';
var $a2c84ff23f57ce8c$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $a2c84ff23f57ce8c$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $fIt1N.RuleList)((0, $erOpW.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $a2c84ff23f57ce8c$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $a2c84ff23f57ce8c$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($a2c84ff23f57ce8c$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $erOpW.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $a2c84ff23f57ce8c$var$separatorRegExp = /\s*,\s*/g;
function $a2c84ff23f57ce8c$var$addScope(selector, scope) {
    var parts = selector.split($a2c84ff23f57ce8c$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $a2c84ff23f57ce8c$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$a2c84ff23f57ce8c$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $erOpW.default)({}, options, {
        selector: $a2c84ff23f57ce8c$var$addScope(name, rule.selector)
    }));
    delete style[$a2c84ff23f57ce8c$var$at];
}
function $a2c84ff23f57ce8c$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $a2c84ff23f57ce8c$var$at.length) !== $a2c84ff23f57ce8c$var$at) continue;
        var selector = $a2c84ff23f57ce8c$var$addScope(prop.substr($a2c84ff23f57ce8c$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $erOpW.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $a2c84ff23f57ce8c$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $a2c84ff23f57ce8c$var$at) return new $a2c84ff23f57ce8c$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $a2c84ff23f57ce8c$var$atPrefix.length) === $a2c84ff23f57ce8c$var$atPrefix) return new $a2c84ff23f57ce8c$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $a2c84ff23f57ce8c$var$handleNestedGlobalContainerRule(rule, sheet);
        $a2c84ff23f57ce8c$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $a2c84ff23f57ce8c$export$2e2bcd8739ae039 = $a2c84ff23f57ce8c$var$jssGlobal;



var $erOpW = parcelRequire("erOpW");

var $9f53a5b04e0582cf$var$separatorRegExp = /\s*,\s*/g;
var $9f53a5b04e0582cf$var$parentRegExp = /&/g;
var $9f53a5b04e0582cf$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9f53a5b04e0582cf$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($9f53a5b04e0582cf$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($9f53a5b04e0582cf$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($9f53a5b04e0582cf$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $erOpW.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $erOpW.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($9f53a5b04e0582cf$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $erOpW.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $erOpW.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $9f53a5b04e0582cf$export$2e2bcd8739ae039 = $9f53a5b04e0582cf$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $f16c9075e7bd2b89$var$uppercasePattern = /[A-Z]/g;
var $f16c9075e7bd2b89$var$msPattern = /^ms-/;
var $f16c9075e7bd2b89$var$cache = {};
function $f16c9075e7bd2b89$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $f16c9075e7bd2b89$var$hyphenateStyleName(name) {
    if ($f16c9075e7bd2b89$var$cache.hasOwnProperty(name)) return $f16c9075e7bd2b89$var$cache[name];
    var hName = name.replace($f16c9075e7bd2b89$var$uppercasePattern, $f16c9075e7bd2b89$var$toHyphenLower);
    return $f16c9075e7bd2b89$var$cache[name] = $f16c9075e7bd2b89$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $f16c9075e7bd2b89$export$2e2bcd8739ae039 = $f16c9075e7bd2b89$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $51075fd2000df302$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $f16c9075e7bd2b89$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($51075fd2000df302$var$convertCase);
        else converted.fallbacks = $51075fd2000df302$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $51075fd2000df302$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $51075fd2000df302$var$convertCase(style[index]);
            return style;
        }
        return $51075fd2000df302$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $f16c9075e7bd2b89$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $51075fd2000df302$export$2e2bcd8739ae039 = $51075fd2000df302$var$camelCase;



var $fIt1N = parcelRequire("fIt1N");
var $088fb6090b542776$var$px = (0, $fIt1N.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $088fb6090b542776$var$ms = (0, $fIt1N.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $088fb6090b542776$var$percent = (0, $fIt1N.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $088fb6090b542776$var$defaultUnits = {
    // Animation properties
    'animation-delay': $088fb6090b542776$var$ms,
    'animation-duration': $088fb6090b542776$var$ms,
    // Background properties
    'background-position': $088fb6090b542776$var$px,
    'background-position-x': $088fb6090b542776$var$px,
    'background-position-y': $088fb6090b542776$var$px,
    'background-size': $088fb6090b542776$var$px,
    // Border Properties
    border: $088fb6090b542776$var$px,
    'border-bottom': $088fb6090b542776$var$px,
    'border-bottom-left-radius': $088fb6090b542776$var$px,
    'border-bottom-right-radius': $088fb6090b542776$var$px,
    'border-bottom-width': $088fb6090b542776$var$px,
    'border-left': $088fb6090b542776$var$px,
    'border-left-width': $088fb6090b542776$var$px,
    'border-radius': $088fb6090b542776$var$px,
    'border-right': $088fb6090b542776$var$px,
    'border-right-width': $088fb6090b542776$var$px,
    'border-top': $088fb6090b542776$var$px,
    'border-top-left-radius': $088fb6090b542776$var$px,
    'border-top-right-radius': $088fb6090b542776$var$px,
    'border-top-width': $088fb6090b542776$var$px,
    'border-width': $088fb6090b542776$var$px,
    'border-block': $088fb6090b542776$var$px,
    'border-block-end': $088fb6090b542776$var$px,
    'border-block-end-width': $088fb6090b542776$var$px,
    'border-block-start': $088fb6090b542776$var$px,
    'border-block-start-width': $088fb6090b542776$var$px,
    'border-block-width': $088fb6090b542776$var$px,
    'border-inline': $088fb6090b542776$var$px,
    'border-inline-end': $088fb6090b542776$var$px,
    'border-inline-end-width': $088fb6090b542776$var$px,
    'border-inline-start': $088fb6090b542776$var$px,
    'border-inline-start-width': $088fb6090b542776$var$px,
    'border-inline-width': $088fb6090b542776$var$px,
    'border-start-start-radius': $088fb6090b542776$var$px,
    'border-start-end-radius': $088fb6090b542776$var$px,
    'border-end-start-radius': $088fb6090b542776$var$px,
    'border-end-end-radius': $088fb6090b542776$var$px,
    // Margin properties
    margin: $088fb6090b542776$var$px,
    'margin-bottom': $088fb6090b542776$var$px,
    'margin-left': $088fb6090b542776$var$px,
    'margin-right': $088fb6090b542776$var$px,
    'margin-top': $088fb6090b542776$var$px,
    'margin-block': $088fb6090b542776$var$px,
    'margin-block-end': $088fb6090b542776$var$px,
    'margin-block-start': $088fb6090b542776$var$px,
    'margin-inline': $088fb6090b542776$var$px,
    'margin-inline-end': $088fb6090b542776$var$px,
    'margin-inline-start': $088fb6090b542776$var$px,
    // Padding properties
    padding: $088fb6090b542776$var$px,
    'padding-bottom': $088fb6090b542776$var$px,
    'padding-left': $088fb6090b542776$var$px,
    'padding-right': $088fb6090b542776$var$px,
    'padding-top': $088fb6090b542776$var$px,
    'padding-block': $088fb6090b542776$var$px,
    'padding-block-end': $088fb6090b542776$var$px,
    'padding-block-start': $088fb6090b542776$var$px,
    'padding-inline': $088fb6090b542776$var$px,
    'padding-inline-end': $088fb6090b542776$var$px,
    'padding-inline-start': $088fb6090b542776$var$px,
    // Mask properties
    'mask-position-x': $088fb6090b542776$var$px,
    'mask-position-y': $088fb6090b542776$var$px,
    'mask-size': $088fb6090b542776$var$px,
    // Width and height properties
    height: $088fb6090b542776$var$px,
    width: $088fb6090b542776$var$px,
    'min-height': $088fb6090b542776$var$px,
    'max-height': $088fb6090b542776$var$px,
    'min-width': $088fb6090b542776$var$px,
    'max-width': $088fb6090b542776$var$px,
    // Position properties
    bottom: $088fb6090b542776$var$px,
    left: $088fb6090b542776$var$px,
    top: $088fb6090b542776$var$px,
    right: $088fb6090b542776$var$px,
    inset: $088fb6090b542776$var$px,
    'inset-block': $088fb6090b542776$var$px,
    'inset-block-end': $088fb6090b542776$var$px,
    'inset-block-start': $088fb6090b542776$var$px,
    'inset-inline': $088fb6090b542776$var$px,
    'inset-inline-end': $088fb6090b542776$var$px,
    'inset-inline-start': $088fb6090b542776$var$px,
    // Shadow properties
    'box-shadow': $088fb6090b542776$var$px,
    'text-shadow': $088fb6090b542776$var$px,
    // Column properties
    'column-gap': $088fb6090b542776$var$px,
    'column-rule': $088fb6090b542776$var$px,
    'column-rule-width': $088fb6090b542776$var$px,
    'column-width': $088fb6090b542776$var$px,
    // Font and text properties
    'font-size': $088fb6090b542776$var$px,
    'font-size-delta': $088fb6090b542776$var$px,
    'letter-spacing': $088fb6090b542776$var$px,
    'text-decoration-thickness': $088fb6090b542776$var$px,
    'text-indent': $088fb6090b542776$var$px,
    'text-stroke': $088fb6090b542776$var$px,
    'text-stroke-width': $088fb6090b542776$var$px,
    'word-spacing': $088fb6090b542776$var$px,
    // Motion properties
    motion: $088fb6090b542776$var$px,
    'motion-offset': $088fb6090b542776$var$px,
    // Outline properties
    outline: $088fb6090b542776$var$px,
    'outline-offset': $088fb6090b542776$var$px,
    'outline-width': $088fb6090b542776$var$px,
    // Perspective properties
    perspective: $088fb6090b542776$var$px,
    'perspective-origin-x': $088fb6090b542776$var$percent,
    'perspective-origin-y': $088fb6090b542776$var$percent,
    // Transform properties
    'transform-origin': $088fb6090b542776$var$percent,
    'transform-origin-x': $088fb6090b542776$var$percent,
    'transform-origin-y': $088fb6090b542776$var$percent,
    'transform-origin-z': $088fb6090b542776$var$percent,
    // Transition properties
    'transition-delay': $088fb6090b542776$var$ms,
    'transition-duration': $088fb6090b542776$var$ms,
    // Alignment properties
    'vertical-align': $088fb6090b542776$var$px,
    'flex-basis': $088fb6090b542776$var$px,
    // Some random properties
    'shape-margin': $088fb6090b542776$var$px,
    size: $088fb6090b542776$var$px,
    gap: $088fb6090b542776$var$px,
    // Grid properties
    grid: $088fb6090b542776$var$px,
    'grid-gap': $088fb6090b542776$var$px,
    'row-gap': $088fb6090b542776$var$px,
    'grid-row-gap': $088fb6090b542776$var$px,
    'grid-column-gap': $088fb6090b542776$var$px,
    'grid-template-rows': $088fb6090b542776$var$px,
    'grid-template-columns': $088fb6090b542776$var$px,
    'grid-auto-rows': $088fb6090b542776$var$px,
    'grid-auto-columns': $088fb6090b542776$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $088fb6090b542776$var$px,
    'box-shadow-y': $088fb6090b542776$var$px,
    'box-shadow-blur': $088fb6090b542776$var$px,
    'box-shadow-spread': $088fb6090b542776$var$px,
    'font-line-height': $088fb6090b542776$var$px,
    'text-shadow-x': $088fb6090b542776$var$px,
    'text-shadow-y': $088fb6090b542776$var$px,
    'text-shadow-blur': $088fb6090b542776$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $088fb6090b542776$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $088fb6090b542776$var$units = $088fb6090b542776$var$addCamelCasedVersion($088fb6090b542776$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $088fb6090b542776$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $088fb6090b542776$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $088fb6090b542776$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $088fb6090b542776$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $088fb6090b542776$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $088fb6090b542776$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $088fb6090b542776$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $088fb6090b542776$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $088fb6090b542776$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $088fb6090b542776$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $088fb6090b542776$export$2e2bcd8739ae039 = $088fb6090b542776$var$defaultUnit;



var $llCtR = parcelRequire("llCtR");
function $d103c14e5709236a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $64bd5c5c3156ba0f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $d103c14e5709236a$export$2e2bcd8739ae039)(r);
}


function $f24844b5d4d0ae95$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $2f7a0465f407354b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $d103c14e5709236a$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $d103c14e5709236a$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $73e8591433573f1b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $3a3d3e5ad168638d$export$2e2bcd8739ae039(r) {
    return (0, $64bd5c5c3156ba0f$export$2e2bcd8739ae039)(r) || (0, $f24844b5d4d0ae95$export$2e2bcd8739ae039)(r) || (0, $2f7a0465f407354b$export$2e2bcd8739ae039)(r) || (0, $73e8591433573f1b$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $71e43d6c7456b47e$var$js = '';
var $71e43d6c7456b47e$var$css = '';
var $71e43d6c7456b47e$var$vendor = '';
var $71e43d6c7456b47e$var$browser = '';
var $71e43d6c7456b47e$var$isTouch = (0, $llCtR.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $llCtR.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $71e43d6c7456b47e$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $71e43d6c7456b47e$var$_document$createEleme = document.createElement('p'), $71e43d6c7456b47e$var$style = $71e43d6c7456b47e$var$_document$createEleme.style;
    var $71e43d6c7456b47e$var$testProp = 'Transform';
    for(var $71e43d6c7456b47e$var$key in $71e43d6c7456b47e$var$jsCssMap)if ($71e43d6c7456b47e$var$key + $71e43d6c7456b47e$var$testProp in $71e43d6c7456b47e$var$style) {
        $71e43d6c7456b47e$var$js = $71e43d6c7456b47e$var$key;
        $71e43d6c7456b47e$var$css = $71e43d6c7456b47e$var$jsCssMap[$71e43d6c7456b47e$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($71e43d6c7456b47e$var$js === 'Webkit' && 'msHyphens' in $71e43d6c7456b47e$var$style) {
        $71e43d6c7456b47e$var$js = 'ms';
        $71e43d6c7456b47e$var$css = $71e43d6c7456b47e$var$jsCssMap.ms;
        $71e43d6c7456b47e$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($71e43d6c7456b47e$var$js === 'Webkit' && '-apple-trailing-word' in $71e43d6c7456b47e$var$style) $71e43d6c7456b47e$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $71e43d6c7456b47e$export$82e9f45cca5ba907 = {
    js: $71e43d6c7456b47e$var$js,
    css: $71e43d6c7456b47e$var$css,
    vendor: $71e43d6c7456b47e$var$vendor,
    browser: $71e43d6c7456b47e$var$browser,
    isTouch: $71e43d6c7456b47e$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $71e43d6c7456b47e$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $71e43d6c7456b47e$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $71e43d6c7456b47e$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $71e43d6c7456b47e$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Webkit') return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $71e43d6c7456b47e$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $71e43d6c7456b47e$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $71e43d6c7456b47e$var$camelize(str) {
    return str.replace($71e43d6c7456b47e$var$regExp, $71e43d6c7456b47e$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $71e43d6c7456b47e$var$pascalize(str) {
    return $71e43d6c7456b47e$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $71e43d6c7456b47e$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($71e43d6c7456b47e$var$camelize(longhand) in style) return prop;
            if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js + $71e43d6c7456b47e$var$pascalize(longhand) in style) return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $71e43d6c7456b47e$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.vendor === 'apple' && !$71e43d6c7456b47e$export$82e9f45cca5ba907.isTouch) return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $71e43d6c7456b47e$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $71e43d6c7456b47e$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $71e43d6c7456b47e$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Webkit' || $71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms' && $71e43d6c7456b47e$export$82e9f45cca5ba907.browser !== 'edge') return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $71e43d6c7456b47e$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Moz' || $71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms' || $71e43d6c7456b47e$export$82e9f45cca5ba907.vendor === 'apple') return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $71e43d6c7456b47e$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $71e43d6c7456b47e$var$pascalize(prop);
            return jsProp in style ? $71e43d6c7456b47e$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $71e43d6c7456b47e$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $71e43d6c7456b47e$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $71e43d6c7456b47e$export$82e9f45cca5ba907.js + $71e43d6c7456b47e$var$pascalize(newProp) in style ? $71e43d6c7456b47e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $71e43d6c7456b47e$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $71e43d6c7456b47e$var$camelize(prop) in style ? prop : false;
    }
};
var $71e43d6c7456b47e$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $71e43d6c7456b47e$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js + pascalized in style) return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $71e43d6c7456b47e$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms') return "" + $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $71e43d6c7456b47e$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($71e43d6c7456b47e$export$82e9f45cca5ba907.js === 'ms') return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $71e43d6c7456b47e$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $71e43d6c7456b47e$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $71e43d6c7456b47e$var$propMap[prop];
        if (!newProp) return false;
        return $71e43d6c7456b47e$export$82e9f45cca5ba907.js + $71e43d6c7456b47e$var$pascalize(newProp) in style ? $71e43d6c7456b47e$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $71e43d6c7456b47e$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $71e43d6c7456b47e$var$propKeys = Object.keys($71e43d6c7456b47e$var$propMap$1);
var $71e43d6c7456b47e$var$prefixCss = function prefixCss(p) {
    return $71e43d6c7456b47e$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $71e43d6c7456b47e$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($71e43d6c7456b47e$var$propKeys.indexOf(prop) > -1) {
            var newProp = $71e43d6c7456b47e$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $71e43d6c7456b47e$export$82e9f45cca5ba907.js + $71e43d6c7456b47e$var$pascalize(newProp) in style ? $71e43d6c7456b47e$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($71e43d6c7456b47e$export$82e9f45cca5ba907.js + $71e43d6c7456b47e$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($71e43d6c7456b47e$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $71e43d6c7456b47e$var$plugins = [
    $71e43d6c7456b47e$var$appearence,
    $71e43d6c7456b47e$var$colorAdjust,
    $71e43d6c7456b47e$var$mask,
    $71e43d6c7456b47e$var$textOrientation,
    $71e43d6c7456b47e$var$transform,
    $71e43d6c7456b47e$var$transition,
    $71e43d6c7456b47e$var$writingMode,
    $71e43d6c7456b47e$var$userSelect,
    $71e43d6c7456b47e$var$breakPropsOld,
    $71e43d6c7456b47e$var$inlineLogicalOld,
    $71e43d6c7456b47e$var$unprefixed,
    $71e43d6c7456b47e$var$prefixed,
    $71e43d6c7456b47e$var$scrollSnap,
    $71e43d6c7456b47e$var$overscrollBehavior,
    $71e43d6c7456b47e$var$flex2012,
    $71e43d6c7456b47e$var$flex2009
];
var $71e43d6c7456b47e$var$propertyDetectors = $71e43d6c7456b47e$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $71e43d6c7456b47e$var$noPrefill = $71e43d6c7456b47e$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $3a3d3e5ad168638d$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $71e43d6c7456b47e$var$el;
var $71e43d6c7456b47e$var$cache = {};
if (0, $llCtR.default) {
    $71e43d6c7456b47e$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $71e43d6c7456b47e$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $71e43d6c7456b47e$var$key$1 in $71e43d6c7456b47e$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($71e43d6c7456b47e$var$key$1)) $71e43d6c7456b47e$var$cache[$71e43d6c7456b47e$var$computed[$71e43d6c7456b47e$var$key$1]] = $71e43d6c7456b47e$var$computed[$71e43d6c7456b47e$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $71e43d6c7456b47e$var$noPrefill.forEach(function(x) {
        return delete $71e43d6c7456b47e$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $71e43d6c7456b47e$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$71e43d6c7456b47e$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($71e43d6c7456b47e$var$cache[prop] != null) return $71e43d6c7456b47e$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $71e43d6c7456b47e$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $71e43d6c7456b47e$var$propertyDetectors.length; i++){
        $71e43d6c7456b47e$var$cache[prop] = $71e43d6c7456b47e$var$propertyDetectors[i](prop, $71e43d6c7456b47e$var$el.style, options); // Break loop, if value found.
        if ($71e43d6c7456b47e$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $71e43d6c7456b47e$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $71e43d6c7456b47e$var$cache[prop];
}
var $71e43d6c7456b47e$var$cache$1 = {};
var $71e43d6c7456b47e$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $71e43d6c7456b47e$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $71e43d6c7456b47e$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $71e43d6c7456b47e$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $71e43d6c7456b47e$export$ce097f82c2e4551a(p1) : ", " + $71e43d6c7456b47e$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $llCtR.default) $71e43d6c7456b47e$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $71e43d6c7456b47e$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$71e43d6c7456b47e$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($71e43d6c7456b47e$var$cache$1[cacheKey] != null) return $71e43d6c7456b47e$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $71e43d6c7456b47e$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $71e43d6c7456b47e$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($71e43d6c7456b47e$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($71e43d6c7456b47e$var$transPropsRegExp, $71e43d6c7456b47e$var$prefixTransitionCallback);
    else if ($71e43d6c7456b47e$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $71e43d6c7456b47e$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $71e43d6c7456b47e$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $71e43d6c7456b47e$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($71e43d6c7456b47e$var$el$1.style[property] === '') {
            $71e43d6c7456b47e$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $71e43d6c7456b47e$var$el$1.style[property] = ''; // Write current value to cache.
    $71e43d6c7456b47e$var$cache$1[cacheKey] = prefixedValue;
    return $71e43d6c7456b47e$var$cache$1[cacheKey];
}



var $fIt1N = parcelRequire("fIt1N");
/**
 * Add vendor prefix to a property name when needed.
 */ function $db3010d875fc2c09$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $71e43d6c7456b47e$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $71e43d6c7456b47e$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $71e43d6c7456b47e$export$511766124059c277)(supportedProp, (0, $fIt1N.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $71e43d6c7456b47e$export$511766124059c277)(prop, (0, $fIt1N.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $db3010d875fc2c09$export$2e2bcd8739ae039 = $db3010d875fc2c09$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $0af049ae3ff07bb5$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $0af049ae3ff07bb5$export$2e2bcd8739ae039 = $0af049ae3ff07bb5$var$jssPropsSort;


function $339e69b38619d19b$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $d518c1330bac79ab$export$2e2bcd8739ae039)(),
            (0, $a2c84ff23f57ce8c$export$2e2bcd8739ae039)(),
            (0, $9f53a5b04e0582cf$export$2e2bcd8739ae039)(),
            (0, $51075fd2000df302$export$2e2bcd8739ae039)(),
            (0, $088fb6090b542776$export$2e2bcd8739ae039)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $db3010d875fc2c09$export$2e2bcd8739ae039)(),
            (0, $0af049ae3ff07bb5$export$2e2bcd8739ae039)()
        ]
    };
}



var $4uaIU = parcelRequire("4uaIU");
const $8a1fd0d12a9dbd11$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $8a1fd0d12a9dbd11$var$defaultJSS = (0, $fIt1N.create)((0, $339e69b38619d19b$export$2e2bcd8739ae039)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $8a1fd0d12a9dbd11$var$defaultGenerateClassName = (0, $ae9870d7747fcf84$export$2e2bcd8739ae039)();
const $8a1fd0d12a9dbd11$export$70a8aea9ff58d1cd = new Map();
const $8a1fd0d12a9dbd11$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $8a1fd0d12a9dbd11$var$defaultGenerateClassName,
    jss: $8a1fd0d12a9dbd11$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $8a1fd0d12a9dbd11$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $8a1fd0d12a9dbd11$export$f4de434b269fe487 = /*#__PURE__*/ $jSIPP.createContext($8a1fd0d12a9dbd11$var$defaultOptions);
let $8a1fd0d12a9dbd11$var$injectFirstNode;
function $8a1fd0d12a9dbd11$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $cMu4A.default)(props, $8a1fd0d12a9dbd11$var$_excluded);
    const outerOptions = $jSIPP.useContext($8a1fd0d12a9dbd11$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $erOpW.default)({}, outerOptions, localOptions);
    const value = $jSIPP.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!$8a1fd0d12a9dbd11$var$injectFirstNode) {
                const head = document.head;
                $8a1fd0d12a9dbd11$var$injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore($8a1fd0d12a9dbd11$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $fIt1N.create)({
                plugins: (0, $339e69b38619d19b$export$2e2bcd8739ae039)().plugins,
                insertionPoint: $8a1fd0d12a9dbd11$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($8a1fd0d12a9dbd11$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $291a627557b4c6a8$var$indexCounter = -1000000000;
function $291a627557b4c6a8$export$a2647aa13413c947() {
    $291a627557b4c6a8$var$indexCounter += 1;
    return $291a627557b4c6a8$var$indexCounter;
}



var $erOpW = parcelRequire("erOpW");

var $2TupR = parcelRequire("2TupR");

var $cMu4A = parcelRequire("cMu4A");

var $61i5U = parcelRequire("61i5U");
const $9e1fbb91065f6a78$var$_excluded = [
    "variant"
];
function $9e1fbb91065f6a78$var$isEmpty(string) {
    return string.length === 0;
}
function $9e1fbb91065f6a78$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $cMu4A.default)(props, $9e1fbb91065f6a78$var$_excluded);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $9e1fbb91065f6a78$var$isEmpty(classKey) ? props[key] : (0, $61i5U.default)(props[key]);
        else classKey += `${$9e1fbb91065f6a78$var$isEmpty(classKey) ? key : (0, $61i5U.default)(key)}${(0, $61i5U.default)(props[key].toString())}`;
    });
    return classKey;
}



function $6201834f264b2a78$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $erOpW.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $2TupR.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $9e1fbb91065f6a78$export$2e2bcd8739ae039)(definition.props);
                stylesWithOverrides[classKey] = (0, $2TupR.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
const $e7ae534d51c697ab$var$noopTheme = {};
var $e7ae534d51c697ab$export$2e2bcd8739ae039 = $e7ae534d51c697ab$var$noopTheme;


const $02ded3e1150d0989$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $02ded3e1150d0989$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $8cfca46295686930$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $02ded3e1150d0989$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $erOpW.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $erOpW.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $fIt1N.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $erOpW.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $8cfca46295686930$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $02ded3e1150d0989$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $02ded3e1150d0989$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $c2b9b15677bd9539$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $02ded3e1150d0989$var$useSynchronousEffect(func, values) {
    const key = $jSIPP.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $jSIPP.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $jSIPP.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $02ded3e1150d0989$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $e7ae534d51c697ab$export$2e2bcd8739ae039) } = options, stylesOptions2 = (0, $cMu4A.default)(options, $02ded3e1150d0989$var$_excluded);
    const stylesCreator = (0, $6201834f264b2a78$export$2e2bcd8739ae039)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $291a627557b4c6a8$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $b5dd19ae449f8606$export$2e2bcd8739ae039)() || defaultTheme;
        const stylesOptions = (0, $erOpW.default)({}, $jSIPP.useContext((0, $8a1fd0d12a9dbd11$export$f4de434b269fe487)), stylesOptions2);
        const instance = $jSIPP.useRef();
        const shouldUpdate = $jSIPP.useRef();
        $02ded3e1150d0989$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $02ded3e1150d0989$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $02ded3e1150d0989$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $jSIPP.useEffect(()=>{
            if (shouldUpdate.current) $02ded3e1150d0989$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $02ded3e1150d0989$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}


const $846dd19afdaaf405$var$useStyles = (0, $02ded3e1150d0989$export$2e2bcd8739ae039)((theme)=>({
        errorText: {
            color: theme.palette.error.main,
            fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1,
            textAlign: 'right',
            marginTop: '0.125rem',
            marginRight: 0,
            marginBottom: '0.125rem',
            marginLeft: 0,
            whiteSpace: 'pre-wrap'
        }
    }));
/**
 * A MUI FormControl/Select component that works with Formik and has better spacing.
 * dataList must be an array of objects that have the attributes {name, value}.
 */ const $846dd19afdaaf405$var$IyoFormikDropDown = ({ name: name, label: label, dataList: dataList, values: values, touched: touched, errors: errors, handleBlur: handleBlur, handleChange: handleChange, disabled: disabled = false, multiple: multiple = false, required: required = false })=>{
    const myClasses = $846dd19afdaaf405$var$useStyles();
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                variant: "outlined",
                fullWidth: true,
                error: Boolean(touched[name] && errors[name]),
                disabled: disabled,
                required: required,
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                        id: name,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                        label: label,
                        name: name,
                        value: values[name],
                        error: Boolean(touched[name] && errors[name]),
                        onBlur: handleBlur,
                        onChange: handleChange,
                        multiple: multiple,
                        required: required,
                        children: dataList.map((rec)=>{
                            var _rec_id;
                            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                value: rec.value,
                                children: rec.name
                            }, (_rec_id = rec.id) !== null && _rec_id !== void 0 ? _rec_id : rec.value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                className: myClasses.errorText,
                children: Boolean(touched[name] && errors[name]) ? '\u25B4 ' + errors[name] : ' '
            })
        ]
    });
};
var $846dd19afdaaf405$export$2e2bcd8739ae039 = $846dd19afdaaf405$var$IyoFormikDropDown;



var $4uaIU = parcelRequire("4uaIU");

/**
 * A multiline text field with monospace font and good helper text and spacing
 */ const $42a4e71091f4742b$var$IyoFormikCodeEditor = ({ name: name, label: label, values: values, touched: touched, errors: errors, handleBlur: handleBlur, handleChange: handleChange, rows: rows, required: required = false, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
        name: name,
        label: label,
        value: values[name],
        error: Boolean(touched[name] && errors[name]),
        helperText: Boolean(touched[name] && errors[name]) ? '\u25B4 ' + errors[name] : ' ',
        FormHelperTextProps: {
            sx: {
                textAlign: 'right',
                lineHeight: 1,
                mx: 0,
                my: '0.125rem'
            }
        },
        fullWidth: true,
        onBlur: handleBlur,
        onChange: handleChange,
        variant: "outlined",
        required: required,
        disabled: disabled,
        multiline: true,
        rows: rows,
        InputProps: {
            sx: {
                fontFamily: 'monospace',
                fontSize: '0.9rem'
            }
        }
    });
};
var $42a4e71091f4742b$export$2e2bcd8739ae039 = $42a4e71091f4742b$var$IyoFormikCodeEditor;







// Splits a stream's rows out to child owners. Each entry names how to recognise the
// child's rows (match) and which owner they belong to (owner_id).
//
//   pen          - the child owns pens in pen_dimension; rows in those pens are theirs.
//                  Needs no value: which pens is a pen_dimension change, not a config one.
//   file_pattern - regex matched against the source file name.
//   file_key     - exact key extracted from the file name by the provider's parser.
//   label        - exact (case-insensitive) match on the row's label column.
//   reassign     - no match: every row goes to one owner. An administrative override,
//                  offered on every stream whatever the provider's scheme.
//
// Omitting match is read as pen, so existing configs keep working unchanged.
// iYotah Solutions, the platform's own owner; id 10 in every environment. Its streams
// belong to devices serving unrelated farms, so their rules may name any owner rather
// than only children.
const $a090740b3e667ed5$var$IYOTAH_OWNER_ID = 10;
// Whether this owner may route rows to owners that are not its children.
const $a090740b3e667ed5$var$routesToAnyOwner = (ownerId)=>Number(ownerId) === $a090740b3e667ed5$var$IYOTAH_OWNER_ID;
// provider.partition_scheme names the ways a provider's rows can be split. The stream
// editor uses this to offer only those match types, since a rule of any other type would
// be read by nothing.
const $a090740b3e667ed5$var$SCHEME_TO_MATCH = {
    PEN: 'pen',
    LABEL: 'label',
    FILE_PATTERN: 'file_pattern',
    FILE_KEY: 'file_key'
};
// The column holds one scheme for almost every provider, and a comma-separated list for
// the few that need more than one — EZfeed-Loads splits by pen and by label, so its
// streams need rules of both kinds. Tokens are returned as stored, not normalised: an
// unrecognised one must survive a round trip through the provider form rather than be
// silently dropped on save. schemeMatchTypes is what discards it.
const $a090740b3e667ed5$var$parsePartitionSchemes = (value)=>{
    if (value === undefined || value === null || value === '') return [];
    const list = Array.isArray(value) ? value : String(value).split(',');
    return [
        ...new Set(list.map((scheme)=>String(scheme).trim()).filter(Boolean))
    ];
};
// The match types a provider's schemes allow, in the order the schemes are listed.
// Unrecognised schemes contribute nothing.
const $a090740b3e667ed5$var$schemeMatchTypes = (value)=>$a090740b3e667ed5$var$parsePartitionSchemes(value).map((scheme)=>$a090740b3e667ed5$var$SCHEME_TO_MATCH[scheme]).filter(Boolean);
const $a090740b3e667ed5$var$EXAMPLE_VALUES = {
    file_pattern: '^Location2',
    file_key: '2',
    label: 'location2'
};
// The seeded example has to match the provider's scheme, or it demonstrates a rule the
// provider cannot use. A provider with several schemes is seeded from the first: one
// example is enough to show the shape, and the editor offers the rest as match types.
const $a090740b3e667ed5$var$exampleForScheme = (scheme)=>{
    const match = $a090740b3e667ed5$var$schemeMatchTypes(scheme)[0] || 'pen';
    const entry = {
        match: match,
        owner_id: 12345
    };
    if ($a090740b3e667ed5$var$EXAMPLE_VALUES[match] !== undefined) entry.value = $a090740b3e667ed5$var$EXAMPLE_VALUES[match];
    return JSON.stringify([
        entry
    ], null, 2);
};
const $a090740b3e667ed5$var$examplePartitionConfigs = $a090740b3e667ed5$var$exampleForScheme(null);
// True when the field still holds an untouched example, whichever scheme produced it.
// Used to avoid saving the example as though it were real configuration. Multi-scheme
// providers seed from their first scheme, so the single-scheme examples cover them too.
const $a090740b3e667ed5$var$isExampleValue = (value)=>value === $a090740b3e667ed5$var$examplePartitionConfigs || Object.keys($a090740b3e667ed5$var$SCHEME_TO_MATCH).some((scheme)=>value === $a090740b3e667ed5$var$exampleForScheme(scheme));
// provider.device_provider marks a PC Agent feed: the rows are pushed by an agent running on
// a machine at the owner's site rather than pulled on a schedule, so the stream belongs to
// one device and the editor has to ask which. The column is a MySQL boolean and reaches the
// browser as 0/1, but the provider form round-trips it as the strings 'true'/'false', so
// both spellings are read here.
const $a090740b3e667ed5$var$isDeviceProvider = (provider)=>{
    const value = provider === null || provider === void 0 ? void 0 : provider.device_provider;
    if (typeof value === 'string') {
        const text = value.trim().toLowerCase();
        return text === 'true' || text === '1';
    }
    return Boolean(value);
};
// device_view exposes owner_name but not owner_id. owner.name is unique in the database and
// the view reaches it by joining on the device's own owner_id, so matching on the name picks
// out exactly the devices that owner has.
const $a090740b3e667ed5$var$devicesForOwner = (devices, owner)=>{
    if (!Array.isArray(devices) || !(owner === null || owner === void 0 ? void 0 : owner.name)) return [];
    return devices.filter((device)=>device.owner_name === owner.name);
};
// The name PC Agent gives a stream it registers itself - see createDeviceSource in ms-ngest,
// which builds `${deviceId} - ${owner.name} - ${source}` from the device's MAC address and
// the provider name, and uses it for the description too. A stream created here has to land
// on the same string: the agent looks its stream up by device and provider, and a second
// name for the same pair is a duplicate nobody can tell apart in the grid.
const $a090740b3e667ed5$var$deviceStreamName = (device, owner, provider)=>{
    if (!(device === null || device === void 0 ? void 0 : device.mac_address) || !(owner === null || owner === void 0 ? void 0 : owner.name) || !(provider === null || provider === void 0 ? void 0 : provider.name)) return '';
    return `${device.mac_address} - ${owner.name} - ${provider.name}`;
};
// Streams that are not a PC Agent feed have no device to name them after, so they are
// numbered: one owner commonly has several streams from the same provider - a site apiece,
// or one per file drop. The number handed out is the lowest not already in use under this
// exact prefix, which is what keeps the result unique; data_stream.name has a UNIQUE key,
// and a collision is a 500 from the insert rather than anything the form could explain.
//
// Matching on the name prefix rather than on owner_id and provider_id is deliberate: the
// prefix is what two names would actually collide on, so a stream left under an old name
// after its owner or provider changed is still counted.
const $a090740b3e667ed5$var$nextInstanceNumber = (prefix, dataStreams, rowEditing)=>{
    const numberIn = (name)=>typeof name === 'string' && name.startsWith(prefix) ? Number(name.slice(prefix.length)) : NaN;
    // A stream that already sits under this prefix keeps the number it has. Opening one and
    // saving it must not renumber it, and nor should the numbers shuffle when an earlier
    // stream is deleted.
    const own = numberIn(rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.name);
    if (Number.isInteger(own) && own > 0) return own;
    const taken = new Set();
    for (const stream of Array.isArray(dataStreams) ? dataStreams : []){
        if ((rowEditing === null || rowEditing === void 0 ? void 0 : rowEditing.id) !== undefined && stream.id === rowEditing.id) continue;
        const number = numberIn(stream.name);
        if (Number.isInteger(number) && number > 0) taken.add(number);
    }
    let next = 1;
    while(taken.has(next))next += 1;
    return next;
};
// The name of a stream, worked out from what the form has selected rather than typed by
// hand - so a name always says what the stream is, and two people setting up the same feed
// arrive at the same name.
//
//   PC Agent  <mac> - <owner> - <provider>   the string the agent registers itself
//   otherwise <provider> - <owner> - <n>     n numbering the owner's streams from that provider
//
// Empty until enough has been chosen to build it; the caller leaves the field alone until
// then rather than showing a half-built name.
const $a090740b3e667ed5$var$streamName = ({ provider: provider, owner: owner, device: device, dataStreams: dataStreams, rowEditing: rowEditing })=>{
    if (!(provider === null || provider === void 0 ? void 0 : provider.name) || !(owner === null || owner === void 0 ? void 0 : owner.name)) return '';
    if ($a090740b3e667ed5$var$isDeviceProvider(provider)) return $a090740b3e667ed5$var$deviceStreamName(device, owner, provider);
    const prefix = `${provider.name} - ${owner.name} - `;
    return `${prefix}${$a090740b3e667ed5$var$nextInstanceNumber(prefix, dataStreams, rowEditing)}`;
};
// Options for the device picker. The MAC address leads because that is what the stream name
// is built from; the device's own name, when it has one, only helps tell two of them apart.
const $a090740b3e667ed5$var$deviceOptions = (devices)=>devices.map((device)=>({
            id: device.id,
            name: device.name ? `${device.mac_address} (${device.name})` : device.mac_address
        }));
const $a090740b3e667ed5$var$MATCH_TYPES = [
    'pen',
    'file_pattern',
    'file_key',
    'label',
    'reassign'
];
const $a090740b3e667ed5$var$VALUELESS_MATCHES = [
    'pen',
    'reassign'
];
// What the rule's value means, per match type. A bare "Value" gives no clue that a
// file_key rule wants the key the provider's regex pulls out of the file name.
const $a090740b3e667ed5$var$VALUE_LABELS = {
    file_pattern: 'File name pattern',
    file_key: 'File key',
    label: 'Label value'
};
const $a090740b3e667ed5$var$VALUE_PLACEHOLDERS = {
    file_pattern: '^Wardsprings',
    file_key: '2',
    label: 'location2'
};
const $a090740b3e667ed5$var$MATCH_LABELS = {
    pen: 'Pen',
    file_pattern: 'File name pattern',
    file_key: 'File name key',
    label: 'Label',
    reassign: 'All rows (override)'
};
// Turns a stored partition_configs value into editable rows. Understands every shape in
// the database: the explicit form, the legacy array of {owner_id} (read as pen), the
// legacy array of {label_value, owner_id}, and the legacy object of {key: owner_id}
// (read as file_key). Returns ok:false when the value cannot be understood, so the caller
// can fall back to raw JSON editing rather than silently discarding it.
const $a090740b3e667ed5$var$parsePartitionConfigs = (value)=>{
    if (value === undefined || value === null || value === '') return {
        ok: true,
        rows: []
    };
    let parsed = value;
    if (typeof value === 'string') try {
        parsed = JSON.parse(value);
    } catch (err) {
        return {
            ok: false,
            rows: []
        };
    }
    if (Array.isArray(parsed)) {
        const rows = parsed.map((entry)=>{
            var _entry_match, _entry_value, _ref, _entry_owner_id;
            return {
                match: (_entry_match = entry.match) !== null && _entry_match !== void 0 ? _entry_match : entry.label_value !== undefined ? 'label' : 'pen',
                value: (_ref = (_entry_value = entry.value) !== null && _entry_value !== void 0 ? _entry_value : entry.label_value) !== null && _ref !== void 0 ? _ref : '',
                owner_id: (_entry_owner_id = entry.owner_id) !== null && _entry_owner_id !== void 0 ? _entry_owner_id : ''
            };
        });
        return {
            ok: rows.every((r)=>$a090740b3e667ed5$var$MATCH_TYPES.includes(r.match)),
            rows: rows
        };
    }
    if (typeof parsed === 'object') return {
        ok: true,
        rows: Object.entries(parsed).map(([key, ownerId])=>({
                match: 'file_key',
                value: key,
                owner_id: ownerId
            }))
    };
    return {
        ok: false,
        rows: []
    };
};
// Always writes the explicit form. Valueless matches omit `value` entirely.
const $a090740b3e667ed5$var$serializePartitionConfigs = (rows)=>{
    if (!rows.length) return '';
    return JSON.stringify(rows.map((row)=>(0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({
            match: row.match
        }, $a090740b3e667ed5$var$VALUELESS_MATCHES.includes(row.match) ? {} : {
            value: row.value
        }), {
            owner_id: Number.isInteger(row.owner_id) ? row.owner_id : parseInt(row.owner_id, 10)
        })), null, 2);
};
// Returns an error string, or null when the value is acceptable. Kept deliberately
// permissive about shape — the legacy array-of-{owner_id} and object-of-{key: owner_id}
// forms are both still live in the database and must remain editable.
const $a090740b3e667ed5$var$validatePartitionConfigs = (value)=>{
    if (value === undefined || value === null || value === '') return null;
    let parsed = value;
    if (typeof value === 'string') try {
        parsed = JSON.parse(value);
    } catch (err) {
        return 'Not valid JSON.';
    }
    // Legacy object form, {"1": 12345}: keys are file keys, values are owner ids.
    if (!Array.isArray(parsed)) {
        if (typeof parsed !== 'object') return 'Must be an array of entries, or an object of {key: owner_id}.';
        const badValue = Object.entries(parsed).find(([, ownerId])=>!Number.isInteger(ownerId));
        return badValue ? `Owner id for key "${badValue[0]}" must be a whole number.` : null;
    }
    if (parsed.length === 0) return 'Must contain at least one entry, or be left empty.';
    for (const [i, entry] of parsed.entries()){
        const at = `Entry ${i + 1}`;
        if (typeof entry !== 'object' || entry === null || Array.isArray(entry)) return `${at} must be an object.`;
        if (!Number.isInteger(entry.owner_id)) return `${at} needs an owner_id that is a whole number.`;
        var _entry_match;
        const match = (_entry_match = entry.match) !== null && _entry_match !== void 0 ? _entry_match : entry.label_value !== undefined ? 'label' : 'pen';
        if (!$a090740b3e667ed5$var$MATCH_TYPES.includes(match)) return `${at} has match "${entry.match}". Use one of: ${$a090740b3e667ed5$var$MATCH_TYPES.join(', ')}.`;
        var _entry_value;
        const matchValue = (_entry_value = entry.value) !== null && _entry_value !== void 0 ? _entry_value : entry.label_value;
        if ($a090740b3e667ed5$var$VALUELESS_MATCHES.includes(match)) {
            if (matchValue !== undefined) return `${at} matches on ${match}, which takes no value.`;
        } else if (matchValue === undefined || matchValue === '') return `${at} matches on ${match}, so it needs a value.`;
        // Judged as BigQuery's RE2 engine would, not as the browser would: the two disagree in
        // both directions, so a plain `new RegExp` check both admits patterns the pipeline
        // rejects and rejects patterns the pipeline accepts.
        if (match === 'file_pattern') {
            const problem = (0, $a9106d6db699107c$export$364b559aabb27140)(matchValue);
            if (problem) return `${at}: ${problem}`;
        }
    }
    return null;
};
const $a090740b3e667ed5$var$generateValidationSchema = (fields)=>{
    let schemaObject = {
        name: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required')
    };
    if (!fields) return schemaObject;
    for (let field of fields)if (field.required || field.type !== 'string') {
        // Yup.string() would cast an array to "a,b" and pass for the wrong reason.
        if (field.type === 'array') schemaObject[field.name] = field.required ? $f07cf38414d7ce0e$export$185802fd694ee1f5().min(1, 'Required') : $f07cf38414d7ce0e$export$185802fd694ee1f5();
        else schemaObject[field.name] = $7a974168aa28ad85$export$185802fd694ee1f5().required('Required');
        schemaObject[field.name].type = field.type;
    }
    return schemaObject;
};
const $a090740b3e667ed5$var$prettifyProperties = (properties)=>{
    if (!properties) return null;
    let newFields = {};
    for (let field of properties){
        // Array properties stay arrays through the form. A stored string is kept as one entry
        // rather than split — site names contain commas.
        let value;
        if (field.type === 'array') value = Array.isArray(field.value) ? field.value : field.value ? [
            field.value
        ] : [];
        else value = field.value ? field.value : '';
        Object.defineProperty(newFields, field.name, {
            value: value,
            enumerable: true
        });
    }
    return newFields;
};
var $a090740b3e667ed5$export$2e2bcd8739ae039 = {
    isDeviceProvider: $a090740b3e667ed5$var$isDeviceProvider,
    devicesForOwner: $a090740b3e667ed5$var$devicesForOwner,
    deviceStreamName: $a090740b3e667ed5$var$deviceStreamName,
    deviceOptions: $a090740b3e667ed5$var$deviceOptions,
    streamName: $a090740b3e667ed5$var$streamName,
    nextInstanceNumber: $a090740b3e667ed5$var$nextInstanceNumber,
    generateValidationSchema: $a090740b3e667ed5$var$generateValidationSchema,
    prettifyProperties: $a090740b3e667ed5$var$prettifyProperties,
    examplePartitionConfigs: $a090740b3e667ed5$var$examplePartitionConfigs,
    validatePartitionConfigs: $a090740b3e667ed5$var$validatePartitionConfigs,
    parsePartitionConfigs: $a090740b3e667ed5$var$parsePartitionConfigs,
    serializePartitionConfigs: $a090740b3e667ed5$var$serializePartitionConfigs,
    exampleForScheme: $a090740b3e667ed5$var$exampleForScheme,
    isExampleValue: $a090740b3e667ed5$var$isExampleValue,
    parsePartitionSchemes: $a090740b3e667ed5$var$parsePartitionSchemes,
    schemeMatchTypes: $a090740b3e667ed5$var$schemeMatchTypes,
    routesToAnyOwner: $a090740b3e667ed5$var$routesToAnyOwner,
    IYOTAH_OWNER_ID: $a090740b3e667ed5$var$IYOTAH_OWNER_ID,
    SCHEME_TO_MATCH: $a090740b3e667ed5$var$SCHEME_TO_MATCH,
    MATCH_TYPES: $a090740b3e667ed5$var$MATCH_TYPES,
    VALUELESS_MATCHES: $a090740b3e667ed5$var$VALUELESS_MATCHES,
    MATCH_LABELS: $a090740b3e667ed5$var$MATCH_LABELS,
    VALUE_LABELS: $a090740b3e667ed5$var$VALUE_LABELS,
    VALUE_PLACEHOLDERS: $a090740b3e667ed5$var$VALUE_PLACEHOLDERS
};



// How a provider's rows are normally split out to child owners. Values match the match
// types in data_stream.partition_configs and the dbt macros.
//
// A provider may name more than one. The column stores them comma-separated, and the data
// stream editor then offers a match type per scheme so one stream can carry rules of each
// kind — EZfeed-Loads is the live case, splitting by pen and by label. The dbt resolvers
// each read only their own match_type, so they already coexist on one stream.
//
// reassign is absent by design: it is a per-stream override, not a provider scheme, and
// is offered on every stream regardless of what is set here.
//
//   PEN          - the child owns pens in the pen dimension; rows in those pens are theirs
//   LABEL        - a column on the row carries the child's label
//   FILE_PATTERN - the source file name is matched against a regex held per rule on the
//                  data stream, so nothing is needed at provider level
//   FILE_KEY     - a key is extracted from the source file name by the regex in
//                  partition_column, then matched against the rules on the data stream
const $639dc5c2b1977fd0$var$PARTITION_SCHEMES = [
    {
        name: 'PEN',
        value: 'PEN'
    },
    {
        name: 'LABEL',
        value: 'LABEL'
    },
    {
        name: 'FILE_PATTERN',
        value: 'FILE_PATTERN'
    },
    {
        name: 'FILE_KEY',
        value: 'FILE_KEY'
    }
];
// Schemes that need a value in partition_column, and what that value means to each.
const $639dc5c2b1977fd0$var$SCHEMES_NEEDING_COLUMN = [
    'LABEL',
    'FILE_KEY'
];
// Of those, the ones whose value is a regular expression rather than a column name.
const $639dc5c2b1977fd0$var$SCHEMES_WITH_REGEX_COLUMN = [
    'FILE_KEY'
];
// Field names as the form labels them, for the list of what is blocking Save.
const $639dc5c2b1977fd0$var$FIELD_LABELS = {
    name: 'Name',
    description: 'Description',
    display_name: 'Display Name',
    provider_child_category_id: 'Sub-Category',
    schema: 'JSON Schema',
    properties: 'Properties',
    has_hwm: 'Has HWM',
    hwm_format: 'HWM Format',
    device_provider: 'Device Provider',
    v3: 'V3',
    multi_tenant_enabled: 'Multi Tenant Enabled',
    partition_scheme: 'Partition Scheme',
    partition_column: 'Partition Column'
};
const $639dc5c2b1977fd0$var$PARTITION_COLUMN_LABELS = {
    LABEL: 'Partition Column',
    FILE_KEY: 'File Name Pattern (one capture group)'
};
// The form works in arrays; the column is a comma-separated string. Parsing keeps tokens
// exactly as stored, so a value this build does not recognise survives a round trip
// instead of being wiped by an edit to some unrelated field.
const $639dc5c2b1977fd0$var$schemeList = (value)=>(0, $a090740b3e667ed5$export$2e2bcd8739ae039).parsePartitionSchemes(value);
const $639dc5c2b1977fd0$var$schemeString = (list)=>$639dc5c2b1977fd0$var$schemeList(list).join(',');
// Of the selected schemes, the one that owns partition_column. LABEL and FILE_KEY both
// claim it and cannot be combined; validate() reports that rather than picking silently.
const $639dc5c2b1977fd0$var$columnOwningScheme = (list)=>$639dc5c2b1977fd0$var$schemeList(list).find((s)=>$639dc5c2b1977fd0$var$SCHEMES_NEEDING_COLUMN.includes(s));
// Counts capturing groups by alternating with an empty branch so the pattern matches ''.
// Normalised first so RE2-only spellings like (?P<key>...) count rather than throw.
const $639dc5c2b1977fd0$var$countCaptureGroups = (pattern)=>{
    try {
        return new RegExp(`${(0, $a9106d6db699107c$export$1e301ffa4bd66559)(pattern)}|`).exec('').length - 1;
    } catch (err) {
        return 0;
    }
};
// What a PC Agent provider is not free to choose.
//
// description - its own name. Every one of them in the database is stored that way, and the
//               agent shows the description to the operator as the source's label, where a
//               second wording just reads as a different source.
// has_hwm     - false. The agent hands over whole files and deletes them behind itself;
//               there is no cursor into a remote system for a high water mark to hold.
// v3          - false. v3 pulls from an API on a schedule. Nothing pulls from an agent, so
//               a PC Agent provider has no v3 form to run in.
//
// Applied here rather than only on save, so the greyed-out fields show what will be written.
const $639dc5c2b1977fd0$var$DEVICE_PROVIDER_FIXED = {
    has_hwm: 'false',
    v3: 'false'
};
// Written in one setValues rather than a setFieldValue per field. Each setFieldValue
// revalidates against the values as they were at the last render, so the second and third
// call would each validate a form still missing the other two changes - and the last to
// resolve wins. That left Save disabled saying Has HWM was Required, until some later
// render happened to revalidate the form as it actually stood.
const $639dc5c2b1977fd0$var$DeviceProviderDefaults = ({ values: values, setValues: setValues })=>{
    (0, $jSIPP.useEffect)(()=>{
        const fixed = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            description: values.name
        }, $639dc5c2b1977fd0$var$DEVICE_PROVIDER_FIXED);
        const changes = Object.entries(fixed).filter(([field, value])=>values[field] !== value);
        if (!changes.length) return;
        setValues((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values, Object.fromEntries(changes)));
    }, [
        values,
        setValues
    ]);
    return null;
};
const $639dc5c2b1977fd0$var$ProviderEditDialog = ({ state: state, setState: setState })=>{
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    // ####################[ Configs ]####################
    const DataTypeName = 'Provider';
    const trueFalseDataList = [
        {
            name: 'true',
            value: 'true'
        },
        {
            name: 'false',
            value: 'false'
        }
    ];
    const hwmFormatDataList = [
        {
            id: 0,
            name: 'YYYY-MM-DD hh:mm:ss.SSS',
            value: 'YYYY-MM-DD hh:mm:ss.SSS'
        },
        {
            id: 1,
            name: 'YYYY-MM-DD hh:mm:ss',
            value: 'YYYY-MM-DD hh:mm:ss'
        },
        {
            id: 2,
            name: 'YYYY-MM-DDThh:mm:ssZ (UTC)',
            value: 'YYYY-MM-DDThh:mm:ssZ'
        },
        {
            id: 3,
            name: 'YYYY-MM-DD',
            value: 'YYYY-MM-DD'
        }
    ];
    // ####################[ Helpers ]####################
    const produceError = (error, setState)=>{
        var _error_response;
        const message = `${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`;
        setState.setErrorOpen(false);
        setState.setErrDisplayText(message);
        setState.setErrorOpen(true);
        console.error(message);
    };
    const generateValidationSchema = (values)=>{
        const schema = {
            name: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required'),
            schema: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required'),
            properties: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required'),
            has_hwm: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required'),
            device_provider: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required'),
            multi_tenant_enabled: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required')
        };
        // partition_scheme is only required when multi_tenant_enabled is set to true. It holds
        // a list: a provider may split its rows more than one way.
        schema.partition_scheme = $f07cf38414d7ce0e$export$185802fd694ee1f5().when('multi_tenant_enabled', {
            is: (val)=>val === 'true',
            then: $f07cf38414d7ce0e$export$185802fd694ee1f5().of($7a974168aa28ad85$export$185802fd694ee1f5().oneOf($639dc5c2b1977fd0$var$PARTITION_SCHEMES.map((s)=>s.value), `Must be one of ${$639dc5c2b1977fd0$var$PARTITION_SCHEMES.map((s)=>s.value).join(', ')}`)).min(1, 'Required'),
            otherwise: $f07cf38414d7ce0e$export$185802fd694ee1f5().notRequired()
        });
        // partition_column holds the column name for LABEL and the extraction regex for
        // FILE_KEY. PEN and FILE_PATTERN need nothing here.
        schema.partition_column = $7a974168aa28ad85$export$185802fd694ee1f5().when('partition_scheme', {
            is: (val)=>Boolean($639dc5c2b1977fd0$var$columnOwningScheme(val)),
            then: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required')// Only the regex schemes are checked; for LABEL this field is a column name.
            .test('valid-regex', 'Not a valid regular expression.', function(value) {
                if (!$639dc5c2b1977fd0$var$schemeList(this.parent.partition_scheme).some((s)=>$639dc5c2b1977fd0$var$SCHEMES_WITH_REGEX_COLUMN.includes(s)) || !value) return true;
                return (0, $a9106d6db699107c$export$493a1a324e74fde0)(value);
            }).test('single-capture-group', 'Must contain exactly one capture group, e.g. -([0-9]+)_', function(value) {
                if (!$639dc5c2b1977fd0$var$schemeList(this.parent.partition_scheme).some((s)=>$639dc5c2b1977fd0$var$SCHEMES_WITH_REGEX_COLUMN.includes(s)) || !value) return true;
                // An invalid pattern is already reported above; do not fail twice for it.
                if (!(0, $a9106d6db699107c$export$493a1a324e74fde0)(value)) return true;
                return $639dc5c2b1977fd0$var$countCaptureGroups(value) === 1;
            })// Message comes from createError below, naming the construct.
            .test('re2-supported', 'Not supported by BigQuery.', function(value) {
                if (!$639dc5c2b1977fd0$var$schemeList(this.parent.partition_scheme).some((s)=>$639dc5c2b1977fd0$var$SCHEMES_WITH_REGEX_COLUMN.includes(s)) || !value) return true;
                if (!(0, $a9106d6db699107c$export$493a1a324e74fde0)(value)) return true;
                const problem = (0, $a9106d6db699107c$export$83c7b33f3da8f9f1)(value);
                return problem ? this.createError({
                    message: problem
                }) : true;
            }),
            otherwise: $7a974168aa28ad85$export$185802fd694ee1f5().notRequired()
        });
        // cron, concurrency_limit, backoff_interval and timezone_sensitive are not shown and
        // not validated: nothing reads them. Their columns still exist and existing values are
        // left exactly as they are, so nothing here can be the reason a provider will not save.
        return schema;
    };
    const cleanPost = async (values)=>{
        let body = {};
        for(let field in values)if (values[field] !== '') body[field] = values[field];
        // The form holds the schemes as an array; the column is a comma-separated string. An
        // empty selection is no scheme at all, not an empty array.
        const schemes = $639dc5c2b1977fd0$var$schemeString(values.partition_scheme);
        if (schemes) body['partition_scheme'] = schemes;
        else delete body['partition_scheme'];
        const boolFields = [
            'has_hwm',
            'device_provider',
            'timezone_sensitive',
            'v3',
            'multi_tenant_enabled'
        ];
        for (let field of boolFields){
            if (body[field] === 'true') body[field] = true;
            else if (body[field] === 'false') body[field] = false;
        }
        if (values.timezone_sensitive === '') body['timezone_sensitive'] = false; // Because it's required in the DB but shouldn't be
        const jsonFields = [
            'schema',
            'properties'
        ];
        for (let field of jsonFields)body[field] = JSON.parse(body[field]);
        const numFields = [
            'concurrency_limit',
            'backoff_interval'
        ];
        for (let field of numFields)if (body[field]) body[field] = Number(body[field]);
        if (body['has_hwm'] === true && !body['hwm_format']) body['hwm_format'] = 'YYYY-MM-DD hh:mm:ss.SSS';
        else if (body['has_hwm'] === false && body['hwm_format']) body['hwm_format'] = null;
        if (body['device_provider'] === true) {
            body['cron'] = null;
            body['concurrency_limit'] = null;
            body['backoff_interval'] = null;
            body['has_hwm'] = false;
            body['hwm_format'] = null;
            body['v3'] = false;
        }
        body['created_by'] = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
        body['updated_by'] = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
        return body;
    };
    const cleanPut = async (values)=>{
        let body = {};
        for(let field in values)if (values[field] !== state.rowEditing[field]) body[field] = values[field] === '' ? null : values[field];
        // An array never compares equal to the stored string, so the loop above always picks
        // partition_scheme up. Compare the joined form instead and drop it when unchanged,
        // or an edit to any other field would rewrite the column for no reason.
        const schemes = $639dc5c2b1977fd0$var$schemeString(values.partition_scheme);
        var _state_rowEditing_partition_scheme;
        if (schemes === ((_state_rowEditing_partition_scheme = state.rowEditing.partition_scheme) !== null && _state_rowEditing_partition_scheme !== void 0 ? _state_rowEditing_partition_scheme : '')) delete body['partition_scheme'];
        else body['partition_scheme'] = schemes === '' ? null : schemes;
        if (Object.entries(body).length === 0) return undefined;
        body['id'] = state.rowEditing.id;
        body['updated_by'] = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
        const boolFields = [
            'has_hwm',
            'device_provider',
            'timezone_sensitive',
            'v3',
            'multi_tenant_enabled'
        ];
        for (let field of boolFields){
            if (body[field] === 'true') body[field] = true;
            else if (body[field] === 'false') body[field] = false;
        }
        const jsonFields = [
            'schema',
            'properties'
        ];
        for (let field of jsonFields)if (body[field]) body[field] = JSON.parse(body[field]);
        if (body['has_hwm'] === true) {
            if (values.hwm_format === '') body['hwm_format'] = 'YYYY-MM-DD hh:mm:ss.SSS';
            else body['hwm_format'] = values.hwm_format;
        } else if (body['has_hwm'] === false) body['hwm_format'] = null;
        if (body['device_provider'] === true) {
            body['cron'] = null;
            body['concurrency_limit'] = null;
            body['backoff_interval'] = null;
            body['has_hwm'] = false;
            body['hwm_format'] = null;
            body['v3'] = false;
        }
        return body;
    };
    // ####################[ Handlers and Queries ]####################
    const pageFn = {
        handleCreateSubmit: async (values, postProvider, state, setState)=>{
            const body = await cleanPost(values);
            await postProvider.mutate(body);
            setState.setEditOpen(false);
        },
        handleEditSubmit: async (values, queryClient, putProvider, state, setState)=>{
            const body = await cleanPut(values);
            if (!body) setState.setEditOpen(false);
            else {
                await putProvider.mutate(body);
                setState.setEditOpen(false);
            }
        },
        handleClose: async (setState)=>{
            setState.setEditOpen(false);
        },
        validate: async (values)=>{
            const validationObject = generateValidationSchema(values);
            let errors = {};
            // Validated as one object rather than field by field. Every .when() above reads a
            // sibling field, and a field validated on its own has no siblings to read: the
            // partition rules resolved against nothing and so never fired, letting a multi-tenant
            // provider save with no scheme and a FILE_KEY provider save with no pattern.
            try {
                await $f986b6e4122227d2$export$185802fd694ee1f5().shape(validationObject).validate(values, {
                    abortEarly: false
                });
            } catch (err) {
                var _err_inner;
                // abortEarly false reports every failure in err.inner; a cast failure arrives on
                // err itself with no inner list.
                const issues = ((_err_inner = err.inner) === null || _err_inner === void 0 ? void 0 : _err_inner.length) ? err.inner : [
                    err
                ];
                for (const issue of issues)if (issue.path && !errors[issue.path]) errors[issue.path] = issue.message;
            }
            // Yup doesn't have a JSON string validation option (at least not one that works)
            const boolFields = [
                'schema',
                'properties'
            ];
            for (let field of boolFields)try {
                JSON.parse(values[field]);
            } catch (err) {
                if (errors[field] !== 'Required') errors[field] = 'Invalid JSON - ' + err.toString();
            }
            // Enforced at save as well as in the field above, so a provider whose description was
            // already something else cannot keep it by way of an edit to an unrelated field.
            if ((0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(values) && values.description !== values.name) errors.description = 'Must match the name for a PC Agent provider.';
            // LABEL and FILE_KEY both take their meaning from partition_column, which can only
            // hold one thing. Every other combination is fine — the match types are independent
            // downstream.
            const columnSchemes = $639dc5c2b1977fd0$var$schemeList(values.partition_scheme).filter((scheme)=>$639dc5c2b1977fd0$var$SCHEMES_NEEDING_COLUMN.includes(scheme));
            if (columnSchemes.length > 1) errors.partition_scheme = `${columnSchemes.join(' and ')} both use Partition Column; pick one.`;
            return errors;
        },
        useInitialValuesQuery: (state, setState)=>{
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)([
                'getInitialProviderValues',
                state.providerId,
                state.rowEditing
            ], ()=>{
                var _state_rowEditing, _state_rowEditing1;
                const fields = [
                    'name',
                    'description',
                    'display_name',
                    'provider_child_category_id',
                    'schema',
                    'properties',
                    'has_hwm',
                    'hwm_format',
                    'device_provider',
                    'cron',
                    'concurrency_limit',
                    'backoff_interval',
                    'timezone_sensitive',
                    'v3',
                    'multi_tenant_enabled',
                    'partition_scheme',
                    'partition_column'
                ];
                let values = {};
                var _state_rowEditing_field;
                for (let field of fields)values[field] = (_state_rowEditing_field = (_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing[field]) !== null && _state_rowEditing_field !== void 0 ? _state_rowEditing_field : '';
                // Stored as a comma-separated string, edited as a multi-select.
                values['partition_scheme'] = $639dc5c2b1977fd0$var$schemeList((_state_rowEditing1 = state.rowEditing) === null || _state_rowEditing1 === void 0 ? void 0 : _state_rowEditing1.partition_scheme);
                // Put in default values to help the user
                if (state.editMode === 'create') {
                    values['schema'] = JSON.stringify({
                        type: 'object',
                        title: 'Example',
                        required: [
                            'example'
                        ],
                        properties: {
                            example: {
                                type: 'string',
                                description: 'an example field'
                            }
                        },
                        sensitiveValues: [],
                        additionalProperties: false
                    }, null, 2);
                    values['properties'] = JSON.stringify({
                        example: 'example field'
                    }, null, 2);
                    values['cron'] = '0 6 * * ? *';
                    values['concurrency_limit'] = 10;
                    values['backoff_interval'] = 2;
                    values['multi_tenant_enabled'] = 'false';
                    values['partition_scheme'] = [];
                    values['partition_column'] = '';
                }
                return values;
            }, {
                onError: (error)=>{
                    produceError(error, setState);
                },
                staleTime: Infinity
            });
        }
    };
    const getInitialValues = pageFn.useInitialValuesQuery(state, setState);
    // Sub-Category options for the Identity section. A blank entry is included so a provider
    // can be left uncategorised - 36 of the 92 seeded providers have no child category, and
    // the column is nullable.
    const getChildCategories = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviderChildCategoriesPage', async ()=>(0, $885b40e5e295b926$export$2e2bcd8739ae039).getAll(), {
        retry: false,
        staleTime: Infinity
    });
    const childCategoryOptions = [
        {
            name: '(none)',
            value: ''
        }
    ].concat((getChildCategories.data || []).filter((cat)=>cat.active).map((cat)=>({
            name: cat.name,
            value: cat.id
        })).sort((a, b)=>a.name.localeCompare(b.name)));
    const putProvider = (0, $1ed46d3dcbd1a752$export$2e2bcd8739ae039).useProviderQuery('PUT', queryClient, state, setState, produceError);
    const postProvider = (0, $1ed46d3dcbd1a752$export$2e2bcd8739ae039).useProviderQuery('POST', queryClient, state, setState, produceError);
    // ####################[ Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: state.editOpen,
        onClose: ()=>pageFn.handleClose(setState),
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: state.editMode === 'edit' ? `Edit ${DataTypeName} : id = ${state.rowEditing.id}` : state.editMode === 'create' ? `Create ${DataTypeName}` : ''
            }),
            !getInitialValues.data ? null : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                initialValues: getInitialValues.data,
                validate: (values)=>pageFn.validate(values),
                onSubmit: state.editMode === 'edit' ? (values)=>pageFn.handleEditSubmit(values, queryClient, putProvider, state, setState) : state.editMode === 'create' ? (values)=>pageFn.handleCreateSubmit(values, postProvider, state, setState) : ()=>{},
                children: ({ errors: errors, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting, resetForm: resetForm, setValues: setValues, touched: touched, values: values })=>/*#__PURE__*/ (0, $4uaIU.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(values) && /*#__PURE__*/ (0, $4uaIU.jsx)($639dc5c2b1977fd0$var$DeviceProviderDefaults, {
                                values: values,
                                setValues: setValues
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                                style: {
                                    margin: '2%'
                                },
                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    container: true,
                                    rowSpacing: 0,
                                    columnSpacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Identity",
                                                description: "What this provider is called.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                                                name: "name",
                                                                label: "Name",
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                                                name: "description",
                                                                label: "Description",
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                disabled: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(values)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                                                name: "display_name",
                                                                label: "Display Name",
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "provider_child_category_id",
                                                                label: "Sub-Category",
                                                                dataList: childCategoryOptions,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            sx: {
                                                mt: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Schema",
                                                description: "The JSON schema a stream's properties are validated against, and the defaults every new stream starts from.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $42a4e71091f4742b$export$2e2bcd8739ae039), {
                                                                name: "schema",
                                                                label: "Schema",
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                rows: 15,
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $42a4e71091f4742b$export$2e2bcd8739ae039), {
                                                                name: "properties",
                                                                label: "Properties",
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                rows: 5,
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            sx: {
                                                mt: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Extraction",
                                                description: "How the pipeline reads from this provider.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "device_provider",
                                                                label: "Device Provider",
                                                                dataList: trueFalseDataList,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "v3",
                                                                label: "Version 3",
                                                                dataList: trueFalseDataList,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true,
                                                                disabled: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(values)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "has_hwm",
                                                                label: "Has HWM",
                                                                dataList: trueFalseDataList,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true,
                                                                disabled: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(values)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "hwm_format",
                                                                label: "HWM Format",
                                                                dataList: hwmFormatDataList,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                disabled: values.has_hwm === 'false'
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            sx: {
                                                mt: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Multi tenancy",
                                                description: "How one stream from this provider is split out to child owners.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "multi_tenant_enabled",
                                                                label: "Multi Tenant Enabled",
                                                                dataList: trueFalseDataList,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                                                name: "partition_scheme",
                                                                label: "Partition Scheme",
                                                                dataList: $639dc5c2b1977fd0$var$PARTITION_SCHEMES,
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                multiple: true,
                                                                // Clear the column when the scheme that owns it changes: its
                                                                // meaning differs per scheme, so a column name left over from
                                                                // LABEL is not a valid regex for FILE_KEY. Adding a scheme that
                                                                // does not use the column — PEN alongside LABEL — leaves it alone.
                                                                //
                                                                // Both go out in one setValues. handleChange followed by a
                                                                // setFieldValue revalidates twice, the second time against the
                                                                // scheme as it was before the change, so the rules that read one
                                                                // field off the other judged a form that never existed.
                                                                handleChange: (e)=>{
                                                                    const partition_scheme = e.target.value;
                                                                    const columnChanged = $639dc5c2b1977fd0$var$columnOwningScheme(partition_scheme) !== $639dc5c2b1977fd0$var$columnOwningScheme(values.partition_scheme);
                                                                    setValues((0, $7e9b970aebca32bd$export$71511d61b312f219)((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values), {
                                                                        partition_scheme: partition_scheme
                                                                    }), columnChanged ? {
                                                                        partition_column: ''
                                                                    } : {}));
                                                                },
                                                                required: values.multi_tenant_enabled === 'true',
                                                                disabled: values.multi_tenant_enabled === 'false'
                                                            })
                                                        }),
                                                        $639dc5c2b1977fd0$var$columnOwningScheme(values.partition_scheme) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                                                name: "partition_column",
                                                                label: $639dc5c2b1977fd0$var$PARTITION_COLUMN_LABELS[$639dc5c2b1977fd0$var$columnOwningScheme(values.partition_scheme)],
                                                                values: values,
                                                                touched: touched,
                                                                errors: errors,
                                                                handleBlur: handleBlur,
                                                                handleChange: handleChange,
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        Object.keys(errors).length > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            sx: {
                                                mt: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
                                                severity: "warning",
                                                children: [
                                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bf1395812ba8dabb$export$2e2bcd8739ae039), {
                                                        children: "Save is disabled until these are fixed"
                                                    }),
                                                    Object.keys(errors).map((field)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                            variant: "body2",
                                                            children: [
                                                                $639dc5c2b1977fd0$var$FIELD_LABELS[field] || field,
                                                                ": ",
                                                                errors[field]
                                                            ]
                                                        }, field))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            sx: {
                                                mt: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        mb: 2
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    disabled: isSubmitting,
                                                    onClick: ()=>pageFn.handleClose(setState),
                                                    size: "large",
                                                    type: "button",
                                                    variant: "outlined",
                                                    sx: {
                                                        mr: 1
                                                    },
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    disabled: isSubmitting || Object.keys(errors).length !== 0,
                                                    size: "large",
                                                    type: "submit",
                                                    variant: "contained",
                                                    children: "Save"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
var $639dc5c2b1977fd0$export$2e2bcd8739ae039 = $639dc5c2b1977fd0$var$ProviderEditDialog;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");





var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");


var $86B3v = parcelRequire("86B3v");

var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");
var $hDFpT = parcelRequire("hDFpT");

var $eyQWd = parcelRequire("eyQWd");


var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $2e7c51b5543807d9$export$d9c6dc45f75b0e4f(slot) {
    return (0, $geF11.default)('MuiDialogContentText', slot);
}
const $2e7c51b5543807d9$var$dialogContentTextClasses = (0, $rARwS.default)('MuiDialogContentText', [
    'root'
]);
var $2e7c51b5543807d9$export$2e2bcd8739ae039 = $2e7c51b5543807d9$var$dialogContentTextClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $1319f131b41e2079$var$_excluded = [
    "children",
    "className"
];
const $1319f131b41e2079$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $i3Yji.default)(slots, (0, $2e7c51b5543807d9$export$d9c6dc45f75b0e4f), classes);
    return (0, $erOpW.default)({}, classes, composedClasses);
};
const $1319f131b41e2079$var$DialogContentTextRoot = (0, $28RyA.default)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $hDFpT.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $1319f131b41e2079$var$DialogContentText = /*#__PURE__*/ $jSIPP.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $cMu4A.default)(props, $1319f131b41e2079$var$_excluded);
    const classes = $1319f131b41e2079$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $4uaIU.jsx)($1319f131b41e2079$var$DialogContentTextRoot, (0, $erOpW.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $86B3v.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $1319f131b41e2079$export$2e2bcd8739ae039 = $1319f131b41e2079$var$DialogContentText;



const $2709e525dda8b54c$var$ScrollableDialog = (props)=>{
    const handleClose = ()=>{
        props.setOpen(false);
    };
    const descriptionElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useRef(null);
    (0, $jSIPP.useEffect)(()=>{
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) descriptionElement.focus();
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: props.open,
        onClose: handleClose,
        scroll: props.scroll,
        maxWidth: 'xl',
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: props.title
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6f8ada62e319d53e$export$2e2bcd8739ae039), {
                dividers: true,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1319f131b41e2079$export$2e2bcd8739ae039), {
                    id: "scroll-dialog-description",
                    ref: descriptionElementRef,
                    tabIndex: -1,
                    component: "span",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)("pre", {
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)("code", {
                            children: props.content
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9e1fc1f07bfe7735$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                    onClick: handleClose,
                    children: "Cancel"
                })
            })
        ]
    });
};
var $2709e525dda8b54c$export$2e2bcd8739ae039 = $2709e525dda8b54c$var$ScrollableDialog;




parcelRequire("jSIPP");
const $1a44ca7ae83cf04b$export$53b3c91859018cd4 = [
    {
        field: 'id',
        headerName: 'ID',
        description: 'Provider ID',
        width: 45
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'Name',
        minWidth: 200
    },
    {
        field: 'display_name',
        headerName: 'Display Name',
        description: 'Vendor-facing name; repeats across a vendor\'s feeds',
        minWidth: 160
    },
    {
        field: 'provider_child_category_name',
        headerName: 'Sub-Category',
        description: 'Provider child category',
        minWidth: 170
    },
    {
        field: 'description',
        headerName: 'Description',
        description: 'Description',
        minWidth: 400
    },
    {
        field: 'has_hwm',
        headerName: 'Has HWM',
        description: 'Has high water mark',
        cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false',
        width: 130
    },
    {
        field: 'hwm_format',
        headerName: 'HWM Format',
        description: 'High water mark format',
        minWidth: 210
    },
    {
        field: 'device_provider',
        headerName: 'Device',
        headerClassName: 'header',
        description: 'Is a PCAgent data feed',
        cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false',
        width: 100
    },
    {
        field: 'v3',
        headerName: 'V3',
        headerClassName: 'header',
        description: 'Runs in version 3',
        cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false',
        width: 100
    },
    {
        field: 'timezone_sensitive',
        headerName: 'Timezone Sensitive',
        headerClassName: 'run-params-header',
        description: 'For an API feed, whether schedule depends on timezone',
        cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false',
        width: 170
    },
    {
        field: 'cron',
        headerName: 'Cron (UTC)',
        headerClassName: 'run-params-header',
        description: 'Cron schedule',
        minWidth: 130
    },
    {
        field: 'concurrency_limit',
        headerName: 'Concurrency',
        headerClassName: 'run-params-header',
        description: 'Max number of concurrent data extractions',
        width: 150
    },
    {
        field: 'backoff_interval',
        headerName: 'Backoff (sec)',
        headerClassName: 'run-params-header',
        description: 'Seconds to wait following API issues',
        width: 150
    },
    {
        field: 'created_by',
        headerName: 'Created By',
        description: 'Created By',
        minWidth: 175
    },
    {
        field: 'created_datetime',
        headerName: 'Created Datetime',
        description: 'Created Datetime',
        minWidth: 225
    },
    {
        field: 'updated_by',
        headerName: 'Updated By',
        description: 'Updated By',
        minWidth: 175
    },
    {
        field: 'updated_datetime',
        headerName: 'Updated Datetime',
        description: 'Updated Datetime',
        minWidth: 225
    },
    {
        field: 'multi_tenant_enabled',
        headerName: 'Multi Tenant',
        description: 'Multi Tenant Enabled Flag',
        minWidth: 100,
        cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false'
    },
    {
        field: 'partition_scheme',
        headerName: 'Partition Scheme',
        description: 'Partition Scheme',
        minWidth: 150
    },
    {
        field: 'partition_column',
        headerName: 'Partition Column',
        description: 'Partition Column',
        minWidth: 150
    }
];





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");







var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");



var $ghfJh = parcelRequire("ghfJh");




const $4a7d42ac6e10ce2f$var$ACTIVE_OPTIONS = [
    {
        name: 'true',
        value: 1
    },
    {
        name: 'false',
        value: 0
    }
];
/**
 * Create/edit dialog shared by the Category and Sub-Category tabs. Both tables carry the
 * same shape (name, description, active) and differ only in whether a parent category has
 * to be picked, so `parentOptions` is what separates them: pass it for Sub-Category and
 * the category_id dropdown appears and becomes required.
 */ const $4a7d42ac6e10ce2f$var$CategoryEditDialog = ({ entityLabel: entityLabel, service: service, queryKey: queryKey, parentOptions: parentOptions, state: state, setState: setState })=>{
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const isEdit = state.editMode === 'edit';
    const row = state.rowEditing;
    var _row_name, _row_description, _row_active, _row_category_id;
    const initialValues = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
        name: isEdit ? (_row_name = row === null || row === void 0 ? void 0 : row.name) !== null && _row_name !== void 0 ? _row_name : '' : '',
        description: isEdit ? (_row_description = row === null || row === void 0 ? void 0 : row.description) !== null && _row_description !== void 0 ? _row_description : '' : '',
        active: isEdit ? (_row_active = row === null || row === void 0 ? void 0 : row.active) !== null && _row_active !== void 0 ? _row_active : 1 : 1
    }, parentOptions ? {
        category_id: isEdit ? (_row_category_id = row === null || row === void 0 ? void 0 : row.category_id) !== null && _row_category_id !== void 0 ? _row_category_id : '' : ''
    } : {});
    const validationSchema = $f986b6e4122227d2$export$185802fd694ee1f5().shape((0, $7e9b970aebca32bd$export$71511d61b312f219)({
        name: $7a974168aa28ad85$export$185802fd694ee1f5().trim().required('Name is required').max(255, 'Name is at most 255 characters'),
        description: $7a974168aa28ad85$export$185802fd694ee1f5().nullable().max(255, 'Description is at most 255 characters')
    }, parentOptions ? {
        category_id: $892f03a053dca93f$export$185802fd694ee1f5().typeError('Category is required').required('Category is required')
    } : {}));
    const handleClose = ()=>setState.setEditOpen(false);
    const handleSubmit = async (values)=>{
        try {
            const body = (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values), {
                updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
            });
            if (isEdit) {
                // The API's PUT validator wants the id in the body as well as the path.
                await service.put(row.id, (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, body), {
                    id: row.id
                }));
                setState.setMsgText(`${entityLabel} ${values.name} updated`);
            } else {
                const resp = await service.post(body);
                setState.setMsgText(`${entityLabel} created, id = ${resp === null || resp === void 0 ? void 0 : resp.id}`);
            }
            setState.setMsgOpen(true);
            setState.setEditOpen(false);
            await queryClient.invalidateQueries(queryKey);
        } catch (error) {
            var _error_response;
            setState.setErrDisplayText(`${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`);
            setState.setErrorOpen(true);
        }
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: state.editOpen,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: isEdit ? `Edit ${entityLabel}` : `Create ${entityLabel}`
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                enableReinitialize: true,
                initialValues: initialValues,
                validationSchema: validationSchema,
                onSubmit: handleSubmit,
                children: ({ values: values, errors: errors, touched: touched, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $4uaIU.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            sx: {
                                p: '1.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                        name: "name",
                                        label: "Name",
                                        required: true,
                                        values: values,
                                        touched: touched,
                                        errors: errors,
                                        handleBlur: handleBlur,
                                        handleChange: handleChange
                                    })
                                }),
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $93f88473253fbdd2$export$2e2bcd8739ae039), {
                                        name: "description",
                                        label: "Description",
                                        values: values,
                                        touched: touched,
                                        errors: errors,
                                        handleBlur: handleBlur,
                                        handleChange: handleChange
                                    })
                                }),
                                parentOptions && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                        name: "category_id",
                                        label: "Category",
                                        required: true,
                                        dataList: parentOptions,
                                        values: values,
                                        touched: touched,
                                        errors: errors,
                                        handleBlur: handleBlur,
                                        handleChange: handleChange
                                    })
                                }),
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $846dd19afdaaf405$export$2e2bcd8739ae039), {
                                        name: "active",
                                        label: "Active",
                                        dataList: $4a7d42ac6e10ce2f$var$ACTIVE_OPTIONS,
                                        values: values,
                                        touched: touched,
                                        errors: errors,
                                        handleBlur: handleBlur,
                                        handleChange: handleChange
                                    })
                                }),
                                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sx: {
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                            onClick: handleClose,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            variant: "contained",
                                            disabled: isSubmitting,
                                            children: "Save"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
            })
        ]
    });
};
var $4a7d42ac6e10ce2f$export$2e2bcd8739ae039 = $4a7d42ac6e10ce2f$var$CategoryEditDialog;






/**
 * Grid for one of the two category tables, laid out the same way as the Providers tab:
 * a create button and refresh in the toolbar, a compact DataGridPro, and an edit action
 * per row opening a dialog.
 *
 * Sub-Category passes `parentOptions` (the provider_category rows as {name, value}); that
 * both adds the resolved Category column here and turns on the required parent dropdown in
 * the dialog. Category passes nothing and gets neither.
 */ const $7ee29aaf7de889bf$var$CategoryTab = ({ entityLabel: entityLabel, queryKey: queryKey, service: service, parentOptions: parentOptions })=>{
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const [editMode, setEditMode] = (0, $jSIPP.useState)('');
    const [editOpen, setEditOpen] = (0, $jSIPP.useState)(false);
    const [rowEditing, setRowEditing] = (0, $jSIPP.useState)(null);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [msgOpen, setMsgOpen] = (0, $jSIPP.useState)(false);
    const [msgText, setMsgText] = (0, $jSIPP.useState)('');
    const state = {
        editMode: editMode,
        editOpen: editOpen,
        rowEditing: rowEditing
    };
    const setState = {
        setEditMode: setEditMode,
        setEditOpen: setEditOpen,
        setRowEditing: setRowEditing,
        setErrDisplayText: setErrDisplayText,
        setErrorOpen: setErrorOpen,
        setMsgOpen: setMsgOpen,
        setMsgText: setMsgText
    };
    const handleError = (error)=>{
        var _error_response;
        setErrorOpen(false);
        setErrDisplayText(`${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`);
        setErrorOpen(true);
    };
    const rows = (0, $41632140e88fef11$export$dd0a697e1782aedd)(queryKey, async ()=>service.getAll(), {
        onError: handleError,
        retry: false,
        staleTime: Infinity
    });
    const handleCreate = ()=>{
        setEditMode('create');
        setRowEditing(null);
        setEditOpen(true);
    };
    const handleEdit = (row)=>{
        setEditMode('edit');
        setRowEditing(row);
        setEditOpen(true);
    };
    const parentName = (id)=>{
        var _parentOptions_find;
        var _parentOptions_find_name;
        return (_parentOptions_find_name = parentOptions === null || parentOptions === void 0 ? void 0 : (_parentOptions_find = parentOptions.find((o)=>o.value === id)) === null || _parentOptions_find === void 0 ? void 0 : _parentOptions_find.name) !== null && _parentOptions_find_name !== void 0 ? _parentOptions_find_name : '';
    };
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            description: 'ID',
            width: 70
        },
        {
            field: 'name',
            headerName: 'Name',
            description: 'Name',
            minWidth: 220
        },
        ...parentOptions ? [
            {
                field: 'category_id',
                headerName: 'Category',
                description: 'Parent provider category',
                minWidth: 180,
                valueGetter: (params)=>parentName(params.row.category_id)
            }
        ] : [],
        {
            field: 'description',
            headerName: 'Description',
            description: 'Description',
            minWidth: 340
        },
        {
            field: 'active',
            headerName: 'Active',
            description: 'Active',
            width: 100,
            // params.value is post-valueGetter, i.e. the string below - not the raw 0/1.
            cellClassName: (params)=>params.value === 'true' ? 'bool-cell-true' : 'bool-cell-false',
            valueGetter: (params)=>params.row.active === 1 ? 'true' : 'false'
        },
        {
            field: 'actions',
            headerName: 'Actions',
            description: 'Actions',
            minWidth: 100,
            renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: "Edit",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: ()=>handleEdit(params.row),
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6be52b93098825b$exports))), {})
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                editHandler: handleCreate,
                onRefresh: async ()=>queryClient.invalidateQueries(queryKey)
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                sx: {
                    height: '70vh'
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                    columns: columns,
                    rows: rows.data || [],
                    slots: {
                        loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                        toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                    },
                    loading: rows.isLoading,
                    density: "compact",
                    sx: {
                        '& .bool-cell-true': {
                            color: 'darkgreen'
                        },
                        '& .bool-cell-false': {
                            color: 'darkred'
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4a7d42ac6e10ce2f$export$2e2bcd8739ae039), {
                entityLabel: entityLabel,
                service: service,
                queryKey: queryKey,
                parentOptions: parentOptions,
                state: state,
                setState: setState
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c5b291bc5932a146$export$2e2bcd8739ae039), {
                open: msgOpen,
                setOpen: setMsgOpen,
                displayText: msgText
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $7ee29aaf7de889bf$export$2e2bcd8739ae039 = $7ee29aaf7de889bf$var$CategoryTab;




const $ebe15401de7d8cfc$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $ebe15401de7d8cfc$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$ebe15401de7d8cfc$var$HOST_URL}/provider-category`)).data;
};
const $ebe15401de7d8cfc$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$ebe15401de7d8cfc$var$HOST_URL}/provider-category`, data)).data;
};
const $ebe15401de7d8cfc$var$put = async (id, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$ebe15401de7d8cfc$var$HOST_URL}/provider-category/${id}`, data)).data;
};
var $ebe15401de7d8cfc$export$2e2bcd8739ae039 = {
    getAll: $ebe15401de7d8cfc$var$getAll,
    post: $ebe15401de7d8cfc$var$post,
    put: $ebe15401de7d8cfc$var$put
};



const $b7e75478e98bb558$var$TAB_PROVIDERS = 0;
const $b7e75478e98bb558$var$TAB_CATEGORY = 1;
const $b7e75478e98bb558$var$TAB_SUB_CATEGORY = 2;
const $b7e75478e98bb558$var$Providers = ({})=>{
    // ####################[ Setup and Initialization ]####################
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const initializeColumns = (initialColumns)=>{
        return initialColumns.concat({
            field: 'actions',
            headerName: 'Actions',
            description: 'Actions',
            minWidth: 175,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "View Schema",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleDialogOpen(event, true, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0eefa11e679f91b4$exports))), {})
                            })
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "View Properties",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleDialogOpen(event, false, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ad317ed5c7ae9683$exports))), {})
                            })
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Edit",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleEdit(event, params.row, queryClient, setState),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6be52b93098825b$exports))), {})
                            })
                        })
                    ]
                });
            }
        });
    };
    // ####################[ State Definitions ]####################
    const [tab, setTab] = (0, $jSIPP.useState)($b7e75478e98bb558$var$TAB_PROVIDERS);
    const [cols, setCols] = (0, $jSIPP.useState)(initializeColumns((0, $1a44ca7ae83cf04b$export$53b3c91859018cd4)));
    const [dialogContent, setDialogContent] = (0, $jSIPP.useState)('');
    const [dialogOpen, setDialogOpen] = (0, $jSIPP.useState)(false);
    const [dialogTitle, setDialogTitle] = (0, $jSIPP.useState)('');
    const [editMode, setEditMode] = (0, $jSIPP.useState)('');
    const [editOpen, setEditOpen] = (0, $jSIPP.useState)(false);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [msgOpen, setMsgOpen] = (0, $jSIPP.useState)(false);
    const [msgText, setMsgText] = (0, $jSIPP.useState)('');
    const [providerId, setProviderId] = (0, $jSIPP.useState)(null);
    const [rowEditing, setRowEditing] = (0, $jSIPP.useState)([]);
    const state = {
        editMode: editMode,
        editOpen: editOpen,
        rowEditing: rowEditing,
        providerId: providerId
    };
    const setState = {
        setEditMode: setEditMode,
        setEditOpen: setEditOpen,
        setErrorOpen: setErrorOpen,
        setErrDisplayText: setErrDisplayText,
        setMsgOpen: setMsgOpen,
        setMsgText: setMsgText,
        setProviderId: setProviderId,
        setRowEditing: setRowEditing
    };
    const formatData = (dataArray)=>{
        let returnArray = [];
        for (let data of dataArray){
            let rec = Object.assign({}, data);
            for(let field in rec)if (rec[field] === null) rec[field] = '';
            const boolFields = [
                'has_hwm',
                'device_provider',
                'timezone_sensitive',
                'v3',
                'multi_tenant_enabled'
            ];
            for (let field of boolFields){
                if (rec[field] === 1) rec[field] = 'true';
                else if (rec[field] === 0) rec[field] = 'false';
            }
            const jsonFields = [
                'schema',
                'properties'
            ];
            for (let field of jsonFields)rec[field] = JSON.stringify(rec[field], null, 2);
            returnArray.push(rec);
        }
        return returnArray;
    };
    // ####################[ Query Definitions ]####################
    const getProviders = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProvidersPage', async ()=>{
        return formatData(await (0, $04fdf08493329c97$export$2e2bcd8739ae039).getAll());
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    // Kept as its own query rather than folded into getProvidersPage: the providers grid must
    // still render if this fails, and sharing the key means CategoryEditDialog's invalidation
    // refreshes the Sub-Category column below without a manual refresh.
    const getChildCategories = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviderChildCategoriesPage', async ()=>(0, $885b40e5e295b926$export$2e2bcd8739ae039).getAll(), {
        onError: (error)=>handleError(error),
        retry: false,
        staleTime: Infinity
    });
    const childNameById = (0, $jSIPP.useMemo)(()=>new Map((getChildCategories.data || []).map((cat)=>[
                cat.id,
                cat.name
            ])), [
        getChildCategories.data
    ]);
    const rows = (0, $jSIPP.useMemo)(()=>(getProviders.data || []).map((row)=>{
            var _childNameById_get;
            return (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, row), {
                provider_child_category_name: (_childNameById_get = childNameById.get(row.provider_child_category_id)) !== null && _childNameById_get !== void 0 ? _childNameById_get : ''
            });
        }), [
        getProviders.data,
        childNameById
    ]);
    const getCategories = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviderCategoriesPage', async ()=>(0, $ebe15401de7d8cfc$export$2e2bcd8739ae039).getAll(), {
        onError: (error)=>handleError(error),
        retry: false,
        staleTime: Infinity
    });
    const categoryOptions = (getCategories.data || []).filter((cat)=>cat.active).map((cat)=>({
            name: cat.name,
            value: cat.id
        })).sort((a, b)=>a.name.localeCompare(b.name));
    // ####################[ Event Handlers ]####################
    const handleCreate = async ()=>{
        setState.setEditMode('create');
        setState.setRowEditing(null);
        setState.setEditOpen(true);
    };
    const handleDialogOpen = async (event, isSchema, row)=>{
        if (isSchema) {
            setDialogContent(row.schema);
            setDialogTitle('JSON Schema');
        } else {
            setDialogContent(row.properties);
            setDialogTitle('Properties');
        }
        setDialogOpen(true);
    };
    const handleDialogClose = async ()=>{
        setDialogOpen(false);
    };
    const handleEdit = async (event, row)=>{
        setEditMode('edit');
        setRowEditing(row);
        setProviderId(row.id);
        setEditOpen(true);
    };
    // Arriving from the home page search as /providers?id=5 opens that provider.
    (0, $fa76533b6a84f8f4$export$2e2bcd8739ae039)(getProviders.data, (row)=>handleEdit(null, row));
    const handleError = (error)=>{
        var _error_response, _error_response1;
        setErrorOpen(false);
        setErrDisplayText(`${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`);
        setErrorOpen(true);
        // axios gives no `response` at all for a network/CORS failure, so dereferencing it here
        // threw a TypeError that replaced the real error with a crash.
        console.error(`${error.message}: ${JSON.stringify((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.data)}`);
    };
    const refreshTable = async ()=>{
        await queryClient.invalidateQueries('getProvidersPage');
    };
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Providers",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $24d3c0f0e1b0f89c$export$2e2bcd8739ae039), {
                        value: tab,
                        onChange: (event, value)=>setTab(value),
                        sx: {
                            mb: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $750ab4e4aedcf19a$export$2e2bcd8739ae039), {
                                label: "Providers"
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $750ab4e4aedcf19a$export$2e2bcd8739ae039), {
                                label: "Category"
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $750ab4e4aedcf19a$export$2e2bcd8739ae039), {
                                label: "Sub-Category"
                            })
                        ]
                    }),
                    tab === $b7e75478e98bb558$var$TAB_PROVIDERS && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                                editHandler: ()=>handleCreate(setState),
                                onRefresh: refreshTable
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '77vh',
                                    '& .disabled': {
                                        color: '#94A3B8'
                                    }
                                },
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                                    columns: cols,
                                    rows: rows,
                                    getRowClassName: (params)=>params.row.disabled ? 'disabled' : '',
                                    slots: {
                                        loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                        toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                                    },
                                    loading: getProviders.isLoading,
                                    initialState: {
                                        columns: {
                                            columnVisibilityModel: {
                                                description: false,
                                                created_by: false,
                                                created_datetime: false,
                                                updated_by: false,
                                                updated_datetime: false,
                                                timezone_sensitive: false,
                                                cron: false,
                                                concurrency_limit: false,
                                                backoff_interval: false,
                                                has_hwm: false
                                            }
                                        }
                                    },
                                    density: "compact",
                                    sx: {
                                        '& .run-params-header': {
                                            backgroundColor: '#ECFDF5'
                                        },
                                        '& .bool-cell-true': {
                                            color: 'darkgreen'
                                        },
                                        '& .bool-cell-false': {
                                            color: 'darkred'
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    tab === $b7e75478e98bb558$var$TAB_CATEGORY && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7ee29aaf7de889bf$export$2e2bcd8739ae039), {
                        entityLabel: "Category",
                        queryKey: "getProviderCategoriesPage",
                        service: (0, $ebe15401de7d8cfc$export$2e2bcd8739ae039)
                    }),
                    tab === $b7e75478e98bb558$var$TAB_SUB_CATEGORY && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7ee29aaf7de889bf$export$2e2bcd8739ae039), {
                        entityLabel: "Sub-Category",
                        queryKey: "getProviderChildCategoriesPage",
                        service: (0, $885b40e5e295b926$export$2e2bcd8739ae039),
                        parentOptions: categoryOptions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $639dc5c2b1977fd0$export$2e2bcd8739ae039), {
                state: state,
                setState: setState
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2709e525dda8b54c$export$2e2bcd8739ae039), {
                open: dialogOpen,
                setOpen: setDialogOpen,
                close: handleDialogClose,
                content: dialogContent,
                title: dialogTitle,
                scroll: 'paper'
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c5b291bc5932a146$export$2e2bcd8739ae039), {
                open: msgOpen,
                setOpen: setMsgOpen,
                displayText: msgText
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $b7e75478e98bb558$export$2e2bcd8739ae039 = $b7e75478e98bb558$var$Providers;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");



var $62be85ceb821ae33$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($62be85ceb821ae33$exports, "__esModule", {
    value: true
});
$62be85ceb821ae33$exports.default = void 0;

var $62be85ceb821ae33$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $62be85ceb821ae33$var$_default = $62be85ceb821ae33$exports.default = (0, $62be85ceb821ae33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');









const $b7de691f030c2cc9$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $b7de691f030c2cc9$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$b7de691f030c2cc9$var$HOST_URL}/provider-monitoring-view`)).data;
};
const $b7de691f030c2cc9$var$post = async (data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).post(`${$b7de691f030c2cc9$var$HOST_URL}/provider-monitoring`, data)).data;
};
const $b7de691f030c2cc9$var$put = async (id, data)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).put(`${$b7de691f030c2cc9$var$HOST_URL}/provider-monitoring/${id}`, data)).data;
};
const $b7de691f030c2cc9$var$remove = async (id)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).delete(`${$b7de691f030c2cc9$var$HOST_URL}/provider-monitoring/${id}`)).data;
};
var $b7de691f030c2cc9$export$2e2bcd8739ae039 = {
    getAll: $b7de691f030c2cc9$var$getAll,
    post: $b7de691f030c2cc9$var$post,
    put: $b7de691f030c2cc9$var$put,
    remove: $b7de691f030c2cc9$var$remove
};




const $40c8394387bb47d0$export$822a894be8d35e7 = (categoryOptions)=>[
        {
            field: 'provider',
            headerName: 'provider',
            description: 'Provider name',
            minWidth: 220,
            flex: 1
        },
        {
            field: 'low_threshold',
            headerName: 'Low (Hours)',
            description: 'Low threshold in hours',
            type: 'number',
            width: 140,
            editable: true,
            align: 'right',
            headerAlign: 'left'
        },
        {
            field: 'med_threshold',
            headerName: 'Medium (Hours)',
            description: 'Medium threshold in hours',
            type: 'number',
            width: 160,
            editable: true,
            align: 'right',
            headerAlign: 'left'
        },
        {
            field: 'high_threshold',
            headerName: 'High (Hours)',
            description: 'High threshold in hours',
            type: 'number',
            width: 140,
            editable: true,
            align: 'right',
            headerAlign: 'left'
        },
        {
            field: 'provider_category_id',
            headerName: 'category *',
            description: 'Provider category (required)',
            type: 'singleSelect',
            valueOptions: categoryOptions,
            width: 200,
            editable: true,
            cellClassName: (params)=>params.value ? '' : 'category-missing',
            renderCell: (params)=>{
                if (params.value) {
                    const opt = categoryOptions.find((o)=>o.value === params.value);
                    return opt ? opt.label : params.value;
                }
                return 'Select category';
            }
        },
        {
            field: 'alias',
            headerName: 'alias',
            description: 'Display alias',
            minWidth: 200,
            flex: 1,
            editable: true
        }
    ];


const $e56c377aecfced50$var$DEFAULT_THRESHOLDS = {
    low_threshold: 24,
    med_threshold: 48,
    high_threshold: 72
};
const $e56c377aecfced50$var$ProviderThresholds = ({})=>{
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    // ####################[ Setup and Initialization ]####################
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    // ####################[ State Definitions ]####################
    const [rows, setRows] = (0, $jSIPP.useState)([]);
    const [deletedIds, setDeletedIds] = (0, $jSIPP.useState)([]);
    const [dirty, setDirty] = (0, $jSIPP.useState)(false);
    const [selectedProviderId, setSelectedProviderId] = (0, $jSIPP.useState)('');
    const [saving, setSaving] = (0, $jSIPP.useState)(false);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [msgOpen, setMsgOpen] = (0, $jSIPP.useState)(false);
    const [msgText, setMsgText] = (0, $jSIPP.useState)('');
    // ####################[ Event Handlers ]####################
    const handleError = (error)=>{
        var _error_response;
        setErrorOpen(false);
        setErrDisplayText(`${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`);
        setErrorOpen(true);
        console.error(`${error.message}: ${error.response ? JSON.stringify(error.response.data) : ''}`);
    };
    // ####################[ Query Definitions ]####################
    const getCategories = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviderCategories', async ()=>{
        return await (0, $ebe15401de7d8cfc$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>handleError(error),
        retry: false,
        staleTime: Infinity
    });
    const getProviders = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProvidersForThresholds', async ()=>{
        return await (0, $04fdf08493329c97$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>handleError(error),
        retry: false,
        staleTime: Infinity
    });
    const getThresholds = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviderThresholdsPage', async ()=>{
        const data = await (0, $b7de691f030c2cc9$export$2e2bcd8739ae039).getAll();
        const normalized = (data || []).map((row)=>({
                id: row.id,
                provider_id: row.provider_id,
                provider: row.provider_name || '',
                provider_category_id: row.category_id,
                category_name: row.category_name,
                low_threshold: row.low_threshold,
                med_threshold: row.med_threshold,
                high_threshold: row.high_threshold,
                alias: row.alias,
                description: row.description
            }));
        setRows(normalized);
        setDeletedIds([]);
        setDirty(false);
        return normalized;
    }, {
        onError: (error)=>handleError(error),
        retry: false,
        refetchOnMount: 'always'
    });
    // ####################[ Derived Data ]####################
    const categoryOptions = (0, $jSIPP.useMemo)(()=>{
        return (getCategories.data || []).filter((c)=>c.active).map((c)=>({
                value: c.id,
                label: c.name
            })).sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                sensitivity: 'base'
            }));
    }, [
        getCategories.data
    ]);
    const availableProviders = (0, $jSIPP.useMemo)(()=>{
        const usedIds = new Set(rows.map((r)=>r.provider_id).filter(Boolean));
        return (getProviders.data || []).filter((p)=>!usedIds.has(p.id)).sort((a, b)=>(a.name || '').localeCompare(b.name || '', undefined, {
                sensitivity: 'base'
            }));
    }, [
        rows,
        getProviders.data
    ]);
    const handleAdd = ()=>{
        if (!selectedProviderId) return;
        const provider = (getProviders.data || []).find((p)=>p.id === selectedProviderId);
        if (!provider) return;
        const newRow = (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            id: `new-${Date.now()}`,
            isNew: true,
            provider: provider.name,
            provider_id: provider.id,
            provider_category_id: '',
            category_name: '',
            alias: provider.name.replace(/_/g, ' '),
            description: null
        }, $e56c377aecfced50$var$DEFAULT_THRESHOLDS);
        setRows((prev)=>[
                ...prev,
                newRow
            ]);
        setSelectedProviderId('');
        setDirty(true);
    };
    const handleDelete = (row)=>{
        setRows((prev)=>prev.filter((r)=>r.id !== row.id));
        if (!row.isNew) setDeletedIds((prev)=>[
                ...prev,
                row.id
            ]);
        setDirty(true);
    };
    const processRowUpdate = (newRow)=>{
        setRows((prev)=>prev.map((r)=>r.id === newRow.id ? newRow : r));
        setDirty(true);
        return newRow;
    };
    const handleCancel = async ()=>{
        setDeletedIds([]);
        await queryClient.invalidateQueries('getProviderThresholdsPage');
    };
    const handleSave = async ()=>{
        const missingCategory = rows.filter((r)=>!r.provider_category_id);
        if (missingCategory.length > 0) {
            const names = missingCategory.map((r)=>r.provider || `row ${r.id}`).join(', ');
            setErrDisplayText(`Category is required for: ${names}`);
            setErrorOpen(true);
            return;
        }
        setSaving(true);
        try {
            const user = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
            const original = getThresholds.data || [];
            const originalById = new Map(original.map((r)=>[
                    r.id,
                    r
                ]));
            const deletes = deletedIds.map((id)=>(0, $b7de691f030c2cc9$export$2e2bcd8739ae039).remove(id));
            const upserts = rows.map((row)=>{
                const payload = {
                    provider_id: row.provider_id,
                    provider_category_id: Number(row.provider_category_id) || null,
                    alias: row.alias || null,
                    low_threshold: row.low_threshold === '' || row.low_threshold == null ? null : Number(row.low_threshold),
                    med_threshold: row.med_threshold === '' || row.med_threshold == null ? null : Number(row.med_threshold),
                    high_threshold: row.high_threshold === '' || row.high_threshold == null ? null : Number(row.high_threshold),
                    description: row.description || null,
                    updated_by: user
                };
                if (row.isNew) return (0, $b7de691f030c2cc9$export$2e2bcd8739ae039).post((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, payload), {
                    created_by: user
                }));
                const prev = originalById.get(row.id);
                const changed = !prev || prev.provider_id !== payload.provider_id || prev.low_threshold !== payload.low_threshold || prev.med_threshold !== payload.med_threshold || prev.high_threshold !== payload.high_threshold || prev.provider_category_id !== payload.provider_category_id || prev.alias !== payload.alias || prev.description !== payload.description;
                return changed ? (0, $b7de691f030c2cc9$export$2e2bcd8739ae039).put(row.id, (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                    id: row.id
                }, payload)) : null;
            }).filter(Boolean);
            await Promise.all([
                ...deletes,
                ...upserts
            ]);
            setMsgText('Provider thresholds saved');
            setMsgOpen(true);
            await queryClient.invalidateQueries('getProviderThresholdsPage');
        } catch (error) {
            handleError(error);
        } finally{
            setSaving(false);
        }
    };
    // ####################[ Columns with Action ]####################
    const cols = (0, $jSIPP.useMemo)(()=>(0, $40c8394387bb47d0$export$822a894be8d35e7)(categoryOptions).concat({
            field: 'actions',
            headerName: 'Actions',
            description: 'Actions',
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: "Delete",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: ()=>handleDelete(params.row),
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($62be85ceb821ae33$exports))), {})
                    })
                })
        }), [
        categoryOptions
    ]);
    const loading = getThresholds.isLoading || getProviders.isLoading || getCategories.isLoading;
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Provider Thresholds",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            mb: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                                size: "small",
                                sx: {
                                    minWidth: 240
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                                        id: "provider-filter-label",
                                        children: "Provider"
                                    }),
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                        labelId: "provider-filter-label",
                                        label: "Provider",
                                        value: selectedProviderId,
                                        onChange: (e)=>setSelectedProviderId(e.target.value),
                                        children: availableProviders.map((p)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                                value: p.id,
                                                children: p.name
                                            }, p.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "contained",
                                onClick: handleAdd,
                                disabled: !selectedProviderId,
                                children: "Add"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '65vh'
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: rows,
                            getRowId: (row)=>row.id,
                            processRowUpdate: processRowUpdate,
                            onProcessRowUpdateError: handleError,
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039)
                            },
                            loading: loading,
                            density: "compact",
                            disableRowSelectionOnClick: true,
                            sx: {
                                '& .category-missing': {
                                    backgroundColor: 'rgba(244, 67, 54, 0.08)',
                                    color: theme.palette.error.main,
                                    fontStyle: 'italic'
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            mt: '1.5rem',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "outlined",
                                onClick: handleCancel,
                                disabled: saving || !dirty,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "contained",
                                onClick: handleSave,
                                disabled: saving || !dirty,
                                children: "Save"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c5b291bc5932a146$export$2e2bcd8739ae039), {
                open: msgOpen,
                setOpen: setMsgOpen,
                displayText: msgText
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $e56c377aecfced50$export$2e2bcd8739ae039 = $e56c377aecfced50$var$ProviderThresholds;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");








const $ed70a4f11e63f46e$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $ed70a4f11e63f46e$var$getBusinessSummary = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$ed70a4f11e63f46e$var$HOST_URL}/pen-health`)).data;
};
const $ed70a4f11e63f46e$var$getFlags = async (businessId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$ed70a4f11e63f46e$var$HOST_URL}/pen-health/flags`, {
        params: {
            business_id: businessId
        }
    })).data;
};
var $ed70a4f11e63f46e$export$2e2bcd8739ae039 = {
    getBusinessSummary: $ed70a4f11e63f46e$var$getBusinessSummary,
    getFlags: $ed70a4f11e63f46e$var$getFlags
};




var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $551f3acc4d24715b$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($551f3acc4d24715b$exports, "__esModule", {
    value: true
});
$551f3acc4d24715b$exports.default = void 0;

var $551f3acc4d24715b$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $551f3acc4d24715b$var$_default = $551f3acc4d24715b$exports.default = (0, $551f3acc4d24715b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');


var $21efae9ac373b853$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($21efae9ac373b853$exports, "__esModule", {
    value: true
});
$21efae9ac373b853$exports.default = void 0;

var $21efae9ac373b853$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $21efae9ac373b853$var$_default = $21efae9ac373b853$exports.default = (0, $21efae9ac373b853$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');



const $71fe21a5ce636973$export$a513ea61a7bee91c = [
    {
        key: 'unmapped',
        label: 'Unmapped',
        description: 'Herd pen holding cows with no pen config'
    },
    {
        key: 'feed_link',
        label: 'Feed link',
        description: 'Feed pen blank, or no delivery to it in 14 days'
    },
    {
        key: 'out_of_production',
        label: 'Out of production',
        description: 'Milk to Processor pen that is not mostly lactating'
    },
    {
        key: 'into_production',
        label: 'Into production',
        description: 'Not Milking or blank pen that is mostly lactating'
    },
    {
        key: 'stage_mismatch',
        label: 'Stage mismatch',
        description: 'Pen stage label contradicts the animals in it'
    },
    {
        key: 'unused_pen',
        label: 'Unused pen',
        description: 'Milk to Processor pen holding no animals (never High)'
    }
];
const $71fe21a5ce636973$var$CATEGORY_LABELS = Object.fromEntries($71fe21a5ce636973$export$a513ea61a7bee91c.map((c)=>[
        c.key,
        c.label
    ]));
const $71fe21a5ce636973$var$CATEGORY_DESCRIPTIONS = Object.fromEntries($71fe21a5ce636973$export$a513ea61a7bee91c.map((c)=>[
        c.key,
        c.description
    ]));
const $71fe21a5ce636973$var$PARENT_UNMAPPED = {
    label: 'Not assigned to a site',
    description: 'Herd pen on a multi-site parent that no child site claims; map it on the right site'
};
const $71fe21a5ce636973$var$categoryLabel = (row)=>row.is_multi_site_parent && row.category === 'unmapped' ? $71fe21a5ce636973$var$PARENT_UNMAPPED.label : $71fe21a5ce636973$var$CATEGORY_LABELS[row.category] || row.category;
const $71fe21a5ce636973$var$categoryDescription = (row)=>row.is_multi_site_parent && row.category === 'unmapped' ? $71fe21a5ce636973$var$PARENT_UNMAPPED.description : $71fe21a5ce636973$var$CATEGORY_DESCRIPTIONS[row.category] || '';
const $71fe21a5ce636973$var$formatDate = (isoDate)=>isoDate ? new Date(`${isoDate}T00:00:00`).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric'
    }) : '';
const $71fe21a5ce636973$var$NONE = /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
    variant: "body2",
    sx: {
        color: 'text.disabled'
    },
    children: "\u2013"
});
const $71fe21a5ce636973$var$Tag = ({ label: label, title: title })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
        title: title,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
            size: "small",
            label: label,
            variant: "outlined",
            sx: {
                height: 18,
                fontSize: '0.65rem',
                color: 'text.secondary'
            }
        })
    });
const $71fe21a5ce636973$export$a8290ea53778e337 = ()=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Tag, {
        label: "PARENT",
        title: "Parent of a multi-site farm. Its own alerts are herd pens not assigned to any of its sites."
    });
const $71fe21a5ce636973$export$8b5c590b2a7bec19 = ({ peak: peak })=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Tag, {
        label: "STRAY",
        title: `Never held more than ${peak} animals in 90 days; likely a data-entry stray, so kept low`
    });
const $71fe21a5ce636973$export$87f352fbe8fb80a1 = ()=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Tag, {
        label: "STALE",
        title: "No herd data for today; evaluated on this older snapshot"
    });
const $71fe21a5ce636973$export$4dc7c15b83bedfd8 = [
    {
        groupId: 'issues',
        headerName: 'Alerts by pen issue',
        description: 'Flagged pens per issue. Bold when any of them are High.',
        headerAlign: 'center',
        children: $71fe21a5ce636973$export$a513ea61a7bee91c.map(({ key: key })=>({
                field: key
            }))
    }
];
const $71fe21a5ce636973$var$farmPathKey = (row)=>`farm:${row.multi_site_owner_id}`;
const $71fe21a5ce636973$export$aff8b6e33fe3711b = (row)=>{
    if (!row.multi_site_owner_id) return [
        row.business_id
    ];
    return row.is_multi_site_parent ? [
        $71fe21a5ce636973$var$farmPathKey(row)
    ] : [
        $71fe21a5ce636973$var$farmPathKey(row),
        row.business_id
    ];
};
const $71fe21a5ce636973$var$FarmHeading = ({ name: name, siteCount: siteCount })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            py: '0.4rem'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$export$a8290ea53778e337, {})
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                sx: {
                    color: 'text.secondary'
                },
                children: [
                    siteCount,
                    " sites \xb7 no herd pens left on the parent"
                ]
            })
        ]
    });
const $71fe21a5ce636973$var$BusinessTreeCell = ({ id: id, row: row, rowNode: rowNode })=>{
    var _apiRef_current_getRow;
    const apiRef = (0, $8e32833f8e5c03cf$export$2d14edd3a7db3bbf)();
    const isGroup = rowNode.type === 'group';
    const toggle = (event)=>{
        event.stopPropagation();
        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            alignItems: 'center',
            pl: rowNode.depth * 4
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    width: 36,
                    flexShrink: 0
                },
                children: isGroup && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: toggle,
                    "aria-label": rowNode.childrenExpanded ? 'Collapse sites' : 'Expand sites',
                    children: rowNode.childrenExpanded ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21efae9ac373b853$exports))), {
                        fontSize: "small"
                    }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($551f3acc4d24715b$exports))), {
                        fontSize: "small"
                    })
                })
            }),
            row.business_id ? /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$BusinessCell, {
                row: row
            }) : /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$FarmHeading, {
                name: (_apiRef_current_getRow = apiRef.current.getRow(rowNode.children[0])) === null || _apiRef_current_getRow === void 0 ? void 0 : _apiRef_current_getRow.multi_site_name,
                siteCount: rowNode.children.length
            })
        ]
    });
};
const $71fe21a5ce636973$export$43d6f37c4534bc1 = {
    headerName: 'Business',
    description: "Business name, then owner id \xb7 cows \xb7 herd snapshot date. Multi-site farms group their sites under the parent.",
    width: 340,
    sortable: false,
    renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$BusinessTreeCell, (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params))
};
const $71fe21a5ce636973$var$BusinessCell = ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            py: '0.4rem'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: row.business_name
                    }),
                    row.is_multi_site_parent && /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$export$a8290ea53778e337, {}),
                    row.is_stale && /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$export$87f352fbe8fb80a1, {})
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                sx: {
                    color: 'text.secondary'
                },
                children: [
                    row.owner_id,
                    " \xb7 ",
                    Number(row.cow_count).toLocaleString(),
                    " cows \xb7 ",
                    $71fe21a5ce636973$var$formatDate(row.snapshot_date)
                ]
            })
        ]
    });
const $71fe21a5ce636973$var$AlertsCell = ({ row: row })=>{
    if (!row.high_count && !row.low_count) return $71fe21a5ce636973$var$NONE;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        sx: {
            py: '0.4rem'
        },
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                component: "div",
                children: [
                    row.high_count > 0 && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: {
                            color: 'error.main',
                            fontWeight: 700
                        },
                        children: [
                            row.high_count,
                            " High"
                        ]
                    }),
                    row.high_count > 0 && row.low_count > 0 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: {
                            color: 'text.secondary'
                        },
                        children: " \xb7 "
                    }),
                    row.low_count > 0 && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: {
                            color: 'text.secondary'
                        },
                        children: [
                            row.low_count,
                            " low"
                        ]
                    })
                ]
            }),
            row.oldest_high_flagged_since && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                sx: {
                    color: 'text.secondary'
                },
                children: [
                    "since ",
                    $71fe21a5ce636973$var$formatDate(row.oldest_high_flagged_since)
                ]
            })
        ]
    });
};
const $71fe21a5ce636973$var$IssueCell = ({ row: row, category: category })=>{
    const high = row[`${category}_high_count`] || 0;
    const low = row[`${category}_low_count`] || 0;
    if (!high && !low) return $71fe21a5ce636973$var$NONE;
    const notAssigned = category === 'unmapped' && row.is_multi_site_parent ? ' not assigned to a site' : '';
    const parts = [
        high && `${high} High`,
        low && `${low} low`
    ].filter(Boolean).join(" \xb7 ") + notAssigned;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
        title: parts,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
            variant: "body2",
            sx: high ? {
                fontWeight: 700
            } : {
                color: 'text.secondary'
            },
            children: high + low
        })
    });
};
const $71fe21a5ce636973$export$a530975baccfee0a = ()=>[
        {
            field: 'alerts',
            headerName: 'Pen alerts',
            description: 'High and low alerts across all pen issues, and how long the oldest High has been open',
            minWidth: 170,
            flex: 1.2,
            valueGetter: ({ row: row })=>(row.high_count || 0) * 1000 + (row.low_count || 0),
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$AlertsCell, {
                    row: row
                })
        },
        ...$71fe21a5ce636973$export$a513ea61a7bee91c.map(({ key: key, label: label, description: description })=>({
                field: key,
                headerName: label,
                description: description,
                minWidth: 130,
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                valueGetter: ({ row: row })=>(row[`${key}_high_count`] || 0) * 1000 + (row[`${key}_low_count`] || 0),
                renderCell: ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$IssueCell, {
                        row: row,
                        category: key
                    })
            }))
    ];
const $71fe21a5ce636973$var$muted = {
    color: 'text.secondary'
};
const $71fe21a5ce636973$var$Code = ({ children: children })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        component: "span",
        sx: {
            fontWeight: 700,
            whiteSpace: 'pre'
        },
        children: `"${children}"`
    });
const $71fe21a5ce636973$var$largestGroup = (row)=>{
    const groups = [
        [
            'lactating cows',
            row.lactating_count
        ],
        [
            'dry cows',
            row.dry_count
        ],
        [
            'young stock',
            row.young_count
        ]
    ];
    return groups.reduce((best, group)=>group[1] > best[1] ? group : best);
};
const $71fe21a5ce636973$var$makeup = (row)=>`${row.lactating_count} lactating \xb7 ${row.dry_count} dry \xb7 ${row.young_count} young stock`;
const $71fe21a5ce636973$var$FeedLinkDetail = ({ row: row })=>{
    const suggestion = row.suggested_feed_pen && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
        children: [
            " Did you mean ",
            /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Code, {
                children: row.suggested_feed_pen
            }),
            "?"
        ]
    });
    switch(row.feed_link_reason){
        case 'no_feed_pen':
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {
                children: "No feed pen is set for this pen, so its feed can't be matched."
            });
        case 'stale':
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    "Feed pen ",
                    /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Code, {
                        children: row.src_feed_pen_id
                    }),
                    " hasn't had a delivery since ",
                    $71fe21a5ce636973$var$formatDate(row.last_feed_delivery),
                    ".",
                    suggestion
                ]
            });
        case 'name_mismatch':
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    "Feed pen ",
                    /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Code, {
                        children: row.src_feed_pen_id
                    }),
                    " differs from the feed system's ",
                    /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Code, {
                        children: row.suggested_feed_pen
                    }),
                    " only by case or spacing."
                ]
            });
        default:
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    "Feed pen ",
                    /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$Code, {
                        children: row.src_feed_pen_id
                    }),
                    " isn't in the feed data.",
                    suggestion || (row.recent_feed_pen_count != null ? ` No close match among the farm's ${row.recent_feed_pen_count} recently fed pens.` : ' No close match among the farm\'s recently fed pens.')
                ]
            });
    }
};
const $71fe21a5ce636973$var$IssueDetail = ({ row: row })=>{
    switch(row.category){
        case 'unmapped':
            return row.is_multi_site_parent ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    row.cow_count,
                    " cows in a herd pen no site claims. Add the pen to the right site's pen config."
                ]
            }) : /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    row.cow_count,
                    " cows in a herd pen with no pen config."
                ]
            });
        case 'feed_link':
            return /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$FeedLinkDetail, {
                row: row
            });
        case 'out_of_production':
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    "Milk to Processor, but only ",
                    row.lactating_count,
                    " of ",
                    row.animal_count,
                    " animals are lactating (",
                    $71fe21a5ce636973$var$makeup(row),
                    ")."
                ]
            });
        case 'into_production':
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    row.milk_disposition || 'No disposition set',
                    ", but ",
                    row.lactating_count,
                    " of ",
                    row.animal_count,
                    " animals are lactating."
                ]
            });
        case 'stage_mismatch':
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    "Labelled ",
                    row.animal_stage,
                    ", but most animals are ",
                    $71fe21a5ce636973$var$largestGroup(row)[0],
                    " (",
                    $71fe21a5ce636973$var$makeup(row),
                    ")."
                ]
            });
        case 'unused_pen':
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {
                children: "Milk to Processor pen with no animals in it."
            });
        default:
            return null;
    }
};
const $71fe21a5ce636973$export$aa4dc9d6f6822505 = ()=>[
        {
            field: 'src_pen_id',
            headerName: 'Pen',
            width: 80
        },
        {
            field: 'severity',
            headerName: 'Severity',
            width: 140,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: row.severity === 'high' && row.base_severity === 'low' ? 'Escalated: low for 7+ days' : '',
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "body2",
                                sx: row.severity === 'high' ? {
                                    color: 'error.main',
                                    fontWeight: 700
                                } : $71fe21a5ce636973$var$muted,
                                children: row.severity === 'high' ? 'High' : 'low'
                            })
                        }),
                        row.is_stray_pen && row.category !== 'unused_pen' && /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$export$8b5c590b2a7bec19, {
                            peak: row.peak_animal_count_90d
                        })
                    ]
                })
        },
        {
            field: 'category',
            headerName: 'Issue',
            width: 190,
            valueGetter: ({ row: row })=>$71fe21a5ce636973$var$categoryLabel(row),
            renderCell: ({ row: row, value: value })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: $71fe21a5ce636973$var$categoryDescription(row),
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: value
                    })
                })
        },
        {
            field: 'detail',
            headerName: "What's wrong",
            minWidth: 420,
            flex: 1,
            sortable: false,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                    variant: "body2",
                    sx: {
                        py: '0.4rem',
                        whiteSpace: 'normal'
                    },
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)($71fe21a5ce636973$var$IssueDetail, {
                        row: row
                    })
                })
        },
        {
            field: 'days_flagged',
            headerName: 'Days',
            type: 'number',
            width: 70,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: `Flagged since ${row.flagged_since}`,
                    children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "body2",
                        children: [
                            row.days_flagged,
                            row.is_flagged_since_window_start ? '+' : ''
                        ]
                    })
                })
        },
        {
            field: 'animal_stage',
            headerName: 'Pen stage',
            width: 170,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'milk_disposition',
            headerName: 'Disposition',
            width: 150,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'src_feed_pen_id',
            headerName: 'Feed pen',
            width: 100,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'animal_count',
            headerName: 'Animals',
            type: 'number',
            width: 90,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'lactating_count',
            headerName: 'Lactating',
            type: 'number',
            width: 95,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'dry_count',
            headerName: 'Dry',
            type: 'number',
            width: 70,
            cellClassName: 'pen-health-muted'
        },
        {
            field: 'young_count',
            headerName: 'Young stock',
            type: 'number',
            width: 105,
            cellClassName: 'pen-health-muted'
        }
    ];


const $fbf3e27db94c1b7f$export$aba9197dc3c6029a = 'getPenHealthSummary';
const $fbf3e27db94c1b7f$export$59b278ef2c09f0d6 = (handleError)=>(0, $41632140e88fef11$export$dd0a697e1782aedd)($fbf3e27db94c1b7f$export$aba9197dc3c6029a, (0, $ed70a4f11e63f46e$export$2e2bcd8739ae039).getBusinessSummary, {
        onError: handleError,
        retry: false
    });
const $fbf3e27db94c1b7f$export$424a73c529ce205c = (error)=>{
    var _error_response;
    return `${error.message}` + `${((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) ? ': ' + JSON.stringify(error.response.data) : ''}`;
};
const $fbf3e27db94c1b7f$var$farmKey = (row)=>{
    var _row_multi_site_owner_id;
    return (_row_multi_site_owner_id = row.multi_site_owner_id) !== null && _row_multi_site_owner_id !== void 0 ? _row_multi_site_owner_id : `single:${row.business_id}`;
};
const $fbf3e27db94c1b7f$var$orderByFarm = (rows)=>{
    const farmHigh = new Map();
    rows.forEach((row)=>farmHigh.set($fbf3e27db94c1b7f$var$farmKey(row), (farmHigh.get($fbf3e27db94c1b7f$var$farmKey(row)) || 0) + (row.high_count || 0)));
    return [
        ...rows
    ].sort((a, b)=>farmHigh.get($fbf3e27db94c1b7f$var$farmKey(b)) - farmHigh.get($fbf3e27db94c1b7f$var$farmKey(a)) || String($fbf3e27db94c1b7f$var$farmKey(a)).localeCompare(String($fbf3e27db94c1b7f$var$farmKey(b))) || b.is_multi_site_parent - a.is_multi_site_parent || (b.high_count || 0) - (a.high_count || 0));
};
const $fbf3e27db94c1b7f$var$PenHealth = ()=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const handleError = (error)=>{
        setErrDisplayText($fbf3e27db94c1b7f$export$424a73c529ce205c(error));
        setErrorOpen(true);
    };
    const summary = $fbf3e27db94c1b7f$export$59b278ef2c09f0d6(handleError);
    const columns = (0, $jSIPP.useMemo)((0, $71fe21a5ce636973$export$a530975baccfee0a), []);
    const rows = (0, $jSIPP.useMemo)(()=>$fbf3e27db94c1b7f$var$orderByFarm(summary.data || []), [
        summary.data
    ]);
    const staleCount = rows.filter((r)=>r.is_stale).length;
    const farmCount = new Set(rows.map($fbf3e27db94c1b7f$var$farmKey)).size;
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Pen Health",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "body2",
                        sx: {
                            mb: '1rem',
                            color: 'text.secondary'
                        },
                        children: [
                            farmCount,
                            " farms (",
                            rows.length,
                            " businesses with cows); multi-site farms list their sites under the parent. High means definitely misconfigured, or low for 7+ days; issue counts are bold when they include a High. ",
                            staleCount > 0 && `${staleCount} evaluated on a stale herd snapshot. `,
                            "Click a business for its pens."
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '70vh'
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: columns,
                            columnGroupingModel: (0, $71fe21a5ce636973$export$4dc7c15b83bedfd8),
                            treeData: true,
                            getTreeDataPath: (0, $71fe21a5ce636973$export$aff8b6e33fe3711b),
                            groupingColDef: (0, $71fe21a5ce636973$export$43d6f37c4534bc1),
                            defaultGroupingExpansionDepth: -1,
                            rows: rows,
                            getRowId: (row)=>row.business_id,
                            loading: summary.isLoading,
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039)
                            },
                            getRowHeight: ()=>'auto',
                            disableRowSelectionOnClick: true,
                            onRowClick: ({ row: row })=>row.business_id && history.push(`/pen-health/${row.business_id}`),
                            sx: {
                                '& .MuiDataGrid-row': {
                                    cursor: 'pointer'
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $fbf3e27db94c1b7f$export$2e2bcd8739ae039 = $fbf3e27db94c1b7f$var$PenHealth;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");



var $73a545b4a15c470e$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($73a545b4a15c470e$exports, "__esModule", {
    value: true
});
$73a545b4a15c470e$exports.default = void 0;

var $73a545b4a15c470e$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $73a545b4a15c470e$var$_default = $73a545b4a15c470e$exports.default = (0, $73a545b4a15c470e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');








const $b7f4849d2ef18c7d$var$PenHealthDetail = ()=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const { businessId: businessId } = (0, $418bff895eee7f39$export$99eaa27ddbbb95ef)();
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const handleError = (error)=>{
        setErrDisplayText((0, $fbf3e27db94c1b7f$export$424a73c529ce205c)(error));
        setErrorOpen(true);
    };
    const summary = (0, $fbf3e27db94c1b7f$export$59b278ef2c09f0d6)(handleError);
    const flags = (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        'getPenHealthFlags',
        businessId
    ], ()=>(0, $ed70a4f11e63f46e$export$2e2bcd8739ae039).getFlags(businessId), {
        onError: handleError,
        retry: false
    });
    const business = (summary.data || []).find((b)=>b.business_id === businessId);
    const columns = (0, $jSIPP.useMemo)((0, $71fe21a5ce636973$export$aa4dc9d6f6822505), []);
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: business ? `Pen Health: ${business.business_name}` : 'Pen Health',
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                        sx: {
                            mb: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73a545b4a15c470e$exports))), {}),
                                onClick: ()=>history.push('/pen-health'),
                                children: "All businesses"
                            }),
                            business && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "body2",
                                sx: {
                                    color: 'text.secondary'
                                },
                                children: [
                                    "Owner ",
                                    business.owner_id,
                                    " \xb7 ",
                                    Number(business.cow_count).toLocaleString(),
                                    " cows \xb7 herd snapshot ",
                                    business.snapshot_date
                                ]
                            }),
                            (business === null || business === void 0 ? void 0 : business.is_multi_site_parent) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $71fe21a5ce636973$export$a8290ea53778e337), {}),
                            (business === null || business === void 0 ? void 0 : business.multi_site_owner_id) && !business.is_multi_site_parent && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                variant: "body2",
                                sx: {
                                    color: 'text.secondary'
                                },
                                children: [
                                    "Site of ",
                                    business.multi_site_name
                                ]
                            }),
                            (business === null || business === void 0 ? void 0 : business.is_stale) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $71fe21a5ce636973$export$87f352fbe8fb80a1), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '68vh'
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: columns,
                            rows: flags.data || [],
                            getRowId: (row)=>`${row.src_pen_id}|${row.category}`,
                            loading: flags.isLoading,
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039)
                            },
                            getRowHeight: ()=>'auto',
                            disableRowSelectionOnClick: true,
                            localeText: {
                                noRowsLabel: 'No flagged pens'
                            },
                            sx: {
                                '& .pen-health-muted': {
                                    color: 'text.secondary'
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $b7f4849d2ef18c7d$export$2e2bcd8739ae039 = $b7f4849d2ef18c7d$var$PenHealthDetail;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");










var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");



var $ghfJh = parcelRequire("ghfJh");


var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");



const $531892a6884f10c9$var$useStyles = (0, $02ded3e1150d0989$export$2e2bcd8739ae039)((theme)=>({
        hasError: {
            '& label': {
                color: theme.palette.error.main
            }
        },
        errorText: {
            color: theme.palette.error.main,
            fontFamily: 'Roboto, Helvetica, Arial,sans-serif',
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1.66,
            letterSpacing: '0.03333em',
            textAlign: 'left',
            marginTop: '3px',
            marginRight: '14px',
            marginBottom: 0,
            marginLeft: '14px'
        }
    }));
/***
 *
 * @param fieldName A custom name for the IyoDropDown.  This should be a unique identifier.
 * @param dataList An array of data entries.  Each entry must contain attributes {id, name}.
 * @param value The field to which selections get assigned.  See Material-UI's Select's value field for more info.
 * @param errors An array of errors.  Designed to work with Formik.
 * @param formTouched a Boolean value stating whether this field has been touched.
 * @param handleChange Handles value change.
 * @returns {JSX.Element}
 * @constructor
 */ const $531892a6884f10c9$var$IyoFormikDropDownLegacy = ({ fieldName: fieldName, dataList: dataList, value: value, errors: errors, touched: touched, handleChange: handleChange, multiple: multiple = false })=>{
    const myClasses = $531892a6884f10c9$var$useStyles();
    const selectId = fieldName.replace('_', '-');
    const labelId = selectId + '-label';
    const inputLabel = (0, $a9106d6db699107c$export$9a216cca07bece15)(fieldName, ' ');
    const labelId2 = (0, $a9106d6db699107c$export$9a216cca07bece15)(fieldName, '');
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                variant: "outlined",
                fullWidth: true,
                className: Boolean(errors[fieldName]) ? myClasses.hasError : '',
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                        id: labelId,
                        children: inputLabel
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                        labelId: labelId2,
                        id: selectId,
                        value: value,
                        onChange: (event, data)=>handleChange(data.props),
                        label: inputLabel,
                        error: touched && Boolean(errors[fieldName]),
                        multiple: multiple,
                        children: dataList.map((rec)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                value: rec.id,
                                children: rec.name
                            }, rec.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                className: myClasses.errorText,
                children: errors[fieldName]
            })
        ]
    });
};
var $531892a6884f10c9$export$2e2bcd8739ae039 = $531892a6884f10c9$var$IyoFormikDropDownLegacy;




const $9bb29106c9ca5483$var$HOST_URL = (0, $a9106d6db699107c$export$1811237fdf5ac5d)('hostUrl');
const $9bb29106c9ca5483$var$getOneById = async (providerTypeId)=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$9bb29106c9ca5483$var$HOST_URL}/consumer-type/${providerTypeId}`)).data;
};
const $9bb29106c9ca5483$var$getAll = async ()=>{
    return (await (0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).get(`${$9bb29106c9ca5483$var$HOST_URL}/consumer-type`)).data;
};
var $9bb29106c9ca5483$export$2e2bcd8739ae039 = {
    getOneById: $9bb29106c9ca5483$var$getOneById,
    getAll: $9bb29106c9ca5483$var$getAll
};



const $fb380b23fba58d59$var$ConsumerEditDialog = (props)=>{
    // ####################[ Query Definitions ]####################
    const getConsumerTypes = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getConsumerTypes', async ()=>{
        return await (0, $9bb29106c9ca5483$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            props.handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    // ####################[ Event Handlers ]####################
    const handleClose = ()=>{
        props.setOpen(false);
    };
    const handleConsumerTypeSelect = (selection, values, resetForm)=>{
        props.setConsumerTypeId(selection.value);
        const newFields = getConsumerTypeProperties(selection.value);
        resetForm({
            values: (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                name: values.name,
                description: values.description,
                consumer_type_id: selection.value
            }, prettifyProperties(newFields))
        });
    };
    const validate = async (values)=>{
        const fields = getConsumerTypeProperties(props.consumerTypeId);
        const validationObject = generateValidationSchema(fields);
        let errors = {};
        for(let field in validationObject)try {
            await validationObject[field].validate(values[field]);
        } catch (err) {
            errors[field] = err.errors[0];
        }
        return errors;
    };
    // ####################[ Helper Functions ]####################
    const generateValidationSchema = (fields)=>{
        let schemaObject = {
            name: $7a974168aa28ad85$export$185802fd694ee1f5().required('Required')
        }; // A starting point; name always required
        if (!fields) return schemaObject;
        for (let field of fields)if (field.required) schemaObject[field.name] = $7a974168aa28ad85$export$185802fd694ee1f5().required('Required');
        return schemaObject;
    };
    const getConsumerTypeProperties = (consumerTypeId)=>{
        var _getConsumerTypes_data_find, _props_rowEditing;
        if (!getConsumerTypes.data || !consumerTypeId) return [];
        // Retrieve the full list of properties from the selected (via the dropdown) provider type's schema.
        // These define the text fields that will be added to the form.
        // An id with no matching type - or one whose type carries no schema - yields no fields
        // rather than taking the dialog down.
        const consumerTypeSchema = (_getConsumerTypes_data_find = getConsumerTypes.data.find((consumerType)=>consumerType.id === consumerTypeId)) === null || _getConsumerTypes_data_find === void 0 ? void 0 : _getConsumerTypes_data_find.schema;
        if (!(consumerTypeSchema === null || consumerTypeSchema === void 0 ? void 0 : consumerTypeSchema.properties)) return [];
        const allProperties = Object.keys(consumerTypeSchema.properties);
        // Retrieve the actual properties from the provider being edited.
        // These will be the values that fill in the text fields created above.
        const currentProperties = ((_props_rowEditing = props.rowEditing) === null || _props_rowEditing === void 0 ? void 0 : _props_rowEditing.properties) ? props.rowEditing.properties : {};
        // Return a merged form of the above two.
        // Values are only filled in if the provider type of the provider being edited and the selected (dropdown) provider type are the same.
        return allProperties.map((prop)=>{
            var _props_rowEditing, _consumerTypeSchema_required;
            return {
                name: prop,
                value: ((_props_rowEditing = props.rowEditing) === null || _props_rowEditing === void 0 ? void 0 : _props_rowEditing.consumer_type_id) === consumerTypeId ? currentProperties[prop] : null,
                required: ((_consumerTypeSchema_required = consumerTypeSchema.required) === null || _consumerTypeSchema_required === void 0 ? void 0 : _consumerTypeSchema_required.includes(prop)) === true
            };
        });
    };
    const prettifyProperties = (properties)=>{
        if (!properties) return null;
        let newFields = {};
        for (let field of properties)Object.defineProperty(newFields, field.name, {
            value: field.value ? field.value : '',
            enumerable: true
        });
        return newFields;
    };
    const setInitialValues = ()=>{
        var _props_rowEditing, _props_rowEditing1, _props_rowEditing2, _props_rowEditing3;
        const initialFields = getConsumerTypeProperties((_props_rowEditing = props.rowEditing) === null || _props_rowEditing === void 0 ? void 0 : _props_rowEditing.consumer_type_id);
        return (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            name: ((_props_rowEditing1 = props.rowEditing) === null || _props_rowEditing1 === void 0 ? void 0 : _props_rowEditing1.name) ? props.rowEditing.name : '',
            description: ((_props_rowEditing2 = props.rowEditing) === null || _props_rowEditing2 === void 0 ? void 0 : _props_rowEditing2.description) ? props.rowEditing.description : '',
            consumer_type_id: ((_props_rowEditing3 = props.rowEditing) === null || _props_rowEditing3 === void 0 ? void 0 : _props_rowEditing3.consumer_type_id) ? props.rowEditing.consumer_type_id : ''
        }, prettifyProperties(initialFields));
    };
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: props.open,
        onClose: handleClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: props.mode === 'edit' ? `Edit Consumer ${props.rowEditing.id}` : props.mode === 'create' ? 'Create Consumer' : ''
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                initialValues: setInitialValues(),
                validate: (values)=>validate(values),
                onSubmit: props.mode === 'edit' ? (values)=>props.handleEditSubmit(values) : props.mode === 'create' ? (values)=>props.handleCreateSubmit(values) : ()=>{},
                children: ({ errors: errors, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting, resetForm: resetForm, touched: touched, values: values })=>/*#__PURE__*/ (0, $4uaIU.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                            style: {
                                margin: '2%'
                            },
                            children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                            title: "Consumer",
                                            description: "What this consumer is called, and what kind it is.",
                                            children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                container: true,
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                            name: "name",
                                                            label: "Name",
                                                            value: values.name,
                                                            error: Boolean(touched.name && errors.name),
                                                            helperText: touched.name && errors.name,
                                                            fullWidth: true,
                                                            onBlur: handleBlur,
                                                            onChange: handleChange,
                                                            variant: "outlined"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                            name: "description",
                                                            label: "Description",
                                                            value: values.description,
                                                            error: Boolean(touched.description && errors.description),
                                                            helperText: touched.description && errors.description,
                                                            fullWidth: true,
                                                            onBlur: handleBlur,
                                                            onChange: handleChange,
                                                            variant: "outlined"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $531892a6884f10c9$export$2e2bcd8739ae039), {
                                                            fieldName: "consumer_type_id",
                                                            dataList: getConsumerTypes.data ? getConsumerTypes.data : [],
                                                            value: props.consumerTypeId ? props.consumerTypeId : '',
                                                            errors: errors,
                                                            touched: touched,
                                                            handleChange: (selection)=>handleConsumerTypeSelect(selection, values, resetForm)
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    Boolean(getConsumerTypeProperties(props.consumerTypeId).length) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                            title: "Type settings",
                                            description: "How this consumer is reached.",
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                container: true,
                                                spacing: 2,
                                                children: getConsumerTypeProperties(props.consumerTypeId).map((field)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                            name: field.name,
                                                            label: field.name,
                                                            value: values[field.name],
                                                            error: Boolean(touched[field.name] && errors[field.name]),
                                                            helperText: touched[field.name] && errors[field.name],
                                                            fullWidth: true,
                                                            onBlur: handleBlur,
                                                            onChange: handleChange,
                                                            variant: "outlined"
                                                        })
                                                    }, field.name))
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                                                sx: {
                                                    mb: 2
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                disabled: isSubmitting,
                                                onClick: handleClose,
                                                size: "large",
                                                type: "button",
                                                variant: "outlined",
                                                sx: {
                                                    mr: 1
                                                },
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                disabled: isSubmitting,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Save"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
            })
        ]
    });
};
var $fb380b23fba58d59$export$2e2bcd8739ae039 = $fb380b23fba58d59$var$ConsumerEditDialog;







const $02eba4d472160af6$var$minWidthDefault = 200;
const $02eba4d472160af6$export$53b3c91859018cd4 = [
    {
        field: 'id',
        headerName: 'ID',
        description: 'Owner ID',
        minWidth: 75
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'Name',
        minWidth: $02eba4d472160af6$var$minWidthDefault
    },
    {
        field: 'description',
        headerName: 'Description',
        description: 'Description',
        minWidth: 400
    },
    {
        field: 'consumer_type_id',
        headerName: 'Description',
        description: 'Description',
        minWidth: 200
    },
    {
        field: 'consumer_type_name',
        headerName: 'Consumer Type Name',
        description: 'Consumer Type Name',
        minWidth: 300
    },
    {
        field: 'consumer_type_description',
        headerName: 'Consumer Type Description',
        description: 'Consumer Type Description',
        minWidth: $02eba4d472160af6$var$minWidthDefault
    },
    {
        field: 'created_by',
        headerName: 'Created By',
        description: 'Created By',
        minWidth: 175
    },
    {
        field: 'created_datetime',
        headerName: 'Created Datetime',
        description: 'Created Datetime',
        minWidth: 225
    },
    {
        field: 'updated_by',
        headerName: 'Updated By',
        description: 'Updated By',
        minWidth: 175
    },
    {
        field: 'updated_datetime',
        headerName: 'Updated Datetime',
        description: 'Updated Datetime',
        minWidth: 225
    }
];




const $2960e797fe11f00b$var$Consumers = ({})=>{
    // ####################[ Setup and Initialization ]####################
    const consumer_fields = [
        'id',
        'name',
        'description',
        'consumer_type_id',
        'created_by',
        'updated_by'
    ];
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const initializeColumns = (initialColumns)=>{
        return initialColumns.concat({
            field: 'actions',
            headerName: 'Actions',
            description: 'Actions',
            minWidth: 175,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Edit",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleEdit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6be52b93098825b$exports))), {})
                            })
                        }),
                        "\xa0",
                        params.row.disabled ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Enable",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "secondary",
                                onClick: (event)=>handleDisableSubmit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b096330a1aa10551$exports))), {})
                            })
                        }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "Disable",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleDisableSubmit(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9763220a10bead63$exports))), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: "View Properties",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: (event)=>handleDialogOpen(event, params.row),
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0eefa11e679f91b4$exports))), {})
                            })
                        })
                    ]
                });
            }
        });
    };
    // ####################[ State Definitions ]####################
    const [cols, setCols] = (0, $jSIPP.useState)(initializeColumns((0, $02eba4d472160af6$export$53b3c91859018cd4)));
    const [scrollableDialogOpen, setScrollableDialogOpen] = (0, $jSIPP.useState)(false);
    const [scrollableDialogData, setScrollableDialogData] = (0, $jSIPP.useState)(null);
    const [editOpen, setEditOpen] = (0, $jSIPP.useState)(false);
    const [rowEditing, setRowEditing] = (0, $jSIPP.useState)([]);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [editMode, setEditMode] = (0, $jSIPP.useState)('');
    const [consumerTypeId, setConsumerTypeId] = (0, $jSIPP.useState)(null);
    // ####################[ Query Definitions ]####################
    const getConsumers = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getConsumers', async ()=>{
        return await (0, $6ea4f0a608034787$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const postConsumer = (0, $74568c0a766c827d$export$609860bf8b0084c)('postConsumer', async (data)=>{
        return await (0, $6ea4f0a608034787$export$2e2bcd8739ae039).post(data);
    }, {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries('getConsumers');
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    const putConsumer = (0, $74568c0a766c827d$export$609860bf8b0084c)('putConsumer', async (data)=>{
        return await (0, $6ea4f0a608034787$export$2e2bcd8739ae039).put(rowEditing.id, data);
    }, {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries('getConsumers');
        },
        onError: (error)=>{
            handleError(error);
        }
    });
    // ####################[ Event Handlers ]####################
    const handleDialogOpen = async (event, row)=>{
        setScrollableDialogData(JSON.stringify(row.properties, undefined, 2));
        setScrollableDialogOpen(true);
    };
    const handleDialogClose = ()=>{
        setScrollableDialogOpen(false);
    };
    const handleCreate = async (event, row)=>{
        setEditMode('create');
        setRowEditing([]);
        setConsumerTypeId(null);
        setEditOpen(true);
    };
    const handleCreateSubmit = async (values)=>{
        let body = {
            properties: {}
        };
        for (const [key, value] of Object.entries(values))if (consumer_fields.includes(key)) body[key] = value;
        else body.properties[key] = value;
        postConsumer.mutate((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, body), {
            created_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser(),
            updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        }));
        setEditOpen(false);
    };
    const handleDisableSubmit = async (event, row)=>{
        console.info(`${row.disabled ? 'Enabling' : 'Disabling'} consumer ${row.id}`);
        setRowEditing(row);
        const body = {
            id: row.id,
            disabled: row.disabled ? 0 : 1,
            updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        };
        putConsumer.mutate(body);
    };
    const handleEdit = async (event, row)=>{
        setEditMode('edit');
        setRowEditing(row);
        setConsumerTypeId(row.consumer_type_id);
        setEditOpen(true);
    };
    // Arriving from the home page search as /consumers?id=9 opens that consumer.
    (0, $fa76533b6a84f8f4$export$2e2bcd8739ae039)(getConsumers.data, (row)=>handleEdit(null, row));
    const handleEditSubmit = async (values)=>{
        let body = {
            properties: {}
        };
        for(let field in values)if (values[field] !== rowEditing[field]) {
            if (consumer_fields.includes(field)) body[field] = values[field];
            else body.properties[field] = values[field];
        }
        body['consumer_type_id'] = values.consumer_type_id;
        body['updated_by'] = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
        body['id'] = rowEditing.id;
        putConsumer.mutate(body);
        setEditOpen(false);
    };
    const handleError = (error)=>{
        setErrorOpen(false);
        setErrDisplayText(`${error.message}: ${JSON.stringify(error.response.data)}`);
        setErrorOpen(true);
        console.error(`${error.message}: ${JSON.stringify(error.response.data)}`);
    };
    const refreshTable = async ()=>{
        console.info('Refreshing table');
        await queryClient.invalidateQueries('getConsumers');
    };
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Consumers",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                        editHandler: handleCreate,
                        onRefresh: refreshTable
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '77vh',
                            '& .disabled': {
                                color: '#94A3B8'
                            }
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: getConsumers.data || [],
                            getRowClassName: (params)=>params.row.disabled ? 'disabled' : '',
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                            },
                            loading: getConsumers.isLoading,
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        consumer_type_id: false,
                                        consumer_type_description: false,
                                        created_by: false,
                                        created_datetime: false,
                                        updated_by: false,
                                        updated_datetime: false
                                    }
                                }
                            },
                            density: "compact"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $fb380b23fba58d59$export$2e2bcd8739ae039), {
                type: "edit",
                open: editOpen,
                setOpen: setEditOpen,
                rowEditing: rowEditing,
                mode: editMode,
                consumerTypeId: consumerTypeId,
                setConsumerTypeId: setConsumerTypeId,
                handleEditSubmit: handleEditSubmit,
                handleCreateSubmit: handleCreateSubmit,
                handleError: handleError
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2709e525dda8b54c$export$2e2bcd8739ae039), {
                open: scrollableDialogOpen,
                setOpen: setScrollableDialogOpen,
                close: handleDialogClose,
                content: scrollableDialogData,
                scroll: 'paper'
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $2960e797fe11f00b$export$2e2bcd8739ae039 = $2960e797fe11f00b$var$Consumers;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");







var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $ghfJh = parcelRequire("ghfJh");


var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


var $99b438cd66ce7356$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $99b438cd66ce7356$exports = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 949: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CronParser = void 0;
                var rangeValidator_1 = __webpack_require__(515);
                var CronParser = function() {
                    function CronParser(expression, dayOfWeekStartIndexZero, monthStartIndexZero) {
                        if (dayOfWeekStartIndexZero === void 0) dayOfWeekStartIndexZero = true;
                        if (monthStartIndexZero === void 0) monthStartIndexZero = false;
                        this.expression = expression;
                        this.dayOfWeekStartIndexZero = dayOfWeekStartIndexZero;
                        this.monthStartIndexZero = monthStartIndexZero;
                    }
                    CronParser.prototype.parse = function() {
                        var _a;
                        var parsed;
                        var expression = (_a = this.expression) !== null && _a !== void 0 ? _a : '';
                        if (expression === "@reboot") {
                            parsed = [
                                "@reboot",
                                "",
                                "",
                                "",
                                "",
                                "",
                                ""
                            ];
                            return parsed;
                        } else if (expression.startsWith('@')) {
                            var special = this.parseSpecial(this.expression);
                            parsed = this.extractParts(special);
                        } else parsed = this.extractParts(this.expression);
                        this.normalize(parsed);
                        this.validate(parsed);
                        return parsed;
                    };
                    CronParser.prototype.parseSpecial = function(expression) {
                        var specialExpressions = {
                            '@yearly': '0 0 1 1 *',
                            '@annually': '0 0 1 1 *',
                            '@monthly': '0 0 1 * *',
                            '@weekly': '0 0 * * 0',
                            '@daily': '0 0 * * *',
                            '@midnight': '0 0 * * *',
                            '@hourly': '0 * * * *',
                            '@reboot': '@reboot'
                        };
                        var special = specialExpressions[expression];
                        if (!special) throw new Error('Unknown special expression.');
                        return special;
                    };
                    CronParser.prototype.extractParts = function(expression) {
                        if (!this.expression) throw new Error("cron expression is empty");
                        var parsed = expression.trim().split(/[ ]+/);
                        for(var i = 0; i < parsed.length; i++)if (parsed[i].includes(",")) {
                            var arrayElement = parsed[i].split(",").map(function(item) {
                                return item.trim();
                            }).filter(function(item) {
                                return item !== "";
                            }).map(function(item) {
                                return !isNaN(Number(item)) ? Number(item) : item;
                            }).filter(function(item) {
                                return item !== null && item !== "";
                            });
                            if (arrayElement.length === 0) arrayElement.push("*");
                            arrayElement.sort(function(a, b) {
                                return a !== null && b !== null ? a - b : 0;
                            });
                            parsed[i] = arrayElement.map(function(item) {
                                return item !== null ? item.toString() : "";
                            }).join(",");
                        }
                        if (parsed.length < 5) throw new Error("Expression has only ".concat(parsed.length, " part").concat(parsed.length == 1 ? "" : "s", ". At least 5 parts are required."));
                        else if (parsed.length == 5) {
                            parsed.unshift("");
                            parsed.push("");
                        } else if (parsed.length == 6) {
                            var isYearWithNoSecondsPart = /\d{4}$/.test(parsed[5]) || parsed[4] == "?" || parsed[2] == "?";
                            if (isYearWithNoSecondsPart) parsed.unshift("");
                            else parsed.push("");
                        } else if (parsed.length > 7) throw new Error("Expression has ".concat(parsed.length, " parts; too many!"));
                        return parsed;
                    };
                    CronParser.prototype.normalize = function(expressionParts) {
                        var _this = this;
                        expressionParts[3] = expressionParts[3].replace("?", "*");
                        expressionParts[5] = expressionParts[5].replace("?", "*");
                        expressionParts[2] = expressionParts[2].replace("?", "*");
                        if (expressionParts[0].indexOf("0/") == 0) expressionParts[0] = expressionParts[0].replace("0/", "*/");
                        if (expressionParts[1].indexOf("0/") == 0) expressionParts[1] = expressionParts[1].replace("0/", "*/");
                        if (expressionParts[2].indexOf("0/") == 0) expressionParts[2] = expressionParts[2].replace("0/", "*/");
                        if (expressionParts[3].indexOf("1/") == 0) expressionParts[3] = expressionParts[3].replace("1/", "*/");
                        if (expressionParts[4].indexOf("1/") == 0) expressionParts[4] = expressionParts[4].replace("1/", "*/");
                        if (expressionParts[6].indexOf("1/") == 0) expressionParts[6] = expressionParts[6].replace("1/", "*/");
                        expressionParts[5] = expressionParts[5].replace(/(^\d)|([^#/\s]\d)/g, function(t) {
                            var dowDigits = t.replace(/\D/, "");
                            var dowDigitsAdjusted = dowDigits;
                            if (_this.dayOfWeekStartIndexZero) {
                                if (dowDigits == "7") dowDigitsAdjusted = "0";
                            } else dowDigitsAdjusted = (parseInt(dowDigits) - 1).toString();
                            return t.replace(dowDigits, dowDigitsAdjusted);
                        });
                        if (expressionParts[5] == "L") expressionParts[5] = "6";
                        if (expressionParts[3] == "?") expressionParts[3] = "*";
                        if (expressionParts[3].indexOf("W") > -1 && (expressionParts[3].indexOf(",") > -1 || expressionParts[3].indexOf("-") > -1)) throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
                        var days = {
                            SUN: 0,
                            MON: 1,
                            TUE: 2,
                            WED: 3,
                            THU: 4,
                            FRI: 5,
                            SAT: 6
                        };
                        for(var day in days)expressionParts[5] = expressionParts[5].replace(new RegExp(day, "gi"), days[day].toString());
                        expressionParts[4] = expressionParts[4].replace(/(^\d{1,2})|([^#/\s]\d{1,2})/g, function(t) {
                            var dowDigits = t.replace(/\D/, "");
                            var dowDigitsAdjusted = dowDigits;
                            if (_this.monthStartIndexZero) dowDigitsAdjusted = (parseInt(dowDigits) + 1).toString();
                            return t.replace(dowDigits, dowDigitsAdjusted);
                        });
                        var months = {
                            JAN: 1,
                            FEB: 2,
                            MAR: 3,
                            APR: 4,
                            MAY: 5,
                            JUN: 6,
                            JUL: 7,
                            AUG: 8,
                            SEP: 9,
                            OCT: 10,
                            NOV: 11,
                            DEC: 12
                        };
                        for(var month in months)expressionParts[4] = expressionParts[4].replace(new RegExp(month, "gi"), months[month].toString());
                        if (expressionParts[0] == "0") expressionParts[0] = "";
                        if (!/\*|\-|\,|\//.test(expressionParts[2]) && (/\*|\//.test(expressionParts[1]) || /\*|\//.test(expressionParts[0]))) expressionParts[2] += "-".concat(expressionParts[2]);
                        for(var i = 0; i < expressionParts.length; i++){
                            if (expressionParts[i].indexOf(",") != -1) expressionParts[i] = expressionParts[i].split(",").filter(function(str) {
                                return str !== "";
                            }).join(",") || "*";
                            if (expressionParts[i] == "*/1") expressionParts[i] = "*";
                            if (expressionParts[i].indexOf("/") > -1 && !/^\*|\-|\,/.test(expressionParts[i])) {
                                var stepRangeThrough = null;
                                switch(i){
                                    case 4:
                                        stepRangeThrough = "12";
                                        break;
                                    case 5:
                                        stepRangeThrough = "6";
                                        break;
                                    case 6:
                                        stepRangeThrough = "9999";
                                        break;
                                    default:
                                        stepRangeThrough = null;
                                        break;
                                }
                                if (stepRangeThrough !== null) {
                                    var parts = expressionParts[i].split("/");
                                    expressionParts[i] = "".concat(parts[0], "-").concat(stepRangeThrough, "/").concat(parts[1]);
                                }
                            }
                        }
                    };
                    CronParser.prototype.validate = function(parsed) {
                        var standardCronPartCharacters = "0-9,\\-*\/";
                        this.validateOnlyExpectedCharactersFound(parsed[0], standardCronPartCharacters);
                        this.validateOnlyExpectedCharactersFound(parsed[1], standardCronPartCharacters);
                        this.validateOnlyExpectedCharactersFound(parsed[2], standardCronPartCharacters);
                        this.validateOnlyExpectedCharactersFound(parsed[3], "0-9,\\-*\/LW");
                        this.validateOnlyExpectedCharactersFound(parsed[4], standardCronPartCharacters);
                        this.validateOnlyExpectedCharactersFound(parsed[5], "0-9,\\-*\/L#");
                        this.validateOnlyExpectedCharactersFound(parsed[6], standardCronPartCharacters);
                        this.validateAnyRanges(parsed);
                    };
                    CronParser.prototype.validateAnyRanges = function(parsed) {
                        rangeValidator_1.default.secondRange(parsed[0]);
                        rangeValidator_1.default.minuteRange(parsed[1]);
                        rangeValidator_1.default.hourRange(parsed[2]);
                        rangeValidator_1.default.dayOfMonthRange(parsed[3]);
                        rangeValidator_1.default.monthRange(parsed[4], this.monthStartIndexZero);
                        rangeValidator_1.default.dayOfWeekRange(parsed[5], this.dayOfWeekStartIndexZero);
                    };
                    CronParser.prototype.validateOnlyExpectedCharactersFound = function(cronPart, allowedCharsExpression) {
                        var invalidChars = cronPart.match(new RegExp("[^".concat(allowedCharsExpression, "]+"), "gi"));
                        if (invalidChars && invalidChars.length) throw new Error("Expression contains invalid values: '".concat(invalidChars.toString(), "'"));
                    };
                    return CronParser;
                }();
                exports.CronParser = CronParser;
            /***/ },
            /***/ 333: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ExpressionDescriptor = void 0;
                var stringUtilities_1 = __webpack_require__(823);
                var cronParser_1 = __webpack_require__(949);
                var ExpressionDescriptor = function() {
                    function ExpressionDescriptor(expression, options) {
                        this.expression = expression;
                        this.options = options;
                        this.expressionParts = new Array(5);
                        if (!this.options.locale && ExpressionDescriptor.defaultLocale) this.options.locale = ExpressionDescriptor.defaultLocale;
                        if (!ExpressionDescriptor.locales[this.options.locale]) {
                            var fallBackLocale = Object.keys(ExpressionDescriptor.locales)[0];
                            console.warn("Locale '".concat(this.options.locale, "' could not be found; falling back to '").concat(fallBackLocale, "'."));
                            this.options.locale = fallBackLocale;
                        }
                        this.i18n = ExpressionDescriptor.locales[this.options.locale];
                        if (options.use24HourTimeFormat === undefined) options.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault();
                    }
                    ExpressionDescriptor.toString = function(expression, _a) {
                        var _b = _a === void 0 ? {} : _a, _c = _b.throwExceptionOnParseError, throwExceptionOnParseError = _c === void 0 ? true : _c, _d = _b.verbose, verbose = _d === void 0 ? false : _d, _e = _b.dayOfWeekStartIndexZero, dayOfWeekStartIndexZero = _e === void 0 ? true : _e, _f = _b.monthStartIndexZero, monthStartIndexZero = _f === void 0 ? false : _f, use24HourTimeFormat = _b.use24HourTimeFormat, _g = _b.locale, locale = _g === void 0 ? null : _g;
                        var options = {
                            throwExceptionOnParseError: throwExceptionOnParseError,
                            verbose: verbose,
                            dayOfWeekStartIndexZero: dayOfWeekStartIndexZero,
                            monthStartIndexZero: monthStartIndexZero,
                            use24HourTimeFormat: use24HourTimeFormat,
                            locale: locale
                        };
                        if (options.tzOffset) console.warn("'tzOffset' option has been deprecated and is no longer supported.");
                        var descripter = new ExpressionDescriptor(expression, options);
                        return descripter.getFullDescription();
                    };
                    ExpressionDescriptor.initialize = function(localesLoader, defaultLocale) {
                        if (defaultLocale === void 0) defaultLocale = "en";
                        ExpressionDescriptor.specialCharacters = [
                            "/",
                            "-",
                            ",",
                            "*"
                        ];
                        ExpressionDescriptor.defaultLocale = defaultLocale;
                        localesLoader.load(ExpressionDescriptor.locales);
                    };
                    ExpressionDescriptor.prototype.getFullDescription = function() {
                        var _a, _b;
                        var description = "";
                        try {
                            var parser = new cronParser_1.CronParser(this.expression, this.options.dayOfWeekStartIndexZero, this.options.monthStartIndexZero);
                            this.expressionParts = parser.parse();
                            if (this.expressionParts[0] === "@reboot") return ((_b = (_a = this.i18n).atReboot) === null || _b === void 0 ? void 0 : _b.call(_a)) || "Run once, at startup";
                            var timeSegment = this.getTimeOfDayDescription();
                            var dayOfMonthDesc = this.getDayOfMonthDescription();
                            var monthDesc = this.getMonthDescription();
                            var dayOfWeekDesc = this.getDayOfWeekDescription();
                            var yearDesc = this.getYearDescription();
                            description += timeSegment + dayOfMonthDesc + dayOfWeekDesc + monthDesc + yearDesc;
                            description = this.transformVerbosity(description, !!this.options.verbose);
                            description = description.charAt(0).toLocaleUpperCase() + description.substr(1);
                        } catch (ex) {
                            if (!this.options.throwExceptionOnParseError) description = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
                            else throw "".concat(ex);
                        }
                        return description;
                    };
                    ExpressionDescriptor.prototype.getTimeOfDayDescription = function() {
                        var secondsExpression = this.expressionParts[0];
                        var minuteExpression = this.expressionParts[1];
                        var hourExpression = this.expressionParts[2];
                        var description = "";
                        if (!stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters) && !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters) && !stringUtilities_1.StringUtilities.containsAny(secondsExpression, ExpressionDescriptor.specialCharacters)) description += this.i18n.atSpace() + this.formatTime(hourExpression, minuteExpression, secondsExpression);
                        else if (!secondsExpression && minuteExpression.indexOf("-") > -1 && !(minuteExpression.indexOf(",") > -1) && !(minuteExpression.indexOf("/") > -1) && !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters)) {
                            var minuteParts = minuteExpression.split("-");
                            description += stringUtilities_1.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(hourExpression, minuteParts[0], ""), this.formatTime(hourExpression, minuteParts[1], ""));
                        } else if (!secondsExpression && hourExpression.indexOf(",") > -1 && hourExpression.indexOf("-") == -1 && hourExpression.indexOf("/") == -1 && !stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters)) {
                            var hourParts = hourExpression.split(",");
                            description += this.i18n.at();
                            for(var i = 0; i < hourParts.length; i++){
                                description += " ";
                                description += this.formatTime(hourParts[i], minuteExpression, "");
                                if (i < hourParts.length - 2) description += ",";
                                if (i == hourParts.length - 2) description += this.i18n.spaceAnd();
                            }
                        } else {
                            var secondsDescription = this.getSecondsDescription();
                            var minutesDescription = this.getMinutesDescription();
                            var hoursDescription = this.getHoursDescription();
                            description += secondsDescription;
                            if (description && minutesDescription) description += ", ";
                            description += minutesDescription;
                            if (minutesDescription === hoursDescription) return description;
                            if (description && hoursDescription) description += ", ";
                            description += hoursDescription;
                        }
                        return description;
                    };
                    ExpressionDescriptor.prototype.getSecondsDescription = function() {
                        var _this = this;
                        var description = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function(s) {
                            return s;
                        }, function(s) {
                            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Seconds(s), s);
                        }, function(s) {
                            return _this.i18n.secondsX0ThroughX1PastTheMinute();
                        }, function(s) {
                            return s == "0" ? "" : parseInt(s) < 20 ? _this.i18n.atX0SecondsPastTheMinute(s) : _this.i18n.atX0SecondsPastTheMinuteGt20() || _this.i18n.atX0SecondsPastTheMinute(s);
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getMinutesDescription = function() {
                        var _this = this;
                        var secondsExpression = this.expressionParts[0];
                        var hourExpression = this.expressionParts[2];
                        var description = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function(s) {
                            return s;
                        }, function(s) {
                            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Minutes(s), s);
                        }, function(s) {
                            return _this.i18n.minutesX0ThroughX1PastTheHour();
                        }, function(s) {
                            try {
                                return s == "0" && hourExpression.indexOf("/") == -1 && secondsExpression == "" ? _this.i18n.everyHour() : parseInt(s) < 20 ? _this.i18n.atX0MinutesPastTheHour(s) : _this.i18n.atX0MinutesPastTheHourGt20() || _this.i18n.atX0MinutesPastTheHour(s);
                            } catch (e) {
                                return _this.i18n.atX0MinutesPastTheHour(s);
                            }
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getHoursDescription = function() {
                        var _this = this;
                        var expression = this.expressionParts[2];
                        var hourIndex = 0;
                        var rangeEndValues = [];
                        expression.split("/")[0].split(",").forEach(function(range) {
                            var rangeParts = range.split("-");
                            if (rangeParts.length === 2) rangeEndValues.push({
                                value: rangeParts[1],
                                index: hourIndex + 1
                            });
                            hourIndex += rangeParts.length;
                        });
                        var evaluationIndex = 0;
                        var description = this.getSegmentDescription(expression, this.i18n.everyHour(), function(s) {
                            var match = rangeEndValues.find(function(r) {
                                return r.value === s && r.index === evaluationIndex;
                            });
                            var isRangeEndWithNonZeroMinute = match && _this.expressionParts[1] !== "0";
                            evaluationIndex++;
                            return isRangeEndWithNonZeroMinute ? _this.formatTime(s, "59", "") : _this.formatTime(s, "0", "");
                        }, function(s) {
                            return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Hours(s), s);
                        }, function(s) {
                            return _this.i18n.betweenX0AndX1();
                        }, function(s) {
                            return _this.i18n.atX0();
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getDayOfWeekDescription = function() {
                        var _this = this;
                        var daysOfWeekNames = this.i18n.daysOfTheWeek();
                        var description = null;
                        if (this.expressionParts[5] == "*") description = "";
                        else description = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function(s, form) {
                            var exp = s;
                            if (s.indexOf("#") > -1) exp = s.substring(0, s.indexOf("#"));
                            else if (s.indexOf("L") > -1) exp = exp.replace("L", "");
                            var parsedExp = parseInt(exp);
                            var description = _this.i18n.daysOfTheWeekInCase ? _this.i18n.daysOfTheWeekInCase(form)[parsedExp] : daysOfWeekNames[parsedExp];
                            if (s.indexOf("#") > -1) {
                                var dayOfWeekOfMonthDescription = null;
                                var dayOfWeekOfMonthNumber = s.substring(s.indexOf("#") + 1);
                                var dayOfWeekNumber = s.substring(0, s.indexOf("#"));
                                switch(dayOfWeekOfMonthNumber){
                                    case "1":
                                        dayOfWeekOfMonthDescription = _this.i18n.first(dayOfWeekNumber);
                                        break;
                                    case "2":
                                        dayOfWeekOfMonthDescription = _this.i18n.second(dayOfWeekNumber);
                                        break;
                                    case "3":
                                        dayOfWeekOfMonthDescription = _this.i18n.third(dayOfWeekNumber);
                                        break;
                                    case "4":
                                        dayOfWeekOfMonthDescription = _this.i18n.fourth(dayOfWeekNumber);
                                        break;
                                    case "5":
                                        dayOfWeekOfMonthDescription = _this.i18n.fifth(dayOfWeekNumber);
                                        break;
                                }
                                description = dayOfWeekOfMonthDescription + " " + description;
                            }
                            return description;
                        }, function(s) {
                            if (parseInt(s) == 1) return "";
                            else return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0DaysOfTheWeek(s), s);
                        }, function(s) {
                            var beginFrom = s.substring(0, s.indexOf("-"));
                            var domSpecified = _this.expressionParts[3] != "*";
                            return domSpecified ? _this.i18n.commaAndX0ThroughX1(beginFrom) : _this.i18n.commaX0ThroughX1(beginFrom);
                        }, function(s) {
                            var format = null;
                            if (s.indexOf("#") > -1) {
                                var dayOfWeekOfMonthNumber = s.substring(s.indexOf("#") + 1);
                                var dayOfWeek = s.substring(0, s.indexOf("#"));
                                format = _this.i18n.commaOnThe(dayOfWeekOfMonthNumber, dayOfWeek).trim() + _this.i18n.spaceX0OfTheMonth();
                            } else if (s.indexOf("L") > -1) format = _this.i18n.commaOnTheLastX0OfTheMonth(s.replace("L", ""));
                            else {
                                var domSpecified = _this.expressionParts[3] != "*";
                                format = domSpecified ? _this.i18n.commaAndOnX0() : _this.i18n.commaOnlyOnX0(s);
                            }
                            return format;
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getMonthDescription = function() {
                        var _this = this;
                        var monthNames = this.i18n.monthsOfTheYear();
                        var description = this.getSegmentDescription(this.expressionParts[4], "", function(s, form) {
                            return form && _this.i18n.monthsOfTheYearInCase ? _this.i18n.monthsOfTheYearInCase(form)[parseInt(s) - 1] : monthNames[parseInt(s) - 1];
                        }, function(s) {
                            if (parseInt(s) == 1) return "";
                            else return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Months(s), s);
                        }, function(s) {
                            return _this.i18n.commaMonthX0ThroughMonthX1() || _this.i18n.commaX0ThroughX1();
                        }, function(s) {
                            return _this.i18n.commaOnlyInMonthX0 ? _this.i18n.commaOnlyInMonthX0() : _this.i18n.commaOnlyInX0();
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getDayOfMonthDescription = function() {
                        var _this = this;
                        var description = null;
                        var expression = this.expressionParts[3];
                        switch(expression){
                            case "L":
                                description = this.i18n.commaOnTheLastDayOfTheMonth();
                                break;
                            case "WL":
                            case "LW":
                                description = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                                break;
                            default:
                                var weekDayNumberMatches = expression.match(/(\d{1,2}W)|(W\d{1,2})/);
                                if (weekDayNumberMatches) {
                                    var dayNumber = parseInt(weekDayNumberMatches[0].replace("W", ""));
                                    var dayString = dayNumber == 1 ? this.i18n.firstWeekday() : stringUtilities_1.StringUtilities.format(this.i18n.weekdayNearestDayX0(), dayNumber.toString());
                                    description = stringUtilities_1.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), dayString);
                                    break;
                                } else {
                                    var lastDayOffSetMatches = expression.match(/L-(\d{1,2})/);
                                    if (lastDayOffSetMatches) {
                                        var offSetDays = lastDayOffSetMatches[1];
                                        description = stringUtilities_1.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(offSetDays), offSetDays);
                                        break;
                                    } else if (expression == "*" && this.expressionParts[5] != "*") return "";
                                    else description = this.getSegmentDescription(expression, this.i18n.commaEveryDay(), function(s) {
                                        return s == "L" ? _this.i18n.lastDay() : _this.i18n.dayX0 ? stringUtilities_1.StringUtilities.format(_this.i18n.dayX0(), s) : s;
                                    }, function(s) {
                                        return s == "1" ? _this.i18n.commaEveryDay() : _this.i18n.commaEveryX0Days(s);
                                    }, function(s) {
                                        return _this.i18n.commaBetweenDayX0AndX1OfTheMonth(s);
                                    }, function(s) {
                                        return _this.i18n.commaOnDayX0OfTheMonth(s);
                                    });
                                    break;
                                }
                        }
                        return description;
                    };
                    ExpressionDescriptor.prototype.getYearDescription = function() {
                        var _this = this;
                        var description = this.getSegmentDescription(this.expressionParts[6], "", function(s) {
                            return /^\d+$/.test(s) ? new Date(parseInt(s), 1).getFullYear().toString() : s;
                        }, function(s) {
                            return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Years(s), s);
                        }, function(s) {
                            return _this.i18n.commaYearX0ThroughYearX1() || _this.i18n.commaX0ThroughX1();
                        }, function(s) {
                            return _this.i18n.commaOnlyInYearX0 ? _this.i18n.commaOnlyInYearX0() : _this.i18n.commaOnlyInX0();
                        });
                        return description;
                    };
                    ExpressionDescriptor.prototype.getSegmentDescription = function(expression, allDescription, getSingleItemDescription, getIncrementDescriptionFormat, getRangeDescriptionFormat, getDescriptionFormat) {
                        var description = null;
                        var doesExpressionContainIncrement = expression.indexOf("/") > -1;
                        var doesExpressionContainRange = expression.indexOf("-") > -1;
                        var doesExpressionContainMultipleValues = expression.indexOf(",") > -1;
                        if (!expression) description = "";
                        else if (expression === "*") description = allDescription;
                        else if (!doesExpressionContainIncrement && !doesExpressionContainRange && !doesExpressionContainMultipleValues) description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), getSingleItemDescription(expression));
                        else if (doesExpressionContainMultipleValues) {
                            var segments = expression.split(",");
                            var descriptionContent = "";
                            for(var i = 0; i < segments.length; i++){
                                if (i > 0 && segments.length > 2) {
                                    descriptionContent += ",";
                                    if (i < segments.length - 1) descriptionContent += " ";
                                }
                                if (i > 0 && segments.length > 1 && (i == segments.length - 1 || segments.length == 2)) descriptionContent += "".concat(this.i18n.spaceAnd(), " ");
                                if (segments[i].indexOf("/") > -1 || segments[i].indexOf("-") > -1) {
                                    var isSegmentRangeWithoutIncrement = segments[i].indexOf("-") > -1 && segments[i].indexOf("/") == -1;
                                    var currentDescriptionContent = this.getSegmentDescription(segments[i], allDescription, getSingleItemDescription, getIncrementDescriptionFormat, isSegmentRangeWithoutIncrement ? this.i18n.commaX0ThroughX1 : getRangeDescriptionFormat, getDescriptionFormat);
                                    if (isSegmentRangeWithoutIncrement) currentDescriptionContent = currentDescriptionContent.replace(", ", "");
                                    descriptionContent += currentDescriptionContent;
                                } else if (!doesExpressionContainIncrement) descriptionContent += getSingleItemDescription(segments[i]);
                                else descriptionContent += this.getSegmentDescription(segments[i], allDescription, getSingleItemDescription, getIncrementDescriptionFormat, getRangeDescriptionFormat, getDescriptionFormat);
                            }
                            if (!doesExpressionContainIncrement) description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), descriptionContent);
                            else description = descriptionContent;
                        } else if (doesExpressionContainIncrement) {
                            var segments = expression.split("/");
                            description = stringUtilities_1.StringUtilities.format(getIncrementDescriptionFormat(segments[1]), segments[1]);
                            if (segments[0].indexOf("-") > -1) {
                                var rangeSegmentDescription = this.generateRangeSegmentDescription(segments[0], getRangeDescriptionFormat, getSingleItemDescription);
                                if (rangeSegmentDescription.indexOf(", ") != 0) description += ", ";
                                description += rangeSegmentDescription;
                            } else if (segments[0].indexOf("*") == -1) {
                                var rangeItemDescription = stringUtilities_1.StringUtilities.format(getDescriptionFormat(segments[0]), getSingleItemDescription(segments[0]));
                                rangeItemDescription = rangeItemDescription.replace(", ", "");
                                description += stringUtilities_1.StringUtilities.format(this.i18n.commaStartingX0(), rangeItemDescription);
                            }
                        } else if (doesExpressionContainRange) description = this.generateRangeSegmentDescription(expression, getRangeDescriptionFormat, getSingleItemDescription);
                        return description;
                    };
                    ExpressionDescriptor.prototype.generateRangeSegmentDescription = function(rangeExpression, getRangeDescriptionFormat, getSingleItemDescription) {
                        var description = "";
                        var rangeSegments = rangeExpression.split("-");
                        var rangeSegment1Description = getSingleItemDescription(rangeSegments[0], 1);
                        var rangeSegment2Description = getSingleItemDescription(rangeSegments[1], 2);
                        var rangeDescriptionFormat = getRangeDescriptionFormat(rangeExpression);
                        description += stringUtilities_1.StringUtilities.format(rangeDescriptionFormat, rangeSegment1Description, rangeSegment2Description);
                        return description;
                    };
                    ExpressionDescriptor.prototype.formatTime = function(hourExpression, minuteExpression, secondExpression) {
                        var hourOffset = 0;
                        var minuteOffset = 0;
                        var hour = parseInt(hourExpression) + hourOffset;
                        var minute = parseInt(minuteExpression) + minuteOffset;
                        if (minute >= 60) {
                            minute -= 60;
                            hour += 1;
                        } else if (minute < 0) {
                            minute += 60;
                            hour -= 1;
                        }
                        if (hour >= 24) hour = hour - 24;
                        else if (hour < 0) hour = 24 + hour;
                        var period = "";
                        var setPeriodBeforeTime = false;
                        if (!this.options.use24HourTimeFormat) {
                            setPeriodBeforeTime = !!(this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime());
                            period = setPeriodBeforeTime ? "".concat(this.getPeriod(hour), " ") : " ".concat(this.getPeriod(hour));
                            if (hour > 12) hour -= 12;
                            if (hour === 0) hour = 12;
                        }
                        var second = "";
                        if (secondExpression) second = ":".concat(("00" + secondExpression).substring(secondExpression.length));
                        return "".concat(setPeriodBeforeTime ? period : "").concat(("00" + hour.toString()).substring(hour.toString().length), ":").concat(("00" + minute.toString()).substring(minute.toString().length)).concat(second).concat(!setPeriodBeforeTime ? period : "");
                    };
                    ExpressionDescriptor.prototype.transformVerbosity = function(description, useVerboseFormat) {
                        if (!useVerboseFormat) {
                            description = description.replace(new RegExp(", ".concat(this.i18n.everyMinute()), "g"), "");
                            description = description.replace(new RegExp(", ".concat(this.i18n.everyHour()), "g"), "");
                            description = description.replace(new RegExp(this.i18n.commaEveryDay(), "g"), "");
                            description = description.replace(/\, ?$/, "");
                            if (this.i18n.conciseVerbosityReplacements) for(var _i = 0, _a = Object.entries(this.i18n.conciseVerbosityReplacements()); _i < _a.length; _i++){
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                description = description.replace(new RegExp(key, "g"), value);
                            }
                        }
                        return description;
                    };
                    ExpressionDescriptor.prototype.getPeriod = function(hour) {
                        return hour >= 12 ? this.i18n.pm && this.i18n.pm() || "PM" : this.i18n.am && this.i18n.am() || "AM";
                    };
                    ExpressionDescriptor.locales = {};
                    return ExpressionDescriptor;
                }();
                exports.ExpressionDescriptor = ExpressionDescriptor;
            /***/ },
            /***/ 747: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.enLocaleLoader = void 0;
                var en_1 = __webpack_require__(486);
                var enLocaleLoader = function() {
                    function enLocaleLoader() {}
                    enLocaleLoader.prototype.load = function(availableLocales) {
                        availableLocales["en"] = new en_1.en();
                    };
                    return enLocaleLoader;
                }();
                exports.enLocaleLoader = enLocaleLoader;
            /***/ },
            /***/ 486: /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.en = void 0;
                var en = function() {
                    function en() {}
                    en.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                        return null;
                    };
                    en.prototype.atX0MinutesPastTheHourGt20 = function() {
                        return null;
                    };
                    en.prototype.commaMonthX0ThroughMonthX1 = function() {
                        return null;
                    };
                    en.prototype.commaYearX0ThroughYearX1 = function() {
                        return null;
                    };
                    en.prototype.use24HourTimeFormatByDefault = function() {
                        return false;
                    };
                    en.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                        return "An error occurred when generating the expression description. Check the cron expression syntax.";
                    };
                    en.prototype.everyMinute = function() {
                        return "every minute";
                    };
                    en.prototype.everyHour = function() {
                        return "every hour";
                    };
                    en.prototype.atSpace = function() {
                        return "At ";
                    };
                    en.prototype.everyMinuteBetweenX0AndX1 = function() {
                        return "Every minute between %s and %s";
                    };
                    en.prototype.at = function() {
                        return "At";
                    };
                    en.prototype.spaceAnd = function() {
                        return " and";
                    };
                    en.prototype.everySecond = function() {
                        return "every second";
                    };
                    en.prototype.everyX0Seconds = function() {
                        return "every %s seconds";
                    };
                    en.prototype.secondsX0ThroughX1PastTheMinute = function() {
                        return "seconds %s through %s past the minute";
                    };
                    en.prototype.atX0SecondsPastTheMinute = function() {
                        return "at %s seconds past the minute";
                    };
                    en.prototype.everyX0Minutes = function() {
                        return "every %s minutes";
                    };
                    en.prototype.minutesX0ThroughX1PastTheHour = function() {
                        return "minutes %s through %s past the hour";
                    };
                    en.prototype.atX0MinutesPastTheHour = function() {
                        return "at %s minutes past the hour";
                    };
                    en.prototype.everyX0Hours = function() {
                        return "every %s hours";
                    };
                    en.prototype.betweenX0AndX1 = function() {
                        return "between %s and %s";
                    };
                    en.prototype.atX0 = function() {
                        return "at %s";
                    };
                    en.prototype.commaEveryDay = function() {
                        return ", every day";
                    };
                    en.prototype.commaEveryX0DaysOfTheWeek = function() {
                        return ", every %s days of the week";
                    };
                    en.prototype.commaX0ThroughX1 = function() {
                        return ", %s through %s";
                    };
                    en.prototype.commaAndX0ThroughX1 = function() {
                        return ", %s through %s";
                    };
                    en.prototype.first = function() {
                        return "first";
                    };
                    en.prototype.second = function() {
                        return "second";
                    };
                    en.prototype.third = function() {
                        return "third";
                    };
                    en.prototype.fourth = function() {
                        return "fourth";
                    };
                    en.prototype.fifth = function() {
                        return "fifth";
                    };
                    en.prototype.commaOnThe = function() {
                        return ", on the ";
                    };
                    en.prototype.spaceX0OfTheMonth = function() {
                        return " %s of the month";
                    };
                    en.prototype.lastDay = function() {
                        return "the last day";
                    };
                    en.prototype.commaOnTheLastX0OfTheMonth = function() {
                        return ", on the last %s of the month";
                    };
                    en.prototype.commaOnlyOnX0 = function() {
                        return ", only on %s";
                    };
                    en.prototype.commaAndOnX0 = function() {
                        return ", and on %s";
                    };
                    en.prototype.commaEveryX0Months = function() {
                        return ", every %s months";
                    };
                    en.prototype.commaOnlyInX0 = function() {
                        return ", only in %s";
                    };
                    en.prototype.commaOnTheLastDayOfTheMonth = function() {
                        return ", on the last day of the month";
                    };
                    en.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                        return ", on the last weekday of the month";
                    };
                    en.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                        return ", %s days before the last day of the month";
                    };
                    en.prototype.firstWeekday = function() {
                        return "first weekday";
                    };
                    en.prototype.weekdayNearestDayX0 = function() {
                        return "weekday nearest day %s";
                    };
                    en.prototype.commaOnTheX0OfTheMonth = function() {
                        return ", on the %s of the month";
                    };
                    en.prototype.commaEveryX0Days = function() {
                        return ", every %s days";
                    };
                    en.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                        return ", between day %s and %s of the month";
                    };
                    en.prototype.commaOnDayX0OfTheMonth = function() {
                        return ", on day %s of the month";
                    };
                    en.prototype.commaEveryHour = function() {
                        return ", every hour";
                    };
                    en.prototype.commaEveryX0Years = function() {
                        return ", every %s years";
                    };
                    en.prototype.commaStartingX0 = function() {
                        return ", starting %s";
                    };
                    en.prototype.daysOfTheWeek = function() {
                        return [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ];
                    };
                    en.prototype.monthsOfTheYear = function() {
                        return [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ];
                    };
                    en.prototype.atReboot = function() {
                        return "Run once, at startup";
                    };
                    return en;
                }();
                exports.en = en;
            /***/ },
            /***/ 515: /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                function assert(value, message) {
                    if (!value) throw new Error(message);
                }
                var RangeValidator = function() {
                    function RangeValidator() {}
                    RangeValidator.secondRange = function(parse) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var second = parseInt(parsed[i], 10);
                            assert(second >= 0 && second <= 59, 'seconds part must be >= 0 and <= 59');
                        }
                    };
                    RangeValidator.minuteRange = function(parse) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var minute = parseInt(parsed[i], 10);
                            assert(minute >= 0 && minute <= 59, 'minutes part must be >= 0 and <= 59');
                        }
                    };
                    RangeValidator.hourRange = function(parse) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var hour = parseInt(parsed[i], 10);
                            assert(hour >= 0 && hour <= 23, 'hours part must be >= 0 and <= 23');
                        }
                    };
                    RangeValidator.dayOfMonthRange = function(parse) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var dayOfMonth = parseInt(parsed[i], 10);
                            assert(dayOfMonth >= 1 && dayOfMonth <= 31, 'DOM part must be >= 1 and <= 31');
                        }
                    };
                    RangeValidator.monthRange = function(parse, monthStartIndexZero) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var month = parseInt(parsed[i], 10);
                            assert(month >= 1 && month <= 12, monthStartIndexZero ? 'month part must be >= 0 and <= 11' : 'month part must be >= 1 and <= 12');
                        }
                    };
                    RangeValidator.dayOfWeekRange = function(parse, dayOfWeekStartIndexZero) {
                        var parsed = parse.split(',');
                        for(var i = 0; i < parsed.length; i++)if (!isNaN(parseInt(parsed[i], 10))) {
                            var dayOfWeek = parseInt(parsed[i], 10);
                            assert(dayOfWeek >= 0 && dayOfWeek <= 6, dayOfWeekStartIndexZero ? 'DOW part must be >= 0 and <= 6' : 'DOW part must be >= 1 and <= 7');
                        }
                    };
                    return RangeValidator;
                }();
                exports["default"] = RangeValidator;
            /***/ },
            /***/ 823: /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StringUtilities = void 0;
                var StringUtilities = function() {
                    function StringUtilities() {}
                    StringUtilities.format = function(template) {
                        var values = [];
                        for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
                        return template.replace(/%s/g, function(substring) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            return values.shift();
                        });
                    };
                    StringUtilities.containsAny = function(text, searchStrings) {
                        return searchStrings.some(function(c) {
                            return text.indexOf(c) > -1;
                        });
                    };
                    return StringUtilities;
                }();
                exports.StringUtilities = StringUtilities;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it uses a non-standard name for the exports (exports).
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.toString = void 0;
            var expressionDescriptor_1 = __webpack_require__(333);
            var enLocaleLoader_1 = __webpack_require__(747);
            expressionDescriptor_1.ExpressionDescriptor.initialize(new enLocaleLoader_1.enLocaleLoader());
            exports["default"] = expressionDescriptor_1.ExpressionDescriptor;
            var toString = expressionDescriptor_1.ExpressionDescriptor.toString;
            exports.toString = toString;
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});


const $6fc2f2f7fd99bbdc$var$DataStreamCron = ({ fieldName: fieldName, handleChange: handleChange, cronValue: cronValue, errors: errors, required: required = false, disabled: disabled = false })=>{
    const selectId = fieldName.replace('_', '-');
    const [cronMessage, setCronMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState('');
    const [isCronError, setIsCronError] = (0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).useState(false);
    // Minutes
    const minsRegex = /^([*]|(([0-5]?\d))|((([0-5]?\d))(\/|-)([0-5]?\d))|((([0-5]?\d))((,)([0-5]?\d))*))$/;
    // Hours
    const hrsRegex = /^([*]|[01]?\d|2[0-3]|(([01]?\d|2[0-3]?)(\/|-)([01]?\d|2[0-3]?))|(([01]?\d|2[0-3]?)((,)([01]?\d|2[0-3]?))*))$/;
    // Day of months
    const dayOfMonthRegex = /^([*]|[?]|(([1-9]|[12]\d|3[01])[LW]?)|(([1-9]|[12]\d|3[01])(\/|-)([1-9]|[12]\d|3[01]))|(([1-9]|[12]\d|3[01])((,)([1-9]|[12]\d|3[01]))*))$/;
    // Months
    const monthsRegex = /^([*]|([2-9]|1[0-2]?)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|((([2-9]|1[0-2]?)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))(\/|-)(([2-9]|1[0-2]?)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)))|((([2-9]|1[0-2]?)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))((,)(([2-9]|1[0-2]?)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)))*))$/;
    // Day of Week
    const dayOfWeekRegex = /^([*]|[?]|([1-7]L?)|(SUN|MON|TUE|WED|THU|FRI|SAT)|((([1-7])|(SUN|MON|TUE|WED|THU|FRI|SAT))(\/|-|,|#)(([1-7])|(SUN|MON|TUE|WED|THU|FRI|SAT)))|((([1-7])|(SUN|MON|TUE|WED|THU|FRI|SAT))((,)(([1-7])|(SUN|MON|TUE|WED|THU|FRI|SAT)))*))$/;
    // Year
    const yearRegex = /^([*]|([1-2]\d{3})|(([1-2]\d{3})(\/|-)([1-2]\d{0,3}))|(([1-2]\d{3})((,)([1-2]\d{3}))*))$/;
    function validateCron(cronValue, mountEvent) {
        const validationMsg = [];
        if (!cronValue || cronValue === '') {
            if (required === true && mountEvent === false) validationMsg.push('Required');
            else return validationMsg;
        }
        const splitValues = cronValue.trim().split(' ');
        function testRegex(val, field, regEx) {
            if (val !== '' && !regEx.test(val)) validationMsg.push(`${val} is not valid for ${field}`);
        }
        if (splitValues.length !== 6 || splitValues[5].trim() === '') validationMsg.push(`${cronValue} is not in a valid AWS cron format`);
        else {
            const mins = splitValues[0].trim();
            const hrs = splitValues[1].trim();
            const dayOfMonth = splitValues[2].trim();
            const months = splitValues[3].trim();
            const dayOfWeek = splitValues[4].trim();
            const year = splitValues[5].trim();
            if (dayOfMonth === '*' && dayOfWeek === '*') validationMsg.push('Can\'t use * in both the Day-of-month and Day-of-week fields');
            testRegex(mins, 'minutes', minsRegex);
            testRegex(hrs, 'hours', hrsRegex);
            testRegex(dayOfMonth, 'day of month', dayOfMonthRegex);
            testRegex(months, 'day of month', monthsRegex);
            testRegex(dayOfWeek, 'day of month', dayOfWeekRegex);
            testRegex(year, 'year', yearRegex);
        }
        const hasError = validationMsg.length > 0;
        if (!hasError) {
            const cronMessage = (0, (/*@__PURE__*/$parcel$interopDefault($99b438cd66ce7356$exports))).toString(cronValue.replace(/,/g, ' ').replace(/!/g, ','), {
                throwExceptionOnParseError: false,
                locale: 'en'
            });
            if (cronMessage && cronMessage !== '') validationMsg.push(cronMessage);
        }
        return {
            hasError: hasError,
            validationMsg: validationMsg
        };
    }
    function onChange(event, blurEvent, mountEvent) {
        let cronValue = event.target.value;
        if (cronValue === undefined || cronValue === '') {
            if (required === true && mountEvent === false) {
                setIsCronError(true);
                setCronMessage('Required');
            } else {
                setIsCronError(false);
                setCronMessage('');
                delete errors.cronError;
                handleChange(cronValue);
                return;
            }
        }
        const validationResult = validateCron(cronValue, mountEvent);
        const message = cronValue ? validationResult.validationMsg.length > 0 ? validationResult.validationMsg[0] : '' : '';
        const hasError = cronValue ? validationResult.hasError === true : false;
        if (hasError) errors['cronError'] = message;
        else delete errors.cronError;
        setIsCronError(hasError);
        setCronMessage(message);
        if (!blurEvent) handleChange(cronValue);
    }
    (0, $jSIPP.useEffect)(()=>onChange({
            target: {
                value: cronValue
            }
        }, true, true), []);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
            item: true,
            xs: 6,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                id: selectId,
                name: fieldName,
                label: 'Cron (Owner Timezone)',
                value: cronValue,
                error: disabled ? null : isCronError,
                helperText: disabled ? ' ' : cronMessage ? '\u25B4 ' + cronMessage : ' ',
                FormHelperTextProps: {
                    sx: {
                        textAlign: 'right',
                        lineHeight: 1,
                        mx: 0,
                        my: '0.125rem'
                    }
                },
                fullWidth: true,
                onBlur: (event)=>onChange(event, true, false),
                onChange: (event)=>onChange(event, false, false),
                variant: "outlined",
                required: required,
                disabled: disabled
            })
        })
    });
};
var $6fc2f2f7fd99bbdc$export$2e2bcd8739ae039 = $6fc2f2f7fd99bbdc$var$DataStreamCron;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");


/***
 *
 * @param fieldName A custom name for the IyoDropDown. This should be a unique identifier.
 * @param dataList An array of data entries. Each entry must contain attributes {id, name}.
 * @param value The field to which selections get assigned. Either a number or an array of numbers, depending on
 * whether the Select is single or multiple.
 * @param handleChange Handles value change. Called with {value} holding the id of the one option that changed,
 * which is what the page's handlers expect - the consumer handler toggles the id it is given rather than
 * replacing the whole list.
 * @param isMultiple {boolean} Whether or not this component is a multi-select or single-select.
 * @returns {JSX.Element}
 * @constructor
 */ const $26614893954f57b9$var$DataStreamDropDown = ({ fieldName: fieldName, dataList: dataList, value: value, handleChange: handleChange, isMultiple: isMultiple })=>{
    const [closed, setClosed] = (0, $jSIPP.useState)(false);
    const inputLabel = (0, $a9106d6db699107c$export$9a216cca07bece15)(fieldName, ' ');
    // The list arrives from a query, so it is null until that query resolves - and stays null
    // if it fails. Rendering an empty menu beats taking the dialog down with it.
    const options = Array.isArray(dataList) ? dataList : [];
    // The dialog holds ids; Autocomplete works in the option objects themselves. An id with no
    // option behind it - a consumer that has since been deleted, or a list still loading -
    // drops out rather than rendering a blank row.
    const optionFor = (id)=>{
        var _options_find;
        return (_options_find = options.find((option)=>option.id === id)) !== null && _options_find !== void 0 ? _options_find : null;
    };
    const selection = isMultiple ? (Array.isArray(value) ? value : []).map(optionFor).filter(Boolean) : optionFor(value);
    const isEmpty = isMultiple ? !selection.length : !selection;
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), {
        id: fieldName.replace('_', '-'),
        options: options,
        value: selection,
        multiple: isMultiple,
        fullWidth: true,
        // Nothing here is clearable in one go. Removal is per option - unticking it in the
        // list, or deleting its chip - because that is the single change the handlers take.
        disableClearable: true,
        disableCloseOnSelect: isMultiple,
        autoHighlight: true,
        getOptionLabel: (option)=>{
            var _option_name;
            return (_option_name = option === null || option === void 0 ? void 0 : option.name) !== null && _option_name !== void 0 ? _option_name : '';
        },
        isOptionEqualToValue: (option, selected)=>option.id === selected.id,
        onChange: (event, next, reason, details)=>{
            if (isMultiple) {
                if (details === null || details === void 0 ? void 0 : details.option) handleChange({
                    value: details.option.id
                });
                return;
            }
            var _next_id;
            handleChange({
                value: (_next_id = next === null || next === void 0 ? void 0 : next.id) !== null && _next_id !== void 0 ? _next_id : ''
            });
        },
        onClose: ()=>setClosed(true),
        renderInput: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params), {
                label: inputLabel,
                error: isEmpty && closed,
                helperText: isEmpty && closed ? 'Required' : '',
                variant: "outlined"
            }))
    });
};
var $26614893954f57b9$export$2e2bcd8739ae039 = $26614893954f57b9$var$DataStreamDropDown;







var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");






const $c10ef6ca62ebf0a3$var$handleCreate = async (setState)=>{
    setState.setEditMode('create');
    setState.setRowEditing(null);
    setState.setProviderId(null);
    setState.setOwnerId(null);
    setState.setConsumerId(null);
    setState.setDeviceId(null);
    setState.setName('');
    setState.setDescription('');
    setState.setCron('');
    setState.setEditOpen(true);
};
const $c10ef6ca62ebf0a3$var$handleCreateSubmit = async (values, state, setState, dataStreamFields, postDataStream, schema)=>{
    try {
        await (0, $007c796d200e5283$export$2e2bcd8739ae039).createDataStream(values, state, setState, dataStreamFields, postDataStream, schema);
    } catch (err) {
        // The mutation's onError has already raised the popup, which sits above the dialog.
        // Swallowed so Formik does not report an unhandled submit rejection, and the dialog is
        // left open so the entered values survive for a retry.
        return;
    }
    setState.setEditOpen(false);
};
const $c10ef6ca62ebf0a3$var$handleDialogOpen = async (event, fieldName, row, setState)=>{
    if (fieldName === 'provider_schema') {
        setState.setDialogContent(JSON.stringify(row.provider_schema, undefined, 2));
        setState.setDialogTitle('Provider JSON Schema');
    } else if (fieldName === 'provider_properties') {
        setState.setDialogContent(JSON.stringify(row.provider_properties, undefined, 2));
        setState.setDialogTitle('Provider Properties');
    } else if (fieldName === 'data_stream_provider_properties') {
        setState.setDialogContent(JSON.stringify(row.data_stream_provider_properties, undefined, 2));
        setState.setDialogTitle('Data Stream Properties');
    }
    setState.setDialogOpen(true);
};
const $c10ef6ca62ebf0a3$var$handleDialogClose = (setState)=>{
    setState.setDialogOpen(false);
};
const $c10ef6ca62ebf0a3$var$handleEdit = async (event, row, queryClient, setState)=>{
    setState.setEditMode('edit');
    setState.setRowEditing(row);
    setState.setCron(row.cron);
    setState.setLastRetrievalDate(row.last_retrieval_date);
    setState.setProviderId(row.provider_id);
    setState.setOwnerId(row.owner_id);
    var _row_device_id;
    // Null for everything but a PC Agent stream, and the dialog only reads it for those.
    setState.setDeviceId((_row_device_id = row.device_id) !== null && _row_device_id !== void 0 ? _row_device_id : null);
    setState.setDataStreamId(row.id);
    await queryClient.refetchQueries('getOwnerConsumerDefaults');
    setState.setEditOpen(true);
};
const $c10ef6ca62ebf0a3$var$handleEditSubmit = async (values, queryClient, state, setState, putDataStream, schema)=>{
    // No invalidateQueries here: updateDataStream awaits the PUT, and the mutation's own
    // onSuccess invalidates getDataStreams once the server has the change. Invalidating
    // alongside the request instead raced it, and the grid kept showing the old row.
    try {
        await (0, $007c796d200e5283$export$2e2bcd8739ae039).updateDataStream(values, state, putDataStream, schema);
    } catch (err) {
        // The mutation's onError has already raised the popup, which sits above the dialog.
        // Swallowed so Formik does not report an unhandled submit rejection, and the dialog is
        // left open so the edits survive for a retry.
        return;
    }
    setState.setEditOpen(false);
};
const $c10ef6ca62ebf0a3$var$refreshTable = async (queryClient)=>{
    await queryClient.invalidateQueries('getDataStreams');
    console.info('Table refreshed');
};
var $c10ef6ca62ebf0a3$export$2e2bcd8739ae039 = {
    handleCreate: $c10ef6ca62ebf0a3$var$handleCreate,
    handleCreateSubmit: $c10ef6ca62ebf0a3$var$handleCreateSubmit,
    handleDialogOpen: $c10ef6ca62ebf0a3$var$handleDialogOpen,
    handleDialogClose: $c10ef6ca62ebf0a3$var$handleDialogClose,
    handleEdit: $c10ef6ca62ebf0a3$var$handleEdit,
    handleEditSubmit: $c10ef6ca62ebf0a3$var$handleEditSubmit,
    refreshTable: $c10ef6ca62ebf0a3$var$refreshTable
};



const $007c796d200e5283$var$initializeColumns = (initialColumns, queryClient, setState)=>{
    return initialColumns.concat({
        field: 'provider_schema',
        headerName: 'Provider Schema',
        description: 'Provider Schema',
        minWidth: 150,
        renderCell: (params)=>{
            return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4uaIU.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        title: "View Schema",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: (event)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleDialogOpen(event, 'provider_schema', params.row, setState),
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0eefa11e679f91b4$exports))), {})
                        })
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        title: "View Properties",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: (event)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleDialogOpen(event, 'provider_properties', params.row, setState),
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ad317ed5c7ae9683$exports))), {})
                        })
                    })
                ]
            });
        }
    }, {
        field: 'data_stream_provider_properties',
        headerName: 'Datastream Properties',
        description: 'Datastream Properties',
        minWidth: 150,
        renderCell: (params)=>{
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: "View Properties",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: (event)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleDialogOpen(event, 'data_stream_provider_properties', params.row, setState),
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ad317ed5c7ae9683$exports))), {})
                    })
                })
            });
        }
    }, {
        field: 'actions',
        headerName: 'Actions',
        description: 'Actions',
        minWidth: 145,
        renderCell: (params)=>{
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                    title: "Edit",
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: (event)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleEdit(event, params.row, queryClient, setState),
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6be52b93098825b$exports))), {})
                    })
                })
            });
        }
    });
};
const $007c796d200e5283$var$produceError = (error, setState)=>{
    var _error_response;
    const message = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) === undefined ? error.toString() : `${error.message}: ${JSON.stringify(error.response.data)}`;
    setState.setErrorOpen(false);
    setState.setErrDisplayText(message);
    setState.setErrorOpen(true);
    console.error(message);
};
const $007c796d200e5283$var$updateDataStream = async (values, state, putDataStream, schema)=>{
    let body = {
        provider_properties: {}
    };
    for(let field in values)if (values[field] !== state.rowEditing[field]) {
        const value = $007c796d200e5283$var$mapValueToSchema(field, values[field], schema);
        if (state.dataStreamFields.includes(field)) body[field] = value;
        else body.provider_properties[field] = value;
    }
    body['provider_id'] = state.providerId;
    body['owner_id'] = state.ownerId;
    body['cron'] = state.cron;
    body['last_retrieval_date'] = state.lastRetrievalDate;
    var _state_deviceId;
    // Only a PC Agent stream has a device; the dialog clears the selection for every other
    // provider. Sent as null rather than omitted so moving a stream off a PC Agent provider
    // actually releases the device - an omitted key is dropped by the JSON round trip and
    // would leave the old one attached.
    body['device_id'] = (_state_deviceId = state.deviceId) !== null && _state_deviceId !== void 0 ? _state_deviceId : null;
    body['updated_by'] = await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser();
    body['id'] = state.rowEditing.id;
    // Read from the form, not from state: the editor writes through Formik's setFieldValue,
    // so there is no state.partition_configs to read.
    //
    // The seeded example varies by provider scheme, so compare against all of them rather
    // than one constant, or an untouched example gets saved as real configuration. An empty
    // value is sent as null so clearing every rule actually clears the column - undefined
    // would be dropped by the PUT's JSON round trip and leave the old rules in place.
    const partitionConfigs = values.partition_configs;
    if (partitionConfigs === undefined || (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isExampleValue(partitionConfigs)) delete body['partition_configs'];
    else body['partition_configs'] = partitionConfigs === '' ? null : partitionConfigs;
    // Awaited, so the caller resumes only once the PUT has landed and the mutation's
    // onSuccess has invalidated getDataStreams. mutate() returns before either, which left
    // the grid refetching the pre-save rows.
    await putDataStream.mutateAsync(body);
};
const $007c796d200e5283$var$createDataStream = async (values, state, setState, dataStreamFields, postDataStream, schema)=>{
    let body = {
        provider_properties: {}
    };
    for (let [key, value] of Object.entries(values)){
        value = $007c796d200e5283$var$mapValueToSchema(key, value, schema);
        if (dataStreamFields.includes(key)) body[key] = value;
        else body.provider_properties[key] = value;
    }
    body['provider_id'] = state.providerId;
    body['owner_id'] = state.ownerId;
    body['cron'] = state.cron;
    body['last_retrieval_date'] = state.lastRetrievalDate;
    var _state_deviceId;
    body['device_id'] = (_state_deviceId = state.deviceId) !== null && _state_deviceId !== void 0 ? _state_deviceId : null;
    // As in updateDataStream: an untouched example is not configuration, and saving it would
    // route rows to the placeholder owner in the example.
    if (!body['partition_configs'] || (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isExampleValue(body['partition_configs'])) delete body['partition_configs'];
    await postDataStream.mutateAsync((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, body), {
        created_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser(),
        updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
    }));
};
function $007c796d200e5283$var$mapValueToSchema(field, value, schema) {
    if (!value) return undefined;
    if (!schema) return value;
    const schemaInfo = schema.find(function(item) {
        return item.name === field;
    });
    switch(schemaInfo === null || schemaInfo === void 0 ? void 0 : schemaInfo.type.toLowerCase()){
        case 'integer':
            value = Number.parseInt(value);
            break;
        case 'float':
            value = Number.parseFloat(value);
            break;
        case 'boolean':
            let boolVal = value.toString().trim().toLowerCase();
            switch(boolVal){
                case 'true':
                case '1':
                    value = true;
                    break;
                case 'false':
                case '0':
                    value = false;
                    break;
                default:
                    value = undefined;
                    break;
            }
            break;
        // ms-ngest validates provider_properties against the provider's JSON schema, so a
        // non-array here is a 400. NO comma splitting: site names contain commas, so a stored
        // string is taken whole rather than guessed at.
        case 'array':
            {
                const clean = (items)=>items.map((item)=>String(item).trim()).filter(Boolean);
                if (Array.isArray(value)) {
                    value = clean(value);
                    break;
                }
                const text = String(value).trim();
                try {
                    const parsed = JSON.parse(text);
                    if (Array.isArray(parsed)) {
                        value = clean(parsed);
                        break;
                    }
                } catch (err) {
                // Not JSON; treat as a single value.
                }
                value = clean([
                    text
                ]);
                break;
            }
        case 'object':
            value = Object.create(value);
            break;
    }
    return value;
}
var $007c796d200e5283$export$2e2bcd8739ae039 = {
    initializeColumns: $007c796d200e5283$var$initializeColumns,
    produceError: $007c796d200e5283$var$produceError,
    createDataStream: $007c796d200e5283$var$createDataStream,
    updateDataStream: $007c796d200e5283$var$updateDataStream
};



const $f1bc31ea7471fcab$var$useDataStreamQuery = (method, queryClient, state, setState, input)=>{
    switch(method){
        case 'GET':
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDataStreams', async ()=>{
                return await (0, $e35ffebe245b57e7$export$2e2bcd8739ae039).getAll();
            }, {
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                },
                staleTime: Infinity
            });
        case 'POST':
            return (0, $74568c0a766c827d$export$609860bf8b0084c)('postDataStream', async (data)=>{
                return await (0, $e35ffebe245b57e7$export$2e2bcd8739ae039).post(data);
            }, {
                onSuccess: async (resp)=>{
                    setState.setDataStreamId(resp);
                    await queryClient.invalidateQueries('getDataStreams');
                },
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                }
            });
        case 'PUT':
            return (0, $74568c0a766c827d$export$609860bf8b0084c)('putDataStream', async (data)=>{
                let myData = JSON.parse(JSON.stringify(data));
                if (!myData.last_retrieval_date) myData.last_retrieval_date = null;
                return await (0, $e35ffebe245b57e7$export$2e2bcd8739ae039).put(state.rowEditing.id, myData);
            }, {
                onSuccess: async ()=>{
                    await queryClient.invalidateQueries('getDataStreams');
                },
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                }
            });
        default:
            return;
    }
};
const $f1bc31ea7471fcab$var$useOwnerDefaultDataStreamQuery = (method, state, setState)=>{
    switch(method){
        case 'GET':
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)([
                'getOwnerConsumerDefaults',
                state.ownerId
            ], async ()=>await (0, $ad8a302f12f32b6f$export$2e2bcd8739ae039).get(state.ownerId), {
                onSuccess: (data)=>{
                    setState.setConsumerId(data.map((rec)=>rec.consumer_id));
                    setState.setOriginalConsumers(data.map((rec)=>rec.consumer_id));
                },
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                },
                staleTime: Infinity
            });
        default:
            return;
    }
};
var $f1bc31ea7471fcab$export$2e2bcd8739ae039 = {
    useDataStreamQuery: $f1bc31ea7471fcab$var$useDataStreamQuery,
    useOwnerDefaultDataStreamQuery: $f1bc31ea7471fcab$var$useOwnerDefaultDataStreamQuery
};










const $69cc8f084f0e7d75$var$useConsumerQuery = (method, setState)=>{
    switch(method){
        case 'GET':
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)('getConsumers', async ()=>{
                return await (0, $6ea4f0a608034787$export$2e2bcd8739ae039).getAll();
            }, {
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                },
                staleTime: Infinity
            });
    }
};
// Shares the 'getDevices' cache entry with the Devices page: same endpoint, same rows, and
// the picker only ever needs a subset of them. The full list is fetched rather than one
// owner's, because device_view has no owner_id to query on - devicesForOwner narrows it.
const $69cc8f084f0e7d75$var$useDeviceQuery = (method, setState)=>{
    switch(method){
        case 'GET':
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDevices', (0, $48e245a686e30046$export$2e2bcd8739ae039).getDevices, {
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                },
                staleTime: Infinity
            });
    }
};
const $69cc8f084f0e7d75$var$useInitialValuesQuery = (state, setState, getProperties, providerScheme)=>{
    // providerScheme is part of the key: changing provider changes which example is seeded.
    return (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        'getInitialValues',
        getProperties,
        state.providerId,
        providerScheme
    ], ()=>{
        var _state_rowEditing, _state_rowEditing1, _state_rowEditing2, _state_rowEditing3, _state_rowEditing4;
        const initialFields = getProperties.data || null;
        return (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            name: ((_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing.name) ? state.rowEditing.name : state.name,
            description: ((_state_rowEditing1 = state.rowEditing) === null || _state_rowEditing1 === void 0 ? void 0 : _state_rowEditing1.description) ? state.rowEditing.description : state.description,
            cron: ((_state_rowEditing2 = state.rowEditing) === null || _state_rowEditing2 === void 0 ? void 0 : _state_rowEditing2.cron) ? state.rowEditing.cron : state.cron,
            last_retrieval_date: ((_state_rowEditing3 = state.rowEditing) === null || _state_rowEditing3 === void 0 ? void 0 : _state_rowEditing3.last_retrieval_date) ? state.rowEditing.last_retrieval_date : state.last_retrieval_date,
            // DialogHelpers, not PageHelpers: the page helpers never exported
            // examplePartitionConfigs, so this was undefined and the example never rendered.
            partition_configs: ((_state_rowEditing4 = state.rowEditing) === null || _state_rowEditing4 === void 0 ? void 0 : _state_rowEditing4.partition_configs) ? state.rowEditing.partition_configs : (0, $a090740b3e667ed5$export$2e2bcd8739ae039).exampleForScheme(providerScheme)
        }, (0, $a090740b3e667ed5$export$2e2bcd8739ae039).prettifyProperties(initialFields));
    }, {
        onError: (error)=>{
            (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
        },
        staleTime: Infinity
    });
};
const $69cc8f084f0e7d75$var$useOwnerQuery = (method, setState)=>{
    switch(method){
        case 'GET':
            return (0, $41632140e88fef11$export$dd0a697e1782aedd)('getOwners', (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAllSortedByName, {
                onError: (error)=>{
                    (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
                },
                staleTime: Infinity
            });
    }
};
const $69cc8f084f0e7d75$var$useProviderQuery = (method, setState)=>{
    return (0, $41632140e88fef11$export$dd0a697e1782aedd)('getProviders', (0, $04fdf08493329c97$export$2e2bcd8739ae039).getAllSortedByName, {
        onError: (error)=>{
            (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
        },
        staleTime: Infinity
    });
};
const $69cc8f084f0e7d75$var$getMatchingProvider = (providerArray, id)=>{
    const provider = providerArray.filter((obj)=>obj.id === id);
    return provider[0];
};
const $69cc8f084f0e7d75$var$usePropertiesQuery = (state, setState, getProviders)=>{
    return (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        'getProperties',
        getProviders,
        state.providerId,
        state.rowEditing
    ], async ()=>{
        var _state_rowEditing;
        if (!getProviders.data || !state.providerId) return [];
        // Retrieve the full list of properties from the selected provider's schema.
        // These define the text fields that will be added to the form.
        const provider = $69cc8f084f0e7d75$var$getMatchingProvider(getProviders.data, state.providerId);
        const providerSchema = provider.schema;
        const schemaProperties = Object.keys(providerSchema.properties);
        // Retrieve the actual properties from the selected provider.
        // These will be the values that initially fill in the text fields created above.
        const defaultProperties = provider.properties;
        // Retrieve the specific instance/override of the properties from the data stream itself
        let dataStreamProperties = {};
        if (state.editMode === 'edit') dataStreamProperties = (_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing.data_stream_provider_properties;
        // Return a merged form of the above lists.
        // Fields are defined by the schema. The initial values are the provider's properties. And these are overridden by
        // the data stream's properties.
        return schemaProperties.map((prop)=>{
            var _providerSchema_required;
            let type = '';
            let description = '';
            let required = ((_providerSchema_required = providerSchema.required) === null || _providerSchema_required === void 0 ? void 0 : _providerSchema_required.includes(prop)) === true;
            const schemaProperties = providerSchema.properties[prop];
            if (schemaProperties) {
                type = schemaProperties.type;
                description = schemaProperties.description;
            }
            let property = {
                name: prop,
                value: '',
                type: type,
                description: description,
                required: required
            };
            if (defaultProperties[prop]) property = {
                name: prop,
                value: defaultProperties[prop],
                type: type,
                description: description,
                required: required
            };
            if (state.editMode === 'create') return property;
            if (dataStreamProperties[prop] && state.rowEditing.provider_id === state.providerId) {
                if (dataStreamProperties[prop] !== '') property = {
                    name: prop,
                    value: dataStreamProperties[prop],
                    type: type,
                    description: description,
                    required: required
                };
            }
            return property;
        });
    }, {
        onError: (error)=>{
            return (0, $007c796d200e5283$export$2e2bcd8739ae039).produceError(error, setState);
        },
        staleTime: Infinity
    });
};
var $69cc8f084f0e7d75$export$2e2bcd8739ae039 = {
    useConsumerQuery: $69cc8f084f0e7d75$var$useConsumerQuery,
    useDeviceQuery: $69cc8f084f0e7d75$var$useDeviceQuery,
    useInitialValuesQuery: $69cc8f084f0e7d75$var$useInitialValuesQuery,
    useOwnerQuery: $69cc8f084f0e7d75$var$useOwnerQuery,
    useProviderQuery: $69cc8f084f0e7d75$var$useProviderQuery,
    usePropertiesQuery: $69cc8f084f0e7d75$var$usePropertiesQuery
};





const $1dc3278bc8d77085$var$boolRegex = /^(?:(1|t(?:rue)?)|(0|f(?:alse)?))$/i;
const $1dc3278bc8d77085$var$intRegex = /^\d+$/;
const $1dc3278bc8d77085$var$handleClose = (setState)=>{
    setState.setName('');
    setState.setDescription('');
    setState.setDeviceId(null);
    setState.setEditOpen(false);
};
const $1dc3278bc8d77085$var$handleConsumerSelect = (selection, state, setState)=>{
    let consumers = JSON.parse(JSON.stringify(state.consumerId || []));
    if (consumers.includes(selection.value)) consumers = consumers.filter((id)=>id !== selection.value);
    else consumers.push(selection.value);
    setState.setConsumerId(consumers);
};
// A description describes this owner's stream from this provider. Change either and it is a
// different stream, so whatever was written for the old one is released and the dialog
// defaults it again from the new name. A device change does not reset it: the stream is still
// the same owner's feed from the same provider, just arriving from another machine.
const $1dc3278bc8d77085$var$handleOwnerSelect = (selection, setState, setFieldValue)=>{
    setState.setOwnerId(selection.value);
    // A device belongs to exactly one owner, so a device picked under the previous owner is
    // not among the choices any more - and would otherwise be saved against the new one.
    setState.setDeviceId(null);
    setState.setDescription('');
    setFieldValue('description', '');
};
const $1dc3278bc8d77085$var$handleDeviceSelect = (selection, setState)=>{
    setState.setDeviceId(selection.value);
};
const $1dc3278bc8d77085$var$handleCronUpdate = (value, setState)=>{
    setState.setCron(value);
};
const $1dc3278bc8d77085$var$handleProviderSelect = async (selection, values, resetForm, setState, getProperties, nextProvider)=>{
    const providerScheme = (nextProvider === null || nextProvider === void 0 ? void 0 : nextProvider.partition_scheme) || null;
    setState.setProviderId(selection.value);
    // Only a PC Agent feed is tied to a device. Moving to any other provider has to let the
    // device go, or a stale id would be written to a stream that has no device behind it.
    if (!(0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(nextProvider)) setState.setDeviceId(null);
    setState.setName(values.name);
    // Emptied here as well as in resetForm below, so the state the dialog seeds a fresh form
    // from agrees with the form it just built.
    setState.setDescription('');
    setState.setCron(values.cron);
    setState.setLastRetrievalDate(values.last_retrieval_date);
    const newFields = !getProperties.data ? null : getProperties.data;
    // Rules the user actually wrote survive the provider change. Anything else - nothing yet,
    // or an untouched example for the provider they moved away from - is reseeded for the new
    // scheme. Leaving partition_configs out of resetForm dropped the field entirely, so the
    // editor came up with no rows and nothing to type a file key into.
    const rules = values.partition_configs;
    const keepRules = Boolean(rules) && !(0, $a090740b3e667ed5$export$2e2bcd8739ae039).isExampleValue(rules);
    resetForm({
        values: (0, $7e9b970aebca32bd$export$71511d61b312f219)({
            name: values.name,
            // Released, not carried over: see handleOwnerSelect.
            description: '',
            provider_id: selection.value,
            partition_configs: keepRules ? rules : (0, $a090740b3e667ed5$export$2e2bcd8739ae039).exampleForScheme(providerScheme)
        }, (0, $a090740b3e667ed5$export$2e2bcd8739ae039).prettifyProperties(newFields))
    });
};
const $1dc3278bc8d77085$var$validate = async (values, getProperties, expectedName = '')=>{
    const fields = !getProperties.data ? null : getProperties.data;
    const validationObject = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).generateValidationSchema(fields);
    let errors = {};
    for(let field in validationObject)try {
        await validationObject[field].validate(values[field]);
        switch(validationObject[field].type){
            case "boolean":
                if (!$1dc3278bc8d77085$var$boolRegex.test(values[field])) errors[field] = `${values[field]} is not a valid boolean value for field ${field}`;
                break;
            case "integer":
                if (!$1dc3278bc8d77085$var$intRegex.test(values[field])) errors[field] = `${values[field]} is not a valid numeric value for field ${field}`;
                break;
        }
    } catch (err) {
        errors[field] = err.errors[0];
    }
    // Validated separately from the loop above, which is driven by the provider's own
    // property list. partition_configs is not one of those - it is a column on every
    // data stream - and a malformed value here silently stops rows being split out to
    // the child owners, so it is worth catching before save rather than in dbt.
    const partitionConfigsError = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).validatePartitionConfigs(values.partition_configs);
    if (partitionConfigsError) errors.partition_configs = partitionConfigsError;
    // The name is worked out from the selections and shown rather than typed, and the dialog
    // keeps it in step as those selections change. This only fires if that sync has not landed
    // yet - it holds Save until it has, rather than let a stale name reach a column with a
    // UNIQUE key on it.
    if (expectedName && values.name !== expectedName) errors.name = `Must be "${expectedName}".`;
    return errors;
};
var $1dc3278bc8d77085$export$2e2bcd8739ae039 = {
    handleClose: $1dc3278bc8d77085$var$handleClose,
    handleConsumerSelect: $1dc3278bc8d77085$var$handleConsumerSelect,
    handleDeviceSelect: $1dc3278bc8d77085$var$handleDeviceSelect,
    handleOwnerSelect: $1dc3278bc8d77085$var$handleOwnerSelect,
    handleCronUpdate: $1dc3278bc8d77085$var$handleCronUpdate,
    handleProviderSelect: $1dc3278bc8d77085$var$handleProviderSelect,
    validate: $1dc3278bc8d77085$var$validate
};






var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");

var $26IBV = parcelRequire("26IBV");

var $cMu4A = parcelRequire("cMu4A");

var $erOpW = parcelRequire("erOpW");

var $jSIPP = parcelRequire("jSIPP");

var $86B3v = parcelRequire("86B3v");





var $i3Yji = parcelRequire("i3Yji");

var $28RyA = parcelRequire("28RyA");

var $eyQWd = parcelRequire("eyQWd");

var $cl3zs = parcelRequire("cl3zs");




var $rARwS = parcelRequire("rARwS");

var $geF11 = parcelRequire("geF11");
function $a1f628edc2280647$export$5162da8f798e0959(slot) {
    return (0, $geF11.default)('MuiCollapse', slot);
}
const $a1f628edc2280647$var$collapseClasses = (0, $rARwS.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $a1f628edc2280647$export$2e2bcd8739ae039 = $a1f628edc2280647$var$collapseClasses;



var $4uaIU = parcelRequire("4uaIU");
'use client';
const $16f6625cf585dfe9$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $16f6625cf585dfe9$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $i3Yji.default)(slots, (0, $a1f628edc2280647$export$5162da8f798e0959), classes);
};
const $16f6625cf585dfe9$var$CollapseRoot = (0, $28RyA.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $erOpW.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $erOpW.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $16f6625cf585dfe9$var$CollapseWrapper = (0, $28RyA.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $16f6625cf585dfe9$var$CollapseWrapperInner = (0, $28RyA.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $erOpW.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $16f6625cf585dfe9$var$Collapse = /*#__PURE__*/ $jSIPP.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $eyQWd.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $cl3zs.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5b7c23598e1f29a1$export$2e2bcd8739ae039) } = props, other = (0, $cMu4A.default)(props, $16f6625cf585dfe9$var$_excluded);
    const ownerState = (0, $erOpW.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $16f6625cf585dfe9$var$useUtilityClasses(ownerState);
    const theme = (0, $2fa84d090238929f$export$2e2bcd8739ae039)();
    const timer = (0, $43303828b5822c3b$export$2e2bcd8739ae039)();
    const wrapperRef = $jSIPP.useRef(null);
    const autoTransitionDuration = $jSIPP.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $jSIPP.useRef(null);
    const handleRef = (0, $b93ec20acf1e421a$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $0413a8e252ff8408$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $4uaIU.jsx)(TransitionComponent, (0, $erOpW.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $4uaIU.jsx)($16f6625cf585dfe9$var$CollapseRoot, (0, $erOpW.default)({
                as: component,
                className: (0, $86B3v.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $erOpW.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $erOpW.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $4uaIU.jsx)($16f6625cf585dfe9$var$CollapseWrapper, {
                    ownerState: (0, $erOpW.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)($16f6625cf585dfe9$var$CollapseWrapperInner, {
                        ownerState: (0, $erOpW.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$16f6625cf585dfe9$var$Collapse.muiSupportAuto = true;
var $16f6625cf585dfe9$export$2e2bcd8739ae039 = $16f6625cf585dfe9$var$Collapse;


var $bb8cfdf676f354df$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($bb8cfdf676f354df$exports, "__esModule", {
    value: true
});
$bb8cfdf676f354df$exports.default = void 0;

var $bb8cfdf676f354df$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $bb8cfdf676f354df$var$_default = $bb8cfdf676f354df$exports.default = (0, $bb8cfdf676f354df$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


var $bf7bec4f3943d65a$exports = {};
"use strict";
"use client";

var $1rPoN = parcelRequire("1rPoN");
Object.defineProperty($bf7bec4f3943d65a$exports, "__esModule", {
    value: true
});
$bf7bec4f3943d65a$exports.default = void 0;

var $bf7bec4f3943d65a$var$_createSvgIcon = $1rPoN((parcelRequire("32m8d")));

var $4uaIU = parcelRequire("4uaIU");
var $bf7bec4f3943d65a$var$_default = $bf7bec4f3943d65a$exports.default = (0, $bf7bec4f3943d65a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');



/**
 * Editor for data_stream.partition_configs.
 *
 * The owner list is restricted to this parent's children — an entry naming a non-child
 * resolves to nothing and the split silently fails. anyOwner lifts that for iYotah.
 *
 * Every legacy shape parses and is rewritten to the explicit form on save. An unparseable
 * value falls back to raw JSON rather than being discarded.
 */ const $929fc28017bc54c6$var$PartitionConfigsEditor = ({ value: value, onChange: onChange, childOwners: childOwners, owners: owners, anyOwner: anyOwner, providerScheme: providerScheme, error: error, helperText: helperText })=>{
    const [showJson, setShowJson] = (0, $jSIPP.useState)(false);
    const { ok: ok, rows: rows } = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).parsePartitionConfigs(value);
    // Offer the provider's own schemes, reassign (an override, always available), and any
    // type already stored — dropping the last would make an existing rule uneditable.
    // Most providers name one scheme; EZfeed-Loads names PEN and LABEL, and its streams
    // need rules of both kinds on the one stream.
    const schemeMatches = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).schemeMatchTypes(providerScheme);
    const matchOptions = schemeMatches.length ? [
        ...new Set([
            ...schemeMatches,
            'reassign',
            ...rows.map((r)=>r.match)
        ])
    ] : (0, $a090740b3e667ed5$export$2e2bcd8739ae039).MATCH_TYPES;
    const defaultMatch = schemeMatches[0] || 'pen';
    const label = (id, owner)=>owner ? `${id} ${owner.name}` : String(id);
    // The any-owner list is long enough to need sorting; children stay in association order.
    const ownerOptions = anyOwner ? [
        ...owners
    ].sort((a, b)=>String(a.name).localeCompare(String(b.name))).map((owner)=>({
            id: owner.id,
            label: label(owner.id, owner)
        })) : childOwners.map((association)=>{
        const id = association.child_owner_id;
        return {
            id: id,
            label: label(id, owners.find((o)=>o.id === id))
        };
    });
    const emit = (nextRows)=>onChange((0, $a090740b3e667ed5$export$2e2bcd8739ae039).serializePartitionConfigs(nextRows));
    const updateRow = (index, patch)=>emit(rows.map((row, i)=>i === index ? (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, row, patch) : row));
    // No default out of the full owner list — an arbitrary one would save unnoticed.
    const addRow = ()=>{
        var _ownerOptions_;
        var _ownerOptions__id;
        return emit([
            ...rows,
            {
                match: defaultMatch,
                value: '',
                owner_id: anyOwner ? '' : (_ownerOptions__id = (_ownerOptions_ = ownerOptions[0]) === null || _ownerOptions_ === void 0 ? void 0 : _ownerOptions_.id) !== null && _ownerOptions__id !== void 0 ? _ownerOptions__id : ''
            }
        ]);
    };
    const removeRow = (index)=>emit(rows.filter((_, i)=>i !== index));
    // An unparseable value keeps its raw text: rendering rows would mean throwing it away.
    if (!ok) return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "error",
                sx: {
                    mb: 1
                },
                children: "This value could not be read as partition configs. Edit it as JSON below."
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                name: "partition_configs",
                label: "Partition Configs",
                value: typeof value === 'object' ? JSON.stringify(value, null, 2) : value,
                onChange: (e)=>onChange(e.target.value),
                error: Boolean(error),
                helperText: helperText,
                fullWidth: true,
                multiline: true,
                rows: 6,
                variant: "outlined"
            })
        ]
    });
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                        variant: "subtitle2",
                        children: [
                            "Partition Configs",
                            schemeMatches.length > 0 && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                component: "span",
                                variant: "body2",
                                color: "textSecondary",
                                sx: {
                                    ml: 1
                                },
                                children: [
                                    "this provider splits by",
                                    ' ',
                                    schemeMatches.map((match)=>(0, $a090740b3e667ed5$export$2e2bcd8739ae039).MATCH_LABELS[match].toLowerCase()).join(' and ')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bb8cfdf676f354df$exports))), {}),
                        onClick: addRow,
                        disabled: ownerOptions.length === 0,
                        children: "Add rule"
                    })
                ]
            }),
            anyOwner && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "textSecondary",
                sx: {
                    mb: 1
                },
                children: "This stream belongs to iYotah, so its rules may name any owner. Rows matching no rule stay with iYotah and are dropped downstream \u2014 give every file a rule."
            }),
            ownerOptions.length === 0 && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "textSecondary",
                sx: {
                    mb: 1
                },
                children: "No child owners are associated with this owner, so a rule would have nowhere to send rows. Add the association first, then come back to add rules."
            }),
            rows.length === 0 && ownerOptions.length > 0 && !anyOwner && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "textSecondary",
                sx: {
                    mb: 1
                },
                children: "No rules. Rows stay with this owner until a rule sends them to a child."
            }),
            rows.map((row, index)=>/*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        gap: 1,
                        alignItems: 'flex-start',
                        mb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: 170
                            },
                            size: "small",
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                                    children: "Match on"
                                }),
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                    label: "Match on",
                                    value: row.match,
                                    onChange: (e)=>updateRow(index, {
                                            match: e.target.value,
                                            value: ''
                                        }),
                                    children: matchOptions.map((type)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                            value: type,
                                            children: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).MATCH_LABELS[type]
                                        }, type))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                            title: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUELESS_MATCHES.includes(row.match) ? row.match === 'pen' ? 'Pen rules take no value: which pens belong to the child comes from the pen dimension' : 'Reassign takes no value: every row of the stream goes to the owner named here' : '',
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                label: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUE_LABELS[row.match] || 'Value',
                                size: "small",
                                sx: {
                                    flex: 1
                                },
                                value: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUELESS_MATCHES.includes(row.match) ? '' : row.value,
                                disabled: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUELESS_MATCHES.includes(row.match),
                                placeholder: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUE_PLACEHOLDERS[row.match] || '',
                                onChange: (e)=>updateRow(index, {
                                        value: e.target.value
                                    })
                            })
                        }),
                        anyOwner ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), {
                            size: "small",
                            sx: {
                                minWidth: 260
                            },
                            options: ownerOptions,
                            getOptionLabel: (option)=>option.label,
                            isOptionEqualToValue: (option, selected)=>option.id === selected.id,
                            value: ownerOptions.find((o)=>o.id === row.owner_id) || null,
                            onChange: (event, option)=>updateRow(index, {
                                    owner_id: option ? option.id : ''
                                }),
                            renderInput: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params), {
                                    label: "Send to owner"
                                }))
                        }) : /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $50dd07d34beb4b6b$export$2e2bcd8739ae039), {
                            sx: {
                                minWidth: 220
                            },
                            size: "small",
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1d035bfeea196a4a$export$2e2bcd8739ae039), {
                                    children: "Send to owner"
                                }),
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                    label: "Send to owner",
                                    value: ownerOptions.some((o)=>o.id === row.owner_id) ? row.owner_id : '',
                                    onChange: (e)=>updateRow(index, {
                                            owner_id: e.target.value
                                        }),
                                    children: ownerOptions.map((option)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                            value: option.id,
                                            children: option.label
                                        }, option.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            "aria-label": "Remove rule",
                            onClick: ()=>removeRow(index),
                            size: "small",
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf7bec4f3943d65a$exports))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }, index)),
            helperText && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: error ? 'error' : 'textSecondary',
                sx: {
                    mt: 1
                },
                children: helperText
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                size: "small",
                onClick: ()=>setShowJson(!showJson),
                sx: {
                    mt: 1
                },
                children: showJson ? 'Hide JSON' : 'Edit as JSON'
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $16f6625cf585dfe9$export$2e2bcd8739ae039), {
                in: showJson,
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                    value: typeof value === 'object' ? JSON.stringify(value, null, 2) : value !== null && value !== void 0 ? value : '',
                    onChange: (e)=>onChange(e.target.value),
                    fullWidth: true,
                    multiline: true,
                    rows: 6,
                    variant: "outlined",
                    sx: {
                        mt: 1
                    }
                })
            })
        ]
    });
};
$929fc28017bc54c6$var$PartitionConfigsEditor.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).object
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).func.isRequired,
    childOwners: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    owners: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).array,
    anyOwner: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    providerScheme: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).bool,
    helperText: (0, (/*@__PURE__*/$parcel$interopDefault($26IBV))).string
};
$929fc28017bc54c6$var$PartitionConfigsEditor.defaultProps = {
    value: '',
    childOwners: [],
    owners: [],
    anyOwner: false,
    providerScheme: null,
    error: false,
    helperText: ''
};
var $929fc28017bc54c6$export$2e2bcd8739ae039 = $929fc28017bc54c6$var$PartitionConfigsEditor;




// Writes the worked-out name into the form whenever the selections behind it change. It
// lives in its own component because the fields are rendered inside Formik's render prop,
// where a hook cannot be called.
const $bda3f2529b52fff3$var$StreamNameSync = ({ streamName: streamName, values: values, setValues: setValues })=>{
    // The description this component last filled in. While the field still holds it, nobody
    // has written one of their own, so it keeps following the name.
    const defaulted = (0, $jSIPP.useRef)('');
    // Both fields go out in one setValues. A setFieldValue revalidates against the values as
    // they stood at the last render, so writing the name and then the description as two calls
    // would have the second validate a form whose name had gone back to the old one - and the
    // last result to land is the one Save reads.
    (0, $jSIPP.useEffect)(()=>{
        const next = {};
        // Nothing is written until there is a name to write, so a stream being edited keeps its
        // stored name while the owner, provider and device lists are still loading - or if the
        // device behind a PC Agent stream has since been deleted, leaving nothing to rebuild from.
        if (streamName && values.name !== streamName) next.name = streamName;
        var _next_name;
        // The description starts from the name and is then left alone from the moment somebody
        // types their own - including a description that was already there when the stream was
        // opened. It is a default, not a rule: only a PC Agent *provider* has to describe itself
        // by its name.
        const name = (_next_name = next.name) !== null && _next_name !== void 0 ? _next_name : values.name;
        const stillDefault = values.description === '' || values.description === defaulted.current;
        if (name && values.description !== name && stillDefault) {
            next.description = name;
            defaulted.current = name;
        }
        if (!Object.keys(next).length) return;
        setValues((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, values, next));
    }, [
        streamName,
        values,
        setValues
    ]);
    return null;
};
// The name is not typed - it is what the pickers beside it add up to. It gets the accent
// treatment so it reads as the result of the form rather than another empty field somebody
// has forgotten to fill in. The description sits inside it because it starts life as a copy
// of the name.
const $bda3f2529b52fff3$var$StreamIdentityCard = ({ name: name, placeholder: placeholder, hint: hint, error: error, children: children })=>{
    // An empty card is not a fault the reader can act on - it is waiting on a selection, which
    // the placeholder already says. Only report a name that is actually wrong.
    const problem = name ? error : '';
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
        title: "Will be saved as",
        accent: true,
        error: Boolean(problem),
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "div",
                color: name ? 'text.primary' : 'text.disabled',
                sx: {
                    fontWeight: name ? 500 : 400,
                    wordBreak: 'break-word',
                    minHeight: '1.5rem'
                },
                children: name || placeholder
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "caption",
                component: "div",
                color: problem ? 'error' : 'text.secondary',
                sx: {
                    mb: 2
                },
                children: problem || hint
            }),
            children
        ]
    });
};
const $bda3f2529b52fff3$var$DataStreamEditDialog = ({ state: state, setState: setState })=>{
    var _getProviders_data, _getOwners_data, _state_rowEditing;
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    (0, $jSIPP.useEffect)(()=>{
        const refetch = async ()=>{
            await queryClient.refetchQueries("getProperties");
        };
        refetch();
    }, [
        state.providerId,
        queryClient
    ]);
    const { data: childOwners = [] } = (0, $41632140e88fef11$export$dd0a697e1782aedd)([
        'childOwners',
        state.ownerId
    ], async ()=>{
        if (!state.ownerId) return [];
        return await (0, $17b1048d84ada6dd$export$2e2bcd8739ae039).getOneByParentId(state.ownerId);
    }, {
        enabled: Boolean(state.ownerId)
    });
    const postDataStream = (0, $f1bc31ea7471fcab$export$2e2bcd8739ae039).useDataStreamQuery('POST', queryClient, state, setState);
    const putDataStream = (0, $f1bc31ea7471fcab$export$2e2bcd8739ae039).useDataStreamQuery('PUT', queryClient, state, setState);
    const getConsumers = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).useConsumerQuery('GET', setState);
    const getProviders = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).useProviderQuery('GET', setState);
    const getOwners = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).useOwnerQuery('GET', setState);
    const getDevices = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).useDeviceQuery('GET', setState);
    const getProperties = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).usePropertiesQuery(state, setState, getProviders);
    const selectedProvider = (_getProviders_data = getProviders.data) === null || _getProviders_data === void 0 ? void 0 : _getProviders_data.find((p)=>p.id === state.providerId);
    const selectedOwner = (_getOwners_data = getOwners.data) === null || _getOwners_data === void 0 ? void 0 : _getOwners_data.find((o)=>o.id === state.ownerId);
    const providerScheme = (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.partition_scheme) || null;
    // A PC Agent feed arrives from one machine at the owner's site, so the stream has to name
    // the device it comes from - and is named after it. No other kind of provider has a device.
    const isDeviceStream = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).isDeviceProvider(selectedProvider);
    const ownerDevices = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).devicesForOwner(getDevices.data, selectedOwner);
    const selectedDevice = ownerDevices.find((d)=>d.id === state.deviceId);
    // The rest are numbered instead, against the list the grid already holds, so the number
    // handed out accounts for what is out there rather than starting from one every time.
    const getDataStreams = (0, $f1bc31ea7471fcab$export$2e2bcd8739ae039).useDataStreamQuery('GET', queryClient, state, setState);
    var _state_deviceId, _state_rowEditing_device_id;
    // Every stream is named from its selections, so a name says what the stream is and two
    // people setting up the same feed arrive at the same one. Opening a stream and saving it
    // must not rename it though - the name is unique, the scheduler is keyed off it, and it is
    // what people search for - so it is rebuilt only once one of its parts actually changes.
    const nameSourcesUnchanged = state.editMode === 'edit' && Boolean((_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing.name) && state.ownerId === state.rowEditing.owner_id && state.providerId === state.rowEditing.provider_id && ((_state_deviceId = state.deviceId) !== null && _state_deviceId !== void 0 ? _state_deviceId : null) === ((_state_rowEditing_device_id = state.rowEditing.device_id) !== null && _state_rowEditing_device_id !== void 0 ? _state_rowEditing_device_id : null);
    const derivedName = nameSourcesUnchanged ? state.rowEditing.name : (0, $a090740b3e667ed5$export$2e2bcd8739ae039).streamName({
        provider: selectedProvider,
        owner: selectedOwner,
        device: selectedDevice,
        dataStreams: getDataStreams.data,
        rowEditing: state.editMode === 'edit' ? state.rowEditing : null
    });
    const getInitialValues = (0, $69cc8f084f0e7d75$export$2e2bcd8739ae039).useInitialValuesQuery(state, setState, getProperties, providerScheme);
    const resetHWM = (values)=>{
        values.last_retrieval_date = '';
        setState.setLastRetrievalDate('');
    };
    const anyOwner = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).routesToAnyOwner(state.ownerId);
    const showPartitionConfigs = ()=>{
        var _state_rowEditing;
        const provider = selectedProvider;
        const owner = selectedOwner;
        // Existing rules are always shown: the pipeline applies them regardless of the
        // provider flag, so hiding them would leave live config unreachable.
        if ((_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing.partition_configs) return true;
        // iYotah streams always need rules, and have neither children nor multi_site.
        if (anyOwner) return true;
        if (!Boolean(provider === null || provider === void 0 ? void 0 : provider.multi_tenant_enabled)) return false;
        return Boolean(owner === null || owner === void 0 ? void 0 : owner.multi_site) && childOwners.length > 0;
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: state.editOpen,
        onClose: ()=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleClose(setState),
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                id: "alert-dialog-title",
                children: state.editMode === 'edit' ? `Edit Data Stream ${state.rowEditing.id}` : state.editMode === 'create' ? 'Create Data Stream' : ''
            }),
            !getInitialValues.data ? null : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                initialValues: getInitialValues.data,
                validate: (values)=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).validate(values, getProperties, derivedName),
                onSubmit: state.editMode === 'edit' ? (values)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleEditSubmit(values, queryClient, state, setState, putDataStream, getProperties.data) : state.editMode === 'create' ? (values)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleCreateSubmit(values, state, setState, state.dataStreamFields, postDataStream, getProperties.data) : ()=>{},
                children: ({ errors: errors, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting, setFieldValue: setFieldValue, setValues: setValues, resetForm: resetForm, touched: touched, values: values })=>{
                    var _state_rowEditing, _getProperties_data;
                    var _state_rowEditing_id;
                    return /*#__PURE__*/ (0, $4uaIU.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)($bda3f2529b52fff3$var$StreamNameSync, {
                                streamName: derivedName,
                                values: values,
                                setValues: setValues
                            }, `${state.editMode}-${(_state_rowEditing_id = (_state_rowEditing = state.rowEditing) === null || _state_rowEditing === void 0 ? void 0 : _state_rowEditing.id) !== null && _state_rowEditing_id !== void 0 ? _state_rowEditing_id : 'new'}`),
                            /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                                style: {
                                    margin: '2%'
                                },
                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 6,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Source",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $63e3d4055b517dea$export$2e2bcd8739ae039), {
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $26614893954f57b9$export$2e2bcd8739ae039), {
                                                            fieldName: "owner",
                                                            dataList: getOwners.data,
                                                            value: state.ownerId || '',
                                                            handleChange: (selection)=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleOwnerSelect(selection, setState, setFieldValue),
                                                            isMultiple: false
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $26614893954f57b9$export$2e2bcd8739ae039), {
                                                            fieldName: "provider",
                                                            dataList: getProviders.data,
                                                            value: state.providerId || '',
                                                            handleChange: (selection)=>{
                                                                var _getProviders_data;
                                                                return (0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleProviderSelect(selection, values, resetForm, setState, getProperties, ((_getProviders_data = getProviders.data) === null || _getProviders_data === void 0 ? void 0 : _getProviders_data.find((p)=>p.id === selection.value)) || null);
                                                            },
                                                            isMultiple: false
                                                        }),
                                                        isDeviceStream && /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $26614893954f57b9$export$2e2bcd8739ae039), {
                                                                    fieldName: "device",
                                                                    dataList: (0, $a090740b3e667ed5$export$2e2bcd8739ae039).deviceOptions(ownerDevices),
                                                                    value: state.deviceId || '',
                                                                    handleChange: (selection)=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleDeviceSelect(selection, setState),
                                                                    isMultiple: false
                                                                }),
                                                                getDevices.data && state.ownerId && !ownerDevices.length && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                                    variant: "caption",
                                                                    color: "error",
                                                                    children: "This owner has no devices. Create one on the Devices page first."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 6,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)($bda3f2529b52fff3$var$StreamIdentityCard, {
                                                name: values.name,
                                                placeholder: isDeviceStream ? 'Set once the owner, provider and device are chosen' : 'Set once the owner and provider are chosen',
                                                hint: isDeviceStream ? 'Device, owner and provider - the name PC Agent uses.' : 'Provider, owner and the number of this stream for that pair.',
                                                error: errors.name,
                                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                    name: "description",
                                                    label: "Description",
                                                    value: values.description,
                                                    error: Boolean(touched.description && errors.description),
                                                    helperText: touched.description && errors.description || 'Defaults to the name. Edit it for anything more useful.',
                                                    fullWidth: true,
                                                    onBlur: handleBlur,
                                                    onChange: handleChange,
                                                    variant: "outlined",
                                                    InputProps: {
                                                        sx: {
                                                            bgcolor: 'background.paper'
                                                        }
                                                    }
                                                })
                                            })
                                        }),
                                        Boolean((_getProperties_data = getProperties.data) === null || _getProperties_data === void 0 ? void 0 : _getProperties_data.length) && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Provider settings",
                                                description: `How this stream reaches ${(selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.name) || 'the provider'}.`,
                                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: getProperties.data.map((field)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 6,
                                                            children: field.type === 'array' ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f5c73759a36ab9b5$export$2e2bcd8739ae039), {
                                                                multiple: true,
                                                                freeSolo: true,
                                                                options: [],
                                                                value: Array.isArray(values[field.name]) ? values[field.name] : [],
                                                                onChange: (event, next)=>setFieldValue(field.name, next),
                                                                renderTags: (tags, getTagProps)=>tags.map((tag, index)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({
                                                                            size: "small",
                                                                            label: tag
                                                                        }, getTagProps({
                                                                            index: index
                                                                        })))),
                                                                renderInput: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), (0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, params), {
                                                                        label: field.name,
                                                                        error: Boolean(touched[field.name] && errors[field.name]),
                                                                        helperText: touched[field.name] && errors[field.name] || field.description,
                                                                        placeholder: "Type a value and press Enter",
                                                                        variant: "outlined"
                                                                    }))
                                                            }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                                name: field.name,
                                                                label: field.name,
                                                                value: values[field.name],
                                                                error: Boolean(touched[field.name] && errors[field.name]),
                                                                helperText: touched[field.name] && errors[field.name] || field.description,
                                                                fullWidth: true,
                                                                onBlur: handleBlur,
                                                                onChange: handleChange,
                                                                variant: "outlined"
                                                            })
                                                        }, field.name))
                                                })
                                            })
                                        }),
                                        showPartitionConfigs() && /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Row routing",
                                                description: "Which rows in this stream belong to which owner.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $929fc28017bc54c6$export$2e2bcd8739ae039), {
                                                    value: values.partition_configs,
                                                    onChange: (next)=>setFieldValue('partition_configs', next),
                                                    childOwners: childOwners,
                                                    owners: getOwners.data || [],
                                                    anyOwner: anyOwner,
                                                    providerScheme: providerScheme,
                                                    error: Boolean(touched.partition_configs && errors.partition_configs),
                                                    helperText: touched.partition_configs && errors.partition_configs || ''
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Delivery",
                                                description: "Where the extracted data is sent once it lands.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    spacing: 2,
                                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $26614893954f57b9$export$2e2bcd8739ae039), {
                                                            fieldName: "consumers",
                                                            dataList: getConsumers.data,
                                                            value: state.consumerId || [],
                                                            handleChange: (selection)=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleConsumerSelect(selection, state, setState),
                                                            isMultiple: true
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                                title: "Schedule",
                                                description: "When the stream runs, and how far through the source it has read.",
                                                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $63e3d4055b517dea$export$2e2bcd8739ae039), {
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $63e3d4055b517dea$export$2e2bcd8739ae039), {
                                                            direction: "row",
                                                            spacing: 2,
                                                            alignItems: "flex-start",
                                                            children: [
                                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                                                    name: "last_retrieval_date",
                                                                    label: "Last Retrieval Date",
                                                                    value: values.last_retrieval_date,
                                                                    error: Boolean(touched.last_retrieval_date && errors.last_retrieval_date),
                                                                    helperText: touched.last_retrieval_date && errors.last_retrieval_date,
                                                                    onBlur: handleBlur,
                                                                    onChange: handleChange,
                                                                    variant: "outlined",
                                                                    inputProps: {
                                                                        readOnly: true
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                                    color: "primary",
                                                                    onClick: ()=>resetHWM(values),
                                                                    size: "large",
                                                                    type: "button",
                                                                    variant: "outlined",
                                                                    children: "Reset"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6fc2f2f7fd99bbdc$export$2e2bcd8739ae039), {
                                                            fieldName: "cron",
                                                            handleChange: (value)=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleCronUpdate(value, setState),
                                                            cronValue: state.cron,
                                                            errors: errors
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        mb: 2
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    disabled: isSubmitting,
                                                    onClick: ()=>(0, $1dc3278bc8d77085$export$2e2bcd8739ae039).handleClose(setState),
                                                    size: "large",
                                                    type: "button",
                                                    variant: "outlined",
                                                    sx: {
                                                        mr: 1
                                                    },
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    disabled: isSubmitting || !state.ownerId || !state.providerId || !state.consumerId || !state.consumerId.length || isDeviceStream && !state.deviceId || Object.keys(errors).length !== 0 || !values.name,
                                                    size: "large",
                                                    type: "submit",
                                                    variant: "contained",
                                                    children: "Save"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $bda3f2529b52fff3$export$2e2bcd8739ae039 = $bda3f2529b52fff3$var$DataStreamEditDialog;






var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");




/**
 * Grid cell for data_stream.partition_configs: one chip per rule, `<what> → <owner>`.
 *
 * Parsing goes through the editor's helper so every legacy shape renders. An unparseable
 * value keeps its raw text rather than rendering blank.
 */ const $77b91b733b3f6df0$var$ruleText = (rule)=>{
    if (rule.match === 'pen') return 'By pen';
    if (rule.match === 'reassign') return 'All rows';
    return rule.value === '' ? '(no value)' : String(rule.value);
};
// An id alone says nothing about who the rows went to. The name leads, with the id kept
// because that is what the config actually stores. Falls back to the bare id while the
// owner list is still loading, or for an id that no longer resolves to an owner.
const $77b91b733b3f6df0$var$ownerLabel = (ownerId, namesById)=>{
    const name = namesById.get(Number(ownerId));
    return name ? `${name} (${ownerId})` : String(ownerId);
};
// Valueless matches name the type only, to avoid "All rows: All rows → Acme (17122)".
const $77b91b733b3f6df0$var$ruleTitle = (rule, namesById)=>{
    const label = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).MATCH_LABELS[rule.match] || rule.match;
    return (0, $a090740b3e667ed5$export$2e2bcd8739ae039).VALUELESS_MATCHES.includes(rule.match) ? `${label} \u{2192} ${$77b91b733b3f6df0$var$ownerLabel(rule.owner_id, namesById)}` : `${label}: ${$77b91b733b3f6df0$var$ruleText(rule)} \u{2192} ${$77b91b733b3f6df0$var$ownerLabel(rule.owner_id, namesById)}`;
};
const $77b91b733b3f6df0$var$PartitionConfigsCell = ({ value: value })=>{
    // Same key the owner dropdowns use, so the grid reads their cache rather than refetching.
    const { data: owners } = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getOwners', (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAllSortedByName, {
        staleTime: Infinity
    });
    const namesById = (0, $jSIPP.useMemo)(()=>new Map((owners || []).map((owner)=>[
                Number(owner.id),
                owner.name
            ])), [
        owners
    ]);
    if (value === null || value === undefined || value === '') return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
        variant: "body2",
        color: "textSecondary",
        children: "\u2014"
    });
    const { ok: ok, rows: rows } = (0, $a090740b3e667ed5$export$2e2bcd8739ae039).parsePartitionConfigs(value);
    if (!ok || rows.length === 0) {
        const raw = typeof value === 'object' ? JSON.stringify(value) : String(value);
        return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
            title: raw,
            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "error",
                noWrap: true,
                children: raw
            })
        });
    }
    // One rule per line; the grid uses auto row height to fit them.
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
            component: "span",
            sx: {
                display: 'block',
                whiteSpace: 'pre-line'
            },
            children: rows.map((rule)=>$77b91b733b3f6df0$var$ruleTitle(rule, namesById)).join('\n')
        }),
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 0.25,
                py: 0.5,
                width: '100%'
            },
            children: rows.map((rule, index)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $dbaa881ad628c459$export$2e2bcd8739ae039), {
                    size: "small",
                    variant: "outlined",
                    label: `${$77b91b733b3f6df0$var$ruleText(rule)} \u{2192} ${$77b91b733b3f6df0$var$ownerLabel(rule.owner_id, namesById)}`,
                    sx: {
                        maxWidth: '100%'
                    }
                }, index))
        })
    });
};
var $77b91b733b3f6df0$export$2e2bcd8739ae039 = $77b91b733b3f6df0$var$PartitionConfigsCell;


const $5a835608c43931d1$var$minWidthDefault = 200;
const $5a835608c43931d1$export$53b3c91859018cd4 = [
    {
        field: 'id',
        headerName: 'ID',
        description: 'Provider ID',
        minWidth: 55
    },
    {
        field: 'owner_id',
        // Numeric so it sorts correctly; some owner ids are below 10000. Alignment and the
        // toLocaleString formatter are overridden — an id is not a quantity.
        type: 'number',
        align: 'left',
        headerAlign: 'left',
        valueFormatter: ({ value: value })=>value === null || value === undefined ? '' : String(value),
        headerName: 'Owner ID',
        description: 'Owner ID',
        minWidth: 75
    },
    {
        field: 'owner_name',
        headerName: 'Owner Name',
        description: 'Owner Name',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'provider_name',
        headerName: 'Provider Name',
        description: 'Provider Name',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'Name',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'description',
        headerName: 'Description',
        description: 'Description',
        minWidth: 250
    },
    {
        field: 'cron',
        headerName: 'Cron Schedule',
        description: 'Cron Schedule',
        minWidth: 150
    },
    {
        field: 'owner_description',
        headerName: 'Owner Description',
        description: 'Owner Description',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'owner_timezone',
        headerName: 'Owner Timezone',
        description: 'Owner Timezone',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'provider_id',
        headerName: 'Provider ID',
        description: 'Provider ID',
        minWidth: 75
    },
    {
        field: 'provider_description',
        headerName: 'Provider Description',
        description: 'Provider Description',
        minWidth: $5a835608c43931d1$var$minWidthDefault
    },
    {
        field: 'consumer_names',
        headerName: 'Consumers',
        description: 'Consumers',
        minWidth: 125
    },
    {
        field: 'created_by',
        headerName: 'Created By',
        description: 'Created By',
        minWidth: 175
    },
    {
        field: 'created_datetime',
        headerName: 'Created Datetime',
        description: 'Created Datetime',
        minWidth: 225
    },
    {
        field: 'updated_by',
        headerName: 'Updated By',
        description: 'Updated By',
        minWidth: 175
    },
    {
        field: 'updated_datetime',
        headerName: 'Updated Datetime',
        description: 'Updated Datetime',
        minWidth: 225
    },
    {
        field: 'partition_configs',
        headerName: 'Partition Configs',
        description: 'Partition Configs',
        minWidth: 260,
        sortable: false,
        renderCell: (params)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $77b91b733b3f6df0$export$2e2bcd8739ae039), {
                value: params.row.partition_configs
            })
    }
];







const $a203045e225c3212$var$DataStreams = ({})=>{
    const [consumerId, setConsumerId] = (0, $jSIPP.useState)(null);
    const [cron, setCron] = (0, $jSIPP.useState)('');
    const [dataStreamFields, setDataStreamFields] = (0, $jSIPP.useState)([
        'id',
        'name',
        'description',
        'cron',
        'last_retrieval_date',
        'provider_id',
        'owner_id',
        'device_id',
        'provider_properties',
        'created_by',
        'updated_by',
        'partition_configs'
    ]);
    const [dataStreamId, setDataStreamId] = (0, $jSIPP.useState)(null);
    const [description, setDescription] = (0, $jSIPP.useState)('');
    const [deviceId, setDeviceId] = (0, $jSIPP.useState)(null);
    const [lastRetrievalDate, setLastRetrievalDate] = (0, $jSIPP.useState)('');
    const [dialogContent, setDialogContent] = (0, $jSIPP.useState)('');
    const [dialogOpen, setDialogOpen] = (0, $jSIPP.useState)(false);
    const [dialogTitle, setDialogTitle] = (0, $jSIPP.useState)('');
    const [editMode, setEditMode] = (0, $jSIPP.useState)('');
    const [editOpen, setEditOpen] = (0, $jSIPP.useState)(false);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    const [name, setName] = (0, $jSIPP.useState)('');
    const [originalConsumers, setOriginalConsumers] = (0, $jSIPP.useState)(null);
    const [ownerId, setOwnerId] = (0, $jSIPP.useState)(null);
    const [providerId, setProviderId] = (0, $jSIPP.useState)(null);
    const [rowEditing, setRowEditing] = (0, $jSIPP.useState)([]);
    const state = {
        consumerId: consumerId,
        dataStreamFields: dataStreamFields,
        dataStreamId: dataStreamId,
        description: description,
        deviceId: deviceId,
        cron: cron,
        lastRetrievalDate: lastRetrievalDate,
        dialogContent: dialogContent,
        dialogOpen: dialogOpen,
        dialogTitle: dialogTitle,
        editMode: editMode,
        editOpen: editOpen,
        errDisplayText: errDisplayText,
        errorOpen: errorOpen,
        name: name,
        originalConsumers: originalConsumers,
        ownerId: ownerId,
        providerId: providerId,
        rowEditing: rowEditing
    };
    const setState = {
        setConsumerId: setConsumerId,
        setDataStreamFields: setDataStreamFields,
        setDataStreamId: setDataStreamId,
        setDescription: setDescription,
        setDeviceId: setDeviceId,
        setCron: setCron,
        setLastRetrievalDate: setLastRetrievalDate,
        setDialogContent: setDialogContent,
        setDialogOpen: setDialogOpen,
        setDialogTitle: setDialogTitle,
        setEditMode: setEditMode,
        setEditOpen: setEditOpen,
        setErrDisplayText: setErrDisplayText,
        setErrorOpen: setErrorOpen,
        setName: setName,
        setOriginalConsumers: setOriginalConsumers,
        setOwnerId: setOwnerId,
        setProviderId: setProviderId,
        setRowEditing: setRowEditing
    };
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const [cols, setCols] = (0, $jSIPP.useState)((0, $007c796d200e5283$export$2e2bcd8739ae039).initializeColumns((0, $5a835608c43931d1$export$53b3c91859018cd4), queryClient, setState));
    const getDataStreams = (0, $f1bc31ea7471fcab$export$2e2bcd8739ae039).useDataStreamQuery('GET', queryClient, state, setState);
    (0, $f1bc31ea7471fcab$export$2e2bcd8739ae039).useOwnerDefaultDataStreamQuery('GET', state, setState);
    // Arriving from the home page search as /data-streams?id=412 opens that stream.
    (0, $fa76533b6a84f8f4$export$2e2bcd8739ae039)(getDataStreams.data, (row)=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleEdit(null, row, queryClient, setState));
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Data Streams",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                        editHandler: ()=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).handleCreate(setState),
                        onRefresh: ()=>(0, $c10ef6ca62ebf0a3$export$2e2bcd8739ae039).refreshTable(queryClient)
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '77vh',
                            '& .disabled': {
                                color: "#94A3B8"
                            }
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: getDataStreams.data || [],
                            getRowClassName: (params)=>params.row.disabled ? 'disabled' : '',
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                            },
                            loading: getDataStreams.isLoading,
                            initialState: {
                                sorting: {
                                    sortModel: [
                                        {
                                            field: 'owner_id',
                                            sort: 'asc'
                                        }
                                    ]
                                },
                                columns: {
                                    columnVisibilityModel: {
                                        description: false,
                                        owner_description: false,
                                        provider_id: false,
                                        provider_description: false,
                                        consumer_names: false,
                                        created_by: false,
                                        created_datetime: false,
                                        updated_by: false,
                                        updated_datetime: false
                                    }
                                }
                            },
                            // Rows grow to fit the partition rules, which render one per line. The estimate
                            // keeps virtualised scrolling smooth.
                            getRowHeight: ()=>'auto',
                            getEstimatedRowHeight: ()=>36,
                            density: "compact"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bda3f2529b52fff3$export$2e2bcd8739ae039), {
                state: state,
                setState: setState
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2709e525dda8b54c$export$2e2bcd8739ae039), {
                open: dialogOpen,
                setOpen: setDialogOpen,
                content: dialogContent,
                title: dialogTitle,
                scroll: 'paper'
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $a203045e225c3212$export$2e2bcd8739ae039 = $a203045e225c3212$var$DataStreams;





var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");





var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");



const $b1f694599632670a$var$CreateDeviceDialog = (props)=>{
    const { control: control, handleSubmit: handleSubmit } = (0, $d8f0cc4747dfcf2c$export$87c0cf8eb5a167e0)();
    const handleClose = ()=>{
        props.setOpen(false);
    };
    // The list arrives from a query, so it is null until that query resolves - and stays null
    // if it fails. Rendering an empty menu beats taking the dialog down with it.
    const owners = Array.isArray(props.owners) ? props.owners : [];
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: props.open,
        onClose: handleClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: "Create Device"
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)("form", {
                onSubmit: handleSubmit(props.onSubmit),
                children: /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
                    style: {
                        margin: '2%'
                    },
                    children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $75b894f64939a696$export$2e2bcd8739ae039), {
                                    title: "Owner",
                                    description: "Who the device belongs to. It cannot be moved afterwards.",
                                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d8f0cc4747dfcf2c$export$bd0bf19f25da8474), {
                                        name: "owner_id",
                                        control: control,
                                        render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e329553cea51e59$export$2e2bcd8739ae039), {
                                                labelId: "owner-label",
                                                id: "owner-id",
                                                value: value,
                                                label: "Owner",
                                                defaultValue: "",
                                                displayEmpty: true,
                                                fullWidth: true,
                                                error: Boolean(error),
                                                renderValue: (selected)=>{
                                                    var _owners_find;
                                                    if (selected === '') return 'Please select owner to create device for...';
                                                    var _owners_find_name;
                                                    return (_owners_find_name = (_owners_find = owners.find((x)=>x.id === selected)) === null || _owners_find === void 0 ? void 0 : _owners_find.name) !== null && _owners_find_name !== void 0 ? _owners_find_name : '';
                                                },
                                                onChange: onChange,
                                                children: owners.map((owner)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $382a7c17a1ce115b$export$2e2bcd8739ae039), {
                                                        value: owner.id,
                                                        children: owner.name
                                                    }, owner.id))
                                            }),
                                        rules: {
                                            required: true
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $1ce7d9cbbe13e769$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $7c3d5f6d6fb23b64$export$2e2bcd8739ae039), {
                                        sx: {
                                            mb: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        onClick: handleClose,
                                        size: "large",
                                        type: "button",
                                        variant: "outlined",
                                        sx: {
                                            mr: 1
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        size: "large",
                                        type: "submit",
                                        variant: "contained",
                                        children: "Create"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $b1f694599632670a$export$2e2bcd8739ae039 = $b1f694599632670a$var$CreateDeviceDialog;





var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");


const $8425a95fe6123edd$var$minWidthDefault = 200;
const $8425a95fe6123edd$export$53b3c91859018cd4 = [
    {
        field: 'source',
        headerName: 'PROVIDER NAME',
        description: 'The name of the provider data is being uploaded for',
        minWidth: 250
    },
    {
        field: 'message',
        headerName: 'MESSAGE',
        description: 'Additional information about the upload event',
        minWidth: 300
    },
    {
        field: 'fileCount',
        headerName: 'FILE COUNT',
        description: 'Number of files uploaded',
        minWidth: $8425a95fe6123edd$var$minWidthDefault
    },
    {
        field: 'created_datetime',
        headerName: 'UPLOAD TIME',
        description: 'The date and time the upload occurred',
        minWidth: 250
    }
];


const $751063e07dbe8b4e$var$UploadLogsDialog = (props)=>{
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $4eb98f32eaddaa19$export$2e2bcd8739ae039), {
        open: props.open,
        onClose: props.close,
        maxWidth: "lg",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d5488e110ee569e2$export$2e2bcd8739ae039), {
                children: "Upload History for Device"
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                sx: {
                    height: '50vh',
                    '& .disabled': {
                        color: '#94A3B8'
                    }
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                    sx: {
                        height: '60%'
                    },
                    columns: (0, $8425a95fe6123edd$export$53b3c91859018cd4),
                    rows: props.logs
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                variant: "contained",
                onClick: props.close,
                children: "Cancel"
            })
        ]
    });
};
var $751063e07dbe8b4e$export$2e2bcd8739ae039 = $751063e07dbe8b4e$var$UploadLogsDialog;






var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $0c0bea12f843bf03$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M7 9H2V7h5zm0 3H2v2h5zm13.59 7-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3M2 19h10v-2H2z"
}), 'ManageSearch');



var $4uaIU = parcelRequire("4uaIU");
parcelRequire("jSIPP");

var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $5b7313abab6748d0$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"
}), 'Block');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $f9a0cc1474790bbd$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');


var $gVlpF = parcelRequire("gVlpF");

var $4uaIU = parcelRequire("4uaIU");
"use client";
var $6a02af3217602dde$export$2e2bcd8739ae039 = (0, $gVlpF.default)(/*#__PURE__*/ (0, $4uaIU.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');



var $cIygu = parcelRequire("cIygu");
var $hiHHm = parcelRequire("hiHHm");
const $7c2c0f498ed869f7$var$minWidthDefault = 200;
const $7c2c0f498ed869f7$export$53b3c91859018cd4 = [
    {
        field: 'id',
        type: 'number',
        headerName: 'ID',
        description: 'numeric device id',
        minWidth: 75
    },
    {
        field: 'owner_name',
        headerName: 'OWNER',
        description: 'owner of the device',
        minWidth: 400
    },
    {
        field: 'mac_address',
        headerName: 'MAC ADDRESS',
        description: 'device mac address',
        minWidth: $7c2c0f498ed869f7$var$minWidthDefault
    },
    {
        field: 'activation_code',
        headerName: 'ACTIVATION CODE',
        description: 'activation code for device',
        minWidth: 250
    },
    {
        field: 'api_key',
        headerName: 'API KEY',
        description: 'api gateway api key',
        minWidth: 200
    },
    {
        field: 'activation_attempts',
        type: 'number',
        headerName: 'ACTIVATION ATTEMPTS',
        description: 'number of attempts to activate',
        minWidth: 300
    },
    {
        field: 'active',
        headerName: 'ACTIVE',
        description: 'is the device active',
        minWidth: 150,
        renderCell: (params)=>{
            if (params.value === 1) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f9a0cc1474790bbd$export$2e2bcd8739ae039), {
                style: {
                    color: (0, $cIygu.default)[500]
                }
            });
            else return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $5b7313abab6748d0$export$2e2bcd8739ae039), {
                style: {
                    color: (0, $hiHHm.default)[500]
                }
            });
        }
    },
    {
        field: 'backend_url',
        headerName: 'BACKEND URL',
        description: 'configured backend url to make all requests',
        minWidth: $7c2c0f498ed869f7$var$minWidthDefault
    },
    {
        field: 'activation_date',
        headerName: 'ACTIVATION DATE',
        type: 'dateTime',
        valueGetter: ({ value: value })=>value && new Date(value),
        description: 'date the device was activated',
        minWidth: 300
    },
    {
        field: 'health_timestamp',
        headerName: 'HEALTH',
        description: 'date time device last checked in',
        minWidth: 150,
        renderCell: (params)=>{
            // TODO: Make this a gradient depending on how old the last health check is?
            if (params.value) {
                let now = new Date();
                let last_health_check = new Date(params.value);
                if (now - last_health_check < 300000) return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6a02af3217602dde$export$2e2bcd8739ae039), {
                    style: {
                        color: (0, $cIygu.default)[500]
                    }
                });
            }
            return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $6a02af3217602dde$export$2e2bcd8739ae039), {
                style: {
                    color: (0, $hiHHm.default)[500]
                }
            });
        }
    },
    {
        field: 'created_by',
        headerName: 'CREATED BY',
        description: 'user who created the device',
        minWidth: 175
    },
    {
        field: 'created_datetime',
        type: 'dateTime',
        valueGetter: ({ value: value })=>value && new Date(value),
        headerName: 'CREATED DATE TIME',
        description: 'date time device was created',
        minWidth: 250
    },
    {
        field: 'updated_by',
        headerName: 'UPDATED BY',
        description: 'last user to update the device',
        minWidth: 175
    },
    {
        field: 'updated_datetime',
        type: 'dateTime',
        valueGetter: ({ value: value })=>value && new Date(value),
        headerName: 'LAST UPDATED DATE TIME',
        description: 'date time the device was last updated',
        minWidth: 250
    }
];



const $a3646354e4a7c4cc$var$Devices = ({})=>{
    // ####################[ Setup and Initialization ]####################
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const initializeColumns = (initialColumns)=>{
        return initialColumns.concat({
            field: 'logs',
            headerName: 'UPLOAD LOGS',
            description: 'view the device upload history',
            minWidth: 250,
            renderCell: (params)=>{
                return params.row.active === 1 ? /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        title: "View Upload History",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: (event)=>handleLogsOpen(event, params.row),
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0c0bea12f843bf03$export$2e2bcd8739ae039), {})
                        })
                    })
                }) : null;
            }
        });
    };
    // ####################[ State Definitions ]####################
    const [cols, setCols] = (0, $jSIPP.useState)(initializeColumns((0, $7c2c0f498ed869f7$export$53b3c91859018cd4)));
    const [createOpen, setCreateOpen] = (0, $jSIPP.useState)(false);
    const [logsOpen, setLogsOpen] = (0, $jSIPP.useState)(false);
    const [macAddress, setMacAddress] = (0, $jSIPP.useState)(null);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    // ####################[ Query Definitions ]####################
    const getDevices = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDevices', async ()=>{
        return await (0, $48e245a686e30046$export$2e2bcd8739ae039).getDevices();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const getDeviceLogs = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getDeviceLogs', async ()=>{
        return await (0, $48e245a686e30046$export$2e2bcd8739ae039).getDeviceLogs(macAddress);
    }, {
        onSuccess: (data)=>{
            // TODO: Return data sorted by date in the API
            return data.sort((a, b)=>new Date(b.created_datetime) - new Date(a.created_datetime));
        },
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity,
        enabled: !!macAddress
    });
    const getOwners = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getOwners', async ()=>{
        return await (0, $17fe0060be69a0cc$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const postDevice = (0, $74568c0a766c827d$export$609860bf8b0084c)('postDevice', async (data)=>{
        return await (0, $48e245a686e30046$export$2e2bcd8739ae039).createDevice(data);
    }, {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries('getDevices');
            setCreateOpen(false);
        },
        onError: (error)=>{
            setCreateOpen(false);
            handleError(error);
        }
    });
    const handleCreate = ()=>{
        setCreateOpen(true);
    };
    const onSubmit = async (data)=>{
        postDevice.mutate((0, $5775f7ba75513da6$export$71511d61b312f219)((0, $7e9b970aebca32bd$export$71511d61b312f219)({}, data), {
            updated_by: await (0, $875b725466af1357$export$2e2bcd8739ae039).getUser()
        }));
    };
    const handleError = (error)=>{
        setErrorOpen(false);
        setErrDisplayText(`${error.message}: ${JSON.stringify(error.response.data)}`);
        setErrorOpen(true);
        console.error(`${error.message}: ${JSON.stringify(error.response.data)}`);
    };
    const handleLogsOpen = async (event, row)=>{
        setMacAddress(row.mac_address);
        setLogsOpen(true);
    };
    const handleLogsClose = ()=>{
        setMacAddress(null);
        setLogsOpen(false);
    };
    const refreshTable = async ()=>{
        console.info('Refreshing table');
        await queryClient.invalidateQueries('getDevices');
    };
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Devices",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                        editHandler: handleCreate,
                        onRefresh: refreshTable
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '77vh',
                            '& .disabled': {
                                color: '#94A3B8'
                            }
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: getDevices.data || [],
                            getRowClassName: (params)=>params.row.disabled ? 'disabled' : '',
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                            },
                            loading: getDevices.isLoading,
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        mac_address: false,
                                        api_key: false,
                                        activation_attempts: false,
                                        backend_url: false,
                                        activation_date: false,
                                        created_by: false,
                                        created_datetime: false,
                                        updated_by: false,
                                        updated_datetime: false
                                    }
                                }
                            },
                            density: "compact"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b1f694599632670a$export$2e2bcd8739ae039), {
                open: createOpen,
                setOpen: setCreateOpen,
                owners: getOwners.data,
                onSubmit: onSubmit,
                handleError: handleError
            }),
            !getDeviceLogs.data ? null : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $751063e07dbe8b4e$export$2e2bcd8739ae039), {
                open: logsOpen,
                setOpen: setLogsOpen,
                close: handleLogsClose,
                logs: getDeviceLogs.data,
                handleError: handleError
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $a3646354e4a7c4cc$export$2e2bcd8739ae039 = $a3646354e4a7c4cc$var$Devices;



var $4uaIU = parcelRequire("4uaIU");

var $jSIPP = parcelRequire("jSIPP");









parcelRequire("jSIPP");
const $4de21db9c00e4ec6$var$minWidthDefault = 200;
const $4de21db9c00e4ec6$export$53b3c91859018cd4 = [
    {
        field: 'id',
        headerName: 'ID',
        description: 'Consumer Type ID',
        minWidth: 75
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'Name',
        minWidth: $4de21db9c00e4ec6$var$minWidthDefault
    },
    {
        field: 'description',
        headerName: 'Description',
        description: 'Description',
        minWidth: 400
    }
];



const $d03642fdc5a7510e$var$ConsumerTypes = ({})=>{
    // ####################[ Setup and Initialization ]####################
    const queryClient = (0, $0e83aeae07108916$export$22e77b9572c4fded)();
    const initializeColumns = (initialColumns)=>{
        return initialColumns.concat({
            field: 'actions',
            headerName: 'Actions',
            description: 'Actions',
            minWidth: 175,
            renderCell: (params)=>{
                return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $49843c171a30b5aa$export$2e2bcd8739ae039), {
                        title: "View Schema",
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f39aadf3bf12995a$export$2e2bcd8739ae039), {
                            color: "primary",
                            onClick: (event)=>handleDialogOpen(event, params.row),
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0eefa11e679f91b4$exports))), {})
                        })
                    })
                });
            }
        });
    };
    // ####################[ State Definitions ]####################
    const [cols, setCols] = (0, $jSIPP.useState)(initializeColumns((0, $4de21db9c00e4ec6$export$53b3c91859018cd4)));
    const [dialogOpen, setDialogOpen] = (0, $jSIPP.useState)(false);
    const [schema, setSchema] = (0, $jSIPP.useState)([]);
    const [errDisplayText, setErrDisplayText] = (0, $jSIPP.useState)('');
    const [errorOpen, setErrorOpen] = (0, $jSIPP.useState)(false);
    // ####################[ Query Definitions ]####################
    const getConsumerTypes = (0, $41632140e88fef11$export$dd0a697e1782aedd)('getConsumerTypes', async ()=>{
        return await (0, $9bb29106c9ca5483$export$2e2bcd8739ae039).getAll();
    }, {
        onError: (error)=>{
            handleError(error);
        },
        retry: false,
        staleTime: Infinity
    });
    const handleError = (error)=>{
        setErrorOpen(false);
        setErrDisplayText(`${error.message}: ${JSON.stringify(error.response.data)}`);
        setErrorOpen(true);
        console.error(`${error.message}: ${JSON.stringify(error.response.data)}`);
    };
    // ####################[ Event Handlers ]####################
    const handleDialogOpen = async (event, row)=>{
        setSchema(row.schema);
        setDialogOpen(true);
    };
    const handleDialogClose = ()=>{
        setDialogOpen(false);
    };
    const refreshTable = async ()=>{
        console.info('Refreshing table');
        await queryClient.invalidateQueries('getConsumerTypes');
    };
    // ####################[ The Component ]####################
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b3c751be1355b7b5$export$2e2bcd8739ae039), {
                appName: "nGEST",
                title: "Consumer Types",
                children: [
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $e9b6e418069ba502$export$2e2bcd8739ae039), {
                        onRefresh: refreshTable
                    }),
                    /*#__PURE__*/ (0, $4uaIU.jsx)((0, $f1b71e2e3f4830a6$export$2e2bcd8739ae039), {
                        sx: {
                            height: '77vh',
                            '& .disabled': {
                                color: '#94A3B8'
                            }
                        },
                        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d0acaa943fee3c99$export$97fd8aadf70de81f), {
                            columns: cols,
                            rows: getConsumerTypes.data || [],
                            getRowClassName: (params)=>params.row.disabled ? 'disabled' : '',
                            slots: {
                                loadingOverlay: (0, $6216cc7e50b683a3$export$2e2bcd8739ae039),
                                toolbar: (0, $6b19d1fc798f1d65$export$2e2bcd8739ae039)
                            },
                            loading: getConsumerTypes.isLoading,
                            initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        consumer_type_id: false,
                                        consumer_type_description: false,
                                        created_by: false,
                                        created_datetime: false,
                                        updated_by: false,
                                        updated_datetime: false
                                    }
                                }
                            },
                            density: "compact"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $2709e525dda8b54c$export$2e2bcd8739ae039), {
                open: dialogOpen,
                setOpen: setDialogOpen,
                close: handleDialogClose,
                content: JSON.stringify(schema, undefined, 2),
                scroll: 'paper'
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $d61e868d178710ba$export$2e2bcd8739ae039), {
                open: errorOpen,
                setOpen: setErrorOpen,
                displayText: errDisplayText
            })
        ]
    });
};
var $d03642fdc5a7510e$export$2e2bcd8739ae039 = $d03642fdc5a7510e$var$ConsumerTypes;



var $4uaIU = parcelRequire("4uaIU");


var $ghfJh = parcelRequire("ghfJh");


var $jSIPP = parcelRequire("jSIPP");





const $72a6e0ddf3c81802$var$ChangePassword = ({})=>{
    const history = (0, $418bff895eee7f39$export$3420e1dc2c4a518c)();
    const [error, setError] = (0, $jSIPP.useState)(null);
    const username = (0, $af024b80000f7590$export$2105062e25df4afe)((0, $f091004a6ec177a3$export$1acb7bb2a487a164));
    const password = (0, $af024b80000f7590$export$2105062e25df4afe)((0, $f091004a6ec177a3$export$24459b23206f809a));
    const handleLoginSubmit = async (values, actions)=>{
        (0, $f759aa5a9826e8c0$export$334c29725a78c21d).signIn(username, password).then((user)=>{
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') (0, $f759aa5a9826e8c0$export$334c29725a78c21d).completeNewPassword(user, values.newPassword).then((_)=>{
                history.push('/');
            }).catch((error)=>{
                console.error(error);
                setError(error);
                actions.setSubmitting(false);
            });
            else history.push('/');
        }).catch((error)=>{
            console.error(error);
            setError(error);
            actions.setSubmitting(false);
        });
    };
    return /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $19efb1c1755d1d62$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $4uaIU.jsx)("title", {
                    children: "Change Password | nGEST"
                })
            }),
            /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: 'background.default',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $47d5907b0888e07d$export$2e2bcd8739ae039), {
                    maxWidth: "sm",
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
                            severity: "info",
                            sx: {
                                my: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bf1395812ba8dabb$export$2e2bcd8739ae039), {
                                    children: "Hi there"
                                }),
                                "You must change your password to continue."
                            ]
                        }),
                        (error === null || error === void 0 ? void 0 : error.message) ? /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b26ccb6af59d84c4$export$2e2bcd8739ae039), {
                            severity: "error",
                            sx: {
                                my: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $bf1395812ba8dabb$export$2e2bcd8739ae039), {
                                    children: "Login Failed"
                                }),
                                "Invalid user/credentials"
                            ]
                        }) : /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4uaIU.Fragment), {}),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ghfJh.Formik), {
                            initialValues: {
                                username: username,
                                password: password,
                                newPassword: ''
                            },
                            validationSchema: $f986b6e4122227d2$export$185802fd694ee1f5().shape({
                                username: $7a974168aa28ad85$export$185802fd694ee1f5().max(255).required('Username is required'),
                                password: $7a974168aa28ad85$export$185802fd694ee1f5().max(255).required('Password is required'),
                                newPassword: $7a974168aa28ad85$export$185802fd694ee1f5().max(255).required('New password is required')
                            }),
                            onSubmit: (values, actions)=>handleLoginSubmit(values, actions),
                            children: ({ errors: errors, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, isSubmitting: isSubmitting, touched: touched, values: values })=>/*#__PURE__*/ (0, $4uaIU.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                            sx: {
                                                mb: 3
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4acc79473d417315$export$2e2bcd8739ae039), {
                                                color: "textPrimary",
                                                variant: "h2",
                                                children: "Sign in"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                            error: Boolean(touched.username && errors.username),
                                            fullWidth: true,
                                            helperText: touched.username && errors.username,
                                            label: "Username",
                                            margin: "normal",
                                            name: "username",
                                            onBlur: handleBlur,
                                            onChange: handleChange,
                                            type: "username",
                                            value: values.username,
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                            error: Boolean(touched.password && errors.password),
                                            fullWidth: true,
                                            helperText: touched.password && errors.password,
                                            label: "Password",
                                            margin: "normal",
                                            name: "password",
                                            onBlur: handleBlur,
                                            onChange: handleChange,
                                            type: "password",
                                            value: values.password,
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $ccc5b601331ac202$export$2e2bcd8739ae039), {
                                            error: Boolean(touched.newPassword && errors.newPassword),
                                            fullWidth: true,
                                            helperText: touched.newPassword && errors.newPassword,
                                            label: "New Password",
                                            margin: "normal",
                                            name: "newPassword",
                                            onBlur: handleBlur,
                                            onChange: handleChange,
                                            type: "password",
                                            value: values.newPassword,
                                            variant: "outlined"
                                        }),
                                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $b72d1b571cb9f93d$export$2e2bcd8739ae039), {
                                            sx: {
                                                py: 2
                                            },
                                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $681a423b309f05b8$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                disabled: isSubmitting,
                                                fullWidth: true,
                                                size: "large",
                                                type: "submit",
                                                variant: "contained",
                                                children: "Sign in now"
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                })
            })
        ]
    });
};
var $72a6e0ddf3c81802$export$2e2bcd8739ae039 = $72a6e0ddf3c81802$var$ChangePassword;


const $0ce0cc016dd97ba5$var$Routes = ({})=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)("div", {
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $418bff895eee7f39$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$e7b0ac011bb776c6), {
                    path: "/info",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $cf6066d05ea77742$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$e7b0ac011bb776c6), {
                    path: "/",
                    exact: true,
                    render: (_)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$2d8d895a0a0f636e), {
                            to: "/home"
                        })
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $3b00fc86dbf3c073$export$2e2bcd8739ae039), {
                    path: "/login",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $38463fdc530198f4$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $418bff895eee7f39$export$e7b0ac011bb776c6), {
                    path: "/changepassword",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $72a6e0ddf3c81802$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/home",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $d42abd0b1794984f$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/owners",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $bc3a015817250ece$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/providers",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $b7e75478e98bb558$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/provider-thresholds",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $e56c377aecfced50$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/pen-health/:businessId",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $b7f4849d2ef18c7d$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/pen-health",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $fbf3e27db94c1b7f$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/consumers",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $2960e797fe11f00b$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/data-streams",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $a203045e225c3212$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/consumerTypes",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $d03642fdc5a7510e$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $32beac86d7bb7278$export$2e2bcd8739ae039), {
                    path: "/devices",
                    render: (props)=>/*#__PURE__*/ (0, $4uaIU.jsx)((0, $a3646354e4a7c4cc$export$2e2bcd8739ae039), (0, $7e9b970aebca32bd$export$71511d61b312f219)({}, props))
                })
            ]
        })
    });
};
var $0ce0cc016dd97ba5$export$2e2bcd8739ae039 = $0ce0cc016dd97ba5$var$Routes;


const $07ed4eef5ab44e9a$var$NavigationTopBarNgest = ({})=>{
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $abb606ea4efaa7cc$export$2e2bcd8739ae039), {});
};
const $07ed4eef5ab44e9a$var$App = ({})=>{
    const [sessionChange, setSessionChange] = (0, $jSIPP.useState)(false);
    const [isLoggedIn, setLoggedIn] = (0, $jSIPP.useState)(false);
    (0, $jSIPP.useEffect)(()=>{
        (0, $875b725466af1357$export$2e2bcd8739ae039).isLoggedIn().then((bool)=>{
            setLoggedIn(bool);
        });
        setSessionChange(false);
    }, [
        sessionChange,
        setSessionChange
    ]);
    // Intercept warning logs masquerading as error logs
    (0, $jSIPP.useEffect)(()=>{
        const err = console.error;
        console.error = (...args)=>{
            if (typeof args[0] === 'string') {
                if (args[0].includes('Warning') || args[0].includes('MUI:') || args[0].includes('MUI X:') || args[0].includes('Expired package version') || args[0].includes('Expired license')) {
                    console.warn(args[0]);
                    return;
                }
            }
            err(...args);
        };
    }, []);
    return /*#__PURE__*/ (0, $4uaIU.jsx)((0, $9a8ba91331ea601c$export$2e2bcd8739ae039), {
        theme: (0, $d2cc57e9a89cc3bf$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $90e85bbb3ec20250$export$dc45bdc734ce6f1e), {
            dateAdapter: (0, $f63005c1ab87d561$export$33545c6a80bae043),
            children: [
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $4fc1f3d6474feb67$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $4uaIU.jsxs)((0, $b2d572a11ba9d27b$export$9ba4e89fdfa1fc54), {
                    children: [
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44ddebeabffdcc65$export$2e2bcd8739ae039), {
                            setSessionUpdate: setSessionChange
                        }),
                        /*#__PURE__*/ (0, $4uaIU.jsx)((0, $c32036e189f278ac$export$2e2bcd8739ae039), {
                            isLoggedIn: isLoggedIn,
                            topbar: $07ed4eef5ab44e9a$var$NavigationTopBarNgest,
                            sidebar: (0, $87d570419464f5a2$export$2e2bcd8739ae039),
                            bottombar: (0, $3699162d32a732ad$export$2e2bcd8739ae039),
                            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0ce0cc016dd97ba5$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4uaIU.jsx)((0, $8de0f85cc7605310$exports.ReactQueryDevtools), {
                    initialIsOpen: false
                })
            ]
        })
    });
};
var $07ed4eef5ab44e9a$export$2e2bcd8739ae039 = $07ed4eef5ab44e9a$var$App;





const $ae153a78e5bb9b88$export$6f57813fe9f31bf9 = (0, $840ab42532c4ded2$export$7d8a5b498da695ac)({
    reducer: {
        userContext: (0, $f091004a6ec177a3$export$2e2bcd8739ae039)
    }
});



const $59639194e8227353$var$queryClient = new (0, $a51662f755b146ff$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            staleTime: 60000
        }
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($cd730a104af6804b$exports))).interceptors.request.use(async (request)=>{
    const token = await (0, $875b725466af1357$export$2e2bcd8739ae039).getIdToken();
    request.headers['Authorization'] = `Bearer ${token}`;
    return request;
}, (error)=>{
    console.error('API error', error);
});
(0, $402b8719785b6ed6$export$2e2bcd8739ae039).configure(window.amplifyConfig);
const $59639194e8227353$var$muiDataGridProLicenseKey = '61a1e8837c63b6e22e5027bdc6c4e9f0Tz01NjQ3MCxFPTE3MDMxODQ1MDg2ODYsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=';
(0, $332fe187cd95a041$export$2c56d2e2ae515eeb).setLicenseKey($59639194e8227353$var$muiDataGridProLicenseKey);
(0, $3ab9800416b64e29$exports.render)(/*#__PURE__*/ (0, $4uaIU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSIPP))).StrictMode, {
    children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $0e83aeae07108916$export$45604f0cc8ae667b), {
        client: $59639194e8227353$var$queryClient,
        children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $44c0ca333985c71b$export$2e2bcd8739ae039), {
            store: (0, $ae153a78e5bb9b88$export$6f57813fe9f31bf9),
            children: /*#__PURE__*/ (0, $4uaIU.jsx)((0, $07ed4eef5ab44e9a$export$2e2bcd8739ae039), {})
        })
    })
}), document.getElementById('root'));


//# sourceMappingURL=build.b4f6b207.js.map
